export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type AccessCode = {
  __typename?: 'AccessCode';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The access code to use */
  code: Scalars['String'];
  /** The membership this access code is associated with */
  isActive: Scalars['Boolean'];
  /** The number of paid entities this access code can be used for */
  quantityPaid: Scalars['Float'];
  /** The number of comp entities this access code can be used for */
  quantityComp: Scalars['Float'];
  /** The number of paid entities this access code has been used for */
  totalUsedPaid: Scalars['Float'];
  /** The number of comp entities this access code has been used for */
  totalUsedComp: Scalars['Float'];
  membershipTypes: Array<MembershipType>;
};

export type AccessCodeConnection = {
  __typename?: 'AccessCodeConnection';
  pageInfo: PageInfo;
  edges: Array<AccessCodeOutputEdge>;
  totalCount: Scalars['Int'];
};

/** An individual access code */
export type AccessCodeInput = {
  /** The access code */
  accessCode: Scalars['String'];
  /** The number of tickets that can be purchased with this access code, set null for no limit */
  quantity?: Maybe<Scalars['Float']>;
  /** The number of free tickets for this access code, set null for no limit */
  quantityFree?: Maybe<Scalars['Float']>;
  /** Whether this access code is enabled */
  isEnabled: Scalars['Boolean'];
};

/** Portable representation of an access code. */
export type AccessCodeOutput = {
  __typename?: 'AccessCodeOutput';
  /** The access code */
  accessCode: Scalars['String'];
  /** The number of tickets that can be purchased with this access code */
  quantity?: Maybe<Scalars['Float']>;
  /** The number of free tickets that can been redeemed with this access code */
  quantityFree?: Maybe<Scalars['Float']>;
  /** The number of tickets that have been purchased with this access code */
  quantityUsed: Scalars['Float'];
  /** the number of free tickets that have been redeemed with this access code */
  quantityFreeUsed: Scalars['Float'];
  /** The link to the access code */
  link: Scalars['String'];
  /** Is enabled */
  isEnabled: Scalars['Boolean'];
};

export type AccessCodeOutputEdge = {
  __typename?: 'AccessCodeOutputEdge';
  cursor: Scalars['String'];
  node: AccessCodeOutput;
};

/** How you can create or update an access code. */
export type AccessCodeReleaseInput = {
  /** The release id for the access code, set null to create new */
  releaseId?: Maybe<Scalars['String']>;
  /** The access codes for the release */
  accessCodes: Array<AccessCodeInput>;
  /** The tickets that can be purchased with this access code */
  tickets: Array<AccessCodeTicketInput>;
  /** The event id for the access code */
  eventId: Scalars['String'];
  requiredMembershipIds?: Maybe<Array<Scalars['String']>>;
};

/** Portable representation of an access code release. */
export type AccessCodeReleaseOutput = {
  __typename?: 'AccessCodeReleaseOutput';
  /** The release id for the access code */
  releaseId: Scalars['String'];
  /** The access codes for the release */
  accessCodes: Array<AccessCodeOutput>;
  /** The tickets that can be purchased with this access code */
  tickets: Array<AccessCodeTicketOutput>;
  /** The event id for the access code */
  eventId: Scalars['String'];
  purchaseRestrictions?: Maybe<ReleasePurchaseRestriction>;
};

/** Access code ticket input for the event. */
export type AccessCodeTicketInput = {
  /** The ticket id */
  id: Scalars['String'];
  /** The type of ticket */
  type: TicketTypeKind;
};

/** Access code ticket output for the event. */
export type AccessCodeTicketOutput = {
  __typename?: 'AccessCodeTicketOutput';
  /** The ticket id */
  id: Scalars['String'];
  /** The type of ticket */
  type: TicketTypeKind;
  /** The ticket name */
  name: Scalars['String'];
  /** The ticket zone name */
  zoneName?: Maybe<Scalars['String']>;
  /** The ticket quantity */
  quantity?: Maybe<Scalars['Float']>;
  /** The ticket price */
  price?: Maybe<Scalars['Float']>;
  /** The ticket pricing tiers. Note: If `null`, the query or mutation didn't populate this field. */
  pricingTiers?: Maybe<Array<PublicReleaseTicketPricingTierOutput>>;
  /** If ticket is hidden by the release */
  isHidden: Scalars['Boolean'];
};

export type AccessCodeWhereInput = {
  releaseId: Scalars['String'];
};

export type ActionEngagementRecordOutput = {
  __typename?: 'ActionEngagementRecordOutput';
  label: Scalars['String'];
  clickCount: Scalars['Float'];
};

export type ActiveCompetitionByTypeInput = {
  eventId: Scalars['String'];
  competitionType: CompetitionType;
};

export type Activity = {
  __typename?: 'Activity';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The user that an activity belongs to */
  user: User;
  /** order:creation */
  type: Scalars['String'];
  /** Origin of activities */
  origin: ActivityOrigin;
  /** Detail is relevant to the action that cant be captured just by the refId and refType */
  detail: Scalars['JSON'];
  fingerPrint?: Maybe<Scalars['JSON']>;
  /** Target entity */
  refName?: Maybe<Scalars['String']>;
  /** Target entity id */
  refId?: Maybe<Scalars['String']>;
  /** human readable description of what has gone */
  description?: Maybe<Scalars['String']>;
  /** The admin that make this activity */
  admin?: Maybe<User>;
};

export type ActivityConnection = {
  __typename?: 'ActivityConnection';
  pageInfo: PageInfo;
  edges: Array<ActivityEdge>;
  totalCount: Scalars['Int'];
};

export type ActivityEdge = {
  __typename?: 'ActivityEdge';
  cursor: Scalars['String'];
  node: Activity;
};

/** Origin of activities */
export enum ActivityOrigin {
  User = 'User',
  System = 'System',
  Admin = 'Admin'
}

export type ActivityWhereInput = {
  userId: Scalars['String'];
};

export type AddAccessCodesToMembershipInput = {
  /** The access code to add to the membership type. */
  code: Scalars['String'];
  /** The max number of uses this access code can be used for this membership type when purchasing tickets. */
  quantityPaid: Scalars['Float'];
  /** The max number of uses this access code can be used for this membership type when claiming complimentary tickets. */
  quantityComp: Scalars['Float'];
  membershipTypeIds: Array<Scalars['ID']>;
};

export type AddAuditLogInput = {
  eventType: AuditEventType;
  eventDetails?: Maybe<Scalars['JSON']>;
  destinationOrganizationId?: Maybe<Scalars['String']>;
};

export type AddExhibitorInput = {
  name: Scalars['String'];
  email: Scalars['String'];
  eventId: Scalars['String'];
  allowCustomQuestions: Scalars['Boolean'];
};

export type AddGatesToEventAddonInput = {
  addonId: Scalars['String'];
  names: Array<Scalars['String']>;
};

export type AddGatesToZoneInput = {
  zoneId: Scalars['String'];
  names: Array<Scalars['String']>;
};

/** Represents additional info to be included with digital event or membership emails. */
export type AdditionalEmailInfoInput = {
  /** Additional info to be included with digital event or membership emails. */
  text?: Maybe<Scalars['String']>;
  /** The text that will be displayed on the action button. Required if buttonUrl is provided. */
  buttonText?: Maybe<Scalars['String']>;
  /** The url that the action button will link to. Required if buttonText is provided. */
  buttonUrl?: Maybe<Scalars['String']>;
};

export type AddonUnion = EventAddon | MembershipAddon;

export type AddPosTransactionInput = {
  /** Selected payment method (allowed: cash, eftpos, cc). */
  method: PaymentProvider;
  amount: Scalars['Float'];
  returned?: Maybe<Scalars['Float']>;
  externalId?: Maybe<Scalars['String']>;
};

export type AddReminderToScoutCommunicationUserInput = {
  remindAt: Scalars['DateTime'];
  message?: Maybe<Scalars['String']>;
};

/** Address details. */
export type Address = {
  __typename?: 'Address';
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  suburb?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  formattedAddress?: Maybe<Scalars['String']>;
};

/** Address details. */
export type AddressInput = {
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  suburb?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  formattedAddress?: Maybe<Scalars['String']>;
};

export type AddUnsubscribeReasonInput = {
  userId: Scalars['String'];
  unsubscribeReason: UnsubscribeReason;
  otherUnsubscribeReason?: Maybe<Scalars['String']>;
};

export type AddUnsubscribeReasonV2Input = {
  id: Scalars['String'];
  unsubscribeReason: UnsubscribeReason;
  unsubscribeReasonDetails?: Maybe<Scalars['String']>;
};

export type AdobeExperiencePlatformIntegration = {
  __typename?: 'AdobeExperiencePlatformIntegration';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  tenant: Scalars['String'];
  sandboxName: Scalars['String'];
  /** Also known as the API key */
  clientId: Scalars['String'];
  clientSecret: Scalars['String'];
  imsOrgId: Scalars['String'];
  technicalAccountId: Scalars['String'];
  privateKeyBase64: Scalars['String'];
  customerEndpoint?: Maybe<Scalars['String']>;
  customerSchemaRefId?: Maybe<Scalars['String']>;
  customerDatasetId?: Maybe<Scalars['String']>;
  ticketEndpoint?: Maybe<Scalars['String']>;
  ticketSchemaRefId?: Maybe<Scalars['String']>;
  ticketDatasetId?: Maybe<Scalars['String']>;
  scanEndpoint?: Maybe<Scalars['String']>;
  scanSchemaRefId?: Maybe<Scalars['String']>;
  scanDatasetId?: Maybe<Scalars['String']>;
};

export type AdobeExperiencePlatformIntegrationInput = {
  tenant: Scalars['String'];
  sandboxName: Scalars['String'];
  /** Also known as the API key */
  clientId: Scalars['String'];
  clientSecret: Scalars['String'];
  imsOrgId: Scalars['String'];
  technicalAccountId: Scalars['String'];
  privateKeyBase64: Scalars['String'];
  customerEndpoint?: Maybe<Scalars['String']>;
  customerSchemaRefId?: Maybe<Scalars['String']>;
  customerDatasetId?: Maybe<Scalars['String']>;
  scanEndpoint?: Maybe<Scalars['String']>;
  scanSchemaRefId?: Maybe<Scalars['String']>;
  scanDatasetId?: Maybe<Scalars['String']>;
  ticketEndpoint?: Maybe<Scalars['String']>;
  ticketSchemaRefId?: Maybe<Scalars['String']>;
  ticketDatasetId?: Maybe<Scalars['String']>;
};

export type AgeArgs = {
  __typename?: 'AgeArgs';
  kind: BroadcastMarketingFiltersV2Kind;
  /** Exclude isn't supported for this filter. */
  exclude: Scalars['Boolean'];
  /** Minimum age in years (inclusive). If omitted, no minimum age condition is applied. */
  minimumAge?: Maybe<Scalars['Float']>;
  /** Maximum age in years (inclusive). If omitted, no maximum age condition is applied. */
  maximumAge?: Maybe<Scalars['Float']>;
};

export type AgeBreakDownOutput = {
  __typename?: 'AgeBreakDownOutput';
  reportData: Array<AgeBreakDownSegment>;
  reportType: ReportType;
  shouldHide: Scalars['Boolean'];
};

export type AgeBreakDownSegment = {
  __typename?: 'AgeBreakDownSegment';
  ageRange: Scalars['String'];
  percentage: Scalars['Float'];
  total: Scalars['Float'];
};

export type AnonymizationInput = {
  /** The ID of the user we are anonymising data for */
  userId: Scalars['String'];
  /** The ID of the org the user belongs to */
  orgId: Scalars['String'];
};

export type AnonymizationOutput = {
  __typename?: 'AnonymizationOutput';
  status: Scalars['String'];
  message: Scalars['String'];
};

export type ApplyPromoCode = {
  promoCode: Scalars['String'];
};

export type AppTicket = {
  __typename?: 'AppTicket';
  id: Scalars['String'];
  ticketNumber: Scalars['String'];
  parentTicketNumber?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  status: TicketStatus;
  gateIds: Array<Scalars['String']>;
  isHold: Scalars['Boolean'];
  ticketTypeName?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  seatZone?: Maybe<Scalars['String']>;
  buyerInformation?: Maybe<AppTicketUserDetails>;
  user?: Maybe<AppTicketUserDetails>;
  scans: Array<AppTicketScan>;
  isEventAddon: Scalars['Boolean'];
  eventAddonName?: Maybe<Scalars['String']>;
  ticketTypeKind?: Maybe<Scalars['String']>;
  isUsherDisabled: Scalars['Boolean'];
};

export type AppTicketScan = {
  __typename?: 'AppTicketScan';
  id: Scalars['String'];
  scannedAt: Scalars['DateTime'];
  direction: Scalars['String'];
  type: Scalars['String'];
};

export type AppTicketUserDetails = {
  __typename?: 'AppTicketUserDetails';
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type Artist = {
  __typename?: 'Artist';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** Name of the artist */
  name: Scalars['String'];
  /** Source of the artist data, e.g. spotify */
  source?: Maybe<Scalars['String']>;
  /** Source id of the artist, e.g. artist id from spotify */
  sourceId?: Maybe<Scalars['String']>;
  /** URL of the artist image */
  imageUrl?: Maybe<Scalars['String']>;
  genres: Array<Genre>;
};

export type AssignScoutCommunicationUsersToAgentInput = {
  scoutCommunicationId: Scalars['String'];
  agentUserId: Scalars['String'];
  scoutCommunicationUserIds: Array<Scalars['String']>;
};

export type AtrMembershipOrdersUpdatedBetweenInput = {
  /** The start date of the range to search provided in the organizations timezone. */
  startDate: Scalars['DateTime'];
  /** The end date of the range to search provided in the organizations timezone. */
  endDate: Scalars['DateTime'];
};

export type AtrMembershipOrdersUpdatedBetweenOutput = {
  __typename?: 'AtrMembershipOrdersUpdatedBetweenOutput';
  order: Order;
  arcMembershipId: Scalars['String'];
  arcContactId: Scalars['String'];
};

export type AtrUsersUpdatedBetweenOutput = {
  __typename?: 'ATRUsersUpdatedBetweenOutput';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  organization: Organization;
  roles: Array<Role>;
  /** Permision set based on roles */
  permissions: Array<Permission>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  fullName: Scalars['String'];
  hasPassword: Scalars['Boolean'];
  isTwoFactorAuthenticationEnabled: Scalars['Boolean'];
  isLoggedInWithLinkedAccount: Scalars['Boolean'];
  hasVerifiedEmail: Scalars['Boolean'];
  birthDate?: Maybe<Scalars['DateTime']>;
  phoneNumber?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
  usableForEmailMarketing?: Maybe<Scalars['Boolean']>;
  receiveScannerEmail?: Maybe<Scalars['Boolean']>;
  usableForSMSMarketing?: Maybe<Scalars['Boolean']>;
  /** Billing address associated with the user. */
  billingAddress?: Maybe<PartialAddress>;
  /** Shipping address associated with the user. */
  shippingAddress?: Maybe<PartialAddress>;
  /** Whether the shipping address matches the billing address. */
  shippingAddressMatchesBillingAddress: Scalars['Boolean'];
  /** User credits balance */
  credits?: Maybe<Scalars['Float']>;
  /** User points balance */
  points: Scalars['Float'];
  usSegment?: Maybe<UsSegment>;
  /** unique uuid of a customer used to link to referral campaigns */
  referralId: Scalars['String'];
  /** User instagram username */
  instagramUsername?: Maybe<Scalars['String']>;
  /** The company name of the user. */
  companyName?: Maybe<Scalars['String']>;
  /** The tax number of the user. */
  taxNumber?: Maybe<Scalars['String']>;
  /** The region of the user, derived from the postal code of billing address. */
  region?: Maybe<Scalars['String']>;
  unsubscribeReason?: Maybe<UnsubscribeReason>;
  lastLoginAttemptedAt: Scalars['String'];
  loginAttempts: Scalars['String'];
  otherUnsubscribeReason?: Maybe<Scalars['String']>;
  lastTimeLoggedInAt?: Maybe<Scalars['DateTime']>;
  e164Number?: Maybe<Scalars['String']>;
  internationalPhoneNumber?: Maybe<InternationalPhoneNumberOutput>;
  tags: Array<Tag>;
  scoutCommunications: Array<ScoutCommunication>;
  orders: OrderConnection;
  ticketHolderOrders: OrderConnection;
  hasOrders: Scalars['Boolean'];
  membershipTickets: Array<Ticket>;
  eventTickets: Array<Ticket>;
  hasMemberships: Scalars['Boolean'];
  hasTickets: Scalars['Boolean'];
  LTV: Scalars['Float'];
  history: HistoryConnection;
  /** The IDs of the events the user can access when their account is scoped for only certain events */
  accessEventIds?: Maybe<Array<Scalars['String']>>;
  /** The IDs of the memberships the user can access when their account is scoped for only certain events */
  accessMembershipIds?: Maybe<Array<Scalars['String']>>;
  /** The Shopify user entry for the user if they have used the organization's Shopify store */
  shopifyUser?: Maybe<ShopifyUser>;
  pfOrgHasCustomEmailDomain?: Maybe<Scalars['Boolean']>;
  hmac?: Maybe<HmacOutput>;
  canConnectToPaymentTerminal: Scalars['Boolean'];
  paymentTerminalGatewayId?: Maybe<Scalars['String']>;
  contactId: Scalars['String'];
};


export type AtrUsersUpdatedBetweenOutputOrdersArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<OrderWhereInput>;
  orderBy?: Maybe<OrderOrderByInput>;
};


export type AtrUsersUpdatedBetweenOutputHistoryArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<HistoryOrderByInput>;
};

export type AttendanceActivityArgs = {
  __typename?: 'AttendanceActivityArgs';
  kind: BroadcastMarketingFiltersV2Kind;
  exclude: Scalars['Boolean'];
  eventIds: Array<Scalars['String']>;
};

export type AudienceCountInput = {
  transactionalType: BroadcastTransactionalType;
  audience?: Maybe<BroadcastAudience>;
  eventId?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
  packageId?: Maybe<Scalars['String']>;
  ticketTypeId?: Maybe<Array<Scalars['String']>>;
  zoneId?: Maybe<Array<Scalars['String']>>;
  releaseId?: Maybe<Array<Scalars['String']>>;
  addonId?: Maybe<Array<Scalars['String']>>;
};

/** Id of the broadcast audience. One broadcast only has one id. */
export type AudienceData = {
  __typename?: 'AudienceData';
  ticketTypeId?: Maybe<Array<Scalars['String']>>;
  zoneId?: Maybe<Array<Scalars['String']>>;
  releaseId?: Maybe<Array<Scalars['String']>>;
  addonId?: Maybe<Array<Scalars['String']>>;
};

/** Id of the broadcast audience. One broadcast only has one id. */
export type AudienceDataInput = {
  ticketTypeId?: Maybe<Array<Scalars['String']>>;
  zoneId?: Maybe<Array<Scalars['String']>>;
  releaseId?: Maybe<Array<Scalars['String']>>;
  addonId?: Maybe<Array<Scalars['String']>>;
};

export enum AuditEventType {
  UserExport = 'USER_EXPORT',
  UserImport = 'USER_IMPORT',
  ReportExport = 'REPORT_EXPORT',
  ApiKeyView = 'API_KEY_VIEW',
  ApiKeyUpdate = 'API_KEY_UPDATE',
  ApiKeyCreate = 'API_KEY_CREATE',
  SwitchOrganization = 'SWITCH_ORGANIZATION',
  Export = 'EXPORT',
  UpdateOrganization = 'UPDATE_ORGANIZATION',
  UserDeleteRequest = 'USER_DELETE_REQUEST',
  UserDeleteCompleted = 'USER_DELETE_COMPLETED',
  UserDeleteFailed = 'USER_DELETE_FAILED',
  UserDownloadRequested = 'USER_DOWNLOAD_REQUESTED',
  UserDownloadCompleted = 'USER_DOWNLOAD_COMPLETED',
  UserDownloadFailed = 'USER_DOWNLOAD_FAILED',
  LogAnonymization = 'LOG_ANONYMIZATION'
}

export type AutomaticallyAttributeInput = {
  refundId: Scalars['String'];
  additionalMetadata?: Maybe<Scalars['JSON']>;
};

export type Automation = {
  __typename?: 'Automation';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  /** When to send the email */
  automationType: AutomationType;
  /** Id of Mailchimp template */
  templateId?: Maybe<Scalars['Float']>;
  /** Id of Mailchimp audience */
  listId?: Maybe<Scalars['String']>;
  /** Subject of email */
  subject?: Maybe<Scalars['String']>;
  /** Used to show what we are targeting */
  targetSource: ReportingFilterSource;
  /** Id of source */
  targetSourceId?: Maybe<Scalars['String']>;
  /** Release Id of the source */
  targetReleaseId?: Maybe<Scalars['String']>;
  /** Active status. */
  isActive: Scalars['Boolean'];
  /** send time for a birthday email, only hour and minute are used */
  timeOfDay?: Maybe<Scalars['DateTime']>;
  /** Postmark template name */
  templateName?: Maybe<Scalars['String']>;
};

export enum AutomationType {
  OrderAbandoned = 'orderAbandoned',
  Birthday = 'birthday'
}

export type BarchartOutput = {
  __typename?: 'BarchartOutput';
  range: Scalars['String'];
  value: Scalars['Float'];
};

export type BillingDetails = {
  __typename?: 'BillingDetails';
  cardLast4?: Maybe<Scalars['String']>;
  cardBrand?: Maybe<Scalars['String']>;
  cardExpiryMonth?: Maybe<Scalars['Float']>;
  cardExpiryYear?: Maybe<Scalars['Float']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  totalPaymentCount?: Maybe<Scalars['Float']>;
  completedPaymentCount?: Maybe<Scalars['Float']>;
  amountPaid?: Maybe<Scalars['Float']>;
  totalFeeAmount?: Maybe<Scalars['Float']>;
};

export type BrandingInput = {
  /** Organization logo. */
  logo?: Maybe<Scalars['Upload']>;
  /** Organization mobile logo. */
  mobileLogo?: Maybe<Scalars['Upload']>;
  /** Organization favicon. */
  favicon?: Maybe<Scalars['Upload']>;
  /** Organization background image. */
  background?: Maybe<Scalars['Upload']>;
  /** Organization background image. */
  fullBackground?: Maybe<Scalars['Upload']>;
  /** Primary color. */
  primaryColor: Scalars['String'];
  /** Secondary color. */
  secondaryColor: Scalars['String'];
  /** Grey scale option. */
  greyScale?: Maybe<GreyScale>;
};

export type BrandingOutputBase = {
  __typename?: 'BrandingOutputBase';
  /** Organization logo. */
  logo?: Maybe<ExtendedFile>;
  /** Organization mobile logo. */
  mobileLogo?: Maybe<ExtendedFile>;
  /** Organization favicon. */
  favicon?: Maybe<ExtendedFile>;
  /** Organization background image. */
  background?: Maybe<ExtendedFile>;
  /** Organization full background image. */
  fullBackground?: Maybe<ExtendedFile>;
  /** Primary color. */
  primaryColor: Scalars['String'];
  /** Secondary color. */
  secondaryColor: Scalars['String'];
  /** Grey scale option. */
  greyScale?: Maybe<GreyScale>;
};

export type BreakdownItem = {
  __typename?: 'BreakdownItem';
  value: Scalars['Float'];
  label: Scalars['String'];
  percentage: Scalars['Float'];
  tooltip?: Maybe<StatisticTooltip>;
};

export type Broadcast = {
  __typename?: 'Broadcast';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  fromName: Scalars['String'];
  fromLocalPart: Scalars['String'];
  fromDomainId?: Maybe<Scalars['String']>;
  fromDomainName?: Maybe<Scalars['String']>;
  /** When to send the email */
  audienceType?: Maybe<BroadcastAudience>;
  /** The rich text object */
  message: Scalars['String'];
  event?: Maybe<Event>;
  membership?: Maybe<Membership>;
  package?: Maybe<PointItem>;
  scheduledAt: Scalars['DateTime'];
  status: BroadcastStatus;
  /** Array an object with the error responses from Postmark */
  errors?: Maybe<Scalars['JSON']>;
  count?: Maybe<Scalars['Float']>;
  /** tag entityIds */
  tags: TagEntityIds;
  audienceData: AudienceData;
  type: BroadcastType;
  marketingType?: Maybe<BroadcastMarketingType>;
  transactionalType?: Maybe<BroadcastTransactionalType>;
  marketingFilters?: Maybe<Array<BroadcastMarketingFilters>>;
  marketingFiltersV2?: Maybe<Array<BroadcastMarketingFiltersV2>>;
  style?: Maybe<EmailStyle>;
  /** The reporting version to decide how to query. */
  reportingVersion: Scalars['Float'];
  postmarkStats?: Maybe<PostmarkEmailStatsOverviewOutput>;
  /** The Postmark server ID to use for sending the email. Null if global server used. */
  postmarkServerId?: Maybe<Scalars['Float']>;
  preheader?: Maybe<Scalars['String']>;
  subjectRich: Scalars['JSON'];
};

/** Type of broadcast audience */
export enum BroadcastAudience {
  TicketBuyers = 'TICKET_BUYERS',
  UnnamedTicketBuyers = 'UNNAMED_TICKET_BUYERS',
  RegistrationWaitlistCustomers = 'REGISTRATION_WAITLIST_CUSTOMERS',
  ResaleWaitlistCustomers = 'RESALE_WAITLIST_CUSTOMERS',
  TicketType = 'TICKET_TYPE',
  Zone = 'ZONE',
  Release = 'RELEASE',
  Addon = 'ADDON',
  ManualMembershipRenewal = 'MANUAL_MEMBERSHIP_RENEWAL',
  AutomaticMembershipRenewal = 'AUTOMATIC_MEMBERSHIP_RENEWAL',
  MembershipBuyers = 'MEMBERSHIP_BUYERS',
  RegistrationWithoutPreauthOrder = 'REGISTRATION_WITHOUT_PREAUTH_ORDER'
}

export enum BroadcastCommunicationType {
  Email = 'email',
  Sms = 'sms'
}

export type BroadcastDefaultConfigOutput = {
  __typename?: 'BroadcastDefaultConfigOutput';
  style: EmailStyle;
  domainId?: Maybe<Scalars['String']>;
  localPart?: Maybe<Scalars['String']>;
};

export type BroadcastDeliveryError = {
  __typename?: 'BroadcastDeliveryError';
  name: Scalars['String'];
  email: Scalars['String'];
};

export type BroadcastDeliveryErrorsOutput = {
  __typename?: 'BroadcastDeliveryErrorsOutput';
  broadcastId: Scalars['String'];
  totalCount: Scalars['Float'];
  deliveryErrors: Array<BroadcastDeliveryError>;
};

export type BroadcastFilterCountInput = {
  filters?: Maybe<Array<MarketingFiltersInput>>;
  filtersV2?: Maybe<Array<BroadcastMarketingFiltersV2Input>>;
  broadcastCommunicationType: BroadcastCommunicationType;
};

export enum BroadcastFilterCriteria {
  Is = 'is',
  Not = 'not'
}

export enum BroadcastFilterStateType {
  Event = 'Event',
  TicketType = 'TicketType',
  Zone = 'Zone',
  Membership = 'Membership',
  Tag = 'Tag',
  Location = 'Location',
  EmailsOpened = 'EmailsOpened',
  Packages = 'Packages',
  Age = 'Age',
  Gender = 'Gender',
  Segment = 'Segment'
}

export enum BroadcastFilterType {
  Waitlist = 'waitlist',
  TicketBuyer = 'ticketBuyer',
  Tag = 'tag',
  Location = 'location',
  Region = 'region'
}

export type BroadcastListOutput = {
  __typename?: 'BroadcastListOutput';
  id: Scalars['ID'];
  scheduledAt: Scalars['DateTime'];
  status: BroadcastStatus;
  count?: Maybe<Scalars['Float']>;
  type: BroadcastType;
  subjectRich: Scalars['JSON'];
  lastEditedByFullName?: Maybe<Scalars['String']>;
  /** Name or title of the target (event, membership, or package) for essential broadcasts */
  targetLabel?: Maybe<Scalars['String']>;
  subjectDisplay: Scalars['String'];
};

export type BroadcastLocationFilterOptions = {
  __typename?: 'BroadcastLocationFilterOptions';
  region: Array<ResponseLabelValue>;
  state: Array<ResponseLabelValue>;
  district: Array<ResponseLabelValue>;
  locality: Array<ResponseLabelValue>;
  country: Array<ResponseLabelValue>;
};

export type BroadcastMarketingFilters = {
  __typename?: 'BroadcastMarketingFilters';
  ids: Array<Scalars['String']>;
  criteria?: Maybe<BroadcastFilterCriteria>;
  filterType: BroadcastFilterType;
};

export type BroadcastMarketingFiltersV2 = {
  __typename?: 'BroadcastMarketingFiltersV2';
  args: Scalars['String'];
};

export type BroadcastMarketingFiltersV2Input = {
  args: Scalars['String'];
};

export enum BroadcastMarketingFiltersV2Kind {
  TicketType = 'TicketType',
  PurchaseHistory = 'PurchaseHistory',
  PurchasedTicketActivity = 'PurchasedTicketActivity',
  AttendanceActivity = 'AttendanceActivity',
  PurchaseFrequency = 'PurchaseFrequency',
  Zone = 'Zone',
  Membership = 'Membership',
  Tag = 'Tag',
  Location = 'Location',
  Comp = 'Comp',
  EmailsOpened = 'EmailsOpened',
  Packages = 'Packages',
  Gender = 'Gender',
  Age = 'Age',
  Segment = 'Segment',
  PreAuthActivity = 'PreAuthActivity',
  RegisteredForActivity = 'RegisteredForActivity',
  JoinedWaitlistActivity = 'JoinedWaitlistActivity'
}

export type BroadcastMarketingFiltersV2Output = {
  __typename?: 'BroadcastMarketingFiltersV2Output';
  args: BroadcastMarketingFiltersV2Union;
};

export type BroadcastMarketingFiltersV2Union = PurchaseHistoryArgs | PurchasedTicketActivityArgs | AttendanceActivityArgs | PurchaseFrequencyArgs | TicketTypeArgs | LocationArgs | ZoneArgs | MembershipArgs | TagArgs | CompArgs | EmailsOpenedArgs | PackageArgs | GenderArgs | AgeArgs | SegmentArgs | PreAuthActivityArgs | RegisteredForActivityArgs | JoinedWaitlistActivityArgs;

export enum BroadcastMarketingType {
  OptIn = 'optIn',
  Custom = 'custom'
}

export type BroadcastMarketingV2StateInput = {
  filterV2: BroadcastMarketingFiltersV2Input;
};

export type BroadcastMarketingV2StateOutput = {
  __typename?: 'BroadcastMarketingV2StateOutput';
  type: BroadcastFilterStateType;
  id: Scalars['String'];
  label: Scalars['String'];
};

export type BroadcastOutput = {
  __typename?: 'BroadcastOutput';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  fromName: Scalars['String'];
  fromLocalPart: Scalars['String'];
  fromDomainId?: Maybe<Scalars['String']>;
  fromDomainName?: Maybe<Scalars['String']>;
  /** When to send the email */
  audienceType?: Maybe<BroadcastAudience>;
  /** The rich text object */
  message: Scalars['String'];
  event?: Maybe<Event>;
  membership?: Maybe<Membership>;
  package?: Maybe<PointItem>;
  scheduledAt: Scalars['DateTime'];
  status: BroadcastStatus;
  /** Array an object with the error responses from Postmark */
  errors?: Maybe<Scalars['JSON']>;
  count?: Maybe<Scalars['Float']>;
  tags: TagEntityIds;
  audienceData: AudienceData;
  type: BroadcastType;
  marketingType?: Maybe<BroadcastMarketingType>;
  transactionalType?: Maybe<BroadcastTransactionalType>;
  marketingFilters?: Maybe<Array<BroadcastMarketingFilters>>;
  marketingFiltersV2?: Maybe<Array<BroadcastMarketingFiltersV2Output>>;
  style?: Maybe<EmailStyle>;
  /** The reporting version to decide how to query. */
  reportingVersion: Scalars['Float'];
  postmarkStats?: Maybe<PostmarkEmailStatsOverviewOutput>;
  /** The Postmark server ID to use for sending the email. Null if global server used. */
  postmarkServerId?: Maybe<Scalars['Float']>;
  preheader?: Maybe<Scalars['String']>;
  subjectRich: Scalars['JSON'];
  recipients?: Maybe<Scalars['Float']>;
  subjectDisplay: Scalars['String'];
  /** The number of users that unsubscribed via this broadcast. */
  unsubscribeCount: Scalars['Int'];
  /** The Broadcast email delivery stats from postmark */
  stats?: Maybe<PostmarkEmailStatsOverviewOutput>;
  lastEditedBy?: Maybe<User>;
};

export type BroadcastReportedAsSpamUser = {
  __typename?: 'BroadcastReportedAsSpamUser';
  name: Scalars['String'];
  email: Scalars['String'];
};

export type BroadcastReportedAsSpamUsersOutput = {
  __typename?: 'BroadcastReportedAsSpamUsersOutput';
  broadcastId: Scalars['String'];
  reportedAsSpamUsers: Array<BroadcastReportedAsSpamUser>;
};

export type BroadcastReportingInputBase = {
  communicationType: BroadcastCommunicationType;
  userId?: Maybe<Scalars['String']>;
  waitlistUserId?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
  /** Email broadcast ID or SMS broadcast ID depending on type field. */
  broadcastId: Scalars['String'];
};

export type BroadcastReportingOrderInput = {
  communicationType: BroadcastCommunicationType;
  userId?: Maybe<Scalars['String']>;
  waitlistUserId?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
  /** Email broadcast ID or SMS broadcast ID depending on type field. */
  broadcastId: Scalars['String'];
  orderId: Scalars['String'];
};

export type BroadcastReportingOutput = {
  __typename?: 'BroadcastReportingOutput';
  clicksOpened: Scalars['Float'];
  revenue: Scalars['Float'];
  conversions: Scalars['Float'];
  spamReported: Scalars['Float'];
};

export type BroadcastReportingStatsInput = {
  broadcastId: Scalars['String'];
  type: BroadcastType;
};

export enum BroadcastStatus {
  Scheduled = 'SCHEDULED',
  Draft = 'DRAFT',
  Sent = 'SENT',
  Test = 'TEST'
}

export type BroadcastTags = {
  value: Scalars['String'];
  type: TagType;
  label?: Maybe<Scalars['String']>;
  isNew?: Maybe<Scalars['Boolean']>;
};

export enum BroadcastTransactionalType {
  Event = 'Event',
  Membership = 'Membership',
  Package = 'Package'
}

export enum BroadcastType {
  Marketing = 'marketing',
  Transactional = 'transactional'
}

export type BroadcastUnsubscribe = {
  __typename?: 'BroadcastUnsubscribe';
  name: Scalars['String'];
  email: Scalars['String'];
};

export type BroadcastUnsubscribesOutput = {
  __typename?: 'BroadcastUnsubscribesOutput';
  broadcastId: Scalars['String'];
  totalCount: Scalars['Float'];
  unsubscribes: Array<BroadcastUnsubscribe>;
};

export type BulkActionAccessCodesFromMembershipInput = {
  /** Array of access code IDs to perform the bulk action on from the membership */
  accessCodeIds?: Maybe<Array<Scalars['ID']>>;
};

export type BulkExpoAttendeeInput = {
  attendees: Array<ExpoAttendeeInput>;
};

/** Bulk orders item type */
export type BulkOrdersItem = {
  __typename?: 'BulkOrdersItem';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  processedAt?: Maybe<Scalars['DateTime']>;
  errorMessage?: Maybe<Scalars['String']>;
  /** bulk orders item status. */
  status?: Maybe<BulkOrdersItemStatus>;
};

/** Bulk order items status */
export enum BulkOrdersItemStatus {
  Success = 'Success',
  Failed = 'Failed'
}

/** Buyer information. */
export type BuyerInformation = {
  __typename?: 'BuyerInformation';
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  /** Postal code provided by the customer. Returns `null` if `UpdateOrderInput.deliveryMethod` is set to other than `eTicket`. */
  postalCode?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  /** Tax number provided by the customer. */
  taxNumber?: Maybe<Scalars['String']>;
  /** Company name provided by the customer. */
  companyName?: Maybe<Scalars['String']>;
  travelDeals?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** Buyer information. */
export type BuyerInformationInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  /** Postal code provided by the customer. Pass `null` if `UpdateOrderInput.deliveryMethod` is set to other than `eTicket`. */
  postalCode?: Maybe<Scalars['String']>;
  /** Tax Number provided by the customer. */
  taxNumber?: Maybe<Scalars['String']>;
  /** Company name provided by the customer. */
  companyName?: Maybe<Scalars['String']>;
  travelDeals?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type CalendarHomepageCustomization = {
  __typename?: 'CalendarHomepageCustomization';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  organizationId: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  banner?: Maybe<ExtendedFile>;
};

export type CardUpdateSetupIntentOutput = {
  __typename?: 'CardUpdateSetupIntentOutput';
  clientSecret: Scalars['String'];
};

export type ChargeLineItem = {
  __typename?: 'ChargeLineItem';
  createdAt: Scalars['DateTime'];
  orderId: Scalars['String'];
  lineItemCount: Scalars['Float'];
  lineItemTotalCents: Scalars['Float'];
  lineItemChargedCents: Scalars['Float'];
  lineItemUnchargedCents: Scalars['Float'];
};

export type ChargeMonthSummaryOutput = {
  __typename?: 'ChargeMonthSummaryOutput';
  lineItems: Array<ChargeLineItem>;
};

export type ChargeSummaryOutput = {
  __typename?: 'ChargeSummaryOutput';
  month: Scalars['DateTime'];
  totalCents: Scalars['Float'];
  totalChargedCents: Scalars['Float'];
  totalUnchargedCents: Scalars['Float'];
};

export type CodeReportItem = {
  __typename?: 'CodeReportItem';
  code: Scalars['String'];
  redeemed: Scalars['Float'];
  sold: Scalars['Float'];
  amount: Scalars['Float'];
  scanned: Scalars['Float'];
};

export type CodeReportOutput = {
  __typename?: 'CodeReportOutput';
  counts: Scalars['Float'];
  items: Array<CodeReportItem>;
};

export type ComparativeReportDefaultFiltersInput = {
  sourceId?: Maybe<Scalars['String']>;
  sourceType?: Maybe<ComparisonSource>;
  alignmentType?: Maybe<SalesComparisonAlignmentType>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
};

export type ComparativeReportDefaultFiltersOutput = {
  __typename?: 'ComparativeReportDefaultFiltersOutput';
  periodFilter: PeriodFilterDefaults;
  metricFilter: MetricFilterDefaults;
};

export type CompArgs = {
  __typename?: 'CompArgs';
  kind: BroadcastMarketingFiltersV2Kind;
  exclude: Scalars['Boolean'];
  eventIds: Array<Scalars['String']>;
};

export enum ComparisonSource {
  Membership = 'MEMBERSHIP',
  Event = 'EVENT',
  Season = 'SEASON'
}

export type Competition = {
  __typename?: 'Competition';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  competitionType: CompetitionType;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  termsAndConditions?: Maybe<Scalars['String']>;
  bannerImage?: Maybe<ExtendedFile>;
  isPublished: Scalars['Boolean'];
  prizes?: Maybe<Array<CompetitionPrize>>;
  promoter?: Maybe<Array<CompetitionReward>>;
  isCompetitionRunning: Scalars['Boolean'];
  competitionState: CompetitionState;
  referralRewardValue?: Maybe<Scalars['Int']>;
};

export type CompetitionCustomerReporting = {
  __typename?: 'CompetitionCustomerReporting';
  competitionEndDate: Scalars['DateTime'];
  competitionTitle: Scalars['String'];
  competitionEventTitle: Scalars['String'];
  competitionEventLogo?: Maybe<ExtendedFile>;
  competitionBannerImage?: Maybe<ExtendedFile>;
  competitionReferralLink?: Maybe<Scalars['String']>;
  competitionSharePageLink?: Maybe<Scalars['String']>;
  eventId: Scalars['String'];
  competitionId: Scalars['String'];
  referralsMade: Scalars['Int'];
  entries: Scalars['Int'];
  isCompetitionRunning: Scalars['Boolean'];
};

export type CompetitionOnsaleOutput = {
  __typename?: 'CompetitionOnsaleOutput';
  totalEntries: Scalars['Float'];
  pageViews: Scalars['Float'];
  conversionRate: Scalars['Float'];
  revenue: Scalars['Float'];
  totalOrders: Scalars['Float'];
  ticketsSold: Scalars['Float'];
  newCustomers: Scalars['Float'];
  hasSalesOutsideOfCompetition: Scalars['Boolean'];
};

export type CompetitionPrize = {
  __typename?: 'CompetitionPrize';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  prizeOrder: Scalars['Float'];
  quantity: Scalars['Float'];
  image?: Maybe<ExtendedFile>;
};

export type CompetitionPrizeInput = {
  id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  prizeOrder?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['Upload']>;
};

export type CompetitionPromoterInput = {
  platform: Scalars['String'];
  actionType: Scalars['String'];
  value: Scalars['Int'];
  enabled: Scalars['Boolean'];
};

export type CompetitionRegistrationOutput = {
  __typename?: 'CompetitionRegistrationOutput';
  totalEntries: Scalars['Float'];
  pageViews: Scalars['Float'];
  /** Total page views for the event details page. */
  eventDetailsPageViews: Scalars['Float'];
  /** Total page views for the registration sign up form page. */
  registrationPageViews: Scalars['Float'];
  conversionRate: Scalars['Float'];
  eventPageConversionRate: Scalars['Float'];
  registrationPageConversionRate: Scalars['Float'];
  totalRegistrations: Scalars['Float'];
  newCustomers: Scalars['Float'];
};

export type CompetitionReportingInput = {
  competitionId: Scalars['String'];
  eventId: Scalars['String'];
};

export type CompetitionReportingOnsaleOutput = {
  __typename?: 'CompetitionReportingOnsaleOutput';
  competition: CompetitionOnsaleOutput;
  promoter: PromoterOnsaleOutput;
  actionEngagement?: Maybe<Array<ActionEngagementRecordOutput>>;
};

export type CompetitionReportingRegistrationOutput = {
  __typename?: 'CompetitionReportingRegistrationOutput';
  competition: CompetitionRegistrationOutput;
  promoter: PromoterRegistrationOutput;
  actionEngagement?: Maybe<Array<ActionEngagementRecordOutput>>;
};

export type CompetitionReward = {
  __typename?: 'CompetitionReward';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  platform: Scalars['String'];
  actionType: Scalars['String'];
  value: Scalars['Float'];
  socialLinkType?: Maybe<Scalars['String']>;
  isEnabled: Scalars['Boolean'];
};

export enum CompetitionState {
  Upcoming = 'UPCOMING',
  Running = 'RUNNING',
  Ended = 'ENDED'
}

/** Competition type. */
export enum CompetitionType {
  Registration = 'REGISTRATION',
  Onsale = 'ONSALE'
}

export type CompleteStripeOAuth = {
  __typename?: 'CompleteStripeOAuth';
  redirectUrl?: Maybe<Scalars['String']>;
};

export type Coordinate = {
  __typename?: 'Coordinate';
  /** Latitude */
  lat: Scalars['Float'];
  /** Longitude */
  lng: Scalars['Float'];
};

export type CoordinateInput = {
  /** Latitude */
  lat: Scalars['Float'];
  /** Longitude */
  lng: Scalars['Float'];
};

export type CopyEmailInput = {
  targetId: Scalars['String'];
  copyFromId: Scalars['String'];
  idType: Scalars['String'];
  emailTypes: Array<EmailType>;
};

export type CreateArtistInput = {
  /** The artist's Flicket ID. */
  id?: Maybe<Scalars['String']>;
  /** The artist's name. */
  name: Scalars['String'];
  /** Where the artist data is from, .e.g. Spotify. */
  source: Scalars['String'];
  /** The artist's source ID. */
  sourceId: Scalars['String'];
  /** The artist's image URL. */
  imageUrl?: Maybe<Scalars['String']>;
  /** The artist's music genres. */
  genres?: Maybe<Array<CreateGenreInput>>;
  /** The artist's follower count. */
  followerCount?: Maybe<Scalars['Float']>;
};

export type CreateAttributableRefundInput = {
  orderId: Scalars['String'];
  /** Notes why the refund was created. */
  notes: Scalars['String'];
  manual?: Maybe<ManualRefundInput>;
  /** Whether to send a refund confirmation email. */
  sendEmail?: Maybe<Scalars['Boolean']>;
  attributions: Array<RefundAttributionInput>;
  ticketIdsToRelease?: Maybe<Array<Scalars['String']>>;
};

export type CreateAutomationInput = {
  name: Scalars['String'];
  automationType: AutomationType;
  templateId?: Maybe<Scalars['Float']>;
  subject?: Maybe<Scalars['String']>;
  listId?: Maybe<Scalars['String']>;
  targetSource: ReportingFilterSource;
  targetSourceId?: Maybe<Scalars['String']>;
  targetReleaseId?: Maybe<Scalars['String']>;
  timeOfDay?: Maybe<Scalars['DateTime']>;
  templateName?: Maybe<Scalars['String']>;
};

export type CreateCompetitionInput = {
  competitionType: CompetitionType;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  termsAndConditions?: Maybe<Scalars['String']>;
  referralRewardValue?: Maybe<Scalars['Int']>;
  bannerImage?: Maybe<Scalars['Upload']>;
  prizes?: Maybe<Array<CompetitionPrizeInput>>;
  promoter?: Maybe<Array<CompetitionPromoterInput>>;
};

/** Single endpoint to create a comp order */
export type CreateCompOrderInput = {
  sendSmsConfirmation?: Maybe<Scalars['Boolean']>;
  /** Order type */
  orderType?: Maybe<OrderType>;
  /** Where the order initiated from */
  orderOriginatedFrom?: Maybe<OrderOriginatedFrom>;
  /** Release id associated with the order. */
  releaseId?: Maybe<Scalars['String']>;
  /** Release password id associated with the order. */
  releasePasswordId?: Maybe<Scalars['String']>;
  /** Access code id associated with the order. */
  accessCodeId?: Maybe<Scalars['String']>;
  /** Membership id associated with the order. */
  membershipId?: Maybe<Scalars['String']>;
  /** User id can be provided for back-office orders */
  userId?: Maybe<Scalars['String']>;
  /** List of the order's line items. */
  lineItems: Array<LineItemInput>;
  /** Seats.IO hold token. */
  holdToken?: Maybe<Scalars['String']>;
  /** Multi buy promotion id. */
  multiBuyId?: Maybe<Scalars['String']>;
  posId?: Maybe<Scalars['String']>;
  referralId?: Maybe<Scalars['String']>;
  referralCode?: Maybe<Scalars['String']>;
  transferFee?: Maybe<Scalars['Float']>;
  isCreatedFromRecoveredCart?: Maybe<Scalars['Boolean']>;
  /** Buyer details. */
  buyerInformation?: Maybe<BuyerInformationInput>;
  usableForMarketing?: Maybe<Scalars['Boolean']>;
  seekaPId?: Maybe<Scalars['String']>;
  /** The delivery method chosen by the customer. */
  deliveryMethod?: Maybe<ShippingOption>;
  /** Billing address provided by the customer. */
  billingAddress?: Maybe<AddressInput>;
  /** Shipping address provided by the customer. */
  shippingAddress?: Maybe<AddressInput>;
  /** Whether the shipping address matches the billing address. */
  shippingAddressMatchesBillingAddress?: Maybe<Scalars['Boolean']>;
  /** If the purchaser has added dietary requirements */
  dietaryRequirements?: Maybe<Scalars['String']>;
  /** How the user heard about the event */
  heardAboutUs?: Maybe<HeardAboutUsType>;
  /** Heard about us details when heardAboutUs is other */
  heardAboutUsDetails?: Maybe<Scalars['String']>;
  /** If the order is starting a membership subscription */
  automaticRenewMambership?: Maybe<Scalars['Boolean']>;
  /**
   * Whether the order is updated on admin portal. 
   *     If the user is an admin, we won't update the details even if this is true.
   */
  updateDetails?: Maybe<Scalars['Boolean']>;
  userAcquisition?: Maybe<UserAcquisition>;
  /** Order status to transition to. */
  status?: Maybe<OrderStatus>;
  /** Selected payment method if order status is paid (allowed: cash, eftpos, invoice, other). */
  method?: Maybe<PaymentProvider>;
  /** Will not send order confirmation email if set */
  skipOrderConfirmation?: Maybe<Scalars['Boolean']>;
  /** Will send the customer an invoice email for hold orders if set */
  sendHoldOrderCustomerEmail?: Maybe<Scalars['Boolean']>;
  /** Whether to generate a Xero invoice for order. Only applies to hold orders for organizations with Xero integration enabled. */
  shouldGenerateXeroInvoice?: Maybe<Scalars['Boolean']>;
  isComp?: Maybe<Scalars['Boolean']>;
  compReason?: Maybe<Scalars['String']>;
  /** Additional transaction fees to be added to the order. Useful for 3rd party payment processing. */
  manualTransactionFee?: Maybe<Scalars['Float']>;
};

/** Represents additional info required to host a digital event. */
export type CreateDigitalInfoInput = {
  /** The url that digital pass codes are appended to in order to access the digital event/membership. */
  url: Scalars['String'];
  /** The Postmark email template that is used to send digital pass codes. */
  emailTemplateId?: Maybe<Scalars['String']>;
  additionalEmailInfo?: Maybe<AdditionalEmailInfoInput>;
};

export type CreateEmailCustomizationInput = {
  emailType: EmailType;
  eventId?: Maybe<Scalars['String']>;
  status?: Maybe<EmailCustomizationStatus>;
  membershipId?: Maybe<Scalars['String']>;
  pointItemId?: Maybe<Scalars['String']>;
};

export type CreateEmailDomainInput = {
  name: Scalars['String'];
};

export type CreateEventAddonInput = {
  /** The event id that is associated with the addon. */
  eventId: Scalars['String'];
  /** The name of the addon. */
  name: Scalars['String'];
  /** Indicates whether naming the addon is possible or not. */
  enableNaming: Scalars['Boolean'];
  /** Maximum quantity to be sold for the addon. */
  quantity: Scalars['Float'];
  /** The price associated with the addon. */
  price: Scalars['Float'];
  /** The brief description of the addon. */
  description?: Maybe<Scalars['String']>;
  /** Images for the ticket gallery */
  imageGallery?: Maybe<Array<ImageGalleryItemInput>>;
  /** The restrictions applied to the addon. */
  restrictions?: Maybe<Scalars['String']>;
  /** The active status of the addon. */
  isActive: Scalars['Boolean'];
  namingFields: Array<FormFieldInput>;
  /** Image banner specific for a ticket type on the print at home ticket */
  addonImage?: Maybe<Scalars['Upload']>;
  insideFee?: Maybe<Scalars['Float']>;
  /** Whether hide QR code on ticket. */
  hideQRCode?: Maybe<Scalars['Boolean']>;
  /** The intellitix access ID that matches this addon */
  intellitixId?: Maybe<Scalars['String']>;
};

export type CreateEventDate = {
  id?: Maybe<Scalars['String']>;
  startDate: Scalars['String'];
  endDate: Scalars['String'];
  doorsOpen?: Maybe<Scalars['String']>;
};

/** Creates a new event. */
export type CreateEventInput = {
  /** The kind of event. */
  eventKind?: Maybe<EventKind>;
  /** Represents additional info required to host a digital event. */
  digitalInfo?: Maybe<CreateDigitalInfoInput>;
  /** Event season. */
  season?: Maybe<Scalars['String']>;
  venue?: Maybe<Scalars['String']>;
  /** Event title. */
  title: Scalars['String'];
  logo?: Maybe<Scalars['Upload']>;
  backgroundImage?: Maybe<Scalars['Upload']>;
  backgroundImageFullPage?: Maybe<Scalars['Upload']>;
  descriptionImage?: Maybe<Scalars['Upload']>;
  thumbnail?: Maybe<Scalars['Upload']>;
  printBanner1?: Maybe<Scalars['Upload']>;
  printBanner2?: Maybe<Scalars['Upload']>;
  hardCopyTicketBanner?: Maybe<Scalars['Upload']>;
  /** Event description. */
  description?: Maybe<Scalars['String']>;
  /** Event dates. */
  dates: Array<CreateEventDate>;
  /** Doors open time. */
  doorsOpen?: Maybe<Scalars['String']>;
  /** Display doors open time. */
  showDoorsOpen?: Maybe<Scalars['Boolean']>;
  /** Display event start time. */
  showStartTime?: Maybe<Scalars['Boolean']>;
  /** Display event end time. */
  showEndTime?: Maybe<Scalars['Boolean']>;
  /** Date at which tickets are viewable/printable from. */
  ticketsViewableFromDate?: Maybe<Scalars['String']>;
  /** Event active status. */
  isActive?: Maybe<Scalars['Boolean']>;
  /** Event featured status. */
  isFeatured?: Maybe<Scalars['Boolean']>;
  /** Booking fee type. */
  bookingFeeType: FeeType;
  /** Booking fee. */
  bookingFee: Scalars['Float'];
  /** Whether event is R-18. */
  isR18?: Maybe<Scalars['Boolean']>;
  /** Whether the event is discoverable on BandsInTown */
  isDiscoverable?: Maybe<Scalars['Boolean']>;
  /** Whether the event should be marked as a festival in BandsInTown */
  isFestival?: Maybe<Scalars['Boolean']>;
  /** Whether event is checking for vaccine passports on entry */
  checkForVaccinePass?: Maybe<Scalars['Boolean']>;
  /** Whether naming ticket is available. */
  canNameTicket?: Maybe<Scalars['Boolean']>;
  /** Whether renaming ticket is available. */
  canRenameTicket?: Maybe<Scalars['Boolean']>;
  /** Whether changing seats is available. */
  canChangeSeats?: Maybe<Scalars['Boolean']>;
  /** Whether transfering ticket is available. */
  canTransferTicket?: Maybe<Scalars['Boolean']>;
  /** Whether the waitlist is visible on the event information page */
  enableWaitlist?: Maybe<Scalars['Boolean']>;
  /** The start date of the presale registration. */
  waitlistStartDate?: Maybe<Scalars['DateTime']>;
  /** The end date of the presale registration. */
  waitlistEndDate?: Maybe<Scalars['DateTime']>;
  /** Whether release codes are visible on the event information page */
  enableReleaseCodes?: Maybe<Scalars['Boolean']>;
  /** The fee for changing seats for the event ticket. */
  changingSeatsFee?: Maybe<Scalars['Float']>;
  /** The fee the seller pays for transferring a ticket. */
  sellerTransferringTicketFee?: Maybe<Scalars['Float']>;
  /** The fee the buyer pays for transferring a ticket. */
  buyerTransferringTicketFee?: Maybe<Scalars['Float']>;
  /** Shipping options. */
  shippingOptions?: Maybe<ShippingOptionsInput>;
  /** The payment gateways enabled for the event. */
  gateways?: Maybe<Array<Scalars['String']>>;
  /** The artists performing at the event. */
  artists?: Maybe<Array<CreateArtistInput>>;
  /** The genres of the event. */
  genres?: Maybe<Array<CreateGenreInput>>;
  termsAndConditions?: Maybe<Scalars['String']>;
  importantNotice?: Maybe<Scalars['String']>;
  accessibility?: Maybe<Scalars['String']>;
  invoiceInformation?: Maybe<Scalars['String']>;
  presaleInformation?: Maybe<Scalars['String']>;
  emailNotification?: Maybe<Scalars['String']>;
  redirectURL?: Maybe<Scalars['String']>;
  zonesAllocatedGates?: Maybe<Array<ZoneAllocatedGateInput>>;
  tags?: Maybe<Array<Scalars['String']>>;
  /** Inside fees for the event */
  insideFeeDetails?: Maybe<Array<InsideFeeDetailsInput>>;
  canUsePoints?: Maybe<Scalars['Boolean']>;
  gaVenue?: Maybe<CreateGaEventVenueInput>;
  ticketCover?: Maybe<TicketCoverInput>;
  listedReleaseOptions?: Maybe<ListedReleaseOptionsInput>;
  merchantReference?: Maybe<Scalars['String']>;
  intellitixProjectId?: Maybe<Scalars['String']>;
  intellitixSourceId?: Maybe<Scalars['String']>;
  pixelId?: Maybe<Scalars['String']>;
  hiddenFromPublic?: Maybe<Scalars['Boolean']>;
  enablePaymentPlans?: Maybe<Scalars['Boolean']>;
  paymentPlanScheduleOptions?: Maybe<Array<ScheduleOptionInput>>;
  seoMetadata?: Maybe<SeoMetadataInput>;
  productUpsell?: Maybe<ProductUpsellInput>;
  /** Bulk ticket type updates */
  ticketTypes?: Maybe<Array<UpdateTicketTypeInputWithId>>;
  /** The event addons to add to the event. */
  eventAddons?: Maybe<Array<UpdateEventAddonInputWithId>>;
  /** Custom tax fields for the event */
  tax?: Maybe<Array<TaxInput>>;
  /** Event override settings for seat selection filters */
  seatSelectionFilterOverrides?: Maybe<SeatSelectionFiltersInput>;
};

export type CreateEventMultiBuyPromotionInput = {
  name: Scalars['String'];
  buyQuantity: Scalars['Float'];
  getQuantity: Scalars['Float'];
  price: Scalars['Float'];
  /** The event id that is associated with the promotion. */
  eventId: Scalars['String'];
  buyTicketTypeId: Scalars['String'];
  getTicketTypeId: Scalars['String'];
};

export type CreateEventPromoCodeInput = {
  /** The unique code that represents the promotion. */
  code: Scalars['String'];
  /** The discount type associated with the promotion. */
  discountType: DiscountType;
  /** The discount amount of the promotion. */
  discountAmount: Scalars['Float'];
  /** The maximum amount of use condition of the promotion. Returns `null` when inactive. */
  maxUsage?: Maybe<Scalars['Float']>;
  /** The start date condition of the promotion. Returns `null` when inactive. */
  startDate?: Maybe<Scalars['DateTime']>;
  /** The end date condition of the promotion. Returns `null` when inactive. */
  endDate?: Maybe<Scalars['DateTime']>;
  /** The minimum order amount condition of the promotion. Returns `null` when inactive. */
  minOrderAmount?: Maybe<Scalars['Float']>;
  /** The maximum order amount condition of the promotion. Returns `null` when inactive. */
  maxOrderAmount?: Maybe<Scalars['Float']>;
  eventId: Scalars['String'];
  type: EventPromoCodeType;
  ticketTypes?: Maybe<Array<Scalars['String']>>;
  eventAddons?: Maybe<Array<Scalars['String']>>;
};

export type CreateGaEventVenueInput = {
  name?: Maybe<Scalars['String']>;
  address?: Maybe<AddressInput>;
  location?: Maybe<CoordinateInput>;
  timezone: Scalars['String'];
  locale: Scalars['String'];
};

export type CreateGenreInput = {
  /** The genres's Flicket ID. */
  id?: Maybe<Scalars['String']>;
  /** The genre's name. */
  name: Scalars['String'];
};

export type CreateHistoryInput = {
  /** The reference name of the history item. */
  refName: HistoryReferenceType;
  /** The reference id of the history item. */
  refId: Scalars['String'];
  /** The description of the history item. */
  description: Scalars['String'];
};

export type CreateIntegrationInput = {
  type: IntegrationType;
  name: Scalars['String'];
  secretKey?: Maybe<Scalars['String']>;
  publicKey?: Maybe<Scalars['String']>;
  wcPxPostSecretKey?: Maybe<Scalars['String']>;
  wcPxPostPublicKey?: Maybe<Scalars['String']>;
  webhookUrl?: Maybe<Scalars['String']>;
  transactionFeeType?: Maybe<FeeType>;
  transactionFee?: Maybe<Scalars['Float']>;
  transactionFeeType2?: Maybe<FeeType>;
  transactionFee2?: Maybe<Scalars['Float']>;
  paymentMethodType?: Maybe<Scalars['String']>;
  expressCheckoutEnabled?: Maybe<Scalars['Boolean']>;
  facebookTempToken?: Maybe<Scalars['String']>;
  facebookPageId?: Maybe<Scalars['String']>;
  facebookUserId?: Maybe<Scalars['String']>;
  bnplEnabled?: Maybe<Scalars['Boolean']>;
  bnplTransactionFeePercent?: Maybe<Scalars['Float']>;
  daysAfterCanRefund?: Maybe<Scalars['Float']>;
  createAccount?: Maybe<Scalars['Boolean']>;
};

export type CreateMembershipAddonInput = {
  /** The membership id that is associated with the addon. */
  membershipId: Scalars['String'];
  /** The name of the addon. */
  name: Scalars['String'];
  /** Indicates whether naming the addon is possible or not. */
  enableNaming: Scalars['Boolean'];
  /** Maximum quantity to be sold for the addon. */
  quantity: Scalars['Float'];
  /** The price associated with the addon. */
  price: Scalars['Float'];
  /** The brief description of the addon. */
  description?: Maybe<Scalars['String']>;
  /** The restrictions applied to the addon. */
  restrictions?: Maybe<Scalars['String']>;
  /** The active status of the addon. */
  isActive: Scalars['Boolean'];
  namingFields: Array<FormFieldInput>;
  /** Image banner specific for a ticket type on the print at home ticket */
  addonImage?: Maybe<Scalars['Upload']>;
};

export type CreateMembershipInput = {
  /** Name of the membership. */
  name: Scalars['String'];
  /** The kind of membership. */
  membershipKind: MembershipKind;
  /** Represents additional info required to host a digital membership. */
  digitalInfo?: Maybe<CreateDigitalInfoInput>;
  /** The previous memberships related to the membership. */
  previousMemberships?: Maybe<Array<Scalars['String']>>;
  /** The start date of the membership. */
  startDate: Scalars['DateTime'];
  /** The end date of the membership. */
  endDate: Scalars['DateTime'];
  /** The booking fee type of the membership. */
  bookingFeeType: FeeType;
  /** The booking fee for the membership. */
  bookingFee: Scalars['Float'];
  /** Shipping options. */
  shippingOptions?: Maybe<ShippingOptionsInput>;
  /** The description of the membership. */
  description: Scalars['String'];
  thumbnail?: Maybe<Scalars['Upload']>;
  backgroundImage?: Maybe<Scalars['Upload']>;
  descriptionImage?: Maybe<Scalars['Upload']>;
  banner?: Maybe<Scalars['Upload']>;
  printBanner1?: Maybe<Scalars['Upload']>;
  printBanner2?: Maybe<Scalars['Upload']>;
  /** The payment gateways enabled for the membership. */
  gateways?: Maybe<Array<Scalars['String']>>;
  /** Whether naming a membership is available. */
  canNameMembership?: Maybe<Scalars['Boolean']>;
  /** Whether renaming a membership is available. */
  canRenameMembership?: Maybe<Scalars['Boolean']>;
  /** Flag to determine if the membership is hidden from the public */
  hiddenFromPublic?: Maybe<Scalars['Boolean']>;
  /** Whether naming a membership is available. */
  canChangeSeats?: Maybe<Scalars['Boolean']>;
  /** The fee for changing seats for the membership. */
  changingSeatsFee?: Maybe<Scalars['Float']>;
  /** Whether the membership is ticketed. */
  isTicketed: Scalars['Boolean'];
  /** The active status of the membership. */
  isActive?: Maybe<Scalars['Boolean']>;
  termsAndConditions?: Maybe<Scalars['String']>;
  importantNotice?: Maybe<Scalars['String']>;
  accessibility?: Maybe<Scalars['String']>;
  invoiceInformation?: Maybe<Scalars['String']>;
  showSchedule?: Maybe<Scalars['Boolean']>;
  emailNotification?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  canUsePoints?: Maybe<Scalars['Boolean']>;
  enableAutoRenew?: Maybe<Scalars['Boolean']>;
  /** Whether individual event tickets can be transferred. */
  canTransferTickets?: Maybe<Scalars['Boolean']>;
  ticketCover?: Maybe<MembershipTicketCoverInput>;
  enablePaymentPlans?: Maybe<Scalars['Boolean']>;
  paymentPlanScheduleOptions?: Maybe<Array<ScheduleOptionInput>>;
  seoMetadata?: Maybe<SeoMetadataInput>;
  productUpsell?: Maybe<ProductUpsellInput>;
  /** Custom tax fields for the membership */
  tax?: Maybe<Array<TaxInput>>;
  membershipsViewableFromDate?: Maybe<Scalars['DateTime']>;
  isFlexiMembership?: Maybe<Scalars['Boolean']>;
};

export type CreateMembershipMultiBuyPromotionInput = {
  name: Scalars['String'];
  buyQuantity: Scalars['Float'];
  getQuantity: Scalars['Float'];
  price: Scalars['Float'];
  /** The membership id that is associated with the promotion. */
  membershipId: Scalars['String'];
  buyMembershipTypeId: Scalars['String'];
  getMembershipTypeId: Scalars['String'];
};

export type CreateMembershipPromoCodeInput = {
  /** The unique code that represents the promotion. */
  code: Scalars['String'];
  /** The discount type associated with the promotion. */
  discountType: DiscountType;
  /** The discount amount of the promotion. */
  discountAmount: Scalars['Float'];
  /** The maximum amount of use condition of the promotion. Returns `null` when inactive. */
  maxUsage?: Maybe<Scalars['Float']>;
  /** The start date condition of the promotion. Returns `null` when inactive. */
  startDate?: Maybe<Scalars['DateTime']>;
  /** The end date condition of the promotion. Returns `null` when inactive. */
  endDate?: Maybe<Scalars['DateTime']>;
  /** The minimum order amount condition of the promotion. Returns `null` when inactive. */
  minOrderAmount?: Maybe<Scalars['Float']>;
  /** The maximum order amount condition of the promotion. Returns `null` when inactive. */
  maxOrderAmount?: Maybe<Scalars['Float']>;
  membershipId: Scalars['String'];
  type: MembershipPromoCodeType;
  membershipTypes?: Maybe<Array<Scalars['String']>>;
  membershipAddons?: Maybe<Array<Scalars['String']>>;
};

export type CreateMembershipTypeInput = {
  /** The associated membership of the membership type. */
  membershipId: Scalars['String'];
  /** The kind of the membership type. */
  kind: MembershipTypeKind;
  /** Name of the membership type. */
  name: Scalars['String'];
  /** The ticket fee type. */
  ticketFeeType: FeeType;
  /** The number of membership tickets that must be purchased together in this set. */
  quantitySet?: Maybe<Scalars['Float']>;
  /** The ticket fee. */
  ticketFee: Scalars['Float'];
  /** Restrictions for the membership type. */
  description?: Maybe<Scalars['String']>;
  /** Restrictions for the membership type. */
  restrictions?: Maybe<Scalars['String']>;
  namingFields: Array<FormFieldInput>;
  minPurchaseQuantity?: Maybe<Scalars['Float']>;
  maxPurchaseQuantity?: Maybe<Scalars['Float']>;
  isGuestCard?: Maybe<Scalars['Boolean']>;
  /** Whether the membership type is for a child. */
  isChild: Scalars['Boolean'];
  isHidden?: Maybe<Scalars['Boolean']>;
};

export type CreateOrderError = {
  message: Scalars['String'];
};

export type CreateOrderErrorUnion = TicketNotAvailableError;

export type CreateOrderInput = {
  sendSmsConfirmation?: Maybe<Scalars['Boolean']>;
  /** Order type */
  orderType?: Maybe<OrderType>;
  /** Where the order initiated from */
  orderOriginatedFrom?: Maybe<OrderOriginatedFrom>;
  /** Release id associated with the order. */
  releaseId?: Maybe<Scalars['String']>;
  /** Release password id associated with the order. */
  releasePasswordId?: Maybe<Scalars['String']>;
  /** Access code id associated with the order. */
  accessCodeId?: Maybe<Scalars['String']>;
  /** Membership id associated with the order. */
  membershipId?: Maybe<Scalars['String']>;
  /** User id can be provided for back-office orders */
  userId?: Maybe<Scalars['String']>;
  /** List of the order's line items. */
  lineItems: Array<LineItemInput>;
  /** Seats.IO hold token. */
  holdToken?: Maybe<Scalars['String']>;
  /** Multi buy promotion id. */
  multiBuyId?: Maybe<Scalars['String']>;
  posId?: Maybe<Scalars['String']>;
  referralId?: Maybe<Scalars['String']>;
  referralCode?: Maybe<Scalars['String']>;
  transferFee?: Maybe<Scalars['Float']>;
  isCreatedFromRecoveredCart?: Maybe<Scalars['Boolean']>;
  /** Buyer details for presale checkout */
  buyerInformation?: Maybe<BuyerInformationInput>;
  usableForMarketing?: Maybe<Scalars['Boolean']>;
  seekaPId?: Maybe<Scalars['String']>;
};

export type CreateOrganizationInput = {
  name: Scalars['String'];
  slug: Scalars['String'];
  address: AddressInput;
  email: Scalars['String'];
  phone: Scalars['String'];
  taxNumber?: Maybe<Scalars['String']>;
  taxRate?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  supportInfo?: Maybe<Scalars['String']>;
  landingPage: LandingPage;
  showMemberships?: Maybe<Scalars['Boolean']>;
  showMembershipRenewal?: Maybe<Scalars['Boolean']>;
  termsAndConditions?: Maybe<Scalars['String']>;
  privacyPolicy?: Maybe<Scalars['String']>;
  branding?: Maybe<BrandingInput>;
  landingTours?: Maybe<LandingToursInput>;
  marketing?: Maybe<MarketingInput>;
  helpLink?: Maybe<Scalars['String']>;
  customTaxRate?: Maybe<Scalars['Float']>;
  customTaxName?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Scalars['String']>>;
  i18n?: Maybe<Scalars['JSON']>;
  defaultOptInMarketing?: Maybe<Scalars['Boolean']>;
  cookieConsent?: Maybe<Scalars['Boolean']>;
};

export type CreateOrganizationOutput = {
  __typename?: 'CreateOrganizationOutput';
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type CreatePaymentInput = {
  /** Payment gateway chosen by the customer (leave empty if paying with credits only). */
  gateway?: Maybe<Scalars['String']>;
  /** Whether the customer opts-in for marketing & promotions. */
  usableForMarketing: Scalars['Boolean'];
  /** Whether the customer receives a receipt by email. */
  skipOrderConfirmation?: Maybe<Scalars['Boolean']>;
  /** Whether the customer gets a hold order confirmation. */
  sendHoldOrderCustomerEmail?: Maybe<Scalars['Boolean']>;
  /** Whether the customer wants to initiate a reoccurring payment. */
  reoccurringPayment?: Maybe<Scalars['Boolean']>;
  pointRedemptionAmount?: Maybe<Scalars['Float']>;
  gatewayOptions?: Maybe<GatewayOptions>;
  customFields?: Maybe<Array<CustomFieldInput>>;
};

/** Represents the order creation result. */
export type CreatePaymentOutput = {
  __typename?: 'CreatePaymentOutput';
  /** The order. */
  order: Order;
  /** The payment creation result of the order. */
  result?: Maybe<PaymentResult>;
};

export type CreatePinPaymentCharge = {
  refId: Scalars['String'];
  cardToken: Scalars['String'];
};

export type CreatePointInput = {
  name?: Maybe<Scalars['String']>;
  termsAndConditions?: Maybe<Scalars['String']>;
  gatewayIds: Array<Scalars['String']>;
  isEnabled: Scalars['Boolean'];
};

export type CreatePointItemInput = {
  pointId: Scalars['String'];
  name: Scalars['String'];
  price: Scalars['Float'];
  amount: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['Upload']>;
  banner?: Maybe<Scalars['Upload']>;
  backgroundImage?: Maybe<Scalars['Upload']>;
  descriptionImage?: Maybe<Scalars['Upload']>;
  isVisible: Scalars['Boolean'];
};

export type CreatePosInput = {
  eventId: Scalars['String'];
  releaseId: Scalars['String'];
  name: Scalars['String'];
  /** Booking fee type. */
  bookingFeeType: FeeType;
  /** Booking fee. */
  bookingFee: Scalars['Float'];
  paymentOptions: PosPaymentOptionsInput;
  deliveryOptions: Array<ShippingOption>;
  cashAmount?: Maybe<Scalars['Float']>;
  /** Whether receipts are turned on. */
  enableReceipts?: Maybe<Scalars['Boolean']>;
  /** Auto print tickets if a printer is connected. */
  autoPrintTickets?: Maybe<Scalars['Boolean']>;
};

export type CreatePosUserInput = {
  eventId: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  accessCode: Scalars['String'];
};

export type CreatePurchaseRestrictionInput = {
  restrictedType: LineItemType;
  restrictedId: Scalars['String'];
  requiredEntities: Array<PurchaseRestrictionRequiredEntityInput>;
  isExclusive?: Maybe<Scalars['Boolean']>;
  isAlwaysVisible?: Maybe<Scalars['Boolean']>;
  quantity: Scalars['Float'];
};

export type CreateRedirectUrlInput = {
  /** Type of entity this redirect is for. */
  refName: Scalars['String'];
  /** Reference entity ID. */
  refId: Scalars['String'];
  /** Full URL path. */
  redirectURL: Scalars['String'];
};

export type CreateReferralCampaignDto = {
  referralReleaseId?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  referralOwnerRewardType: ReferralRewardType;
  referralOwnerRewardQuantityType: ReferralRewardQuantityType;
  referralOwnerRewardQuantity: Scalars['Float'];
  referralUserRewardType: ReferralRewardType;
  referralUserRewardQuantityType: ReferralRewardQuantityType;
  referralUserRewardQuantity: Scalars['Float'];
};

export type CreateReferralRewardsDto = {
  referralCampaignId: Scalars['String'];
  referralOwnerUserReferralId: Scalars['String'];
  referralUserId: Scalars['String'];
  orderId: Scalars['String'];
};

/** Creates a refund. */
export type CreateRefundInput = {
  /** Order id for which the refund will be created. */
  orderId: Scalars['String'];
  /** Desired amount of the refund. */
  amount: Scalars['Float'];
  /** Notes why the refund was created. */
  notes: Scalars['String'];
  /** Tickets to release (will also release child tickets). */
  ticketIds?: Maybe<Array<Scalars['String']>>;
  /** Whether the refund is a manual one. */
  isManual?: Maybe<Scalars['Boolean']>;
  gateway?: Maybe<RefundGateway>;
  /** Whether to send a refund confirmation email. */
  sendEmail?: Maybe<Scalars['Boolean']>;
  attributions?: Maybe<Array<RefundAttributionInput>>;
};

export type CreateReleaseInput = {
  event: Scalars['String'];
  /** Release name. */
  name: Scalars['String'];
  /** Release type. */
  type: ReleaseType;
  /** The slug for the unlisted release. Pass null if the release type is set to other than `unlisted`. */
  slug?: Maybe<Scalars['String']>;
  /** The password for the unlisted release. Pass null if the release type is set to other than `unlisted`. */
  password?: Maybe<Scalars['String']>;
  /** The start condition of the release. */
  startCondition: ReleaseStartCondition;
  /** The start date of the release. Pass null if the startCondition is set to other than `date`. */
  startConditionDate?: Maybe<Scalars['DateTime']>;
  /** The end condition of the release. */
  endCondition: ReleaseEndCondition;
  /** The quantity limit of the release. Pass null if the endCondition is set to other than `quantity`. */
  endConditionQuantity?: Maybe<Scalars['Float']>;
  /** The end date of the release. Pass null if the endCondition is set to other than `date`. */
  endConditionDate?: Maybe<Scalars['DateTime']>;
  /** The status of the release. */
  isActive?: Maybe<Scalars['Boolean']>;
  /** The zones of the release. */
  releaseZones: Array<ReleaseZoneInput>;
  /** The title of the unlisted release. Pass null if the `type` is set to other than `unlisted`. */
  presaleTitle?: Maybe<Scalars['String']>;
  presaleLogo?: Maybe<Scalars['Upload']>;
  presaleHeader?: Maybe<Scalars['Upload']>;
  /** The information of the unlisted release. Pass null if the `type` is set to other than `unlisted`. */
  presaleInformation?: Maybe<Scalars['String']>;
  /** The information that will be shown to customers on the ticketing page. */
  releaseNotes?: Maybe<Scalars['String']>;
  /** Ask how did you heard about us during the purchasing flow */
  askHowDidYouHearAboutUs?: Maybe<Scalars['Boolean']>;
  /** Request purchasers  */
  askForDietaryRequirements?: Maybe<Scalars['Boolean']>;
  /** Are comps visible to public */
  allowPublicComp?: Maybe<Scalars['Boolean']>;
  /** Can this release use Windcaves Account2Account functionality */
  allowAccount2Account?: Maybe<Scalars['Boolean']>;
  /** Can customers create hold orders for this release */
  allowHoldOrders?: Maybe<Scalars['Boolean']>;
  minPurchaseQuantity?: Maybe<Scalars['Float']>;
  maxPurchaseQuantity?: Maybe<Scalars['Float']>;
  releaseEventAddons?: Maybe<Array<Scalars['String']>>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  channels?: Maybe<Array<Scalars['String']>>;
  requiredMembershipIds?: Maybe<Array<Scalars['String']>>;
};

export type CreateReleaseZoneInput = {
  eventId: Scalars['String'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  /** Images for the ticket gallery */
  imageGallery?: Maybe<Array<ImageGalleryItemInput>>;
  capacity?: Maybe<Scalars['Int']>;
  admission: Scalars['Boolean'];
  isActive: Scalars['Boolean'];
};

export type CreateResaleTicketTypeInput = {
  /** The event id that is associated with the ticket type. */
  event: Scalars['String'];
  /** Ticket group name. */
  name: Scalars['String'];
  /** Booking fee type. */
  bookingFeeType: FeeType;
  /** Booking fee. */
  bookingFee: Scalars['Float'];
  /** Price for v2 event */
  price?: Maybe<Scalars['Float']>;
  /** The ticket types that map to this resale ticket. */
  ticketTypes: Array<Scalars['String']>;
};

export type CreateScoutCommunicationInput = {
  name: Scalars['String'];
  purpose: ScoutPurpose;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  type: ScoutCommunicationType;
  includeOptedOutOfMarketing?: Maybe<Scalars['Boolean']>;
  segmentId?: Maybe<Scalars['String']>;
  campaignId?: Maybe<Scalars['String']>;
  trackSource?: Maybe<ReportingFilterSource>;
  trackSourceId?: Maybe<Scalars['String']>;
  trackReleaseId?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  shouldUpdate?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  listId?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['Float']>;
  subject?: Maybe<Scalars['String']>;
};

export type CreateScoutInput = {
  name: Scalars['String'];
  promoteTo: Array<FilterSelectionInput>;
  exclude?: Maybe<Array<FilterSelectionInput>>;
};

export type CreateSeasonInput = {
  /** Season name. */
  name: Scalars['String'];
  /** Season active status. */
  isActive?: Maybe<Scalars['Boolean']>;
  /** Season description. */
  description: Scalars['String'];
  thumbnail?: Maybe<Scalars['Upload']>;
  backgroundImageFullPage?: Maybe<Scalars['Upload']>;
  landingBanner?: Maybe<Scalars['Upload']>;
  /** Rich text shown above the season events. */
  landingDescription?: Maybe<Scalars['String']>;
  displayOrder: Scalars['Float'];
};

export type CreateSignupFormInput = {
  name: Scalars['String'];
  heading: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<SignupFormTag>>;
  buttonText: Scalars['String'];
  styles: SignupFormStylesInput;
  formFields: Array<SignupFormFieldInput>;
  successMessage: Scalars['String'];
  successHeading: Scalars['String'];
};

export type CreateSmsBroadcastInput = {
  tags?: Maybe<Array<BroadcastTags>>;
  subject: Scalars['String'];
  message: Scalars['String'];
  /** If the input contains send time, then this is a scheduled SMS */
  scheduledAt?: Maybe<Scalars['DateTime']>;
  status: BroadcastStatus;
  testPhoneNumber?: Maybe<Scalars['String']>;
  marketingFilters?: Maybe<Array<BroadcastMarketingFiltersV2Input>>;
};

export type CreateTagInput = {
  name: Scalars['String'];
};

export type CreateTemporaryPosUserInput = {
  eventId: Scalars['String'];
  fullName: Scalars['String'];
};

export type CreateTemporaryPosUserOutput = {
  __typename?: 'CreateTemporaryPosUserOutput';
  user: User;
  password: Scalars['String'];
  /** Access token to create a single temporary POS user */
  oneTimeAccessToken: Scalars['String'];
};

export type CreateTestEmailInput = {
  emails: Array<Scalars['String']>;
  templateId: Scalars['Float'];
  subject: Scalars['String'];
  communicationId: Scalars['String'];
};

export type CreateTicketTypeDate = {
  eventDateId: Scalars['String'];
  alternateEntryTime?: Maybe<Scalars['String']>;
};

export type CreateTicketTypeInput = {
  /** The event id that is associated with the ticket type. */
  event: Scalars['String'];
  /** The kind of the ticket type. */
  kind: TicketTypeKind;
  /** Whether the ticket type is grouped. */
  isGrouped: Scalars['Boolean'];
  /** Whether the ticket is for a child. */
  isChild: Scalars['Boolean'];
  /** The amount of people in a group. Returns null if the ticket type is not grouped. */
  groupAmount?: Maybe<Scalars['Float']>;
  /** The number of tickets that must be purchased together in this set. */
  quantitySet?: Maybe<Scalars['Float']>;
  /** Intellitix access IDs */
  intellitixIds?: Maybe<Array<Scalars['String']>>;
  /** Ticket group name. */
  name: Scalars['String'];
  /** Event dates. */
  dates: Array<CreateTicketTypeDate>;
  /** Booking fee type. */
  bookingFeeType: FeeType;
  /** Booking fee. */
  bookingFee: Scalars['Float'];
  /** Per ticket stadium levy ticket fee. */
  stadiumLevyFee?: Maybe<Scalars['Float']>;
  /** Mark a ticket type as high demand */
  inHighDemand: Scalars['Boolean'];
  /** Custom badge text for ticket type (max 50 chars) */
  customBadge?: Maybe<Scalars['String']>;
  /** Custom badge background color (hex code) */
  customBadgeBackgroundColor?: Maybe<Scalars['String']>;
  /** Custom badge text color (hex code) */
  customBadgeTextColor?: Maybe<Scalars['String']>;
  /** Mark a ticket type as sold out */
  soldOut: Scalars['Boolean'];
  /** Hide the price in customer portal when the ticket type is marked as sold out */
  hidePriceWhenSoldOut: Scalars['Boolean'];
  /** Description of the ticket */
  description?: Maybe<Scalars['String']>;
  /** Restrictions for the ticket group. */
  restrictions?: Maybe<Scalars['String']>;
  /** Print at home information for the ticket group. */
  printAtHomeInformation?: Maybe<Scalars['String']>;
  namingFields: Array<FormFieldInput>;
  /** Doors open time. */
  doorsOpen?: Maybe<Scalars['String']>;
  /** Display doors open time. */
  showDoorsOpen?: Maybe<Scalars['Boolean']>;
  /** Display event start time. */
  showStartTime?: Maybe<Scalars['Boolean']>;
  /** Display event end time. */
  showEndTime?: Maybe<Scalars['Boolean']>;
  /** Custom entry dates for this ticket type. */
  entryDates?: Maybe<Array<Maybe<CreateEventDate>>>;
  /** Image banner specific for a ticket type on the print at home ticket */
  ticketBanner?: Maybe<Scalars['Upload']>;
  /** Image banner specific for a ticket type on the print at home ticket */
  ticketImage?: Maybe<Scalars['Upload']>;
  /** Images for the ticket gallery */
  imageGallery?: Maybe<Array<ImageGalleryItemInput>>;
  quantity?: Maybe<Scalars['Float']>;
  minPurchaseQuantity?: Maybe<Scalars['Float']>;
  maxPurchaseQuantity?: Maybe<Scalars['Float']>;
  tags?: Maybe<Array<Scalars['String']>>;
  /** Price for v2 event */
  price?: Maybe<Scalars['Float']>;
  /** releaseZoneId for v2 event */
  releaseZoneId?: Maybe<Scalars['String']>;
  /** isActive for v2 event */
  isActive?: Maybe<Scalars['Boolean']>;
  /** isComplimentary for v2 event */
  isComplimentary?: Maybe<Scalars['Boolean']>;
  /** Whether the ticket type can only be purchased by businesses. Makes company name required during checkout. */
  isBusinessOnly?: Maybe<Scalars['Boolean']>;
  onSaleConfig?: Maybe<TicketTypeOnSaleConfigInput>;
  /** Pricing tiers to set for the ticket type. NOTE: If `null` or omitted, the pricing tiers won't be updated. */
  pricingTiers?: Maybe<Array<PricingTierInput>>;
};

export type CreateUserInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  roles?: Maybe<Array<Role>>;
  phoneNumber?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['DateTime']>;
  /** To receive scanner login reminder emails. */
  receiveScannerEmail?: Maybe<Scalars['Boolean']>;
  gender?: Maybe<Gender>;
  usableForEmailMarketing?: Maybe<Scalars['Boolean']>;
  usableForSMSMarketing?: Maybe<Scalars['Boolean']>;
  /** Billing address provided by the user. */
  billingAddress?: Maybe<PartialAddressInput>;
  /** Shipping address provided by the user. */
  shippingAddress?: Maybe<PartialAddressInput>;
  /** Whether the shipping address matches the billing address. */
  shippingAddressMatchesBillingAddress?: Maybe<Scalars['Boolean']>;
  credits?: Maybe<Scalars['Float']>;
  companyName?: Maybe<Scalars['String']>;
  taxNumber?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  instagramUsername?: Maybe<Scalars['String']>;
  referralId?: Maybe<Scalars['String']>;
  accessEventIds?: Maybe<Array<Scalars['String']>>;
  accessMembershipIds?: Maybe<Array<Scalars['String']>>;
  /** Elevate users privileges from user to admin. */
  elevatePrivileges?: Maybe<Scalars['Boolean']>;
  userAcquisition?: Maybe<UserAcquisition>;
};

export type CreateVenueInput = {
  seating: VenueSeating;
  /** Seats.IO chart id. */
  seatsChartKey?: Maybe<Scalars['String']>;
  accessibilityInfo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  capacity?: Maybe<Scalars['Int']>;
  capacityUtilization?: Maybe<Scalars['Float']>;
  timezone: Scalars['String'];
  locale: Scalars['String'];
  address: AddressInput;
  location?: Maybe<CoordinateInput>;
  zones?: Maybe<Array<ZoneInput>>;
  gates?: Maybe<Array<GateInput>>;
  /** Default settings for seat selection filters */
  defaultSeatSelectionFilters?: Maybe<SeatSelectionFiltersInput>;
};

export type CurrentOrganizationOutput = {
  __typename?: 'CurrentOrganizationOutput';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** Organization name. */
  name: Scalars['String'];
  /** Organization slug. */
  slug: Scalars['String'];
  /** Contact e-mail address. */
  email: Scalars['String'];
  /** Contact phone. */
  phone: Scalars['String'];
  /** Tax number */
  taxNumber?: Maybe<Scalars['String']>;
  /** Currency */
  currency?: Maybe<Scalars['String']>;
  /** Address details. */
  address?: Maybe<Address>;
  /** Landing page settings. */
  landingPage: LandingPage;
  /** Show memberships in client navigation. */
  showMemberships: Scalars['Boolean'];
  /** Show memberships renewal banner. */
  showMembershipRenewal?: Maybe<Scalars['Boolean']>;
  /** The support information of the organistion */
  supportInfo?: Maybe<Scalars['String']>;
  /** The privacy policy of the organistion */
  privacyPolicy?: Maybe<Scalars['String']>;
  /** The terms and conditions of the organistion */
  termsAndConditions?: Maybe<Scalars['String']>;
  /** Marketing settings. */
  marketing?: Maybe<Marketing>;
  /** Shipping labels. */
  shippingLabels?: Maybe<ShippingLabels>;
  /** Beta features. */
  features?: Maybe<Array<Scalars['String']>>;
  timezone: Scalars['String'];
  locale: Scalars['String'];
  helpLink?: Maybe<Scalars['String']>;
  ticketCoverPlatformFeePercentage?: Maybe<Scalars['Float']>;
  taxRate: Scalars['Float'];
  /** Tax calculation method. either inclusive or exclusive. */
  taxCalculationMethod: TaxCalculationMethod;
  /** Used for UK customer, opt in marketing when is true */
  defaultOptInMarketing?: Maybe<Scalars['Boolean']>;
  /** Determines whether the cookie banner is enabled for this organization */
  cookieConsent: Scalars['Boolean'];
  defaultLanguage: Scalars['String'];
  customTaxRate?: Maybe<Scalars['Float']>;
  customTaxName?: Maybe<Scalars['String']>;
  platformChargeSettings?: Maybe<PlatformChargeSettings>;
  /** The i18n overrides for this organization. */
  i18n?: Maybe<Scalars['JSON']>;
  isTest: Scalars['Boolean'];
  /** Settings for the Tours landing page. */
  landingTours?: Maybe<LandingToursSettings>;
  /** Override for the domain, e.g. flicket.io */
  flicketDomainOverride?: Maybe<Scalars['String']>;
  branding: OrganizationOutputBranding;
  singleEvent?: Maybe<Event>;
  shopify?: Maybe<ShopifyIntegration>;
  point?: Maybe<Point>;
  defaultI18nLanguage: Scalars['String'];
  customFields: Array<CustomFieldOuput>;
  seekaConfig?: Maybe<SeekaOutput>;
  stats?: Maybe<OrganizationStats>;
  scannerUrl: Scalars['String'];
};

export type CustomerCompetitionReportingInput = {
  customerId: Scalars['String'];
};

export type CustomerReferralReportingInput = {
  customerId: Scalars['String'];
};

export type CustomerReportingOverviewArgs = {
  __typename?: 'CustomerReportingOverviewArgs';
  resold: PeReportStatistic;
  abandonCart: PeReportStatistic;
  abandonCartRecovered: PeReportStatistic;
  addons: PeReportStatistic;
  resaleMargin?: Maybe<PeReportStatistic>;
  resaleFeeRevenue?: Maybe<PeReportStatistic>;
  bookingFeeRevenue?: Maybe<PeReportStatistic>;
  refund: PeReportStatistic;
  ordersPartPaid: PeReportStatistic;
  ticketsPartPaid: PeReportStatistic;
  addonsRevenue?: Maybe<PeReportStatistic>;
  totalTicketsScanned: PeReportStatistic;
  conversionRate: PeReportStatistic;
  newCustomers: PeReportStatistic;
  marketableAudience: PeReportStatistic;
  averageLTV: PeReportStatistic;
  eventVisitors: PeReportStatistic;
  totalCustomers: PeReportStatistic;
  repeatPurchasers: PeReportStatistic;
  returningCustomers: PeReportStatistic;
  essentialEmailsSent: PeReportStatistic;
  essentialEmailsSentRate: PeReportStatistic;
  totalRegistrations: PeReportStatistic;
  newCustomerRegistrations: PeReportStatistic;
  registrationRevenue?: Maybe<PeReportStatistic>;
  registrationsNotConverted: PeReportStatistic;
  registrationCompetitionTotalRegistrations: PeReportStatistic;
  registrationCompetitionEventDetailsPageViews: PeReportStatistic;
  registrationCompetitionEventPageConversionRate: PeReportStatistic;
  registrationCompetitionRegistrationPageViews: PeReportStatistic;
  registrationCompetitionRegistrationPageConversionRate: PeReportStatistic;
  registrationCompetitionNewCustomers: PeReportStatistic;
  registrationCompetitionTotalEntries: PeReportStatistic;
  posSaleOverview: PosSaleOverview;
  posFinancialData?: Maybe<PosFinancialData>;
  posFloatData: PosFloatData;
  onsaleCompetitionTotalRevenue?: Maybe<PeReportStatistic>;
  onsaleCompetitionTotalCompetitionEntries: PeReportStatistic;
  onsaleCompetitionEventPageViews: PeReportStatistic;
  onsaleCompetitionEventPageConversionRate: PeReportStatistic;
  onsaleCompetitionTotalOrders: PeReportStatistic;
  onsaleCompetitionTicketsSold: PeReportStatistic;
  onsaleCompetitionNewCustomers: PeReportStatistic;
  registrationPromoterRegistrationsViaReferral: PeReportStatistic;
  registrationPromoterNewCustomers: PeReportStatistic;
  registrationPromoterReferralEntriesAwarded: PeReportStatistic;
  totalTicketsIssued: PeReportStatistic;
  totalTicketsSold: PeReportStatistic;
  totalCompsIssued: PeReportStatistic;
  totalOrders: PeReportStatistic;
  membershipsRenewed: PeReportStatistic;
  membershipSales: MembershipSales;
  membershipFinancial?: Maybe<MembershipFinancial>;
  onsalePromoter: OnsalePromoter;
  faceValueTotal?: Maybe<PeReportStatistic>;
  netSale?: Maybe<PeReportStatistic>;
  averageOrderAmount: PeReportStatistic;
  overallPartPaidTicketRevenue?: Maybe<PeReportStatistic>;
  membershipsIssued: PeReportStatistic;
  membershipsSold: PeReportStatistic;
  membershipsComp: PeReportStatistic;
  ticketsRefund: PeReportStatistic;
  membershipsRefund: PeReportStatistic;
  overallTicketsPartPaid: PeReportStatistic;
  overallMembershipsPartPaid: PeReportStatistic;
  faceValueWithBookingFeeTotal?: Maybe<PeReportStatistic>;
  discounts: PeReportStatistic;
  ticketCoverOrdersSold: PeReportStatistic;
  ticketCoverOrderTotal?: Maybe<PeReportStatistic>;
  ticketProtectionRevenue?: Maybe<PeReportStatistic>;
  ticketProtectionCost?: Maybe<PeReportStatistic>;
  ticketProtectionMargin?: Maybe<PeReportStatistic>;
  averageOrderSize: PeReportStatistic;
  overallAverageTicketPrice: PeReportStatistic;
  overallAverageMembershipPrice: PeReportStatistic;
  overallPartPaidMembershipRevenue?: Maybe<PeReportStatistic>;
  paymentPlanTotalRevDue?: Maybe<PeReportStatistic>;
  points?: Maybe<PeReportStatistic>;
  credits?: Maybe<PeReportStatistic>;
  packagesSold: PeReportStatistic;
  pointsDistributed: PeReportStatistic;
  presaleEventDetailsPageViews: PeReportStatistic;
  presalePreAuthorizationFaceValue?: Maybe<PeReportStatistic>;
  presalePreAuthorizationConversionRate: PeReportStatistic;
  presalePreAuthorizationOrderCount: PeReportStatistic;
  presaleEventPageConversionRate: PeReportStatistic;
  preAuthTicketsAndTotalAdmissionTickets: PeReportStatistic;
  completedPreAuthAndPresaleOrders: PeReportStatistic;
  totalTicketsScannedOut: PeReportStatistic;
};

export type CustomField = {
  __typename?: 'CustomField';
  id?: Maybe<Scalars['String']>;
  fieldName: Scalars['String'];
  fieldValue: Scalars['String'];
};

export type CustomFieldInput = {
  id?: Maybe<Scalars['String']>;
  fieldName: Scalars['String'];
  fieldValue: Scalars['String'];
};

export type CustomFieldOuput = {
  __typename?: 'CustomFieldOuput';
  id: Scalars['String'];
  label: Scalars['String'];
  value: Scalars['Boolean'];
  /** Where the custom field input should appear. */
  targetArea: Array<Scalars['String']>;
  type: Scalars['String'];
  /** Whether the custom field is required. */
  isRequired?: Maybe<Scalars['Boolean']>;
};

export type CustomSaleOutput = {
  __typename?: 'CustomSaleOutput';
  data?: Maybe<Scalars['JSON']>;
};

export type DateRange = {
  __typename?: 'DateRange';
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
};


export type DefaultDateRange = {
  __typename?: 'DefaultDateRange';
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
};

export type DefaultDates = {
  __typename?: 'DefaultDates';
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
};

export type DeleteOneOutput = {
  __typename?: 'DeleteOneOutput';
  deletedId?: Maybe<Scalars['String']>;
};

export type DeleteScoutUserInput = {
  ids: Array<Scalars['String']>;
};

/** Derived Order status */
export enum DerivedOrderStatus {
  Pending = 'Pending',
  Hold = 'Hold',
  Paid = 'Paid',
  PartPaid = 'PartPaid',
  Completed = 'Completed',
  Canceled = 'Canceled',
  Expired = 'Expired',
  RefundFailed = 'RefundFailed',
  Refunded = 'Refunded',
  PartiallyRefunded = 'PartiallyRefunded',
  Precharge = 'Precharge'
}

/** Represents additional info required to host a digital event/membership. */
export type DigitalInfo = {
  __typename?: 'DigitalInfo';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The url that digital pass codes are appended to in order to access the digital event/membership. */
  url: Scalars['String'];
  /** The Postmark email template that is used to send digital pass codes. */
  emailTemplateId?: Maybe<Scalars['String']>;
  /** Additional email info to be added in digital event/membership access emails. */
  additionalEmailInfoText?: Maybe<Scalars['String']>;
  /** Additional email info button URL to be added in digital event/membership access emails. */
  additionalEmailButtonUrl?: Maybe<Scalars['String']>;
  /** Additional email info button text to be added in digital event/membership access emails. */
  additionalEmailButtonText?: Maybe<Scalars['String']>;
  /** Additional email info HTML be added in digital event/membership access emails. */
  additionalEmailInfoHTML?: Maybe<Scalars['String']>;
  event?: Maybe<Event>;
  membership?: Maybe<Membership>;
};

export type DigitalPassCodeStatusOutput = {
  __typename?: 'DigitalPassCodeStatusOutput';
  totalPassCodes: Scalars['Int'];
  remainingPassCodes: Scalars['Int'];
};

export enum DiscountType {
  Percentage = 'PERCENTAGE',
  Fixed = 'FIXED'
}

/** Duplicate an existing release. */
export type DuplicateSingleReleaseInput = {
  releaseId: Scalars['String'];
  newSlug: Scalars['String'];
  releaseType?: Maybe<Scalars['String']>;
};

export type DynamicImageInput = {
  eventId?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
  pointItemId?: Maybe<Scalars['String']>;
};

export type EmailCustomizationOutput = {
  __typename?: 'EmailCustomizationOutput';
  id: Scalars['String'];
  emailType: EmailType;
  status: EmailCustomizationStatus;
  subject?: Maybe<Scalars['JSON']>;
  richTextTemplate?: Maybe<Scalars['JSON']>;
  style: EmailStyle;
};

/** If the customization is active or not. */
export enum EmailCustomizationStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  Draft = 'DRAFT'
}

export type EmailDomainOutput = {
  __typename?: 'EmailDomainOutput';
  id: Scalars['String'];
  name: Scalars['String'];
  verified: Scalars['Boolean'];
  records: Array<EmailDomainRecordOutput>;
  isDeletable: Scalars['Boolean'];
};

export type EmailDomainRecordOutput = {
  __typename?: 'EmailDomainRecordOutput';
  host: Scalars['String'];
  type: Scalars['String'];
  verified: Scalars['Boolean'];
  value: Scalars['String'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
};

export type EmailsOpenedArgs = {
  __typename?: 'EmailsOpenedArgs';
  kind: BroadcastMarketingFiltersV2Kind;
  exclude: Scalars['Boolean'];
  broadcastIds: Array<Scalars['String']>;
};

export type EmailStyle = {
  __typename?: 'EmailStyle';
  backgroundColour: Scalars['String'];
  bodyColour: Scalars['String'];
  headingColour: Scalars['String'];
  paragraphColour: Scalars['String'];
  linkColour: Scalars['String'];
  buttonColour: Scalars['String'];
};

export type EmailStyleInput = {
  backgroundColour: Scalars['String'];
  bodyColour: Scalars['String'];
  headingColour: Scalars['String'];
  paragraphColour: Scalars['String'];
  linkColour: Scalars['String'];
  buttonColour: Scalars['String'];
};

/** The type of system email. */
export enum EmailType {
  AbandonedCart = 'ABANDONED_CART',
  OrderConfirmation = 'ORDER_CONFIRMATION',
  ComplimentaryOrderConfirmation = 'COMPLIMENTARY_ORDER_CONFIRMATION',
  SendToAFriend = 'SEND_TO_A_FRIEND',
  RegistrationConfirmation = 'REGISTRATION_CONFIRMATION',
  CompetitionConfirmationRegistration = 'COMPETITION_CONFIRMATION_REGISTRATION',
  CompetitionConfirmationMainSale = 'COMPETITION_CONFIRMATION_MAIN_SALE',
  ExhibitorLogin = 'EXHIBITOR_LOGIN',
  ScannerAccessInstruction = 'SCANNER_ACCESS_INSTRUCTION',
  ExhibitorPostEvent = 'EXHIBITOR_POST_EVENT',
  PointConfirmation = 'POINT_CONFIRMATION',
  ResaleTicketConfirmation = 'RESALE_TICKET_CONFIRMATION',
  ViewableNotification = 'VIEWABLE_NOTIFICATION',
  UserDeletionRequest = 'USER_DELETION_REQUEST',
  TicketNamingNotification = 'TICKET_NAMING_NOTIFICATION',
  PresaleCancelled = 'PRESALE_CANCELLED',
  PrechargePaymentFailed = 'PRECHARGE_PAYMENT_FAILED',
  PrechargeReminder = 'PRECHARGE_REMINDER',
  PrechargeConfirmation = 'PRECHARGE_CONFIRMATION',
  PresaleDateChangeNotification = 'PRESALE_DATE_CHANGE_NOTIFICATION',
  TotpCode = 'TOTP_CODE',
  MfaDisableWarning = 'MFA_DISABLE_WARNING',
  UserDeletionRequestComplete = 'USER_DELETION_REQUEST_COMPLETE',
  PreAuthEditCard = 'PRE_AUTH_EDIT_CARD'
}

export type EmailUsherComplimentaryInput = {
  ticketTypeId: Scalars['String'];
  ticketTypeName: Scalars['String'];
  releaseId: Scalars['String'];
};

export type Event = {
  __typename?: 'Event';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The kind of event */
  eventKind: EventKind;
  /** Event season. */
  season?: Maybe<Season>;
  venue: Venue;
  intellitixProjectId?: Maybe<Scalars['String']>;
  intellitixSourceId?: Maybe<Scalars['String']>;
  releases: Array<Release>;
  /** Seats.io event key. */
  seatsEventKey?: Maybe<Scalars['String']>;
  /** Event title. */
  title: Scalars['String'];
  /** Event description. */
  description: Scalars['String'];
  /** Event dates. */
  dates: Array<EventDate>;
  /** Event start date. */
  startDate?: Maybe<Scalars['DateTime']>;
  /** Display event start time. */
  showStartTime: Scalars['Boolean'];
  /** Event end date. */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Display event end time. */
  showEndTime: Scalars['Boolean'];
  /** Date at which tickets are viewable/printable after. */
  ticketsViewableFromDate?: Maybe<Scalars['DateTime']>;
  /** Event endDate has now lapsed, therefore it has ended. */
  hasEventEnded: Scalars['Boolean'];
  /** Event active status. */
  isActive: Scalars['Boolean'];
  /** Featured status. */
  isFeatured: Scalars['Boolean'];
  /** Booking fee type. */
  bookingFeeType: FeeType;
  /** Booking fee. */
  bookingFee: Scalars['Float'];
  /** Whether event is R-18. */
  isR18: Scalars['Boolean'];
  /** Whether the event is discoverable on BandsInTown */
  isDiscoverable: Scalars['Boolean'];
  /** Whether the event is a festival */
  isFestival: Scalars['Boolean'];
  /** Whether naming ticket is available. */
  canNameTicket: Scalars['Boolean'];
  /** Whether renaming ticket is available. */
  canRenameTicket: Scalars['Boolean'];
  /** Whether the waitlist is visible on the event information page */
  enableWaitlist: Scalars['Boolean'];
  /** The date the presale registration will be visible on the event information page. */
  waitlistStartDate?: Maybe<Scalars['DateTime']>;
  /** The date the presale registration will no longer be visible on the event information page. */
  waitlistEndDate?: Maybe<Scalars['DateTime']>;
  /** Whether renaming ticket is available. */
  enableReleaseCodes: Scalars['Boolean'];
  /** Whether changing seats is available. */
  canChangeSeats: Scalars['Boolean'];
  /** Whether transfering ticket is available. */
  canTransferTicket: Scalars['Boolean'];
  /** Whether sell to other fans on the waitlist is enabled. */
  ticketResaleEnabled: Scalars['Boolean'];
  /** Whether to enable waitlist for tickets when sold out. */
  ticketResaleWaitlistEnabled: Scalars['Boolean'];
  /** The renaming fee for the event ticket. */
  renamingFee?: Maybe<Scalars['Float']>;
  /** The fee for changing seats for the event ticket. */
  changingSeatsFee?: Maybe<Scalars['Float']>;
  /** The fee the seller pays for transferring a ticket. */
  sellerTransferringTicketFee?: Maybe<Scalars['Float']>;
  /** The fee the buyer pays for transferring a ticket. */
  buyerTransferringTicketFee?: Maybe<Scalars['Float']>;
  /** Shipping options. */
  shippingOptions?: Maybe<ShippingOptions>;
  thumbnail?: Maybe<ExtendedFile>;
  logo?: Maybe<ExtendedFile>;
  backgroundImage?: Maybe<ExtendedFile>;
  backgroundImageFullPage?: Maybe<ExtendedFile>;
  descriptionImage?: Maybe<ExtendedFile>;
  printBanner1?: Maybe<ExtendedFile>;
  printBanner2?: Maybe<ExtendedFile>;
  hardCopyTicketBanner?: Maybe<ExtendedFile>;
  /** The terms and conditions of the event */
  termsAndConditions?: Maybe<Scalars['String']>;
  /** Important notice section on the tickets */
  importantNotice?: Maybe<Scalars['String']>;
  /** The accessibility info of the event */
  accessibility?: Maybe<Scalars['String']>;
  /** The presale info of the event */
  presaleInformation?: Maybe<Scalars['String']>;
  /** The invoice info of the event */
  invoiceInformation?: Maybe<Scalars['String']>;
  /** Allocated gates to venue zones */
  zonesAllocatedGates?: Maybe<Array<ZoneAllocatedGate>>;
  /** Inside fees for the event */
  insideFeeDetails?: Maybe<Array<InsideFeeDetails>>;
  /** Featured status. */
  checkForVaccinePass: Scalars['Boolean'];
  /** Email address that gets sent a notifcation every time an order is completed */
  emailNotification?: Maybe<Scalars['String']>;
  /** Once a customer has finished purchasing they can be redirected back to another URL to continuing their purchsing journey */
  redirectURL?: Maybe<Scalars['String']>;
  /** The referral campaign associated with this event */
  referralCampaignId?: Maybe<Scalars['String']>;
  canUsePoints: Scalars['Boolean'];
  /** The ID of the Google Wallet Event Class for this event */
  googleWalletEventClassId?: Maybe<Scalars['String']>;
  lastTicketsViewableEmailsSentAt?: Maybe<Scalars['DateTime']>;
  ticketCover?: Maybe<EventTicketCover>;
  seoMetadata?: Maybe<SeoMetadata>;
  paymentPlanSettings?: Maybe<PaymentPlanSettings>;
  /** event level facebook pixel id */
  pixelId?: Maybe<Scalars['String']>;
  /** Whether to allow a ticket to be scanned in to multiple areas within a venue. */
  multiScanningEnabled: Scalars['Boolean'];
  /** Configuration for enforcing ticket entry time windows with grace period. */
  ticketEntryTimeEnforcement: TicketEntryTimeEnforcementOptions;
  hiddenFromPublic: Scalars['Boolean'];
  /** Custom tax fields for the event */
  tax?: Maybe<Array<Tax>>;
  merchantReferenceResult?: Maybe<Scalars['String']>;
  /** Event override for seat selection filters */
  seatSelectionFilterOverrides?: Maybe<SeatSelectionFilters>;
  hasPublicRelease: Scalars['Boolean'];
  venueAddress: Venue;
  ticketTypes: Array<TicketType>;
  gateways: Array<Integration>;
  addons: Array<EventAddon>;
  soldTicketsCount?: Maybe<Scalars['Float']>;
  soldTicketsCountToday?: Maybe<Scalars['Float']>;
  soldTicketsCountYesterday?: Maybe<Scalars['Float']>;
  totalRevenue?: Maybe<Scalars['Float']>;
  totalFaceValue?: Maybe<Scalars['Float']>;
  multiBuyPromotions: Array<EventMultiBuyPromotion>;
  tags: Array<Tag>;
  digitalPassCodesStatus?: Maybe<DigitalPassCodeStatusOutput>;
  digitalInfo?: Maybe<DigitalInfo>;
  defaultDateRange?: Maybe<DefaultDateRange>;
  hasPromoCodes: Scalars['Boolean'];
  isWaitlistAvailable: Scalars['Boolean'];
  presaleRelease?: Maybe<Release>;
  publicReleaseStartsAt?: Maybe<Scalars['DateTime']>;
  listedRelease?: Maybe<Release>;
  artists: Array<Artist>;
  ticketsIssued: Scalars['Int'];
  capacity?: Maybe<Scalars['Int']>;
  totalTicketsFaceValue?: Maybe<Scalars['Float']>;
  taxRate: Scalars['Float'];
  customTaxRate: Scalars['Float'];
  taxCalculationMethod: TaxCalculationMethod;
  customFields: Array<CustomFieldOuput>;
  fees: OrderFee;
  canUpgrade: Scalars['Boolean'];
  seekaConfig?: Maybe<SeekaOutput>;
  /** Effective seat selection filters (venue defaults merged with event overrides) */
  effectiveSeatFilters: SeatSelectionFilters;
  prePurchaseAvailableStatus: PrePurchaseAvailableStatus;
  hasPrePurchasePresale: Scalars['Boolean'];
  seatsIoConfig?: Maybe<SeatsIoConfigOutput>;
  stripeConfig?: Maybe<StripeConfigOutput>;
  userRestrictedReleases: Array<RestrictedRelease>;
};


export type EventTicketTypesArgs = {
  ticketTypeFilter?: Maybe<TicketTypeFilter>;
};

export enum EventAccessStatus {
  ShouldRedirect = 'SHOULD_REDIRECT',
  EventEnded = 'EVENT_ENDED',
  Denied = 'DENIED',
  Allowed = 'ALLOWED',
  AllowedAdminPreview = 'ALLOWED_ADMIN_PREVIEW'
}

export type EventAddon = {
  __typename?: 'EventAddon';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  /** Indicates whether naming the addon is possible or not. */
  enableNaming: Scalars['Boolean'];
  /** Maximum quantity to be sold for the addon. */
  quantity: Scalars['Float'];
  /** The price associated with the addon. */
  price: Scalars['Float'];
  /** The brief description of the addon. */
  description?: Maybe<Scalars['String']>;
  /** The restrictions applied to the addon. */
  restrictions?: Maybe<Scalars['String']>;
  /** The active status of the addon. */
  isActive: Scalars['Boolean'];
  namingFields: Array<FormField>;
  /** Image to be shown on the customer portal of the addon . Returns null if the not set. */
  addonImage?: Maybe<ExtendedFile>;
  /** Quantity allocated already */
  quantityAllocated: Scalars['Float'];
  maxPurchaseQuantity: Scalars['Float'];
  /** Quantity remaining via order created or canceled, does not take into account the order status */
  remaining: Scalars['Float'];
  displayOrder: Scalars['Int'];
  /** Booking fee. */
  insideFee?: Maybe<Scalars['Float']>;
  /** Whether hide QR code on ticket. */
  hideQRCode: Scalars['Boolean'];
  scannableGateIds: Array<Scalars['String']>;
  /** Image gallery for ticket listing and sub-page. */
  imageGallery: Array<ImageGalleryItem>;
  intellitixId?: Maybe<Scalars['String']>;
  purchaseRestrictions: Array<PurchaseRestriction>;
  purchaseRestrictionsHelpText: Array<Scalars['String']>;
  totalSold?: Maybe<Scalars['Int']>;
  addonAvailabilityStatus: TicketAvailabilityStatus;
};

export type EventChannelOutput = {
  __typename?: 'EventChannelOutput';
  id: Scalars['String'];
  label: Scalars['String'];
  isEnabled: Scalars['Boolean'];
};

export type EventConnection = {
  __typename?: 'EventConnection';
  pageInfo: PageInfo;
  edges: Array<EventEdge>;
  totalCount: Scalars['Int'];
};

/** Represents a date in an event. */
export type EventDate = {
  __typename?: 'EventDate';
  id: Scalars['ID'];
  startDate: Scalars['String'];
  endDate: Scalars['String'];
  /** Doors open time. */
  doorsOpen?: Maybe<Scalars['String']>;
};

export type EventDateOptions = {
  __typename?: 'EventDateOptions';
  label: Scalars['String'];
  value: Scalars['String'];
};

export type EventEdge = {
  __typename?: 'EventEdge';
  cursor: Scalars['String'];
  node: Event;
};

export enum EventErrorType {
  EventHasEnded = 'EVENT_HAS_ENDED',
  EventNotPublished = 'EVENT_NOT_PUBLISHED',
  TicketsNotOnSale = 'TICKETS_NOT_ON_SALE',
  PresaleStartsLater = 'PRESALE_STARTS_LATER',
  TicketsNotAvailable = 'TICKETS_NOT_AVAILABLE'
}

export type EventForBroadcast = {
  __typename?: 'EventForBroadcast';
  id: Scalars['String'];
  title: Scalars['String'];
  hasResaleTicket: Scalars['Boolean'];
  /** Event dates. */
  dates: Array<EventDate>;
};

export type EventForCompetitionReportingEntity = {
  __typename?: 'EventForCompetitionReportingEntity';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The kind of event */
  eventKind: EventKind;
  /** Event season. */
  season?: Maybe<Season>;
  venue: Venue;
  intellitixProjectId?: Maybe<Scalars['String']>;
  intellitixSourceId?: Maybe<Scalars['String']>;
  releases: Array<Release>;
  /** Seats.io event key. */
  seatsEventKey?: Maybe<Scalars['String']>;
  /** Event title. */
  title: Scalars['String'];
  /** Event description. */
  description: Scalars['String'];
  /** Event dates. */
  dates: Array<EventDate>;
  /** Event start date. */
  startDate?: Maybe<Scalars['DateTime']>;
  /** Display event start time. */
  showStartTime: Scalars['Boolean'];
  /** Event end date. */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Display event end time. */
  showEndTime: Scalars['Boolean'];
  /** Date at which tickets are viewable/printable after. */
  ticketsViewableFromDate?: Maybe<Scalars['DateTime']>;
  /** Event endDate has now lapsed, therefore it has ended. */
  hasEventEnded: Scalars['Boolean'];
  /** Event active status. */
  isActive: Scalars['Boolean'];
  /** Featured status. */
  isFeatured: Scalars['Boolean'];
  /** Booking fee type. */
  bookingFeeType: FeeType;
  /** Booking fee. */
  bookingFee: Scalars['Float'];
  /** Whether event is R-18. */
  isR18: Scalars['Boolean'];
  /** Whether the event is discoverable on BandsInTown */
  isDiscoverable: Scalars['Boolean'];
  /** Whether the event is a festival */
  isFestival: Scalars['Boolean'];
  /** Whether naming ticket is available. */
  canNameTicket: Scalars['Boolean'];
  /** Whether renaming ticket is available. */
  canRenameTicket: Scalars['Boolean'];
  /** Whether the waitlist is visible on the event information page */
  enableWaitlist: Scalars['Boolean'];
  /** The date the presale registration will be visible on the event information page. */
  waitlistStartDate?: Maybe<Scalars['DateTime']>;
  /** The date the presale registration will no longer be visible on the event information page. */
  waitlistEndDate?: Maybe<Scalars['DateTime']>;
  /** Whether renaming ticket is available. */
  enableReleaseCodes: Scalars['Boolean'];
  /** Whether changing seats is available. */
  canChangeSeats: Scalars['Boolean'];
  /** Whether transfering ticket is available. */
  canTransferTicket: Scalars['Boolean'];
  /** Whether sell to other fans on the waitlist is enabled. */
  ticketResaleEnabled: Scalars['Boolean'];
  /** Whether to enable waitlist for tickets when sold out. */
  ticketResaleWaitlistEnabled: Scalars['Boolean'];
  /** The renaming fee for the event ticket. */
  renamingFee?: Maybe<Scalars['Float']>;
  /** The fee for changing seats for the event ticket. */
  changingSeatsFee?: Maybe<Scalars['Float']>;
  /** The fee the seller pays for transferring a ticket. */
  sellerTransferringTicketFee?: Maybe<Scalars['Float']>;
  /** The fee the buyer pays for transferring a ticket. */
  buyerTransferringTicketFee?: Maybe<Scalars['Float']>;
  /** Shipping options. */
  shippingOptions?: Maybe<ShippingOptions>;
  thumbnail?: Maybe<ExtendedFile>;
  logo?: Maybe<ExtendedFile>;
  backgroundImage?: Maybe<ExtendedFile>;
  backgroundImageFullPage?: Maybe<ExtendedFile>;
  descriptionImage?: Maybe<ExtendedFile>;
  printBanner1?: Maybe<ExtendedFile>;
  printBanner2?: Maybe<ExtendedFile>;
  hardCopyTicketBanner?: Maybe<ExtendedFile>;
  /** The terms and conditions of the event */
  termsAndConditions?: Maybe<Scalars['String']>;
  /** Important notice section on the tickets */
  importantNotice?: Maybe<Scalars['String']>;
  /** The accessibility info of the event */
  accessibility?: Maybe<Scalars['String']>;
  /** The presale info of the event */
  presaleInformation?: Maybe<Scalars['String']>;
  /** The invoice info of the event */
  invoiceInformation?: Maybe<Scalars['String']>;
  /** Allocated gates to venue zones */
  zonesAllocatedGates?: Maybe<Array<ZoneAllocatedGate>>;
  /** Inside fees for the event */
  insideFeeDetails?: Maybe<Array<InsideFeeDetails>>;
  /** Featured status. */
  checkForVaccinePass: Scalars['Boolean'];
  /** Email address that gets sent a notifcation every time an order is completed */
  emailNotification?: Maybe<Scalars['String']>;
  /** Once a customer has finished purchasing they can be redirected back to another URL to continuing their purchsing journey */
  redirectURL?: Maybe<Scalars['String']>;
  /** The referral campaign associated with this event */
  referralCampaignId?: Maybe<Scalars['String']>;
  canUsePoints: Scalars['Boolean'];
  /** The ID of the Google Wallet Event Class for this event */
  googleWalletEventClassId?: Maybe<Scalars['String']>;
  lastTicketsViewableEmailsSentAt?: Maybe<Scalars['DateTime']>;
  ticketCover?: Maybe<EventTicketCover>;
  seoMetadata?: Maybe<SeoMetadata>;
  paymentPlanSettings?: Maybe<PaymentPlanSettings>;
  /** event level facebook pixel id */
  pixelId?: Maybe<Scalars['String']>;
  /** Whether to allow a ticket to be scanned in to multiple areas within a venue. */
  multiScanningEnabled: Scalars['Boolean'];
  /** Configuration for enforcing ticket entry time windows with grace period. */
  ticketEntryTimeEnforcement: TicketEntryTimeEnforcementOptions;
  hiddenFromPublic: Scalars['Boolean'];
  /** Custom tax fields for the event */
  tax?: Maybe<Array<Tax>>;
  merchantReferenceResult?: Maybe<Scalars['String']>;
  /** Event override for seat selection filters */
  seatSelectionFilterOverrides?: Maybe<SeatSelectionFilters>;
  /** Indicates if the event had a public sales release */
  hasPublicRelease: Scalars['Boolean'];
  venueAddress: Venue;
  ticketTypes: Array<TicketType>;
  gateways: Array<Integration>;
  addons: Array<EventAddon>;
  soldTicketsCount?: Maybe<Scalars['Float']>;
  soldTicketsCountToday?: Maybe<Scalars['Float']>;
  soldTicketsCountYesterday?: Maybe<Scalars['Float']>;
  totalRevenue?: Maybe<Scalars['Float']>;
  totalFaceValue?: Maybe<Scalars['Float']>;
  multiBuyPromotions: Array<EventMultiBuyPromotion>;
  tags: Array<Tag>;
  digitalPassCodesStatus?: Maybe<DigitalPassCodeStatusOutput>;
  digitalInfo?: Maybe<DigitalInfo>;
  defaultDateRange?: Maybe<DefaultDateRange>;
  hasPromoCodes: Scalars['Boolean'];
  isWaitlistAvailable: Scalars['Boolean'];
  presaleRelease?: Maybe<Release>;
  publicReleaseStartsAt?: Maybe<Scalars['DateTime']>;
  listedRelease?: Maybe<Release>;
  artists: Array<Artist>;
  ticketsIssued: Scalars['Int'];
  capacity?: Maybe<Scalars['Int']>;
  totalTicketsFaceValue?: Maybe<Scalars['Float']>;
  taxRate: Scalars['Float'];
  customTaxRate: Scalars['Float'];
  taxCalculationMethod: TaxCalculationMethod;
  customFields: Array<CustomFieldOuput>;
  fees: OrderFee;
  canUpgrade: Scalars['Boolean'];
  seekaConfig?: Maybe<SeekaOutput>;
  /** Effective seat selection filters (venue defaults merged with event overrides) */
  effectiveSeatFilters: SeatSelectionFilters;
  prePurchaseAvailableStatus: PrePurchaseAvailableStatus;
  hasPrePurchasePresale: Scalars['Boolean'];
  seatsIoConfig?: Maybe<SeatsIoConfigOutput>;
  stripeConfig?: Maybe<StripeConfigOutput>;
  userRestrictedReleases: Array<RestrictedRelease>;
  /** Indicates if the event had or has a presale waitlist */
  hadOrHasPresaleWaitlist: Scalars['Boolean'];
};


export type EventForCompetitionReportingEntityTicketTypesArgs = {
  ticketTypeFilter?: Maybe<TicketTypeFilter>;
};

export type EventForecastOutput = {
  __typename?: 'EventForecastOutput';
  id: Scalars['String'];
  eventId: Scalars['String'];
  /** The zones and forecasted seat count attributes */
  zones?: Maybe<Array<EventForecastZoneOutput>>;
  /** The array of possible forecasting scenarios */
  scenarios?: Maybe<Array<ForecastScenario>>;
};

/** Object to hold the zoneId and the seat allocation forecasts */
export type EventForecastZone = {
  __typename?: 'EventForecastZone';
  /** The zone id of for the seats forecast. */
  zoneId?: Maybe<Scalars['String']>;
  /** How many seats are forecast to be comps */
  comps: Scalars['Int'];
  /** How many seats are forecast to be contingency */
  contingency: Scalars['Int'];
};

/** Object to hold the zoneId and the seat allocation forecasts */
export type EventForecastZoneOutput = {
  __typename?: 'EventForecastZoneOutput';
  /** The zone id of for the seats forecast. */
  zoneId?: Maybe<Scalars['String']>;
  /** How many seats are forecast to be comps */
  comps: Scalars['Int'];
  /** How many seats are forecast to be contingency */
  contingency: Scalars['Int'];
  /** Sales statistics if available */
  sales?: Maybe<FinancialSales>;
};

export type EventInformation = {
  __typename?: 'EventInformation';
  id: Scalars['String'];
  title: Scalars['String'];
  dates: Array<EventDate>;
  location?: Maybe<Scalars['String']>;
  hasEventEnded?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  logo?: Maybe<ExtendedFile>;
  isSeated: Scalars['Boolean'];
  hasRegistration: Scalars['Boolean'];
  hasOnsaleCompetition: Scalars['Boolean'];
  hasRegistrationCompetition: Scalars['Boolean'];
  hasPresale: Scalars['Boolean'];
  hasPreAuth: Scalars['Boolean'];
  hasLinkToWaitlistPresale: Scalars['Boolean'];
  hasStartedPresale: Scalars['Boolean'];
  eventDateOptions: Array<EventDateOptions>;
  timezone: Scalars['String'];
  locale: Scalars['String'];
  isMultiDayEvent: Scalars['Boolean'];
};

/** Ticket kind for ticket type. */
export enum EventKind {
  Standard = 'STANDARD',
  Digital = 'DIGITAL',
  Exhibition = 'EXHIBITION'
}

export type EventLayoutOutput = {
  __typename?: 'EventLayoutOutput';
  defaultDateRange: DateRange;
  event?: Maybe<EventInformation>;
};

export type EventMultiBuyPromotion = {
  __typename?: 'EventMultiBuyPromotion';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  buyQuantity: Scalars['Float'];
  getQuantity: Scalars['Float'];
  price: Scalars['Float'];
  enabled: Scalars['Boolean'];
  buyTicketType: TicketType;
  getTicketType: TicketType;
  used: Scalars['Float'];
};

export type EventOrderByInput = {
  createdAt?: Maybe<OrderByDirection>;
  updatedAt?: Maybe<OrderByDirection>;
  startDate?: Maybe<OrderByDirection>;
  endDate?: Maybe<OrderByDirection>;
  isFeatured?: Maybe<OrderByDirection>;
};

export type EventOrdersOnlineOutput = {
  __typename?: 'EventOrdersOnlineOutput';
  totalCount: Scalars['Float'];
  baseTickets: Scalars['Float'];
  ticketFees: Scalars['Float'];
  bookingFees: Scalars['Float'];
  transactionFees: Scalars['Float'];
  deliveryFees: Scalars['Float'];
  refundedAmount: Scalars['Float'];
  addons: Scalars['Float'];
  creditsUsed: Scalars['Float'];
  orderIdsOnline: Array<OrderIdsOnlineOutput>;
};

export enum EventPermissions {
  ViewInfo = 'VIEW_INFO',
  ViewTickets = 'VIEW_TICKETS',
  ViewInfoAdmin = 'VIEW_INFO_ADMIN',
  ViewTicketsAdmin = 'VIEW_TICKETS_ADMIN'
}

export type EventPromoCode = {
  __typename?: 'EventPromoCode';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The unique code that represents the promotion. */
  code: Scalars['String'];
  /** The discount type associated with the promotion. */
  discountType: DiscountType;
  /** The discount amount of the promotion. */
  discountAmount: Scalars['Float'];
  enabled: Scalars['Boolean'];
  /** The type of the promotion which determines on which items the promotion will be applied. */
  type: EventPromoCodeType;
  /** Ticket type ids for promo code. */
  ticketTypes: Array<Scalars['String']>;
  /** Event addon ids for promo code. */
  eventAddons: Array<Scalars['String']>;
  /** The total amount of usage of the promotion. */
  used?: Maybe<Scalars['Int']>;
  /** The maximum amount of use condition of the promotion. Returns `null` when inactive. */
  maxUsage?: Maybe<Scalars['Int']>;
  /** The start date condition of the promotion. Returns `null` when inactive. */
  startDate?: Maybe<Scalars['DateTime']>;
  /** The end date condition of the promotion. Returns `null` when inactive. */
  endDate?: Maybe<Scalars['DateTime']>;
  /** The minimum order amount condition of the promotion. Returns `null` when inactive. */
  minOrderAmount?: Maybe<Scalars['Float']>;
  /** The maximum order amount condition of the promotion. Returns `null` when inactive. */
  maxOrderAmount?: Maybe<Scalars['Float']>;
};

export enum EventPromoCodeType {
  EventAndAddons = 'EVENT_AND_ADDONS',
  Event = 'EVENT',
  Addons = 'ADDONS'
}

export type EventRedirectQueryParams = {
  __typename?: 'EventRedirectQueryParams';
  path?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type EventsByIdInput = {
  eventIds: Array<Scalars['String']>;
};

export type EventSocialPage = {
  __typename?: 'EventSocialPage';
  name: Scalars['String'];
  isEnabled: Scalars['Boolean'];
  url?: Maybe<Scalars['String']>;
};

export type EventSocialPageInput = {
  name: Scalars['String'];
  isEnabled: Scalars['Boolean'];
  url?: Maybe<Scalars['String']>;
};

export type EventsWithAccessControlInput = {
  eventId: Scalars['String'];
  releaseId?: Maybe<Scalars['String']>;
  releaseSlug?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
};

export type EventsWithAccessControlOutput = {
  __typename?: 'EventsWithAccessControlOutput';
  event?: Maybe<Event>;
  release?: Maybe<Release>;
  isAdmin: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
  errorType?: Maybe<EventErrorType>;
  redirect?: Maybe<EventRedirectQueryParams>;
  permissions: Array<EventPermissions>;
  /** @deprecated Use permissions instead */
  accessType: EventAccessStatus;
};

export type EventTicketCover = {
  __typename?: 'EventTicketCover';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** Event that the ticket cover is configured for */
  event: Event;
  enabledAt?: Maybe<Scalars['DateTime']>;
  disabledAt?: Maybe<Scalars['DateTime']>;
  /** Promoter fee as percentage of ticket price */
  promoterFeePercentage: Scalars['Float'];
  /** Platform fee as percentage of ticket price */
  platformFeePercentage: Scalars['Float'];
  /** Ticket cover purchase behaviour */
  purchaseBehaviour: TicketCoverPurchaseBehaviour;
  /** Total fee as percentage of ticket price */
  totalFeePercentage: Scalars['Float'];
  /** Is ticket cover enabled */
  isEnabled: Scalars['Boolean'];
};

export type EventWhereInput = {
  /** Fuzzy search query. */
  q?: Maybe<Scalars['String']>;
  /** Event active status. */
  isActive?: Maybe<Scalars['Boolean']>;
  /** Event featured status. */
  isFeatured?: Maybe<Scalars['Boolean']>;
  /** Event start date. */
  startDate?: Maybe<Scalars['DateTime']>;
  /** Event end date. */
  endDate?: Maybe<Scalars['DateTime']>;
  pos?: Maybe<Scalars['Boolean']>;
  seasonId?: Maybe<Scalars['String']>;
  /**
   * If this is set to true,
   *     then we will left join release and check whether this event contains a outlet release.
   */
  isOutlet?: Maybe<Scalars['Boolean']>;
  seating?: Maybe<VenueSeating>;
  includeHidden?: Maybe<Scalars['Boolean']>;
};

export type ExchangeableEvent = {
  __typename?: 'ExchangeableEvent';
  fromEventId: Scalars['String'];
  toEventIds: Array<Scalars['String']>;
};

export type ExchangeSettings = {
  __typename?: 'ExchangeSettings';
  isEnabled: Scalars['Boolean'];
  exchangeableEvents: Array<ExchangeableEvent>;
  totalEventCount: Scalars['Float'];
  creditFullMembership: Scalars['Boolean'];
  creditBookingFees: Scalars['Boolean'];
  releaseSlug?: Maybe<Scalars['String']>;
};

export type ExhibitorContextOutput = {
  __typename?: 'ExhibitorContextOutput';
  profile: ExpoExhibitorSessionProfileOutput;
  event: Event;
  organization: CurrentOrganizationOutput;
};

export type ExhibitorLoginFailure = {
  __typename?: 'ExhibitorLoginFailure';
  failure: Scalars['Boolean'];
};

export type ExhibitorLoginMultipleFound = {
  __typename?: 'ExhibitorLoginMultipleFound';
  multipleFound: Scalars['Boolean'];
  events: Array<ExpoEventForLogin>;
};

export type ExhibitorLoginOutputUnion = ExhibitorLoginSuccess | ExhibitorLoginFailure | ExhibitorLoginMultipleFound;

export type ExhibitorLoginSuccess = {
  __typename?: 'ExhibitorLoginSuccess';
  success: Scalars['Boolean'];
  exhibitor: ExpoExhibitor;
};

export type ExpoAttendee = {
  __typename?: 'ExpoAttendee';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  organizationId: Scalars['String'];
  eventId: Scalars['String'];
  exhibitorId: Scalars['String'];
  ticketId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Gender>;
  postalCode?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  optInToMarketing?: Maybe<Scalars['Boolean']>;
  customFields?: Maybe<Array<CustomField>>;
};

export type ExpoAttendeeInput = {
  id?: Maybe<Scalars['String']>;
  ticketId?: Maybe<Scalars['String']>;
  ticketNumber?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Gender>;
  postalCode?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  optInToMarketing?: Maybe<Scalars['Boolean']>;
  customFields?: Maybe<Array<ExpoCustomFieldInput>>;
};

export type ExpoAttendeeTicketOutput = {
  __typename?: 'ExpoAttendeeTicketOutput';
  ticket: Ticket;
  attendeeId?: Maybe<Scalars['String']>;
};

export type ExpoCustomFieldInput = {
  id?: Maybe<Scalars['String']>;
  fieldName: Scalars['String'];
  fieldValue: Scalars['String'];
};

export type ExpoEncryptedTicket = {
  __typename?: 'ExpoEncryptedTicket';
  /** Base64 encoded encrypted ticket */
  encrypted: Scalars['String'];
  /** Base64 encoded initialization vector */
  iv: Scalars['String'];
  /** Base64 encoded authentication tag */
  authTag: Scalars['String'];
  /** Base64 encoded index key */
  index: Scalars['String'];
};

export type ExpoEventForLogin = {
  __typename?: 'ExpoEventForLogin';
  name: Scalars['String'];
  id: Scalars['String'];
};

/** Represents a business who is exhibiting at an event. Multiple users may be logged in as an Exhibitor. */
export type ExpoExhibitor = {
  __typename?: 'ExpoExhibitor';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  email: Scalars['String'];
  organizationId: Scalars['String'];
  eventId: Scalars['String'];
  allowCustomQuestions: Scalars['Boolean'];
  attendeeCount: Scalars['Float'];
  qrCode: Scalars['String'];
  loginLink: Scalars['String'];
};

export type ExpoExhibitorLoginInput = {
  name?: Maybe<Scalars['String']>;
  exhibitorId: Scalars['String'];
  exhibitorSecret: Scalars['String'];
  eventId?: Maybe<Scalars['String']>;
};

export type ExpoExhibitorSessionProfileOutput = {
  __typename?: 'ExpoExhibitorSessionProfileOutput';
  exhibitorName: Scalars['String'];
  scannerName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  allowCustomQuestions: Scalars['Boolean'];
  safeModeEnabled: Scalars['Boolean'];
};

export type ExpoNamingField = {
  __typename?: 'ExpoNamingField';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  type: ExpoNamingFieldType;
  label: Scalars['String'];
  required: Scalars['Boolean'];
  orderKey: Scalars['Float'];
  options?: Maybe<Array<Scalars['String']>>;
};

export type ExpoNamingFieldInput = {
  id?: Maybe<Scalars['String']>;
  type: ExpoNamingFieldType;
  label: Scalars['String'];
  required: Scalars['Boolean'];
  orderKey: Scalars['Float'];
  options?: Maybe<Array<Scalars['String']>>;
};

export enum ExpoNamingFieldType {
  FirstName = 'FirstName',
  LastName = 'LastName',
  CompanyName = 'CompanyName',
  Gender = 'Gender',
  BirthDate = 'BirthDate',
  PhoneNumber = 'PhoneNumber',
  PostalCode = 'PostalCode',
  Email = 'Email',
  OptInToMarketing = 'OptInToMarketing',
  CustomText = 'CustomText',
  CustomSelect = 'CustomSelect',
  CustomCheckbox = 'CustomCheckbox'
}

export type ExportFilterCategory = {
  __typename?: 'ExportFilterCategory';
  key: Scalars['String'];
  name: Scalars['String'];
  columns: Array<ExportFilterColumn>;
};

export type ExportFilterCategoryOutput = {
  __typename?: 'ExportFilterCategoryOutput';
  categories: Array<ExportFilterCategory>;
};

export type ExportFilterColumn = {
  __typename?: 'ExportFilterColumn';
  key: Scalars['String'];
  name: Scalars['String'];
  default?: Maybe<Scalars['Boolean']>;
  tooltip?: Maybe<StatisticTooltip>;
};

export type ExportFilterColumnsInput = {
  exportType: ExportType;
  source: PointReportingFilterSource;
  sourceId?: Maybe<Scalars['ID']>;
  scanType?: Maybe<ScanExportType>;
};

export enum ExportType {
  Order = 'ORDER',
  Customer = 'CUSTOMER',
  Ticket = 'TICKET',
  Addon = 'ADDON',
  Registration = 'REGISTRATION',
  Membership = 'MEMBERSHIP',
  ScanLog = 'SCAN_LOG',
  Transaction = 'TRANSACTION',
  AbandonedCart = 'ABANDONED_CART'
}

export type ExtendedFile = {
  __typename?: 'ExtendedFile';
  storage: StorageType;
  directory: Scalars['String'];
  fileName: Scalars['String'];
  originalFileName?: Maybe<Scalars['String']>;
  metaData?: Maybe<MetaData>;
};

export type FacebookPageListsInput = {
  token?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type FaceValueOverviewOutput = {
  __typename?: 'FaceValueOverviewOutput';
  totalFaceValue: Scalars['Float'];
  avgOrderItemsCount: Scalars['Float'];
};

export type FailedImportItem = {
  __typename?: 'FailedImportItem';
  index: Scalars['Float'];
  message?: Maybe<Scalars['String']>;
};

export type FansWouldPay = {
  __typename?: 'FansWouldPay';
  mean: Scalars['Float'];
  median: Scalars['Float'];
};

export type Feature = {
  __typename?: 'Feature';
  /** Unique feature key. Case insensitive */
  key: FeatureFlagKeyEnum;
  /** Human-readable name */
  label: Scalars['String'];
  /** Human-readable explanation */
  description: Scalars['String'];
  /** Current feature status */
  status: FeatureStatusEnum;
};

/** All feature flags keys */
export enum FeatureFlagKeyEnum {
  Account2Account = 'Account2Account',
  AddressFinder = 'AddressFinder',
  ApplyPlatformAdjustment = 'ApplyPlatformAdjustment',
  AskForDietaryRequirements = 'AskForDietaryRequirements',
  AskHowDidYouHearAboutUs = 'AskHowDidYouHearAboutUs',
  AuthDuringCheckout = 'AuthDuringCheckout',
  AutoRenewMemberships = 'AutoRenewMemberships',
  BandsInTown = 'BandsInTown',
  BroadcastFilters = 'BroadcastFilters',
  BroadcastSms = 'BroadcastSMS',
  BusinessOnlyTicketTypes = 'BusinessOnlyTicketTypes',
  CaptureAllPlatformFees = 'CaptureAllPlatformFees',
  ComparativeSalesReport = 'ComparativeSalesReport',
  Competitions = 'Competitions',
  CookieConsent = 'CookieConsent',
  CrmSegments = 'CrmSegments',
  CustomEmailAbandonedCart = 'CustomEmailAbandonedCart',
  CustomTax = 'CustomTax',
  DigitalEvents = 'DigitalEvents',
  DigitalMemberships = 'DigitalMemberships',
  DisableCrmEventActivityFilter = 'DisableCrmEventActivityFilter',
  DisableCrmFilters = 'DisableCrmFilters',
  DisableEventListCards = 'DisableEventListCards',
  DisableMjmlEmail = 'DisableMJMLEmail',
  DisableOrderExportStreaming = 'DisableOrderExportStreaming',
  DisableOrderQueue = 'DisableOrderQueue',
  DisablePageLoadTracing = 'DisablePageLoadTracing',
  DisablePreauth = 'DisablePreauth',
  DisableRefundByLineItem = 'DisableRefundByLineItem',
  EventCalendarHomepage = 'EventCalendarHomepage',
  EventListHomepage = 'EventListHomepage',
  Expo = 'Expo',
  ExpoAutoSubmit = 'ExpoAutoSubmit',
  ExtraCheckoutDuration = 'ExtraCheckoutDuration',
  Fiji = 'Fiji',
  FinancialReportSplitBreakdown = 'FinancialReportSplitBreakdown',
  Forecast = 'Forecast',
  GroupLink = 'GroupLink',
  GuestCard = 'GuestCard',
  HideCompetitions = 'HideCompetitions',
  HideCustomDomain = 'HideCustomDomain',
  HideCustomerAccount = 'HideCustomerAccount',
  HideCustomSystemEmails = 'HideCustomSystemEmails',
  HideEventTime = 'HideEventTime',
  HideMainSaleCountdown = 'HideMainSaleCountdown',
  HideNewExportModal = 'HideNewExportModal',
  HidePresaleCountdown = 'HidePresaleCountdown',
  HideResale = 'HideResale',
  HideReportingIa = 'HideReportingIA',
  HideScheduledReports = 'HideScheduledReports',
  HideSignUpForm = 'HideSignUpForm',
  HideTags = 'HideTags',
  InvoiceTicketCover = 'InvoiceTicketCover',
  LegacyConfirmationPage = 'LegacyConfirmationPage',
  LegacyGaSetup = 'LegacyGASetup',
  LegacyGaTicketSelection = 'LegacyGATicketSelection',
  LegacyPrivateLinksTab = 'LegacyPrivateLinksTab',
  LegacyShopify = 'LegacyShopify',
  LegacyStripe = 'LegacyStripe',
  Levy = 'Levy',
  MembershipChannelHolds = 'MembershipChannelHolds',
  MembershipTransfers = 'MembershipTransfers',
  MultiScanning = 'MultiScanning',
  OldNamingFields = 'OldNamingFields',
  OrderCustomerType = 'OrderCustomerType',
  OrderExportXls = 'OrderExportXls',
  OrderSmsConfirmationDefaultOptOut = 'OrderSmsConfirmationDefaultOptOut',
  OrderSmsConfirmationDisabled = 'OrderSmsConfirmationDisabled',
  PaymentPlans = 'PaymentPlans',
  PinPaymentGateway = 'PinPaymentGateway',
  PointOfSale = 'PointOfSale',
  Points = 'Points',
  PointsOnHomepage = 'PointsOnHomepage',
  Presale = 'Presale',
  DisableDynamicTiers = 'DisableDynamicTiers',
  RefundByLineItemReporting = 'RefundByLineItemReporting',
  ReleaseMembershipHolds = 'ReleaseMembershipHolds',
  ReleasePurchaseRestrictions = 'ReleasePurchaseRestrictions',
  RemoveBackgroundImageFromTicketPage = 'RemoveBackgroundImageFromTicketPage',
  ResaleTicketPriceCollection = 'ResaleTicketPriceCollection',
  ResaleTicketQuantityCollection = 'ResaleTicketQuantityCollection',
  ResellerAdminOnly = 'ResellerAdminOnly',
  SalesAndFinancialReportsV2 = 'SalesAndFinancialReportsV2',
  ScanMultiDays = 'ScanMultiDays',
  ScannerAccessInstruction = 'ScannerAccessInstruction',
  Scout = 'Scout',
  SeekaServerSideTracking = 'SeekaServerSideTracking',
  ShowHiddenFees = 'ShowHiddenFees',
  ShowSocialMediaLogin = 'ShowSocialMediaLogin',
  SkipCreatePostmarkOrganizationServers = 'SkipCreatePostmarkOrganizationServers',
  SkipPreauthDateChangeEmails = 'SkipPreauthDateChangeEmails',
  SkipPreauthOrderConfirmationEmail = 'SkipPreauthOrderConfirmationEmail',
  SkipPreauthReminderEmails = 'SkipPreauthReminderEmails',
  SmsMessageMedia = 'SmsMessageMedia',
  Social = 'Social',
  StripeExpressCheckoutLegacy = 'StripeExpressCheckoutLegacy',
  StripeOAuth = 'StripeOAuth',
  StripeOnlyAfterpay = 'StripeOnlyAfterpay',
  StripeTerminal = 'StripeTerminal',
  Tags = 'Tags',
  TempPosOperators = 'TempPOSOperators',
  TicketAccordion = 'TicketAccordion',
  TicketDates = 'TicketDates',
  TicketResale = 'TicketResale',
  TicketTransfers = 'TicketTransfers',
  TotalSalesInsteadOfFaceValue = 'TotalSalesInsteadOfFaceValue',
  TravelDeals = 'TravelDeals',
  UnifiedReporting = 'UnifiedReporting',
  UsePostmarkDefaultServer = 'UsePostmarkDefaultServer',
  UsherComplimentary = 'UsherComplimentary',
  VaccinePassport = 'VaccinePassport',
  WindcavePaymentsRedirect = 'WindcavePaymentsRedirect',
  XeroIntegration = 'XeroIntegration',
  ZoneAlternativeEntryTime = 'ZoneAlternativeEntryTime',
  EnforceTicketEntryTime = 'EnforceTicketEntryTime',
  DisableScansOverTime = 'DisableScansOverTime',
  ComparativeSalesReportOverview = 'ComparativeSalesReportOverview',
  ComparativeSalesReportMembership = 'ComparativeSalesReportMembership',
  ComparativeSalesReportSeason = 'ComparativeSalesReportSeason',
  HideMultiBuySavings = 'HideMultiBuySavings',
  SinglePageCheckout = 'SinglePageCheckout'
}

/** Status of the feature flag */
export enum FeatureStatusEnum {
  Development = 'DEVELOPMENT',
  Beta = 'BETA',
  Released = 'RELEASED',
  Deprecated = 'DEPRECATED'
}

export type Fee = {
  __typename?: 'Fee';
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: FeeType;
  value: Scalars['Float'];
  isOptional: Scalars['Boolean'];
  order: Scalars['Int'];
};

/** The valid values for fee types. */
export enum FeeType {
  FlatRate = 'FlatRate',
  Percentage = 'Percentage'
}

export type FilterArgs = {
  __typename?: 'FilterArgs';
  kind: BroadcastMarketingFiltersV2Kind;
  exclude: Scalars['Boolean'];
};

export type FilterOption = {
  __typename?: 'FilterOption';
  label: Scalars['String'];
  value: PeriodFilter;
};

export type FilterSelection = {
  __typename?: 'FilterSelection';
  userTagIds?: Maybe<Array<Scalars['String']>>;
  seasonIds?: Maybe<Array<Scalars['String']>>;
  eventTypes?: Maybe<Array<ScoutEventType>>;
  regions?: Maybe<Array<Scalars['String']>>;
  membershipTypes?: Maybe<Array<Scalars['String']>>;
  eventIds?: Maybe<Array<Scalars['String']>>;
  eventTitlesForWaitlist?: Maybe<Array<Scalars['String']>>;
  totalEventsPurchasedTo?: Maybe<Scalars['Float']>;
  ticketTypeKinds?: Maybe<Array<TicketTypeKind>>;
  zones?: Maybe<Array<Scalars['String']>>;
  releaseIds?: Maybe<Array<Scalars['String']>>;
  gender?: Maybe<Array<Gender>>;
  minAge?: Maybe<Scalars['Float']>;
  maxAge?: Maybe<Scalars['Float']>;
};

export type FilterSelectionInput = {
  userTagIds?: Maybe<Array<Scalars['String']>>;
  seasonIds?: Maybe<Array<Scalars['String']>>;
  eventTypes?: Maybe<Array<ScoutEventType>>;
  regions?: Maybe<Array<Scalars['String']>>;
  membershipTypes?: Maybe<Array<Scalars['String']>>;
  eventIds?: Maybe<Array<Scalars['String']>>;
  eventTitlesForWaitlist?: Maybe<Array<Scalars['String']>>;
  totalEventsPurchasedTo?: Maybe<Scalars['Float']>;
  ticketTypeKinds?: Maybe<Array<TicketTypeKind>>;
  zones?: Maybe<Array<Scalars['String']>>;
  releaseIds?: Maybe<Array<Scalars['String']>>;
  gender?: Maybe<Array<Gender>>;
  minAge?: Maybe<Scalars['Float']>;
  maxAge?: Maybe<Scalars['Float']>;
};

export type FinalisePrechargeOrderInput = {
  orderId: Scalars['String'];
  setupIntentId: Scalars['String'];
  postCode: Scalars['String'];
  country: Scalars['String'];
  state?: Maybe<Scalars['String']>;
};

export type FinancialGatewayGraphOutput = {
  __typename?: 'FinancialGatewayGraphOutput';
  transactions: Scalars['Float'];
  integrations: Array<FinancialGraphIntegration>;
};

export type FinancialGraphIntegration = {
  __typename?: 'FinancialGraphIntegration';
  name: Scalars['String'];
  transactions: Scalars['Float'];
};

export type FinancialOverviewOutput = {
  __typename?: 'FinancialOverviewOutput';
  netSales: Scalars['Float'];
  discounts: Scalars['Float'];
  avgOrderAmount: Scalars['Float'];
  avgOrderItemsCount: Scalars['Float'];
  resaleFees: Scalars['Float'];
  ticketCoverOrderTotal: Scalars['Float'];
  ticketCoverRevenue: Scalars['Float'];
  ticketCoverMargin: Scalars['Float'];
  ticketCoverCost: Scalars['Float'];
  resaleMargin: Scalars['Float'];
  planTotalPaid: Scalars['Float'];
  planTotalOutstanding: Scalars['Float'];
};

export type FinancialReportingOverviewOutput = {
  __typename?: 'FinancialReportingOverviewOutput';
  financial: Array<PeReportStatistic>;
};

export type FinancialSales = {
  __typename?: 'FinancialSales';
  /** This is the sourceId for seasons filter */
  zoneId: Scalars['String'];
  zoneName: Scalars['String'];
  capacity: Scalars['String'];
  available: Scalars['String'];
  availablePercentage?: Maybe<Scalars['Float']>;
  sellableCapacity: Scalars['String'];
  totalNotForSaleCount: Scalars['Float'];
  totalNotForSalePercentage?: Maybe<Scalars['Float']>;
  /** This is the sum of membershipRenewalHolds and holdByMembershipCount, only used by events */
  allMembershipHolds: Scalars['Float'];
  allMembershipHoldsPercentage?: Maybe<Scalars['Float']>;
  /** Only used by events to display the memberships */
  totalMembershipTicketCount: Scalars['Float'];
  totalMembershipTicketPercentage?: Maybe<Scalars['Float']>;
  types: Array<FinancialSalesType>;
  sourceId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  issued?: Maybe<Scalars['Float']>;
  ticketIssued?: Maybe<Scalars['Float']>;
  ticketHolds?: Maybe<Scalars['Float']>;
  partPaidTickets?: Maybe<Scalars['Float']>;
  partPaidTicketsPercentage?: Maybe<Scalars['Float']>;
  partPaidMemberships?: Maybe<Scalars['Float']>;
  partPaidMembershipsPercentage?: Maybe<Scalars['Float']>;
  totalHoldsPercentage?: Maybe<Scalars['Float']>;
  transfersPending?: Maybe<Scalars['Float']>;
  transfers?: Maybe<Scalars['Float']>;
  comps?: Maybe<Scalars['Float']>;
  compsPercentage?: Maybe<Scalars['Float']>;
  ticketSold?: Maybe<Scalars['Float']>;
  ticketsRefunded?: Maybe<Scalars['Float']>;
  ticketSoldPercentage: Scalars['String'];
  baseRevenue?: Maybe<Scalars['Float']>;
  partPaidRevenue?: Maybe<Scalars['Float']>;
  refunds?: Maybe<Scalars['Float']>;
  totalBookingFee?: Maybe<Scalars['Float']>;
  totalWithBookingFees?: Maybe<Scalars['Float']>;
  buyerTransferFees?: Maybe<Scalars['Float']>;
  sellerTransferFees?: Maybe<Scalars['Float']>;
  isAdmissionZone?: Maybe<Scalars['Boolean']>;
  venueCapacity: Scalars['Float'];
  membershipRenewalHolds?: Maybe<Scalars['Float']>;
  membershipRenewalHoldsPercentage?: Maybe<Scalars['Float']>;
  holdByMembershipCount?: Maybe<Scalars['Float']>;
  holdByMembershipCountPercentage?: Maybe<Scalars['Float']>;
  channelHolds: Scalars['Int'];
  totalExclusiveTax?: Maybe<Scalars['Float']>;
  totalOccupied?: Maybe<Scalars['Float']>;
};

export type FinancialSalesType = {
  __typename?: 'FinancialSalesType';
  name: Scalars['String'];
  /** This is the sum of ticketIssued and membershipTicketCount */
  issued: Scalars['Float'];
  ticketIssued: Scalars['Float'];
  ticketHolds: Scalars['Float'];
  partPaidTickets: Scalars['Float'];
  partPaidMemberships: Scalars['Float'];
  posTickets?: Maybe<Scalars['Float']>;
  transfersPending: Scalars['Float'];
  transfers: Scalars['Float'];
  comps: Scalars['Float'];
  ticketSold: Scalars['Float'];
  ticketsRefunded: Scalars['Float'];
  baseRevenue?: Maybe<Scalars['Float']>;
  partPaidRevenue?: Maybe<Scalars['Float']>;
  refunds?: Maybe<Scalars['Float']>;
  channel?: Maybe<Scalars['String']>;
  release?: Maybe<Scalars['String']>;
  totalWithBookingFees?: Maybe<Scalars['Float']>;
  available?: Maybe<Scalars['String']>;
  capacity?: Maybe<Scalars['String']>;
  /**
   * This value should only exist on FinancialSalesType when 
   *     the filter is the seasons filter and the source ID is all memberships. 
   *     It should only exist on the zone level.
   */
  membershipRenewalHolds?: Maybe<Scalars['Float']>;
  holdByMembershipCount?: Maybe<Scalars['Float']>;
  /** Renewal holds should not be added on the zone level. This is sum of holdByMembershipCount. Only used by events */
  allMembershipHolds?: Maybe<Scalars['Float']>;
  /**
   * Ticket type price is a range since the price can be different for different releases and sections.
   * If the price is the same for all releases and sections, the array will only have one value.
   * Otherwise, the array will have two values, the first being the lowest price and the second being the highest price.
   */
  ticketTypePriceRange?: Maybe<Array<Scalars['Float']>>;
  totalBookingFee?: Maybe<Scalars['Float']>;
  buyerTransferFees?: Maybe<Scalars['Float']>;
  sellerTransferFees?: Maybe<Scalars['Float']>;
  totalDiscounts?: Maybe<Scalars['Float']>;
  discounts?: Maybe<Scalars['Float']>;
  /**
   * Booking fee is a range when the type is percentage and ticket type fee is a range.
   * If the price only has one value, the array will only have one value.
   * Otherwise, the array will have two values, the first being the lowest price and the second being the highest price.
   */
  ticketTypeBookingFeeRange?: Maybe<Array<Scalars['Float']>>;
  /** Only used by events to display the memberships */
  totalMembershipTicketCount?: Maybe<Scalars['Float']>;
  isCompTicketType?: Maybe<Scalars['Boolean']>;
  isMembership?: Maybe<Scalars['Boolean']>;
  /** Only defined on zone level for seasons filter  */
  isTotalAddon?: Maybe<Scalars['Boolean']>;
  /** Only defined on zone level for seasons filter  */
  isAdmissionZone?: Maybe<Scalars['Boolean']>;
  channelHolds?: Maybe<Scalars['Int']>;
  totalExclusiveTax?: Maybe<Scalars['Float']>;
  ticketTypeId?: Maybe<Scalars['String']>;
  hasPricingTiers?: Maybe<Scalars['Boolean']>;
};

export type FindAutomationsInput = {
  isActive: Scalars['Boolean'];
  automationType?: Maybe<Scalars['String']>;
};

export type FindExhibitorInput = {
  id: Scalars['String'];
  eventId: Scalars['String'];
};

export type FindOrderIdForTicketOutput = {
  __typename?: 'findOrderIdForTicketOutput';
  /** Order Id */
  orderId: Scalars['String'];
};

export type FindScoutsInput = {
  isActive?: Maybe<Scalars['Boolean']>;
};

export type ForecastScenario = {
  __typename?: 'ForecastScenario';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The zones and forecasted seat count attributes */
  zones?: Maybe<Array<ForecastScenarioZone>>;
};

/** Object to hold the zoneId and the seat allocation forecasts */
export type ForecastScenarioZone = {
  __typename?: 'ForecastScenarioZone';
  /** The zone id of for the seats forecast. */
  zoneId?: Maybe<Scalars['String']>;
  /** Array of ticket type ids and the forecast cost and spilt of ticket sales */
  ticketTypes: Array<ScenarioZoneTicketType>;
};

export type ForecastZoneInput = {
  /** The zone related to this input */
  zoneId: Scalars['String'];
  /** How many seats are forecast to be comped. */
  comps: Scalars['Float'];
  /** How many seats are forecast to be comped. */
  contingency: Scalars['Float'];
};

export type FormField = {
  __typename?: 'FormField';
  field: Scalars['String'];
  isRequired?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  isCustom?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
  defaultValue?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Scalars['String']>>;
};

export type FormFieldInput = {
  field: Scalars['String'];
  isRequired?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  isCustom?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
  defaultValue?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Scalars['String']>>;
};

export type GalleryImage = {
  __typename?: 'GalleryImage';
  src?: Maybe<Scalars['String']>;
  metaData?: Maybe<MetaData>;
  aspectRatio?: Maybe<Scalars['Float']>;
};

export type GalleryImageInput = {
  src?: Maybe<Scalars['String']>;
  metaData?: Maybe<MetaDataInput>;
  aspectRatio?: Maybe<Scalars['Float']>;
};

export type Gate = {
  __typename?: 'Gate';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  isActive: Scalars['Boolean'];
};

/** The gate belonging to a venue */
export type GateInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type GatewayOptions = {
  /** A unique id to specify a variation for a payment gateway. */
  variantId?: Maybe<Scalars['String']>;
  isBNPL?: Maybe<Scalars['Boolean']>;
  isStripeTerminal?: Maybe<Scalars['Boolean']>;
  isStripeEmbeddedCard?: Maybe<Scalars['Boolean']>;
  expressCheckoutPaymentMethod?: Maybe<StripePaymentMethod>;
};

/** Amount remaining that can be automatically refunded through the payment gateway */
export type GatewayRefundableAmount = {
  __typename?: 'GatewayRefundableAmount';
  integrationName: Scalars['String'];
  /** Display label for the payment card used with this gateway */
  cardLabel?: Maybe<Scalars['String']>;
  /** The amount that has already been refunded through this gateway. */
  refundedAmount: Scalars['Float'];
  /** The amount that is availble to be refunded automatically through the gateway  */
  refundableAmount: Scalars['Float'];
};

/** The valid values for gender. */
export enum Gender {
  Male = 'Male',
  Female = 'Female',
  Other = 'Other'
}

export type GenderArgs = {
  __typename?: 'GenderArgs';
  kind: BroadcastMarketingFiltersV2Kind;
  exclude: Scalars['Boolean'];
  genders: Array<GenderFilterType>;
};

export type GenderBreakDownData = {
  __typename?: 'GenderBreakDownData';
  male: Scalars['Int'];
  female: Scalars['Int'];
  other: Scalars['Int'];
};

export type GenderBreakDownOutput = {
  __typename?: 'GenderBreakDownOutput';
  reportData: GenderBreakDownData;
  reportType: ReportType;
  shouldHide: Scalars['Boolean'];
};

/** Gender values that can be filtered on. */
export enum GenderFilterType {
  Male = 'Male',
  Female = 'Female',
  Other = 'Other',
  Unspecified = 'Unspecified'
}

export type Genre = {
  __typename?: 'Genre';
  id: Scalars['ID'];
  /** Name of the genre */
  name: Scalars['String'];
};

export type GetAllCustomizationInput = {
  eventId?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
};

export type GetHistoryByCustomerIdInput = {
  /** An array of the reference name of the history item. */
  refName?: Maybe<Array<Scalars['String']>>;
  /** Id of order. Used when looking at a customers order */
  orderId?: Maybe<Scalars['String']>;
  /** Id of customers. Not the id of admins. */
  userId?: Maybe<Scalars['String']>;
};

export type GetReportSchedulesInput = {
  type: ReportScheduleType;
  eventId?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
};

export type GetUserEntriesInput = {
  competitionId: Scalars['String'];
  userId: Scalars['String'];
};

export type GoogleAnalyticsReportingFilterInput = {
  sourceId?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  source: ReportingFilterSource;
  type: GoogleAnalyticsReportType;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
};

/** Google Analytics report type */
export enum GoogleAnalyticsReportType {
  Device = 'DEVICE',
  TrafficSource = 'TRAFFIC_SOURCE',
  Gender = 'GENDER',
  Age = 'AGE',
  UniqueUsers = 'UNIQUE_USERS',
  Sessions = 'SESSIONS'
}

export type GrantCompetitionRewardInput = {
  competitionId: Scalars['String'];
  userId: Scalars['String'];
  platform: Scalars['String'];
  actionType: Scalars['String'];
  orderId?: Maybe<Scalars['String']>;
};

export type GrantRewardOutput = {
  __typename?: 'GrantRewardOutput';
  platform: Scalars['String'];
  actionType: Scalars['String'];
  value: Scalars['Int'];
};

export type GraphDateItem = {
  __typename?: 'GraphDateItem';
  date: Scalars['DateTime'];
  items: Array<GraphItem>;
};

export enum GraphFilterType {
  Overall = 'OVERALL',
  Tickets = 'TICKETS',
  AddOns = 'ADD_ONS',
  Memberships = 'MEMBERSHIPS',
  Package = 'PACKAGE'
}

export type GraphItem = {
  __typename?: 'GraphItem';
  key?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  value: Scalars['Float'];
};

export type GraphOutput = {
  __typename?: 'GraphOutput';
  dates: Array<GraphDateItem>;
};

export type GraphRangeItem = {
  __typename?: 'GraphRangeItem';
  start: Scalars['String'];
  end: Scalars['String'];
  value: Scalars['Float'];
};

export type GraphTextItem = {
  __typename?: 'GraphTextItem';
  identifier: Scalars['String'];
  description: Scalars['String'];
  items: Array<GraphItem>;
};

/** Grey scale options. */
export enum GreyScale {
  Warm = 'Warm',
  Neutral = 'Neutral',
  Cool = 'Cool'
}

export type HandleInstagramCodeInput = {
  code: Scalars['String'];
  url: Scalars['String'];
};

export type HeardAboutUsBreakDownOutput = {
  __typename?: 'HeardAboutUsBreakDownOutput';
  heardAboutUs?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Float']>;
};

/** Heard about us type */
export enum HeardAboutUsType {
  WordOfMouth = 'WordOfMouth',
  Radio = 'Radio',
  Billboard = 'Billboard',
  SocialMedia = 'SocialMedia',
  Email = 'Email',
  Other = 'Other',
  InternetSearch = 'InternetSearch'
}

export type HighestValueCustomersOutput = {
  __typename?: 'HighestValueCustomersOutput';
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

/** Represents information about an history item. */
export type History = {
  __typename?: 'History';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  refName: Scalars['String'];
  /** The user who make this history, should get this value from @CurrentUser */
  user?: Maybe<User>;
  /** History item description. */
  description: Scalars['String'];
  scoutCommunication?: Maybe<Scout>;
  order?: Maybe<Order>;
  ticket?: Maybe<Ticket>;
};

export type HistoryConnection = {
  __typename?: 'HistoryConnection';
  pageInfo: PageInfo;
  edges: Array<HistoryEdge>;
  totalCount: Scalars['Int'];
};

export type HistoryEdge = {
  __typename?: 'HistoryEdge';
  cursor: Scalars['String'];
  node: History;
};

export type HistoryOrderByInput = {
  createdAt?: Maybe<OrderByDirection>;
};

/** The valid reference types for history items. */
export enum HistoryReferenceType {
  Order = 'Order',
  User = 'User',
  ScoutUser = 'ScoutUser',
  Scan = 'Scan',
  Competition = 'Competition'
}

export type HmacOutput = {
  __typename?: 'HmacOutput';
  hash: Scalars['String'];
  expiration: Scalars['String'];
};

export type HoldBestAvailableSeatsInput = {
  holdToken: Scalars['String'];
  quantity: Scalars['Int'];
  categories: Array<Scalars['Int']>;
};

export type HoldBestAvailableSeatsOutput = {
  __typename?: 'HoldBestAvailableSeatsOutput';
  objects: Array<Scalars['String']>;
  nextToEachOther: Scalars['Boolean'];
};

export type I18nOutput = {
  __typename?: 'I18nOutput';
  data: Scalars['JSON'];
};

/** Image gallery item */
export type ImageGalleryItem = {
  __typename?: 'ImageGalleryItem';
  id: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  original?: Maybe<GalleryImage>;
  cropped?: Maybe<GalleryImage>;
};

/** Image gallery item */
export type ImageGalleryItemInput = {
  id: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  original?: Maybe<GalleryImageInput>;
  cropped?: Maybe<GalleryImageInput>;
};

export type ImportExhibitorAlreadyExistsResultOutput = {
  __typename?: 'ImportExhibitorAlreadyExistsResultOutput';
  email: Scalars['String'];
  name: Scalars['String'];
};

export type ImportExhibitorInput = {
  file: Scalars['Upload'];
  eventId: Scalars['String'];
};

export type ImportExhibitorOutput = {
  __typename?: 'ImportExhibitorOutput';
  importedCount: Scalars['Int'];
  failed: Array<ImportExhibitorParseFailedResultOutput>;
  duplicates: Array<ImportExhibitorAlreadyExistsResultOutput>;
};

export type ImportExhibitorParseFailedResultOutput = {
  __typename?: 'ImportExhibitorParseFailedResultOutput';
  rowData: Scalars['String'];
  reason: Scalars['String'];
};

export type ImportInput = {
  file: Scalars['Upload'];
};

export type ImportOutput = {
  __typename?: 'ImportOutput';
  /** Returns information about failed lines. */
  failed: Array<FailedImportItem>;
};

/** Import user item */
export type ImportUserItem = {
  __typename?: 'ImportUserItem';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  processedAt?: Maybe<Scalars['DateTime']>;
  message?: Maybe<Scalars['String']>;
  /** import user item status */
  status?: Maybe<ImportUserItemStatus>;
};

export enum ImportUserItemStatus {
  Success = 'Success',
  Failed = 'Failed'
}

export type InitialiseSetupIntentOutput = {
  __typename?: 'InitialiseSetupIntentOutput';
  clientSecret: Scalars['String'];
};

export type InitScout = {
  __typename?: 'InitScout';
  seasons: Array<Season>;
  membershipTypes: Array<MembershipType>;
  events: Array<Event>;
  userTags: Array<Tag>;
  zones: Array<Zone>;
};

/** Inside fee and range. */
export type InsideFeeDetails = {
  __typename?: 'InsideFeeDetails';
  priceRangeFrom: Scalars['Float'];
  priceRangeTo: Scalars['Float'];
  insideFee: Scalars['Float'];
};

/** Inside fee and range. */
export type InsideFeeDetailsInput = {
  priceRangeFrom: Scalars['Float'];
  priceRangeTo: Scalars['Float'];
  insideFee: Scalars['Float'];
};

export type InsightsOverviewOutput = {
  __typename?: 'InsightsOverviewOutput';
  customers?: Maybe<Scalars['Float']>;
  addressableAudience?: Maybe<Scalars['Float']>;
  customerValue?: Maybe<Scalars['Float']>;
  numberOfOrders?: Maybe<Scalars['Float']>;
  repeatPurchasers?: Maybe<Scalars['Float']>;
  referralLinksCreated?: Maybe<Scalars['Float']>;
  newReferredCustomers?: Maybe<Scalars['Float']>;
  ordersPerUser?: Maybe<Scalars['Float']>;
  ticketsCount?: Maybe<Scalars['Float']>;
  netSales?: Maybe<Scalars['Float']>;
};

export type Integration = {
  __typename?: 'Integration';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** Integration type */
  type: IntegrationType;
  /** Integration name */
  name: Scalars['String'];
  /** External public key (can be used in customer frontend) */
  publicKey?: Maybe<Scalars['String']>;
  /** Webhook URL to point integration to */
  webhookUrl?: Maybe<Scalars['String']>;
  /** Transaction fee type. */
  transactionFeeType?: Maybe<FeeType>;
  /** Transaction fee. */
  transactionFee?: Maybe<Scalars['Float']>;
  /** Transaction fee type(only for stripe). Users can input both fixed and percentage fee for stripe(0.3$+2%). */
  transactionFeeType2?: Maybe<FeeType>;
  /** Transaction fee(only for stripe). Users can input both fixed and percentage fee for stripe(0.3$+2%). */
  transactionFee2?: Maybe<Scalars['Float']>;
  /** If payment gateways have different option types this field is used to specify which one to force */
  paymentMethodType?: Maybe<Scalars['String']>;
  facebookPageId?: Maybe<Scalars['String']>;
  facebookUserId?: Maybe<Scalars['String']>;
  bnplEnabled?: Maybe<Scalars['Boolean']>;
  /** Whether Express Checkout is enabled for this integration. If null, it is considered disabled. */
  expressCheckoutEnabled?: Maybe<Scalars['Boolean']>;
  bnplTransactionFeePercent?: Maybe<Scalars['Float']>;
  /** Number of days after transaction when refunds are allowed for Afterpay */
  daysAfterCanRefund?: Maybe<Scalars['Int']>;
  stripeConnectAccount?: Maybe<StripeConnectAccount>;
  /** Internal API key (should not be shared) */
  secretKey?: Maybe<Scalars['String']>;
  /** External secret key (should not be shared) */
  apiKey?: Maybe<Scalars['String']>;
  /** External secret key for Windcave PxPost. */
  wcPxPostSecretKey?: Maybe<Scalars['String']>;
  /** External public key for Windcave PxPost. */
  wcPxPostPublicKey?: Maybe<Scalars['String']>;
};

/** Integration group. */
export enum IntegrationGroup {
  Payment = 'PAYMENT',
  Ecommerce = 'ECOMMERCE',
  Crm = 'CRM',
  Marketing = 'MARKETING',
  Social = 'SOCIAL',
  Accounting = 'ACCOUNTING',
  Ops = 'OPS'
}

/** Integration type. */
export enum IntegrationType {
  PaymentStripe = 'PAYMENT_STRIPE',
  PaymentWindcave = 'PAYMENT_WINDCAVE',
  PaymentLaybuy = 'PAYMENT_LAYBUY',
  PaymentAfterpay = 'PAYMENT_AFTERPAY',
  PaymentMpaisa = 'PAYMENT_MPAISA',
  PaymentPin = 'PAYMENT_PIN',
  EcommerceShopify = 'ECOMMERCE_SHOPIFY',
  ReportingShopify = 'REPORTING_SHOPIFY',
  CrmKore = 'CRM_KORE',
  CrmCustom = 'CRM_CUSTOM',
  CrmUssegment = 'CRM_USSEGMENT',
  CrmAdobe = 'CRM_ADOBE',
  MarketingDatorama = 'MARKETING_DATORAMA',
  MarketingMailchimp = 'MARKETING_MAILCHIMP',
  MarketingMessageMedia = 'MARKETING_MESSAGE_MEDIA',
  SocialInstagram = 'SOCIAL_INSTAGRAM',
  AccountingXero = 'ACCOUNTING_XERO',
  OpsIntellitix = 'OPS_INTELLITIX',
  SeatsIo = 'SEATS_IO'
}

export type IntegrationWhereInput = {
  group?: Maybe<IntegrationGroup>;
};

export type InternationalPhoneNumberOutput = {
  __typename?: 'InternationalPhoneNumberOutput';
  number: Scalars['String'];
  country: Scalars['String'];
};

export type ItemFee = {
  __typename?: 'ItemFee';
  id: Scalars['String'];
  isComp: Scalars['Boolean'];
  fees: Array<Fee>;
};

export type JoinedWaitlistActivityArgs = {
  __typename?: 'JoinedWaitlistActivityArgs';
  kind: BroadcastMarketingFiltersV2Kind;
  exclude: Scalars['Boolean'];
  eventIds: Array<Scalars['String']>;
};

export type JoinWaitlistInput = {
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  usableForMarketing: Scalars['Boolean'];
  eventId: Scalars['String'];
  releaseId?: Maybe<Scalars['String']>;
  referralCode?: Maybe<Scalars['String']>;
  userAcquisition?: Maybe<UserAcquisition>;
  customFields?: Maybe<Array<CustomFieldInput>>;
};



/** Landing page options. */
export enum LandingPage {
  MultiEvent = 'MultiEvent',
  SingleEvent = 'SingleEvent',
  Tours = 'Tours'
}

export type LandingToursInput = {
  /** Rich text shown above the tours list. */
  description?: Maybe<Scalars['String']>;
  /** Banner image for Tours landing page. */
  banner?: Maybe<Scalars['Upload']>;
  /** When true, the Tours page for a specific season shows a calendar view instead of event tiles. */
  showCalendarOnTourPage?: Maybe<Scalars['Boolean']>;
};

export type LandingToursSettings = {
  __typename?: 'LandingToursSettings';
  description?: Maybe<Scalars['String']>;
  banner?: Maybe<ExtendedFile>;
  /** When true, the Tours page for a specific season shows a calendar view instead of event tiles. */
  showCalendarOnTourPage?: Maybe<Scalars['Boolean']>;
};

/** Order line items */
export type LineItem = {
  __typename?: 'LineItem';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  type: LineItemType;
  /** Ticket type. Only available for ticket type line items. */
  ticketType?: Maybe<TicketType>;
  /** The release associated with the line item. Returns null if the line item is not bound to a release. */
  release?: Maybe<Release>;
  /** Membership type. Only available for membership type line items. */
  membershipType?: Maybe<MembershipType>;
  /** Event addon. Only available for addon line items. */
  eventAddon?: Maybe<EventAddon>;
  /** Membership addon. Only available for addon line items. */
  membershipAddon?: Maybe<MembershipAddon>;
  /** Seat label. Only available for ticket type line items. */
  seatLabel?: Maybe<Scalars['String']>;
  /** Seat zone. Only available for ticket type line items. */
  seatZone?: Maybe<Scalars['String']>;
  seatZoneEntity?: Maybe<Zone>;
  /** Seat section. Only available for ticket type line items. */
  seatSection?: Maybe<Scalars['String']>;
  seatSectionEntity?: Maybe<Section>;
  /** Seat type. Only available for seated events. */
  seatType?: Maybe<SeatType>;
  /** Seat tags. Only available for ticket type line items. */
  seatTags?: Maybe<Array<Scalars['String']>>;
  /** Item name. */
  name: Scalars['String'];
  /** Price of the line item with discounts applied. */
  price: Scalars['Float'];
  /** This is the stadium levy fee amount for the line item. */
  stadiumLevyFee?: Maybe<Scalars['Float']>;
  /** Original price of the line item without any discounts applied. */
  originalPrice: Scalars['Float'];
  /** Item quantity. */
  quantity: Scalars['Float'];
  /** Ticket fee type. */
  ticketFeeType?: Maybe<FeeType>;
  /** Item ticket fee. */
  ticketFee?: Maybe<Scalars['Float']>;
  /** Tax rate applied to the item. */
  taxRate: Scalars['Float'];
  /** Tax calculation method. either inclusive or exclusive. */
  taxCalculationMethod?: Maybe<TaxCalculationMethod>;
  isComp: Scalars['Boolean'];
  pointItem?: Maybe<PointItem>;
  /** Ticket fee amount (for 1 ticket) */
  ticketFeeAmount?: Maybe<Scalars['Float']>;
  pricingTierId?: Maybe<Scalars['String']>;
  /** Total per unit amount: price + ticketFee + levyFee */
  totalPerUnit: Scalars['Float'];
  /** Total amount: quantity * (price + ticketFee + levyFee) */
  total: Scalars['Float'];
  taxAmount: Scalars['Float'];
  customTaxRate?: Maybe<Scalars['Float']>;
  /** The amount of custom taxes per item */
  customTaxAmount?: Maybe<Scalars['Float']>;
  pricingTierName?: Maybe<Scalars['String']>;
};

/** Action to perform on line item */
export enum LineItemAction {
  Delete = 'DELETE',
  Update = 'UPDATE',
  Complete = 'COMPLETE'
}

export type LineItemActionInput = {
  /** ID of the line item in the order. */
  id: Scalars['String'];
  /** Action to perform on the line item. */
  action: LineItemAction;
  /** New ticket or membership type ID (only relevant for `UPDATE`). */
  ticketOrMembershipTypeId?: Maybe<Scalars['String']>;
};

export type LineItemConnection = {
  __typename?: 'LineItemConnection';
  pageInfo: PageInfo;
  edges: Array<LineItemEdge>;
  totalCount: Scalars['Int'];
};

export type LineItemEdge = {
  __typename?: 'LineItemEdge';
  cursor: Scalars['String'];
  node: LineItem;
};

export type LineItemInput = {
  /** Item type. */
  type: LineItemType;
  /** Line item quantity. */
  quantity: Scalars['Float'];
  /** Previous ticket. Only applicable for seat changes and membership renewals */
  previousTicketId?: Maybe<Scalars['String']>;
  /** Seat label. Only applicable seated venues in combination with for `ticket` and `membership` line items. */
  seatLabel?: Maybe<Scalars['String']>;
  /** Seat zone. Only applicable to non-seated venues in combination for `ticket` and `membership` line items. */
  seatZone?: Maybe<Scalars['String']>;
  seatType?: Maybe<Scalars['String']>;
  /** Seat tags. Only available for ticket type line items. */
  seatTags?: Maybe<Array<Scalars['String']>>;
  /** Seat section. Only available for ticket type line items. */
  seatSection?: Maybe<Scalars['String']>;
  /** Ticket type. Only applicable for `ticket` line items. */
  ticketTypeId?: Maybe<Scalars['String']>;
  /** Membership type. Only applicable for `membership` line items. */
  membershipTypeId?: Maybe<Scalars['String']>;
  /** Addon id. Only applicable for `addon` line items. */
  addonId?: Maybe<Scalars['String']>;
  /** Ticket transfer id. Only applicable for `ticket` line items in a ticket transfer order. */
  ticketTransferId?: Maybe<Scalars['String']>;
  pointItemId?: Maybe<Scalars['String']>;
  /** Price of the line item with discounts applied. Only used for ticket transfers. */
  price?: Maybe<Scalars['Float']>;
};

export type LineItemsToCompleteInput = {
  /** Quantity of tickets to keep on each line item. */
  items: Array<LineItemToCompleteInput>;
  /** Selected payment method if order status is paid (allowed: cash, eftpos, invoice, other). */
  method: PaymentProvider;
  /** Will not send order confirmation email if set */
  skipOrderConfirmation: Scalars['Boolean'];
};

export type LineItemToCompleteInput = {
  /** ID of the line item in the order. */
  id: Scalars['String'];
  /** Quantity of tickets to keep on each line item. */
  quantity: Scalars['Int'];
};

export enum LineItemType {
  Ticket = 'Ticket',
  Membership = 'Membership',
  Addon = 'Addon',
  Point = 'Point',
  MembershipSingleEventTicket = 'MembershipSingleEventTicket'
}

export type LinkedAccountRegisterInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  newAccountPassword: Scalars['String'];
  token: Scalars['String'];
};

export type LinkedAccountUser = {
  __typename?: 'LinkedAccountUser';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  hasVerifiedEmail: Scalars['Boolean'];
  organizationSlugs: Array<Scalars['String']>;
};

export type ListedReleaseOptionsInput = {
  askHowDidYouHearAboutUs?: Maybe<Scalars['Boolean']>;
  askForDietaryRequirements?: Maybe<Scalars['Boolean']>;
  startCondition?: Maybe<ReleaseStartCondition>;
  startConditionDate?: Maybe<Scalars['DateTime']>;
  endCondition?: Maybe<ReleaseEndCondition>;
  endConditionDate?: Maybe<Scalars['DateTime']>;
  endConditionQuantity?: Maybe<Scalars['Float']>;
};

export type LocationArgs = {
  __typename?: 'LocationArgs';
  kind: BroadcastMarketingFiltersV2Kind;
  exclude: Scalars['Boolean'];
  list: Array<Scalars['String']>;
  locationFilterType: LocationFilterTypes;
};

export enum LocationFilterTypes {
  District = 'DISTRICT',
  Locality = 'LOCALITY',
  Region = 'REGION',
  Country = 'COUNTRY',
  State = 'STATE'
}

export type LocationOutput = {
  __typename?: 'LocationOutput';
  city: Scalars['String'];
  count: Scalars['String'];
  amount?: Maybe<Scalars['Float']>;
};

export type LocationOutputV2 = {
  __typename?: 'LocationOutputV2';
  label: Scalars['String'];
  orderCount: Scalars['Float'];
  orderCountPercentage: Scalars['Float'];
  orderAmount: Scalars['Float'];
  orderAmountPercentage: Scalars['Float'];
  ticketSoldPercentage: Scalars['Float'];
  ticketSoldCount: Scalars['Float'];
  membershipSoldCount: Scalars['Float'];
  membershipSoldPercentage: Scalars['Float'];
  userCount: Scalars['Float'];
  userCountPercentage: Scalars['Float'];
  faceValueTicketRevenue: Scalars['Float'];
  faceValueTicketRevenuePercentage: Scalars['Float'];
};

export type LoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  posId?: Maybe<Scalars['String']>;
};

export type ManualRefundInput = {
  manualGateway: RefundGateway;
  amount?: Maybe<Scalars['Float']>;
};

/** Organization marketing settings. */
export type Marketing = {
  __typename?: 'Marketing';
  /** Google Tag Manager ID */
  gtmId?: Maybe<Scalars['String']>;
  /** Facebook Pixel ID */
  pixelId?: Maybe<Scalars['String']>;
};

export type MarketingFiltersInput = {
  ids: Array<Scalars['String']>;
  criteria?: Maybe<BroadcastFilterCriteria>;
  filterType: BroadcastFilterType;
};

/** Organization marketing settings. */
export type MarketingInput = {
  /** Google Tag Manager ID */
  gtmId?: Maybe<Scalars['String']>;
  /** Facebook Pixel ID */
  pixelId?: Maybe<Scalars['String']>;
};

export type MarketingPreferenceUnsubscribeOutput = {
  __typename?: 'MarketingPreferenceUnsubscribeOutput';
  id: Scalars['String'];
};

export type Membership = {
  __typename?: 'Membership';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** Name of the membership. */
  name: Scalars['String'];
  membershipKind: MembershipKind;
  /** The start date of the membership. */
  startDate: Scalars['DateTime'];
  /** The end date of the membership. */
  endDate: Scalars['DateTime'];
  /** The booking fee type of the membership. */
  bookingFeeType: FeeType;
  /** The booking fee for the membership. */
  bookingFee: Scalars['Float'];
  /** Shipping options of the membership. */
  shippingOptions?: Maybe<ShippingOptions>;
  /** The description of the membership. */
  description: Scalars['String'];
  /** The thumbnail associated with the membership. */
  thumbnail?: Maybe<ExtendedFile>;
  backgroundImage?: Maybe<ExtendedFile>;
  descriptionImage?: Maybe<ExtendedFile>;
  /** The banner associated with the membership. */
  banner?: Maybe<ExtendedFile>;
  printBanner1?: Maybe<ExtendedFile>;
  printBanner2?: Maybe<ExtendedFile>;
  /** The payment gateways enabled for the event. */
  gateways?: Maybe<Array<Integration>>;
  /** Whether naming a membership is available. */
  canNameMembership: Scalars['Boolean'];
  /** Whether renaming a membership is available. */
  canRenameMembership: Scalars['Boolean'];
  /** Whether naming a membership is available. */
  canChangeSeats: Scalars['Boolean'];
  /** The renaming fee for the membership. */
  renamingFee?: Maybe<Scalars['Float']>;
  /** The fee for changing seats for the membership. */
  changingSeatsFee?: Maybe<Scalars['Float']>;
  /** The active status of the membership. */
  isActive: Scalars['Boolean'];
  /** Whether the membership is ticketed */
  isTicketed: Scalars['Boolean'];
  events?: Maybe<Array<Event>>;
  membershipZones: Array<MembershipZone>;
  /** The terms and conditions of the membership */
  termsAndConditions?: Maybe<Scalars['String']>;
  /** Important notice section on the tickets */
  importantNotice?: Maybe<Scalars['String']>;
  /** The accessibility info of the membership */
  accessibility?: Maybe<Scalars['String']>;
  /** The accessibility info of the membership */
  invoiceInformation?: Maybe<Scalars['String']>;
  /** Whether the schedule is shown on the customer portal */
  showSchedule?: Maybe<Scalars['Boolean']>;
  /** The referral campaign associated with this membership */
  referralCampaignId?: Maybe<Scalars['String']>;
  /** Email address that gets sent a notifcation every time an order is completed */
  emailNotification?: Maybe<Scalars['String']>;
  /** Flag to determine if the membership is hidden from the public */
  hiddenFromPublic: Scalars['Boolean'];
  /** Flag to issue the value of the membership as credit on sale */
  issueCreditOnSale: Scalars['Boolean'];
  canUsePoints: Scalars['Boolean'];
  enableAutoRenew: Scalars['Boolean'];
  canTransferTickets: Scalars['Boolean'];
  paymentPlanSettings?: Maybe<PaymentPlanSettings>;
  ticketCover?: Maybe<MembershipTicketCover>;
  /** The ID of the Google Wallet Event Class for this membership */
  googleWalletEventClassId?: Maybe<Scalars['String']>;
  releasedRenewalHolds: Scalars['Boolean'];
  seoMetadata?: Maybe<SeoMetadata>;
  /** Custom tax fields for the membership */
  tax?: Maybe<Array<Tax>>;
  exchangeSettings?: Maybe<ExchangeSettings>;
  membershipsViewableFromDate?: Maybe<Scalars['DateTime']>;
  lastMembershipViewableEmailsSentAt?: Maybe<Scalars['DateTime']>;
  accessCodes: Array<AccessCode>;
  types: Array<MembershipType>;
  hasAccessCodes: Scalars['Boolean'];
  renewalMembership?: Maybe<Membership>;
  previousMemberships: Array<Membership>;
  season?: Maybe<Season>;
  /** The venue associated with the membership. */
  venue?: Maybe<Venue>;
  addons: Array<MembershipAddon>;
  membershipHoldersCount?: Maybe<Scalars['Float']>;
  multiBuyPromotions: Array<MembershipMultiBuyPromotion>;
  digitalPassCodesStatus?: Maybe<DigitalPassCodeStatusOutput>;
  digitalInfo?: Maybe<DigitalInfo>;
  defaultDateRange?: Maybe<DateRange>;
  tags: Array<Tag>;
  hasPromoCodes: Scalars['Boolean'];
  taxRate: Scalars['Float'];
  customTaxRate: Scalars['Float'];
  taxCalculationMethod: TaxCalculationMethod;
  fees: OrderFee;
  seekaConfig?: Maybe<SeekaOutput>;
  seatsIoConfig?: Maybe<SeatsIoConfigOutput>;
  stripeConfig?: Maybe<StripeConfigOutput>;
};


export type MembershipTypesArgs = {
  code?: Maybe<Scalars['String']>;
};

export type MembershipAddon = {
  __typename?: 'MembershipAddon';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  /** Indicates whether naming the addon is possible or not. */
  enableNaming: Scalars['Boolean'];
  /** Maximum quantity to be sold for the addon. */
  quantity: Scalars['Float'];
  /** The price associated with the addon. */
  price: Scalars['Float'];
  /** The brief description of the addon. */
  description?: Maybe<Scalars['String']>;
  /** The restrictions applied to the addon. */
  restrictions?: Maybe<Scalars['String']>;
  /** The active status of the addon. */
  isActive: Scalars['Boolean'];
  namingFields: Array<FormField>;
  /** Image to be shown on the customer portal of the addon . Returns null if the not set. */
  addonImage?: Maybe<ExtendedFile>;
  /** Quantity allocated already */
  quantityAllocated: Scalars['Float'];
  maxPurchaseQuantity: Scalars['Float'];
  /** Quantity remaining via order created or canceled, does not take into account the order status */
  remaining: Scalars['Float'];
  displayOrder: Scalars['Int'];
};

export type MembershipArgs = {
  __typename?: 'MembershipArgs';
  kind: BroadcastMarketingFiltersV2Kind;
  exclude: Scalars['Boolean'];
  membershipIds: Array<Scalars['String']>;
};

export type MembershipAutoRenewal = {
  __typename?: 'MembershipAutoRenewal';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  membership: Membership;
  membershipId: Scalars['String'];
  organizationId: Scalars['String'];
  renewalDate?: Maybe<Scalars['DateTime']>;
  reminderDate?: Maybe<Scalars['DateTime']>;
  /** Mappings for previous memberships used by renewal process */
  membershipMappings: Array<MembershipRenewalMapping>;
  /** Current step of the auto renewal process */
  renewalStep: MembershipAutoRenewalStep;
};

export type MembershipAutoRenewalInput = {
  membershipId: Scalars['String'];
  renewalDate: Scalars['DateTime'];
  reminderDate?: Maybe<Scalars['DateTime']>;
  membershipMappings: Array<MembershipRenewalMappingInput>;
  /** Current step of the auto renewal process */
  renewalStep: MembershipAutoRenewalStep;
};

export type MembershipAutoRenewalOutput = {
  __typename?: 'MembershipAutoRenewalOutput';
  autoRenewal?: Maybe<MembershipAutoRenewal>;
};

export enum MembershipAutoRenewalStep {
  Scheduled = 'Scheduled',
  Reminded = 'Reminded',
  Renewed = 'Renewed'
}

export type MembershipConnection = {
  __typename?: 'MembershipConnection';
  pageInfo: PageInfo;
  edges: Array<MembershipEdge>;
  totalCount: Scalars['Int'];
};

export type MembershipEdge = {
  __typename?: 'MembershipEdge';
  cursor: Scalars['String'];
  node: Membership;
};

export type MembershipFinancial = {
  __typename?: 'MembershipFinancial';
  discounts: PeReportStatistic;
  avgOrderItemsCount: PeReportStatistic;
  netSales: PeReportStatistic;
  averageOrderAmount: PeReportStatistic;
  partPaidRevenue: PeReportStatistic;
  planTotalOutstanding: PeReportStatistic;
};

export type MembershipInformation = {
  __typename?: 'MembershipInformation';
  id: Scalars['String'];
  name: Scalars['String'];
  location?: Maybe<Scalars['String']>;
  startDate: Scalars['String'];
  endDate: Scalars['String'];
  banner?: Maybe<ExtendedFile>;
};

export enum MembershipKind {
  Standard = 'Standard',
  Digital = 'Digital'
}

export type MembershipLayoutOutput = {
  __typename?: 'MembershipLayoutOutput';
  defaultDateRange: DateRange;
  membership?: Maybe<MembershipInformation>;
};

export type MembershipMultiBuyPromotion = {
  __typename?: 'MembershipMultiBuyPromotion';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  buyQuantity: Scalars['Float'];
  getQuantity: Scalars['Float'];
  price: Scalars['Float'];
  enabled: Scalars['Boolean'];
  buyMembershipType?: Maybe<MembershipType>;
  getMembershipType?: Maybe<MembershipType>;
  used: Scalars['Float'];
};

export type MembershipOrderByInput = {
  createdAt?: Maybe<OrderByDirection>;
  updatedAt?: Maybe<OrderByDirection>;
  startDate?: Maybe<OrderByDirection>;
  endDate?: Maybe<OrderByDirection>;
};

export type MembershipPromoCode = {
  __typename?: 'MembershipPromoCode';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The unique code that represents the promotion. */
  code: Scalars['String'];
  /** The discount type associated with the promotion. */
  discountType: DiscountType;
  /** The discount amount of the promotion. */
  discountAmount: Scalars['Float'];
  enabled: Scalars['Boolean'];
  /** The type of the promotion which determines on which items the promotion will be applied. */
  type: MembershipPromoCodeType;
  membershipTypes: Array<Scalars['String']>;
  membershipAddons: Array<Scalars['String']>;
  /** The total amount of usage of the promotion. */
  used?: Maybe<Scalars['Int']>;
  /** The maximum amount of use condition of the promotion. Returns `null` when inactive. */
  maxUsage?: Maybe<Scalars['Int']>;
  /** The start date condition of the promotion. Returns `null` when inactive. */
  startDate?: Maybe<Scalars['DateTime']>;
  /** The end date condition of the promotion. Returns `null` when inactive. */
  endDate?: Maybe<Scalars['DateTime']>;
  /** The minimum order amount condition of the promotion. Returns `null` when inactive. */
  minOrderAmount?: Maybe<Scalars['Float']>;
  /** The maximum order amount condition of the promotion. Returns `null` when inactive. */
  maxOrderAmount?: Maybe<Scalars['Float']>;
};

export enum MembershipPromoCodeType {
  MembershipAndAddons = 'MEMBERSHIP_AND_ADDONS',
  Membership = 'MEMBERSHIP',
  Addons = 'ADDONS'
}

export type MembershipRenewalMapping = {
  __typename?: 'MembershipRenewalMapping';
  membershipId: Scalars['String'];
  membershipTypeMappings?: Maybe<Array<MembershipTypeMapping>>;
};

export type MembershipRenewalMappingInput = {
  membershipId: Scalars['String'];
  membershipTypeMappings?: Maybe<Array<MembershipTypeMappingInput>>;
};

export type MembershipSales = {
  __typename?: 'MembershipSales';
  membershipsIssued: PeReportStatistic;
  membershipsRenewed: PeReportStatistic;
  membershipsSold: PeReportStatistic;
};

/** Represents a membership type in a seating zone. */
export type MembershipSeatingZoneType = {
  __typename?: 'MembershipSeatingZoneType';
  /** The price of the zone ticket. Returns null if `pricingLevel` of the parent is set to other than `zone`. */
  price?: Maybe<Scalars['Float']>;
  /** The sections of the zone ticket. Returns null if `pricingLevel` of the parent is set to other than `section`. */
  sections?: Maybe<Array<ZonePricingTypeSection>>;
  /** Whether the pricing type is hidden from public view. */
  isHidden: Scalars['Boolean'];
  /** The active status of the zone ticket. Defaults to `false`. */
  isActive: Scalars['Boolean'];
  purchaseRestrictions: Array<PurchaseRestriction>;
  purchaseRestrictionsHelpText?: Maybe<Array<Scalars['String']>>;
  /** The membership type id of the membership zone. */
  membershipTypeId: Scalars['String'];
};

export type MembershipSubscription = {
  __typename?: 'MembershipSubscription';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  stripeSubscriptionId: Scalars['String'];
  /** Billing details of the subscription */
  billingDetails: MembershipSubscriptionBillingDetails;
  /** Number of membership tickets */
  membershipTicketCount: Scalars['Float'];
  /** Last order id */
  lastOrderId: Scalars['String'];
  lastOrder: Order;
  /** User id */
  userId: Scalars['String'];
  renewals: Array<MembershipSubscriptionRenewal>;
  latestRenewalId?: Maybe<Scalars['String']>;
};

export type MembershipSubscriptionBillingDetails = {
  __typename?: 'MembershipSubscriptionBillingDetails';
  cardLast4: Scalars['String'];
  cardBrand: Scalars['String'];
  cardExpiryMonth: Scalars['Float'];
  cardExpiryYear: Scalars['Float'];
  emailAddress: Scalars['String'];
};

export type MembershipSubscriptionPortalOutput = {
  __typename?: 'MembershipSubscriptionPortalOutput';
  url?: Maybe<Scalars['String']>;
};

export type MembershipSubscriptionRenewal = {
  __typename?: 'MembershipSubscriptionRenewal';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  dueAt?: Maybe<Scalars['DateTime']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  remindedAt?: Maybe<Scalars['DateTime']>;
  /** Current state of the subscription */
  subscriptionState?: Maybe<MembershipSubscriptionState>;
  failedAt?: Maybe<Scalars['DateTime']>;
  failureReason?: Maybe<Scalars['String']>;
  membershipSubscriptionId: Scalars['String'];
  currentMembershipId: Scalars['String'];
  currentOrderId?: Maybe<Scalars['String']>;
  previousMembershipId: Scalars['String'];
  previousOrderId: Scalars['String'];
};

export enum MembershipSubscriptionState {
  Scheduled = 'Scheduled',
  Paid = 'Paid',
  Overdue = 'Overdue',
  Pending = 'Pending',
  Cancelled = 'Cancelled'
}

export type MembershipTicketCover = {
  __typename?: 'MembershipTicketCover';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** Membership that the ticket cover is configured for */
  membership: Membership;
  enabledAt?: Maybe<Scalars['DateTime']>;
  disabledAt?: Maybe<Scalars['DateTime']>;
  /** Promoter fee as percentage of ticket price */
  promoterFeePercentage: Scalars['Float'];
  /** Platform fee as percentage of ticket price */
  platformFeePercentage: Scalars['Float'];
  /** Ticket cover purchase behaviour */
  purchaseBehaviour: TicketCoverPurchaseBehaviour;
  /** Total fee as percentage of ticket price */
  totalFeePercentage?: Maybe<Scalars['Float']>;
  /** Is ticket cover enabled */
  isEnabled?: Maybe<Scalars['Boolean']>;
};

export type MembershipTicketCoverInput = {
  /** Promoter fee as percentage of ticket price */
  promoterFeePercentage: Scalars['Float'];
  /** Ticket cover purchase behaviour */
  purchaseBehaviour: TicketCoverPurchaseBehaviour;
  /** Whether ticket cover is enabled */
  isEnabled: Scalars['Boolean'];
};

export type MembershipType = {
  __typename?: 'MembershipType';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The kind of the membership type. */
  kind: MembershipTypeKind;
  /** Number of membership tickets that must be purchased in this set. */
  quantitySet?: Maybe<Scalars['Int']>;
  /** Name of the membership type. */
  name: Scalars['String'];
  /** The ticket fee type. */
  ticketFeeType: FeeType;
  /** The ticket fee. */
  ticketFee: Scalars['Float'];
  /** Restrictions for the membership type. */
  description?: Maybe<Scalars['String']>;
  /** Restrictions for the membership type. */
  restrictions?: Maybe<Scalars['String']>;
  namingFields: Array<FormField>;
  minPurchaseQuantity?: Maybe<Scalars['Int']>;
  maxPurchaseQuantity?: Maybe<Scalars['Int']>;
  isGuestCard: Scalars['Boolean'];
  isHidden: Scalars['Boolean'];
  /** Whether the membership type is for a child. */
  isChild: Scalars['Boolean'];
  accessCodes?: Maybe<Array<AccessCode>>;
  membership: Membership;
};

export type MembershipTypeEventTransferPrice = {
  __typename?: 'MembershipTypeEventTransferPrice';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  membership: Membership;
  membershipType: MembershipType;
  membershipZone: MembershipZone;
  event: Event;
  maxSalePrice: Scalars['Float'];
};

/** Membership kind for membership type. */
export enum MembershipTypeKind {
  Standard = 'STANDARD',
  ComplimentaryNamed = 'COMPLIMENTARY_NAMED',
  ComplimentaryUnnamed = 'COMPLIMENTARY_UNNAMED',
  Addon = 'ADDON'
}

export type MembershipTypeMapping = {
  __typename?: 'MembershipTypeMapping';
  previousMembershipTypeId: Scalars['String'];
  newMembershipTypeId: Scalars['String'];
};

export type MembershipTypeMappingInput = {
  previousMembershipTypeId: Scalars['String'];
  newMembershipTypeId: Scalars['String'];
};

export type MembershipTypePurchaseTotal = {
  __typename?: 'MembershipTypePurchaseTotal';
  membershipType: MembershipType;
  total: Scalars['Int'];
};

export type MembershipTypeTransferPriceInput = {
  eventId: Scalars['String'];
  maxSalePrice: Scalars['Float'];
};

export type MembershipWhereInput = {
  /** Membership active status. */
  isActive?: Maybe<Scalars['Boolean']>;
  /** Fuzzy search query. */
  q?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
};

export type MembershipZone = {
  __typename?: 'MembershipZone';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  zone: Zone;
  /** The pricing level of the zone. Will be set to `zone` for non-seated events. */
  pricingLevel: ZonePricingLevel;
  /** The active status of the zone. Defaults to `false`. */
  isActive: Scalars['Boolean'];
  /** The list of ticket types of the release zone. */
  membershipTypes: Array<MembershipSeatingZoneType>;
};

/** The zone belonging to a release zone */
export type MembershipZoneZoneInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

/** Represents the overview of mentions. */
export type MentionOverview = {
  __typename?: 'MentionOverview';
  commentMentionCount: Scalars['Float'];
  mediaMentionCount: Scalars['Float'];
  storyMentionCount: Scalars['Float'];
};

export type MentionOverviewInput = {
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
};

export type MetaData = {
  __typename?: 'MetaData';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
};

export type MetaDataInput = {
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
};

export type MetricFilterDefaults = {
  __typename?: 'MetricFilterDefaults';
  default: Scalars['String'];
  options: Array<MetricFilterOption>;
};

export type MetricFilterOption = {
  __typename?: 'MetricFilterOption';
  label: Scalars['String'];
  value: Scalars['String'];
};

export type MinTicketTypePricesForEventOutput = {
  __typename?: 'MinTicketTypePricesForEventOutput';
  ticketTypeId: Scalars['String'];
  price: Scalars['Float'];
};

export type MoneyStatistic = {
  __typename?: 'MoneyStatistic';
  label: Scalars['String'];
  tooltip?: Maybe<StatisticTooltip>;
  value: Scalars['Float'];
};

export type MultiBuyPromotionUnion = EventMultiBuyPromotion | MembershipMultiBuyPromotion;

export type Mutation = {
  __typename?: 'Mutation';
  register: Scalars['Boolean'];
  linkedAccountLogin: LinkedAccountUser;
  linkedAccountRegister: LinkedAccountUser;
  initiateLinkedAccountRegistration: Scalars['Boolean'];
  login: User;
  socialAuth: User;
  logout: Scalars['Boolean'];
  requestMagicLink: Scalars['Boolean'];
  requestDeleteAccount: Scalars['Boolean'];
  verifyMagicLink: VerifyMagicLinkOutput;
  verifyToken: VerifyMagicLinkOutput;
  requestResetPassword: Scalars['Boolean'];
  resetPassword: Scalars['Boolean'];
  setPasswordForNewUser: Scalars['Boolean'];
  updatePassword: Scalars['Boolean'];
  assignTwoFactorAuthenticationSecret: TwoFactorAuthenticationSetupResult;
  removeMultiFactorAuthenticationSecret: Scalars['Boolean'];
  enableTwoFactorAuthentication: Scalars['Boolean'];
  authenticateWithTwoFactor: User;
  sendTwoFactorCodeViaEmail: Scalars['Boolean'];
  verifyManageTicketsLink: VerifyManageTicketsOutput;
  /** Creates a user. */
  createUser: User;
  createPosUser: User;
  createTemporaryPosUser: CreateTemporaryPosUserOutput;
  updatePosUser: User;
  /** Updates a user. */
  updateUser: User;
  /** Deletes a user. */
  deleteUser: DeleteOneOutput;
  /** Delete yourself. */
  deleteSelf: DeleteOneOutput;
  /** Updates the current user. */
  updateProfile: User;
  /** Sends an invite to an existing user. */
  sendUserInvite: User;
  /** Sends invitations to existing users based on CSV file. */
  importAndInviteUsers: ImportOutput;
  importUsers: Scalars['Boolean'];
  deleteRequest: Scalars['Boolean'];
  userPaymentTerminalConnect: Scalars['Boolean'];
  userPaymentTerminalDisconnect: Scalars['Boolean'];
  optInMarketing: Scalars['Boolean'];
  updateCreditsForUser: User;
  createPos: Pos;
  createOrUpdatePosRelease: Release;
  setPosReleasePaymentOptions: ReleasePosPaymentOptions;
  posAutoscan: Scalars['Boolean'];
  posTerminalConnect: Scalars['Boolean'];
  posTerminalDisconnect: Scalars['Boolean'];
  posTerminalIdentify: Scalars['Boolean'];
  posTerminalCancel: Scalars['Boolean'];
  posTerminalConnectionToken: PosTerminalConnectionOutput;
  syncEventToIntellitix: Scalars['Boolean'];
  updateForecast: EventForecastOutput;
  addForecastScenario: EventForecastOutput;
  deleteForecastScenario: EventForecastOutput;
  createEvent: Event;
  updateEvent: Event;
  duplicateEvent: Scalars['String'];
  addGatesToZoneAndEvent: Event;
  toggleMultiScanning: Scalars['Boolean'];
  updateTicketEntryTimeEnforcement: Scalars['Boolean'];
  updateEventSeatSelectionDefaults: Event;
  setTicketTypePricingTiers: Array<PricingTierOutput>;
  setTicketTypePricingTierSoldOut: Scalars['Boolean'];
  createTicketType: TicketType;
  updateTicketType: TicketType;
  deleteTicketType: DeleteOneOutput;
  createRelease: Release;
  updateRelease: Release;
  deleteRelease: DeleteOneOutput;
  holdBestAvailableSeats: HoldBestAvailableSeatsOutput;
  validateReleasePasswordOrRelease: ValidateReleasePasswordOrReleaseOutput;
  validateReleasePassword: ReleasePassword;
  importReleasePasswords: Scalars['Boolean'];
  duplicateSingleRelease: Release;
  createEventPromoCode: EventPromoCode;
  updateEventPromoCode: EventPromoCode;
  deleteEventPromoCode: DeleteOneOutput;
  createEventMultiBuyPromotion: EventMultiBuyPromotion;
  updateEventMultiBuyPromotion: EventMultiBuyPromotion;
  deleteEventMultiBuyPromotion: DeleteOneOutput;
  createEventAddon: EventAddon;
  updateEventAddon: EventAddon;
  deleteEventAddon: DeleteOneOutput;
  addGatesToScannableGatesId: EventAddon;
  createReleaseZone: ReleaseZone;
  updateReleaseZone: ReleaseZone;
  deleteReleaseZone: Scalars['Boolean'];
  reorderTicketTypes: ReleaseZone;
  createOrUpdateAccessCodeRelease: AccessCodeReleaseOutput;
  deleteAccessCode: AccessCodeReleaseOutput;
  updateAccessCode: AccessCodeOutput;
  createOrUpdatePresale: PresaleReleaseOutput;
  deletePresale: Scalars['Boolean'];
  enablePresale: Scalars['Boolean'];
  createOrUpdateNamingField: NamingFieldOutput;
  deleteNamingField: Scalars['Boolean'];
  toggleNamingFields: Scalars['Boolean'];
  toggleCanRename: Scalars['Boolean'];
  resendUsherTicket: Scalars['Boolean'];
  createUsherTicketType: TicketType;
  updateUsherTicketTypeName: TicketType;
  disableUsherTicketType: Scalars['Boolean'];
  deleteUsherTicketType: Scalars['Boolean'];
  createSeason: Season;
  updateSeason: Season;
  completeStripeSetup: Integration;
  createIntegration: Integration;
  updateIntegration: Integration;
  deleteIntegration: Scalars['Boolean'];
  rollIntegrationApiKey: Integration;
  completeStripeOAuthSetup: CompleteStripeOAuth;
  setXeroConfiguration: XeroConfigurationOutput;
  enableXeroIntegration: Scalars['Boolean'];
  completeShopifySetup: Scalars['Boolean'];
  upsertAdobeIntegration: AdobeExperiencePlatformIntegration;
  createOrganization: CreateOrganizationOutput;
  updateOrganization: Organization;
  updateOrganizationById: Organization;
  uploadImage: Scalars['JSON'];
  updateCalendarHomepageCustomization: CalendarHomepageCustomization;
  syncOrderToIntellitix: Order;
  createOrder: OrderCreateOutput;
  createCompOrder: Order;
  updateOrder: Order;
  updateHoldOrder: Order;
  splitHoldOrder: Order;
  releaseSeats: Order;
  createPayment: CreatePaymentOutput;
  applyPromoCodeToOrder: Order;
  updateTicketCoverForOrder: Order;
  removePromoCodeFromOrder: Order;
  holdCustomerOrder: Order;
  updateOrderStatus: Order;
  completePreprintTicketOrder: Order;
  addPosTransaction: PosTransaction;
  removePosTransaction: Order;
  finishPosTransaction: Order;
  sendOrderConfirmation: SendOrderConfirmationOutput;
  sendInternalOrderReceipt: SendOrderConfirmationOutput;
  cancelOrder: Order;
  cancelOrderPaymentPlan: Scalars['Boolean'];
  expireOrder: Order;
  generateXeroInvoiceForOrder: Scalars['String'];
  splitGroupOrder: Order;
  createBulkOrders: Scalars['Boolean'];
  createRefund: Refund;
  automaticallyAttribute: Scalars['Boolean'];
  createAttributableRefund: Scalars['Boolean'];
  createPurchaseRestriction: PurchaseRestriction;
  updatePurchaseRestriction: PurchaseRestriction;
  deletePurchaseRestriction: DeleteOneOutput;
  createHistory: History;
  createVenue: Venue;
  updateVenue: Venue;
  /** Update zones based on seatsChartKey. */
  updateVenueZones: Venue;
  deleteVenue: DeleteOneOutput;
  updateVenueCapacity: Scalars['Boolean'];
  updateDefaultSeatSelectionFilters: Scalars['Boolean'];
  reorderZones: Array<Zone>;
  createMembership: Membership;
  updateMembership: Membership;
  duplicateMembership: Scalars['String'];
  releaseAllMembershipHolds?: Maybe<Scalars['Boolean']>;
  updateExchangeableEvents?: Maybe<Scalars['Boolean']>;
  upsertMembershipTypeEventTransferPrices: Array<MembershipTypeEventTransferPrice>;
  createMembershipType: MembershipType;
  updateMembershipType: MembershipType;
  deleteMembershipType: DeleteOneOutput;
  createMembershipAddon: MembershipAddon;
  updateMembershipAddon: MembershipAddon;
  deleteMembershipAddon: DeleteOneOutput;
  createMembershipPromoCode: MembershipPromoCode;
  updateMembershipPromoCode: MembershipPromoCode;
  deleteMembershipPromoCode: DeleteOneOutput;
  createMembershipMultiBuyPromotion: MembershipMultiBuyPromotion;
  updateMembershipMultiBuyPromotion: MembershipMultiBuyPromotion;
  deleteMembershipMultiBuyPromotion: DeleteOneOutput;
  createOrUpdateMembershipAutoRenewal: MembershipAutoRenewal;
  deleteMembershipAutoRenewalOrders: Scalars['Boolean'];
  createScout: Scout;
  updateScout: Scout;
  updateScoutUsers: Scalars['Boolean'];
  deleteScoutUsers: Scalars['Boolean'];
  createScoutCommunication: ScoutCommunication;
  updateScoutCommunication: ScoutCommunication;
  createTestEmail: Scalars['Boolean'];
  updateScoutCommunicationUser: ScoutCommunicationUser;
  addReminderToScoutCommunicationUser: Scalars['Boolean'];
  clearReminderFromScoutCommunicationUser: Scalars['Boolean'];
  assignScoutCommunicationUsersToAgent: Scalars['Boolean'];
  createTag: Tag;
  updateTag: Tag;
  tagEntities: Array<Scalars['String']>;
  deleteTag: Scalars['Boolean'];
  updateTicketHolder: Ticket;
  releaseClaimsForNextMembership: Array<Ticket>;
  listTicketForResale: Scalars['Boolean'];
  unlistTicketForResale: Scalars['Boolean'];
  ticketTransferRetryRefund: Scalars['Boolean'];
  requestTicketTransfer: Scalars['Boolean'];
  cancelPendingTicketTransfer: Scalars['Boolean'];
  sendTicket: Scalars['Boolean'];
  scanTicket: ScanTicketOutput;
  redeemTicket: ScanTicketOutput;
  scanVaccinePass: Scalars['Boolean'];
  scanTicketBulk: Array<ScanTicketOutput>;
  importDigitalPassCodesForEvent: Scalars['Boolean'];
  importDigitalPassCodesForMembership: Scalars['Boolean'];
  createPinPaymentCharge: PinPaymentChargeResponse;
  verifyPinPayment3DS: PinPaymentChargeResponse;
  handleInstagramCode: Scalars['String'];
  createPoint: Point;
  updatePoint: Point;
  createPointItem: PointItem;
  updatePointItem: PointItem;
  addAuditLog: Scalars['Boolean'];
  addUnsubscribeReason: User;
  resubscribe: User;
  unsubscribeFromMarketing: User;
  unsubscribe: MarketingPreferenceUnsubscribeOutput;
  addUnsubscribeReasonV2: Scalars['Boolean'];
  resubscribeV2: Scalars['Boolean'];
  sendScannerEmail: ScannerEmailOutput;
  emailCustomization: EmailCustomizationOutput;
  emailCustomizationUpsert: EmailCustomizationOutput;
  emailCustomizationSendTest: Scalars['Boolean'];
  emailCustomizationEnable: EmailCustomizationOutput;
  /** Copies the templates from another event or membership */
  copyEmail: Scalars['Boolean'];
  emailCustomizationPublish: EmailCustomizationOutput;
  emailCustomizationUnpublish: EmailCustomizationOutput;
  addExhibitor: ExpoExhibitor;
  updateExhibitor: ExpoExhibitor;
  deleteExhibitor: Scalars['Boolean'];
  invalidateExhibitorCredentials: ExpoExhibitor;
  importExhibitors: ImportExhibitorOutput;
  exhibitorLogin: ExhibitorLoginOutputUnion;
  resendExhibitorLoginEmail: ResendExhibitorLoginEmailOutputUnion;
  exhibitorLogout: Scalars['Boolean'];
  enableSafeMode: Scalars['Boolean'];
  nameExhibitorSession: ExpoExhibitorSessionProfileOutput;
  expoCreateOrUpdateNamingField: ExpoNamingField;
  expoDeleteNamingField: Scalars['Boolean'];
  createOrUpdateAttendee: ExpoAttendee;
  bulkCreateOrUpdateAttendee: Scalars['Boolean'];
  deleteAttendee: Scalars['Boolean'];
  sendDownloadAttendeesEmail: Scalars['Boolean'];
  createAutomation: Automation;
  updateAutomation: Automation;
  anonymize: AnonymizationOutput;
  createReferralCampaign: ReferralCampaign;
  updateReferralCampaign: ReferralCampaign;
  createReferralRewards: Array<ReferralReward>;
  setPromoterSettings: PromoterSettingsOutput;
  createOrUpdateShopifySettings: ShopifySettings;
  finalisePrechargeOrder: Order;
  initialiseSetupIntentForPrechargeOrder: InitialiseSetupIntentOutput;
  cancelPrechargeOrder: Scalars['Boolean'];
  extendOrderExpiry: Scalars['Boolean'];
  processPreauthOrder: Scalars['Boolean'];
  createSetupIntentForCardUpdate: CardUpdateSetupIntentOutput;
  saveNewSetupIntentForCardUpdate: Scalars['Boolean'];
  createCompetition: Competition;
  updateCompetition: Competition;
  unpublishCompetition: Competition;
  deleteCompetition: Scalars['Boolean'];
  updateAndPublishCompetition: Competition;
  grantCompetitionReward?: Maybe<CompetitionReward>;
  broadcastReportingLinkOpened: Scalars['Boolean'];
  broadcastReportingOrderCreated: Scalars['Boolean'];
  broadcastReportingSetAsSpamFromUser: Scalars['Boolean'];
  createRedirectUrl: RedirectUrl;
  addAccessCodesToMembership: Array<AccessCode>;
  deleteAccessCodesFromMembership: Scalars['Boolean'];
  disableAccessCodesForMembership: Scalars['Boolean'];
  enableAccessCodesForMembership: Scalars['Boolean'];
  updateMembershipAccessCode: AccessCode;
  createShortUrl: ShortUrl;
  testUrl?: Maybe<Scalars['String']>;
  joinWaitlist: Waitlist;
  updateTicketResaleConfig: Event;
  createResaleTicketType: TicketType;
  updateResaleTicketType: TicketType;
  deleteResaleTicketType: Scalars['Boolean'];
  hideResaleTicketTypeFromPublic: Scalars['Boolean'];
  unhideResaleTicketTypeFromPublic: Scalars['Boolean'];
  joinResaleWaitlist: ResaleWaitlistOutput;
  deleteBroadcast: DeleteOneOutput;
  sendBroadcast: Scalars['Boolean'];
  saveEmailBroadcastTags: Scalars['Boolean'];
  createSMSBroadcast: SmsBroadcastSaveOutput;
  updateSMSBroadcast: SmsBroadcastSaveOutput;
  deleteSMSBroadcast: DeleteOneOutput;
  emailDomainCreate: EmailDomainOutput;
  emailDomainDelete: Scalars['Boolean'];
  createReportSchedule: ReportSchedule;
  updateReportSchedule: ReportSchedule;
  deleteReportSchedule: Scalars['Boolean'];
  pauseReportSchedule: ReportSchedule;
  createTrackingCode: Scalars['Boolean'];
  deleteTrackingCode: Scalars['Boolean'];
  onTrackingCodeVisit: Scalars['Boolean'];
  createOrderToTrackingCodeAssociation: Scalars['Boolean'];
  signupFormCreate: SignupFormOutput;
  signupFormUpdate: SignupFormOutput;
  signupFormDelete: Scalars['Boolean'];
  signupFormSubmit: Scalars['Boolean'];
  createSegment: SegmentOutput;
  updateSegment: SegmentOutput;
};


export type MutationRegisterArgs = {
  input: RegisterInput;
};


export type MutationLinkedAccountLoginArgs = {
  input: LoginInput;
};


export type MutationLinkedAccountRegisterArgs = {
  input: LinkedAccountRegisterInput;
};


export type MutationInitiateLinkedAccountRegistrationArgs = {
  input: LoginInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationSocialAuthArgs = {
  input: SocialAuthInput;
};


export type MutationRequestMagicLinkArgs = {
  input: RequestMagicLinkInput;
};


export type MutationRequestDeleteAccountArgs = {
  input: RequestMagicLinkInput;
};


export type MutationVerifyMagicLinkArgs = {
  input: VerifyEmailInput;
};


export type MutationVerifyTokenArgs = {
  input: VerifyEmailInput;
};


export type MutationRequestResetPasswordArgs = {
  input: RequestResetPasswordInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationSetPasswordForNewUserArgs = {
  input: SetPasswordForNewUserInput;
};


export type MutationUpdatePasswordArgs = {
  input: UpdatePasswordInput;
};


export type MutationRemoveMultiFactorAuthenticationSecretArgs = {
  code: Scalars['String'];
};


export type MutationEnableTwoFactorAuthenticationArgs = {
  input: TwoFactorAuthenticationCodeInput;
};


export type MutationAuthenticateWithTwoFactorArgs = {
  input: TwoFactorAuthenticationCodeInput;
};


export type MutationVerifyManageTicketsLinkArgs = {
  email?: Maybe<Scalars['String']>;
  orderId: Scalars['String'];
};


export type MutationCreateUserArgs = {
  sendInvite: Scalars['Boolean'];
  input: CreateUserInput;
};


export type MutationCreatePosUserArgs = {
  input: CreatePosUserInput;
};


export type MutationCreateTemporaryPosUserArgs = {
  input: CreateTemporaryPosUserInput;
};


export type MutationUpdatePosUserArgs = {
  input: UpdatePosUserInput;
  id: Scalars['String'];
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
  id: Scalars['String'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['String'];
};


export type MutationUpdateProfileArgs = {
  input: UpdateProfileInput;
};


export type MutationSendUserInviteArgs = {
  id: Scalars['String'];
};


export type MutationImportAndInviteUsersArgs = {
  input: ImportInput;
};


export type MutationImportUsersArgs = {
  input: ImportInput;
};


export type MutationUserPaymentTerminalConnectArgs = {
  registrationCode: Scalars['String'];
};


export type MutationOptInMarketingArgs = {
  ticketSendId: Scalars['String'];
  optIn: Scalars['Boolean'];
};


export type MutationUpdateCreditsForUserArgs = {
  input: UpdateCreditsInput;
  userId: Scalars['String'];
};


export type MutationCreatePosArgs = {
  input: CreatePosInput;
};


export type MutationCreateOrUpdatePosReleaseArgs = {
  input: PosReleaseInput;
};


export type MutationSetPosReleasePaymentOptionsArgs = {
  input: SetPosPaymentOptionsInput;
  releaseId: Scalars['String'];
};


export type MutationPosAutoscanArgs = {
  orderId: Scalars['String'];
};


export type MutationPosTerminalConnectArgs = {
  registrationCode: Scalars['String'];
  posId: Scalars['String'];
};


export type MutationPosTerminalDisconnectArgs = {
  posId: Scalars['String'];
};


export type MutationPosTerminalIdentifyArgs = {
  posId: Scalars['String'];
};


export type MutationPosTerminalCancelArgs = {
  posId: Scalars['String'];
};


export type MutationPosTerminalConnectionTokenArgs = {
  loginCode: Scalars['String'];
};


export type MutationSyncEventToIntellitixArgs = {
  id: Scalars['String'];
};


export type MutationUpdateForecastArgs = {
  input: UpdateForecastInput;
  id: Scalars['String'];
};


export type MutationAddForecastScenarioArgs = {
  id: Scalars['String'];
};


export type MutationDeleteForecastScenarioArgs = {
  forecastId: Scalars['String'];
  id: Scalars['String'];
};


export type MutationCreateEventArgs = {
  input: CreateEventInput;
};


export type MutationUpdateEventArgs = {
  sendTicketViewableEmails?: Maybe<Scalars['Boolean']>;
  input: UpdateEventInput;
  id: Scalars['String'];
};


export type MutationDuplicateEventArgs = {
  id: Scalars['String'];
};


export type MutationAddGatesToZoneAndEventArgs = {
  input: AddGatesToZoneInput;
  eventId: Scalars['String'];
};


export type MutationToggleMultiScanningArgs = {
  multiScanningEnabled: Scalars['Boolean'];
  eventId: Scalars['String'];
};


export type MutationUpdateTicketEntryTimeEnforcementArgs = {
  gracePeriodMinutes: Scalars['Float'];
  enabled: Scalars['Boolean'];
  eventId: Scalars['String'];
};


export type MutationUpdateEventSeatSelectionDefaultsArgs = {
  filters?: Maybe<SeatSelectionFiltersInput>;
  id: Scalars['String'];
};


export type MutationSetTicketTypePricingTiersArgs = {
  input: SetPricingTiersInput;
  ticketTypeId: Scalars['String'];
};


export type MutationSetTicketTypePricingTierSoldOutArgs = {
  soldOut: Scalars['Boolean'];
  pricingTierId: Scalars['String'];
  ticketTypeId: Scalars['String'];
};


export type MutationCreateTicketTypeArgs = {
  input: CreateTicketTypeInput;
};


export type MutationUpdateTicketTypeArgs = {
  id: Scalars['String'];
  input: UpdateTicketTypeInput;
};


export type MutationDeleteTicketTypeArgs = {
  id: Scalars['String'];
};


export type MutationCreateReleaseArgs = {
  input: CreateReleaseInput;
};


export type MutationUpdateReleaseArgs = {
  input: UpdateReleaseInput;
  id: Scalars['String'];
};


export type MutationDeleteReleaseArgs = {
  id: Scalars['String'];
};


export type MutationHoldBestAvailableSeatsArgs = {
  input: HoldBestAvailableSeatsInput;
  id: Scalars['String'];
};


export type MutationValidateReleasePasswordOrReleaseArgs = {
  password: Scalars['String'];
  eventId: Scalars['String'];
};


export type MutationValidateReleasePasswordArgs = {
  password: Scalars['String'];
  id: Scalars['String'];
};


export type MutationImportReleasePasswordsArgs = {
  input: ImportInput;
  id: Scalars['String'];
};


export type MutationDuplicateSingleReleaseArgs = {
  input: DuplicateSingleReleaseInput;
};


export type MutationCreateEventPromoCodeArgs = {
  input: CreateEventPromoCodeInput;
};


export type MutationUpdateEventPromoCodeArgs = {
  input: UpdateEventPromoCodeInput;
  id: Scalars['String'];
};


export type MutationDeleteEventPromoCodeArgs = {
  id: Scalars['String'];
};


export type MutationCreateEventMultiBuyPromotionArgs = {
  input: CreateEventMultiBuyPromotionInput;
};


export type MutationUpdateEventMultiBuyPromotionArgs = {
  id: Scalars['String'];
  input: UpdateEventMultiBuyPromotionInput;
};


export type MutationDeleteEventMultiBuyPromotionArgs = {
  id: Scalars['String'];
};


export type MutationCreateEventAddonArgs = {
  input: CreateEventAddonInput;
};


export type MutationUpdateEventAddonArgs = {
  id: Scalars['String'];
  input: UpdateEventAddonInput;
};


export type MutationDeleteEventAddonArgs = {
  id: Scalars['String'];
};


export type MutationAddGatesToScannableGatesIdArgs = {
  input: AddGatesToEventAddonInput;
  eventId: Scalars['String'];
};


export type MutationCreateReleaseZoneArgs = {
  input: CreateReleaseZoneInput;
};


export type MutationUpdateReleaseZoneArgs = {
  input: UpdateReleaseZoneInput;
  id: Scalars['String'];
};


export type MutationDeleteReleaseZoneArgs = {
  id: Scalars['String'];
};


export type MutationReorderTicketTypesArgs = {
  input: ReorderTicketTypeInput;
};


export type MutationCreateOrUpdateAccessCodeReleaseArgs = {
  input: AccessCodeReleaseInput;
};


export type MutationDeleteAccessCodeArgs = {
  accessCode?: Maybe<Scalars['String']>;
  releaseId: Scalars['String'];
};


export type MutationUpdateAccessCodeArgs = {
  input: AccessCodeInput;
  releaseId: Scalars['String'];
};


export type MutationCreateOrUpdatePresaleArgs = {
  input: PresaleReleaseInput;
};


export type MutationDeletePresaleArgs = {
  releaseId: Scalars['String'];
};


export type MutationEnablePresaleArgs = {
  isEnabled: Scalars['Boolean'];
  releaseId: Scalars['String'];
};


export type MutationCreateOrUpdateNamingFieldArgs = {
  input: NamingFieldInput;
};


export type MutationDeleteNamingFieldArgs = {
  fieldId: Scalars['String'];
};


export type MutationToggleNamingFieldsArgs = {
  isActive: Scalars['Boolean'];
  eventId: Scalars['String'];
};


export type MutationToggleCanRenameArgs = {
  isEnabled: Scalars['Boolean'];
  eventId: Scalars['String'];
};


export type MutationResendUsherTicketArgs = {
  input: EmailUsherComplimentaryInput;
};


export type MutationCreateUsherTicketTypeArgs = {
  createTicketAndOrderInput: UsherComplimetaryCreateInput;
};


export type MutationUpdateUsherTicketTypeNameArgs = {
  name: Scalars['String'];
  id: Scalars['String'];
};


export type MutationDisableUsherTicketTypeArgs = {
  id: Scalars['String'];
};


export type MutationDeleteUsherTicketTypeArgs = {
  id: Scalars['String'];
};


export type MutationCreateSeasonArgs = {
  input: CreateSeasonInput;
};


export type MutationUpdateSeasonArgs = {
  input: UpdateSeasonInput;
  id: Scalars['String'];
};


export type MutationCompleteStripeSetupArgs = {
  id: Scalars['String'];
};


export type MutationCreateIntegrationArgs = {
  input: CreateIntegrationInput;
};


export type MutationUpdateIntegrationArgs = {
  input: UpdateIntegrationInput;
  id: Scalars['String'];
};


export type MutationDeleteIntegrationArgs = {
  id: Scalars['String'];
};


export type MutationRollIntegrationApiKeyArgs = {
  id: Scalars['String'];
};


export type MutationCompleteStripeOAuthSetupArgs = {
  code: Scalars['String'];
  state: Scalars['String'];
};


export type MutationSetXeroConfigurationArgs = {
  input: XeroConfigurationInput;
};


export type MutationEnableXeroIntegrationArgs = {
  input: XeroCallbackInput;
};


export type MutationCompleteShopifySetupArgs = {
  input: ShopifySetupInput;
};


export type MutationUpsertAdobeIntegrationArgs = {
  input: AdobeExperiencePlatformIntegrationInput;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};


export type MutationUpdateOrganizationByIdArgs = {
  input: UpdateOrganizationInput;
  id: Scalars['String'];
};


export type MutationUploadImageArgs = {
  file: ImportInput;
};


export type MutationUpdateCalendarHomepageCustomizationArgs = {
  input: UpdateCalendarHomepageCustomizationInput;
};


export type MutationSyncOrderToIntellitixArgs = {
  id: Scalars['String'];
};


export type MutationCreateOrderArgs = {
  input: CreateOrderInput;
};


export type MutationCreateCompOrderArgs = {
  input: CreateCompOrderInput;
};


export type MutationUpdateOrderArgs = {
  input: UpdateOrderInput;
  id: Scalars['String'];
};


export type MutationUpdateHoldOrderArgs = {
  input: UpdateHoldOrderInput;
  id: Scalars['String'];
};


export type MutationSplitHoldOrderArgs = {
  input: SplitOrderInput;
  id: Scalars['String'];
};


export type MutationReleaseSeatsArgs = {
  input: ReleaseSeatsInput;
};


export type MutationCreatePaymentArgs = {
  input: CreatePaymentInput;
  id: Scalars['String'];
};


export type MutationApplyPromoCodeToOrderArgs = {
  input: ApplyPromoCode;
  id: Scalars['String'];
};


export type MutationUpdateTicketCoverForOrderArgs = {
  input: UpdateOrderTicketCoverInput;
  id: Scalars['String'];
};


export type MutationRemovePromoCodeFromOrderArgs = {
  id: Scalars['String'];
};


export type MutationHoldCustomerOrderArgs = {
  id: Scalars['String'];
};


export type MutationUpdateOrderStatusArgs = {
  input: UpdateOrderStatusInput;
  id: Scalars['String'];
};


export type MutationCompletePreprintTicketOrderArgs = {
  input: LineItemsToCompleteInput;
  id: Scalars['String'];
};


export type MutationAddPosTransactionArgs = {
  input: AddPosTransactionInput;
  id: Scalars['String'];
};


export type MutationRemovePosTransactionArgs = {
  posTransactionId: Scalars['String'];
  id: Scalars['String'];
};


export type MutationFinishPosTransactionArgs = {
  autoScan?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type MutationSendOrderConfirmationArgs = {
  input: SendOrderConfirmationInput;
  id: Scalars['String'];
};


export type MutationSendInternalOrderReceiptArgs = {
  id: Scalars['String'];
};


export type MutationCancelOrderArgs = {
  id: Scalars['String'];
};


export type MutationCancelOrderPaymentPlanArgs = {
  orderId: Scalars['String'];
};


export type MutationExpireOrderArgs = {
  id: Scalars['String'];
};


export type MutationGenerateXeroInvoiceForOrderArgs = {
  orderId: Scalars['String'];
};


export type MutationSplitGroupOrderArgs = {
  input: SplitOrderInput;
  id: Scalars['String'];
};


export type MutationCreateBulkOrdersArgs = {
  input: ImportInput;
  createdById: Scalars['String'];
};


export type MutationCreateRefundArgs = {
  input: CreateRefundInput;
};


export type MutationAutomaticallyAttributeArgs = {
  input: AutomaticallyAttributeInput;
};


export type MutationCreateAttributableRefundArgs = {
  input: CreateAttributableRefundInput;
};


export type MutationCreatePurchaseRestrictionArgs = {
  input: CreatePurchaseRestrictionInput;
};


export type MutationUpdatePurchaseRestrictionArgs = {
  id: Scalars['String'];
  input: CreatePurchaseRestrictionInput;
};


export type MutationDeletePurchaseRestrictionArgs = {
  id: Scalars['String'];
};


export type MutationCreateHistoryArgs = {
  input: CreateHistoryInput;
};


export type MutationCreateVenueArgs = {
  input: CreateVenueInput;
};


export type MutationUpdateVenueArgs = {
  input: UpdateVenueInput;
  id: Scalars['String'];
};


export type MutationUpdateVenueZonesArgs = {
  id: Scalars['String'];
};


export type MutationDeleteVenueArgs = {
  id: Scalars['String'];
};


export type MutationUpdateVenueCapacityArgs = {
  capacity?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
};


export type MutationUpdateDefaultSeatSelectionFiltersArgs = {
  filters: SeatSelectionFiltersInput;
  id: Scalars['String'];
};


export type MutationReorderZonesArgs = {
  input: ReorderZoneInput;
};


export type MutationCreateMembershipArgs = {
  input: CreateMembershipInput;
};


export type MutationUpdateMembershipArgs = {
  input: UpdateMembershipInput;
  id: Scalars['String'];
};


export type MutationDuplicateMembershipArgs = {
  id: Scalars['String'];
};


export type MutationReleaseAllMembershipHoldsArgs = {
  id: Scalars['String'];
};


export type MutationUpdateExchangeableEventsArgs = {
  input: UpdateExchangeableEventsInput;
  membershipId: Scalars['String'];
};


export type MutationUpsertMembershipTypeEventTransferPricesArgs = {
  input: Array<UpdateMembershipTypeEventTransferPriceInput>;
  id: Scalars['String'];
};


export type MutationCreateMembershipTypeArgs = {
  input: CreateMembershipTypeInput;
};


export type MutationUpdateMembershipTypeArgs = {
  input: UpdateMembershipTypeInput;
  id: Scalars['String'];
};


export type MutationDeleteMembershipTypeArgs = {
  id: Scalars['String'];
};


export type MutationCreateMembershipAddonArgs = {
  input: CreateMembershipAddonInput;
};


export type MutationUpdateMembershipAddonArgs = {
  id: Scalars['String'];
  input: UpdateMembershipAddonInput;
};


export type MutationDeleteMembershipAddonArgs = {
  id: Scalars['String'];
};


export type MutationCreateMembershipPromoCodeArgs = {
  input: CreateMembershipPromoCodeInput;
};


export type MutationUpdateMembershipPromoCodeArgs = {
  input: UpdateMembershipPromoCodeInput;
  id: Scalars['String'];
};


export type MutationDeleteMembershipPromoCodeArgs = {
  id: Scalars['String'];
};


export type MutationCreateMembershipMultiBuyPromotionArgs = {
  input: CreateMembershipMultiBuyPromotionInput;
};


export type MutationUpdateMembershipMultiBuyPromotionArgs = {
  id: Scalars['String'];
  input: UpdateMembershipMultiBuyPromotionInput;
};


export type MutationDeleteMembershipMultiBuyPromotionArgs = {
  id: Scalars['String'];
};


export type MutationCreateOrUpdateMembershipAutoRenewalArgs = {
  input: MembershipAutoRenewalInput;
};


export type MutationDeleteMembershipAutoRenewalOrdersArgs = {
  membershipId: Scalars['String'];
};


export type MutationCreateScoutArgs = {
  input: CreateScoutInput;
};


export type MutationUpdateScoutArgs = {
  input: UpdateScoutInput;
  id: Scalars['String'];
};


export type MutationUpdateScoutUsersArgs = {
  id: Scalars['String'];
};


export type MutationDeleteScoutUsersArgs = {
  input: DeleteScoutUserInput;
};


export type MutationCreateScoutCommunicationArgs = {
  input: CreateScoutCommunicationInput;
};


export type MutationUpdateScoutCommunicationArgs = {
  input: UpdateScoutCommunicationInput;
  id: Scalars['String'];
};


export type MutationCreateTestEmailArgs = {
  input: CreateTestEmailInput;
};


export type MutationUpdateScoutCommunicationUserArgs = {
  input: UpdateScoutCommunicationUserInput;
  id: Scalars['String'];
};


export type MutationAddReminderToScoutCommunicationUserArgs = {
  input: AddReminderToScoutCommunicationUserInput;
  id: Scalars['String'];
};


export type MutationClearReminderFromScoutCommunicationUserArgs = {
  id: Scalars['String'];
};


export type MutationAssignScoutCommunicationUsersToAgentArgs = {
  input: AssignScoutCommunicationUsersToAgentInput;
};


export type MutationCreateTagArgs = {
  input: CreateTagInput;
};


export type MutationUpdateTagArgs = {
  input: UpdateTagInput;
  id: Scalars['String'];
};


export type MutationTagEntitiesArgs = {
  input: TagEntitiesInput;
};


export type MutationDeleteTagArgs = {
  entityId: Scalars['String'];
  tagId: Scalars['String'];
};


export type MutationUpdateTicketHolderArgs = {
  id: Scalars['String'];
  input: UpdateTicketHolderInput;
};


export type MutationReleaseClaimsForNextMembershipArgs = {
  ids: Scalars['String'];
};


export type MutationListTicketForResaleArgs = {
  ticketId: Scalars['String'];
};


export type MutationUnlistTicketForResaleArgs = {
  ticketId: Scalars['String'];
};


export type MutationTicketTransferRetryRefundArgs = {
  ticketTransferId: Scalars['String'];
};


export type MutationRequestTicketTransferArgs = {
  input: RequestTicketTransferInput;
};


export type MutationCancelPendingTicketTransferArgs = {
  ticketId: Scalars['String'];
};


export type MutationSendTicketArgs = {
  email: Scalars['String'];
  ticketIds: Array<Scalars['String']>;
};


export type MutationScanTicketArgs = {
  eventId: Scalars['String'];
  input: ScanTicketInput;
};


export type MutationRedeemTicketArgs = {
  input: RedeemTicketInput;
};


export type MutationScanVaccinePassArgs = {
  payload: Scalars['String'];
  ticketId: Scalars['String'];
};


export type MutationScanTicketBulkArgs = {
  input: ScanTicketBulkInput;
};


export type MutationImportDigitalPassCodesForEventArgs = {
  input: ImportInput;
  eventId: Scalars['String'];
};


export type MutationImportDigitalPassCodesForMembershipArgs = {
  input: ImportInput;
  membershipId: Scalars['String'];
};


export type MutationCreatePinPaymentChargeArgs = {
  input: CreatePinPaymentCharge;
};


export type MutationVerifyPinPayment3DsArgs = {
  input: VerifyPinPayment3Ds;
};


export type MutationHandleInstagramCodeArgs = {
  input: HandleInstagramCodeInput;
};


export type MutationCreatePointArgs = {
  input: CreatePointInput;
};


export type MutationUpdatePointArgs = {
  input: UpdatePointInput;
};


export type MutationCreatePointItemArgs = {
  input: CreatePointItemInput;
};


export type MutationUpdatePointItemArgs = {
  input: UpdatePointItemInput;
  id: Scalars['String'];
};


export type MutationAddAuditLogArgs = {
  input: AddAuditLogInput;
};


export type MutationAddUnsubscribeReasonArgs = {
  input: AddUnsubscribeReasonInput;
};


export type MutationResubscribeArgs = {
  userId: Scalars['String'];
};


export type MutationUnsubscribeFromMarketingArgs = {
  userId: Scalars['String'];
};


export type MutationUnsubscribeArgs = {
  sendId: Scalars['String'];
};


export type MutationAddUnsubscribeReasonV2Args = {
  input: AddUnsubscribeReasonV2Input;
};


export type MutationResubscribeV2Args = {
  sendId: Scalars['String'];
};


export type MutationSendScannerEmailArgs = {
  userId: Scalars['String'];
};


export type MutationEmailCustomizationArgs = {
  input: CreateEmailCustomizationInput;
};


export type MutationEmailCustomizationUpsertArgs = {
  id?: Maybe<Scalars['String']>;
  input: UpdateEmailCustomizationInput;
};


export type MutationEmailCustomizationSendTestArgs = {
  input: SendTestEmailInput;
};


export type MutationEmailCustomizationEnableArgs = {
  id: Scalars['String'];
};


export type MutationCopyEmailArgs = {
  input: CopyEmailInput;
};


export type MutationEmailCustomizationPublishArgs = {
  id: Scalars['String'];
};


export type MutationEmailCustomizationUnpublishArgs = {
  id: Scalars['String'];
};


export type MutationAddExhibitorArgs = {
  input: AddExhibitorInput;
};


export type MutationUpdateExhibitorArgs = {
  input: UpdateExhibitorInput;
};


export type MutationDeleteExhibitorArgs = {
  input: FindExhibitorInput;
};


export type MutationInvalidateExhibitorCredentialsArgs = {
  input: FindExhibitorInput;
};


export type MutationImportExhibitorsArgs = {
  input: ImportExhibitorInput;
};


export type MutationExhibitorLoginArgs = {
  input: ExpoExhibitorLoginInput;
};


export type MutationResendExhibitorLoginEmailArgs = {
  eventId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
};


export type MutationNameExhibitorSessionArgs = {
  name: Scalars['String'];
};


export type MutationExpoCreateOrUpdateNamingFieldArgs = {
  input: ExpoNamingFieldInput;
};


export type MutationExpoDeleteNamingFieldArgs = {
  id: Scalars['String'];
};


export type MutationCreateOrUpdateAttendeeArgs = {
  input: ExpoAttendeeInput;
};


export type MutationBulkCreateOrUpdateAttendeeArgs = {
  input: BulkExpoAttendeeInput;
};


export type MutationDeleteAttendeeArgs = {
  id: Scalars['String'];
};


export type MutationSendDownloadAttendeesEmailArgs = {
  email: Scalars['String'];
};


export type MutationCreateAutomationArgs = {
  input: CreateAutomationInput;
};


export type MutationUpdateAutomationArgs = {
  input: UpdateAutomationInput;
  id: Scalars['String'];
};


export type MutationAnonymizeArgs = {
  input: AnonymizationInput;
};


export type MutationCreateReferralCampaignArgs = {
  campaign: CreateReferralCampaignDto;
};


export type MutationUpdateReferralCampaignArgs = {
  campaign: UpdateReferralCampaignDto;
};


export type MutationCreateReferralRewardsArgs = {
  rewards: CreateReferralRewardsDto;
};


export type MutationSetPromoterSettingsArgs = {
  input: PromoterSettingsInput;
};


export type MutationCreateOrUpdateShopifySettingsArgs = {
  input: ShopifySettingsInput;
};


export type MutationFinalisePrechargeOrderArgs = {
  input: FinalisePrechargeOrderInput;
};


export type MutationInitialiseSetupIntentForPrechargeOrderArgs = {
  orderId: Scalars['String'];
};


export type MutationCancelPrechargeOrderArgs = {
  orderId: Scalars['String'];
};


export type MutationExtendOrderExpiryArgs = {
  orderId: Scalars['String'];
};


export type MutationProcessPreauthOrderArgs = {
  orderId: Scalars['String'];
};


export type MutationCreateSetupIntentForCardUpdateArgs = {
  orderId: Scalars['String'];
};


export type MutationSaveNewSetupIntentForCardUpdateArgs = {
  input: SaveNewSetupIntentForCardUpdateInput;
};


export type MutationCreateCompetitionArgs = {
  input: CreateCompetitionInput;
  eventId: Scalars['String'];
};


export type MutationUpdateCompetitionArgs = {
  input: CreateCompetitionInput;
  competitionId: Scalars['String'];
};


export type MutationUnpublishCompetitionArgs = {
  competitionId: Scalars['String'];
};


export type MutationDeleteCompetitionArgs = {
  competitionId: Scalars['String'];
};


export type MutationUpdateAndPublishCompetitionArgs = {
  input: PublishCompetitionInput;
  eventId: Scalars['String'];
};


export type MutationGrantCompetitionRewardArgs = {
  input: GrantCompetitionRewardInput;
};


export type MutationBroadcastReportingLinkOpenedArgs = {
  input: BroadcastReportingInputBase;
};


export type MutationBroadcastReportingOrderCreatedArgs = {
  input: BroadcastReportingOrderInput;
};


export type MutationBroadcastReportingSetAsSpamFromUserArgs = {
  input: BroadcastReportingInputBase;
};


export type MutationCreateRedirectUrlArgs = {
  input: CreateRedirectUrlInput;
};


export type MutationAddAccessCodesToMembershipArgs = {
  input: Array<AddAccessCodesToMembershipInput>;
  id: Scalars['String'];
};


export type MutationDeleteAccessCodesFromMembershipArgs = {
  input: BulkActionAccessCodesFromMembershipInput;
  id: Scalars['String'];
};


export type MutationDisableAccessCodesForMembershipArgs = {
  input: BulkActionAccessCodesFromMembershipInput;
  id: Scalars['String'];
};


export type MutationEnableAccessCodesForMembershipArgs = {
  input: BulkActionAccessCodesFromMembershipInput;
  id: Scalars['String'];
};


export type MutationUpdateMembershipAccessCodeArgs = {
  input: UpsertAccessCodeInput;
  membershipId: Scalars['String'];
  id: Scalars['String'];
};


export type MutationCreateShortUrlArgs = {
  url: Scalars['String'];
};


export type MutationTestUrlArgs = {
  url: Scalars['String'];
};


export type MutationJoinWaitlistArgs = {
  input: JoinWaitlistInput;
};


export type MutationUpdateTicketResaleConfigArgs = {
  input: UpdateResaleConfigInput;
};


export type MutationCreateResaleTicketTypeArgs = {
  input: CreateResaleTicketTypeInput;
};


export type MutationUpdateResaleTicketTypeArgs = {
  input: CreateResaleTicketTypeInput;
  resaleTicketTypeId: Scalars['String'];
};


export type MutationDeleteResaleTicketTypeArgs = {
  resaleTicketTypeId: Scalars['String'];
};


export type MutationHideResaleTicketTypeFromPublicArgs = {
  resaleTicketTypeId: Scalars['String'];
};


export type MutationUnhideResaleTicketTypeFromPublicArgs = {
  resaleTicketTypeId: Scalars['String'];
};


export type MutationJoinResaleWaitlistArgs = {
  input: ResaleWaitlistInput;
};


export type MutationDeleteBroadcastArgs = {
  id: Scalars['String'];
};


export type MutationSendBroadcastArgs = {
  input: SendBroadcastInput;
};


export type MutationSaveEmailBroadcastTagsArgs = {
  input: Array<BroadcastTags>;
  broadcastId: Scalars['String'];
};


export type MutationCreateSmsBroadcastArgs = {
  input: CreateSmsBroadcastInput;
};


export type MutationUpdateSmsBroadcastArgs = {
  input: UpdateSmsBroadcastInput;
};


export type MutationDeleteSmsBroadcastArgs = {
  id: Scalars['String'];
};


export type MutationEmailDomainCreateArgs = {
  input: CreateEmailDomainInput;
};


export type MutationEmailDomainDeleteArgs = {
  id: Scalars['String'];
};


export type MutationCreateReportScheduleArgs = {
  input: ReportScheduleInput;
};


export type MutationUpdateReportScheduleArgs = {
  input: ReportScheduleInput;
  reportScheduleId: Scalars['String'];
};


export type MutationDeleteReportScheduleArgs = {
  reportScheduleId: Scalars['String'];
};


export type MutationPauseReportScheduleArgs = {
  pause: Scalars['Boolean'];
  reportScheduleId: Scalars['String'];
};


export type MutationCreateTrackingCodeArgs = {
  input: TrackingCodeCreateInput;
};


export type MutationDeleteTrackingCodeArgs = {
  id: Scalars['String'];
};


export type MutationOnTrackingCodeVisitArgs = {
  input: TrackingCodeVisitInput;
};


export type MutationCreateOrderToTrackingCodeAssociationArgs = {
  input: TrackingCodeOrderInput;
};


export type MutationSignupFormCreateArgs = {
  input: CreateSignupFormInput;
};


export type MutationSignupFormUpdateArgs = {
  input: CreateSignupFormInput;
  id: Scalars['String'];
};


export type MutationSignupFormDeleteArgs = {
  id: Scalars['String'];
};


export type MutationSignupFormSubmitArgs = {
  input: SubmissionInput;
};


export type MutationCreateSegmentArgs = {
  input: SegmentInput;
};


export type MutationUpdateSegmentArgs = {
  input: SegmentInput;
  id: Scalars['String'];
};

export type MyEventsOrderByInput = {
  startDate?: Maybe<OrderByDirection>;
};

export type MyEventsWhereInput = {
  /** Event start date. */
  startDate?: Maybe<Scalars['DateTime']>;
  /** Event end date. */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Filter on tickets that are (not) related to a membership ticket. */
  hasParentTicket?: Maybe<Scalars['Boolean']>;
};

export type MyLoggedInOrganizationsOutput = {
  __typename?: 'MyLoggedInOrganizationsOutput';
  id: Scalars['String'];
  slug: Scalars['String'];
  logoUrl?: Maybe<Scalars['String']>;
  isLinked: Scalars['Boolean'];
};

export type NamingFieldInput = {
  id?: Maybe<Scalars['String']>;
  eventId: Scalars['String'];
  type: NamingFieldType;
  label: Scalars['String'];
  required: Scalars['Boolean'];
  allTickets: Scalars['Boolean'];
  specificTicketTypes: Array<AccessCodeTicketInput>;
  options?: Maybe<Array<Scalars['String']>>;
  orderKey: Scalars['Float'];
};

export type NamingFieldOutput = {
  __typename?: 'NamingFieldOutput';
  id: Scalars['String'];
  name: Scalars['String'];
  type: NamingFieldType;
  label: Scalars['String'];
  required: Scalars['Boolean'];
  allTickets: Scalars['Boolean'];
  specificTicketTypes: Array<PublicReleaseTicketOutput>;
  options?: Maybe<Array<Scalars['String']>>;
  orderKey: Scalars['Float'];
};

export enum NamingFieldType {
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  CompanyName = 'COMPANY_NAME',
  Gender = 'GENDER',
  BirthDate = 'BIRTH_DATE',
  PhoneNumber = 'PHONE_NUMBER',
  PostalCode = 'POSTAL_CODE',
  Email = 'EMAIL',
  UsableForEmailMarketing = 'USABLE_FOR_EMAIL_MARKETING',
  UsableForSmsMarketing = 'USABLE_FOR_SMS_MARKETING',
  CustomText = 'CUSTOM_TEXT',
  CustomSelect = 'CUSTOM_SELECT',
  CustomCheckbox = 'CUSTOM_CHECKBOX'
}

export enum NotificationType {
  Email = 'Email',
  Sms = 'SMS'
}

export type NumberStatistic = {
  __typename?: 'NumberStatistic';
  label: Scalars['String'];
  tooltip?: Maybe<StatisticTooltip>;
  value: Scalars['Float'];
};

export type OnsalePromoter = {
  __typename?: 'OnsalePromoter';
  onsalePromoterCompetition: OnsalePromoterCompetition;
  onsalePromoterOutsideCompetition: OnsalePromoterOutsideCompetition;
};

export type OnsalePromoterCompetition = {
  __typename?: 'OnsalePromoterCompetition';
  onsalePromoterRevenueViaReferral: PeReportStatistic;
  onsalePromoterOrdersViaReferral: PeReportStatistic;
  onsalePromoterNewCustomersReferred: PeReportStatistic;
  onsalePromoterReferrerEntriesAwarded: PeReportStatistic;
};

export type OnsalePromoterOutsideCompetition = {
  __typename?: 'OnsalePromoterOutsideCompetition';
  onsalePromoterOutsideRevenueViaReferral: PeReportStatistic;
  onsalePromoterOutsideOrdersViaReferral: PeReportStatistic;
  onsalePromoterOutsideNewCustomersReferred: PeReportStatistic;
  onsalePromoterOutsideReferrerPointsAwarded: PeReportStatistic;
  onsalePromoterOutsideDiscountValue: PeReportStatistic;
};

export type Order = {
  __typename?: 'Order';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  orderType: OrderType;
  orderOriginatedFrom?: Maybe<OrderOriginatedFrom>;
  orderNumber: Scalars['String'];
  currency: Scalars['String'];
  derivedStatus: DerivedOrderStatus;
  /** Indicates if the order has been handled on success (e.g. ticket creation). */
  isHandled: Scalars['Boolean'];
  /** Indicates if the order is a full comp order (all tickets are comps). */
  isComp: Scalars['Boolean'];
  /** Indicates if the order is a precharge hold order. */
  isPrechargeOrder: Scalars['Boolean'];
  /** Buyer details. */
  buyerInformation?: Maybe<BuyerInformation>;
  /** Billing address provided by the customer. */
  billingAddress?: Maybe<Address>;
  /** Shipping address provided by the customer. */
  shippingAddress?: Maybe<Address>;
  /** Whether the shipping address matches the billing address. */
  shippingAddressMatchesBillingAddress: Scalars['Boolean'];
  /** This is a snapshot value when an order is created, used to update usableForMarketing on user */
  usableForMarketing?: Maybe<Scalars['Boolean']>;
  membershipSubscriptionId?: Maybe<Scalars['String']>;
  /** The release associated with the order. Returns null if the order is not bound to a release. */
  release?: Maybe<Release>;
  /** The release password associated with the order. Returns null if the order is not bound to a release password. */
  releasePassword?: Maybe<ReleasePassword>;
  /** The access code associated with the order. Returns null if the order is not bound to an access code. */
  accessCode?: Maybe<AccessCode>;
  /** Indicated whether the order has been paid with a subscription. */
  paidWithSubscription: Scalars['Boolean'];
  /** Current status of the order. */
  status: OrderStatus;
  /** Channel associated with the order. */
  channel: OrderChannel;
  /** Last used payment gateway. */
  paymentGateway?: Maybe<PaymentProvider>;
  /** The status of the latest transaction status. */
  transactionStatus?: Maybe<OrderTransactionStatus>;
  orderTicketCover?: Maybe<OrderTicketCover>;
  /** Timestamp when order confirmation has been sent. */
  orderConfirmationSentAt?: Maybe<Scalars['DateTime']>;
  /** The ip address of the client that is associated with this order. */
  clientIp: Scalars['String'];
  /** Amount of credits used in the order */
  usedCredits?: Maybe<Scalars['Float']>;
  usedPoints: Scalars['Float'];
  /** Amount of credits detucted from the total for changing the seats */
  changingSeatsCredits?: Maybe<Scalars['Float']>;
  /** Fee for changing seats. */
  changingSeatsFee?: Maybe<Scalars['Float']>;
  bookingFeeType: FeeType;
  /** Booking fee (amount or percentage based on type). */
  bookingFee: Scalars['Float'];
  /** Calculated booking fee. */
  bookingFeeAmount: Scalars['Float'];
  /** Fee charged for ticket transfer. */
  transferFee?: Maybe<Scalars['Float']>;
  /** The delivery method chosen by the customer. */
  deliveryMethod?: Maybe<ShippingOption>;
  /** Delivery fee (based on delivery method). */
  deliveryFee?: Maybe<Scalars['Float']>;
  /** Transaction fee type. */
  transactionFeeType?: Maybe<FeeType>;
  /** Transaction fee. */
  transactionFee?: Maybe<Scalars['Float']>;
  /** Transaction fee type. */
  transactionFeeType2?: Maybe<FeeType>;
  /** Transaction fee. */
  transactionFee2?: Maybe<Scalars['Float']>;
  /** Calculated transaction fee. */
  transactionFeeAmount?: Maybe<Scalars['Float']>;
  /** Order total (including fees and taxes). */
  total: Scalars['Float'];
  /** Time after which the order will be automatically expired */
  expiryDate?: Maybe<Scalars['DateTime']>;
  /** Total amount of refunds. */
  refundedAmount: Scalars['Float'];
  /** If the order is created from order abandoned email. */
  isCreatedFromRecoveredCart: Scalars['Boolean'];
  taxRate?: Maybe<Scalars['Float']>;
  /** Tax calculation method. either inclusive or exclusive. */
  taxCalculationMethod?: Maybe<TaxCalculationMethod>;
  /** Tax rate: taxRate * total */
  totalTax: Scalars['Float'];
  /** Subtotal: total - taxAmount */
  subtotal: Scalars['Float'];
  amountDue: Scalars['Float'];
  /** Whether the hardcopy tickets have been printed for an order */
  hardCopyTicketsPrinted: Scalars['Boolean'];
  /** How the customer heard about the items they are purchasing */
  heardAboutUs?: Maybe<HeardAboutUsType>;
  /** Heard about us details when heardAboutUs is other */
  heardAboutUsDetails?: Maybe<Scalars['String']>;
  /** How the customer heard about the items they are purchasing */
  dietaryRequirements?: Maybe<Scalars['String']>;
  /** Used to link an order to the referrer user that refered the order creator */
  referralId?: Maybe<Scalars['String']>;
  /**
   * Used to link an order to the referral code that was used to create the order.
   * Currently only used for competitions but will eventually be used for all referrals.
   */
  referralCode?: Maybe<ReferralCode>;
  /** Xero invoice ID if Xero integration is configured and an invoice was created for this order */
  xeroInvoiceId?: Maybe<Scalars['String']>;
  /** Amount of referral discount applied to the order. Used when there is a flat amount applied to the order */
  referralDiscountAmount?: Maybe<Scalars['Float']>;
  compReason?: Maybe<Scalars['String']>;
  expiresInSeconds: Scalars['Float'];
  tax?: Maybe<OrderTax>;
  /**
   * Unused changing seat credits. When exchanging a more expensive ticket for a cheaper one, 
   *     the price difference can be used to cover the seat change fee. 
   *     This field represents the remaining amount after the exchange.
   */
  unusedChangingSeatsCredits: Scalars['Float'];
  customTaxRate?: Maybe<Scalars['Float']>;
  customTaxAmount?: Maybe<Scalars['Float']>;
  orderPlan?: Maybe<OrderPlan>;
  smsConfirmationAmount: Scalars['Float'];
  /** The event associated with the order. Returns null if the order is not bound to an event. */
  event?: Maybe<Event>;
  /** The payment provider which processed the last transaction. */
  gateway?: Maybe<PaymentIntegrationOutput>;
  /** The payment method used in the last transaction. E.g. credit card, Afterpay, etc. */
  stripePaymentMethod?: Maybe<StripePaymentMethod>;
  transactions: OrderTransactionConnection;
  posTransactions: PosTransactionConnection;
  /** List of the order's line items. */
  lineItems: LineItemConnection;
  /** The created tickets for the order. Only returns the membership tickets (including add-on tickets) for memberships. */
  tickets: Array<Ticket>;
  /** Order owner. Not all orders have users. */
  user?: Maybe<User>;
  /** Order is created by */
  createdBy?: Maybe<User>;
  /** The membership associated with the order. Returns null if the order is not bound to a membership. */
  membership?: Maybe<Membership>;
  /** The pointItem associated with the order. Returns null if the order is not bound to a pointItem. */
  pointItem?: Maybe<PointItem>;
  promoCode?: Maybe<PromoCodeUnion>;
  multiBuyPromotion?: Maybe<MultiBuyPromotionUnion>;
  history: HistoryConnection;
  refunds: Array<Refund>;
  /** Details about how the order can be refunded based on payment methods and how much has already been refunded */
  refundableState: RefundableState;
  pos?: Maybe<Pos>;
  point?: Maybe<Point>;
  defaultGateway?: Maybe<Integration>;
  stripeTerminalGatewayId?: Maybe<Scalars['String']>;
  stripeTerminalGatewayIds: Array<Scalars['String']>;
  useFallbackRefundFlow?: Maybe<Scalars['Boolean']>;
  prechargeOrderScheduledChargeDate?: Maybe<Scalars['DateTime']>;
  prechargeOrderFailedAt?: Maybe<Scalars['DateTime']>;
  prechargeOrderCancellation?: Maybe<PrechargeOrderCancellation>;
  stripeConfig?: Maybe<StripeConfigOutput>;
};


export type OrderTransactionsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<TransactionOrderByInput>;
};


export type OrderPosTransactionsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<PosTransactionOrderByInput>;
};


export type OrderLineItemsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type OrderHistoryArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<HistoryOrderByInput>;
};

export enum OrderByDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Order status */
export enum OrderChannel {
  Online = 'Online',
  BackOffice = 'BackOffice',
  Pos = 'POS'
}

export type OrderChargeSetting = {
  __typename?: 'OrderChargeSetting';
  percentage?: Maybe<Scalars['Float']>;
  pricingStrategy: PricingStrategy;
};

export type OrderComponent = {
  __typename?: 'OrderComponent';
  type: OrderComponentType;
  orderId: Scalars['String'];
  isFullyRefunded: Scalars['Boolean'];
  refundableAmount: Scalars['Float'];
  refundedAmount: Scalars['Float'];
  /** The amount paid for this component. This can be less than the total for payment plans. */
  paidAmount: Scalars['Float'];
  totalAmount: Scalars['Float'];
  ticketId?: Maybe<Scalars['String']>;
  ticket?: Maybe<Ticket>;
  lineItemId?: Maybe<Scalars['String']>;
  /** Only populated for custom tax and tax types. */
  customLabel?: Maybe<Scalars['String']>;
  /** The name of the user defined tax from the tax service */
  taxName?: Maybe<Scalars['String']>;
};

/** Different component types of the order. */
export enum OrderComponentType {
  FaceValue = 'FaceValue',
  StadiumLevyFee = 'StadiumLevyFee',
  TicketFee = 'TicketFee',
  CustomTax = 'CustomTax',
  TransactionFee = 'TransactionFee',
  SmsConfirmation = 'SmsConfirmation',
  BookingFee = 'BookingFee',
  DeliveryFee = 'DeliveryFee',
  TransferFee = 'TransferFee',
  TicketCover = 'TicketCover',
  PaymentPlanFee = 'PaymentPlanFee',
  OrganizationTax = 'OrganizationTax',
  Tax = 'Tax'
}

export type OrderConnection = {
  __typename?: 'OrderConnection';
  pageInfo: PageInfo;
  edges: Array<OrderEdge>;
  totalCount: Scalars['Int'];
};

export type OrderCreateOutput = {
  __typename?: 'OrderCreateOutput';
  jobId: Scalars['String'];
  order?: Maybe<Order>;
  createOrderError?: Maybe<Array<CreateOrderErrorUnion>>;
};

export type OrderEdge = {
  __typename?: 'OrderEdge';
  cursor: Scalars['String'];
  node: Order;
};

export type OrderFee = {
  __typename?: 'OrderFee';
  fees: Array<Fee>;
  items: Array<ItemFee>;
  gateways: Array<OrderFeeIntegration>;
  organizationExclusiveTaxRate: Scalars['Float'];
};

export type OrderFeeIntegration = {
  __typename?: 'OrderFeeIntegration';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** Integration type */
  type: IntegrationType;
  /** Integration name */
  name: Scalars['String'];
  /** External public key (can be used in customer frontend) */
  publicKey?: Maybe<Scalars['String']>;
  /** Webhook URL to point integration to */
  webhookUrl?: Maybe<Scalars['String']>;
  /** Transaction fee type. */
  transactionFeeType?: Maybe<FeeType>;
  /** Transaction fee. */
  transactionFee?: Maybe<Scalars['Float']>;
  /** Transaction fee type(only for stripe). Users can input both fixed and percentage fee for stripe(0.3$+2%). */
  transactionFeeType2?: Maybe<FeeType>;
  /** Transaction fee(only for stripe). Users can input both fixed and percentage fee for stripe(0.3$+2%). */
  transactionFee2?: Maybe<Scalars['Float']>;
  /** If payment gateways have different option types this field is used to specify which one to force */
  paymentMethodType?: Maybe<Scalars['String']>;
  facebookPageId?: Maybe<Scalars['String']>;
  facebookUserId?: Maybe<Scalars['String']>;
  bnplEnabled?: Maybe<Scalars['Boolean']>;
  /** Whether Express Checkout is enabled for this integration. If null, it is considered disabled. */
  expressCheckoutEnabled?: Maybe<Scalars['Boolean']>;
  bnplTransactionFeePercent?: Maybe<Scalars['Float']>;
  /** Number of days after transaction when refunds are allowed for Afterpay */
  daysAfterCanRefund?: Maybe<Scalars['Int']>;
  stripeConnectAccount?: Maybe<StripeConnectAccount>;
  /** Internal API key (should not be shared) */
  secretKey?: Maybe<Scalars['String']>;
  /** External secret key (should not be shared) */
  apiKey?: Maybe<Scalars['String']>;
  /** External secret key for Windcave PxPost. */
  wcPxPostSecretKey?: Maybe<Scalars['String']>;
  /** External public key for Windcave PxPost. */
  wcPxPostPublicKey?: Maybe<Scalars['String']>;
  isDefault: Scalars['Boolean'];
};

export type OrderIdsOnlineOutput = {
  __typename?: 'OrderIdsOnlineOutput';
  orderId: Scalars['String'];
};

export type OrderList = {
  __typename?: 'OrderList';
  title: Scalars['String'];
  totalOrders: Scalars['Float'];
  items: Array<BreakdownItem>;
};

export type OrderOrderByInput = {
  createdAt?: Maybe<OrderByDirection>;
  updatedAt?: Maybe<OrderByDirection>;
};

/** Where the order initiated from */
export enum OrderOriginatedFrom {
  ExpressCheckout = 'ExpressCheckout',
  LegacyCheckout = 'LegacyCheckout',
  StandardCheckout = 'StandardCheckout',
  PreAuthCheckout = 'PreAuthCheckout'
}

export type OrderPlan = {
  __typename?: 'OrderPlan';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  orderId: Scalars['String'];
  schedule: ScheduleOption;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  status: OrderPlanStatus;
  payments: Array<OrderPlanPayment>;
  billingDetails?: Maybe<BillingDetails>;
  allowEarlyAccess?: Maybe<Scalars['Boolean']>;
};

export type OrderPlanPayment = {
  __typename?: 'OrderPlanPayment';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  amountDue: Scalars['Float'];
  dueAt: Scalars['DateTime'];
  paidAt?: Maybe<Scalars['DateTime']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
  status: OrderPlanPaymentStatus;
  stripeInvoiceUrl?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  attemptCount?: Maybe<Scalars['Float']>;
  failureReason?: Maybe<Scalars['String']>;
};

export enum OrderPlanPaymentStatus {
  Upcoming = 'upcoming',
  Paid = 'paid',
  Refunded = 'refunded',
  PartiallyRefunded = 'partiallyRefunded',
  Cancelled = 'cancelled'
}

export enum OrderPlanStatus {
  Pending = 'pending',
  Active = 'active',
  Overdue = 'overdue',
  Cancelled = 'cancelled',
  Completed = 'completed',
  Refunded = 'refunded',
  Stopped = 'stopped'
}

export type OrderPrechargeSummaryOutput = {
  __typename?: 'OrderPrechargeSummaryOutput';
  card: StripeSetupIntentCardOutput;
  numTickets: Scalars['Float'];
};

export type OrderRefundData = {
  __typename?: 'OrderRefundData';
  orderId: Scalars['String'];
  /** The amount that can be automatically refunded */
  gatewayRefundableAmount?: Maybe<GatewayRefundableAmount>;
  ticketRefundData: Array<TicketRefundData>;
  orderLevelComponents: Array<OrderComponent>;
};

export type OrderRefundDetailsOutput = {
  __typename?: 'OrderRefundDetailsOutput';
  orderId: Scalars['String'];
  baseTickets: Scalars['Float'];
  ticketFees: Scalars['Float'];
  bookingFees: Scalars['Float'];
  transactionFees: Scalars['Float'];
  deliveryFees: Scalars['Float'];
  refundedAmount: Scalars['Float'];
  addons: Scalars['Float'];
  creditsUsed: Scalars['Float'];
};

/** The refund state for an order based on how it was paid for and previous refunds. */
export enum OrderRefundState {
  FullGateway = 'FULL_GATEWAY',
  PartialGateway = 'PARTIAL_GATEWAY',
  ManualOnly = 'MANUAL_ONLY',
  FullyRefunded = 'FULLY_REFUNDED',
  None = 'NONE'
}

/** Order status */
export enum OrderStatus {
  Pending = 'Pending',
  Hold = 'Hold',
  Paid = 'Paid',
  PartPaid = 'PartPaid',
  Completed = 'Completed',
  Canceled = 'Canceled',
  Expired = 'Expired'
}

export type OrderTax = {
  __typename?: 'OrderTax';
  totalInclusive: Scalars['Float'];
  totalExclusive: Scalars['Float'];
  tax: Array<TaxApplied>;
};

export type OrderTicketCover = {
  __typename?: 'OrderTicketCover';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  purchasedAt?: Maybe<Scalars['DateTime']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  promoterFeeAmount: Scalars['Float'];
  platformFeeAmount: Scalars['Float'];
  totalFeeAmount?: Maybe<Scalars['Float']>;
  ticketTicketCovers?: Maybe<Array<TicketTicketCover>>;
  /** Order that the ticket cover is purchased for */
  order: Order;
  retryCount: Scalars['Float'];
  /** Ticket cover purchase behaviour */
  purchaseBehaviour?: Maybe<TicketCoverPurchaseBehaviour>;
};

/** A transaction represents an exchange of money as part of an order. */
export type OrderTransaction = {
  __typename?: 'OrderTransaction';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  kind: OrderTransactionKind;
  status: OrderTransactionStatus;
  amount: Scalars['Float'];
  /** Payment method used with Stripe. Null if not a Stripe transaction. */
  stripePaymentMethod?: Maybe<StripePaymentMethod>;
  /** The amount of the transaction that is held for Flicket at the point of sale as a platform commission. */
  platformAdjustment: Scalars['Float'];
};

export type OrderTransactionConnection = {
  __typename?: 'OrderTransactionConnection';
  pageInfo: PageInfo;
  edges: Array<OrderTransactionEdge>;
  totalCount: Scalars['Int'];
};

export type OrderTransactionEdge = {
  __typename?: 'OrderTransactionEdge';
  cursor: Scalars['String'];
  node: OrderTransaction;
};

/** The different kinds of order transactions. */
export enum OrderTransactionKind {
  Sale = 'Sale',
  Refund = 'Refund'
}

/** Payment statuses */
export enum OrderTransactionStatus {
  Waiting = 'Waiting',
  Pending = 'Pending',
  Error = 'Error',
  Failure = 'Failure',
  Success = 'Success',
  Unknown = 'Unknown',
  Cancelled = 'Cancelled'
}

/** Order type */
export enum OrderType {
  Default = 'DEFAULT',
  RenewMemberships = 'RENEW_MEMBERSHIPS',
  ChangeSeats = 'CHANGE_SEATS',
  RenameTickets = 'RENAME_TICKETS',
  TicketTransfer = 'TICKET_TRANSFER',
  MembershipTicketTransfer = 'MEMBERSHIP_TICKET_TRANSFER',
  ResaleTicketTransfer = 'RESALE_TICKET_TRANSFER',
  PointPurchase = 'POINT_PURCHASE',
  PaymentPlan = 'PAYMENT_PLAN',
  Usher = 'USHER'
}

export type OrderWhereInput = {
  source?: Maybe<PointReportingFilterSource>;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  gateway?: Maybe<PaymentProvider>;
  createdById?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  dates?: Maybe<Array<Scalars['DateTime']>>;
  status?: Maybe<Array<OrderStatus>>;
  /** refund tab */
  refund?: Maybe<Scalars['Boolean']>;
  releaseId?: Maybe<Scalars['String']>;
  release?: Maybe<Scalars['String']>;
  /** Fuzzy search query. */
  q?: Maybe<Scalars['String']>;
  paymentPlans?: Maybe<Scalars['String']>;
  orderPlanStatus?: Maybe<Scalars['String']>;
};

export type Organization = {
  __typename?: 'Organization';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** Organization name. */
  name: Scalars['String'];
  /** Organization slug. */
  slug: Scalars['String'];
  /** Contact e-mail address. */
  email: Scalars['String'];
  /** Contact phone. */
  phone: Scalars['String'];
  /** Tax number */
  taxNumber?: Maybe<Scalars['String']>;
  /** Currency */
  currency?: Maybe<Scalars['String']>;
  /** Address details. */
  address?: Maybe<Address>;
  /** Landing page settings. */
  landingPage: LandingPage;
  /** Show memberships in client navigation. */
  showMemberships: Scalars['Boolean'];
  /** Show memberships renewal banner. */
  showMembershipRenewal?: Maybe<Scalars['Boolean']>;
  /** The support information of the organistion */
  supportInfo?: Maybe<Scalars['String']>;
  /** The privacy policy of the organistion */
  privacyPolicy?: Maybe<Scalars['String']>;
  /** The terms and conditions of the organistion */
  termsAndConditions?: Maybe<Scalars['String']>;
  /** Marketing settings. */
  marketing?: Maybe<Marketing>;
  /** Branding settings. */
  branding: BrandingOutputBase;
  /** Shipping labels. */
  shippingLabels?: Maybe<ShippingLabels>;
  /** Beta features. */
  features?: Maybe<Array<Scalars['String']>>;
  timezone: Scalars['String'];
  locale: Scalars['String'];
  helpLink?: Maybe<Scalars['String']>;
  ticketCoverPlatformFeePercentage?: Maybe<Scalars['Float']>;
  taxRate: Scalars['Float'];
  /** Tax calculation method. either inclusive or exclusive. */
  taxCalculationMethod: TaxCalculationMethod;
  /** Used for UK customer, opt in marketing when is true */
  defaultOptInMarketing?: Maybe<Scalars['Boolean']>;
  /** Determines whether the cookie banner is enabled for this organization */
  cookieConsent: Scalars['Boolean'];
  defaultLanguage: Scalars['String'];
  customTaxRate?: Maybe<Scalars['Float']>;
  customTaxName?: Maybe<Scalars['String']>;
  platformChargeSettings?: Maybe<PlatformChargeSettings>;
  /** The i18n overrides for this organization. */
  i18n?: Maybe<Scalars['JSON']>;
  isTest: Scalars['Boolean'];
  /** Settings for the Tours landing page. */
  landingTours?: Maybe<LandingToursSettings>;
  /** Override for the domain, e.g. flicket.io */
  flicketDomainOverride?: Maybe<Scalars['String']>;
  point: Point;
  calendarHomepageCustomization?: Maybe<CalendarHomepageCustomization>;
};

export type OrganizationConnection = {
  __typename?: 'OrganizationConnection';
  pageInfo: PageInfo;
  edges: Array<OrganizationEdge>;
  totalCount: Scalars['Int'];
};

export type OrganizationEdge = {
  __typename?: 'OrganizationEdge';
  cursor: Scalars['String'];
  node: Organization;
};

export type OrganizationFeatures = {
  __typename?: 'OrganizationFeatures';
  features: Array<Feature>;
};

export type OrganizationOrderByInput = {
  createdAt?: Maybe<OrderByDirection>;
  updatedAt?: Maybe<OrderByDirection>;
};

export type OrganizationOutputBranding = {
  __typename?: 'OrganizationOutputBranding';
  /** Organization logo. */
  logo?: Maybe<ExtendedFile>;
  /** Organization mobile logo. */
  mobileLogo?: Maybe<ExtendedFile>;
  /** Organization favicon. */
  favicon?: Maybe<ExtendedFile>;
  /** Organization background image. */
  background?: Maybe<ExtendedFile>;
  /** Organization full background image. */
  fullBackground?: Maybe<ExtendedFile>;
  /** Primary color. */
  primaryColor: Scalars['String'];
  /** Secondary color. */
  secondaryColor: Scalars['String'];
  /** Grey scale option. */
  greyScale?: Maybe<GreyScale>;
  P300: Scalars['String'];
  P200: Scalars['String'];
  P100: Scalars['String'];
  S300: Scalars['String'];
  S200: Scalars['String'];
  S100: Scalars['String'];
  N800: Scalars['String'];
  N700: Scalars['String'];
  N600: Scalars['String'];
  N500: Scalars['String'];
  N400: Scalars['String'];
  N300: Scalars['String'];
  N200: Scalars['String'];
  N100: Scalars['String'];
};

export type OrganizationStats = {
  __typename?: 'OrganizationStats';
  emailBroadcastLastUsedAt?: Maybe<Scalars['DateTime']>;
  emailBroadcastLastSentAt?: Maybe<Scalars['DateTime']>;
  smsBroadcastLastUsedAt?: Maybe<Scalars['DateTime']>;
  smsBroadcastLastSentAt?: Maybe<Scalars['DateTime']>;
  leadFormsLastReceivedAt?: Maybe<Scalars['DateTime']>;
  shopifyLastUsedAt?: Maybe<Scalars['DateTime']>;
  trackingCodeLastUsedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationWhereInput = {
  /** Fuzzy search query. */
  q?: Maybe<Scalars['String']>;
};

export type OverallLayoutOutput = {
  __typename?: 'OverallLayoutOutput';
  defaultDateRange: DateRange;
};

export type PackageArgs = {
  __typename?: 'PackageArgs';
  kind: BroadcastMarketingFiltersV2Kind;
  exclude: Scalars['Boolean'];
  packageIds: Array<Scalars['String']>;
};

export type PackageInformation = {
  __typename?: 'PackageInformation';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type PackageLayoutOutput = {
  __typename?: 'PackageLayoutOutput';
  defaultDateRange: DateRange;
  pointItem?: Maybe<PackageInformation>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  startCursor?: Maybe<Scalars['String']>;
  endCursor?: Maybe<Scalars['String']>;
};

/** Facebook page. */
export type PageListsOutput = {
  __typename?: 'PageListsOutput';
  id: Scalars['String'];
  name: Scalars['String'];
  access_token: Scalars['String'];
};

/** Address details. */
export type PartialAddress = {
  __typename?: 'PartialAddress';
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  suburb?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
};

/** Address details. */
export type PartialAddressInput = {
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  suburb?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
};

export type PartPaidTicketStats = {
  __typename?: 'PartPaidTicketStats';
  orderId: Scalars['String'];
  ticketCount: Scalars['Float'];
  eventId?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
};

export type PaymentError = {
  __typename?: 'PaymentError';
  code?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** Represents the order creation result. */
export type PaymentIntegrationOutput = {
  __typename?: 'PaymentIntegrationOutput';
  id?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Integration type */
  type?: Maybe<IntegrationType>;
  /** Integration name */
  name?: Maybe<Scalars['String']>;
  /** External public key (can be used in customer frontend) */
  publicKey?: Maybe<Scalars['String']>;
  /** Webhook URL to point integration to */
  webhookUrl?: Maybe<Scalars['String']>;
  /** Transaction fee type. */
  transactionFeeType?: Maybe<FeeType>;
  /** Transaction fee. */
  transactionFee?: Maybe<Scalars['Float']>;
  /** Transaction fee type(only for stripe). Users can input both fixed and percentage fee for stripe(0.3$+2%). */
  transactionFeeType2?: Maybe<FeeType>;
  /** Transaction fee(only for stripe). Users can input both fixed and percentage fee for stripe(0.3$+2%). */
  transactionFee2?: Maybe<Scalars['Float']>;
  /** If payment gateways have different option types this field is used to specify which one to force */
  paymentMethodType?: Maybe<Scalars['String']>;
  facebookPageId?: Maybe<Scalars['String']>;
  facebookUserId?: Maybe<Scalars['String']>;
  bnplEnabled?: Maybe<Scalars['Boolean']>;
  /** Whether Express Checkout is enabled for this integration. If null, it is considered disabled. */
  expressCheckoutEnabled?: Maybe<Scalars['Boolean']>;
  bnplTransactionFeePercent?: Maybe<Scalars['Float']>;
  /** Number of days after transaction when refunds are allowed for Afterpay */
  daysAfterCanRefund?: Maybe<Scalars['Int']>;
  stripeConnectAccount?: Maybe<StripeConnectAccount>;
};

export type PaymentOption = {
  __typename?: 'PaymentOption';
  id: Scalars['String'];
  value: Scalars['String'];
  label: Scalars['String'];
  type: IntegrationType;
  paymentMethod?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Float']>;
  transactionFee?: Maybe<Scalars['Float']>;
  transactionFeeType?: Maybe<FeeType>;
  transactionFee2?: Maybe<Scalars['Float']>;
  transactionFeeType2?: Maybe<FeeType>;
  bnplEnabled?: Maybe<Scalars['Boolean']>;
  calculatedTransactionFee?: Maybe<Scalars['Float']>;
  paymentPlanMetadata?: Maybe<PaymentPlanMetadata>;
};

export type PaymentOptions = {
  __typename?: 'PaymentOptions';
  orderId: Scalars['String'];
  options?: Maybe<Array<PaymentOption>>;
};

export type PaymentPlanMetadata = {
  __typename?: 'PaymentPlanMetadata';
  depositAmount?: Maybe<Scalars['Float']>;
  installmentAmount?: Maybe<Scalars['Float']>;
  installmentCount: Scalars['Float'];
  paymentPlanFeePercentage: Scalars['Float'];
};

export type PaymentPlanSettings = {
  __typename?: 'PaymentPlanSettings';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  disabledAt?: Maybe<Scalars['String']>;
  scheduleOptions?: Maybe<Array<ScheduleOption>>;
  gracePeriodDays: Scalars['Float'];
};

/** Payment providers and methods */
export enum PaymentProvider {
  Stripe = 'Stripe',
  StripeAfterpay = 'StripeAfterpay',
  Laybuy = 'Laybuy',
  Afterpay = 'Afterpay',
  Windcave = 'Windcave',
  MpAiSa = 'MPAiSA',
  Pin = 'Pin',
  Credits = 'Credits',
  Points = 'Points',
  Pos = 'Pos',
  Cash = 'Cash',
  Eftpos = 'Eftpos',
  CreditCard = 'CreditCard',
  Invoice = 'Invoice',
  Other = 'Other'
}

export type PaymentResult = PaymentSuccess | PaymentError;

export type PaymentSuccess = {
  __typename?: 'PaymentSuccess';
  /** The payment gateway. */
  gateway: PaymentProvider;
  /** The payment url provided by the payment gateway. */
  redirectTo?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
};

export type PercentageStatistic = {
  __typename?: 'PercentageStatistic';
  label: Scalars['String'];
  tooltip?: Maybe<StatisticTooltip>;
  value: Scalars['Float'];
  percentage: Scalars['Float'];
};

/** Data to supply the audience page of the post event (PE) report */
export type PeReportAudienceOutput = {
  __typename?: 'PEReportAudienceOutput';
  insights: Array<PeReportStatistic>;
  trafficChannels: Array<PercentageStatistic>;
};

/** Data to supply the overview page of the post event (PE) report */
export type PeReportDemographicsOutput = {
  __typename?: 'PEReportDemographicsOutput';
  ticketsSold?: Maybe<Array<PercentageStatistic>>;
  audienceViews?: Maybe<Array<PercentageStatistic>>;
  gender?: Maybe<GenderBreakDownOutput>;
  age?: Maybe<AgeBreakDownOutput>;
};

export type PeReportEvent = {
  __typename?: 'PEReportEvent';
  title?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  location?: Maybe<Scalars['String']>;
};

/** Data to supply the overview page of the post event (PE) report */
export type PeReportOverviewOutput = {
  __typename?: 'PEReportOverviewOutput';
  event: PeReportEvent;
  financialSales: Array<FinancialSales>;
  statistics: Array<PeReportStatistic>;
  ticketSalesStatistics: Array<PeReportStatistic>;
  salesBreakdown: SalesBreakdown;
};

/** Data to supply the main sale referral page of the post event (PE) report */
export type PeReportReferralOutsideMainSaleOutput = {
  __typename?: 'PEReportReferralOutsideMainSaleOutput';
  promoter: Array<PeReportStatistic>;
  actionEngagement?: Maybe<Array<ActionEngagementRecordOutput>>;
};

/** Data to supply the post event (PE) report for competition stats */
export type PeReportRegistrationCompetitionOutput = {
  __typename?: 'PEReportRegistrationCompetitionOutput';
  overview: Array<PeReportStatistic>;
  promoter: Array<PeReportStatistic>;
  actionEngagement?: Maybe<Array<ActionEngagementRecordOutput>>;
  hasCompetition: Scalars['Boolean'];
};

/** Data to supply the overview page of the post event (PE) report */
export type PeReportRegistrationOutput = {
  __typename?: 'PEReportRegistrationOutput';
  overview: Array<PeReportStatistic>;
  promoter: Array<PeReportStatistic>;
  actionEngagement?: Maybe<Array<ActionEngagementRecordOutput>>;
};

export type PeReportStatistic = NumberStatistic | StringStatistic | MoneyStatistic | PercentageStatistic;

/** Data to supply the overview page of the post event (PE) report */
export type PeReportWaitlistOutput = {
  __typename?: 'PEReportWaitlistOutput';
  statistics: Array<PeReportStatistic>;
};

export enum PeriodFilter {
  Day = 'day',
  Week = 'week',
  Hour = 'hour',
  Month = 'month'
}

export type PeriodFilterDefaults = {
  __typename?: 'PeriodFilterDefaults';
  default: PeriodFilter;
  options: Array<FilterOption>;
};

/** Permission for a specific action */
export enum Permission {
  AccountCreate = 'ACCOUNT_CREATE',
  AccountRead = 'ACCOUNT_READ',
  AccountUpdate = 'ACCOUNT_UPDATE',
  AccountDelete = 'ACCOUNT_DELETE',
  CustomerCreate = 'CUSTOMER_CREATE',
  CustomerRead = 'CUSTOMER_READ',
  CustomerUpdate = 'CUSTOMER_UPDATE',
  CustomerDelete = 'CUSTOMER_DELETE',
  CustomerCredits = 'CUSTOMER_CREDITS',
  CustomerImport = 'CUSTOMER_IMPORT',
  CustomerExport = 'CUSTOMER_EXPORT',
  EventCreate = 'EVENT_CREATE',
  EventRead = 'EVENT_READ',
  EventUpdate = 'EVENT_UPDATE',
  EventDelete = 'EVENT_DELETE',
  MembershipCreate = 'MEMBERSHIP_CREATE',
  MembershipRead = 'MEMBERSHIP_READ',
  MembershipUpdate = 'MEMBERSHIP_UPDATE',
  MembershipDelete = 'MEMBERSHIP_DELETE',
  OrderCreate = 'ORDER_CREATE',
  OrderRead = 'ORDER_READ',
  OrderUpdate = 'ORDER_UPDATE',
  OrderDelete = 'ORDER_DELETE',
  OrderCancel = 'ORDER_CANCEL',
  OrderComp = 'ORDER_COMP',
  OrderRefund = 'ORDER_REFUND',
  OrderExport = 'ORDER_EXPORT',
  AbandonedCartsExport = 'ABANDONED_CARTS_EXPORT',
  OrganizationCreate = 'ORGANIZATION_CREATE',
  OrganizationDelete = 'ORGANIZATION_DELETE',
  OrganizationSettings = 'ORGANIZATION_SETTINGS',
  OrganizationBranding = 'ORGANIZATION_BRANDING',
  OrganizationIntegrations = 'ORGANIZATION_INTEGRATIONS',
  OrganizationVenues = 'ORGANIZATION_VENUES',
  OrganizationLegal = 'ORGANIZATION_LEGAL',
  ReportingRead = 'REPORTING_READ',
  ReportingTabSales = 'REPORTING_TAB_SALES',
  ReportingTabInsights = 'REPORTING_TAB_INSIGHTS',
  ReportingTabPromotions = 'REPORTING_TAB_PROMOTIONS',
  ReportingTabEvents = 'REPORTING_TAB_EVENTS',
  ReportingSales = 'REPORTING_SALES',
  ReportingFinancial = 'REPORTING_FINANCIAL',
  ReportingScans = 'REPORTING_SCANS',
  ReportingPos = 'REPORTING_POS',
  ReportingPostevent = 'REPORTING_POSTEVENT',
  ReportingCapacity = 'REPORTING_CAPACITY',
  ReportingFaceValue = 'REPORTING_FACE_VALUE',
  ReportingAggregateFinancial = 'REPORTING_AGGREGATE_FINANCIAL',
  ReportingGatewayCount = 'REPORTING_GATEWAY_COUNT',
  ReportingSalesReport = 'REPORTING_SALES_REPORT',
  ReportingFinancialGraph = 'REPORTING_FINANCIAL_GRAPH',
  ReportingExportTopTags = 'REPORTING_EXPORT_TOP_TAGS',
  SeasonCreate = 'SEASON_CREATE',
  SeasonRead = 'SEASON_READ',
  SeasonUpdate = 'SEASON_UPDATE',
  SeasonDelete = 'SEASON_DELETE',
  TicketRead = 'TICKET_READ',
  TicketPrint = 'TICKET_PRINT',
  TicketRelease = 'TICKET_RELEASE',
  TicketImport = 'TICKET_IMPORT',
  TicketExport = 'TICKET_EXPORT',
  PosRead = 'POS_READ',
  PosCreate = 'POS_CREATE',
  PosOperatorCreate = 'POS_OPERATOR_CREATE',
  ScoutRead = 'SCOUT_READ',
  ScoutDelete = 'SCOUT_DELETE',
  SocialRead = 'SOCIAL_READ',
  SocialCreate = 'SOCIAL_CREATE',
  WaitlistRead = 'WAITLIST_READ',
  WaitlistExport = 'WAITLIST_EXPORT',
  AutomationCreate = 'AUTOMATION_CREATE',
  AutomationRead = 'AUTOMATION_READ',
  AutomationUpdate = 'AUTOMATION_UPDATE',
  PointsRead = 'POINTS_READ',
  PointsUpdate = 'POINTS_UPDATE',
  PointsCreate = 'POINTS_CREATE',
  BroadcastCreate = 'BROADCAST_CREATE',
  BroadcastRead = 'BROADCAST_READ',
  CompetitionEntriesRead = 'COMPETITION_ENTRIES_READ',
  TrackingCodesExport = 'TRACKING_CODES_EXPORT',
  ScansExport = 'SCANS_EXPORT',
  ScannerAccess = 'SCANNER_ACCESS',
  TransactionExport = 'TRANSACTION_EXPORT',
  ReportingIaOverview = 'REPORTING_IA_OVERVIEW',
  ReportingIaReports = 'REPORTING_IA_REPORTS',
  ReportingIaSales = 'REPORTING_IA_SALES',
  ReportingIaFinancial = 'REPORTING_IA_FINANCIAL',
  ReportingIaScans = 'REPORTING_IA_SCANS',
  ReportingIaCapacity = 'REPORTING_IA_CAPACITY',
  ReportingIaAudience = 'REPORTING_IA_AUDIENCE',
  ReportingIaMarketing = 'REPORTING_IA_MARKETING',
  ReportingIaCodes = 'REPORTING_IA_CODES',
  ReportingIaPos = 'REPORTING_IA_POS',
  ReportingIaScheduled = 'REPORTING_IA_SCHEDULED',
  ReportingIaPresale = 'REPORTING_IA_PRESALE',
  SourceSwitcherEvent = 'SOURCE_SWITCHER_EVENT',
  SourceSwitcherMembership = 'SOURCE_SWITCHER_MEMBERSHIP',
  SourceSwitcherSeasons = 'SOURCE_SWITCHER_SEASONS',
  SourceSwitcherOverall = 'SOURCE_SWITCHER_OVERALL',
  SourceSwitcherPackages = 'SOURCE_SWITCHER_PACKAGES',
  SignupFormsCreate = 'SIGNUP_FORMS_CREATE',
  EmailDomainsCreate = 'EMAIL_DOMAINS_CREATE',
  DashboardRead = 'DASHBOARD_READ'
}

export type PinPaymentChargeResponse = {
  __typename?: 'PinPaymentChargeResponse';
  redirectUrl: Scalars['String'];
};

export type PinPaymentContext = {
  __typename?: 'PinPaymentContext';
  amount?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  redirectUrl?: Maybe<Scalars['String']>;
  publicKey?: Maybe<Scalars['String']>;
  isSandbox: Scalars['Boolean'];
  orderId?: Maybe<Scalars['String']>;
};

export type PlatformChargeSettings = {
  __typename?: 'PlatformChargeSettings';
  orderChargeSettings?: Maybe<Array<OrderChargeSetting>>;
};

export type Point = {
  __typename?: 'Point';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  organization: Organization;
  name: Scalars['String'];
  termsAndConditions?: Maybe<Scalars['String']>;
  isEnabled: Scalars['Boolean'];
  pointItems: Array<PointItem>;
  gateways: Array<Integration>;
  stripeConfig?: Maybe<StripeConfigOutput>;
};

export type PointItem = {
  __typename?: 'PointItem';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  organization: Organization;
  point: Point;
  name: Scalars['String'];
  price: Scalars['Float'];
  amount: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<ExtendedFile>;
  banner?: Maybe<ExtendedFile>;
  backgroundImage?: Maybe<ExtendedFile>;
  descriptionImage?: Maybe<ExtendedFile>;
  isVisible: Scalars['Boolean'];
  displayOrder: Scalars['Int'];
  ticketFeeType: FeeType;
  ticketFee: Scalars['Float'];
  fees: OrderFee;
};

export enum PointReportingFilterSource {
  Overall = 'OVERALL',
  Membership = 'MEMBERSHIP',
  Event = 'EVENT',
  Package = 'PACKAGE'
}

/** Represents a POS terminal. */
export type Pos = {
  __typename?: 'Pos';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** Friendly name of the POS terminal. */
  name: Scalars['String'];
  /** Booking fee type. */
  bookingFeeType: FeeType;
  /** Booking fee. */
  bookingFee: Scalars['Float'];
  /** Available payment option incl. fees. */
  paymentOptions: PosPaymentOptions;
  /** Available delivery options for the POS terminal. */
  deliveryOptions: Array<ShippingOption>;
  /** The beginning float of change for the POS terminal. */
  cashAmount?: Maybe<Scalars['Float']>;
  /** Whether receipts are turned on. */
  enableReceipts: Scalars['Boolean'];
  /** Auto print tickets if a printer is connected. */
  autoPrintTickets: Scalars['Boolean'];
  sessions?: Maybe<Array<PosSession>>;
  isConnectedToTerminal: Scalars['Boolean'];
  stripeTerminalLoginCode?: Maybe<Scalars['String']>;
  canConnectToTerminal: Scalars['Boolean'];
  event: Event;
  release: Release;
  users: Array<PosUser>;
};

export type PosFinancialData = {
  __typename?: 'PosFinancialData';
  grossSales: PeReportStatistic;
  eftpos: PeReportStatistic;
  cash: PeReportStatistic;
  creditCard: PeReportStatistic;
};

export type PosFloatData = {
  __typename?: 'PosFloatData';
  startFloat: PeReportStatistic;
  cashReceived: PeReportStatistic;
  cashReturned: PeReportStatistic;
  endFloat: PeReportStatistic;
};

export type PosPaymentFee = {
  __typename?: 'PosPaymentFee';
  /** Fee type. */
  feeType: FeeType;
  /** Fee amount */
  feeAmount: Scalars['Float'];
};

export type PosPaymentFeeInput = {
  /** Fee type. */
  feeType: FeeType;
  /** Fee amount */
  feeAmount: Scalars['Float'];
};

/** Represents POS options incl. fees. */
export type PosPaymentOptions = {
  __typename?: 'PosPaymentOptions';
  /** Cash fee (normally $0). */
  cash?: Maybe<PosPaymentFee>;
  /** Eftpos fee. */
  eftpos?: Maybe<PosPaymentFee>;
  /** Credit card fee. */
  cc?: Maybe<PosPaymentFee>;
  /** MPAiSA fee. */
  MPAiSA?: Maybe<PosPaymentFee>;
};

export type PosPaymentOptionsInput = {
  /** Cash fee (normally $0). */
  cash?: Maybe<PosPaymentFeeInput>;
  /** Eftpos fee. */
  eftpos?: Maybe<PosPaymentFeeInput>;
  /** Credit card fee. */
  cc?: Maybe<PosPaymentFeeInput>;
  /** MPAiSA fee. */
  MPAiSA?: Maybe<PosPaymentFeeInput>;
};

export type PosReleaseInput = {
  releaseId?: Maybe<Scalars['String']>;
  eventId: Scalars['String'];
  tickets: Array<PosTicketDto>;
  posPaymentOptions?: Maybe<PosPaymentOptionsInput>;
  bookingFeeType?: Maybe<FeeType>;
  bookingFee?: Maybe<Scalars['Float']>;
};

export type PosSaleOverview = {
  __typename?: 'PosSaleOverview';
  ticketSoldAtDoor: PeReportStatistic;
  posOrders: PeReportStatistic;
  averageOrderSize: PeReportStatistic;
  ticketPerHour: PeReportStatistic;
};

export type PosSalesOverviewOutput = {
  __typename?: 'PosSalesOverviewOutput';
  soldAtTheDoor: Scalars['Float'];
  orders: Scalars['Float'];
  soldOnline: Scalars['Float'];
  scannedPercentage: Scalars['Float'];
  average: Scalars['Float'];
  perHour: Scalars['Float'];
};

export type PosSession = {
  __typename?: 'PosSession';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  pos: Pos;
  operator?: Maybe<User>;
  startedAt: Scalars['DateTime'];
  endedAt?: Maybe<Scalars['DateTime']>;
  startCash?: Maybe<Scalars['Float']>;
  endCash?: Maybe<Scalars['Float']>;
};

export type PosTerminalConnectionOutput = {
  __typename?: 'PosTerminalConnectionOutput';
  connectionToken: Scalars['String'];
  organizationId: Scalars['String'];
  eventTitle: Scalars['String'];
  eventId: Scalars['String'];
  posReleaseId: Scalars['String'];
  posId: Scalars['String'];
  posName: Scalars['String'];
  posEmail: Scalars['String'];
  timezone: Scalars['String'];
  locale: Scalars['String'];
  currency: Scalars['String'];
  transactionFeeType: FeeType;
  transactionFeeAmount: Scalars['Float'];
  bookingFeeType: FeeType;
  bookingFee: Scalars['Float'];
};

export type PosTicketDto = {
  id: Scalars['String'];
  /** The type of ticket */
  type: TicketTypeKind;
  isActive: Scalars['Boolean'];
  price: Scalars['Float'];
};

export type PostmarkEmailStatsOverviewOutput = {
  __typename?: 'PostmarkEmailStatsOverviewOutput';
  sent: Scalars['Float'];
  bounced: Scalars['Float'];
  smtpApiErrors: Scalars['Float'];
  bounceRate: Scalars['Float'];
  spamComplaints: Scalars['Float'];
  spamComplaintsRate: Scalars['Float'];
  opens: Scalars['Float'];
  uniqueOpens: Scalars['Float'];
  tracked: Scalars['Float'];
  withLinkTracking: Scalars['Float'];
  withOpenTracking: Scalars['Float'];
  totalTrackedLinksSent: Scalars['Float'];
  uniqueLinksClicked: Scalars['Float'];
  totalClicks: Scalars['Float'];
  withClientRecorded: Scalars['Float'];
  withPlatformRecorded: Scalars['Float'];
  withReadTimeRecorded: Scalars['Float'];
};

export type PosTransaction = {
  __typename?: 'PosTransaction';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  order: Order;
  /** Used payment gateway. */
  paymentGateway: PaymentProvider;
  amount: Scalars['Float'];
  fee: Scalars['Float'];
  /** Return amount (only relevant for cash). */
  returned: Scalars['Float'];
  status: OrderTransactionStatus;
};

export type PosTransactionConnection = {
  __typename?: 'PosTransactionConnection';
  pageInfo: PageInfo;
  edges: Array<PosTransactionEdge>;
  totalCount: Scalars['Int'];
};

export type PosTransactionEdge = {
  __typename?: 'PosTransactionEdge';
  cursor: Scalars['String'];
  node: PosTransaction;
};

export type PosTransactionOrderByInput = {
  createdAt?: Maybe<OrderByDirection>;
};

export type PosUser = {
  __typename?: 'PosUser';
  id: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  fullName: Scalars['String'];
};

export type PreAuthActivityArgs = {
  __typename?: 'PreAuthActivityArgs';
  kind: BroadcastMarketingFiltersV2Kind;
  exclude: Scalars['Boolean'];
  eventIds: Array<Scalars['String']>;
};

export type PrechargeOrderCancellation = {
  __typename?: 'PrechargeOrderCancellation';
  /** When the precharge order was cancelled */
  cancelledAt: Scalars['DateTime'];
  /** The name of the user who cancelled the precharge order */
  cancelledByName?: Maybe<Scalars['String']>;
  /** Whether the user who cancelled the precharge order is an admin */
  cancelledByAdmin: Scalars['Boolean'];
  cancellationSource?: Maybe<SetupIntentCancellationSource>;
};

export enum PrePurchaseAvailableStatus {
  Available = 'AVAILABLE',
  UnavailableNoStripeEvent = 'UNAVAILABLE_NO_STRIPE_EVENT',
  UnavailableNoStripeOrg = 'UNAVAILABLE_NO_STRIPE_ORG',
  UnavailableMultipleStripeEvent = 'UNAVAILABLE_MULTIPLE_STRIPE_EVENT'
}

export type PresaleConversionOutput = {
  __typename?: 'PresaleConversionOutput';
  conversionSteps: Array<BreakdownItem>;
  completedPresaleOrders: OrderList;
  completedOrderList?: Maybe<OrderList>;
  preAuthorizedOrderList?: Maybe<OrderList>;
};

export type PresaleDateRangeInput = {
  eventId?: Maybe<Scalars['String']>;
  releaseId?: Maybe<Scalars['String']>;
};

/** Create or update a presale. */
export type PresaleReleaseInput = {
  releaseId?: Maybe<Scalars['String']>;
  eventId: Scalars['String'];
  name: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate?: Maybe<Scalars['DateTime']>;
  tickets: Array<AccessCodeTicketInput>;
  accessCodes: Array<AccessCodeInput>;
  accessScreenMessage?: Maybe<Scalars['String']>;
  accessScreenImage?: Maybe<Scalars['Upload']>;
  linkToWaitlist?: Maybe<Scalars['Boolean']>;
  allowPrePurchase?: Maybe<Scalars['Boolean']>;
};

/** Portable representation of presale release. */
export type PresaleReleaseOutput = {
  __typename?: 'PresaleReleaseOutput';
  releaseId: Scalars['String'];
  name: Scalars['String'];
  /** The presale URL slug */
  slug: Scalars['String'];
  isActive: Scalars['Boolean'];
  isEnabled: Scalars['Boolean'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  status?: Maybe<PresaleStatus>;
  /** The tickets that can be purchased with this presale */
  tickets: Array<PresaleTicketOutput>;
  /** The access codes that can be used with this presale */
  accessCodes: Array<AccessCodeOutput>;
  accessScreenMessage?: Maybe<Scalars['String']>;
  /** Image to be shown on the customer portal of the ticket . Returns null if the not set. */
  accessScreenImage?: Maybe<ExtendedFile>;
  linkToWaitlist?: Maybe<Scalars['Boolean']>;
  allowPrePurchase?: Maybe<Scalars['Boolean']>;
  hasPrechargeOrder: Scalars['Boolean'];
  startDateChangeInfo?: Maybe<PresaleStartDateChangeInfo>;
};

export type PresaleStartDateChangeInfo = {
  __typename?: 'PresaleStartDateChangeInfo';
  hasChanged: Scalars['Boolean'];
  latestActiveStartDateHistory: StartDateHistory;
};

export enum PresaleStatus {
  Scheduled = 'SCHEDULED',
  PendingScheduled = 'PENDING_SCHEDULED',
  Completed = 'COMPLETED',
  Disabled = 'DISABLED',
  OnSale = 'ON_SALE',
  PendingOnSale = 'PENDING_ON_SALE'
}

/** Presale ticket output */
export type PresaleTicketOutput = {
  __typename?: 'PresaleTicketOutput';
  /** The ticket id */
  id: Scalars['String'];
  /** The type of ticket */
  type: TicketTypeKind;
};

export enum PricingStrategy {
  LineItemsExcComp = 'LINE_ITEMS_EXC_COMP',
  LineItemsComp = 'LINE_ITEMS_COMP',
  OrderFee = 'ORDER_FEE',
  PaymentPlanFee = 'PAYMENT_PLAN_FEE',
  TicketCover = 'TICKET_COVER',
  OrderSmsConfirmation = 'ORDER_SMS_CONFIRMATION'
}

export type PricingTierInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  quantity: Scalars['Float'];
  soldOut: Scalars['Boolean'];
};

export type PricingTierOutput = {
  __typename?: 'PricingTierOutput';
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  quantity: Scalars['Float'];
  soldOut: Scalars['Boolean'];
  totalSold?: Maybe<Scalars['Int']>;
  revenueProcessed?: Maybe<Scalars['Float']>;
  isDeletable: Scalars['Boolean'];
};

/** The code of the problem that caused an issue. */
export enum ProblemCode {
  TicketNotFound = 'TICKET_NOT_FOUND',
  Gate = 'GATE',
  OutsideEntryTime = 'OUTSIDE_ENTRY_TIME'
}

export type ProductUpsellInput = {
  selectedProducts: Array<SelectedProductInput>;
  customizedUpsell: Scalars['Boolean'];
};

export type PromoCodeUnion = EventPromoCode | MembershipPromoCode;

export type PromoterOnsaleOutput = {
  __typename?: 'PromoterOnsaleOutput';
  revenue: Scalars['Float'];
  newCustomers: Scalars['Float'];
  referralEntriesAwarded: Scalars['Float'];
  orders: Scalars['Float'];
};

export type PromoterRegistrationOutput = {
  __typename?: 'PromoterRegistrationOutput';
  newCustomers: Scalars['Float'];
  referralEntriesAwarded: Scalars['Float'];
  registrationsViaReferral: Scalars['Float'];
};

export type PromoterSettingsInput = {
  eventId: Scalars['String'];
  config?: Maybe<Array<PromoterShareActionInput>>;
  socialPages?: Maybe<Array<EventSocialPageInput>>;
  rewardSettings?: Maybe<RewardSettingsDto>;
};

export type PromoterSettingsOutput = {
  __typename?: 'PromoterSettingsOutput';
  configurations?: Maybe<Array<PromoterShareAction>>;
  socialPages?: Maybe<Array<EventSocialPage>>;
  /** The referral campaign associated with this event */
  referralCampaign?: Maybe<ReferralCampaign>;
};


export type PromoterSettingsOutputReferralCampaignArgs = {
  eventId: Scalars['String'];
};

export type PromoterShareAction = {
  __typename?: 'PromoterShareAction';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  platform: Scalars['String'];
  actionType: Scalars['String'];
  socialLinkType?: Maybe<Scalars['String']>;
};

export type PromoterShareActionInput = {
  platform: Scalars['String'];
  actionType: Scalars['String'];
};

/** Listed release ticket (ticketType or addon). */
export type PublicReleaseTicketOutput = {
  __typename?: 'PublicReleaseTicketOutput';
  /** The ticket id */
  id: Scalars['String'];
  /** The type of ticket */
  type: TicketTypeKind;
  /** The ticket name */
  name: Scalars['String'];
  /** The ticket zone name */
  zoneName?: Maybe<Scalars['String']>;
  /** The ticket quantity */
  quantity?: Maybe<Scalars['Float']>;
  /** The ticket price */
  price?: Maybe<Scalars['Float']>;
  /** The ticket pricing tiers. Note: If `null`, the query or mutation didn't populate this field. */
  pricingTiers?: Maybe<Array<PublicReleaseTicketPricingTierOutput>>;
  /** If ticket is hidden by the release */
  isHidden: Scalars['Boolean'];
};

/** Listed release ticket (ticketType) pricing tier. */
export type PublicReleaseTicketPricingTierOutput = {
  __typename?: 'PublicReleaseTicketPricingTierOutput';
  /** The tier name */
  name?: Maybe<Scalars['String']>;
  /** The tier price */
  price: Scalars['Float'];
};

export type PublishCompetitionInput = {
  competitionType: CompetitionType;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  termsAndConditions?: Maybe<Scalars['String']>;
  referralRewardValue?: Maybe<Scalars['Int']>;
  bannerImage?: Maybe<Scalars['Upload']>;
  prizes?: Maybe<Array<CompetitionPrizeInput>>;
  promoter?: Maybe<Array<CompetitionPromoterInput>>;
  competitionId?: Maybe<Scalars['String']>;
};

export type PurchasedTicketActivityArgs = {
  __typename?: 'PurchasedTicketActivityArgs';
  kind: BroadcastMarketingFiltersV2Kind;
  exclude: Scalars['Boolean'];
  eventIds: Array<Scalars['String']>;
};

export type PurchaseFrequencyArgs = {
  __typename?: 'PurchaseFrequencyArgs';
  kind: BroadcastMarketingFiltersV2Kind;
  /** Exclude isn't supported for this filter. */
  exclude: Scalars['Boolean'];
  /** Minimum number of purchases (inclusive). If omitted, no minimum purchases condition is applied. */
  minimumPurchases?: Maybe<Scalars['Float']>;
  /** Maximum number of purchases (inclusive). If omitted, no maximum purchases condition is applied. */
  maximumPurchases?: Maybe<Scalars['Float']>;
  purchaseType: PurchaseFrequencyFilterPurchaseType;
  interval?: Maybe<PurchaseFrequencyFilterInterval>;
  range?: Maybe<PurchaseFrequencyFilterRange>;
};

export type PurchaseFrequencyFilterInterval = {
  __typename?: 'PurchaseFrequencyFilterInterval';
  before: Scalars['Boolean'];
  number: Scalars['Float'];
  unit: PurchaseFrequencyFilterIntervalUnit;
};

/** Unit of time for purchase frequency interval filtering. */
export enum PurchaseFrequencyFilterIntervalUnit {
  Days = 'Days',
  Months = 'Months',
  Years = 'Years'
}

/** Purchase type that can be filtered on. */
export enum PurchaseFrequencyFilterPurchaseType {
  Event = 'Event',
  Membership = 'Membership',
  Package = 'Package'
}

export type PurchaseFrequencyFilterRange = {
  __typename?: 'PurchaseFrequencyFilterRange';
  /**
   * Range start date. The date will be parsed in the organization's time zone, and
   * will include the whole day. Any time and/or time zone will be ignored.
   */
  startDate?: Maybe<Scalars['String']>;
  /**
   * Range end date. The date will be parsed in the organization's time zone, and
   * will include the whole day. Any time and/or time zone will be ignored.
   */
  endDate?: Maybe<Scalars['String']>;
};

export type PurchaseHistoryArgs = {
  __typename?: 'PurchaseHistoryArgs';
  kind: BroadcastMarketingFiltersV2Kind;
  exclude: Scalars['Boolean'];
  eventIds: Array<Scalars['String']>;
};

export type PurchaseRestriction = {
  __typename?: 'PurchaseRestriction';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  restrictedType: LineItemType;
  restrictedId: Scalars['ID'];
  quantity: Scalars['Int'];
  requiredEntities: Array<PurchaseRestrictionRequiredEntity>;
  isExclusive: Scalars['Boolean'];
  isAlwaysVisible: Scalars['Boolean'];
};

export type PurchaseRestrictionInput = {
  restrictedType: LineItemType;
  restrictedId: Scalars['ID'];
  quantity: Scalars['Int'];
  requiredEntities: Array<PurchaseRestrictionRequiredEntityInput>;
  isExclusive?: Maybe<Scalars['Boolean']>;
  isAlwaysVisible?: Maybe<Scalars['Boolean']>;
};

export type PurchaseRestrictionRequiredEntity = {
  __typename?: 'PurchaseRestrictionRequiredEntity';
  requiredType: LineItemType;
  requiredId: Scalars['ID'];
};

export type PurchaseRestrictionRequiredEntityInput = {
  requiredType: LineItemType;
  requiredId: Scalars['ID'];
};

export type Query = {
  __typename?: 'Query';
  isLoggedIn: Scalars['Boolean'];
  me: User;
  myLoggedInOrganizations?: Maybe<Array<MyLoggedInOrganizationsOutput>>;
  /** Fetches users (paginated). */
  users: UserConnection;
  /** Fetches users updated between given date range. Dates supplied in organizations timezone. */
  usersUpdatedBetween: Array<User>;
  /** Fetches a user. */
  user: User;
  /** Fetches a users referral ID. */
  findUserReferralId: User;
  posUsers: Array<User>;
  accountsList: UserConnection;
  linkedAccountUser: LinkedAccountUser;
  poses: Array<Pos>;
  pos: Pos;
  getPosReleasePaymentOptions?: Maybe<ReleasePosPaymentOptions>;
  posTerminalLatestTransactionStatus: TerminalLatestTransactionStatus;
  posSessions: Array<PosSession>;
  events: EventConnection;
  event: Event;
  eventsById: Array<Event>;
  getEventAndReleaseForCustomer: EventsWithAccessControlOutput;
  getEventForCompetitionReporting: EventForCompetitionReportingEntity;
  myEvents: Array<Event>;
  eventForecast: EventForecastOutput;
  hasSeatedEvent: Scalars['Boolean'];
  ticketTypes: Array<TicketType>;
  ticketTypesById: Array<TicketType>;
  releases: Array<Release>;
  getReleasesForPrivateLinks: Array<Release>;
  release: Release;
  getReleaseBySlug?: Maybe<Release>;
  getPublicReleaseTickets?: Maybe<Array<PublicReleaseTicketOutput>>;
  eventPromoCodes: Array<EventPromoCode>;
  eventMultiBuyPromotions: Array<EventMultiBuyPromotion>;
  eventAddons: Array<EventAddon>;
  getAccessCode: AccessCodeReleaseOutput;
  getPaginatedAccessCode: AccessCodeConnection;
  getAccessCodes: Array<AccessCodeReleaseOutput>;
  listPresales: Array<PresaleReleaseOutput>;
  listNamingFields: Array<NamingFieldOutput>;
  seasons: Array<Season>;
  eventOrMembershipSeasons: Array<Season>;
  season: Season;
  presaleDateRange?: Maybe<DateRange>;
  integrations: Array<Integration>;
  integration: Integration;
  stripeConnectUrl: Scalars['String'];
  getConsentUrl: Scalars['String'];
  getXeroAccounts: XeroAllAccountsOutput;
  getXeroConfiguration?: Maybe<XeroConfigurationOutput>;
  disableXeroIntegration: Scalars['Boolean'];
  hasXeroIntegration: Scalars['Boolean'];
  disableShopifyIntegration: Scalars['Boolean'];
  customerOrders: Array<ShopifyCustomerOrder>;
  deleteAdobeIntegration: Scalars['Boolean'];
  adobeIntegration?: Maybe<AdobeExperiencePlatformIntegration>;
  currentOrganization: CurrentOrganizationOutput;
  /** [super-admin] | Fetches organizations (paginated) */
  organizations: OrganizationConnection;
  /** [super-admin] | Fetches an organization by id */
  organization: Organization;
  /** [app] | Fetches organization-names and Ids (paginated) */
  organizationNames: OrganizationConnection;
  /** Fetches all available features */
  availableFeatures: OrganizationFeatures;
  calendarHomepageCustomization?: Maybe<CalendarHomepageCustomization>;
  /** Fetches orders (paginated). */
  orders: OrderConnection;
  /** Fetches an order. */
  order?: Maybe<Order>;
  /** Checks an order for successful payment. */
  pollOrder?: Maybe<Order>;
  /** Fetches online orders ids for an event */
  orderIdsOnline?: Maybe<Array<OrderIdsOnlineOutput>>;
  /** Fetches online orders for an event */
  eventOrdersOnline?: Maybe<EventOrdersOnlineOutput>;
  /** Returns an orders details required to do refunds */
  orderRefundDetails?: Maybe<OrderRefundDetailsOutput>;
  /** Fetches orders of a user (paginated). */
  myOrders: OrderConnection;
  /** Fetches membership hold orders of a user. */
  myMembershipHoldOrders: Array<Order>;
  /** Gets updated orders */
  ordersUpdatedSince: CustomSaleOutput;
  /** Gets updated orders */
  ordersUpdatedSinceForEvent: CustomSaleOutput;
  /** Fetches payment options for an order during checkout. */
  getPaymentOptions: PaymentOptions;
  /** Gets ticket cover amount for order */
  calculateTicketCoverAmounts: TicketCoverAmount;
  getOrderJobStatus: OrderCreateOutput;
  orderComponents: Array<OrderComponent>;
  orderRefundData: OrderRefundData;
  getEventPurchaseRestrictions: Array<PurchaseRestriction>;
  getMembershipPurchaseRestrictions: Array<PurchaseRestriction>;
  getOrderPlan: OrderPlan;
  payRemainingOrderPlan: OrderPlan;
  getHistoryByCustomerId: Array<History>;
  venues: Array<Venue>;
  venue: Venue;
  venueSeatsThumbnail?: Maybe<Scalars['String']>;
  getZonesByEventId: Array<Zone>;
  getGatesByEventId: Array<Gate>;
  memberships: MembershipConnection;
  membership?: Maybe<Membership>;
  membershipTypeEventTransferPrices?: Maybe<Array<MembershipTypeEventTransferPrice>>;
  exchangeableEvents?: Maybe<Array<Event>>;
  membershipTypes: Array<MembershipType>;
  membershipAddons: Array<MembershipAddon>;
  membershipPromoCodes: Array<MembershipPromoCode>;
  membershipMultiBuyPromotions: Array<MembershipMultiBuyPromotion>;
  getSubscriptionPortalUrlForTicket: MembershipSubscriptionPortalOutput;
  getSubscriptionPortalUrlForOrder: MembershipSubscriptionPortalOutput;
  getMembershipSubscription: MembershipSubscription;
  getMembershipSubscriptionsForPreviousMemberships: Array<MembershipSubscription>;
  getMembershipAutoRenewal: MembershipAutoRenewalOutput;
  scout: Scout;
  scouts: Array<Scout>;
  /** Fetches users (paginated). */
  scoutUsers: ScoutUserConnection;
  initScout: InitScout;
  scoutCommunications: Array<ScoutCommunication>;
  scoutCommunication: ScoutCommunication;
  scoutCommunicationUsers: ScoutCommunicationUserConnection;
  scoutCommunicationUser: ScoutCommunicationUser;
  scoutUserReminders: Array<ScoutCommunicationUser>;
  tags: Array<Tag>;
  myMembershipTickets: Array<Ticket>;
  usersEventTickets: Array<Ticket>;
  myMembershipAddons: Array<Ticket>;
  myEventTickets: Array<Ticket>;
  myPaymentPlanTickets: Array<PartPaidTicketStats>;
  ticket?: Maybe<Ticket>;
  findOrderIdForTicket: FindOrderIdForTicketOutput;
  ticketsSoldForUser: Array<TicketTypePurchaseTotal>;
  membershipsSoldForUser: Array<MembershipTypePurchaseTotal>;
  getTicketsByIds: Array<Ticket>;
  /** DEPRECATED: should use searchTicketsByEventApp to fetch for scanner app */
  searchTickets: TicketConnection;
  searchTicketsByEventApp: SearchEventTicketsAppOutput;
  /** Returns stringyfied mapping of details per seat label. */
  ticketDetailsForBackOfficeOrders: Scalars['String'];
  transferredMembershipTicketsForOrder?: Maybe<Array<Ticket>>;
  ticketTransfersForAdmin: Array<TicketTransferForAdmin>;
  /** Gets updated ticket transfers within a date range. */
  completedTicketResalesSince: TicketTransferExportResultOutput;
  getSentTicketsById: SentTicketOutput;
  myScannedTickets: Array<Ticket>;
  myScannedTicketsCount: Scalars['Float'];
  pinPaymentContext: PinPaymentContext;
  windcavePaymentContext: WindcavePaymentContext;
  windcavePaymentResult: WindcavePaymentResultOutput;
  stripePaymentContext: StripePaymentContext;
  socialMentions: SocialConnection;
  mentionOverview: MentionOverview;
  facebookPageLists: Array<PageListsOutput>;
  mailchimpDomains: Scalars['JSON'];
  mailchimpLists: Scalars['JSON'];
  mailchimpTemplates: Scalars['JSON'];
  point?: Maybe<Point>;
  pointItem: PointItem;
  pointItems: Array<PointItem>;
  emailCustomizations: Array<EmailCustomizationOutput>;
  availableEmailTypesToCopy: Array<EmailType>;
  dynamicImage?: Maybe<ExtendedFile>;
  exhibitors: Array<ExpoExhibitor>;
  resendExhibitorLoginEmail: Scalars['Boolean'];
  expoListNamingFields: Array<ExpoNamingField>;
  listAttendees: Array<ExpoAttendee>;
  getAttendee: ExpoAttendee;
  getAttendeeTicket: ExpoAttendeeTicketOutput;
  getAllEncryptedAttendeeTickets: Array<ExpoEncryptedTicket>;
  exhibitorContext: ExhibitorContextOutput;
  exhibitorProfile: ExpoExhibitorSessionProfileOutput;
  activities: ActivityConnection;
  automations: Array<Automation>;
  automation: Automation;
  getI18n: I18nOutput;
  getReferralCampaigns: Array<ReferralCampaign>;
  getReferralCampaignsByEventId?: Maybe<Array<ReferralCampaign>>;
  getReferralCampaignByEventId?: Maybe<ReferralCampaign>;
  getReferralCampaignByReferralCode?: Maybe<ReferralCampaign>;
  getReferralCampaignByOrderId?: Maybe<ReferralCampaign>;
  getReferralCampaignStats: ReferralCampaignOverviewOutput;
  getReferralRewardByOrderId?: Maybe<ReferralReward>;
  referralUrlByOrderId?: Maybe<Scalars['String']>;
  referralUrlByWaitlistUserId?: Maybe<Scalars['String']>;
  getPromoterSettings?: Maybe<PromoterSettingsOutput>;
  searchArtists: Array<SearchArtistOutput>;
  seoMetadata?: Maybe<SeoMetadata>;
  getShopifySettings?: Maybe<ShopifySettings>;
  searchShopifyProducts: ShopifyProductsDto;
  getShopifyProducts: ShopifyProductsDto;
  prechargeOrderSummary: OrderPrechargeSummaryOutput;
  stripeIntegrationForPrechargeEvent: Integration;
  prechargeOrderRedirect?: Maybe<Scalars['String']>;
  competitions: Array<Competition>;
  competition: Competition;
  activeCompetitions?: Maybe<Array<Competition>>;
  activeCompetitionByType?: Maybe<Competition>;
  userEntries?: Maybe<Array<GrantRewardOutput>>;
  salesOverview: SalesOverviewOutput;
  salesComparisonData: SalesComparisonDataOutput;
  comparativeReportDefaultFilters: ComparativeReportDefaultFiltersOutput;
  scoutCampaignOverview: ScoutCampaignOverviewOutput;
  scoutCampaignTopTags: Array<TopTagsOutput>;
  scoutCampaignHighestValueCustomers: Array<HighestValueCustomersOutput>;
  scoutCampaignGenderBreakdown: GenderBreakDownOutput;
  scoutCampaignCustomerLocations: Array<LocationOutput>;
  summaryOverview: SummaryOverviewOutput;
  summaryOverviewV2: SummaryOverviewOutput;
  salesGraph: GraphOutput;
  presaleGraph: GraphOutput;
  preAuthorizationPresaleGraph: GraphOutput;
  presaleFinancialGateways: FinancialGatewayGraphOutput;
  customerLocationsByFilter: Array<LocationOutputV2>;
  salesChannelGraph: SalesChannelGraphOutput;
  financialOverview: FinancialOverviewOutput;
  faceValueOverview: FaceValueOverviewOutput;
  financialGraph: GraphOutput;
  faceValueFinancialGraph: GraphOutput;
  financialGateways: FinancialGatewayGraphOutput;
  salesReport: SalesReportOutput;
  scanVisitors: Array<ScannedVisitorsOutput>;
  scanVisitorsOverTime?: Maybe<Array<GraphRangeItem>>;
  scansOverTime: Array<ScansOverTimeOutput>;
  scanningOverview: ScanningOverviewOutput;
  scanTicketTypes: Array<GraphTextItem>;
  posSalesOverview: PosSalesOverviewOutput;
  posFinancialOverview: Array<GraphItem>;
  posFloatOfChange: Array<GraphItem>;
  insightsOverview: InsightsOverviewOutput;
  highestValueCustomers: Array<HighestValueCustomersOutput>;
  topTags: Array<TopTagsOutput>;
  topReferrers: Array<TopReferrersOutput>;
  topRepeatPurchasers: Array<TopRepeatPurchasers>;
  insightsGenderBreakDown: GenderBreakDownOutput;
  insightsHeardAboutUsBreakDown: Array<HeardAboutUsBreakDownOutput>;
  insightsAgeBreakDown: AgeBreakDownOutput;
  waitlistOverview: WaitlistOverviewOutput;
  capacityOverview: Array<FinancialSales>;
  capacitySeatingMap: Scalars['String'];
  capacitySeatingMapTooltips: Scalars['String'];
  broadcastReportStats: BroadcastReportingOutput;
  purchasingDaysBreakdown: Array<BarchartOutput>;
  referralPromotionReportStats: ReferralPromotionReportingOutput;
  timeOfDayBreakdown: Array<BarchartOutput>;
  getOnsaleCompetitionReportStats: CompetitionReportingOnsaleOutput;
  googleAnalyticsReport: Array<BarchartOutput>;
  getRegistrationCompetitionReportStats: CompetitionReportingRegistrationOutput;
  getRegistrationReferralReportStats: ReferralRegistrationPromotionReportingOutput;
  getCompetitionReferralReportForCustomer: Array<CompetitionCustomerReporting>;
  getReferralReportForCustomer: Array<ReferralCustomerReporting>;
  scanUsherTicketTypes?: Maybe<GraphItem>;
  getRegistrationCompetitionReportStatsByEventId: CompetitionReportingRegistrationOutput;
  getOnsaleCompetitionReportStatsByEventId: CompetitionReportingOnsaleOutput;
  conversionBreakdown: PresaleConversionOutput;
  reportingLayout: ReportingLayoutOutput;
  reportingOverview: ReportingOverviewOutput;
  financialReportingOverview: FinancialReportingOverviewOutput;
  eventInformation: EventInformation;
  membershipInformation: MembershipInformation;
  seasonInformation: SeasonInformation;
  packageInformation: PackageInformation;
  reportingSearchIndex: ReportingSearchIndexOutput;
  customerReportingOverview: CustomerReportingOverviewArgs;
  peReportOverview: PeReportOverviewOutput;
  peReportAudience: PeReportAudienceOutput;
  resaleWaitlistOverview: PeReportWaitlistOutput;
  registrationOverview: PeReportRegistrationOutput;
  registrationCompetitionOverview: PeReportRegistrationCompetitionOutput;
  peReferralPromotionReportStats: PeReportReferralOutsideMainSaleOutput;
  peOnsaleCompetitionReportStats: PeReportRegistrationCompetitionOutput;
  /** Source is hard coded to EVENT in peReport.graphql */
  demographics: PeReportDemographicsOutput;
  defaultDatesForPostEventReport: DefaultDates;
  peSalesChannelGraph: SalesChannelGraphOutput;
  peFinancialGateways: FinancialGatewayGraphOutput;
  getRedirectUrlByCode: RedirectUrl;
  getAccessCodesForMembership: Array<AccessCode>;
  validateAccessCodeForMembership: AccessCode;
  getShortUrlByCode: ShortUrl;
  getWaitlistUser?: Maybe<WaitlistUser>;
  resaleTickets: Array<TicketType>;
  resaleTicket: TicketType;
  resaleTicketsMetrics: Array<ResaleTicketMetrics>;
  resaleWaitlistCount: ResaleWaitlistCount;
  getReleaseUrlForResaleTicketType: Scalars['String'];
  getMinTicketTypePricesForEvent: Array<MinTicketTypePricesForEventOutput>;
  resaleTicketTypesForWaitlist: Array<TicketType>;
  broadcasts: Array<BroadcastListOutput>;
  broadcast: BroadcastOutput;
  audienceCount: Scalars['Float'];
  marketingUserCount: Scalars['Float'];
  broadcastFilterState: Array<BroadcastMarketingV2StateOutput>;
  broadcastDeliveryErrors: BroadcastDeliveryErrorsOutput;
  getBroadcastDefaultConfig?: Maybe<BroadcastDefaultConfigOutput>;
  getRegionsForCountry: Array<Scalars['String']>;
  getBroadcastLocationFilterOptions: BroadcastLocationFilterOptions;
  broadcastsForEmailsOpenedFilter: Array<ResponseLabelValue>;
  broadcastUnsubscribes: BroadcastUnsubscribesOutput;
  broadcastReportedAsSpam: BroadcastReportedAsSpamUsersOutput;
  eventsForBroadcast: Array<EventForBroadcast>;
  smsBroadcasts: Array<SmsBroadcastListOutput>;
  smsBroadcast: SmsBroadcastOutput;
  smsBroadcastDeliveryErrors: SmsBroadcastDeliveryErrorsOutput;
  smsBroadcastAudience: SmsBroadcastAudienceOutput;
  smsBroadcastUnsubscribes: SmsBroadcastUnsubscribesOutput;
  emailDomains: Array<EmailDomainOutput>;
  verifiedEmailDomains: Array<EmailDomainOutput>;
  codeReport: CodeReportOutput;
  reportSchedules: Array<ReportSchedule>;
  chargeSummary: Array<ChargeSummaryOutput>;
  chargeMonthSummary: ChargeMonthSummaryOutput;
  getTrackingCodesByEventId: Array<TrackingCodeOutput>;
  /** Gets created/updated ATR orders between a supplied date range. Loads order and order.user relations. */
  atrMembershipOrdersUpdatedBetween: Array<AtrMembershipOrdersUpdatedBetweenOutput>;
  /** Fetches users updated between given date range. Dates supplied in organizations timezone. */
  atrUsersUpdatedBetween: Array<AtrUsersUpdatedBetweenOutput>;
  exportFilterColumns: ExportFilterCategoryOutput;
  signupForm: SignupFormOutput;
  signupForms: Array<SignupFormOutput>;
  getProcessedCustomCSS: Scalars['String'];
  segments: Array<SegmentListOutput>;
  segment: SegmentOutput;
  segmentCustomerCount: SegmentCustomerCountOutput;
};


export type QueryUsersArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<UserWhereInput>;
  orderBy?: Maybe<UserOrderByInput>;
};


export type QueryUsersUpdatedBetweenArgs = {
  input: UsersUpdatedBetweenInput;
};


export type QueryUserArgs = {
  id: Scalars['String'];
};


export type QueryFindUserReferralIdArgs = {
  id: Scalars['String'];
};


export type QueryPosUsersArgs = {
  eventId: Scalars['String'];
};


export type QueryLinkedAccountUserArgs = {
  id: Scalars['String'];
};


export type QueryPosesArgs = {
  eventId: Scalars['String'];
};


export type QueryPosArgs = {
  id: Scalars['String'];
};


export type QueryGetPosReleasePaymentOptionsArgs = {
  releaseId: Scalars['String'];
};


export type QueryPosTerminalLatestTransactionStatusArgs = {
  posId: Scalars['String'];
};


export type QueryPosSessionsArgs = {
  posId: Scalars['String'];
};


export type QueryEventsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<EventWhereInput>;
  orderBy?: Maybe<EventOrderByInput>;
};


export type QueryEventArgs = {
  id: Scalars['String'];
};


export type QueryEventsByIdArgs = {
  input: EventsByIdInput;
};


export type QueryGetEventAndReleaseForCustomerArgs = {
  input: EventsWithAccessControlInput;
};


export type QueryGetEventForCompetitionReportingArgs = {
  id: Scalars['String'];
};


export type QueryMyEventsArgs = {
  where?: Maybe<MyEventsWhereInput>;
  orderBy?: Maybe<MyEventsOrderByInput>;
};


export type QueryEventForecastArgs = {
  eventId: Scalars['String'];
};


export type QueryTicketTypesArgs = {
  eventId: Scalars['String'];
};


export type QueryTicketTypesByIdArgs = {
  input: TicketTypesByIdInput;
};


export type QueryReleasesArgs = {
  type?: Maybe<ReleaseType>;
  event: Scalars['String'];
};


export type QueryGetReleasesForPrivateLinksArgs = {
  eventId: Scalars['String'];
};


export type QueryReleaseArgs = {
  id: Scalars['String'];
};


export type QueryGetReleaseBySlugArgs = {
  eventId: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
};


export type QueryGetPublicReleaseTicketsArgs = {
  includeResale?: Maybe<Scalars['Boolean']>;
  eventId: Scalars['String'];
};


export type QueryEventPromoCodesArgs = {
  eventId: Scalars['String'];
};


export type QueryEventMultiBuyPromotionsArgs = {
  eventId: Scalars['String'];
};


export type QueryEventAddonsArgs = {
  eventId: Scalars['String'];
};


export type QueryGetAccessCodeArgs = {
  releaseId: Scalars['String'];
};


export type QueryGetPaginatedAccessCodeArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where: AccessCodeWhereInput;
};


export type QueryGetAccessCodesArgs = {
  eventId: Scalars['String'];
};


export type QueryListPresalesArgs = {
  eventId: Scalars['String'];
};


export type QueryListNamingFieldsArgs = {
  eventId: Scalars['String'];
};


export type QuerySeasonArgs = {
  id: Scalars['String'];
};


export type QueryPresaleDateRangeArgs = {
  input: PresaleDateRangeInput;
};


export type QueryIntegrationsArgs = {
  input?: Maybe<IntegrationWhereInput>;
};


export type QueryIntegrationArgs = {
  id: Scalars['String'];
};


export type QueryStripeConnectUrlArgs = {
  id: Scalars['String'];
};


export type QueryCustomerOrdersArgs = {
  customerId: Scalars['String'];
};


export type QueryOrganizationsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationWhereInput>;
  orderBy?: Maybe<OrganizationOrderByInput>;
};


export type QueryOrganizationArgs = {
  id: Scalars['String'];
};


export type QueryOrganizationNamesArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<OrganizationWhereInput>;
  orderBy?: Maybe<OrganizationOrderByInput>;
};


export type QueryOrdersArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<OrderWhereInput>;
  orderBy?: Maybe<OrderOrderByInput>;
};


export type QueryOrderArgs = {
  id: Scalars['String'];
};


export type QueryPollOrderArgs = {
  id: Scalars['String'];
};


export type QueryOrderIdsOnlineArgs = {
  id: Scalars['String'];
};


export type QueryEventOrdersOnlineArgs = {
  id: Scalars['String'];
};


export type QueryOrderRefundDetailsArgs = {
  eventId: Scalars['String'];
  orderId: Scalars['String'];
};


export type QueryMyOrdersArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<OrderWhereInput>;
  orderBy?: Maybe<OrderOrderByInput>;
};


export type QueryOrdersUpdatedSinceArgs = {
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  eventId?: Maybe<Scalars['String']>;
};


export type QueryOrdersUpdatedSinceForEventArgs = {
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  eventId?: Maybe<Scalars['String']>;
};


export type QueryGetPaymentOptionsArgs = {
  id: Scalars['String'];
};


export type QueryCalculateTicketCoverAmountsArgs = {
  id: Scalars['String'];
};


export type QueryGetOrderJobStatusArgs = {
  jobId: Scalars['String'];
};


export type QueryOrderComponentsArgs = {
  organizationId: Scalars['String'];
  orderId: Scalars['String'];
};


export type QueryOrderRefundDataArgs = {
  orderId: Scalars['String'];
};


export type QueryGetEventPurchaseRestrictionsArgs = {
  eventId: Scalars['String'];
};


export type QueryGetMembershipPurchaseRestrictionsArgs = {
  membershipId: Scalars['String'];
};


export type QueryGetOrderPlanArgs = {
  orderId: Scalars['String'];
};


export type QueryPayRemainingOrderPlanArgs = {
  orderPlanId: Scalars['String'];
};


export type QueryGetHistoryByCustomerIdArgs = {
  input: GetHistoryByCustomerIdInput;
};


export type QueryVenueArgs = {
  id: Scalars['String'];
};


export type QueryVenueSeatsThumbnailArgs = {
  id: Scalars['String'];
};


export type QueryGetZonesByEventIdArgs = {
  eventId: Scalars['String'];
};


export type QueryGetGatesByEventIdArgs = {
  eventId: Scalars['String'];
};


export type QueryMembershipsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<MembershipWhereInput>;
  orderBy?: Maybe<MembershipOrderByInput>;
};


export type QueryMembershipArgs = {
  id: Scalars['String'];
};


export type QueryMembershipTypeEventTransferPricesArgs = {
  id: Scalars['String'];
};


export type QueryExchangeableEventsArgs = {
  eventToExchangeId: Scalars['String'];
  membershipId: Scalars['String'];
};


export type QueryMembershipTypesArgs = {
  membership: Scalars['String'];
};


export type QueryMembershipAddonsArgs = {
  membershipId: Scalars['String'];
};


export type QueryMembershipPromoCodesArgs = {
  membershipId: Scalars['String'];
};


export type QueryMembershipMultiBuyPromotionsArgs = {
  membershipId: Scalars['String'];
};


export type QueryGetSubscriptionPortalUrlForTicketArgs = {
  ticketId: Scalars['String'];
};


export type QueryGetSubscriptionPortalUrlForOrderArgs = {
  orderId: Scalars['String'];
};


export type QueryGetMembershipSubscriptionArgs = {
  membershipSubscriptionId: Scalars['String'];
};


export type QueryGetMembershipSubscriptionsForPreviousMembershipsArgs = {
  previousMembershipIds: Array<Scalars['String']>;
};


export type QueryGetMembershipAutoRenewalArgs = {
  membershipId: Scalars['String'];
};


export type QueryScoutArgs = {
  id: Scalars['String'];
};


export type QueryScoutsArgs = {
  input?: Maybe<FindScoutsInput>;
};


export type QueryScoutUsersArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<UserWhereInput>;
  stage?: Maybe<Array<ScoutStage>>;
  agentUserId?: Maybe<Scalars['String']>;
  hasPhoneNumber?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type QueryScoutCommunicationsArgs = {
  input: ScoutCommunicationsInput;
};


export type QueryScoutCommunicationArgs = {
  id: Scalars['String'];
};


export type QueryScoutCommunicationUsersArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<UserWhereInput>;
  hasPhoneNumber?: Maybe<Scalars['Boolean']>;
  stage?: Maybe<Array<ScoutStage>>;
  agentUserId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
};


export type QueryScoutCommunicationUserArgs = {
  id: Scalars['String'];
};


export type QueryMyMembershipAddonsArgs = {
  membershipId: Scalars['String'];
};


export type QueryMyEventTicketsArgs = {
  eventId: Scalars['String'];
};


export type QueryTicketArgs = {
  id: Scalars['String'];
};


export type QueryFindOrderIdForTicketArgs = {
  ticketId: Scalars['String'];
};


export type QueryTicketsSoldForUserArgs = {
  eventId: Scalars['String'];
};


export type QueryMembershipsSoldForUserArgs = {
  membershipId: Scalars['String'];
};


export type QueryGetTicketsByIdsArgs = {
  ids: Scalars['String'];
};


export type QuerySearchTicketsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<TicketWhereInput>;
  orderBy?: Maybe<TicketWhereInput>;
  eventId: Scalars['String'];
};


export type QuerySearchTicketsByEventAppArgs = {
  q?: Maybe<Scalars['String']>;
  eventId: Scalars['String'];
};


export type QueryTicketDetailsForBackOfficeOrdersArgs = {
  membershipId?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
};


export type QueryTransferredMembershipTicketsForOrderArgs = {
  orderId: Scalars['String'];
};


export type QueryTicketTransfersForAdminArgs = {
  orderId: Scalars['String'];
};


export type QueryCompletedTicketResalesSinceArgs = {
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  eventId?: Maybe<Scalars['String']>;
};


export type QueryGetSentTicketsByIdArgs = {
  sendId: Scalars['String'];
};


export type QueryMyScannedTicketsArgs = {
  eventId: Scalars['String'];
};


export type QueryMyScannedTicketsCountArgs = {
  eventId: Scalars['String'];
};


export type QueryPinPaymentContextArgs = {
  id: Scalars['String'];
};


export type QueryWindcavePaymentContextArgs = {
  id: Scalars['String'];
};


export type QueryWindcavePaymentResultArgs = {
  result: Scalars['String'];
  externalId: Scalars['String'];
};


export type QueryStripePaymentContextArgs = {
  id: Scalars['String'];
};


export type QuerySocialMentionsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<SocialWhereInput>;
};


export type QueryMentionOverviewArgs = {
  input: MentionOverviewInput;
};


export type QueryFacebookPageListsArgs = {
  input: FacebookPageListsInput;
};


export type QueryPointItemArgs = {
  id: Scalars['String'];
};


export type QueryEmailCustomizationsArgs = {
  input: GetAllCustomizationInput;
};


export type QueryAvailableEmailTypesToCopyArgs = {
  membershipId?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
};


export type QueryDynamicImageArgs = {
  input: DynamicImageInput;
};


export type QueryExhibitorsArgs = {
  eventId: Scalars['String'];
};


export type QueryResendExhibitorLoginEmailArgs = {
  input: FindExhibitorInput;
};


export type QueryGetAttendeeArgs = {
  id: Scalars['String'];
};


export type QueryGetAttendeeTicketArgs = {
  ticketNumber: Scalars['String'];
};


export type QueryActivitiesArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<ActivityWhereInput>;
};


export type QueryAutomationsArgs = {
  input: FindAutomationsInput;
};


export type QueryAutomationArgs = {
  id: Scalars['String'];
};


export type QueryGetReferralCampaignsByEventIdArgs = {
  id: Scalars['String'];
};


export type QueryGetReferralCampaignByEventIdArgs = {
  id: Scalars['String'];
};


export type QueryGetReferralCampaignByReferralCodeArgs = {
  referralCode: Scalars['String'];
};


export type QueryGetReferralCampaignByOrderIdArgs = {
  id: Scalars['String'];
};


export type QueryGetReferralCampaignStatsArgs = {
  eventId: Scalars['String'];
  id: Scalars['String'];
};


export type QueryGetReferralRewardByOrderIdArgs = {
  id: Scalars['String'];
};


export type QueryReferralUrlByOrderIdArgs = {
  orderId: Scalars['String'];
};


export type QueryReferralUrlByWaitlistUserIdArgs = {
  waitlistUserId: Scalars['String'];
  eventId: Scalars['String'];
};


export type QueryGetPromoterSettingsArgs = {
  eventId: Scalars['String'];
};


export type QuerySearchArtistsArgs = {
  input: SearchArtistInput;
};


export type QuerySeoMetadataArgs = {
  membershipId?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
};


export type QuerySearchShopifyProductsArgs = {
  search: Scalars['String'];
};


export type QueryGetShopifyProductsArgs = {
  membershipId?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
};


export type QueryPrechargeOrderSummaryArgs = {
  orderId: Scalars['String'];
};


export type QueryStripeIntegrationForPrechargeEventArgs = {
  eventId: Scalars['String'];
};


export type QueryPrechargeOrderRedirectArgs = {
  orderId: Scalars['String'];
};


export type QueryCompetitionsArgs = {
  eventId: Scalars['String'];
};


export type QueryCompetitionArgs = {
  id: Scalars['String'];
};


export type QueryActiveCompetitionsArgs = {
  eventId: Scalars['String'];
};


export type QueryActiveCompetitionByTypeArgs = {
  input: ActiveCompetitionByTypeInput;
};


export type QueryUserEntriesArgs = {
  input: GetUserEntriesInput;
};


export type QuerySalesOverviewArgs = {
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
  source: PointReportingFilterSource;
};


export type QuerySalesComparisonDataArgs = {
  input: SalesComparisonGraphInput;
};


export type QueryComparativeReportDefaultFiltersArgs = {
  input?: Maybe<ComparativeReportDefaultFiltersInput>;
};


export type QueryScoutCampaignOverviewArgs = {
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
};


export type QueryScoutCampaignTopTagsArgs = {
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
};


export type QueryScoutCampaignHighestValueCustomersArgs = {
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
};


export type QueryScoutCampaignGenderBreakdownArgs = {
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
};


export type QueryScoutCampaignCustomerLocationsArgs = {
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
};


export type QuerySummaryOverviewArgs = {
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
};


export type QuerySalesGraphArgs = {
  source: PointReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<GraphFilterType>;
};


export type QueryPresaleGraphArgs = {
  source: PointReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<GraphFilterType>;
};


export type QueryPreAuthorizationPresaleGraphArgs = {
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  eventId?: Maybe<Scalars['String']>;
};


export type QueryPresaleFinancialGatewaysArgs = {
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
  source: PointReportingFilterSource;
};


export type QueryCustomerLocationsByFilterArgs = {
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
  filter: LocationFilterTypes;
};


export type QuerySalesChannelGraphArgs = {
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
  source: PointReportingFilterSource;
};


export type QueryFinancialOverviewArgs = {
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
  source: PointReportingFilterSource;
};


export type QueryFaceValueOverviewArgs = {
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
  source: PointReportingFilterSource;
};


export type QueryFinancialGraphArgs = {
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
};


export type QueryFaceValueFinancialGraphArgs = {
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
  source: PointReportingFilterSource;
};


export type QueryFinancialGatewaysArgs = {
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
  source: PointReportingFilterSource;
};


export type QuerySalesReportArgs = {
  source: ReportingFinancialSalesBreakdownSource;
  sourceId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  releaseIds?: Maybe<Array<Scalars['String']>>;
  isPreauthReport?: Maybe<Scalars['Boolean']>;
  showIndividualPricingTiers?: Maybe<Scalars['Boolean']>;
  ticketTypeId?: Maybe<Scalars['String']>;
};


export type QueryScanVisitorsArgs = {
  eventId: Scalars['String'];
  filter?: Maybe<ScannerTypeFilter>;
  dateFilterType?: Maybe<ScanReportingDateFilterType>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
};


export type QueryScanVisitorsOverTimeArgs = {
  eventId: Scalars['String'];
  filter?: Maybe<ScannerTypeFilter>;
  dateFilterType?: Maybe<ScanReportingDateFilterType>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
};


export type QueryScansOverTimeArgs = {
  input: ScansOverTimeInput;
};


export type QueryScanningOverviewArgs = {
  eventId: Scalars['String'];
  filter?: Maybe<ScannerTypeFilter>;
  dateFilterType?: Maybe<ScanReportingDateFilterType>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
};


export type QueryScanTicketTypesArgs = {
  eventId: Scalars['String'];
  filter?: Maybe<ScannerTypeFilter>;
  dateFilterType?: Maybe<ScanReportingDateFilterType>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
};


export type QueryPosSalesOverviewArgs = {
  eventId: Scalars['String'];
  posId?: Maybe<Scalars['String']>;
  sessionId?: Maybe<Scalars['String']>;
};


export type QueryPosFinancialOverviewArgs = {
  eventId: Scalars['String'];
  posId?: Maybe<Scalars['String']>;
  sessionId?: Maybe<Scalars['String']>;
};


export type QueryPosFloatOfChangeArgs = {
  eventId: Scalars['String'];
  posId?: Maybe<Scalars['String']>;
  sessionId?: Maybe<Scalars['String']>;
};


export type QueryInsightsOverviewArgs = {
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
};


export type QueryHighestValueCustomersArgs = {
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
};


export type QueryTopTagsArgs = {
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
};


export type QueryTopReferrersArgs = {
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
};


export type QueryTopRepeatPurchasersArgs = {
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
};


export type QueryInsightsGenderBreakDownArgs = {
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
};


export type QueryInsightsHeardAboutUsBreakDownArgs = {
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
};


export type QueryInsightsAgeBreakDownArgs = {
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
};


export type QueryWaitlistOverviewArgs = {
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
};


export type QueryCapacityOverviewArgs = {
  eventId: Scalars['String'];
};


export type QueryCapacitySeatingMapArgs = {
  eventId: Scalars['String'];
};


export type QueryCapacitySeatingMapTooltipsArgs = {
  eventId: Scalars['String'];
};


export type QueryBroadcastReportStatsArgs = {
  input: BroadcastReportingStatsInput;
};


export type QueryPurchasingDaysBreakdownArgs = {
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
};


export type QueryReferralPromotionReportStatsArgs = {
  input: ReferralPromotionReportingInput;
};


export type QueryTimeOfDayBreakdownArgs = {
  source: ReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  release?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  scoutCommunicationId?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
};


export type QueryGetOnsaleCompetitionReportStatsArgs = {
  input: CompetitionReportingInput;
};


export type QueryGoogleAnalyticsReportArgs = {
  input: GoogleAnalyticsReportingFilterInput;
};


export type QueryGetRegistrationCompetitionReportStatsArgs = {
  input: CompetitionReportingInput;
};


export type QueryGetRegistrationReferralReportStatsArgs = {
  input: ReferralPromotionReportingInput;
};


export type QueryGetCompetitionReferralReportForCustomerArgs = {
  input: CustomerCompetitionReportingInput;
};


export type QueryGetReferralReportForCustomerArgs = {
  input: CustomerReferralReportingInput;
};


export type QueryScanUsherTicketTypesArgs = {
  eventId: Scalars['String'];
  filter?: Maybe<ScannerTypeFilter>;
  dateFilterType?: Maybe<ScanReportingDateFilterType>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
};


export type QueryGetRegistrationCompetitionReportStatsByEventIdArgs = {
  eventId?: Maybe<Scalars['String']>;
};


export type QueryGetOnsaleCompetitionReportStatsByEventIdArgs = {
  eventId: Scalars['String'];
};


export type QueryConversionBreakdownArgs = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
  eventId: Scalars['String'];
};


export type QueryReportingLayoutArgs = {
  input?: Maybe<ReportingLayoutInput>;
};


export type QueryReportingOverviewArgs = {
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  releaseId?: Maybe<Scalars['String']>;
  source: PointReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  posId?: Maybe<Scalars['String']>;
  sessionId?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
};


export type QueryFinancialReportingOverviewArgs = {
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  releaseId?: Maybe<Scalars['String']>;
  source: PointReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  posId?: Maybe<Scalars['String']>;
  sessionId?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
};


export type QueryEventInformationArgs = {
  eventId: Scalars['String'];
};


export type QueryMembershipInformationArgs = {
  membershipId: Scalars['String'];
};


export type QuerySeasonInformationArgs = {
  seasonId: Scalars['String'];
};


export type QueryPackageInformationArgs = {
  packageId: Scalars['String'];
};


export type QueryCustomerReportingOverviewArgs = {
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  releaseId?: Maybe<Scalars['String']>;
  source: PointReportingFilterSource;
  sourceId?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  channel?: Maybe<OrderChannel>;
  posId?: Maybe<Scalars['String']>;
  sessionId?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
};


export type QueryPeReportOverviewArgs = {
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  eventId: Scalars['String'];
};


export type QueryPeReportAudienceArgs = {
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  eventId: Scalars['String'];
};


export type QueryResaleWaitlistOverviewArgs = {
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  eventId: Scalars['String'];
};


export type QueryRegistrationOverviewArgs = {
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  eventId: Scalars['String'];
};


export type QueryRegistrationCompetitionOverviewArgs = {
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  eventId: Scalars['String'];
};


export type QueryPeReferralPromotionReportStatsArgs = {
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  eventId: Scalars['String'];
};


export type QueryPeOnsaleCompetitionReportStatsArgs = {
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  eventId: Scalars['String'];
};


export type QueryDemographicsArgs = {
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  eventId: Scalars['String'];
  locationFilterTypes?: Maybe<LocationFilterTypes>;
};


export type QueryDefaultDatesForPostEventReportArgs = {
  eventId: Scalars['String'];
};


export type QueryPeSalesChannelGraphArgs = {
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  eventId: Scalars['String'];
};


export type QueryPeFinancialGatewaysArgs = {
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  eventId: Scalars['String'];
};


export type QueryGetRedirectUrlByCodeArgs = {
  input: RedirectCodeInput;
};


export type QueryGetAccessCodesForMembershipArgs = {
  id: Scalars['String'];
};


export type QueryValidateAccessCodeForMembershipArgs = {
  input: ValidateAccessCodeForMembershipInput;
};


export type QueryGetShortUrlByCodeArgs = {
  code: Scalars['String'];
};


export type QueryGetWaitlistUserArgs = {
  eventId: Scalars['String'];
  userId: Scalars['String'];
};


export type QueryResaleTicketsArgs = {
  eventId: Scalars['String'];
};


export type QueryResaleTicketArgs = {
  id: Scalars['String'];
};


export type QueryResaleTicketsMetricsArgs = {
  eventId: Scalars['String'];
};


export type QueryResaleWaitlistCountArgs = {
  eventId: Scalars['String'];
};


export type QueryGetReleaseUrlForResaleTicketTypeArgs = {
  eventId: Scalars['String'];
};


export type QueryGetMinTicketTypePricesForEventArgs = {
  eventId: Scalars['String'];
};


export type QueryResaleTicketTypesForWaitlistArgs = {
  eventId: Scalars['String'];
  releaseId?: Maybe<Scalars['String']>;
};


export type QueryBroadcastArgs = {
  id: Scalars['String'];
};


export type QueryAudienceCountArgs = {
  input: AudienceCountInput;
};


export type QueryMarketingUserCountArgs = {
  input: BroadcastFilterCountInput;
};


export type QueryBroadcastFilterStateArgs = {
  input: BroadcastMarketingV2StateInput;
};


export type QueryBroadcastDeliveryErrorsArgs = {
  broadcastId: Scalars['String'];
};


export type QueryGetRegionsForCountryArgs = {
  country: Scalars['String'];
};


export type QueryGetBroadcastLocationFilterOptionsArgs = {
  broadcastCommunicationType: BroadcastCommunicationType;
};


export type QueryBroadcastUnsubscribesArgs = {
  broadcastId: Scalars['String'];
};


export type QueryBroadcastReportedAsSpamArgs = {
  broadcastId: Scalars['String'];
};


export type QuerySmsBroadcastArgs = {
  broadcastId: Scalars['String'];
};


export type QuerySmsBroadcastDeliveryErrorsArgs = {
  smsBroadcastId: Scalars['String'];
};


export type QuerySmsBroadcastAudienceArgs = {
  input: SmsBroadcastFilterCountInput;
};


export type QuerySmsBroadcastUnsubscribesArgs = {
  smsBroadcastId: Scalars['String'];
};


export type QueryCodeReportArgs = {
  sourceId?: Maybe<Scalars['String']>;
  sourceType: Scalars['String'];
  type: Scalars['String'];
};


export type QueryReportSchedulesArgs = {
  input: GetReportSchedulesInput;
};


export type QueryChargeMonthSummaryArgs = {
  date?: Maybe<Scalars['DateTime']>;
};


export type QueryGetTrackingCodesByEventIdArgs = {
  eventId: Scalars['String'];
};


export type QueryAtrMembershipOrdersUpdatedBetweenArgs = {
  input: AtrMembershipOrdersUpdatedBetweenInput;
};


export type QueryAtrUsersUpdatedBetweenArgs = {
  input: UsersUpdatedBetweenInput;
};


export type QueryExportFilterColumnsArgs = {
  input: ExportFilterColumnsInput;
};


export type QuerySignupFormArgs = {
  id: Scalars['String'];
};


export type QueryGetProcessedCustomCssArgs = {
  css: Scalars['String'];
};


export type QuerySegmentArgs = {
  id: Scalars['String'];
};


export type QuerySegmentCustomerCountArgs = {
  id: Scalars['String'];
};

export type RedeemTicketInput = {
  /** Ticket number */
  ticketNumber: Scalars['String'];
  /** Event ID */
  eventId: Scalars['String'];
  timestamp: Scalars['DateTime'];
};

export type RedirectCodeInput = {
  /** Full URL path. */
  redirectCode: Scalars['String'];
};

/** Mapping of a shortened URL to its full path */
export type RedirectUrl = {
  __typename?: 'RedirectUrl';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** Type of entity this redirect is for. */
  refName: Scalars['String'];
  /** Reference entity ID. */
  refId: Scalars['String'];
  /** Shortned URL slug. */
  shortenedSlug: Scalars['String'];
  /** Full URL path. */
  redirectURL: Scalars['String'];
  /** Number of times the shortened URL has redirected to the full path. */
  timesUsed: Scalars['Float'];
};

/** Referral Campaign */
export type ReferralCampaign = {
  __typename?: 'ReferralCampaign';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The unique identifier for the referral campaign */
  referralRelease?: Maybe<Release>;
  /** The eventId that the referral campaign is associated with */
  event?: Maybe<Event>;
  /** The memebrshipId that the referral campaign is associated with */
  membership?: Maybe<Membership>;
  /** Whether the referral campaign is active */
  isActive: Scalars['Boolean'];
  /** The type of reward for the owner of the referral */
  referralOwnerRewardType: ReferralRewardType;
  /** The reward quantity type. */
  referralOwnerRewardQuantityType: ReferralRewardQuantityType;
  /** The quantity of the reward for the owner of the referral */
  referralOwnerRewardQuantity: Scalars['Float'];
  /** The type of reward for the user of the referral */
  referralUserRewardType: ReferralRewardType;
  /** The reward quantity type. */
  referralUserRewardQuantityType: ReferralRewardQuantityType;
  /** The quantity of the reward for the user of the referral */
  referralUserRewardQuantity: Scalars['Float'];
};

export type ReferralCampaignOverviewOutput = {
  __typename?: 'ReferralCampaignOverviewOutput';
  numberOfOrders: Scalars['Float'];
  userRewards: Scalars['Float'];
  ownerRewards: Scalars['Float'];
  referralLinksCreated: Scalars['Float'];
  referralLinksClicked: Scalars['Float'];
  tickets: Scalars['Float'];
  revenueGenerated: Scalars['Float'];
  customersAccquired: Scalars['Float'];
};

/** A referral code for a user and event */
export type ReferralCode = {
  __typename?: 'ReferralCode';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type ReferralCustomerReporting = {
  __typename?: 'ReferralCustomerReporting';
  orderNumber: Scalars['String'];
  eventLogo?: Maybe<ExtendedFile>;
  eventName: Scalars['String'];
  orderDate: Scalars['DateTime'];
  referralsMade: Scalars['Int'];
  referralLink?: Maybe<Scalars['String']>;
};

export type ReferralPromotionReportingInput = {
  eventId: Scalars['String'];
};

export type ReferralPromotionReportingOutput = {
  __typename?: 'ReferralPromotionReportingOutput';
  revenue: Scalars['Float'];
  roi: Scalars['Float'];
  orders: Scalars['Float'];
  newReferredCustomers: Scalars['Float'];
  referrerPointsAwarded: Scalars['Float'];
  discountValue: Scalars['Float'];
  actionEngagement?: Maybe<Array<ActionEngagementRecordOutput>>;
};

export type ReferralRegistrationPromotionReportingOutput = {
  __typename?: 'ReferralRegistrationPromotionReportingOutput';
  newReferredCustomers: Scalars['Float'];
  registrations: Scalars['Float'];
  actionEngagement?: Maybe<Array<ActionEngagementRecordOutput>>;
};

/** Referral Reward */
export type ReferralReward = {
  __typename?: 'ReferralReward';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  order: Order;
  /** The referral campaign the rewards are from */
  referralCampaign: ReferralCampaign;
  /** Organization associated with the referral campaign */
  organization: Organization;
  /** The role of the user played when receiving these rewards */
  rewardForRole: ReferralRole;
  /** The type of reward for the referral */
  rewardType: ReferralRewardType;
  /** The reward quantity type. */
  rewardQuantityType: ReferralRewardQuantityType;
  /** The quantity of the reward for the owner of the referral */
  rewardQuantity: Scalars['Float'];
};

/** The valid values for quantities of referral rewards. */
export enum ReferralRewardQuantityType {
  FlatRate = 'flatRate',
  Percentage = 'percentage'
}

/** The valid values for referral rewards. Some are only applicable to certain roles in a referral transaction. */
export enum ReferralRewardType {
  Points = 'Points',
  Credits = 'Credits',
  Discount = 'Discount'
}

/** The role the user played when in a referral exchange. */
export enum ReferralRole {
  Owner = 'Owner',
  User = 'User'
}

/** Represents a refund of items in an order. */
export type Refund = {
  __typename?: 'Refund';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  kind: RefundKind;
  /** The amount of the refund. */
  amount: Scalars['Float'];
  /** Notes why the refund has been initiated. */
  notes: Scalars['String'];
  /** Whether the refund is a manual one. */
  isManual: Scalars['Boolean'];
  gateway?: Maybe<RefundGateway>;
};

/** Amount remaining that can be automatically refunded through the payment gateway */
export type RefundableState = {
  __typename?: 'RefundableState';
  refundState: OrderRefundState;
  totalRefundableAmount: Scalars['Float'];
  /** The amount that can be automatically refunded */
  gatewayRefundableAmount?: Maybe<GatewayRefundableAmount>;
};

export type RefundAttributionInput = {
  type: OrderComponentType;
  amount: Scalars['Float'];
  ticketId?: Maybe<Scalars['String']>;
  taxName?: Maybe<Scalars['String']>;
};

/** Refund gateways. */
export enum RefundGateway {
  Cash = 'Cash',
  Point = 'Point',
  Eftpos = 'Eftpos',
  CreditCard = 'CreditCard',
  Invoice = 'Invoice',
  Other = 'Other'
}

/** Refund kinds. */
export enum RefundKind {
  Default = 'Default',
  TicketTransfer = 'TicketTransfer'
}

export type RegisteredForActivityArgs = {
  __typename?: 'RegisteredForActivityArgs';
  kind: BroadcastMarketingFiltersV2Kind;
  exclude: Scalars['Boolean'];
  eventIds: Array<Scalars['String']>;
};

export type RegisterInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  posId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  enableTwoFactorAuthentication: Scalars['Boolean'];
  userAcquisition?: Maybe<UserAcquisition>;
};

/** Represents a release in an event. */
export type Release = {
  __typename?: 'Release';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** Release name. */
  name: Scalars['String'];
  /** Release type. */
  type: ReleaseType;
  /** The slug for the unlisted release. Returns null if the release type is set to other than `unlisted`. */
  slug?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  /** The start condition of the release. */
  startCondition: ReleaseStartCondition;
  /** The start date of the release. Returns null if the startCondition is set to other than "date". */
  startConditionDate?: Maybe<Scalars['DateTime']>;
  /** The end condition of the release. */
  endCondition: ReleaseEndCondition;
  /** The quantity limit of the release. Returns null if the endCondition is set to other than "quantity". */
  endConditionQuantity?: Maybe<Scalars['Float']>;
  /** The end date of the release. Returs null if the endCondition is set to other than "date". */
  endConditionDate?: Maybe<Scalars['DateTime']>;
  /** The status of the release. */
  isActive: Scalars['Boolean'];
  /** The title of the unlisted release. Returns null if the `type` is set to other than `unlisted`. */
  presaleTitle?: Maybe<Scalars['String']>;
  /** The logo of the unlisted release. Returns null if the `type` is set to other than `unlisted`. */
  presaleLogo?: Maybe<ExtendedFile>;
  /** The header image of the unlisted release. Returns null if the `type` is set to other than `unlisted`. */
  presaleHeader?: Maybe<ExtendedFile>;
  /** The information of the unlisted release. Returns null if the `type` is set to other than `unlisted`. */
  presaleInformation?: Maybe<Scalars['String']>;
  /** The information that will be displayed on the ticketing page for a specific release. */
  releaseNotes?: Maybe<Scalars['String']>;
  /** Toggle whether to ask customers how they heard about their purcahse */
  askHowDidYouHearAboutUs?: Maybe<Scalars['Boolean']>;
  /** Toggle whether to ask for dietary requirements with their order */
  askForDietaryRequirements?: Maybe<Scalars['Boolean']>;
  allowPublicComp: Scalars['Boolean'];
  /** Toggle whether customers can create hold orders for this release */
  allowHoldOrders: Scalars['Boolean'];
  allowAccount2Account?: Maybe<Scalars['Boolean']>;
  minPurchaseQuantity: Scalars['Int'];
  maxPurchaseQuantity: Scalars['Int'];
  isEnabled: Scalars['Boolean'];
  /** Presale only: whether to link to this release from the waitlist page (where applicable) */
  linkToWaitlist?: Maybe<Scalars['Boolean']>;
  /** Presale only: whether to allow pre-purchases for this release */
  allowPrePurchase?: Maybe<Scalars['Boolean']>;
  purchaseRestrictions?: Maybe<ReleasePurchaseRestriction>;
  status: ReleaseStatus;
  event: Event;
  canBeHardDeleted: Scalars['Boolean'];
  requiresAuth: Scalars['Boolean'];
  releaseZones: Array<ReleaseZone>;
  releaseEventAddons: Array<ReleaseEventAddon>;
  isResaleRelease: Scalars['Boolean'];
  channels: Array<EventChannelOutput>;
  isPrePurchaseActive: Scalars['Boolean'];
  showMemberTicketsBanner: Scalars['Boolean'];
};

export enum ReleaseEndCondition {
  Manual = 'MANUAL',
  Date = 'DATE',
  Quantity = 'QUANTITY'
}

export type ReleaseEventAddon = {
  __typename?: 'ReleaseEventAddon';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  eventAddon: EventAddon;
  releaseId: Scalars['String'];
  eventAddonId: Scalars['String'];
};

/** Represents a unique password code in a release. */
export type ReleasePassword = {
  __typename?: 'ReleasePassword';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** The usage limit of the release password. Returns null if password has no usage limit. */
  quantityPaid: Scalars['Int'];
  /** The usage limit of the release password for complimentary tickets. */
  quantityComp: Scalars['Int'];
  totalUsedPaid: Scalars['Int'];
  totalUsedComp: Scalars['Int'];
};

export type ReleasePosPaymentOptions = {
  __typename?: 'ReleasePosPaymentOptions';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  releaseId: Scalars['String'];
  organizationId: Scalars['String'];
  paymentOptions: PosPaymentOptions;
  /** Booking fee type. */
  bookingFeeType: FeeType;
  /** Booking fee. */
  bookingFee: Scalars['Float'];
};

export type ReleasePurchaseRestriction = {
  __typename?: 'ReleasePurchaseRestriction';
  showBanner: Scalars['Boolean'];
  membershipIds: Array<Scalars['String']>;
};

/** Creates a refund. */
export type ReleaseSeatsInput = {
  /** Order id for which the seats will be released. */
  orderId: Scalars['String'];
  /** Notes why the seats are released. */
  notes: Scalars['String'];
  /** Tickets to realease (will also release child tickets). */
  ticketIds: Array<Scalars['String']>;
};

export enum ReleaseStartCondition {
  Manual = 'MANUAL',
  Date = 'DATE'
}

export type ReleaseStatus = {
  __typename?: 'ReleaseStatus';
  value: ReleaseStatusValue;
  message?: Maybe<Scalars['String']>;
};

export enum ReleaseStatusValue {
  ReleaseHasEndedDueToDate = 'RELEASE_HAS_ENDED_DUE_TO_DATE',
  ReleaseIsPrivateWithFutureStartDate = 'RELEASE_IS_PRIVATE_WITH_FUTURE_START_DATE',
  ReleaseIsPrivate = 'RELEASE_IS_PRIVATE',
  ReleaseIsPublic = 'RELEASE_IS_PUBLIC'
}

export enum ReleaseType {
  Listed = 'LISTED',
  Unlisted = 'UNLISTED',
  Presale = 'PRESALE',
  Pos = 'POS',
  Referral = 'REFERRAL',
  Outlet = 'OUTLET',
  Resale = 'RESALE'
}

export type ReleaseZone = {
  __typename?: 'ReleaseZone';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  zone: Zone;
  /** The pricing level of the zone. Will be set to `zone` for non-seated events. */
  pricingLevel: ZonePricingLevel;
  /** The active status of the zone. Defaults to `false`. */
  isActive: Scalars['Boolean'];
  isSoldOut: Scalars['Boolean'];
  /** The list of ticket types of the release zone. */
  ticketTypes: Array<ReleaseZoneTicketType>;
};

export type ReleaseZoneInput = {
  id?: Maybe<Scalars['String']>;
  zone: ReleaseZoneZoneInput;
  /** The pricing level of the release zone. Will be set to `zone` for non-seated events. */
  pricingLevel: ZonePricingLevel;
  /** The active status of the zone seating. Defaults to `false`. */
  isActive?: Maybe<Scalars['Boolean']>;
  /** The list of ticket types of the release zone. */
  ticketTypes: Array<ReleaseZoneTicketTypeInput>;
};

/** Represents a ticket type in a release zone. */
export type ReleaseZoneTicketType = {
  __typename?: 'ReleaseZoneTicketType';
  /** The price of the zone ticket. Returns null if `pricingLevel` of the parent is set to other than `zone`. */
  price?: Maybe<Scalars['Float']>;
  /** The sections of the zone ticket. Returns null if `pricingLevel` of the parent is set to other than `section`. */
  sections?: Maybe<Array<ZonePricingTypeSection>>;
  /** Whether the pricing type is hidden from public view. */
  isHidden: Scalars['Boolean'];
  /** The active status of the zone ticket. Defaults to `false`. */
  isActive: Scalars['Boolean'];
  purchaseRestrictions: Array<PurchaseRestriction>;
  purchaseRestrictionsHelpText?: Maybe<Array<Scalars['String']>>;
  /** The ticket type id of the zone ticket. */
  ticketTypeId?: Maybe<Scalars['String']>;
  minPurchaseQuantity: Scalars['Int'];
  maxPurchaseQuantity: Scalars['Int'];
  isSoldOut: Scalars['Boolean'];
  hidePrice: Scalars['Boolean'];
  ticketAvailabilityStatus: TicketAvailabilityStatus;
  pricingTierId?: Maybe<Scalars['String']>;
  pricingTierName?: Maybe<Scalars['String']>;
};

export type ReleaseZoneTicketTypeInput = {
  /** The ticket type id of the zone ticket. */
  ticketTypeId: Scalars['String'];
  /** The price of the zone ticket. Pass null if `ReleaseZoneInput.pricingLevel` is set to other than `zone`. */
  price?: Maybe<Scalars['Float']>;
  /** The sections of the zone ticket. Pass null if `ReleaseZoneInput.pricingLevel` is set to other than `section`. */
  sections?: Maybe<Array<ReleaseZoneTicketTypeSectionInput>>;
  /** The active status of the zone ticket type. Defaults to `false`. */
  isActive?: Maybe<Scalars['Boolean']>;
};

export type ReleaseZoneTicketTypeSectionInput = {
  /** The section id. Should be equal to one of the sections defined in the event venue. */
  sectionId: Scalars['String'];
  /** The section name. Should be equal to one of the sections defined in the event venue. */
  name: Scalars['String'];
  /** The price of the section ticket. */
  price?: Maybe<Scalars['Float']>;
};

/** The zone belonging to a release zone */
export type ReleaseZoneZoneInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type ReorderTicketTypeInput = {
  releaseZoneId: Scalars['String'];
  ticketTypeIds: Array<Scalars['String']>;
};

export type ReorderZoneInput = {
  venueId: Scalars['String'];
  zoneIds: Array<Scalars['String']>;
};

export enum ReportingFilterSource {
  Overall = 'OVERALL',
  Membership = 'MEMBERSHIP',
  Event = 'EVENT'
}

export enum ReportingFinancialSalesBreakdownSource {
  Membership = 'MEMBERSHIP',
  Event = 'EVENT'
}

export type ReportingLayoutInput = {
  allEvents?: Maybe<Scalars['Boolean']>;
  eventId?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
  allMemberships?: Maybe<Scalars['Boolean']>;
  seasonId?: Maybe<Scalars['String']>;
  allSeasons?: Maybe<Scalars['Boolean']>;
  seasonSource?: Maybe<ReportingFinancialSalesBreakdownSource>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  isOverall?: Maybe<Scalars['Boolean']>;
  packageId?: Maybe<Scalars['String']>;
  allPackages?: Maybe<Scalars['Boolean']>;
};

export type ReportingLayoutOutput = EventLayoutOutput | MembershipLayoutOutput | SeasonLayoutOutput | OverallLayoutOutput | PackageLayoutOutput;

export type ReportingOverviewOutput = {
  __typename?: 'ReportingOverviewOutput';
  ticketSales: Array<PeReportStatistic>;
  financial: Array<PeReportStatistic>;
  audience: Array<PeReportStatistic>;
};

export type ReportingSearchIndexOutput = {
  __typename?: 'ReportingSearchIndexOutput';
  searchableEvents: Array<SearchEvent>;
  searchableSeasons: Array<SearchSeason>;
  searchableMemberships: Array<SearchMembership>;
  searchablePackages: Array<SearchPackage>;
};


export type ReportingSearchIndexOutputSearchableEventsArgs = {
  filter?: Maybe<SearchEventFilter>;
};

export type ReportSchedule = {
  __typename?: 'ReportSchedule';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** This should exist when type is event */
  eventId?: Maybe<Scalars['String']>;
  /** This should exist when type is membership */
  membershipId?: Maybe<Scalars['String']>;
  scheduleName: Scalars['String'];
  recipientList: Array<Scalars['String']>;
  scheduleOptions: ReportScheduleOptions;
  isPaused: Scalars['Boolean'];
  type: ReportScheduleType;
  scheduleDateInfo: ReportScheduleDateInfoOutput;
};

/** Report schedule date information provided in the organizations timezone ready for presentation. */
export type ReportScheduleDateInfoOutput = {
  __typename?: 'ReportScheduleDateInfoOutput';
  nextSendDate?: Maybe<Scalars['String']>;
  firstSendDate?: Maybe<Scalars['String']>;
  mostRecentSendDate?: Maybe<Scalars['String']>;
};

export enum ReportScheduleFrequency {
  Monthly = 'Monthly',
  Weekly = 'Weekly',
  Daily = 'Daily'
}

export type ReportScheduleInput = {
  scheduleName: Scalars['String'];
  recipientList: Array<Scalars['String']>;
  scheduleOptions: ReportScheduleOptionsInput;
  isPaused: Scalars['Boolean'];
  type: ReportScheduleType;
  eventId?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
};

export type ReportScheduleOptions = {
  __typename?: 'ReportScheduleOptions';
  frequency: ReportScheduleFrequency;
  /** The time of day as a 24h string in the format HH:MM */
  sendTime: Scalars['String'];
  sendDay?: Maybe<Scalars['String']>;
  startDate: Scalars['String'];
  endDate: Scalars['String'];
};

export type ReportScheduleOptionsInput = {
  frequency: ReportScheduleFrequency;
  /** The time of day as a 24h string in the format HH:MM */
  sendTime: Scalars['String'];
  sendDay?: Maybe<Scalars['String']>;
  startDate: Scalars['String'];
  endDate: Scalars['String'];
};

/** The type of automated sales report */
export enum ReportScheduleType {
  Event = 'Event',
  Membership = 'Membership'
}

export enum ReportType {
  Internal = 'INTERNAL',
  GoogleAnalytics = 'GOOGLE_ANALYTICS'
}

export type RequestMagicLinkInput = {
  email: Scalars['String'];
  redirectUrl?: Maybe<Scalars['String']>;
  entry?: Maybe<Scalars['String']>;
};

export type RequestResetPasswordInput = {
  email: Scalars['String'];
};

export type RequestTicketTransferInput = {
  email: Scalars['String'];
  ticketId: Scalars['String'];
  /**
   * The price set by the seller for the ticket transfer. Must be between the seller transfer fee 
   *     and the original line item price. If not supplied, the original line item price is used.
   */
  ticketSalePrice?: Maybe<Scalars['Float']>;
};

export type ResaleTicketMetrics = {
  __typename?: 'ResaleTicketMetrics';
  ticketTypeId: Scalars['String'];
  numInterestedFans: Scalars['Float'];
  soldRevenue: Scalars['Float'];
  /** The mean and median prices that customers have said they would pay. Will be null if no data is present. */
  fansWouldPay?: Maybe<FansWouldPay>;
  numCurrentlyOnSale: Scalars['Float'];
  numSold: Scalars['Float'];
};

export type ResaleWaitlistCount = {
  __typename?: 'ResaleWaitlistCount';
  numWaitlisted: Scalars['Float'];
};

/** input for the resale waitlist */
export type ResaleWaitlistInput = {
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  usableForMarketing: Scalars['Boolean'];
  eventId: Scalars['String'];
  releaseId?: Maybe<Scalars['String']>;
  referralCode?: Maybe<Scalars['String']>;
  userAcquisition?: Maybe<UserAcquisition>;
  customFields?: Maybe<Array<CustomFieldInput>>;
  /** The resale ticket types */
  resaleTicketTypes?: Maybe<Array<ResaleWaitlistInputTicketTypes>>;
};

export type ResaleWaitlistInputTicketTypes = {
  id: Scalars['String'];
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

export type ResaleWaitlistOutput = {
  __typename?: 'ResaleWaitlistOutput';
  e164Number?: Maybe<Scalars['String']>;
  user: User;
};

export type ResendExhibitorLoginEmailMultipleFound = {
  __typename?: 'ResendExhibitorLoginEmailMultipleFound';
  multipleFound: Scalars['Boolean'];
  events: Array<ExpoEventForLogin>;
};

export type ResendExhibitorLoginEmailNotFound = {
  __typename?: 'ResendExhibitorLoginEmailNotFound';
  notFound: Scalars['Boolean'];
};

export type ResendExhibitorLoginEmailOutputUnion = ResendExhibitorLoginEmailSuccess | ResendExhibitorLoginEmailNotFound | ResendExhibitorLoginEmailMultipleFound;

export type ResendExhibitorLoginEmailSuccess = {
  __typename?: 'ResendExhibitorLoginEmailSuccess';
  success: Scalars['Boolean'];
};

export type ResetPasswordInput = {
  token: Scalars['String'];
  password: Scalars['String'];
};

export type ResponseLabelValue = {
  __typename?: 'ResponseLabelValue';
  label: Scalars['String'];
  value: Scalars['String'];
};

/** A release which has purchase restrictions. */
export type RestrictedRelease = {
  __typename?: 'RestrictedRelease';
  releaseId: Scalars['String'];
  path: Scalars['String'];
  isActive: Scalars['Boolean'];
  memberships: Array<RestrictedReleaseRequiredMembership>;
};

/** A membership required to access a restricted release. */
export type RestrictedReleaseRequiredMembership = {
  __typename?: 'RestrictedReleaseRequiredMembership';
  id: Scalars['String'];
  name: Scalars['String'];
  isActive: Scalars['Boolean'];
};

export type RewardSettingsDto = {
  referralOwnerRewardQuantityType: ReferralRewardQuantityType;
  referralOwnerRewardQuantity?: Maybe<Scalars['Float']>;
  referralUserRewardQuantityType: ReferralRewardQuantityType;
  referralUserRewardQuantity?: Maybe<Scalars['Float']>;
};

export enum Role {
  Superadmin = 'Superadmin',
  Admin = 'Admin',
  Sales = 'Sales',
  PosAdmin = 'PosAdmin',
  PosOperator = 'PosOperator',
  VenueAdmin = 'VenueAdmin',
  Scanner = 'Scanner',
  User = 'User',
  EventReporting = 'EventReporting',
  BackOfficeStaff = 'BackOfficeStaff',
  SalesOutlet = 'SalesOutlet',
  EventManager = 'EventManager',
  SubPromoter = 'SubPromoter',
  Marketing = 'Marketing',
  CustomerSupport = 'CustomerSupport',
  SalesRep = 'SalesRep'
}

export type SalesBreakdown = {
  __typename?: 'SalesBreakdown';
  /** The breakdown total which is the sum of fully paid + part paid */
  items: Array<NumberStatistic>;
  /** Breakdown of all orders that have been fully paid */
  fullyPaidItems: Array<NumberStatistic>;
  /** Breakdown of all orders that are currently in a payment plan that hasn't been completed */
  partPaidItems: Array<NumberStatistic>;
  totalNet: Scalars['Float'];
  faceValue: Scalars['Float'];
};

export type SalesChannelGraphOutput = {
  __typename?: 'SalesChannelGraphOutput';
  transactions: Scalars['Float'];
  online: Scalars['Float'];
  backOffice: Scalars['Float'];
  pos: Scalars['Float'];
};

export enum SalesComparisonAlignmentType {
  DaysOnSale = 'DAYS_ON_SALE',
  DaysUntilEventEnds = 'DAYS_UNTIL_EVENT_ENDS'
}

export type SalesComparisonBasePeriod = {
  __typename?: 'SalesComparisonBasePeriod';
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
};

export type SalesComparisonDataItem = {
  __typename?: 'SalesComparisonDataItem';
  id: Scalars['String'];
  name: Scalars['String'];
  faceValue: Scalars['Float'];
  ticketsSold: Scalars['Float'];
  addonsSold: Scalars['Float'];
  membershipSold?: Maybe<Scalars['Float']>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  insufficientPeriod: Scalars['Boolean'];
};

export type SalesComparisonDataOutput = {
  __typename?: 'SalesComparisonDataOutput';
  duration: Scalars['Int'];
  data?: Maybe<Scalars['JSONObject']>;
};

export type SalesComparisonGraphDataItem = {
  __typename?: 'SalesComparisonGraphDataItem';
  faceValue?: Maybe<Scalars['Float']>;
  ticketSold?: Maybe<Scalars['Int']>;
  addonSold?: Maybe<Scalars['Int']>;
  membershipSold?: Maybe<Scalars['Int']>;
  date: Scalars['String'];
  sourceId?: Maybe<Scalars['String']>;
};

export type SalesComparisonGraphInput = {
  sourceIds: Array<Scalars['String']>;
  source?: Maybe<ComparisonSource>;
  alignmentType: SalesComparisonAlignmentType;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  periodFilter: PeriodFilter;
};

export type SalesComparisonSumItem = {
  __typename?: 'SalesComparisonSumItem';
  faceValue?: Maybe<Scalars['Float']>;
  ticketSold?: Maybe<Scalars['Int']>;
  addonSold?: Maybe<Scalars['Int']>;
  membershipSold?: Maybe<Scalars['Int']>;
};

export type SalesOverviewOutput = {
  __typename?: 'SalesOverviewOutput';
  ticketsIssued: Scalars['Float'];
  membershipsIssued: Scalars['Float'];
  membershipsSold: Scalars['Float'];
  membershipsComp: Scalars['Float'];
  addonsIssued: Scalars['Float'];
  addonsSold: Scalars['Float'];
  orders: Scalars['Float'];
  ordersPartPaid: Scalars['Float'];
  cartAbandonment: Scalars['Float'];
  returningCustomers: Scalars['Float'];
  ticketsSold: Scalars['Float'];
  ticketsPartPaid: Scalars['Float'];
  membershipsPartPaid: Scalars['Float'];
  ticketsComp: Scalars['Float'];
  ticketsTransferred: Scalars['Float'];
  packagesSold: Scalars['Float'];
  pointsDistributed: Scalars['Float'];
  membershipsRenewed: Scalars['Float'];
  ticketCoverOrdersSold: Scalars['Float'];
  ticketCoverTicketsIssued: Scalars['Float'];
  ticketCoverMembershipsIssued: Scalars['Float'];
  cartRecovered: Scalars['Float'];
};

export type SalesReportOutput = {
  __typename?: 'SalesReportOutput';
  salesBreakdown?: Maybe<SalesBreakdown>;
  financialSales: Array<FinancialSales>;
};

export type SaveNewSetupIntentForCardUpdateInput = {
  orderId: Scalars['String'];
  setupIntentId: Scalars['String'];
};

export type Scan = {
  __typename?: 'Scan';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  scannedAt: Scalars['DateTime'];
  event: Event;
  direction: TicketScanDirection;
  type: TicketScanType;
  gate: Gate;
  hasScannedParentTicket: Scalars['Boolean'];
  isOffline: Scalars['Boolean'];
};

export enum ScanExportType {
  Tickets = 'TICKETS',
  Addons = 'ADDONS'
}

export enum ScanMetric {
  Issued = 'ISSUED',
  Presented = 'PRESENTED',
  ToScan = 'TO_SCAN',
  Scanned = 'SCANNED'
}

export enum ScannedTicketType {
  SoldTickets = 'SOLD_TICKETS',
  Comps = 'COMPS',
  Memberships = 'MEMBERSHIPS',
  UsherTickets = 'USHER_TICKETS',
  AddOns = 'ADD_ONS'
}

export type ScannedTicketTypesItem = {
  __typename?: 'ScannedTicketTypesItem';
  key: ScanMetric;
  name: Scalars['String'];
  value: Scalars['Float'];
};

export type ScannedTicketTypesOutput = {
  __typename?: 'ScannedTicketTypesOutput';
  identifier: ScannedTicketType;
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  items: Array<ScannedTicketTypesItem>;
};

export type ScannedVisitorsCategory = {
  __typename?: 'ScannedVisitorsCategory';
  title: Scalars['String'];
  displayValue: Scalars['String'];
  chartProps: ScannedVisitorsChartProps;
  descriptionItems: Array<Scalars['String']>;
};

export type ScannedVisitorsChartProps = {
  __typename?: 'ScannedVisitorsChartProps';
  percentage: Scalars['Float'];
};

export type ScannedVisitorsGate = {
  __typename?: 'ScannedVisitorsGate';
  title: Scalars['String'];
  subtitle: Scalars['String'];
  displayValue: Scalars['String'];
};

export type ScannedVisitorsOutput = {
  __typename?: 'ScannedVisitorsOutput';
  category: ScannedVisitorsCategory;
  items: Array<ScannedVisitorsGate>;
};

export type ScannerEmailOutput = {
  __typename?: 'ScannerEmailOutput';
  success: Scalars['Boolean'];
};

export enum ScannerTypeFilter {
  TicketType = 'TICKET_TYPE',
  Gate = 'GATE'
}

export type ScanningOverviewOutput = {
  __typename?: 'ScanningOverviewOutput';
  totalScanned: Scalars['Float'];
  totalIssued: Scalars['Float'];
  totalToScan: Scalars['Float'];
  totalNonAdmissionScanned: Scalars['Float'];
  totalTicketsScannedOut: Scalars['Float'];
  scannedTicketTypes: Array<ScannedTicketTypesOutput>;
  scansByDay: Array<ScansByDayOutput>;
};

export enum ScanOverTimeGroupBy {
  OneDay = 'ONE_DAY',
  OneHour = 'ONE_HOUR',
  ThirtyMinutes = 'THIRTY_MINUTES',
  FifteenMinutes = 'FIFTEEN_MINUTES',
  FiveMinutes = 'FIVE_MINUTES'
}

export enum ScanReportingDateFilterType {
  All = 'ALL',
  AllEventDates = 'ALL_EVENT_DATES',
  SpecificDate = 'SPECIFIC_DATE'
}

export type ScansByDayOutput = {
  __typename?: 'ScansByDayOutput';
  value: Scalars['Float'];
  label: Scalars['String'];
  percentage: Scalars['Float'];
  subLabel?: Maybe<Scalars['String']>;
};

export type ScansOverTimeInput = {
  eventId: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  groupBy: ScanOverTimeGroupBy;
  dateFilterType?: Maybe<ScanReportingDateFilterType>;
};

export type ScansOverTimeOutput = {
  __typename?: 'ScansOverTimeOutput';
  date: Scalars['DateTime'];
  value: Scalars['Float'];
};

/** Scan status. */
export enum ScanStatus {
  Ok = 'OK',
  Warning = 'WARNING',
  Error = 'ERROR'
}

export type ScanTicketBulk = {
  /** Ticket number */
  ticketNumber: Scalars['String'];
  /** Scanner gate */
  gateId: Scalars['String'];
  /** Scanner direction */
  scanDirection: TicketScanDirection;
  /** Ticket scan type */
  scanType?: Maybe<TicketScanType>;
  isOffline?: Maybe<Scalars['Boolean']>;
  /** Validations to bypass during ticket scanning. */
  bypassValidations?: Maybe<Array<TicketScanValidations>>;
  eventId?: Maybe<Scalars['String']>;
  scannedAt: Scalars['DateTime'];
};

export type ScanTicketBulkInput = {
  /** Scan data. */
  scans: Array<ScanTicketBulk>;
};

export type ScanTicketInput = {
  /** Ticket number */
  ticketNumber: Scalars['String'];
  /** Scanner gate */
  gateId: Scalars['String'];
  /** Scanner direction */
  scanDirection: TicketScanDirection;
  /** Ticket scan type */
  scanType?: Maybe<TicketScanType>;
  isOffline?: Maybe<Scalars['Boolean']>;
  /** Validations to bypass during ticket scanning. */
  bypassValidations?: Maybe<Array<TicketScanValidations>>;
};

export type ScanTicketOutput = {
  __typename?: 'ScanTicketOutput';
  status: ScanStatus;
  message?: Maybe<Scalars['String']>;
  ticket?: Maybe<Ticket>;
  /** When there is an error or a warning status, this field provides a code indicating what triggered the problem */
  problemCode?: Maybe<ProblemCode>;
};

export type ScenarioInput = {
  scenarioId: Scalars['String'];
  /** The zones and Scenario inputs. */
  zones: Array<ScenarioZoneInput>;
};

export type ScenarioZoneInput = {
  /** The zone related to this input */
  zoneId: Scalars['String'];
  /** The ticket types for the zone and Scenario inputs. */
  ticketTypes: Array<ScenarioZoneTicketTypeInput>;
};

/** An object with ticket type id and forecast cost and split of sales */
export type ScenarioZoneTicketType = {
  __typename?: 'ScenarioZoneTicketType';
  /** Ticket type id */
  ticketTypeId: Scalars['String'];
  /** The forecast price of a ticket */
  price: Scalars['Float'];
  /** The forecast split of sales for this ticket type as a percentage */
  splitPercentage: Scalars['Float'];
};

export type ScenarioZoneTicketTypeInput = {
  /** The ticket type of this input. */
  ticketTypeId: Scalars['String'];
  /** The price of a seat in this zone for the ticket type. */
  price: Scalars['Float'];
  /** What percentage of the seats will be this ticket type */
  splitPercentage: Scalars['Float'];
};

export type ScheduleOption = {
  __typename?: 'ScheduleOption';
  id: Scalars['String'];
  interval: ScheduleOptionInterval;
  installmentCount: Scalars['Float'];
  availableUntil?: Maybe<Scalars['String']>;
  minimumOrderAmount?: Maybe<Scalars['Float']>;
  finalPaymentDate?: Maybe<Scalars['String']>;
  depositPercentage?: Maybe<Scalars['Float']>;
  /** This fee is collected to cover the Stripe costs. */
  stripeFeePercentage?: Maybe<Scalars['Float']>;
  /** This fee is collected as additional revenue for offering Payment Plans. */
  promoterFeePercentage?: Maybe<Scalars['Float']>;
  /** This fee is collected for Flicket as part of Payment Plans. */
  flicketFeePercentage?: Maybe<Scalars['Float']>;
};

export type ScheduleOptionInput = {
  id: Scalars['String'];
  interval: ScheduleOptionInterval;
  installmentCount: Scalars['Float'];
  availableUntil?: Maybe<Scalars['String']>;
  minimumOrderAmount?: Maybe<Scalars['Float']>;
  finalPaymentDate?: Maybe<Scalars['String']>;
  depositPercentage?: Maybe<Scalars['Float']>;
  /** This fee is collected to cover the Stripe costs. */
  stripeFeePercentage?: Maybe<Scalars['Float']>;
  /** This fee is collected as additional revenue for offering Payment Plans. */
  promoterFeePercentage?: Maybe<Scalars['Float']>;
  /** This fee is collected for Flicket as part of Payment Plans. */
  flicketFeePercentage?: Maybe<Scalars['Float']>;
};

export enum ScheduleOptionInterval {
  Day = 'day',
  Week = 'week',
  Month = 'month'
}

export type Scout = {
  __typename?: 'Scout';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  purpose?: Maybe<ScoutPurpose>;
  includeOptedOutOfMarketing?: Maybe<Scalars['Boolean']>;
  promoteTo: Array<FilterSelection>;
  exclude: Array<FilterSelection>;
  /** Used to show what we are tracking */
  trackSource?: Maybe<Scalars['String']>;
  /** Id of source */
  trackSourceId?: Maybe<Scalars['String']>;
  /** Release Id of the source that we are tracking */
  trackReleaseId?: Maybe<Scalars['String']>;
  /** Scout active status. */
  isActive: Scalars['Boolean'];
  total: Scalars['Float'];
};

export type ScoutCampaignOverviewOutput = {
  __typename?: 'ScoutCampaignOverviewOutput';
  ticketsSold: Scalars['Float'];
  membershipsSold: Scalars['Float'];
  addonsSold: Scalars['Float'];
  orders: Scalars['Float'];
  cartAbandonment: Scalars['Float'];
  returningCustomers: Scalars['Float'];
  ticketsPaid: Scalars['Float'];
  ticketsComp: Scalars['Float'];
  totalRevenue: Scalars['Float'];
  todayRevenue: Scalars['Float'];
  campaignSize: Scalars['Float'];
  contactRate: Scalars['Float'];
  conversionRate: Scalars['Float'];
  emailClickRate: Scalars['Float'];
  emailOpenRate: Scalars['Float'];
};

export type ScoutCommunication = {
  __typename?: 'ScoutCommunication';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** If a campaign is created from a segment, then it should have a scout Id. */
  scout?: Maybe<Scout>;
  /** If a campaign is created from another campaign, then it should have a campaign Id. */
  campaign?: Maybe<ScoutCommunication>;
  /** email, sms or call */
  type: ScoutCommunicationType;
  data: Scalars['JSON'];
  name: Scalars['String'];
  purpose: ScoutPurpose;
  includeOptedOutOfMarketing?: Maybe<Scalars['Boolean']>;
  /** Used to show what we are tracking */
  trackSource?: Maybe<ReportingFilterSource>;
  /** Id of source */
  trackSourceId?: Maybe<Scalars['String']>;
  /** Release Id of the source that we are tracking */
  trackReleaseId?: Maybe<Scalars['String']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  processedAt?: Maybe<Scalars['DateTime']>;
  shouldUpdate?: Maybe<Scalars['Boolean']>;
  /** Required when type is email communication */
  mailchimpCampaignId?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
  listId?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['Float']>;
  link?: Maybe<Scalars['String']>;
  count: Scalars['Int'];
  conversions: Scalars['Float'];
};

export type ScoutCommunicationsInput = {
  isActive?: Maybe<Scalars['Boolean']>;
};

/** The communication types for a scout campaign. */
export enum ScoutCommunicationType {
  Email = 'Email',
  Sms = 'SMS',
  Call = 'Call'
}

export type ScoutCommunicationUser = {
  __typename?: 'ScoutCommunicationUser';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  scoutCommunication: ScoutCommunication;
  stage: ScoutStage;
  remindAt?: Maybe<Scalars['DateTime']>;
  user: User;
  agentUser?: Maybe<User>;
  response?: Maybe<Scalars['JSON']>;
  processedAt?: Maybe<Scalars['DateTime']>;
  scoutUser?: Maybe<ScoutUser>;
  history: HistoryConnection;
};


export type ScoutCommunicationUserHistoryArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<HistoryOrderByInput>;
};

export type ScoutCommunicationUserConnection = {
  __typename?: 'ScoutCommunicationUserConnection';
  pageInfo: PageInfo;
  edges: Array<ScoutCommunicationUserEdge>;
  totalCount: Scalars['Int'];
};

export type ScoutCommunicationUserEdge = {
  __typename?: 'ScoutCommunicationUserEdge';
  cursor: Scalars['String'];
  node: ScoutCommunicationUser;
};

export enum ScoutEventType {
  Event = 'Event',
  Membership = 'Membership'
}

/** The valid purposes for a scout. */
export enum ScoutPurpose {
  SellMembership = 'SellMembership',
  SellTickets = 'SellTickets',
  SellMerchandise = 'SellMerchandise',
  Communication = 'Communication'
}

/** The valid stages for a scout user. */
export enum ScoutStage {
  NoContact = 'NoContact',
  NoAnswer = 'NoAnswer',
  InProgress = 'InProgress',
  Completed = 'Completed'
}

export type ScoutUser = {
  __typename?: 'ScoutUser';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  scout: Scout;
  user: User;
  stage: ScoutStage;
  agentUser?: Maybe<User>;
  remindAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
};

export type ScoutUserConnection = {
  __typename?: 'ScoutUserConnection';
  pageInfo: PageInfo;
  edges: Array<ScoutUserEdge>;
  totalCount: Scalars['Int'];
};

export type ScoutUserEdge = {
  __typename?: 'ScoutUserEdge';
  cursor: Scalars['String'];
  node: ScoutUser;
};

export type SearchArtistInput = {
  query: Scalars['String'];
};

export type SearchArtistOutput = {
  __typename?: 'SearchArtistOutput';
  id: Scalars['String'];
  /** Name of the artist */
  name: Scalars['String'];
  /** Source of the artist data, e.g. spotify */
  source?: Maybe<Scalars['String']>;
  /** Source id of the artist, e.g. artist id from spotify */
  sourceId?: Maybe<Scalars['String']>;
  /** URL of the artist image */
  imageUrl?: Maybe<Scalars['String']>;
  /** Follower count of the artist */
  followerCount?: Maybe<Scalars['Int']>;
  /** Genres of the artist */
  genres?: Maybe<Array<Scalars['String']>>;
};

export type SearchEvent = {
  __typename?: 'SearchEvent';
  id: Scalars['String'];
  title: Scalars['String'];
  dates: Array<EventDate>;
};

export type SearchEventFilter = {
  /**
   * A value of true will return only events that have registration enabled. A
   * value of false will return only the events that have no registration. Null
   * will not filter on this value.
   */
  hasRegistrationEnabled?: Maybe<Scalars['Boolean']>;
  activeEventsOnly?: Maybe<Scalars['Boolean']>;
};

export type SearchEventTicketsAppOutput = {
  __typename?: 'SearchEventTicketsAppOutput';
  totalCount: Scalars['Float'];
  tickets: Array<AppTicket>;
};

export type SearchMembership = {
  __typename?: 'SearchMembership';
  id: Scalars['String'];
  name: Scalars['String'];
  startDate: Scalars['DateTime'];
};

export type SearchPackage = {
  __typename?: 'SearchPackage';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type SearchSeason = {
  __typename?: 'SearchSeason';
  id: Scalars['String'];
  name: Scalars['String'];
  startDate: Scalars['DateTime'];
};

export type Season = {
  __typename?: 'Season';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** Season name */
  name: Scalars['String'];
  /** Events in the season */
  events: Array<Event>;
  /** Season active status */
  isActive: Scalars['Boolean'];
  /** Description of the season */
  description?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<ExtendedFile>;
  /** Banner image shown on the tour (season) page. */
  backgroundImageFullPage?: Maybe<ExtendedFile>;
  /** Banner image shown at the top of the season events page. */
  landingBanner?: Maybe<ExtendedFile>;
  /** Rich text shown above the season events. */
  landingDescription?: Maybe<Scalars['String']>;
  displayOrder: Scalars['Int'];
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  defaultDateRange?: Maybe<DateRange>;
};


export type SeasonDefaultDateRangeArgs = {
  input: SeasonOnsaleDateRangeInput;
};

export type SeasonInformation = {
  __typename?: 'SeasonInformation';
  id: Scalars['String'];
  name: Scalars['String'];
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
};

export type SeasonLayoutOutput = {
  __typename?: 'SeasonLayoutOutput';
  defaultDateRange: DateRange;
  season?: Maybe<SeasonInformation>;
};

export type SeasonOnsaleDateRangeInput = {
  source: ReportingFinancialSalesBreakdownSource;
};

/** Default seat selection filters. */
export type SeatSelectionFilters = {
  __typename?: 'SeatSelectionFilters';
  seatQuantity: Scalars['Int'];
  sortType: Scalars['String'];
  selectType: Scalars['String'];
};

export type SeatSelectionFiltersInput = {
  seatQuantity: Scalars['Int'];
  sortType: Scalars['String'];
  selectType: Scalars['String'];
};

export type SeatsIoConfigOutput = {
  __typename?: 'SeatsIoConfigOutput';
  isFlicketWorkspace: Scalars['Boolean'];
  region: Scalars['String'];
  publicKey: Scalars['String'];
  secretKey?: Maybe<Scalars['String']>;
  eventKeys: Array<Scalars['String']>;
  thumbnailUrl: Scalars['String'];
};

/** The valid values for seat type (based on seats.io). */
export enum SeatType {
  Seat = 'SEAT',
  GeneralAdmission = 'GENERAL_ADMISSION'
}

export type Section = {
  __typename?: 'Section';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  seatsIoKey?: Maybe<Scalars['Int']>;
  isActive: Scalars['Boolean'];
};

export type SeekaOutput = {
  __typename?: 'SeekaOutput';
  seekaOrganizationId: Scalars['String'];
  seekaPublicKey: Scalars['String'];
  seekaInstanceId: Scalars['String'];
  seekaScopeDescription: Scalars['String'];
  currencyCode?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
};

export type SegmentArgs = {
  __typename?: 'SegmentArgs';
  kind: BroadcastMarketingFiltersV2Kind;
  exclude: Scalars['Boolean'];
  segmentIds: Array<Scalars['String']>;
};

export type SegmentCustomerCountOutput = {
  __typename?: 'SegmentCustomerCountOutput';
  overall: Scalars['Int'];
  emailMarketing: Scalars['Int'];
  smsMarketing: Scalars['Int'];
};

export type SegmentInput = {
  name: Scalars['String'];
  filters: Array<BroadcastMarketingFiltersV2Input>;
};

export type SegmentListOutput = {
  __typename?: 'SegmentListOutput';
  id: Scalars['String'];
  name: Scalars['String'];
  description: Scalars['String'];
  /** The time when the segment's name and/or filters were last updated */
  editedAt: Scalars['DateTime'];
};

export type SegmentOutput = {
  __typename?: 'SegmentOutput';
  id: Scalars['String'];
  name: Scalars['String'];
  filters: Array<BroadcastMarketingFiltersV2Output>;
  description: Scalars['String'];
  /** The time when the segment's name and/or filters were last updated */
  editedAt: Scalars['DateTime'];
};

export type SelectedProductInput = {
  id: Scalars['String'];
};

export type SendBroadcastInput = {
  tags?: Maybe<Array<BroadcastTags>>;
  richTextString: Scalars['String'];
  eventId?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
  packageId?: Maybe<Scalars['String']>;
  audience?: Maybe<BroadcastAudience>;
  fromName: Scalars['String'];
  fromLocalPart?: Maybe<Scalars['String']>;
  fromDomainId?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  subjectRich: Scalars['JSON'];
  /** If the input contains send time, then this is a scheduled email */
  sendTime?: Maybe<Scalars['DateTime']>;
  broadcastId?: Maybe<Scalars['String']>;
  ticketTypeId?: Maybe<Array<Scalars['String']>>;
  zoneId?: Maybe<Array<Scalars['String']>>;
  releaseId?: Maybe<Array<Scalars['String']>>;
  addonId?: Maybe<Array<Scalars['String']>>;
  /** If the input contains test email, then send test email */
  testEmail?: Maybe<Scalars['String']>;
  status: BroadcastStatus;
  type: BroadcastType;
  marketingType?: Maybe<BroadcastMarketingType>;
  marketingFilters?: Maybe<Array<MarketingFiltersInput>>;
  marketingFiltersV2?: Maybe<Array<BroadcastMarketingFiltersV2Input>>;
  transactionalType?: Maybe<BroadcastTransactionalType>;
  style?: Maybe<EmailStyleInput>;
  preheader?: Maybe<Scalars['String']>;
};

export type SendOrderConfirmationInput = {
  notificationType?: Maybe<NotificationType>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type SendOrderConfirmationOutput = {
  __typename?: 'SendOrderConfirmationOutput';
  notificationType: NotificationType;
  email?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type SendTestEmailInput = {
  email: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  subject: Scalars['JSON'];
  richTextTemplate: Scalars['JSON'];
  style: EmailStyleInput;
  eventId?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
  pointItemId?: Maybe<Scalars['String']>;
};

export type SentTicketOutput = {
  __typename?: 'SentTicketOutput';
  /** owner name */
  sender: Scalars['String'];
  activeTickets?: Maybe<Array<Ticket>>;
  totalSentTickets: Scalars['Float'];
  firstTimeLogin: Scalars['Boolean'];
};

export type SeoMetadata = {
  __typename?: 'SeoMetadata';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  title: Scalars['String'];
  description: Scalars['String'];
  keywords?: Maybe<Array<Scalars['String']>>;
  openGraphImageUrl?: Maybe<Scalars['String']>;
  origin?: Maybe<SeoMetadataOrigin>;
  eventId?: Maybe<Scalars['String']>;
  event: Event;
  membershipId?: Maybe<Scalars['String']>;
  membership: Membership;
};

export type SeoMetadataInput = {
  title: Scalars['String'];
  description: Scalars['String'];
  origin: SeoMetadataOrigin;
};

export enum SeoMetadataOrigin {
  UserDefined = 'UserDefined',
  DefaultValues = 'DefaultValues'
}

export type SetPasswordForNewUserInput = {
  password: Scalars['String'];
};

export type SetPosPaymentOptionsInput = {
  posPaymentOptions?: Maybe<PosPaymentOptionsInput>;
  bookingFeeType?: Maybe<FeeType>;
  bookingFee?: Maybe<Scalars['Float']>;
};

export type SetPricingTiersInput = {
  pricingTiers: Array<PricingTierInput>;
};

export enum SetupIntentCancellationSource {
  CustomerOrderPage = 'CustomerOrderPage',
  AdminOrderPage = 'AdminOrderPage',
  DeletedPresale = 'DeletedPresale',
  PaymentFailure = 'PaymentFailure'
}

/** Represents shipping labels. */
export type ShippingLabels = {
  __typename?: 'ShippingLabels';
  /** Shipping label for e-tickets. */
  eTicket?: Maybe<Scalars['String']>;
  /** Shipping label for printed tickets by mail. */
  printedTicketByMail?: Maybe<Scalars['String']>;
  /** Shipping label for printed tickets by courier. */
  printedTicketByCourier?: Maybe<Scalars['String']>;
  /** Shipping label for printed tickets by courier - rural. */
  printedTicketByCourierRural?: Maybe<Scalars['String']>;
  /** Shipping label for printed tickets at venue. */
  printedTicketAtVenue?: Maybe<Scalars['String']>;
};

/** Specifies the input fields for shipping labels. */
export type ShippingLabelsInput = {
  /** Shipping label for e-tickets. */
  eTicket?: Maybe<Scalars['String']>;
  /** Shipping label for printed tickets by mail. */
  printedTicketByMail?: Maybe<Scalars['String']>;
  /** Shipping label for printed tickets by courier. */
  printedTicketByCourier?: Maybe<Scalars['String']>;
  /** Shipping label for printed tickets by courier - rural. */
  printedTicketByCourierRural?: Maybe<Scalars['String']>;
  /** Shipping label for printed tickets at venue. */
  printedTicketAtVenue?: Maybe<Scalars['String']>;
};

export enum ShippingOption {
  Eticket = 'ETICKET',
  PrintedTicketByMail = 'PRINTED_TICKET_BY_MAIL',
  PrintedTicketByCourier = 'PRINTED_TICKET_BY_COURIER',
  PrintedTicketByCourierRural = 'PRINTED_TICKET_BY_COURIER_RURAL',
  PrintedTicketAtVenue = 'PRINTED_TICKET_AT_VENUE'
}

/** Represents shipping options. */
export type ShippingOptions = {
  __typename?: 'ShippingOptions';
  /** Shipping fee for e-tickets. */
  eTicket?: Maybe<Scalars['Float']>;
  /** Shipping fee for printed tickets by mail. */
  printedTicketByMail?: Maybe<Scalars['Float']>;
  /** Shipping fee for printed tickets by courier. */
  printedTicketByCourier?: Maybe<Scalars['Float']>;
  /** Shipping fee for printed tickets by courier - rural. */
  printedTicketByCourierRural?: Maybe<Scalars['Float']>;
  /** Shipping fee for printed tickets at venue. */
  printedTicketAtVenue?: Maybe<Scalars['Float']>;
};

/** Specifies the input fields for shipping options. Set to `null` for unavailability per item. */
export type ShippingOptionsInput = {
  /** Shipping fee for e-tickets. */
  eTicket?: Maybe<Scalars['Float']>;
  /** Shipping fee for printed tickets by mail. */
  printedTicketByMail?: Maybe<Scalars['Float']>;
  /** Shipping fee for printed tickets by courier. */
  printedTicketByCourier?: Maybe<Scalars['Float']>;
  /** Shipping fee for printed tickets by courier - rural. */
  printedTicketByCourierRural?: Maybe<Scalars['Float']>;
  /** Shipping fee for printed tickets at venue. */
  printedTicketAtVenue?: Maybe<Scalars['Float']>;
};

/** Represents a Shopify customer */
export type ShopifyCustomerOrder = {
  __typename?: 'ShopifyCustomerOrder';
  id: Scalars['String'];
  total: Scalars['String'];
  currencyCode: Scalars['String'];
  lineItems: Array<ShopifyLineItem>;
};

export type ShopifyIntegration = {
  __typename?: 'ShopifyIntegration';
  storefrontAccessToken: Scalars['String'];
  shopDomain: Scalars['String'];
  navLinkLabel: Scalars['String'];
  navLinkUrl: Scalars['String'];
};

export type ShopifyLineItem = {
  __typename?: 'ShopifyLineItem';
  id: Scalars['String'];
  title: Scalars['String'];
  quantity: Scalars['Float'];
};

export type ShopifyProductDto = {
  __typename?: 'ShopifyProductDto';
  id: Scalars['String'];
  url: Scalars['String'];
  name: Scalars['String'];
  price: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
};

export type ShopifyProductsDto = {
  __typename?: 'ShopifyProductsDto';
  products: Array<ShopifyProductDto>;
  storeUrl: Scalars['String'];
  showUpsell: Scalars['Boolean'];
  customizedUpsell: Scalars['Boolean'];
};

export type ShopifySettings = {
  __typename?: 'ShopifySettings';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
  navLinkLabel: Scalars['String'];
  showNavLink: Scalars['Boolean'];
  alwaysShowPostPurchase: Scalars['Boolean'];
};

export type ShopifySettingsInput = {
  url: Scalars['String'];
  navLinkLabel: Scalars['String'];
  showNavLink: Scalars['Boolean'];
  alwaysShowPostPurchase: Scalars['Boolean'];
  selectedProducts: Array<SelectedProductInput>;
};

export type ShopifySetupInput = {
  token: Scalars['String'];
};

export type ShopifyUser = {
  __typename?: 'ShopifyUser';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** Shopify user ID */
  shopifyUserId: Scalars['String'];
  /** Total amount spent on Shopify store with currency code */
  totalSpent?: Maybe<Scalars['String']>;
};

/** Mapping of a shortened URL to its full path */
export type ShortUrl = {
  __typename?: 'ShortUrl';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** Unique sequence number. The short URL is this number in base62, padded to 4 characters. */
  sequenceId: Scalars['Float'];
  /** Full original URL path to redirect to. */
  originalUrl: Scalars['String'];
  /** Number of times the shortened URL has redirected to the full path. */
  timesUsed: Scalars['Float'];
  publicShortUrl: Scalars['String'];
};

export type SignupFormFieldInput = {
  id?: Maybe<Scalars['String']>;
  type: NamingFieldType;
  label: Scalars['String'];
  required: Scalars['Boolean'];
  options?: Maybe<Array<Scalars['String']>>;
  orderKey: Scalars['Float'];
};

export type SignupFormFieldOutput = {
  __typename?: 'SignupFormFieldOutput';
  id: Scalars['String'];
  name: Scalars['String'];
  type: NamingFieldType;
  label: Scalars['String'];
  required: Scalars['Boolean'];
  options?: Maybe<Array<Scalars['String']>>;
  orderKey: Scalars['Float'];
  isLocked: Scalars['Boolean'];
};

export type SignupFormFieldValue = {
  signUpFormFieldId: Scalars['String'];
  label: Scalars['String'];
  value: Scalars['String'];
  type: NamingFieldType;
};

export type SignupFormOutput = {
  __typename?: 'SignupFormOutput';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  heading: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  buttonText: Scalars['String'];
  /** tag entityIds */
  tags: SignUpFormTagEntityIds;
  formFields: Array<SignupFormFieldOutput>;
  styles: SignupFormStyles;
  successMessage: Scalars['String'];
  successHeading: Scalars['String'];
  processedCustomCSS: Scalars['String'];
  submissionCount: Scalars['Float'];
};

export type SignupFormStyles = {
  __typename?: 'SignupFormStyles';
  backgroundColour: Scalars['String'];
  textColour: Scalars['String'];
  buttonColour: Scalars['String'];
  customCSS: Scalars['String'];
};

export type SignupFormStylesInput = {
  backgroundColour: Scalars['String'];
  textColour: Scalars['String'];
  buttonColour: Scalars['String'];
  customCSS: Scalars['String'];
};

export type SignupFormTag = {
  value: Scalars['String'];
  type: TagType;
  label?: Maybe<Scalars['String']>;
  isNew?: Maybe<Scalars['Boolean']>;
};

export type SignUpFormTagEntityIds = {
  __typename?: 'SignUpFormTagEntityIds';
  /** Entity Ids of either an eventId, membershipId or tagId */
  entityIds?: Maybe<Array<Scalars['String']>>;
};

export type SmsBroadcastAudienceOutput = {
  __typename?: 'SMSBroadcastAudienceOutput';
  totalCostInCents: Scalars['Float'];
  audienceSize: Scalars['Float'];
};

export type SmsBroadcastDeliveryError = {
  __typename?: 'SMSBroadcastDeliveryError';
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type SmsBroadcastDeliveryErrorsOutput = {
  __typename?: 'SMSBroadcastDeliveryErrorsOutput';
  smsBroadcastId: Scalars['String'];
  totalCount: Scalars['Float'];
  deliveryErrors: Array<SmsBroadcastDeliveryError>;
};

export type SmsBroadcastFilterCountInput = {
  filters?: Maybe<Array<BroadcastMarketingFiltersV2Input>>;
};

export type SmsBroadcastListOutput = {
  __typename?: 'SMSBroadcastListOutput';
  id: Scalars['String'];
  subject: Scalars['String'];
  scheduledAt: Scalars['DateTime'];
  status: BroadcastStatus;
  recipientCount: Scalars['Float'];
  lastEditedBy?: Maybe<User>;
};

export type SmsBroadcastOutput = {
  __typename?: 'SMSBroadcastOutput';
  id: Scalars['String'];
  status: BroadcastStatus;
  scheduledAt: Scalars['DateTime'];
  subject: Scalars['String'];
  message: Scalars['String'];
  sentMessageContent?: Maybe<Scalars['String']>;
  recipientCount: Scalars['Float'];
  deliveryCount: Scalars['Float'];
  bounceCount: Scalars['Float'];
  deliveryRate: Scalars['Float'];
  unsubscribeCount: Scalars['Float'];
  uniqueClicksCount: Scalars['Float'];
  conversionCount: Scalars['Float'];
  generatedRevenue: Scalars['Float'];
  totalCostInCents: Scalars['Float'];
  hasTrackingLink: Scalars['Boolean'];
  marketingFilters?: Maybe<Array<BroadcastMarketingFiltersV2Output>>;
  lastEditedBy?: Maybe<User>;
  tags: TagEntityIds;
  conversionPercentage: Scalars['Float'];
};

export type SmsBroadcastSaveOutput = {
  __typename?: 'SMSBroadcastSaveOutput';
  id: Scalars['ID'];
};

export type SmsBroadcastUnsubscribe = {
  __typename?: 'SMSBroadcastUnsubscribe';
  name: Scalars['String'];
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type SmsBroadcastUnsubscribesOutput = {
  __typename?: 'SMSBroadcastUnsubscribesOutput';
  smsBroadcastId: Scalars['String'];
  totalCount: Scalars['Float'];
  unsubscribes: Array<SmsBroadcastUnsubscribe>;
};

export type SocialAuthInput = {
  socialAuthType: SocialAuthType;
  accessToken: Scalars['String'];
};

/** Social authentication type */
export enum SocialAuthType {
  Facebook = 'Facebook',
  Google = 'Google'
}

export type SocialConnection = {
  __typename?: 'SocialConnection';
  pageInfo: PageInfo;
  edges: Array<SocialMentionEdge>;
  totalCount: Scalars['Int'];
};

export type SocialMention = {
  __typename?: 'SocialMention';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  type: Scalars['String'];
  /** igsid of customer, exist for story mentions */
  senderId?: Maybe<Scalars['String']>;
  /** igid of organisation */
  recipientId: Scalars['String'];
  /** id of comment */
  commentId?: Maybe<Scalars['String']>;
  /** id of media */
  mediaId?: Maybe<Scalars['String']>;
  /** content of comment mention and media mention */
  content?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  /** url of mentions */
  url: Scalars['String'];
};

export type SocialMentionEdge = {
  __typename?: 'SocialMentionEdge';
  cursor: Scalars['String'];
  node: SocialMention;
};

export type SocialWhereInput = {
  mentionType?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
};

export type SplitOrderInput = {
  /** List of the order's line items ids that need to be transfered. */
  lineItemIds: Array<Scalars['String']>;
  /** User id can be provided for new order */
  userId?: Maybe<Scalars['String']>;
  /** Delivery method for the new order */
  deliveryMethod: ShippingOption;
  /** Multi buy promotion id for current order. */
  curMultiBuyId?: Maybe<Scalars['String']>;
  /** Multi buy promotion id for new order. */
  newMultiBuyId?: Maybe<Scalars['String']>;
  newTicketTypes?: Maybe<Array<SplitOrderTicketTypes>>;
};

export type SplitOrderTicketTypes = {
  lineItemId: Scalars['String'];
  ticketTypeId: Scalars['String'];
};

export type StartDateHistory = {
  __typename?: 'StartDateHistory';
  /** The start date of the presale when it was disabled */
  startDate: Scalars['DateTime'];
  /** The date when the presale was disabled */
  disabledAt: Scalars['DateTime'];
};

export type StatisticTooltip = {
  __typename?: 'StatisticTooltip';
  content: Scalars['String'];
  /** Link for the learn More button. This should be a link to the external documentation page. */
  link?: Maybe<Scalars['String']>;
};

/** File storage type. */
export enum StorageType {
  Local = 'Local',
  Google = 'Google'
}

export type StringStatistic = {
  __typename?: 'StringStatistic';
  label: Scalars['String'];
  tooltip?: Maybe<StatisticTooltip>;
  value: Scalars['String'];
};

export type StripeConfigOutput = {
  __typename?: 'StripeConfigOutput';
  integrationId: Scalars['String'];
  publishableKey: Scalars['String'];
  connectedAccountId?: Maybe<Scalars['String']>;
  expressCheckoutEnabled?: Maybe<Scalars['Boolean']>;
};

export type StripeConnectAccount = {
  __typename?: 'StripeConnectAccount';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  stripeAccountId: Scalars['String'];
  organization: Organization;
  integration?: Maybe<Integration>;
  setupState: StripeConnectSetupState;
  stripePublishableKey: Scalars['String'];
};

/** Stripe Connect setup state. */
export enum StripeConnectSetupState {
  Incomplete = 'INCOMPLETE',
  Pending = 'PENDING',
  Restricted = 'RESTRICTED',
  Active = 'ACTIVE'
}

export type StripePaymentContext = {
  __typename?: 'StripePaymentContext';
  redirectUrl?: Maybe<Scalars['String']>;
  checkoutUrl: Scalars['String'];
  orderId: Scalars['String'];
  stripeAccountId: Scalars['String'];
  publishableKey?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
};

/** Payment method used with Stripe. */
export enum StripePaymentMethod {
  CreditCard = 'CreditCard',
  Afterpay = 'Afterpay',
  GooglePay = 'GooglePay',
  ApplePay = 'ApplePay',
  Link = 'Link',
  Klarna = 'Klarna',
  PayPal = 'PayPal',
  AmazonPay = 'AmazonPay'
}

export type StripeSetupIntentCardOutput = {
  __typename?: 'StripeSetupIntentCardOutput';
  brand: Scalars['String'];
  last4: Scalars['String'];
  expMonth: Scalars['Float'];
  expYear: Scalars['Float'];
};

export type SubmissionInput = {
  signUpFormId: Scalars['String'];
  fieldValues: Array<SignupFormFieldValue>;
};

export type SummaryOverviewOutput = {
  __typename?: 'SummaryOverviewOutput';
  ticketsIssued?: Maybe<Scalars['Float']>;
  membershipsIssued?: Maybe<Scalars['Float']>;
  addonsIssued?: Maybe<Scalars['Float']>;
  orders?: Maybe<Scalars['Float']>;
  cartAbandonment?: Maybe<Scalars['Float']>;
  returningCustomers?: Maybe<Scalars['Float']>;
  ticketsSold?: Maybe<Scalars['Float']>;
  ticketsComp?: Maybe<Scalars['Float']>;
  totalNetRevenue?: Maybe<Scalars['Float']>;
  todayNetRevenue?: Maybe<Scalars['Float']>;
  yesterdayNetRevenue?: Maybe<Scalars['Float']>;
  ticketsSoldToday?: Maybe<Scalars['Float']>;
  ticketsSoldYesterday?: Maybe<Scalars['Float']>;
  ticketsPartPaid?: Maybe<Scalars['Float']>;
  membershipsPartPaid?: Maybe<Scalars['Float']>;
  ordersPartPaid?: Maybe<Scalars['Float']>;
  membershipsRenewed?: Maybe<Scalars['Float']>;
  totalFaceRevenue?: Maybe<Scalars['Float']>;
  faceRevenueToday?: Maybe<Scalars['Float']>;
  faceRevenueYesterday?: Maybe<Scalars['Float']>;
};

export type Tag = {
  __typename?: 'Tag';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
};

export type TagArgs = {
  __typename?: 'TagArgs';
  kind: BroadcastMarketingFiltersV2Kind;
  exclude: Scalars['Boolean'];
  tagIds: Array<Scalars['String']>;
};

export type TagEntitiesInput = {
  /** tag ids */
  tags: Array<Scalars['String']>;
  entityIds?: Maybe<Array<Scalars['String']>>;
  scoutCommunicationId?: Maybe<Scalars['String']>;
};

export type TagEntityIds = {
  __typename?: 'TagEntityIds';
  /** Entity Ids of either an eventId, membershipId or tagId */
  entityIds?: Maybe<Array<Scalars['String']>>;
};

export enum TagType {
  Tag = 'TAG',
  Event = 'EVENT',
  Membership = 'MEMBERSHIP'
}

export type Tax = {
  __typename?: 'Tax';
  name: Scalars['String'];
  value: Scalars['Float'];
  isExclusive: Scalars['Boolean'];
};

export type TaxApplied = {
  __typename?: 'TaxApplied';
  name: Scalars['String'];
  value: Scalars['Float'];
  isExclusive: Scalars['Boolean'];
  total: Scalars['Float'];
};

/** The tax calculation method, either inclusive or exclusive */
export enum TaxCalculationMethod {
  Inclusive = 'INCLUSIVE',
  Exclusive = 'EXCLUSIVE'
}

export type TaxInput = {
  name: Scalars['String'];
  value: Scalars['Float'];
  isExclusive: Scalars['Boolean'];
};

export type TerminalLatestTransactionStatus = {
  __typename?: 'TerminalLatestTransactionStatus';
  status: OrderTransactionStatus;
  message?: Maybe<Scalars['String']>;
  failureCode?: Maybe<Scalars['String']>;
};

export type Ticket = {
  __typename?: 'Ticket';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** Ticket owner. Not all tickets have users. */
  user?: Maybe<User>;
  /** Ticket number */
  ticketNumber: Scalars['String'];
  /** Ticket creation origin */
  origin: TicketOrigin;
  /** Ticket status */
  status: TicketStatus;
  /** Ticket event. Only available for single tickets. */
  event?: Maybe<Event>;
  /** Ticket release. Only available for single tickets. */
  release?: Maybe<Release>;
  /** Ticket seat label. Only available for seated events. */
  seatLabel?: Maybe<Scalars['String']>;
  /** Ticket seat zone. Only available for seated events. */
  seatZone?: Maybe<Scalars['String']>;
  seatZoneEntity?: Maybe<Zone>;
  /** Ticket seat section. Only available for seated events. */
  seatSection?: Maybe<Scalars['String']>;
  seatSectionEntity?: Maybe<Section>;
  /** Ticket seat type. Only available for seated events. */
  seatType?: Maybe<SeatType>;
  /** Ticket seat tags. Only available for seated events. */
  seatTags?: Maybe<Array<Scalars['String']>>;
  /** Indicates if the claim for the seat has been released for the next membership. */
  hasReleasedNextMembershipClaim: Scalars['Boolean'];
  ticketTransfer?: Maybe<TicketTransfer>;
  /** Indicates if all required ticket holder naming fields have been filled in. */
  isNamed: Scalars['Boolean'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Gender>;
  postalCode?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  memberSince?: Maybe<Scalars['DateTime']>;
  licensePlate?: Maybe<Scalars['String']>;
  membershipNumber?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  dietaryRequirements?: Maybe<Scalars['String']>;
  lengthOfStay?: Maybe<Scalars['String']>;
  usableForEmailMarketing?: Maybe<Scalars['Boolean']>;
  usableForSMSMarketing?: Maybe<Scalars['Boolean']>;
  vaccinePass?: Maybe<VaccinePass>;
  emergencyName?: Maybe<Scalars['String']>;
  emergencyContact?: Maybe<Scalars['String']>;
  emergencyContactRelationship?: Maybe<Scalars['String']>;
  customFields?: Maybe<Array<CustomField>>;
  dunedinResidentialAddress?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['String']>;
  membershipSubscriptionId?: Maybe<Scalars['String']>;
  /** Timestamp when ticket was most recently preprinted. */
  preprint?: Maybe<Scalars['DateTime']>;
  scans?: Maybe<Array<Scan>>;
  ticketSendFields?: Maybe<Array<TicketSendFields>>;
  firstScanIn?: Maybe<Scan>;
  lastScanOut?: Maybe<Scan>;
  ticketCover?: Maybe<TicketTicketCover>;
  downloadCount: Scalars['Float'];
  firstScanInId?: Maybe<Scalars['String']>;
  /**
   * Only populated if at least the relations ['event', 'event.venue', 'event.venue.gates'] are loaded,
   *       Also load ['event.eventAddon'] if used for getting scannable gates from event addon
   */
  gates?: Maybe<Array<Gate>>;
  /** The membership type associated with the ticket. */
  membershipType?: Maybe<MembershipType>;
  /** The ticket type associated with the ticket. */
  ticketType?: Maybe<TicketType>;
  lineItem?: Maybe<LineItem>;
  maxTransferPrice?: Maybe<Scalars['Float']>;
  order?: Maybe<Order>;
  isHold: Scalars['Boolean'];
  displayName: Scalars['String'];
  parentTicketNumber?: Maybe<Scalars['String']>;
  /**
   * Returns the transfer fee paid for the ticket. If the ticket was sold, it will
   * include the seller fee. If the ticket was bought through a transfer, it will
   * include the buyer fee.
   */
  transferFee?: Maybe<TicketTransferFee>;
  digitalPassCode?: Maybe<Scalars['String']>;
  digitalEventUrl?: Maybe<Scalars['String']>;
  shouldBeNamed: Scalars['Boolean'];
  qrCode: Scalars['String'];
  hasRenewedMembership: Scalars['Boolean'];
  /** Parent ticket. Only available for single tickets that are child tickets of a membership. */
  parentTicket?: Maybe<Ticket>;
  childTickets?: Maybe<Array<Ticket>>;
  membership?: Maybe<Membership>;
  addon?: Maybe<AddonUnion>;
  transferStatus?: Maybe<TicketTransferStatus>;
  resellabilityState: TicketResellabilityState;
  purchaseRestrictionText?: Maybe<Array<Scalars['String']>>;
  isReleasable: Scalars['Boolean'];
};

export enum TicketAvailabilityStatus {
  Available = 'AVAILABLE',
  AllocationExhausted = 'ALLOCATION_EXHAUSTED',
  Soldout = 'SOLDOUT'
}

export type TicketConnection = {
  __typename?: 'TicketConnection';
  pageInfo: PageInfo;
  edges: Array<TicketEdge>;
  totalCount: Scalars['Int'];
};

export type TicketCoverAmount = {
  __typename?: 'TicketCoverAmount';
  totalFeeAmount: Scalars['Float'];
};

export type TicketCoverInput = {
  /** Promoter fee as percentage of ticket price */
  promoterFeePercentage: Scalars['Float'];
  /** Ticket cover purchase behaviour */
  purchaseBehaviour: TicketCoverPurchaseBehaviour;
  /** Whether ticket cover is enabled */
  isEnabled: Scalars['Boolean'];
};

export enum TicketCoverPurchaseBehaviour {
  Optional = 'Optional',
  Additional = 'Additional',
  Included = 'Included'
}

export type TicketEdge = {
  __typename?: 'TicketEdge';
  cursor: Scalars['String'];
  node: Ticket;
};

/** Options to configure Ticket Entry time Enforcement */
export type TicketEntryTimeEnforcementOptions = {
  __typename?: 'TicketEntryTimeEnforcementOptions';
  /** If entry time enforcement is enabled for this event */
  enabled: Scalars['Boolean'];
  /**
   * If set to a non 0 value, will allow entry up to the specific number of
   * minutes, prior to the configured ticket entry time. 
   */
  gracePeriodMinutes: Scalars['Float'];
};

export type TicketNotAvailableError = CreateOrderError & {
  __typename?: 'TicketNotAvailableError';
  message: Scalars['String'];
  shouldDisplayWaitlist: Scalars['Boolean'];
  eventId: Scalars['String'];
  releaseId: Scalars['String'];
};

/** Ticket creation origin. */
export enum TicketOrigin {
  Order = 'ORDER',
  Import = 'IMPORT'
}

export type TicketRefundData = {
  __typename?: 'TicketRefundData';
  ticket: Ticket;
  ticketLevelComponents: Array<OrderComponent>;
};

export type TicketResellabilityState = {
  __typename?: 'TicketResellabilityState';
  ticketTransferAllowed: Scalars['Boolean'];
  ticketResaleAllowed: Scalars['Boolean'];
  hoursLeftToTransfer: Scalars['Float'];
  /** Number of days Afterpay orders are allowed to be refunded. */
  afterpayRefundWindow?: Maybe<Scalars['Float']>;
  /** The latest date that a transfer can be completed. Only relevant to Afterpay orders. */
  latestTransferCompletionDate?: Maybe<Scalars['DateTime']>;
  /**
   * The reason why the ticket is not resellable. This field is only present when
   * ticketResaleAllowed or ticketTransferAllowed is false
   */
  reason?: Maybe<Scalars['String']>;
};

/** Scanner direction. */
export enum TicketScanDirection {
  ScanIn = 'SCAN_IN',
  ScanOut = 'SCAN_OUT'
}

/** Ticket scan type. */
export enum TicketScanType {
  Eticket = 'ETICKET',
  Hardcopy = 'HARDCOPY',
  Digital = 'DIGITAL',
  Pos = 'POS'
}

/** Ticket scan validations. */
export enum TicketScanValidations {
  EntryTime = 'ENTRY_TIME'
}

export type TicketSendFields = {
  __typename?: 'TicketSendFields';
  active: Scalars['Boolean'];
  email: Scalars['String'];
};

/** Ticket status. */
export enum TicketStatus {
  Active = 'ACTIVE',
  SeatChanged = 'SEAT_CHANGED',
  TicketChangePending = 'TICKET_CHANGE_PENDING',
  OrderCanceled = 'ORDER_CANCELED',
  OrderChanged = 'ORDER_CHANGED',
  Released = 'RELEASED',
  Refunded = 'REFUNDED',
  Transferred = 'TRANSFERRED',
  TransferPending = 'TRANSFER_PENDING',
  MarkedForResale = 'MARKED_FOR_RESALE'
}

export type TicketTicketCover = {
  __typename?: 'TicketTicketCover';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  perTicketAmount: Scalars['Float'];
  orderTicketCover: OrderTicketCover;
};

export type TicketTransfer = {
  __typename?: 'TicketTransfer';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  transferStatus: TicketTransferStatus;
  newOwnerEmail?: Maybe<Scalars['String']>;
  buyerTransferFee: Scalars['Float'];
  sellerTransferFee: Scalars['Float'];
  originalLineItemPrice: Scalars['Float'];
  newLineItemPrice: Scalars['Float'];
  transferGroupId?: Maybe<Scalars['String']>;
};

export type TicketTransferBuyer = {
  __typename?: 'TicketTransferBuyer';
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  purchasePrice: Scalars['Float'];
  buyerTransferFee: Scalars['Float'];
  newOrderNumber: Scalars['String'];
};

export type TicketTransferExportOutput = {
  __typename?: 'TicketTransferExportOutput';
  ticketBuyer: TicketTransferBuyer;
  ticketSeller: TicketTransferSeller;
  ticketType: Scalars['String'];
  transferType: Scalars['String'];
};

export type TicketTransferExportResultOutput = {
  __typename?: 'TicketTransferExportResultOutput';
  results: Array<TicketTransferExportOutput>;
};

export type TicketTransferFee = {
  __typename?: 'TicketTransferFee';
  type: TransferFeeType;
  fee: Scalars['Float'];
};

export type TicketTransferForAdmin = {
  __typename?: 'TicketTransferForAdmin';
  id: Scalars['String'];
  newOrderId: Scalars['String'];
  newOrderNumber: Scalars['String'];
  productName: Scalars['String'];
  transferredAt: Scalars['DateTime'];
  refundStatus?: Maybe<TransferRefundStatus>;
  refundFailureMessage?: Maybe<Scalars['String']>;
  transferStatus: TicketTransferStatus;
  amountToRefund: Scalars['Float'];
};

export type TicketTransferSeller = {
  __typename?: 'TicketTransferSeller';
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  sellerTransferFee: Scalars['Float'];
  refundAmount: Scalars['Float'];
  hasBeenRefunded: Scalars['Boolean'];
  originalOrderNumber: Scalars['String'];
  originalPurchasePrice: Scalars['Float'];
};

/** The status of the ticket transfer. */
export enum TicketTransferStatus {
  Pending = 'PENDING',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED'
}

/** Ticket type. */
export type TicketType = {
  __typename?: 'TicketType';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  event: Event;
  /** The kind of the ticket type. */
  kind: TicketTypeKind;
  quantity?: Maybe<Scalars['Int']>;
  minPurchaseQuantity?: Maybe<Scalars['Int']>;
  maxPurchaseQuantity?: Maybe<Scalars['Int']>;
  /** Whether the ticket type is grouped. */
  isGrouped: Scalars['Boolean'];
  /** Whether the ticket type is for a child. */
  isChild: Scalars['Boolean'];
  /** Whether the ticket type can only be purchased by businesses. Makes company name required during checkout. */
  isBusinessOnly: Scalars['Boolean'];
  /** The amount of people in a group. Returns null if the ticket type is not grouped. */
  groupAmount?: Maybe<Scalars['Int']>;
  /** Number of tickets that must be purchased in this set. */
  quantitySet?: Maybe<Scalars['Int']>;
  /** Ticket group name. */
  name: Scalars['String'];
  /** Ticket type allowed dates. */
  dates: Array<TicketTypeDate>;
  /** Custom entry dates for this ticket type. */
  entryDates?: Maybe<Array<EventDate>>;
  /** Display ticket start time. */
  showStartTime: Scalars['Boolean'];
  /** Display ticket end time. */
  showEndTime: Scalars['Boolean'];
  /** Ticket fee type. */
  bookingFeeType: FeeType;
  /** Ticket fee. */
  bookingFee: Scalars['Float'];
  /** Per ticket stadium levy ticket fee. */
  stadiumLevyFee?: Maybe<Scalars['Float']>;
  /** Mark a ticket type as high demand */
  inHighDemand: Scalars['Boolean'];
  /** Custom badge text for ticket type (max 50 chars) */
  customBadge?: Maybe<Scalars['String']>;
  /** Custom badge background color (hex code) */
  customBadgeBackgroundColor?: Maybe<Scalars['String']>;
  /** Custom badge text color (hex code) */
  customBadgeTextColor?: Maybe<Scalars['String']>;
  /** Mark a ticket type as sold out */
  soldOut: Scalars['Boolean'];
  /** Whether to hide the ticket price in customer portal when the ticket type is marked as sold out */
  hidePriceWhenSoldOut: Scalars['Boolean'];
  /** Ticket description */
  description?: Maybe<Scalars['String']>;
  /** Restrictions for the ticket group. */
  restrictions?: Maybe<Scalars['String']>;
  /** Print at home information for the ticket group. */
  printAtHomeInformation?: Maybe<Scalars['String']>;
  /** Image for the bottom of the print at home ticket . Returns null if the not set. */
  ticketBanner?: Maybe<ExtendedFile>;
  /** Image to be shown on the customer portal of the ticket . Returns null if the not set. */
  ticketImage?: Maybe<ExtendedFile>;
  /** Image gallery for ticket listing and sub-page. */
  imageGallery: Array<ImageGalleryItem>;
  namingFields: Array<FormField>;
  price?: Maybe<Scalars['Float']>;
  /** Intellitix access IDs */
  intellitixIds?: Maybe<Array<Scalars['String']>>;
  isResaleTicket: Scalars['Boolean'];
  /** The resale ticket type that this ticket will be transformed into when resold. */
  resaleTicketTypeId?: Maybe<Scalars['String']>;
  /** If this is a resale ticket, this is the array of ticketTypes that is grouped under this resale ticket */
  resaleTicketTypes: Array<TicketType>;
  /** Number of fans on waitlist */
  waitlistFanCount: Scalars['Int'];
  resaleHiddenFromPublic: Scalars['Boolean'];
  hasCustomDates: Scalars['Boolean'];
  isUsherDisabled: Scalars['Boolean'];
  /** The configuration for the customised ticket type on sale date. The value is null if the ticket type is not customised. */
  onSaleConfig?: Maybe<TicketTypeOnSaleConfig>;
  isOnSale: Scalars['Boolean'];
  /**
   * If the ticket type is on sale, it returns null. 
   *       Otherwise, it returns the message that should be displayed.
   */
  notOnSaleMessage?: Maybe<Scalars['String']>;
  onSaleStatus: TicketTypeOnSaleStatus;
  pricingTiers: Array<PricingTierOutput>;
  canUsePricingTiers: Scalars['Boolean'];
  tags: Array<Tag>;
  totalSold?: Maybe<Scalars['Int']>;
  zones?: Maybe<Array<Zone>>;
};

export type TicketTypeArgs = {
  __typename?: 'TicketTypeArgs';
  kind: BroadcastMarketingFiltersV2Kind;
  exclude: Scalars['Boolean'];
  ticketTypeIds: Array<Scalars['String']>;
};

/** Allowed date for the ticket type. */
export type TicketTypeDate = {
  __typename?: 'TicketTypeDate';
  eventDateId: Scalars['ID'];
  /** Alternate entry time for the date. */
  alternateEntryTime?: Maybe<Scalars['String']>;
};

/** The subset of ticket types the caller would like returned as part of the event */
export enum TicketTypeFilter {
  All = 'ALL',
  ResaleOnly = 'RESALE_ONLY'
}

/** Ticket kind for ticket type. */
export enum TicketTypeKind {
  Standard = 'STANDARD',
  ComplimentaryNamed = 'COMPLIMENTARY_NAMED',
  ComplimentaryUnnamed = 'COMPLIMENTARY_UNNAMED',
  Usher = 'USHER',
  Addon = 'ADDON'
}

export enum TicketTypeOnSaleCondition {
  TicketType = 'TICKET_TYPE',
  Date = 'DATE'
}

export type TicketTypeOnSaleConfig = {
  __typename?: 'TicketTypeOnSaleConfig';
  startConfig: TicketTypeOnSaleStartConfig;
  endDate: Scalars['DateTime'];
};

export type TicketTypeOnSaleConfigInput = {
  startConfig: TicketTypeOnSaleStartConfigInput;
  endDate: Scalars['DateTime'];
};

export type TicketTypeOnSaleStartConfig = {
  __typename?: 'TicketTypeOnSaleStartConfig';
  condition: TicketTypeOnSaleCondition;
  startDate?: Maybe<Scalars['DateTime']>;
  ticketTypeId?: Maybe<Scalars['ID']>;
};

export type TicketTypeOnSaleStartConfigInput = {
  condition: TicketTypeOnSaleCondition;
  startDate?: Maybe<Scalars['DateTime']>;
  ticketTypeId?: Maybe<Scalars['ID']>;
};

export enum TicketTypeOnSaleStatus {
  NotYetOnSale = 'NotYetOnSale',
  OnSale = 'OnSale',
  OnSaleEnded = 'OnSaleEnded'
}

export type TicketTypePurchaseTotal = {
  __typename?: 'TicketTypePurchaseTotal';
  ticketType: TicketType;
  total: Scalars['Int'];
};

export type TicketTypesByIdInput = {
  ticketTypeIds: Array<Scalars['String']>;
};

export type TicketWhereInput = {
  /** Fuzzy search query. */
  q?: Maybe<Scalars['String']>;
};

export type TokenSet = {
  __typename?: 'TokenSet';
  idToken?: Maybe<Scalars['String']>;
  accessToken?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['Float']>;
  tokenType?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
};

export type TopReferrersOutput = {
  __typename?: 'TopReferrersOutput';
  name?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['String']>;
};

export type TopRepeatPurchasers = {
  __typename?: 'TopRepeatPurchasers';
  name?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['String']>;
};

export type TopTagsOutput = {
  __typename?: 'TopTagsOutput';
  tag?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Float']>;
};

export type TrackingCodeCreateInput = {
  eventId: Scalars['String'];
  title: Scalars['String'];
};

export type TrackingCodeOrderInput = {
  trackingCodeTitle: Scalars['String'];
  eventId: Scalars['String'];
  orderId: Scalars['String'];
};

export type TrackingCodeOutput = {
  __typename?: 'TrackingCodeOutput';
  id: Scalars['ID'];
  title: Scalars['String'];
  eventId: Scalars['String'];
  url: Scalars['String'];
  visitorCount: Scalars['Float'];
  sales: Scalars['Float'];
  totalTicketRevenue: Scalars['Float'];
  ticketsSold: Scalars['Float'];
  createdAt: Scalars['DateTime'];
};

export type TrackingCodeVisitInput = {
  trackingCodeTitle: Scalars['String'];
  eventId: Scalars['String'];
};

export type TransactionOrderByInput = {
  createdAt?: Maybe<OrderByDirection>;
};

/** Transfer fee type. */
export enum TransferFeeType {
  Buyer = 'BUYER',
  Seller = 'SELLER'
}

/** The status of the refund for the ticket transfer */
export enum TransferRefundStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Skipped = 'SKIPPED'
}

export type TwoFactorAuthenticationCodeInput = {
  twoFactorAuthenticationCode: Scalars['String'];
};

export type TwoFactorAuthenticationSetupResult = {
  __typename?: 'TwoFactorAuthenticationSetupResult';
  dataURL: Scalars['String'];
  secret: Scalars['String'];
};

/** UnsubscribeReason reason. */
export enum UnsubscribeReason {
  NoLongerInterested = 'NoLongerInterested',
  NeverSubscribed = 'NeverSubscribed',
  TooFrequent = 'TooFrequent',
  Other = 'OTHER'
}

export type UpdateAutomationInput = {
  name?: Maybe<Scalars['String']>;
  automationType?: Maybe<AutomationType>;
  templateId?: Maybe<Scalars['Float']>;
  subject?: Maybe<Scalars['String']>;
  listId?: Maybe<Scalars['String']>;
  targetSource?: Maybe<ReportingFilterSource>;
  targetSourceId?: Maybe<Scalars['String']>;
  targetReleaseId?: Maybe<Scalars['String']>;
  timeOfDay?: Maybe<Scalars['DateTime']>;
  templateName?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
};

export type UpdateCalendarHomepageCustomizationInput = {
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  banner?: Maybe<Scalars['Upload']>;
};

export type UpdateCreditsInput = {
  credits: Scalars['Float'];
};

/** Updates the info for a digital event/membership. */
export type UpdateDigitalInfoInput = {
  /** The url that digital pass codes are appended to in order to access the digital event/membership. */
  url?: Maybe<Scalars['String']>;
  /** The Postmark email template that is used to send digital pass codes. */
  emailTemplateId?: Maybe<Scalars['String']>;
  additionalEmailInfo?: Maybe<AdditionalEmailInfoInput>;
};

export type UpdateEmailCustomizationInput = {
  emailType: EmailType;
  eventId?: Maybe<Scalars['String']>;
  status?: Maybe<EmailCustomizationStatus>;
  membershipId?: Maybe<Scalars['String']>;
  pointItemId?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['JSON']>;
  richTextTemplate?: Maybe<Scalars['JSON']>;
  style?: Maybe<EmailStyleInput>;
};

export type UpdateEventAddonInput = {
  /** The name of the addon. */
  name?: Maybe<Scalars['String']>;
  /** Indicates whether naming the addon is possible or not. */
  enableNaming?: Maybe<Scalars['Boolean']>;
  /** Maximum quantity to be sold for the addon. */
  quantity?: Maybe<Scalars['Float']>;
  /** The price associated with the addon. */
  price?: Maybe<Scalars['Float']>;
  /** The brief description of the addon. */
  description?: Maybe<Scalars['String']>;
  /** Images for the ticket gallery */
  imageGallery?: Maybe<Array<ImageGalleryItemInput>>;
  /** The restrictions applied to the addon. */
  restrictions?: Maybe<Scalars['String']>;
  /** The active status of the addon. */
  isActive?: Maybe<Scalars['Boolean']>;
  namingFields?: Maybe<Array<FormFieldInput>>;
  /** Image banner specific for a ticket type on the print at home ticket */
  addonImage?: Maybe<Scalars['Upload']>;
  insideFee?: Maybe<Scalars['Float']>;
  /** Whether hide QR code on ticket. */
  hideQRCode?: Maybe<Scalars['Boolean']>;
  /** The intellitix access ID that matches this addon */
  intellitixId?: Maybe<Scalars['String']>;
};

export type UpdateEventAddonInputWithId = {
  /** The name of the addon. */
  name?: Maybe<Scalars['String']>;
  /** Indicates whether naming the addon is possible or not. */
  enableNaming?: Maybe<Scalars['Boolean']>;
  /** Maximum quantity to be sold for the addon. */
  quantity?: Maybe<Scalars['Float']>;
  /** The price associated with the addon. */
  price?: Maybe<Scalars['Float']>;
  /** The brief description of the addon. */
  description?: Maybe<Scalars['String']>;
  /** Images for the ticket gallery */
  imageGallery?: Maybe<Array<ImageGalleryItemInput>>;
  /** The restrictions applied to the addon. */
  restrictions?: Maybe<Scalars['String']>;
  /** The active status of the addon. */
  isActive?: Maybe<Scalars['Boolean']>;
  namingFields?: Maybe<Array<FormFieldInput>>;
  /** Image banner specific for a ticket type on the print at home ticket */
  addonImage?: Maybe<Scalars['Upload']>;
  insideFee?: Maybe<Scalars['Float']>;
  /** Whether hide QR code on ticket. */
  hideQRCode?: Maybe<Scalars['Boolean']>;
  /** The intellitix access ID that matches this addon */
  intellitixId?: Maybe<Scalars['String']>;
  /** The ID of the event addon to update. */
  id: Scalars['String'];
};

/** Updates an event. */
export type UpdateEventInput = {
  /** The kind of event. */
  eventKind?: Maybe<EventKind>;
  /** Represents additional info required to host a digital event. */
  digitalInfo?: Maybe<UpdateDigitalInfoInput>;
  /** Event season. */
  season?: Maybe<Scalars['String']>;
  venue?: Maybe<Scalars['String']>;
  /** Event title. */
  title?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['Upload']>;
  backgroundImage?: Maybe<Scalars['Upload']>;
  backgroundImageFullPage?: Maybe<Scalars['Upload']>;
  descriptionImage?: Maybe<Scalars['Upload']>;
  thumbnail?: Maybe<Scalars['Upload']>;
  printBanner1?: Maybe<Scalars['Upload']>;
  printBanner2?: Maybe<Scalars['Upload']>;
  hardCopyTicketBanner?: Maybe<Scalars['Upload']>;
  /** Event description. */
  description?: Maybe<Scalars['String']>;
  /** Event dates. */
  dates?: Maybe<Array<CreateEventDate>>;
  /** Doors open time. */
  doorsOpen?: Maybe<Scalars['String']>;
  /** Display doors open time. */
  showDoorsOpen?: Maybe<Scalars['Boolean']>;
  /** Display event start time. */
  showStartTime?: Maybe<Scalars['Boolean']>;
  /** Display event end time. */
  showEndTime?: Maybe<Scalars['Boolean']>;
  /** Date at which tickets are viewable/printable from. */
  ticketsViewableFromDate?: Maybe<Scalars['String']>;
  /** Event active status. */
  isActive?: Maybe<Scalars['Boolean']>;
  /** Event featured status. */
  isFeatured?: Maybe<Scalars['Boolean']>;
  /** Booking fee type. */
  bookingFeeType?: Maybe<FeeType>;
  /** Booking fee. */
  bookingFee?: Maybe<Scalars['Float']>;
  /** Whether event is R-18. */
  isR18?: Maybe<Scalars['Boolean']>;
  /** Whether the event is discoverable on BandsInTown */
  isDiscoverable?: Maybe<Scalars['Boolean']>;
  /** Whether the event should be marked as a festival in BandsInTown */
  isFestival?: Maybe<Scalars['Boolean']>;
  /** Whether event is checking for vaccine passports on entry */
  checkForVaccinePass?: Maybe<Scalars['Boolean']>;
  /** Whether naming ticket is available. */
  canNameTicket?: Maybe<Scalars['Boolean']>;
  /** Whether renaming ticket is available. */
  canRenameTicket?: Maybe<Scalars['Boolean']>;
  /** Whether changing seats is available. */
  canChangeSeats?: Maybe<Scalars['Boolean']>;
  /** Whether transfering ticket is available. */
  canTransferTicket?: Maybe<Scalars['Boolean']>;
  /** Whether the waitlist is visible on the event information page */
  enableWaitlist?: Maybe<Scalars['Boolean']>;
  /** The start date of the presale registration. */
  waitlistStartDate?: Maybe<Scalars['DateTime']>;
  /** The end date of the presale registration. */
  waitlistEndDate?: Maybe<Scalars['DateTime']>;
  /** Whether release codes are visible on the event information page */
  enableReleaseCodes?: Maybe<Scalars['Boolean']>;
  /** The fee for changing seats for the event ticket. */
  changingSeatsFee?: Maybe<Scalars['Float']>;
  /** The fee the seller pays for transferring a ticket. */
  sellerTransferringTicketFee?: Maybe<Scalars['Float']>;
  /** The fee the buyer pays for transferring a ticket. */
  buyerTransferringTicketFee?: Maybe<Scalars['Float']>;
  /** Shipping options. */
  shippingOptions?: Maybe<ShippingOptionsInput>;
  /** The payment gateways enabled for the event. */
  gateways?: Maybe<Array<Scalars['String']>>;
  /** The artists performing at the event. */
  artists?: Maybe<Array<CreateArtistInput>>;
  /** The genres of the event. */
  genres?: Maybe<Array<CreateGenreInput>>;
  termsAndConditions?: Maybe<Scalars['String']>;
  importantNotice?: Maybe<Scalars['String']>;
  accessibility?: Maybe<Scalars['String']>;
  invoiceInformation?: Maybe<Scalars['String']>;
  presaleInformation?: Maybe<Scalars['String']>;
  emailNotification?: Maybe<Scalars['String']>;
  redirectURL?: Maybe<Scalars['String']>;
  zonesAllocatedGates?: Maybe<Array<ZoneAllocatedGateInput>>;
  tags?: Maybe<Array<Scalars['String']>>;
  /** Inside fees for the event */
  insideFeeDetails?: Maybe<Array<InsideFeeDetailsInput>>;
  canUsePoints?: Maybe<Scalars['Boolean']>;
  gaVenue?: Maybe<CreateGaEventVenueInput>;
  ticketCover?: Maybe<TicketCoverInput>;
  listedReleaseOptions?: Maybe<ListedReleaseOptionsInput>;
  merchantReference?: Maybe<Scalars['String']>;
  intellitixProjectId?: Maybe<Scalars['String']>;
  intellitixSourceId?: Maybe<Scalars['String']>;
  pixelId?: Maybe<Scalars['String']>;
  hiddenFromPublic?: Maybe<Scalars['Boolean']>;
  enablePaymentPlans?: Maybe<Scalars['Boolean']>;
  paymentPlanScheduleOptions?: Maybe<Array<ScheduleOptionInput>>;
  seoMetadata?: Maybe<SeoMetadataInput>;
  productUpsell?: Maybe<ProductUpsellInput>;
  /** Bulk ticket type updates */
  ticketTypes?: Maybe<Array<UpdateTicketTypeInputWithId>>;
  /** The event addons to add to the event. */
  eventAddons?: Maybe<Array<UpdateEventAddonInputWithId>>;
  /** Custom tax fields for the event */
  tax?: Maybe<Array<TaxInput>>;
  /** Event override settings for seat selection filters */
  seatSelectionFilterOverrides?: Maybe<SeatSelectionFiltersInput>;
};

export type UpdateEventMultiBuyPromotionInput = {
  name?: Maybe<Scalars['String']>;
  buyQuantity?: Maybe<Scalars['Float']>;
  getQuantity?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  buyTicketTypeId?: Maybe<Scalars['String']>;
  getTicketTypeId?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
};

export type UpdateEventPromoCodeInput = {
  /** The unique code that represents the promotion. */
  code?: Maybe<Scalars['String']>;
  /** The discount type associated with the promotion. */
  discountType?: Maybe<DiscountType>;
  /** The discount amount of the promotion. */
  discountAmount?: Maybe<Scalars['Float']>;
  /** The maximum amount of use condition of the promotion. Returns `null` when inactive. */
  maxUsage?: Maybe<Scalars['Float']>;
  /** The start date condition of the promotion. Returns `null` when inactive. */
  startDate?: Maybe<Scalars['DateTime']>;
  /** The end date condition of the promotion. Returns `null` when inactive. */
  endDate?: Maybe<Scalars['DateTime']>;
  /** The minimum order amount condition of the promotion. Returns `null` when inactive. */
  minOrderAmount?: Maybe<Scalars['Float']>;
  /** The maximum order amount condition of the promotion. Returns `null` when inactive. */
  maxOrderAmount?: Maybe<Scalars['Float']>;
  type?: Maybe<EventPromoCodeType>;
  ticketTypes?: Maybe<Array<Scalars['String']>>;
  eventAddons?: Maybe<Array<Scalars['String']>>;
  enabled?: Maybe<Scalars['Boolean']>;
};

export type UpdateExchangeableEventsInput = {
  fromEventId: Scalars['String'];
  toEventIds: Array<Scalars['String']>;
};

export type UpdateExhibitorInput = {
  id: Scalars['String'];
  name: Scalars['String'];
  email: Scalars['String'];
  allowCustomQuestions: Scalars['Boolean'];
  shouldInvalidateLogins: Scalars['Boolean'];
};

/** Updates an EventForecst */
export type UpdateForecastInput = {
  eventId: Scalars['String'];
  /** The zones and forecast inputs. */
  zones: Array<ForecastZoneInput>;
  /** The zones and forecast inputs. */
  scenarios: Array<ScenarioInput>;
};

export type UpdateHoldOrderInput = {
  /** List of actions to perform on line items. */
  lineItemActions: Array<LineItemActionInput>;
  /** Multi buy promotion id. */
  multiBuyId?: Maybe<Scalars['String']>;
};

export type UpdateIntegrationInput = {
  name?: Maybe<Scalars['String']>;
  secretKey?: Maybe<Scalars['String']>;
  publicKey?: Maybe<Scalars['String']>;
  wcPxPostSecretKey?: Maybe<Scalars['String']>;
  wcPxPostPublicKey?: Maybe<Scalars['String']>;
  webhookUrl?: Maybe<Scalars['String']>;
  transactionFeeType?: Maybe<FeeType>;
  transactionFee?: Maybe<Scalars['Float']>;
  transactionFeeType2?: Maybe<FeeType>;
  transactionFee2?: Maybe<Scalars['Float']>;
  paymentMethodType?: Maybe<Scalars['String']>;
  expressCheckoutEnabled?: Maybe<Scalars['Boolean']>;
  facebookTempToken?: Maybe<Scalars['String']>;
  facebookPageId?: Maybe<Scalars['String']>;
  facebookUserId?: Maybe<Scalars['String']>;
  bnplEnabled?: Maybe<Scalars['Boolean']>;
  bnplTransactionFeePercent?: Maybe<Scalars['Float']>;
  daysAfterCanRefund?: Maybe<Scalars['Float']>;
  createAccount?: Maybe<Scalars['Boolean']>;
  type: IntegrationType;
};

export type UpdateMembershipAddonInput = {
  /** The name of the addon. */
  name?: Maybe<Scalars['String']>;
  /** Indicates whether naming the addon is possible or not. */
  enableNaming?: Maybe<Scalars['Boolean']>;
  /** Maximum quantity to be sold for the addon. */
  quantity?: Maybe<Scalars['Float']>;
  /** The price associated with the addon. */
  price?: Maybe<Scalars['Float']>;
  /** The brief description of the addon. */
  description?: Maybe<Scalars['String']>;
  /** The restrictions applied to the addon. */
  restrictions?: Maybe<Scalars['String']>;
  /** The active status of the addon. */
  isActive?: Maybe<Scalars['Boolean']>;
  namingFields?: Maybe<Array<FormFieldInput>>;
  /** Image banner specific for a ticket type on the print at home ticket */
  addonImage?: Maybe<Scalars['Upload']>;
};

export type UpdateMembershipInput = {
  /** Name of the membership. */
  name?: Maybe<Scalars['String']>;
  /** The kind of membership. */
  membershipKind?: Maybe<MembershipKind>;
  /** Represents additional info required to host a digital event. */
  digitalInfo?: Maybe<UpdateDigitalInfoInput>;
  /** The previous memberships related to the membership. */
  previousMemberships?: Maybe<Array<Scalars['String']>>;
  /** The start date of the membership. */
  startDate?: Maybe<Scalars['DateTime']>;
  /** The end date of the membership. */
  endDate?: Maybe<Scalars['DateTime']>;
  /** The booking fee type of the membership. */
  bookingFeeType?: Maybe<FeeType>;
  /** The booking fee for the membership. */
  bookingFee?: Maybe<Scalars['Float']>;
  /** Shipping options. */
  shippingOptions?: Maybe<ShippingOptionsInput>;
  /** The description of the membership. */
  description?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['Upload']>;
  backgroundImage?: Maybe<Scalars['Upload']>;
  descriptionImage?: Maybe<Scalars['Upload']>;
  banner?: Maybe<Scalars['Upload']>;
  printBanner1?: Maybe<Scalars['Upload']>;
  printBanner2?: Maybe<Scalars['Upload']>;
  /** The payment gateways enabled for the membership. */
  gateways?: Maybe<Array<Scalars['String']>>;
  /** Whether naming a membership is available. */
  canNameMembership?: Maybe<Scalars['Boolean']>;
  /** Whether renaming a membership is available. */
  canRenameMembership?: Maybe<Scalars['Boolean']>;
  /** Flag to determine if the membership is hidden from the public */
  hiddenFromPublic?: Maybe<Scalars['Boolean']>;
  /** Whether naming a membership is available. */
  canChangeSeats?: Maybe<Scalars['Boolean']>;
  /** The fee for changing seats for the membership. */
  changingSeatsFee?: Maybe<Scalars['Float']>;
  /** Whether the membership is ticketed. */
  isTicketed?: Maybe<Scalars['Boolean']>;
  /** The active status of the membership. */
  isActive?: Maybe<Scalars['Boolean']>;
  termsAndConditions?: Maybe<Scalars['String']>;
  importantNotice?: Maybe<Scalars['String']>;
  accessibility?: Maybe<Scalars['String']>;
  invoiceInformation?: Maybe<Scalars['String']>;
  showSchedule?: Maybe<Scalars['Boolean']>;
  emailNotification?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  canUsePoints?: Maybe<Scalars['Boolean']>;
  enableAutoRenew?: Maybe<Scalars['Boolean']>;
  /** Whether individual event tickets can be transferred. */
  canTransferTickets?: Maybe<Scalars['Boolean']>;
  ticketCover?: Maybe<MembershipTicketCoverInput>;
  enablePaymentPlans?: Maybe<Scalars['Boolean']>;
  paymentPlanScheduleOptions?: Maybe<Array<ScheduleOptionInput>>;
  seoMetadata?: Maybe<SeoMetadataInput>;
  productUpsell?: Maybe<ProductUpsellInput>;
  /** Custom tax fields for the membership */
  tax?: Maybe<Array<TaxInput>>;
  membershipsViewableFromDate?: Maybe<Scalars['DateTime']>;
  isFlexiMembership?: Maybe<Scalars['Boolean']>;
  /** The season associated with the membership. */
  season?: Maybe<Scalars['String']>;
  /** The events associated with the membership. */
  events?: Maybe<Array<Scalars['String']>>;
  /** The zones of the seating. */
  membershipZones?: Maybe<Array<UpdateMembershipZoneInput>>;
  /** Send viewable email immediately when this is true. */
  sendMembershipViewableEmails?: Maybe<Scalars['Boolean']>;
};

export type UpdateMembershipMultiBuyPromotionInput = {
  name?: Maybe<Scalars['String']>;
  buyQuantity?: Maybe<Scalars['Float']>;
  getQuantity?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  buyMembershipTypeId?: Maybe<Scalars['String']>;
  getMembershipTypeId?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
};

export type UpdateMembershipPromoCodeInput = {
  /** The unique code that represents the promotion. */
  code?: Maybe<Scalars['String']>;
  /** The discount type associated with the promotion. */
  discountType?: Maybe<DiscountType>;
  /** The discount amount of the promotion. */
  discountAmount?: Maybe<Scalars['Float']>;
  /** The maximum amount of use condition of the promotion. Returns `null` when inactive. */
  maxUsage?: Maybe<Scalars['Float']>;
  /** The start date condition of the promotion. Returns `null` when inactive. */
  startDate?: Maybe<Scalars['DateTime']>;
  /** The end date condition of the promotion. Returns `null` when inactive. */
  endDate?: Maybe<Scalars['DateTime']>;
  /** The minimum order amount condition of the promotion. Returns `null` when inactive. */
  minOrderAmount?: Maybe<Scalars['Float']>;
  /** The maximum order amount condition of the promotion. Returns `null` when inactive. */
  maxOrderAmount?: Maybe<Scalars['Float']>;
  type?: Maybe<MembershipPromoCodeType>;
  membershipTypes?: Maybe<Array<Scalars['String']>>;
  membershipAddons?: Maybe<Array<Scalars['String']>>;
  enabled?: Maybe<Scalars['Boolean']>;
};

export type UpdateMembershipTypeEventTransferPriceInput = {
  membershipTypeId: Scalars['String'];
  membershipZoneId: Scalars['String'];
  prices: Array<MembershipTypeTransferPriceInput>;
};

export type UpdateMembershipTypeInput = {
  /** The kind of the membership type. */
  kind?: Maybe<MembershipTypeKind>;
  /** Name of the membership type. */
  name?: Maybe<Scalars['String']>;
  /** The ticket fee type. */
  ticketFeeType?: Maybe<FeeType>;
  /** The number of membership tickets that must be purchased together in this set. */
  quantitySet?: Maybe<Scalars['Float']>;
  /** The ticket fee. */
  ticketFee?: Maybe<Scalars['Float']>;
  /** Restrictions for the membership type. */
  description?: Maybe<Scalars['String']>;
  /** Restrictions for the membership type. */
  restrictions?: Maybe<Scalars['String']>;
  namingFields?: Maybe<Array<FormFieldInput>>;
  minPurchaseQuantity?: Maybe<Scalars['Float']>;
  maxPurchaseQuantity?: Maybe<Scalars['Float']>;
  isGuestCard?: Maybe<Scalars['Boolean']>;
  /** Whether the membership type is for a child. */
  isChild?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
};

export type UpdateMembershipZoneInput = {
  /** The  memebershipZone id. */
  id?: Maybe<Scalars['String']>;
  /** The  zone. */
  zone: MembershipZoneZoneInput;
  /** The pricing level of the seating zone. Will be set to `zone` for non-seated events. */
  pricingLevel: ZonePricingLevel;
  /** The active status of the membership seating. Defaults to `false`. */
  isActive?: Maybe<Scalars['Boolean']>;
  /** The list of membership types of the seating zone. */
  membershipTypes: Array<UpdateMembershipZoneMembershipTypeInput>;
};

export type UpdateMembershipZoneMembershipTypeInput = {
  /** The membership type id of the seating. */
  membershipTypeId: Scalars['String'];
  /** The price of the zone per membership. Pass null if `pricingLevel` of the parent is set to other than `zone`. */
  price?: Maybe<Scalars['Float']>;
  /** The sections of the membership seating. Pass null if `pricingLevel` of the parent is set to other than `section`. */
  sections?: Maybe<Array<UpdateMembershipZoneMembershipTypeSectionInput>>;
  /** The active status of the membership type. Defaults to `false`. */
  isActive?: Maybe<Scalars['Boolean']>;
};

export type UpdateMembershipZoneMembershipTypeSectionInput = {
  /** The section id. Should be equal to one of the sections defined in the venue. */
  sectionId: Scalars['String'];
  /** The section name. Should be equal to one of the sections defined in the venue. */
  name: Scalars['String'];
  price?: Maybe<Scalars['Float']>;
};

export type UpdateOrderInput = {
  /** The step the order currently is in. */
  step: Scalars['Float'];
  /** The delivery method chosen by the customer. */
  deliveryMethod?: Maybe<ShippingOption>;
  /** Buyer details. */
  buyerInformation?: Maybe<BuyerInformationInput>;
  /** Billing address provided by the customer. */
  billingAddress?: Maybe<AddressInput>;
  /** Shipping address provided by the customer. */
  shippingAddress?: Maybe<AddressInput>;
  /** Whether the shipping address matches the billing address. */
  shippingAddressMatchesBillingAddress?: Maybe<Scalars['Boolean']>;
  /** If the purchaser has added dietary requirements */
  dietaryRequirements?: Maybe<Scalars['String']>;
  /** How the user heard about the event */
  heardAboutUs?: Maybe<HeardAboutUsType>;
  /** Heard about us details when heardAboutUs is other */
  heardAboutUsDetails?: Maybe<Scalars['String']>;
  /** If the order is starting a membership subscription */
  automaticRenewMambership?: Maybe<Scalars['Boolean']>;
  /**
   * Whether the order is updated on admin portal. 
   *     If the user is an admin, we won't update the details even if this is true.
   */
  updateDetails?: Maybe<Scalars['Boolean']>;
  userAcquisition?: Maybe<UserAcquisition>;
  sendSmsConfirmation?: Maybe<Scalars['Boolean']>;
  usableForMarketing?: Maybe<Scalars['Boolean']>;
};

export type UpdateOrderStatusInput = {
  /** Order status to transition to. */
  status?: Maybe<OrderStatus>;
  /** Selected payment method if order status is paid (allowed: cash, eftpos, invoice, other). */
  method?: Maybe<PaymentProvider>;
  /** Will not send order confirmation email if set */
  skipOrderConfirmation?: Maybe<Scalars['Boolean']>;
  /** Will send the customer an invoice email for hold orders if set */
  sendHoldOrderCustomerEmail?: Maybe<Scalars['Boolean']>;
  /** Whether to generate a Xero invoice for order. Only applies to hold orders for organizations with Xero integration enabled. */
  shouldGenerateXeroInvoice?: Maybe<Scalars['Boolean']>;
  isComp?: Maybe<Scalars['Boolean']>;
  compReason?: Maybe<Scalars['String']>;
  /** Additional transaction fees to be added to the order. Useful for 3rd party payment processing. */
  manualTransactionFee?: Maybe<Scalars['Float']>;
};

export type UpdateOrderTicketCoverInput = {
  includeTicketCover: Scalars['Boolean'];
};

export type UpdateOrganizationInput = {
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  address?: Maybe<AddressInput>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  taxNumber?: Maybe<Scalars['String']>;
  taxRate?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  supportInfo?: Maybe<Scalars['String']>;
  landingPage?: Maybe<LandingPage>;
  showMemberships?: Maybe<Scalars['Boolean']>;
  showMembershipRenewal?: Maybe<Scalars['Boolean']>;
  termsAndConditions?: Maybe<Scalars['String']>;
  privacyPolicy?: Maybe<Scalars['String']>;
  branding?: Maybe<BrandingInput>;
  landingTours?: Maybe<LandingToursInput>;
  marketing?: Maybe<MarketingInput>;
  helpLink?: Maybe<Scalars['String']>;
  customTaxRate?: Maybe<Scalars['Float']>;
  customTaxName?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Scalars['String']>>;
  i18n?: Maybe<Scalars['JSON']>;
  defaultOptInMarketing?: Maybe<Scalars['Boolean']>;
  cookieConsent?: Maybe<Scalars['Boolean']>;
  /** Shipping options. */
  shippingLabels?: Maybe<ShippingLabelsInput>;
};

export type UpdatePasswordInput = {
  oldPassword: Scalars['String'];
  newPassword: Scalars['String'];
};

export type UpdatePointInput = {
  name?: Maybe<Scalars['String']>;
  termsAndConditions?: Maybe<Scalars['String']>;
  gatewayIds: Array<Scalars['String']>;
  isEnabled: Scalars['Boolean'];
};

export type UpdatePointItemInput = {
  name: Scalars['String'];
  price: Scalars['Float'];
  amount: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['Upload']>;
  banner?: Maybe<Scalars['Upload']>;
  backgroundImage?: Maybe<Scalars['Upload']>;
  descriptionImage?: Maybe<Scalars['Upload']>;
  isVisible: Scalars['Boolean'];
};

export type UpdatePosUserInput = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  accessCode?: Maybe<Scalars['String']>;
};

export type UpdateProfileInput = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Gender>;
  usableForEmailMarketing?: Maybe<Scalars['Boolean']>;
  usableForSMSMarketing?: Maybe<Scalars['Boolean']>;
  /** Billing address provided by the user. */
  billingAddress?: Maybe<PartialAddressInput>;
  /** Shipping address provided by the user. */
  shippingAddress?: Maybe<PartialAddressInput>;
  /** Whether the shipping address matches the billing address. */
  shippingAddressMatchesBillingAddress?: Maybe<Scalars['Boolean']>;
  companyName?: Maybe<Scalars['String']>;
  taxNumber?: Maybe<Scalars['String']>;
  instagramUsername?: Maybe<Scalars['String']>;
};

/** Updates a Referral Campaign */
export type UpdateReferralCampaignDto = {
  referralReleaseId?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  referralOwnerRewardType?: Maybe<ReferralRewardType>;
  referralOwnerRewardQuantityType?: Maybe<ReferralRewardQuantityType>;
  referralOwnerRewardQuantity?: Maybe<Scalars['Float']>;
  referralUserRewardType?: Maybe<ReferralRewardType>;
  referralUserRewardQuantityType?: Maybe<ReferralRewardQuantityType>;
  referralUserRewardQuantity?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
};

export type UpdateReleaseInput = {
  /** Release name. */
  name?: Maybe<Scalars['String']>;
  /** Release type. */
  type?: Maybe<ReleaseType>;
  /** The slug for the unlisted release. Pass null if the release type is set to other than `unlisted`. */
  slug?: Maybe<Scalars['String']>;
  /** The password for the unlisted release. Pass null if the release type is set to other than `unlisted`. */
  password?: Maybe<Scalars['String']>;
  /** The start condition of the release. */
  startCondition?: Maybe<ReleaseStartCondition>;
  /** The start date of the release. Pass null if the startCondition is set to other than `date`. */
  startConditionDate?: Maybe<Scalars['DateTime']>;
  /** The end condition of the release. */
  endCondition?: Maybe<ReleaseEndCondition>;
  /** The quantity limit of the release. Pass null if the endCondition is set to other than `quantity`. */
  endConditionQuantity?: Maybe<Scalars['Float']>;
  /** The end date of the release. Pass null if the endCondition is set to other than `date`. */
  endConditionDate?: Maybe<Scalars['DateTime']>;
  /** The status of the release. */
  isActive?: Maybe<Scalars['Boolean']>;
  /** The zones of the release. */
  releaseZones?: Maybe<Array<ReleaseZoneInput>>;
  /** The title of the unlisted release. Pass null if the `type` is set to other than `unlisted`. */
  presaleTitle?: Maybe<Scalars['String']>;
  presaleLogo?: Maybe<Scalars['Upload']>;
  presaleHeader?: Maybe<Scalars['Upload']>;
  /** The information of the unlisted release. Pass null if the `type` is set to other than `unlisted`. */
  presaleInformation?: Maybe<Scalars['String']>;
  /** The information that will be shown to customers on the ticketing page. */
  releaseNotes?: Maybe<Scalars['String']>;
  /** Ask how did you heard about us during the purchasing flow */
  askHowDidYouHearAboutUs?: Maybe<Scalars['Boolean']>;
  /** Request purchasers  */
  askForDietaryRequirements?: Maybe<Scalars['Boolean']>;
  /** Are comps visible to public */
  allowPublicComp?: Maybe<Scalars['Boolean']>;
  /** Can this release use Windcaves Account2Account functionality */
  allowAccount2Account?: Maybe<Scalars['Boolean']>;
  /** Can customers create hold orders for this release */
  allowHoldOrders?: Maybe<Scalars['Boolean']>;
  minPurchaseQuantity?: Maybe<Scalars['Float']>;
  maxPurchaseQuantity?: Maybe<Scalars['Float']>;
  releaseEventAddons?: Maybe<Array<Scalars['String']>>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  channels?: Maybe<Array<Scalars['String']>>;
  requiredMembershipIds?: Maybe<Array<Scalars['String']>>;
};

export type UpdateReleaseZoneInput = {
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  /** Images for the ticket gallery */
  imageGallery?: Maybe<Array<ImageGalleryItemInput>>;
  capacity?: Maybe<Scalars['Int']>;
  admission: Scalars['Boolean'];
  isActive: Scalars['Boolean'];
};

export type UpdateResaleConfigInput = {
  eventId: Scalars['String'];
  canTransferTicket: Scalars['Boolean'];
  ticketResaleWaitlistEnabled: Scalars['Boolean'];
  ticketResaleEnabled: Scalars['Boolean'];
  /** The fee the seller pays for transferring a ticket. */
  sellerTransferringTicketFee?: Maybe<Scalars['Float']>;
  /** The fee the buyer pays for transferring a ticket. */
  buyerTransferringTicketFee?: Maybe<Scalars['Float']>;
  canChangeSeats: Scalars['Boolean'];
};

export type UpdateScoutCommunicationInput = {
  name?: Maybe<Scalars['String']>;
  purpose?: Maybe<ScoutPurpose>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<ScoutCommunicationType>;
  includeOptedOutOfMarketing?: Maybe<Scalars['Boolean']>;
  segmentId?: Maybe<Scalars['String']>;
  campaignId?: Maybe<Scalars['String']>;
  trackSource?: Maybe<ReportingFilterSource>;
  trackSourceId?: Maybe<Scalars['String']>;
  trackReleaseId?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  shouldUpdate?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  listId?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['Float']>;
  subject?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
};

export type UpdateScoutCommunicationUserInput = {
  stage: ScoutStage;
  usableForEmailMarketing?: Maybe<Scalars['Boolean']>;
  usableForSMSMarketing?: Maybe<Scalars['Boolean']>;
};

export type UpdateScoutInput = {
  name?: Maybe<Scalars['String']>;
  promoteTo?: Maybe<Array<FilterSelectionInput>>;
  exclude?: Maybe<Array<FilterSelectionInput>>;
  isActive: Scalars['Boolean'];
};

export type UpdateSeasonInput = {
  /** Season name. */
  name?: Maybe<Scalars['String']>;
  /** Season active status. */
  isActive?: Maybe<Scalars['Boolean']>;
  /** Season description. */
  description?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['Upload']>;
  backgroundImageFullPage?: Maybe<Scalars['Upload']>;
  landingBanner?: Maybe<Scalars['Upload']>;
  /** Rich text shown above the season events. */
  landingDescription?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Float']>;
};

export type UpdateSmsBroadcastInput = {
  tags?: Maybe<Array<BroadcastTags>>;
  subject: Scalars['String'];
  message: Scalars['String'];
  /** If the input contains send time, then this is a scheduled SMS */
  scheduledAt?: Maybe<Scalars['DateTime']>;
  status: BroadcastStatus;
  testPhoneNumber?: Maybe<Scalars['String']>;
  marketingFilters?: Maybe<Array<BroadcastMarketingFiltersV2Input>>;
  id: Scalars['String'];
};

export type UpdateTagInput = {
  name?: Maybe<Scalars['String']>;
};

export type UpdateTicketHolderInput = {
  vaccinePass?: Maybe<Scalars['Upload']>;
  customFields?: Maybe<Array<CustomFieldInput>>;
  /** First name of the ticket holder. */
  firstName?: Maybe<Scalars['String']>;
  /** Last name of the ticket holder. */
  lastName?: Maybe<Scalars['String']>;
  /** Email of the ticket holder. */
  email?: Maybe<Scalars['String']>;
  /** Phone number of the ticket holder. */
  phoneNumber?: Maybe<Scalars['String']>;
  /** Birth date of the ticket holder. */
  birthDate?: Maybe<Scalars['DateTime']>;
  /** Gender of the ticket holder. */
  gender?: Maybe<Gender>;
  /** Postal code of the ticket holder. */
  postalCode?: Maybe<Scalars['String']>;
  /** Company name of the ticket holder (optional). */
  companyName?: Maybe<Scalars['String']>;
  /** Since when the ticket holder is a member. */
  memberSince?: Maybe<Scalars['DateTime']>;
  /** License plate of the ticket holder. */
  licensePlate?: Maybe<Scalars['String']>;
  /** Membership number of the ticket holder. */
  membershipNumber?: Maybe<Scalars['String']>;
  /** Comments of the ticket holder. */
  comments?: Maybe<Scalars['String']>;
  /** Dietary requirements of the ticket holder. */
  dietaryRequirements?: Maybe<Scalars['String']>;
  /** Whether the ticket holder opts in to email marketing */
  usableForEmailMarketing?: Maybe<Scalars['Boolean']>;
  /** Whether the ticket holder opts in to text marketing */
  usableForSMSMarketing?: Maybe<Scalars['Boolean']>;
  /** How long someone is staying at an event */
  lengthOfStay?: Maybe<Scalars['String']>;
  /** Name of the emergency contact */
  emergencyName?: Maybe<Scalars['String']>;
  /** Phone number of the emergency contact */
  emergencyContact?: Maybe<Scalars['String']>;
  /** Phone number of the emergency contact */
  emergencyContactRelationship?: Maybe<Scalars['String']>;
  /** Residential address in Dunedin */
  dunedinResidentialAddress?: Maybe<Scalars['String']>;
  /** Student id of the ticket holder */
  studentId?: Maybe<Scalars['String']>;
};

export type UpdateTicketTypeInput = {
  /** The kind of the ticket type. */
  kind?: Maybe<TicketTypeKind>;
  /** Whether the ticket type is grouped. */
  isGrouped?: Maybe<Scalars['Boolean']>;
  /** Whether the ticket is for a child. */
  isChild?: Maybe<Scalars['Boolean']>;
  /** The amount of people in a group. Returns null if the ticket type is not grouped. */
  groupAmount?: Maybe<Scalars['Float']>;
  /** The number of tickets that must be purchased together in this set. */
  quantitySet?: Maybe<Scalars['Float']>;
  /** Intellitix access IDs */
  intellitixIds?: Maybe<Array<Scalars['String']>>;
  /** Ticket group name. */
  name?: Maybe<Scalars['String']>;
  /** Event dates. */
  dates?: Maybe<Array<CreateTicketTypeDate>>;
  /** Booking fee type. */
  bookingFeeType?: Maybe<FeeType>;
  /** Booking fee. */
  bookingFee?: Maybe<Scalars['Float']>;
  /** Per ticket stadium levy ticket fee. */
  stadiumLevyFee?: Maybe<Scalars['Float']>;
  /** Mark a ticket type as high demand */
  inHighDemand?: Maybe<Scalars['Boolean']>;
  /** Custom badge text for ticket type (max 50 chars) */
  customBadge?: Maybe<Scalars['String']>;
  /** Custom badge background color (hex code) */
  customBadgeBackgroundColor?: Maybe<Scalars['String']>;
  /** Custom badge text color (hex code) */
  customBadgeTextColor?: Maybe<Scalars['String']>;
  /** Mark a ticket type as sold out */
  soldOut?: Maybe<Scalars['Boolean']>;
  /** Hide the price in customer portal when the ticket type is marked as sold out */
  hidePriceWhenSoldOut?: Maybe<Scalars['Boolean']>;
  /** Description of the ticket */
  description?: Maybe<Scalars['String']>;
  /** Restrictions for the ticket group. */
  restrictions?: Maybe<Scalars['String']>;
  /** Print at home information for the ticket group. */
  printAtHomeInformation?: Maybe<Scalars['String']>;
  namingFields?: Maybe<Array<FormFieldInput>>;
  /** Doors open time. */
  doorsOpen?: Maybe<Scalars['String']>;
  /** Display doors open time. */
  showDoorsOpen?: Maybe<Scalars['Boolean']>;
  /** Display event start time. */
  showStartTime?: Maybe<Scalars['Boolean']>;
  /** Display event end time. */
  showEndTime?: Maybe<Scalars['Boolean']>;
  /** Custom entry dates for this ticket type. */
  entryDates?: Maybe<Array<CreateEventDate>>;
  /** Image banner specific for a ticket type on the print at home ticket */
  ticketBanner?: Maybe<Scalars['Upload']>;
  /** Image banner specific for a ticket type on the print at home ticket */
  ticketImage?: Maybe<Scalars['Upload']>;
  /** Images for the ticket gallery */
  imageGallery?: Maybe<Array<ImageGalleryItemInput>>;
  quantity?: Maybe<Scalars['Float']>;
  minPurchaseQuantity?: Maybe<Scalars['Float']>;
  maxPurchaseQuantity?: Maybe<Scalars['Float']>;
  tags?: Maybe<Array<Scalars['String']>>;
  /** Price for v2 event */
  price?: Maybe<Scalars['Float']>;
  /** releaseZoneId for v2 event */
  releaseZoneId?: Maybe<Scalars['String']>;
  /** isActive for v2 event */
  isActive?: Maybe<Scalars['Boolean']>;
  /** isComplimentary for v2 event */
  isComplimentary?: Maybe<Scalars['Boolean']>;
  /** Whether the ticket type can only be purchased by businesses. Makes company name required during checkout. */
  isBusinessOnly?: Maybe<Scalars['Boolean']>;
  onSaleConfig?: Maybe<TicketTypeOnSaleConfigInput>;
  /** Pricing tiers to set for the ticket type. NOTE: If `null` or omitted, the pricing tiers won't be updated. */
  pricingTiers?: Maybe<Array<PricingTierInput>>;
};

export type UpdateTicketTypeInputWithId = {
  /** The kind of the ticket type. */
  kind?: Maybe<TicketTypeKind>;
  /** Whether the ticket type is grouped. */
  isGrouped?: Maybe<Scalars['Boolean']>;
  /** Whether the ticket is for a child. */
  isChild?: Maybe<Scalars['Boolean']>;
  /** The amount of people in a group. Returns null if the ticket type is not grouped. */
  groupAmount?: Maybe<Scalars['Float']>;
  /** The number of tickets that must be purchased together in this set. */
  quantitySet?: Maybe<Scalars['Float']>;
  /** Intellitix access IDs */
  intellitixIds?: Maybe<Array<Scalars['String']>>;
  /** Ticket group name. */
  name?: Maybe<Scalars['String']>;
  /** Event dates. */
  dates?: Maybe<Array<CreateTicketTypeDate>>;
  /** Booking fee type. */
  bookingFeeType?: Maybe<FeeType>;
  /** Booking fee. */
  bookingFee?: Maybe<Scalars['Float']>;
  /** Per ticket stadium levy ticket fee. */
  stadiumLevyFee?: Maybe<Scalars['Float']>;
  /** Mark a ticket type as high demand */
  inHighDemand?: Maybe<Scalars['Boolean']>;
  /** Custom badge text for ticket type (max 50 chars) */
  customBadge?: Maybe<Scalars['String']>;
  /** Custom badge background color (hex code) */
  customBadgeBackgroundColor?: Maybe<Scalars['String']>;
  /** Custom badge text color (hex code) */
  customBadgeTextColor?: Maybe<Scalars['String']>;
  /** Mark a ticket type as sold out */
  soldOut?: Maybe<Scalars['Boolean']>;
  /** Hide the price in customer portal when the ticket type is marked as sold out */
  hidePriceWhenSoldOut?: Maybe<Scalars['Boolean']>;
  /** Description of the ticket */
  description?: Maybe<Scalars['String']>;
  /** Restrictions for the ticket group. */
  restrictions?: Maybe<Scalars['String']>;
  /** Print at home information for the ticket group. */
  printAtHomeInformation?: Maybe<Scalars['String']>;
  namingFields?: Maybe<Array<FormFieldInput>>;
  /** Doors open time. */
  doorsOpen?: Maybe<Scalars['String']>;
  /** Display doors open time. */
  showDoorsOpen?: Maybe<Scalars['Boolean']>;
  /** Display event start time. */
  showStartTime?: Maybe<Scalars['Boolean']>;
  /** Display event end time. */
  showEndTime?: Maybe<Scalars['Boolean']>;
  /** Custom entry dates for this ticket type. */
  entryDates?: Maybe<Array<CreateEventDate>>;
  /** Image banner specific for a ticket type on the print at home ticket */
  ticketBanner?: Maybe<Scalars['Upload']>;
  /** Image banner specific for a ticket type on the print at home ticket */
  ticketImage?: Maybe<Scalars['Upload']>;
  /** Images for the ticket gallery */
  imageGallery?: Maybe<Array<ImageGalleryItemInput>>;
  quantity?: Maybe<Scalars['Float']>;
  minPurchaseQuantity?: Maybe<Scalars['Float']>;
  maxPurchaseQuantity?: Maybe<Scalars['Float']>;
  tags?: Maybe<Array<Scalars['String']>>;
  /** Price for v2 event */
  price?: Maybe<Scalars['Float']>;
  /** releaseZoneId for v2 event */
  releaseZoneId?: Maybe<Scalars['String']>;
  /** isActive for v2 event */
  isActive?: Maybe<Scalars['Boolean']>;
  /** isComplimentary for v2 event */
  isComplimentary?: Maybe<Scalars['Boolean']>;
  /** Whether the ticket type can only be purchased by businesses. Makes company name required during checkout. */
  isBusinessOnly?: Maybe<Scalars['Boolean']>;
  onSaleConfig?: Maybe<TicketTypeOnSaleConfigInput>;
  /** Pricing tiers to set for the ticket type. NOTE: If `null` or omitted, the pricing tiers won't be updated. */
  pricingTiers?: Maybe<Array<PricingTierInput>>;
  /** The ID of the ticket type to update. */
  id: Scalars['String'];
};

export type UpdateUserInput = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Role>>;
  phoneNumber?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['DateTime']>;
  /** To receive scanner login reminder emails. */
  receiveScannerEmail?: Maybe<Scalars['Boolean']>;
  gender?: Maybe<Gender>;
  usableForEmailMarketing?: Maybe<Scalars['Boolean']>;
  usableForSMSMarketing?: Maybe<Scalars['Boolean']>;
  /** Billing address provided by the user. */
  billingAddress?: Maybe<PartialAddressInput>;
  /** Shipping address provided by the user. */
  shippingAddress?: Maybe<PartialAddressInput>;
  /** Whether the shipping address matches the billing address. */
  shippingAddressMatchesBillingAddress?: Maybe<Scalars['Boolean']>;
  credits?: Maybe<Scalars['Float']>;
  companyName?: Maybe<Scalars['String']>;
  taxNumber?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  instagramUsername?: Maybe<Scalars['String']>;
  referralId?: Maybe<Scalars['String']>;
  accessEventIds?: Maybe<Array<Scalars['String']>>;
  accessMembershipIds?: Maybe<Array<Scalars['String']>>;
  /** Elevate users privileges from user to admin. */
  elevatePrivileges?: Maybe<Scalars['Boolean']>;
  userAcquisition?: Maybe<UserAcquisition>;
};

export type UpdateVenueInput = {
  accessibilityInfo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  capacity?: Maybe<Scalars['Int']>;
  capacityUtilization?: Maybe<Scalars['Float']>;
  timezone?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  address?: Maybe<AddressInput>;
  location?: Maybe<CoordinateInput>;
  zones?: Maybe<Array<ZoneInput>>;
  gates?: Maybe<Array<GateInput>>;
  /** Default settings for seat selection filters */
  defaultSeatSelectionFilters?: Maybe<SeatSelectionFiltersInput>;
};


export type UpsertAccessCodeInput = {
  /** The access code you want to supply to users when they purchase a membership */
  code?: Maybe<Scalars['String']>;
  /** If true, deletes all access codes from the membership */
  isActive?: Maybe<Scalars['Boolean']>;
  /** The number of paid entities this access code can be used for */
  quantityPaid?: Maybe<Scalars['Float']>;
  /** The number of comp entities this access code can be used for */
  quantityComp?: Maybe<Scalars['Float']>;
  /** The uuids of the membership types linked to this access code */
  membershipTypeIds?: Maybe<Array<Scalars['ID']>>;
};

export type User = {
  __typename?: 'User';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  organization: Organization;
  roles: Array<Role>;
  /** Permision set based on roles */
  permissions: Array<Permission>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  fullName: Scalars['String'];
  hasPassword: Scalars['Boolean'];
  isTwoFactorAuthenticationEnabled: Scalars['Boolean'];
  isLoggedInWithLinkedAccount: Scalars['Boolean'];
  hasVerifiedEmail: Scalars['Boolean'];
  birthDate?: Maybe<Scalars['DateTime']>;
  phoneNumber?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
  usableForEmailMarketing?: Maybe<Scalars['Boolean']>;
  receiveScannerEmail?: Maybe<Scalars['Boolean']>;
  usableForSMSMarketing?: Maybe<Scalars['Boolean']>;
  /** Billing address associated with the user. */
  billingAddress?: Maybe<PartialAddress>;
  /** Shipping address associated with the user. */
  shippingAddress?: Maybe<PartialAddress>;
  /** Whether the shipping address matches the billing address. */
  shippingAddressMatchesBillingAddress: Scalars['Boolean'];
  /** User credits balance */
  credits?: Maybe<Scalars['Float']>;
  /** User points balance */
  points: Scalars['Float'];
  usSegment?: Maybe<UsSegment>;
  /** unique uuid of a customer used to link to referral campaigns */
  referralId: Scalars['String'];
  /** User instagram username */
  instagramUsername?: Maybe<Scalars['String']>;
  /** The company name of the user. */
  companyName?: Maybe<Scalars['String']>;
  /** The tax number of the user. */
  taxNumber?: Maybe<Scalars['String']>;
  /** The region of the user, derived from the postal code of billing address. */
  region?: Maybe<Scalars['String']>;
  unsubscribeReason?: Maybe<UnsubscribeReason>;
  lastLoginAttemptedAt: Scalars['String'];
  loginAttempts: Scalars['String'];
  otherUnsubscribeReason?: Maybe<Scalars['String']>;
  lastTimeLoggedInAt?: Maybe<Scalars['DateTime']>;
  e164Number?: Maybe<Scalars['String']>;
  internationalPhoneNumber?: Maybe<InternationalPhoneNumberOutput>;
  tags: Array<Tag>;
  scoutCommunications: Array<ScoutCommunication>;
  orders: OrderConnection;
  ticketHolderOrders: OrderConnection;
  hasOrders: Scalars['Boolean'];
  membershipTickets: Array<Ticket>;
  eventTickets: Array<Ticket>;
  hasMemberships: Scalars['Boolean'];
  hasTickets: Scalars['Boolean'];
  LTV: Scalars['Float'];
  history: HistoryConnection;
  /** The IDs of the events the user can access when their account is scoped for only certain events */
  accessEventIds?: Maybe<Array<Scalars['String']>>;
  /** The IDs of the memberships the user can access when their account is scoped for only certain events */
  accessMembershipIds?: Maybe<Array<Scalars['String']>>;
  /** The Shopify user entry for the user if they have used the organization's Shopify store */
  shopifyUser?: Maybe<ShopifyUser>;
  pfOrgHasCustomEmailDomain?: Maybe<Scalars['Boolean']>;
  hmac?: Maybe<HmacOutput>;
  canConnectToPaymentTerminal: Scalars['Boolean'];
  paymentTerminalGatewayId?: Maybe<Scalars['String']>;
};


export type UserOrdersArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<OrderWhereInput>;
  orderBy?: Maybe<OrderOrderByInput>;
};


export type UserHistoryArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<HistoryOrderByInput>;
};

export type UserAcquisition = {
  referralCodeId?: Maybe<Scalars['String']>;
};

export type UserConnection = {
  __typename?: 'UserConnection';
  pageInfo: PageInfo;
  edges: Array<UserEdge>;
  totalCount: Scalars['Int'];
};

export type UserEdge = {
  __typename?: 'UserEdge';
  cursor: Scalars['String'];
  node: User;
};

export type UserOrderByInput = {
  firstName?: Maybe<OrderByDirection>;
  lastName?: Maybe<OrderByDirection>;
  createdAt?: Maybe<OrderByDirection>;
  updatedAt?: Maybe<OrderByDirection>;
};

export type UsersUpdatedBetweenInput = {
  /** The start date of the range to search provided in the organizations timezone. */
  startDate: Scalars['DateTime'];
  /** The end date of the range to search provided in the organizations timezone. */
  endDate: Scalars['DateTime'];
};

export type UserWhereInput = {
  /** Fuzzy search query. */
  q?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Role>>;
};

export type UsherComplimetaryCreateInput = {
  releaseId: Scalars['String'];
  seatZoneId?: Maybe<Scalars['String']>;
  seatZone: Scalars['String'];
  eventId: Scalars['String'];
  releaseZoneId: Scalars['String'];
  name: Scalars['String'];
};

export type UsSegment = {
  __typename?: 'UsSegment';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  user: User;
  organization: Organization;
  accuracy: Scalars['Float'];
  /** A single letter representation of the segment a user is in */
  segment: Scalars['String'];
  /** Address that was provided for the Us Segment */
  address: PartialAddress;
};

export type VaccinePass = {
  __typename?: 'VaccinePass';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** Pass owner */
  user?: Maybe<User>;
  /** Ticket that the pass is asscoiated with */
  ticket?: Maybe<Ticket>;
  /** Raw payload of the vaccine pass */
  payload?: Maybe<Scalars['String']>;
  /** Decoded payload of the vaccine pass */
  payloadDecoded: Scalars['JSON'];
};

export type ValidateAccessCodeForMembershipInput = {
  /** The access code to validate */
  code: Scalars['String'];
  /** The membership ID to validate the access code for */
  membershipId: Scalars['ID'];
};

export type ValidateReleasePasswordOrReleaseOutput = {
  __typename?: 'ValidateReleasePasswordOrReleaseOutput';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** Release name. */
  name: Scalars['String'];
  /** Release type. */
  type: ReleaseType;
  /** The slug for the unlisted release. Returns null if the release type is set to other than `unlisted`. */
  slug?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  /** The start condition of the release. */
  startCondition: ReleaseStartCondition;
  /** The start date of the release. Returns null if the startCondition is set to other than "date". */
  startConditionDate?: Maybe<Scalars['DateTime']>;
  /** The end condition of the release. */
  endCondition: ReleaseEndCondition;
  /** The quantity limit of the release. Returns null if the endCondition is set to other than "quantity". */
  endConditionQuantity?: Maybe<Scalars['Float']>;
  /** The end date of the release. Returs null if the endCondition is set to other than "date". */
  endConditionDate?: Maybe<Scalars['DateTime']>;
  /** The status of the release. */
  isActive: Scalars['Boolean'];
  /** The title of the unlisted release. Returns null if the `type` is set to other than `unlisted`. */
  presaleTitle?: Maybe<Scalars['String']>;
  /** The logo of the unlisted release. Returns null if the `type` is set to other than `unlisted`. */
  presaleLogo?: Maybe<ExtendedFile>;
  /** The header image of the unlisted release. Returns null if the `type` is set to other than `unlisted`. */
  presaleHeader?: Maybe<ExtendedFile>;
  /** The information of the unlisted release. Returns null if the `type` is set to other than `unlisted`. */
  presaleInformation?: Maybe<Scalars['String']>;
  /** The information that will be displayed on the ticketing page for a specific release. */
  releaseNotes?: Maybe<Scalars['String']>;
  /** Toggle whether to ask customers how they heard about their purcahse */
  askHowDidYouHearAboutUs?: Maybe<Scalars['Boolean']>;
  /** Toggle whether to ask for dietary requirements with their order */
  askForDietaryRequirements?: Maybe<Scalars['Boolean']>;
  allowPublicComp: Scalars['Boolean'];
  /** Toggle whether customers can create hold orders for this release */
  allowHoldOrders: Scalars['Boolean'];
  allowAccount2Account?: Maybe<Scalars['Boolean']>;
  minPurchaseQuantity: Scalars['Int'];
  maxPurchaseQuantity: Scalars['Int'];
  isEnabled: Scalars['Boolean'];
  /** Presale only: whether to link to this release from the waitlist page (where applicable) */
  linkToWaitlist?: Maybe<Scalars['Boolean']>;
  /** Presale only: whether to allow pre-purchases for this release */
  allowPrePurchase?: Maybe<Scalars['Boolean']>;
  purchaseRestrictions?: Maybe<ReleasePurchaseRestriction>;
  status: ReleaseStatus;
  event: Event;
  canBeHardDeleted: Scalars['Boolean'];
  requiresAuth: Scalars['Boolean'];
  releaseZones: Array<ReleaseZone>;
  releaseEventAddons: Array<ReleaseEventAddon>;
  isResaleRelease: Scalars['Boolean'];
  channels: Array<EventChannelOutput>;
  isPrePurchaseActive: Scalars['Boolean'];
  showMemberTicketsBanner: Scalars['Boolean'];
  releasePasswordId?: Maybe<Scalars['String']>;
};

export type Venue = {
  __typename?: 'Venue';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  /** Seats.io chart key */
  seatsChartKey?: Maybe<Scalars['String']>;
  zones: Array<Zone>;
  /** Venue address */
  address: Address;
  /** Venue seating settings. */
  seating: VenueSeating;
  capacity?: Maybe<Scalars['Int']>;
  /** Venue capacity utilization as a percentage. */
  capacityUtilization: Scalars['Float'];
  accessibilityInfo?: Maybe<Scalars['String']>;
  /** Venue coordinates (lat, lng). */
  location?: Maybe<Coordinate>;
  gates: Array<Gate>;
  trackHardCopyTickets: Scalars['Boolean'];
  /** Does this stadium require a per ticket levy to be charged */
  hasStadiumLevy: Scalars['Boolean'];
  timezone: Scalars['String'];
  locale: Scalars['String'];
  /** Filter options that are available for a seated venue */
  filterOptions?: Maybe<Array<Scalars['String']>>;
  createdFromEvent: Scalars['Boolean'];
  /** Default settings for seat selection filters */
  defaultSeatSelectionFilters: SeatSelectionFilters;
};

/** Venue seating settings. */
export enum VenueSeating {
  Seated = 'Seated',
  NonSeated = 'NonSeated',
  Digital = 'Digital'
}

export type VerifyEmailInput = {
  token: Scalars['String'];
};

export type VerifyMagicLinkOutput = {
  __typename?: 'VerifyMagicLinkOutput';
  redirectUrl: Scalars['String'];
};

export type VerifyManageTicketsOutput = {
  __typename?: 'VerifyManageTicketsOutput';
  isLoggedIn: Scalars['Boolean'];
  eventId: Scalars['String'];
  isEventEnded: Scalars['Boolean'];
};

export type VerifyPinPayment3Ds = {
  refId: Scalars['String'];
  sessionToken: Scalars['String'];
};

/** Represents a date in an event. */
export type Waitlist = {
  __typename?: 'Waitlist';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  organization: Organization;
  user: User;
  event: Event;
};

export type WaitlistOverviewOutput = {
  __typename?: 'WaitlistOverviewOutput';
  totalCustomers?: Maybe<Scalars['Float']>;
  totalNewCustomers?: Maybe<Scalars['Float']>;
  totalReturningCustomers?: Maybe<Scalars['Float']>;
  customersOptedIntoMarketing?: Maybe<Scalars['Float']>;
  totalRevenue?: Maybe<Scalars['Float']>;
  numberOfOrders?: Maybe<Scalars['Float']>;
  numberOfSuccesfulUsers?: Maybe<Scalars['Float']>;
  numberOfTickets?: Maybe<Scalars['Float']>;
  yetToConvert?: Maybe<Scalars['Float']>;
};

/** Represents a customer on a waitlist for an event. This customer may or may not exist as an actual user. */
export type WaitlistUser = {
  __typename?: 'WaitlistUser';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  organization: Organization;
  event: Event;
  /** The linked release that this waitlist user is registered for. */
  release?: Maybe<Release>;
  /** The referral code used when registering for presale access. Will be tied to the referring user/waitlist user */
  referralCode?: Maybe<ReferralCode>;
  /** The user that is on the waitlist. This may be null if the user does not already exist in our system. */
  user: User;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  usableForMarketing: Scalars['Boolean'];
  fullName: Scalars['String'];
};

/** Contains encoded ticket data in the format required for various wallet providers. */
export type WalletTicket = {
  __typename?: 'WalletTicket';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  /** (Apple): authentication token to be used with Apple Wallet. */
  authenticationToken?: Maybe<Scalars['String']>;
  /** (Google): The object ID to identify this ticket in the Google Wallet API. */
  googleObjectId?: Maybe<Scalars['String']>;
  /** The ticket that is encoded in the entity */
  ticket?: Maybe<Ticket>;
  /** The organization associated with the ticket. */
  organization?: Maybe<Organization>;
};

export type WindcavePaymentContext = {
  __typename?: 'WindcavePaymentContext';
  redirectUrl?: Maybe<Scalars['String']>;
  checkoutUrl: Scalars['String'];
  orderId: Scalars['String'];
};

/** The payment result. */
export type WindcavePaymentResultOutput = {
  __typename?: 'WindcavePaymentResultOutput';
  redirectUrl: Scalars['String'];
};

/** Represents a Xero account. */
export type XeroAccountOutput = {
  __typename?: 'XeroAccountOutput';
  accountId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  taxType?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
};

/** Represents all available Xero accounts. */
export type XeroAllAccountsOutput = {
  __typename?: 'XeroAllAccountsOutput';
  currentAccountCode?: Maybe<Scalars['String']>;
  availableAccounts?: Maybe<Array<XeroAccountOutput>>;
};

export type XeroCallbackInput = {
  code: Scalars['String'];
};

export type XeroConfigurationInput = {
  accountCode: Scalars['String'];
  sendFlicketInvoice: Scalars['Boolean'];
  invoiceStatus: XeroInvoiceStatus;
  numDaysToPay: Scalars['Float'];
  useCompanyNameOnInvoice: Scalars['Boolean'];
};

export type XeroConfigurationOutput = {
  __typename?: 'XeroConfigurationOutput';
  accountCode?: Maybe<Scalars['String']>;
  sendFlicketInvoice?: Maybe<Scalars['Boolean']>;
  invoiceStatus?: Maybe<XeroInvoiceStatus>;
  numDaysToPay?: Maybe<Scalars['Float']>;
  useCompanyNameOnInvoice?: Maybe<Scalars['Boolean']>;
};

/** Xero invoice status */
export enum XeroInvoiceStatus {
  Draft = 'DRAFT',
  Submitted = 'SUBMITTED',
  Authorised = 'AUTHORISED'
}

export type Zone = {
  __typename?: 'Zone';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  capacity?: Maybe<Scalars['Int']>;
  sections?: Maybe<Array<Section>>;
  stand?: Maybe<Scalars['String']>;
  seated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  /** Image gallery for zone listing and sub-page. */
  imageGallery: Array<ImageGalleryItem>;
  displayOrder: Scalars['Int'];
  admission: Scalars['Boolean'];
  isActive: Scalars['Boolean'];
};

/** Allowed date for the zone. */
export type ZoneAllocatedDate = {
  __typename?: 'ZoneAllocatedDate';
  eventDateId: Scalars['ID'];
  /** Alternate entry time for the zone. */
  alternateEntryTime: Scalars['String'];
};

export type ZoneAllocatedDateInput = {
  eventDateId: Scalars['ID'];
  /** Alternate entry time for the zone. */
  alternateEntryTime: Scalars['String'];
};

export type ZoneAllocatedGate = {
  __typename?: 'ZoneAllocatedGate';
  zoneId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  gates?: Maybe<Array<Scalars['String']>>;
  sections?: Maybe<Array<ZoneAllocatedGateSection>>;
  availabilityCount?: Maybe<ZoneAllocationAvailability>;
  /** Alternate entry time for the zone. */
  dates?: Maybe<Array<ZoneAllocatedDate>>;
};

export type ZoneAllocatedGateInput = {
  zoneId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  gates?: Maybe<Array<Scalars['String']>>;
  sections?: Maybe<Array<ZoneAllocatedGateSectionInput>>;
  availabilityCount?: Maybe<ZoneAllocationAvailabilityInput>;
  /** Alternate entry time for the zone. */
  dates?: Maybe<Array<ZoneAllocatedDateInput>>;
};

export type ZoneAllocatedGateSection = {
  __typename?: 'ZoneAllocatedGateSection';
  /** Section name. */
  name: Scalars['String'];
  /** Section id. */
  sectionId?: Maybe<Scalars['String']>;
  gates?: Maybe<Array<Scalars['String']>>;
};

export type ZoneAllocatedGateSectionInput = {
  /** Section name. */
  name: Scalars['String'];
  /** Section id. */
  sectionId?: Maybe<Scalars['String']>;
  gates?: Maybe<Array<Scalars['String']>>;
};

export type ZoneAllocationAvailability = {
  __typename?: 'ZoneAllocationAvailability';
  notForSale?: Maybe<Scalars['Float']>;
  holdByMembership?: Maybe<Scalars['Float']>;
  booked?: Maybe<Scalars['Float']>;
  available?: Maybe<Scalars['Float']>;
};

export type ZoneAllocationAvailabilityInput = {
  notForSale?: Maybe<Scalars['Float']>;
  holdByMembership?: Maybe<Scalars['Float']>;
  booked?: Maybe<Scalars['Float']>;
  available?: Maybe<Scalars['Float']>;
};

export type ZoneArgs = {
  __typename?: 'ZoneArgs';
  kind: BroadcastMarketingFiltersV2Kind;
  exclude: Scalars['Boolean'];
  eventId: Scalars['String'];
  seatZoneIds: Array<Scalars['String']>;
};

/** The zone belonging to a venue (can only be set for non-seated venues) */
export type ZoneInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  capacity?: Maybe<Scalars['Int']>;
  stand?: Maybe<Scalars['String']>;
  displayOrder: Scalars['Float'];
  admission?: Maybe<Scalars['Boolean']>;
};

export enum ZonePricingLevel {
  Zone = 'ZONE',
  Section = 'SECTION'
}

/** Represents a section level pricing. */
export type ZonePricingTypeSection = {
  __typename?: 'ZonePricingTypeSection';
  /** Section name. */
  name: Scalars['String'];
  /** Section id. */
  sectionId: Scalars['String'];
  /** The price of the section ticket type or the section membership type. */
  price?: Maybe<Scalars['Float']>;
};

export type GetWaitlistUserQueryVariables = Exact<{
  userId: Scalars['String'];
  eventId: Scalars['String'];
}>;


export type GetWaitlistUserQuery = (
  { __typename?: 'Query' }
  & { getWaitlistUser?: Maybe<(
    { __typename?: 'WaitlistUser' }
    & Pick<WaitlistUser, 'id'>
  )> }
);

export type ExtendOrderExpiryMutationVariables = Exact<{
  orderId: Scalars['String'];
}>;


export type ExtendOrderExpiryMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'extendOrderExpiry'>
);

export type FinalisePrechargeOrderMutationVariables = Exact<{
  input: FinalisePrechargeOrderInput;
}>;


export type FinalisePrechargeOrderMutation = (
  { __typename?: 'Mutation' }
  & { finalisePrechargeOrder: (
    { __typename?: 'Order' }
    & Pick<Order, 'id'>
  ) }
);

export type PrechargeOrderSummaryQueryVariables = Exact<{
  orderId: Scalars['String'];
}>;


export type PrechargeOrderSummaryQuery = (
  { __typename?: 'Query' }
  & { prechargeOrderSummary: (
    { __typename?: 'OrderPrechargeSummaryOutput' }
    & Pick<OrderPrechargeSummaryOutput, 'numTickets'>
    & { card: (
      { __typename?: 'StripeSetupIntentCardOutput' }
      & Pick<StripeSetupIntentCardOutput, 'brand' | 'last4' | 'expMonth' | 'expYear'>
    ) }
  ) }
);

export type InitialiseSetupIntentForPrechargeOrderMutationVariables = Exact<{
  orderId: Scalars['String'];
}>;


export type InitialiseSetupIntentForPrechargeOrderMutation = (
  { __typename?: 'Mutation' }
  & { initialiseSetupIntentForPrechargeOrder: (
    { __typename?: 'InitialiseSetupIntentOutput' }
    & Pick<InitialiseSetupIntentOutput, 'clientSecret'>
  ) }
);

export type StripeIntegrationForPrechargeEventQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type StripeIntegrationForPrechargeEventQuery = (
  { __typename?: 'Query' }
  & { stripeIntegrationForPrechargeEvent: (
    { __typename?: 'Integration' }
    & Pick<Integration, 'publicKey'>
    & { stripeConnectAccount?: Maybe<(
      { __typename?: 'StripeConnectAccount' }
      & Pick<StripeConnectAccount, 'stripeAccountId' | 'stripePublishableKey'>
    )> }
  ) }
);

export type SignupFormFragmentFragment = (
  { __typename?: 'SignupFormOutput' }
  & Pick<SignupFormOutput, 'id' | 'heading' | 'description' | 'buttonText' | 'successMessage' | 'successHeading' | 'processedCustomCSS'>
  & { styles: (
    { __typename?: 'SignupFormStyles' }
    & SignupFormStylesFragmentFragment
  ), formFields: Array<(
    { __typename?: 'SignupFormFieldOutput' }
    & SignupFormFieldFragmentFragment
  )>, tags: (
    { __typename?: 'SignUpFormTagEntityIds' }
    & Pick<SignUpFormTagEntityIds, 'entityIds'>
  ) }
);

export type SignupFormStylesFragmentFragment = (
  { __typename?: 'SignupFormStyles' }
  & Pick<SignupFormStyles, 'backgroundColour' | 'textColour' | 'buttonColour' | 'customCSS'>
);

export type SignupFormFieldFragmentFragment = (
  { __typename?: 'SignupFormFieldOutput' }
  & Pick<SignupFormFieldOutput, 'id' | 'name' | 'label' | 'type' | 'required' | 'orderKey' | 'options'>
);

export type SignupFormQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type SignupFormQuery = (
  { __typename?: 'Query' }
  & { signupForm: (
    { __typename?: 'SignupFormOutput' }
    & SignupFormFragmentFragment
  ) }
);

export type SignupFormSubmitMutationVariables = Exact<{
  input: SubmissionInput;
}>;


export type SignupFormSubmitMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'signupFormSubmit'>
);

export type ActiveCompetitionByTypeQueryVariables = Exact<{
  input: ActiveCompetitionByTypeInput;
}>;


export type ActiveCompetitionByTypeQuery = (
  { __typename?: 'Query' }
  & { activeCompetitionByType?: Maybe<(
    { __typename?: 'Competition' }
    & CompetitionFragmentFragment
  )> }
);

export type ActiveCompetitionsQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type ActiveCompetitionsQuery = (
  { __typename?: 'Query' }
  & { activeCompetitions?: Maybe<Array<(
    { __typename?: 'Competition' }
    & CompetitionFragmentFragment
  )>> }
);

export type CompetitionFragmentFragment = (
  { __typename?: 'Competition' }
  & Pick<Competition, 'id' | 'startDate' | 'endDate' | 'competitionType' | 'description' | 'termsAndConditions' | 'title' | 'isPublished' | 'referralRewardValue'>
  & { prizes?: Maybe<Array<(
    { __typename?: 'CompetitionPrize' }
    & CompetitionPrizeFragmentFragment
  )>>, promoter?: Maybe<Array<(
    { __typename?: 'CompetitionReward' }
    & CompetitionRewardFragmentFragment
  )>> }
);

export type CompetitionByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type CompetitionByIdQuery = (
  { __typename?: 'Query' }
  & { competition: (
    { __typename?: 'Competition' }
    & CompetitionFragmentFragment
  ) }
);

export type CompetitionPrizeFragmentFragment = (
  { __typename?: 'CompetitionPrize' }
  & Pick<CompetitionPrize, 'id' | 'title' | 'description' | 'prizeOrder' | 'quantity'>
  & { image?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragment
  )> }
);

export type CompetitionRewardFragmentFragment = (
  { __typename?: 'CompetitionReward' }
  & Pick<CompetitionReward, 'platform' | 'actionType' | 'value' | 'isEnabled' | 'socialLinkType'>
);

export type GetEventAndReleaseForCustomerQueryVariables = Exact<{
  input: EventsWithAccessControlInput;
}>;


export type GetEventAndReleaseForCustomerQuery = (
  { __typename?: 'Query' }
  & { getEventAndReleaseForCustomer: (
    { __typename?: 'EventsWithAccessControlOutput' }
    & Pick<EventsWithAccessControlOutput, 'isAdmin' | 'errorType' | 'errorMessage' | 'permissions'>
    & { redirect?: Maybe<(
      { __typename?: 'EventRedirectQueryParams' }
      & Pick<EventRedirectQueryParams, 'eventId' | 'code' | 'slug' | 'path'>
    )>, event?: Maybe<(
      { __typename?: 'Event' }
      & Pick<Event, 'hasPublicRelease' | 'publicReleaseStartsAt'>
      & { venue: (
        { __typename?: 'Venue' }
        & VenueFragment
      ), addons: Array<(
        { __typename?: 'EventAddon' }
        & Pick<EventAddon, 'id'>
      )>, ticketTypes: Array<(
        { __typename?: 'TicketType' }
        & { imageGallery: Array<(
          { __typename?: 'ImageGalleryItem' }
          & ImageGalleryFragmentFragment
        )> }
        & TicketTypeBaseFragment
        & TicketTypeInfoFragment
        & FinanceFragment
      )>, presaleRelease?: Maybe<(
        { __typename?: 'Release' }
        & Pick<Release, 'id' | 'startConditionDate' | 'isPrePurchaseActive'>
      )>, paymentPlanSettings?: Maybe<(
        { __typename?: 'PaymentPlanSettings' }
        & PaymentPlanSettingsFragmentFragment
      )>, seekaConfig?: Maybe<(
        { __typename?: 'SeekaOutput' }
        & SeekaConfigFragment
      )>, stripeConfig?: Maybe<(
        { __typename?: 'StripeConfigOutput' }
        & StripeConfigFragment
      )> }
      & EventFragment
    )>, release?: Maybe<(
      { __typename?: 'Release' }
      & Pick<Release, 'id' | 'name' | 'type' | 'slug' | 'isActive' | 'requiresAuth' | 'startConditionDate' | 'startCondition' | 'isPrePurchaseActive' | 'minPurchaseQuantity' | 'maxPurchaseQuantity' | 'isResaleRelease' | 'presaleTitle' | 'presaleInformation' | 'releaseNotes' | 'allowPublicComp' | 'showMemberTicketsBanner'>
      & { status: (
        { __typename?: 'ReleaseStatus' }
        & Pick<ReleaseStatus, 'value' | 'message'>
      ), event: (
        { __typename?: 'Event' }
        & Pick<Event, 'hasPublicRelease'>
        & { venue: (
          { __typename?: 'Venue' }
          & VenueFragment
        ), ticketTypes: Array<(
          { __typename?: 'TicketType' }
          & TicketTypeBaseFragment
          & TicketTypeInfoFragment
        )>, paymentPlanSettings?: Maybe<(
          { __typename?: 'PaymentPlanSettings' }
          & PaymentPlanSettingsFragmentFragment
        )>, multiBuyPromotions: Array<(
          { __typename?: 'EventMultiBuyPromotion' }
          & Pick<EventMultiBuyPromotion, 'id' | 'name' | 'getQuantity' | 'buyQuantity' | 'price' | 'enabled'>
          & { getTicketType: (
            { __typename?: 'TicketType' }
            & Pick<TicketType, 'id' | 'name' | 'description' | 'restrictions' | 'kind' | 'isGrouped' | 'groupAmount' | 'bookingFeeType' | 'bookingFee'>
            & { dates: Array<(
              { __typename?: 'TicketTypeDate' }
              & Pick<TicketTypeDate, 'alternateEntryTime'>
            )> }
          ), buyTicketType: (
            { __typename?: 'TicketType' }
            & Pick<TicketType, 'id' | 'name' | 'description' | 'restrictions' | 'kind' | 'isGrouped' | 'groupAmount' | 'bookingFeeType' | 'bookingFee'>
            & { dates: Array<(
              { __typename?: 'TicketTypeDate' }
              & Pick<TicketTypeDate, 'alternateEntryTime'>
            )> }
          ) }
        )> }
        & EventFragment
      ), presaleHeader?: Maybe<(
        { __typename?: 'ExtendedFile' }
        & FileFragment
      )>, presaleLogo?: Maybe<(
        { __typename?: 'ExtendedFile' }
        & FileFragment
      )>, releaseZones: Array<(
        { __typename?: 'ReleaseZone' }
        & Pick<ReleaseZone, 'id' | 'isActive' | 'isSoldOut' | 'pricingLevel'>
        & { zone: (
          { __typename?: 'Zone' }
          & Pick<Zone, 'id' | 'name' | 'description' | 'displayOrder'>
          & { imageGallery: Array<(
            { __typename?: 'ImageGalleryItem' }
            & ImageGalleryFragmentFragment
          )> }
        ), ticketTypes: Array<(
          { __typename?: 'ReleaseZoneTicketType' }
          & Pick<ReleaseZoneTicketType, 'price' | 'isActive' | 'ticketTypeId' | 'isSoldOut' | 'hidePrice' | 'minPurchaseQuantity' | 'maxPurchaseQuantity' | 'ticketAvailabilityStatus' | 'purchaseRestrictionsHelpText' | 'pricingTierId' | 'pricingTierName'>
          & { sections?: Maybe<Array<(
            { __typename?: 'ZonePricingTypeSection' }
            & Pick<ZonePricingTypeSection, 'name' | 'price'>
          )>>, purchaseRestrictions: Array<(
            { __typename?: 'PurchaseRestriction' }
            & Pick<PurchaseRestriction, 'id' | 'quantity' | 'isExclusive' | 'isAlwaysVisible'>
            & { requiredEntities: Array<(
              { __typename?: 'PurchaseRestrictionRequiredEntity' }
              & Pick<PurchaseRestrictionRequiredEntity, 'requiredType' | 'requiredId'>
            )> }
          )> }
        )> }
      )>, releaseEventAddons: Array<(
        { __typename?: 'ReleaseEventAddon' }
        & { eventAddon: (
          { __typename?: 'EventAddon' }
          & Pick<EventAddon, 'id' | 'name' | 'enableNaming' | 'price' | 'description' | 'restrictions' | 'isActive' | 'quantity' | 'addonAvailabilityStatus' | 'maxPurchaseQuantity' | 'purchaseRestrictionsHelpText'>
          & { addonImage?: Maybe<(
            { __typename?: 'ExtendedFile' }
            & FileFragment
          )>, purchaseRestrictions: Array<(
            { __typename?: 'PurchaseRestriction' }
            & Pick<PurchaseRestriction, 'id' | 'quantity' | 'isExclusive' | 'isAlwaysVisible'>
            & { requiredEntities: Array<(
              { __typename?: 'PurchaseRestrictionRequiredEntity' }
              & Pick<PurchaseRestrictionRequiredEntity, 'requiredType' | 'requiredId'>
            )> }
          )>, imageGallery: Array<(
            { __typename?: 'ImageGalleryItem' }
            & ImageGalleryFragmentFragment
          )> }
        ) }
      )>, channels: Array<(
        { __typename?: 'EventChannelOutput' }
        & Pick<EventChannelOutput, 'id' | 'label' | 'isEnabled'>
      )> }
    )> }
  ) }
);

export type UserEntriesQueryVariables = Exact<{
  input: GetUserEntriesInput;
}>;


export type UserEntriesQuery = (
  { __typename?: 'Query' }
  & { userEntries?: Maybe<Array<(
    { __typename?: 'GrantRewardOutput' }
    & Pick<GrantRewardOutput, 'platform' | 'actionType' | 'value'>
  )>> }
);

export type GrantCompetitionRewardMutationVariables = Exact<{
  input: GrantCompetitionRewardInput;
}>;


export type GrantCompetitionRewardMutation = (
  { __typename?: 'Mutation' }
  & { grantCompetitionReward?: Maybe<(
    { __typename?: 'CompetitionReward' }
    & Pick<CompetitionReward, 'platform' | 'actionType' | 'value'>
  )> }
);

export type JoinResaleWaitlistMutationVariables = Exact<{
  input: ResaleWaitlistInput;
}>;


export type JoinResaleWaitlistMutation = (
  { __typename?: 'Mutation' }
  & { joinResaleWaitlist: (
    { __typename?: 'ResaleWaitlistOutput' }
    & Pick<ResaleWaitlistOutput, 'e164Number'>
    & { user: (
      { __typename?: 'User' }
      & Pick<User, 'phoneNumber'>
      & { billingAddress?: Maybe<(
        { __typename?: 'PartialAddress' }
        & Pick<PartialAddress, 'country'>
      )>, internationalPhoneNumber?: Maybe<(
        { __typename?: 'InternationalPhoneNumberOutput' }
        & Pick<InternationalPhoneNumberOutput, 'country'>
      )> }
    ) }
  ) }
);

export type MembershipsOverviewQueryVariables = Exact<{
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
}>;


export type MembershipsOverviewQuery = (
  { __typename?: 'Query' }
  & { memberships: (
    { __typename?: 'MembershipConnection' }
    & Pick<MembershipConnection, 'totalCount'>
    & { edges: Array<(
      { __typename?: 'MembershipEdge' }
      & { node: (
        { __typename?: 'Membership' }
        & Pick<Membership, 'name' | 'membershipKind' | 'startDate' | 'endDate'>
        & { thumbnail?: Maybe<(
          { __typename?: 'ExtendedFile' }
          & FileFragment
        )>, events?: Maybe<Array<(
          { __typename?: 'Event' }
          & Pick<Event, 'id'>
          & { venueAddress: (
            { __typename?: 'Venue' }
            & Pick<Venue, 'name'>
            & { address: (
              { __typename?: 'Address' }
              & Pick<Address, 'city'>
            ) }
          ) }
        )>>, types: Array<(
          { __typename?: 'MembershipType' }
          & Pick<MembershipType, 'id' | 'quantitySet'>
        )>, membershipZones: Array<(
          { __typename?: 'MembershipZone' }
          & Pick<MembershipZone, 'id' | 'pricingLevel' | 'isActive'>
          & { zone: (
            { __typename?: 'Zone' }
            & Pick<Zone, 'id' | 'name'>
          ), membershipTypes: Array<(
            { __typename?: 'MembershipSeatingZoneType' }
            & Pick<MembershipSeatingZoneType, 'membershipTypeId' | 'price' | 'isActive' | 'isHidden'>
            & { sections?: Maybe<Array<(
              { __typename?: 'ZonePricingTypeSection' }
              & Pick<ZonePricingTypeSection, 'name' | 'price'>
            )>> }
          )> }
        )> }
        & MembershipBaseFragment
      ) }
    )>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ) }
  ) }
);

export type PointFragment = (
  { __typename?: 'Point' }
  & Pick<Point, 'id' | 'name' | 'termsAndConditions'>
  & { gateways: Array<(
    { __typename?: 'Integration' }
    & Pick<Integration, 'id' | 'name' | 'type' | 'transactionFeeType' | 'transactionFee' | 'transactionFeeType2' | 'transactionFee2' | 'publicKey' | 'paymentMethodType'>
  )>, stripeConfig?: Maybe<(
    { __typename?: 'StripeConfigOutput' }
    & StripeConfigFragment
  )> }
);

export type PointItemFragment = (
  { __typename?: 'PointItem' }
  & Pick<PointItem, 'id' | 'name' | 'price' | 'amount' | 'isVisible' | 'description'>
  & { banner?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragment
  )>, thumbnail?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragment
  )>, backgroundImage?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragment
  )>, descriptionImage?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragment
  )>, fees: (
    { __typename?: 'OrderFee' }
    & Pick<OrderFee, 'organizationExclusiveTaxRate'>
    & { fees: Array<(
      { __typename?: 'Fee' }
      & Pick<Fee, 'id' | 'name' | 'type' | 'value' | 'order' | 'isOptional'>
    )>, items: Array<(
      { __typename?: 'ItemFee' }
      & Pick<ItemFee, 'id' | 'isComp'>
      & { fees: Array<(
        { __typename?: 'Fee' }
        & Pick<Fee, 'id' | 'name' | 'type' | 'value' | 'order' | 'isOptional'>
      )> }
    )>, gateways: Array<(
      { __typename?: 'OrderFeeIntegration' }
      & Pick<OrderFeeIntegration, 'id' | 'type' | 'transactionFeeType' | 'transactionFee' | 'transactionFeeType2' | 'transactionFee2' | 'bnplEnabled' | 'bnplTransactionFeePercent' | 'isDefault'>
    )> }
  ) }
);

export type PointQueryVariables = Exact<{ [key: string]: never; }>;


export type PointQuery = (
  { __typename?: 'Query' }
  & { point?: Maybe<(
    { __typename?: 'Point' }
    & PointFragment
  )> }
);

export type PointItemQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type PointItemQuery = (
  { __typename?: 'Query' }
  & { pointItem: (
    { __typename?: 'PointItem' }
    & PointItemFragment
  ) }
);

export type PointItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type PointItemsQuery = (
  { __typename?: 'Query' }
  & { pointItems: Array<(
    { __typename?: 'PointItem' }
    & PointItemFragment
  )> }
);

export type GetReferralCampaignByReferralCodeQueryVariables = Exact<{
  referralCode: Scalars['String'];
}>;


export type GetReferralCampaignByReferralCodeQuery = (
  { __typename?: 'Query' }
  & { getReferralCampaignByReferralCode?: Maybe<(
    { __typename?: 'ReferralCampaign' }
    & Pick<ReferralCampaign, 'id' | 'isActive' | 'referralOwnerRewardType' | 'referralOwnerRewardQuantityType' | 'referralOwnerRewardQuantity' | 'referralUserRewardType' | 'referralUserRewardQuantityType' | 'referralUserRewardQuantity'>
    & { referralRelease?: Maybe<(
      { __typename?: 'Release' }
      & Pick<Release, 'id'>
    )>, event?: Maybe<(
      { __typename?: 'Event' }
      & Pick<Event, 'id'>
    )> }
  )> }
);

export type AddressFragment = (
  { __typename?: 'Address' }
  & Pick<Address, 'line1' | 'line2' | 'suburb' | 'postalCode' | 'city' | 'state' | 'country'>
);

export type CompetitionStatsFragmentFragment = (
  { __typename?: 'CompetitionCustomerReporting' }
  & Pick<CompetitionCustomerReporting, 'competitionEndDate' | 'competitionReferralLink' | 'competitionTitle' | 'competitionSharePageLink' | 'referralsMade' | 'entries' | 'eventId' | 'isCompetitionRunning' | 'competitionId' | 'competitionEventTitle'>
  & { competitionEventLogo?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & Pick<ExtendedFile, 'fileName' | 'storage' | 'originalFileName' | 'directory'>
    & { metaData?: Maybe<(
      { __typename?: 'MetaData' }
      & Pick<MetaData, 'height' | 'width'>
    )> }
  )>, competitionBannerImage?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & Pick<ExtendedFile, 'fileName' | 'storage' | 'originalFileName' | 'directory'>
    & { metaData?: Maybe<(
      { __typename?: 'MetaData' }
      & Pick<MetaData, 'height' | 'width'>
    )> }
  )> }
);

export type EventBaseFragment = (
  { __typename?: 'Event' }
  & Pick<Event, 'id' | 'createdAt' | 'updatedAt'>
);

export type DateOptionsFragment = (
  { __typename?: 'EventDate' }
  & Pick<EventDate, 'id' | 'startDate' | 'endDate' | 'doorsOpen'>
);

export type EventDateOptionsFragment = (
  { __typename?: 'Event' }
  & Pick<Event, 'showStartTime' | 'showEndTime'>
  & { dates: Array<(
    { __typename?: 'EventDate' }
    & DateOptionsFragment
  )> }
);

export type EventSeatSelectionFiltersFragment = (
  { __typename?: 'Event' }
  & { effectiveSeatFilters: (
    { __typename?: 'SeatSelectionFilters' }
    & Pick<SeatSelectionFilters, 'seatQuantity' | 'sortType' | 'selectType'>
  ) }
);

export type EventFragment = (
  { __typename?: 'Event' }
  & Pick<Event, 'customTaxRate' | 'taxRate' | 'taxCalculationMethod' | 'ticketResaleWaitlistEnabled'>
  & { multiBuyPromotions: Array<(
    { __typename?: 'EventMultiBuyPromotion' }
    & Pick<EventMultiBuyPromotion, 'id' | 'name' | 'getQuantity' | 'buyQuantity' | 'price' | 'enabled'>
    & { getTicketType: (
      { __typename?: 'TicketType' }
      & Pick<TicketType, 'id' | 'name' | 'description' | 'restrictions' | 'kind' | 'isGrouped' | 'groupAmount' | 'bookingFeeType' | 'bookingFee'>
      & { dates: Array<(
        { __typename?: 'TicketTypeDate' }
        & Pick<TicketTypeDate, 'alternateEntryTime'>
      )> }
    ), buyTicketType: (
      { __typename?: 'TicketType' }
      & Pick<TicketType, 'id' | 'name' | 'description' | 'restrictions' | 'kind' | 'isGrouped' | 'groupAmount' | 'bookingFeeType' | 'bookingFee'>
      & { dates: Array<(
        { __typename?: 'TicketTypeDate' }
        & Pick<TicketTypeDate, 'alternateEntryTime'>
      )> }
    ) }
  )>, customFields: Array<(
    { __typename?: 'CustomFieldOuput' }
    & Pick<CustomFieldOuput, 'id' | 'label' | 'value' | 'targetArea' | 'type' | 'isRequired'>
  )>, fees: (
    { __typename?: 'OrderFee' }
    & Pick<OrderFee, 'organizationExclusiveTaxRate'>
    & { fees: Array<(
      { __typename?: 'Fee' }
      & Pick<Fee, 'id' | 'name' | 'type' | 'value' | 'order' | 'isOptional'>
    )>, items: Array<(
      { __typename?: 'ItemFee' }
      & Pick<ItemFee, 'id' | 'isComp'>
      & { fees: Array<(
        { __typename?: 'Fee' }
        & Pick<Fee, 'id' | 'name' | 'type' | 'value' | 'order' | 'isOptional'>
      )> }
    )>, gateways: Array<(
      { __typename?: 'OrderFeeIntegration' }
      & Pick<OrderFeeIntegration, 'id' | 'type' | 'transactionFeeType' | 'transactionFee' | 'transactionFeeType2' | 'transactionFee2' | 'bnplEnabled' | 'bnplTransactionFeePercent' | 'isDefault'>
    )> }
  ), seekaConfig?: Maybe<(
    { __typename?: 'SeekaOutput' }
    & SeekaConfigFragment
  )>, seatsIoConfig?: Maybe<(
    { __typename?: 'SeatsIoConfigOutput' }
    & Pick<SeatsIoConfigOutput, 'region' | 'publicKey' | 'eventKeys'>
  )> }
  & EventBaseFragment
  & EventInfoFragment
  & EventOptionsFragment
  & EventSeatSelectionFiltersFragment
);

export type EventInfoFragment = (
  { __typename?: 'Event' }
  & Pick<Event, 'title' | 'description' | 'eventKind' | 'hasEventEnded' | 'startDate' | 'endDate' | 'isFeatured' | 'canUpgrade' | 'importantNotice' | 'termsAndConditions' | 'accessibility' | 'isR18' | 'presaleInformation' | 'enableReleaseCodes' | 'enableWaitlist' | 'isWaitlistAvailable' | 'waitlistEndDate' | 'pixelId' | 'hiddenFromPublic'>
  & { thumbnail?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragment
  )>, logo?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragment
  )>, backgroundImage?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragment
  )>, backgroundImageFullPage?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragment
  )>, descriptionImage?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragment
  )>, printBanner1?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragment
  )>, printBanner2?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragment
  )>, digitalPassCodesStatus?: Maybe<(
    { __typename?: 'DigitalPassCodeStatusOutput' }
    & Pick<DigitalPassCodeStatusOutput, 'remainingPassCodes'>
  )>, season?: Maybe<(
    { __typename?: 'Season' }
    & Pick<Season, 'id'>
  )> }
  & EventDateOptionsFragment
);

export type EventOptionsFragment = (
  { __typename?: 'Event' }
  & Pick<Event, 'isActive' | 'seatsEventKey' | 'bookingFeeType' | 'bookingFee' | 'canUsePoints' | 'canChangeSeats' | 'changingSeatsFee'>
  & { shippingOptions?: Maybe<(
    { __typename?: 'ShippingOptions' }
    & ShippingOptionsFragment
  )>, gateways: Array<(
    { __typename?: 'Integration' }
    & Pick<Integration, 'id' | 'name' | 'type' | 'transactionFee' | 'transactionFeeType' | 'transactionFeeType2' | 'transactionFee2' | 'bnplEnabled' | 'bnplTransactionFeePercent'>
  )> }
);

export type FileFragment = (
  { __typename?: 'ExtendedFile' }
  & Pick<ExtendedFile, 'storage' | 'directory' | 'fileName' | 'originalFileName'>
  & { metaData?: Maybe<(
    { __typename?: 'MetaData' }
    & Pick<MetaData, 'width' | 'height'>
  )> }
);

export type ImageGalleryFragmentFragment = (
  { __typename?: 'ImageGalleryItem' }
  & Pick<ImageGalleryItem, 'id' | 'title'>
  & { original?: Maybe<(
    { __typename?: 'GalleryImage' }
    & Pick<GalleryImage, 'src' | 'aspectRatio'>
    & { metaData?: Maybe<(
      { __typename?: 'MetaData' }
      & Pick<MetaData, 'width' | 'height'>
    )> }
  )>, cropped?: Maybe<(
    { __typename?: 'GalleryImage' }
    & Pick<GalleryImage, 'src' | 'aspectRatio'>
    & { metaData?: Maybe<(
      { __typename?: 'MetaData' }
      & Pick<MetaData, 'width' | 'height'>
    )> }
  )> }
);

export type IntegrationFragmentFragment = (
  { __typename?: 'Integration' }
  & Pick<Integration, 'id' | 'type' | 'paymentMethodType' | 'name' | 'transactionFeeType' | 'transactionFee' | 'transactionFeeType2' | 'transactionFee2' | 'publicKey' | 'webhookUrl' | 'bnplEnabled' | 'bnplTransactionFeePercent'>
);

export type LineItemBaseFragment = (
  { __typename?: 'LineItem' }
  & Pick<LineItem, 'id' | 'createdAt' | 'updatedAt'>
);

export type LineItemFinanceFragment = (
  { __typename?: 'LineItem' }
  & Pick<LineItem, 'price' | 'originalPrice' | 'quantity' | 'ticketFee' | 'ticketFeeAmount' | 'stadiumLevyFee' | 'taxRate' | 'total' | 'taxAmount' | 'customTaxAmount' | 'customTaxRate'>
  & { pointItem?: Maybe<(
    { __typename?: 'PointItem' }
    & Pick<PointItem, 'id' | 'name' | 'amount'>
  )>, ticketType?: Maybe<(
    { __typename?: 'TicketType' }
    & Pick<TicketType, 'id' | 'name' | 'isChild' | 'isBusinessOnly'>
  )>, membershipType?: Maybe<(
    { __typename?: 'MembershipType' }
    & Pick<MembershipType, 'id' | 'name' | 'isChild'>
    & { membership: (
      { __typename?: 'Membership' }
      & Pick<Membership, 'name'>
    ) }
  )>, eventAddon?: Maybe<(
    { __typename?: 'EventAddon' }
    & Pick<EventAddon, 'id' | 'name'>
  )>, membershipAddon?: Maybe<(
    { __typename?: 'MembershipAddon' }
    & Pick<MembershipAddon, 'id' | 'name'>
  )> }
);

export type LineItemFragment = (
  { __typename?: 'LineItem' }
  & LineItemBaseFragment
  & LineItemInfoFragment
  & LineItemSeatFragment
  & LineItemFinanceFragment
  & LineItemPricingTierFragment
);

export type LineItemInfoFragment = (
  { __typename?: 'LineItem' }
  & Pick<LineItem, 'name' | 'type' | 'isComp'>
);

export type LineItemPricingTierFragment = (
  { __typename?: 'LineItem' }
  & Pick<LineItem, 'pricingTierId' | 'pricingTierName'>
);

export type LineItemSeatFragment = (
  { __typename?: 'LineItem' }
  & Pick<LineItem, 'seatLabel' | 'seatZone' | 'seatSection' | 'seatTags'>
);

export type MembershipBaseFragment = (
  { __typename?: 'Membership' }
  & Pick<Membership, 'id' | 'createdAt' | 'updatedAt'>
);

export type MembershipFragment = (
  { __typename?: 'Membership' }
  & Pick<Membership, 'taxRate' | 'customTaxRate' | 'taxCalculationMethod' | 'hasAccessCodes'>
  & { types: Array<(
    { __typename?: 'MembershipType' }
    & MembershipTypeFragment
  )>, multiBuyPromotions: Array<(
    { __typename?: 'MembershipMultiBuyPromotion' }
    & Pick<MembershipMultiBuyPromotion, 'id' | 'name' | 'getQuantity' | 'buyQuantity' | 'price' | 'enabled'>
    & { getMembershipType?: Maybe<(
      { __typename?: 'MembershipType' }
      & Pick<MembershipType, 'id' | 'name' | 'description' | 'restrictions' | 'kind'>
    )>, buyMembershipType?: Maybe<(
      { __typename?: 'MembershipType' }
      & Pick<MembershipType, 'id' | 'name' | 'description' | 'restrictions' | 'kind'>
    )> }
  )>, fees: (
    { __typename?: 'OrderFee' }
    & Pick<OrderFee, 'organizationExclusiveTaxRate'>
    & { fees: Array<(
      { __typename?: 'Fee' }
      & Pick<Fee, 'id' | 'name' | 'type' | 'value' | 'order' | 'isOptional'>
    )>, items: Array<(
      { __typename?: 'ItemFee' }
      & Pick<ItemFee, 'id' | 'isComp'>
      & { fees: Array<(
        { __typename?: 'Fee' }
        & Pick<Fee, 'id' | 'name' | 'type' | 'value' | 'order' | 'isOptional'>
      )> }
    )>, gateways: Array<(
      { __typename?: 'OrderFeeIntegration' }
      & Pick<OrderFeeIntegration, 'id' | 'type' | 'transactionFeeType' | 'transactionFee' | 'transactionFeeType2' | 'transactionFee2' | 'bnplEnabled' | 'bnplTransactionFeePercent' | 'isDefault'>
    )> }
  ), seatsIoConfig?: Maybe<(
    { __typename?: 'SeatsIoConfigOutput' }
    & Pick<SeatsIoConfigOutput, 'region' | 'publicKey' | 'eventKeys'>
  )> }
  & MembershipBaseFragment
  & MembershipInfoFragment
  & MembershipOptionsFragment
);

export type MembershipInfoFragment = (
  { __typename?: 'Membership' }
  & Pick<Membership, 'name' | 'membershipKind' | 'startDate' | 'endDate' | 'description' | 'showSchedule' | 'termsAndConditions' | 'accessibility' | 'importantNotice'>
  & { digitalPassCodesStatus?: Maybe<(
    { __typename?: 'DigitalPassCodeStatusOutput' }
    & Pick<DigitalPassCodeStatusOutput, 'remainingPassCodes'>
  )>, thumbnail?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragment
  )>, banner?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragment
  )>, backgroundImage?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragment
  )>, descriptionImage?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragment
  )>, ticketCover?: Maybe<(
    { __typename?: 'MembershipTicketCover' }
    & Pick<MembershipTicketCover, 'isEnabled' | 'totalFeePercentage' | 'purchaseBehaviour'>
  )> }
);

export type MembershipOptionsFragment = (
  { __typename?: 'Membership' }
  & Pick<Membership, 'bookingFeeType' | 'bookingFee' | 'canNameMembership' | 'canRenameMembership' | 'canChangeSeats' | 'changingSeatsFee' | 'canUsePoints' | 'isActive' | 'showSchedule'>
  & { shippingOptions?: Maybe<(
    { __typename?: 'ShippingOptions' }
    & ShippingOptionsFragment
  )>, gateways?: Maybe<Array<(
    { __typename?: 'Integration' }
    & Pick<Integration, 'id' | 'name' | 'type' | 'transactionFee' | 'transactionFeeType' | 'transactionFeeType2' | 'transactionFee2' | 'bnplEnabled' | 'bnplTransactionFeePercent'>
  )>>, addons: Array<(
    { __typename?: 'MembershipAddon' }
    & Pick<MembershipAddon, 'id' | 'name' | 'enableNaming' | 'price' | 'description' | 'restrictions' | 'isActive' | 'maxPurchaseQuantity'>
    & { namingFields: Array<(
      { __typename?: 'FormField' }
      & NamingFieldsFragment
    )>, addonImage?: Maybe<(
      { __typename?: 'ExtendedFile' }
      & FileFragment
    )> }
  )> }
);

export type MembershipTypeFragment = (
  { __typename?: 'MembershipType' }
  & Pick<MembershipType, 'id' | 'name' | 'kind' | 'quantitySet' | 'ticketFeeType' | 'description' | 'restrictions' | 'ticketFee' | 'isHidden' | 'isChild' | 'minPurchaseQuantity' | 'maxPurchaseQuantity'>
  & { namingFields: Array<(
    { __typename?: 'FormField' }
    & NamingFieldsFragment
  )> }
);

export type NamingFieldsFragment = (
  { __typename?: 'FormField' }
  & Pick<FormField, 'field' | 'isRequired' | 'label' | 'isCustom' | 'type' | 'defaultValue' | 'id' | 'options'>
);

export type OrderBaseFragment = (
  { __typename?: 'Order' }
  & Pick<Order, 'id' | 'createdAt' | 'updatedAt'>
);

export type CheckoutOrderFragment = (
  { __typename?: 'Order' }
  & { event?: Maybe<(
    { __typename?: 'Event' }
    & Pick<Event, 'id' | 'startDate' | 'endDate' | 'eventKind' | 'title' | 'canChangeSeats' | 'canRenameTicket' | 'sellerTransferringTicketFee' | 'canTransferTicket' | 'ticketsViewableFromDate' | 'hasPromoCodes' | 'redirectURL' | 'canUsePoints' | 'canUpgrade'>
    & { paymentPlanSettings?: Maybe<(
      { __typename?: 'PaymentPlanSettings' }
      & PaymentPlanSettingsFragmentFragment
    )>, venue: (
      { __typename?: 'Venue' }
      & Pick<Venue, 'id' | 'seating' | 'name'>
      & { zones: Array<(
        { __typename?: 'Zone' }
        & Pick<Zone, 'name' | 'stand' | 'admission'>
      )>, gates: Array<(
        { __typename?: 'Gate' }
        & Pick<Gate, 'name' | 'id'>
      )> }
      & VenueAddressFragment
    ), zonesAllocatedGates?: Maybe<Array<(
      { __typename?: 'ZoneAllocatedGate' }
      & Pick<ZoneAllocatedGate, 'name'>
    )>>, gateways: Array<(
      { __typename?: 'Integration' }
      & Pick<Integration, 'name' | 'id' | 'transactionFeeType' | 'transactionFee' | 'transactionFeeType2' | 'transactionFee2' | 'type' | 'publicKey' | 'paymentMethodType' | 'bnplEnabled' | 'bnplTransactionFeePercent'>
    )>, shippingOptions?: Maybe<(
      { __typename?: 'ShippingOptions' }
      & ShippingOptionsFragment
    )>, ticketTypes: Array<(
      { __typename?: 'TicketType' }
      & Pick<TicketType, 'isChild'>
      & { dates: Array<(
        { __typename?: 'TicketTypeDate' }
        & Pick<TicketTypeDate, 'alternateEntryTime'>
      )> }
      & TicketTypeDateOptionsFragment
    )>, multiBuyPromotions: Array<(
      { __typename?: 'EventMultiBuyPromotion' }
      & Pick<EventMultiBuyPromotion, 'id' | 'name' | 'getQuantity' | 'buyQuantity' | 'price' | 'enabled'>
      & { getTicketType: (
        { __typename?: 'TicketType' }
        & Pick<TicketType, 'id' | 'name' | 'description' | 'restrictions' | 'kind' | 'isGrouped' | 'groupAmount' | 'bookingFeeType' | 'bookingFee'>
        & { dates: Array<(
          { __typename?: 'TicketTypeDate' }
          & Pick<TicketTypeDate, 'alternateEntryTime'>
        )> }
      ), buyTicketType: (
        { __typename?: 'TicketType' }
        & Pick<TicketType, 'id' | 'name' | 'description' | 'restrictions' | 'kind' | 'isGrouped' | 'groupAmount' | 'bookingFeeType' | 'bookingFee'>
        & { dates: Array<(
          { __typename?: 'TicketTypeDate' }
          & Pick<TicketTypeDate, 'alternateEntryTime'>
        )> }
      ) }
    )>, customFields: Array<(
      { __typename?: 'CustomFieldOuput' }
      & Pick<CustomFieldOuput, 'id' | 'label' | 'value' | 'targetArea' | 'type' | 'isRequired'>
    )>, fees: (
      { __typename?: 'OrderFee' }
      & Pick<OrderFee, 'organizationExclusiveTaxRate'>
      & { fees: Array<(
        { __typename?: 'Fee' }
        & Pick<Fee, 'id' | 'name' | 'type' | 'value' | 'order' | 'isOptional'>
      )>, items: Array<(
        { __typename?: 'ItemFee' }
        & Pick<ItemFee, 'id' | 'isComp'>
        & { fees: Array<(
          { __typename?: 'Fee' }
          & Pick<Fee, 'id' | 'name' | 'type' | 'value' | 'order' | 'isOptional'>
        )> }
      )>, gateways: Array<(
        { __typename?: 'OrderFeeIntegration' }
        & Pick<OrderFeeIntegration, 'id' | 'type' | 'transactionFeeType' | 'transactionFee' | 'transactionFeeType2' | 'transactionFee2' | 'bnplEnabled' | 'bnplTransactionFeePercent' | 'isDefault'>
      )> }
    ), seekaConfig?: Maybe<(
      { __typename?: 'SeekaOutput' }
      & SeekaConfigFragment
    )> }
  )>, membership?: Maybe<(
    { __typename?: 'Membership' }
    & Pick<Membership, 'name' | 'canUsePoints' | 'enableAutoRenew' | 'membershipKind' | 'hasPromoCodes' | 'showSchedule' | 'membershipsViewableFromDate' | 'isTicketed'>
    & { paymentPlanSettings?: Maybe<(
      { __typename?: 'PaymentPlanSettings' }
      & PaymentPlanSettingsFragmentFragment
    )>, shippingOptions?: Maybe<(
      { __typename?: 'ShippingOptions' }
      & ShippingOptionsFragment
    )>, gateways?: Maybe<Array<(
      { __typename?: 'Integration' }
      & Pick<Integration, 'name' | 'id' | 'transactionFeeType' | 'transactionFee' | 'transactionFeeType2' | 'transactionFee2' | 'type' | 'publicKey' | 'bnplEnabled' | 'bnplTransactionFeePercent'>
    )>>, venue?: Maybe<(
      { __typename?: 'Venue' }
      & Pick<Venue, 'name' | 'seating'>
      & VenueAddressFragment
    )>, multiBuyPromotions: Array<(
      { __typename?: 'MembershipMultiBuyPromotion' }
      & Pick<MembershipMultiBuyPromotion, 'id' | 'name' | 'getQuantity' | 'buyQuantity' | 'price' | 'enabled'>
      & { getMembershipType?: Maybe<(
        { __typename?: 'MembershipType' }
        & Pick<MembershipType, 'id' | 'name' | 'description' | 'restrictions' | 'kind'>
      )>, buyMembershipType?: Maybe<(
        { __typename?: 'MembershipType' }
        & Pick<MembershipType, 'id' | 'name' | 'description' | 'restrictions' | 'kind'>
      )> }
    )>, fees: (
      { __typename?: 'OrderFee' }
      & Pick<OrderFee, 'organizationExclusiveTaxRate'>
      & { fees: Array<(
        { __typename?: 'Fee' }
        & Pick<Fee, 'id' | 'name' | 'type' | 'value' | 'order' | 'isOptional'>
      )>, items: Array<(
        { __typename?: 'ItemFee' }
        & Pick<ItemFee, 'id' | 'isComp'>
        & { fees: Array<(
          { __typename?: 'Fee' }
          & Pick<Fee, 'id' | 'name' | 'type' | 'value' | 'order' | 'isOptional'>
        )> }
      )>, gateways: Array<(
        { __typename?: 'OrderFeeIntegration' }
        & Pick<OrderFeeIntegration, 'id' | 'type' | 'transactionFeeType' | 'transactionFee' | 'transactionFeeType2' | 'transactionFee2' | 'bnplEnabled' | 'bnplTransactionFeePercent' | 'isDefault'>
      )> }
    ), seekaConfig?: Maybe<(
      { __typename?: 'SeekaOutput' }
      & SeekaConfigFragment
    )> }
  )> }
  & OrderFragment
);

export type OrderFinanceFragment = (
  { __typename?: 'Order' }
  & Pick<Order, 'bookingFeeType' | 'bookingFee' | 'bookingFeeAmount' | 'transferFee' | 'changingSeatsCredits' | 'deliveryFee' | 'subtotal' | 'amountDue' | 'total' | 'totalTax' | 'taxCalculationMethod' | 'taxRate' | 'customTaxAmount' | 'customTaxRate' | 'transactionFeeAmount' | 'usedCredits' | 'usedPoints' | 'paymentGateway' | 'membershipSubscriptionId' | 'isComp' | 'isPrechargeOrder' | 'refundedAmount' | 'transactionFeeType' | 'transactionFee' | 'transactionFeeType2' | 'transactionFee2' | 'smsConfirmationAmount'>
  & { multiBuyPromotion?: Maybe<(
    { __typename?: 'EventMultiBuyPromotion' }
    & Pick<EventMultiBuyPromotion, 'id' | 'name' | 'getQuantity' | 'buyQuantity' | 'price'>
    & { getTicketType: (
      { __typename?: 'TicketType' }
      & Pick<TicketType, 'id' | 'name' | 'description' | 'restrictions' | 'kind' | 'isGrouped' | 'groupAmount' | 'bookingFeeType' | 'bookingFee'>
      & { dates: Array<(
        { __typename?: 'TicketTypeDate' }
        & Pick<TicketTypeDate, 'alternateEntryTime'>
      )> }
    ), buyTicketType: (
      { __typename?: 'TicketType' }
      & Pick<TicketType, 'id' | 'name' | 'description' | 'restrictions' | 'kind' | 'isGrouped' | 'groupAmount' | 'bookingFeeType' | 'bookingFee'>
      & { dates: Array<(
        { __typename?: 'TicketTypeDate' }
        & Pick<TicketTypeDate, 'alternateEntryTime'>
      )> }
    ) }
  ) | (
    { __typename?: 'MembershipMultiBuyPromotion' }
    & Pick<MembershipMultiBuyPromotion, 'id' | 'name' | 'getQuantity' | 'buyQuantity' | 'price'>
    & { getMembershipType?: Maybe<(
      { __typename?: 'MembershipType' }
      & Pick<MembershipType, 'id' | 'name' | 'description' | 'restrictions' | 'kind'>
    )>, buyMembershipType?: Maybe<(
      { __typename?: 'MembershipType' }
      & Pick<MembershipType, 'id' | 'name' | 'description' | 'restrictions' | 'kind'>
    )> }
  )> }
  & PromoCodeFragment
);

export type OrderFragment = (
  { __typename?: 'Order' }
  & OrderBaseFragment
  & OrderInfoFragment
  & OrderFinanceFragment
  & OrderItemsFragment
  & OrderUserFragment
);

export type OrderInfoFragment = (
  { __typename?: 'Order' }
  & Pick<Order, 'orderNumber' | 'orderType' | 'status' | 'transactionStatus' | 'deliveryMethod' | 'expiryDate' | 'expiresInSeconds' | 'channel' | 'referralId' | 'isPrechargeOrder' | 'usableForMarketing' | 'prechargeOrderScheduledChargeDate' | 'heardAboutUs' | 'dietaryRequirements' | 'orderConfirmationSentAt' | 'stripeTerminalGatewayIds' | 'orderOriginatedFrom'>
  & { event?: Maybe<(
    { __typename?: 'Event' }
    & Pick<Event, 'id' | 'title' | 'sellerTransferringTicketFee'>
    & { ticketCover?: Maybe<(
      { __typename?: 'EventTicketCover' }
      & Pick<EventTicketCover, 'isEnabled' | 'totalFeePercentage' | 'purchaseBehaviour'>
    )> }
  )>, orderTicketCover?: Maybe<(
    { __typename?: 'OrderTicketCover' }
    & Pick<OrderTicketCover, 'totalFeeAmount' | 'purchaseBehaviour'>
  )>, orderPlan?: Maybe<(
    { __typename?: 'OrderPlan' }
    & Pick<OrderPlan, 'allowEarlyAccess'>
    & { billingDetails?: Maybe<(
      { __typename?: 'BillingDetails' }
      & Pick<BillingDetails, 'totalFeeAmount'>
    )> }
  )>, release?: Maybe<(
    { __typename?: 'Release' }
    & Pick<Release, 'id' | 'slug' | 'askHowDidYouHearAboutUs' | 'askForDietaryRequirements' | 'allowAccount2Account' | 'allowHoldOrders' | 'type' | 'isPrePurchaseActive' | 'startConditionDate'>
  )>, pos?: Maybe<(
    { __typename?: 'Pos' }
    & Pick<Pos, 'id'>
    & { event: (
      { __typename?: 'Event' }
      & Pick<Event, 'id'>
    ), release: (
      { __typename?: 'Release' }
      & Pick<Release, 'id'>
    ) }
  )>, defaultGateway?: Maybe<(
    { __typename?: 'Integration' }
    & Pick<Integration, 'id'>
  )>, tax?: Maybe<(
    { __typename?: 'OrderTax' }
    & Pick<OrderTax, 'totalExclusive'>
    & { tax: Array<(
      { __typename?: 'TaxApplied' }
      & Pick<TaxApplied, 'name' | 'total' | 'isExclusive'>
    )> }
  )>, point?: Maybe<(
    { __typename?: 'Point' }
    & Pick<Point, 'id'>
  )>, pointItem?: Maybe<(
    { __typename?: 'PointItem' }
    & Pick<PointItem, 'id'>
  )>, stripeConfig?: Maybe<(
    { __typename?: 'StripeConfigOutput' }
    & StripeConfigFragment
  )> }
);

export type OrderItemsFragment = (
  { __typename?: 'Order' }
  & { lineItems: (
    { __typename?: 'LineItemConnection' }
    & { edges: Array<(
      { __typename?: 'LineItemEdge' }
      & { node: (
        { __typename?: 'LineItem' }
        & { membershipType?: Maybe<(
          { __typename?: 'MembershipType' }
          & { membership: (
            { __typename?: 'Membership' }
            & Pick<Membership, 'isTicketed'>
          ) }
        )> }
        & LineItemFragment
      ) }
    )> }
  ), orderTicketCover?: Maybe<(
    { __typename?: 'OrderTicketCover' }
    & Pick<OrderTicketCover, 'totalFeeAmount' | 'purchaseBehaviour'>
  )>, orderPlan?: Maybe<(
    { __typename?: 'OrderPlan' }
    & { billingDetails?: Maybe<(
      { __typename?: 'BillingDetails' }
      & Pick<BillingDetails, 'totalFeeAmount'>
    )> }
  )>, tickets: Array<(
    { __typename?: 'Ticket' }
    & Pick<Ticket, 'status' | 'displayName'>
    & { lineItem?: Maybe<(
      { __typename?: 'LineItem' }
      & LineItemFragment
    )>, ticketType?: Maybe<(
      { __typename?: 'TicketType' }
      & Pick<TicketType, 'id' | 'name' | 'kind' | 'isChild' | 'printAtHomeInformation'>
      & { dates: Array<(
        { __typename?: 'TicketTypeDate' }
        & Pick<TicketTypeDate, 'eventDateId' | 'alternateEntryTime'>
      )>, namingFields: Array<(
        { __typename?: 'FormField' }
        & NamingFieldsFragment
      )> }
      & TicketTypeDateOptionsFragment
    )>, parentTicket?: Maybe<(
      { __typename?: 'Ticket' }
      & Pick<Ticket, 'id' | 'firstName' | 'lastName'>
    )>, event?: Maybe<(
      { __typename?: 'Event' }
      & Pick<Event, 'id' | 'title' | 'startDate' | 'endDate' | 'eventKind' | 'canRenameTicket' | 'sellerTransferringTicketFee' | 'canTransferTicket' | 'canChangeSeats' | 'ticketResaleEnabled' | 'ticketsViewableFromDate' | 'isR18'>
      & { venue: (
        { __typename?: 'Venue' }
        & Pick<Venue, 'id' | 'name'>
        & { zones: Array<(
          { __typename?: 'Zone' }
          & Pick<Zone, 'name' | 'stand' | 'admission'>
        )>, gates: Array<(
          { __typename?: 'Gate' }
          & Pick<Gate, 'name' | 'id'>
        )> }
        & VenueAddressFragment
      ), zonesAllocatedGates?: Maybe<Array<(
        { __typename?: 'ZoneAllocatedGate' }
        & Pick<ZoneAllocatedGate, 'name'>
        & { dates?: Maybe<Array<(
          { __typename?: 'ZoneAllocatedDate' }
          & Pick<ZoneAllocatedDate, 'eventDateId' | 'alternateEntryTime'>
        )>> }
      )>>, ticketCover?: Maybe<(
        { __typename?: 'EventTicketCover' }
        & Pick<EventTicketCover, 'isEnabled' | 'totalFeePercentage' | 'purchaseBehaviour'>
      )> }
      & EventDateOptionsFragment
    )>, membershipType?: Maybe<(
      { __typename?: 'MembershipType' }
      & Pick<MembershipType, 'name' | 'isChild'>
      & { membership: (
        { __typename?: 'Membership' }
        & Pick<Membership, 'name' | 'canRenameMembership' | 'membershipKind' | 'isTicketed' | 'membershipsViewableFromDate'>
      ), namingFields: Array<(
        { __typename?: 'FormField' }
        & NamingFieldsFragment
      )> }
    )>, membership?: Maybe<(
      { __typename?: 'Membership' }
      & Pick<Membership, 'name' | 'membershipKind' | 'canRenameMembership' | 'startDate' | 'endDate'>
      & { venue?: Maybe<(
        { __typename?: 'Venue' }
        & Pick<Venue, 'id' | 'name'>
        & { zones: Array<(
          { __typename?: 'Zone' }
          & Pick<Zone, 'name' | 'stand' | 'admission'>
        )>, gates: Array<(
          { __typename?: 'Gate' }
          & Pick<Gate, 'name' | 'id'>
        )> }
        & VenueAddressFragment
      )>, ticketCover?: Maybe<(
        { __typename?: 'MembershipTicketCover' }
        & Pick<MembershipTicketCover, 'isEnabled' | 'totalFeePercentage' | 'purchaseBehaviour'>
      )> }
    )>, addon?: Maybe<(
      { __typename?: 'EventAddon' }
      & Pick<EventAddon, 'id' | 'name' | 'enableNaming' | 'hideQRCode'>
      & { namingFields: Array<(
        { __typename?: 'FormField' }
        & NamingFieldsFragment
      )> }
    ) | (
      { __typename?: 'MembershipAddon' }
      & Pick<MembershipAddon, 'id' | 'name' | 'enableNaming'>
      & { namingFields: Array<(
        { __typename?: 'FormField' }
        & NamingFieldsFragment
      )> }
    )> }
    & TicketFragment
  )>, event?: Maybe<(
    { __typename?: 'Event' }
    & Pick<Event, 'canChangeSeats' | 'changingSeatsFee' | 'canRenameTicket'>
    & EventBaseFragment
    & EventInfoFragment
  )>, membership?: Maybe<(
    { __typename?: 'Membership' }
    & Pick<Membership, 'canRenameMembership'>
    & MembershipBaseFragment
    & MembershipInfoFragment
  )>, transactions: (
    { __typename?: 'OrderTransactionConnection' }
    & { edges: Array<(
      { __typename?: 'OrderTransactionEdge' }
      & { node: (
        { __typename?: 'OrderTransaction' }
        & Pick<OrderTransaction, 'id' | 'kind' | 'status' | 'amount'>
      ) }
    )> }
  ), posTransactions: (
    { __typename?: 'PosTransactionConnection' }
    & { edges: Array<(
      { __typename?: 'PosTransactionEdge' }
      & { node: (
        { __typename?: 'PosTransaction' }
        & Pick<PosTransaction, 'id' | 'amount' | 'fee' | 'paymentGateway' | 'returned'>
      ) }
    )> }
  ) }
);

export type PromoCodeFragment = (
  { __typename?: 'Order' }
  & { promoCode?: Maybe<(
    { __typename: 'EventPromoCode' }
    & Pick<EventPromoCode, 'id' | 'code' | 'discountType' | 'discountAmount'>
    & { eventType: EventPromoCode['type'] }
  ) | (
    { __typename: 'MembershipPromoCode' }
    & Pick<MembershipPromoCode, 'id' | 'code' | 'discountType' | 'discountAmount'>
    & { membershipType: MembershipPromoCode['type'] }
  )> }
);

export type OrderUserFragment = (
  { __typename?: 'Order' }
  & Pick<Order, 'shippingAddressMatchesBillingAddress'>
  & { user?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'referralId' | 'birthDate' | 'credits' | 'fullName' | 'firstName' | 'lastName' | 'email' | 'phoneNumber' | 'e164Number' | 'points'>
    & { billingAddress?: Maybe<(
      { __typename?: 'PartialAddress' }
      & PartialAddressFragment
    )>, shippingAddress?: Maybe<(
      { __typename?: 'PartialAddress' }
      & PartialAddressFragment
    )> }
  )>, buyerInformation?: Maybe<(
    { __typename?: 'BuyerInformation' }
    & Pick<BuyerInformation, 'firstName' | 'lastName' | 'email' | 'phoneNumber' | 'taxNumber' | 'postalCode' | 'city' | 'country' | 'companyName' | 'state'>
  )>, billingAddress?: Maybe<(
    { __typename?: 'Address' }
    & AddressFragment
  )>, shippingAddress?: Maybe<(
    { __typename?: 'Address' }
    & AddressFragment
  )> }
);

export type PartialAddressFragment = (
  { __typename?: 'PartialAddress' }
  & Pick<PartialAddress, 'line1' | 'line2' | 'suburb' | 'postalCode' | 'city' | 'state' | 'country'>
);

export type PaymentPlanSettingsFragmentFragment = (
  { __typename?: 'PaymentPlanSettings' }
  & Pick<PaymentPlanSettings, 'disabledAt'>
  & { scheduleOptions?: Maybe<Array<(
    { __typename?: 'ScheduleOption' }
    & Pick<ScheduleOption, 'id' | 'interval' | 'installmentCount' | 'stripeFeePercentage' | 'promoterFeePercentage' | 'flicketFeePercentage' | 'minimumOrderAmount' | 'finalPaymentDate'>
  )>> }
);

export type ReferralStatsFragmentFragment = (
  { __typename?: 'ReferralCustomerReporting' }
  & Pick<ReferralCustomerReporting, 'referralsMade' | 'eventName' | 'orderDate' | 'orderNumber' | 'referralLink'>
  & { eventLogo?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & Pick<ExtendedFile, 'fileName' | 'storage' | 'originalFileName' | 'directory'>
    & { metaData?: Maybe<(
      { __typename?: 'MetaData' }
      & Pick<MetaData, 'height' | 'width'>
    )> }
  )> }
);

export type ReleaseBaseFragment = (
  { __typename?: 'Release' }
  & Pick<Release, 'id' | 'createdAt' | 'updatedAt'>
);

export type ReleaseFragment = (
  { __typename?: 'Release' }
  & ReleaseBaseFragment
  & ReleaseInfoFragment
  & ReleaseOptionsFragment
);

export type ReleaseInfoFragment = (
  { __typename?: 'Release' }
  & Pick<Release, 'name' | 'slug' | 'type' | 'presaleTitle' | 'presaleInformation' | 'releaseNotes'>
  & { presaleLogo?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragment
  )>, presaleHeader?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragment
  )>, releaseEventAddons: Array<(
    { __typename?: 'ReleaseEventAddon' }
    & { eventAddon: (
      { __typename?: 'EventAddon' }
      & Pick<EventAddon, 'id' | 'name' | 'enableNaming' | 'price' | 'description' | 'restrictions' | 'isActive' | 'addonAvailabilityStatus' | 'maxPurchaseQuantity'>
      & { addonImage?: Maybe<(
        { __typename?: 'ExtendedFile' }
        & FileFragment
      )> }
    ) }
  )> }
);

export type ReleaseOptionsFragment = (
  { __typename?: 'Release' }
  & Pick<Release, 'startCondition' | 'startConditionDate' | 'endCondition' | 'endConditionQuantity' | 'endConditionDate' | 'isActive' | 'askHowDidYouHearAboutUs' | 'askForDietaryRequirements' | 'allowPublicComp' | 'allowAccount2Account'>
  & { releaseZones: Array<(
    { __typename?: 'ReleaseZone' }
    & ReleaseZonesFragment
  )> }
);

export type ReleaseZonesFragment = (
  { __typename?: 'ReleaseZone' }
  & Pick<ReleaseZone, 'pricingLevel' | 'isActive'>
  & { zone: (
    { __typename?: 'Zone' }
    & Pick<Zone, 'name'>
  ), ticketTypes: Array<(
    { __typename?: 'ReleaseZoneTicketType' }
    & Pick<ReleaseZoneTicketType, 'price' | 'isActive' | 'ticketTypeId' | 'isSoldOut' | 'minPurchaseQuantity' | 'maxPurchaseQuantity'>
    & { sections?: Maybe<Array<(
      { __typename?: 'ZonePricingTypeSection' }
      & Pick<ZonePricingTypeSection, 'name' | 'price'>
    )>> }
  )> }
);

export type SeasonFragmentFragment = (
  { __typename?: 'Season' }
  & Pick<Season, 'id' | 'name' | 'isActive' | 'startDate' | 'description' | 'endDate' | 'landingDescription' | 'updatedAt' | 'createdAt' | 'displayOrder'>
  & { events: Array<(
    { __typename?: 'Event' }
    & Pick<Event, 'id' | 'title' | 'startDate' | 'endDate' | 'eventKind' | 'isActive'>
  )>, thumbnail?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragment
  )>, backgroundImageFullPage?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragment
  )>, landingBanner?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragment
  )> }
);

export type SeasonBaseFragment = (
  { __typename?: 'Season' }
  & Pick<Season, 'id' | 'createdAt' | 'updatedAt'>
);

export type SeasonFragment = (
  { __typename?: 'Season' }
  & SeasonBaseFragment
  & SeasonInfoFragment
);

export type SeasonInfoFragment = (
  { __typename?: 'Season' }
  & Pick<Season, 'name' | 'isActive' | 'startDate' | 'endDate'>
);

export type SeekaConfigFragment = (
  { __typename?: 'SeekaOutput' }
  & Pick<SeekaOutput, 'seekaOrganizationId' | 'seekaPublicKey' | 'seekaInstanceId' | 'seekaScopeDescription' | 'currencyCode' | 'countryCode'>
);

export type ShippingOptionsFragment = (
  { __typename?: 'ShippingOptions' }
  & Pick<ShippingOptions, 'eTicket' | 'printedTicketByMail' | 'printedTicketByCourier' | 'printedTicketByCourierRural' | 'printedTicketAtVenue'>
);

export type StripeConfigFragment = (
  { __typename?: 'StripeConfigOutput' }
  & Pick<StripeConfigOutput, 'integrationId' | 'publishableKey' | 'connectedAccountId' | 'expressCheckoutEnabled'>
);

export type TicketTypeBaseFragment = (
  { __typename?: 'TicketType' }
  & Pick<TicketType, 'id' | 'createdAt' | 'updatedAt'>
);

export type FinanceFragment = (
  { __typename?: 'TicketType' }
  & Pick<TicketType, 'isGrouped' | 'groupAmount' | 'bookingFeeType' | 'bookingFee' | 'stadiumLevyFee' | 'kind'>
);

export type TicketTypeFragment = (
  { __typename?: 'TicketType' }
  & TicketTypeBaseFragment
  & TicketTypeInfoFragment
  & FinanceFragment
);

export type TicketTypeInfoFragment = (
  { __typename?: 'TicketType' }
  & Pick<TicketType, 'id' | 'name' | 'description' | 'restrictions' | 'kind' | 'quantitySet' | 'inHighDemand' | 'customBadge' | 'customBadgeBackgroundColor' | 'customBadgeTextColor' | 'soldOut' | 'isChild' | 'isBusinessOnly' | 'isResaleTicket' | 'resaleHiddenFromPublic' | 'quantity' | 'notOnSaleMessage' | 'onSaleStatus'>
  & { dates: Array<(
    { __typename?: 'TicketTypeDate' }
    & Pick<TicketTypeDate, 'alternateEntryTime'>
  )>, namingFields: Array<(
    { __typename?: 'FormField' }
    & NamingFieldsFragment
  )>, ticketImage?: Maybe<(
    { __typename?: 'ExtendedFile' }
    & FileFragment
  )>, onSaleConfig?: Maybe<(
    { __typename?: 'TicketTypeOnSaleConfig' }
    & Pick<TicketTypeOnSaleConfig, 'endDate'>
    & { startConfig: (
      { __typename?: 'TicketTypeOnSaleStartConfig' }
      & Pick<TicketTypeOnSaleStartConfig, 'startDate'>
    ) }
  )> }
  & TicketTypeDateOptionsFragment
);

export type TicketTypeDateOptionsFragment = (
  { __typename?: 'TicketType' }
  & Pick<TicketType, 'showStartTime' | 'showEndTime' | 'hasCustomDates'>
  & { entryDates?: Maybe<Array<(
    { __typename?: 'EventDate' }
    & DateOptionsFragment
  )>> }
);

export type TicketBaseFragment = (
  { __typename?: 'Ticket' }
  & Pick<Ticket, 'id' | 'createdAt' | 'updatedAt'>
);

export type TicketFragment = (
  { __typename?: 'Ticket' }
  & TicketBaseFragment
  & TicketInfoFragment
  & TicketUserFragment
  & TicketSendFragment
);

export type TicketInfoFragment = (
  { __typename?: 'Ticket' }
  & Pick<Ticket, 'displayName' | 'ticketNumber' | 'digitalPassCode' | 'digitalEventUrl' | 'seatLabel' | 'seatZone' | 'seatSection' | 'seatTags' | 'isNamed' | 'shouldBeNamed' | 'qrCode' | 'status' | 'transferStatus' | 'maxTransferPrice' | 'purchaseRestrictionText' | 'firstScanInId'>
  & { ticketType?: Maybe<(
    { __typename?: 'TicketType' }
    & Pick<TicketType, 'isChild'>
  )>, resellabilityState: (
    { __typename?: 'TicketResellabilityState' }
    & Pick<TicketResellabilityState, 'ticketResaleAllowed' | 'ticketTransferAllowed' | 'latestTransferCompletionDate' | 'reason' | 'hoursLeftToTransfer' | 'afterpayRefundWindow'>
  ), gates?: Maybe<Array<(
    { __typename?: 'Gate' }
    & Pick<Gate, 'id' | 'name'>
  )>> }
);

export type TicketUserFragment = (
  { __typename?: 'Ticket' }
  & Pick<Ticket, 'firstName' | 'lastName' | 'email' | 'phoneNumber' | 'birthDate' | 'gender' | 'postalCode' | 'companyName' | 'licensePlate' | 'memberSince' | 'membershipNumber' | 'comments' | 'dietaryRequirements' | 'lengthOfStay' | 'usableForEmailMarketing' | 'usableForSMSMarketing' | 'emergencyName' | 'emergencyContact' | 'emergencyContactRelationship' | 'dunedinResidentialAddress' | 'studentId'>
  & { vaccinePass?: Maybe<(
    { __typename?: 'VaccinePass' }
    & Pick<VaccinePass, 'id'>
  )>, customFields?: Maybe<Array<(
    { __typename?: 'CustomField' }
    & Pick<CustomField, 'fieldName' | 'fieldValue'>
  )>> }
);

export type UserBaseFragment = (
  { __typename?: 'User' }
  & Pick<User, 'id' | 'createdAt' | 'updatedAt'>
);

export type BillingAndShippingFragment = (
  { __typename?: 'User' }
  & Pick<User, 'shippingAddressMatchesBillingAddress'>
  & { billingAddress?: Maybe<(
    { __typename?: 'PartialAddress' }
    & PartialAddressFragment
  )>, shippingAddress?: Maybe<(
    { __typename?: 'PartialAddress' }
    & PartialAddressFragment
  )> }
);

export type CredentialsFragment = (
  { __typename?: 'User' }
  & Pick<User, 'email' | 'roles' | 'hasPassword' | 'permissions' | 'isTwoFactorAuthenticationEnabled'>
);

export type UserFragment = (
  { __typename?: 'User' }
  & UserBaseFragment
  & NameFragment
  & PersonalFragment
  & BillingAndShippingFragment
  & CredentialsFragment
);

export type NameFragment = (
  { __typename?: 'User' }
  & Pick<User, 'firstName' | 'lastName' | 'fullName'>
);

export type PersonalFragment = (
  { __typename?: 'User' }
  & Pick<User, 'birthDate' | 'phoneNumber' | 'e164Number' | 'gender' | 'usableForEmailMarketing' | 'usableForSMSMarketing' | 'credits' | 'points' | 'taxNumber' | 'companyName' | 'instagramUsername' | 'referralId'>
);

export type VenueAddressFragment = (
  { __typename?: 'Venue' }
  & Pick<Venue, 'timezone' | 'locale'>
  & { address: (
    { __typename?: 'Address' }
    & AddressFragment
  ), location?: Maybe<(
    { __typename?: 'Coordinate' }
    & Pick<Coordinate, 'lat' | 'lng'>
  )> }
);

export type VenueBaseFragment = (
  { __typename?: 'Venue' }
  & Pick<Venue, 'id' | 'createdAt' | 'updatedAt'>
);

export type VenueFragment = (
  { __typename?: 'Venue' }
  & VenueBaseFragment
  & VenueInfoFragment
  & VenueAddressFragment
  & SeatsIoFragment
  & VenueSeatSelectionFiltersFragment
);

export type VenueInfoFragment = (
  { __typename?: 'Venue' }
  & Pick<Venue, 'name' | 'capacity' | 'accessibilityInfo' | 'filterOptions'>
);

export type SeatsIoFragment = (
  { __typename?: 'Venue' }
  & Pick<Venue, 'seatsChartKey' | 'seating'>
  & { zones: Array<(
    { __typename?: 'Zone' }
    & Pick<Zone, 'name' | 'stand'>
    & { sections?: Maybe<Array<(
      { __typename?: 'Section' }
      & Pick<Section, 'name'>
    )>> }
  )> }
  & VenueAddressFragment
);

export type VenueSeatSelectionFiltersFragment = (
  { __typename?: 'Venue' }
  & { defaultSeatSelectionFilters: (
    { __typename?: 'SeatSelectionFilters' }
    & Pick<SeatSelectionFilters, 'seatQuantity' | 'sortType' | 'selectType'>
  ) }
);

export type AddTransactionMutationVariables = Exact<{
  id: Scalars['String'];
  input: AddPosTransactionInput;
}>;


export type AddTransactionMutation = (
  { __typename?: 'Mutation' }
  & { addPosTransaction: (
    { __typename?: 'PosTransaction' }
    & Pick<PosTransaction, 'id' | 'paymentGateway' | 'amount' | 'fee' | 'returned' | 'status'>
  ) }
);

export type OnTrackingCodeVisitMutationVariables = Exact<{
  input: TrackingCodeVisitInput;
}>;


export type OnTrackingCodeVisitMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'onTrackingCodeVisit'>
);

export type AddUnsubscribeReasonMutationVariables = Exact<{
  input: AddUnsubscribeReasonInput;
}>;


export type AddUnsubscribeReasonMutation = (
  { __typename?: 'Mutation' }
  & { addUnsubscribeReason: (
    { __typename?: 'User' }
    & Pick<User, 'id'>
  ) }
);

export type AddUnsubscribeReasonV2MutationVariables = Exact<{
  input: AddUnsubscribeReasonV2Input;
}>;


export type AddUnsubscribeReasonV2Mutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addUnsubscribeReasonV2'>
);

export type ApplyPromoCodeMutationVariables = Exact<{
  input: ApplyPromoCode;
  id: Scalars['String'];
}>;


export type ApplyPromoCodeMutation = (
  { __typename?: 'Mutation' }
  & { applyPromoCodeToOrder: (
    { __typename?: 'Order' }
    & Pick<Order, 'id'>
    & PromoCodeFragment
  ) }
);

export type AssignTwoFactorAuthenticationSecretMutationVariables = Exact<{ [key: string]: never; }>;


export type AssignTwoFactorAuthenticationSecretMutation = (
  { __typename?: 'Mutation' }
  & { assignTwoFactorAuthenticationSecret: (
    { __typename?: 'TwoFactorAuthenticationSetupResult' }
    & Pick<TwoFactorAuthenticationSetupResult, 'dataURL' | 'secret'>
  ) }
);

export type AuthenticateWithTwoFactorMutationVariables = Exact<{
  input: TwoFactorAuthenticationCodeInput;
}>;


export type AuthenticateWithTwoFactorMutation = (
  { __typename?: 'Mutation' }
  & { authenticateWithTwoFactor: (
    { __typename?: 'User' }
    & Pick<User, 'id'>
  ) }
);

export type BroadcastReportingLinkOpenedMutationVariables = Exact<{
  input: BroadcastReportingInputBase;
}>;


export type BroadcastReportingLinkOpenedMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'broadcastReportingLinkOpened'>
);

export type BroadcastReportingOrderCreatedMutationVariables = Exact<{
  input: BroadcastReportingOrderInput;
}>;


export type BroadcastReportingOrderCreatedMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'broadcastReportingOrderCreated'>
);

export type BroadcastReportingSetAsSpamFromUserMutationVariables = Exact<{
  input: BroadcastReportingInputBase;
}>;


export type BroadcastReportingSetAsSpamFromUserMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'broadcastReportingSetAsSpamFromUser'>
);

export type CancelOrderMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type CancelOrderMutation = (
  { __typename?: 'Mutation' }
  & { cancelOrder: (
    { __typename?: 'Order' }
    & Pick<Order, 'id'>
  ) }
);

export type CancelPendingTicketTransferMutationVariables = Exact<{
  ticketId: Scalars['String'];
}>;


export type CancelPendingTicketTransferMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'cancelPendingTicketTransfer'>
);

export type CancelPrechargeOrderMutationVariables = Exact<{
  orderId: Scalars['String'];
}>;


export type CancelPrechargeOrderMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'cancelPrechargeOrder'>
);

export type CreateOrderMutationVariables = Exact<{
  input: CreateOrderInput;
}>;


export type CreateOrderMutation = (
  { __typename?: 'Mutation' }
  & { createOrder: (
    { __typename?: 'OrderCreateOutput' }
    & Pick<OrderCreateOutput, 'jobId'>
    & { order?: Maybe<(
      { __typename?: 'Order' }
      & { event?: Maybe<(
        { __typename?: 'Event' }
        & Pick<Event, 'title'>
      )>, membership?: Maybe<(
        { __typename?: 'Membership' }
        & Pick<Membership, 'name'>
      )> }
      & OrderFragment
    )>, createOrderError?: Maybe<Array<(
      { __typename: 'TicketNotAvailableError' }
      & Pick<TicketNotAvailableError, 'message' | 'shouldDisplayWaitlist' | 'eventId' | 'releaseId'>
    )>> }
  ) }
);

export type CreateOrderToTrackingCodeAssociationMutationVariables = Exact<{
  input: TrackingCodeOrderInput;
}>;


export type CreateOrderToTrackingCodeAssociationMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'createOrderToTrackingCodeAssociation'>
);

export type CreatePaymentMutationVariables = Exact<{
  id: Scalars['String'];
  input: CreatePaymentInput;
}>;


export type CreatePaymentMutation = (
  { __typename?: 'Mutation' }
  & { createPayment: (
    { __typename?: 'CreatePaymentOutput' }
    & { result?: Maybe<(
      { __typename: 'PaymentSuccess' }
      & Pick<PaymentSuccess, 'gateway' | 'redirectTo' | 'externalId'>
    ) | (
      { __typename: 'PaymentError' }
      & Pick<PaymentError, 'code' | 'message'>
    )> }
  ) }
);

export type CreatePinPaymentChargeMutationVariables = Exact<{
  input: CreatePinPaymentCharge;
}>;


export type CreatePinPaymentChargeMutation = (
  { __typename?: 'Mutation' }
  & { createPinPaymentCharge: (
    { __typename?: 'PinPaymentChargeResponse' }
    & Pick<PinPaymentChargeResponse, 'redirectUrl'>
  ) }
);

export type CreateRedirectUrlMutationVariables = Exact<{
  input: CreateRedirectUrlInput;
}>;


export type CreateRedirectUrlMutation = (
  { __typename?: 'Mutation' }
  & { createRedirectUrl: (
    { __typename?: 'RedirectUrl' }
    & Pick<RedirectUrl, 'redirectURL'>
  ) }
);

export type CreateSetupIntentForCardUpdateMutationVariables = Exact<{
  orderId: Scalars['String'];
}>;


export type CreateSetupIntentForCardUpdateMutation = (
  { __typename?: 'Mutation' }
  & { createSetupIntentForCardUpdate: (
    { __typename?: 'CardUpdateSetupIntentOutput' }
    & Pick<CardUpdateSetupIntentOutput, 'clientSecret'>
  ) }
);

export type DeleteSelfMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteSelfMutation = (
  { __typename?: 'Mutation' }
  & { deleteSelf: (
    { __typename?: 'DeleteOneOutput' }
    & Pick<DeleteOneOutput, 'deletedId'>
  ) }
);

export type EnableTwoFactorAuthenticationMutationVariables = Exact<{
  input: TwoFactorAuthenticationCodeInput;
}>;


export type EnableTwoFactorAuthenticationMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'enableTwoFactorAuthentication'>
);

export type ExpireOrderMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ExpireOrderMutation = (
  { __typename?: 'Mutation' }
  & { expireOrder: (
    { __typename?: 'Order' }
    & Pick<Order, 'id'>
  ) }
);

export type FinishPosTransactionMutationVariables = Exact<{
  id: Scalars['String'];
  autoScan?: Maybe<Scalars['Boolean']>;
}>;


export type FinishPosTransactionMutation = (
  { __typename?: 'Mutation' }
  & { finishPosTransaction: (
    { __typename?: 'Order' }
    & OrderFragment
  ) }
);

export type HoldBestAvailableSeatsMutationVariables = Exact<{
  id: Scalars['String'];
  input: HoldBestAvailableSeatsInput;
}>;


export type HoldBestAvailableSeatsMutation = (
  { __typename?: 'Mutation' }
  & { holdBestAvailableSeats: (
    { __typename?: 'HoldBestAvailableSeatsOutput' }
    & Pick<HoldBestAvailableSeatsOutput, 'objects'>
  ) }
);

export type HoldCustomerOrderMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type HoldCustomerOrderMutation = (
  { __typename?: 'Mutation' }
  & { holdCustomerOrder: (
    { __typename?: 'Order' }
    & OrderFragment
  ) }
);

export type JoinWaitlistMutationVariables = Exact<{
  input: JoinWaitlistInput;
}>;


export type JoinWaitlistMutation = (
  { __typename?: 'Mutation' }
  & { joinWaitlist: (
    { __typename?: 'Waitlist' }
    & Pick<Waitlist, 'id'>
    & { user: (
      { __typename?: 'User' }
      & Pick<User, 'e164Number' | 'phoneNumber'>
      & { billingAddress?: Maybe<(
        { __typename?: 'PartialAddress' }
        & Pick<PartialAddress, 'country'>
      )>, internationalPhoneNumber?: Maybe<(
        { __typename?: 'InternationalPhoneNumberOutput' }
        & Pick<InternationalPhoneNumberOutput, 'country'>
      )> }
    ) }
  ) }
);

export type ListTicketForResaleMutationVariables = Exact<{
  ticketId: Scalars['String'];
}>;


export type ListTicketForResaleMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'listTicketForResale'>
);

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutation = (
  { __typename?: 'Mutation' }
  & { login: (
    { __typename?: 'User' }
    & Pick<User, 'id'>
  ) }
);

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'logout'>
);

export type OptInMarketingMutationVariables = Exact<{
  ticketSendId: Scalars['String'];
  optIn: Scalars['Boolean'];
}>;


export type OptInMarketingMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'optInMarketing'>
);

export type PosAutoscanMutationVariables = Exact<{
  orderId: Scalars['String'];
}>;


export type PosAutoscanMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'posAutoscan'>
);

export type PosTerminalCancelMutationVariables = Exact<{
  posId: Scalars['String'];
}>;


export type PosTerminalCancelMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'posTerminalCancel'>
);

export type RegisterMutationVariables = Exact<{
  input: RegisterInput;
}>;


export type RegisterMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'register'>
);

export type RemovePromoCodeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemovePromoCodeMutation = (
  { __typename?: 'Mutation' }
  & { removePromoCodeFromOrder: (
    { __typename?: 'Order' }
    & OrderFragment
  ) }
);

export type RemoveMultiFactorAuthenticationSecretMutationVariables = Exact<{
  code: Scalars['String'];
}>;


export type RemoveMultiFactorAuthenticationSecretMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'removeMultiFactorAuthenticationSecret'>
);

export type RemoveTransactionMutationVariables = Exact<{
  id: Scalars['String'];
  transactionId: Scalars['String'];
}>;


export type RemoveTransactionMutation = (
  { __typename?: 'Mutation' }
  & { removePosTransaction: (
    { __typename?: 'Order' }
    & OrderFragment
  ) }
);

export type RequestDeleteAccountMutationVariables = Exact<{
  input: RequestMagicLinkInput;
}>;


export type RequestDeleteAccountMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'requestDeleteAccount'>
);

export type RequestMagicLinkMutationVariables = Exact<{
  input: RequestMagicLinkInput;
}>;


export type RequestMagicLinkMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'requestMagicLink'>
);

export type RequestResetPasswordMutationVariables = Exact<{
  input: RequestResetPasswordInput;
}>;


export type RequestResetPasswordMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'requestResetPassword'>
);

export type RequestTicketTransferMutationVariables = Exact<{
  input: RequestTicketTransferInput;
}>;


export type RequestTicketTransferMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'requestTicketTransfer'>
);

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'resetPassword'>
);

export type ResubscribeMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type ResubscribeMutation = (
  { __typename?: 'Mutation' }
  & { resubscribe: (
    { __typename?: 'User' }
    & Pick<User, 'id'>
  ) }
);

export type ResubscribeV2MutationVariables = Exact<{
  sendId: Scalars['String'];
}>;


export type ResubscribeV2Mutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'resubscribeV2'>
);

export type SaveNewSetupIntentForCardUpdateMutationVariables = Exact<{
  input: SaveNewSetupIntentForCardUpdateInput;
}>;


export type SaveNewSetupIntentForCardUpdateMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'saveNewSetupIntentForCardUpdate'>
);

export type SendOrderConfirmationMutationVariables = Exact<{
  id: Scalars['String'];
  input: SendOrderConfirmationInput;
}>;


export type SendOrderConfirmationMutation = (
  { __typename?: 'Mutation' }
  & { sendOrderConfirmation: (
    { __typename?: 'SendOrderConfirmationOutput' }
    & Pick<SendOrderConfirmationOutput, 'email'>
  ) }
);

export type SendTwoFactorCodeViaEmailMutationVariables = Exact<{ [key: string]: never; }>;


export type SendTwoFactorCodeViaEmailMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'sendTwoFactorCodeViaEmail'>
);

export type SocialAuthMutationVariables = Exact<{
  input: SocialAuthInput;
}>;


export type SocialAuthMutation = (
  { __typename?: 'Mutation' }
  & { socialAuth: (
    { __typename?: 'User' }
    & Pick<User, 'id'>
  ) }
);

export type SplitGroupOrderMutationVariables = Exact<{
  id: Scalars['String'];
  input: SplitOrderInput;
}>;


export type SplitGroupOrderMutation = (
  { __typename?: 'Mutation' }
  & { splitGroupOrder: (
    { __typename?: 'Order' }
    & Pick<Order, 'id'>
  ) }
);

export type UnlistTicketForResaleMutationVariables = Exact<{
  ticketId: Scalars['String'];
}>;


export type UnlistTicketForResaleMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'unlistTicketForResale'>
);

export type UnsubscribeMutationVariables = Exact<{
  sendId: Scalars['String'];
}>;


export type UnsubscribeMutation = (
  { __typename?: 'Mutation' }
  & { unsubscribe: (
    { __typename?: 'MarketingPreferenceUnsubscribeOutput' }
    & Pick<MarketingPreferenceUnsubscribeOutput, 'id'>
  ) }
);

export type UnsubscribeFromMarketingMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type UnsubscribeFromMarketingMutation = (
  { __typename?: 'Mutation' }
  & { unsubscribeFromMarketing: (
    { __typename?: 'User' }
    & Pick<User, 'id'>
  ) }
);

export type UpdateOrderMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateOrderInput;
}>;


export type UpdateOrderMutation = (
  { __typename?: 'Mutation' }
  & { updateOrder: (
    { __typename?: 'Order' }
    & OrderFragment
  ) }
);

export type UpdateOrderStatusMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateOrderStatusInput;
}>;


export type UpdateOrderStatusMutation = (
  { __typename?: 'Mutation' }
  & { updateOrderStatus: (
    { __typename?: 'Order' }
    & OrderFragment
  ) }
);

export type UpdatePasswordMutationVariables = Exact<{
  input: UpdatePasswordInput;
}>;


export type UpdatePasswordMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updatePassword'>
);

export type UpdateProfileMutationVariables = Exact<{
  input: UpdateProfileInput;
}>;


export type UpdateProfileMutation = (
  { __typename?: 'Mutation' }
  & { updateProfile: (
    { __typename?: 'User' }
    & Pick<User, 'id'>
  ) }
);

export type UpdateTicketCoverForOrderMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateOrderTicketCoverInput;
}>;


export type UpdateTicketCoverForOrderMutation = (
  { __typename?: 'Mutation' }
  & { updateTicketCoverForOrder: (
    { __typename?: 'Order' }
    & OrderFragment
  ) }
);

export type UpdateTicketHolderMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateTicketHolderInput;
}>;


export type UpdateTicketHolderMutation = (
  { __typename?: 'Mutation' }
  & { updateTicketHolder: (
    { __typename?: 'Ticket' }
    & Pick<Ticket, 'id'>
  ) }
);

export type ValidateReleasePasswordMutationVariables = Exact<{
  id: Scalars['String'];
  password: Scalars['String'];
}>;


export type ValidateReleasePasswordMutation = (
  { __typename?: 'Mutation' }
  & { validateReleasePassword: (
    { __typename?: 'ReleasePassword' }
    & Pick<ReleasePassword, 'id' | 'quantityPaid' | 'quantityComp' | 'totalUsedPaid' | 'totalUsedComp'>
  ) }
);

export type ValidateReleasePasswordOrReleaseMutationVariables = Exact<{
  eventId: Scalars['String'];
  password: Scalars['String'];
}>;


export type ValidateReleasePasswordOrReleaseMutation = (
  { __typename?: 'Mutation' }
  & { validateReleasePasswordOrRelease: (
    { __typename?: 'ValidateReleasePasswordOrReleaseOutput' }
    & Pick<ValidateReleasePasswordOrReleaseOutput, 'id' | 'slug' | 'password' | 'releasePasswordId'>
  ) }
);

export type VerifyMagicLinkMutationVariables = Exact<{
  input: VerifyEmailInput;
}>;


export type VerifyMagicLinkMutation = (
  { __typename?: 'Mutation' }
  & { verifyMagicLink: (
    { __typename?: 'VerifyMagicLinkOutput' }
    & Pick<VerifyMagicLinkOutput, 'redirectUrl'>
  ) }
);

export type VerifyManageTicketsLinkMutationVariables = Exact<{
  orderId: Scalars['String'];
  email?: Maybe<Scalars['String']>;
}>;


export type VerifyManageTicketsLinkMutation = (
  { __typename?: 'Mutation' }
  & { verifyManageTicketsLink: (
    { __typename?: 'VerifyManageTicketsOutput' }
    & Pick<VerifyManageTicketsOutput, 'isLoggedIn' | 'eventId' | 'isEventEnded'>
  ) }
);

export type VerifyPinPayment3DsMutationVariables = Exact<{
  input: VerifyPinPayment3Ds;
}>;


export type VerifyPinPayment3DsMutation = (
  { __typename?: 'Mutation' }
  & { verifyPinPayment3DS: (
    { __typename?: 'PinPaymentChargeResponse' }
    & Pick<PinPaymentChargeResponse, 'redirectUrl'>
  ) }
);

export type VerifyTokenMutationVariables = Exact<{
  input: VerifyEmailInput;
}>;


export type VerifyTokenMutation = (
  { __typename?: 'Mutation' }
  & { verifyToken: (
    { __typename?: 'VerifyMagicLinkOutput' }
    & Pick<VerifyMagicLinkOutput, 'redirectUrl'>
  ) }
);

export type GetPromoterSettingsQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type GetPromoterSettingsQuery = (
  { __typename?: 'Query' }
  & { getPromoterSettings?: Maybe<(
    { __typename?: 'PromoterSettingsOutput' }
    & { configurations?: Maybe<Array<(
      { __typename?: 'PromoterShareAction' }
      & Pick<PromoterShareAction, 'platform' | 'actionType' | 'socialLinkType'>
    )>>, socialPages?: Maybe<Array<(
      { __typename?: 'EventSocialPage' }
      & Pick<EventSocialPage, 'name' | 'isEnabled' | 'url'>
    )>> }
  )> }
);

export type AvailableFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableFeaturesQuery = (
  { __typename?: 'Query' }
  & { availableFeatures: (
    { __typename?: 'OrganizationFeatures' }
    & { features: Array<(
      { __typename?: 'Feature' }
      & Pick<Feature, 'key' | 'label' | 'description' | 'status'>
    )> }
  ) }
);

export type CalculateTicketCoverAmountsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type CalculateTicketCoverAmountsQuery = (
  { __typename?: 'Query' }
  & { calculateTicketCoverAmounts: (
    { __typename?: 'TicketCoverAmount' }
    & Pick<TicketCoverAmount, 'totalFeeAmount'>
  ) }
);

export type CalendarHomepageCustomizationQueryVariables = Exact<{ [key: string]: never; }>;


export type CalendarHomepageCustomizationQuery = (
  { __typename?: 'Query' }
  & { calendarHomepageCustomization?: Maybe<(
    { __typename?: 'CalendarHomepageCustomization' }
    & Pick<CalendarHomepageCustomization, 'id' | 'title' | 'description'>
    & { banner?: Maybe<(
      { __typename?: 'ExtendedFile' }
      & FileFragment
    )> }
  )> }
);

export type CurrentOrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentOrganizationQuery = (
  { __typename?: 'Query' }
  & { currentOrganization: (
    { __typename?: 'CurrentOrganizationOutput' }
    & Pick<CurrentOrganizationOutput, 'id' | 'name' | 'slug' | 'showMemberships' | 'showMembershipRenewal' | 'landingPage' | 'privacyPolicy' | 'termsAndConditions' | 'supportInfo' | 'currency' | 'taxRate' | 'features' | 'timezone' | 'locale' | 'helpLink' | 'defaultI18nLanguage' | 'defaultLanguage' | 'customTaxName' | 'isTest' | 'defaultOptInMarketing' | 'cookieConsent'>
    & { address?: Maybe<(
      { __typename?: 'Address' }
      & Pick<Address, 'country'>
    )>, shippingLabels?: Maybe<(
      { __typename?: 'ShippingLabels' }
      & Pick<ShippingLabels, 'eTicket' | 'printedTicketByMail' | 'printedTicketByCourier' | 'printedTicketByCourierRural' | 'printedTicketAtVenue'>
    )>, marketing?: Maybe<(
      { __typename?: 'Marketing' }
      & Pick<Marketing, 'gtmId' | 'pixelId'>
    )>, shopify?: Maybe<(
      { __typename?: 'ShopifyIntegration' }
      & Pick<ShopifyIntegration, 'shopDomain' | 'storefrontAccessToken' | 'navLinkLabel' | 'navLinkUrl'>
    )>, branding: (
      { __typename?: 'OrganizationOutputBranding' }
      & Pick<OrganizationOutputBranding, 'greyScale' | 'P300' | 'P200' | 'P100' | 'S300' | 'S200' | 'S100' | 'N800' | 'N700' | 'N600' | 'N500' | 'N300' | 'N200' | 'N100'>
      & { logo?: Maybe<(
        { __typename?: 'ExtendedFile' }
        & FileFragment
      )>, mobileLogo?: Maybe<(
        { __typename?: 'ExtendedFile' }
        & FileFragment
      )>, favicon?: Maybe<(
        { __typename?: 'ExtendedFile' }
        & FileFragment
      )>, background?: Maybe<(
        { __typename?: 'ExtendedFile' }
        & FileFragment
      )>, fullBackground?: Maybe<(
        { __typename?: 'ExtendedFile' }
        & FileFragment
      )> }
    ), landingTours?: Maybe<(
      { __typename?: 'LandingToursSettings' }
      & Pick<LandingToursSettings, 'description' | 'showCalendarOnTourPage'>
      & { banner?: Maybe<(
        { __typename?: 'ExtendedFile' }
        & FileFragment
      )> }
    )>, point?: Maybe<(
      { __typename?: 'Point' }
      & Pick<Point, 'name' | 'isEnabled'>
    )>, customFields: Array<(
      { __typename?: 'CustomFieldOuput' }
      & Pick<CustomFieldOuput, 'id' | 'label' | 'value' | 'targetArea' | 'type' | 'isRequired'>
    )>, seekaConfig?: Maybe<(
      { __typename?: 'SeekaOutput' }
      & SeekaConfigFragment
    )> }
  ) }
);

export type EventQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type EventQuery = (
  { __typename?: 'Query' }
  & { event: (
    { __typename?: 'Event' }
    & Pick<Event, 'hasPublicRelease'>
    & { venue: (
      { __typename?: 'Venue' }
      & VenueFragment
    ), ticketTypes: Array<(
      { __typename?: 'TicketType' }
      & TicketTypeBaseFragment
      & TicketTypeInfoFragment
      & FinanceFragment
    )>, paymentPlanSettings?: Maybe<(
      { __typename?: 'PaymentPlanSettings' }
      & PaymentPlanSettingsFragmentFragment
    )> }
    & EventFragment
  ) }
);

export type EventWithGatesQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type EventWithGatesQuery = (
  { __typename?: 'Query' }
  & { event: (
    { __typename?: 'Event' }
    & Pick<Event, 'title'>
    & { venue: (
      { __typename?: 'Venue' }
      & Pick<Venue, 'id' | 'timezone' | 'locale'>
    ), zonesAllocatedGates?: Maybe<Array<(
      { __typename?: 'ZoneAllocatedGate' }
      & Pick<ZoneAllocatedGate, 'name' | 'gates'>
      & { sections?: Maybe<Array<(
        { __typename?: 'ZoneAllocatedGateSection' }
        & Pick<ZoneAllocatedGateSection, 'name' | 'gates'>
      )>> }
    )>> }
  ) }
);

export type EventWithTicketTypeFilterQueryVariables = Exact<{
  id: Scalars['String'];
  ticketTypeFilter?: Maybe<TicketTypeFilter>;
}>;


export type EventWithTicketTypeFilterQuery = (
  { __typename?: 'Query' }
  & { event: (
    { __typename?: 'Event' }
    & Pick<Event, 'hasPublicRelease'>
    & { venue: (
      { __typename?: 'Venue' }
      & VenueFragment
    ), ticketTypes: Array<(
      { __typename?: 'TicketType' }
      & { resaleTicketTypes: Array<(
        { __typename?: 'TicketType' }
        & Pick<TicketType, 'id'>
      )> }
      & TicketTypeBaseFragment
      & TicketTypeInfoFragment
      & FinanceFragment
    )> }
    & EventFragment
  ) }
);

export type EventsQueryVariables = Exact<{
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<EventWhereInput>;
  orderBy?: Maybe<EventOrderByInput>;
}>;


export type EventsQuery = (
  { __typename?: 'Query' }
  & { events: (
    { __typename?: 'EventConnection' }
    & Pick<EventConnection, 'totalCount'>
    & { edges: Array<(
      { __typename?: 'EventEdge' }
      & { node: (
        { __typename?: 'Event' }
        & Pick<Event, 'hasPublicRelease'>
        & { venue: (
          { __typename?: 'Venue' }
          & VenueBaseFragment
          & VenueInfoFragment
          & VenueAddressFragment
        ), presaleRelease?: Maybe<(
          { __typename?: 'Release' }
          & Pick<Release, 'id' | 'startConditionDate'>
        )> }
        & EventBaseFragment
        & EventInfoFragment
      ) }
    )>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ) }
  ) }
);

export type ExchangeableEventsQueryVariables = Exact<{
  membershipId: Scalars['String'];
  eventToExchangeId: Scalars['String'];
}>;


export type ExchangeableEventsQuery = (
  { __typename?: 'Query' }
  & { exchangeableEvents?: Maybe<Array<(
    { __typename?: 'Event' }
    & Pick<Event, 'id' | 'title' | 'startDate' | 'endDate'>
    & { venue: (
      { __typename?: 'Venue' }
      & Pick<Venue, 'name'>
      & { gates: Array<(
        { __typename?: 'Gate' }
        & Pick<Gate, 'name'>
      )> }
      & VenueAddressFragment
    ), zonesAllocatedGates?: Maybe<Array<(
      { __typename?: 'ZoneAllocatedGate' }
      & Pick<ZoneAllocatedGate, 'name'>
      & { dates?: Maybe<Array<(
        { __typename?: 'ZoneAllocatedDate' }
        & Pick<ZoneAllocatedDate, 'eventDateId' | 'alternateEntryTime'>
      )>> }
    )>> }
  )>> }
);

export type FindOrderIdForTicketQueryVariables = Exact<{
  ticketId: Scalars['String'];
}>;


export type FindOrderIdForTicketQuery = (
  { __typename?: 'Query' }
  & { findOrderIdForTicket: (
    { __typename?: 'findOrderIdForTicketOutput' }
    & Pick<FindOrderIdForTicketOutput, 'orderId'>
  ) }
);

export type GetCompetitionReferralReportForCustomerQueryVariables = Exact<{
  input: CustomerCompetitionReportingInput;
}>;


export type GetCompetitionReferralReportForCustomerQuery = (
  { __typename?: 'Query' }
  & { getCompetitionReferralReportForCustomer: Array<(
    { __typename?: 'CompetitionCustomerReporting' }
    & CompetitionStatsFragmentFragment
  )> }
);

export type GetEventPurchaseRestrictionsQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type GetEventPurchaseRestrictionsQuery = (
  { __typename?: 'Query' }
  & { getEventPurchaseRestrictions: Array<(
    { __typename?: 'PurchaseRestriction' }
    & Pick<PurchaseRestriction, 'id' | 'restrictedType' | 'restrictedId' | 'quantity' | 'isExclusive' | 'isAlwaysVisible' | 'createdAt' | 'updatedAt'>
    & { requiredEntities: Array<(
      { __typename?: 'PurchaseRestrictionRequiredEntity' }
      & Pick<PurchaseRestrictionRequiredEntity, 'requiredId' | 'requiredType'>
    )> }
  )> }
);

export type GetI18nQueryVariables = Exact<{ [key: string]: never; }>;


export type GetI18nQuery = (
  { __typename?: 'Query' }
  & { getI18n: (
    { __typename?: 'I18nOutput' }
    & Pick<I18nOutput, 'data'>
  ) }
);

export type GetMembershipSubscriptionQueryVariables = Exact<{
  membershipSubscriptionId: Scalars['String'];
}>;


export type GetMembershipSubscriptionQuery = (
  { __typename?: 'Query' }
  & { getMembershipSubscription: (
    { __typename?: 'MembershipSubscription' }
    & { billingDetails: (
      { __typename?: 'MembershipSubscriptionBillingDetails' }
      & Pick<MembershipSubscriptionBillingDetails, 'emailAddress' | 'cardLast4' | 'cardBrand' | 'cardExpiryMonth' | 'cardExpiryYear'>
    ) }
  ) }
);

export type GetOrderJobStatusQueryVariables = Exact<{
  jobId: Scalars['String'];
}>;


export type GetOrderJobStatusQuery = (
  { __typename?: 'Query' }
  & { getOrderJobStatus: (
    { __typename?: 'OrderCreateOutput' }
    & Pick<OrderCreateOutput, 'jobId'>
    & { order?: Maybe<(
      { __typename?: 'Order' }
      & { event?: Maybe<(
        { __typename?: 'Event' }
        & Pick<Event, 'id' | 'title'>
      )>, membership?: Maybe<(
        { __typename?: 'Membership' }
        & Pick<Membership, 'id' | 'name'>
      )> }
      & OrderFragment
    )>, createOrderError?: Maybe<Array<(
      { __typename: 'TicketNotAvailableError' }
      & Pick<TicketNotAvailableError, 'message' | 'shouldDisplayWaitlist' | 'eventId' | 'releaseId'>
    )>> }
  ) }
);

export type GetOrderPlanQueryVariables = Exact<{
  orderId: Scalars['String'];
}>;


export type GetOrderPlanQuery = (
  { __typename?: 'Query' }
  & { getOrderPlan: (
    { __typename?: 'OrderPlan' }
    & Pick<OrderPlan, 'orderId' | 'status'>
    & { schedule: (
      { __typename?: 'ScheduleOption' }
      & Pick<ScheduleOption, 'interval' | 'installmentCount'>
    ), payments: Array<(
      { __typename?: 'OrderPlanPayment' }
      & Pick<OrderPlanPayment, 'id' | 'amountDue' | 'dueAt' | 'paidAt' | 'refundedAt' | 'status' | 'stripeInvoiceUrl' | 'failureReason' | 'attemptCount'>
    )>, billingDetails?: Maybe<(
      { __typename?: 'BillingDetails' }
      & Pick<BillingDetails, 'cardLast4' | 'cardBrand' | 'cardExpiryMonth' | 'cardExpiryYear' | 'totalFeeAmount'>
    )> }
  ) }
);

export type GetPaymentOptionsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPaymentOptionsQuery = (
  { __typename?: 'Query' }
  & { getPaymentOptions: (
    { __typename?: 'PaymentOptions' }
    & Pick<PaymentOptions, 'orderId'>
    & { options?: Maybe<Array<(
      { __typename?: 'PaymentOption' }
      & Pick<PaymentOption, 'id' | 'value' | 'label' | 'type' | 'paymentMethod' | 'description' | 'order' | 'transactionFee' | 'transactionFeeType' | 'transactionFee2' | 'transactionFeeType2' | 'bnplEnabled' | 'calculatedTransactionFee'>
      & { paymentPlanMetadata?: Maybe<(
        { __typename?: 'PaymentPlanMetadata' }
        & Pick<PaymentPlanMetadata, 'depositAmount' | 'installmentAmount' | 'installmentCount' | 'paymentPlanFeePercentage'>
      )> }
    )>> }
  ) }
);

export type GetRedirectUrlByCodeQueryVariables = Exact<{
  input: RedirectCodeInput;
}>;


export type GetRedirectUrlByCodeQuery = (
  { __typename?: 'Query' }
  & { getRedirectUrlByCode: (
    { __typename?: 'RedirectUrl' }
    & Pick<RedirectUrl, 'redirectURL'>
  ) }
);

export type GetReferralCampaignByEventIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetReferralCampaignByEventIdQuery = (
  { __typename?: 'Query' }
  & { getReferralCampaignByEventId?: Maybe<(
    { __typename?: 'ReferralCampaign' }
    & Pick<ReferralCampaign, 'id' | 'isActive' | 'referralOwnerRewardType' | 'referralOwnerRewardQuantityType' | 'referralOwnerRewardQuantity' | 'referralUserRewardType' | 'referralUserRewardQuantityType' | 'referralUserRewardQuantity'>
    & { referralRelease?: Maybe<(
      { __typename?: 'Release' }
      & Pick<Release, 'id'>
    )> }
  )> }
);

export type GetReferralCampaignByOrderIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetReferralCampaignByOrderIdQuery = (
  { __typename?: 'Query' }
  & { getReferralCampaignByOrderId?: Maybe<(
    { __typename?: 'ReferralCampaign' }
    & Pick<ReferralCampaign, 'id' | 'isActive' | 'referralOwnerRewardType' | 'referralOwnerRewardQuantityType' | 'referralOwnerRewardQuantity' | 'referralUserRewardType' | 'referralUserRewardQuantityType' | 'referralUserRewardQuantity'>
    & { referralRelease?: Maybe<(
      { __typename?: 'Release' }
      & Pick<Release, 'id'>
    )> }
  )> }
);

export type GetReferralCampaignsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReferralCampaignsQuery = (
  { __typename?: 'Query' }
  & { getReferralCampaigns: Array<(
    { __typename?: 'ReferralCampaign' }
    & Pick<ReferralCampaign, 'id' | 'isActive'>
    & { event?: Maybe<(
      { __typename?: 'Event' }
      & Pick<Event, 'id'>
    )> }
  )> }
);

export type GetReferralReportForCustomerQueryVariables = Exact<{
  input: CustomerReferralReportingInput;
}>;


export type GetReferralReportForCustomerQuery = (
  { __typename?: 'Query' }
  & { getReferralReportForCustomer: Array<(
    { __typename?: 'ReferralCustomerReporting' }
    & ReferralStatsFragmentFragment
  )> }
);

export type GetReferralRewardByOrderIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetReferralRewardByOrderIdQuery = (
  { __typename?: 'Query' }
  & { getReferralRewardByOrderId?: Maybe<(
    { __typename?: 'ReferralReward' }
    & Pick<ReferralReward, 'id' | 'rewardType' | 'rewardQuantityType' | 'rewardQuantity'>
    & { referralCampaign: (
      { __typename?: 'ReferralCampaign' }
      & Pick<ReferralCampaign, 'id'>
    ) }
  )> }
);

export type GetReleaseByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetReleaseByIdQuery = (
  { __typename?: 'Query' }
  & { release: (
    { __typename?: 'Release' }
    & Pick<Release, 'id' | 'name' | 'type' | 'slug' | 'isActive' | 'requiresAuth' | 'minPurchaseQuantity' | 'maxPurchaseQuantity' | 'presaleTitle' | 'presaleInformation' | 'releaseNotes' | 'allowPublicComp' | 'isResaleRelease'>
    & { status: (
      { __typename?: 'ReleaseStatus' }
      & Pick<ReleaseStatus, 'value' | 'message'>
    ), event: (
      { __typename?: 'Event' }
      & Pick<Event, 'hasPublicRelease'>
      & { venue: (
        { __typename?: 'Venue' }
        & VenueFragment
      ), ticketTypes: Array<(
        { __typename?: 'TicketType' }
        & TicketTypeBaseFragment
        & TicketTypeInfoFragment
      )>, multiBuyPromotions: Array<(
        { __typename?: 'EventMultiBuyPromotion' }
        & Pick<EventMultiBuyPromotion, 'id' | 'name' | 'getQuantity' | 'buyQuantity' | 'price' | 'enabled'>
        & { getTicketType: (
          { __typename?: 'TicketType' }
          & Pick<TicketType, 'id' | 'name' | 'description' | 'restrictions' | 'kind' | 'isGrouped' | 'groupAmount' | 'bookingFeeType' | 'bookingFee'>
          & { dates: Array<(
            { __typename?: 'TicketTypeDate' }
            & Pick<TicketTypeDate, 'alternateEntryTime'>
          )> }
        ), buyTicketType: (
          { __typename?: 'TicketType' }
          & Pick<TicketType, 'id' | 'name' | 'description' | 'restrictions' | 'kind' | 'isGrouped' | 'groupAmount' | 'bookingFeeType' | 'bookingFee'>
          & { dates: Array<(
            { __typename?: 'TicketTypeDate' }
            & Pick<TicketTypeDate, 'alternateEntryTime'>
          )> }
        ) }
      )> }
      & EventFragment
    ), presaleHeader?: Maybe<(
      { __typename?: 'ExtendedFile' }
      & FileFragment
    )>, presaleLogo?: Maybe<(
      { __typename?: 'ExtendedFile' }
      & FileFragment
    )>, releaseZones: Array<(
      { __typename?: 'ReleaseZone' }
      & Pick<ReleaseZone, 'isActive' | 'pricingLevel'>
      & { zone: (
        { __typename?: 'Zone' }
        & Pick<Zone, 'name' | 'description' | 'displayOrder'>
      ), ticketTypes: Array<(
        { __typename?: 'ReleaseZoneTicketType' }
        & Pick<ReleaseZoneTicketType, 'price' | 'isActive' | 'ticketTypeId' | 'isSoldOut' | 'minPurchaseQuantity' | 'maxPurchaseQuantity' | 'ticketAvailabilityStatus' | 'purchaseRestrictionsHelpText'>
        & { sections?: Maybe<Array<(
          { __typename?: 'ZonePricingTypeSection' }
          & Pick<ZonePricingTypeSection, 'name' | 'price'>
        )>>, purchaseRestrictions: Array<(
          { __typename?: 'PurchaseRestriction' }
          & Pick<PurchaseRestriction, 'id' | 'quantity' | 'isExclusive' | 'isAlwaysVisible'>
          & { requiredEntities: Array<(
            { __typename?: 'PurchaseRestrictionRequiredEntity' }
            & Pick<PurchaseRestrictionRequiredEntity, 'requiredType' | 'requiredId'>
          )> }
        )> }
      )> }
    )>, releaseEventAddons: Array<(
      { __typename?: 'ReleaseEventAddon' }
      & { eventAddon: (
        { __typename?: 'EventAddon' }
        & Pick<EventAddon, 'id' | 'name' | 'enableNaming' | 'price' | 'description' | 'restrictions' | 'isActive' | 'addonAvailabilityStatus' | 'maxPurchaseQuantity' | 'purchaseRestrictionsHelpText'>
        & { addonImage?: Maybe<(
          { __typename?: 'ExtendedFile' }
          & FileFragment
        )>, purchaseRestrictions: Array<(
          { __typename?: 'PurchaseRestriction' }
          & Pick<PurchaseRestriction, 'id' | 'quantity' | 'isExclusive' | 'isAlwaysVisible'>
          & { requiredEntities: Array<(
            { __typename?: 'PurchaseRestrictionRequiredEntity' }
            & Pick<PurchaseRestrictionRequiredEntity, 'requiredType' | 'requiredId'>
          )> }
        )> }
      ) }
    )>, channels: Array<(
      { __typename?: 'EventChannelOutput' }
      & Pick<EventChannelOutput, 'id' | 'label' | 'isEnabled'>
    )> }
  ) }
);

export type GetReleaseBySlugQueryVariables = Exact<{
  slug?: Maybe<Scalars['String']>;
  eventId: Scalars['String'];
}>;


export type GetReleaseBySlugQuery = (
  { __typename?: 'Query' }
  & { getReleaseBySlug?: Maybe<(
    { __typename?: 'Release' }
    & Pick<Release, 'id' | 'name' | 'type' | 'slug' | 'isActive' | 'requiresAuth' | 'minPurchaseQuantity' | 'maxPurchaseQuantity' | 'presaleTitle' | 'presaleInformation' | 'releaseNotes' | 'allowPublicComp' | 'isResaleRelease'>
    & { status: (
      { __typename?: 'ReleaseStatus' }
      & Pick<ReleaseStatus, 'value' | 'message'>
    ), event: (
      { __typename?: 'Event' }
      & Pick<Event, 'hasPublicRelease'>
      & { venue: (
        { __typename?: 'Venue' }
        & VenueFragment
      ), ticketTypes: Array<(
        { __typename?: 'TicketType' }
        & TicketTypeBaseFragment
        & TicketTypeInfoFragment
      )>, multiBuyPromotions: Array<(
        { __typename?: 'EventMultiBuyPromotion' }
        & Pick<EventMultiBuyPromotion, 'id' | 'name' | 'getQuantity' | 'buyQuantity' | 'price' | 'enabled'>
        & { getTicketType: (
          { __typename?: 'TicketType' }
          & Pick<TicketType, 'id' | 'name' | 'description' | 'restrictions' | 'kind' | 'isGrouped' | 'groupAmount' | 'bookingFeeType' | 'bookingFee'>
          & { dates: Array<(
            { __typename?: 'TicketTypeDate' }
            & Pick<TicketTypeDate, 'alternateEntryTime'>
          )> }
        ), buyTicketType: (
          { __typename?: 'TicketType' }
          & Pick<TicketType, 'id' | 'name' | 'description' | 'restrictions' | 'kind' | 'isGrouped' | 'groupAmount' | 'bookingFeeType' | 'bookingFee'>
          & { dates: Array<(
            { __typename?: 'TicketTypeDate' }
            & Pick<TicketTypeDate, 'alternateEntryTime'>
          )> }
        ) }
      )> }
      & EventFragment
    ), presaleHeader?: Maybe<(
      { __typename?: 'ExtendedFile' }
      & FileFragment
    )>, presaleLogo?: Maybe<(
      { __typename?: 'ExtendedFile' }
      & FileFragment
    )>, releaseZones: Array<(
      { __typename?: 'ReleaseZone' }
      & Pick<ReleaseZone, 'isActive' | 'pricingLevel'>
      & { zone: (
        { __typename?: 'Zone' }
        & Pick<Zone, 'name' | 'description' | 'displayOrder'>
      ), ticketTypes: Array<(
        { __typename?: 'ReleaseZoneTicketType' }
        & Pick<ReleaseZoneTicketType, 'price' | 'isActive' | 'ticketTypeId' | 'isSoldOut' | 'minPurchaseQuantity' | 'maxPurchaseQuantity' | 'ticketAvailabilityStatus' | 'purchaseRestrictionsHelpText'>
        & { sections?: Maybe<Array<(
          { __typename?: 'ZonePricingTypeSection' }
          & Pick<ZonePricingTypeSection, 'name' | 'price'>
        )>>, purchaseRestrictions: Array<(
          { __typename?: 'PurchaseRestriction' }
          & Pick<PurchaseRestriction, 'id' | 'quantity' | 'isExclusive' | 'isAlwaysVisible'>
          & { requiredEntities: Array<(
            { __typename?: 'PurchaseRestrictionRequiredEntity' }
            & Pick<PurchaseRestrictionRequiredEntity, 'requiredType' | 'requiredId'>
          )> }
        )> }
      )> }
    )>, releaseEventAddons: Array<(
      { __typename?: 'ReleaseEventAddon' }
      & { eventAddon: (
        { __typename?: 'EventAddon' }
        & Pick<EventAddon, 'id' | 'name' | 'enableNaming' | 'price' | 'description' | 'restrictions' | 'isActive' | 'addonAvailabilityStatus' | 'maxPurchaseQuantity' | 'purchaseRestrictionsHelpText'>
        & { addonImage?: Maybe<(
          { __typename?: 'ExtendedFile' }
          & FileFragment
        )>, purchaseRestrictions: Array<(
          { __typename?: 'PurchaseRestriction' }
          & Pick<PurchaseRestriction, 'id' | 'quantity' | 'isExclusive' | 'isAlwaysVisible'>
          & { requiredEntities: Array<(
            { __typename?: 'PurchaseRestrictionRequiredEntity' }
            & Pick<PurchaseRestrictionRequiredEntity, 'requiredType' | 'requiredId'>
          )> }
        )> }
      ) }
    )>, channels: Array<(
      { __typename?: 'EventChannelOutput' }
      & Pick<EventChannelOutput, 'id' | 'label' | 'isEnabled'>
    )> }
  )> }
);

export type GetShopifyProductsQueryVariables = Exact<{
  eventId?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
}>;


export type GetShopifyProductsQuery = (
  { __typename?: 'Query' }
  & { getShopifyProducts: (
    { __typename?: 'ShopifyProductsDto' }
    & Pick<ShopifyProductsDto, 'storeUrl'>
    & { products: Array<(
      { __typename?: 'ShopifyProductDto' }
      & Pick<ShopifyProductDto, 'id' | 'name' | 'price' | 'url' | 'imageUrl'>
    )> }
  ) }
);

export type GetSubscriptionPortalUrlForOrderQueryVariables = Exact<{
  orderId: Scalars['String'];
}>;


export type GetSubscriptionPortalUrlForOrderQuery = (
  { __typename?: 'Query' }
  & { getSubscriptionPortalUrlForOrder: (
    { __typename?: 'MembershipSubscriptionPortalOutput' }
    & Pick<MembershipSubscriptionPortalOutput, 'url'>
  ) }
);

export type GetSubscriptionPortalUrlForTicketQueryVariables = Exact<{
  ticketId: Scalars['String'];
}>;


export type GetSubscriptionPortalUrlForTicketQuery = (
  { __typename?: 'Query' }
  & { getSubscriptionPortalUrlForTicket: (
    { __typename?: 'MembershipSubscriptionPortalOutput' }
    & Pick<MembershipSubscriptionPortalOutput, 'url'>
  ) }
);

export type GetTicketsByIdsQueryVariables = Exact<{
  ids: Scalars['String'];
}>;


export type GetTicketsByIdsQuery = (
  { __typename?: 'Query' }
  & { getTicketsByIds: Array<(
    { __typename?: 'Ticket' }
    & Pick<Ticket, 'status' | 'shouldBeNamed'>
    & { addon?: Maybe<(
      { __typename?: 'EventAddon' }
      & Pick<EventAddon, 'id' | 'name' | 'enableNaming'>
    ) | (
      { __typename?: 'MembershipAddon' }
      & Pick<MembershipAddon, 'id' | 'name' | 'enableNaming'>
    )>, lineItem?: Maybe<(
      { __typename?: 'LineItem' }
      & LineItemFragment
    )>, parentTicket?: Maybe<(
      { __typename?: 'Ticket' }
      & Pick<Ticket, 'firstName' | 'lastName' | 'id'>
      & { membershipType?: Maybe<(
        { __typename?: 'MembershipType' }
        & { membership: (
          { __typename?: 'Membership' }
          & Pick<Membership, 'canRenameMembership' | 'name'>
          & { exchangeSettings?: Maybe<(
            { __typename?: 'ExchangeSettings' }
            & Pick<ExchangeSettings, 'isEnabled' | 'totalEventCount' | 'creditFullMembership' | 'releaseSlug'>
          )> }
        ) }
      )> }
    )>, ticketType?: Maybe<(
      { __typename?: 'TicketType' }
      & Pick<TicketType, 'name' | 'isChild'>
      & { dates: Array<(
        { __typename?: 'TicketTypeDate' }
        & Pick<TicketTypeDate, 'alternateEntryTime'>
      )> }
    )>, membershipType?: Maybe<(
      { __typename?: 'MembershipType' }
      & Pick<MembershipType, 'isChild'>
      & { membership: (
        { __typename?: 'Membership' }
        & Pick<Membership, 'name'>
      ) }
    )>, event?: Maybe<(
      { __typename?: 'Event' }
      & Pick<Event, 'title' | 'startDate' | 'endDate' | 'canChangeSeats' | 'changingSeatsFee' | 'canRenameTicket'>
      & { venue: (
        { __typename?: 'Venue' }
        & Pick<Venue, 'name'>
        & { zones: Array<(
          { __typename?: 'Zone' }
          & Pick<Zone, 'name' | 'stand'>
        )>, gates: Array<(
          { __typename?: 'Gate' }
          & Pick<Gate, 'name' | 'id'>
        )> }
        & VenueAddressFragment
      ), zonesAllocatedGates?: Maybe<Array<(
        { __typename?: 'ZoneAllocatedGate' }
        & Pick<ZoneAllocatedGate, 'name'>
      )>> }
    )> }
    & TicketFragment
  )> }
);

export type HandleInstagramCodeMutationVariables = Exact<{
  input: HandleInstagramCodeInput;
}>;


export type HandleInstagramCodeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'handleInstagramCode'>
);

export type HasMembershipToRenewQueryVariables = Exact<{ [key: string]: never; }>;


export type HasMembershipToRenewQuery = (
  { __typename?: 'Query' }
  & { myMembershipTickets: Array<(
    { __typename?: 'Ticket' }
    & Pick<Ticket, 'hasRenewedMembership'>
    & { membershipType?: Maybe<(
      { __typename?: 'MembershipType' }
      & Pick<MembershipType, 'name'>
      & { membership: (
        { __typename?: 'Membership' }
        & Pick<Membership, 'name' | 'isActive' | 'id'>
        & { renewalMembership?: Maybe<(
          { __typename?: 'Membership' }
          & Pick<Membership, 'id'>
        )> }
      ) }
    )> }
  )> }
);

export type IntegrationsQueryVariables = Exact<{
  input?: Maybe<IntegrationWhereInput>;
}>;


export type IntegrationsQuery = (
  { __typename?: 'Query' }
  & { integrations: Array<(
    { __typename?: 'Integration' }
    & IntegrationFragmentFragment
  )> }
);

export type IsLoggedInQueryVariables = Exact<{ [key: string]: never; }>;


export type IsLoggedInQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'isLoggedIn'>
);

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = (
  { __typename?: 'Query' }
  & { me: (
    { __typename?: 'User' }
    & UserFragment
  ) }
);

export type MembershipQueryVariables = Exact<{
  id: Scalars['String'];
  code?: Maybe<Scalars['String']>;
}>;


export type MembershipQuery = (
  { __typename?: 'Query' }
  & { membership?: Maybe<(
    { __typename?: 'Membership' }
    & { paymentPlanSettings?: Maybe<(
      { __typename?: 'PaymentPlanSettings' }
      & PaymentPlanSettingsFragmentFragment
    )>, venue?: Maybe<(
      { __typename?: 'Venue' }
      & VenueFragment
    )>, events?: Maybe<Array<(
      { __typename?: 'Event' }
      & Pick<Event, 'id' | 'eventKind' | 'seatsEventKey' | 'title' | 'startDate' | 'endDate' | 'description' | 'hasPublicRelease'>
      & { logo?: Maybe<(
        { __typename?: 'ExtendedFile' }
        & FileFragment
      )>, venue: (
        { __typename?: 'Venue' }
        & Pick<Venue, 'name'>
        & VenueAddressFragment
      ), printBanner1?: Maybe<(
        { __typename?: 'ExtendedFile' }
        & FileFragment
      )>, paymentPlanSettings?: Maybe<(
        { __typename?: 'PaymentPlanSettings' }
        & PaymentPlanSettingsFragmentFragment
      )> }
    )>>, membershipZones: Array<(
      { __typename?: 'MembershipZone' }
      & Pick<MembershipZone, 'id' | 'pricingLevel' | 'isActive'>
      & { zone: (
        { __typename?: 'Zone' }
        & Pick<Zone, 'id' | 'name' | 'description' | 'displayOrder'>
      ), membershipTypes: Array<(
        { __typename?: 'MembershipSeatingZoneType' }
        & Pick<MembershipSeatingZoneType, 'membershipTypeId' | 'price' | 'isActive' | 'purchaseRestrictionsHelpText'>
        & { sections?: Maybe<Array<(
          { __typename?: 'ZonePricingTypeSection' }
          & Pick<ZonePricingTypeSection, 'name' | 'price'>
        )>>, purchaseRestrictions: Array<(
          { __typename?: 'PurchaseRestriction' }
          & Pick<PurchaseRestriction, 'id' | 'quantity' | 'isExclusive' | 'isAlwaysVisible'>
          & { requiredEntities: Array<(
            { __typename?: 'PurchaseRestrictionRequiredEntity' }
            & Pick<PurchaseRestrictionRequiredEntity, 'requiredType' | 'requiredId'>
          )> }
        )> }
      )> }
    )>, seekaConfig?: Maybe<(
      { __typename?: 'SeekaOutput' }
      & SeekaConfigFragment
    )>, stripeConfig?: Maybe<(
      { __typename?: 'StripeConfigOutput' }
      & StripeConfigFragment
    )> }
    & MembershipFragment
  )> }
);

export type MembershipsQueryVariables = Exact<{
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  where?: Maybe<MembershipWhereInput>;
  orderBy?: Maybe<MembershipOrderByInput>;
}>;


export type MembershipsQuery = (
  { __typename?: 'Query' }
  & { memberships: (
    { __typename?: 'MembershipConnection' }
    & Pick<MembershipConnection, 'totalCount'>
    & { edges: Array<(
      { __typename?: 'MembershipEdge' }
      & { node: (
        { __typename?: 'Membership' }
        & { venue?: Maybe<(
          { __typename?: 'Venue' }
          & VenueInfoFragment
          & VenueAddressFragment
        )>, events?: Maybe<Array<(
          { __typename?: 'Event' }
          & Pick<Event, 'id'>
          & { venueAddress: (
            { __typename?: 'Venue' }
            & Pick<Venue, 'name'>
            & { address: (
              { __typename?: 'Address' }
              & Pick<Address, 'city'>
            ) }
          ) }
        )>>, membershipZones: Array<(
          { __typename?: 'MembershipZone' }
          & Pick<MembershipZone, 'id' | 'pricingLevel' | 'isActive'>
          & { zone: (
            { __typename?: 'Zone' }
            & Pick<Zone, 'id' | 'name'>
          ), membershipTypes: Array<(
            { __typename?: 'MembershipSeatingZoneType' }
            & Pick<MembershipSeatingZoneType, 'price' | 'isActive'>
            & { sections?: Maybe<Array<(
              { __typename?: 'ZonePricingTypeSection' }
              & Pick<ZonePricingTypeSection, 'name' | 'price'>
            )>> }
          )> }
        )> }
        & MembershipBaseFragment
        & MembershipInfoFragment
      ) }
    )>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ) }
  ) }
);

export type MembershipsSoldForUserQueryVariables = Exact<{
  membershipId: Scalars['String'];
}>;


export type MembershipsSoldForUserQuery = (
  { __typename?: 'Query' }
  & { membershipsSoldForUser: Array<(
    { __typename?: 'MembershipTypePurchaseTotal' }
    & Pick<MembershipTypePurchaseTotal, 'total'>
    & { membershipType: (
      { __typename?: 'MembershipType' }
      & Pick<MembershipType, 'id'>
    ) }
  )> }
);

export type MyEventTicketsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type MyEventTicketsQuery = (
  { __typename?: 'Query' }
  & { myEventTickets: Array<(
    { __typename?: 'Ticket' }
    & Pick<Ticket, 'status'>
    & { addon?: Maybe<(
      { __typename?: 'EventAddon' }
      & Pick<EventAddon, 'id' | 'name' | 'enableNaming' | 'hideQRCode'>
      & { namingFields: Array<(
        { __typename?: 'FormField' }
        & NamingFieldsFragment
      )> }
    ) | (
      { __typename?: 'MembershipAddon' }
      & Pick<MembershipAddon, 'id' | 'name' | 'enableNaming'>
      & { namingFields: Array<(
        { __typename?: 'FormField' }
        & NamingFieldsFragment
      )> }
    )>, lineItem?: Maybe<(
      { __typename?: 'LineItem' }
      & LineItemFragment
    )>, parentTicket?: Maybe<(
      { __typename?: 'Ticket' }
      & Pick<Ticket, 'firstName' | 'lastName' | 'id'>
      & { membershipType?: Maybe<(
        { __typename?: 'MembershipType' }
        & { membership: (
          { __typename?: 'Membership' }
          & Pick<Membership, 'canRenameMembership' | 'name' | 'showSchedule' | 'membershipKind'>
        ) }
      )> }
    )>, ticketType?: Maybe<(
      { __typename?: 'TicketType' }
      & Pick<TicketType, 'id' | 'kind' | 'name' | 'isChild'>
      & { dates: Array<(
        { __typename?: 'TicketTypeDate' }
        & Pick<TicketTypeDate, 'eventDateId' | 'alternateEntryTime'>
      )>, namingFields: Array<(
        { __typename?: 'FormField' }
        & NamingFieldsFragment
      )> }
      & TicketTypeDateOptionsFragment
    )>, membershipType?: Maybe<(
      { __typename?: 'MembershipType' }
      & Pick<MembershipType, 'name' | 'isChild'>
      & { membership: (
        { __typename?: 'Membership' }
        & Pick<Membership, 'membershipKind' | 'name' | 'isTicketed'>
      ), namingFields: Array<(
        { __typename?: 'FormField' }
        & NamingFieldsFragment
      )> }
    )>, event?: Maybe<(
      { __typename?: 'Event' }
      & Pick<Event, 'id' | 'title' | 'startDate' | 'endDate' | 'eventKind' | 'canChangeSeats' | 'changingSeatsFee' | 'canRenameTicket' | 'ticketResaleEnabled' | 'sellerTransferringTicketFee' | 'canTransferTicket' | 'ticketsViewableFromDate' | 'isR18' | 'canUpgrade'>
      & { backgroundImage?: Maybe<(
        { __typename?: 'ExtendedFile' }
        & FileFragment
      )>, venue: (
        { __typename?: 'Venue' }
        & Pick<Venue, 'name' | 'seating'>
        & { zones: Array<(
          { __typename?: 'Zone' }
          & Pick<Zone, 'name' | 'stand'>
        )>, gates: Array<(
          { __typename?: 'Gate' }
          & Pick<Gate, 'name' | 'id'>
        )> }
        & VenueAddressFragment
      ), zonesAllocatedGates?: Maybe<Array<(
        { __typename?: 'ZoneAllocatedGate' }
        & Pick<ZoneAllocatedGate, 'name'>
        & { dates?: Maybe<Array<(
          { __typename?: 'ZoneAllocatedDate' }
          & Pick<ZoneAllocatedDate, 'eventDateId' | 'alternateEntryTime'>
        )>> }
      )>>, seekaConfig?: Maybe<(
        { __typename?: 'SeekaOutput' }
        & SeekaConfigFragment
      )> }
      & EventDateOptionsFragment
    )>, membership?: Maybe<(
      { __typename?: 'Membership' }
      & Pick<Membership, 'name' | 'membershipKind' | 'startDate' | 'endDate'>
      & { venue?: Maybe<(
        { __typename?: 'Venue' }
        & Pick<Venue, 'name' | 'seating'>
        & { zones: Array<(
          { __typename?: 'Zone' }
          & Pick<Zone, 'name' | 'stand'>
        )>, gates: Array<(
          { __typename?: 'Gate' }
          & Pick<Gate, 'name' | 'id'>
        )> }
        & VenueAddressFragment
      )> }
    )> }
    & TicketFragment
  )> }
);

export type MyEventsQueryVariables = Exact<{
  where?: Maybe<MyEventsWhereInput>;
  orderBy?: Maybe<MyEventsOrderByInput>;
}>;


export type MyEventsQuery = (
  { __typename?: 'Query' }
  & { myEvents: Array<(
    { __typename?: 'Event' }
    & { venue: (
      { __typename?: 'Venue' }
      & Pick<Venue, 'name'>
      & VenueAddressFragment
    ) }
    & EventBaseFragment
    & EventInfoFragment
  )> }
);

export type MyMembershipAddonsQueryVariables = Exact<{
  membershipId: Scalars['String'];
}>;


export type MyMembershipAddonsQuery = (
  { __typename?: 'Query' }
  & { myMembershipAddons: Array<(
    { __typename?: 'Ticket' }
    & Pick<Ticket, 'id' | 'isNamed' | 'firstName' | 'lastName'>
    & { parentTicket?: Maybe<(
      { __typename?: 'Ticket' }
      & Pick<Ticket, 'firstName' | 'lastName' | 'id'>
      & { membershipType?: Maybe<(
        { __typename?: 'MembershipType' }
        & { membership: (
          { __typename?: 'Membership' }
          & Pick<Membership, 'name'>
        ) }
      )> }
    )>, membership?: Maybe<(
      { __typename?: 'Membership' }
      & Pick<Membership, 'name' | 'startDate' | 'endDate'>
      & { venue?: Maybe<(
        { __typename?: 'Venue' }
        & Pick<Venue, 'name'>
        & VenueAddressFragment
      )> }
    )>, membershipType?: Maybe<(
      { __typename?: 'MembershipType' }
      & Pick<MembershipType, 'name'>
      & { membership: (
        { __typename?: 'Membership' }
        & Pick<Membership, 'name' | 'membershipKind'>
      ) }
    )>, lineItem?: Maybe<(
      { __typename?: 'LineItem' }
      & LineItemFragment
    )>, addon?: Maybe<(
      { __typename?: 'EventAddon' }
      & Pick<EventAddon, 'id' | 'enableNaming' | 'name'>
      & { namingFields: Array<(
        { __typename?: 'FormField' }
        & NamingFieldsFragment
      )> }
    ) | (
      { __typename?: 'MembershipAddon' }
      & Pick<MembershipAddon, 'id' | 'enableNaming' | 'name'>
      & { namingFields: Array<(
        { __typename?: 'FormField' }
        & NamingFieldsFragment
      )> }
    )>, ticketType?: Maybe<(
      { __typename?: 'TicketType' }
      & Pick<TicketType, 'name'>
      & { dates: Array<(
        { __typename?: 'TicketTypeDate' }
        & Pick<TicketTypeDate, 'eventDateId' | 'alternateEntryTime'>
      )>, namingFields: Array<(
        { __typename?: 'FormField' }
        & NamingFieldsFragment
      )> }
    )>, event?: Maybe<(
      { __typename?: 'Event' }
      & Pick<Event, 'id' | 'title' | 'eventKind' | 'startDate' | 'endDate' | 'canChangeSeats' | 'changingSeatsFee' | 'canRenameTicket' | 'sellerTransferringTicketFee' | 'canTransferTicket' | 'ticketsViewableFromDate' | 'isR18'>
      & { venue: (
        { __typename?: 'Venue' }
        & Pick<Venue, 'name'>
        & { zones: Array<(
          { __typename?: 'Zone' }
          & Pick<Zone, 'name' | 'stand'>
        )>, gates: Array<(
          { __typename?: 'Gate' }
          & Pick<Gate, 'name' | 'id'>
        )> }
        & VenueAddressFragment
      ), zonesAllocatedGates?: Maybe<Array<(
        { __typename?: 'ZoneAllocatedGate' }
        & Pick<ZoneAllocatedGate, 'name'>
        & { dates?: Maybe<Array<(
          { __typename?: 'ZoneAllocatedDate' }
          & Pick<ZoneAllocatedDate, 'eventDateId' | 'alternateEntryTime'>
        )>> }
      )>> }
      & EventDateOptionsFragment
    )> }
    & TicketFragment
  )> }
);

export type MyMembershipHoldOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type MyMembershipHoldOrdersQuery = (
  { __typename?: 'Query' }
  & { myMembershipHoldOrders: Array<(
    { __typename?: 'Order' }
    & Pick<Order, 'id' | 'total' | 'orderNumber'>
    & { membership?: Maybe<(
      { __typename?: 'Membership' }
      & Pick<Membership, 'name'>
    )> }
  )> }
);

export type MyMembershipTicketsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyMembershipTicketsQuery = (
  { __typename?: 'Query' }
  & { myMembershipTickets: Array<(
    { __typename?: 'Ticket' }
    & Pick<Ticket, 'status' | 'hasRenewedMembership' | 'shouldBeNamed'>
    & { lineItem?: Maybe<(
      { __typename?: 'LineItem' }
      & LineItemFragment
    )>, membership?: Maybe<(
      { __typename?: 'Membership' }
      & Pick<Membership, 'endDate'>
    )>, membershipType?: Maybe<(
      { __typename?: 'MembershipType' }
      & Pick<MembershipType, 'name' | 'isChild'>
      & { membership: (
        { __typename?: 'Membership' }
        & Pick<Membership, 'membershipKind' | 'canRenameMembership' | 'showSchedule' | 'name' | 'isActive' | 'id'>
        & { thumbnail?: Maybe<(
          { __typename?: 'ExtendedFile' }
          & FileFragment
        )>, renewalMembership?: Maybe<(
          { __typename?: 'Membership' }
          & Pick<Membership, 'id'>
        )> }
      ), namingFields: Array<(
        { __typename?: 'FormField' }
        & NamingFieldsFragment
      )> }
    )>, event?: Maybe<(
      { __typename?: 'Event' }
      & Pick<Event, 'eventKind'>
      & { thumbnail?: Maybe<(
        { __typename?: 'ExtendedFile' }
        & FileFragment
      )>, venue: (
        { __typename?: 'Venue' }
        & Pick<Venue, 'name'>
        & VenueAddressFragment
      ) }
    )> }
    & TicketFragment
  )> }
);

export type MyPaymentPlanTicketsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyPaymentPlanTicketsQuery = (
  { __typename?: 'Query' }
  & { myPaymentPlanTickets: Array<(
    { __typename?: 'PartPaidTicketStats' }
    & Pick<PartPaidTicketStats, 'orderId' | 'ticketCount' | 'membershipId' | 'eventId'>
  )> }
);

export type OrderQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type OrderQuery = (
  { __typename?: 'Query' }
  & { order?: Maybe<(
    { __typename?: 'Order' }
    & CheckoutOrderFragment
  )> }
);

export type OrderTicketsPdfQueryVariables = Exact<{
  orderId: Scalars['String'];
}>;


export type OrderTicketsPdfQuery = (
  { __typename?: 'Query' }
  & { order?: Maybe<(
    { __typename?: 'Order' }
    & Pick<Order, 'id' | 'orderNumber'>
    & { buyerInformation?: Maybe<(
      { __typename?: 'BuyerInformation' }
      & Pick<BuyerInformation, 'firstName' | 'lastName'>
    )>, event?: Maybe<(
      { __typename?: 'Event' }
      & Pick<Event, 'id' | 'title' | 'startDate' | 'endDate' | 'showStartTime' | 'showEndTime'>
      & { dates: Array<(
        { __typename?: 'EventDate' }
        & Pick<EventDate, 'id' | 'startDate' | 'endDate'>
      )>, venue: (
        { __typename?: 'Venue' }
        & Pick<Venue, 'id' | 'seating' | 'name' | 'timezone' | 'locale'>
        & { zones: Array<(
          { __typename?: 'Zone' }
          & Pick<Zone, 'name' | 'admission' | 'stand'>
        )> }
        & VenueAddressFragment
      ), zonesAllocatedGates?: Maybe<Array<(
        { __typename?: 'ZoneAllocatedGate' }
        & Pick<ZoneAllocatedGate, 'name'>
        & { dates?: Maybe<Array<(
          { __typename?: 'ZoneAllocatedDate' }
          & Pick<ZoneAllocatedDate, 'eventDateId' | 'alternateEntryTime'>
        )>> }
      )>> }
    )>, tickets: Array<(
      { __typename?: 'Ticket' }
      & Pick<Ticket, 'id' | 'qrCode' | 'status' | 'seatZone' | 'displayName' | 'firstName' | 'lastName' | 'isNamed' | 'shouldBeNamed' | 'ticketNumber'>
      & { gates?: Maybe<Array<(
        { __typename?: 'Gate' }
        & Pick<Gate, 'id' | 'name'>
      )>>, lineItem?: Maybe<(
        { __typename?: 'LineItem' }
        & Pick<LineItem, 'type' | 'name' | 'pricingTierName'>
      )>, ticketType?: Maybe<(
        { __typename?: 'TicketType' }
        & Pick<TicketType, 'name' | 'printAtHomeInformation'>
        & { dates: Array<(
          { __typename?: 'TicketTypeDate' }
          & Pick<TicketTypeDate, 'alternateEntryTime'>
        )> }
      )>, membershipType?: Maybe<(
        { __typename?: 'MembershipType' }
        & Pick<MembershipType, 'name'>
      )>, parentTicket?: Maybe<(
        { __typename?: 'Ticket' }
        & Pick<Ticket, 'firstName' | 'lastName'>
      )> }
    )> }
  )> }
);

export type MyOrdersQueryVariables = Exact<{
  where?: Maybe<OrderWhereInput>;
}>;


export type MyOrdersQuery = (
  { __typename?: 'Query' }
  & { myOrders: (
    { __typename?: 'OrderConnection' }
    & Pick<OrderConnection, 'totalCount'>
    & { edges: Array<(
      { __typename?: 'OrderEdge' }
      & { node: (
        { __typename?: 'Order' }
        & Pick<Order, 'createdAt' | 'orderNumber' | 'status' | 'isPrechargeOrder' | 'id'>
      ) }
    )>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ) }
  ) }
);

export type PinPaymentContextQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type PinPaymentContextQuery = (
  { __typename?: 'Query' }
  & { pinPaymentContext: (
    { __typename?: 'PinPaymentContext' }
    & Pick<PinPaymentContext, 'amount' | 'currency' | 'redirectUrl' | 'publicKey' | 'isSandbox' | 'orderId'>
  ) }
);

export type PollOrderQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type PollOrderQuery = (
  { __typename?: 'Query' }
  & { pollOrder?: Maybe<(
    { __typename?: 'Order' }
    & CheckoutOrderFragment
  )> }
);

export type GetPosQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPosQuery = (
  { __typename?: 'Query' }
  & { pos: (
    { __typename?: 'Pos' }
    & Pick<Pos, 'id' | 'name' | 'createdAt' | 'updatedAt' | 'deliveryOptions' | 'autoPrintTickets'>
    & { paymentOptions: (
      { __typename?: 'PosPaymentOptions' }
      & { cash?: Maybe<(
        { __typename?: 'PosPaymentFee' }
        & Pick<PosPaymentFee, 'feeType' | 'feeAmount'>
      )>, eftpos?: Maybe<(
        { __typename?: 'PosPaymentFee' }
        & Pick<PosPaymentFee, 'feeType' | 'feeAmount'>
      )>, cc?: Maybe<(
        { __typename?: 'PosPaymentFee' }
        & Pick<PosPaymentFee, 'feeType' | 'feeAmount'>
      )>, MPAiSA?: Maybe<(
        { __typename?: 'PosPaymentFee' }
        & Pick<PosPaymentFee, 'feeType' | 'feeAmount'>
      )> }
    ), event: (
      { __typename?: 'Event' }
      & Pick<Event, 'title' | 'id' | 'startDate' | 'endDate'>
      & { venue: (
        { __typename?: 'Venue' }
        & Pick<Venue, 'name'>
        & VenueAddressFragment
      ) }
    ), release: (
      { __typename?: 'Release' }
      & Pick<Release, 'name' | 'id'>
    ) }
  ) }
);

export type PosTerminalLatestTransactionStatusQueryVariables = Exact<{
  posId: Scalars['String'];
}>;


export type PosTerminalLatestTransactionStatusQuery = (
  { __typename?: 'Query' }
  & { posTerminalLatestTransactionStatus: (
    { __typename?: 'TerminalLatestTransactionStatus' }
    & Pick<TerminalLatestTransactionStatus, 'status' | 'message' | 'failureCode'>
  ) }
);

export type ReferralUrlByOrderIdQueryVariables = Exact<{
  orderId: Scalars['String'];
}>;


export type ReferralUrlByOrderIdQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'referralUrlByOrderId'>
);

export type ReferralUrlByWaitlistUserIdQueryVariables = Exact<{
  eventId: Scalars['String'];
  waitlistUserId: Scalars['String'];
}>;


export type ReferralUrlByWaitlistUserIdQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'referralUrlByWaitlistUserId'>
);

export type ReportSpamMembershipQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ReportSpamMembershipQuery = (
  { __typename?: 'Query' }
  & { membership?: Maybe<(
    { __typename?: 'Membership' }
    & Pick<Membership, 'id' | 'name'>
  )> }
);

export type ResaleTicketTypesForWaitlistQueryVariables = Exact<{
  eventId: Scalars['String'];
  releaseId?: Maybe<Scalars['String']>;
}>;


export type ResaleTicketTypesForWaitlistQuery = (
  { __typename?: 'Query' }
  & { resaleTicketTypesForWaitlist: Array<(
    { __typename?: 'TicketType' }
    & Pick<TicketType, 'id' | 'name'>
  )> }
);

export type SeasonQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type SeasonQuery = (
  { __typename?: 'Query' }
  & { season: (
    { __typename?: 'Season' }
    & Pick<Season, 'id' | 'name' | 'landingDescription'>
    & { landingBanner?: Maybe<(
      { __typename?: 'ExtendedFile' }
      & FileFragment
    )> }
  ) }
);

export type SeasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type SeasonsQuery = (
  { __typename?: 'Query' }
  & { seasons: Array<(
    { __typename?: 'Season' }
    & SeasonFragmentFragment
  )> }
);

export type SeoMetadataQueryVariables = Exact<{
  eventId: Scalars['String'];
  membershipId: Scalars['String'];
}>;


export type SeoMetadataQuery = (
  { __typename?: 'Query' }
  & { seoMetadata?: Maybe<(
    { __typename?: 'SeoMetadata' }
    & Pick<SeoMetadata, 'title' | 'description' | 'keywords' | 'openGraphImageUrl' | 'origin' | 'membershipId' | 'eventId'>
  )> }
);

export type SingleEventQueryVariables = Exact<{ [key: string]: never; }>;


export type SingleEventQuery = (
  { __typename?: 'Query' }
  & { currentOrganization: (
    { __typename?: 'CurrentOrganizationOutput' }
    & { singleEvent?: Maybe<(
      { __typename?: 'Event' }
      & Pick<Event, 'hasPublicRelease' | 'publicReleaseStartsAt'>
      & { logo?: Maybe<(
        { __typename?: 'ExtendedFile' }
        & FileFragment
      )>, venue: (
        { __typename?: 'Venue' }
        & VenueBaseFragment
        & VenueInfoFragment
        & VenueAddressFragment
      ), seekaConfig?: Maybe<(
        { __typename?: 'SeekaOutput' }
        & SeekaConfigFragment
      )>, presaleRelease?: Maybe<(
        { __typename?: 'Release' }
        & Pick<Release, 'id' | 'startConditionDate' | 'isPrePurchaseActive'>
      )> }
      & EventBaseFragment
      & EventInfoFragment
    )> }
  ) }
);

export type StripePaymentContextQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type StripePaymentContextQuery = (
  { __typename?: 'Query' }
  & { stripePaymentContext: (
    { __typename?: 'StripePaymentContext' }
    & Pick<StripePaymentContext, 'redirectUrl' | 'checkoutUrl' | 'orderId' | 'stripeAccountId' | 'publishableKey' | 'clientSecret'>
  ) }
);

export type TicketNamingFieldFragment = (
  { __typename?: 'Ticket' }
  & { membershipType?: Maybe<(
    { __typename?: 'MembershipType' }
    & Pick<MembershipType, 'name' | 'kind' | 'isChild'>
    & { membership: (
      { __typename?: 'Membership' }
      & Pick<Membership, 'id' | 'isTicketed' | 'canNameMembership' | 'canRenameMembership' | 'canChangeSeats' | 'membershipKind' | 'endDate' | 'membershipsViewableFromDate'>
      & { renewalMembership?: Maybe<(
        { __typename?: 'Membership' }
        & Pick<Membership, 'id'>
      )>, exchangeSettings?: Maybe<(
        { __typename?: 'ExchangeSettings' }
        & Pick<ExchangeSettings, 'isEnabled' | 'totalEventCount' | 'releaseSlug'>
      )> }
    ), namingFields: Array<(
      { __typename?: 'FormField' }
      & NamingFieldsFragment
    )> }
  )>, ticketType?: Maybe<(
    { __typename?: 'TicketType' }
    & Pick<TicketType, 'id' | 'kind' | 'name' | 'isChild'>
    & { dates: Array<(
      { __typename?: 'TicketTypeDate' }
      & Pick<TicketTypeDate, 'eventDateId' | 'alternateEntryTime'>
    )>, namingFields: Array<(
      { __typename?: 'FormField' }
      & NamingFieldsFragment
    )> }
  )> }
);

export type TicketQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type TicketQuery = (
  { __typename?: 'Query' }
  & { ticket?: Maybe<(
    { __typename?: 'Ticket' }
    & Pick<Ticket, 'transferStatus' | 'shouldBeNamed' | 'purchaseRestrictionText' | 'maxTransferPrice' | 'membershipSubscriptionId'>
    & { childTickets?: Maybe<Array<(
      { __typename?: 'Ticket' }
      & Pick<Ticket, 'transferStatus'>
      & { lineItem?: Maybe<(
        { __typename?: 'LineItem' }
        & LineItemFragment
      )>, event?: Maybe<(
        { __typename?: 'Event' }
        & Pick<Event, 'id' | 'title' | 'startDate' | 'endDate'>
        & { venue: (
          { __typename?: 'Venue' }
          & Pick<Venue, 'name'>
          & { gates: Array<(
            { __typename?: 'Gate' }
            & Pick<Gate, 'name'>
          )> }
          & VenueAddressFragment
        ), zonesAllocatedGates?: Maybe<Array<(
          { __typename?: 'ZoneAllocatedGate' }
          & Pick<ZoneAllocatedGate, 'name'>
          & { dates?: Maybe<Array<(
            { __typename?: 'ZoneAllocatedDate' }
            & Pick<ZoneAllocatedDate, 'eventDateId' | 'alternateEntryTime'>
          )>> }
        )>> }
        & EventDateOptionsFragment
      )> }
      & TicketFragment
      & TicketNamingFieldFragment
    )>>, resellabilityState: (
      { __typename?: 'TicketResellabilityState' }
      & Pick<TicketResellabilityState, 'ticketResaleAllowed' | 'ticketTransferAllowed' | 'latestTransferCompletionDate' | 'reason' | 'afterpayRefundWindow'>
    ), lineItem?: Maybe<(
      { __typename?: 'LineItem' }
      & Pick<LineItem, 'type' | 'name' | 'pricingTierName'>
    )>, addon?: Maybe<(
      { __typename: 'EventAddon' }
      & Pick<EventAddon, 'name' | 'id'>
      & { namingFields: Array<(
        { __typename?: 'FormField' }
        & NamingFieldsFragment
      )> }
    ) | (
      { __typename: 'MembershipAddon' }
      & Pick<MembershipAddon, 'id' | 'name'>
      & { namingFields: Array<(
        { __typename?: 'FormField' }
        & NamingFieldsFragment
      )> }
    )>, event?: Maybe<(
      { __typename?: 'Event' }
      & Pick<Event, 'id' | 'title' | 'eventKind' | 'startDate' | 'endDate' | 'canRenameTicket' | 'canChangeSeats' | 'ticketsViewableFromDate' | 'sellerTransferringTicketFee' | 'canTransferTicket' | 'isR18'>
      & { venue: (
        { __typename?: 'Venue' }
        & Pick<Venue, 'name'>
        & { zones: Array<(
          { __typename?: 'Zone' }
          & Pick<Zone, 'name' | 'stand'>
        )>, gates: Array<(
          { __typename?: 'Gate' }
          & Pick<Gate, 'name' | 'id'>
        )> }
        & VenueAddressFragment
      ), zonesAllocatedGates?: Maybe<Array<(
        { __typename?: 'ZoneAllocatedGate' }
        & Pick<ZoneAllocatedGate, 'name'>
        & { dates?: Maybe<Array<(
          { __typename?: 'ZoneAllocatedDate' }
          & Pick<ZoneAllocatedDate, 'eventDateId' | 'alternateEntryTime'>
        )>> }
      )>> }
    )>, membership?: Maybe<(
      { __typename?: 'Membership' }
      & Pick<Membership, 'name' | 'membershipKind' | 'canNameMembership' | 'canRenameMembership' | 'membershipsViewableFromDate' | 'startDate'>
      & { backgroundImage?: Maybe<(
        { __typename?: 'ExtendedFile' }
        & FileFragment
      )>, venue?: Maybe<(
        { __typename?: 'Venue' }
        & Pick<Venue, 'name'>
        & { zones: Array<(
          { __typename?: 'Zone' }
          & Pick<Zone, 'name' | 'stand'>
        )>, gates: Array<(
          { __typename?: 'Gate' }
          & Pick<Gate, 'name' | 'id'>
        )> }
        & VenueAddressFragment
      )>, exchangeSettings?: Maybe<(
        { __typename?: 'ExchangeSettings' }
        & Pick<ExchangeSettings, 'isEnabled' | 'totalEventCount' | 'releaseSlug'>
      )> }
    )> }
    & TicketFragment
    & TicketNamingFieldFragment
  )> }
);

export type TicketDetailsForBackOfficeOrdersQueryVariables = Exact<{
  eventId?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
}>;


export type TicketDetailsForBackOfficeOrdersQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'ticketDetailsForBackOfficeOrders'>
);

export type TicketGatesQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type TicketGatesQuery = (
  { __typename?: 'Query' }
  & { ticket?: Maybe<(
    { __typename?: 'Ticket' }
    & { gates?: Maybe<Array<(
      { __typename?: 'Gate' }
      & Pick<Gate, 'id' | 'name'>
    )>> }
  )> }
);

export type SendTicketMutationVariables = Exact<{
  ticketIds: Array<Scalars['String']>;
  email: Scalars['String'];
}>;


export type SendTicketMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'sendTicket'>
);

export type TicketSendFragment = (
  { __typename?: 'Ticket' }
  & { ticketSendFields?: Maybe<Array<(
    { __typename?: 'TicketSendFields' }
    & Pick<TicketSendFields, 'active' | 'email'>
  )>> }
);

export type GetSentTicketsByIdQueryVariables = Exact<{
  sendId: Scalars['String'];
}>;


export type GetSentTicketsByIdQuery = (
  { __typename?: 'Query' }
  & { getSentTicketsById: (
    { __typename?: 'SentTicketOutput' }
    & Pick<SentTicketOutput, 'totalSentTickets' | 'sender' | 'firstTimeLogin'>
    & { activeTickets?: Maybe<Array<(
      { __typename?: 'Ticket' }
      & Pick<Ticket, 'transferStatus' | 'purchaseRestrictionText'>
      & { lineItem?: Maybe<(
        { __typename?: 'LineItem' }
        & LineItemFragment
      )>, addon?: Maybe<(
        { __typename?: 'EventAddon' }
        & Pick<EventAddon, 'id' | 'createdAt' | 'updatedAt' | 'name' | 'enableNaming' | 'hideQRCode'>
      ) | (
        { __typename?: 'MembershipAddon' }
        & Pick<MembershipAddon, 'id' | 'createdAt' | 'updatedAt' | 'name' | 'enableNaming'>
      )>, event?: Maybe<(
        { __typename?: 'Event' }
        & Pick<Event, 'id' | 'canUpgrade' | 'title' | 'startDate' | 'endDate' | 'eventKind' | 'canChangeSeats' | 'changingSeatsFee' | 'ticketsViewableFromDate' | 'canRenameTicket'>
        & { venue: (
          { __typename?: 'Venue' }
          & Pick<Venue, 'name'>
          & { zones: Array<(
            { __typename?: 'Zone' }
            & Pick<Zone, 'name' | 'stand'>
          )>, gates: Array<(
            { __typename?: 'Gate' }
            & Pick<Gate, 'name' | 'id'>
          )> }
          & VenueAddressFragment
        ), zonesAllocatedGates?: Maybe<Array<(
          { __typename?: 'ZoneAllocatedGate' }
          & Pick<ZoneAllocatedGate, 'name'>
        )>> }
      )> }
      & TicketFragment
      & TicketNamingFieldFragment
    )>> }
  ) }
);

export type TicketsSoldForUserQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type TicketsSoldForUserQuery = (
  { __typename?: 'Query' }
  & { ticketsSoldForUser: Array<(
    { __typename?: 'TicketTypePurchaseTotal' }
    & Pick<TicketTypePurchaseTotal, 'total'>
    & { ticketType: (
      { __typename?: 'TicketType' }
      & Pick<TicketType, 'id'>
    ) }
  )> }
);

export type UserQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type UserQuery = (
  { __typename?: 'Query' }
  & { user: (
    { __typename?: 'User' }
    & UserFragment
  ) }
);

export type DeleteRequestMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteRequestMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteRequest'>
);

export type ValidateAccessCodeForMembershipQueryVariables = Exact<{
  input: ValidateAccessCodeForMembershipInput;
}>;


export type ValidateAccessCodeForMembershipQuery = (
  { __typename?: 'Query' }
  & { validateAccessCodeForMembership: (
    { __typename?: 'AccessCode' }
    & Pick<AccessCode, 'id' | 'code'>
  ) }
);

export type VenueSeatsThumbnailQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type VenueSeatsThumbnailQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'venueSeatsThumbnail'>
);

export type VenueWithGatesQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type VenueWithGatesQuery = (
  { __typename?: 'Query' }
  & { venue: (
    { __typename?: 'Venue' }
    & Pick<Venue, 'name'>
    & { gates: Array<(
      { __typename?: 'Gate' }
      & Pick<Gate, 'id' | 'name'>
    )> }
  ) }
);

export type WindcavePaymentContextQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type WindcavePaymentContextQuery = (
  { __typename?: 'Query' }
  & { windcavePaymentContext: (
    { __typename?: 'WindcavePaymentContext' }
    & Pick<WindcavePaymentContext, 'redirectUrl' | 'checkoutUrl' | 'orderId'>
  ) }
);

export type WindcavePaymentResultQueryVariables = Exact<{
  externalId: Scalars['String'];
  result: Scalars['String'];
}>;


export type WindcavePaymentResultQuery = (
  { __typename?: 'Query' }
  & { windcavePaymentResult: (
    { __typename?: 'WindcavePaymentResultOutput' }
    & Pick<WindcavePaymentResultOutput, 'redirectUrl'>
  ) }
);

export type GetXeroConfigurationQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetXeroConfigurationQueryQuery = (
  { __typename?: 'Query' }
  & { getXeroConfiguration?: Maybe<(
    { __typename?: 'XeroConfigurationOutput' }
    & Pick<XeroConfigurationOutput, 'accountCode' | 'sendFlicketInvoice' | 'invoiceStatus'>
  )> }
);


export const aQuery = (overrides?: Partial<Query>, _relationshipsToOmit: Set<string> = new Set()): Query => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Query');
    return {
        isLoggedIn: overrides && overrides.hasOwnProperty('isLoggedIn') ? overrides.isLoggedIn! : true,
        me: overrides && overrides.hasOwnProperty('me') ? overrides.me! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        myLoggedInOrganizations: overrides && overrides.hasOwnProperty('myLoggedInOrganizations') ? overrides.myLoggedInOrganizations! : [relationshipsToOmit.has('MyLoggedInOrganizationsOutput') ? {} as MyLoggedInOrganizationsOutput : aMyLoggedInOrganizationsOutput({}, relationshipsToOmit)],
        users: overrides && overrides.hasOwnProperty('users') ? overrides.users! : relationshipsToOmit.has('UserConnection') ? {} as UserConnection : aUserConnection({}, relationshipsToOmit),
        usersUpdatedBetween: overrides && overrides.hasOwnProperty('usersUpdatedBetween') ? overrides.usersUpdatedBetween! : [relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit)],
        user: overrides && overrides.hasOwnProperty('user') ? overrides.user! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        findUserReferralId: overrides && overrides.hasOwnProperty('findUserReferralId') ? overrides.findUserReferralId! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        posUsers: overrides && overrides.hasOwnProperty('posUsers') ? overrides.posUsers! : [relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit)],
        accountsList: overrides && overrides.hasOwnProperty('accountsList') ? overrides.accountsList! : relationshipsToOmit.has('UserConnection') ? {} as UserConnection : aUserConnection({}, relationshipsToOmit),
        linkedAccountUser: overrides && overrides.hasOwnProperty('linkedAccountUser') ? overrides.linkedAccountUser! : relationshipsToOmit.has('LinkedAccountUser') ? {} as LinkedAccountUser : aLinkedAccountUser({}, relationshipsToOmit),
        poses: overrides && overrides.hasOwnProperty('poses') ? overrides.poses! : [relationshipsToOmit.has('Pos') ? {} as Pos : aPos({}, relationshipsToOmit)],
        pos: overrides && overrides.hasOwnProperty('pos') ? overrides.pos! : relationshipsToOmit.has('Pos') ? {} as Pos : aPos({}, relationshipsToOmit),
        getPosReleasePaymentOptions: overrides && overrides.hasOwnProperty('getPosReleasePaymentOptions') ? overrides.getPosReleasePaymentOptions! : relationshipsToOmit.has('ReleasePosPaymentOptions') ? {} as ReleasePosPaymentOptions : aReleasePosPaymentOptions({}, relationshipsToOmit),
        posTerminalLatestTransactionStatus: overrides && overrides.hasOwnProperty('posTerminalLatestTransactionStatus') ? overrides.posTerminalLatestTransactionStatus! : relationshipsToOmit.has('TerminalLatestTransactionStatus') ? {} as TerminalLatestTransactionStatus : aTerminalLatestTransactionStatus({}, relationshipsToOmit),
        posSessions: overrides && overrides.hasOwnProperty('posSessions') ? overrides.posSessions! : [relationshipsToOmit.has('PosSession') ? {} as PosSession : aPosSession({}, relationshipsToOmit)],
        events: overrides && overrides.hasOwnProperty('events') ? overrides.events! : relationshipsToOmit.has('EventConnection') ? {} as EventConnection : anEventConnection({}, relationshipsToOmit),
        event: overrides && overrides.hasOwnProperty('event') ? overrides.event! : relationshipsToOmit.has('Event') ? {} as Event : anEvent({}, relationshipsToOmit),
        eventsById: overrides && overrides.hasOwnProperty('eventsById') ? overrides.eventsById! : [relationshipsToOmit.has('Event') ? {} as Event : anEvent({}, relationshipsToOmit)],
        getEventAndReleaseForCustomer: overrides && overrides.hasOwnProperty('getEventAndReleaseForCustomer') ? overrides.getEventAndReleaseForCustomer! : relationshipsToOmit.has('EventsWithAccessControlOutput') ? {} as EventsWithAccessControlOutput : anEventsWithAccessControlOutput({}, relationshipsToOmit),
        getEventForCompetitionReporting: overrides && overrides.hasOwnProperty('getEventForCompetitionReporting') ? overrides.getEventForCompetitionReporting! : relationshipsToOmit.has('EventForCompetitionReportingEntity') ? {} as EventForCompetitionReportingEntity : anEventForCompetitionReportingEntity({}, relationshipsToOmit),
        myEvents: overrides && overrides.hasOwnProperty('myEvents') ? overrides.myEvents! : [relationshipsToOmit.has('Event') ? {} as Event : anEvent({}, relationshipsToOmit)],
        eventForecast: overrides && overrides.hasOwnProperty('eventForecast') ? overrides.eventForecast! : relationshipsToOmit.has('EventForecastOutput') ? {} as EventForecastOutput : anEventForecastOutput({}, relationshipsToOmit),
        hasSeatedEvent: overrides && overrides.hasOwnProperty('hasSeatedEvent') ? overrides.hasSeatedEvent! : false,
        ticketTypes: overrides && overrides.hasOwnProperty('ticketTypes') ? overrides.ticketTypes! : [relationshipsToOmit.has('TicketType') ? {} as TicketType : aTicketType({}, relationshipsToOmit)],
        ticketTypesById: overrides && overrides.hasOwnProperty('ticketTypesById') ? overrides.ticketTypesById! : [relationshipsToOmit.has('TicketType') ? {} as TicketType : aTicketType({}, relationshipsToOmit)],
        releases: overrides && overrides.hasOwnProperty('releases') ? overrides.releases! : [relationshipsToOmit.has('Release') ? {} as Release : aRelease({}, relationshipsToOmit)],
        getReleasesForPrivateLinks: overrides && overrides.hasOwnProperty('getReleasesForPrivateLinks') ? overrides.getReleasesForPrivateLinks! : [relationshipsToOmit.has('Release') ? {} as Release : aRelease({}, relationshipsToOmit)],
        release: overrides && overrides.hasOwnProperty('release') ? overrides.release! : relationshipsToOmit.has('Release') ? {} as Release : aRelease({}, relationshipsToOmit),
        getReleaseBySlug: overrides && overrides.hasOwnProperty('getReleaseBySlug') ? overrides.getReleaseBySlug! : relationshipsToOmit.has('Release') ? {} as Release : aRelease({}, relationshipsToOmit),
        getPublicReleaseTickets: overrides && overrides.hasOwnProperty('getPublicReleaseTickets') ? overrides.getPublicReleaseTickets! : [relationshipsToOmit.has('PublicReleaseTicketOutput') ? {} as PublicReleaseTicketOutput : aPublicReleaseTicketOutput({}, relationshipsToOmit)],
        eventPromoCodes: overrides && overrides.hasOwnProperty('eventPromoCodes') ? overrides.eventPromoCodes! : [relationshipsToOmit.has('EventPromoCode') ? {} as EventPromoCode : anEventPromoCode({}, relationshipsToOmit)],
        eventMultiBuyPromotions: overrides && overrides.hasOwnProperty('eventMultiBuyPromotions') ? overrides.eventMultiBuyPromotions! : [relationshipsToOmit.has('EventMultiBuyPromotion') ? {} as EventMultiBuyPromotion : anEventMultiBuyPromotion({}, relationshipsToOmit)],
        eventAddons: overrides && overrides.hasOwnProperty('eventAddons') ? overrides.eventAddons! : [relationshipsToOmit.has('EventAddon') ? {} as EventAddon : anEventAddon({}, relationshipsToOmit)],
        getAccessCode: overrides && overrides.hasOwnProperty('getAccessCode') ? overrides.getAccessCode! : relationshipsToOmit.has('AccessCodeReleaseOutput') ? {} as AccessCodeReleaseOutput : anAccessCodeReleaseOutput({}, relationshipsToOmit),
        getPaginatedAccessCode: overrides && overrides.hasOwnProperty('getPaginatedAccessCode') ? overrides.getPaginatedAccessCode! : relationshipsToOmit.has('AccessCodeConnection') ? {} as AccessCodeConnection : anAccessCodeConnection({}, relationshipsToOmit),
        getAccessCodes: overrides && overrides.hasOwnProperty('getAccessCodes') ? overrides.getAccessCodes! : [relationshipsToOmit.has('AccessCodeReleaseOutput') ? {} as AccessCodeReleaseOutput : anAccessCodeReleaseOutput({}, relationshipsToOmit)],
        listPresales: overrides && overrides.hasOwnProperty('listPresales') ? overrides.listPresales! : [relationshipsToOmit.has('PresaleReleaseOutput') ? {} as PresaleReleaseOutput : aPresaleReleaseOutput({}, relationshipsToOmit)],
        listNamingFields: overrides && overrides.hasOwnProperty('listNamingFields') ? overrides.listNamingFields! : [relationshipsToOmit.has('NamingFieldOutput') ? {} as NamingFieldOutput : aNamingFieldOutput({}, relationshipsToOmit)],
        seasons: overrides && overrides.hasOwnProperty('seasons') ? overrides.seasons! : [relationshipsToOmit.has('Season') ? {} as Season : aSeason({}, relationshipsToOmit)],
        eventOrMembershipSeasons: overrides && overrides.hasOwnProperty('eventOrMembershipSeasons') ? overrides.eventOrMembershipSeasons! : [relationshipsToOmit.has('Season') ? {} as Season : aSeason({}, relationshipsToOmit)],
        season: overrides && overrides.hasOwnProperty('season') ? overrides.season! : relationshipsToOmit.has('Season') ? {} as Season : aSeason({}, relationshipsToOmit),
        presaleDateRange: overrides && overrides.hasOwnProperty('presaleDateRange') ? overrides.presaleDateRange! : relationshipsToOmit.has('DateRange') ? {} as DateRange : aDateRange({}, relationshipsToOmit),
        integrations: overrides && overrides.hasOwnProperty('integrations') ? overrides.integrations! : [relationshipsToOmit.has('Integration') ? {} as Integration : anIntegration({}, relationshipsToOmit)],
        integration: overrides && overrides.hasOwnProperty('integration') ? overrides.integration! : relationshipsToOmit.has('Integration') ? {} as Integration : anIntegration({}, relationshipsToOmit),
        stripeConnectUrl: overrides && overrides.hasOwnProperty('stripeConnectUrl') ? overrides.stripeConnectUrl! : 'adsuesco',
        getConsentUrl: overrides && overrides.hasOwnProperty('getConsentUrl') ? overrides.getConsentUrl! : 'spoliatio',
        getXeroAccounts: overrides && overrides.hasOwnProperty('getXeroAccounts') ? overrides.getXeroAccounts! : relationshipsToOmit.has('XeroAllAccountsOutput') ? {} as XeroAllAccountsOutput : aXeroAllAccountsOutput({}, relationshipsToOmit),
        getXeroConfiguration: overrides && overrides.hasOwnProperty('getXeroConfiguration') ? overrides.getXeroConfiguration! : relationshipsToOmit.has('XeroConfigurationOutput') ? {} as XeroConfigurationOutput : aXeroConfigurationOutput({}, relationshipsToOmit),
        disableXeroIntegration: overrides && overrides.hasOwnProperty('disableXeroIntegration') ? overrides.disableXeroIntegration! : false,
        hasXeroIntegration: overrides && overrides.hasOwnProperty('hasXeroIntegration') ? overrides.hasXeroIntegration! : true,
        disableShopifyIntegration: overrides && overrides.hasOwnProperty('disableShopifyIntegration') ? overrides.disableShopifyIntegration! : true,
        customerOrders: overrides && overrides.hasOwnProperty('customerOrders') ? overrides.customerOrders! : [relationshipsToOmit.has('ShopifyCustomerOrder') ? {} as ShopifyCustomerOrder : aShopifyCustomerOrder({}, relationshipsToOmit)],
        deleteAdobeIntegration: overrides && overrides.hasOwnProperty('deleteAdobeIntegration') ? overrides.deleteAdobeIntegration! : false,
        adobeIntegration: overrides && overrides.hasOwnProperty('adobeIntegration') ? overrides.adobeIntegration! : relationshipsToOmit.has('AdobeExperiencePlatformIntegration') ? {} as AdobeExperiencePlatformIntegration : anAdobeExperiencePlatformIntegration({}, relationshipsToOmit),
        currentOrganization: overrides && overrides.hasOwnProperty('currentOrganization') ? overrides.currentOrganization! : relationshipsToOmit.has('CurrentOrganizationOutput') ? {} as CurrentOrganizationOutput : aCurrentOrganizationOutput({}, relationshipsToOmit),
        organizations: overrides && overrides.hasOwnProperty('organizations') ? overrides.organizations! : relationshipsToOmit.has('OrganizationConnection') ? {} as OrganizationConnection : anOrganizationConnection({}, relationshipsToOmit),
        organization: overrides && overrides.hasOwnProperty('organization') ? overrides.organization! : relationshipsToOmit.has('Organization') ? {} as Organization : anOrganization({}, relationshipsToOmit),
        organizationNames: overrides && overrides.hasOwnProperty('organizationNames') ? overrides.organizationNames! : relationshipsToOmit.has('OrganizationConnection') ? {} as OrganizationConnection : anOrganizationConnection({}, relationshipsToOmit),
        availableFeatures: overrides && overrides.hasOwnProperty('availableFeatures') ? overrides.availableFeatures! : relationshipsToOmit.has('OrganizationFeatures') ? {} as OrganizationFeatures : anOrganizationFeatures({}, relationshipsToOmit),
        calendarHomepageCustomization: overrides && overrides.hasOwnProperty('calendarHomepageCustomization') ? overrides.calendarHomepageCustomization! : relationshipsToOmit.has('CalendarHomepageCustomization') ? {} as CalendarHomepageCustomization : aCalendarHomepageCustomization({}, relationshipsToOmit),
        orders: overrides && overrides.hasOwnProperty('orders') ? overrides.orders! : relationshipsToOmit.has('OrderConnection') ? {} as OrderConnection : anOrderConnection({}, relationshipsToOmit),
        order: overrides && overrides.hasOwnProperty('order') ? overrides.order! : relationshipsToOmit.has('Order') ? {} as Order : anOrder({}, relationshipsToOmit),
        pollOrder: overrides && overrides.hasOwnProperty('pollOrder') ? overrides.pollOrder! : relationshipsToOmit.has('Order') ? {} as Order : anOrder({}, relationshipsToOmit),
        orderIdsOnline: overrides && overrides.hasOwnProperty('orderIdsOnline') ? overrides.orderIdsOnline! : [relationshipsToOmit.has('OrderIdsOnlineOutput') ? {} as OrderIdsOnlineOutput : anOrderIdsOnlineOutput({}, relationshipsToOmit)],
        eventOrdersOnline: overrides && overrides.hasOwnProperty('eventOrdersOnline') ? overrides.eventOrdersOnline! : relationshipsToOmit.has('EventOrdersOnlineOutput') ? {} as EventOrdersOnlineOutput : anEventOrdersOnlineOutput({}, relationshipsToOmit),
        orderRefundDetails: overrides && overrides.hasOwnProperty('orderRefundDetails') ? overrides.orderRefundDetails! : relationshipsToOmit.has('OrderRefundDetailsOutput') ? {} as OrderRefundDetailsOutput : anOrderRefundDetailsOutput({}, relationshipsToOmit),
        myOrders: overrides && overrides.hasOwnProperty('myOrders') ? overrides.myOrders! : relationshipsToOmit.has('OrderConnection') ? {} as OrderConnection : anOrderConnection({}, relationshipsToOmit),
        myMembershipHoldOrders: overrides && overrides.hasOwnProperty('myMembershipHoldOrders') ? overrides.myMembershipHoldOrders! : [relationshipsToOmit.has('Order') ? {} as Order : anOrder({}, relationshipsToOmit)],
        ordersUpdatedSince: overrides && overrides.hasOwnProperty('ordersUpdatedSince') ? overrides.ordersUpdatedSince! : relationshipsToOmit.has('CustomSaleOutput') ? {} as CustomSaleOutput : aCustomSaleOutput({}, relationshipsToOmit),
        ordersUpdatedSinceForEvent: overrides && overrides.hasOwnProperty('ordersUpdatedSinceForEvent') ? overrides.ordersUpdatedSinceForEvent! : relationshipsToOmit.has('CustomSaleOutput') ? {} as CustomSaleOutput : aCustomSaleOutput({}, relationshipsToOmit),
        getPaymentOptions: overrides && overrides.hasOwnProperty('getPaymentOptions') ? overrides.getPaymentOptions! : relationshipsToOmit.has('PaymentOptions') ? {} as PaymentOptions : aPaymentOptions({}, relationshipsToOmit),
        calculateTicketCoverAmounts: overrides && overrides.hasOwnProperty('calculateTicketCoverAmounts') ? overrides.calculateTicketCoverAmounts! : relationshipsToOmit.has('TicketCoverAmount') ? {} as TicketCoverAmount : aTicketCoverAmount({}, relationshipsToOmit),
        getOrderJobStatus: overrides && overrides.hasOwnProperty('getOrderJobStatus') ? overrides.getOrderJobStatus! : relationshipsToOmit.has('OrderCreateOutput') ? {} as OrderCreateOutput : anOrderCreateOutput({}, relationshipsToOmit),
        orderComponents: overrides && overrides.hasOwnProperty('orderComponents') ? overrides.orderComponents! : [relationshipsToOmit.has('OrderComponent') ? {} as OrderComponent : anOrderComponent({}, relationshipsToOmit)],
        orderRefundData: overrides && overrides.hasOwnProperty('orderRefundData') ? overrides.orderRefundData! : relationshipsToOmit.has('OrderRefundData') ? {} as OrderRefundData : anOrderRefundData({}, relationshipsToOmit),
        getEventPurchaseRestrictions: overrides && overrides.hasOwnProperty('getEventPurchaseRestrictions') ? overrides.getEventPurchaseRestrictions! : [relationshipsToOmit.has('PurchaseRestriction') ? {} as PurchaseRestriction : aPurchaseRestriction({}, relationshipsToOmit)],
        getMembershipPurchaseRestrictions: overrides && overrides.hasOwnProperty('getMembershipPurchaseRestrictions') ? overrides.getMembershipPurchaseRestrictions! : [relationshipsToOmit.has('PurchaseRestriction') ? {} as PurchaseRestriction : aPurchaseRestriction({}, relationshipsToOmit)],
        getOrderPlan: overrides && overrides.hasOwnProperty('getOrderPlan') ? overrides.getOrderPlan! : relationshipsToOmit.has('OrderPlan') ? {} as OrderPlan : anOrderPlan({}, relationshipsToOmit),
        payRemainingOrderPlan: overrides && overrides.hasOwnProperty('payRemainingOrderPlan') ? overrides.payRemainingOrderPlan! : relationshipsToOmit.has('OrderPlan') ? {} as OrderPlan : anOrderPlan({}, relationshipsToOmit),
        getHistoryByCustomerId: overrides && overrides.hasOwnProperty('getHistoryByCustomerId') ? overrides.getHistoryByCustomerId! : [relationshipsToOmit.has('History') ? {} as History : aHistory({}, relationshipsToOmit)],
        venues: overrides && overrides.hasOwnProperty('venues') ? overrides.venues! : [relationshipsToOmit.has('Venue') ? {} as Venue : aVenue({}, relationshipsToOmit)],
        venue: overrides && overrides.hasOwnProperty('venue') ? overrides.venue! : relationshipsToOmit.has('Venue') ? {} as Venue : aVenue({}, relationshipsToOmit),
        venueSeatsThumbnail: overrides && overrides.hasOwnProperty('venueSeatsThumbnail') ? overrides.venueSeatsThumbnail! : 'victoria',
        getZonesByEventId: overrides && overrides.hasOwnProperty('getZonesByEventId') ? overrides.getZonesByEventId! : [relationshipsToOmit.has('Zone') ? {} as Zone : aZone({}, relationshipsToOmit)],
        getGatesByEventId: overrides && overrides.hasOwnProperty('getGatesByEventId') ? overrides.getGatesByEventId! : [relationshipsToOmit.has('Gate') ? {} as Gate : aGate({}, relationshipsToOmit)],
        memberships: overrides && overrides.hasOwnProperty('memberships') ? overrides.memberships! : relationshipsToOmit.has('MembershipConnection') ? {} as MembershipConnection : aMembershipConnection({}, relationshipsToOmit),
        membership: overrides && overrides.hasOwnProperty('membership') ? overrides.membership! : relationshipsToOmit.has('Membership') ? {} as Membership : aMembership({}, relationshipsToOmit),
        membershipTypeEventTransferPrices: overrides && overrides.hasOwnProperty('membershipTypeEventTransferPrices') ? overrides.membershipTypeEventTransferPrices! : [relationshipsToOmit.has('MembershipTypeEventTransferPrice') ? {} as MembershipTypeEventTransferPrice : aMembershipTypeEventTransferPrice({}, relationshipsToOmit)],
        exchangeableEvents: overrides && overrides.hasOwnProperty('exchangeableEvents') ? overrides.exchangeableEvents! : [relationshipsToOmit.has('Event') ? {} as Event : anEvent({}, relationshipsToOmit)],
        membershipTypes: overrides && overrides.hasOwnProperty('membershipTypes') ? overrides.membershipTypes! : [relationshipsToOmit.has('MembershipType') ? {} as MembershipType : aMembershipType({}, relationshipsToOmit)],
        membershipAddons: overrides && overrides.hasOwnProperty('membershipAddons') ? overrides.membershipAddons! : [relationshipsToOmit.has('MembershipAddon') ? {} as MembershipAddon : aMembershipAddon({}, relationshipsToOmit)],
        membershipPromoCodes: overrides && overrides.hasOwnProperty('membershipPromoCodes') ? overrides.membershipPromoCodes! : [relationshipsToOmit.has('MembershipPromoCode') ? {} as MembershipPromoCode : aMembershipPromoCode({}, relationshipsToOmit)],
        membershipMultiBuyPromotions: overrides && overrides.hasOwnProperty('membershipMultiBuyPromotions') ? overrides.membershipMultiBuyPromotions! : [relationshipsToOmit.has('MembershipMultiBuyPromotion') ? {} as MembershipMultiBuyPromotion : aMembershipMultiBuyPromotion({}, relationshipsToOmit)],
        getSubscriptionPortalUrlForTicket: overrides && overrides.hasOwnProperty('getSubscriptionPortalUrlForTicket') ? overrides.getSubscriptionPortalUrlForTicket! : relationshipsToOmit.has('MembershipSubscriptionPortalOutput') ? {} as MembershipSubscriptionPortalOutput : aMembershipSubscriptionPortalOutput({}, relationshipsToOmit),
        getSubscriptionPortalUrlForOrder: overrides && overrides.hasOwnProperty('getSubscriptionPortalUrlForOrder') ? overrides.getSubscriptionPortalUrlForOrder! : relationshipsToOmit.has('MembershipSubscriptionPortalOutput') ? {} as MembershipSubscriptionPortalOutput : aMembershipSubscriptionPortalOutput({}, relationshipsToOmit),
        getMembershipSubscription: overrides && overrides.hasOwnProperty('getMembershipSubscription') ? overrides.getMembershipSubscription! : relationshipsToOmit.has('MembershipSubscription') ? {} as MembershipSubscription : aMembershipSubscription({}, relationshipsToOmit),
        getMembershipSubscriptionsForPreviousMemberships: overrides && overrides.hasOwnProperty('getMembershipSubscriptionsForPreviousMemberships') ? overrides.getMembershipSubscriptionsForPreviousMemberships! : [relationshipsToOmit.has('MembershipSubscription') ? {} as MembershipSubscription : aMembershipSubscription({}, relationshipsToOmit)],
        getMembershipAutoRenewal: overrides && overrides.hasOwnProperty('getMembershipAutoRenewal') ? overrides.getMembershipAutoRenewal! : relationshipsToOmit.has('MembershipAutoRenewalOutput') ? {} as MembershipAutoRenewalOutput : aMembershipAutoRenewalOutput({}, relationshipsToOmit),
        scout: overrides && overrides.hasOwnProperty('scout') ? overrides.scout! : relationshipsToOmit.has('Scout') ? {} as Scout : aScout({}, relationshipsToOmit),
        scouts: overrides && overrides.hasOwnProperty('scouts') ? overrides.scouts! : [relationshipsToOmit.has('Scout') ? {} as Scout : aScout({}, relationshipsToOmit)],
        scoutUsers: overrides && overrides.hasOwnProperty('scoutUsers') ? overrides.scoutUsers! : relationshipsToOmit.has('ScoutUserConnection') ? {} as ScoutUserConnection : aScoutUserConnection({}, relationshipsToOmit),
        initScout: overrides && overrides.hasOwnProperty('initScout') ? overrides.initScout! : relationshipsToOmit.has('InitScout') ? {} as InitScout : anInitScout({}, relationshipsToOmit),
        scoutCommunications: overrides && overrides.hasOwnProperty('scoutCommunications') ? overrides.scoutCommunications! : [relationshipsToOmit.has('ScoutCommunication') ? {} as ScoutCommunication : aScoutCommunication({}, relationshipsToOmit)],
        scoutCommunication: overrides && overrides.hasOwnProperty('scoutCommunication') ? overrides.scoutCommunication! : relationshipsToOmit.has('ScoutCommunication') ? {} as ScoutCommunication : aScoutCommunication({}, relationshipsToOmit),
        scoutCommunicationUsers: overrides && overrides.hasOwnProperty('scoutCommunicationUsers') ? overrides.scoutCommunicationUsers! : relationshipsToOmit.has('ScoutCommunicationUserConnection') ? {} as ScoutCommunicationUserConnection : aScoutCommunicationUserConnection({}, relationshipsToOmit),
        scoutCommunicationUser: overrides && overrides.hasOwnProperty('scoutCommunicationUser') ? overrides.scoutCommunicationUser! : relationshipsToOmit.has('ScoutCommunicationUser') ? {} as ScoutCommunicationUser : aScoutCommunicationUser({}, relationshipsToOmit),
        scoutUserReminders: overrides && overrides.hasOwnProperty('scoutUserReminders') ? overrides.scoutUserReminders! : [relationshipsToOmit.has('ScoutCommunicationUser') ? {} as ScoutCommunicationUser : aScoutCommunicationUser({}, relationshipsToOmit)],
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : [relationshipsToOmit.has('Tag') ? {} as Tag : aTag({}, relationshipsToOmit)],
        myMembershipTickets: overrides && overrides.hasOwnProperty('myMembershipTickets') ? overrides.myMembershipTickets! : [relationshipsToOmit.has('Ticket') ? {} as Ticket : aTicket({}, relationshipsToOmit)],
        usersEventTickets: overrides && overrides.hasOwnProperty('usersEventTickets') ? overrides.usersEventTickets! : [relationshipsToOmit.has('Ticket') ? {} as Ticket : aTicket({}, relationshipsToOmit)],
        myMembershipAddons: overrides && overrides.hasOwnProperty('myMembershipAddons') ? overrides.myMembershipAddons! : [relationshipsToOmit.has('Ticket') ? {} as Ticket : aTicket({}, relationshipsToOmit)],
        myEventTickets: overrides && overrides.hasOwnProperty('myEventTickets') ? overrides.myEventTickets! : [relationshipsToOmit.has('Ticket') ? {} as Ticket : aTicket({}, relationshipsToOmit)],
        myPaymentPlanTickets: overrides && overrides.hasOwnProperty('myPaymentPlanTickets') ? overrides.myPaymentPlanTickets! : [relationshipsToOmit.has('PartPaidTicketStats') ? {} as PartPaidTicketStats : aPartPaidTicketStats({}, relationshipsToOmit)],
        ticket: overrides && overrides.hasOwnProperty('ticket') ? overrides.ticket! : relationshipsToOmit.has('Ticket') ? {} as Ticket : aTicket({}, relationshipsToOmit),
        findOrderIdForTicket: overrides && overrides.hasOwnProperty('findOrderIdForTicket') ? overrides.findOrderIdForTicket! : relationshipsToOmit.has('FindOrderIdForTicketOutput') ? {} as FindOrderIdForTicketOutput : aFindOrderIdForTicketOutput({}, relationshipsToOmit),
        ticketsSoldForUser: overrides && overrides.hasOwnProperty('ticketsSoldForUser') ? overrides.ticketsSoldForUser! : [relationshipsToOmit.has('TicketTypePurchaseTotal') ? {} as TicketTypePurchaseTotal : aTicketTypePurchaseTotal({}, relationshipsToOmit)],
        membershipsSoldForUser: overrides && overrides.hasOwnProperty('membershipsSoldForUser') ? overrides.membershipsSoldForUser! : [relationshipsToOmit.has('MembershipTypePurchaseTotal') ? {} as MembershipTypePurchaseTotal : aMembershipTypePurchaseTotal({}, relationshipsToOmit)],
        getTicketsByIds: overrides && overrides.hasOwnProperty('getTicketsByIds') ? overrides.getTicketsByIds! : [relationshipsToOmit.has('Ticket') ? {} as Ticket : aTicket({}, relationshipsToOmit)],
        searchTickets: overrides && overrides.hasOwnProperty('searchTickets') ? overrides.searchTickets! : relationshipsToOmit.has('TicketConnection') ? {} as TicketConnection : aTicketConnection({}, relationshipsToOmit),
        searchTicketsByEventApp: overrides && overrides.hasOwnProperty('searchTicketsByEventApp') ? overrides.searchTicketsByEventApp! : relationshipsToOmit.has('SearchEventTicketsAppOutput') ? {} as SearchEventTicketsAppOutput : aSearchEventTicketsAppOutput({}, relationshipsToOmit),
        ticketDetailsForBackOfficeOrders: overrides && overrides.hasOwnProperty('ticketDetailsForBackOfficeOrders') ? overrides.ticketDetailsForBackOfficeOrders! : 'cervus',
        transferredMembershipTicketsForOrder: overrides && overrides.hasOwnProperty('transferredMembershipTicketsForOrder') ? overrides.transferredMembershipTicketsForOrder! : [relationshipsToOmit.has('Ticket') ? {} as Ticket : aTicket({}, relationshipsToOmit)],
        ticketTransfersForAdmin: overrides && overrides.hasOwnProperty('ticketTransfersForAdmin') ? overrides.ticketTransfersForAdmin! : [relationshipsToOmit.has('TicketTransferForAdmin') ? {} as TicketTransferForAdmin : aTicketTransferForAdmin({}, relationshipsToOmit)],
        completedTicketResalesSince: overrides && overrides.hasOwnProperty('completedTicketResalesSince') ? overrides.completedTicketResalesSince! : relationshipsToOmit.has('TicketTransferExportResultOutput') ? {} as TicketTransferExportResultOutput : aTicketTransferExportResultOutput({}, relationshipsToOmit),
        getSentTicketsById: overrides && overrides.hasOwnProperty('getSentTicketsById') ? overrides.getSentTicketsById! : relationshipsToOmit.has('SentTicketOutput') ? {} as SentTicketOutput : aSentTicketOutput({}, relationshipsToOmit),
        myScannedTickets: overrides && overrides.hasOwnProperty('myScannedTickets') ? overrides.myScannedTickets! : [relationshipsToOmit.has('Ticket') ? {} as Ticket : aTicket({}, relationshipsToOmit)],
        myScannedTicketsCount: overrides && overrides.hasOwnProperty('myScannedTicketsCount') ? overrides.myScannedTicketsCount! : 9.9,
        pinPaymentContext: overrides && overrides.hasOwnProperty('pinPaymentContext') ? overrides.pinPaymentContext! : relationshipsToOmit.has('PinPaymentContext') ? {} as PinPaymentContext : aPinPaymentContext({}, relationshipsToOmit),
        windcavePaymentContext: overrides && overrides.hasOwnProperty('windcavePaymentContext') ? overrides.windcavePaymentContext! : relationshipsToOmit.has('WindcavePaymentContext') ? {} as WindcavePaymentContext : aWindcavePaymentContext({}, relationshipsToOmit),
        windcavePaymentResult: overrides && overrides.hasOwnProperty('windcavePaymentResult') ? overrides.windcavePaymentResult! : relationshipsToOmit.has('WindcavePaymentResultOutput') ? {} as WindcavePaymentResultOutput : aWindcavePaymentResultOutput({}, relationshipsToOmit),
        stripePaymentContext: overrides && overrides.hasOwnProperty('stripePaymentContext') ? overrides.stripePaymentContext! : relationshipsToOmit.has('StripePaymentContext') ? {} as StripePaymentContext : aStripePaymentContext({}, relationshipsToOmit),
        socialMentions: overrides && overrides.hasOwnProperty('socialMentions') ? overrides.socialMentions! : relationshipsToOmit.has('SocialConnection') ? {} as SocialConnection : aSocialConnection({}, relationshipsToOmit),
        mentionOverview: overrides && overrides.hasOwnProperty('mentionOverview') ? overrides.mentionOverview! : relationshipsToOmit.has('MentionOverview') ? {} as MentionOverview : aMentionOverview({}, relationshipsToOmit),
        facebookPageLists: overrides && overrides.hasOwnProperty('facebookPageLists') ? overrides.facebookPageLists! : [relationshipsToOmit.has('PageListsOutput') ? {} as PageListsOutput : aPageListsOutput({}, relationshipsToOmit)],
        mailchimpDomains: overrides && overrides.hasOwnProperty('mailchimpDomains') ? overrides.mailchimpDomains! : 'tepidus',
        mailchimpLists: overrides && overrides.hasOwnProperty('mailchimpLists') ? overrides.mailchimpLists! : 'auctor',
        mailchimpTemplates: overrides && overrides.hasOwnProperty('mailchimpTemplates') ? overrides.mailchimpTemplates! : 'ultio',
        point: overrides && overrides.hasOwnProperty('point') ? overrides.point! : relationshipsToOmit.has('Point') ? {} as Point : aPoint({}, relationshipsToOmit),
        pointItem: overrides && overrides.hasOwnProperty('pointItem') ? overrides.pointItem! : relationshipsToOmit.has('PointItem') ? {} as PointItem : aPointItem({}, relationshipsToOmit),
        pointItems: overrides && overrides.hasOwnProperty('pointItems') ? overrides.pointItems! : [relationshipsToOmit.has('PointItem') ? {} as PointItem : aPointItem({}, relationshipsToOmit)],
        emailCustomizations: overrides && overrides.hasOwnProperty('emailCustomizations') ? overrides.emailCustomizations! : [relationshipsToOmit.has('EmailCustomizationOutput') ? {} as EmailCustomizationOutput : anEmailCustomizationOutput({}, relationshipsToOmit)],
        availableEmailTypesToCopy: overrides && overrides.hasOwnProperty('availableEmailTypesToCopy') ? overrides.availableEmailTypesToCopy! : [EmailType.AbandonedCart],
        dynamicImage: overrides && overrides.hasOwnProperty('dynamicImage') ? overrides.dynamicImage! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        exhibitors: overrides && overrides.hasOwnProperty('exhibitors') ? overrides.exhibitors! : [relationshipsToOmit.has('ExpoExhibitor') ? {} as ExpoExhibitor : anExpoExhibitor({}, relationshipsToOmit)],
        resendExhibitorLoginEmail: overrides && overrides.hasOwnProperty('resendExhibitorLoginEmail') ? overrides.resendExhibitorLoginEmail! : false,
        expoListNamingFields: overrides && overrides.hasOwnProperty('expoListNamingFields') ? overrides.expoListNamingFields! : [relationshipsToOmit.has('ExpoNamingField') ? {} as ExpoNamingField : anExpoNamingField({}, relationshipsToOmit)],
        listAttendees: overrides && overrides.hasOwnProperty('listAttendees') ? overrides.listAttendees! : [relationshipsToOmit.has('ExpoAttendee') ? {} as ExpoAttendee : anExpoAttendee({}, relationshipsToOmit)],
        getAttendee: overrides && overrides.hasOwnProperty('getAttendee') ? overrides.getAttendee! : relationshipsToOmit.has('ExpoAttendee') ? {} as ExpoAttendee : anExpoAttendee({}, relationshipsToOmit),
        getAttendeeTicket: overrides && overrides.hasOwnProperty('getAttendeeTicket') ? overrides.getAttendeeTicket! : relationshipsToOmit.has('ExpoAttendeeTicketOutput') ? {} as ExpoAttendeeTicketOutput : anExpoAttendeeTicketOutput({}, relationshipsToOmit),
        getAllEncryptedAttendeeTickets: overrides && overrides.hasOwnProperty('getAllEncryptedAttendeeTickets') ? overrides.getAllEncryptedAttendeeTickets! : [relationshipsToOmit.has('ExpoEncryptedTicket') ? {} as ExpoEncryptedTicket : anExpoEncryptedTicket({}, relationshipsToOmit)],
        exhibitorContext: overrides && overrides.hasOwnProperty('exhibitorContext') ? overrides.exhibitorContext! : relationshipsToOmit.has('ExhibitorContextOutput') ? {} as ExhibitorContextOutput : anExhibitorContextOutput({}, relationshipsToOmit),
        exhibitorProfile: overrides && overrides.hasOwnProperty('exhibitorProfile') ? overrides.exhibitorProfile! : relationshipsToOmit.has('ExpoExhibitorSessionProfileOutput') ? {} as ExpoExhibitorSessionProfileOutput : anExpoExhibitorSessionProfileOutput({}, relationshipsToOmit),
        activities: overrides && overrides.hasOwnProperty('activities') ? overrides.activities! : relationshipsToOmit.has('ActivityConnection') ? {} as ActivityConnection : anActivityConnection({}, relationshipsToOmit),
        automations: overrides && overrides.hasOwnProperty('automations') ? overrides.automations! : [relationshipsToOmit.has('Automation') ? {} as Automation : anAutomation({}, relationshipsToOmit)],
        automation: overrides && overrides.hasOwnProperty('automation') ? overrides.automation! : relationshipsToOmit.has('Automation') ? {} as Automation : anAutomation({}, relationshipsToOmit),
        getI18n: overrides && overrides.hasOwnProperty('getI18n') ? overrides.getI18n! : relationshipsToOmit.has('I18nOutput') ? {} as I18nOutput : anI18nOutput({}, relationshipsToOmit),
        getReferralCampaigns: overrides && overrides.hasOwnProperty('getReferralCampaigns') ? overrides.getReferralCampaigns! : [relationshipsToOmit.has('ReferralCampaign') ? {} as ReferralCampaign : aReferralCampaign({}, relationshipsToOmit)],
        getReferralCampaignsByEventId: overrides && overrides.hasOwnProperty('getReferralCampaignsByEventId') ? overrides.getReferralCampaignsByEventId! : [relationshipsToOmit.has('ReferralCampaign') ? {} as ReferralCampaign : aReferralCampaign({}, relationshipsToOmit)],
        getReferralCampaignByEventId: overrides && overrides.hasOwnProperty('getReferralCampaignByEventId') ? overrides.getReferralCampaignByEventId! : relationshipsToOmit.has('ReferralCampaign') ? {} as ReferralCampaign : aReferralCampaign({}, relationshipsToOmit),
        getReferralCampaignByReferralCode: overrides && overrides.hasOwnProperty('getReferralCampaignByReferralCode') ? overrides.getReferralCampaignByReferralCode! : relationshipsToOmit.has('ReferralCampaign') ? {} as ReferralCampaign : aReferralCampaign({}, relationshipsToOmit),
        getReferralCampaignByOrderId: overrides && overrides.hasOwnProperty('getReferralCampaignByOrderId') ? overrides.getReferralCampaignByOrderId! : relationshipsToOmit.has('ReferralCampaign') ? {} as ReferralCampaign : aReferralCampaign({}, relationshipsToOmit),
        getReferralCampaignStats: overrides && overrides.hasOwnProperty('getReferralCampaignStats') ? overrides.getReferralCampaignStats! : relationshipsToOmit.has('ReferralCampaignOverviewOutput') ? {} as ReferralCampaignOverviewOutput : aReferralCampaignOverviewOutput({}, relationshipsToOmit),
        getReferralRewardByOrderId: overrides && overrides.hasOwnProperty('getReferralRewardByOrderId') ? overrides.getReferralRewardByOrderId! : relationshipsToOmit.has('ReferralReward') ? {} as ReferralReward : aReferralReward({}, relationshipsToOmit),
        referralUrlByOrderId: overrides && overrides.hasOwnProperty('referralUrlByOrderId') ? overrides.referralUrlByOrderId! : 'degusto',
        referralUrlByWaitlistUserId: overrides && overrides.hasOwnProperty('referralUrlByWaitlistUserId') ? overrides.referralUrlByWaitlistUserId! : 'certus',
        getPromoterSettings: overrides && overrides.hasOwnProperty('getPromoterSettings') ? overrides.getPromoterSettings! : relationshipsToOmit.has('PromoterSettingsOutput') ? {} as PromoterSettingsOutput : aPromoterSettingsOutput({}, relationshipsToOmit),
        searchArtists: overrides && overrides.hasOwnProperty('searchArtists') ? overrides.searchArtists! : [relationshipsToOmit.has('SearchArtistOutput') ? {} as SearchArtistOutput : aSearchArtistOutput({}, relationshipsToOmit)],
        seoMetadata: overrides && overrides.hasOwnProperty('seoMetadata') ? overrides.seoMetadata! : relationshipsToOmit.has('SeoMetadata') ? {} as SeoMetadata : aSeoMetadata({}, relationshipsToOmit),
        getShopifySettings: overrides && overrides.hasOwnProperty('getShopifySettings') ? overrides.getShopifySettings! : relationshipsToOmit.has('ShopifySettings') ? {} as ShopifySettings : aShopifySettings({}, relationshipsToOmit),
        searchShopifyProducts: overrides && overrides.hasOwnProperty('searchShopifyProducts') ? overrides.searchShopifyProducts! : relationshipsToOmit.has('ShopifyProductsDto') ? {} as ShopifyProductsDto : aShopifyProductsDto({}, relationshipsToOmit),
        getShopifyProducts: overrides && overrides.hasOwnProperty('getShopifyProducts') ? overrides.getShopifyProducts! : relationshipsToOmit.has('ShopifyProductsDto') ? {} as ShopifyProductsDto : aShopifyProductsDto({}, relationshipsToOmit),
        prechargeOrderSummary: overrides && overrides.hasOwnProperty('prechargeOrderSummary') ? overrides.prechargeOrderSummary! : relationshipsToOmit.has('OrderPrechargeSummaryOutput') ? {} as OrderPrechargeSummaryOutput : anOrderPrechargeSummaryOutput({}, relationshipsToOmit),
        stripeIntegrationForPrechargeEvent: overrides && overrides.hasOwnProperty('stripeIntegrationForPrechargeEvent') ? overrides.stripeIntegrationForPrechargeEvent! : relationshipsToOmit.has('Integration') ? {} as Integration : anIntegration({}, relationshipsToOmit),
        prechargeOrderRedirect: overrides && overrides.hasOwnProperty('prechargeOrderRedirect') ? overrides.prechargeOrderRedirect! : 'aliquam',
        competitions: overrides && overrides.hasOwnProperty('competitions') ? overrides.competitions! : [relationshipsToOmit.has('Competition') ? {} as Competition : aCompetition({}, relationshipsToOmit)],
        competition: overrides && overrides.hasOwnProperty('competition') ? overrides.competition! : relationshipsToOmit.has('Competition') ? {} as Competition : aCompetition({}, relationshipsToOmit),
        activeCompetitions: overrides && overrides.hasOwnProperty('activeCompetitions') ? overrides.activeCompetitions! : [relationshipsToOmit.has('Competition') ? {} as Competition : aCompetition({}, relationshipsToOmit)],
        activeCompetitionByType: overrides && overrides.hasOwnProperty('activeCompetitionByType') ? overrides.activeCompetitionByType! : relationshipsToOmit.has('Competition') ? {} as Competition : aCompetition({}, relationshipsToOmit),
        userEntries: overrides && overrides.hasOwnProperty('userEntries') ? overrides.userEntries! : [relationshipsToOmit.has('GrantRewardOutput') ? {} as GrantRewardOutput : aGrantRewardOutput({}, relationshipsToOmit)],
        salesOverview: overrides && overrides.hasOwnProperty('salesOverview') ? overrides.salesOverview! : relationshipsToOmit.has('SalesOverviewOutput') ? {} as SalesOverviewOutput : aSalesOverviewOutput({}, relationshipsToOmit),
        salesComparisonData: overrides && overrides.hasOwnProperty('salesComparisonData') ? overrides.salesComparisonData! : relationshipsToOmit.has('SalesComparisonDataOutput') ? {} as SalesComparisonDataOutput : aSalesComparisonDataOutput({}, relationshipsToOmit),
        comparativeReportDefaultFilters: overrides && overrides.hasOwnProperty('comparativeReportDefaultFilters') ? overrides.comparativeReportDefaultFilters! : relationshipsToOmit.has('ComparativeReportDefaultFiltersOutput') ? {} as ComparativeReportDefaultFiltersOutput : aComparativeReportDefaultFiltersOutput({}, relationshipsToOmit),
        scoutCampaignOverview: overrides && overrides.hasOwnProperty('scoutCampaignOverview') ? overrides.scoutCampaignOverview! : relationshipsToOmit.has('ScoutCampaignOverviewOutput') ? {} as ScoutCampaignOverviewOutput : aScoutCampaignOverviewOutput({}, relationshipsToOmit),
        scoutCampaignTopTags: overrides && overrides.hasOwnProperty('scoutCampaignTopTags') ? overrides.scoutCampaignTopTags! : [relationshipsToOmit.has('TopTagsOutput') ? {} as TopTagsOutput : aTopTagsOutput({}, relationshipsToOmit)],
        scoutCampaignHighestValueCustomers: overrides && overrides.hasOwnProperty('scoutCampaignHighestValueCustomers') ? overrides.scoutCampaignHighestValueCustomers! : [relationshipsToOmit.has('HighestValueCustomersOutput') ? {} as HighestValueCustomersOutput : aHighestValueCustomersOutput({}, relationshipsToOmit)],
        scoutCampaignGenderBreakdown: overrides && overrides.hasOwnProperty('scoutCampaignGenderBreakdown') ? overrides.scoutCampaignGenderBreakdown! : relationshipsToOmit.has('GenderBreakDownOutput') ? {} as GenderBreakDownOutput : aGenderBreakDownOutput({}, relationshipsToOmit),
        scoutCampaignCustomerLocations: overrides && overrides.hasOwnProperty('scoutCampaignCustomerLocations') ? overrides.scoutCampaignCustomerLocations! : [relationshipsToOmit.has('LocationOutput') ? {} as LocationOutput : aLocationOutput({}, relationshipsToOmit)],
        summaryOverview: overrides && overrides.hasOwnProperty('summaryOverview') ? overrides.summaryOverview! : relationshipsToOmit.has('SummaryOverviewOutput') ? {} as SummaryOverviewOutput : aSummaryOverviewOutput({}, relationshipsToOmit),
        summaryOverviewV2: overrides && overrides.hasOwnProperty('summaryOverviewV2') ? overrides.summaryOverviewV2! : relationshipsToOmit.has('SummaryOverviewOutput') ? {} as SummaryOverviewOutput : aSummaryOverviewOutput({}, relationshipsToOmit),
        salesGraph: overrides && overrides.hasOwnProperty('salesGraph') ? overrides.salesGraph! : relationshipsToOmit.has('GraphOutput') ? {} as GraphOutput : aGraphOutput({}, relationshipsToOmit),
        presaleGraph: overrides && overrides.hasOwnProperty('presaleGraph') ? overrides.presaleGraph! : relationshipsToOmit.has('GraphOutput') ? {} as GraphOutput : aGraphOutput({}, relationshipsToOmit),
        preAuthorizationPresaleGraph: overrides && overrides.hasOwnProperty('preAuthorizationPresaleGraph') ? overrides.preAuthorizationPresaleGraph! : relationshipsToOmit.has('GraphOutput') ? {} as GraphOutput : aGraphOutput({}, relationshipsToOmit),
        presaleFinancialGateways: overrides && overrides.hasOwnProperty('presaleFinancialGateways') ? overrides.presaleFinancialGateways! : relationshipsToOmit.has('FinancialGatewayGraphOutput') ? {} as FinancialGatewayGraphOutput : aFinancialGatewayGraphOutput({}, relationshipsToOmit),
        customerLocationsByFilter: overrides && overrides.hasOwnProperty('customerLocationsByFilter') ? overrides.customerLocationsByFilter! : [relationshipsToOmit.has('LocationOutputV2') ? {} as LocationOutputV2 : aLocationOutputV2({}, relationshipsToOmit)],
        salesChannelGraph: overrides && overrides.hasOwnProperty('salesChannelGraph') ? overrides.salesChannelGraph! : relationshipsToOmit.has('SalesChannelGraphOutput') ? {} as SalesChannelGraphOutput : aSalesChannelGraphOutput({}, relationshipsToOmit),
        financialOverview: overrides && overrides.hasOwnProperty('financialOverview') ? overrides.financialOverview! : relationshipsToOmit.has('FinancialOverviewOutput') ? {} as FinancialOverviewOutput : aFinancialOverviewOutput({}, relationshipsToOmit),
        faceValueOverview: overrides && overrides.hasOwnProperty('faceValueOverview') ? overrides.faceValueOverview! : relationshipsToOmit.has('FaceValueOverviewOutput') ? {} as FaceValueOverviewOutput : aFaceValueOverviewOutput({}, relationshipsToOmit),
        financialGraph: overrides && overrides.hasOwnProperty('financialGraph') ? overrides.financialGraph! : relationshipsToOmit.has('GraphOutput') ? {} as GraphOutput : aGraphOutput({}, relationshipsToOmit),
        faceValueFinancialGraph: overrides && overrides.hasOwnProperty('faceValueFinancialGraph') ? overrides.faceValueFinancialGraph! : relationshipsToOmit.has('GraphOutput') ? {} as GraphOutput : aGraphOutput({}, relationshipsToOmit),
        financialGateways: overrides && overrides.hasOwnProperty('financialGateways') ? overrides.financialGateways! : relationshipsToOmit.has('FinancialGatewayGraphOutput') ? {} as FinancialGatewayGraphOutput : aFinancialGatewayGraphOutput({}, relationshipsToOmit),
        salesReport: overrides && overrides.hasOwnProperty('salesReport') ? overrides.salesReport! : relationshipsToOmit.has('SalesReportOutput') ? {} as SalesReportOutput : aSalesReportOutput({}, relationshipsToOmit),
        scanVisitors: overrides && overrides.hasOwnProperty('scanVisitors') ? overrides.scanVisitors! : [relationshipsToOmit.has('ScannedVisitorsOutput') ? {} as ScannedVisitorsOutput : aScannedVisitorsOutput({}, relationshipsToOmit)],
        scanVisitorsOverTime: overrides && overrides.hasOwnProperty('scanVisitorsOverTime') ? overrides.scanVisitorsOverTime! : [relationshipsToOmit.has('GraphRangeItem') ? {} as GraphRangeItem : aGraphRangeItem({}, relationshipsToOmit)],
        scansOverTime: overrides && overrides.hasOwnProperty('scansOverTime') ? overrides.scansOverTime! : [relationshipsToOmit.has('ScansOverTimeOutput') ? {} as ScansOverTimeOutput : aScansOverTimeOutput({}, relationshipsToOmit)],
        scanningOverview: overrides && overrides.hasOwnProperty('scanningOverview') ? overrides.scanningOverview! : relationshipsToOmit.has('ScanningOverviewOutput') ? {} as ScanningOverviewOutput : aScanningOverviewOutput({}, relationshipsToOmit),
        scanTicketTypes: overrides && overrides.hasOwnProperty('scanTicketTypes') ? overrides.scanTicketTypes! : [relationshipsToOmit.has('GraphTextItem') ? {} as GraphTextItem : aGraphTextItem({}, relationshipsToOmit)],
        posSalesOverview: overrides && overrides.hasOwnProperty('posSalesOverview') ? overrides.posSalesOverview! : relationshipsToOmit.has('PosSalesOverviewOutput') ? {} as PosSalesOverviewOutput : aPosSalesOverviewOutput({}, relationshipsToOmit),
        posFinancialOverview: overrides && overrides.hasOwnProperty('posFinancialOverview') ? overrides.posFinancialOverview! : [relationshipsToOmit.has('GraphItem') ? {} as GraphItem : aGraphItem({}, relationshipsToOmit)],
        posFloatOfChange: overrides && overrides.hasOwnProperty('posFloatOfChange') ? overrides.posFloatOfChange! : [relationshipsToOmit.has('GraphItem') ? {} as GraphItem : aGraphItem({}, relationshipsToOmit)],
        insightsOverview: overrides && overrides.hasOwnProperty('insightsOverview') ? overrides.insightsOverview! : relationshipsToOmit.has('InsightsOverviewOutput') ? {} as InsightsOverviewOutput : anInsightsOverviewOutput({}, relationshipsToOmit),
        highestValueCustomers: overrides && overrides.hasOwnProperty('highestValueCustomers') ? overrides.highestValueCustomers! : [relationshipsToOmit.has('HighestValueCustomersOutput') ? {} as HighestValueCustomersOutput : aHighestValueCustomersOutput({}, relationshipsToOmit)],
        topTags: overrides && overrides.hasOwnProperty('topTags') ? overrides.topTags! : [relationshipsToOmit.has('TopTagsOutput') ? {} as TopTagsOutput : aTopTagsOutput({}, relationshipsToOmit)],
        topReferrers: overrides && overrides.hasOwnProperty('topReferrers') ? overrides.topReferrers! : [relationshipsToOmit.has('TopReferrersOutput') ? {} as TopReferrersOutput : aTopReferrersOutput({}, relationshipsToOmit)],
        topRepeatPurchasers: overrides && overrides.hasOwnProperty('topRepeatPurchasers') ? overrides.topRepeatPurchasers! : [relationshipsToOmit.has('TopRepeatPurchasers') ? {} as TopRepeatPurchasers : aTopRepeatPurchasers({}, relationshipsToOmit)],
        insightsGenderBreakDown: overrides && overrides.hasOwnProperty('insightsGenderBreakDown') ? overrides.insightsGenderBreakDown! : relationshipsToOmit.has('GenderBreakDownOutput') ? {} as GenderBreakDownOutput : aGenderBreakDownOutput({}, relationshipsToOmit),
        insightsHeardAboutUsBreakDown: overrides && overrides.hasOwnProperty('insightsHeardAboutUsBreakDown') ? overrides.insightsHeardAboutUsBreakDown! : [relationshipsToOmit.has('HeardAboutUsBreakDownOutput') ? {} as HeardAboutUsBreakDownOutput : aHeardAboutUsBreakDownOutput({}, relationshipsToOmit)],
        insightsAgeBreakDown: overrides && overrides.hasOwnProperty('insightsAgeBreakDown') ? overrides.insightsAgeBreakDown! : relationshipsToOmit.has('AgeBreakDownOutput') ? {} as AgeBreakDownOutput : anAgeBreakDownOutput({}, relationshipsToOmit),
        waitlistOverview: overrides && overrides.hasOwnProperty('waitlistOverview') ? overrides.waitlistOverview! : relationshipsToOmit.has('WaitlistOverviewOutput') ? {} as WaitlistOverviewOutput : aWaitlistOverviewOutput({}, relationshipsToOmit),
        capacityOverview: overrides && overrides.hasOwnProperty('capacityOverview') ? overrides.capacityOverview! : [relationshipsToOmit.has('FinancialSales') ? {} as FinancialSales : aFinancialSales({}, relationshipsToOmit)],
        capacitySeatingMap: overrides && overrides.hasOwnProperty('capacitySeatingMap') ? overrides.capacitySeatingMap! : 'conturbo',
        capacitySeatingMapTooltips: overrides && overrides.hasOwnProperty('capacitySeatingMapTooltips') ? overrides.capacitySeatingMapTooltips! : 'optio',
        broadcastReportStats: overrides && overrides.hasOwnProperty('broadcastReportStats') ? overrides.broadcastReportStats! : relationshipsToOmit.has('BroadcastReportingOutput') ? {} as BroadcastReportingOutput : aBroadcastReportingOutput({}, relationshipsToOmit),
        purchasingDaysBreakdown: overrides && overrides.hasOwnProperty('purchasingDaysBreakdown') ? overrides.purchasingDaysBreakdown! : [relationshipsToOmit.has('BarchartOutput') ? {} as BarchartOutput : aBarchartOutput({}, relationshipsToOmit)],
        referralPromotionReportStats: overrides && overrides.hasOwnProperty('referralPromotionReportStats') ? overrides.referralPromotionReportStats! : relationshipsToOmit.has('ReferralPromotionReportingOutput') ? {} as ReferralPromotionReportingOutput : aReferralPromotionReportingOutput({}, relationshipsToOmit),
        timeOfDayBreakdown: overrides && overrides.hasOwnProperty('timeOfDayBreakdown') ? overrides.timeOfDayBreakdown! : [relationshipsToOmit.has('BarchartOutput') ? {} as BarchartOutput : aBarchartOutput({}, relationshipsToOmit)],
        getOnsaleCompetitionReportStats: overrides && overrides.hasOwnProperty('getOnsaleCompetitionReportStats') ? overrides.getOnsaleCompetitionReportStats! : relationshipsToOmit.has('CompetitionReportingOnsaleOutput') ? {} as CompetitionReportingOnsaleOutput : aCompetitionReportingOnsaleOutput({}, relationshipsToOmit),
        googleAnalyticsReport: overrides && overrides.hasOwnProperty('googleAnalyticsReport') ? overrides.googleAnalyticsReport! : [relationshipsToOmit.has('BarchartOutput') ? {} as BarchartOutput : aBarchartOutput({}, relationshipsToOmit)],
        getRegistrationCompetitionReportStats: overrides && overrides.hasOwnProperty('getRegistrationCompetitionReportStats') ? overrides.getRegistrationCompetitionReportStats! : relationshipsToOmit.has('CompetitionReportingRegistrationOutput') ? {} as CompetitionReportingRegistrationOutput : aCompetitionReportingRegistrationOutput({}, relationshipsToOmit),
        getRegistrationReferralReportStats: overrides && overrides.hasOwnProperty('getRegistrationReferralReportStats') ? overrides.getRegistrationReferralReportStats! : relationshipsToOmit.has('ReferralRegistrationPromotionReportingOutput') ? {} as ReferralRegistrationPromotionReportingOutput : aReferralRegistrationPromotionReportingOutput({}, relationshipsToOmit),
        getCompetitionReferralReportForCustomer: overrides && overrides.hasOwnProperty('getCompetitionReferralReportForCustomer') ? overrides.getCompetitionReferralReportForCustomer! : [relationshipsToOmit.has('CompetitionCustomerReporting') ? {} as CompetitionCustomerReporting : aCompetitionCustomerReporting({}, relationshipsToOmit)],
        getReferralReportForCustomer: overrides && overrides.hasOwnProperty('getReferralReportForCustomer') ? overrides.getReferralReportForCustomer! : [relationshipsToOmit.has('ReferralCustomerReporting') ? {} as ReferralCustomerReporting : aReferralCustomerReporting({}, relationshipsToOmit)],
        scanUsherTicketTypes: overrides && overrides.hasOwnProperty('scanUsherTicketTypes') ? overrides.scanUsherTicketTypes! : relationshipsToOmit.has('GraphItem') ? {} as GraphItem : aGraphItem({}, relationshipsToOmit),
        getRegistrationCompetitionReportStatsByEventId: overrides && overrides.hasOwnProperty('getRegistrationCompetitionReportStatsByEventId') ? overrides.getRegistrationCompetitionReportStatsByEventId! : relationshipsToOmit.has('CompetitionReportingRegistrationOutput') ? {} as CompetitionReportingRegistrationOutput : aCompetitionReportingRegistrationOutput({}, relationshipsToOmit),
        getOnsaleCompetitionReportStatsByEventId: overrides && overrides.hasOwnProperty('getOnsaleCompetitionReportStatsByEventId') ? overrides.getOnsaleCompetitionReportStatsByEventId! : relationshipsToOmit.has('CompetitionReportingOnsaleOutput') ? {} as CompetitionReportingOnsaleOutput : aCompetitionReportingOnsaleOutput({}, relationshipsToOmit),
        conversionBreakdown: overrides && overrides.hasOwnProperty('conversionBreakdown') ? overrides.conversionBreakdown! : relationshipsToOmit.has('PresaleConversionOutput') ? {} as PresaleConversionOutput : aPresaleConversionOutput({}, relationshipsToOmit),
        reportingLayout: overrides && overrides.hasOwnProperty('reportingLayout') ? overrides.reportingLayout! : relationshipsToOmit.has('EventLayoutOutput') ? {} as EventLayoutOutput : anEventLayoutOutput({}, relationshipsToOmit),
        reportingOverview: overrides && overrides.hasOwnProperty('reportingOverview') ? overrides.reportingOverview! : relationshipsToOmit.has('ReportingOverviewOutput') ? {} as ReportingOverviewOutput : aReportingOverviewOutput({}, relationshipsToOmit),
        financialReportingOverview: overrides && overrides.hasOwnProperty('financialReportingOverview') ? overrides.financialReportingOverview! : relationshipsToOmit.has('FinancialReportingOverviewOutput') ? {} as FinancialReportingOverviewOutput : aFinancialReportingOverviewOutput({}, relationshipsToOmit),
        eventInformation: overrides && overrides.hasOwnProperty('eventInformation') ? overrides.eventInformation! : relationshipsToOmit.has('EventInformation') ? {} as EventInformation : anEventInformation({}, relationshipsToOmit),
        membershipInformation: overrides && overrides.hasOwnProperty('membershipInformation') ? overrides.membershipInformation! : relationshipsToOmit.has('MembershipInformation') ? {} as MembershipInformation : aMembershipInformation({}, relationshipsToOmit),
        seasonInformation: overrides && overrides.hasOwnProperty('seasonInformation') ? overrides.seasonInformation! : relationshipsToOmit.has('SeasonInformation') ? {} as SeasonInformation : aSeasonInformation({}, relationshipsToOmit),
        packageInformation: overrides && overrides.hasOwnProperty('packageInformation') ? overrides.packageInformation! : relationshipsToOmit.has('PackageInformation') ? {} as PackageInformation : aPackageInformation({}, relationshipsToOmit),
        reportingSearchIndex: overrides && overrides.hasOwnProperty('reportingSearchIndex') ? overrides.reportingSearchIndex! : relationshipsToOmit.has('ReportingSearchIndexOutput') ? {} as ReportingSearchIndexOutput : aReportingSearchIndexOutput({}, relationshipsToOmit),
        customerReportingOverview: overrides && overrides.hasOwnProperty('customerReportingOverview') ? overrides.customerReportingOverview! : relationshipsToOmit.has('CustomerReportingOverviewArgs') ? {} as CustomerReportingOverviewArgs : aCustomerReportingOverviewArgs({}, relationshipsToOmit),
        peReportOverview: overrides && overrides.hasOwnProperty('peReportOverview') ? overrides.peReportOverview! : relationshipsToOmit.has('PeReportOverviewOutput') ? {} as PeReportOverviewOutput : aPeReportOverviewOutput({}, relationshipsToOmit),
        peReportAudience: overrides && overrides.hasOwnProperty('peReportAudience') ? overrides.peReportAudience! : relationshipsToOmit.has('PeReportAudienceOutput') ? {} as PeReportAudienceOutput : aPeReportAudienceOutput({}, relationshipsToOmit),
        resaleWaitlistOverview: overrides && overrides.hasOwnProperty('resaleWaitlistOverview') ? overrides.resaleWaitlistOverview! : relationshipsToOmit.has('PeReportWaitlistOutput') ? {} as PeReportWaitlistOutput : aPeReportWaitlistOutput({}, relationshipsToOmit),
        registrationOverview: overrides && overrides.hasOwnProperty('registrationOverview') ? overrides.registrationOverview! : relationshipsToOmit.has('PeReportRegistrationOutput') ? {} as PeReportRegistrationOutput : aPeReportRegistrationOutput({}, relationshipsToOmit),
        registrationCompetitionOverview: overrides && overrides.hasOwnProperty('registrationCompetitionOverview') ? overrides.registrationCompetitionOverview! : relationshipsToOmit.has('PeReportRegistrationCompetitionOutput') ? {} as PeReportRegistrationCompetitionOutput : aPeReportRegistrationCompetitionOutput({}, relationshipsToOmit),
        peReferralPromotionReportStats: overrides && overrides.hasOwnProperty('peReferralPromotionReportStats') ? overrides.peReferralPromotionReportStats! : relationshipsToOmit.has('PeReportReferralOutsideMainSaleOutput') ? {} as PeReportReferralOutsideMainSaleOutput : aPeReportReferralOutsideMainSaleOutput({}, relationshipsToOmit),
        peOnsaleCompetitionReportStats: overrides && overrides.hasOwnProperty('peOnsaleCompetitionReportStats') ? overrides.peOnsaleCompetitionReportStats! : relationshipsToOmit.has('PeReportRegistrationCompetitionOutput') ? {} as PeReportRegistrationCompetitionOutput : aPeReportRegistrationCompetitionOutput({}, relationshipsToOmit),
        demographics: overrides && overrides.hasOwnProperty('demographics') ? overrides.demographics! : relationshipsToOmit.has('PeReportDemographicsOutput') ? {} as PeReportDemographicsOutput : aPeReportDemographicsOutput({}, relationshipsToOmit),
        defaultDatesForPostEventReport: overrides && overrides.hasOwnProperty('defaultDatesForPostEventReport') ? overrides.defaultDatesForPostEventReport! : relationshipsToOmit.has('DefaultDates') ? {} as DefaultDates : aDefaultDates({}, relationshipsToOmit),
        peSalesChannelGraph: overrides && overrides.hasOwnProperty('peSalesChannelGraph') ? overrides.peSalesChannelGraph! : relationshipsToOmit.has('SalesChannelGraphOutput') ? {} as SalesChannelGraphOutput : aSalesChannelGraphOutput({}, relationshipsToOmit),
        peFinancialGateways: overrides && overrides.hasOwnProperty('peFinancialGateways') ? overrides.peFinancialGateways! : relationshipsToOmit.has('FinancialGatewayGraphOutput') ? {} as FinancialGatewayGraphOutput : aFinancialGatewayGraphOutput({}, relationshipsToOmit),
        getRedirectUrlByCode: overrides && overrides.hasOwnProperty('getRedirectUrlByCode') ? overrides.getRedirectUrlByCode! : relationshipsToOmit.has('RedirectUrl') ? {} as RedirectUrl : aRedirectUrl({}, relationshipsToOmit),
        getAccessCodesForMembership: overrides && overrides.hasOwnProperty('getAccessCodesForMembership') ? overrides.getAccessCodesForMembership! : [relationshipsToOmit.has('AccessCode') ? {} as AccessCode : anAccessCode({}, relationshipsToOmit)],
        validateAccessCodeForMembership: overrides && overrides.hasOwnProperty('validateAccessCodeForMembership') ? overrides.validateAccessCodeForMembership! : relationshipsToOmit.has('AccessCode') ? {} as AccessCode : anAccessCode({}, relationshipsToOmit),
        getShortUrlByCode: overrides && overrides.hasOwnProperty('getShortUrlByCode') ? overrides.getShortUrlByCode! : relationshipsToOmit.has('ShortUrl') ? {} as ShortUrl : aShortUrl({}, relationshipsToOmit),
        getWaitlistUser: overrides && overrides.hasOwnProperty('getWaitlistUser') ? overrides.getWaitlistUser! : relationshipsToOmit.has('WaitlistUser') ? {} as WaitlistUser : aWaitlistUser({}, relationshipsToOmit),
        resaleTickets: overrides && overrides.hasOwnProperty('resaleTickets') ? overrides.resaleTickets! : [relationshipsToOmit.has('TicketType') ? {} as TicketType : aTicketType({}, relationshipsToOmit)],
        resaleTicket: overrides && overrides.hasOwnProperty('resaleTicket') ? overrides.resaleTicket! : relationshipsToOmit.has('TicketType') ? {} as TicketType : aTicketType({}, relationshipsToOmit),
        resaleTicketsMetrics: overrides && overrides.hasOwnProperty('resaleTicketsMetrics') ? overrides.resaleTicketsMetrics! : [relationshipsToOmit.has('ResaleTicketMetrics') ? {} as ResaleTicketMetrics : aResaleTicketMetrics({}, relationshipsToOmit)],
        resaleWaitlistCount: overrides && overrides.hasOwnProperty('resaleWaitlistCount') ? overrides.resaleWaitlistCount! : relationshipsToOmit.has('ResaleWaitlistCount') ? {} as ResaleWaitlistCount : aResaleWaitlistCount({}, relationshipsToOmit),
        getReleaseUrlForResaleTicketType: overrides && overrides.hasOwnProperty('getReleaseUrlForResaleTicketType') ? overrides.getReleaseUrlForResaleTicketType! : 'vulgivagus',
        getMinTicketTypePricesForEvent: overrides && overrides.hasOwnProperty('getMinTicketTypePricesForEvent') ? overrides.getMinTicketTypePricesForEvent! : [relationshipsToOmit.has('MinTicketTypePricesForEventOutput') ? {} as MinTicketTypePricesForEventOutput : aMinTicketTypePricesForEventOutput({}, relationshipsToOmit)],
        resaleTicketTypesForWaitlist: overrides && overrides.hasOwnProperty('resaleTicketTypesForWaitlist') ? overrides.resaleTicketTypesForWaitlist! : [relationshipsToOmit.has('TicketType') ? {} as TicketType : aTicketType({}, relationshipsToOmit)],
        broadcasts: overrides && overrides.hasOwnProperty('broadcasts') ? overrides.broadcasts! : [relationshipsToOmit.has('BroadcastListOutput') ? {} as BroadcastListOutput : aBroadcastListOutput({}, relationshipsToOmit)],
        broadcast: overrides && overrides.hasOwnProperty('broadcast') ? overrides.broadcast! : relationshipsToOmit.has('BroadcastOutput') ? {} as BroadcastOutput : aBroadcastOutput({}, relationshipsToOmit),
        audienceCount: overrides && overrides.hasOwnProperty('audienceCount') ? overrides.audienceCount! : 3.5,
        marketingUserCount: overrides && overrides.hasOwnProperty('marketingUserCount') ? overrides.marketingUserCount! : 4.8,
        broadcastFilterState: overrides && overrides.hasOwnProperty('broadcastFilterState') ? overrides.broadcastFilterState! : [relationshipsToOmit.has('BroadcastMarketingV2StateOutput') ? {} as BroadcastMarketingV2StateOutput : aBroadcastMarketingV2StateOutput({}, relationshipsToOmit)],
        broadcastDeliveryErrors: overrides && overrides.hasOwnProperty('broadcastDeliveryErrors') ? overrides.broadcastDeliveryErrors! : relationshipsToOmit.has('BroadcastDeliveryErrorsOutput') ? {} as BroadcastDeliveryErrorsOutput : aBroadcastDeliveryErrorsOutput({}, relationshipsToOmit),
        getBroadcastDefaultConfig: overrides && overrides.hasOwnProperty('getBroadcastDefaultConfig') ? overrides.getBroadcastDefaultConfig! : relationshipsToOmit.has('BroadcastDefaultConfigOutput') ? {} as BroadcastDefaultConfigOutput : aBroadcastDefaultConfigOutput({}, relationshipsToOmit),
        getRegionsForCountry: overrides && overrides.hasOwnProperty('getRegionsForCountry') ? overrides.getRegionsForCountry! : ['defleo'],
        getBroadcastLocationFilterOptions: overrides && overrides.hasOwnProperty('getBroadcastLocationFilterOptions') ? overrides.getBroadcastLocationFilterOptions! : relationshipsToOmit.has('BroadcastLocationFilterOptions') ? {} as BroadcastLocationFilterOptions : aBroadcastLocationFilterOptions({}, relationshipsToOmit),
        broadcastsForEmailsOpenedFilter: overrides && overrides.hasOwnProperty('broadcastsForEmailsOpenedFilter') ? overrides.broadcastsForEmailsOpenedFilter! : [relationshipsToOmit.has('ResponseLabelValue') ? {} as ResponseLabelValue : aResponseLabelValue({}, relationshipsToOmit)],
        broadcastUnsubscribes: overrides && overrides.hasOwnProperty('broadcastUnsubscribes') ? overrides.broadcastUnsubscribes! : relationshipsToOmit.has('BroadcastUnsubscribesOutput') ? {} as BroadcastUnsubscribesOutput : aBroadcastUnsubscribesOutput({}, relationshipsToOmit),
        broadcastReportedAsSpam: overrides && overrides.hasOwnProperty('broadcastReportedAsSpam') ? overrides.broadcastReportedAsSpam! : relationshipsToOmit.has('BroadcastReportedAsSpamUsersOutput') ? {} as BroadcastReportedAsSpamUsersOutput : aBroadcastReportedAsSpamUsersOutput({}, relationshipsToOmit),
        eventsForBroadcast: overrides && overrides.hasOwnProperty('eventsForBroadcast') ? overrides.eventsForBroadcast! : [relationshipsToOmit.has('EventForBroadcast') ? {} as EventForBroadcast : anEventForBroadcast({}, relationshipsToOmit)],
        smsBroadcasts: overrides && overrides.hasOwnProperty('smsBroadcasts') ? overrides.smsBroadcasts! : [relationshipsToOmit.has('SmsBroadcastListOutput') ? {} as SmsBroadcastListOutput : aSmsBroadcastListOutput({}, relationshipsToOmit)],
        smsBroadcast: overrides && overrides.hasOwnProperty('smsBroadcast') ? overrides.smsBroadcast! : relationshipsToOmit.has('SmsBroadcastOutput') ? {} as SmsBroadcastOutput : aSmsBroadcastOutput({}, relationshipsToOmit),
        smsBroadcastDeliveryErrors: overrides && overrides.hasOwnProperty('smsBroadcastDeliveryErrors') ? overrides.smsBroadcastDeliveryErrors! : relationshipsToOmit.has('SmsBroadcastDeliveryErrorsOutput') ? {} as SmsBroadcastDeliveryErrorsOutput : aSmsBroadcastDeliveryErrorsOutput({}, relationshipsToOmit),
        smsBroadcastAudience: overrides && overrides.hasOwnProperty('smsBroadcastAudience') ? overrides.smsBroadcastAudience! : relationshipsToOmit.has('SmsBroadcastAudienceOutput') ? {} as SmsBroadcastAudienceOutput : aSmsBroadcastAudienceOutput({}, relationshipsToOmit),
        smsBroadcastUnsubscribes: overrides && overrides.hasOwnProperty('smsBroadcastUnsubscribes') ? overrides.smsBroadcastUnsubscribes! : relationshipsToOmit.has('SmsBroadcastUnsubscribesOutput') ? {} as SmsBroadcastUnsubscribesOutput : aSmsBroadcastUnsubscribesOutput({}, relationshipsToOmit),
        emailDomains: overrides && overrides.hasOwnProperty('emailDomains') ? overrides.emailDomains! : [relationshipsToOmit.has('EmailDomainOutput') ? {} as EmailDomainOutput : anEmailDomainOutput({}, relationshipsToOmit)],
        verifiedEmailDomains: overrides && overrides.hasOwnProperty('verifiedEmailDomains') ? overrides.verifiedEmailDomains! : [relationshipsToOmit.has('EmailDomainOutput') ? {} as EmailDomainOutput : anEmailDomainOutput({}, relationshipsToOmit)],
        codeReport: overrides && overrides.hasOwnProperty('codeReport') ? overrides.codeReport! : relationshipsToOmit.has('CodeReportOutput') ? {} as CodeReportOutput : aCodeReportOutput({}, relationshipsToOmit),
        reportSchedules: overrides && overrides.hasOwnProperty('reportSchedules') ? overrides.reportSchedules! : [relationshipsToOmit.has('ReportSchedule') ? {} as ReportSchedule : aReportSchedule({}, relationshipsToOmit)],
        chargeSummary: overrides && overrides.hasOwnProperty('chargeSummary') ? overrides.chargeSummary! : [relationshipsToOmit.has('ChargeSummaryOutput') ? {} as ChargeSummaryOutput : aChargeSummaryOutput({}, relationshipsToOmit)],
        chargeMonthSummary: overrides && overrides.hasOwnProperty('chargeMonthSummary') ? overrides.chargeMonthSummary! : relationshipsToOmit.has('ChargeMonthSummaryOutput') ? {} as ChargeMonthSummaryOutput : aChargeMonthSummaryOutput({}, relationshipsToOmit),
        getTrackingCodesByEventId: overrides && overrides.hasOwnProperty('getTrackingCodesByEventId') ? overrides.getTrackingCodesByEventId! : [relationshipsToOmit.has('TrackingCodeOutput') ? {} as TrackingCodeOutput : aTrackingCodeOutput({}, relationshipsToOmit)],
        atrMembershipOrdersUpdatedBetween: overrides && overrides.hasOwnProperty('atrMembershipOrdersUpdatedBetween') ? overrides.atrMembershipOrdersUpdatedBetween! : [relationshipsToOmit.has('AtrMembershipOrdersUpdatedBetweenOutput') ? {} as AtrMembershipOrdersUpdatedBetweenOutput : anAtrMembershipOrdersUpdatedBetweenOutput({}, relationshipsToOmit)],
        atrUsersUpdatedBetween: overrides && overrides.hasOwnProperty('atrUsersUpdatedBetween') ? overrides.atrUsersUpdatedBetween! : [relationshipsToOmit.has('AtrUsersUpdatedBetweenOutput') ? {} as AtrUsersUpdatedBetweenOutput : anAtrUsersUpdatedBetweenOutput({}, relationshipsToOmit)],
        exportFilterColumns: overrides && overrides.hasOwnProperty('exportFilterColumns') ? overrides.exportFilterColumns! : relationshipsToOmit.has('ExportFilterCategoryOutput') ? {} as ExportFilterCategoryOutput : anExportFilterCategoryOutput({}, relationshipsToOmit),
        signupForm: overrides && overrides.hasOwnProperty('signupForm') ? overrides.signupForm! : relationshipsToOmit.has('SignupFormOutput') ? {} as SignupFormOutput : aSignupFormOutput({}, relationshipsToOmit),
        signupForms: overrides && overrides.hasOwnProperty('signupForms') ? overrides.signupForms! : [relationshipsToOmit.has('SignupFormOutput') ? {} as SignupFormOutput : aSignupFormOutput({}, relationshipsToOmit)],
        getProcessedCustomCSS: overrides && overrides.hasOwnProperty('getProcessedCustomCSS') ? overrides.getProcessedCustomCSS! : 'ubi',
        segments: overrides && overrides.hasOwnProperty('segments') ? overrides.segments! : [relationshipsToOmit.has('SegmentListOutput') ? {} as SegmentListOutput : aSegmentListOutput({}, relationshipsToOmit)],
        segment: overrides && overrides.hasOwnProperty('segment') ? overrides.segment! : relationshipsToOmit.has('SegmentOutput') ? {} as SegmentOutput : aSegmentOutput({}, relationshipsToOmit),
        segmentCustomerCount: overrides && overrides.hasOwnProperty('segmentCustomerCount') ? overrides.segmentCustomerCount! : relationshipsToOmit.has('SegmentCustomerCountOutput') ? {} as SegmentCustomerCountOutput : aSegmentCustomerCountOutput({}, relationshipsToOmit),
    };
};

export const aUser = (overrides?: Partial<User>, _relationshipsToOmit: Set<string> = new Set()): User => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('User');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'b7605a2a-ad1e-4667-801e-5e47e5de933b',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2026-03-02T19:00:52.711Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-10-25T20:53:20.921Z",
        organization: overrides && overrides.hasOwnProperty('organization') ? overrides.organization! : relationshipsToOmit.has('Organization') ? {} as Organization : anOrganization({}, relationshipsToOmit),
        roles: overrides && overrides.hasOwnProperty('roles') ? overrides.roles! : [Role.Superadmin],
        permissions: overrides && overrides.hasOwnProperty('permissions') ? overrides.permissions! : [Permission.AccountCreate],
        firstName: overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'trans',
        lastName: overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'avaritia',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'natus',
        fullName: overrides && overrides.hasOwnProperty('fullName') ? overrides.fullName! : 'circumvenio',
        hasPassword: overrides && overrides.hasOwnProperty('hasPassword') ? overrides.hasPassword! : false,
        isTwoFactorAuthenticationEnabled: overrides && overrides.hasOwnProperty('isTwoFactorAuthenticationEnabled') ? overrides.isTwoFactorAuthenticationEnabled! : true,
        isLoggedInWithLinkedAccount: overrides && overrides.hasOwnProperty('isLoggedInWithLinkedAccount') ? overrides.isLoggedInWithLinkedAccount! : true,
        hasVerifiedEmail: overrides && overrides.hasOwnProperty('hasVerifiedEmail') ? overrides.hasVerifiedEmail! : true,
        birthDate: overrides && overrides.hasOwnProperty('birthDate') ? overrides.birthDate! : "2025-08-14T02:18:59.384Z",
        phoneNumber: overrides && overrides.hasOwnProperty('phoneNumber') ? overrides.phoneNumber! : 'usitas',
        gender: overrides && overrides.hasOwnProperty('gender') ? overrides.gender! : Gender.Male,
        usableForEmailMarketing: overrides && overrides.hasOwnProperty('usableForEmailMarketing') ? overrides.usableForEmailMarketing! : false,
        receiveScannerEmail: overrides && overrides.hasOwnProperty('receiveScannerEmail') ? overrides.receiveScannerEmail! : true,
        usableForSMSMarketing: overrides && overrides.hasOwnProperty('usableForSMSMarketing') ? overrides.usableForSMSMarketing! : false,
        billingAddress: overrides && overrides.hasOwnProperty('billingAddress') ? overrides.billingAddress! : relationshipsToOmit.has('PartialAddress') ? {} as PartialAddress : aPartialAddress({}, relationshipsToOmit),
        shippingAddress: overrides && overrides.hasOwnProperty('shippingAddress') ? overrides.shippingAddress! : relationshipsToOmit.has('PartialAddress') ? {} as PartialAddress : aPartialAddress({}, relationshipsToOmit),
        shippingAddressMatchesBillingAddress: overrides && overrides.hasOwnProperty('shippingAddressMatchesBillingAddress') ? overrides.shippingAddressMatchesBillingAddress! : true,
        credits: overrides && overrides.hasOwnProperty('credits') ? overrides.credits! : 3.4,
        points: overrides && overrides.hasOwnProperty('points') ? overrides.points! : 4.9,
        usSegment: overrides && overrides.hasOwnProperty('usSegment') ? overrides.usSegment! : relationshipsToOmit.has('UsSegment') ? {} as UsSegment : anUsSegment({}, relationshipsToOmit),
        referralId: overrides && overrides.hasOwnProperty('referralId') ? overrides.referralId! : 'aegrus',
        instagramUsername: overrides && overrides.hasOwnProperty('instagramUsername') ? overrides.instagramUsername! : 'curis',
        companyName: overrides && overrides.hasOwnProperty('companyName') ? overrides.companyName! : 'tamquam',
        taxNumber: overrides && overrides.hasOwnProperty('taxNumber') ? overrides.taxNumber! : 'adaugeo',
        region: overrides && overrides.hasOwnProperty('region') ? overrides.region! : 'vespillo',
        unsubscribeReason: overrides && overrides.hasOwnProperty('unsubscribeReason') ? overrides.unsubscribeReason! : UnsubscribeReason.NoLongerInterested,
        lastLoginAttemptedAt: overrides && overrides.hasOwnProperty('lastLoginAttemptedAt') ? overrides.lastLoginAttemptedAt! : 'acerbitas',
        loginAttempts: overrides && overrides.hasOwnProperty('loginAttempts') ? overrides.loginAttempts! : 'amplexus',
        otherUnsubscribeReason: overrides && overrides.hasOwnProperty('otherUnsubscribeReason') ? overrides.otherUnsubscribeReason! : 'subseco',
        lastTimeLoggedInAt: overrides && overrides.hasOwnProperty('lastTimeLoggedInAt') ? overrides.lastTimeLoggedInAt! : "2025-08-09T06:52:45.582Z",
        e164Number: overrides && overrides.hasOwnProperty('e164Number') ? overrides.e164Number! : 'tremo',
        internationalPhoneNumber: overrides && overrides.hasOwnProperty('internationalPhoneNumber') ? overrides.internationalPhoneNumber! : relationshipsToOmit.has('InternationalPhoneNumberOutput') ? {} as InternationalPhoneNumberOutput : anInternationalPhoneNumberOutput({}, relationshipsToOmit),
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : [relationshipsToOmit.has('Tag') ? {} as Tag : aTag({}, relationshipsToOmit)],
        scoutCommunications: overrides && overrides.hasOwnProperty('scoutCommunications') ? overrides.scoutCommunications! : [relationshipsToOmit.has('ScoutCommunication') ? {} as ScoutCommunication : aScoutCommunication({}, relationshipsToOmit)],
        orders: overrides && overrides.hasOwnProperty('orders') ? overrides.orders! : relationshipsToOmit.has('OrderConnection') ? {} as OrderConnection : anOrderConnection({}, relationshipsToOmit),
        ticketHolderOrders: overrides && overrides.hasOwnProperty('ticketHolderOrders') ? overrides.ticketHolderOrders! : relationshipsToOmit.has('OrderConnection') ? {} as OrderConnection : anOrderConnection({}, relationshipsToOmit),
        hasOrders: overrides && overrides.hasOwnProperty('hasOrders') ? overrides.hasOrders! : true,
        membershipTickets: overrides && overrides.hasOwnProperty('membershipTickets') ? overrides.membershipTickets! : [relationshipsToOmit.has('Ticket') ? {} as Ticket : aTicket({}, relationshipsToOmit)],
        eventTickets: overrides && overrides.hasOwnProperty('eventTickets') ? overrides.eventTickets! : [relationshipsToOmit.has('Ticket') ? {} as Ticket : aTicket({}, relationshipsToOmit)],
        hasMemberships: overrides && overrides.hasOwnProperty('hasMemberships') ? overrides.hasMemberships! : false,
        hasTickets: overrides && overrides.hasOwnProperty('hasTickets') ? overrides.hasTickets! : true,
        LTV: overrides && overrides.hasOwnProperty('LTV') ? overrides.LTV! : 9.4,
        history: overrides && overrides.hasOwnProperty('history') ? overrides.history! : relationshipsToOmit.has('HistoryConnection') ? {} as HistoryConnection : aHistoryConnection({}, relationshipsToOmit),
        accessEventIds: overrides && overrides.hasOwnProperty('accessEventIds') ? overrides.accessEventIds! : ['tripudio'],
        accessMembershipIds: overrides && overrides.hasOwnProperty('accessMembershipIds') ? overrides.accessMembershipIds! : ['crustulum'],
        shopifyUser: overrides && overrides.hasOwnProperty('shopifyUser') ? overrides.shopifyUser! : relationshipsToOmit.has('ShopifyUser') ? {} as ShopifyUser : aShopifyUser({}, relationshipsToOmit),
        pfOrgHasCustomEmailDomain: overrides && overrides.hasOwnProperty('pfOrgHasCustomEmailDomain') ? overrides.pfOrgHasCustomEmailDomain! : true,
        hmac: overrides && overrides.hasOwnProperty('hmac') ? overrides.hmac! : relationshipsToOmit.has('HmacOutput') ? {} as HmacOutput : aHmacOutput({}, relationshipsToOmit),
        canConnectToPaymentTerminal: overrides && overrides.hasOwnProperty('canConnectToPaymentTerminal') ? overrides.canConnectToPaymentTerminal! : false,
        paymentTerminalGatewayId: overrides && overrides.hasOwnProperty('paymentTerminalGatewayId') ? overrides.paymentTerminalGatewayId! : 'conduco',
    };
};

export const anOrganization = (overrides?: Partial<Organization>, _relationshipsToOmit: Set<string> = new Set()): Organization => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Organization');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '5f8a43ce-bfc3-411d-b6d9-e3b4c562c170',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2026-01-21T05:27:30.414Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-05-21T06:55:38.780Z",
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'succedo',
        slug: overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'caelum',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'natus',
        phone: overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : 'blandior',
        taxNumber: overrides && overrides.hasOwnProperty('taxNumber') ? overrides.taxNumber! : 'venio',
        currency: overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'pariatur',
        address: overrides && overrides.hasOwnProperty('address') ? overrides.address! : relationshipsToOmit.has('Address') ? {} as Address : anAddress({}, relationshipsToOmit),
        landingPage: overrides && overrides.hasOwnProperty('landingPage') ? overrides.landingPage! : LandingPage.MultiEvent,
        showMemberships: overrides && overrides.hasOwnProperty('showMemberships') ? overrides.showMemberships! : false,
        showMembershipRenewal: overrides && overrides.hasOwnProperty('showMembershipRenewal') ? overrides.showMembershipRenewal! : true,
        supportInfo: overrides && overrides.hasOwnProperty('supportInfo') ? overrides.supportInfo! : 'civis',
        privacyPolicy: overrides && overrides.hasOwnProperty('privacyPolicy') ? overrides.privacyPolicy! : 'circumvenio',
        termsAndConditions: overrides && overrides.hasOwnProperty('termsAndConditions') ? overrides.termsAndConditions! : 'agnosco',
        marketing: overrides && overrides.hasOwnProperty('marketing') ? overrides.marketing! : relationshipsToOmit.has('Marketing') ? {} as Marketing : aMarketing({}, relationshipsToOmit),
        branding: overrides && overrides.hasOwnProperty('branding') ? overrides.branding! : relationshipsToOmit.has('BrandingOutputBase') ? {} as BrandingOutputBase : aBrandingOutputBase({}, relationshipsToOmit),
        shippingLabels: overrides && overrides.hasOwnProperty('shippingLabels') ? overrides.shippingLabels! : relationshipsToOmit.has('ShippingLabels') ? {} as ShippingLabels : aShippingLabels({}, relationshipsToOmit),
        features: overrides && overrides.hasOwnProperty('features') ? overrides.features! : ['aranea'],
        timezone: overrides && overrides.hasOwnProperty('timezone') ? overrides.timezone! : 'Pacific/Auckland',
        locale: overrides && overrides.hasOwnProperty('locale') ? overrides.locale! : 'en',
        helpLink: overrides && overrides.hasOwnProperty('helpLink') ? overrides.helpLink! : 'aliquid',
        ticketCoverPlatformFeePercentage: overrides && overrides.hasOwnProperty('ticketCoverPlatformFeePercentage') ? overrides.ticketCoverPlatformFeePercentage! : 2.5,
        taxRate: overrides && overrides.hasOwnProperty('taxRate') ? overrides.taxRate! : 5,
        taxCalculationMethod: overrides && overrides.hasOwnProperty('taxCalculationMethod') ? overrides.taxCalculationMethod! : TaxCalculationMethod.Inclusive,
        defaultOptInMarketing: overrides && overrides.hasOwnProperty('defaultOptInMarketing') ? overrides.defaultOptInMarketing! : true,
        cookieConsent: overrides && overrides.hasOwnProperty('cookieConsent') ? overrides.cookieConsent! : true,
        defaultLanguage: overrides && overrides.hasOwnProperty('defaultLanguage') ? overrides.defaultLanguage! : 'crudelis',
        customTaxRate: overrides && overrides.hasOwnProperty('customTaxRate') ? overrides.customTaxRate! : 8.9,
        customTaxName: overrides && overrides.hasOwnProperty('customTaxName') ? overrides.customTaxName! : 'varietas',
        platformChargeSettings: overrides && overrides.hasOwnProperty('platformChargeSettings') ? overrides.platformChargeSettings! : relationshipsToOmit.has('PlatformChargeSettings') ? {} as PlatformChargeSettings : aPlatformChargeSettings({}, relationshipsToOmit),
        i18n: overrides && overrides.hasOwnProperty('i18n') ? overrides.i18n! : 'ambitus',
        isTest: overrides && overrides.hasOwnProperty('isTest') ? overrides.isTest! : true,
        landingTours: overrides && overrides.hasOwnProperty('landingTours') ? overrides.landingTours! : relationshipsToOmit.has('LandingToursSettings') ? {} as LandingToursSettings : aLandingToursSettings({}, relationshipsToOmit),
        flicketDomainOverride: overrides && overrides.hasOwnProperty('flicketDomainOverride') ? overrides.flicketDomainOverride! : 'audio',
        point: overrides && overrides.hasOwnProperty('point') ? overrides.point! : relationshipsToOmit.has('Point') ? {} as Point : aPoint({}, relationshipsToOmit),
        calendarHomepageCustomization: overrides && overrides.hasOwnProperty('calendarHomepageCustomization') ? overrides.calendarHomepageCustomization! : relationshipsToOmit.has('CalendarHomepageCustomization') ? {} as CalendarHomepageCustomization : aCalendarHomepageCustomization({}, relationshipsToOmit),
    };
};

export const anAddress = (overrides?: Partial<Address>, _relationshipsToOmit: Set<string> = new Set()): Address => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Address');
    return {
        line1: overrides && overrides.hasOwnProperty('line1') ? overrides.line1! : 'aestivus',
        line2: overrides && overrides.hasOwnProperty('line2') ? overrides.line2! : 'viduo',
        suburb: overrides && overrides.hasOwnProperty('suburb') ? overrides.suburb! : 'non',
        postalCode: overrides && overrides.hasOwnProperty('postalCode') ? overrides.postalCode! : 'ciminatio',
        city: overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'audacia',
        state: overrides && overrides.hasOwnProperty('state') ? overrides.state! : 'eveniet',
        country: overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'bene',
        formattedAddress: overrides && overrides.hasOwnProperty('formattedAddress') ? overrides.formattedAddress! : 'sed',
    };
};

export const aMarketing = (overrides?: Partial<Marketing>, _relationshipsToOmit: Set<string> = new Set()): Marketing => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Marketing');
    return {
        gtmId: overrides && overrides.hasOwnProperty('gtmId') ? overrides.gtmId! : 'aegrotatio',
        pixelId: overrides && overrides.hasOwnProperty('pixelId') ? overrides.pixelId! : 'cupiditate',
    };
};

export const aBrandingOutputBase = (overrides?: Partial<BrandingOutputBase>, _relationshipsToOmit: Set<string> = new Set()): BrandingOutputBase => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BrandingOutputBase');
    return {
        logo: overrides && overrides.hasOwnProperty('logo') ? overrides.logo! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        mobileLogo: overrides && overrides.hasOwnProperty('mobileLogo') ? overrides.mobileLogo! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        favicon: overrides && overrides.hasOwnProperty('favicon') ? overrides.favicon! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        background: overrides && overrides.hasOwnProperty('background') ? overrides.background! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        fullBackground: overrides && overrides.hasOwnProperty('fullBackground') ? overrides.fullBackground! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        primaryColor: overrides && overrides.hasOwnProperty('primaryColor') ? overrides.primaryColor! : 'arma',
        secondaryColor: overrides && overrides.hasOwnProperty('secondaryColor') ? overrides.secondaryColor! : 'brevis',
        greyScale: overrides && overrides.hasOwnProperty('greyScale') ? overrides.greyScale! : GreyScale.Warm,
    };
};

export const anExtendedFile = (overrides?: Partial<ExtendedFile>, _relationshipsToOmit: Set<string> = new Set()): ExtendedFile => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ExtendedFile');
    return {
        storage: overrides && overrides.hasOwnProperty('storage') ? overrides.storage! : StorageType.Local,
        directory: overrides && overrides.hasOwnProperty('directory') ? overrides.directory! : 'clibanus',
        fileName: overrides && overrides.hasOwnProperty('fileName') ? overrides.fileName! : 'sunt',
        originalFileName: overrides && overrides.hasOwnProperty('originalFileName') ? overrides.originalFileName! : 'eum',
        metaData: overrides && overrides.hasOwnProperty('metaData') ? overrides.metaData! : relationshipsToOmit.has('MetaData') ? {} as MetaData : aMetaData({}, relationshipsToOmit),
    };
};

export const aMetaData = (overrides?: Partial<MetaData>, _relationshipsToOmit: Set<string> = new Set()): MetaData => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MetaData');
    return {
        width: overrides && overrides.hasOwnProperty('width') ? overrides.width! : 8,
        height: overrides && overrides.hasOwnProperty('height') ? overrides.height! : 8.6,
    };
};

export const aShippingLabels = (overrides?: Partial<ShippingLabels>, _relationshipsToOmit: Set<string> = new Set()): ShippingLabels => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ShippingLabels');
    return {
        eTicket: overrides && overrides.hasOwnProperty('eTicket') ? overrides.eTicket! : 'numquam',
        printedTicketByMail: overrides && overrides.hasOwnProperty('printedTicketByMail') ? overrides.printedTicketByMail! : 'verbera',
        printedTicketByCourier: overrides && overrides.hasOwnProperty('printedTicketByCourier') ? overrides.printedTicketByCourier! : 'tredecim',
        printedTicketByCourierRural: overrides && overrides.hasOwnProperty('printedTicketByCourierRural') ? overrides.printedTicketByCourierRural! : 'repudiandae',
        printedTicketAtVenue: overrides && overrides.hasOwnProperty('printedTicketAtVenue') ? overrides.printedTicketAtVenue! : 'textilis',
    };
};

export const aPlatformChargeSettings = (overrides?: Partial<PlatformChargeSettings>, _relationshipsToOmit: Set<string> = new Set()): PlatformChargeSettings => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PlatformChargeSettings');
    return {
        orderChargeSettings: overrides && overrides.hasOwnProperty('orderChargeSettings') ? overrides.orderChargeSettings! : [relationshipsToOmit.has('OrderChargeSetting') ? {} as OrderChargeSetting : anOrderChargeSetting({}, relationshipsToOmit)],
    };
};

export const anOrderChargeSetting = (overrides?: Partial<OrderChargeSetting>, _relationshipsToOmit: Set<string> = new Set()): OrderChargeSetting => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OrderChargeSetting');
    return {
        percentage: overrides && overrides.hasOwnProperty('percentage') ? overrides.percentage! : 9.8,
        pricingStrategy: overrides && overrides.hasOwnProperty('pricingStrategy') ? overrides.pricingStrategy! : PricingStrategy.LineItemsExcComp,
    };
};

export const aLandingToursSettings = (overrides?: Partial<LandingToursSettings>, _relationshipsToOmit: Set<string> = new Set()): LandingToursSettings => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LandingToursSettings');
    return {
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'admoveo',
        banner: overrides && overrides.hasOwnProperty('banner') ? overrides.banner! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        showCalendarOnTourPage: overrides && overrides.hasOwnProperty('showCalendarOnTourPage') ? overrides.showCalendarOnTourPage! : false,
    };
};

export const aPoint = (overrides?: Partial<Point>, _relationshipsToOmit: Set<string> = new Set()): Point => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Point');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'db51c507-2d92-482d-8b4d-1bcb73cb6c4c',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2026-02-06T10:13:09.300Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2026-02-16T21:15:02.786Z",
        organization: overrides && overrides.hasOwnProperty('organization') ? overrides.organization! : relationshipsToOmit.has('Organization') ? {} as Organization : anOrganization({}, relationshipsToOmit),
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'suadeo',
        termsAndConditions: overrides && overrides.hasOwnProperty('termsAndConditions') ? overrides.termsAndConditions! : 'utpote',
        isEnabled: overrides && overrides.hasOwnProperty('isEnabled') ? overrides.isEnabled! : true,
        pointItems: overrides && overrides.hasOwnProperty('pointItems') ? overrides.pointItems! : [relationshipsToOmit.has('PointItem') ? {} as PointItem : aPointItem({}, relationshipsToOmit)],
        gateways: overrides && overrides.hasOwnProperty('gateways') ? overrides.gateways! : [relationshipsToOmit.has('Integration') ? {} as Integration : anIntegration({}, relationshipsToOmit)],
        stripeConfig: overrides && overrides.hasOwnProperty('stripeConfig') ? overrides.stripeConfig! : relationshipsToOmit.has('StripeConfigOutput') ? {} as StripeConfigOutput : aStripeConfigOutput({}, relationshipsToOmit),
    };
};

export const aPointItem = (overrides?: Partial<PointItem>, _relationshipsToOmit: Set<string> = new Set()): PointItem => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PointItem');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '37690fb7-9515-4173-bb68-d5f40bb82df5',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-11-09T18:11:24.932Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-12-17T04:31:23.795Z",
        organization: overrides && overrides.hasOwnProperty('organization') ? overrides.organization! : relationshipsToOmit.has('Organization') ? {} as Organization : anOrganization({}, relationshipsToOmit),
        point: overrides && overrides.hasOwnProperty('point') ? overrides.point! : relationshipsToOmit.has('Point') ? {} as Point : aPoint({}, relationshipsToOmit),
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'averto',
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 1.7,
        amount: overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 8,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'defessus',
        thumbnail: overrides && overrides.hasOwnProperty('thumbnail') ? overrides.thumbnail! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        banner: overrides && overrides.hasOwnProperty('banner') ? overrides.banner! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        backgroundImage: overrides && overrides.hasOwnProperty('backgroundImage') ? overrides.backgroundImage! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        descriptionImage: overrides && overrides.hasOwnProperty('descriptionImage') ? overrides.descriptionImage! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        isVisible: overrides && overrides.hasOwnProperty('isVisible') ? overrides.isVisible! : true,
        displayOrder: overrides && overrides.hasOwnProperty('displayOrder') ? overrides.displayOrder! : 7321,
        ticketFeeType: overrides && overrides.hasOwnProperty('ticketFeeType') ? overrides.ticketFeeType! : FeeType.FlatRate,
        ticketFee: overrides && overrides.hasOwnProperty('ticketFee') ? overrides.ticketFee! : 8.3,
        fees: overrides && overrides.hasOwnProperty('fees') ? overrides.fees! : relationshipsToOmit.has('OrderFee') ? {} as OrderFee : anOrderFee({}, relationshipsToOmit),
    };
};

export const anOrderFee = (overrides?: Partial<OrderFee>, _relationshipsToOmit: Set<string> = new Set()): OrderFee => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OrderFee');
    return {
        fees: overrides && overrides.hasOwnProperty('fees') ? overrides.fees! : [relationshipsToOmit.has('Fee') ? {} as Fee : aFee({}, relationshipsToOmit)],
        items: overrides && overrides.hasOwnProperty('items') ? overrides.items! : [relationshipsToOmit.has('ItemFee') ? {} as ItemFee : anItemFee({}, relationshipsToOmit)],
        gateways: overrides && overrides.hasOwnProperty('gateways') ? overrides.gateways! : [relationshipsToOmit.has('OrderFeeIntegration') ? {} as OrderFeeIntegration : anOrderFeeIntegration({}, relationshipsToOmit)],
        organizationExclusiveTaxRate: overrides && overrides.hasOwnProperty('organizationExclusiveTaxRate') ? overrides.organizationExclusiveTaxRate! : 2.8,
    };
};

export const aFee = (overrides?: Partial<Fee>, _relationshipsToOmit: Set<string> = new Set()): Fee => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Fee');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'aegrotatio',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'stultus',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : FeeType.FlatRate,
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 8.4,
        isOptional: overrides && overrides.hasOwnProperty('isOptional') ? overrides.isOptional! : true,
        order: overrides && overrides.hasOwnProperty('order') ? overrides.order! : 7107,
    };
};

export const anItemFee = (overrides?: Partial<ItemFee>, _relationshipsToOmit: Set<string> = new Set()): ItemFee => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ItemFee');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'aggredior',
        isComp: overrides && overrides.hasOwnProperty('isComp') ? overrides.isComp! : false,
        fees: overrides && overrides.hasOwnProperty('fees') ? overrides.fees! : [relationshipsToOmit.has('Fee') ? {} as Fee : aFee({}, relationshipsToOmit)],
    };
};

export const anOrderFeeIntegration = (overrides?: Partial<OrderFeeIntegration>, _relationshipsToOmit: Set<string> = new Set()): OrderFeeIntegration => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OrderFeeIntegration');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '6baa1f4a-7f56-4a87-8b5d-ef8199e5574f',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-08-21T10:15:18.288Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-12-12T10:18:16.815Z",
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : IntegrationType.PaymentStripe,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'asporto',
        publicKey: overrides && overrides.hasOwnProperty('publicKey') ? overrides.publicKey! : 'vetus',
        webhookUrl: overrides && overrides.hasOwnProperty('webhookUrl') ? overrides.webhookUrl! : 'aequus',
        transactionFeeType: overrides && overrides.hasOwnProperty('transactionFeeType') ? overrides.transactionFeeType! : FeeType.FlatRate,
        transactionFee: overrides && overrides.hasOwnProperty('transactionFee') ? overrides.transactionFee! : 8.6,
        transactionFeeType2: overrides && overrides.hasOwnProperty('transactionFeeType2') ? overrides.transactionFeeType2! : FeeType.FlatRate,
        transactionFee2: overrides && overrides.hasOwnProperty('transactionFee2') ? overrides.transactionFee2! : 5.1,
        paymentMethodType: overrides && overrides.hasOwnProperty('paymentMethodType') ? overrides.paymentMethodType! : 'dolorum',
        facebookPageId: overrides && overrides.hasOwnProperty('facebookPageId') ? overrides.facebookPageId! : 'compono',
        facebookUserId: overrides && overrides.hasOwnProperty('facebookUserId') ? overrides.facebookUserId! : 'ducimus',
        bnplEnabled: overrides && overrides.hasOwnProperty('bnplEnabled') ? overrides.bnplEnabled! : false,
        expressCheckoutEnabled: overrides && overrides.hasOwnProperty('expressCheckoutEnabled') ? overrides.expressCheckoutEnabled! : true,
        bnplTransactionFeePercent: overrides && overrides.hasOwnProperty('bnplTransactionFeePercent') ? overrides.bnplTransactionFeePercent! : 1,
        daysAfterCanRefund: overrides && overrides.hasOwnProperty('daysAfterCanRefund') ? overrides.daysAfterCanRefund! : 5956,
        stripeConnectAccount: overrides && overrides.hasOwnProperty('stripeConnectAccount') ? overrides.stripeConnectAccount! : relationshipsToOmit.has('StripeConnectAccount') ? {} as StripeConnectAccount : aStripeConnectAccount({}, relationshipsToOmit),
        secretKey: overrides && overrides.hasOwnProperty('secretKey') ? overrides.secretKey! : 'trucido',
        apiKey: overrides && overrides.hasOwnProperty('apiKey') ? overrides.apiKey! : 'arca',
        wcPxPostSecretKey: overrides && overrides.hasOwnProperty('wcPxPostSecretKey') ? overrides.wcPxPostSecretKey! : 'aeternus',
        wcPxPostPublicKey: overrides && overrides.hasOwnProperty('wcPxPostPublicKey') ? overrides.wcPxPostPublicKey! : 'terra',
        isDefault: overrides && overrides.hasOwnProperty('isDefault') ? overrides.isDefault! : false,
    };
};

export const aStripeConnectAccount = (overrides?: Partial<StripeConnectAccount>, _relationshipsToOmit: Set<string> = new Set()): StripeConnectAccount => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('StripeConnectAccount');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'b78d9ac0-3306-4d92-800d-ac3081e0b43a',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-08-06T09:34:59.929Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-12-04T23:35:44.421Z",
        stripeAccountId: overrides && overrides.hasOwnProperty('stripeAccountId') ? overrides.stripeAccountId! : 'vicinus',
        organization: overrides && overrides.hasOwnProperty('organization') ? overrides.organization! : relationshipsToOmit.has('Organization') ? {} as Organization : anOrganization({}, relationshipsToOmit),
        integration: overrides && overrides.hasOwnProperty('integration') ? overrides.integration! : relationshipsToOmit.has('Integration') ? {} as Integration : anIntegration({}, relationshipsToOmit),
        setupState: overrides && overrides.hasOwnProperty('setupState') ? overrides.setupState! : StripeConnectSetupState.Incomplete,
        stripePublishableKey: overrides && overrides.hasOwnProperty('stripePublishableKey') ? overrides.stripePublishableKey! : 'deputo',
    };
};

export const anIntegration = (overrides?: Partial<Integration>, _relationshipsToOmit: Set<string> = new Set()): Integration => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Integration');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '13dc993d-b0b3-4f4d-bccd-92696c8395f2',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-12-17T01:14:48.684Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-06-02T18:09:39.414Z",
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : IntegrationType.PaymentStripe,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'vel',
        publicKey: overrides && overrides.hasOwnProperty('publicKey') ? overrides.publicKey! : 'tantum',
        webhookUrl: overrides && overrides.hasOwnProperty('webhookUrl') ? overrides.webhookUrl! : 'atque',
        transactionFeeType: overrides && overrides.hasOwnProperty('transactionFeeType') ? overrides.transactionFeeType! : FeeType.FlatRate,
        transactionFee: overrides && overrides.hasOwnProperty('transactionFee') ? overrides.transactionFee! : 3.8,
        transactionFeeType2: overrides && overrides.hasOwnProperty('transactionFeeType2') ? overrides.transactionFeeType2! : FeeType.FlatRate,
        transactionFee2: overrides && overrides.hasOwnProperty('transactionFee2') ? overrides.transactionFee2! : 8.6,
        paymentMethodType: overrides && overrides.hasOwnProperty('paymentMethodType') ? overrides.paymentMethodType! : 'suggero',
        facebookPageId: overrides && overrides.hasOwnProperty('facebookPageId') ? overrides.facebookPageId! : 'deputo',
        facebookUserId: overrides && overrides.hasOwnProperty('facebookUserId') ? overrides.facebookUserId! : 'astrum',
        bnplEnabled: overrides && overrides.hasOwnProperty('bnplEnabled') ? overrides.bnplEnabled! : true,
        expressCheckoutEnabled: overrides && overrides.hasOwnProperty('expressCheckoutEnabled') ? overrides.expressCheckoutEnabled! : true,
        bnplTransactionFeePercent: overrides && overrides.hasOwnProperty('bnplTransactionFeePercent') ? overrides.bnplTransactionFeePercent! : 5.7,
        daysAfterCanRefund: overrides && overrides.hasOwnProperty('daysAfterCanRefund') ? overrides.daysAfterCanRefund! : 4064,
        stripeConnectAccount: overrides && overrides.hasOwnProperty('stripeConnectAccount') ? overrides.stripeConnectAccount! : relationshipsToOmit.has('StripeConnectAccount') ? {} as StripeConnectAccount : aStripeConnectAccount({}, relationshipsToOmit),
        secretKey: overrides && overrides.hasOwnProperty('secretKey') ? overrides.secretKey! : 'custodia',
        apiKey: overrides && overrides.hasOwnProperty('apiKey') ? overrides.apiKey! : 'strenuus',
        wcPxPostSecretKey: overrides && overrides.hasOwnProperty('wcPxPostSecretKey') ? overrides.wcPxPostSecretKey! : 'officiis',
        wcPxPostPublicKey: overrides && overrides.hasOwnProperty('wcPxPostPublicKey') ? overrides.wcPxPostPublicKey! : 'soleo',
    };
};

export const aStripeConfigOutput = (overrides?: Partial<StripeConfigOutput>, _relationshipsToOmit: Set<string> = new Set()): StripeConfigOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('StripeConfigOutput');
    return {
        integrationId: overrides && overrides.hasOwnProperty('integrationId') ? overrides.integrationId! : 'enim',
        publishableKey: overrides && overrides.hasOwnProperty('publishableKey') ? overrides.publishableKey! : 'valetudo',
        connectedAccountId: overrides && overrides.hasOwnProperty('connectedAccountId') ? overrides.connectedAccountId! : 'correptius',
        expressCheckoutEnabled: overrides && overrides.hasOwnProperty('expressCheckoutEnabled') ? overrides.expressCheckoutEnabled! : true,
    };
};

export const aCalendarHomepageCustomization = (overrides?: Partial<CalendarHomepageCustomization>, _relationshipsToOmit: Set<string> = new Set()): CalendarHomepageCustomization => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CalendarHomepageCustomization');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '19de374a-b55b-4456-86e3-93c780225d35',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-12-24T20:26:16.314Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-10-30T04:31:57.844Z",
        organizationId: overrides && overrides.hasOwnProperty('organizationId') ? overrides.organizationId! : 'architecto',
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'terra',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'varius',
        banner: overrides && overrides.hasOwnProperty('banner') ? overrides.banner! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
    };
};

export const aPartialAddress = (overrides?: Partial<PartialAddress>, _relationshipsToOmit: Set<string> = new Set()): PartialAddress => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PartialAddress');
    return {
        line1: overrides && overrides.hasOwnProperty('line1') ? overrides.line1! : 'truculenter',
        line2: overrides && overrides.hasOwnProperty('line2') ? overrides.line2! : 'creo',
        suburb: overrides && overrides.hasOwnProperty('suburb') ? overrides.suburb! : 'eaque',
        postalCode: overrides && overrides.hasOwnProperty('postalCode') ? overrides.postalCode! : 'terra',
        city: overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'adsum',
        state: overrides && overrides.hasOwnProperty('state') ? overrides.state! : 'assentator',
        country: overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'veniam',
    };
};

export const anUsSegment = (overrides?: Partial<UsSegment>, _relationshipsToOmit: Set<string> = new Set()): UsSegment => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UsSegment');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '920e4bbe-9411-41ea-b3bb-a22cb8362829',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-08-25T00:23:46.319Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-10-01T08:44:01.137Z",
        user: overrides && overrides.hasOwnProperty('user') ? overrides.user! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        organization: overrides && overrides.hasOwnProperty('organization') ? overrides.organization! : relationshipsToOmit.has('Organization') ? {} as Organization : anOrganization({}, relationshipsToOmit),
        accuracy: overrides && overrides.hasOwnProperty('accuracy') ? overrides.accuracy! : 9.2,
        segment: overrides && overrides.hasOwnProperty('segment') ? overrides.segment! : 'volaticus',
        address: overrides && overrides.hasOwnProperty('address') ? overrides.address! : relationshipsToOmit.has('PartialAddress') ? {} as PartialAddress : aPartialAddress({}, relationshipsToOmit),
    };
};

export const anInternationalPhoneNumberOutput = (overrides?: Partial<InternationalPhoneNumberOutput>, _relationshipsToOmit: Set<string> = new Set()): InternationalPhoneNumberOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InternationalPhoneNumberOutput');
    return {
        number: overrides && overrides.hasOwnProperty('number') ? overrides.number! : 'deprimo',
        country: overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'vos',
    };
};

export const aTag = (overrides?: Partial<Tag>, _relationshipsToOmit: Set<string> = new Set()): Tag => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Tag');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '62b579e5-7c20-4649-8cc9-17a0c192fb11',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-10-19T06:37:39.208Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-09-18T18:18:50.474Z",
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'cruentus',
    };
};

export const aScoutCommunication = (overrides?: Partial<ScoutCommunication>, _relationshipsToOmit: Set<string> = new Set()): ScoutCommunication => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ScoutCommunication');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'c8e523db-c7ed-4052-8606-1377e2591404',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-10-22T00:23:38.038Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2026-02-16T09:15:07.742Z",
        scout: overrides && overrides.hasOwnProperty('scout') ? overrides.scout! : relationshipsToOmit.has('Scout') ? {} as Scout : aScout({}, relationshipsToOmit),
        campaign: overrides && overrides.hasOwnProperty('campaign') ? overrides.campaign! : relationshipsToOmit.has('ScoutCommunication') ? {} as ScoutCommunication : aScoutCommunication({}, relationshipsToOmit),
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : ScoutCommunicationType.Email,
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : 'cultellus',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'defungo',
        purpose: overrides && overrides.hasOwnProperty('purpose') ? overrides.purpose! : ScoutPurpose.SellMembership,
        includeOptedOutOfMarketing: overrides && overrides.hasOwnProperty('includeOptedOutOfMarketing') ? overrides.includeOptedOutOfMarketing! : true,
        trackSource: overrides && overrides.hasOwnProperty('trackSource') ? overrides.trackSource! : ReportingFilterSource.Overall,
        trackSourceId: overrides && overrides.hasOwnProperty('trackSourceId') ? overrides.trackSourceId! : 'necessitatibus',
        trackReleaseId: overrides && overrides.hasOwnProperty('trackReleaseId') ? overrides.trackReleaseId! : 'sonitus',
        scheduledAt: overrides && overrides.hasOwnProperty('scheduledAt') ? overrides.scheduledAt! : "2025-11-30T10:09:38.733Z",
        processedAt: overrides && overrides.hasOwnProperty('processedAt') ? overrides.processedAt! : "2025-05-17T02:01:31.589Z",
        shouldUpdate: overrides && overrides.hasOwnProperty('shouldUpdate') ? overrides.shouldUpdate! : false,
        mailchimpCampaignId: overrides && overrides.hasOwnProperty('mailchimpCampaignId') ? overrides.mailchimpCampaignId! : 'ascit',
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : false,
        message: overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'adfectus',
        listId: overrides && overrides.hasOwnProperty('listId') ? overrides.listId! : 'coepi',
        subject: overrides && overrides.hasOwnProperty('subject') ? overrides.subject! : 'qui',
        templateId: overrides && overrides.hasOwnProperty('templateId') ? overrides.templateId! : 0.1,
        link: overrides && overrides.hasOwnProperty('link') ? overrides.link! : 'desidero',
        count: overrides && overrides.hasOwnProperty('count') ? overrides.count! : 2405,
        conversions: overrides && overrides.hasOwnProperty('conversions') ? overrides.conversions! : 0.3,
    };
};

export const aScout = (overrides?: Partial<Scout>, _relationshipsToOmit: Set<string> = new Set()): Scout => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Scout');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'a8690a18-3881-44bb-849e-72d57807de41',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-06-07T20:19:19.406Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-08-14T06:43:10.702Z",
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'atrocitas',
        purpose: overrides && overrides.hasOwnProperty('purpose') ? overrides.purpose! : ScoutPurpose.SellMembership,
        includeOptedOutOfMarketing: overrides && overrides.hasOwnProperty('includeOptedOutOfMarketing') ? overrides.includeOptedOutOfMarketing! : true,
        promoteTo: overrides && overrides.hasOwnProperty('promoteTo') ? overrides.promoteTo! : [relationshipsToOmit.has('FilterSelection') ? {} as FilterSelection : aFilterSelection({}, relationshipsToOmit)],
        exclude: overrides && overrides.hasOwnProperty('exclude') ? overrides.exclude! : [relationshipsToOmit.has('FilterSelection') ? {} as FilterSelection : aFilterSelection({}, relationshipsToOmit)],
        trackSource: overrides && overrides.hasOwnProperty('trackSource') ? overrides.trackSource! : 'caput',
        trackSourceId: overrides && overrides.hasOwnProperty('trackSourceId') ? overrides.trackSourceId! : 'adduco',
        trackReleaseId: overrides && overrides.hasOwnProperty('trackReleaseId') ? overrides.trackReleaseId! : 'stabilis',
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : false,
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 2.1,
    };
};

export const aFilterSelection = (overrides?: Partial<FilterSelection>, _relationshipsToOmit: Set<string> = new Set()): FilterSelection => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('FilterSelection');
    return {
        userTagIds: overrides && overrides.hasOwnProperty('userTagIds') ? overrides.userTagIds! : ['acerbitas'],
        seasonIds: overrides && overrides.hasOwnProperty('seasonIds') ? overrides.seasonIds! : ['molestiae'],
        eventTypes: overrides && overrides.hasOwnProperty('eventTypes') ? overrides.eventTypes! : [ScoutEventType.Event],
        regions: overrides && overrides.hasOwnProperty('regions') ? overrides.regions! : ['vilicus'],
        membershipTypes: overrides && overrides.hasOwnProperty('membershipTypes') ? overrides.membershipTypes! : ['vomer'],
        eventIds: overrides && overrides.hasOwnProperty('eventIds') ? overrides.eventIds! : ['decor'],
        eventTitlesForWaitlist: overrides && overrides.hasOwnProperty('eventTitlesForWaitlist') ? overrides.eventTitlesForWaitlist! : ['comitatus'],
        totalEventsPurchasedTo: overrides && overrides.hasOwnProperty('totalEventsPurchasedTo') ? overrides.totalEventsPurchasedTo! : 7.7,
        ticketTypeKinds: overrides && overrides.hasOwnProperty('ticketTypeKinds') ? overrides.ticketTypeKinds! : [TicketTypeKind.Standard],
        zones: overrides && overrides.hasOwnProperty('zones') ? overrides.zones! : ['spero'],
        releaseIds: overrides && overrides.hasOwnProperty('releaseIds') ? overrides.releaseIds! : ['accusator'],
        gender: overrides && overrides.hasOwnProperty('gender') ? overrides.gender! : [Gender.Male],
        minAge: overrides && overrides.hasOwnProperty('minAge') ? overrides.minAge! : 2.5,
        maxAge: overrides && overrides.hasOwnProperty('maxAge') ? overrides.maxAge! : 8.3,
    };
};

export const anOrderWhereInput = (overrides?: Partial<OrderWhereInput>, _relationshipsToOmit: Set<string> = new Set()): OrderWhereInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OrderWhereInput');
    return {
        source: overrides && overrides.hasOwnProperty('source') ? overrides.source! : PointReportingFilterSource.Overall,
        sourceId: overrides && overrides.hasOwnProperty('sourceId') ? overrides.sourceId! : 'porro',
        channel: overrides && overrides.hasOwnProperty('channel') ? overrides.channel! : OrderChannel.Online,
        gateway: overrides && overrides.hasOwnProperty('gateway') ? overrides.gateway! : PaymentProvider.Stripe,
        createdById: overrides && overrides.hasOwnProperty('createdById') ? overrides.createdById! : 'arbitro',
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2025-11-27T02:07:22.938Z",
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : "2025-07-15T06:26:54.697Z",
        dates: overrides && overrides.hasOwnProperty('dates') ? overrides.dates! : ["2026-02-21T03:06:47.854Z"],
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : [OrderStatus.Pending],
        refund: overrides && overrides.hasOwnProperty('refund') ? overrides.refund! : true,
        releaseId: overrides && overrides.hasOwnProperty('releaseId') ? overrides.releaseId! : 'templum',
        release: overrides && overrides.hasOwnProperty('release') ? overrides.release! : 'vinum',
        q: overrides && overrides.hasOwnProperty('q') ? overrides.q! : 'infit',
        paymentPlans: overrides && overrides.hasOwnProperty('paymentPlans') ? overrides.paymentPlans! : 'absens',
        orderPlanStatus: overrides && overrides.hasOwnProperty('orderPlanStatus') ? overrides.orderPlanStatus! : 'supra',
    };
};

export const anOrderOrderByInput = (overrides?: Partial<OrderOrderByInput>, _relationshipsToOmit: Set<string> = new Set()): OrderOrderByInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OrderOrderByInput');
    return {
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : OrderByDirection.Asc,
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : OrderByDirection.Asc,
    };
};

export const anOrderConnection = (overrides?: Partial<OrderConnection>, _relationshipsToOmit: Set<string> = new Set()): OrderConnection => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OrderConnection');
    return {
        pageInfo: overrides && overrides.hasOwnProperty('pageInfo') ? overrides.pageInfo! : relationshipsToOmit.has('PageInfo') ? {} as PageInfo : aPageInfo({}, relationshipsToOmit),
        edges: overrides && overrides.hasOwnProperty('edges') ? overrides.edges! : [relationshipsToOmit.has('OrderEdge') ? {} as OrderEdge : anOrderEdge({}, relationshipsToOmit)],
        totalCount: overrides && overrides.hasOwnProperty('totalCount') ? overrides.totalCount! : 2612,
    };
};

export const aPageInfo = (overrides?: Partial<PageInfo>, _relationshipsToOmit: Set<string> = new Set()): PageInfo => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PageInfo');
    return {
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : true,
        hasPreviousPage: overrides && overrides.hasOwnProperty('hasPreviousPage') ? overrides.hasPreviousPage! : false,
        startCursor: overrides && overrides.hasOwnProperty('startCursor') ? overrides.startCursor! : 'tripudio',
        endCursor: overrides && overrides.hasOwnProperty('endCursor') ? overrides.endCursor! : 'tabgo',
    };
};

export const anOrderEdge = (overrides?: Partial<OrderEdge>, _relationshipsToOmit: Set<string> = new Set()): OrderEdge => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OrderEdge');
    return {
        cursor: overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'caries',
        node: overrides && overrides.hasOwnProperty('node') ? overrides.node! : relationshipsToOmit.has('Order') ? {} as Order : anOrder({}, relationshipsToOmit),
    };
};

export const anOrder = (overrides?: Partial<Order>, _relationshipsToOmit: Set<string> = new Set()): Order => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Order');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '81f20cb0-49f6-4ebd-a3b0-f2cc1a2d7d02',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-07-12T17:24:08.980Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2026-03-03T14:55:53.604Z",
        orderType: overrides && overrides.hasOwnProperty('orderType') ? overrides.orderType! : OrderType.Default,
        orderOriginatedFrom: overrides && overrides.hasOwnProperty('orderOriginatedFrom') ? overrides.orderOriginatedFrom! : OrderOriginatedFrom.ExpressCheckout,
        orderNumber: overrides && overrides.hasOwnProperty('orderNumber') ? overrides.orderNumber! : 'denego',
        currency: overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'calamitas',
        derivedStatus: overrides && overrides.hasOwnProperty('derivedStatus') ? overrides.derivedStatus! : DerivedOrderStatus.Pending,
        isHandled: overrides && overrides.hasOwnProperty('isHandled') ? overrides.isHandled! : true,
        isComp: overrides && overrides.hasOwnProperty('isComp') ? overrides.isComp! : true,
        isPrechargeOrder: overrides && overrides.hasOwnProperty('isPrechargeOrder') ? overrides.isPrechargeOrder! : true,
        buyerInformation: overrides && overrides.hasOwnProperty('buyerInformation') ? overrides.buyerInformation! : relationshipsToOmit.has('BuyerInformation') ? {} as BuyerInformation : aBuyerInformation({}, relationshipsToOmit),
        billingAddress: overrides && overrides.hasOwnProperty('billingAddress') ? overrides.billingAddress! : relationshipsToOmit.has('Address') ? {} as Address : anAddress({}, relationshipsToOmit),
        shippingAddress: overrides && overrides.hasOwnProperty('shippingAddress') ? overrides.shippingAddress! : relationshipsToOmit.has('Address') ? {} as Address : anAddress({}, relationshipsToOmit),
        shippingAddressMatchesBillingAddress: overrides && overrides.hasOwnProperty('shippingAddressMatchesBillingAddress') ? overrides.shippingAddressMatchesBillingAddress! : true,
        usableForMarketing: overrides && overrides.hasOwnProperty('usableForMarketing') ? overrides.usableForMarketing! : false,
        membershipSubscriptionId: overrides && overrides.hasOwnProperty('membershipSubscriptionId') ? overrides.membershipSubscriptionId! : 'tenuis',
        release: overrides && overrides.hasOwnProperty('release') ? overrides.release! : relationshipsToOmit.has('Release') ? {} as Release : aRelease({}, relationshipsToOmit),
        releasePassword: overrides && overrides.hasOwnProperty('releasePassword') ? overrides.releasePassword! : relationshipsToOmit.has('ReleasePassword') ? {} as ReleasePassword : aReleasePassword({}, relationshipsToOmit),
        accessCode: overrides && overrides.hasOwnProperty('accessCode') ? overrides.accessCode! : relationshipsToOmit.has('AccessCode') ? {} as AccessCode : anAccessCode({}, relationshipsToOmit),
        paidWithSubscription: overrides && overrides.hasOwnProperty('paidWithSubscription') ? overrides.paidWithSubscription! : false,
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : OrderStatus.Pending,
        channel: overrides && overrides.hasOwnProperty('channel') ? overrides.channel! : OrderChannel.Online,
        paymentGateway: overrides && overrides.hasOwnProperty('paymentGateway') ? overrides.paymentGateway! : PaymentProvider.Stripe,
        transactionStatus: overrides && overrides.hasOwnProperty('transactionStatus') ? overrides.transactionStatus! : OrderTransactionStatus.Waiting,
        orderTicketCover: overrides && overrides.hasOwnProperty('orderTicketCover') ? overrides.orderTicketCover! : relationshipsToOmit.has('OrderTicketCover') ? {} as OrderTicketCover : anOrderTicketCover({}, relationshipsToOmit),
        orderConfirmationSentAt: overrides && overrides.hasOwnProperty('orderConfirmationSentAt') ? overrides.orderConfirmationSentAt! : "2025-07-21T13:32:12.238Z",
        clientIp: overrides && overrides.hasOwnProperty('clientIp') ? overrides.clientIp! : 'aspernatur',
        usedCredits: overrides && overrides.hasOwnProperty('usedCredits') ? overrides.usedCredits! : 8.5,
        usedPoints: overrides && overrides.hasOwnProperty('usedPoints') ? overrides.usedPoints! : 5.8,
        changingSeatsCredits: overrides && overrides.hasOwnProperty('changingSeatsCredits') ? overrides.changingSeatsCredits! : 7.8,
        changingSeatsFee: overrides && overrides.hasOwnProperty('changingSeatsFee') ? overrides.changingSeatsFee! : 0.7,
        bookingFeeType: overrides && overrides.hasOwnProperty('bookingFeeType') ? overrides.bookingFeeType! : FeeType.FlatRate,
        bookingFee: overrides && overrides.hasOwnProperty('bookingFee') ? overrides.bookingFee! : 3,
        bookingFeeAmount: overrides && overrides.hasOwnProperty('bookingFeeAmount') ? overrides.bookingFeeAmount! : 3.5,
        transferFee: overrides && overrides.hasOwnProperty('transferFee') ? overrides.transferFee! : 4.9,
        deliveryMethod: overrides && overrides.hasOwnProperty('deliveryMethod') ? overrides.deliveryMethod! : ShippingOption.Eticket,
        deliveryFee: overrides && overrides.hasOwnProperty('deliveryFee') ? overrides.deliveryFee! : 4.6,
        transactionFeeType: overrides && overrides.hasOwnProperty('transactionFeeType') ? overrides.transactionFeeType! : FeeType.FlatRate,
        transactionFee: overrides && overrides.hasOwnProperty('transactionFee') ? overrides.transactionFee! : 9.6,
        transactionFeeType2: overrides && overrides.hasOwnProperty('transactionFeeType2') ? overrides.transactionFeeType2! : FeeType.FlatRate,
        transactionFee2: overrides && overrides.hasOwnProperty('transactionFee2') ? overrides.transactionFee2! : 3.6,
        transactionFeeAmount: overrides && overrides.hasOwnProperty('transactionFeeAmount') ? overrides.transactionFeeAmount! : 2.9,
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 0.3,
        expiryDate: overrides && overrides.hasOwnProperty('expiryDate') ? overrides.expiryDate! : "2025-07-28T03:52:38.726Z",
        refundedAmount: overrides && overrides.hasOwnProperty('refundedAmount') ? overrides.refundedAmount! : 0.6,
        isCreatedFromRecoveredCart: overrides && overrides.hasOwnProperty('isCreatedFromRecoveredCart') ? overrides.isCreatedFromRecoveredCart! : true,
        taxRate: overrides && overrides.hasOwnProperty('taxRate') ? overrides.taxRate! : 2.6,
        taxCalculationMethod: overrides && overrides.hasOwnProperty('taxCalculationMethod') ? overrides.taxCalculationMethod! : TaxCalculationMethod.Inclusive,
        totalTax: overrides && overrides.hasOwnProperty('totalTax') ? overrides.totalTax! : 4.9,
        subtotal: overrides && overrides.hasOwnProperty('subtotal') ? overrides.subtotal! : 7.4,
        amountDue: overrides && overrides.hasOwnProperty('amountDue') ? overrides.amountDue! : 3.9,
        hardCopyTicketsPrinted: overrides && overrides.hasOwnProperty('hardCopyTicketsPrinted') ? overrides.hardCopyTicketsPrinted! : true,
        heardAboutUs: overrides && overrides.hasOwnProperty('heardAboutUs') ? overrides.heardAboutUs! : HeardAboutUsType.WordOfMouth,
        heardAboutUsDetails: overrides && overrides.hasOwnProperty('heardAboutUsDetails') ? overrides.heardAboutUsDetails! : 'video',
        dietaryRequirements: overrides && overrides.hasOwnProperty('dietaryRequirements') ? overrides.dietaryRequirements! : 'curvo',
        referralId: overrides && overrides.hasOwnProperty('referralId') ? overrides.referralId! : 'demitto',
        referralCode: overrides && overrides.hasOwnProperty('referralCode') ? overrides.referralCode! : relationshipsToOmit.has('ReferralCode') ? {} as ReferralCode : aReferralCode({}, relationshipsToOmit),
        xeroInvoiceId: overrides && overrides.hasOwnProperty('xeroInvoiceId') ? overrides.xeroInvoiceId! : 'vester',
        referralDiscountAmount: overrides && overrides.hasOwnProperty('referralDiscountAmount') ? overrides.referralDiscountAmount! : 0.9,
        compReason: overrides && overrides.hasOwnProperty('compReason') ? overrides.compReason! : 'derideo',
        expiresInSeconds: overrides && overrides.hasOwnProperty('expiresInSeconds') ? overrides.expiresInSeconds! : 8.5,
        tax: overrides && overrides.hasOwnProperty('tax') ? overrides.tax! : relationshipsToOmit.has('OrderTax') ? {} as OrderTax : anOrderTax({}, relationshipsToOmit),
        unusedChangingSeatsCredits: overrides && overrides.hasOwnProperty('unusedChangingSeatsCredits') ? overrides.unusedChangingSeatsCredits! : 2.4,
        customTaxRate: overrides && overrides.hasOwnProperty('customTaxRate') ? overrides.customTaxRate! : 6.4,
        customTaxAmount: overrides && overrides.hasOwnProperty('customTaxAmount') ? overrides.customTaxAmount! : 1,
        orderPlan: overrides && overrides.hasOwnProperty('orderPlan') ? overrides.orderPlan! : relationshipsToOmit.has('OrderPlan') ? {} as OrderPlan : anOrderPlan({}, relationshipsToOmit),
        smsConfirmationAmount: overrides && overrides.hasOwnProperty('smsConfirmationAmount') ? overrides.smsConfirmationAmount! : 4.5,
        event: overrides && overrides.hasOwnProperty('event') ? overrides.event! : relationshipsToOmit.has('Event') ? {} as Event : anEvent({}, relationshipsToOmit),
        gateway: overrides && overrides.hasOwnProperty('gateway') ? overrides.gateway! : relationshipsToOmit.has('PaymentIntegrationOutput') ? {} as PaymentIntegrationOutput : aPaymentIntegrationOutput({}, relationshipsToOmit),
        stripePaymentMethod: overrides && overrides.hasOwnProperty('stripePaymentMethod') ? overrides.stripePaymentMethod! : StripePaymentMethod.CreditCard,
        transactions: overrides && overrides.hasOwnProperty('transactions') ? overrides.transactions! : relationshipsToOmit.has('OrderTransactionConnection') ? {} as OrderTransactionConnection : anOrderTransactionConnection({}, relationshipsToOmit),
        posTransactions: overrides && overrides.hasOwnProperty('posTransactions') ? overrides.posTransactions! : relationshipsToOmit.has('PosTransactionConnection') ? {} as PosTransactionConnection : aPosTransactionConnection({}, relationshipsToOmit),
        lineItems: overrides && overrides.hasOwnProperty('lineItems') ? overrides.lineItems! : relationshipsToOmit.has('LineItemConnection') ? {} as LineItemConnection : aLineItemConnection({}, relationshipsToOmit),
        tickets: overrides && overrides.hasOwnProperty('tickets') ? overrides.tickets! : [relationshipsToOmit.has('Ticket') ? {} as Ticket : aTicket({}, relationshipsToOmit)],
        user: overrides && overrides.hasOwnProperty('user') ? overrides.user! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        createdBy: overrides && overrides.hasOwnProperty('createdBy') ? overrides.createdBy! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        membership: overrides && overrides.hasOwnProperty('membership') ? overrides.membership! : relationshipsToOmit.has('Membership') ? {} as Membership : aMembership({}, relationshipsToOmit),
        pointItem: overrides && overrides.hasOwnProperty('pointItem') ? overrides.pointItem! : relationshipsToOmit.has('PointItem') ? {} as PointItem : aPointItem({}, relationshipsToOmit),
        promoCode: overrides && overrides.hasOwnProperty('promoCode') ? overrides.promoCode! : relationshipsToOmit.has('EventPromoCode') ? {} as EventPromoCode : anEventPromoCode({}, relationshipsToOmit),
        multiBuyPromotion: overrides && overrides.hasOwnProperty('multiBuyPromotion') ? overrides.multiBuyPromotion! : relationshipsToOmit.has('EventMultiBuyPromotion') ? {} as EventMultiBuyPromotion : anEventMultiBuyPromotion({}, relationshipsToOmit),
        history: overrides && overrides.hasOwnProperty('history') ? overrides.history! : relationshipsToOmit.has('HistoryConnection') ? {} as HistoryConnection : aHistoryConnection({}, relationshipsToOmit),
        refunds: overrides && overrides.hasOwnProperty('refunds') ? overrides.refunds! : [relationshipsToOmit.has('Refund') ? {} as Refund : aRefund({}, relationshipsToOmit)],
        refundableState: overrides && overrides.hasOwnProperty('refundableState') ? overrides.refundableState! : relationshipsToOmit.has('RefundableState') ? {} as RefundableState : aRefundableState({}, relationshipsToOmit),
        pos: overrides && overrides.hasOwnProperty('pos') ? overrides.pos! : relationshipsToOmit.has('Pos') ? {} as Pos : aPos({}, relationshipsToOmit),
        point: overrides && overrides.hasOwnProperty('point') ? overrides.point! : relationshipsToOmit.has('Point') ? {} as Point : aPoint({}, relationshipsToOmit),
        defaultGateway: overrides && overrides.hasOwnProperty('defaultGateway') ? overrides.defaultGateway! : relationshipsToOmit.has('Integration') ? {} as Integration : anIntegration({}, relationshipsToOmit),
        stripeTerminalGatewayId: overrides && overrides.hasOwnProperty('stripeTerminalGatewayId') ? overrides.stripeTerminalGatewayId! : 'sopor',
        stripeTerminalGatewayIds: overrides && overrides.hasOwnProperty('stripeTerminalGatewayIds') ? overrides.stripeTerminalGatewayIds! : ['decet'],
        useFallbackRefundFlow: overrides && overrides.hasOwnProperty('useFallbackRefundFlow') ? overrides.useFallbackRefundFlow! : false,
        prechargeOrderScheduledChargeDate: overrides && overrides.hasOwnProperty('prechargeOrderScheduledChargeDate') ? overrides.prechargeOrderScheduledChargeDate! : "2025-09-25T00:06:13.559Z",
        prechargeOrderFailedAt: overrides && overrides.hasOwnProperty('prechargeOrderFailedAt') ? overrides.prechargeOrderFailedAt! : "2025-08-26T22:51:05.835Z",
        prechargeOrderCancellation: overrides && overrides.hasOwnProperty('prechargeOrderCancellation') ? overrides.prechargeOrderCancellation! : relationshipsToOmit.has('PrechargeOrderCancellation') ? {} as PrechargeOrderCancellation : aPrechargeOrderCancellation({}, relationshipsToOmit),
        stripeConfig: overrides && overrides.hasOwnProperty('stripeConfig') ? overrides.stripeConfig! : relationshipsToOmit.has('StripeConfigOutput') ? {} as StripeConfigOutput : aStripeConfigOutput({}, relationshipsToOmit),
    };
};

export const aBuyerInformation = (overrides?: Partial<BuyerInformation>, _relationshipsToOmit: Set<string> = new Set()): BuyerInformation => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BuyerInformation');
    return {
        firstName: overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'civis',
        lastName: overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'ante',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'sui',
        phoneNumber: overrides && overrides.hasOwnProperty('phoneNumber') ? overrides.phoneNumber! : 'sulum',
        city: overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'bardus',
        postalCode: overrides && overrides.hasOwnProperty('postalCode') ? overrides.postalCode! : 'cursus',
        country: overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'molestiae',
        taxNumber: overrides && overrides.hasOwnProperty('taxNumber') ? overrides.taxNumber! : 'delectatio',
        companyName: overrides && overrides.hasOwnProperty('companyName') ? overrides.companyName! : 'antea',
        travelDeals: overrides && overrides.hasOwnProperty('travelDeals') ? overrides.travelDeals! : 'thymbra',
        state: overrides && overrides.hasOwnProperty('state') ? overrides.state! : 'vulticulus',
    };
};

export const aRelease = (overrides?: Partial<Release>, _relationshipsToOmit: Set<string> = new Set()): Release => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Release');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '1bede5f8-eae3-4fca-9604-76037fb0be90',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-03-29T17:34:21.043Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-11-11T21:46:20.962Z",
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'umbra',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : ReleaseType.Listed,
        slug: overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'cunabula',
        password: overrides && overrides.hasOwnProperty('password') ? overrides.password! : 'somniculosus',
        startCondition: overrides && overrides.hasOwnProperty('startCondition') ? overrides.startCondition! : ReleaseStartCondition.Manual,
        startConditionDate: overrides && overrides.hasOwnProperty('startConditionDate') ? overrides.startConditionDate! : "2025-05-28T06:30:32.471Z",
        endCondition: overrides && overrides.hasOwnProperty('endCondition') ? overrides.endCondition! : ReleaseEndCondition.Manual,
        endConditionQuantity: overrides && overrides.hasOwnProperty('endConditionQuantity') ? overrides.endConditionQuantity! : 9.4,
        endConditionDate: overrides && overrides.hasOwnProperty('endConditionDate') ? overrides.endConditionDate! : "2025-11-16T03:30:42.442Z",
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : false,
        presaleTitle: overrides && overrides.hasOwnProperty('presaleTitle') ? overrides.presaleTitle! : 'tenax',
        presaleLogo: overrides && overrides.hasOwnProperty('presaleLogo') ? overrides.presaleLogo! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        presaleHeader: overrides && overrides.hasOwnProperty('presaleHeader') ? overrides.presaleHeader! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        presaleInformation: overrides && overrides.hasOwnProperty('presaleInformation') ? overrides.presaleInformation! : 'subvenio',
        releaseNotes: overrides && overrides.hasOwnProperty('releaseNotes') ? overrides.releaseNotes! : 'varius',
        askHowDidYouHearAboutUs: overrides && overrides.hasOwnProperty('askHowDidYouHearAboutUs') ? overrides.askHowDidYouHearAboutUs! : true,
        askForDietaryRequirements: overrides && overrides.hasOwnProperty('askForDietaryRequirements') ? overrides.askForDietaryRequirements! : true,
        allowPublicComp: overrides && overrides.hasOwnProperty('allowPublicComp') ? overrides.allowPublicComp! : false,
        allowHoldOrders: overrides && overrides.hasOwnProperty('allowHoldOrders') ? overrides.allowHoldOrders! : true,
        allowAccount2Account: overrides && overrides.hasOwnProperty('allowAccount2Account') ? overrides.allowAccount2Account! : false,
        minPurchaseQuantity: overrides && overrides.hasOwnProperty('minPurchaseQuantity') ? overrides.minPurchaseQuantity! : 8004,
        maxPurchaseQuantity: overrides && overrides.hasOwnProperty('maxPurchaseQuantity') ? overrides.maxPurchaseQuantity! : 3882,
        isEnabled: overrides && overrides.hasOwnProperty('isEnabled') ? overrides.isEnabled! : true,
        linkToWaitlist: overrides && overrides.hasOwnProperty('linkToWaitlist') ? overrides.linkToWaitlist! : true,
        allowPrePurchase: overrides && overrides.hasOwnProperty('allowPrePurchase') ? overrides.allowPrePurchase! : false,
        purchaseRestrictions: overrides && overrides.hasOwnProperty('purchaseRestrictions') ? overrides.purchaseRestrictions! : relationshipsToOmit.has('ReleasePurchaseRestriction') ? {} as ReleasePurchaseRestriction : aReleasePurchaseRestriction({}, relationshipsToOmit),
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : relationshipsToOmit.has('ReleaseStatus') ? {} as ReleaseStatus : aReleaseStatus({}, relationshipsToOmit),
        event: overrides && overrides.hasOwnProperty('event') ? overrides.event! : relationshipsToOmit.has('Event') ? {} as Event : anEvent({}, relationshipsToOmit),
        canBeHardDeleted: overrides && overrides.hasOwnProperty('canBeHardDeleted') ? overrides.canBeHardDeleted! : false,
        requiresAuth: overrides && overrides.hasOwnProperty('requiresAuth') ? overrides.requiresAuth! : true,
        releaseZones: overrides && overrides.hasOwnProperty('releaseZones') ? overrides.releaseZones! : [relationshipsToOmit.has('ReleaseZone') ? {} as ReleaseZone : aReleaseZone({}, relationshipsToOmit)],
        releaseEventAddons: overrides && overrides.hasOwnProperty('releaseEventAddons') ? overrides.releaseEventAddons! : [relationshipsToOmit.has('ReleaseEventAddon') ? {} as ReleaseEventAddon : aReleaseEventAddon({}, relationshipsToOmit)],
        isResaleRelease: overrides && overrides.hasOwnProperty('isResaleRelease') ? overrides.isResaleRelease! : false,
        channels: overrides && overrides.hasOwnProperty('channels') ? overrides.channels! : [relationshipsToOmit.has('EventChannelOutput') ? {} as EventChannelOutput : anEventChannelOutput({}, relationshipsToOmit)],
        isPrePurchaseActive: overrides && overrides.hasOwnProperty('isPrePurchaseActive') ? overrides.isPrePurchaseActive! : false,
        showMemberTicketsBanner: overrides && overrides.hasOwnProperty('showMemberTicketsBanner') ? overrides.showMemberTicketsBanner! : true,
    };
};

export const aReleasePurchaseRestriction = (overrides?: Partial<ReleasePurchaseRestriction>, _relationshipsToOmit: Set<string> = new Set()): ReleasePurchaseRestriction => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ReleasePurchaseRestriction');
    return {
        showBanner: overrides && overrides.hasOwnProperty('showBanner') ? overrides.showBanner! : false,
        membershipIds: overrides && overrides.hasOwnProperty('membershipIds') ? overrides.membershipIds! : ['dignissimos'],
    };
};

export const aReleaseStatus = (overrides?: Partial<ReleaseStatus>, _relationshipsToOmit: Set<string> = new Set()): ReleaseStatus => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ReleaseStatus');
    return {
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : ReleaseStatusValue.ReleaseHasEndedDueToDate,
        message: overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'circumvenio',
    };
};

export const anEvent = (overrides?: Partial<Event>, _relationshipsToOmit: Set<string> = new Set()): Event => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Event');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'c54e8bc4-f3ec-4678-b203-2e92de2597e1',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-10-31T02:44:27.959Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-12-13T05:47:30.763Z",
        eventKind: overrides && overrides.hasOwnProperty('eventKind') ? overrides.eventKind! : EventKind.Standard,
        season: overrides && overrides.hasOwnProperty('season') ? overrides.season! : relationshipsToOmit.has('Season') ? {} as Season : aSeason({}, relationshipsToOmit),
        venue: overrides && overrides.hasOwnProperty('venue') ? overrides.venue! : relationshipsToOmit.has('Venue') ? {} as Venue : aVenue({}, relationshipsToOmit),
        intellitixProjectId: overrides && overrides.hasOwnProperty('intellitixProjectId') ? overrides.intellitixProjectId! : 'decor',
        intellitixSourceId: overrides && overrides.hasOwnProperty('intellitixSourceId') ? overrides.intellitixSourceId! : 'depono',
        releases: overrides && overrides.hasOwnProperty('releases') ? overrides.releases! : [relationshipsToOmit.has('Release') ? {} as Release : aRelease({}, relationshipsToOmit)],
        seatsEventKey: overrides && overrides.hasOwnProperty('seatsEventKey') ? overrides.seatsEventKey! : 'conscendo',
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'comminor',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'basium',
        dates: overrides && overrides.hasOwnProperty('dates') ? overrides.dates! : [relationshipsToOmit.has('EventDate') ? {} as EventDate : anEventDate({}, relationshipsToOmit)],
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2025-09-28T07:17:09.722Z",
        showStartTime: overrides && overrides.hasOwnProperty('showStartTime') ? overrides.showStartTime! : false,
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : "2025-10-20T15:07:26.947Z",
        showEndTime: overrides && overrides.hasOwnProperty('showEndTime') ? overrides.showEndTime! : true,
        ticketsViewableFromDate: overrides && overrides.hasOwnProperty('ticketsViewableFromDate') ? overrides.ticketsViewableFromDate! : "2025-10-11T07:18:31.702Z",
        hasEventEnded: overrides && overrides.hasOwnProperty('hasEventEnded') ? overrides.hasEventEnded! : false,
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : true,
        isFeatured: overrides && overrides.hasOwnProperty('isFeatured') ? overrides.isFeatured! : true,
        bookingFeeType: overrides && overrides.hasOwnProperty('bookingFeeType') ? overrides.bookingFeeType! : FeeType.FlatRate,
        bookingFee: overrides && overrides.hasOwnProperty('bookingFee') ? overrides.bookingFee! : 4.1,
        isR18: overrides && overrides.hasOwnProperty('isR18') ? overrides.isR18! : false,
        isDiscoverable: overrides && overrides.hasOwnProperty('isDiscoverable') ? overrides.isDiscoverable! : false,
        isFestival: overrides && overrides.hasOwnProperty('isFestival') ? overrides.isFestival! : true,
        canNameTicket: overrides && overrides.hasOwnProperty('canNameTicket') ? overrides.canNameTicket! : true,
        canRenameTicket: overrides && overrides.hasOwnProperty('canRenameTicket') ? overrides.canRenameTicket! : true,
        enableWaitlist: overrides && overrides.hasOwnProperty('enableWaitlist') ? overrides.enableWaitlist! : true,
        waitlistStartDate: overrides && overrides.hasOwnProperty('waitlistStartDate') ? overrides.waitlistStartDate! : "2025-04-19T17:56:44.330Z",
        waitlistEndDate: overrides && overrides.hasOwnProperty('waitlistEndDate') ? overrides.waitlistEndDate! : "2025-06-08T11:42:35.077Z",
        enableReleaseCodes: overrides && overrides.hasOwnProperty('enableReleaseCodes') ? overrides.enableReleaseCodes! : false,
        canChangeSeats: overrides && overrides.hasOwnProperty('canChangeSeats') ? overrides.canChangeSeats! : true,
        canTransferTicket: overrides && overrides.hasOwnProperty('canTransferTicket') ? overrides.canTransferTicket! : true,
        ticketResaleEnabled: overrides && overrides.hasOwnProperty('ticketResaleEnabled') ? overrides.ticketResaleEnabled! : false,
        ticketResaleWaitlistEnabled: overrides && overrides.hasOwnProperty('ticketResaleWaitlistEnabled') ? overrides.ticketResaleWaitlistEnabled! : true,
        renamingFee: overrides && overrides.hasOwnProperty('renamingFee') ? overrides.renamingFee! : 1.9,
        changingSeatsFee: overrides && overrides.hasOwnProperty('changingSeatsFee') ? overrides.changingSeatsFee! : 1.8,
        sellerTransferringTicketFee: overrides && overrides.hasOwnProperty('sellerTransferringTicketFee') ? overrides.sellerTransferringTicketFee! : 8.7,
        buyerTransferringTicketFee: overrides && overrides.hasOwnProperty('buyerTransferringTicketFee') ? overrides.buyerTransferringTicketFee! : 5.6,
        shippingOptions: overrides && overrides.hasOwnProperty('shippingOptions') ? overrides.shippingOptions! : relationshipsToOmit.has('ShippingOptions') ? {} as ShippingOptions : aShippingOptions({}, relationshipsToOmit),
        thumbnail: overrides && overrides.hasOwnProperty('thumbnail') ? overrides.thumbnail! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        logo: overrides && overrides.hasOwnProperty('logo') ? overrides.logo! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        backgroundImage: overrides && overrides.hasOwnProperty('backgroundImage') ? overrides.backgroundImage! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        backgroundImageFullPage: overrides && overrides.hasOwnProperty('backgroundImageFullPage') ? overrides.backgroundImageFullPage! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        descriptionImage: overrides && overrides.hasOwnProperty('descriptionImage') ? overrides.descriptionImage! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        printBanner1: overrides && overrides.hasOwnProperty('printBanner1') ? overrides.printBanner1! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        printBanner2: overrides && overrides.hasOwnProperty('printBanner2') ? overrides.printBanner2! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        hardCopyTicketBanner: overrides && overrides.hasOwnProperty('hardCopyTicketBanner') ? overrides.hardCopyTicketBanner! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        termsAndConditions: overrides && overrides.hasOwnProperty('termsAndConditions') ? overrides.termsAndConditions! : 'pecco',
        importantNotice: overrides && overrides.hasOwnProperty('importantNotice') ? overrides.importantNotice! : 'desparatus',
        accessibility: overrides && overrides.hasOwnProperty('accessibility') ? overrides.accessibility! : 'conventus',
        presaleInformation: overrides && overrides.hasOwnProperty('presaleInformation') ? overrides.presaleInformation! : 'sumo',
        invoiceInformation: overrides && overrides.hasOwnProperty('invoiceInformation') ? overrides.invoiceInformation! : 'curtus',
        zonesAllocatedGates: overrides && overrides.hasOwnProperty('zonesAllocatedGates') ? overrides.zonesAllocatedGates! : [relationshipsToOmit.has('ZoneAllocatedGate') ? {} as ZoneAllocatedGate : aZoneAllocatedGate({}, relationshipsToOmit)],
        insideFeeDetails: overrides && overrides.hasOwnProperty('insideFeeDetails') ? overrides.insideFeeDetails! : [relationshipsToOmit.has('InsideFeeDetails') ? {} as InsideFeeDetails : anInsideFeeDetails({}, relationshipsToOmit)],
        checkForVaccinePass: overrides && overrides.hasOwnProperty('checkForVaccinePass') ? overrides.checkForVaccinePass! : true,
        emailNotification: overrides && overrides.hasOwnProperty('emailNotification') ? overrides.emailNotification! : 'varius',
        redirectURL: overrides && overrides.hasOwnProperty('redirectURL') ? overrides.redirectURL! : 'vesica',
        referralCampaignId: overrides && overrides.hasOwnProperty('referralCampaignId') ? overrides.referralCampaignId! : 'accusantium',
        canUsePoints: overrides && overrides.hasOwnProperty('canUsePoints') ? overrides.canUsePoints! : false,
        googleWalletEventClassId: overrides && overrides.hasOwnProperty('googleWalletEventClassId') ? overrides.googleWalletEventClassId! : 'damno',
        lastTicketsViewableEmailsSentAt: overrides && overrides.hasOwnProperty('lastTicketsViewableEmailsSentAt') ? overrides.lastTicketsViewableEmailsSentAt! : "2025-07-26T01:36:40.059Z",
        ticketCover: overrides && overrides.hasOwnProperty('ticketCover') ? overrides.ticketCover! : relationshipsToOmit.has('EventTicketCover') ? {} as EventTicketCover : anEventTicketCover({}, relationshipsToOmit),
        seoMetadata: overrides && overrides.hasOwnProperty('seoMetadata') ? overrides.seoMetadata! : relationshipsToOmit.has('SeoMetadata') ? {} as SeoMetadata : aSeoMetadata({}, relationshipsToOmit),
        paymentPlanSettings: overrides && overrides.hasOwnProperty('paymentPlanSettings') ? overrides.paymentPlanSettings! : relationshipsToOmit.has('PaymentPlanSettings') ? {} as PaymentPlanSettings : aPaymentPlanSettings({}, relationshipsToOmit),
        pixelId: overrides && overrides.hasOwnProperty('pixelId') ? overrides.pixelId! : 'eaque',
        multiScanningEnabled: overrides && overrides.hasOwnProperty('multiScanningEnabled') ? overrides.multiScanningEnabled! : true,
        ticketEntryTimeEnforcement: overrides && overrides.hasOwnProperty('ticketEntryTimeEnforcement') ? overrides.ticketEntryTimeEnforcement! : relationshipsToOmit.has('TicketEntryTimeEnforcementOptions') ? {} as TicketEntryTimeEnforcementOptions : aTicketEntryTimeEnforcementOptions({}, relationshipsToOmit),
        hiddenFromPublic: overrides && overrides.hasOwnProperty('hiddenFromPublic') ? overrides.hiddenFromPublic! : false,
        tax: overrides && overrides.hasOwnProperty('tax') ? overrides.tax! : [relationshipsToOmit.has('Tax') ? {} as Tax : aTax({}, relationshipsToOmit)],
        merchantReferenceResult: overrides && overrides.hasOwnProperty('merchantReferenceResult') ? overrides.merchantReferenceResult! : 'valeo',
        seatSelectionFilterOverrides: overrides && overrides.hasOwnProperty('seatSelectionFilterOverrides') ? overrides.seatSelectionFilterOverrides! : relationshipsToOmit.has('SeatSelectionFilters') ? {} as SeatSelectionFilters : aSeatSelectionFilters({}, relationshipsToOmit),
        hasPublicRelease: overrides && overrides.hasOwnProperty('hasPublicRelease') ? overrides.hasPublicRelease! : true,
        venueAddress: overrides && overrides.hasOwnProperty('venueAddress') ? overrides.venueAddress! : relationshipsToOmit.has('Venue') ? {} as Venue : aVenue({}, relationshipsToOmit),
        ticketTypes: overrides && overrides.hasOwnProperty('ticketTypes') ? overrides.ticketTypes! : [relationshipsToOmit.has('TicketType') ? {} as TicketType : aTicketType({}, relationshipsToOmit)],
        gateways: overrides && overrides.hasOwnProperty('gateways') ? overrides.gateways! : [relationshipsToOmit.has('Integration') ? {} as Integration : anIntegration({}, relationshipsToOmit)],
        addons: overrides && overrides.hasOwnProperty('addons') ? overrides.addons! : [relationshipsToOmit.has('EventAddon') ? {} as EventAddon : anEventAddon({}, relationshipsToOmit)],
        soldTicketsCount: overrides && overrides.hasOwnProperty('soldTicketsCount') ? overrides.soldTicketsCount! : 7.8,
        soldTicketsCountToday: overrides && overrides.hasOwnProperty('soldTicketsCountToday') ? overrides.soldTicketsCountToday! : 4.7,
        soldTicketsCountYesterday: overrides && overrides.hasOwnProperty('soldTicketsCountYesterday') ? overrides.soldTicketsCountYesterday! : 8.8,
        totalRevenue: overrides && overrides.hasOwnProperty('totalRevenue') ? overrides.totalRevenue! : 1.5,
        totalFaceValue: overrides && overrides.hasOwnProperty('totalFaceValue') ? overrides.totalFaceValue! : 8.5,
        multiBuyPromotions: overrides && overrides.hasOwnProperty('multiBuyPromotions') ? overrides.multiBuyPromotions! : [relationshipsToOmit.has('EventMultiBuyPromotion') ? {} as EventMultiBuyPromotion : anEventMultiBuyPromotion({}, relationshipsToOmit)],
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : [relationshipsToOmit.has('Tag') ? {} as Tag : aTag({}, relationshipsToOmit)],
        digitalPassCodesStatus: overrides && overrides.hasOwnProperty('digitalPassCodesStatus') ? overrides.digitalPassCodesStatus! : relationshipsToOmit.has('DigitalPassCodeStatusOutput') ? {} as DigitalPassCodeStatusOutput : aDigitalPassCodeStatusOutput({}, relationshipsToOmit),
        digitalInfo: overrides && overrides.hasOwnProperty('digitalInfo') ? overrides.digitalInfo! : relationshipsToOmit.has('DigitalInfo') ? {} as DigitalInfo : aDigitalInfo({}, relationshipsToOmit),
        defaultDateRange: overrides && overrides.hasOwnProperty('defaultDateRange') ? overrides.defaultDateRange! : relationshipsToOmit.has('DefaultDateRange') ? {} as DefaultDateRange : aDefaultDateRange({}, relationshipsToOmit),
        hasPromoCodes: overrides && overrides.hasOwnProperty('hasPromoCodes') ? overrides.hasPromoCodes! : false,
        isWaitlistAvailable: overrides && overrides.hasOwnProperty('isWaitlistAvailable') ? overrides.isWaitlistAvailable! : true,
        presaleRelease: overrides && overrides.hasOwnProperty('presaleRelease') ? overrides.presaleRelease! : relationshipsToOmit.has('Release') ? {} as Release : aRelease({}, relationshipsToOmit),
        publicReleaseStartsAt: overrides && overrides.hasOwnProperty('publicReleaseStartsAt') ? overrides.publicReleaseStartsAt! : "2025-08-16T22:23:20.627Z",
        listedRelease: overrides && overrides.hasOwnProperty('listedRelease') ? overrides.listedRelease! : relationshipsToOmit.has('Release') ? {} as Release : aRelease({}, relationshipsToOmit),
        artists: overrides && overrides.hasOwnProperty('artists') ? overrides.artists! : [relationshipsToOmit.has('Artist') ? {} as Artist : anArtist({}, relationshipsToOmit)],
        ticketsIssued: overrides && overrides.hasOwnProperty('ticketsIssued') ? overrides.ticketsIssued! : 1223,
        capacity: overrides && overrides.hasOwnProperty('capacity') ? overrides.capacity! : 5896,
        totalTicketsFaceValue: overrides && overrides.hasOwnProperty('totalTicketsFaceValue') ? overrides.totalTicketsFaceValue! : 6.6,
        taxRate: overrides && overrides.hasOwnProperty('taxRate') ? overrides.taxRate! : 3.3,
        customTaxRate: overrides && overrides.hasOwnProperty('customTaxRate') ? overrides.customTaxRate! : 0.7,
        taxCalculationMethod: overrides && overrides.hasOwnProperty('taxCalculationMethod') ? overrides.taxCalculationMethod! : TaxCalculationMethod.Inclusive,
        customFields: overrides && overrides.hasOwnProperty('customFields') ? overrides.customFields! : [relationshipsToOmit.has('CustomFieldOuput') ? {} as CustomFieldOuput : aCustomFieldOuput({}, relationshipsToOmit)],
        fees: overrides && overrides.hasOwnProperty('fees') ? overrides.fees! : relationshipsToOmit.has('OrderFee') ? {} as OrderFee : anOrderFee({}, relationshipsToOmit),
        canUpgrade: overrides && overrides.hasOwnProperty('canUpgrade') ? overrides.canUpgrade! : false,
        seekaConfig: overrides && overrides.hasOwnProperty('seekaConfig') ? overrides.seekaConfig! : relationshipsToOmit.has('SeekaOutput') ? {} as SeekaOutput : aSeekaOutput({}, relationshipsToOmit),
        effectiveSeatFilters: overrides && overrides.hasOwnProperty('effectiveSeatFilters') ? overrides.effectiveSeatFilters! : relationshipsToOmit.has('SeatSelectionFilters') ? {} as SeatSelectionFilters : aSeatSelectionFilters({}, relationshipsToOmit),
        prePurchaseAvailableStatus: overrides && overrides.hasOwnProperty('prePurchaseAvailableStatus') ? overrides.prePurchaseAvailableStatus! : PrePurchaseAvailableStatus.Available,
        hasPrePurchasePresale: overrides && overrides.hasOwnProperty('hasPrePurchasePresale') ? overrides.hasPrePurchasePresale! : true,
        seatsIoConfig: overrides && overrides.hasOwnProperty('seatsIoConfig') ? overrides.seatsIoConfig! : relationshipsToOmit.has('SeatsIoConfigOutput') ? {} as SeatsIoConfigOutput : aSeatsIoConfigOutput({}, relationshipsToOmit),
        stripeConfig: overrides && overrides.hasOwnProperty('stripeConfig') ? overrides.stripeConfig! : relationshipsToOmit.has('StripeConfigOutput') ? {} as StripeConfigOutput : aStripeConfigOutput({}, relationshipsToOmit),
        userRestrictedReleases: overrides && overrides.hasOwnProperty('userRestrictedReleases') ? overrides.userRestrictedReleases! : [relationshipsToOmit.has('RestrictedRelease') ? {} as RestrictedRelease : aRestrictedRelease({}, relationshipsToOmit)],
    };
};

export const aSeason = (overrides?: Partial<Season>, _relationshipsToOmit: Set<string> = new Set()): Season => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Season');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '22634162-41bd-47b2-9003-2f0b1d92c3f4',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2026-01-28T22:17:35.927Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-08-22T17:59:56.329Z",
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'adficio',
        events: overrides && overrides.hasOwnProperty('events') ? overrides.events! : [relationshipsToOmit.has('Event') ? {} as Event : anEvent({}, relationshipsToOmit)],
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : false,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'demoror',
        thumbnail: overrides && overrides.hasOwnProperty('thumbnail') ? overrides.thumbnail! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        backgroundImageFullPage: overrides && overrides.hasOwnProperty('backgroundImageFullPage') ? overrides.backgroundImageFullPage! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        landingBanner: overrides && overrides.hasOwnProperty('landingBanner') ? overrides.landingBanner! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        landingDescription: overrides && overrides.hasOwnProperty('landingDescription') ? overrides.landingDescription! : 'approbo',
        displayOrder: overrides && overrides.hasOwnProperty('displayOrder') ? overrides.displayOrder! : 1536,
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2025-11-13T05:29:32.071Z",
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : "2026-01-26T04:05:28.498Z",
        defaultDateRange: overrides && overrides.hasOwnProperty('defaultDateRange') ? overrides.defaultDateRange! : relationshipsToOmit.has('DateRange') ? {} as DateRange : aDateRange({}, relationshipsToOmit),
    };
};

export const aSeasonOnsaleDateRangeInput = (overrides?: Partial<SeasonOnsaleDateRangeInput>, _relationshipsToOmit: Set<string> = new Set()): SeasonOnsaleDateRangeInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SeasonOnsaleDateRangeInput');
    return {
        source: overrides && overrides.hasOwnProperty('source') ? overrides.source! : ReportingFinancialSalesBreakdownSource.Membership,
    };
};

export const aDateRange = (overrides?: Partial<DateRange>, _relationshipsToOmit: Set<string> = new Set()): DateRange => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DateRange');
    return {
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2025-03-19T16:59:01.302Z",
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : "2025-09-13T16:31:32.509Z",
    };
};

export const aVenue = (overrides?: Partial<Venue>, _relationshipsToOmit: Set<string> = new Set()): Venue => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Venue');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '227f3da1-d7c8-4e61-aea4-b261e0eca912',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-06-02T08:31:07.671Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-03-07T02:13:28.491Z",
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'alienus',
        seatsChartKey: overrides && overrides.hasOwnProperty('seatsChartKey') ? overrides.seatsChartKey! : 'accusator',
        zones: overrides && overrides.hasOwnProperty('zones') ? overrides.zones! : [relationshipsToOmit.has('Zone') ? {} as Zone : aZone({}, relationshipsToOmit)],
        address: overrides && overrides.hasOwnProperty('address') ? overrides.address! : relationshipsToOmit.has('Address') ? {} as Address : anAddress({}, relationshipsToOmit),
        seating: overrides && overrides.hasOwnProperty('seating') ? overrides.seating! : VenueSeating.Seated,
        capacity: overrides && overrides.hasOwnProperty('capacity') ? overrides.capacity! : 4772,
        capacityUtilization: overrides && overrides.hasOwnProperty('capacityUtilization') ? overrides.capacityUtilization! : 5.6,
        accessibilityInfo: overrides && overrides.hasOwnProperty('accessibilityInfo') ? overrides.accessibilityInfo! : 'cohors',
        location: overrides && overrides.hasOwnProperty('location') ? overrides.location! : relationshipsToOmit.has('Coordinate') ? {} as Coordinate : aCoordinate({}, relationshipsToOmit),
        gates: overrides && overrides.hasOwnProperty('gates') ? overrides.gates! : [relationshipsToOmit.has('Gate') ? {} as Gate : aGate({}, relationshipsToOmit)],
        trackHardCopyTickets: overrides && overrides.hasOwnProperty('trackHardCopyTickets') ? overrides.trackHardCopyTickets! : false,
        hasStadiumLevy: overrides && overrides.hasOwnProperty('hasStadiumLevy') ? overrides.hasStadiumLevy! : true,
        timezone: overrides && overrides.hasOwnProperty('timezone') ? overrides.timezone! : 'Pacific/Auckland',
        locale: overrides && overrides.hasOwnProperty('locale') ? overrides.locale! : 'en',
        filterOptions: overrides && overrides.hasOwnProperty('filterOptions') ? overrides.filterOptions! : ['cauda'],
        createdFromEvent: overrides && overrides.hasOwnProperty('createdFromEvent') ? overrides.createdFromEvent! : false,
        defaultSeatSelectionFilters: overrides && overrides.hasOwnProperty('defaultSeatSelectionFilters') ? overrides.defaultSeatSelectionFilters! : relationshipsToOmit.has('SeatSelectionFilters') ? {} as SeatSelectionFilters : aSeatSelectionFilters({}, relationshipsToOmit),
    };
};

export const aZone = (overrides?: Partial<Zone>, _relationshipsToOmit: Set<string> = new Set()): Zone => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Zone');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '48a895f4-53d5-443a-813f-53d6e3c9f82e',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-05-01T21:31:55.567Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-12-06T19:21:29.974Z",
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'cubicularis',
        capacity: overrides && overrides.hasOwnProperty('capacity') ? overrides.capacity! : 7454,
        sections: overrides && overrides.hasOwnProperty('sections') ? overrides.sections! : [relationshipsToOmit.has('Section') ? {} as Section : aSection({}, relationshipsToOmit)],
        stand: overrides && overrides.hasOwnProperty('stand') ? overrides.stand! : 'depereo',
        seated: overrides && overrides.hasOwnProperty('seated') ? overrides.seated! : false,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'volup',
        imageGallery: overrides && overrides.hasOwnProperty('imageGallery') ? overrides.imageGallery! : [relationshipsToOmit.has('ImageGalleryItem') ? {} as ImageGalleryItem : anImageGalleryItem({}, relationshipsToOmit)],
        displayOrder: overrides && overrides.hasOwnProperty('displayOrder') ? overrides.displayOrder! : 1296,
        admission: overrides && overrides.hasOwnProperty('admission') ? overrides.admission! : true,
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : true,
    };
};

export const aSection = (overrides?: Partial<Section>, _relationshipsToOmit: Set<string> = new Set()): Section => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Section');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'a244defc-cc03-42a2-a476-2c307bcf89b9',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-08-08T11:28:36.523Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2026-01-28T22:56:04.974Z",
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'vorago',
        seatsIoKey: overrides && overrides.hasOwnProperty('seatsIoKey') ? overrides.seatsIoKey! : 2383,
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : false,
    };
};

export const anImageGalleryItem = (overrides?: Partial<ImageGalleryItem>, _relationshipsToOmit: Set<string> = new Set()): ImageGalleryItem => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ImageGalleryItem');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'villa',
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'pauci',
        original: overrides && overrides.hasOwnProperty('original') ? overrides.original! : relationshipsToOmit.has('GalleryImage') ? {} as GalleryImage : aGalleryImage({}, relationshipsToOmit),
        cropped: overrides && overrides.hasOwnProperty('cropped') ? overrides.cropped! : relationshipsToOmit.has('GalleryImage') ? {} as GalleryImage : aGalleryImage({}, relationshipsToOmit),
    };
};

export const aGalleryImage = (overrides?: Partial<GalleryImage>, _relationshipsToOmit: Set<string> = new Set()): GalleryImage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('GalleryImage');
    return {
        src: overrides && overrides.hasOwnProperty('src') ? overrides.src! : 'autus',
        metaData: overrides && overrides.hasOwnProperty('metaData') ? overrides.metaData! : relationshipsToOmit.has('MetaData') ? {} as MetaData : aMetaData({}, relationshipsToOmit),
        aspectRatio: overrides && overrides.hasOwnProperty('aspectRatio') ? overrides.aspectRatio! : 10,
    };
};

export const aCoordinate = (overrides?: Partial<Coordinate>, _relationshipsToOmit: Set<string> = new Set()): Coordinate => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Coordinate');
    return {
        lat: overrides && overrides.hasOwnProperty('lat') ? overrides.lat! : 4.6,
        lng: overrides && overrides.hasOwnProperty('lng') ? overrides.lng! : 6.8,
    };
};

export const aGate = (overrides?: Partial<Gate>, _relationshipsToOmit: Set<string> = new Set()): Gate => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Gate');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'f0329452-5040-4a5c-ade1-e5899dff4e77',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-08-05T14:29:45.345Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2026-01-08T22:58:51.835Z",
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'synagoga',
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : true,
    };
};

export const aSeatSelectionFilters = (overrides?: Partial<SeatSelectionFilters>, _relationshipsToOmit: Set<string> = new Set()): SeatSelectionFilters => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SeatSelectionFilters');
    return {
        seatQuantity: overrides && overrides.hasOwnProperty('seatQuantity') ? overrides.seatQuantity! : 8727,
        sortType: overrides && overrides.hasOwnProperty('sortType') ? overrides.sortType! : 'acidus',
        selectType: overrides && overrides.hasOwnProperty('selectType') ? overrides.selectType! : 'calamitas',
    };
};

export const anEventDate = (overrides?: Partial<EventDate>, _relationshipsToOmit: Set<string> = new Set()): EventDate => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EventDate');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '5839240a-fd05-471d-a995-ad25f91ee66d',
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : 'correptius',
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : 'sui',
        doorsOpen: overrides && overrides.hasOwnProperty('doorsOpen') ? overrides.doorsOpen! : 'ceno',
    };
};

export const aShippingOptions = (overrides?: Partial<ShippingOptions>, _relationshipsToOmit: Set<string> = new Set()): ShippingOptions => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ShippingOptions');
    return {
        eTicket: overrides && overrides.hasOwnProperty('eTicket') ? overrides.eTicket! : 5.8,
        printedTicketByMail: overrides && overrides.hasOwnProperty('printedTicketByMail') ? overrides.printedTicketByMail! : 4.8,
        printedTicketByCourier: overrides && overrides.hasOwnProperty('printedTicketByCourier') ? overrides.printedTicketByCourier! : 7.1,
        printedTicketByCourierRural: overrides && overrides.hasOwnProperty('printedTicketByCourierRural') ? overrides.printedTicketByCourierRural! : 5.5,
        printedTicketAtVenue: overrides && overrides.hasOwnProperty('printedTicketAtVenue') ? overrides.printedTicketAtVenue! : 5.6,
    };
};

export const aZoneAllocatedGate = (overrides?: Partial<ZoneAllocatedGate>, _relationshipsToOmit: Set<string> = new Set()): ZoneAllocatedGate => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ZoneAllocatedGate');
    return {
        zoneId: overrides && overrides.hasOwnProperty('zoneId') ? overrides.zoneId! : 'libero',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'assentator',
        gates: overrides && overrides.hasOwnProperty('gates') ? overrides.gates! : ['tendo'],
        sections: overrides && overrides.hasOwnProperty('sections') ? overrides.sections! : [relationshipsToOmit.has('ZoneAllocatedGateSection') ? {} as ZoneAllocatedGateSection : aZoneAllocatedGateSection({}, relationshipsToOmit)],
        availabilityCount: overrides && overrides.hasOwnProperty('availabilityCount') ? overrides.availabilityCount! : relationshipsToOmit.has('ZoneAllocationAvailability') ? {} as ZoneAllocationAvailability : aZoneAllocationAvailability({}, relationshipsToOmit),
        dates: overrides && overrides.hasOwnProperty('dates') ? overrides.dates! : [relationshipsToOmit.has('ZoneAllocatedDate') ? {} as ZoneAllocatedDate : aZoneAllocatedDate({}, relationshipsToOmit)],
    };
};

export const aZoneAllocatedGateSection = (overrides?: Partial<ZoneAllocatedGateSection>, _relationshipsToOmit: Set<string> = new Set()): ZoneAllocatedGateSection => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ZoneAllocatedGateSection');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'currus',
        sectionId: overrides && overrides.hasOwnProperty('sectionId') ? overrides.sectionId! : 'cunae',
        gates: overrides && overrides.hasOwnProperty('gates') ? overrides.gates! : ['corroboro'],
    };
};

export const aZoneAllocationAvailability = (overrides?: Partial<ZoneAllocationAvailability>, _relationshipsToOmit: Set<string> = new Set()): ZoneAllocationAvailability => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ZoneAllocationAvailability');
    return {
        notForSale: overrides && overrides.hasOwnProperty('notForSale') ? overrides.notForSale! : 2.9,
        holdByMembership: overrides && overrides.hasOwnProperty('holdByMembership') ? overrides.holdByMembership! : 9.8,
        booked: overrides && overrides.hasOwnProperty('booked') ? overrides.booked! : 8.6,
        available: overrides && overrides.hasOwnProperty('available') ? overrides.available! : 1.5,
    };
};

export const aZoneAllocatedDate = (overrides?: Partial<ZoneAllocatedDate>, _relationshipsToOmit: Set<string> = new Set()): ZoneAllocatedDate => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ZoneAllocatedDate');
    return {
        eventDateId: overrides && overrides.hasOwnProperty('eventDateId') ? overrides.eventDateId! : '61af9fd3-5386-4d82-8479-a20c0eaaff49',
        alternateEntryTime: overrides && overrides.hasOwnProperty('alternateEntryTime') ? overrides.alternateEntryTime! : 'cornu',
    };
};

export const anInsideFeeDetails = (overrides?: Partial<InsideFeeDetails>, _relationshipsToOmit: Set<string> = new Set()): InsideFeeDetails => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InsideFeeDetails');
    return {
        priceRangeFrom: overrides && overrides.hasOwnProperty('priceRangeFrom') ? overrides.priceRangeFrom! : 2.5,
        priceRangeTo: overrides && overrides.hasOwnProperty('priceRangeTo') ? overrides.priceRangeTo! : 2.1,
        insideFee: overrides && overrides.hasOwnProperty('insideFee') ? overrides.insideFee! : 1.6,
    };
};

export const anEventTicketCover = (overrides?: Partial<EventTicketCover>, _relationshipsToOmit: Set<string> = new Set()): EventTicketCover => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EventTicketCover');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '6dad19b0-5730-4970-af03-431b28570189',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-08-23T17:07:27.300Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2026-02-24T12:24:14.085Z",
        event: overrides && overrides.hasOwnProperty('event') ? overrides.event! : relationshipsToOmit.has('Event') ? {} as Event : anEvent({}, relationshipsToOmit),
        enabledAt: overrides && overrides.hasOwnProperty('enabledAt') ? overrides.enabledAt! : "2025-06-12T21:09:16.981Z",
        disabledAt: overrides && overrides.hasOwnProperty('disabledAt') ? overrides.disabledAt! : "2025-12-07T22:44:07.642Z",
        promoterFeePercentage: overrides && overrides.hasOwnProperty('promoterFeePercentage') ? overrides.promoterFeePercentage! : 4.8,
        platformFeePercentage: overrides && overrides.hasOwnProperty('platformFeePercentage') ? overrides.platformFeePercentage! : 10,
        purchaseBehaviour: overrides && overrides.hasOwnProperty('purchaseBehaviour') ? overrides.purchaseBehaviour! : TicketCoverPurchaseBehaviour.Optional,
        totalFeePercentage: overrides && overrides.hasOwnProperty('totalFeePercentage') ? overrides.totalFeePercentage! : 8.3,
        isEnabled: overrides && overrides.hasOwnProperty('isEnabled') ? overrides.isEnabled! : true,
    };
};

export const aSeoMetadata = (overrides?: Partial<SeoMetadata>, _relationshipsToOmit: Set<string> = new Set()): SeoMetadata => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SeoMetadata');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'cf15d1be-e7b6-4447-9a2a-9554ecfcbdc2',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-09-06T16:17:06.621Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-07-29T09:09:11.428Z",
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'cattus',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'virga',
        keywords: overrides && overrides.hasOwnProperty('keywords') ? overrides.keywords! : ['combibo'],
        openGraphImageUrl: overrides && overrides.hasOwnProperty('openGraphImageUrl') ? overrides.openGraphImageUrl! : 'arbustum',
        origin: overrides && overrides.hasOwnProperty('origin') ? overrides.origin! : SeoMetadataOrigin.UserDefined,
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'aggredior',
        event: overrides && overrides.hasOwnProperty('event') ? overrides.event! : relationshipsToOmit.has('Event') ? {} as Event : anEvent({}, relationshipsToOmit),
        membershipId: overrides && overrides.hasOwnProperty('membershipId') ? overrides.membershipId! : 'nesciunt',
        membership: overrides && overrides.hasOwnProperty('membership') ? overrides.membership! : relationshipsToOmit.has('Membership') ? {} as Membership : aMembership({}, relationshipsToOmit),
    };
};

export const aMembership = (overrides?: Partial<Membership>, _relationshipsToOmit: Set<string> = new Set()): Membership => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Membership');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'd1cf97ad-7d87-42d6-b425-4b9f4f998b49',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-11-16T06:17:51.009Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-12-01T02:27:49.302Z",
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'venia',
        membershipKind: overrides && overrides.hasOwnProperty('membershipKind') ? overrides.membershipKind! : MembershipKind.Standard,
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2026-01-22T09:08:06.343Z",
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : "2026-02-03T19:01:03.834Z",
        bookingFeeType: overrides && overrides.hasOwnProperty('bookingFeeType') ? overrides.bookingFeeType! : FeeType.FlatRate,
        bookingFee: overrides && overrides.hasOwnProperty('bookingFee') ? overrides.bookingFee! : 0.2,
        shippingOptions: overrides && overrides.hasOwnProperty('shippingOptions') ? overrides.shippingOptions! : relationshipsToOmit.has('ShippingOptions') ? {} as ShippingOptions : aShippingOptions({}, relationshipsToOmit),
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'sordeo',
        thumbnail: overrides && overrides.hasOwnProperty('thumbnail') ? overrides.thumbnail! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        backgroundImage: overrides && overrides.hasOwnProperty('backgroundImage') ? overrides.backgroundImage! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        descriptionImage: overrides && overrides.hasOwnProperty('descriptionImage') ? overrides.descriptionImage! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        banner: overrides && overrides.hasOwnProperty('banner') ? overrides.banner! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        printBanner1: overrides && overrides.hasOwnProperty('printBanner1') ? overrides.printBanner1! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        printBanner2: overrides && overrides.hasOwnProperty('printBanner2') ? overrides.printBanner2! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        gateways: overrides && overrides.hasOwnProperty('gateways') ? overrides.gateways! : [relationshipsToOmit.has('Integration') ? {} as Integration : anIntegration({}, relationshipsToOmit)],
        canNameMembership: overrides && overrides.hasOwnProperty('canNameMembership') ? overrides.canNameMembership! : true,
        canRenameMembership: overrides && overrides.hasOwnProperty('canRenameMembership') ? overrides.canRenameMembership! : false,
        canChangeSeats: overrides && overrides.hasOwnProperty('canChangeSeats') ? overrides.canChangeSeats! : false,
        renamingFee: overrides && overrides.hasOwnProperty('renamingFee') ? overrides.renamingFee! : 5,
        changingSeatsFee: overrides && overrides.hasOwnProperty('changingSeatsFee') ? overrides.changingSeatsFee! : 2.8,
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : false,
        isTicketed: overrides && overrides.hasOwnProperty('isTicketed') ? overrides.isTicketed! : false,
        events: overrides && overrides.hasOwnProperty('events') ? overrides.events! : [relationshipsToOmit.has('Event') ? {} as Event : anEvent({}, relationshipsToOmit)],
        membershipZones: overrides && overrides.hasOwnProperty('membershipZones') ? overrides.membershipZones! : [relationshipsToOmit.has('MembershipZone') ? {} as MembershipZone : aMembershipZone({}, relationshipsToOmit)],
        termsAndConditions: overrides && overrides.hasOwnProperty('termsAndConditions') ? overrides.termsAndConditions! : 'peccatus',
        importantNotice: overrides && overrides.hasOwnProperty('importantNotice') ? overrides.importantNotice! : 'corrupti',
        accessibility: overrides && overrides.hasOwnProperty('accessibility') ? overrides.accessibility! : 'crastinus',
        invoiceInformation: overrides && overrides.hasOwnProperty('invoiceInformation') ? overrides.invoiceInformation! : 'virtus',
        showSchedule: overrides && overrides.hasOwnProperty('showSchedule') ? overrides.showSchedule! : false,
        referralCampaignId: overrides && overrides.hasOwnProperty('referralCampaignId') ? overrides.referralCampaignId! : 'suus',
        emailNotification: overrides && overrides.hasOwnProperty('emailNotification') ? overrides.emailNotification! : 'cultura',
        hiddenFromPublic: overrides && overrides.hasOwnProperty('hiddenFromPublic') ? overrides.hiddenFromPublic! : true,
        issueCreditOnSale: overrides && overrides.hasOwnProperty('issueCreditOnSale') ? overrides.issueCreditOnSale! : true,
        canUsePoints: overrides && overrides.hasOwnProperty('canUsePoints') ? overrides.canUsePoints! : false,
        enableAutoRenew: overrides && overrides.hasOwnProperty('enableAutoRenew') ? overrides.enableAutoRenew! : true,
        canTransferTickets: overrides && overrides.hasOwnProperty('canTransferTickets') ? overrides.canTransferTickets! : true,
        paymentPlanSettings: overrides && overrides.hasOwnProperty('paymentPlanSettings') ? overrides.paymentPlanSettings! : relationshipsToOmit.has('PaymentPlanSettings') ? {} as PaymentPlanSettings : aPaymentPlanSettings({}, relationshipsToOmit),
        ticketCover: overrides && overrides.hasOwnProperty('ticketCover') ? overrides.ticketCover! : relationshipsToOmit.has('MembershipTicketCover') ? {} as MembershipTicketCover : aMembershipTicketCover({}, relationshipsToOmit),
        googleWalletEventClassId: overrides && overrides.hasOwnProperty('googleWalletEventClassId') ? overrides.googleWalletEventClassId! : 'vinitor',
        releasedRenewalHolds: overrides && overrides.hasOwnProperty('releasedRenewalHolds') ? overrides.releasedRenewalHolds! : false,
        seoMetadata: overrides && overrides.hasOwnProperty('seoMetadata') ? overrides.seoMetadata! : relationshipsToOmit.has('SeoMetadata') ? {} as SeoMetadata : aSeoMetadata({}, relationshipsToOmit),
        tax: overrides && overrides.hasOwnProperty('tax') ? overrides.tax! : [relationshipsToOmit.has('Tax') ? {} as Tax : aTax({}, relationshipsToOmit)],
        exchangeSettings: overrides && overrides.hasOwnProperty('exchangeSettings') ? overrides.exchangeSettings! : relationshipsToOmit.has('ExchangeSettings') ? {} as ExchangeSettings : anExchangeSettings({}, relationshipsToOmit),
        membershipsViewableFromDate: overrides && overrides.hasOwnProperty('membershipsViewableFromDate') ? overrides.membershipsViewableFromDate! : "2025-04-15T06:21:46.474Z",
        lastMembershipViewableEmailsSentAt: overrides && overrides.hasOwnProperty('lastMembershipViewableEmailsSentAt') ? overrides.lastMembershipViewableEmailsSentAt! : "2025-05-26T06:03:22.500Z",
        accessCodes: overrides && overrides.hasOwnProperty('accessCodes') ? overrides.accessCodes! : [relationshipsToOmit.has('AccessCode') ? {} as AccessCode : anAccessCode({}, relationshipsToOmit)],
        types: overrides && overrides.hasOwnProperty('types') ? overrides.types! : [relationshipsToOmit.has('MembershipType') ? {} as MembershipType : aMembershipType({}, relationshipsToOmit)],
        hasAccessCodes: overrides && overrides.hasOwnProperty('hasAccessCodes') ? overrides.hasAccessCodes! : true,
        renewalMembership: overrides && overrides.hasOwnProperty('renewalMembership') ? overrides.renewalMembership! : relationshipsToOmit.has('Membership') ? {} as Membership : aMembership({}, relationshipsToOmit),
        previousMemberships: overrides && overrides.hasOwnProperty('previousMemberships') ? overrides.previousMemberships! : [relationshipsToOmit.has('Membership') ? {} as Membership : aMembership({}, relationshipsToOmit)],
        season: overrides && overrides.hasOwnProperty('season') ? overrides.season! : relationshipsToOmit.has('Season') ? {} as Season : aSeason({}, relationshipsToOmit),
        venue: overrides && overrides.hasOwnProperty('venue') ? overrides.venue! : relationshipsToOmit.has('Venue') ? {} as Venue : aVenue({}, relationshipsToOmit),
        addons: overrides && overrides.hasOwnProperty('addons') ? overrides.addons! : [relationshipsToOmit.has('MembershipAddon') ? {} as MembershipAddon : aMembershipAddon({}, relationshipsToOmit)],
        membershipHoldersCount: overrides && overrides.hasOwnProperty('membershipHoldersCount') ? overrides.membershipHoldersCount! : 4.6,
        multiBuyPromotions: overrides && overrides.hasOwnProperty('multiBuyPromotions') ? overrides.multiBuyPromotions! : [relationshipsToOmit.has('MembershipMultiBuyPromotion') ? {} as MembershipMultiBuyPromotion : aMembershipMultiBuyPromotion({}, relationshipsToOmit)],
        digitalPassCodesStatus: overrides && overrides.hasOwnProperty('digitalPassCodesStatus') ? overrides.digitalPassCodesStatus! : relationshipsToOmit.has('DigitalPassCodeStatusOutput') ? {} as DigitalPassCodeStatusOutput : aDigitalPassCodeStatusOutput({}, relationshipsToOmit),
        digitalInfo: overrides && overrides.hasOwnProperty('digitalInfo') ? overrides.digitalInfo! : relationshipsToOmit.has('DigitalInfo') ? {} as DigitalInfo : aDigitalInfo({}, relationshipsToOmit),
        defaultDateRange: overrides && overrides.hasOwnProperty('defaultDateRange') ? overrides.defaultDateRange! : relationshipsToOmit.has('DateRange') ? {} as DateRange : aDateRange({}, relationshipsToOmit),
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : [relationshipsToOmit.has('Tag') ? {} as Tag : aTag({}, relationshipsToOmit)],
        hasPromoCodes: overrides && overrides.hasOwnProperty('hasPromoCodes') ? overrides.hasPromoCodes! : false,
        taxRate: overrides && overrides.hasOwnProperty('taxRate') ? overrides.taxRate! : 5.2,
        customTaxRate: overrides && overrides.hasOwnProperty('customTaxRate') ? overrides.customTaxRate! : 5.9,
        taxCalculationMethod: overrides && overrides.hasOwnProperty('taxCalculationMethod') ? overrides.taxCalculationMethod! : TaxCalculationMethod.Inclusive,
        fees: overrides && overrides.hasOwnProperty('fees') ? overrides.fees! : relationshipsToOmit.has('OrderFee') ? {} as OrderFee : anOrderFee({}, relationshipsToOmit),
        seekaConfig: overrides && overrides.hasOwnProperty('seekaConfig') ? overrides.seekaConfig! : relationshipsToOmit.has('SeekaOutput') ? {} as SeekaOutput : aSeekaOutput({}, relationshipsToOmit),
        seatsIoConfig: overrides && overrides.hasOwnProperty('seatsIoConfig') ? overrides.seatsIoConfig! : relationshipsToOmit.has('SeatsIoConfigOutput') ? {} as SeatsIoConfigOutput : aSeatsIoConfigOutput({}, relationshipsToOmit),
        stripeConfig: overrides && overrides.hasOwnProperty('stripeConfig') ? overrides.stripeConfig! : relationshipsToOmit.has('StripeConfigOutput') ? {} as StripeConfigOutput : aStripeConfigOutput({}, relationshipsToOmit),
    };
};

export const aMembershipZone = (overrides?: Partial<MembershipZone>, _relationshipsToOmit: Set<string> = new Set()): MembershipZone => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MembershipZone');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '213de381-bd1d-48a1-a3ad-3752798cb3a8',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-06-04T12:55:17.160Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-06-26T21:53:43.776Z",
        zone: overrides && overrides.hasOwnProperty('zone') ? overrides.zone! : relationshipsToOmit.has('Zone') ? {} as Zone : aZone({}, relationshipsToOmit),
        pricingLevel: overrides && overrides.hasOwnProperty('pricingLevel') ? overrides.pricingLevel! : ZonePricingLevel.Zone,
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : false,
        membershipTypes: overrides && overrides.hasOwnProperty('membershipTypes') ? overrides.membershipTypes! : [relationshipsToOmit.has('MembershipSeatingZoneType') ? {} as MembershipSeatingZoneType : aMembershipSeatingZoneType({}, relationshipsToOmit)],
    };
};

export const aMembershipSeatingZoneType = (overrides?: Partial<MembershipSeatingZoneType>, _relationshipsToOmit: Set<string> = new Set()): MembershipSeatingZoneType => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MembershipSeatingZoneType');
    return {
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 0.1,
        sections: overrides && overrides.hasOwnProperty('sections') ? overrides.sections! : [relationshipsToOmit.has('ZonePricingTypeSection') ? {} as ZonePricingTypeSection : aZonePricingTypeSection({}, relationshipsToOmit)],
        isHidden: overrides && overrides.hasOwnProperty('isHidden') ? overrides.isHidden! : true,
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : true,
        purchaseRestrictions: overrides && overrides.hasOwnProperty('purchaseRestrictions') ? overrides.purchaseRestrictions! : [relationshipsToOmit.has('PurchaseRestriction') ? {} as PurchaseRestriction : aPurchaseRestriction({}, relationshipsToOmit)],
        purchaseRestrictionsHelpText: overrides && overrides.hasOwnProperty('purchaseRestrictionsHelpText') ? overrides.purchaseRestrictionsHelpText! : ['utrimque'],
        membershipTypeId: overrides && overrides.hasOwnProperty('membershipTypeId') ? overrides.membershipTypeId! : 'spargo',
    };
};

export const aZonePricingTypeSection = (overrides?: Partial<ZonePricingTypeSection>, _relationshipsToOmit: Set<string> = new Set()): ZonePricingTypeSection => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ZonePricingTypeSection');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'culpa',
        sectionId: overrides && overrides.hasOwnProperty('sectionId') ? overrides.sectionId! : 'talio',
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 9.7,
    };
};

export const aPurchaseRestriction = (overrides?: Partial<PurchaseRestriction>, _relationshipsToOmit: Set<string> = new Set()): PurchaseRestriction => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PurchaseRestriction');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '40c09b25-073d-4906-9984-0b8a0432fac3',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-12-30T12:23:58.586Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-06-21T05:58:34.383Z",
        restrictedType: overrides && overrides.hasOwnProperty('restrictedType') ? overrides.restrictedType! : LineItemType.Ticket,
        restrictedId: overrides && overrides.hasOwnProperty('restrictedId') ? overrides.restrictedId! : 'af45a1e9-6f75-49c7-b9d8-12a78f7dc6a1',
        quantity: overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 7348,
        requiredEntities: overrides && overrides.hasOwnProperty('requiredEntities') ? overrides.requiredEntities! : [relationshipsToOmit.has('PurchaseRestrictionRequiredEntity') ? {} as PurchaseRestrictionRequiredEntity : aPurchaseRestrictionRequiredEntity({}, relationshipsToOmit)],
        isExclusive: overrides && overrides.hasOwnProperty('isExclusive') ? overrides.isExclusive! : true,
        isAlwaysVisible: overrides && overrides.hasOwnProperty('isAlwaysVisible') ? overrides.isAlwaysVisible! : true,
    };
};

export const aPurchaseRestrictionRequiredEntity = (overrides?: Partial<PurchaseRestrictionRequiredEntity>, _relationshipsToOmit: Set<string> = new Set()): PurchaseRestrictionRequiredEntity => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PurchaseRestrictionRequiredEntity');
    return {
        requiredType: overrides && overrides.hasOwnProperty('requiredType') ? overrides.requiredType! : LineItemType.Ticket,
        requiredId: overrides && overrides.hasOwnProperty('requiredId') ? overrides.requiredId! : 'ae456e90-f91c-4360-9ae5-f51e2a1aa374',
    };
};

export const aPaymentPlanSettings = (overrides?: Partial<PaymentPlanSettings>, _relationshipsToOmit: Set<string> = new Set()): PaymentPlanSettings => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PaymentPlanSettings');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'de2a9b1e-dca6-4e56-9edc-a1c2c7187f2a',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-06-01T22:01:44.573Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-12-13T23:32:26.341Z",
        disabledAt: overrides && overrides.hasOwnProperty('disabledAt') ? overrides.disabledAt! : 'suffragium',
        scheduleOptions: overrides && overrides.hasOwnProperty('scheduleOptions') ? overrides.scheduleOptions! : [relationshipsToOmit.has('ScheduleOption') ? {} as ScheduleOption : aScheduleOption({}, relationshipsToOmit)],
        gracePeriodDays: overrides && overrides.hasOwnProperty('gracePeriodDays') ? overrides.gracePeriodDays! : 0.1,
    };
};

export const aScheduleOption = (overrides?: Partial<ScheduleOption>, _relationshipsToOmit: Set<string> = new Set()): ScheduleOption => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ScheduleOption');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'aeger',
        interval: overrides && overrides.hasOwnProperty('interval') ? overrides.interval! : ScheduleOptionInterval.Day,
        installmentCount: overrides && overrides.hasOwnProperty('installmentCount') ? overrides.installmentCount! : 6.1,
        availableUntil: overrides && overrides.hasOwnProperty('availableUntil') ? overrides.availableUntil! : 'canto',
        minimumOrderAmount: overrides && overrides.hasOwnProperty('minimumOrderAmount') ? overrides.minimumOrderAmount! : 5.9,
        finalPaymentDate: overrides && overrides.hasOwnProperty('finalPaymentDate') ? overrides.finalPaymentDate! : 'cupressus',
        depositPercentage: overrides && overrides.hasOwnProperty('depositPercentage') ? overrides.depositPercentage! : 6.5,
        stripeFeePercentage: overrides && overrides.hasOwnProperty('stripeFeePercentage') ? overrides.stripeFeePercentage! : 4.9,
        promoterFeePercentage: overrides && overrides.hasOwnProperty('promoterFeePercentage') ? overrides.promoterFeePercentage! : 7.9,
        flicketFeePercentage: overrides && overrides.hasOwnProperty('flicketFeePercentage') ? overrides.flicketFeePercentage! : 5.2,
    };
};

export const aMembershipTicketCover = (overrides?: Partial<MembershipTicketCover>, _relationshipsToOmit: Set<string> = new Set()): MembershipTicketCover => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MembershipTicketCover');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '4a7fb6df-217b-4542-97cf-9ebf94538882',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-03-19T18:07:45.557Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-10-15T12:04:21.818Z",
        membership: overrides && overrides.hasOwnProperty('membership') ? overrides.membership! : relationshipsToOmit.has('Membership') ? {} as Membership : aMembership({}, relationshipsToOmit),
        enabledAt: overrides && overrides.hasOwnProperty('enabledAt') ? overrides.enabledAt! : "2025-08-21T13:43:15.524Z",
        disabledAt: overrides && overrides.hasOwnProperty('disabledAt') ? overrides.disabledAt! : "2025-06-28T17:20:58.527Z",
        promoterFeePercentage: overrides && overrides.hasOwnProperty('promoterFeePercentage') ? overrides.promoterFeePercentage! : 6.4,
        platformFeePercentage: overrides && overrides.hasOwnProperty('platformFeePercentage') ? overrides.platformFeePercentage! : 8.2,
        purchaseBehaviour: overrides && overrides.hasOwnProperty('purchaseBehaviour') ? overrides.purchaseBehaviour! : TicketCoverPurchaseBehaviour.Optional,
        totalFeePercentage: overrides && overrides.hasOwnProperty('totalFeePercentage') ? overrides.totalFeePercentage! : 7.7,
        isEnabled: overrides && overrides.hasOwnProperty('isEnabled') ? overrides.isEnabled! : false,
    };
};

export const aTax = (overrides?: Partial<Tax>, _relationshipsToOmit: Set<string> = new Set()): Tax => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Tax');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'ventosus',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 7.8,
        isExclusive: overrides && overrides.hasOwnProperty('isExclusive') ? overrides.isExclusive! : false,
    };
};

export const anExchangeSettings = (overrides?: Partial<ExchangeSettings>, _relationshipsToOmit: Set<string> = new Set()): ExchangeSettings => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ExchangeSettings');
    return {
        isEnabled: overrides && overrides.hasOwnProperty('isEnabled') ? overrides.isEnabled! : true,
        exchangeableEvents: overrides && overrides.hasOwnProperty('exchangeableEvents') ? overrides.exchangeableEvents! : [relationshipsToOmit.has('ExchangeableEvent') ? {} as ExchangeableEvent : anExchangeableEvent({}, relationshipsToOmit)],
        totalEventCount: overrides && overrides.hasOwnProperty('totalEventCount') ? overrides.totalEventCount! : 1.4,
        creditFullMembership: overrides && overrides.hasOwnProperty('creditFullMembership') ? overrides.creditFullMembership! : true,
        creditBookingFees: overrides && overrides.hasOwnProperty('creditBookingFees') ? overrides.creditBookingFees! : false,
        releaseSlug: overrides && overrides.hasOwnProperty('releaseSlug') ? overrides.releaseSlug! : 'ago',
    };
};

export const anExchangeableEvent = (overrides?: Partial<ExchangeableEvent>, _relationshipsToOmit: Set<string> = new Set()): ExchangeableEvent => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ExchangeableEvent');
    return {
        fromEventId: overrides && overrides.hasOwnProperty('fromEventId') ? overrides.fromEventId! : 'averto',
        toEventIds: overrides && overrides.hasOwnProperty('toEventIds') ? overrides.toEventIds! : ['viduo'],
    };
};

export const anAccessCode = (overrides?: Partial<AccessCode>, _relationshipsToOmit: Set<string> = new Set()): AccessCode => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AccessCode');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '7c6d9cc5-14a8-454f-96a9-431661c97e13',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-05-16T00:09:56.495Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-05-22T16:26:31.328Z",
        code: overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'tondeo',
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : false,
        quantityPaid: overrides && overrides.hasOwnProperty('quantityPaid') ? overrides.quantityPaid! : 5.6,
        quantityComp: overrides && overrides.hasOwnProperty('quantityComp') ? overrides.quantityComp! : 3.2,
        totalUsedPaid: overrides && overrides.hasOwnProperty('totalUsedPaid') ? overrides.totalUsedPaid! : 1.5,
        totalUsedComp: overrides && overrides.hasOwnProperty('totalUsedComp') ? overrides.totalUsedComp! : 9.9,
        membershipTypes: overrides && overrides.hasOwnProperty('membershipTypes') ? overrides.membershipTypes! : [relationshipsToOmit.has('MembershipType') ? {} as MembershipType : aMembershipType({}, relationshipsToOmit)],
    };
};

export const aMembershipType = (overrides?: Partial<MembershipType>, _relationshipsToOmit: Set<string> = new Set()): MembershipType => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MembershipType');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'd596ac04-e427-4cea-9072-b4c1489ec0c1',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-11-26T20:01:32.756Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2026-03-01T06:41:53.925Z",
        kind: overrides && overrides.hasOwnProperty('kind') ? overrides.kind! : MembershipTypeKind.Standard,
        quantitySet: overrides && overrides.hasOwnProperty('quantitySet') ? overrides.quantitySet! : 6692,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'pecco',
        ticketFeeType: overrides && overrides.hasOwnProperty('ticketFeeType') ? overrides.ticketFeeType! : FeeType.FlatRate,
        ticketFee: overrides && overrides.hasOwnProperty('ticketFee') ? overrides.ticketFee! : 0.7,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'totus',
        restrictions: overrides && overrides.hasOwnProperty('restrictions') ? overrides.restrictions! : 'strenuus',
        namingFields: overrides && overrides.hasOwnProperty('namingFields') ? overrides.namingFields! : [relationshipsToOmit.has('FormField') ? {} as FormField : aFormField({}, relationshipsToOmit)],
        minPurchaseQuantity: overrides && overrides.hasOwnProperty('minPurchaseQuantity') ? overrides.minPurchaseQuantity! : 3787,
        maxPurchaseQuantity: overrides && overrides.hasOwnProperty('maxPurchaseQuantity') ? overrides.maxPurchaseQuantity! : 3085,
        isGuestCard: overrides && overrides.hasOwnProperty('isGuestCard') ? overrides.isGuestCard! : true,
        isHidden: overrides && overrides.hasOwnProperty('isHidden') ? overrides.isHidden! : true,
        isChild: overrides && overrides.hasOwnProperty('isChild') ? overrides.isChild! : false,
        accessCodes: overrides && overrides.hasOwnProperty('accessCodes') ? overrides.accessCodes! : [relationshipsToOmit.has('AccessCode') ? {} as AccessCode : anAccessCode({}, relationshipsToOmit)],
        membership: overrides && overrides.hasOwnProperty('membership') ? overrides.membership! : relationshipsToOmit.has('Membership') ? {} as Membership : aMembership({}, relationshipsToOmit),
    };
};

export const aFormField = (overrides?: Partial<FormField>, _relationshipsToOmit: Set<string> = new Set()): FormField => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('FormField');
    return {
        field: overrides && overrides.hasOwnProperty('field') ? overrides.field! : 'voro',
        isRequired: overrides && overrides.hasOwnProperty('isRequired') ? overrides.isRequired! : false,
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'verumtamen',
        isCustom: overrides && overrides.hasOwnProperty('isCustom') ? overrides.isCustom! : true,
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'crinis',
        defaultValue: overrides && overrides.hasOwnProperty('defaultValue') ? overrides.defaultValue! : 'quos',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'cubicularis',
        options: overrides && overrides.hasOwnProperty('options') ? overrides.options! : ['tenuis'],
    };
};

export const aMembershipAddon = (overrides?: Partial<MembershipAddon>, _relationshipsToOmit: Set<string> = new Set()): MembershipAddon => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MembershipAddon');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '325a16dc-7718-4ad8-ac40-d015e7a680e7',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-03-19T13:18:15.401Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-07-06T10:45:51.622Z",
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'velit',
        enableNaming: overrides && overrides.hasOwnProperty('enableNaming') ? overrides.enableNaming! : true,
        quantity: overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 1.4,
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 6.9,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'et',
        restrictions: overrides && overrides.hasOwnProperty('restrictions') ? overrides.restrictions! : 'tenax',
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : false,
        namingFields: overrides && overrides.hasOwnProperty('namingFields') ? overrides.namingFields! : [relationshipsToOmit.has('FormField') ? {} as FormField : aFormField({}, relationshipsToOmit)],
        addonImage: overrides && overrides.hasOwnProperty('addonImage') ? overrides.addonImage! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        quantityAllocated: overrides && overrides.hasOwnProperty('quantityAllocated') ? overrides.quantityAllocated! : 4.9,
        maxPurchaseQuantity: overrides && overrides.hasOwnProperty('maxPurchaseQuantity') ? overrides.maxPurchaseQuantity! : 3,
        remaining: overrides && overrides.hasOwnProperty('remaining') ? overrides.remaining! : 9.2,
        displayOrder: overrides && overrides.hasOwnProperty('displayOrder') ? overrides.displayOrder! : 3608,
    };
};

export const aMembershipMultiBuyPromotion = (overrides?: Partial<MembershipMultiBuyPromotion>, _relationshipsToOmit: Set<string> = new Set()): MembershipMultiBuyPromotion => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MembershipMultiBuyPromotion');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '6b8ce25b-96b1-472f-9287-747be7bdf758',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-12-12T22:55:23.322Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2026-01-01T06:25:57.833Z",
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'et',
        buyQuantity: overrides && overrides.hasOwnProperty('buyQuantity') ? overrides.buyQuantity! : 1.5,
        getQuantity: overrides && overrides.hasOwnProperty('getQuantity') ? overrides.getQuantity! : 3.7,
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 0.9,
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
        buyMembershipType: overrides && overrides.hasOwnProperty('buyMembershipType') ? overrides.buyMembershipType! : relationshipsToOmit.has('MembershipType') ? {} as MembershipType : aMembershipType({}, relationshipsToOmit),
        getMembershipType: overrides && overrides.hasOwnProperty('getMembershipType') ? overrides.getMembershipType! : relationshipsToOmit.has('MembershipType') ? {} as MembershipType : aMembershipType({}, relationshipsToOmit),
        used: overrides && overrides.hasOwnProperty('used') ? overrides.used! : 5.6,
    };
};

export const aDigitalPassCodeStatusOutput = (overrides?: Partial<DigitalPassCodeStatusOutput>, _relationshipsToOmit: Set<string> = new Set()): DigitalPassCodeStatusOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DigitalPassCodeStatusOutput');
    return {
        totalPassCodes: overrides && overrides.hasOwnProperty('totalPassCodes') ? overrides.totalPassCodes! : 1976,
        remainingPassCodes: overrides && overrides.hasOwnProperty('remainingPassCodes') ? overrides.remainingPassCodes! : 6855,
    };
};

export const aDigitalInfo = (overrides?: Partial<DigitalInfo>, _relationshipsToOmit: Set<string> = new Set()): DigitalInfo => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DigitalInfo');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'bee21d3d-0f03-43ba-a028-d72006978dd6',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-09-13T00:00:29.938Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-10-11T09:00:41.189Z",
        url: overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'victoria',
        emailTemplateId: overrides && overrides.hasOwnProperty('emailTemplateId') ? overrides.emailTemplateId! : 'adaugeo',
        additionalEmailInfoText: overrides && overrides.hasOwnProperty('additionalEmailInfoText') ? overrides.additionalEmailInfoText! : 'ipsum',
        additionalEmailButtonUrl: overrides && overrides.hasOwnProperty('additionalEmailButtonUrl') ? overrides.additionalEmailButtonUrl! : 'barba',
        additionalEmailButtonText: overrides && overrides.hasOwnProperty('additionalEmailButtonText') ? overrides.additionalEmailButtonText! : 'toties',
        additionalEmailInfoHTML: overrides && overrides.hasOwnProperty('additionalEmailInfoHTML') ? overrides.additionalEmailInfoHTML! : 'ver',
        event: overrides && overrides.hasOwnProperty('event') ? overrides.event! : relationshipsToOmit.has('Event') ? {} as Event : anEvent({}, relationshipsToOmit),
        membership: overrides && overrides.hasOwnProperty('membership') ? overrides.membership! : relationshipsToOmit.has('Membership') ? {} as Membership : aMembership({}, relationshipsToOmit),
    };
};

export const aSeekaOutput = (overrides?: Partial<SeekaOutput>, _relationshipsToOmit: Set<string> = new Set()): SeekaOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SeekaOutput');
    return {
        seekaOrganizationId: overrides && overrides.hasOwnProperty('seekaOrganizationId') ? overrides.seekaOrganizationId! : 'officiis',
        seekaPublicKey: overrides && overrides.hasOwnProperty('seekaPublicKey') ? overrides.seekaPublicKey! : 'arbustum',
        seekaInstanceId: overrides && overrides.hasOwnProperty('seekaInstanceId') ? overrides.seekaInstanceId! : 'thymum',
        seekaScopeDescription: overrides && overrides.hasOwnProperty('seekaScopeDescription') ? overrides.seekaScopeDescription! : 'vesica',
        currencyCode: overrides && overrides.hasOwnProperty('currencyCode') ? overrides.currencyCode! : 'spoliatio',
        countryCode: overrides && overrides.hasOwnProperty('countryCode') ? overrides.countryCode! : 'tabernus',
    };
};

export const aSeatsIoConfigOutput = (overrides?: Partial<SeatsIoConfigOutput>, _relationshipsToOmit: Set<string> = new Set()): SeatsIoConfigOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SeatsIoConfigOutput');
    return {
        isFlicketWorkspace: overrides && overrides.hasOwnProperty('isFlicketWorkspace') ? overrides.isFlicketWorkspace! : true,
        region: overrides && overrides.hasOwnProperty('region') ? overrides.region! : 'arto',
        publicKey: overrides && overrides.hasOwnProperty('publicKey') ? overrides.publicKey! : 'crux',
        secretKey: overrides && overrides.hasOwnProperty('secretKey') ? overrides.secretKey! : 'vaco',
        eventKeys: overrides && overrides.hasOwnProperty('eventKeys') ? overrides.eventKeys! : ['cohors'],
        thumbnailUrl: overrides && overrides.hasOwnProperty('thumbnailUrl') ? overrides.thumbnailUrl! : 'dolores',
    };
};

export const aTicketEntryTimeEnforcementOptions = (overrides?: Partial<TicketEntryTimeEnforcementOptions>, _relationshipsToOmit: Set<string> = new Set()): TicketEntryTimeEnforcementOptions => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TicketEntryTimeEnforcementOptions');
    return {
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false,
        gracePeriodMinutes: overrides && overrides.hasOwnProperty('gracePeriodMinutes') ? overrides.gracePeriodMinutes! : 4.9,
    };
};

export const aTicketType = (overrides?: Partial<TicketType>, _relationshipsToOmit: Set<string> = new Set()): TicketType => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TicketType');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '41f3eb91-d79d-48e2-a93f-efbc80166368',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-09-14T00:40:57.425Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-12-23T18:05:39.050Z",
        event: overrides && overrides.hasOwnProperty('event') ? overrides.event! : relationshipsToOmit.has('Event') ? {} as Event : anEvent({}, relationshipsToOmit),
        kind: overrides && overrides.hasOwnProperty('kind') ? overrides.kind! : TicketTypeKind.Standard,
        quantity: overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 9056,
        minPurchaseQuantity: overrides && overrides.hasOwnProperty('minPurchaseQuantity') ? overrides.minPurchaseQuantity! : 8459,
        maxPurchaseQuantity: overrides && overrides.hasOwnProperty('maxPurchaseQuantity') ? overrides.maxPurchaseQuantity! : 4890,
        isGrouped: overrides && overrides.hasOwnProperty('isGrouped') ? overrides.isGrouped! : true,
        isChild: overrides && overrides.hasOwnProperty('isChild') ? overrides.isChild! : true,
        isBusinessOnly: overrides && overrides.hasOwnProperty('isBusinessOnly') ? overrides.isBusinessOnly! : false,
        groupAmount: overrides && overrides.hasOwnProperty('groupAmount') ? overrides.groupAmount! : 4303,
        quantitySet: overrides && overrides.hasOwnProperty('quantitySet') ? overrides.quantitySet! : 1063,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'volutabrum',
        dates: overrides && overrides.hasOwnProperty('dates') ? overrides.dates! : [relationshipsToOmit.has('TicketTypeDate') ? {} as TicketTypeDate : aTicketTypeDate({}, relationshipsToOmit)],
        entryDates: overrides && overrides.hasOwnProperty('entryDates') ? overrides.entryDates! : [relationshipsToOmit.has('EventDate') ? {} as EventDate : anEventDate({}, relationshipsToOmit)],
        showStartTime: overrides && overrides.hasOwnProperty('showStartTime') ? overrides.showStartTime! : true,
        showEndTime: overrides && overrides.hasOwnProperty('showEndTime') ? overrides.showEndTime! : true,
        bookingFeeType: overrides && overrides.hasOwnProperty('bookingFeeType') ? overrides.bookingFeeType! : FeeType.FlatRate,
        bookingFee: overrides && overrides.hasOwnProperty('bookingFee') ? overrides.bookingFee! : 0.2,
        stadiumLevyFee: overrides && overrides.hasOwnProperty('stadiumLevyFee') ? overrides.stadiumLevyFee! : 7.8,
        inHighDemand: overrides && overrides.hasOwnProperty('inHighDemand') ? overrides.inHighDemand! : false,
        customBadge: overrides && overrides.hasOwnProperty('customBadge') ? overrides.customBadge! : 'credo',
        customBadgeBackgroundColor: overrides && overrides.hasOwnProperty('customBadgeBackgroundColor') ? overrides.customBadgeBackgroundColor! : 'territo',
        customBadgeTextColor: overrides && overrides.hasOwnProperty('customBadgeTextColor') ? overrides.customBadgeTextColor! : 'condico',
        soldOut: overrides && overrides.hasOwnProperty('soldOut') ? overrides.soldOut! : false,
        hidePriceWhenSoldOut: overrides && overrides.hasOwnProperty('hidePriceWhenSoldOut') ? overrides.hidePriceWhenSoldOut! : true,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'patrocinor',
        restrictions: overrides && overrides.hasOwnProperty('restrictions') ? overrides.restrictions! : 'decet',
        printAtHomeInformation: overrides && overrides.hasOwnProperty('printAtHomeInformation') ? overrides.printAtHomeInformation! : 'convoco',
        ticketBanner: overrides && overrides.hasOwnProperty('ticketBanner') ? overrides.ticketBanner! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        ticketImage: overrides && overrides.hasOwnProperty('ticketImage') ? overrides.ticketImage! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        imageGallery: overrides && overrides.hasOwnProperty('imageGallery') ? overrides.imageGallery! : [relationshipsToOmit.has('ImageGalleryItem') ? {} as ImageGalleryItem : anImageGalleryItem({}, relationshipsToOmit)],
        namingFields: overrides && overrides.hasOwnProperty('namingFields') ? overrides.namingFields! : [relationshipsToOmit.has('FormField') ? {} as FormField : aFormField({}, relationshipsToOmit)],
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 8.8,
        intellitixIds: overrides && overrides.hasOwnProperty('intellitixIds') ? overrides.intellitixIds! : ['supellex'],
        isResaleTicket: overrides && overrides.hasOwnProperty('isResaleTicket') ? overrides.isResaleTicket! : true,
        resaleTicketTypeId: overrides && overrides.hasOwnProperty('resaleTicketTypeId') ? overrides.resaleTicketTypeId! : 'arceo',
        resaleTicketTypes: overrides && overrides.hasOwnProperty('resaleTicketTypes') ? overrides.resaleTicketTypes! : [relationshipsToOmit.has('TicketType') ? {} as TicketType : aTicketType({}, relationshipsToOmit)],
        waitlistFanCount: overrides && overrides.hasOwnProperty('waitlistFanCount') ? overrides.waitlistFanCount! : 9786,
        resaleHiddenFromPublic: overrides && overrides.hasOwnProperty('resaleHiddenFromPublic') ? overrides.resaleHiddenFromPublic! : false,
        hasCustomDates: overrides && overrides.hasOwnProperty('hasCustomDates') ? overrides.hasCustomDates! : false,
        isUsherDisabled: overrides && overrides.hasOwnProperty('isUsherDisabled') ? overrides.isUsherDisabled! : true,
        onSaleConfig: overrides && overrides.hasOwnProperty('onSaleConfig') ? overrides.onSaleConfig! : relationshipsToOmit.has('TicketTypeOnSaleConfig') ? {} as TicketTypeOnSaleConfig : aTicketTypeOnSaleConfig({}, relationshipsToOmit),
        isOnSale: overrides && overrides.hasOwnProperty('isOnSale') ? overrides.isOnSale! : false,
        notOnSaleMessage: overrides && overrides.hasOwnProperty('notOnSaleMessage') ? overrides.notOnSaleMessage! : 'aptus',
        onSaleStatus: overrides && overrides.hasOwnProperty('onSaleStatus') ? overrides.onSaleStatus! : TicketTypeOnSaleStatus.NotYetOnSale,
        pricingTiers: overrides && overrides.hasOwnProperty('pricingTiers') ? overrides.pricingTiers! : [relationshipsToOmit.has('PricingTierOutput') ? {} as PricingTierOutput : aPricingTierOutput({}, relationshipsToOmit)],
        canUsePricingTiers: overrides && overrides.hasOwnProperty('canUsePricingTiers') ? overrides.canUsePricingTiers! : false,
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : [relationshipsToOmit.has('Tag') ? {} as Tag : aTag({}, relationshipsToOmit)],
        totalSold: overrides && overrides.hasOwnProperty('totalSold') ? overrides.totalSold! : 9877,
        zones: overrides && overrides.hasOwnProperty('zones') ? overrides.zones! : [relationshipsToOmit.has('Zone') ? {} as Zone : aZone({}, relationshipsToOmit)],
    };
};

export const aTicketTypeDate = (overrides?: Partial<TicketTypeDate>, _relationshipsToOmit: Set<string> = new Set()): TicketTypeDate => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TicketTypeDate');
    return {
        eventDateId: overrides && overrides.hasOwnProperty('eventDateId') ? overrides.eventDateId! : '8e95ad2f-3347-435e-9bfa-1013acc1719f',
        alternateEntryTime: overrides && overrides.hasOwnProperty('alternateEntryTime') ? overrides.alternateEntryTime! : 'verbum',
    };
};

export const aTicketTypeOnSaleConfig = (overrides?: Partial<TicketTypeOnSaleConfig>, _relationshipsToOmit: Set<string> = new Set()): TicketTypeOnSaleConfig => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TicketTypeOnSaleConfig');
    return {
        startConfig: overrides && overrides.hasOwnProperty('startConfig') ? overrides.startConfig! : relationshipsToOmit.has('TicketTypeOnSaleStartConfig') ? {} as TicketTypeOnSaleStartConfig : aTicketTypeOnSaleStartConfig({}, relationshipsToOmit),
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : "2025-04-06T06:40:56.210Z",
    };
};

export const aTicketTypeOnSaleStartConfig = (overrides?: Partial<TicketTypeOnSaleStartConfig>, _relationshipsToOmit: Set<string> = new Set()): TicketTypeOnSaleStartConfig => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TicketTypeOnSaleStartConfig');
    return {
        condition: overrides && overrides.hasOwnProperty('condition') ? overrides.condition! : TicketTypeOnSaleCondition.TicketType,
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2025-07-10T21:33:22.282Z",
        ticketTypeId: overrides && overrides.hasOwnProperty('ticketTypeId') ? overrides.ticketTypeId! : 'a2433f10-d03b-4c1a-822e-f0501e9dbe1e',
    };
};

export const aPricingTierOutput = (overrides?: Partial<PricingTierOutput>, _relationshipsToOmit: Set<string> = new Set()): PricingTierOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PricingTierOutput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'itaque',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'tendo',
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 4.8,
        quantity: overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 0,
        soldOut: overrides && overrides.hasOwnProperty('soldOut') ? overrides.soldOut! : false,
        totalSold: overrides && overrides.hasOwnProperty('totalSold') ? overrides.totalSold! : 3562,
        revenueProcessed: overrides && overrides.hasOwnProperty('revenueProcessed') ? overrides.revenueProcessed! : 6.1,
        isDeletable: overrides && overrides.hasOwnProperty('isDeletable') ? overrides.isDeletable! : false,
    };
};

export const anEventAddon = (overrides?: Partial<EventAddon>, _relationshipsToOmit: Set<string> = new Set()): EventAddon => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EventAddon');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '01b85364-f7bb-4183-b200-5add22afcc2a',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-03-13T21:27:08.945Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2026-01-04T23:52:58.026Z",
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'cursus',
        enableNaming: overrides && overrides.hasOwnProperty('enableNaming') ? overrides.enableNaming! : true,
        quantity: overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 8,
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 3.3,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'canis',
        restrictions: overrides && overrides.hasOwnProperty('restrictions') ? overrides.restrictions! : 'voluptatem',
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : false,
        namingFields: overrides && overrides.hasOwnProperty('namingFields') ? overrides.namingFields! : [relationshipsToOmit.has('FormField') ? {} as FormField : aFormField({}, relationshipsToOmit)],
        addonImage: overrides && overrides.hasOwnProperty('addonImage') ? overrides.addonImage! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        quantityAllocated: overrides && overrides.hasOwnProperty('quantityAllocated') ? overrides.quantityAllocated! : 6.1,
        maxPurchaseQuantity: overrides && overrides.hasOwnProperty('maxPurchaseQuantity') ? overrides.maxPurchaseQuantity! : 6.7,
        remaining: overrides && overrides.hasOwnProperty('remaining') ? overrides.remaining! : 3.4,
        displayOrder: overrides && overrides.hasOwnProperty('displayOrder') ? overrides.displayOrder! : 7153,
        insideFee: overrides && overrides.hasOwnProperty('insideFee') ? overrides.insideFee! : 8.6,
        hideQRCode: overrides && overrides.hasOwnProperty('hideQRCode') ? overrides.hideQRCode! : true,
        scannableGateIds: overrides && overrides.hasOwnProperty('scannableGateIds') ? overrides.scannableGateIds! : ['campana'],
        imageGallery: overrides && overrides.hasOwnProperty('imageGallery') ? overrides.imageGallery! : [relationshipsToOmit.has('ImageGalleryItem') ? {} as ImageGalleryItem : anImageGalleryItem({}, relationshipsToOmit)],
        intellitixId: overrides && overrides.hasOwnProperty('intellitixId') ? overrides.intellitixId! : 'uxor',
        purchaseRestrictions: overrides && overrides.hasOwnProperty('purchaseRestrictions') ? overrides.purchaseRestrictions! : [relationshipsToOmit.has('PurchaseRestriction') ? {} as PurchaseRestriction : aPurchaseRestriction({}, relationshipsToOmit)],
        purchaseRestrictionsHelpText: overrides && overrides.hasOwnProperty('purchaseRestrictionsHelpText') ? overrides.purchaseRestrictionsHelpText! : ['vomito'],
        totalSold: overrides && overrides.hasOwnProperty('totalSold') ? overrides.totalSold! : 3885,
        addonAvailabilityStatus: overrides && overrides.hasOwnProperty('addonAvailabilityStatus') ? overrides.addonAvailabilityStatus! : TicketAvailabilityStatus.Available,
    };
};

export const anEventMultiBuyPromotion = (overrides?: Partial<EventMultiBuyPromotion>, _relationshipsToOmit: Set<string> = new Set()): EventMultiBuyPromotion => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EventMultiBuyPromotion');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '8fd5da17-df03-4269-b5b1-0b88b17d7b62',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2026-02-20T06:46:00.500Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-07-13T08:34:56.204Z",
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'dapifer',
        buyQuantity: overrides && overrides.hasOwnProperty('buyQuantity') ? overrides.buyQuantity! : 5.4,
        getQuantity: overrides && overrides.hasOwnProperty('getQuantity') ? overrides.getQuantity! : 4,
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 7.8,
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false,
        buyTicketType: overrides && overrides.hasOwnProperty('buyTicketType') ? overrides.buyTicketType! : relationshipsToOmit.has('TicketType') ? {} as TicketType : aTicketType({}, relationshipsToOmit),
        getTicketType: overrides && overrides.hasOwnProperty('getTicketType') ? overrides.getTicketType! : relationshipsToOmit.has('TicketType') ? {} as TicketType : aTicketType({}, relationshipsToOmit),
        used: overrides && overrides.hasOwnProperty('used') ? overrides.used! : 1.5,
    };
};

export const aDefaultDateRange = (overrides?: Partial<DefaultDateRange>, _relationshipsToOmit: Set<string> = new Set()): DefaultDateRange => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DefaultDateRange');
    return {
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2026-02-02T14:29:01.439Z",
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : "2026-02-06T14:38:09.556Z",
    };
};

export const anArtist = (overrides?: Partial<Artist>, _relationshipsToOmit: Set<string> = new Set()): Artist => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Artist');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'b0b024fc-8c90-4cdd-baff-f2dd400938d2',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-03-20T05:07:32.116Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2026-02-21T06:09:32.306Z",
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'virga',
        source: overrides && overrides.hasOwnProperty('source') ? overrides.source! : 'angelus',
        sourceId: overrides && overrides.hasOwnProperty('sourceId') ? overrides.sourceId! : 'tero',
        imageUrl: overrides && overrides.hasOwnProperty('imageUrl') ? overrides.imageUrl! : 'terminatio',
        genres: overrides && overrides.hasOwnProperty('genres') ? overrides.genres! : [relationshipsToOmit.has('Genre') ? {} as Genre : aGenre({}, relationshipsToOmit)],
    };
};

export const aGenre = (overrides?: Partial<Genre>, _relationshipsToOmit: Set<string> = new Set()): Genre => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Genre');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'b765fa4d-79d9-4c81-9462-cae17fd90690',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'civitas',
    };
};

export const aCustomFieldOuput = (overrides?: Partial<CustomFieldOuput>, _relationshipsToOmit: Set<string> = new Set()): CustomFieldOuput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CustomFieldOuput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'abduco',
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'talio',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : true,
        targetArea: overrides && overrides.hasOwnProperty('targetArea') ? overrides.targetArea! : ['cuppedia'],
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'umquam',
        isRequired: overrides && overrides.hasOwnProperty('isRequired') ? overrides.isRequired! : false,
    };
};

export const aRestrictedRelease = (overrides?: Partial<RestrictedRelease>, _relationshipsToOmit: Set<string> = new Set()): RestrictedRelease => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RestrictedRelease');
    return {
        releaseId: overrides && overrides.hasOwnProperty('releaseId') ? overrides.releaseId! : 'voluptate',
        path: overrides && overrides.hasOwnProperty('path') ? overrides.path! : 'vobis',
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : true,
        memberships: overrides && overrides.hasOwnProperty('memberships') ? overrides.memberships! : [relationshipsToOmit.has('RestrictedReleaseRequiredMembership') ? {} as RestrictedReleaseRequiredMembership : aRestrictedReleaseRequiredMembership({}, relationshipsToOmit)],
    };
};

export const aRestrictedReleaseRequiredMembership = (overrides?: Partial<RestrictedReleaseRequiredMembership>, _relationshipsToOmit: Set<string> = new Set()): RestrictedReleaseRequiredMembership => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RestrictedReleaseRequiredMembership');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'antea',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'tubineus',
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : false,
    };
};

export const aReleaseZone = (overrides?: Partial<ReleaseZone>, _relationshipsToOmit: Set<string> = new Set()): ReleaseZone => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ReleaseZone');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '1299045d-04e7-4e39-9e94-a06854d83782',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-09-28T02:26:10.188Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-06-13T19:45:55.485Z",
        zone: overrides && overrides.hasOwnProperty('zone') ? overrides.zone! : relationshipsToOmit.has('Zone') ? {} as Zone : aZone({}, relationshipsToOmit),
        pricingLevel: overrides && overrides.hasOwnProperty('pricingLevel') ? overrides.pricingLevel! : ZonePricingLevel.Zone,
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : true,
        isSoldOut: overrides && overrides.hasOwnProperty('isSoldOut') ? overrides.isSoldOut! : false,
        ticketTypes: overrides && overrides.hasOwnProperty('ticketTypes') ? overrides.ticketTypes! : [relationshipsToOmit.has('ReleaseZoneTicketType') ? {} as ReleaseZoneTicketType : aReleaseZoneTicketType({}, relationshipsToOmit)],
    };
};

export const aReleaseZoneTicketType = (overrides?: Partial<ReleaseZoneTicketType>, _relationshipsToOmit: Set<string> = new Set()): ReleaseZoneTicketType => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ReleaseZoneTicketType');
    return {
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 9,
        sections: overrides && overrides.hasOwnProperty('sections') ? overrides.sections! : [relationshipsToOmit.has('ZonePricingTypeSection') ? {} as ZonePricingTypeSection : aZonePricingTypeSection({}, relationshipsToOmit)],
        isHidden: overrides && overrides.hasOwnProperty('isHidden') ? overrides.isHidden! : false,
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : true,
        purchaseRestrictions: overrides && overrides.hasOwnProperty('purchaseRestrictions') ? overrides.purchaseRestrictions! : [relationshipsToOmit.has('PurchaseRestriction') ? {} as PurchaseRestriction : aPurchaseRestriction({}, relationshipsToOmit)],
        purchaseRestrictionsHelpText: overrides && overrides.hasOwnProperty('purchaseRestrictionsHelpText') ? overrides.purchaseRestrictionsHelpText! : ['pax'],
        ticketTypeId: overrides && overrides.hasOwnProperty('ticketTypeId') ? overrides.ticketTypeId! : 'tametsi',
        minPurchaseQuantity: overrides && overrides.hasOwnProperty('minPurchaseQuantity') ? overrides.minPurchaseQuantity! : 283,
        maxPurchaseQuantity: overrides && overrides.hasOwnProperty('maxPurchaseQuantity') ? overrides.maxPurchaseQuantity! : 6328,
        isSoldOut: overrides && overrides.hasOwnProperty('isSoldOut') ? overrides.isSoldOut! : true,
        hidePrice: overrides && overrides.hasOwnProperty('hidePrice') ? overrides.hidePrice! : true,
        ticketAvailabilityStatus: overrides && overrides.hasOwnProperty('ticketAvailabilityStatus') ? overrides.ticketAvailabilityStatus! : TicketAvailabilityStatus.Available,
        pricingTierId: overrides && overrides.hasOwnProperty('pricingTierId') ? overrides.pricingTierId! : 'curtus',
        pricingTierName: overrides && overrides.hasOwnProperty('pricingTierName') ? overrides.pricingTierName! : 'tonsor',
    };
};

export const aReleaseEventAddon = (overrides?: Partial<ReleaseEventAddon>, _relationshipsToOmit: Set<string> = new Set()): ReleaseEventAddon => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ReleaseEventAddon');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '6dc8e744-819e-491a-a321-3ba66c70e057',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-12-14T13:25:29.331Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-03-18T01:58:33.800Z",
        eventAddon: overrides && overrides.hasOwnProperty('eventAddon') ? overrides.eventAddon! : relationshipsToOmit.has('EventAddon') ? {} as EventAddon : anEventAddon({}, relationshipsToOmit),
        releaseId: overrides && overrides.hasOwnProperty('releaseId') ? overrides.releaseId! : 'voveo',
        eventAddonId: overrides && overrides.hasOwnProperty('eventAddonId') ? overrides.eventAddonId! : 'nesciunt',
    };
};

export const anEventChannelOutput = (overrides?: Partial<EventChannelOutput>, _relationshipsToOmit: Set<string> = new Set()): EventChannelOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EventChannelOutput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'adhuc',
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'pax',
        isEnabled: overrides && overrides.hasOwnProperty('isEnabled') ? overrides.isEnabled! : true,
    };
};

export const aReleasePassword = (overrides?: Partial<ReleasePassword>, _relationshipsToOmit: Set<string> = new Set()): ReleasePassword => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ReleasePassword');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '51eaada8-be63-4ac8-af52-3896eb705631',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-06-10T20:27:20.774Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-12-14T17:16:38.086Z",
        quantityPaid: overrides && overrides.hasOwnProperty('quantityPaid') ? overrides.quantityPaid! : 1095,
        quantityComp: overrides && overrides.hasOwnProperty('quantityComp') ? overrides.quantityComp! : 8560,
        totalUsedPaid: overrides && overrides.hasOwnProperty('totalUsedPaid') ? overrides.totalUsedPaid! : 703,
        totalUsedComp: overrides && overrides.hasOwnProperty('totalUsedComp') ? overrides.totalUsedComp! : 1367,
    };
};

export const anOrderTicketCover = (overrides?: Partial<OrderTicketCover>, _relationshipsToOmit: Set<string> = new Set()): OrderTicketCover => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OrderTicketCover');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '46afd728-f608-4e9c-b822-f5b19c3c96d4',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-06-06T05:57:30.946Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-04-01T20:38:24.989Z",
        purchasedAt: overrides && overrides.hasOwnProperty('purchasedAt') ? overrides.purchasedAt! : "2026-02-27T10:35:15.079Z",
        issuedAt: overrides && overrides.hasOwnProperty('issuedAt') ? overrides.issuedAt! : "2025-09-28T06:44:08.245Z",
        promoterFeeAmount: overrides && overrides.hasOwnProperty('promoterFeeAmount') ? overrides.promoterFeeAmount! : 0.5,
        platformFeeAmount: overrides && overrides.hasOwnProperty('platformFeeAmount') ? overrides.platformFeeAmount! : 0.2,
        totalFeeAmount: overrides && overrides.hasOwnProperty('totalFeeAmount') ? overrides.totalFeeAmount! : 6.2,
        ticketTicketCovers: overrides && overrides.hasOwnProperty('ticketTicketCovers') ? overrides.ticketTicketCovers! : [relationshipsToOmit.has('TicketTicketCover') ? {} as TicketTicketCover : aTicketTicketCover({}, relationshipsToOmit)],
        order: overrides && overrides.hasOwnProperty('order') ? overrides.order! : relationshipsToOmit.has('Order') ? {} as Order : anOrder({}, relationshipsToOmit),
        retryCount: overrides && overrides.hasOwnProperty('retryCount') ? overrides.retryCount! : 9.9,
        purchaseBehaviour: overrides && overrides.hasOwnProperty('purchaseBehaviour') ? overrides.purchaseBehaviour! : TicketCoverPurchaseBehaviour.Optional,
    };
};

export const aTicketTicketCover = (overrides?: Partial<TicketTicketCover>, _relationshipsToOmit: Set<string> = new Set()): TicketTicketCover => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TicketTicketCover');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '430e996b-cb51-4b50-97fc-6177a8ba0567',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-04-13T07:53:13.448Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-09-02T04:31:12.205Z",
        perTicketAmount: overrides && overrides.hasOwnProperty('perTicketAmount') ? overrides.perTicketAmount! : 9,
        orderTicketCover: overrides && overrides.hasOwnProperty('orderTicketCover') ? overrides.orderTicketCover! : relationshipsToOmit.has('OrderTicketCover') ? {} as OrderTicketCover : anOrderTicketCover({}, relationshipsToOmit),
    };
};

export const aReferralCode = (overrides?: Partial<ReferralCode>, _relationshipsToOmit: Set<string> = new Set()): ReferralCode => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ReferralCode');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'e6092488-9289-4b45-8a18-d68189e8e2cd',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-03-30T02:06:42.432Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-10-28T12:28:13.187Z",
    };
};

export const anOrderTax = (overrides?: Partial<OrderTax>, _relationshipsToOmit: Set<string> = new Set()): OrderTax => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OrderTax');
    return {
        totalInclusive: overrides && overrides.hasOwnProperty('totalInclusive') ? overrides.totalInclusive! : 0.6,
        totalExclusive: overrides && overrides.hasOwnProperty('totalExclusive') ? overrides.totalExclusive! : 0.3,
        tax: overrides && overrides.hasOwnProperty('tax') ? overrides.tax! : [relationshipsToOmit.has('TaxApplied') ? {} as TaxApplied : aTaxApplied({}, relationshipsToOmit)],
    };
};

export const aTaxApplied = (overrides?: Partial<TaxApplied>, _relationshipsToOmit: Set<string> = new Set()): TaxApplied => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TaxApplied');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'vapulus',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 9.4,
        isExclusive: overrides && overrides.hasOwnProperty('isExclusive') ? overrides.isExclusive! : true,
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 7,
    };
};

export const anOrderPlan = (overrides?: Partial<OrderPlan>, _relationshipsToOmit: Set<string> = new Set()): OrderPlan => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OrderPlan');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '6995e8b6-83d4-45cd-8668-254624c197ed',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-07-04T18:52:47.400Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2026-01-11T12:33:36.948Z",
        orderId: overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'vere',
        schedule: overrides && overrides.hasOwnProperty('schedule') ? overrides.schedule! : relationshipsToOmit.has('ScheduleOption') ? {} as ScheduleOption : aScheduleOption({}, relationshipsToOmit),
        stripeSubscriptionId: overrides && overrides.hasOwnProperty('stripeSubscriptionId') ? overrides.stripeSubscriptionId! : 'decretum',
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : OrderPlanStatus.Pending,
        payments: overrides && overrides.hasOwnProperty('payments') ? overrides.payments! : [relationshipsToOmit.has('OrderPlanPayment') ? {} as OrderPlanPayment : anOrderPlanPayment({}, relationshipsToOmit)],
        billingDetails: overrides && overrides.hasOwnProperty('billingDetails') ? overrides.billingDetails! : relationshipsToOmit.has('BillingDetails') ? {} as BillingDetails : aBillingDetails({}, relationshipsToOmit),
        allowEarlyAccess: overrides && overrides.hasOwnProperty('allowEarlyAccess') ? overrides.allowEarlyAccess! : false,
    };
};

export const anOrderPlanPayment = (overrides?: Partial<OrderPlanPayment>, _relationshipsToOmit: Set<string> = new Set()): OrderPlanPayment => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OrderPlanPayment');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '72bb5570-4421-4bc6-b8ff-d3f440cb9047',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-10-19T16:06:37.817Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-06-26T19:21:59.196Z",
        amountDue: overrides && overrides.hasOwnProperty('amountDue') ? overrides.amountDue! : 7.8,
        dueAt: overrides && overrides.hasOwnProperty('dueAt') ? overrides.dueAt! : "2026-02-02T10:21:30.341Z",
        paidAt: overrides && overrides.hasOwnProperty('paidAt') ? overrides.paidAt! : "2026-02-25T18:14:18.921Z",
        refundedAt: overrides && overrides.hasOwnProperty('refundedAt') ? overrides.refundedAt! : "2025-06-30T17:42:15.915Z",
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : OrderPlanPaymentStatus.Upcoming,
        stripeInvoiceUrl: overrides && overrides.hasOwnProperty('stripeInvoiceUrl') ? overrides.stripeInvoiceUrl! : 'somnus',
        stripePaymentIntentId: overrides && overrides.hasOwnProperty('stripePaymentIntentId') ? overrides.stripePaymentIntentId! : 'argumentum',
        attemptCount: overrides && overrides.hasOwnProperty('attemptCount') ? overrides.attemptCount! : 2.1,
        failureReason: overrides && overrides.hasOwnProperty('failureReason') ? overrides.failureReason! : 'una',
    };
};

export const aBillingDetails = (overrides?: Partial<BillingDetails>, _relationshipsToOmit: Set<string> = new Set()): BillingDetails => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BillingDetails');
    return {
        cardLast4: overrides && overrides.hasOwnProperty('cardLast4') ? overrides.cardLast4! : 'ciminatio',
        cardBrand: overrides && overrides.hasOwnProperty('cardBrand') ? overrides.cardBrand! : 'amplexus',
        cardExpiryMonth: overrides && overrides.hasOwnProperty('cardExpiryMonth') ? overrides.cardExpiryMonth! : 5.9,
        cardExpiryYear: overrides && overrides.hasOwnProperty('cardExpiryYear') ? overrides.cardExpiryYear! : 8.7,
        stripeCustomerId: overrides && overrides.hasOwnProperty('stripeCustomerId') ? overrides.stripeCustomerId! : 'surgo',
        totalPaymentCount: overrides && overrides.hasOwnProperty('totalPaymentCount') ? overrides.totalPaymentCount! : 5.3,
        completedPaymentCount: overrides && overrides.hasOwnProperty('completedPaymentCount') ? overrides.completedPaymentCount! : 10,
        amountPaid: overrides && overrides.hasOwnProperty('amountPaid') ? overrides.amountPaid! : 1.6,
        totalFeeAmount: overrides && overrides.hasOwnProperty('totalFeeAmount') ? overrides.totalFeeAmount! : 10,
    };
};

export const aPaymentIntegrationOutput = (overrides?: Partial<PaymentIntegrationOutput>, _relationshipsToOmit: Set<string> = new Set()): PaymentIntegrationOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PaymentIntegrationOutput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '0286fb1e-a487-40a7-9bf9-282eccbf5817',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-06-22T16:16:05.719Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-11-14T15:28:18.103Z",
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : IntegrationType.PaymentStripe,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'amet',
        publicKey: overrides && overrides.hasOwnProperty('publicKey') ? overrides.publicKey! : 'desparatus',
        webhookUrl: overrides && overrides.hasOwnProperty('webhookUrl') ? overrides.webhookUrl! : 'tenax',
        transactionFeeType: overrides && overrides.hasOwnProperty('transactionFeeType') ? overrides.transactionFeeType! : FeeType.FlatRate,
        transactionFee: overrides && overrides.hasOwnProperty('transactionFee') ? overrides.transactionFee! : 1.4,
        transactionFeeType2: overrides && overrides.hasOwnProperty('transactionFeeType2') ? overrides.transactionFeeType2! : FeeType.FlatRate,
        transactionFee2: overrides && overrides.hasOwnProperty('transactionFee2') ? overrides.transactionFee2! : 2.9,
        paymentMethodType: overrides && overrides.hasOwnProperty('paymentMethodType') ? overrides.paymentMethodType! : 'atavus',
        facebookPageId: overrides && overrides.hasOwnProperty('facebookPageId') ? overrides.facebookPageId! : 'color',
        facebookUserId: overrides && overrides.hasOwnProperty('facebookUserId') ? overrides.facebookUserId! : 'dolor',
        bnplEnabled: overrides && overrides.hasOwnProperty('bnplEnabled') ? overrides.bnplEnabled! : true,
        expressCheckoutEnabled: overrides && overrides.hasOwnProperty('expressCheckoutEnabled') ? overrides.expressCheckoutEnabled! : false,
        bnplTransactionFeePercent: overrides && overrides.hasOwnProperty('bnplTransactionFeePercent') ? overrides.bnplTransactionFeePercent! : 3.7,
        daysAfterCanRefund: overrides && overrides.hasOwnProperty('daysAfterCanRefund') ? overrides.daysAfterCanRefund! : 5458,
        stripeConnectAccount: overrides && overrides.hasOwnProperty('stripeConnectAccount') ? overrides.stripeConnectAccount! : relationshipsToOmit.has('StripeConnectAccount') ? {} as StripeConnectAccount : aStripeConnectAccount({}, relationshipsToOmit),
    };
};

export const aTransactionOrderByInput = (overrides?: Partial<TransactionOrderByInput>, _relationshipsToOmit: Set<string> = new Set()): TransactionOrderByInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TransactionOrderByInput');
    return {
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : OrderByDirection.Asc,
    };
};

export const anOrderTransactionConnection = (overrides?: Partial<OrderTransactionConnection>, _relationshipsToOmit: Set<string> = new Set()): OrderTransactionConnection => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OrderTransactionConnection');
    return {
        pageInfo: overrides && overrides.hasOwnProperty('pageInfo') ? overrides.pageInfo! : relationshipsToOmit.has('PageInfo') ? {} as PageInfo : aPageInfo({}, relationshipsToOmit),
        edges: overrides && overrides.hasOwnProperty('edges') ? overrides.edges! : [relationshipsToOmit.has('OrderTransactionEdge') ? {} as OrderTransactionEdge : anOrderTransactionEdge({}, relationshipsToOmit)],
        totalCount: overrides && overrides.hasOwnProperty('totalCount') ? overrides.totalCount! : 8300,
    };
};

export const anOrderTransactionEdge = (overrides?: Partial<OrderTransactionEdge>, _relationshipsToOmit: Set<string> = new Set()): OrderTransactionEdge => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OrderTransactionEdge');
    return {
        cursor: overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'odio',
        node: overrides && overrides.hasOwnProperty('node') ? overrides.node! : relationshipsToOmit.has('OrderTransaction') ? {} as OrderTransaction : anOrderTransaction({}, relationshipsToOmit),
    };
};

export const anOrderTransaction = (overrides?: Partial<OrderTransaction>, _relationshipsToOmit: Set<string> = new Set()): OrderTransaction => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OrderTransaction');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '798d5097-c8f4-4ec7-85fd-31f784e7cddb',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-04-22T14:07:34.855Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2026-01-17T10:08:21.569Z",
        kind: overrides && overrides.hasOwnProperty('kind') ? overrides.kind! : OrderTransactionKind.Sale,
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : OrderTransactionStatus.Waiting,
        amount: overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 3.3,
        stripePaymentMethod: overrides && overrides.hasOwnProperty('stripePaymentMethod') ? overrides.stripePaymentMethod! : StripePaymentMethod.CreditCard,
        platformAdjustment: overrides && overrides.hasOwnProperty('platformAdjustment') ? overrides.platformAdjustment! : 3.9,
    };
};

export const aPosTransactionOrderByInput = (overrides?: Partial<PosTransactionOrderByInput>, _relationshipsToOmit: Set<string> = new Set()): PosTransactionOrderByInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PosTransactionOrderByInput');
    return {
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : OrderByDirection.Asc,
    };
};

export const aPosTransactionConnection = (overrides?: Partial<PosTransactionConnection>, _relationshipsToOmit: Set<string> = new Set()): PosTransactionConnection => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PosTransactionConnection');
    return {
        pageInfo: overrides && overrides.hasOwnProperty('pageInfo') ? overrides.pageInfo! : relationshipsToOmit.has('PageInfo') ? {} as PageInfo : aPageInfo({}, relationshipsToOmit),
        edges: overrides && overrides.hasOwnProperty('edges') ? overrides.edges! : [relationshipsToOmit.has('PosTransactionEdge') ? {} as PosTransactionEdge : aPosTransactionEdge({}, relationshipsToOmit)],
        totalCount: overrides && overrides.hasOwnProperty('totalCount') ? overrides.totalCount! : 7766,
    };
};

export const aPosTransactionEdge = (overrides?: Partial<PosTransactionEdge>, _relationshipsToOmit: Set<string> = new Set()): PosTransactionEdge => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PosTransactionEdge');
    return {
        cursor: overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'blandior',
        node: overrides && overrides.hasOwnProperty('node') ? overrides.node! : relationshipsToOmit.has('PosTransaction') ? {} as PosTransaction : aPosTransaction({}, relationshipsToOmit),
    };
};

export const aPosTransaction = (overrides?: Partial<PosTransaction>, _relationshipsToOmit: Set<string> = new Set()): PosTransaction => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PosTransaction');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'af90f62d-dbb4-4f21-9810-1441949a7bfb',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-11-13T15:08:24.857Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-11-07T06:58:35.902Z",
        order: overrides && overrides.hasOwnProperty('order') ? overrides.order! : relationshipsToOmit.has('Order') ? {} as Order : anOrder({}, relationshipsToOmit),
        paymentGateway: overrides && overrides.hasOwnProperty('paymentGateway') ? overrides.paymentGateway! : PaymentProvider.Stripe,
        amount: overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 8.5,
        fee: overrides && overrides.hasOwnProperty('fee') ? overrides.fee! : 9,
        returned: overrides && overrides.hasOwnProperty('returned') ? overrides.returned! : 5.8,
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : OrderTransactionStatus.Waiting,
    };
};

export const aLineItemConnection = (overrides?: Partial<LineItemConnection>, _relationshipsToOmit: Set<string> = new Set()): LineItemConnection => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LineItemConnection');
    return {
        pageInfo: overrides && overrides.hasOwnProperty('pageInfo') ? overrides.pageInfo! : relationshipsToOmit.has('PageInfo') ? {} as PageInfo : aPageInfo({}, relationshipsToOmit),
        edges: overrides && overrides.hasOwnProperty('edges') ? overrides.edges! : [relationshipsToOmit.has('LineItemEdge') ? {} as LineItemEdge : aLineItemEdge({}, relationshipsToOmit)],
        totalCount: overrides && overrides.hasOwnProperty('totalCount') ? overrides.totalCount! : 8257,
    };
};

export const aLineItemEdge = (overrides?: Partial<LineItemEdge>, _relationshipsToOmit: Set<string> = new Set()): LineItemEdge => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LineItemEdge');
    return {
        cursor: overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'toties',
        node: overrides && overrides.hasOwnProperty('node') ? overrides.node! : relationshipsToOmit.has('LineItem') ? {} as LineItem : aLineItem({}, relationshipsToOmit),
    };
};

export const aLineItem = (overrides?: Partial<LineItem>, _relationshipsToOmit: Set<string> = new Set()): LineItem => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LineItem');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '255b91fd-f169-4256-92dc-1b4da5e0d04c',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-04-16T19:36:30.413Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-11-20T00:09:28.175Z",
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : LineItemType.Ticket,
        ticketType: overrides && overrides.hasOwnProperty('ticketType') ? overrides.ticketType! : relationshipsToOmit.has('TicketType') ? {} as TicketType : aTicketType({}, relationshipsToOmit),
        release: overrides && overrides.hasOwnProperty('release') ? overrides.release! : relationshipsToOmit.has('Release') ? {} as Release : aRelease({}, relationshipsToOmit),
        membershipType: overrides && overrides.hasOwnProperty('membershipType') ? overrides.membershipType! : relationshipsToOmit.has('MembershipType') ? {} as MembershipType : aMembershipType({}, relationshipsToOmit),
        eventAddon: overrides && overrides.hasOwnProperty('eventAddon') ? overrides.eventAddon! : relationshipsToOmit.has('EventAddon') ? {} as EventAddon : anEventAddon({}, relationshipsToOmit),
        membershipAddon: overrides && overrides.hasOwnProperty('membershipAddon') ? overrides.membershipAddon! : relationshipsToOmit.has('MembershipAddon') ? {} as MembershipAddon : aMembershipAddon({}, relationshipsToOmit),
        seatLabel: overrides && overrides.hasOwnProperty('seatLabel') ? overrides.seatLabel! : 'aestivus',
        seatZone: overrides && overrides.hasOwnProperty('seatZone') ? overrides.seatZone! : 'tres',
        seatZoneEntity: overrides && overrides.hasOwnProperty('seatZoneEntity') ? overrides.seatZoneEntity! : relationshipsToOmit.has('Zone') ? {} as Zone : aZone({}, relationshipsToOmit),
        seatSection: overrides && overrides.hasOwnProperty('seatSection') ? overrides.seatSection! : 'patruus',
        seatSectionEntity: overrides && overrides.hasOwnProperty('seatSectionEntity') ? overrides.seatSectionEntity! : relationshipsToOmit.has('Section') ? {} as Section : aSection({}, relationshipsToOmit),
        seatType: overrides && overrides.hasOwnProperty('seatType') ? overrides.seatType! : SeatType.Seat,
        seatTags: overrides && overrides.hasOwnProperty('seatTags') ? overrides.seatTags! : ['temperantia'],
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'cubicularis',
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 6.9,
        stadiumLevyFee: overrides && overrides.hasOwnProperty('stadiumLevyFee') ? overrides.stadiumLevyFee! : 7.4,
        originalPrice: overrides && overrides.hasOwnProperty('originalPrice') ? overrides.originalPrice! : 0.7,
        quantity: overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 8,
        ticketFeeType: overrides && overrides.hasOwnProperty('ticketFeeType') ? overrides.ticketFeeType! : FeeType.FlatRate,
        ticketFee: overrides && overrides.hasOwnProperty('ticketFee') ? overrides.ticketFee! : 3.1,
        taxRate: overrides && overrides.hasOwnProperty('taxRate') ? overrides.taxRate! : 7.8,
        taxCalculationMethod: overrides && overrides.hasOwnProperty('taxCalculationMethod') ? overrides.taxCalculationMethod! : TaxCalculationMethod.Inclusive,
        isComp: overrides && overrides.hasOwnProperty('isComp') ? overrides.isComp! : true,
        pointItem: overrides && overrides.hasOwnProperty('pointItem') ? overrides.pointItem! : relationshipsToOmit.has('PointItem') ? {} as PointItem : aPointItem({}, relationshipsToOmit),
        ticketFeeAmount: overrides && overrides.hasOwnProperty('ticketFeeAmount') ? overrides.ticketFeeAmount! : 9,
        pricingTierId: overrides && overrides.hasOwnProperty('pricingTierId') ? overrides.pricingTierId! : 'demo',
        totalPerUnit: overrides && overrides.hasOwnProperty('totalPerUnit') ? overrides.totalPerUnit! : 9.2,
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 7.3,
        taxAmount: overrides && overrides.hasOwnProperty('taxAmount') ? overrides.taxAmount! : 4.2,
        customTaxRate: overrides && overrides.hasOwnProperty('customTaxRate') ? overrides.customTaxRate! : 1,
        customTaxAmount: overrides && overrides.hasOwnProperty('customTaxAmount') ? overrides.customTaxAmount! : 2.1,
        pricingTierName: overrides && overrides.hasOwnProperty('pricingTierName') ? overrides.pricingTierName! : 'amplexus',
    };
};

export const aTicket = (overrides?: Partial<Ticket>, _relationshipsToOmit: Set<string> = new Set()): Ticket => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Ticket');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'e6e5ed9b-225b-4f05-9bd7-e71aef6aae14',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-04-18T08:29:40.712Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-03-16T21:22:45.472Z",
        user: overrides && overrides.hasOwnProperty('user') ? overrides.user! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        ticketNumber: overrides && overrides.hasOwnProperty('ticketNumber') ? overrides.ticketNumber! : 'tabgo',
        origin: overrides && overrides.hasOwnProperty('origin') ? overrides.origin! : TicketOrigin.Order,
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : TicketStatus.Active,
        event: overrides && overrides.hasOwnProperty('event') ? overrides.event! : relationshipsToOmit.has('Event') ? {} as Event : anEvent({}, relationshipsToOmit),
        release: overrides && overrides.hasOwnProperty('release') ? overrides.release! : relationshipsToOmit.has('Release') ? {} as Release : aRelease({}, relationshipsToOmit),
        seatLabel: overrides && overrides.hasOwnProperty('seatLabel') ? overrides.seatLabel! : 'vinco',
        seatZone: overrides && overrides.hasOwnProperty('seatZone') ? overrides.seatZone! : 'alius',
        seatZoneEntity: overrides && overrides.hasOwnProperty('seatZoneEntity') ? overrides.seatZoneEntity! : relationshipsToOmit.has('Zone') ? {} as Zone : aZone({}, relationshipsToOmit),
        seatSection: overrides && overrides.hasOwnProperty('seatSection') ? overrides.seatSection! : 'carcer',
        seatSectionEntity: overrides && overrides.hasOwnProperty('seatSectionEntity') ? overrides.seatSectionEntity! : relationshipsToOmit.has('Section') ? {} as Section : aSection({}, relationshipsToOmit),
        seatType: overrides && overrides.hasOwnProperty('seatType') ? overrides.seatType! : SeatType.Seat,
        seatTags: overrides && overrides.hasOwnProperty('seatTags') ? overrides.seatTags! : ['in'],
        hasReleasedNextMembershipClaim: overrides && overrides.hasOwnProperty('hasReleasedNextMembershipClaim') ? overrides.hasReleasedNextMembershipClaim! : true,
        ticketTransfer: overrides && overrides.hasOwnProperty('ticketTransfer') ? overrides.ticketTransfer! : relationshipsToOmit.has('TicketTransfer') ? {} as TicketTransfer : aTicketTransfer({}, relationshipsToOmit),
        isNamed: overrides && overrides.hasOwnProperty('isNamed') ? overrides.isNamed! : true,
        firstName: overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'villa',
        lastName: overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'aptus',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'sodalitas',
        phoneNumber: overrides && overrides.hasOwnProperty('phoneNumber') ? overrides.phoneNumber! : 'cohibeo',
        birthDate: overrides && overrides.hasOwnProperty('birthDate') ? overrides.birthDate! : "2025-11-09T03:35:40.904Z",
        gender: overrides && overrides.hasOwnProperty('gender') ? overrides.gender! : Gender.Male,
        postalCode: overrides && overrides.hasOwnProperty('postalCode') ? overrides.postalCode! : 'capio',
        companyName: overrides && overrides.hasOwnProperty('companyName') ? overrides.companyName! : 'casus',
        memberSince: overrides && overrides.hasOwnProperty('memberSince') ? overrides.memberSince! : "2025-06-07T00:32:45.773Z",
        licensePlate: overrides && overrides.hasOwnProperty('licensePlate') ? overrides.licensePlate! : 'blanditiis',
        membershipNumber: overrides && overrides.hasOwnProperty('membershipNumber') ? overrides.membershipNumber! : 'tricesimus',
        comments: overrides && overrides.hasOwnProperty('comments') ? overrides.comments! : 'caecus',
        dietaryRequirements: overrides && overrides.hasOwnProperty('dietaryRequirements') ? overrides.dietaryRequirements! : 'decor',
        lengthOfStay: overrides && overrides.hasOwnProperty('lengthOfStay') ? overrides.lengthOfStay! : 'vigilo',
        usableForEmailMarketing: overrides && overrides.hasOwnProperty('usableForEmailMarketing') ? overrides.usableForEmailMarketing! : false,
        usableForSMSMarketing: overrides && overrides.hasOwnProperty('usableForSMSMarketing') ? overrides.usableForSMSMarketing! : true,
        vaccinePass: overrides && overrides.hasOwnProperty('vaccinePass') ? overrides.vaccinePass! : relationshipsToOmit.has('VaccinePass') ? {} as VaccinePass : aVaccinePass({}, relationshipsToOmit),
        emergencyName: overrides && overrides.hasOwnProperty('emergencyName') ? overrides.emergencyName! : 'absorbeo',
        emergencyContact: overrides && overrides.hasOwnProperty('emergencyContact') ? overrides.emergencyContact! : 'alter',
        emergencyContactRelationship: overrides && overrides.hasOwnProperty('emergencyContactRelationship') ? overrides.emergencyContactRelationship! : 'atque',
        customFields: overrides && overrides.hasOwnProperty('customFields') ? overrides.customFields! : [relationshipsToOmit.has('CustomField') ? {} as CustomField : aCustomField({}, relationshipsToOmit)],
        dunedinResidentialAddress: overrides && overrides.hasOwnProperty('dunedinResidentialAddress') ? overrides.dunedinResidentialAddress! : 'atque',
        studentId: overrides && overrides.hasOwnProperty('studentId') ? overrides.studentId! : 'usque',
        membershipSubscriptionId: overrides && overrides.hasOwnProperty('membershipSubscriptionId') ? overrides.membershipSubscriptionId! : 'vir',
        preprint: overrides && overrides.hasOwnProperty('preprint') ? overrides.preprint! : "2025-11-01T05:33:38.198Z",
        scans: overrides && overrides.hasOwnProperty('scans') ? overrides.scans! : [relationshipsToOmit.has('Scan') ? {} as Scan : aScan({}, relationshipsToOmit)],
        ticketSendFields: overrides && overrides.hasOwnProperty('ticketSendFields') ? overrides.ticketSendFields! : [relationshipsToOmit.has('TicketSendFields') ? {} as TicketSendFields : aTicketSendFields({}, relationshipsToOmit)],
        firstScanIn: overrides && overrides.hasOwnProperty('firstScanIn') ? overrides.firstScanIn! : relationshipsToOmit.has('Scan') ? {} as Scan : aScan({}, relationshipsToOmit),
        lastScanOut: overrides && overrides.hasOwnProperty('lastScanOut') ? overrides.lastScanOut! : relationshipsToOmit.has('Scan') ? {} as Scan : aScan({}, relationshipsToOmit),
        ticketCover: overrides && overrides.hasOwnProperty('ticketCover') ? overrides.ticketCover! : relationshipsToOmit.has('TicketTicketCover') ? {} as TicketTicketCover : aTicketTicketCover({}, relationshipsToOmit),
        downloadCount: overrides && overrides.hasOwnProperty('downloadCount') ? overrides.downloadCount! : 1.1,
        firstScanInId: overrides && overrides.hasOwnProperty('firstScanInId') ? overrides.firstScanInId! : 'constans',
        gates: overrides && overrides.hasOwnProperty('gates') ? overrides.gates! : [relationshipsToOmit.has('Gate') ? {} as Gate : aGate({}, relationshipsToOmit)],
        membershipType: overrides && overrides.hasOwnProperty('membershipType') ? overrides.membershipType! : relationshipsToOmit.has('MembershipType') ? {} as MembershipType : aMembershipType({}, relationshipsToOmit),
        ticketType: overrides && overrides.hasOwnProperty('ticketType') ? overrides.ticketType! : relationshipsToOmit.has('TicketType') ? {} as TicketType : aTicketType({}, relationshipsToOmit),
        lineItem: overrides && overrides.hasOwnProperty('lineItem') ? overrides.lineItem! : relationshipsToOmit.has('LineItem') ? {} as LineItem : aLineItem({}, relationshipsToOmit),
        maxTransferPrice: overrides && overrides.hasOwnProperty('maxTransferPrice') ? overrides.maxTransferPrice! : 1.2,
        order: overrides && overrides.hasOwnProperty('order') ? overrides.order! : relationshipsToOmit.has('Order') ? {} as Order : anOrder({}, relationshipsToOmit),
        isHold: overrides && overrides.hasOwnProperty('isHold') ? overrides.isHold! : true,
        displayName: overrides && overrides.hasOwnProperty('displayName') ? overrides.displayName! : 'abundans',
        parentTicketNumber: overrides && overrides.hasOwnProperty('parentTicketNumber') ? overrides.parentTicketNumber! : 'culpa',
        transferFee: overrides && overrides.hasOwnProperty('transferFee') ? overrides.transferFee! : relationshipsToOmit.has('TicketTransferFee') ? {} as TicketTransferFee : aTicketTransferFee({}, relationshipsToOmit),
        digitalPassCode: overrides && overrides.hasOwnProperty('digitalPassCode') ? overrides.digitalPassCode! : 'tollo',
        digitalEventUrl: overrides && overrides.hasOwnProperty('digitalEventUrl') ? overrides.digitalEventUrl! : 'aggredior',
        shouldBeNamed: overrides && overrides.hasOwnProperty('shouldBeNamed') ? overrides.shouldBeNamed! : true,
        qrCode: overrides && overrides.hasOwnProperty('qrCode') ? overrides.qrCode! : 'quidem',
        hasRenewedMembership: overrides && overrides.hasOwnProperty('hasRenewedMembership') ? overrides.hasRenewedMembership! : true,
        parentTicket: overrides && overrides.hasOwnProperty('parentTicket') ? overrides.parentTicket! : relationshipsToOmit.has('Ticket') ? {} as Ticket : aTicket({}, relationshipsToOmit),
        childTickets: overrides && overrides.hasOwnProperty('childTickets') ? overrides.childTickets! : [relationshipsToOmit.has('Ticket') ? {} as Ticket : aTicket({}, relationshipsToOmit)],
        membership: overrides && overrides.hasOwnProperty('membership') ? overrides.membership! : relationshipsToOmit.has('Membership') ? {} as Membership : aMembership({}, relationshipsToOmit),
        addon: overrides && overrides.hasOwnProperty('addon') ? overrides.addon! : relationshipsToOmit.has('EventAddon') ? {} as EventAddon : anEventAddon({}, relationshipsToOmit),
        transferStatus: overrides && overrides.hasOwnProperty('transferStatus') ? overrides.transferStatus! : TicketTransferStatus.Pending,
        resellabilityState: overrides && overrides.hasOwnProperty('resellabilityState') ? overrides.resellabilityState! : relationshipsToOmit.has('TicketResellabilityState') ? {} as TicketResellabilityState : aTicketResellabilityState({}, relationshipsToOmit),
        purchaseRestrictionText: overrides && overrides.hasOwnProperty('purchaseRestrictionText') ? overrides.purchaseRestrictionText! : ['solus'],
        isReleasable: overrides && overrides.hasOwnProperty('isReleasable') ? overrides.isReleasable! : false,
    };
};

export const aTicketTransfer = (overrides?: Partial<TicketTransfer>, _relationshipsToOmit: Set<string> = new Set()): TicketTransfer => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TicketTransfer');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '03cb23ee-b340-4862-b41f-eab1823c51b6',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-04-08T21:40:28.720Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-10-04T06:32:26.200Z",
        transferStatus: overrides && overrides.hasOwnProperty('transferStatus') ? overrides.transferStatus! : TicketTransferStatus.Pending,
        newOwnerEmail: overrides && overrides.hasOwnProperty('newOwnerEmail') ? overrides.newOwnerEmail! : 'adsum',
        buyerTransferFee: overrides && overrides.hasOwnProperty('buyerTransferFee') ? overrides.buyerTransferFee! : 3.9,
        sellerTransferFee: overrides && overrides.hasOwnProperty('sellerTransferFee') ? overrides.sellerTransferFee! : 3.7,
        originalLineItemPrice: overrides && overrides.hasOwnProperty('originalLineItemPrice') ? overrides.originalLineItemPrice! : 2.9,
        newLineItemPrice: overrides && overrides.hasOwnProperty('newLineItemPrice') ? overrides.newLineItemPrice! : 8.5,
        transferGroupId: overrides && overrides.hasOwnProperty('transferGroupId') ? overrides.transferGroupId! : 'degusto',
    };
};

export const aVaccinePass = (overrides?: Partial<VaccinePass>, _relationshipsToOmit: Set<string> = new Set()): VaccinePass => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('VaccinePass');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'aa3573c5-c383-40f5-9e25-bf8fd2156aa3',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2026-01-01T23:15:06.260Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2026-02-02T13:11:45.111Z",
        user: overrides && overrides.hasOwnProperty('user') ? overrides.user! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        ticket: overrides && overrides.hasOwnProperty('ticket') ? overrides.ticket! : relationshipsToOmit.has('Ticket') ? {} as Ticket : aTicket({}, relationshipsToOmit),
        payload: overrides && overrides.hasOwnProperty('payload') ? overrides.payload! : 'somniculosus',
        payloadDecoded: overrides && overrides.hasOwnProperty('payloadDecoded') ? overrides.payloadDecoded! : 'velut',
    };
};

export const aCustomField = (overrides?: Partial<CustomField>, _relationshipsToOmit: Set<string> = new Set()): CustomField => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CustomField');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'fuga',
        fieldName: overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'arbitro',
        fieldValue: overrides && overrides.hasOwnProperty('fieldValue') ? overrides.fieldValue! : 'cupio',
    };
};

export const aScan = (overrides?: Partial<Scan>, _relationshipsToOmit: Set<string> = new Set()): Scan => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Scan');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '4b0451a7-16a9-4d94-9b05-3f2b39901e14',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-04-15T04:43:08.321Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-08-14T05:56:52.519Z",
        scannedAt: overrides && overrides.hasOwnProperty('scannedAt') ? overrides.scannedAt! : "2026-01-16T15:13:56.003Z",
        event: overrides && overrides.hasOwnProperty('event') ? overrides.event! : relationshipsToOmit.has('Event') ? {} as Event : anEvent({}, relationshipsToOmit),
        direction: overrides && overrides.hasOwnProperty('direction') ? overrides.direction! : TicketScanDirection.ScanIn,
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : TicketScanType.Eticket,
        gate: overrides && overrides.hasOwnProperty('gate') ? overrides.gate! : relationshipsToOmit.has('Gate') ? {} as Gate : aGate({}, relationshipsToOmit),
        hasScannedParentTicket: overrides && overrides.hasOwnProperty('hasScannedParentTicket') ? overrides.hasScannedParentTicket! : true,
        isOffline: overrides && overrides.hasOwnProperty('isOffline') ? overrides.isOffline! : true,
    };
};

export const aTicketSendFields = (overrides?: Partial<TicketSendFields>, _relationshipsToOmit: Set<string> = new Set()): TicketSendFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TicketSendFields');
    return {
        active: overrides && overrides.hasOwnProperty('active') ? overrides.active! : false,
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'demum',
    };
};

export const aTicketTransferFee = (overrides?: Partial<TicketTransferFee>, _relationshipsToOmit: Set<string> = new Set()): TicketTransferFee => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TicketTransferFee');
    return {
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : TransferFeeType.Buyer,
        fee: overrides && overrides.hasOwnProperty('fee') ? overrides.fee! : 6.6,
    };
};

export const aTicketResellabilityState = (overrides?: Partial<TicketResellabilityState>, _relationshipsToOmit: Set<string> = new Set()): TicketResellabilityState => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TicketResellabilityState');
    return {
        ticketTransferAllowed: overrides && overrides.hasOwnProperty('ticketTransferAllowed') ? overrides.ticketTransferAllowed! : false,
        ticketResaleAllowed: overrides && overrides.hasOwnProperty('ticketResaleAllowed') ? overrides.ticketResaleAllowed! : false,
        hoursLeftToTransfer: overrides && overrides.hasOwnProperty('hoursLeftToTransfer') ? overrides.hoursLeftToTransfer! : 7.2,
        afterpayRefundWindow: overrides && overrides.hasOwnProperty('afterpayRefundWindow') ? overrides.afterpayRefundWindow! : 2.3,
        latestTransferCompletionDate: overrides && overrides.hasOwnProperty('latestTransferCompletionDate') ? overrides.latestTransferCompletionDate! : "2025-11-24T02:27:52.092Z",
        reason: overrides && overrides.hasOwnProperty('reason') ? overrides.reason! : 'cetera',
    };
};

export const anEventPromoCode = (overrides?: Partial<EventPromoCode>, _relationshipsToOmit: Set<string> = new Set()): EventPromoCode => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EventPromoCode');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '5e9b9979-f6bf-49a5-93bd-03e330c49a94',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-08-16T16:26:49.398Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-03-27T06:42:35.287Z",
        code: overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'concedo',
        discountType: overrides && overrides.hasOwnProperty('discountType') ? overrides.discountType! : DiscountType.Percentage,
        discountAmount: overrides && overrides.hasOwnProperty('discountAmount') ? overrides.discountAmount! : 0,
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : EventPromoCodeType.EventAndAddons,
        ticketTypes: overrides && overrides.hasOwnProperty('ticketTypes') ? overrides.ticketTypes! : ['apud'],
        eventAddons: overrides && overrides.hasOwnProperty('eventAddons') ? overrides.eventAddons! : ['defungo'],
        used: overrides && overrides.hasOwnProperty('used') ? overrides.used! : 6215,
        maxUsage: overrides && overrides.hasOwnProperty('maxUsage') ? overrides.maxUsage! : 2214,
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2026-01-01T19:56:50.933Z",
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : "2025-07-03T21:04:09.186Z",
        minOrderAmount: overrides && overrides.hasOwnProperty('minOrderAmount') ? overrides.minOrderAmount! : 4.4,
        maxOrderAmount: overrides && overrides.hasOwnProperty('maxOrderAmount') ? overrides.maxOrderAmount! : 3.4,
    };
};

export const aMembershipPromoCode = (overrides?: Partial<MembershipPromoCode>, _relationshipsToOmit: Set<string> = new Set()): MembershipPromoCode => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MembershipPromoCode');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'beaa9843-9a9b-4ee9-98c1-8caa77f048c7',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-11-23T14:30:01.295Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-07-08T07:29:53.744Z",
        code: overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'omnis',
        discountType: overrides && overrides.hasOwnProperty('discountType') ? overrides.discountType! : DiscountType.Percentage,
        discountAmount: overrides && overrides.hasOwnProperty('discountAmount') ? overrides.discountAmount! : 9.3,
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false,
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : MembershipPromoCodeType.MembershipAndAddons,
        membershipTypes: overrides && overrides.hasOwnProperty('membershipTypes') ? overrides.membershipTypes! : ['conservo'],
        membershipAddons: overrides && overrides.hasOwnProperty('membershipAddons') ? overrides.membershipAddons! : ['alo'],
        used: overrides && overrides.hasOwnProperty('used') ? overrides.used! : 5842,
        maxUsage: overrides && overrides.hasOwnProperty('maxUsage') ? overrides.maxUsage! : 664,
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2026-01-28T09:55:58.851Z",
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : "2025-06-28T14:32:08.630Z",
        minOrderAmount: overrides && overrides.hasOwnProperty('minOrderAmount') ? overrides.minOrderAmount! : 8.9,
        maxOrderAmount: overrides && overrides.hasOwnProperty('maxOrderAmount') ? overrides.maxOrderAmount! : 9.6,
    };
};

export const aHistoryOrderByInput = (overrides?: Partial<HistoryOrderByInput>, _relationshipsToOmit: Set<string> = new Set()): HistoryOrderByInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('HistoryOrderByInput');
    return {
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : OrderByDirection.Asc,
    };
};

export const aHistoryConnection = (overrides?: Partial<HistoryConnection>, _relationshipsToOmit: Set<string> = new Set()): HistoryConnection => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('HistoryConnection');
    return {
        pageInfo: overrides && overrides.hasOwnProperty('pageInfo') ? overrides.pageInfo! : relationshipsToOmit.has('PageInfo') ? {} as PageInfo : aPageInfo({}, relationshipsToOmit),
        edges: overrides && overrides.hasOwnProperty('edges') ? overrides.edges! : [relationshipsToOmit.has('HistoryEdge') ? {} as HistoryEdge : aHistoryEdge({}, relationshipsToOmit)],
        totalCount: overrides && overrides.hasOwnProperty('totalCount') ? overrides.totalCount! : 6793,
    };
};

export const aHistoryEdge = (overrides?: Partial<HistoryEdge>, _relationshipsToOmit: Set<string> = new Set()): HistoryEdge => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('HistoryEdge');
    return {
        cursor: overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'torrens',
        node: overrides && overrides.hasOwnProperty('node') ? overrides.node! : relationshipsToOmit.has('History') ? {} as History : aHistory({}, relationshipsToOmit),
    };
};

export const aHistory = (overrides?: Partial<History>, _relationshipsToOmit: Set<string> = new Set()): History => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('History');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'b82af84a-a0cf-49cb-8f24-d1cd51d0923c',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-10-24T10:14:54.426Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-05-11T19:38:35.177Z",
        refName: overrides && overrides.hasOwnProperty('refName') ? overrides.refName! : 'villa',
        user: overrides && overrides.hasOwnProperty('user') ? overrides.user! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'cruentus',
        scoutCommunication: overrides && overrides.hasOwnProperty('scoutCommunication') ? overrides.scoutCommunication! : relationshipsToOmit.has('Scout') ? {} as Scout : aScout({}, relationshipsToOmit),
        order: overrides && overrides.hasOwnProperty('order') ? overrides.order! : relationshipsToOmit.has('Order') ? {} as Order : anOrder({}, relationshipsToOmit),
        ticket: overrides && overrides.hasOwnProperty('ticket') ? overrides.ticket! : relationshipsToOmit.has('Ticket') ? {} as Ticket : aTicket({}, relationshipsToOmit),
    };
};

export const aRefund = (overrides?: Partial<Refund>, _relationshipsToOmit: Set<string> = new Set()): Refund => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Refund');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '68bc8f9c-a372-4cba-a7df-f1e8107cfcff',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-03-07T01:02:05.007Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-12-16T21:46:33.589Z",
        kind: overrides && overrides.hasOwnProperty('kind') ? overrides.kind! : RefundKind.Default,
        amount: overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 6.6,
        notes: overrides && overrides.hasOwnProperty('notes') ? overrides.notes! : 'uredo',
        isManual: overrides && overrides.hasOwnProperty('isManual') ? overrides.isManual! : false,
        gateway: overrides && overrides.hasOwnProperty('gateway') ? overrides.gateway! : RefundGateway.Cash,
    };
};

export const aRefundableState = (overrides?: Partial<RefundableState>, _relationshipsToOmit: Set<string> = new Set()): RefundableState => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RefundableState');
    return {
        refundState: overrides && overrides.hasOwnProperty('refundState') ? overrides.refundState! : OrderRefundState.FullGateway,
        totalRefundableAmount: overrides && overrides.hasOwnProperty('totalRefundableAmount') ? overrides.totalRefundableAmount! : 0.2,
        gatewayRefundableAmount: overrides && overrides.hasOwnProperty('gatewayRefundableAmount') ? overrides.gatewayRefundableAmount! : relationshipsToOmit.has('GatewayRefundableAmount') ? {} as GatewayRefundableAmount : aGatewayRefundableAmount({}, relationshipsToOmit),
    };
};

export const aGatewayRefundableAmount = (overrides?: Partial<GatewayRefundableAmount>, _relationshipsToOmit: Set<string> = new Set()): GatewayRefundableAmount => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('GatewayRefundableAmount');
    return {
        integrationName: overrides && overrides.hasOwnProperty('integrationName') ? overrides.integrationName! : 'conqueror',
        cardLabel: overrides && overrides.hasOwnProperty('cardLabel') ? overrides.cardLabel! : 'suspendo',
        refundedAmount: overrides && overrides.hasOwnProperty('refundedAmount') ? overrides.refundedAmount! : 0.6,
        refundableAmount: overrides && overrides.hasOwnProperty('refundableAmount') ? overrides.refundableAmount! : 2.2,
    };
};

export const aPos = (overrides?: Partial<Pos>, _relationshipsToOmit: Set<string> = new Set()): Pos => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Pos');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '8578218d-7a9a-4daf-a41b-bdbab799e21c',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2026-01-18T02:17:24.707Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-06-19T19:47:36.321Z",
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'correptius',
        bookingFeeType: overrides && overrides.hasOwnProperty('bookingFeeType') ? overrides.bookingFeeType! : FeeType.FlatRate,
        bookingFee: overrides && overrides.hasOwnProperty('bookingFee') ? overrides.bookingFee! : 9.2,
        paymentOptions: overrides && overrides.hasOwnProperty('paymentOptions') ? overrides.paymentOptions! : relationshipsToOmit.has('PosPaymentOptions') ? {} as PosPaymentOptions : aPosPaymentOptions({}, relationshipsToOmit),
        deliveryOptions: overrides && overrides.hasOwnProperty('deliveryOptions') ? overrides.deliveryOptions! : [ShippingOption.Eticket],
        cashAmount: overrides && overrides.hasOwnProperty('cashAmount') ? overrides.cashAmount! : 4.4,
        enableReceipts: overrides && overrides.hasOwnProperty('enableReceipts') ? overrides.enableReceipts! : true,
        autoPrintTickets: overrides && overrides.hasOwnProperty('autoPrintTickets') ? overrides.autoPrintTickets! : true,
        sessions: overrides && overrides.hasOwnProperty('sessions') ? overrides.sessions! : [relationshipsToOmit.has('PosSession') ? {} as PosSession : aPosSession({}, relationshipsToOmit)],
        isConnectedToTerminal: overrides && overrides.hasOwnProperty('isConnectedToTerminal') ? overrides.isConnectedToTerminal! : true,
        stripeTerminalLoginCode: overrides && overrides.hasOwnProperty('stripeTerminalLoginCode') ? overrides.stripeTerminalLoginCode! : 'umquam',
        canConnectToTerminal: overrides && overrides.hasOwnProperty('canConnectToTerminal') ? overrides.canConnectToTerminal! : true,
        event: overrides && overrides.hasOwnProperty('event') ? overrides.event! : relationshipsToOmit.has('Event') ? {} as Event : anEvent({}, relationshipsToOmit),
        release: overrides && overrides.hasOwnProperty('release') ? overrides.release! : relationshipsToOmit.has('Release') ? {} as Release : aRelease({}, relationshipsToOmit),
        users: overrides && overrides.hasOwnProperty('users') ? overrides.users! : [relationshipsToOmit.has('PosUser') ? {} as PosUser : aPosUser({}, relationshipsToOmit)],
    };
};

export const aPosPaymentOptions = (overrides?: Partial<PosPaymentOptions>, _relationshipsToOmit: Set<string> = new Set()): PosPaymentOptions => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PosPaymentOptions');
    return {
        cash: overrides && overrides.hasOwnProperty('cash') ? overrides.cash! : relationshipsToOmit.has('PosPaymentFee') ? {} as PosPaymentFee : aPosPaymentFee({}, relationshipsToOmit),
        eftpos: overrides && overrides.hasOwnProperty('eftpos') ? overrides.eftpos! : relationshipsToOmit.has('PosPaymentFee') ? {} as PosPaymentFee : aPosPaymentFee({}, relationshipsToOmit),
        cc: overrides && overrides.hasOwnProperty('cc') ? overrides.cc! : relationshipsToOmit.has('PosPaymentFee') ? {} as PosPaymentFee : aPosPaymentFee({}, relationshipsToOmit),
        MPAiSA: overrides && overrides.hasOwnProperty('MPAiSA') ? overrides.MPAiSA! : relationshipsToOmit.has('PosPaymentFee') ? {} as PosPaymentFee : aPosPaymentFee({}, relationshipsToOmit),
    };
};

export const aPosPaymentFee = (overrides?: Partial<PosPaymentFee>, _relationshipsToOmit: Set<string> = new Set()): PosPaymentFee => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PosPaymentFee');
    return {
        feeType: overrides && overrides.hasOwnProperty('feeType') ? overrides.feeType! : FeeType.FlatRate,
        feeAmount: overrides && overrides.hasOwnProperty('feeAmount') ? overrides.feeAmount! : 2.3,
    };
};

export const aPosSession = (overrides?: Partial<PosSession>, _relationshipsToOmit: Set<string> = new Set()): PosSession => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PosSession');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '9ba685c8-60e6-4305-b33c-e9d57719f574',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-10-03T20:18:20.829Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-08-21T14:29:31.442Z",
        pos: overrides && overrides.hasOwnProperty('pos') ? overrides.pos! : relationshipsToOmit.has('Pos') ? {} as Pos : aPos({}, relationshipsToOmit),
        operator: overrides && overrides.hasOwnProperty('operator') ? overrides.operator! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        startedAt: overrides && overrides.hasOwnProperty('startedAt') ? overrides.startedAt! : "2025-06-19T14:42:24.599Z",
        endedAt: overrides && overrides.hasOwnProperty('endedAt') ? overrides.endedAt! : "2025-08-04T12:17:40.282Z",
        startCash: overrides && overrides.hasOwnProperty('startCash') ? overrides.startCash! : 0.3,
        endCash: overrides && overrides.hasOwnProperty('endCash') ? overrides.endCash! : 8.1,
    };
};

export const aPosUser = (overrides?: Partial<PosUser>, _relationshipsToOmit: Set<string> = new Set()): PosUser => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PosUser');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'aae03dc1-9ab0-4868-bbf9-a1c2edb72fd1',
        firstName: overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'alienus',
        lastName: overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'conforto',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'corrigo',
        fullName: overrides && overrides.hasOwnProperty('fullName') ? overrides.fullName! : 'traho',
    };
};

export const aPrechargeOrderCancellation = (overrides?: Partial<PrechargeOrderCancellation>, _relationshipsToOmit: Set<string> = new Set()): PrechargeOrderCancellation => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PrechargeOrderCancellation');
    return {
        cancelledAt: overrides && overrides.hasOwnProperty('cancelledAt') ? overrides.cancelledAt! : "2025-10-09T22:19:02.057Z",
        cancelledByName: overrides && overrides.hasOwnProperty('cancelledByName') ? overrides.cancelledByName! : 'teres',
        cancelledByAdmin: overrides && overrides.hasOwnProperty('cancelledByAdmin') ? overrides.cancelledByAdmin! : true,
        cancellationSource: overrides && overrides.hasOwnProperty('cancellationSource') ? overrides.cancellationSource! : SetupIntentCancellationSource.CustomerOrderPage,
    };
};

export const aShopifyUser = (overrides?: Partial<ShopifyUser>, _relationshipsToOmit: Set<string> = new Set()): ShopifyUser => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ShopifyUser');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '73affd92-e645-4cc3-86bb-2e8209f0cb10',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-04-28T10:06:09.239Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-04-27T08:23:15.241Z",
        shopifyUserId: overrides && overrides.hasOwnProperty('shopifyUserId') ? overrides.shopifyUserId! : 'reprehenderit',
        totalSpent: overrides && overrides.hasOwnProperty('totalSpent') ? overrides.totalSpent! : 'subiungo',
    };
};

export const aHmacOutput = (overrides?: Partial<HmacOutput>, _relationshipsToOmit: Set<string> = new Set()): HmacOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('HmacOutput');
    return {
        hash: overrides && overrides.hasOwnProperty('hash') ? overrides.hash! : 'clam',
        expiration: overrides && overrides.hasOwnProperty('expiration') ? overrides.expiration! : 'tenax',
    };
};

export const aMyLoggedInOrganizationsOutput = (overrides?: Partial<MyLoggedInOrganizationsOutput>, _relationshipsToOmit: Set<string> = new Set()): MyLoggedInOrganizationsOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MyLoggedInOrganizationsOutput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'exercitationem',
        slug: overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'uxor',
        logoUrl: overrides && overrides.hasOwnProperty('logoUrl') ? overrides.logoUrl! : 'aequitas',
        isLinked: overrides && overrides.hasOwnProperty('isLinked') ? overrides.isLinked! : false,
    };
};

export const aUserWhereInput = (overrides?: Partial<UserWhereInput>, _relationshipsToOmit: Set<string> = new Set()): UserWhereInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UserWhereInput');
    return {
        q: overrides && overrides.hasOwnProperty('q') ? overrides.q! : 'trepide',
        roles: overrides && overrides.hasOwnProperty('roles') ? overrides.roles! : [Role.Superadmin],
    };
};

export const aUserOrderByInput = (overrides?: Partial<UserOrderByInput>, _relationshipsToOmit: Set<string> = new Set()): UserOrderByInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UserOrderByInput');
    return {
        firstName: overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : OrderByDirection.Asc,
        lastName: overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : OrderByDirection.Asc,
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : OrderByDirection.Asc,
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : OrderByDirection.Asc,
    };
};

export const aUserConnection = (overrides?: Partial<UserConnection>, _relationshipsToOmit: Set<string> = new Set()): UserConnection => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UserConnection');
    return {
        pageInfo: overrides && overrides.hasOwnProperty('pageInfo') ? overrides.pageInfo! : relationshipsToOmit.has('PageInfo') ? {} as PageInfo : aPageInfo({}, relationshipsToOmit),
        edges: overrides && overrides.hasOwnProperty('edges') ? overrides.edges! : [relationshipsToOmit.has('UserEdge') ? {} as UserEdge : aUserEdge({}, relationshipsToOmit)],
        totalCount: overrides && overrides.hasOwnProperty('totalCount') ? overrides.totalCount! : 3509,
    };
};

export const aUserEdge = (overrides?: Partial<UserEdge>, _relationshipsToOmit: Set<string> = new Set()): UserEdge => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UserEdge');
    return {
        cursor: overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'subiungo',
        node: overrides && overrides.hasOwnProperty('node') ? overrides.node! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
    };
};

export const aUsersUpdatedBetweenInput = (overrides?: Partial<UsersUpdatedBetweenInput>, _relationshipsToOmit: Set<string> = new Set()): UsersUpdatedBetweenInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UsersUpdatedBetweenInput');
    return {
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2026-01-31T10:03:49.639Z",
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : "2026-02-08T18:37:39.793Z",
    };
};

export const aLinkedAccountUser = (overrides?: Partial<LinkedAccountUser>, _relationshipsToOmit: Set<string> = new Set()): LinkedAccountUser => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LinkedAccountUser');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'abdd14af-c09d-4e81-880d-faeafbf57b74',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-11-16T20:28:42.834Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-08-27T16:28:29.285Z",
        firstName: overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'pectus',
        lastName: overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'decet',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'adfectus',
        phoneNumber: overrides && overrides.hasOwnProperty('phoneNumber') ? overrides.phoneNumber! : 'vaco',
        hasVerifiedEmail: overrides && overrides.hasOwnProperty('hasVerifiedEmail') ? overrides.hasVerifiedEmail! : true,
        organizationSlugs: overrides && overrides.hasOwnProperty('organizationSlugs') ? overrides.organizationSlugs! : ['beatus'],
    };
};

export const aReleasePosPaymentOptions = (overrides?: Partial<ReleasePosPaymentOptions>, _relationshipsToOmit: Set<string> = new Set()): ReleasePosPaymentOptions => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ReleasePosPaymentOptions');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '7277338a-8f44-44f9-9855-8f9c2c06d127',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-04-16T11:19:00.146Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-12-28T17:52:01.238Z",
        releaseId: overrides && overrides.hasOwnProperty('releaseId') ? overrides.releaseId! : 'adopto',
        organizationId: overrides && overrides.hasOwnProperty('organizationId') ? overrides.organizationId! : 'arca',
        paymentOptions: overrides && overrides.hasOwnProperty('paymentOptions') ? overrides.paymentOptions! : relationshipsToOmit.has('PosPaymentOptions') ? {} as PosPaymentOptions : aPosPaymentOptions({}, relationshipsToOmit),
        bookingFeeType: overrides && overrides.hasOwnProperty('bookingFeeType') ? overrides.bookingFeeType! : FeeType.FlatRate,
        bookingFee: overrides && overrides.hasOwnProperty('bookingFee') ? overrides.bookingFee! : 6.4,
    };
};

export const aTerminalLatestTransactionStatus = (overrides?: Partial<TerminalLatestTransactionStatus>, _relationshipsToOmit: Set<string> = new Set()): TerminalLatestTransactionStatus => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TerminalLatestTransactionStatus');
    return {
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : OrderTransactionStatus.Waiting,
        message: overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'cunae',
        failureCode: overrides && overrides.hasOwnProperty('failureCode') ? overrides.failureCode! : 'decor',
    };
};

export const anEventWhereInput = (overrides?: Partial<EventWhereInput>, _relationshipsToOmit: Set<string> = new Set()): EventWhereInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EventWhereInput');
    return {
        q: overrides && overrides.hasOwnProperty('q') ? overrides.q! : 'similique',
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : false,
        isFeatured: overrides && overrides.hasOwnProperty('isFeatured') ? overrides.isFeatured! : true,
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2025-08-23T03:58:14.034Z",
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : "2025-11-25T23:00:13.442Z",
        pos: overrides && overrides.hasOwnProperty('pos') ? overrides.pos! : true,
        seasonId: overrides && overrides.hasOwnProperty('seasonId') ? overrides.seasonId! : 'angustus',
        isOutlet: overrides && overrides.hasOwnProperty('isOutlet') ? overrides.isOutlet! : true,
        seating: overrides && overrides.hasOwnProperty('seating') ? overrides.seating! : VenueSeating.Seated,
        includeHidden: overrides && overrides.hasOwnProperty('includeHidden') ? overrides.includeHidden! : true,
    };
};

export const anEventOrderByInput = (overrides?: Partial<EventOrderByInput>, _relationshipsToOmit: Set<string> = new Set()): EventOrderByInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EventOrderByInput');
    return {
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : OrderByDirection.Asc,
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : OrderByDirection.Asc,
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : OrderByDirection.Asc,
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : OrderByDirection.Asc,
        isFeatured: overrides && overrides.hasOwnProperty('isFeatured') ? overrides.isFeatured! : OrderByDirection.Asc,
    };
};

export const anEventConnection = (overrides?: Partial<EventConnection>, _relationshipsToOmit: Set<string> = new Set()): EventConnection => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EventConnection');
    return {
        pageInfo: overrides && overrides.hasOwnProperty('pageInfo') ? overrides.pageInfo! : relationshipsToOmit.has('PageInfo') ? {} as PageInfo : aPageInfo({}, relationshipsToOmit),
        edges: overrides && overrides.hasOwnProperty('edges') ? overrides.edges! : [relationshipsToOmit.has('EventEdge') ? {} as EventEdge : anEventEdge({}, relationshipsToOmit)],
        totalCount: overrides && overrides.hasOwnProperty('totalCount') ? overrides.totalCount! : 2084,
    };
};

export const anEventEdge = (overrides?: Partial<EventEdge>, _relationshipsToOmit: Set<string> = new Set()): EventEdge => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EventEdge');
    return {
        cursor: overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'audeo',
        node: overrides && overrides.hasOwnProperty('node') ? overrides.node! : relationshipsToOmit.has('Event') ? {} as Event : anEvent({}, relationshipsToOmit),
    };
};

export const anEventsByIdInput = (overrides?: Partial<EventsByIdInput>, _relationshipsToOmit: Set<string> = new Set()): EventsByIdInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EventsByIdInput');
    return {
        eventIds: overrides && overrides.hasOwnProperty('eventIds') ? overrides.eventIds! : ['tertius'],
    };
};

export const anEventsWithAccessControlInput = (overrides?: Partial<EventsWithAccessControlInput>, _relationshipsToOmit: Set<string> = new Set()): EventsWithAccessControlInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EventsWithAccessControlInput');
    return {
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'demergo',
        releaseId: overrides && overrides.hasOwnProperty('releaseId') ? overrides.releaseId! : 'asperiores',
        releaseSlug: overrides && overrides.hasOwnProperty('releaseSlug') ? overrides.releaseSlug! : 'quasi',
        code: overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'terminatio',
    };
};

export const anEventsWithAccessControlOutput = (overrides?: Partial<EventsWithAccessControlOutput>, _relationshipsToOmit: Set<string> = new Set()): EventsWithAccessControlOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EventsWithAccessControlOutput');
    return {
        event: overrides && overrides.hasOwnProperty('event') ? overrides.event! : relationshipsToOmit.has('Event') ? {} as Event : anEvent({}, relationshipsToOmit),
        release: overrides && overrides.hasOwnProperty('release') ? overrides.release! : relationshipsToOmit.has('Release') ? {} as Release : aRelease({}, relationshipsToOmit),
        isAdmin: overrides && overrides.hasOwnProperty('isAdmin') ? overrides.isAdmin! : false,
        errorMessage: overrides && overrides.hasOwnProperty('errorMessage') ? overrides.errorMessage! : 'sint',
        errorType: overrides && overrides.hasOwnProperty('errorType') ? overrides.errorType! : EventErrorType.EventHasEnded,
        redirect: overrides && overrides.hasOwnProperty('redirect') ? overrides.redirect! : relationshipsToOmit.has('EventRedirectQueryParams') ? {} as EventRedirectQueryParams : anEventRedirectQueryParams({}, relationshipsToOmit),
        permissions: overrides && overrides.hasOwnProperty('permissions') ? overrides.permissions! : [EventPermissions.ViewInfo],
        accessType: overrides && overrides.hasOwnProperty('accessType') ? overrides.accessType! : EventAccessStatus.ShouldRedirect,
    };
};

export const anEventRedirectQueryParams = (overrides?: Partial<EventRedirectQueryParams>, _relationshipsToOmit: Set<string> = new Set()): EventRedirectQueryParams => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EventRedirectQueryParams');
    return {
        path: overrides && overrides.hasOwnProperty('path') ? overrides.path! : 'cohaero',
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'calamitas',
        code: overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'vita',
        slug: overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'cupressus',
    };
};

export const anEventForCompetitionReportingEntity = (overrides?: Partial<EventForCompetitionReportingEntity>, _relationshipsToOmit: Set<string> = new Set()): EventForCompetitionReportingEntity => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EventForCompetitionReportingEntity');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'f356b686-23e9-4f13-a01b-2f528dc1277b',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-04-18T23:47:16.246Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-12-17T12:41:59.119Z",
        eventKind: overrides && overrides.hasOwnProperty('eventKind') ? overrides.eventKind! : EventKind.Standard,
        season: overrides && overrides.hasOwnProperty('season') ? overrides.season! : relationshipsToOmit.has('Season') ? {} as Season : aSeason({}, relationshipsToOmit),
        venue: overrides && overrides.hasOwnProperty('venue') ? overrides.venue! : relationshipsToOmit.has('Venue') ? {} as Venue : aVenue({}, relationshipsToOmit),
        intellitixProjectId: overrides && overrides.hasOwnProperty('intellitixProjectId') ? overrides.intellitixProjectId! : 'molestias',
        intellitixSourceId: overrides && overrides.hasOwnProperty('intellitixSourceId') ? overrides.intellitixSourceId! : 'nulla',
        releases: overrides && overrides.hasOwnProperty('releases') ? overrides.releases! : [relationshipsToOmit.has('Release') ? {} as Release : aRelease({}, relationshipsToOmit)],
        seatsEventKey: overrides && overrides.hasOwnProperty('seatsEventKey') ? overrides.seatsEventKey! : 'aeneus',
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'odit',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'bellicus',
        dates: overrides && overrides.hasOwnProperty('dates') ? overrides.dates! : [relationshipsToOmit.has('EventDate') ? {} as EventDate : anEventDate({}, relationshipsToOmit)],
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2025-04-11T03:05:06.500Z",
        showStartTime: overrides && overrides.hasOwnProperty('showStartTime') ? overrides.showStartTime! : true,
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : "2025-06-14T13:53:45.086Z",
        showEndTime: overrides && overrides.hasOwnProperty('showEndTime') ? overrides.showEndTime! : false,
        ticketsViewableFromDate: overrides && overrides.hasOwnProperty('ticketsViewableFromDate') ? overrides.ticketsViewableFromDate! : "2026-02-05T18:22:19.689Z",
        hasEventEnded: overrides && overrides.hasOwnProperty('hasEventEnded') ? overrides.hasEventEnded! : false,
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : true,
        isFeatured: overrides && overrides.hasOwnProperty('isFeatured') ? overrides.isFeatured! : true,
        bookingFeeType: overrides && overrides.hasOwnProperty('bookingFeeType') ? overrides.bookingFeeType! : FeeType.FlatRate,
        bookingFee: overrides && overrides.hasOwnProperty('bookingFee') ? overrides.bookingFee! : 6.8,
        isR18: overrides && overrides.hasOwnProperty('isR18') ? overrides.isR18! : true,
        isDiscoverable: overrides && overrides.hasOwnProperty('isDiscoverable') ? overrides.isDiscoverable! : true,
        isFestival: overrides && overrides.hasOwnProperty('isFestival') ? overrides.isFestival! : false,
        canNameTicket: overrides && overrides.hasOwnProperty('canNameTicket') ? overrides.canNameTicket! : false,
        canRenameTicket: overrides && overrides.hasOwnProperty('canRenameTicket') ? overrides.canRenameTicket! : true,
        enableWaitlist: overrides && overrides.hasOwnProperty('enableWaitlist') ? overrides.enableWaitlist! : false,
        waitlistStartDate: overrides && overrides.hasOwnProperty('waitlistStartDate') ? overrides.waitlistStartDate! : "2025-06-01T12:14:27.926Z",
        waitlistEndDate: overrides && overrides.hasOwnProperty('waitlistEndDate') ? overrides.waitlistEndDate! : "2025-10-04T21:51:20.364Z",
        enableReleaseCodes: overrides && overrides.hasOwnProperty('enableReleaseCodes') ? overrides.enableReleaseCodes! : false,
        canChangeSeats: overrides && overrides.hasOwnProperty('canChangeSeats') ? overrides.canChangeSeats! : true,
        canTransferTicket: overrides && overrides.hasOwnProperty('canTransferTicket') ? overrides.canTransferTicket! : true,
        ticketResaleEnabled: overrides && overrides.hasOwnProperty('ticketResaleEnabled') ? overrides.ticketResaleEnabled! : true,
        ticketResaleWaitlistEnabled: overrides && overrides.hasOwnProperty('ticketResaleWaitlistEnabled') ? overrides.ticketResaleWaitlistEnabled! : false,
        renamingFee: overrides && overrides.hasOwnProperty('renamingFee') ? overrides.renamingFee! : 3.2,
        changingSeatsFee: overrides && overrides.hasOwnProperty('changingSeatsFee') ? overrides.changingSeatsFee! : 7.2,
        sellerTransferringTicketFee: overrides && overrides.hasOwnProperty('sellerTransferringTicketFee') ? overrides.sellerTransferringTicketFee! : 5.2,
        buyerTransferringTicketFee: overrides && overrides.hasOwnProperty('buyerTransferringTicketFee') ? overrides.buyerTransferringTicketFee! : 6.2,
        shippingOptions: overrides && overrides.hasOwnProperty('shippingOptions') ? overrides.shippingOptions! : relationshipsToOmit.has('ShippingOptions') ? {} as ShippingOptions : aShippingOptions({}, relationshipsToOmit),
        thumbnail: overrides && overrides.hasOwnProperty('thumbnail') ? overrides.thumbnail! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        logo: overrides && overrides.hasOwnProperty('logo') ? overrides.logo! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        backgroundImage: overrides && overrides.hasOwnProperty('backgroundImage') ? overrides.backgroundImage! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        backgroundImageFullPage: overrides && overrides.hasOwnProperty('backgroundImageFullPage') ? overrides.backgroundImageFullPage! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        descriptionImage: overrides && overrides.hasOwnProperty('descriptionImage') ? overrides.descriptionImage! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        printBanner1: overrides && overrides.hasOwnProperty('printBanner1') ? overrides.printBanner1! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        printBanner2: overrides && overrides.hasOwnProperty('printBanner2') ? overrides.printBanner2! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        hardCopyTicketBanner: overrides && overrides.hasOwnProperty('hardCopyTicketBanner') ? overrides.hardCopyTicketBanner! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        termsAndConditions: overrides && overrides.hasOwnProperty('termsAndConditions') ? overrides.termsAndConditions! : 'coma',
        importantNotice: overrides && overrides.hasOwnProperty('importantNotice') ? overrides.importantNotice! : 'vesper',
        accessibility: overrides && overrides.hasOwnProperty('accessibility') ? overrides.accessibility! : 'uterque',
        presaleInformation: overrides && overrides.hasOwnProperty('presaleInformation') ? overrides.presaleInformation! : 'laudantium',
        invoiceInformation: overrides && overrides.hasOwnProperty('invoiceInformation') ? overrides.invoiceInformation! : 'umerus',
        zonesAllocatedGates: overrides && overrides.hasOwnProperty('zonesAllocatedGates') ? overrides.zonesAllocatedGates! : [relationshipsToOmit.has('ZoneAllocatedGate') ? {} as ZoneAllocatedGate : aZoneAllocatedGate({}, relationshipsToOmit)],
        insideFeeDetails: overrides && overrides.hasOwnProperty('insideFeeDetails') ? overrides.insideFeeDetails! : [relationshipsToOmit.has('InsideFeeDetails') ? {} as InsideFeeDetails : anInsideFeeDetails({}, relationshipsToOmit)],
        checkForVaccinePass: overrides && overrides.hasOwnProperty('checkForVaccinePass') ? overrides.checkForVaccinePass! : true,
        emailNotification: overrides && overrides.hasOwnProperty('emailNotification') ? overrides.emailNotification! : 'avarus',
        redirectURL: overrides && overrides.hasOwnProperty('redirectURL') ? overrides.redirectURL! : 'carcer',
        referralCampaignId: overrides && overrides.hasOwnProperty('referralCampaignId') ? overrides.referralCampaignId! : 'angustus',
        canUsePoints: overrides && overrides.hasOwnProperty('canUsePoints') ? overrides.canUsePoints! : true,
        googleWalletEventClassId: overrides && overrides.hasOwnProperty('googleWalletEventClassId') ? overrides.googleWalletEventClassId! : 'alioqui',
        lastTicketsViewableEmailsSentAt: overrides && overrides.hasOwnProperty('lastTicketsViewableEmailsSentAt') ? overrides.lastTicketsViewableEmailsSentAt! : "2025-11-13T05:00:37.916Z",
        ticketCover: overrides && overrides.hasOwnProperty('ticketCover') ? overrides.ticketCover! : relationshipsToOmit.has('EventTicketCover') ? {} as EventTicketCover : anEventTicketCover({}, relationshipsToOmit),
        seoMetadata: overrides && overrides.hasOwnProperty('seoMetadata') ? overrides.seoMetadata! : relationshipsToOmit.has('SeoMetadata') ? {} as SeoMetadata : aSeoMetadata({}, relationshipsToOmit),
        paymentPlanSettings: overrides && overrides.hasOwnProperty('paymentPlanSettings') ? overrides.paymentPlanSettings! : relationshipsToOmit.has('PaymentPlanSettings') ? {} as PaymentPlanSettings : aPaymentPlanSettings({}, relationshipsToOmit),
        pixelId: overrides && overrides.hasOwnProperty('pixelId') ? overrides.pixelId! : 'truculenter',
        multiScanningEnabled: overrides && overrides.hasOwnProperty('multiScanningEnabled') ? overrides.multiScanningEnabled! : false,
        ticketEntryTimeEnforcement: overrides && overrides.hasOwnProperty('ticketEntryTimeEnforcement') ? overrides.ticketEntryTimeEnforcement! : relationshipsToOmit.has('TicketEntryTimeEnforcementOptions') ? {} as TicketEntryTimeEnforcementOptions : aTicketEntryTimeEnforcementOptions({}, relationshipsToOmit),
        hiddenFromPublic: overrides && overrides.hasOwnProperty('hiddenFromPublic') ? overrides.hiddenFromPublic! : true,
        tax: overrides && overrides.hasOwnProperty('tax') ? overrides.tax! : [relationshipsToOmit.has('Tax') ? {} as Tax : aTax({}, relationshipsToOmit)],
        merchantReferenceResult: overrides && overrides.hasOwnProperty('merchantReferenceResult') ? overrides.merchantReferenceResult! : 'corrumpo',
        seatSelectionFilterOverrides: overrides && overrides.hasOwnProperty('seatSelectionFilterOverrides') ? overrides.seatSelectionFilterOverrides! : relationshipsToOmit.has('SeatSelectionFilters') ? {} as SeatSelectionFilters : aSeatSelectionFilters({}, relationshipsToOmit),
        hasPublicRelease: overrides && overrides.hasOwnProperty('hasPublicRelease') ? overrides.hasPublicRelease! : true,
        venueAddress: overrides && overrides.hasOwnProperty('venueAddress') ? overrides.venueAddress! : relationshipsToOmit.has('Venue') ? {} as Venue : aVenue({}, relationshipsToOmit),
        ticketTypes: overrides && overrides.hasOwnProperty('ticketTypes') ? overrides.ticketTypes! : [relationshipsToOmit.has('TicketType') ? {} as TicketType : aTicketType({}, relationshipsToOmit)],
        gateways: overrides && overrides.hasOwnProperty('gateways') ? overrides.gateways! : [relationshipsToOmit.has('Integration') ? {} as Integration : anIntegration({}, relationshipsToOmit)],
        addons: overrides && overrides.hasOwnProperty('addons') ? overrides.addons! : [relationshipsToOmit.has('EventAddon') ? {} as EventAddon : anEventAddon({}, relationshipsToOmit)],
        soldTicketsCount: overrides && overrides.hasOwnProperty('soldTicketsCount') ? overrides.soldTicketsCount! : 5.2,
        soldTicketsCountToday: overrides && overrides.hasOwnProperty('soldTicketsCountToday') ? overrides.soldTicketsCountToday! : 0,
        soldTicketsCountYesterday: overrides && overrides.hasOwnProperty('soldTicketsCountYesterday') ? overrides.soldTicketsCountYesterday! : 6.6,
        totalRevenue: overrides && overrides.hasOwnProperty('totalRevenue') ? overrides.totalRevenue! : 4.1,
        totalFaceValue: overrides && overrides.hasOwnProperty('totalFaceValue') ? overrides.totalFaceValue! : 6.1,
        multiBuyPromotions: overrides && overrides.hasOwnProperty('multiBuyPromotions') ? overrides.multiBuyPromotions! : [relationshipsToOmit.has('EventMultiBuyPromotion') ? {} as EventMultiBuyPromotion : anEventMultiBuyPromotion({}, relationshipsToOmit)],
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : [relationshipsToOmit.has('Tag') ? {} as Tag : aTag({}, relationshipsToOmit)],
        digitalPassCodesStatus: overrides && overrides.hasOwnProperty('digitalPassCodesStatus') ? overrides.digitalPassCodesStatus! : relationshipsToOmit.has('DigitalPassCodeStatusOutput') ? {} as DigitalPassCodeStatusOutput : aDigitalPassCodeStatusOutput({}, relationshipsToOmit),
        digitalInfo: overrides && overrides.hasOwnProperty('digitalInfo') ? overrides.digitalInfo! : relationshipsToOmit.has('DigitalInfo') ? {} as DigitalInfo : aDigitalInfo({}, relationshipsToOmit),
        defaultDateRange: overrides && overrides.hasOwnProperty('defaultDateRange') ? overrides.defaultDateRange! : relationshipsToOmit.has('DefaultDateRange') ? {} as DefaultDateRange : aDefaultDateRange({}, relationshipsToOmit),
        hasPromoCodes: overrides && overrides.hasOwnProperty('hasPromoCodes') ? overrides.hasPromoCodes! : true,
        isWaitlistAvailable: overrides && overrides.hasOwnProperty('isWaitlistAvailable') ? overrides.isWaitlistAvailable! : true,
        presaleRelease: overrides && overrides.hasOwnProperty('presaleRelease') ? overrides.presaleRelease! : relationshipsToOmit.has('Release') ? {} as Release : aRelease({}, relationshipsToOmit),
        publicReleaseStartsAt: overrides && overrides.hasOwnProperty('publicReleaseStartsAt') ? overrides.publicReleaseStartsAt! : "2025-07-02T07:21:16.768Z",
        listedRelease: overrides && overrides.hasOwnProperty('listedRelease') ? overrides.listedRelease! : relationshipsToOmit.has('Release') ? {} as Release : aRelease({}, relationshipsToOmit),
        artists: overrides && overrides.hasOwnProperty('artists') ? overrides.artists! : [relationshipsToOmit.has('Artist') ? {} as Artist : anArtist({}, relationshipsToOmit)],
        ticketsIssued: overrides && overrides.hasOwnProperty('ticketsIssued') ? overrides.ticketsIssued! : 7725,
        capacity: overrides && overrides.hasOwnProperty('capacity') ? overrides.capacity! : 676,
        totalTicketsFaceValue: overrides && overrides.hasOwnProperty('totalTicketsFaceValue') ? overrides.totalTicketsFaceValue! : 4.1,
        taxRate: overrides && overrides.hasOwnProperty('taxRate') ? overrides.taxRate! : 9,
        customTaxRate: overrides && overrides.hasOwnProperty('customTaxRate') ? overrides.customTaxRate! : 1.8,
        taxCalculationMethod: overrides && overrides.hasOwnProperty('taxCalculationMethod') ? overrides.taxCalculationMethod! : TaxCalculationMethod.Inclusive,
        customFields: overrides && overrides.hasOwnProperty('customFields') ? overrides.customFields! : [relationshipsToOmit.has('CustomFieldOuput') ? {} as CustomFieldOuput : aCustomFieldOuput({}, relationshipsToOmit)],
        fees: overrides && overrides.hasOwnProperty('fees') ? overrides.fees! : relationshipsToOmit.has('OrderFee') ? {} as OrderFee : anOrderFee({}, relationshipsToOmit),
        canUpgrade: overrides && overrides.hasOwnProperty('canUpgrade') ? overrides.canUpgrade! : false,
        seekaConfig: overrides && overrides.hasOwnProperty('seekaConfig') ? overrides.seekaConfig! : relationshipsToOmit.has('SeekaOutput') ? {} as SeekaOutput : aSeekaOutput({}, relationshipsToOmit),
        effectiveSeatFilters: overrides && overrides.hasOwnProperty('effectiveSeatFilters') ? overrides.effectiveSeatFilters! : relationshipsToOmit.has('SeatSelectionFilters') ? {} as SeatSelectionFilters : aSeatSelectionFilters({}, relationshipsToOmit),
        prePurchaseAvailableStatus: overrides && overrides.hasOwnProperty('prePurchaseAvailableStatus') ? overrides.prePurchaseAvailableStatus! : PrePurchaseAvailableStatus.Available,
        hasPrePurchasePresale: overrides && overrides.hasOwnProperty('hasPrePurchasePresale') ? overrides.hasPrePurchasePresale! : false,
        seatsIoConfig: overrides && overrides.hasOwnProperty('seatsIoConfig') ? overrides.seatsIoConfig! : relationshipsToOmit.has('SeatsIoConfigOutput') ? {} as SeatsIoConfigOutput : aSeatsIoConfigOutput({}, relationshipsToOmit),
        stripeConfig: overrides && overrides.hasOwnProperty('stripeConfig') ? overrides.stripeConfig! : relationshipsToOmit.has('StripeConfigOutput') ? {} as StripeConfigOutput : aStripeConfigOutput({}, relationshipsToOmit),
        userRestrictedReleases: overrides && overrides.hasOwnProperty('userRestrictedReleases') ? overrides.userRestrictedReleases! : [relationshipsToOmit.has('RestrictedRelease') ? {} as RestrictedRelease : aRestrictedRelease({}, relationshipsToOmit)],
        hadOrHasPresaleWaitlist: overrides && overrides.hasOwnProperty('hadOrHasPresaleWaitlist') ? overrides.hadOrHasPresaleWaitlist! : true,
    };
};

export const aMyEventsWhereInput = (overrides?: Partial<MyEventsWhereInput>, _relationshipsToOmit: Set<string> = new Set()): MyEventsWhereInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MyEventsWhereInput');
    return {
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2025-08-23T21:33:04.443Z",
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : "2025-05-04T18:18:45.719Z",
        hasParentTicket: overrides && overrides.hasOwnProperty('hasParentTicket') ? overrides.hasParentTicket! : true,
    };
};

export const aMyEventsOrderByInput = (overrides?: Partial<MyEventsOrderByInput>, _relationshipsToOmit: Set<string> = new Set()): MyEventsOrderByInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MyEventsOrderByInput');
    return {
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : OrderByDirection.Asc,
    };
};

export const anEventForecastOutput = (overrides?: Partial<EventForecastOutput>, _relationshipsToOmit: Set<string> = new Set()): EventForecastOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EventForecastOutput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'claudeo',
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'veritas',
        zones: overrides && overrides.hasOwnProperty('zones') ? overrides.zones! : [relationshipsToOmit.has('EventForecastZoneOutput') ? {} as EventForecastZoneOutput : anEventForecastZoneOutput({}, relationshipsToOmit)],
        scenarios: overrides && overrides.hasOwnProperty('scenarios') ? overrides.scenarios! : [relationshipsToOmit.has('ForecastScenario') ? {} as ForecastScenario : aForecastScenario({}, relationshipsToOmit)],
    };
};

export const anEventForecastZoneOutput = (overrides?: Partial<EventForecastZoneOutput>, _relationshipsToOmit: Set<string> = new Set()): EventForecastZoneOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EventForecastZoneOutput');
    return {
        zoneId: overrides && overrides.hasOwnProperty('zoneId') ? overrides.zoneId! : 'tempora',
        comps: overrides && overrides.hasOwnProperty('comps') ? overrides.comps! : 4725,
        contingency: overrides && overrides.hasOwnProperty('contingency') ? overrides.contingency! : 7895,
        sales: overrides && overrides.hasOwnProperty('sales') ? overrides.sales! : relationshipsToOmit.has('FinancialSales') ? {} as FinancialSales : aFinancialSales({}, relationshipsToOmit),
    };
};

export const aFinancialSales = (overrides?: Partial<FinancialSales>, _relationshipsToOmit: Set<string> = new Set()): FinancialSales => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('FinancialSales');
    return {
        zoneId: overrides && overrides.hasOwnProperty('zoneId') ? overrides.zoneId! : 'dedecor',
        zoneName: overrides && overrides.hasOwnProperty('zoneName') ? overrides.zoneName! : 'amo',
        capacity: overrides && overrides.hasOwnProperty('capacity') ? overrides.capacity! : 'vomer',
        available: overrides && overrides.hasOwnProperty('available') ? overrides.available! : 'nobis',
        availablePercentage: overrides && overrides.hasOwnProperty('availablePercentage') ? overrides.availablePercentage! : 2.4,
        sellableCapacity: overrides && overrides.hasOwnProperty('sellableCapacity') ? overrides.sellableCapacity! : 'absconditus',
        totalNotForSaleCount: overrides && overrides.hasOwnProperty('totalNotForSaleCount') ? overrides.totalNotForSaleCount! : 8.1,
        totalNotForSalePercentage: overrides && overrides.hasOwnProperty('totalNotForSalePercentage') ? overrides.totalNotForSalePercentage! : 4.4,
        allMembershipHolds: overrides && overrides.hasOwnProperty('allMembershipHolds') ? overrides.allMembershipHolds! : 1.3,
        allMembershipHoldsPercentage: overrides && overrides.hasOwnProperty('allMembershipHoldsPercentage') ? overrides.allMembershipHoldsPercentage! : 6,
        totalMembershipTicketCount: overrides && overrides.hasOwnProperty('totalMembershipTicketCount') ? overrides.totalMembershipTicketCount! : 1.7,
        totalMembershipTicketPercentage: overrides && overrides.hasOwnProperty('totalMembershipTicketPercentage') ? overrides.totalMembershipTicketPercentage! : 4,
        types: overrides && overrides.hasOwnProperty('types') ? overrides.types! : [relationshipsToOmit.has('FinancialSalesType') ? {} as FinancialSalesType : aFinancialSalesType({}, relationshipsToOmit)],
        sourceId: overrides && overrides.hasOwnProperty('sourceId') ? overrides.sourceId! : 'vehemens',
        sourceName: overrides && overrides.hasOwnProperty('sourceName') ? overrides.sourceName! : 'uberrime',
        issued: overrides && overrides.hasOwnProperty('issued') ? overrides.issued! : 4.8,
        ticketIssued: overrides && overrides.hasOwnProperty('ticketIssued') ? overrides.ticketIssued! : 2.6,
        ticketHolds: overrides && overrides.hasOwnProperty('ticketHolds') ? overrides.ticketHolds! : 7.1,
        partPaidTickets: overrides && overrides.hasOwnProperty('partPaidTickets') ? overrides.partPaidTickets! : 5.8,
        partPaidTicketsPercentage: overrides && overrides.hasOwnProperty('partPaidTicketsPercentage') ? overrides.partPaidTicketsPercentage! : 9.5,
        partPaidMemberships: overrides && overrides.hasOwnProperty('partPaidMemberships') ? overrides.partPaidMemberships! : 2.6,
        partPaidMembershipsPercentage: overrides && overrides.hasOwnProperty('partPaidMembershipsPercentage') ? overrides.partPaidMembershipsPercentage! : 7.7,
        totalHoldsPercentage: overrides && overrides.hasOwnProperty('totalHoldsPercentage') ? overrides.totalHoldsPercentage! : 4.4,
        transfersPending: overrides && overrides.hasOwnProperty('transfersPending') ? overrides.transfersPending! : 9.8,
        transfers: overrides && overrides.hasOwnProperty('transfers') ? overrides.transfers! : 5.2,
        comps: overrides && overrides.hasOwnProperty('comps') ? overrides.comps! : 0.9,
        compsPercentage: overrides && overrides.hasOwnProperty('compsPercentage') ? overrides.compsPercentage! : 3.7,
        ticketSold: overrides && overrides.hasOwnProperty('ticketSold') ? overrides.ticketSold! : 7.4,
        ticketsRefunded: overrides && overrides.hasOwnProperty('ticketsRefunded') ? overrides.ticketsRefunded! : 7.2,
        ticketSoldPercentage: overrides && overrides.hasOwnProperty('ticketSoldPercentage') ? overrides.ticketSoldPercentage! : 'cernuus',
        baseRevenue: overrides && overrides.hasOwnProperty('baseRevenue') ? overrides.baseRevenue! : 7.9,
        partPaidRevenue: overrides && overrides.hasOwnProperty('partPaidRevenue') ? overrides.partPaidRevenue! : 5.8,
        refunds: overrides && overrides.hasOwnProperty('refunds') ? overrides.refunds! : 3.7,
        totalBookingFee: overrides && overrides.hasOwnProperty('totalBookingFee') ? overrides.totalBookingFee! : 3.9,
        totalWithBookingFees: overrides && overrides.hasOwnProperty('totalWithBookingFees') ? overrides.totalWithBookingFees! : 9.6,
        buyerTransferFees: overrides && overrides.hasOwnProperty('buyerTransferFees') ? overrides.buyerTransferFees! : 1.6,
        sellerTransferFees: overrides && overrides.hasOwnProperty('sellerTransferFees') ? overrides.sellerTransferFees! : 2.8,
        isAdmissionZone: overrides && overrides.hasOwnProperty('isAdmissionZone') ? overrides.isAdmissionZone! : true,
        venueCapacity: overrides && overrides.hasOwnProperty('venueCapacity') ? overrides.venueCapacity! : 0.7,
        membershipRenewalHolds: overrides && overrides.hasOwnProperty('membershipRenewalHolds') ? overrides.membershipRenewalHolds! : 1.4,
        membershipRenewalHoldsPercentage: overrides && overrides.hasOwnProperty('membershipRenewalHoldsPercentage') ? overrides.membershipRenewalHoldsPercentage! : 1.6,
        holdByMembershipCount: overrides && overrides.hasOwnProperty('holdByMembershipCount') ? overrides.holdByMembershipCount! : 6,
        holdByMembershipCountPercentage: overrides && overrides.hasOwnProperty('holdByMembershipCountPercentage') ? overrides.holdByMembershipCountPercentage! : 4,
        channelHolds: overrides && overrides.hasOwnProperty('channelHolds') ? overrides.channelHolds! : 6041,
        totalExclusiveTax: overrides && overrides.hasOwnProperty('totalExclusiveTax') ? overrides.totalExclusiveTax! : 5.6,
        totalOccupied: overrides && overrides.hasOwnProperty('totalOccupied') ? overrides.totalOccupied! : 2.7,
    };
};

export const aFinancialSalesType = (overrides?: Partial<FinancialSalesType>, _relationshipsToOmit: Set<string> = new Set()): FinancialSalesType => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('FinancialSalesType');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'defaeco',
        issued: overrides && overrides.hasOwnProperty('issued') ? overrides.issued! : 8.6,
        ticketIssued: overrides && overrides.hasOwnProperty('ticketIssued') ? overrides.ticketIssued! : 1.7,
        ticketHolds: overrides && overrides.hasOwnProperty('ticketHolds') ? overrides.ticketHolds! : 1.4,
        partPaidTickets: overrides && overrides.hasOwnProperty('partPaidTickets') ? overrides.partPaidTickets! : 7,
        partPaidMemberships: overrides && overrides.hasOwnProperty('partPaidMemberships') ? overrides.partPaidMemberships! : 7.7,
        posTickets: overrides && overrides.hasOwnProperty('posTickets') ? overrides.posTickets! : 0.5,
        transfersPending: overrides && overrides.hasOwnProperty('transfersPending') ? overrides.transfersPending! : 4.6,
        transfers: overrides && overrides.hasOwnProperty('transfers') ? overrides.transfers! : 9.7,
        comps: overrides && overrides.hasOwnProperty('comps') ? overrides.comps! : 2.4,
        ticketSold: overrides && overrides.hasOwnProperty('ticketSold') ? overrides.ticketSold! : 6.3,
        ticketsRefunded: overrides && overrides.hasOwnProperty('ticketsRefunded') ? overrides.ticketsRefunded! : 7.2,
        baseRevenue: overrides && overrides.hasOwnProperty('baseRevenue') ? overrides.baseRevenue! : 2.3,
        partPaidRevenue: overrides && overrides.hasOwnProperty('partPaidRevenue') ? overrides.partPaidRevenue! : 0.8,
        refunds: overrides && overrides.hasOwnProperty('refunds') ? overrides.refunds! : 8.3,
        channel: overrides && overrides.hasOwnProperty('channel') ? overrides.channel! : 'textor',
        release: overrides && overrides.hasOwnProperty('release') ? overrides.release! : 'stips',
        totalWithBookingFees: overrides && overrides.hasOwnProperty('totalWithBookingFees') ? overrides.totalWithBookingFees! : 5.4,
        available: overrides && overrides.hasOwnProperty('available') ? overrides.available! : 'turbo',
        capacity: overrides && overrides.hasOwnProperty('capacity') ? overrides.capacity! : 'cupiditate',
        membershipRenewalHolds: overrides && overrides.hasOwnProperty('membershipRenewalHolds') ? overrides.membershipRenewalHolds! : 4.8,
        holdByMembershipCount: overrides && overrides.hasOwnProperty('holdByMembershipCount') ? overrides.holdByMembershipCount! : 3.8,
        allMembershipHolds: overrides && overrides.hasOwnProperty('allMembershipHolds') ? overrides.allMembershipHolds! : 5.7,
        ticketTypePriceRange: overrides && overrides.hasOwnProperty('ticketTypePriceRange') ? overrides.ticketTypePriceRange! : [0.8],
        totalBookingFee: overrides && overrides.hasOwnProperty('totalBookingFee') ? overrides.totalBookingFee! : 7.7,
        buyerTransferFees: overrides && overrides.hasOwnProperty('buyerTransferFees') ? overrides.buyerTransferFees! : 0.7,
        sellerTransferFees: overrides && overrides.hasOwnProperty('sellerTransferFees') ? overrides.sellerTransferFees! : 4.6,
        totalDiscounts: overrides && overrides.hasOwnProperty('totalDiscounts') ? overrides.totalDiscounts! : 4.2,
        discounts: overrides && overrides.hasOwnProperty('discounts') ? overrides.discounts! : 6.1,
        ticketTypeBookingFeeRange: overrides && overrides.hasOwnProperty('ticketTypeBookingFeeRange') ? overrides.ticketTypeBookingFeeRange! : [1],
        totalMembershipTicketCount: overrides && overrides.hasOwnProperty('totalMembershipTicketCount') ? overrides.totalMembershipTicketCount! : 1.1,
        isCompTicketType: overrides && overrides.hasOwnProperty('isCompTicketType') ? overrides.isCompTicketType! : true,
        isMembership: overrides && overrides.hasOwnProperty('isMembership') ? overrides.isMembership! : false,
        isTotalAddon: overrides && overrides.hasOwnProperty('isTotalAddon') ? overrides.isTotalAddon! : true,
        isAdmissionZone: overrides && overrides.hasOwnProperty('isAdmissionZone') ? overrides.isAdmissionZone! : true,
        channelHolds: overrides && overrides.hasOwnProperty('channelHolds') ? overrides.channelHolds! : 2846,
        totalExclusiveTax: overrides && overrides.hasOwnProperty('totalExclusiveTax') ? overrides.totalExclusiveTax! : 9.1,
        ticketTypeId: overrides && overrides.hasOwnProperty('ticketTypeId') ? overrides.ticketTypeId! : 'amaritudo',
        hasPricingTiers: overrides && overrides.hasOwnProperty('hasPricingTiers') ? overrides.hasPricingTiers! : true,
    };
};

export const aForecastScenario = (overrides?: Partial<ForecastScenario>, _relationshipsToOmit: Set<string> = new Set()): ForecastScenario => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ForecastScenario');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '54c13868-9fa2-4e21-a3ea-7d69f73cc092',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-12-09T17:57:09.515Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-03-16T05:32:44.913Z",
        zones: overrides && overrides.hasOwnProperty('zones') ? overrides.zones! : [relationshipsToOmit.has('ForecastScenarioZone') ? {} as ForecastScenarioZone : aForecastScenarioZone({}, relationshipsToOmit)],
    };
};

export const aForecastScenarioZone = (overrides?: Partial<ForecastScenarioZone>, _relationshipsToOmit: Set<string> = new Set()): ForecastScenarioZone => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ForecastScenarioZone');
    return {
        zoneId: overrides && overrides.hasOwnProperty('zoneId') ? overrides.zoneId! : 'una',
        ticketTypes: overrides && overrides.hasOwnProperty('ticketTypes') ? overrides.ticketTypes! : [relationshipsToOmit.has('ScenarioZoneTicketType') ? {} as ScenarioZoneTicketType : aScenarioZoneTicketType({}, relationshipsToOmit)],
    };
};

export const aScenarioZoneTicketType = (overrides?: Partial<ScenarioZoneTicketType>, _relationshipsToOmit: Set<string> = new Set()): ScenarioZoneTicketType => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ScenarioZoneTicketType');
    return {
        ticketTypeId: overrides && overrides.hasOwnProperty('ticketTypeId') ? overrides.ticketTypeId! : 'torqueo',
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 3.4,
        splitPercentage: overrides && overrides.hasOwnProperty('splitPercentage') ? overrides.splitPercentage! : 0.2,
    };
};

export const aTicketTypesByIdInput = (overrides?: Partial<TicketTypesByIdInput>, _relationshipsToOmit: Set<string> = new Set()): TicketTypesByIdInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TicketTypesByIdInput');
    return {
        ticketTypeIds: overrides && overrides.hasOwnProperty('ticketTypeIds') ? overrides.ticketTypeIds! : ['vae'],
    };
};

export const aPublicReleaseTicketOutput = (overrides?: Partial<PublicReleaseTicketOutput>, _relationshipsToOmit: Set<string> = new Set()): PublicReleaseTicketOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PublicReleaseTicketOutput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'aeneus',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : TicketTypeKind.Standard,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'comedo',
        zoneName: overrides && overrides.hasOwnProperty('zoneName') ? overrides.zoneName! : 'confero',
        quantity: overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 0,
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 10,
        pricingTiers: overrides && overrides.hasOwnProperty('pricingTiers') ? overrides.pricingTiers! : [relationshipsToOmit.has('PublicReleaseTicketPricingTierOutput') ? {} as PublicReleaseTicketPricingTierOutput : aPublicReleaseTicketPricingTierOutput({}, relationshipsToOmit)],
        isHidden: overrides && overrides.hasOwnProperty('isHidden') ? overrides.isHidden! : false,
    };
};

export const aPublicReleaseTicketPricingTierOutput = (overrides?: Partial<PublicReleaseTicketPricingTierOutput>, _relationshipsToOmit: Set<string> = new Set()): PublicReleaseTicketPricingTierOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PublicReleaseTicketPricingTierOutput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'cicuta',
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 2.6,
    };
};

export const anAccessCodeReleaseOutput = (overrides?: Partial<AccessCodeReleaseOutput>, _relationshipsToOmit: Set<string> = new Set()): AccessCodeReleaseOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AccessCodeReleaseOutput');
    return {
        releaseId: overrides && overrides.hasOwnProperty('releaseId') ? overrides.releaseId! : 'arbitro',
        accessCodes: overrides && overrides.hasOwnProperty('accessCodes') ? overrides.accessCodes! : [relationshipsToOmit.has('AccessCodeOutput') ? {} as AccessCodeOutput : anAccessCodeOutput({}, relationshipsToOmit)],
        tickets: overrides && overrides.hasOwnProperty('tickets') ? overrides.tickets! : [relationshipsToOmit.has('AccessCodeTicketOutput') ? {} as AccessCodeTicketOutput : anAccessCodeTicketOutput({}, relationshipsToOmit)],
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'turbo',
        purchaseRestrictions: overrides && overrides.hasOwnProperty('purchaseRestrictions') ? overrides.purchaseRestrictions! : relationshipsToOmit.has('ReleasePurchaseRestriction') ? {} as ReleasePurchaseRestriction : aReleasePurchaseRestriction({}, relationshipsToOmit),
    };
};

export const anAccessCodeOutput = (overrides?: Partial<AccessCodeOutput>, _relationshipsToOmit: Set<string> = new Set()): AccessCodeOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AccessCodeOutput');
    return {
        accessCode: overrides && overrides.hasOwnProperty('accessCode') ? overrides.accessCode! : 'ater',
        quantity: overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 8.4,
        quantityFree: overrides && overrides.hasOwnProperty('quantityFree') ? overrides.quantityFree! : 5.9,
        quantityUsed: overrides && overrides.hasOwnProperty('quantityUsed') ? overrides.quantityUsed! : 3.9,
        quantityFreeUsed: overrides && overrides.hasOwnProperty('quantityFreeUsed') ? overrides.quantityFreeUsed! : 1.2,
        link: overrides && overrides.hasOwnProperty('link') ? overrides.link! : 'dolorum',
        isEnabled: overrides && overrides.hasOwnProperty('isEnabled') ? overrides.isEnabled! : false,
    };
};

export const anAccessCodeTicketOutput = (overrides?: Partial<AccessCodeTicketOutput>, _relationshipsToOmit: Set<string> = new Set()): AccessCodeTicketOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AccessCodeTicketOutput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'votum',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : TicketTypeKind.Standard,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'virgo',
        zoneName: overrides && overrides.hasOwnProperty('zoneName') ? overrides.zoneName! : 'quisquam',
        quantity: overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 9.5,
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 7.9,
        pricingTiers: overrides && overrides.hasOwnProperty('pricingTiers') ? overrides.pricingTiers! : [relationshipsToOmit.has('PublicReleaseTicketPricingTierOutput') ? {} as PublicReleaseTicketPricingTierOutput : aPublicReleaseTicketPricingTierOutput({}, relationshipsToOmit)],
        isHidden: overrides && overrides.hasOwnProperty('isHidden') ? overrides.isHidden! : false,
    };
};

export const anAccessCodeWhereInput = (overrides?: Partial<AccessCodeWhereInput>, _relationshipsToOmit: Set<string> = new Set()): AccessCodeWhereInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AccessCodeWhereInput');
    return {
        releaseId: overrides && overrides.hasOwnProperty('releaseId') ? overrides.releaseId! : 'calculus',
    };
};

export const anAccessCodeConnection = (overrides?: Partial<AccessCodeConnection>, _relationshipsToOmit: Set<string> = new Set()): AccessCodeConnection => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AccessCodeConnection');
    return {
        pageInfo: overrides && overrides.hasOwnProperty('pageInfo') ? overrides.pageInfo! : relationshipsToOmit.has('PageInfo') ? {} as PageInfo : aPageInfo({}, relationshipsToOmit),
        edges: overrides && overrides.hasOwnProperty('edges') ? overrides.edges! : [relationshipsToOmit.has('AccessCodeOutputEdge') ? {} as AccessCodeOutputEdge : anAccessCodeOutputEdge({}, relationshipsToOmit)],
        totalCount: overrides && overrides.hasOwnProperty('totalCount') ? overrides.totalCount! : 4500,
    };
};

export const anAccessCodeOutputEdge = (overrides?: Partial<AccessCodeOutputEdge>, _relationshipsToOmit: Set<string> = new Set()): AccessCodeOutputEdge => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AccessCodeOutputEdge');
    return {
        cursor: overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'thymum',
        node: overrides && overrides.hasOwnProperty('node') ? overrides.node! : relationshipsToOmit.has('AccessCodeOutput') ? {} as AccessCodeOutput : anAccessCodeOutput({}, relationshipsToOmit),
    };
};

export const aPresaleReleaseOutput = (overrides?: Partial<PresaleReleaseOutput>, _relationshipsToOmit: Set<string> = new Set()): PresaleReleaseOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PresaleReleaseOutput');
    return {
        releaseId: overrides && overrides.hasOwnProperty('releaseId') ? overrides.releaseId! : 'non',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'iste',
        slug: overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'qui',
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : true,
        isEnabled: overrides && overrides.hasOwnProperty('isEnabled') ? overrides.isEnabled! : true,
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2025-10-26T17:23:54.125Z",
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : "2025-05-16T11:36:45.662Z",
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : PresaleStatus.Scheduled,
        tickets: overrides && overrides.hasOwnProperty('tickets') ? overrides.tickets! : [relationshipsToOmit.has('PresaleTicketOutput') ? {} as PresaleTicketOutput : aPresaleTicketOutput({}, relationshipsToOmit)],
        accessCodes: overrides && overrides.hasOwnProperty('accessCodes') ? overrides.accessCodes! : [relationshipsToOmit.has('AccessCodeOutput') ? {} as AccessCodeOutput : anAccessCodeOutput({}, relationshipsToOmit)],
        accessScreenMessage: overrides && overrides.hasOwnProperty('accessScreenMessage') ? overrides.accessScreenMessage! : 'quaerat',
        accessScreenImage: overrides && overrides.hasOwnProperty('accessScreenImage') ? overrides.accessScreenImage! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        linkToWaitlist: overrides && overrides.hasOwnProperty('linkToWaitlist') ? overrides.linkToWaitlist! : false,
        allowPrePurchase: overrides && overrides.hasOwnProperty('allowPrePurchase') ? overrides.allowPrePurchase! : true,
        hasPrechargeOrder: overrides && overrides.hasOwnProperty('hasPrechargeOrder') ? overrides.hasPrechargeOrder! : true,
        startDateChangeInfo: overrides && overrides.hasOwnProperty('startDateChangeInfo') ? overrides.startDateChangeInfo! : relationshipsToOmit.has('PresaleStartDateChangeInfo') ? {} as PresaleStartDateChangeInfo : aPresaleStartDateChangeInfo({}, relationshipsToOmit),
    };
};

export const aPresaleTicketOutput = (overrides?: Partial<PresaleTicketOutput>, _relationshipsToOmit: Set<string> = new Set()): PresaleTicketOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PresaleTicketOutput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'defluo',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : TicketTypeKind.Standard,
    };
};

export const aPresaleStartDateChangeInfo = (overrides?: Partial<PresaleStartDateChangeInfo>, _relationshipsToOmit: Set<string> = new Set()): PresaleStartDateChangeInfo => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PresaleStartDateChangeInfo');
    return {
        hasChanged: overrides && overrides.hasOwnProperty('hasChanged') ? overrides.hasChanged! : false,
        latestActiveStartDateHistory: overrides && overrides.hasOwnProperty('latestActiveStartDateHistory') ? overrides.latestActiveStartDateHistory! : relationshipsToOmit.has('StartDateHistory') ? {} as StartDateHistory : aStartDateHistory({}, relationshipsToOmit),
    };
};

export const aStartDateHistory = (overrides?: Partial<StartDateHistory>, _relationshipsToOmit: Set<string> = new Set()): StartDateHistory => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('StartDateHistory');
    return {
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2025-08-23T03:35:34.391Z",
        disabledAt: overrides && overrides.hasOwnProperty('disabledAt') ? overrides.disabledAt! : "2025-04-08T09:37:07.947Z",
    };
};

export const aNamingFieldOutput = (overrides?: Partial<NamingFieldOutput>, _relationshipsToOmit: Set<string> = new Set()): NamingFieldOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('NamingFieldOutput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'consectetur',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'constans',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : NamingFieldType.FirstName,
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'utique',
        required: overrides && overrides.hasOwnProperty('required') ? overrides.required! : false,
        allTickets: overrides && overrides.hasOwnProperty('allTickets') ? overrides.allTickets! : false,
        specificTicketTypes: overrides && overrides.hasOwnProperty('specificTicketTypes') ? overrides.specificTicketTypes! : [relationshipsToOmit.has('PublicReleaseTicketOutput') ? {} as PublicReleaseTicketOutput : aPublicReleaseTicketOutput({}, relationshipsToOmit)],
        options: overrides && overrides.hasOwnProperty('options') ? overrides.options! : ['vulariter'],
        orderKey: overrides && overrides.hasOwnProperty('orderKey') ? overrides.orderKey! : 9,
    };
};

export const aPresaleDateRangeInput = (overrides?: Partial<PresaleDateRangeInput>, _relationshipsToOmit: Set<string> = new Set()): PresaleDateRangeInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PresaleDateRangeInput');
    return {
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'dolores',
        releaseId: overrides && overrides.hasOwnProperty('releaseId') ? overrides.releaseId! : 'impedit',
    };
};

export const anIntegrationWhereInput = (overrides?: Partial<IntegrationWhereInput>, _relationshipsToOmit: Set<string> = new Set()): IntegrationWhereInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('IntegrationWhereInput');
    return {
        group: overrides && overrides.hasOwnProperty('group') ? overrides.group! : IntegrationGroup.Payment,
    };
};

export const aXeroAllAccountsOutput = (overrides?: Partial<XeroAllAccountsOutput>, _relationshipsToOmit: Set<string> = new Set()): XeroAllAccountsOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('XeroAllAccountsOutput');
    return {
        currentAccountCode: overrides && overrides.hasOwnProperty('currentAccountCode') ? overrides.currentAccountCode! : 'crapula',
        availableAccounts: overrides && overrides.hasOwnProperty('availableAccounts') ? overrides.availableAccounts! : [relationshipsToOmit.has('XeroAccountOutput') ? {} as XeroAccountOutput : aXeroAccountOutput({}, relationshipsToOmit)],
    };
};

export const aXeroAccountOutput = (overrides?: Partial<XeroAccountOutput>, _relationshipsToOmit: Set<string> = new Set()): XeroAccountOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('XeroAccountOutput');
    return {
        accountId: overrides && overrides.hasOwnProperty('accountId') ? overrides.accountId! : 'conventus',
        code: overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'colligo',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'cursus',
        taxType: overrides && overrides.hasOwnProperty('taxType') ? overrides.taxType! : 'cornu',
        currency: overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'ater',
    };
};

export const aXeroConfigurationOutput = (overrides?: Partial<XeroConfigurationOutput>, _relationshipsToOmit: Set<string> = new Set()): XeroConfigurationOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('XeroConfigurationOutput');
    return {
        accountCode: overrides && overrides.hasOwnProperty('accountCode') ? overrides.accountCode! : 'adhaero',
        sendFlicketInvoice: overrides && overrides.hasOwnProperty('sendFlicketInvoice') ? overrides.sendFlicketInvoice! : true,
        invoiceStatus: overrides && overrides.hasOwnProperty('invoiceStatus') ? overrides.invoiceStatus! : XeroInvoiceStatus.Draft,
        numDaysToPay: overrides && overrides.hasOwnProperty('numDaysToPay') ? overrides.numDaysToPay! : 7.6,
        useCompanyNameOnInvoice: overrides && overrides.hasOwnProperty('useCompanyNameOnInvoice') ? overrides.useCompanyNameOnInvoice! : false,
    };
};

export const aShopifyCustomerOrder = (overrides?: Partial<ShopifyCustomerOrder>, _relationshipsToOmit: Set<string> = new Set()): ShopifyCustomerOrder => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ShopifyCustomerOrder');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'abundans',
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 'similique',
        currencyCode: overrides && overrides.hasOwnProperty('currencyCode') ? overrides.currencyCode! : 'esse',
        lineItems: overrides && overrides.hasOwnProperty('lineItems') ? overrides.lineItems! : [relationshipsToOmit.has('ShopifyLineItem') ? {} as ShopifyLineItem : aShopifyLineItem({}, relationshipsToOmit)],
    };
};

export const aShopifyLineItem = (overrides?: Partial<ShopifyLineItem>, _relationshipsToOmit: Set<string> = new Set()): ShopifyLineItem => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ShopifyLineItem');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'patria',
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'aduro',
        quantity: overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 2.7,
    };
};

export const anAdobeExperiencePlatformIntegration = (overrides?: Partial<AdobeExperiencePlatformIntegration>, _relationshipsToOmit: Set<string> = new Set()): AdobeExperiencePlatformIntegration => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AdobeExperiencePlatformIntegration');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '3f27546b-5fba-4afb-8ee4-d1d2589d26e9',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-08-10T15:00:39.159Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2026-02-12T17:01:00.332Z",
        tenant: overrides && overrides.hasOwnProperty('tenant') ? overrides.tenant! : 'tabella',
        sandboxName: overrides && overrides.hasOwnProperty('sandboxName') ? overrides.sandboxName! : 'volo',
        clientId: overrides && overrides.hasOwnProperty('clientId') ? overrides.clientId! : 'basium',
        clientSecret: overrides && overrides.hasOwnProperty('clientSecret') ? overrides.clientSecret! : 'vigilo',
        imsOrgId: overrides && overrides.hasOwnProperty('imsOrgId') ? overrides.imsOrgId! : 'compello',
        technicalAccountId: overrides && overrides.hasOwnProperty('technicalAccountId') ? overrides.technicalAccountId! : 'aqua',
        privateKeyBase64: overrides && overrides.hasOwnProperty('privateKeyBase64') ? overrides.privateKeyBase64! : 'confero',
        customerEndpoint: overrides && overrides.hasOwnProperty('customerEndpoint') ? overrides.customerEndpoint! : 'stipes',
        customerSchemaRefId: overrides && overrides.hasOwnProperty('customerSchemaRefId') ? overrides.customerSchemaRefId! : 'veritatis',
        customerDatasetId: overrides && overrides.hasOwnProperty('customerDatasetId') ? overrides.customerDatasetId! : 'trans',
        ticketEndpoint: overrides && overrides.hasOwnProperty('ticketEndpoint') ? overrides.ticketEndpoint! : 'venio',
        ticketSchemaRefId: overrides && overrides.hasOwnProperty('ticketSchemaRefId') ? overrides.ticketSchemaRefId! : 'aperiam',
        ticketDatasetId: overrides && overrides.hasOwnProperty('ticketDatasetId') ? overrides.ticketDatasetId! : 'taceo',
        scanEndpoint: overrides && overrides.hasOwnProperty('scanEndpoint') ? overrides.scanEndpoint! : 'delectatio',
        scanSchemaRefId: overrides && overrides.hasOwnProperty('scanSchemaRefId') ? overrides.scanSchemaRefId! : 'tredecim',
        scanDatasetId: overrides && overrides.hasOwnProperty('scanDatasetId') ? overrides.scanDatasetId! : 'esse',
    };
};

export const aCurrentOrganizationOutput = (overrides?: Partial<CurrentOrganizationOutput>, _relationshipsToOmit: Set<string> = new Set()): CurrentOrganizationOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CurrentOrganizationOutput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '1cd63a8d-6948-483b-834b-bfbc364c76e6',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2026-02-28T11:47:17.829Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-05-03T12:51:41.584Z",
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'vester',
        slug: overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'copia',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'artificiose',
        phone: overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : 'clementia',
        taxNumber: overrides && overrides.hasOwnProperty('taxNumber') ? overrides.taxNumber! : 'tumultus',
        currency: overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'bellum',
        address: overrides && overrides.hasOwnProperty('address') ? overrides.address! : relationshipsToOmit.has('Address') ? {} as Address : anAddress({}, relationshipsToOmit),
        landingPage: overrides && overrides.hasOwnProperty('landingPage') ? overrides.landingPage! : LandingPage.MultiEvent,
        showMemberships: overrides && overrides.hasOwnProperty('showMemberships') ? overrides.showMemberships! : true,
        showMembershipRenewal: overrides && overrides.hasOwnProperty('showMembershipRenewal') ? overrides.showMembershipRenewal! : false,
        supportInfo: overrides && overrides.hasOwnProperty('supportInfo') ? overrides.supportInfo! : 'blanditiis',
        privacyPolicy: overrides && overrides.hasOwnProperty('privacyPolicy') ? overrides.privacyPolicy! : 'adhaero',
        termsAndConditions: overrides && overrides.hasOwnProperty('termsAndConditions') ? overrides.termsAndConditions! : 'attonbitus',
        marketing: overrides && overrides.hasOwnProperty('marketing') ? overrides.marketing! : relationshipsToOmit.has('Marketing') ? {} as Marketing : aMarketing({}, relationshipsToOmit),
        shippingLabels: overrides && overrides.hasOwnProperty('shippingLabels') ? overrides.shippingLabels! : relationshipsToOmit.has('ShippingLabels') ? {} as ShippingLabels : aShippingLabels({}, relationshipsToOmit),
        features: overrides && overrides.hasOwnProperty('features') ? overrides.features! : ['sub'],
        timezone: overrides && overrides.hasOwnProperty('timezone') ? overrides.timezone! : 'Pacific/Auckland',
        locale: overrides && overrides.hasOwnProperty('locale') ? overrides.locale! : 'en',
        helpLink: overrides && overrides.hasOwnProperty('helpLink') ? overrides.helpLink! : 'absque',
        ticketCoverPlatformFeePercentage: overrides && overrides.hasOwnProperty('ticketCoverPlatformFeePercentage') ? overrides.ticketCoverPlatformFeePercentage! : 1.8,
        taxRate: overrides && overrides.hasOwnProperty('taxRate') ? overrides.taxRate! : 3.5,
        taxCalculationMethod: overrides && overrides.hasOwnProperty('taxCalculationMethod') ? overrides.taxCalculationMethod! : TaxCalculationMethod.Inclusive,
        defaultOptInMarketing: overrides && overrides.hasOwnProperty('defaultOptInMarketing') ? overrides.defaultOptInMarketing! : false,
        cookieConsent: overrides && overrides.hasOwnProperty('cookieConsent') ? overrides.cookieConsent! : true,
        defaultLanguage: overrides && overrides.hasOwnProperty('defaultLanguage') ? overrides.defaultLanguage! : 'copia',
        customTaxRate: overrides && overrides.hasOwnProperty('customTaxRate') ? overrides.customTaxRate! : 8,
        customTaxName: overrides && overrides.hasOwnProperty('customTaxName') ? overrides.customTaxName! : 'calculus',
        platformChargeSettings: overrides && overrides.hasOwnProperty('platformChargeSettings') ? overrides.platformChargeSettings! : relationshipsToOmit.has('PlatformChargeSettings') ? {} as PlatformChargeSettings : aPlatformChargeSettings({}, relationshipsToOmit),
        i18n: overrides && overrides.hasOwnProperty('i18n') ? overrides.i18n! : 'delinquo',
        isTest: overrides && overrides.hasOwnProperty('isTest') ? overrides.isTest! : false,
        landingTours: overrides && overrides.hasOwnProperty('landingTours') ? overrides.landingTours! : relationshipsToOmit.has('LandingToursSettings') ? {} as LandingToursSettings : aLandingToursSettings({}, relationshipsToOmit),
        flicketDomainOverride: overrides && overrides.hasOwnProperty('flicketDomainOverride') ? overrides.flicketDomainOverride! : 'basium',
        branding: overrides && overrides.hasOwnProperty('branding') ? overrides.branding! : relationshipsToOmit.has('OrganizationOutputBranding') ? {} as OrganizationOutputBranding : anOrganizationOutputBranding({}, relationshipsToOmit),
        singleEvent: overrides && overrides.hasOwnProperty('singleEvent') ? overrides.singleEvent! : relationshipsToOmit.has('Event') ? {} as Event : anEvent({}, relationshipsToOmit),
        shopify: overrides && overrides.hasOwnProperty('shopify') ? overrides.shopify! : relationshipsToOmit.has('ShopifyIntegration') ? {} as ShopifyIntegration : aShopifyIntegration({}, relationshipsToOmit),
        point: overrides && overrides.hasOwnProperty('point') ? overrides.point! : relationshipsToOmit.has('Point') ? {} as Point : aPoint({}, relationshipsToOmit),
        defaultI18nLanguage: overrides && overrides.hasOwnProperty('defaultI18nLanguage') ? overrides.defaultI18nLanguage! : 'crepusculum',
        customFields: overrides && overrides.hasOwnProperty('customFields') ? overrides.customFields! : [relationshipsToOmit.has('CustomFieldOuput') ? {} as CustomFieldOuput : aCustomFieldOuput({}, relationshipsToOmit)],
        seekaConfig: overrides && overrides.hasOwnProperty('seekaConfig') ? overrides.seekaConfig! : relationshipsToOmit.has('SeekaOutput') ? {} as SeekaOutput : aSeekaOutput({}, relationshipsToOmit),
        stats: overrides && overrides.hasOwnProperty('stats') ? overrides.stats! : relationshipsToOmit.has('OrganizationStats') ? {} as OrganizationStats : anOrganizationStats({}, relationshipsToOmit),
        scannerUrl: overrides && overrides.hasOwnProperty('scannerUrl') ? overrides.scannerUrl! : 'aequitas',
    };
};

export const anOrganizationOutputBranding = (overrides?: Partial<OrganizationOutputBranding>, _relationshipsToOmit: Set<string> = new Set()): OrganizationOutputBranding => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OrganizationOutputBranding');
    return {
        logo: overrides && overrides.hasOwnProperty('logo') ? overrides.logo! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        mobileLogo: overrides && overrides.hasOwnProperty('mobileLogo') ? overrides.mobileLogo! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        favicon: overrides && overrides.hasOwnProperty('favicon') ? overrides.favicon! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        background: overrides && overrides.hasOwnProperty('background') ? overrides.background! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        fullBackground: overrides && overrides.hasOwnProperty('fullBackground') ? overrides.fullBackground! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        primaryColor: overrides && overrides.hasOwnProperty('primaryColor') ? overrides.primaryColor! : 'ipsa',
        secondaryColor: overrides && overrides.hasOwnProperty('secondaryColor') ? overrides.secondaryColor! : 'copiose',
        greyScale: overrides && overrides.hasOwnProperty('greyScale') ? overrides.greyScale! : GreyScale.Warm,
        P300: overrides && overrides.hasOwnProperty('P300') ? overrides.P300! : 'deprecator',
        P200: overrides && overrides.hasOwnProperty('P200') ? overrides.P200! : 'altus',
        P100: overrides && overrides.hasOwnProperty('P100') ? overrides.P100! : 'candidus',
        S300: overrides && overrides.hasOwnProperty('S300') ? overrides.S300! : 'compello',
        S200: overrides && overrides.hasOwnProperty('S200') ? overrides.S200! : 'aspernatur',
        S100: overrides && overrides.hasOwnProperty('S100') ? overrides.S100! : 'tandem',
        N800: overrides && overrides.hasOwnProperty('N800') ? overrides.N800! : 'absum',
        N700: overrides && overrides.hasOwnProperty('N700') ? overrides.N700! : 'attollo',
        N600: overrides && overrides.hasOwnProperty('N600') ? overrides.N600! : 'quo',
        N500: overrides && overrides.hasOwnProperty('N500') ? overrides.N500! : 'cohors',
        N400: overrides && overrides.hasOwnProperty('N400') ? overrides.N400! : 'adeptio',
        N300: overrides && overrides.hasOwnProperty('N300') ? overrides.N300! : 'cum',
        N200: overrides && overrides.hasOwnProperty('N200') ? overrides.N200! : 'casso',
        N100: overrides && overrides.hasOwnProperty('N100') ? overrides.N100! : 'clementia',
    };
};

export const aShopifyIntegration = (overrides?: Partial<ShopifyIntegration>, _relationshipsToOmit: Set<string> = new Set()): ShopifyIntegration => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ShopifyIntegration');
    return {
        storefrontAccessToken: overrides && overrides.hasOwnProperty('storefrontAccessToken') ? overrides.storefrontAccessToken! : 'deinde',
        shopDomain: overrides && overrides.hasOwnProperty('shopDomain') ? overrides.shopDomain! : 'alii',
        navLinkLabel: overrides && overrides.hasOwnProperty('navLinkLabel') ? overrides.navLinkLabel! : 'appono',
        navLinkUrl: overrides && overrides.hasOwnProperty('navLinkUrl') ? overrides.navLinkUrl! : 'succurro',
    };
};

export const anOrganizationStats = (overrides?: Partial<OrganizationStats>, _relationshipsToOmit: Set<string> = new Set()): OrganizationStats => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OrganizationStats');
    return {
        emailBroadcastLastUsedAt: overrides && overrides.hasOwnProperty('emailBroadcastLastUsedAt') ? overrides.emailBroadcastLastUsedAt! : "2025-07-24T20:27:30.950Z",
        emailBroadcastLastSentAt: overrides && overrides.hasOwnProperty('emailBroadcastLastSentAt') ? overrides.emailBroadcastLastSentAt! : "2025-05-07T07:36:31.109Z",
        smsBroadcastLastUsedAt: overrides && overrides.hasOwnProperty('smsBroadcastLastUsedAt') ? overrides.smsBroadcastLastUsedAt! : "2025-04-17T19:29:24.707Z",
        smsBroadcastLastSentAt: overrides && overrides.hasOwnProperty('smsBroadcastLastSentAt') ? overrides.smsBroadcastLastSentAt! : "2025-10-14T13:30:17.898Z",
        leadFormsLastReceivedAt: overrides && overrides.hasOwnProperty('leadFormsLastReceivedAt') ? overrides.leadFormsLastReceivedAt! : "2025-08-16T05:08:14.858Z",
        shopifyLastUsedAt: overrides && overrides.hasOwnProperty('shopifyLastUsedAt') ? overrides.shopifyLastUsedAt! : "2025-07-15T02:54:22.306Z",
        trackingCodeLastUsedAt: overrides && overrides.hasOwnProperty('trackingCodeLastUsedAt') ? overrides.trackingCodeLastUsedAt! : "2025-12-28T02:21:43.111Z",
    };
};

export const anOrganizationWhereInput = (overrides?: Partial<OrganizationWhereInput>, _relationshipsToOmit: Set<string> = new Set()): OrganizationWhereInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OrganizationWhereInput');
    return {
        q: overrides && overrides.hasOwnProperty('q') ? overrides.q! : 'vulnus',
    };
};

export const anOrganizationOrderByInput = (overrides?: Partial<OrganizationOrderByInput>, _relationshipsToOmit: Set<string> = new Set()): OrganizationOrderByInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OrganizationOrderByInput');
    return {
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : OrderByDirection.Asc,
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : OrderByDirection.Asc,
    };
};

export const anOrganizationConnection = (overrides?: Partial<OrganizationConnection>, _relationshipsToOmit: Set<string> = new Set()): OrganizationConnection => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OrganizationConnection');
    return {
        pageInfo: overrides && overrides.hasOwnProperty('pageInfo') ? overrides.pageInfo! : relationshipsToOmit.has('PageInfo') ? {} as PageInfo : aPageInfo({}, relationshipsToOmit),
        edges: overrides && overrides.hasOwnProperty('edges') ? overrides.edges! : [relationshipsToOmit.has('OrganizationEdge') ? {} as OrganizationEdge : anOrganizationEdge({}, relationshipsToOmit)],
        totalCount: overrides && overrides.hasOwnProperty('totalCount') ? overrides.totalCount! : 8365,
    };
};

export const anOrganizationEdge = (overrides?: Partial<OrganizationEdge>, _relationshipsToOmit: Set<string> = new Set()): OrganizationEdge => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OrganizationEdge');
    return {
        cursor: overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'commemoro',
        node: overrides && overrides.hasOwnProperty('node') ? overrides.node! : relationshipsToOmit.has('Organization') ? {} as Organization : anOrganization({}, relationshipsToOmit),
    };
};

export const anOrganizationFeatures = (overrides?: Partial<OrganizationFeatures>, _relationshipsToOmit: Set<string> = new Set()): OrganizationFeatures => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OrganizationFeatures');
    return {
        features: overrides && overrides.hasOwnProperty('features') ? overrides.features! : [relationshipsToOmit.has('Feature') ? {} as Feature : aFeature({}, relationshipsToOmit)],
    };
};

export const aFeature = (overrides?: Partial<Feature>, _relationshipsToOmit: Set<string> = new Set()): Feature => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Feature');
    return {
        key: overrides && overrides.hasOwnProperty('key') ? overrides.key! : FeatureFlagKeyEnum.Account2Account,
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'suscipit',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'administratio',
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : FeatureStatusEnum.Development,
    };
};

export const anOrderIdsOnlineOutput = (overrides?: Partial<OrderIdsOnlineOutput>, _relationshipsToOmit: Set<string> = new Set()): OrderIdsOnlineOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OrderIdsOnlineOutput');
    return {
        orderId: overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'custodia',
    };
};

export const anEventOrdersOnlineOutput = (overrides?: Partial<EventOrdersOnlineOutput>, _relationshipsToOmit: Set<string> = new Set()): EventOrdersOnlineOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EventOrdersOnlineOutput');
    return {
        totalCount: overrides && overrides.hasOwnProperty('totalCount') ? overrides.totalCount! : 9.8,
        baseTickets: overrides && overrides.hasOwnProperty('baseTickets') ? overrides.baseTickets! : 0.1,
        ticketFees: overrides && overrides.hasOwnProperty('ticketFees') ? overrides.ticketFees! : 0.3,
        bookingFees: overrides && overrides.hasOwnProperty('bookingFees') ? overrides.bookingFees! : 4.8,
        transactionFees: overrides && overrides.hasOwnProperty('transactionFees') ? overrides.transactionFees! : 3.7,
        deliveryFees: overrides && overrides.hasOwnProperty('deliveryFees') ? overrides.deliveryFees! : 6.9,
        refundedAmount: overrides && overrides.hasOwnProperty('refundedAmount') ? overrides.refundedAmount! : 4.7,
        addons: overrides && overrides.hasOwnProperty('addons') ? overrides.addons! : 7.5,
        creditsUsed: overrides && overrides.hasOwnProperty('creditsUsed') ? overrides.creditsUsed! : 5.5,
        orderIdsOnline: overrides && overrides.hasOwnProperty('orderIdsOnline') ? overrides.orderIdsOnline! : [relationshipsToOmit.has('OrderIdsOnlineOutput') ? {} as OrderIdsOnlineOutput : anOrderIdsOnlineOutput({}, relationshipsToOmit)],
    };
};

export const anOrderRefundDetailsOutput = (overrides?: Partial<OrderRefundDetailsOutput>, _relationshipsToOmit: Set<string> = new Set()): OrderRefundDetailsOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OrderRefundDetailsOutput');
    return {
        orderId: overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'turba',
        baseTickets: overrides && overrides.hasOwnProperty('baseTickets') ? overrides.baseTickets! : 0.6,
        ticketFees: overrides && overrides.hasOwnProperty('ticketFees') ? overrides.ticketFees! : 7,
        bookingFees: overrides && overrides.hasOwnProperty('bookingFees') ? overrides.bookingFees! : 8.7,
        transactionFees: overrides && overrides.hasOwnProperty('transactionFees') ? overrides.transactionFees! : 1.5,
        deliveryFees: overrides && overrides.hasOwnProperty('deliveryFees') ? overrides.deliveryFees! : 4.7,
        refundedAmount: overrides && overrides.hasOwnProperty('refundedAmount') ? overrides.refundedAmount! : 2,
        addons: overrides && overrides.hasOwnProperty('addons') ? overrides.addons! : 4.5,
        creditsUsed: overrides && overrides.hasOwnProperty('creditsUsed') ? overrides.creditsUsed! : 6.1,
    };
};

export const aCustomSaleOutput = (overrides?: Partial<CustomSaleOutput>, _relationshipsToOmit: Set<string> = new Set()): CustomSaleOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CustomSaleOutput');
    return {
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : 'itaque',
    };
};

export const aPaymentOptions = (overrides?: Partial<PaymentOptions>, _relationshipsToOmit: Set<string> = new Set()): PaymentOptions => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PaymentOptions');
    return {
        orderId: overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'bonus',
        options: overrides && overrides.hasOwnProperty('options') ? overrides.options! : [relationshipsToOmit.has('PaymentOption') ? {} as PaymentOption : aPaymentOption({}, relationshipsToOmit)],
    };
};

export const aPaymentOption = (overrides?: Partial<PaymentOption>, _relationshipsToOmit: Set<string> = new Set()): PaymentOption => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PaymentOption');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'tolero',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'ventito',
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'ventosus',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : IntegrationType.PaymentStripe,
        paymentMethod: overrides && overrides.hasOwnProperty('paymentMethod') ? overrides.paymentMethod! : 'aperte',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'voluptatem',
        order: overrides && overrides.hasOwnProperty('order') ? overrides.order! : 8.6,
        transactionFee: overrides && overrides.hasOwnProperty('transactionFee') ? overrides.transactionFee! : 9.4,
        transactionFeeType: overrides && overrides.hasOwnProperty('transactionFeeType') ? overrides.transactionFeeType! : FeeType.FlatRate,
        transactionFee2: overrides && overrides.hasOwnProperty('transactionFee2') ? overrides.transactionFee2! : 6.3,
        transactionFeeType2: overrides && overrides.hasOwnProperty('transactionFeeType2') ? overrides.transactionFeeType2! : FeeType.FlatRate,
        bnplEnabled: overrides && overrides.hasOwnProperty('bnplEnabled') ? overrides.bnplEnabled! : false,
        calculatedTransactionFee: overrides && overrides.hasOwnProperty('calculatedTransactionFee') ? overrides.calculatedTransactionFee! : 1.1,
        paymentPlanMetadata: overrides && overrides.hasOwnProperty('paymentPlanMetadata') ? overrides.paymentPlanMetadata! : relationshipsToOmit.has('PaymentPlanMetadata') ? {} as PaymentPlanMetadata : aPaymentPlanMetadata({}, relationshipsToOmit),
    };
};

export const aPaymentPlanMetadata = (overrides?: Partial<PaymentPlanMetadata>, _relationshipsToOmit: Set<string> = new Set()): PaymentPlanMetadata => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PaymentPlanMetadata');
    return {
        depositAmount: overrides && overrides.hasOwnProperty('depositAmount') ? overrides.depositAmount! : 9,
        installmentAmount: overrides && overrides.hasOwnProperty('installmentAmount') ? overrides.installmentAmount! : 7.4,
        installmentCount: overrides && overrides.hasOwnProperty('installmentCount') ? overrides.installmentCount! : 1.7,
        paymentPlanFeePercentage: overrides && overrides.hasOwnProperty('paymentPlanFeePercentage') ? overrides.paymentPlanFeePercentage! : 1.8,
    };
};

export const aTicketCoverAmount = (overrides?: Partial<TicketCoverAmount>, _relationshipsToOmit: Set<string> = new Set()): TicketCoverAmount => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TicketCoverAmount');
    return {
        totalFeeAmount: overrides && overrides.hasOwnProperty('totalFeeAmount') ? overrides.totalFeeAmount! : 1,
    };
};

export const anOrderCreateOutput = (overrides?: Partial<OrderCreateOutput>, _relationshipsToOmit: Set<string> = new Set()): OrderCreateOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OrderCreateOutput');
    return {
        jobId: overrides && overrides.hasOwnProperty('jobId') ? overrides.jobId! : 'deserunt',
        order: overrides && overrides.hasOwnProperty('order') ? overrides.order! : relationshipsToOmit.has('Order') ? {} as Order : anOrder({}, relationshipsToOmit),
        createOrderError: overrides && overrides.hasOwnProperty('createOrderError') ? overrides.createOrderError! : [relationshipsToOmit.has('TicketNotAvailableError') ? {} as TicketNotAvailableError : aTicketNotAvailableError({}, relationshipsToOmit)],
    };
};

export const aTicketNotAvailableError = (overrides?: Partial<TicketNotAvailableError>, _relationshipsToOmit: Set<string> = new Set()): TicketNotAvailableError => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TicketNotAvailableError');
    return {
        message: overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'conturbo',
        shouldDisplayWaitlist: overrides && overrides.hasOwnProperty('shouldDisplayWaitlist') ? overrides.shouldDisplayWaitlist! : false,
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'aro',
        releaseId: overrides && overrides.hasOwnProperty('releaseId') ? overrides.releaseId! : 'abduco',
    };
};

export const aCreateOrderError = (overrides?: Partial<CreateOrderError>, _relationshipsToOmit: Set<string> = new Set()): CreateOrderError => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateOrderError');
    return {
        message: overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'auctor',
    };
};

export const anOrderComponent = (overrides?: Partial<OrderComponent>, _relationshipsToOmit: Set<string> = new Set()): OrderComponent => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OrderComponent');
    return {
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : OrderComponentType.FaceValue,
        orderId: overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'canto',
        isFullyRefunded: overrides && overrides.hasOwnProperty('isFullyRefunded') ? overrides.isFullyRefunded! : true,
        refundableAmount: overrides && overrides.hasOwnProperty('refundableAmount') ? overrides.refundableAmount! : 8.6,
        refundedAmount: overrides && overrides.hasOwnProperty('refundedAmount') ? overrides.refundedAmount! : 0.1,
        paidAmount: overrides && overrides.hasOwnProperty('paidAmount') ? overrides.paidAmount! : 3.1,
        totalAmount: overrides && overrides.hasOwnProperty('totalAmount') ? overrides.totalAmount! : 8.8,
        ticketId: overrides && overrides.hasOwnProperty('ticketId') ? overrides.ticketId! : 'textor',
        ticket: overrides && overrides.hasOwnProperty('ticket') ? overrides.ticket! : relationshipsToOmit.has('Ticket') ? {} as Ticket : aTicket({}, relationshipsToOmit),
        lineItemId: overrides && overrides.hasOwnProperty('lineItemId') ? overrides.lineItemId! : 'accendo',
        customLabel: overrides && overrides.hasOwnProperty('customLabel') ? overrides.customLabel! : 'et',
        taxName: overrides && overrides.hasOwnProperty('taxName') ? overrides.taxName! : 'texo',
    };
};

export const anOrderRefundData = (overrides?: Partial<OrderRefundData>, _relationshipsToOmit: Set<string> = new Set()): OrderRefundData => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OrderRefundData');
    return {
        orderId: overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'vomer',
        gatewayRefundableAmount: overrides && overrides.hasOwnProperty('gatewayRefundableAmount') ? overrides.gatewayRefundableAmount! : relationshipsToOmit.has('GatewayRefundableAmount') ? {} as GatewayRefundableAmount : aGatewayRefundableAmount({}, relationshipsToOmit),
        ticketRefundData: overrides && overrides.hasOwnProperty('ticketRefundData') ? overrides.ticketRefundData! : [relationshipsToOmit.has('TicketRefundData') ? {} as TicketRefundData : aTicketRefundData({}, relationshipsToOmit)],
        orderLevelComponents: overrides && overrides.hasOwnProperty('orderLevelComponents') ? overrides.orderLevelComponents! : [relationshipsToOmit.has('OrderComponent') ? {} as OrderComponent : anOrderComponent({}, relationshipsToOmit)],
    };
};

export const aTicketRefundData = (overrides?: Partial<TicketRefundData>, _relationshipsToOmit: Set<string> = new Set()): TicketRefundData => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TicketRefundData');
    return {
        ticket: overrides && overrides.hasOwnProperty('ticket') ? overrides.ticket! : relationshipsToOmit.has('Ticket') ? {} as Ticket : aTicket({}, relationshipsToOmit),
        ticketLevelComponents: overrides && overrides.hasOwnProperty('ticketLevelComponents') ? overrides.ticketLevelComponents! : [relationshipsToOmit.has('OrderComponent') ? {} as OrderComponent : anOrderComponent({}, relationshipsToOmit)],
    };
};

export const aGetHistoryByCustomerIdInput = (overrides?: Partial<GetHistoryByCustomerIdInput>, _relationshipsToOmit: Set<string> = new Set()): GetHistoryByCustomerIdInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('GetHistoryByCustomerIdInput');
    return {
        refName: overrides && overrides.hasOwnProperty('refName') ? overrides.refName! : ['tot'],
        orderId: overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'tunc',
        userId: overrides && overrides.hasOwnProperty('userId') ? overrides.userId! : 'tutis',
    };
};

export const aMembershipWhereInput = (overrides?: Partial<MembershipWhereInput>, _relationshipsToOmit: Set<string> = new Set()): MembershipWhereInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MembershipWhereInput');
    return {
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : false,
        q: overrides && overrides.hasOwnProperty('q') ? overrides.q! : 'vinum',
        seasonId: overrides && overrides.hasOwnProperty('seasonId') ? overrides.seasonId! : 'sumptus',
    };
};

export const aMembershipOrderByInput = (overrides?: Partial<MembershipOrderByInput>, _relationshipsToOmit: Set<string> = new Set()): MembershipOrderByInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MembershipOrderByInput');
    return {
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : OrderByDirection.Asc,
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : OrderByDirection.Asc,
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : OrderByDirection.Asc,
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : OrderByDirection.Asc,
    };
};

export const aMembershipConnection = (overrides?: Partial<MembershipConnection>, _relationshipsToOmit: Set<string> = new Set()): MembershipConnection => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MembershipConnection');
    return {
        pageInfo: overrides && overrides.hasOwnProperty('pageInfo') ? overrides.pageInfo! : relationshipsToOmit.has('PageInfo') ? {} as PageInfo : aPageInfo({}, relationshipsToOmit),
        edges: overrides && overrides.hasOwnProperty('edges') ? overrides.edges! : [relationshipsToOmit.has('MembershipEdge') ? {} as MembershipEdge : aMembershipEdge({}, relationshipsToOmit)],
        totalCount: overrides && overrides.hasOwnProperty('totalCount') ? overrides.totalCount! : 3094,
    };
};

export const aMembershipEdge = (overrides?: Partial<MembershipEdge>, _relationshipsToOmit: Set<string> = new Set()): MembershipEdge => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MembershipEdge');
    return {
        cursor: overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'demitto',
        node: overrides && overrides.hasOwnProperty('node') ? overrides.node! : relationshipsToOmit.has('Membership') ? {} as Membership : aMembership({}, relationshipsToOmit),
    };
};

export const aMembershipTypeEventTransferPrice = (overrides?: Partial<MembershipTypeEventTransferPrice>, _relationshipsToOmit: Set<string> = new Set()): MembershipTypeEventTransferPrice => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MembershipTypeEventTransferPrice');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'a075dc4a-06b7-4b95-89e5-ae0b04356501',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-09-03T00:49:12.976Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-06-24T18:17:23.184Z",
        membership: overrides && overrides.hasOwnProperty('membership') ? overrides.membership! : relationshipsToOmit.has('Membership') ? {} as Membership : aMembership({}, relationshipsToOmit),
        membershipType: overrides && overrides.hasOwnProperty('membershipType') ? overrides.membershipType! : relationshipsToOmit.has('MembershipType') ? {} as MembershipType : aMembershipType({}, relationshipsToOmit),
        membershipZone: overrides && overrides.hasOwnProperty('membershipZone') ? overrides.membershipZone! : relationshipsToOmit.has('MembershipZone') ? {} as MembershipZone : aMembershipZone({}, relationshipsToOmit),
        event: overrides && overrides.hasOwnProperty('event') ? overrides.event! : relationshipsToOmit.has('Event') ? {} as Event : anEvent({}, relationshipsToOmit),
        maxSalePrice: overrides && overrides.hasOwnProperty('maxSalePrice') ? overrides.maxSalePrice! : 5.6,
    };
};

export const aMembershipSubscriptionPortalOutput = (overrides?: Partial<MembershipSubscriptionPortalOutput>, _relationshipsToOmit: Set<string> = new Set()): MembershipSubscriptionPortalOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MembershipSubscriptionPortalOutput');
    return {
        url: overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'somniculosus',
    };
};

export const aMembershipSubscription = (overrides?: Partial<MembershipSubscription>, _relationshipsToOmit: Set<string> = new Set()): MembershipSubscription => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MembershipSubscription');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '588525c2-be74-4e68-85b3-0a015a607368',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-12-31T20:40:48.773Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-04-22T08:28:05.858Z",
        stripeSubscriptionId: overrides && overrides.hasOwnProperty('stripeSubscriptionId') ? overrides.stripeSubscriptionId! : 'crapula',
        billingDetails: overrides && overrides.hasOwnProperty('billingDetails') ? overrides.billingDetails! : relationshipsToOmit.has('MembershipSubscriptionBillingDetails') ? {} as MembershipSubscriptionBillingDetails : aMembershipSubscriptionBillingDetails({}, relationshipsToOmit),
        membershipTicketCount: overrides && overrides.hasOwnProperty('membershipTicketCount') ? overrides.membershipTicketCount! : 7.7,
        lastOrderId: overrides && overrides.hasOwnProperty('lastOrderId') ? overrides.lastOrderId! : 'patrocinor',
        lastOrder: overrides && overrides.hasOwnProperty('lastOrder') ? overrides.lastOrder! : relationshipsToOmit.has('Order') ? {} as Order : anOrder({}, relationshipsToOmit),
        userId: overrides && overrides.hasOwnProperty('userId') ? overrides.userId! : 'laboriosam',
        renewals: overrides && overrides.hasOwnProperty('renewals') ? overrides.renewals! : [relationshipsToOmit.has('MembershipSubscriptionRenewal') ? {} as MembershipSubscriptionRenewal : aMembershipSubscriptionRenewal({}, relationshipsToOmit)],
        latestRenewalId: overrides && overrides.hasOwnProperty('latestRenewalId') ? overrides.latestRenewalId! : 'cetera',
    };
};

export const aMembershipSubscriptionBillingDetails = (overrides?: Partial<MembershipSubscriptionBillingDetails>, _relationshipsToOmit: Set<string> = new Set()): MembershipSubscriptionBillingDetails => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MembershipSubscriptionBillingDetails');
    return {
        cardLast4: overrides && overrides.hasOwnProperty('cardLast4') ? overrides.cardLast4! : 'volubilis',
        cardBrand: overrides && overrides.hasOwnProperty('cardBrand') ? overrides.cardBrand! : 'vorax',
        cardExpiryMonth: overrides && overrides.hasOwnProperty('cardExpiryMonth') ? overrides.cardExpiryMonth! : 2.6,
        cardExpiryYear: overrides && overrides.hasOwnProperty('cardExpiryYear') ? overrides.cardExpiryYear! : 2.1,
        emailAddress: overrides && overrides.hasOwnProperty('emailAddress') ? overrides.emailAddress! : 'atque',
    };
};

export const aMembershipSubscriptionRenewal = (overrides?: Partial<MembershipSubscriptionRenewal>, _relationshipsToOmit: Set<string> = new Set()): MembershipSubscriptionRenewal => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MembershipSubscriptionRenewal');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'e9d3e32d-d2cf-4afb-9d5a-ab534ef12d3f',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-12-19T20:07:26.871Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-03-24T06:27:12.924Z",
        dueAt: overrides && overrides.hasOwnProperty('dueAt') ? overrides.dueAt! : "2026-02-26T09:31:05.022Z",
        completedAt: overrides && overrides.hasOwnProperty('completedAt') ? overrides.completedAt! : "2026-03-02T04:23:36.853Z",
        remindedAt: overrides && overrides.hasOwnProperty('remindedAt') ? overrides.remindedAt! : "2026-01-06T04:26:32.144Z",
        subscriptionState: overrides && overrides.hasOwnProperty('subscriptionState') ? overrides.subscriptionState! : MembershipSubscriptionState.Scheduled,
        failedAt: overrides && overrides.hasOwnProperty('failedAt') ? overrides.failedAt! : "2025-03-16T16:10:40.688Z",
        failureReason: overrides && overrides.hasOwnProperty('failureReason') ? overrides.failureReason! : 'sui',
        membershipSubscriptionId: overrides && overrides.hasOwnProperty('membershipSubscriptionId') ? overrides.membershipSubscriptionId! : 'voluptates',
        currentMembershipId: overrides && overrides.hasOwnProperty('currentMembershipId') ? overrides.currentMembershipId! : 'alveus',
        currentOrderId: overrides && overrides.hasOwnProperty('currentOrderId') ? overrides.currentOrderId! : 'valeo',
        previousMembershipId: overrides && overrides.hasOwnProperty('previousMembershipId') ? overrides.previousMembershipId! : 'voro',
        previousOrderId: overrides && overrides.hasOwnProperty('previousOrderId') ? overrides.previousOrderId! : 'suppellex',
    };
};

export const aMembershipAutoRenewalOutput = (overrides?: Partial<MembershipAutoRenewalOutput>, _relationshipsToOmit: Set<string> = new Set()): MembershipAutoRenewalOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MembershipAutoRenewalOutput');
    return {
        autoRenewal: overrides && overrides.hasOwnProperty('autoRenewal') ? overrides.autoRenewal! : relationshipsToOmit.has('MembershipAutoRenewal') ? {} as MembershipAutoRenewal : aMembershipAutoRenewal({}, relationshipsToOmit),
    };
};

export const aMembershipAutoRenewal = (overrides?: Partial<MembershipAutoRenewal>, _relationshipsToOmit: Set<string> = new Set()): MembershipAutoRenewal => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MembershipAutoRenewal');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '1438ca27-4b20-4857-9b1c-fae62c41936f',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-07-10T10:13:34.973Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-07-15T15:21:27.186Z",
        membership: overrides && overrides.hasOwnProperty('membership') ? overrides.membership! : relationshipsToOmit.has('Membership') ? {} as Membership : aMembership({}, relationshipsToOmit),
        membershipId: overrides && overrides.hasOwnProperty('membershipId') ? overrides.membershipId! : 'umerus',
        organizationId: overrides && overrides.hasOwnProperty('organizationId') ? overrides.organizationId! : 'talis',
        renewalDate: overrides && overrides.hasOwnProperty('renewalDate') ? overrides.renewalDate! : "2025-04-04T10:12:28.490Z",
        reminderDate: overrides && overrides.hasOwnProperty('reminderDate') ? overrides.reminderDate! : "2025-05-06T15:41:09.567Z",
        membershipMappings: overrides && overrides.hasOwnProperty('membershipMappings') ? overrides.membershipMappings! : [relationshipsToOmit.has('MembershipRenewalMapping') ? {} as MembershipRenewalMapping : aMembershipRenewalMapping({}, relationshipsToOmit)],
        renewalStep: overrides && overrides.hasOwnProperty('renewalStep') ? overrides.renewalStep! : MembershipAutoRenewalStep.Scheduled,
    };
};

export const aMembershipRenewalMapping = (overrides?: Partial<MembershipRenewalMapping>, _relationshipsToOmit: Set<string> = new Set()): MembershipRenewalMapping => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MembershipRenewalMapping');
    return {
        membershipId: overrides && overrides.hasOwnProperty('membershipId') ? overrides.membershipId! : 'quaerat',
        membershipTypeMappings: overrides && overrides.hasOwnProperty('membershipTypeMappings') ? overrides.membershipTypeMappings! : [relationshipsToOmit.has('MembershipTypeMapping') ? {} as MembershipTypeMapping : aMembershipTypeMapping({}, relationshipsToOmit)],
    };
};

export const aMembershipTypeMapping = (overrides?: Partial<MembershipTypeMapping>, _relationshipsToOmit: Set<string> = new Set()): MembershipTypeMapping => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MembershipTypeMapping');
    return {
        previousMembershipTypeId: overrides && overrides.hasOwnProperty('previousMembershipTypeId') ? overrides.previousMembershipTypeId! : 'synagoga',
        newMembershipTypeId: overrides && overrides.hasOwnProperty('newMembershipTypeId') ? overrides.newMembershipTypeId! : 'ademptio',
    };
};

export const aFindScoutsInput = (overrides?: Partial<FindScoutsInput>, _relationshipsToOmit: Set<string> = new Set()): FindScoutsInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('FindScoutsInput');
    return {
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : true,
    };
};

export const aScoutUserConnection = (overrides?: Partial<ScoutUserConnection>, _relationshipsToOmit: Set<string> = new Set()): ScoutUserConnection => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ScoutUserConnection');
    return {
        pageInfo: overrides && overrides.hasOwnProperty('pageInfo') ? overrides.pageInfo! : relationshipsToOmit.has('PageInfo') ? {} as PageInfo : aPageInfo({}, relationshipsToOmit),
        edges: overrides && overrides.hasOwnProperty('edges') ? overrides.edges! : [relationshipsToOmit.has('ScoutUserEdge') ? {} as ScoutUserEdge : aScoutUserEdge({}, relationshipsToOmit)],
        totalCount: overrides && overrides.hasOwnProperty('totalCount') ? overrides.totalCount! : 7391,
    };
};

export const aScoutUserEdge = (overrides?: Partial<ScoutUserEdge>, _relationshipsToOmit: Set<string> = new Set()): ScoutUserEdge => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ScoutUserEdge');
    return {
        cursor: overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'viscus',
        node: overrides && overrides.hasOwnProperty('node') ? overrides.node! : relationshipsToOmit.has('ScoutUser') ? {} as ScoutUser : aScoutUser({}, relationshipsToOmit),
    };
};

export const aScoutUser = (overrides?: Partial<ScoutUser>, _relationshipsToOmit: Set<string> = new Set()): ScoutUser => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ScoutUser');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '3515950a-2e11-4247-b5fc-1e8f0a117b5a',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-08-24T18:57:57.128Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-08-31T21:40:13.377Z",
        scout: overrides && overrides.hasOwnProperty('scout') ? overrides.scout! : relationshipsToOmit.has('Scout') ? {} as Scout : aScout({}, relationshipsToOmit),
        user: overrides && overrides.hasOwnProperty('user') ? overrides.user! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        stage: overrides && overrides.hasOwnProperty('stage') ? overrides.stage! : ScoutStage.NoContact,
        agentUser: overrides && overrides.hasOwnProperty('agentUser') ? overrides.agentUser! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        remindAt: overrides && overrides.hasOwnProperty('remindAt') ? overrides.remindAt! : "2025-10-16T14:10:00.088Z",
        deletedAt: overrides && overrides.hasOwnProperty('deletedAt') ? overrides.deletedAt! : "2025-05-18T01:07:17.221Z",
    };
};

export const anInitScout = (overrides?: Partial<InitScout>, _relationshipsToOmit: Set<string> = new Set()): InitScout => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InitScout');
    return {
        seasons: overrides && overrides.hasOwnProperty('seasons') ? overrides.seasons! : [relationshipsToOmit.has('Season') ? {} as Season : aSeason({}, relationshipsToOmit)],
        membershipTypes: overrides && overrides.hasOwnProperty('membershipTypes') ? overrides.membershipTypes! : [relationshipsToOmit.has('MembershipType') ? {} as MembershipType : aMembershipType({}, relationshipsToOmit)],
        events: overrides && overrides.hasOwnProperty('events') ? overrides.events! : [relationshipsToOmit.has('Event') ? {} as Event : anEvent({}, relationshipsToOmit)],
        userTags: overrides && overrides.hasOwnProperty('userTags') ? overrides.userTags! : [relationshipsToOmit.has('Tag') ? {} as Tag : aTag({}, relationshipsToOmit)],
        zones: overrides && overrides.hasOwnProperty('zones') ? overrides.zones! : [relationshipsToOmit.has('Zone') ? {} as Zone : aZone({}, relationshipsToOmit)],
    };
};

export const aScoutCommunicationsInput = (overrides?: Partial<ScoutCommunicationsInput>, _relationshipsToOmit: Set<string> = new Set()): ScoutCommunicationsInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ScoutCommunicationsInput');
    return {
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : true,
    };
};

export const aScoutCommunicationUserConnection = (overrides?: Partial<ScoutCommunicationUserConnection>, _relationshipsToOmit: Set<string> = new Set()): ScoutCommunicationUserConnection => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ScoutCommunicationUserConnection');
    return {
        pageInfo: overrides && overrides.hasOwnProperty('pageInfo') ? overrides.pageInfo! : relationshipsToOmit.has('PageInfo') ? {} as PageInfo : aPageInfo({}, relationshipsToOmit),
        edges: overrides && overrides.hasOwnProperty('edges') ? overrides.edges! : [relationshipsToOmit.has('ScoutCommunicationUserEdge') ? {} as ScoutCommunicationUserEdge : aScoutCommunicationUserEdge({}, relationshipsToOmit)],
        totalCount: overrides && overrides.hasOwnProperty('totalCount') ? overrides.totalCount! : 7407,
    };
};

export const aScoutCommunicationUserEdge = (overrides?: Partial<ScoutCommunicationUserEdge>, _relationshipsToOmit: Set<string> = new Set()): ScoutCommunicationUserEdge => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ScoutCommunicationUserEdge');
    return {
        cursor: overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'decimus',
        node: overrides && overrides.hasOwnProperty('node') ? overrides.node! : relationshipsToOmit.has('ScoutCommunicationUser') ? {} as ScoutCommunicationUser : aScoutCommunicationUser({}, relationshipsToOmit),
    };
};

export const aScoutCommunicationUser = (overrides?: Partial<ScoutCommunicationUser>, _relationshipsToOmit: Set<string> = new Set()): ScoutCommunicationUser => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ScoutCommunicationUser');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'e167a4b7-0368-47d6-b733-7b701c2faa0b',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-08-11T08:37:29.304Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-08-06T14:54:07.236Z",
        scoutCommunication: overrides && overrides.hasOwnProperty('scoutCommunication') ? overrides.scoutCommunication! : relationshipsToOmit.has('ScoutCommunication') ? {} as ScoutCommunication : aScoutCommunication({}, relationshipsToOmit),
        stage: overrides && overrides.hasOwnProperty('stage') ? overrides.stage! : ScoutStage.NoContact,
        remindAt: overrides && overrides.hasOwnProperty('remindAt') ? overrides.remindAt! : "2025-11-19T09:52:20.634Z",
        user: overrides && overrides.hasOwnProperty('user') ? overrides.user! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        agentUser: overrides && overrides.hasOwnProperty('agentUser') ? overrides.agentUser! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        response: overrides && overrides.hasOwnProperty('response') ? overrides.response! : 'valetudo',
        processedAt: overrides && overrides.hasOwnProperty('processedAt') ? overrides.processedAt! : "2025-05-12T13:34:37.939Z",
        scoutUser: overrides && overrides.hasOwnProperty('scoutUser') ? overrides.scoutUser! : relationshipsToOmit.has('ScoutUser') ? {} as ScoutUser : aScoutUser({}, relationshipsToOmit),
        history: overrides && overrides.hasOwnProperty('history') ? overrides.history! : relationshipsToOmit.has('HistoryConnection') ? {} as HistoryConnection : aHistoryConnection({}, relationshipsToOmit),
    };
};

export const aPartPaidTicketStats = (overrides?: Partial<PartPaidTicketStats>, _relationshipsToOmit: Set<string> = new Set()): PartPaidTicketStats => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PartPaidTicketStats');
    return {
        orderId: overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'terror',
        ticketCount: overrides && overrides.hasOwnProperty('ticketCount') ? overrides.ticketCount! : 2.1,
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'adeptio',
        membershipId: overrides && overrides.hasOwnProperty('membershipId') ? overrides.membershipId! : 'terebro',
    };
};

export const aFindOrderIdForTicketOutput = (overrides?: Partial<FindOrderIdForTicketOutput>, _relationshipsToOmit: Set<string> = new Set()): FindOrderIdForTicketOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('FindOrderIdForTicketOutput');
    return {
        orderId: overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'amissio',
    };
};

export const aTicketTypePurchaseTotal = (overrides?: Partial<TicketTypePurchaseTotal>, _relationshipsToOmit: Set<string> = new Set()): TicketTypePurchaseTotal => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TicketTypePurchaseTotal');
    return {
        ticketType: overrides && overrides.hasOwnProperty('ticketType') ? overrides.ticketType! : relationshipsToOmit.has('TicketType') ? {} as TicketType : aTicketType({}, relationshipsToOmit),
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 1690,
    };
};

export const aMembershipTypePurchaseTotal = (overrides?: Partial<MembershipTypePurchaseTotal>, _relationshipsToOmit: Set<string> = new Set()): MembershipTypePurchaseTotal => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MembershipTypePurchaseTotal');
    return {
        membershipType: overrides && overrides.hasOwnProperty('membershipType') ? overrides.membershipType! : relationshipsToOmit.has('MembershipType') ? {} as MembershipType : aMembershipType({}, relationshipsToOmit),
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 9800,
    };
};

export const aTicketWhereInput = (overrides?: Partial<TicketWhereInput>, _relationshipsToOmit: Set<string> = new Set()): TicketWhereInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TicketWhereInput');
    return {
        q: overrides && overrides.hasOwnProperty('q') ? overrides.q! : 'terebro',
    };
};

export const aTicketConnection = (overrides?: Partial<TicketConnection>, _relationshipsToOmit: Set<string> = new Set()): TicketConnection => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TicketConnection');
    return {
        pageInfo: overrides && overrides.hasOwnProperty('pageInfo') ? overrides.pageInfo! : relationshipsToOmit.has('PageInfo') ? {} as PageInfo : aPageInfo({}, relationshipsToOmit),
        edges: overrides && overrides.hasOwnProperty('edges') ? overrides.edges! : [relationshipsToOmit.has('TicketEdge') ? {} as TicketEdge : aTicketEdge({}, relationshipsToOmit)],
        totalCount: overrides && overrides.hasOwnProperty('totalCount') ? overrides.totalCount! : 973,
    };
};

export const aTicketEdge = (overrides?: Partial<TicketEdge>, _relationshipsToOmit: Set<string> = new Set()): TicketEdge => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TicketEdge');
    return {
        cursor: overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'conatus',
        node: overrides && overrides.hasOwnProperty('node') ? overrides.node! : relationshipsToOmit.has('Ticket') ? {} as Ticket : aTicket({}, relationshipsToOmit),
    };
};

export const aSearchEventTicketsAppOutput = (overrides?: Partial<SearchEventTicketsAppOutput>, _relationshipsToOmit: Set<string> = new Set()): SearchEventTicketsAppOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SearchEventTicketsAppOutput');
    return {
        totalCount: overrides && overrides.hasOwnProperty('totalCount') ? overrides.totalCount! : 1.5,
        tickets: overrides && overrides.hasOwnProperty('tickets') ? overrides.tickets! : [relationshipsToOmit.has('AppTicket') ? {} as AppTicket : anAppTicket({}, relationshipsToOmit)],
    };
};

export const anAppTicket = (overrides?: Partial<AppTicket>, _relationshipsToOmit: Set<string> = new Set()): AppTicket => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AppTicket');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'clam',
        ticketNumber: overrides && overrides.hasOwnProperty('ticketNumber') ? overrides.ticketNumber! : 'vinitor',
        parentTicketNumber: overrides && overrides.hasOwnProperty('parentTicketNumber') ? overrides.parentTicketNumber! : 'tui',
        firstName: overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'adnuo',
        lastName: overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'calcar',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'ait',
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : TicketStatus.Active,
        gateIds: overrides && overrides.hasOwnProperty('gateIds') ? overrides.gateIds! : ['textus'],
        isHold: overrides && overrides.hasOwnProperty('isHold') ? overrides.isHold! : true,
        ticketTypeName: overrides && overrides.hasOwnProperty('ticketTypeName') ? overrides.ticketTypeName! : 'sui',
        orderNumber: overrides && overrides.hasOwnProperty('orderNumber') ? overrides.orderNumber! : 'suus',
        seatZone: overrides && overrides.hasOwnProperty('seatZone') ? overrides.seatZone! : 'appositus',
        buyerInformation: overrides && overrides.hasOwnProperty('buyerInformation') ? overrides.buyerInformation! : relationshipsToOmit.has('AppTicketUserDetails') ? {} as AppTicketUserDetails : anAppTicketUserDetails({}, relationshipsToOmit),
        user: overrides && overrides.hasOwnProperty('user') ? overrides.user! : relationshipsToOmit.has('AppTicketUserDetails') ? {} as AppTicketUserDetails : anAppTicketUserDetails({}, relationshipsToOmit),
        scans: overrides && overrides.hasOwnProperty('scans') ? overrides.scans! : [relationshipsToOmit.has('AppTicketScan') ? {} as AppTicketScan : anAppTicketScan({}, relationshipsToOmit)],
        isEventAddon: overrides && overrides.hasOwnProperty('isEventAddon') ? overrides.isEventAddon! : false,
        eventAddonName: overrides && overrides.hasOwnProperty('eventAddonName') ? overrides.eventAddonName! : 'carbo',
        ticketTypeKind: overrides && overrides.hasOwnProperty('ticketTypeKind') ? overrides.ticketTypeKind! : 'solum',
        isUsherDisabled: overrides && overrides.hasOwnProperty('isUsherDisabled') ? overrides.isUsherDisabled! : true,
    };
};

export const anAppTicketUserDetails = (overrides?: Partial<AppTicketUserDetails>, _relationshipsToOmit: Set<string> = new Set()): AppTicketUserDetails => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AppTicketUserDetails');
    return {
        firstName: overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'vita',
        lastName: overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'sunt',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'contigo',
    };
};

export const anAppTicketScan = (overrides?: Partial<AppTicketScan>, _relationshipsToOmit: Set<string> = new Set()): AppTicketScan => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AppTicketScan');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'cui',
        scannedAt: overrides && overrides.hasOwnProperty('scannedAt') ? overrides.scannedAt! : "2026-01-27T16:17:41.125Z",
        direction: overrides && overrides.hasOwnProperty('direction') ? overrides.direction! : 'ulterius',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'tempus',
    };
};

export const aTicketTransferForAdmin = (overrides?: Partial<TicketTransferForAdmin>, _relationshipsToOmit: Set<string> = new Set()): TicketTransferForAdmin => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TicketTransferForAdmin');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'vesica',
        newOrderId: overrides && overrides.hasOwnProperty('newOrderId') ? overrides.newOrderId! : 'arbor',
        newOrderNumber: overrides && overrides.hasOwnProperty('newOrderNumber') ? overrides.newOrderNumber! : 'enim',
        productName: overrides && overrides.hasOwnProperty('productName') ? overrides.productName! : 'suppellex',
        transferredAt: overrides && overrides.hasOwnProperty('transferredAt') ? overrides.transferredAt! : "2025-08-30T12:15:22.058Z",
        refundStatus: overrides && overrides.hasOwnProperty('refundStatus') ? overrides.refundStatus! : TransferRefundStatus.Completed,
        refundFailureMessage: overrides && overrides.hasOwnProperty('refundFailureMessage') ? overrides.refundFailureMessage! : 'considero',
        transferStatus: overrides && overrides.hasOwnProperty('transferStatus') ? overrides.transferStatus! : TicketTransferStatus.Pending,
        amountToRefund: overrides && overrides.hasOwnProperty('amountToRefund') ? overrides.amountToRefund! : 1.1,
    };
};

export const aTicketTransferExportResultOutput = (overrides?: Partial<TicketTransferExportResultOutput>, _relationshipsToOmit: Set<string> = new Set()): TicketTransferExportResultOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TicketTransferExportResultOutput');
    return {
        results: overrides && overrides.hasOwnProperty('results') ? overrides.results! : [relationshipsToOmit.has('TicketTransferExportOutput') ? {} as TicketTransferExportOutput : aTicketTransferExportOutput({}, relationshipsToOmit)],
    };
};

export const aTicketTransferExportOutput = (overrides?: Partial<TicketTransferExportOutput>, _relationshipsToOmit: Set<string> = new Set()): TicketTransferExportOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TicketTransferExportOutput');
    return {
        ticketBuyer: overrides && overrides.hasOwnProperty('ticketBuyer') ? overrides.ticketBuyer! : relationshipsToOmit.has('TicketTransferBuyer') ? {} as TicketTransferBuyer : aTicketTransferBuyer({}, relationshipsToOmit),
        ticketSeller: overrides && overrides.hasOwnProperty('ticketSeller') ? overrides.ticketSeller! : relationshipsToOmit.has('TicketTransferSeller') ? {} as TicketTransferSeller : aTicketTransferSeller({}, relationshipsToOmit),
        ticketType: overrides && overrides.hasOwnProperty('ticketType') ? overrides.ticketType! : 'ascisco',
        transferType: overrides && overrides.hasOwnProperty('transferType') ? overrides.transferType! : 'sodalitas',
    };
};

export const aTicketTransferBuyer = (overrides?: Partial<TicketTransferBuyer>, _relationshipsToOmit: Set<string> = new Set()): TicketTransferBuyer => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TicketTransferBuyer');
    return {
        firstName: overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'accendo',
        lastName: overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'aureus',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'audax',
        purchasePrice: overrides && overrides.hasOwnProperty('purchasePrice') ? overrides.purchasePrice! : 2.8,
        buyerTransferFee: overrides && overrides.hasOwnProperty('buyerTransferFee') ? overrides.buyerTransferFee! : 9.2,
        newOrderNumber: overrides && overrides.hasOwnProperty('newOrderNumber') ? overrides.newOrderNumber! : 'voluptatibus',
    };
};

export const aTicketTransferSeller = (overrides?: Partial<TicketTransferSeller>, _relationshipsToOmit: Set<string> = new Set()): TicketTransferSeller => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TicketTransferSeller');
    return {
        firstName: overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'capitulus',
        lastName: overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'adeo',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'deserunt',
        sellerTransferFee: overrides && overrides.hasOwnProperty('sellerTransferFee') ? overrides.sellerTransferFee! : 2.7,
        refundAmount: overrides && overrides.hasOwnProperty('refundAmount') ? overrides.refundAmount! : 3.9,
        hasBeenRefunded: overrides && overrides.hasOwnProperty('hasBeenRefunded') ? overrides.hasBeenRefunded! : true,
        originalOrderNumber: overrides && overrides.hasOwnProperty('originalOrderNumber') ? overrides.originalOrderNumber! : 'quis',
        originalPurchasePrice: overrides && overrides.hasOwnProperty('originalPurchasePrice') ? overrides.originalPurchasePrice! : 2.3,
    };
};

export const aSentTicketOutput = (overrides?: Partial<SentTicketOutput>, _relationshipsToOmit: Set<string> = new Set()): SentTicketOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SentTicketOutput');
    return {
        sender: overrides && overrides.hasOwnProperty('sender') ? overrides.sender! : 'concido',
        activeTickets: overrides && overrides.hasOwnProperty('activeTickets') ? overrides.activeTickets! : [relationshipsToOmit.has('Ticket') ? {} as Ticket : aTicket({}, relationshipsToOmit)],
        totalSentTickets: overrides && overrides.hasOwnProperty('totalSentTickets') ? overrides.totalSentTickets! : 6.5,
        firstTimeLogin: overrides && overrides.hasOwnProperty('firstTimeLogin') ? overrides.firstTimeLogin! : false,
    };
};

export const aPinPaymentContext = (overrides?: Partial<PinPaymentContext>, _relationshipsToOmit: Set<string> = new Set()): PinPaymentContext => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PinPaymentContext');
    return {
        amount: overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 4.9,
        currency: overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'approbo',
        redirectUrl: overrides && overrides.hasOwnProperty('redirectUrl') ? overrides.redirectUrl! : 'cunae',
        publicKey: overrides && overrides.hasOwnProperty('publicKey') ? overrides.publicKey! : 'adnuo',
        isSandbox: overrides && overrides.hasOwnProperty('isSandbox') ? overrides.isSandbox! : true,
        orderId: overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'verumtamen',
    };
};

export const aWindcavePaymentContext = (overrides?: Partial<WindcavePaymentContext>, _relationshipsToOmit: Set<string> = new Set()): WindcavePaymentContext => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('WindcavePaymentContext');
    return {
        redirectUrl: overrides && overrides.hasOwnProperty('redirectUrl') ? overrides.redirectUrl! : 'umerus',
        checkoutUrl: overrides && overrides.hasOwnProperty('checkoutUrl') ? overrides.checkoutUrl! : 'chirographum',
        orderId: overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'summopere',
    };
};

export const aWindcavePaymentResultOutput = (overrides?: Partial<WindcavePaymentResultOutput>, _relationshipsToOmit: Set<string> = new Set()): WindcavePaymentResultOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('WindcavePaymentResultOutput');
    return {
        redirectUrl: overrides && overrides.hasOwnProperty('redirectUrl') ? overrides.redirectUrl! : 'saepe',
    };
};

export const aStripePaymentContext = (overrides?: Partial<StripePaymentContext>, _relationshipsToOmit: Set<string> = new Set()): StripePaymentContext => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('StripePaymentContext');
    return {
        redirectUrl: overrides && overrides.hasOwnProperty('redirectUrl') ? overrides.redirectUrl! : 'amicitia',
        checkoutUrl: overrides && overrides.hasOwnProperty('checkoutUrl') ? overrides.checkoutUrl! : 'tergiversatio',
        orderId: overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'teneo',
        stripeAccountId: overrides && overrides.hasOwnProperty('stripeAccountId') ? overrides.stripeAccountId! : 'carbo',
        publishableKey: overrides && overrides.hasOwnProperty('publishableKey') ? overrides.publishableKey! : 'pecco',
        clientSecret: overrides && overrides.hasOwnProperty('clientSecret') ? overrides.clientSecret! : 'delego',
    };
};

export const aSocialWhereInput = (overrides?: Partial<SocialWhereInput>, _relationshipsToOmit: Set<string> = new Set()): SocialWhereInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SocialWhereInput');
    return {
        mentionType: overrides && overrides.hasOwnProperty('mentionType') ? overrides.mentionType! : 'ipsam',
        userId: overrides && overrides.hasOwnProperty('userId') ? overrides.userId! : 'cavus',
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2025-03-13T11:47:32.290Z",
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : "2025-07-29T15:46:23.086Z",
    };
};

export const aSocialConnection = (overrides?: Partial<SocialConnection>, _relationshipsToOmit: Set<string> = new Set()): SocialConnection => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SocialConnection');
    return {
        pageInfo: overrides && overrides.hasOwnProperty('pageInfo') ? overrides.pageInfo! : relationshipsToOmit.has('PageInfo') ? {} as PageInfo : aPageInfo({}, relationshipsToOmit),
        edges: overrides && overrides.hasOwnProperty('edges') ? overrides.edges! : [relationshipsToOmit.has('SocialMentionEdge') ? {} as SocialMentionEdge : aSocialMentionEdge({}, relationshipsToOmit)],
        totalCount: overrides && overrides.hasOwnProperty('totalCount') ? overrides.totalCount! : 5729,
    };
};

export const aSocialMentionEdge = (overrides?: Partial<SocialMentionEdge>, _relationshipsToOmit: Set<string> = new Set()): SocialMentionEdge => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SocialMentionEdge');
    return {
        cursor: overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'eveniet',
        node: overrides && overrides.hasOwnProperty('node') ? overrides.node! : relationshipsToOmit.has('SocialMention') ? {} as SocialMention : aSocialMention({}, relationshipsToOmit),
    };
};

export const aSocialMention = (overrides?: Partial<SocialMention>, _relationshipsToOmit: Set<string> = new Set()): SocialMention => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SocialMention');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '9988ef5b-4c28-4aa2-ba0f-35ab51088425',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-07-01T01:10:49.556Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-07-11T12:17:54.192Z",
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'centum',
        senderId: overrides && overrides.hasOwnProperty('senderId') ? overrides.senderId! : 'defluo',
        recipientId: overrides && overrides.hasOwnProperty('recipientId') ? overrides.recipientId! : 'deleniti',
        commentId: overrides && overrides.hasOwnProperty('commentId') ? overrides.commentId! : 'adnuo',
        mediaId: overrides && overrides.hasOwnProperty('mediaId') ? overrides.mediaId! : 'tonsor',
        content: overrides && overrides.hasOwnProperty('content') ? overrides.content! : 'approbo',
        user: overrides && overrides.hasOwnProperty('user') ? overrides.user! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        url: overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'arca',
    };
};

export const aMentionOverviewInput = (overrides?: Partial<MentionOverviewInput>, _relationshipsToOmit: Set<string> = new Set()): MentionOverviewInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MentionOverviewInput');
    return {
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2025-10-07T18:13:31.776Z",
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : "2025-03-13T16:59:58.704Z",
    };
};

export const aMentionOverview = (overrides?: Partial<MentionOverview>, _relationshipsToOmit: Set<string> = new Set()): MentionOverview => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MentionOverview');
    return {
        commentMentionCount: overrides && overrides.hasOwnProperty('commentMentionCount') ? overrides.commentMentionCount! : 1.8,
        mediaMentionCount: overrides && overrides.hasOwnProperty('mediaMentionCount') ? overrides.mediaMentionCount! : 7.2,
        storyMentionCount: overrides && overrides.hasOwnProperty('storyMentionCount') ? overrides.storyMentionCount! : 4.4,
    };
};

export const aFacebookPageListsInput = (overrides?: Partial<FacebookPageListsInput>, _relationshipsToOmit: Set<string> = new Set()): FacebookPageListsInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('FacebookPageListsInput');
    return {
        token: overrides && overrides.hasOwnProperty('token') ? overrides.token! : 'pariatur',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'stillicidium',
    };
};

export const aPageListsOutput = (overrides?: Partial<PageListsOutput>, _relationshipsToOmit: Set<string> = new Set()): PageListsOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PageListsOutput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ascit',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'validus',
        access_token: overrides && overrides.hasOwnProperty('access_token') ? overrides.access_token! : 'cilicium',
    };
};

export const aGetAllCustomizationInput = (overrides?: Partial<GetAllCustomizationInput>, _relationshipsToOmit: Set<string> = new Set()): GetAllCustomizationInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('GetAllCustomizationInput');
    return {
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'neque',
        membershipId: overrides && overrides.hasOwnProperty('membershipId') ? overrides.membershipId! : 'tabernus',
    };
};

export const anEmailCustomizationOutput = (overrides?: Partial<EmailCustomizationOutput>, _relationshipsToOmit: Set<string> = new Set()): EmailCustomizationOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EmailCustomizationOutput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'curo',
        emailType: overrides && overrides.hasOwnProperty('emailType') ? overrides.emailType! : EmailType.AbandonedCart,
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : EmailCustomizationStatus.Active,
        subject: overrides && overrides.hasOwnProperty('subject') ? overrides.subject! : 'cohaero',
        richTextTemplate: overrides && overrides.hasOwnProperty('richTextTemplate') ? overrides.richTextTemplate! : 'cubicularis',
        style: overrides && overrides.hasOwnProperty('style') ? overrides.style! : relationshipsToOmit.has('EmailStyle') ? {} as EmailStyle : anEmailStyle({}, relationshipsToOmit),
    };
};

export const anEmailStyle = (overrides?: Partial<EmailStyle>, _relationshipsToOmit: Set<string> = new Set()): EmailStyle => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EmailStyle');
    return {
        backgroundColour: overrides && overrides.hasOwnProperty('backgroundColour') ? overrides.backgroundColour! : 'abeo',
        bodyColour: overrides && overrides.hasOwnProperty('bodyColour') ? overrides.bodyColour! : 'quod',
        headingColour: overrides && overrides.hasOwnProperty('headingColour') ? overrides.headingColour! : 'vetus',
        paragraphColour: overrides && overrides.hasOwnProperty('paragraphColour') ? overrides.paragraphColour! : 'accusamus',
        linkColour: overrides && overrides.hasOwnProperty('linkColour') ? overrides.linkColour! : 'tergum',
        buttonColour: overrides && overrides.hasOwnProperty('buttonColour') ? overrides.buttonColour! : 'aiunt',
    };
};

export const aDynamicImageInput = (overrides?: Partial<DynamicImageInput>, _relationshipsToOmit: Set<string> = new Set()): DynamicImageInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DynamicImageInput');
    return {
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'corrupti',
        membershipId: overrides && overrides.hasOwnProperty('membershipId') ? overrides.membershipId! : 'universe',
        pointItemId: overrides && overrides.hasOwnProperty('pointItemId') ? overrides.pointItemId! : 'strues',
    };
};

export const anExpoExhibitor = (overrides?: Partial<ExpoExhibitor>, _relationshipsToOmit: Set<string> = new Set()): ExpoExhibitor => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ExpoExhibitor');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '11e9aab2-c9da-473e-a530-6826250f129f',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-10-04T10:14:40.099Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-09-01T00:17:23.107Z",
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'laborum',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'culpo',
        organizationId: overrides && overrides.hasOwnProperty('organizationId') ? overrides.organizationId! : 'varietas',
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'aro',
        allowCustomQuestions: overrides && overrides.hasOwnProperty('allowCustomQuestions') ? overrides.allowCustomQuestions! : true,
        attendeeCount: overrides && overrides.hasOwnProperty('attendeeCount') ? overrides.attendeeCount! : 6.3,
        qrCode: overrides && overrides.hasOwnProperty('qrCode') ? overrides.qrCode! : 'ager',
        loginLink: overrides && overrides.hasOwnProperty('loginLink') ? overrides.loginLink! : 'undique',
    };
};

export const aFindExhibitorInput = (overrides?: Partial<FindExhibitorInput>, _relationshipsToOmit: Set<string> = new Set()): FindExhibitorInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('FindExhibitorInput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'coadunatio',
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'optio',
    };
};

export const anExpoNamingField = (overrides?: Partial<ExpoNamingField>, _relationshipsToOmit: Set<string> = new Set()): ExpoNamingField => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ExpoNamingField');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '42130111-7d3e-4d5a-9f52-ebe4356b07d4',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-12-28T23:35:38.509Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-05-01T10:44:19.497Z",
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'talus',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : ExpoNamingFieldType.FirstName,
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'celer',
        required: overrides && overrides.hasOwnProperty('required') ? overrides.required! : false,
        orderKey: overrides && overrides.hasOwnProperty('orderKey') ? overrides.orderKey! : 5.8,
        options: overrides && overrides.hasOwnProperty('options') ? overrides.options! : ['consectetur'],
    };
};

export const anExpoAttendee = (overrides?: Partial<ExpoAttendee>, _relationshipsToOmit: Set<string> = new Set()): ExpoAttendee => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ExpoAttendee');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'd1cfaa81-b97d-476b-98d3-2e5e82827ec3',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-10-04T14:12:56.884Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-03-26T21:18:05.755Z",
        organizationId: overrides && overrides.hasOwnProperty('organizationId') ? overrides.organizationId! : 'umquam',
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'communis',
        exhibitorId: overrides && overrides.hasOwnProperty('exhibitorId') ? overrides.exhibitorId! : 'vesper',
        ticketId: overrides && overrides.hasOwnProperty('ticketId') ? overrides.ticketId! : 'depulso',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'unus',
        firstName: overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'a',
        lastName: overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'alias',
        phoneNumber: overrides && overrides.hasOwnProperty('phoneNumber') ? overrides.phoneNumber! : 'deporto',
        birthDate: overrides && overrides.hasOwnProperty('birthDate') ? overrides.birthDate! : "2025-05-08T09:59:47.256Z",
        gender: overrides && overrides.hasOwnProperty('gender') ? overrides.gender! : Gender.Male,
        postalCode: overrides && overrides.hasOwnProperty('postalCode') ? overrides.postalCode! : 'solium',
        companyName: overrides && overrides.hasOwnProperty('companyName') ? overrides.companyName! : 'desparatus',
        notes: overrides && overrides.hasOwnProperty('notes') ? overrides.notes! : 'cohors',
        optInToMarketing: overrides && overrides.hasOwnProperty('optInToMarketing') ? overrides.optInToMarketing! : true,
        customFields: overrides && overrides.hasOwnProperty('customFields') ? overrides.customFields! : [relationshipsToOmit.has('CustomField') ? {} as CustomField : aCustomField({}, relationshipsToOmit)],
    };
};

export const anExpoAttendeeTicketOutput = (overrides?: Partial<ExpoAttendeeTicketOutput>, _relationshipsToOmit: Set<string> = new Set()): ExpoAttendeeTicketOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ExpoAttendeeTicketOutput');
    return {
        ticket: overrides && overrides.hasOwnProperty('ticket') ? overrides.ticket! : relationshipsToOmit.has('Ticket') ? {} as Ticket : aTicket({}, relationshipsToOmit),
        attendeeId: overrides && overrides.hasOwnProperty('attendeeId') ? overrides.attendeeId! : 'cupressus',
    };
};

export const anExpoEncryptedTicket = (overrides?: Partial<ExpoEncryptedTicket>, _relationshipsToOmit: Set<string> = new Set()): ExpoEncryptedTicket => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ExpoEncryptedTicket');
    return {
        encrypted: overrides && overrides.hasOwnProperty('encrypted') ? overrides.encrypted! : 'vester',
        iv: overrides && overrides.hasOwnProperty('iv') ? overrides.iv! : 'somnus',
        authTag: overrides && overrides.hasOwnProperty('authTag') ? overrides.authTag! : 'sollers',
        index: overrides && overrides.hasOwnProperty('index') ? overrides.index! : 'admoneo',
    };
};

export const anExhibitorContextOutput = (overrides?: Partial<ExhibitorContextOutput>, _relationshipsToOmit: Set<string> = new Set()): ExhibitorContextOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ExhibitorContextOutput');
    return {
        profile: overrides && overrides.hasOwnProperty('profile') ? overrides.profile! : relationshipsToOmit.has('ExpoExhibitorSessionProfileOutput') ? {} as ExpoExhibitorSessionProfileOutput : anExpoExhibitorSessionProfileOutput({}, relationshipsToOmit),
        event: overrides && overrides.hasOwnProperty('event') ? overrides.event! : relationshipsToOmit.has('Event') ? {} as Event : anEvent({}, relationshipsToOmit),
        organization: overrides && overrides.hasOwnProperty('organization') ? overrides.organization! : relationshipsToOmit.has('CurrentOrganizationOutput') ? {} as CurrentOrganizationOutput : aCurrentOrganizationOutput({}, relationshipsToOmit),
    };
};

export const anExpoExhibitorSessionProfileOutput = (overrides?: Partial<ExpoExhibitorSessionProfileOutput>, _relationshipsToOmit: Set<string> = new Set()): ExpoExhibitorSessionProfileOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ExpoExhibitorSessionProfileOutput');
    return {
        exhibitorName: overrides && overrides.hasOwnProperty('exhibitorName') ? overrides.exhibitorName! : 'creo',
        scannerName: overrides && overrides.hasOwnProperty('scannerName') ? overrides.scannerName! : 'eius',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'valetudo',
        allowCustomQuestions: overrides && overrides.hasOwnProperty('allowCustomQuestions') ? overrides.allowCustomQuestions! : false,
        safeModeEnabled: overrides && overrides.hasOwnProperty('safeModeEnabled') ? overrides.safeModeEnabled! : false,
    };
};

export const anActivityWhereInput = (overrides?: Partial<ActivityWhereInput>, _relationshipsToOmit: Set<string> = new Set()): ActivityWhereInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ActivityWhereInput');
    return {
        userId: overrides && overrides.hasOwnProperty('userId') ? overrides.userId! : 'currus',
    };
};

export const anActivityConnection = (overrides?: Partial<ActivityConnection>, _relationshipsToOmit: Set<string> = new Set()): ActivityConnection => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ActivityConnection');
    return {
        pageInfo: overrides && overrides.hasOwnProperty('pageInfo') ? overrides.pageInfo! : relationshipsToOmit.has('PageInfo') ? {} as PageInfo : aPageInfo({}, relationshipsToOmit),
        edges: overrides && overrides.hasOwnProperty('edges') ? overrides.edges! : [relationshipsToOmit.has('ActivityEdge') ? {} as ActivityEdge : anActivityEdge({}, relationshipsToOmit)],
        totalCount: overrides && overrides.hasOwnProperty('totalCount') ? overrides.totalCount! : 895,
    };
};

export const anActivityEdge = (overrides?: Partial<ActivityEdge>, _relationshipsToOmit: Set<string> = new Set()): ActivityEdge => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ActivityEdge');
    return {
        cursor: overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'dicta',
        node: overrides && overrides.hasOwnProperty('node') ? overrides.node! : relationshipsToOmit.has('Activity') ? {} as Activity : anActivity({}, relationshipsToOmit),
    };
};

export const anActivity = (overrides?: Partial<Activity>, _relationshipsToOmit: Set<string> = new Set()): Activity => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Activity');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'e968f974-6e5b-4473-b8bb-427bca2046e4',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-09-10T20:50:30.771Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-08-10T15:29:14.467Z",
        user: overrides && overrides.hasOwnProperty('user') ? overrides.user! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'certus',
        origin: overrides && overrides.hasOwnProperty('origin') ? overrides.origin! : ActivityOrigin.User,
        detail: overrides && overrides.hasOwnProperty('detail') ? overrides.detail! : 'tero',
        fingerPrint: overrides && overrides.hasOwnProperty('fingerPrint') ? overrides.fingerPrint! : 'uberrime',
        refName: overrides && overrides.hasOwnProperty('refName') ? overrides.refName! : 'textus',
        refId: overrides && overrides.hasOwnProperty('refId') ? overrides.refId! : 'comparo',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'patior',
        admin: overrides && overrides.hasOwnProperty('admin') ? overrides.admin! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
    };
};

export const aFindAutomationsInput = (overrides?: Partial<FindAutomationsInput>, _relationshipsToOmit: Set<string> = new Set()): FindAutomationsInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('FindAutomationsInput');
    return {
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : true,
        automationType: overrides && overrides.hasOwnProperty('automationType') ? overrides.automationType! : 'demo',
    };
};

export const anAutomation = (overrides?: Partial<Automation>, _relationshipsToOmit: Set<string> = new Set()): Automation => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Automation');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'e981304f-b25b-4230-ab0c-f36a8192b765',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-08-01T02:36:04.945Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2026-02-02T06:49:10.769Z",
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'thalassinus',
        automationType: overrides && overrides.hasOwnProperty('automationType') ? overrides.automationType! : AutomationType.OrderAbandoned,
        templateId: overrides && overrides.hasOwnProperty('templateId') ? overrides.templateId! : 8.8,
        listId: overrides && overrides.hasOwnProperty('listId') ? overrides.listId! : 'tertius',
        subject: overrides && overrides.hasOwnProperty('subject') ? overrides.subject! : 'velut',
        targetSource: overrides && overrides.hasOwnProperty('targetSource') ? overrides.targetSource! : ReportingFilterSource.Overall,
        targetSourceId: overrides && overrides.hasOwnProperty('targetSourceId') ? overrides.targetSourceId! : 'sub',
        targetReleaseId: overrides && overrides.hasOwnProperty('targetReleaseId') ? overrides.targetReleaseId! : 'supellex',
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : true,
        timeOfDay: overrides && overrides.hasOwnProperty('timeOfDay') ? overrides.timeOfDay! : "2025-11-13T08:23:30.766Z",
        templateName: overrides && overrides.hasOwnProperty('templateName') ? overrides.templateName! : 'quo',
    };
};

export const anI18nOutput = (overrides?: Partial<I18nOutput>, _relationshipsToOmit: Set<string> = new Set()): I18nOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('I18nOutput');
    return {
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : 'cenaculum',
    };
};

export const aReferralCampaign = (overrides?: Partial<ReferralCampaign>, _relationshipsToOmit: Set<string> = new Set()): ReferralCampaign => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ReferralCampaign');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'f4309378-4d79-4418-b5c8-075b08fd7ad3',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-11-10T12:08:35.683Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-04-25T02:15:00.011Z",
        referralRelease: overrides && overrides.hasOwnProperty('referralRelease') ? overrides.referralRelease! : relationshipsToOmit.has('Release') ? {} as Release : aRelease({}, relationshipsToOmit),
        event: overrides && overrides.hasOwnProperty('event') ? overrides.event! : relationshipsToOmit.has('Event') ? {} as Event : anEvent({}, relationshipsToOmit),
        membership: overrides && overrides.hasOwnProperty('membership') ? overrides.membership! : relationshipsToOmit.has('Membership') ? {} as Membership : aMembership({}, relationshipsToOmit),
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : false,
        referralOwnerRewardType: overrides && overrides.hasOwnProperty('referralOwnerRewardType') ? overrides.referralOwnerRewardType! : ReferralRewardType.Points,
        referralOwnerRewardQuantityType: overrides && overrides.hasOwnProperty('referralOwnerRewardQuantityType') ? overrides.referralOwnerRewardQuantityType! : ReferralRewardQuantityType.FlatRate,
        referralOwnerRewardQuantity: overrides && overrides.hasOwnProperty('referralOwnerRewardQuantity') ? overrides.referralOwnerRewardQuantity! : 2.3,
        referralUserRewardType: overrides && overrides.hasOwnProperty('referralUserRewardType') ? overrides.referralUserRewardType! : ReferralRewardType.Points,
        referralUserRewardQuantityType: overrides && overrides.hasOwnProperty('referralUserRewardQuantityType') ? overrides.referralUserRewardQuantityType! : ReferralRewardQuantityType.FlatRate,
        referralUserRewardQuantity: overrides && overrides.hasOwnProperty('referralUserRewardQuantity') ? overrides.referralUserRewardQuantity! : 7.4,
    };
};

export const aReferralCampaignOverviewOutput = (overrides?: Partial<ReferralCampaignOverviewOutput>, _relationshipsToOmit: Set<string> = new Set()): ReferralCampaignOverviewOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ReferralCampaignOverviewOutput');
    return {
        numberOfOrders: overrides && overrides.hasOwnProperty('numberOfOrders') ? overrides.numberOfOrders! : 5,
        userRewards: overrides && overrides.hasOwnProperty('userRewards') ? overrides.userRewards! : 7.4,
        ownerRewards: overrides && overrides.hasOwnProperty('ownerRewards') ? overrides.ownerRewards! : 2.7,
        referralLinksCreated: overrides && overrides.hasOwnProperty('referralLinksCreated') ? overrides.referralLinksCreated! : 5.9,
        referralLinksClicked: overrides && overrides.hasOwnProperty('referralLinksClicked') ? overrides.referralLinksClicked! : 8,
        tickets: overrides && overrides.hasOwnProperty('tickets') ? overrides.tickets! : 2.7,
        revenueGenerated: overrides && overrides.hasOwnProperty('revenueGenerated') ? overrides.revenueGenerated! : 2.9,
        customersAccquired: overrides && overrides.hasOwnProperty('customersAccquired') ? overrides.customersAccquired! : 8,
    };
};

export const aReferralReward = (overrides?: Partial<ReferralReward>, _relationshipsToOmit: Set<string> = new Set()): ReferralReward => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ReferralReward');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'cebc1f49-1fe0-4932-b414-899d55279cce',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2026-01-03T11:25:35.946Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-03-25T22:51:38.782Z",
        order: overrides && overrides.hasOwnProperty('order') ? overrides.order! : relationshipsToOmit.has('Order') ? {} as Order : anOrder({}, relationshipsToOmit),
        referralCampaign: overrides && overrides.hasOwnProperty('referralCampaign') ? overrides.referralCampaign! : relationshipsToOmit.has('ReferralCampaign') ? {} as ReferralCampaign : aReferralCampaign({}, relationshipsToOmit),
        organization: overrides && overrides.hasOwnProperty('organization') ? overrides.organization! : relationshipsToOmit.has('Organization') ? {} as Organization : anOrganization({}, relationshipsToOmit),
        rewardForRole: overrides && overrides.hasOwnProperty('rewardForRole') ? overrides.rewardForRole! : ReferralRole.Owner,
        rewardType: overrides && overrides.hasOwnProperty('rewardType') ? overrides.rewardType! : ReferralRewardType.Points,
        rewardQuantityType: overrides && overrides.hasOwnProperty('rewardQuantityType') ? overrides.rewardQuantityType! : ReferralRewardQuantityType.FlatRate,
        rewardQuantity: overrides && overrides.hasOwnProperty('rewardQuantity') ? overrides.rewardQuantity! : 7.5,
    };
};

export const aPromoterSettingsOutput = (overrides?: Partial<PromoterSettingsOutput>, _relationshipsToOmit: Set<string> = new Set()): PromoterSettingsOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PromoterSettingsOutput');
    return {
        configurations: overrides && overrides.hasOwnProperty('configurations') ? overrides.configurations! : [relationshipsToOmit.has('PromoterShareAction') ? {} as PromoterShareAction : aPromoterShareAction({}, relationshipsToOmit)],
        socialPages: overrides && overrides.hasOwnProperty('socialPages') ? overrides.socialPages! : [relationshipsToOmit.has('EventSocialPage') ? {} as EventSocialPage : anEventSocialPage({}, relationshipsToOmit)],
        referralCampaign: overrides && overrides.hasOwnProperty('referralCampaign') ? overrides.referralCampaign! : relationshipsToOmit.has('ReferralCampaign') ? {} as ReferralCampaign : aReferralCampaign({}, relationshipsToOmit),
    };
};

export const aPromoterShareAction = (overrides?: Partial<PromoterShareAction>, _relationshipsToOmit: Set<string> = new Set()): PromoterShareAction => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PromoterShareAction');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '87a062d1-b4d1-4125-97db-55533dc12eb9',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-11-01T23:30:29.912Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-03-31T21:25:45.497Z",
        platform: overrides && overrides.hasOwnProperty('platform') ? overrides.platform! : 'accommodo',
        actionType: overrides && overrides.hasOwnProperty('actionType') ? overrides.actionType! : 'decerno',
        socialLinkType: overrides && overrides.hasOwnProperty('socialLinkType') ? overrides.socialLinkType! : 'turba',
    };
};

export const anEventSocialPage = (overrides?: Partial<EventSocialPage>, _relationshipsToOmit: Set<string> = new Set()): EventSocialPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EventSocialPage');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'vallum',
        isEnabled: overrides && overrides.hasOwnProperty('isEnabled') ? overrides.isEnabled! : false,
        url: overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'pecco',
    };
};

export const aSearchArtistInput = (overrides?: Partial<SearchArtistInput>, _relationshipsToOmit: Set<string> = new Set()): SearchArtistInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SearchArtistInput');
    return {
        query: overrides && overrides.hasOwnProperty('query') ? overrides.query! : 'tubineus',
    };
};

export const aSearchArtistOutput = (overrides?: Partial<SearchArtistOutput>, _relationshipsToOmit: Set<string> = new Set()): SearchArtistOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SearchArtistOutput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ullus',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'vel',
        source: overrides && overrides.hasOwnProperty('source') ? overrides.source! : 'acquiro',
        sourceId: overrides && overrides.hasOwnProperty('sourceId') ? overrides.sourceId! : 'quia',
        imageUrl: overrides && overrides.hasOwnProperty('imageUrl') ? overrides.imageUrl! : 'sponte',
        followerCount: overrides && overrides.hasOwnProperty('followerCount') ? overrides.followerCount! : 8541,
        genres: overrides && overrides.hasOwnProperty('genres') ? overrides.genres! : ['acerbitas'],
    };
};

export const aShopifySettings = (overrides?: Partial<ShopifySettings>, _relationshipsToOmit: Set<string> = new Set()): ShopifySettings => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ShopifySettings');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '70f2eb6d-80b8-4918-94e5-543e4b488878',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2026-01-25T07:33:50.338Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-07-05T09:40:52.191Z",
        url: overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'officia',
        navLinkLabel: overrides && overrides.hasOwnProperty('navLinkLabel') ? overrides.navLinkLabel! : 'omnis',
        showNavLink: overrides && overrides.hasOwnProperty('showNavLink') ? overrides.showNavLink! : true,
        alwaysShowPostPurchase: overrides && overrides.hasOwnProperty('alwaysShowPostPurchase') ? overrides.alwaysShowPostPurchase! : true,
    };
};

export const aShopifyProductsDto = (overrides?: Partial<ShopifyProductsDto>, _relationshipsToOmit: Set<string> = new Set()): ShopifyProductsDto => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ShopifyProductsDto');
    return {
        products: overrides && overrides.hasOwnProperty('products') ? overrides.products! : [relationshipsToOmit.has('ShopifyProductDto') ? {} as ShopifyProductDto : aShopifyProductDto({}, relationshipsToOmit)],
        storeUrl: overrides && overrides.hasOwnProperty('storeUrl') ? overrides.storeUrl! : 'sit',
        showUpsell: overrides && overrides.hasOwnProperty('showUpsell') ? overrides.showUpsell! : true,
        customizedUpsell: overrides && overrides.hasOwnProperty('customizedUpsell') ? overrides.customizedUpsell! : true,
    };
};

export const aShopifyProductDto = (overrides?: Partial<ShopifyProductDto>, _relationshipsToOmit: Set<string> = new Set()): ShopifyProductDto => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ShopifyProductDto');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'cogo',
        url: overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'conatus',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'perferendis',
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 'turbo',
        imageUrl: overrides && overrides.hasOwnProperty('imageUrl') ? overrides.imageUrl! : 'arceo',
    };
};

export const anOrderPrechargeSummaryOutput = (overrides?: Partial<OrderPrechargeSummaryOutput>, _relationshipsToOmit: Set<string> = new Set()): OrderPrechargeSummaryOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OrderPrechargeSummaryOutput');
    return {
        card: overrides && overrides.hasOwnProperty('card') ? overrides.card! : relationshipsToOmit.has('StripeSetupIntentCardOutput') ? {} as StripeSetupIntentCardOutput : aStripeSetupIntentCardOutput({}, relationshipsToOmit),
        numTickets: overrides && overrides.hasOwnProperty('numTickets') ? overrides.numTickets! : 4.7,
    };
};

export const aStripeSetupIntentCardOutput = (overrides?: Partial<StripeSetupIntentCardOutput>, _relationshipsToOmit: Set<string> = new Set()): StripeSetupIntentCardOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('StripeSetupIntentCardOutput');
    return {
        brand: overrides && overrides.hasOwnProperty('brand') ? overrides.brand! : 'ex',
        last4: overrides && overrides.hasOwnProperty('last4') ? overrides.last4! : 'tepidus',
        expMonth: overrides && overrides.hasOwnProperty('expMonth') ? overrides.expMonth! : 4.4,
        expYear: overrides && overrides.hasOwnProperty('expYear') ? overrides.expYear! : 1.8,
    };
};

export const aCompetition = (overrides?: Partial<Competition>, _relationshipsToOmit: Set<string> = new Set()): Competition => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Competition');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'b3283503-737b-43d4-a44c-399ba1886226',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-03-30T12:15:01.897Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2026-01-30T09:22:50.965Z",
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2025-08-03T20:19:52.513Z",
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : "2025-09-29T20:06:47.644Z",
        competitionType: overrides && overrides.hasOwnProperty('competitionType') ? overrides.competitionType! : CompetitionType.Registration,
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'sulum',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'conforto',
        termsAndConditions: overrides && overrides.hasOwnProperty('termsAndConditions') ? overrides.termsAndConditions! : 'vobis',
        bannerImage: overrides && overrides.hasOwnProperty('bannerImage') ? overrides.bannerImage! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        isPublished: overrides && overrides.hasOwnProperty('isPublished') ? overrides.isPublished! : true,
        prizes: overrides && overrides.hasOwnProperty('prizes') ? overrides.prizes! : [relationshipsToOmit.has('CompetitionPrize') ? {} as CompetitionPrize : aCompetitionPrize({}, relationshipsToOmit)],
        promoter: overrides && overrides.hasOwnProperty('promoter') ? overrides.promoter! : [relationshipsToOmit.has('CompetitionReward') ? {} as CompetitionReward : aCompetitionReward({}, relationshipsToOmit)],
        isCompetitionRunning: overrides && overrides.hasOwnProperty('isCompetitionRunning') ? overrides.isCompetitionRunning! : true,
        competitionState: overrides && overrides.hasOwnProperty('competitionState') ? overrides.competitionState! : CompetitionState.Upcoming,
        referralRewardValue: overrides && overrides.hasOwnProperty('referralRewardValue') ? overrides.referralRewardValue! : 994,
    };
};

export const aCompetitionPrize = (overrides?: Partial<CompetitionPrize>, _relationshipsToOmit: Set<string> = new Set()): CompetitionPrize => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CompetitionPrize');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '6eb321be-d75d-4487-bf5c-2ae5f220a7c3',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-05-05T20:05:41.765Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-11-28T10:43:49.446Z",
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'utique',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'anser',
        prizeOrder: overrides && overrides.hasOwnProperty('prizeOrder') ? overrides.prizeOrder! : 3.9,
        quantity: overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 1.4,
        image: overrides && overrides.hasOwnProperty('image') ? overrides.image! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
    };
};

export const aCompetitionReward = (overrides?: Partial<CompetitionReward>, _relationshipsToOmit: Set<string> = new Set()): CompetitionReward => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CompetitionReward');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '238e123b-1ef3-4714-850b-1fa67020cb84',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2026-02-20T02:30:51.964Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2026-02-09T01:06:33.696Z",
        platform: overrides && overrides.hasOwnProperty('platform') ? overrides.platform! : 'nisi',
        actionType: overrides && overrides.hasOwnProperty('actionType') ? overrides.actionType! : 'molestias',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 5.5,
        socialLinkType: overrides && overrides.hasOwnProperty('socialLinkType') ? overrides.socialLinkType! : 'spes',
        isEnabled: overrides && overrides.hasOwnProperty('isEnabled') ? overrides.isEnabled! : false,
    };
};

export const anActiveCompetitionByTypeInput = (overrides?: Partial<ActiveCompetitionByTypeInput>, _relationshipsToOmit: Set<string> = new Set()): ActiveCompetitionByTypeInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ActiveCompetitionByTypeInput');
    return {
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'sollicito',
        competitionType: overrides && overrides.hasOwnProperty('competitionType') ? overrides.competitionType! : CompetitionType.Registration,
    };
};

export const aGetUserEntriesInput = (overrides?: Partial<GetUserEntriesInput>, _relationshipsToOmit: Set<string> = new Set()): GetUserEntriesInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('GetUserEntriesInput');
    return {
        competitionId: overrides && overrides.hasOwnProperty('competitionId') ? overrides.competitionId! : 'bonus',
        userId: overrides && overrides.hasOwnProperty('userId') ? overrides.userId! : 'somnus',
    };
};

export const aGrantRewardOutput = (overrides?: Partial<GrantRewardOutput>, _relationshipsToOmit: Set<string> = new Set()): GrantRewardOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('GrantRewardOutput');
    return {
        platform: overrides && overrides.hasOwnProperty('platform') ? overrides.platform! : 'defessus',
        actionType: overrides && overrides.hasOwnProperty('actionType') ? overrides.actionType! : 'somnus',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 3104,
    };
};

export const aSalesOverviewOutput = (overrides?: Partial<SalesOverviewOutput>, _relationshipsToOmit: Set<string> = new Set()): SalesOverviewOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SalesOverviewOutput');
    return {
        ticketsIssued: overrides && overrides.hasOwnProperty('ticketsIssued') ? overrides.ticketsIssued! : 7.2,
        membershipsIssued: overrides && overrides.hasOwnProperty('membershipsIssued') ? overrides.membershipsIssued! : 0.1,
        membershipsSold: overrides && overrides.hasOwnProperty('membershipsSold') ? overrides.membershipsSold! : 5.1,
        membershipsComp: overrides && overrides.hasOwnProperty('membershipsComp') ? overrides.membershipsComp! : 0.7,
        addonsIssued: overrides && overrides.hasOwnProperty('addonsIssued') ? overrides.addonsIssued! : 5,
        addonsSold: overrides && overrides.hasOwnProperty('addonsSold') ? overrides.addonsSold! : 5.3,
        orders: overrides && overrides.hasOwnProperty('orders') ? overrides.orders! : 1,
        ordersPartPaid: overrides && overrides.hasOwnProperty('ordersPartPaid') ? overrides.ordersPartPaid! : 8,
        cartAbandonment: overrides && overrides.hasOwnProperty('cartAbandonment') ? overrides.cartAbandonment! : 7,
        returningCustomers: overrides && overrides.hasOwnProperty('returningCustomers') ? overrides.returningCustomers! : 0.7,
        ticketsSold: overrides && overrides.hasOwnProperty('ticketsSold') ? overrides.ticketsSold! : 8.5,
        ticketsPartPaid: overrides && overrides.hasOwnProperty('ticketsPartPaid') ? overrides.ticketsPartPaid! : 4.7,
        membershipsPartPaid: overrides && overrides.hasOwnProperty('membershipsPartPaid') ? overrides.membershipsPartPaid! : 7.6,
        ticketsComp: overrides && overrides.hasOwnProperty('ticketsComp') ? overrides.ticketsComp! : 2.7,
        ticketsTransferred: overrides && overrides.hasOwnProperty('ticketsTransferred') ? overrides.ticketsTransferred! : 5.8,
        packagesSold: overrides && overrides.hasOwnProperty('packagesSold') ? overrides.packagesSold! : 5.9,
        pointsDistributed: overrides && overrides.hasOwnProperty('pointsDistributed') ? overrides.pointsDistributed! : 6.1,
        membershipsRenewed: overrides && overrides.hasOwnProperty('membershipsRenewed') ? overrides.membershipsRenewed! : 10,
        ticketCoverOrdersSold: overrides && overrides.hasOwnProperty('ticketCoverOrdersSold') ? overrides.ticketCoverOrdersSold! : 0.5,
        ticketCoverTicketsIssued: overrides && overrides.hasOwnProperty('ticketCoverTicketsIssued') ? overrides.ticketCoverTicketsIssued! : 3,
        ticketCoverMembershipsIssued: overrides && overrides.hasOwnProperty('ticketCoverMembershipsIssued') ? overrides.ticketCoverMembershipsIssued! : 5.5,
        cartRecovered: overrides && overrides.hasOwnProperty('cartRecovered') ? overrides.cartRecovered! : 5.8,
    };
};

export const aSalesComparisonGraphInput = (overrides?: Partial<SalesComparisonGraphInput>, _relationshipsToOmit: Set<string> = new Set()): SalesComparisonGraphInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SalesComparisonGraphInput');
    return {
        sourceIds: overrides && overrides.hasOwnProperty('sourceIds') ? overrides.sourceIds! : ['avarus'],
        source: overrides && overrides.hasOwnProperty('source') ? overrides.source! : ComparisonSource.Membership,
        alignmentType: overrides && overrides.hasOwnProperty('alignmentType') ? overrides.alignmentType! : SalesComparisonAlignmentType.DaysOnSale,
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2025-07-01T09:21:22.863Z",
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : "2025-05-27T15:13:15.769Z",
        periodFilter: overrides && overrides.hasOwnProperty('periodFilter') ? overrides.periodFilter! : PeriodFilter.Day,
    };
};

export const aSalesComparisonDataOutput = (overrides?: Partial<SalesComparisonDataOutput>, _relationshipsToOmit: Set<string> = new Set()): SalesComparisonDataOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SalesComparisonDataOutput');
    return {
        duration: overrides && overrides.hasOwnProperty('duration') ? overrides.duration! : 4319,
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : 'vespillo',
    };
};

export const aComparativeReportDefaultFiltersInput = (overrides?: Partial<ComparativeReportDefaultFiltersInput>, _relationshipsToOmit: Set<string> = new Set()): ComparativeReportDefaultFiltersInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ComparativeReportDefaultFiltersInput');
    return {
        sourceId: overrides && overrides.hasOwnProperty('sourceId') ? overrides.sourceId! : 'cariosus',
        sourceType: overrides && overrides.hasOwnProperty('sourceType') ? overrides.sourceType! : ComparisonSource.Membership,
        alignmentType: overrides && overrides.hasOwnProperty('alignmentType') ? overrides.alignmentType! : SalesComparisonAlignmentType.DaysOnSale,
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2025-05-14T18:23:15.156Z",
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : "2025-11-05T11:23:10.339Z",
    };
};

export const aComparativeReportDefaultFiltersOutput = (overrides?: Partial<ComparativeReportDefaultFiltersOutput>, _relationshipsToOmit: Set<string> = new Set()): ComparativeReportDefaultFiltersOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ComparativeReportDefaultFiltersOutput');
    return {
        periodFilter: overrides && overrides.hasOwnProperty('periodFilter') ? overrides.periodFilter! : relationshipsToOmit.has('PeriodFilterDefaults') ? {} as PeriodFilterDefaults : aPeriodFilterDefaults({}, relationshipsToOmit),
        metricFilter: overrides && overrides.hasOwnProperty('metricFilter') ? overrides.metricFilter! : relationshipsToOmit.has('MetricFilterDefaults') ? {} as MetricFilterDefaults : aMetricFilterDefaults({}, relationshipsToOmit),
    };
};

export const aPeriodFilterDefaults = (overrides?: Partial<PeriodFilterDefaults>, _relationshipsToOmit: Set<string> = new Set()): PeriodFilterDefaults => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PeriodFilterDefaults');
    return {
        default: overrides && overrides.hasOwnProperty('default') ? overrides.default! : PeriodFilter.Day,
        options: overrides && overrides.hasOwnProperty('options') ? overrides.options! : [relationshipsToOmit.has('FilterOption') ? {} as FilterOption : aFilterOption({}, relationshipsToOmit)],
    };
};

export const aFilterOption = (overrides?: Partial<FilterOption>, _relationshipsToOmit: Set<string> = new Set()): FilterOption => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('FilterOption');
    return {
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'aperio',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : PeriodFilter.Day,
    };
};

export const aMetricFilterDefaults = (overrides?: Partial<MetricFilterDefaults>, _relationshipsToOmit: Set<string> = new Set()): MetricFilterDefaults => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MetricFilterDefaults');
    return {
        default: overrides && overrides.hasOwnProperty('default') ? overrides.default! : 'calcar',
        options: overrides && overrides.hasOwnProperty('options') ? overrides.options! : [relationshipsToOmit.has('MetricFilterOption') ? {} as MetricFilterOption : aMetricFilterOption({}, relationshipsToOmit)],
    };
};

export const aMetricFilterOption = (overrides?: Partial<MetricFilterOption>, _relationshipsToOmit: Set<string> = new Set()): MetricFilterOption => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MetricFilterOption');
    return {
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'cupiditas',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'ustulo',
    };
};

export const aScoutCampaignOverviewOutput = (overrides?: Partial<ScoutCampaignOverviewOutput>, _relationshipsToOmit: Set<string> = new Set()): ScoutCampaignOverviewOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ScoutCampaignOverviewOutput');
    return {
        ticketsSold: overrides && overrides.hasOwnProperty('ticketsSold') ? overrides.ticketsSold! : 5.9,
        membershipsSold: overrides && overrides.hasOwnProperty('membershipsSold') ? overrides.membershipsSold! : 7,
        addonsSold: overrides && overrides.hasOwnProperty('addonsSold') ? overrides.addonsSold! : 9.7,
        orders: overrides && overrides.hasOwnProperty('orders') ? overrides.orders! : 0,
        cartAbandonment: overrides && overrides.hasOwnProperty('cartAbandonment') ? overrides.cartAbandonment! : 5.3,
        returningCustomers: overrides && overrides.hasOwnProperty('returningCustomers') ? overrides.returningCustomers! : 8.2,
        ticketsPaid: overrides && overrides.hasOwnProperty('ticketsPaid') ? overrides.ticketsPaid! : 3.7,
        ticketsComp: overrides && overrides.hasOwnProperty('ticketsComp') ? overrides.ticketsComp! : 7.3,
        totalRevenue: overrides && overrides.hasOwnProperty('totalRevenue') ? overrides.totalRevenue! : 7.6,
        todayRevenue: overrides && overrides.hasOwnProperty('todayRevenue') ? overrides.todayRevenue! : 0.4,
        campaignSize: overrides && overrides.hasOwnProperty('campaignSize') ? overrides.campaignSize! : 5.4,
        contactRate: overrides && overrides.hasOwnProperty('contactRate') ? overrides.contactRate! : 6,
        conversionRate: overrides && overrides.hasOwnProperty('conversionRate') ? overrides.conversionRate! : 1.2,
        emailClickRate: overrides && overrides.hasOwnProperty('emailClickRate') ? overrides.emailClickRate! : 5.8,
        emailOpenRate: overrides && overrides.hasOwnProperty('emailOpenRate') ? overrides.emailOpenRate! : 4.9,
    };
};

export const aTopTagsOutput = (overrides?: Partial<TopTagsOutput>, _relationshipsToOmit: Set<string> = new Set()): TopTagsOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TopTagsOutput');
    return {
        tag: overrides && overrides.hasOwnProperty('tag') ? overrides.tag! : 'alius',
        count: overrides && overrides.hasOwnProperty('count') ? overrides.count! : 7.6,
    };
};

export const aHighestValueCustomersOutput = (overrides?: Partial<HighestValueCustomersOutput>, _relationshipsToOmit: Set<string> = new Set()): HighestValueCustomersOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('HighestValueCustomersOutput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'cupiditate',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'catena',
        userId: overrides && overrides.hasOwnProperty('userId') ? overrides.userId! : 'strues',
    };
};

export const aGenderBreakDownOutput = (overrides?: Partial<GenderBreakDownOutput>, _relationshipsToOmit: Set<string> = new Set()): GenderBreakDownOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('GenderBreakDownOutput');
    return {
        reportData: overrides && overrides.hasOwnProperty('reportData') ? overrides.reportData! : relationshipsToOmit.has('GenderBreakDownData') ? {} as GenderBreakDownData : aGenderBreakDownData({}, relationshipsToOmit),
        reportType: overrides && overrides.hasOwnProperty('reportType') ? overrides.reportType! : ReportType.Internal,
        shouldHide: overrides && overrides.hasOwnProperty('shouldHide') ? overrides.shouldHide! : true,
    };
};

export const aGenderBreakDownData = (overrides?: Partial<GenderBreakDownData>, _relationshipsToOmit: Set<string> = new Set()): GenderBreakDownData => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('GenderBreakDownData');
    return {
        male: overrides && overrides.hasOwnProperty('male') ? overrides.male! : 2724,
        female: overrides && overrides.hasOwnProperty('female') ? overrides.female! : 226,
        other: overrides && overrides.hasOwnProperty('other') ? overrides.other! : 1591,
    };
};

export const aLocationOutput = (overrides?: Partial<LocationOutput>, _relationshipsToOmit: Set<string> = new Set()): LocationOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LocationOutput');
    return {
        city: overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'vinitor',
        count: overrides && overrides.hasOwnProperty('count') ? overrides.count! : 'victus',
        amount: overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 5.3,
    };
};

export const aSummaryOverviewOutput = (overrides?: Partial<SummaryOverviewOutput>, _relationshipsToOmit: Set<string> = new Set()): SummaryOverviewOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SummaryOverviewOutput');
    return {
        ticketsIssued: overrides && overrides.hasOwnProperty('ticketsIssued') ? overrides.ticketsIssued! : 1.3,
        membershipsIssued: overrides && overrides.hasOwnProperty('membershipsIssued') ? overrides.membershipsIssued! : 4.3,
        addonsIssued: overrides && overrides.hasOwnProperty('addonsIssued') ? overrides.addonsIssued! : 3.1,
        orders: overrides && overrides.hasOwnProperty('orders') ? overrides.orders! : 5.2,
        cartAbandonment: overrides && overrides.hasOwnProperty('cartAbandonment') ? overrides.cartAbandonment! : 0.7,
        returningCustomers: overrides && overrides.hasOwnProperty('returningCustomers') ? overrides.returningCustomers! : 1.7,
        ticketsSold: overrides && overrides.hasOwnProperty('ticketsSold') ? overrides.ticketsSold! : 4.8,
        ticketsComp: overrides && overrides.hasOwnProperty('ticketsComp') ? overrides.ticketsComp! : 6.3,
        totalNetRevenue: overrides && overrides.hasOwnProperty('totalNetRevenue') ? overrides.totalNetRevenue! : 6.7,
        todayNetRevenue: overrides && overrides.hasOwnProperty('todayNetRevenue') ? overrides.todayNetRevenue! : 7.6,
        yesterdayNetRevenue: overrides && overrides.hasOwnProperty('yesterdayNetRevenue') ? overrides.yesterdayNetRevenue! : 5.5,
        ticketsSoldToday: overrides && overrides.hasOwnProperty('ticketsSoldToday') ? overrides.ticketsSoldToday! : 6.1,
        ticketsSoldYesterday: overrides && overrides.hasOwnProperty('ticketsSoldYesterday') ? overrides.ticketsSoldYesterday! : 0.1,
        ticketsPartPaid: overrides && overrides.hasOwnProperty('ticketsPartPaid') ? overrides.ticketsPartPaid! : 0.1,
        membershipsPartPaid: overrides && overrides.hasOwnProperty('membershipsPartPaid') ? overrides.membershipsPartPaid! : 3.3,
        ordersPartPaid: overrides && overrides.hasOwnProperty('ordersPartPaid') ? overrides.ordersPartPaid! : 1.3,
        membershipsRenewed: overrides && overrides.hasOwnProperty('membershipsRenewed') ? overrides.membershipsRenewed! : 6.5,
        totalFaceRevenue: overrides && overrides.hasOwnProperty('totalFaceRevenue') ? overrides.totalFaceRevenue! : 5.1,
        faceRevenueToday: overrides && overrides.hasOwnProperty('faceRevenueToday') ? overrides.faceRevenueToday! : 1,
        faceRevenueYesterday: overrides && overrides.hasOwnProperty('faceRevenueYesterday') ? overrides.faceRevenueYesterday! : 8.4,
    };
};

export const aGraphOutput = (overrides?: Partial<GraphOutput>, _relationshipsToOmit: Set<string> = new Set()): GraphOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('GraphOutput');
    return {
        dates: overrides && overrides.hasOwnProperty('dates') ? overrides.dates! : [relationshipsToOmit.has('GraphDateItem') ? {} as GraphDateItem : aGraphDateItem({}, relationshipsToOmit)],
    };
};

export const aGraphDateItem = (overrides?: Partial<GraphDateItem>, _relationshipsToOmit: Set<string> = new Set()): GraphDateItem => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('GraphDateItem');
    return {
        date: overrides && overrides.hasOwnProperty('date') ? overrides.date! : "2025-05-21T13:56:46.008Z",
        items: overrides && overrides.hasOwnProperty('items') ? overrides.items! : [relationshipsToOmit.has('GraphItem') ? {} as GraphItem : aGraphItem({}, relationshipsToOmit)],
    };
};

export const aGraphItem = (overrides?: Partial<GraphItem>, _relationshipsToOmit: Set<string> = new Set()): GraphItem => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('GraphItem');
    return {
        key: overrides && overrides.hasOwnProperty('key') ? overrides.key! : 'toties',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'decens',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 0.9,
    };
};

export const aFinancialGatewayGraphOutput = (overrides?: Partial<FinancialGatewayGraphOutput>, _relationshipsToOmit: Set<string> = new Set()): FinancialGatewayGraphOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('FinancialGatewayGraphOutput');
    return {
        transactions: overrides && overrides.hasOwnProperty('transactions') ? overrides.transactions! : 5.1,
        integrations: overrides && overrides.hasOwnProperty('integrations') ? overrides.integrations! : [relationshipsToOmit.has('FinancialGraphIntegration') ? {} as FinancialGraphIntegration : aFinancialGraphIntegration({}, relationshipsToOmit)],
    };
};

export const aFinancialGraphIntegration = (overrides?: Partial<FinancialGraphIntegration>, _relationshipsToOmit: Set<string> = new Set()): FinancialGraphIntegration => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('FinancialGraphIntegration');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'aegrotatio',
        transactions: overrides && overrides.hasOwnProperty('transactions') ? overrides.transactions! : 8.9,
    };
};

export const aLocationOutputV2 = (overrides?: Partial<LocationOutputV2>, _relationshipsToOmit: Set<string> = new Set()): LocationOutputV2 => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LocationOutputV2');
    return {
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'undique',
        orderCount: overrides && overrides.hasOwnProperty('orderCount') ? overrides.orderCount! : 0.8,
        orderCountPercentage: overrides && overrides.hasOwnProperty('orderCountPercentage') ? overrides.orderCountPercentage! : 9.9,
        orderAmount: overrides && overrides.hasOwnProperty('orderAmount') ? overrides.orderAmount! : 3,
        orderAmountPercentage: overrides && overrides.hasOwnProperty('orderAmountPercentage') ? overrides.orderAmountPercentage! : 6.5,
        ticketSoldPercentage: overrides && overrides.hasOwnProperty('ticketSoldPercentage') ? overrides.ticketSoldPercentage! : 3.4,
        ticketSoldCount: overrides && overrides.hasOwnProperty('ticketSoldCount') ? overrides.ticketSoldCount! : 8.2,
        membershipSoldCount: overrides && overrides.hasOwnProperty('membershipSoldCount') ? overrides.membershipSoldCount! : 10,
        membershipSoldPercentage: overrides && overrides.hasOwnProperty('membershipSoldPercentage') ? overrides.membershipSoldPercentage! : 4.6,
        userCount: overrides && overrides.hasOwnProperty('userCount') ? overrides.userCount! : 4.6,
        userCountPercentage: overrides && overrides.hasOwnProperty('userCountPercentage') ? overrides.userCountPercentage! : 6.3,
        faceValueTicketRevenue: overrides && overrides.hasOwnProperty('faceValueTicketRevenue') ? overrides.faceValueTicketRevenue! : 4.7,
        faceValueTicketRevenuePercentage: overrides && overrides.hasOwnProperty('faceValueTicketRevenuePercentage') ? overrides.faceValueTicketRevenuePercentage! : 5.2,
    };
};

export const aSalesChannelGraphOutput = (overrides?: Partial<SalesChannelGraphOutput>, _relationshipsToOmit: Set<string> = new Set()): SalesChannelGraphOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SalesChannelGraphOutput');
    return {
        transactions: overrides && overrides.hasOwnProperty('transactions') ? overrides.transactions! : 3.9,
        online: overrides && overrides.hasOwnProperty('online') ? overrides.online! : 5.7,
        backOffice: overrides && overrides.hasOwnProperty('backOffice') ? overrides.backOffice! : 8,
        pos: overrides && overrides.hasOwnProperty('pos') ? overrides.pos! : 8.2,
    };
};

export const aFinancialOverviewOutput = (overrides?: Partial<FinancialOverviewOutput>, _relationshipsToOmit: Set<string> = new Set()): FinancialOverviewOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('FinancialOverviewOutput');
    return {
        netSales: overrides && overrides.hasOwnProperty('netSales') ? overrides.netSales! : 8.2,
        discounts: overrides && overrides.hasOwnProperty('discounts') ? overrides.discounts! : 6.6,
        avgOrderAmount: overrides && overrides.hasOwnProperty('avgOrderAmount') ? overrides.avgOrderAmount! : 8.8,
        avgOrderItemsCount: overrides && overrides.hasOwnProperty('avgOrderItemsCount') ? overrides.avgOrderItemsCount! : 5.4,
        resaleFees: overrides && overrides.hasOwnProperty('resaleFees') ? overrides.resaleFees! : 2.8,
        ticketCoverOrderTotal: overrides && overrides.hasOwnProperty('ticketCoverOrderTotal') ? overrides.ticketCoverOrderTotal! : 4.7,
        ticketCoverRevenue: overrides && overrides.hasOwnProperty('ticketCoverRevenue') ? overrides.ticketCoverRevenue! : 2.9,
        ticketCoverMargin: overrides && overrides.hasOwnProperty('ticketCoverMargin') ? overrides.ticketCoverMargin! : 2.1,
        ticketCoverCost: overrides && overrides.hasOwnProperty('ticketCoverCost') ? overrides.ticketCoverCost! : 9.1,
        resaleMargin: overrides && overrides.hasOwnProperty('resaleMargin') ? overrides.resaleMargin! : 8.1,
        planTotalPaid: overrides && overrides.hasOwnProperty('planTotalPaid') ? overrides.planTotalPaid! : 9.6,
        planTotalOutstanding: overrides && overrides.hasOwnProperty('planTotalOutstanding') ? overrides.planTotalOutstanding! : 6.2,
    };
};

export const aFaceValueOverviewOutput = (overrides?: Partial<FaceValueOverviewOutput>, _relationshipsToOmit: Set<string> = new Set()): FaceValueOverviewOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('FaceValueOverviewOutput');
    return {
        totalFaceValue: overrides && overrides.hasOwnProperty('totalFaceValue') ? overrides.totalFaceValue! : 1.5,
        avgOrderItemsCount: overrides && overrides.hasOwnProperty('avgOrderItemsCount') ? overrides.avgOrderItemsCount! : 1.2,
    };
};

export const aSalesReportOutput = (overrides?: Partial<SalesReportOutput>, _relationshipsToOmit: Set<string> = new Set()): SalesReportOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SalesReportOutput');
    return {
        salesBreakdown: overrides && overrides.hasOwnProperty('salesBreakdown') ? overrides.salesBreakdown! : relationshipsToOmit.has('SalesBreakdown') ? {} as SalesBreakdown : aSalesBreakdown({}, relationshipsToOmit),
        financialSales: overrides && overrides.hasOwnProperty('financialSales') ? overrides.financialSales! : [relationshipsToOmit.has('FinancialSales') ? {} as FinancialSales : aFinancialSales({}, relationshipsToOmit)],
    };
};

export const aSalesBreakdown = (overrides?: Partial<SalesBreakdown>, _relationshipsToOmit: Set<string> = new Set()): SalesBreakdown => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SalesBreakdown');
    return {
        items: overrides && overrides.hasOwnProperty('items') ? overrides.items! : [relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit)],
        fullyPaidItems: overrides && overrides.hasOwnProperty('fullyPaidItems') ? overrides.fullyPaidItems! : [relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit)],
        partPaidItems: overrides && overrides.hasOwnProperty('partPaidItems') ? overrides.partPaidItems! : [relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit)],
        totalNet: overrides && overrides.hasOwnProperty('totalNet') ? overrides.totalNet! : 3.6,
        faceValue: overrides && overrides.hasOwnProperty('faceValue') ? overrides.faceValue! : 3.2,
    };
};

export const aNumberStatistic = (overrides?: Partial<NumberStatistic>, _relationshipsToOmit: Set<string> = new Set()): NumberStatistic => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('NumberStatistic');
    return {
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'dolores',
        tooltip: overrides && overrides.hasOwnProperty('tooltip') ? overrides.tooltip! : relationshipsToOmit.has('StatisticTooltip') ? {} as StatisticTooltip : aStatisticTooltip({}, relationshipsToOmit),
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 8.7,
    };
};

export const aStatisticTooltip = (overrides?: Partial<StatisticTooltip>, _relationshipsToOmit: Set<string> = new Set()): StatisticTooltip => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('StatisticTooltip');
    return {
        content: overrides && overrides.hasOwnProperty('content') ? overrides.content! : 'textilis',
        link: overrides && overrides.hasOwnProperty('link') ? overrides.link! : 'dens',
    };
};

export const aScannedVisitorsOutput = (overrides?: Partial<ScannedVisitorsOutput>, _relationshipsToOmit: Set<string> = new Set()): ScannedVisitorsOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ScannedVisitorsOutput');
    return {
        category: overrides && overrides.hasOwnProperty('category') ? overrides.category! : relationshipsToOmit.has('ScannedVisitorsCategory') ? {} as ScannedVisitorsCategory : aScannedVisitorsCategory({}, relationshipsToOmit),
        items: overrides && overrides.hasOwnProperty('items') ? overrides.items! : [relationshipsToOmit.has('ScannedVisitorsGate') ? {} as ScannedVisitorsGate : aScannedVisitorsGate({}, relationshipsToOmit)],
    };
};

export const aScannedVisitorsCategory = (overrides?: Partial<ScannedVisitorsCategory>, _relationshipsToOmit: Set<string> = new Set()): ScannedVisitorsCategory => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ScannedVisitorsCategory');
    return {
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'patria',
        displayValue: overrides && overrides.hasOwnProperty('displayValue') ? overrides.displayValue! : 'subseco',
        chartProps: overrides && overrides.hasOwnProperty('chartProps') ? overrides.chartProps! : relationshipsToOmit.has('ScannedVisitorsChartProps') ? {} as ScannedVisitorsChartProps : aScannedVisitorsChartProps({}, relationshipsToOmit),
        descriptionItems: overrides && overrides.hasOwnProperty('descriptionItems') ? overrides.descriptionItems! : ['absconditus'],
    };
};

export const aScannedVisitorsChartProps = (overrides?: Partial<ScannedVisitorsChartProps>, _relationshipsToOmit: Set<string> = new Set()): ScannedVisitorsChartProps => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ScannedVisitorsChartProps');
    return {
        percentage: overrides && overrides.hasOwnProperty('percentage') ? overrides.percentage! : 5.1,
    };
};

export const aScannedVisitorsGate = (overrides?: Partial<ScannedVisitorsGate>, _relationshipsToOmit: Set<string> = new Set()): ScannedVisitorsGate => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ScannedVisitorsGate');
    return {
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'caste',
        subtitle: overrides && overrides.hasOwnProperty('subtitle') ? overrides.subtitle! : 'deleniti',
        displayValue: overrides && overrides.hasOwnProperty('displayValue') ? overrides.displayValue! : 'eius',
    };
};

export const aGraphRangeItem = (overrides?: Partial<GraphRangeItem>, _relationshipsToOmit: Set<string> = new Set()): GraphRangeItem => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('GraphRangeItem');
    return {
        start: overrides && overrides.hasOwnProperty('start') ? overrides.start! : 'adsuesco',
        end: overrides && overrides.hasOwnProperty('end') ? overrides.end! : 'cunctatio',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 8.8,
    };
};

export const aScansOverTimeInput = (overrides?: Partial<ScansOverTimeInput>, _relationshipsToOmit: Set<string> = new Set()): ScansOverTimeInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ScansOverTimeInput');
    return {
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'sumo',
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2026-01-07T22:10:28.953Z",
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : "2025-04-24T04:31:19.808Z",
        groupBy: overrides && overrides.hasOwnProperty('groupBy') ? overrides.groupBy! : ScanOverTimeGroupBy.OneDay,
        dateFilterType: overrides && overrides.hasOwnProperty('dateFilterType') ? overrides.dateFilterType! : ScanReportingDateFilterType.All,
    };
};

export const aScansOverTimeOutput = (overrides?: Partial<ScansOverTimeOutput>, _relationshipsToOmit: Set<string> = new Set()): ScansOverTimeOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ScansOverTimeOutput');
    return {
        date: overrides && overrides.hasOwnProperty('date') ? overrides.date! : "2026-02-02T02:02:26.637Z",
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 7,
    };
};

export const aScanningOverviewOutput = (overrides?: Partial<ScanningOverviewOutput>, _relationshipsToOmit: Set<string> = new Set()): ScanningOverviewOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ScanningOverviewOutput');
    return {
        totalScanned: overrides && overrides.hasOwnProperty('totalScanned') ? overrides.totalScanned! : 8.5,
        totalIssued: overrides && overrides.hasOwnProperty('totalIssued') ? overrides.totalIssued! : 1.8,
        totalToScan: overrides && overrides.hasOwnProperty('totalToScan') ? overrides.totalToScan! : 2.9,
        totalNonAdmissionScanned: overrides && overrides.hasOwnProperty('totalNonAdmissionScanned') ? overrides.totalNonAdmissionScanned! : 2.8,
        totalTicketsScannedOut: overrides && overrides.hasOwnProperty('totalTicketsScannedOut') ? overrides.totalTicketsScannedOut! : 9,
        scannedTicketTypes: overrides && overrides.hasOwnProperty('scannedTicketTypes') ? overrides.scannedTicketTypes! : [relationshipsToOmit.has('ScannedTicketTypesOutput') ? {} as ScannedTicketTypesOutput : aScannedTicketTypesOutput({}, relationshipsToOmit)],
        scansByDay: overrides && overrides.hasOwnProperty('scansByDay') ? overrides.scansByDay! : [relationshipsToOmit.has('ScansByDayOutput') ? {} as ScansByDayOutput : aScansByDayOutput({}, relationshipsToOmit)],
    };
};

export const aScannedTicketTypesOutput = (overrides?: Partial<ScannedTicketTypesOutput>, _relationshipsToOmit: Set<string> = new Set()): ScannedTicketTypesOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ScannedTicketTypesOutput');
    return {
        identifier: overrides && overrides.hasOwnProperty('identifier') ? overrides.identifier! : ScannedTicketType.SoldTickets,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'placeat',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'ager',
        items: overrides && overrides.hasOwnProperty('items') ? overrides.items! : [relationshipsToOmit.has('ScannedTicketTypesItem') ? {} as ScannedTicketTypesItem : aScannedTicketTypesItem({}, relationshipsToOmit)],
    };
};

export const aScannedTicketTypesItem = (overrides?: Partial<ScannedTicketTypesItem>, _relationshipsToOmit: Set<string> = new Set()): ScannedTicketTypesItem => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ScannedTicketTypesItem');
    return {
        key: overrides && overrides.hasOwnProperty('key') ? overrides.key! : ScanMetric.Issued,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'terreo',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 1.2,
    };
};

export const aScansByDayOutput = (overrides?: Partial<ScansByDayOutput>, _relationshipsToOmit: Set<string> = new Set()): ScansByDayOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ScansByDayOutput');
    return {
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 5.8,
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'cur',
        percentage: overrides && overrides.hasOwnProperty('percentage') ? overrides.percentage! : 7.8,
        subLabel: overrides && overrides.hasOwnProperty('subLabel') ? overrides.subLabel! : 'abundans',
    };
};

export const aGraphTextItem = (overrides?: Partial<GraphTextItem>, _relationshipsToOmit: Set<string> = new Set()): GraphTextItem => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('GraphTextItem');
    return {
        identifier: overrides && overrides.hasOwnProperty('identifier') ? overrides.identifier! : 'votum',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'dolorem',
        items: overrides && overrides.hasOwnProperty('items') ? overrides.items! : [relationshipsToOmit.has('GraphItem') ? {} as GraphItem : aGraphItem({}, relationshipsToOmit)],
    };
};

export const aPosSalesOverviewOutput = (overrides?: Partial<PosSalesOverviewOutput>, _relationshipsToOmit: Set<string> = new Set()): PosSalesOverviewOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PosSalesOverviewOutput');
    return {
        soldAtTheDoor: overrides && overrides.hasOwnProperty('soldAtTheDoor') ? overrides.soldAtTheDoor! : 3.3,
        orders: overrides && overrides.hasOwnProperty('orders') ? overrides.orders! : 7.1,
        soldOnline: overrides && overrides.hasOwnProperty('soldOnline') ? overrides.soldOnline! : 5.9,
        scannedPercentage: overrides && overrides.hasOwnProperty('scannedPercentage') ? overrides.scannedPercentage! : 3.9,
        average: overrides && overrides.hasOwnProperty('average') ? overrides.average! : 8.4,
        perHour: overrides && overrides.hasOwnProperty('perHour') ? overrides.perHour! : 5.7,
    };
};

export const anInsightsOverviewOutput = (overrides?: Partial<InsightsOverviewOutput>, _relationshipsToOmit: Set<string> = new Set()): InsightsOverviewOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InsightsOverviewOutput');
    return {
        customers: overrides && overrides.hasOwnProperty('customers') ? overrides.customers! : 0.6,
        addressableAudience: overrides && overrides.hasOwnProperty('addressableAudience') ? overrides.addressableAudience! : 5.7,
        customerValue: overrides && overrides.hasOwnProperty('customerValue') ? overrides.customerValue! : 7.4,
        numberOfOrders: overrides && overrides.hasOwnProperty('numberOfOrders') ? overrides.numberOfOrders! : 5,
        repeatPurchasers: overrides && overrides.hasOwnProperty('repeatPurchasers') ? overrides.repeatPurchasers! : 0.7,
        referralLinksCreated: overrides && overrides.hasOwnProperty('referralLinksCreated') ? overrides.referralLinksCreated! : 6.9,
        newReferredCustomers: overrides && overrides.hasOwnProperty('newReferredCustomers') ? overrides.newReferredCustomers! : 4,
        ordersPerUser: overrides && overrides.hasOwnProperty('ordersPerUser') ? overrides.ordersPerUser! : 8,
        ticketsCount: overrides && overrides.hasOwnProperty('ticketsCount') ? overrides.ticketsCount! : 8.9,
        netSales: overrides && overrides.hasOwnProperty('netSales') ? overrides.netSales! : 6.9,
    };
};

export const aTopReferrersOutput = (overrides?: Partial<TopReferrersOutput>, _relationshipsToOmit: Set<string> = new Set()): TopReferrersOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TopReferrersOutput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'comes',
        count: overrides && overrides.hasOwnProperty('count') ? overrides.count! : 7,
        userId: overrides && overrides.hasOwnProperty('userId') ? overrides.userId! : 'aveho',
    };
};

export const aTopRepeatPurchasers = (overrides?: Partial<TopRepeatPurchasers>, _relationshipsToOmit: Set<string> = new Set()): TopRepeatPurchasers => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TopRepeatPurchasers');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'cilicium',
        count: overrides && overrides.hasOwnProperty('count') ? overrides.count! : 8.2,
        userId: overrides && overrides.hasOwnProperty('userId') ? overrides.userId! : 'conicio',
    };
};

export const aHeardAboutUsBreakDownOutput = (overrides?: Partial<HeardAboutUsBreakDownOutput>, _relationshipsToOmit: Set<string> = new Set()): HeardAboutUsBreakDownOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('HeardAboutUsBreakDownOutput');
    return {
        heardAboutUs: overrides && overrides.hasOwnProperty('heardAboutUs') ? overrides.heardAboutUs! : 'subvenio',
        count: overrides && overrides.hasOwnProperty('count') ? overrides.count! : 7.4,
    };
};

export const anAgeBreakDownOutput = (overrides?: Partial<AgeBreakDownOutput>, _relationshipsToOmit: Set<string> = new Set()): AgeBreakDownOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AgeBreakDownOutput');
    return {
        reportData: overrides && overrides.hasOwnProperty('reportData') ? overrides.reportData! : [relationshipsToOmit.has('AgeBreakDownSegment') ? {} as AgeBreakDownSegment : anAgeBreakDownSegment({}, relationshipsToOmit)],
        reportType: overrides && overrides.hasOwnProperty('reportType') ? overrides.reportType! : ReportType.Internal,
        shouldHide: overrides && overrides.hasOwnProperty('shouldHide') ? overrides.shouldHide! : true,
    };
};

export const anAgeBreakDownSegment = (overrides?: Partial<AgeBreakDownSegment>, _relationshipsToOmit: Set<string> = new Set()): AgeBreakDownSegment => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AgeBreakDownSegment');
    return {
        ageRange: overrides && overrides.hasOwnProperty('ageRange') ? overrides.ageRange! : 'tam',
        percentage: overrides && overrides.hasOwnProperty('percentage') ? overrides.percentage! : 0.1,
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 1.3,
    };
};

export const aWaitlistOverviewOutput = (overrides?: Partial<WaitlistOverviewOutput>, _relationshipsToOmit: Set<string> = new Set()): WaitlistOverviewOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('WaitlistOverviewOutput');
    return {
        totalCustomers: overrides && overrides.hasOwnProperty('totalCustomers') ? overrides.totalCustomers! : 1.1,
        totalNewCustomers: overrides && overrides.hasOwnProperty('totalNewCustomers') ? overrides.totalNewCustomers! : 1.4,
        totalReturningCustomers: overrides && overrides.hasOwnProperty('totalReturningCustomers') ? overrides.totalReturningCustomers! : 6.1,
        customersOptedIntoMarketing: overrides && overrides.hasOwnProperty('customersOptedIntoMarketing') ? overrides.customersOptedIntoMarketing! : 8,
        totalRevenue: overrides && overrides.hasOwnProperty('totalRevenue') ? overrides.totalRevenue! : 1.5,
        numberOfOrders: overrides && overrides.hasOwnProperty('numberOfOrders') ? overrides.numberOfOrders! : 3,
        numberOfSuccesfulUsers: overrides && overrides.hasOwnProperty('numberOfSuccesfulUsers') ? overrides.numberOfSuccesfulUsers! : 5.2,
        numberOfTickets: overrides && overrides.hasOwnProperty('numberOfTickets') ? overrides.numberOfTickets! : 7.4,
        yetToConvert: overrides && overrides.hasOwnProperty('yetToConvert') ? overrides.yetToConvert! : 8.4,
    };
};

export const aBroadcastReportingStatsInput = (overrides?: Partial<BroadcastReportingStatsInput>, _relationshipsToOmit: Set<string> = new Set()): BroadcastReportingStatsInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BroadcastReportingStatsInput');
    return {
        broadcastId: overrides && overrides.hasOwnProperty('broadcastId') ? overrides.broadcastId! : 'quis',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : BroadcastType.Marketing,
    };
};

export const aBroadcastReportingOutput = (overrides?: Partial<BroadcastReportingOutput>, _relationshipsToOmit: Set<string> = new Set()): BroadcastReportingOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BroadcastReportingOutput');
    return {
        clicksOpened: overrides && overrides.hasOwnProperty('clicksOpened') ? overrides.clicksOpened! : 2.6,
        revenue: overrides && overrides.hasOwnProperty('revenue') ? overrides.revenue! : 3.6,
        conversions: overrides && overrides.hasOwnProperty('conversions') ? overrides.conversions! : 2.9,
        spamReported: overrides && overrides.hasOwnProperty('spamReported') ? overrides.spamReported! : 0.4,
    };
};

export const aBarchartOutput = (overrides?: Partial<BarchartOutput>, _relationshipsToOmit: Set<string> = new Set()): BarchartOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BarchartOutput');
    return {
        range: overrides && overrides.hasOwnProperty('range') ? overrides.range! : 'succedo',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 0.6,
    };
};

export const aReferralPromotionReportingInput = (overrides?: Partial<ReferralPromotionReportingInput>, _relationshipsToOmit: Set<string> = new Set()): ReferralPromotionReportingInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ReferralPromotionReportingInput');
    return {
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'denique',
    };
};

export const aReferralPromotionReportingOutput = (overrides?: Partial<ReferralPromotionReportingOutput>, _relationshipsToOmit: Set<string> = new Set()): ReferralPromotionReportingOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ReferralPromotionReportingOutput');
    return {
        revenue: overrides && overrides.hasOwnProperty('revenue') ? overrides.revenue! : 0.3,
        roi: overrides && overrides.hasOwnProperty('roi') ? overrides.roi! : 9.3,
        orders: overrides && overrides.hasOwnProperty('orders') ? overrides.orders! : 9.5,
        newReferredCustomers: overrides && overrides.hasOwnProperty('newReferredCustomers') ? overrides.newReferredCustomers! : 1.4,
        referrerPointsAwarded: overrides && overrides.hasOwnProperty('referrerPointsAwarded') ? overrides.referrerPointsAwarded! : 5.4,
        discountValue: overrides && overrides.hasOwnProperty('discountValue') ? overrides.discountValue! : 6.4,
        actionEngagement: overrides && overrides.hasOwnProperty('actionEngagement') ? overrides.actionEngagement! : [relationshipsToOmit.has('ActionEngagementRecordOutput') ? {} as ActionEngagementRecordOutput : anActionEngagementRecordOutput({}, relationshipsToOmit)],
    };
};

export const anActionEngagementRecordOutput = (overrides?: Partial<ActionEngagementRecordOutput>, _relationshipsToOmit: Set<string> = new Set()): ActionEngagementRecordOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ActionEngagementRecordOutput');
    return {
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'calcar',
        clickCount: overrides && overrides.hasOwnProperty('clickCount') ? overrides.clickCount! : 2.8,
    };
};

export const aCompetitionReportingInput = (overrides?: Partial<CompetitionReportingInput>, _relationshipsToOmit: Set<string> = new Set()): CompetitionReportingInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CompetitionReportingInput');
    return {
        competitionId: overrides && overrides.hasOwnProperty('competitionId') ? overrides.competitionId! : 'cedo',
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'constans',
    };
};

export const aCompetitionReportingOnsaleOutput = (overrides?: Partial<CompetitionReportingOnsaleOutput>, _relationshipsToOmit: Set<string> = new Set()): CompetitionReportingOnsaleOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CompetitionReportingOnsaleOutput');
    return {
        competition: overrides && overrides.hasOwnProperty('competition') ? overrides.competition! : relationshipsToOmit.has('CompetitionOnsaleOutput') ? {} as CompetitionOnsaleOutput : aCompetitionOnsaleOutput({}, relationshipsToOmit),
        promoter: overrides && overrides.hasOwnProperty('promoter') ? overrides.promoter! : relationshipsToOmit.has('PromoterOnsaleOutput') ? {} as PromoterOnsaleOutput : aPromoterOnsaleOutput({}, relationshipsToOmit),
        actionEngagement: overrides && overrides.hasOwnProperty('actionEngagement') ? overrides.actionEngagement! : [relationshipsToOmit.has('ActionEngagementRecordOutput') ? {} as ActionEngagementRecordOutput : anActionEngagementRecordOutput({}, relationshipsToOmit)],
    };
};

export const aCompetitionOnsaleOutput = (overrides?: Partial<CompetitionOnsaleOutput>, _relationshipsToOmit: Set<string> = new Set()): CompetitionOnsaleOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CompetitionOnsaleOutput');
    return {
        totalEntries: overrides && overrides.hasOwnProperty('totalEntries') ? overrides.totalEntries! : 5,
        pageViews: overrides && overrides.hasOwnProperty('pageViews') ? overrides.pageViews! : 8,
        conversionRate: overrides && overrides.hasOwnProperty('conversionRate') ? overrides.conversionRate! : 7.3,
        revenue: overrides && overrides.hasOwnProperty('revenue') ? overrides.revenue! : 2.1,
        totalOrders: overrides && overrides.hasOwnProperty('totalOrders') ? overrides.totalOrders! : 8.5,
        ticketsSold: overrides && overrides.hasOwnProperty('ticketsSold') ? overrides.ticketsSold! : 6.5,
        newCustomers: overrides && overrides.hasOwnProperty('newCustomers') ? overrides.newCustomers! : 8.1,
        hasSalesOutsideOfCompetition: overrides && overrides.hasOwnProperty('hasSalesOutsideOfCompetition') ? overrides.hasSalesOutsideOfCompetition! : true,
    };
};

export const aPromoterOnsaleOutput = (overrides?: Partial<PromoterOnsaleOutput>, _relationshipsToOmit: Set<string> = new Set()): PromoterOnsaleOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PromoterOnsaleOutput');
    return {
        revenue: overrides && overrides.hasOwnProperty('revenue') ? overrides.revenue! : 4.7,
        newCustomers: overrides && overrides.hasOwnProperty('newCustomers') ? overrides.newCustomers! : 5,
        referralEntriesAwarded: overrides && overrides.hasOwnProperty('referralEntriesAwarded') ? overrides.referralEntriesAwarded! : 1.8,
        orders: overrides && overrides.hasOwnProperty('orders') ? overrides.orders! : 6.9,
    };
};

export const aGoogleAnalyticsReportingFilterInput = (overrides?: Partial<GoogleAnalyticsReportingFilterInput>, _relationshipsToOmit: Set<string> = new Set()): GoogleAnalyticsReportingFilterInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('GoogleAnalyticsReportingFilterInput');
    return {
        sourceId: overrides && overrides.hasOwnProperty('sourceId') ? overrides.sourceId! : 'curso',
        seasonId: overrides && overrides.hasOwnProperty('seasonId') ? overrides.seasonId! : 'denuncio',
        source: overrides && overrides.hasOwnProperty('source') ? overrides.source! : ReportingFilterSource.Overall,
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : GoogleAnalyticsReportType.Device,
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2025-05-16T11:08:27.064Z",
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : "2025-11-25T19:34:19.021Z",
    };
};

export const aCompetitionReportingRegistrationOutput = (overrides?: Partial<CompetitionReportingRegistrationOutput>, _relationshipsToOmit: Set<string> = new Set()): CompetitionReportingRegistrationOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CompetitionReportingRegistrationOutput');
    return {
        competition: overrides && overrides.hasOwnProperty('competition') ? overrides.competition! : relationshipsToOmit.has('CompetitionRegistrationOutput') ? {} as CompetitionRegistrationOutput : aCompetitionRegistrationOutput({}, relationshipsToOmit),
        promoter: overrides && overrides.hasOwnProperty('promoter') ? overrides.promoter! : relationshipsToOmit.has('PromoterRegistrationOutput') ? {} as PromoterRegistrationOutput : aPromoterRegistrationOutput({}, relationshipsToOmit),
        actionEngagement: overrides && overrides.hasOwnProperty('actionEngagement') ? overrides.actionEngagement! : [relationshipsToOmit.has('ActionEngagementRecordOutput') ? {} as ActionEngagementRecordOutput : anActionEngagementRecordOutput({}, relationshipsToOmit)],
    };
};

export const aCompetitionRegistrationOutput = (overrides?: Partial<CompetitionRegistrationOutput>, _relationshipsToOmit: Set<string> = new Set()): CompetitionRegistrationOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CompetitionRegistrationOutput');
    return {
        totalEntries: overrides && overrides.hasOwnProperty('totalEntries') ? overrides.totalEntries! : 2.1,
        pageViews: overrides && overrides.hasOwnProperty('pageViews') ? overrides.pageViews! : 2.9,
        eventDetailsPageViews: overrides && overrides.hasOwnProperty('eventDetailsPageViews') ? overrides.eventDetailsPageViews! : 5.2,
        registrationPageViews: overrides && overrides.hasOwnProperty('registrationPageViews') ? overrides.registrationPageViews! : 2,
        conversionRate: overrides && overrides.hasOwnProperty('conversionRate') ? overrides.conversionRate! : 4.8,
        eventPageConversionRate: overrides && overrides.hasOwnProperty('eventPageConversionRate') ? overrides.eventPageConversionRate! : 3.6,
        registrationPageConversionRate: overrides && overrides.hasOwnProperty('registrationPageConversionRate') ? overrides.registrationPageConversionRate! : 9.5,
        totalRegistrations: overrides && overrides.hasOwnProperty('totalRegistrations') ? overrides.totalRegistrations! : 7.1,
        newCustomers: overrides && overrides.hasOwnProperty('newCustomers') ? overrides.newCustomers! : 0,
    };
};

export const aPromoterRegistrationOutput = (overrides?: Partial<PromoterRegistrationOutput>, _relationshipsToOmit: Set<string> = new Set()): PromoterRegistrationOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PromoterRegistrationOutput');
    return {
        newCustomers: overrides && overrides.hasOwnProperty('newCustomers') ? overrides.newCustomers! : 1.6,
        referralEntriesAwarded: overrides && overrides.hasOwnProperty('referralEntriesAwarded') ? overrides.referralEntriesAwarded! : 8.7,
        registrationsViaReferral: overrides && overrides.hasOwnProperty('registrationsViaReferral') ? overrides.registrationsViaReferral! : 6.2,
    };
};

export const aReferralRegistrationPromotionReportingOutput = (overrides?: Partial<ReferralRegistrationPromotionReportingOutput>, _relationshipsToOmit: Set<string> = new Set()): ReferralRegistrationPromotionReportingOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ReferralRegistrationPromotionReportingOutput');
    return {
        newReferredCustomers: overrides && overrides.hasOwnProperty('newReferredCustomers') ? overrides.newReferredCustomers! : 3,
        registrations: overrides && overrides.hasOwnProperty('registrations') ? overrides.registrations! : 0.2,
        actionEngagement: overrides && overrides.hasOwnProperty('actionEngagement') ? overrides.actionEngagement! : [relationshipsToOmit.has('ActionEngagementRecordOutput') ? {} as ActionEngagementRecordOutput : anActionEngagementRecordOutput({}, relationshipsToOmit)],
    };
};

export const aCustomerCompetitionReportingInput = (overrides?: Partial<CustomerCompetitionReportingInput>, _relationshipsToOmit: Set<string> = new Set()): CustomerCompetitionReportingInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CustomerCompetitionReportingInput');
    return {
        customerId: overrides && overrides.hasOwnProperty('customerId') ? overrides.customerId! : 'uxor',
    };
};

export const aCompetitionCustomerReporting = (overrides?: Partial<CompetitionCustomerReporting>, _relationshipsToOmit: Set<string> = new Set()): CompetitionCustomerReporting => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CompetitionCustomerReporting');
    return {
        competitionEndDate: overrides && overrides.hasOwnProperty('competitionEndDate') ? overrides.competitionEndDate! : "2025-06-21T09:53:06.768Z",
        competitionTitle: overrides && overrides.hasOwnProperty('competitionTitle') ? overrides.competitionTitle! : 'basium',
        competitionEventTitle: overrides && overrides.hasOwnProperty('competitionEventTitle') ? overrides.competitionEventTitle! : 'timidus',
        competitionEventLogo: overrides && overrides.hasOwnProperty('competitionEventLogo') ? overrides.competitionEventLogo! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        competitionBannerImage: overrides && overrides.hasOwnProperty('competitionBannerImage') ? overrides.competitionBannerImage! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        competitionReferralLink: overrides && overrides.hasOwnProperty('competitionReferralLink') ? overrides.competitionReferralLink! : 'dapifer',
        competitionSharePageLink: overrides && overrides.hasOwnProperty('competitionSharePageLink') ? overrides.competitionSharePageLink! : 'decretum',
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'corporis',
        competitionId: overrides && overrides.hasOwnProperty('competitionId') ? overrides.competitionId! : 'velociter',
        referralsMade: overrides && overrides.hasOwnProperty('referralsMade') ? overrides.referralsMade! : 8787,
        entries: overrides && overrides.hasOwnProperty('entries') ? overrides.entries! : 3455,
        isCompetitionRunning: overrides && overrides.hasOwnProperty('isCompetitionRunning') ? overrides.isCompetitionRunning! : false,
    };
};

export const aCustomerReferralReportingInput = (overrides?: Partial<CustomerReferralReportingInput>, _relationshipsToOmit: Set<string> = new Set()): CustomerReferralReportingInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CustomerReferralReportingInput');
    return {
        customerId: overrides && overrides.hasOwnProperty('customerId') ? overrides.customerId! : 'suggero',
    };
};

export const aReferralCustomerReporting = (overrides?: Partial<ReferralCustomerReporting>, _relationshipsToOmit: Set<string> = new Set()): ReferralCustomerReporting => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ReferralCustomerReporting');
    return {
        orderNumber: overrides && overrides.hasOwnProperty('orderNumber') ? overrides.orderNumber! : 'versus',
        eventLogo: overrides && overrides.hasOwnProperty('eventLogo') ? overrides.eventLogo! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        eventName: overrides && overrides.hasOwnProperty('eventName') ? overrides.eventName! : 'qui',
        orderDate: overrides && overrides.hasOwnProperty('orderDate') ? overrides.orderDate! : "2025-07-01T03:25:30.720Z",
        referralsMade: overrides && overrides.hasOwnProperty('referralsMade') ? overrides.referralsMade! : 7561,
        referralLink: overrides && overrides.hasOwnProperty('referralLink') ? overrides.referralLink! : 'adeo',
    };
};

export const aPresaleConversionOutput = (overrides?: Partial<PresaleConversionOutput>, _relationshipsToOmit: Set<string> = new Set()): PresaleConversionOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PresaleConversionOutput');
    return {
        conversionSteps: overrides && overrides.hasOwnProperty('conversionSteps') ? overrides.conversionSteps! : [relationshipsToOmit.has('BreakdownItem') ? {} as BreakdownItem : aBreakdownItem({}, relationshipsToOmit)],
        completedPresaleOrders: overrides && overrides.hasOwnProperty('completedPresaleOrders') ? overrides.completedPresaleOrders! : relationshipsToOmit.has('OrderList') ? {} as OrderList : anOrderList({}, relationshipsToOmit),
        completedOrderList: overrides && overrides.hasOwnProperty('completedOrderList') ? overrides.completedOrderList! : relationshipsToOmit.has('OrderList') ? {} as OrderList : anOrderList({}, relationshipsToOmit),
        preAuthorizedOrderList: overrides && overrides.hasOwnProperty('preAuthorizedOrderList') ? overrides.preAuthorizedOrderList! : relationshipsToOmit.has('OrderList') ? {} as OrderList : anOrderList({}, relationshipsToOmit),
    };
};

export const aBreakdownItem = (overrides?: Partial<BreakdownItem>, _relationshipsToOmit: Set<string> = new Set()): BreakdownItem => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BreakdownItem');
    return {
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 6.4,
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'damno',
        percentage: overrides && overrides.hasOwnProperty('percentage') ? overrides.percentage! : 6.1,
        tooltip: overrides && overrides.hasOwnProperty('tooltip') ? overrides.tooltip! : relationshipsToOmit.has('StatisticTooltip') ? {} as StatisticTooltip : aStatisticTooltip({}, relationshipsToOmit),
    };
};

export const anOrderList = (overrides?: Partial<OrderList>, _relationshipsToOmit: Set<string> = new Set()): OrderList => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OrderList');
    return {
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'patruus',
        totalOrders: overrides && overrides.hasOwnProperty('totalOrders') ? overrides.totalOrders! : 1.2,
        items: overrides && overrides.hasOwnProperty('items') ? overrides.items! : [relationshipsToOmit.has('BreakdownItem') ? {} as BreakdownItem : aBreakdownItem({}, relationshipsToOmit)],
    };
};

export const aReportingLayoutInput = (overrides?: Partial<ReportingLayoutInput>, _relationshipsToOmit: Set<string> = new Set()): ReportingLayoutInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ReportingLayoutInput');
    return {
        allEvents: overrides && overrides.hasOwnProperty('allEvents') ? overrides.allEvents! : false,
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'peccatus',
        membershipId: overrides && overrides.hasOwnProperty('membershipId') ? overrides.membershipId! : 'suffragium',
        allMemberships: overrides && overrides.hasOwnProperty('allMemberships') ? overrides.allMemberships! : true,
        seasonId: overrides && overrides.hasOwnProperty('seasonId') ? overrides.seasonId! : 'coruscus',
        allSeasons: overrides && overrides.hasOwnProperty('allSeasons') ? overrides.allSeasons! : true,
        seasonSource: overrides && overrides.hasOwnProperty('seasonSource') ? overrides.seasonSource! : ReportingFinancialSalesBreakdownSource.Membership,
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2025-12-08T16:19:35.677Z",
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : "2026-01-07T23:19:46.284Z",
        isOverall: overrides && overrides.hasOwnProperty('isOverall') ? overrides.isOverall! : true,
        packageId: overrides && overrides.hasOwnProperty('packageId') ? overrides.packageId! : 'basium',
        allPackages: overrides && overrides.hasOwnProperty('allPackages') ? overrides.allPackages! : false,
    };
};

export const anEventLayoutOutput = (overrides?: Partial<EventLayoutOutput>, _relationshipsToOmit: Set<string> = new Set()): EventLayoutOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EventLayoutOutput');
    return {
        defaultDateRange: overrides && overrides.hasOwnProperty('defaultDateRange') ? overrides.defaultDateRange! : relationshipsToOmit.has('DateRange') ? {} as DateRange : aDateRange({}, relationshipsToOmit),
        event: overrides && overrides.hasOwnProperty('event') ? overrides.event! : relationshipsToOmit.has('EventInformation') ? {} as EventInformation : anEventInformation({}, relationshipsToOmit),
    };
};

export const anEventInformation = (overrides?: Partial<EventInformation>, _relationshipsToOmit: Set<string> = new Set()): EventInformation => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EventInformation');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'nesciunt',
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'cupiditate',
        dates: overrides && overrides.hasOwnProperty('dates') ? overrides.dates! : [relationshipsToOmit.has('EventDate') ? {} as EventDate : anEventDate({}, relationshipsToOmit)],
        location: overrides && overrides.hasOwnProperty('location') ? overrides.location! : 'ventito',
        hasEventEnded: overrides && overrides.hasOwnProperty('hasEventEnded') ? overrides.hasEventEnded! : true,
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : true,
        logo: overrides && overrides.hasOwnProperty('logo') ? overrides.logo! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        isSeated: overrides && overrides.hasOwnProperty('isSeated') ? overrides.isSeated! : false,
        hasRegistration: overrides && overrides.hasOwnProperty('hasRegistration') ? overrides.hasRegistration! : false,
        hasOnsaleCompetition: overrides && overrides.hasOwnProperty('hasOnsaleCompetition') ? overrides.hasOnsaleCompetition! : false,
        hasRegistrationCompetition: overrides && overrides.hasOwnProperty('hasRegistrationCompetition') ? overrides.hasRegistrationCompetition! : true,
        hasPresale: overrides && overrides.hasOwnProperty('hasPresale') ? overrides.hasPresale! : false,
        hasPreAuth: overrides && overrides.hasOwnProperty('hasPreAuth') ? overrides.hasPreAuth! : true,
        hasLinkToWaitlistPresale: overrides && overrides.hasOwnProperty('hasLinkToWaitlistPresale') ? overrides.hasLinkToWaitlistPresale! : false,
        hasStartedPresale: overrides && overrides.hasOwnProperty('hasStartedPresale') ? overrides.hasStartedPresale! : false,
        eventDateOptions: overrides && overrides.hasOwnProperty('eventDateOptions') ? overrides.eventDateOptions! : [relationshipsToOmit.has('EventDateOptions') ? {} as EventDateOptions : anEventDateOptions({}, relationshipsToOmit)],
        timezone: overrides && overrides.hasOwnProperty('timezone') ? overrides.timezone! : 'Pacific/Auckland',
        locale: overrides && overrides.hasOwnProperty('locale') ? overrides.locale! : 'en',
        isMultiDayEvent: overrides && overrides.hasOwnProperty('isMultiDayEvent') ? overrides.isMultiDayEvent! : false,
    };
};

export const anEventDateOptions = (overrides?: Partial<EventDateOptions>, _relationshipsToOmit: Set<string> = new Set()): EventDateOptions => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EventDateOptions');
    return {
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'thalassinus',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'commodi',
    };
};

export const aMembershipLayoutOutput = (overrides?: Partial<MembershipLayoutOutput>, _relationshipsToOmit: Set<string> = new Set()): MembershipLayoutOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MembershipLayoutOutput');
    return {
        defaultDateRange: overrides && overrides.hasOwnProperty('defaultDateRange') ? overrides.defaultDateRange! : relationshipsToOmit.has('DateRange') ? {} as DateRange : aDateRange({}, relationshipsToOmit),
        membership: overrides && overrides.hasOwnProperty('membership') ? overrides.membership! : relationshipsToOmit.has('MembershipInformation') ? {} as MembershipInformation : aMembershipInformation({}, relationshipsToOmit),
    };
};

export const aMembershipInformation = (overrides?: Partial<MembershipInformation>, _relationshipsToOmit: Set<string> = new Set()): MembershipInformation => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MembershipInformation');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'amicitia',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'trucido',
        location: overrides && overrides.hasOwnProperty('location') ? overrides.location! : 'casus',
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : 'angulus',
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : 'varietas',
        banner: overrides && overrides.hasOwnProperty('banner') ? overrides.banner! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
    };
};

export const aSeasonLayoutOutput = (overrides?: Partial<SeasonLayoutOutput>, _relationshipsToOmit: Set<string> = new Set()): SeasonLayoutOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SeasonLayoutOutput');
    return {
        defaultDateRange: overrides && overrides.hasOwnProperty('defaultDateRange') ? overrides.defaultDateRange! : relationshipsToOmit.has('DateRange') ? {} as DateRange : aDateRange({}, relationshipsToOmit),
        season: overrides && overrides.hasOwnProperty('season') ? overrides.season! : relationshipsToOmit.has('SeasonInformation') ? {} as SeasonInformation : aSeasonInformation({}, relationshipsToOmit),
    };
};

export const aSeasonInformation = (overrides?: Partial<SeasonInformation>, _relationshipsToOmit: Set<string> = new Set()): SeasonInformation => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SeasonInformation');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'textor',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'soluta',
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : 'venio',
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : 'trado',
        location: overrides && overrides.hasOwnProperty('location') ? overrides.location! : 'cenaculum',
    };
};

export const anOverallLayoutOutput = (overrides?: Partial<OverallLayoutOutput>, _relationshipsToOmit: Set<string> = new Set()): OverallLayoutOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OverallLayoutOutput');
    return {
        defaultDateRange: overrides && overrides.hasOwnProperty('defaultDateRange') ? overrides.defaultDateRange! : relationshipsToOmit.has('DateRange') ? {} as DateRange : aDateRange({}, relationshipsToOmit),
    };
};

export const aPackageLayoutOutput = (overrides?: Partial<PackageLayoutOutput>, _relationshipsToOmit: Set<string> = new Set()): PackageLayoutOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PackageLayoutOutput');
    return {
        defaultDateRange: overrides && overrides.hasOwnProperty('defaultDateRange') ? overrides.defaultDateRange! : relationshipsToOmit.has('DateRange') ? {} as DateRange : aDateRange({}, relationshipsToOmit),
        pointItem: overrides && overrides.hasOwnProperty('pointItem') ? overrides.pointItem! : relationshipsToOmit.has('PackageInformation') ? {} as PackageInformation : aPackageInformation({}, relationshipsToOmit),
    };
};

export const aPackageInformation = (overrides?: Partial<PackageInformation>, _relationshipsToOmit: Set<string> = new Set()): PackageInformation => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PackageInformation');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'contigo',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'caste',
    };
};

export const aReportingOverviewOutput = (overrides?: Partial<ReportingOverviewOutput>, _relationshipsToOmit: Set<string> = new Set()): ReportingOverviewOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ReportingOverviewOutput');
    return {
        ticketSales: overrides && overrides.hasOwnProperty('ticketSales') ? overrides.ticketSales! : [relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit)],
        financial: overrides && overrides.hasOwnProperty('financial') ? overrides.financial! : [relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit)],
        audience: overrides && overrides.hasOwnProperty('audience') ? overrides.audience! : [relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit)],
    };
};

export const aStringStatistic = (overrides?: Partial<StringStatistic>, _relationshipsToOmit: Set<string> = new Set()): StringStatistic => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('StringStatistic');
    return {
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'ceno',
        tooltip: overrides && overrides.hasOwnProperty('tooltip') ? overrides.tooltip! : relationshipsToOmit.has('StatisticTooltip') ? {} as StatisticTooltip : aStatisticTooltip({}, relationshipsToOmit),
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'admoneo',
    };
};

export const aMoneyStatistic = (overrides?: Partial<MoneyStatistic>, _relationshipsToOmit: Set<string> = new Set()): MoneyStatistic => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MoneyStatistic');
    return {
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'carpo',
        tooltip: overrides && overrides.hasOwnProperty('tooltip') ? overrides.tooltip! : relationshipsToOmit.has('StatisticTooltip') ? {} as StatisticTooltip : aStatisticTooltip({}, relationshipsToOmit),
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 4.5,
    };
};

export const aPercentageStatistic = (overrides?: Partial<PercentageStatistic>, _relationshipsToOmit: Set<string> = new Set()): PercentageStatistic => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PercentageStatistic');
    return {
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'vulticulus',
        tooltip: overrides && overrides.hasOwnProperty('tooltip') ? overrides.tooltip! : relationshipsToOmit.has('StatisticTooltip') ? {} as StatisticTooltip : aStatisticTooltip({}, relationshipsToOmit),
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 8.9,
        percentage: overrides && overrides.hasOwnProperty('percentage') ? overrides.percentage! : 4.9,
    };
};

export const aFinancialReportingOverviewOutput = (overrides?: Partial<FinancialReportingOverviewOutput>, _relationshipsToOmit: Set<string> = new Set()): FinancialReportingOverviewOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('FinancialReportingOverviewOutput');
    return {
        financial: overrides && overrides.hasOwnProperty('financial') ? overrides.financial! : [relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit)],
    };
};

export const aReportingSearchIndexOutput = (overrides?: Partial<ReportingSearchIndexOutput>, _relationshipsToOmit: Set<string> = new Set()): ReportingSearchIndexOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ReportingSearchIndexOutput');
    return {
        searchableEvents: overrides && overrides.hasOwnProperty('searchableEvents') ? overrides.searchableEvents! : [relationshipsToOmit.has('SearchEvent') ? {} as SearchEvent : aSearchEvent({}, relationshipsToOmit)],
        searchableSeasons: overrides && overrides.hasOwnProperty('searchableSeasons') ? overrides.searchableSeasons! : [relationshipsToOmit.has('SearchSeason') ? {} as SearchSeason : aSearchSeason({}, relationshipsToOmit)],
        searchableMemberships: overrides && overrides.hasOwnProperty('searchableMemberships') ? overrides.searchableMemberships! : [relationshipsToOmit.has('SearchMembership') ? {} as SearchMembership : aSearchMembership({}, relationshipsToOmit)],
        searchablePackages: overrides && overrides.hasOwnProperty('searchablePackages') ? overrides.searchablePackages! : [relationshipsToOmit.has('SearchPackage') ? {} as SearchPackage : aSearchPackage({}, relationshipsToOmit)],
    };
};

export const aSearchEventFilter = (overrides?: Partial<SearchEventFilter>, _relationshipsToOmit: Set<string> = new Set()): SearchEventFilter => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SearchEventFilter');
    return {
        hasRegistrationEnabled: overrides && overrides.hasOwnProperty('hasRegistrationEnabled') ? overrides.hasRegistrationEnabled! : false,
        activeEventsOnly: overrides && overrides.hasOwnProperty('activeEventsOnly') ? overrides.activeEventsOnly! : false,
    };
};

export const aSearchEvent = (overrides?: Partial<SearchEvent>, _relationshipsToOmit: Set<string> = new Set()): SearchEvent => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SearchEvent');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'delego',
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'pauci',
        dates: overrides && overrides.hasOwnProperty('dates') ? overrides.dates! : [relationshipsToOmit.has('EventDate') ? {} as EventDate : anEventDate({}, relationshipsToOmit)],
    };
};

export const aSearchSeason = (overrides?: Partial<SearchSeason>, _relationshipsToOmit: Set<string> = new Set()): SearchSeason => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SearchSeason');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'cognatus',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'ultra',
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2025-10-29T11:41:46.451Z",
    };
};

export const aSearchMembership = (overrides?: Partial<SearchMembership>, _relationshipsToOmit: Set<string> = new Set()): SearchMembership => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SearchMembership');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'centum',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'creber',
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2025-09-27T08:31:32.955Z",
    };
};

export const aSearchPackage = (overrides?: Partial<SearchPackage>, _relationshipsToOmit: Set<string> = new Set()): SearchPackage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SearchPackage');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'degusto',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'sequi',
    };
};

export const aCustomerReportingOverviewArgs = (overrides?: Partial<CustomerReportingOverviewArgs>, _relationshipsToOmit: Set<string> = new Set()): CustomerReportingOverviewArgs => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CustomerReportingOverviewArgs');
    return {
        resold: overrides && overrides.hasOwnProperty('resold') ? overrides.resold! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        abandonCart: overrides && overrides.hasOwnProperty('abandonCart') ? overrides.abandonCart! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        abandonCartRecovered: overrides && overrides.hasOwnProperty('abandonCartRecovered') ? overrides.abandonCartRecovered! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        addons: overrides && overrides.hasOwnProperty('addons') ? overrides.addons! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        resaleMargin: overrides && overrides.hasOwnProperty('resaleMargin') ? overrides.resaleMargin! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        resaleFeeRevenue: overrides && overrides.hasOwnProperty('resaleFeeRevenue') ? overrides.resaleFeeRevenue! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        bookingFeeRevenue: overrides && overrides.hasOwnProperty('bookingFeeRevenue') ? overrides.bookingFeeRevenue! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        refund: overrides && overrides.hasOwnProperty('refund') ? overrides.refund! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        ordersPartPaid: overrides && overrides.hasOwnProperty('ordersPartPaid') ? overrides.ordersPartPaid! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        ticketsPartPaid: overrides && overrides.hasOwnProperty('ticketsPartPaid') ? overrides.ticketsPartPaid! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        addonsRevenue: overrides && overrides.hasOwnProperty('addonsRevenue') ? overrides.addonsRevenue! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        totalTicketsScanned: overrides && overrides.hasOwnProperty('totalTicketsScanned') ? overrides.totalTicketsScanned! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        conversionRate: overrides && overrides.hasOwnProperty('conversionRate') ? overrides.conversionRate! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        newCustomers: overrides && overrides.hasOwnProperty('newCustomers') ? overrides.newCustomers! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        marketableAudience: overrides && overrides.hasOwnProperty('marketableAudience') ? overrides.marketableAudience! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        averageLTV: overrides && overrides.hasOwnProperty('averageLTV') ? overrides.averageLTV! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        eventVisitors: overrides && overrides.hasOwnProperty('eventVisitors') ? overrides.eventVisitors! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        totalCustomers: overrides && overrides.hasOwnProperty('totalCustomers') ? overrides.totalCustomers! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        repeatPurchasers: overrides && overrides.hasOwnProperty('repeatPurchasers') ? overrides.repeatPurchasers! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        returningCustomers: overrides && overrides.hasOwnProperty('returningCustomers') ? overrides.returningCustomers! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        essentialEmailsSent: overrides && overrides.hasOwnProperty('essentialEmailsSent') ? overrides.essentialEmailsSent! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        essentialEmailsSentRate: overrides && overrides.hasOwnProperty('essentialEmailsSentRate') ? overrides.essentialEmailsSentRate! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        totalRegistrations: overrides && overrides.hasOwnProperty('totalRegistrations') ? overrides.totalRegistrations! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        newCustomerRegistrations: overrides && overrides.hasOwnProperty('newCustomerRegistrations') ? overrides.newCustomerRegistrations! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        registrationRevenue: overrides && overrides.hasOwnProperty('registrationRevenue') ? overrides.registrationRevenue! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        registrationsNotConverted: overrides && overrides.hasOwnProperty('registrationsNotConverted') ? overrides.registrationsNotConverted! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        registrationCompetitionTotalRegistrations: overrides && overrides.hasOwnProperty('registrationCompetitionTotalRegistrations') ? overrides.registrationCompetitionTotalRegistrations! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        registrationCompetitionEventDetailsPageViews: overrides && overrides.hasOwnProperty('registrationCompetitionEventDetailsPageViews') ? overrides.registrationCompetitionEventDetailsPageViews! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        registrationCompetitionEventPageConversionRate: overrides && overrides.hasOwnProperty('registrationCompetitionEventPageConversionRate') ? overrides.registrationCompetitionEventPageConversionRate! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        registrationCompetitionRegistrationPageViews: overrides && overrides.hasOwnProperty('registrationCompetitionRegistrationPageViews') ? overrides.registrationCompetitionRegistrationPageViews! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        registrationCompetitionRegistrationPageConversionRate: overrides && overrides.hasOwnProperty('registrationCompetitionRegistrationPageConversionRate') ? overrides.registrationCompetitionRegistrationPageConversionRate! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        registrationCompetitionNewCustomers: overrides && overrides.hasOwnProperty('registrationCompetitionNewCustomers') ? overrides.registrationCompetitionNewCustomers! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        registrationCompetitionTotalEntries: overrides && overrides.hasOwnProperty('registrationCompetitionTotalEntries') ? overrides.registrationCompetitionTotalEntries! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        posSaleOverview: overrides && overrides.hasOwnProperty('posSaleOverview') ? overrides.posSaleOverview! : relationshipsToOmit.has('PosSaleOverview') ? {} as PosSaleOverview : aPosSaleOverview({}, relationshipsToOmit),
        posFinancialData: overrides && overrides.hasOwnProperty('posFinancialData') ? overrides.posFinancialData! : relationshipsToOmit.has('PosFinancialData') ? {} as PosFinancialData : aPosFinancialData({}, relationshipsToOmit),
        posFloatData: overrides && overrides.hasOwnProperty('posFloatData') ? overrides.posFloatData! : relationshipsToOmit.has('PosFloatData') ? {} as PosFloatData : aPosFloatData({}, relationshipsToOmit),
        onsaleCompetitionTotalRevenue: overrides && overrides.hasOwnProperty('onsaleCompetitionTotalRevenue') ? overrides.onsaleCompetitionTotalRevenue! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        onsaleCompetitionTotalCompetitionEntries: overrides && overrides.hasOwnProperty('onsaleCompetitionTotalCompetitionEntries') ? overrides.onsaleCompetitionTotalCompetitionEntries! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        onsaleCompetitionEventPageViews: overrides && overrides.hasOwnProperty('onsaleCompetitionEventPageViews') ? overrides.onsaleCompetitionEventPageViews! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        onsaleCompetitionEventPageConversionRate: overrides && overrides.hasOwnProperty('onsaleCompetitionEventPageConversionRate') ? overrides.onsaleCompetitionEventPageConversionRate! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        onsaleCompetitionTotalOrders: overrides && overrides.hasOwnProperty('onsaleCompetitionTotalOrders') ? overrides.onsaleCompetitionTotalOrders! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        onsaleCompetitionTicketsSold: overrides && overrides.hasOwnProperty('onsaleCompetitionTicketsSold') ? overrides.onsaleCompetitionTicketsSold! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        onsaleCompetitionNewCustomers: overrides && overrides.hasOwnProperty('onsaleCompetitionNewCustomers') ? overrides.onsaleCompetitionNewCustomers! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        registrationPromoterRegistrationsViaReferral: overrides && overrides.hasOwnProperty('registrationPromoterRegistrationsViaReferral') ? overrides.registrationPromoterRegistrationsViaReferral! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        registrationPromoterNewCustomers: overrides && overrides.hasOwnProperty('registrationPromoterNewCustomers') ? overrides.registrationPromoterNewCustomers! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        registrationPromoterReferralEntriesAwarded: overrides && overrides.hasOwnProperty('registrationPromoterReferralEntriesAwarded') ? overrides.registrationPromoterReferralEntriesAwarded! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        totalTicketsIssued: overrides && overrides.hasOwnProperty('totalTicketsIssued') ? overrides.totalTicketsIssued! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        totalTicketsSold: overrides && overrides.hasOwnProperty('totalTicketsSold') ? overrides.totalTicketsSold! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        totalCompsIssued: overrides && overrides.hasOwnProperty('totalCompsIssued') ? overrides.totalCompsIssued! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        totalOrders: overrides && overrides.hasOwnProperty('totalOrders') ? overrides.totalOrders! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        membershipsRenewed: overrides && overrides.hasOwnProperty('membershipsRenewed') ? overrides.membershipsRenewed! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        membershipSales: overrides && overrides.hasOwnProperty('membershipSales') ? overrides.membershipSales! : relationshipsToOmit.has('MembershipSales') ? {} as MembershipSales : aMembershipSales({}, relationshipsToOmit),
        membershipFinancial: overrides && overrides.hasOwnProperty('membershipFinancial') ? overrides.membershipFinancial! : relationshipsToOmit.has('MembershipFinancial') ? {} as MembershipFinancial : aMembershipFinancial({}, relationshipsToOmit),
        onsalePromoter: overrides && overrides.hasOwnProperty('onsalePromoter') ? overrides.onsalePromoter! : relationshipsToOmit.has('OnsalePromoter') ? {} as OnsalePromoter : anOnsalePromoter({}, relationshipsToOmit),
        faceValueTotal: overrides && overrides.hasOwnProperty('faceValueTotal') ? overrides.faceValueTotal! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        netSale: overrides && overrides.hasOwnProperty('netSale') ? overrides.netSale! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        averageOrderAmount: overrides && overrides.hasOwnProperty('averageOrderAmount') ? overrides.averageOrderAmount! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        overallPartPaidTicketRevenue: overrides && overrides.hasOwnProperty('overallPartPaidTicketRevenue') ? overrides.overallPartPaidTicketRevenue! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        membershipsIssued: overrides && overrides.hasOwnProperty('membershipsIssued') ? overrides.membershipsIssued! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        membershipsSold: overrides && overrides.hasOwnProperty('membershipsSold') ? overrides.membershipsSold! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        membershipsComp: overrides && overrides.hasOwnProperty('membershipsComp') ? overrides.membershipsComp! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        ticketsRefund: overrides && overrides.hasOwnProperty('ticketsRefund') ? overrides.ticketsRefund! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        membershipsRefund: overrides && overrides.hasOwnProperty('membershipsRefund') ? overrides.membershipsRefund! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        overallTicketsPartPaid: overrides && overrides.hasOwnProperty('overallTicketsPartPaid') ? overrides.overallTicketsPartPaid! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        overallMembershipsPartPaid: overrides && overrides.hasOwnProperty('overallMembershipsPartPaid') ? overrides.overallMembershipsPartPaid! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        faceValueWithBookingFeeTotal: overrides && overrides.hasOwnProperty('faceValueWithBookingFeeTotal') ? overrides.faceValueWithBookingFeeTotal! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        discounts: overrides && overrides.hasOwnProperty('discounts') ? overrides.discounts! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        ticketCoverOrdersSold: overrides && overrides.hasOwnProperty('ticketCoverOrdersSold') ? overrides.ticketCoverOrdersSold! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        ticketCoverOrderTotal: overrides && overrides.hasOwnProperty('ticketCoverOrderTotal') ? overrides.ticketCoverOrderTotal! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        ticketProtectionRevenue: overrides && overrides.hasOwnProperty('ticketProtectionRevenue') ? overrides.ticketProtectionRevenue! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        ticketProtectionCost: overrides && overrides.hasOwnProperty('ticketProtectionCost') ? overrides.ticketProtectionCost! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        ticketProtectionMargin: overrides && overrides.hasOwnProperty('ticketProtectionMargin') ? overrides.ticketProtectionMargin! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        averageOrderSize: overrides && overrides.hasOwnProperty('averageOrderSize') ? overrides.averageOrderSize! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        overallAverageTicketPrice: overrides && overrides.hasOwnProperty('overallAverageTicketPrice') ? overrides.overallAverageTicketPrice! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        overallAverageMembershipPrice: overrides && overrides.hasOwnProperty('overallAverageMembershipPrice') ? overrides.overallAverageMembershipPrice! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        overallPartPaidMembershipRevenue: overrides && overrides.hasOwnProperty('overallPartPaidMembershipRevenue') ? overrides.overallPartPaidMembershipRevenue! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        paymentPlanTotalRevDue: overrides && overrides.hasOwnProperty('paymentPlanTotalRevDue') ? overrides.paymentPlanTotalRevDue! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        points: overrides && overrides.hasOwnProperty('points') ? overrides.points! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        credits: overrides && overrides.hasOwnProperty('credits') ? overrides.credits! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        packagesSold: overrides && overrides.hasOwnProperty('packagesSold') ? overrides.packagesSold! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        pointsDistributed: overrides && overrides.hasOwnProperty('pointsDistributed') ? overrides.pointsDistributed! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        presaleEventDetailsPageViews: overrides && overrides.hasOwnProperty('presaleEventDetailsPageViews') ? overrides.presaleEventDetailsPageViews! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        presalePreAuthorizationFaceValue: overrides && overrides.hasOwnProperty('presalePreAuthorizationFaceValue') ? overrides.presalePreAuthorizationFaceValue! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        presalePreAuthorizationConversionRate: overrides && overrides.hasOwnProperty('presalePreAuthorizationConversionRate') ? overrides.presalePreAuthorizationConversionRate! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        presalePreAuthorizationOrderCount: overrides && overrides.hasOwnProperty('presalePreAuthorizationOrderCount') ? overrides.presalePreAuthorizationOrderCount! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        presaleEventPageConversionRate: overrides && overrides.hasOwnProperty('presaleEventPageConversionRate') ? overrides.presaleEventPageConversionRate! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        preAuthTicketsAndTotalAdmissionTickets: overrides && overrides.hasOwnProperty('preAuthTicketsAndTotalAdmissionTickets') ? overrides.preAuthTicketsAndTotalAdmissionTickets! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        completedPreAuthAndPresaleOrders: overrides && overrides.hasOwnProperty('completedPreAuthAndPresaleOrders') ? overrides.completedPreAuthAndPresaleOrders! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        totalTicketsScannedOut: overrides && overrides.hasOwnProperty('totalTicketsScannedOut') ? overrides.totalTicketsScannedOut! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
    };
};

export const aPosSaleOverview = (overrides?: Partial<PosSaleOverview>, _relationshipsToOmit: Set<string> = new Set()): PosSaleOverview => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PosSaleOverview');
    return {
        ticketSoldAtDoor: overrides && overrides.hasOwnProperty('ticketSoldAtDoor') ? overrides.ticketSoldAtDoor! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        posOrders: overrides && overrides.hasOwnProperty('posOrders') ? overrides.posOrders! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        averageOrderSize: overrides && overrides.hasOwnProperty('averageOrderSize') ? overrides.averageOrderSize! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        ticketPerHour: overrides && overrides.hasOwnProperty('ticketPerHour') ? overrides.ticketPerHour! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
    };
};

export const aPosFinancialData = (overrides?: Partial<PosFinancialData>, _relationshipsToOmit: Set<string> = new Set()): PosFinancialData => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PosFinancialData');
    return {
        grossSales: overrides && overrides.hasOwnProperty('grossSales') ? overrides.grossSales! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        eftpos: overrides && overrides.hasOwnProperty('eftpos') ? overrides.eftpos! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        cash: overrides && overrides.hasOwnProperty('cash') ? overrides.cash! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        creditCard: overrides && overrides.hasOwnProperty('creditCard') ? overrides.creditCard! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
    };
};

export const aPosFloatData = (overrides?: Partial<PosFloatData>, _relationshipsToOmit: Set<string> = new Set()): PosFloatData => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PosFloatData');
    return {
        startFloat: overrides && overrides.hasOwnProperty('startFloat') ? overrides.startFloat! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        cashReceived: overrides && overrides.hasOwnProperty('cashReceived') ? overrides.cashReceived! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        cashReturned: overrides && overrides.hasOwnProperty('cashReturned') ? overrides.cashReturned! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        endFloat: overrides && overrides.hasOwnProperty('endFloat') ? overrides.endFloat! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
    };
};

export const aMembershipSales = (overrides?: Partial<MembershipSales>, _relationshipsToOmit: Set<string> = new Set()): MembershipSales => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MembershipSales');
    return {
        membershipsIssued: overrides && overrides.hasOwnProperty('membershipsIssued') ? overrides.membershipsIssued! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        membershipsRenewed: overrides && overrides.hasOwnProperty('membershipsRenewed') ? overrides.membershipsRenewed! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        membershipsSold: overrides && overrides.hasOwnProperty('membershipsSold') ? overrides.membershipsSold! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
    };
};

export const aMembershipFinancial = (overrides?: Partial<MembershipFinancial>, _relationshipsToOmit: Set<string> = new Set()): MembershipFinancial => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MembershipFinancial');
    return {
        discounts: overrides && overrides.hasOwnProperty('discounts') ? overrides.discounts! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        avgOrderItemsCount: overrides && overrides.hasOwnProperty('avgOrderItemsCount') ? overrides.avgOrderItemsCount! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        netSales: overrides && overrides.hasOwnProperty('netSales') ? overrides.netSales! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        averageOrderAmount: overrides && overrides.hasOwnProperty('averageOrderAmount') ? overrides.averageOrderAmount! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        partPaidRevenue: overrides && overrides.hasOwnProperty('partPaidRevenue') ? overrides.partPaidRevenue! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        planTotalOutstanding: overrides && overrides.hasOwnProperty('planTotalOutstanding') ? overrides.planTotalOutstanding! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
    };
};

export const anOnsalePromoter = (overrides?: Partial<OnsalePromoter>, _relationshipsToOmit: Set<string> = new Set()): OnsalePromoter => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OnsalePromoter');
    return {
        onsalePromoterCompetition: overrides && overrides.hasOwnProperty('onsalePromoterCompetition') ? overrides.onsalePromoterCompetition! : relationshipsToOmit.has('OnsalePromoterCompetition') ? {} as OnsalePromoterCompetition : anOnsalePromoterCompetition({}, relationshipsToOmit),
        onsalePromoterOutsideCompetition: overrides && overrides.hasOwnProperty('onsalePromoterOutsideCompetition') ? overrides.onsalePromoterOutsideCompetition! : relationshipsToOmit.has('OnsalePromoterOutsideCompetition') ? {} as OnsalePromoterOutsideCompetition : anOnsalePromoterOutsideCompetition({}, relationshipsToOmit),
    };
};

export const anOnsalePromoterCompetition = (overrides?: Partial<OnsalePromoterCompetition>, _relationshipsToOmit: Set<string> = new Set()): OnsalePromoterCompetition => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OnsalePromoterCompetition');
    return {
        onsalePromoterRevenueViaReferral: overrides && overrides.hasOwnProperty('onsalePromoterRevenueViaReferral') ? overrides.onsalePromoterRevenueViaReferral! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        onsalePromoterOrdersViaReferral: overrides && overrides.hasOwnProperty('onsalePromoterOrdersViaReferral') ? overrides.onsalePromoterOrdersViaReferral! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        onsalePromoterNewCustomersReferred: overrides && overrides.hasOwnProperty('onsalePromoterNewCustomersReferred') ? overrides.onsalePromoterNewCustomersReferred! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        onsalePromoterReferrerEntriesAwarded: overrides && overrides.hasOwnProperty('onsalePromoterReferrerEntriesAwarded') ? overrides.onsalePromoterReferrerEntriesAwarded! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
    };
};

export const anOnsalePromoterOutsideCompetition = (overrides?: Partial<OnsalePromoterOutsideCompetition>, _relationshipsToOmit: Set<string> = new Set()): OnsalePromoterOutsideCompetition => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OnsalePromoterOutsideCompetition');
    return {
        onsalePromoterOutsideRevenueViaReferral: overrides && overrides.hasOwnProperty('onsalePromoterOutsideRevenueViaReferral') ? overrides.onsalePromoterOutsideRevenueViaReferral! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        onsalePromoterOutsideOrdersViaReferral: overrides && overrides.hasOwnProperty('onsalePromoterOutsideOrdersViaReferral') ? overrides.onsalePromoterOutsideOrdersViaReferral! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        onsalePromoterOutsideNewCustomersReferred: overrides && overrides.hasOwnProperty('onsalePromoterOutsideNewCustomersReferred') ? overrides.onsalePromoterOutsideNewCustomersReferred! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        onsalePromoterOutsideReferrerPointsAwarded: overrides && overrides.hasOwnProperty('onsalePromoterOutsideReferrerPointsAwarded') ? overrides.onsalePromoterOutsideReferrerPointsAwarded! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
        onsalePromoterOutsideDiscountValue: overrides && overrides.hasOwnProperty('onsalePromoterOutsideDiscountValue') ? overrides.onsalePromoterOutsideDiscountValue! : relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit),
    };
};

export const aPeReportOverviewOutput = (overrides?: Partial<PeReportOverviewOutput>, _relationshipsToOmit: Set<string> = new Set()): PeReportOverviewOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PeReportOverviewOutput');
    return {
        event: overrides && overrides.hasOwnProperty('event') ? overrides.event! : relationshipsToOmit.has('PeReportEvent') ? {} as PeReportEvent : aPeReportEvent({}, relationshipsToOmit),
        financialSales: overrides && overrides.hasOwnProperty('financialSales') ? overrides.financialSales! : [relationshipsToOmit.has('FinancialSales') ? {} as FinancialSales : aFinancialSales({}, relationshipsToOmit)],
        statistics: overrides && overrides.hasOwnProperty('statistics') ? overrides.statistics! : [relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit)],
        ticketSalesStatistics: overrides && overrides.hasOwnProperty('ticketSalesStatistics') ? overrides.ticketSalesStatistics! : [relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit)],
        salesBreakdown: overrides && overrides.hasOwnProperty('salesBreakdown') ? overrides.salesBreakdown! : relationshipsToOmit.has('SalesBreakdown') ? {} as SalesBreakdown : aSalesBreakdown({}, relationshipsToOmit),
    };
};

export const aPeReportEvent = (overrides?: Partial<PeReportEvent>, _relationshipsToOmit: Set<string> = new Set()): PeReportEvent => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PeReportEvent');
    return {
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'absum',
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2025-11-12T15:42:45.933Z",
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : "2026-01-11T20:22:41.287Z",
        location: overrides && overrides.hasOwnProperty('location') ? overrides.location! : 'curatio',
    };
};

export const aPeReportAudienceOutput = (overrides?: Partial<PeReportAudienceOutput>, _relationshipsToOmit: Set<string> = new Set()): PeReportAudienceOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PeReportAudienceOutput');
    return {
        insights: overrides && overrides.hasOwnProperty('insights') ? overrides.insights! : [relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit)],
        trafficChannels: overrides && overrides.hasOwnProperty('trafficChannels') ? overrides.trafficChannels! : [relationshipsToOmit.has('PercentageStatistic') ? {} as PercentageStatistic : aPercentageStatistic({}, relationshipsToOmit)],
    };
};

export const aPeReportWaitlistOutput = (overrides?: Partial<PeReportWaitlistOutput>, _relationshipsToOmit: Set<string> = new Set()): PeReportWaitlistOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PeReportWaitlistOutput');
    return {
        statistics: overrides && overrides.hasOwnProperty('statistics') ? overrides.statistics! : [relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit)],
    };
};

export const aPeReportRegistrationOutput = (overrides?: Partial<PeReportRegistrationOutput>, _relationshipsToOmit: Set<string> = new Set()): PeReportRegistrationOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PeReportRegistrationOutput');
    return {
        overview: overrides && overrides.hasOwnProperty('overview') ? overrides.overview! : [relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit)],
        promoter: overrides && overrides.hasOwnProperty('promoter') ? overrides.promoter! : [relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit)],
        actionEngagement: overrides && overrides.hasOwnProperty('actionEngagement') ? overrides.actionEngagement! : [relationshipsToOmit.has('ActionEngagementRecordOutput') ? {} as ActionEngagementRecordOutput : anActionEngagementRecordOutput({}, relationshipsToOmit)],
    };
};

export const aPeReportRegistrationCompetitionOutput = (overrides?: Partial<PeReportRegistrationCompetitionOutput>, _relationshipsToOmit: Set<string> = new Set()): PeReportRegistrationCompetitionOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PeReportRegistrationCompetitionOutput');
    return {
        overview: overrides && overrides.hasOwnProperty('overview') ? overrides.overview! : [relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit)],
        promoter: overrides && overrides.hasOwnProperty('promoter') ? overrides.promoter! : [relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit)],
        actionEngagement: overrides && overrides.hasOwnProperty('actionEngagement') ? overrides.actionEngagement! : [relationshipsToOmit.has('ActionEngagementRecordOutput') ? {} as ActionEngagementRecordOutput : anActionEngagementRecordOutput({}, relationshipsToOmit)],
        hasCompetition: overrides && overrides.hasOwnProperty('hasCompetition') ? overrides.hasCompetition! : false,
    };
};

export const aPeReportReferralOutsideMainSaleOutput = (overrides?: Partial<PeReportReferralOutsideMainSaleOutput>, _relationshipsToOmit: Set<string> = new Set()): PeReportReferralOutsideMainSaleOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PeReportReferralOutsideMainSaleOutput');
    return {
        promoter: overrides && overrides.hasOwnProperty('promoter') ? overrides.promoter! : [relationshipsToOmit.has('NumberStatistic') ? {} as NumberStatistic : aNumberStatistic({}, relationshipsToOmit)],
        actionEngagement: overrides && overrides.hasOwnProperty('actionEngagement') ? overrides.actionEngagement! : [relationshipsToOmit.has('ActionEngagementRecordOutput') ? {} as ActionEngagementRecordOutput : anActionEngagementRecordOutput({}, relationshipsToOmit)],
    };
};

export const aPeReportDemographicsOutput = (overrides?: Partial<PeReportDemographicsOutput>, _relationshipsToOmit: Set<string> = new Set()): PeReportDemographicsOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PeReportDemographicsOutput');
    return {
        ticketsSold: overrides && overrides.hasOwnProperty('ticketsSold') ? overrides.ticketsSold! : [relationshipsToOmit.has('PercentageStatistic') ? {} as PercentageStatistic : aPercentageStatistic({}, relationshipsToOmit)],
        audienceViews: overrides && overrides.hasOwnProperty('audienceViews') ? overrides.audienceViews! : [relationshipsToOmit.has('PercentageStatistic') ? {} as PercentageStatistic : aPercentageStatistic({}, relationshipsToOmit)],
        gender: overrides && overrides.hasOwnProperty('gender') ? overrides.gender! : relationshipsToOmit.has('GenderBreakDownOutput') ? {} as GenderBreakDownOutput : aGenderBreakDownOutput({}, relationshipsToOmit),
        age: overrides && overrides.hasOwnProperty('age') ? overrides.age! : relationshipsToOmit.has('AgeBreakDownOutput') ? {} as AgeBreakDownOutput : anAgeBreakDownOutput({}, relationshipsToOmit),
    };
};

export const aDefaultDates = (overrides?: Partial<DefaultDates>, _relationshipsToOmit: Set<string> = new Set()): DefaultDates => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DefaultDates');
    return {
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2025-07-16T01:21:52.905Z",
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : "2026-02-09T01:30:09.547Z",
    };
};

export const aRedirectCodeInput = (overrides?: Partial<RedirectCodeInput>, _relationshipsToOmit: Set<string> = new Set()): RedirectCodeInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RedirectCodeInput');
    return {
        redirectCode: overrides && overrides.hasOwnProperty('redirectCode') ? overrides.redirectCode! : 'caelum',
    };
};

export const aRedirectUrl = (overrides?: Partial<RedirectUrl>, _relationshipsToOmit: Set<string> = new Set()): RedirectUrl => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RedirectUrl');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'cecdc1d9-261c-4b28-b4c3-d99612ab4b4f',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-04-06T16:24:28.861Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-06-20T14:47:43.795Z",
        refName: overrides && overrides.hasOwnProperty('refName') ? overrides.refName! : 'curo',
        refId: overrides && overrides.hasOwnProperty('refId') ? overrides.refId! : 'corporis',
        shortenedSlug: overrides && overrides.hasOwnProperty('shortenedSlug') ? overrides.shortenedSlug! : 'ullam',
        redirectURL: overrides && overrides.hasOwnProperty('redirectURL') ? overrides.redirectURL! : 'causa',
        timesUsed: overrides && overrides.hasOwnProperty('timesUsed') ? overrides.timesUsed! : 9.4,
    };
};

export const aValidateAccessCodeForMembershipInput = (overrides?: Partial<ValidateAccessCodeForMembershipInput>, _relationshipsToOmit: Set<string> = new Set()): ValidateAccessCodeForMembershipInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ValidateAccessCodeForMembershipInput');
    return {
        code: overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'caste',
        membershipId: overrides && overrides.hasOwnProperty('membershipId') ? overrides.membershipId! : '62964c4b-caea-49cf-bf5e-22439cfaec5c',
    };
};

export const aShortUrl = (overrides?: Partial<ShortUrl>, _relationshipsToOmit: Set<string> = new Set()): ShortUrl => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ShortUrl');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '9f23a564-d5ad-4167-9169-6ad2410eadd6',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-04-07T14:27:11.015Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-09-16T04:05:00.460Z",
        sequenceId: overrides && overrides.hasOwnProperty('sequenceId') ? overrides.sequenceId! : 5.8,
        originalUrl: overrides && overrides.hasOwnProperty('originalUrl') ? overrides.originalUrl! : 'triduana',
        timesUsed: overrides && overrides.hasOwnProperty('timesUsed') ? overrides.timesUsed! : 9.8,
        publicShortUrl: overrides && overrides.hasOwnProperty('publicShortUrl') ? overrides.publicShortUrl! : 'aliqua',
    };
};

export const aWaitlistUser = (overrides?: Partial<WaitlistUser>, _relationshipsToOmit: Set<string> = new Set()): WaitlistUser => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('WaitlistUser');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '6cba3efc-d49b-4593-8b4b-7ddeea2970a6',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-10-31T17:20:51.069Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-06-15T10:23:10.431Z",
        organization: overrides && overrides.hasOwnProperty('organization') ? overrides.organization! : relationshipsToOmit.has('Organization') ? {} as Organization : anOrganization({}, relationshipsToOmit),
        event: overrides && overrides.hasOwnProperty('event') ? overrides.event! : relationshipsToOmit.has('Event') ? {} as Event : anEvent({}, relationshipsToOmit),
        release: overrides && overrides.hasOwnProperty('release') ? overrides.release! : relationshipsToOmit.has('Release') ? {} as Release : aRelease({}, relationshipsToOmit),
        referralCode: overrides && overrides.hasOwnProperty('referralCode') ? overrides.referralCode! : relationshipsToOmit.has('ReferralCode') ? {} as ReferralCode : aReferralCode({}, relationshipsToOmit),
        user: overrides && overrides.hasOwnProperty('user') ? overrides.user! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        firstName: overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'rerum',
        lastName: overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'cur',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'adfero',
        phoneNumber: overrides && overrides.hasOwnProperty('phoneNumber') ? overrides.phoneNumber! : 'consectetur',
        usableForMarketing: overrides && overrides.hasOwnProperty('usableForMarketing') ? overrides.usableForMarketing! : true,
        fullName: overrides && overrides.hasOwnProperty('fullName') ? overrides.fullName! : 'conqueror',
    };
};

export const aResaleTicketMetrics = (overrides?: Partial<ResaleTicketMetrics>, _relationshipsToOmit: Set<string> = new Set()): ResaleTicketMetrics => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ResaleTicketMetrics');
    return {
        ticketTypeId: overrides && overrides.hasOwnProperty('ticketTypeId') ? overrides.ticketTypeId! : 'vir',
        numInterestedFans: overrides && overrides.hasOwnProperty('numInterestedFans') ? overrides.numInterestedFans! : 9.7,
        soldRevenue: overrides && overrides.hasOwnProperty('soldRevenue') ? overrides.soldRevenue! : 1.7,
        fansWouldPay: overrides && overrides.hasOwnProperty('fansWouldPay') ? overrides.fansWouldPay! : relationshipsToOmit.has('FansWouldPay') ? {} as FansWouldPay : aFansWouldPay({}, relationshipsToOmit),
        numCurrentlyOnSale: overrides && overrides.hasOwnProperty('numCurrentlyOnSale') ? overrides.numCurrentlyOnSale! : 3.2,
        numSold: overrides && overrides.hasOwnProperty('numSold') ? overrides.numSold! : 5.1,
    };
};

export const aFansWouldPay = (overrides?: Partial<FansWouldPay>, _relationshipsToOmit: Set<string> = new Set()): FansWouldPay => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('FansWouldPay');
    return {
        mean: overrides && overrides.hasOwnProperty('mean') ? overrides.mean! : 4.4,
        median: overrides && overrides.hasOwnProperty('median') ? overrides.median! : 9.3,
    };
};

export const aResaleWaitlistCount = (overrides?: Partial<ResaleWaitlistCount>, _relationshipsToOmit: Set<string> = new Set()): ResaleWaitlistCount => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ResaleWaitlistCount');
    return {
        numWaitlisted: overrides && overrides.hasOwnProperty('numWaitlisted') ? overrides.numWaitlisted! : 5.2,
    };
};

export const aMinTicketTypePricesForEventOutput = (overrides?: Partial<MinTicketTypePricesForEventOutput>, _relationshipsToOmit: Set<string> = new Set()): MinTicketTypePricesForEventOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MinTicketTypePricesForEventOutput');
    return {
        ticketTypeId: overrides && overrides.hasOwnProperty('ticketTypeId') ? overrides.ticketTypeId! : 'cruciamentum',
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 9.9,
    };
};

export const aBroadcastListOutput = (overrides?: Partial<BroadcastListOutput>, _relationshipsToOmit: Set<string> = new Set()): BroadcastListOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BroadcastListOutput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'a2bbb892-659a-4b0a-bf9b-3c4356194fc8',
        scheduledAt: overrides && overrides.hasOwnProperty('scheduledAt') ? overrides.scheduledAt! : "2025-09-06T01:26:41.128Z",
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : BroadcastStatus.Scheduled,
        count: overrides && overrides.hasOwnProperty('count') ? overrides.count! : 8.2,
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : BroadcastType.Marketing,
        subjectRich: overrides && overrides.hasOwnProperty('subjectRich') ? overrides.subjectRich! : 'aer',
        lastEditedByFullName: overrides && overrides.hasOwnProperty('lastEditedByFullName') ? overrides.lastEditedByFullName! : 'exercitationem',
        targetLabel: overrides && overrides.hasOwnProperty('targetLabel') ? overrides.targetLabel! : 'temperantia',
        subjectDisplay: overrides && overrides.hasOwnProperty('subjectDisplay') ? overrides.subjectDisplay! : 'alias',
    };
};

export const aBroadcastOutput = (overrides?: Partial<BroadcastOutput>, _relationshipsToOmit: Set<string> = new Set()): BroadcastOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BroadcastOutput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '8a701096-d723-451b-b4f5-a9626788d3d2',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-06-18T00:56:19.677Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2026-02-12T09:02:29.024Z",
        fromName: overrides && overrides.hasOwnProperty('fromName') ? overrides.fromName! : 'thesis',
        fromLocalPart: overrides && overrides.hasOwnProperty('fromLocalPart') ? overrides.fromLocalPart! : 'sub',
        fromDomainId: overrides && overrides.hasOwnProperty('fromDomainId') ? overrides.fromDomainId! : 'censura',
        fromDomainName: overrides && overrides.hasOwnProperty('fromDomainName') ? overrides.fromDomainName! : 'terebro',
        audienceType: overrides && overrides.hasOwnProperty('audienceType') ? overrides.audienceType! : BroadcastAudience.TicketBuyers,
        message: overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'ubi',
        event: overrides && overrides.hasOwnProperty('event') ? overrides.event! : relationshipsToOmit.has('Event') ? {} as Event : anEvent({}, relationshipsToOmit),
        membership: overrides && overrides.hasOwnProperty('membership') ? overrides.membership! : relationshipsToOmit.has('Membership') ? {} as Membership : aMembership({}, relationshipsToOmit),
        package: overrides && overrides.hasOwnProperty('package') ? overrides.package! : relationshipsToOmit.has('PointItem') ? {} as PointItem : aPointItem({}, relationshipsToOmit),
        scheduledAt: overrides && overrides.hasOwnProperty('scheduledAt') ? overrides.scheduledAt! : "2025-09-04T17:16:51.157Z",
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : BroadcastStatus.Scheduled,
        errors: overrides && overrides.hasOwnProperty('errors') ? overrides.errors! : 'sollicito',
        count: overrides && overrides.hasOwnProperty('count') ? overrides.count! : 2.8,
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : relationshipsToOmit.has('TagEntityIds') ? {} as TagEntityIds : aTagEntityIds({}, relationshipsToOmit),
        audienceData: overrides && overrides.hasOwnProperty('audienceData') ? overrides.audienceData! : relationshipsToOmit.has('AudienceData') ? {} as AudienceData : anAudienceData({}, relationshipsToOmit),
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : BroadcastType.Marketing,
        marketingType: overrides && overrides.hasOwnProperty('marketingType') ? overrides.marketingType! : BroadcastMarketingType.OptIn,
        transactionalType: overrides && overrides.hasOwnProperty('transactionalType') ? overrides.transactionalType! : BroadcastTransactionalType.Event,
        marketingFilters: overrides && overrides.hasOwnProperty('marketingFilters') ? overrides.marketingFilters! : [relationshipsToOmit.has('BroadcastMarketingFilters') ? {} as BroadcastMarketingFilters : aBroadcastMarketingFilters({}, relationshipsToOmit)],
        marketingFiltersV2: overrides && overrides.hasOwnProperty('marketingFiltersV2') ? overrides.marketingFiltersV2! : [relationshipsToOmit.has('BroadcastMarketingFiltersV2Output') ? {} as BroadcastMarketingFiltersV2Output : aBroadcastMarketingFiltersV2Output({}, relationshipsToOmit)],
        style: overrides && overrides.hasOwnProperty('style') ? overrides.style! : relationshipsToOmit.has('EmailStyle') ? {} as EmailStyle : anEmailStyle({}, relationshipsToOmit),
        reportingVersion: overrides && overrides.hasOwnProperty('reportingVersion') ? overrides.reportingVersion! : 0.9,
        postmarkStats: overrides && overrides.hasOwnProperty('postmarkStats') ? overrides.postmarkStats! : relationshipsToOmit.has('PostmarkEmailStatsOverviewOutput') ? {} as PostmarkEmailStatsOverviewOutput : aPostmarkEmailStatsOverviewOutput({}, relationshipsToOmit),
        postmarkServerId: overrides && overrides.hasOwnProperty('postmarkServerId') ? overrides.postmarkServerId! : 2.3,
        preheader: overrides && overrides.hasOwnProperty('preheader') ? overrides.preheader! : 'titulus',
        subjectRich: overrides && overrides.hasOwnProperty('subjectRich') ? overrides.subjectRich! : 'terror',
        recipients: overrides && overrides.hasOwnProperty('recipients') ? overrides.recipients! : 6.6,
        subjectDisplay: overrides && overrides.hasOwnProperty('subjectDisplay') ? overrides.subjectDisplay! : 'cupiditate',
        unsubscribeCount: overrides && overrides.hasOwnProperty('unsubscribeCount') ? overrides.unsubscribeCount! : 6815,
        stats: overrides && overrides.hasOwnProperty('stats') ? overrides.stats! : relationshipsToOmit.has('PostmarkEmailStatsOverviewOutput') ? {} as PostmarkEmailStatsOverviewOutput : aPostmarkEmailStatsOverviewOutput({}, relationshipsToOmit),
        lastEditedBy: overrides && overrides.hasOwnProperty('lastEditedBy') ? overrides.lastEditedBy! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
    };
};

export const aTagEntityIds = (overrides?: Partial<TagEntityIds>, _relationshipsToOmit: Set<string> = new Set()): TagEntityIds => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TagEntityIds');
    return {
        entityIds: overrides && overrides.hasOwnProperty('entityIds') ? overrides.entityIds! : ['coepi'],
    };
};

export const anAudienceData = (overrides?: Partial<AudienceData>, _relationshipsToOmit: Set<string> = new Set()): AudienceData => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AudienceData');
    return {
        ticketTypeId: overrides && overrides.hasOwnProperty('ticketTypeId') ? overrides.ticketTypeId! : ['ago'],
        zoneId: overrides && overrides.hasOwnProperty('zoneId') ? overrides.zoneId! : ['autus'],
        releaseId: overrides && overrides.hasOwnProperty('releaseId') ? overrides.releaseId! : ['caelestis'],
        addonId: overrides && overrides.hasOwnProperty('addonId') ? overrides.addonId! : ['desolo'],
    };
};

export const aBroadcastMarketingFilters = (overrides?: Partial<BroadcastMarketingFilters>, _relationshipsToOmit: Set<string> = new Set()): BroadcastMarketingFilters => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BroadcastMarketingFilters');
    return {
        ids: overrides && overrides.hasOwnProperty('ids') ? overrides.ids! : ['sponte'],
        criteria: overrides && overrides.hasOwnProperty('criteria') ? overrides.criteria! : BroadcastFilterCriteria.Is,
        filterType: overrides && overrides.hasOwnProperty('filterType') ? overrides.filterType! : BroadcastFilterType.Waitlist,
    };
};

export const aBroadcastMarketingFiltersV2Output = (overrides?: Partial<BroadcastMarketingFiltersV2Output>, _relationshipsToOmit: Set<string> = new Set()): BroadcastMarketingFiltersV2Output => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BroadcastMarketingFiltersV2Output');
    return {
        args: overrides && overrides.hasOwnProperty('args') ? overrides.args! : relationshipsToOmit.has('PurchaseHistoryArgs') ? {} as PurchaseHistoryArgs : aPurchaseHistoryArgs({}, relationshipsToOmit),
    };
};

export const aPurchaseHistoryArgs = (overrides?: Partial<PurchaseHistoryArgs>, _relationshipsToOmit: Set<string> = new Set()): PurchaseHistoryArgs => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PurchaseHistoryArgs');
    return {
        kind: overrides && overrides.hasOwnProperty('kind') ? overrides.kind! : BroadcastMarketingFiltersV2Kind.TicketType,
        exclude: overrides && overrides.hasOwnProperty('exclude') ? overrides.exclude! : true,
        eventIds: overrides && overrides.hasOwnProperty('eventIds') ? overrides.eventIds! : ['cur'],
    };
};

export const aPurchasedTicketActivityArgs = (overrides?: Partial<PurchasedTicketActivityArgs>, _relationshipsToOmit: Set<string> = new Set()): PurchasedTicketActivityArgs => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PurchasedTicketActivityArgs');
    return {
        kind: overrides && overrides.hasOwnProperty('kind') ? overrides.kind! : BroadcastMarketingFiltersV2Kind.TicketType,
        exclude: overrides && overrides.hasOwnProperty('exclude') ? overrides.exclude! : true,
        eventIds: overrides && overrides.hasOwnProperty('eventIds') ? overrides.eventIds! : ['deficio'],
    };
};

export const anAttendanceActivityArgs = (overrides?: Partial<AttendanceActivityArgs>, _relationshipsToOmit: Set<string> = new Set()): AttendanceActivityArgs => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AttendanceActivityArgs');
    return {
        kind: overrides && overrides.hasOwnProperty('kind') ? overrides.kind! : BroadcastMarketingFiltersV2Kind.TicketType,
        exclude: overrides && overrides.hasOwnProperty('exclude') ? overrides.exclude! : true,
        eventIds: overrides && overrides.hasOwnProperty('eventIds') ? overrides.eventIds! : ['arbor'],
    };
};

export const aPurchaseFrequencyArgs = (overrides?: Partial<PurchaseFrequencyArgs>, _relationshipsToOmit: Set<string> = new Set()): PurchaseFrequencyArgs => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PurchaseFrequencyArgs');
    return {
        kind: overrides && overrides.hasOwnProperty('kind') ? overrides.kind! : BroadcastMarketingFiltersV2Kind.TicketType,
        exclude: overrides && overrides.hasOwnProperty('exclude') ? overrides.exclude! : true,
        minimumPurchases: overrides && overrides.hasOwnProperty('minimumPurchases') ? overrides.minimumPurchases! : 6,
        maximumPurchases: overrides && overrides.hasOwnProperty('maximumPurchases') ? overrides.maximumPurchases! : 8.8,
        purchaseType: overrides && overrides.hasOwnProperty('purchaseType') ? overrides.purchaseType! : PurchaseFrequencyFilterPurchaseType.Event,
        interval: overrides && overrides.hasOwnProperty('interval') ? overrides.interval! : relationshipsToOmit.has('PurchaseFrequencyFilterInterval') ? {} as PurchaseFrequencyFilterInterval : aPurchaseFrequencyFilterInterval({}, relationshipsToOmit),
        range: overrides && overrides.hasOwnProperty('range') ? overrides.range! : relationshipsToOmit.has('PurchaseFrequencyFilterRange') ? {} as PurchaseFrequencyFilterRange : aPurchaseFrequencyFilterRange({}, relationshipsToOmit),
    };
};

export const aPurchaseFrequencyFilterInterval = (overrides?: Partial<PurchaseFrequencyFilterInterval>, _relationshipsToOmit: Set<string> = new Set()): PurchaseFrequencyFilterInterval => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PurchaseFrequencyFilterInterval');
    return {
        before: overrides && overrides.hasOwnProperty('before') ? overrides.before! : true,
        number: overrides && overrides.hasOwnProperty('number') ? overrides.number! : 8.8,
        unit: overrides && overrides.hasOwnProperty('unit') ? overrides.unit! : PurchaseFrequencyFilterIntervalUnit.Days,
    };
};

export const aPurchaseFrequencyFilterRange = (overrides?: Partial<PurchaseFrequencyFilterRange>, _relationshipsToOmit: Set<string> = new Set()): PurchaseFrequencyFilterRange => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PurchaseFrequencyFilterRange');
    return {
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : 'curvo',
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : 'attero',
    };
};

export const aTicketTypeArgs = (overrides?: Partial<TicketTypeArgs>, _relationshipsToOmit: Set<string> = new Set()): TicketTypeArgs => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TicketTypeArgs');
    return {
        kind: overrides && overrides.hasOwnProperty('kind') ? overrides.kind! : BroadcastMarketingFiltersV2Kind.TicketType,
        exclude: overrides && overrides.hasOwnProperty('exclude') ? overrides.exclude! : false,
        ticketTypeIds: overrides && overrides.hasOwnProperty('ticketTypeIds') ? overrides.ticketTypeIds! : ['angelus'],
    };
};

export const aLocationArgs = (overrides?: Partial<LocationArgs>, _relationshipsToOmit: Set<string> = new Set()): LocationArgs => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LocationArgs');
    return {
        kind: overrides && overrides.hasOwnProperty('kind') ? overrides.kind! : BroadcastMarketingFiltersV2Kind.TicketType,
        exclude: overrides && overrides.hasOwnProperty('exclude') ? overrides.exclude! : true,
        list: overrides && overrides.hasOwnProperty('list') ? overrides.list! : ['bonus'],
        locationFilterType: overrides && overrides.hasOwnProperty('locationFilterType') ? overrides.locationFilterType! : LocationFilterTypes.District,
    };
};

export const aZoneArgs = (overrides?: Partial<ZoneArgs>, _relationshipsToOmit: Set<string> = new Set()): ZoneArgs => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ZoneArgs');
    return {
        kind: overrides && overrides.hasOwnProperty('kind') ? overrides.kind! : BroadcastMarketingFiltersV2Kind.TicketType,
        exclude: overrides && overrides.hasOwnProperty('exclude') ? overrides.exclude! : false,
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'varietas',
        seatZoneIds: overrides && overrides.hasOwnProperty('seatZoneIds') ? overrides.seatZoneIds! : ['earum'],
    };
};

export const aMembershipArgs = (overrides?: Partial<MembershipArgs>, _relationshipsToOmit: Set<string> = new Set()): MembershipArgs => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MembershipArgs');
    return {
        kind: overrides && overrides.hasOwnProperty('kind') ? overrides.kind! : BroadcastMarketingFiltersV2Kind.TicketType,
        exclude: overrides && overrides.hasOwnProperty('exclude') ? overrides.exclude! : false,
        membershipIds: overrides && overrides.hasOwnProperty('membershipIds') ? overrides.membershipIds! : ['ducimus'],
    };
};

export const aTagArgs = (overrides?: Partial<TagArgs>, _relationshipsToOmit: Set<string> = new Set()): TagArgs => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TagArgs');
    return {
        kind: overrides && overrides.hasOwnProperty('kind') ? overrides.kind! : BroadcastMarketingFiltersV2Kind.TicketType,
        exclude: overrides && overrides.hasOwnProperty('exclude') ? overrides.exclude! : true,
        tagIds: overrides && overrides.hasOwnProperty('tagIds') ? overrides.tagIds! : ['uredo'],
    };
};

export const aCompArgs = (overrides?: Partial<CompArgs>, _relationshipsToOmit: Set<string> = new Set()): CompArgs => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CompArgs');
    return {
        kind: overrides && overrides.hasOwnProperty('kind') ? overrides.kind! : BroadcastMarketingFiltersV2Kind.TicketType,
        exclude: overrides && overrides.hasOwnProperty('exclude') ? overrides.exclude! : true,
        eventIds: overrides && overrides.hasOwnProperty('eventIds') ? overrides.eventIds! : ['vere'],
    };
};

export const anEmailsOpenedArgs = (overrides?: Partial<EmailsOpenedArgs>, _relationshipsToOmit: Set<string> = new Set()): EmailsOpenedArgs => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EmailsOpenedArgs');
    return {
        kind: overrides && overrides.hasOwnProperty('kind') ? overrides.kind! : BroadcastMarketingFiltersV2Kind.TicketType,
        exclude: overrides && overrides.hasOwnProperty('exclude') ? overrides.exclude! : false,
        broadcastIds: overrides && overrides.hasOwnProperty('broadcastIds') ? overrides.broadcastIds! : ['aedificium'],
    };
};

export const aPackageArgs = (overrides?: Partial<PackageArgs>, _relationshipsToOmit: Set<string> = new Set()): PackageArgs => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PackageArgs');
    return {
        kind: overrides && overrides.hasOwnProperty('kind') ? overrides.kind! : BroadcastMarketingFiltersV2Kind.TicketType,
        exclude: overrides && overrides.hasOwnProperty('exclude') ? overrides.exclude! : true,
        packageIds: overrides && overrides.hasOwnProperty('packageIds') ? overrides.packageIds! : ['artificiose'],
    };
};

export const aGenderArgs = (overrides?: Partial<GenderArgs>, _relationshipsToOmit: Set<string> = new Set()): GenderArgs => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('GenderArgs');
    return {
        kind: overrides && overrides.hasOwnProperty('kind') ? overrides.kind! : BroadcastMarketingFiltersV2Kind.TicketType,
        exclude: overrides && overrides.hasOwnProperty('exclude') ? overrides.exclude! : false,
        genders: overrides && overrides.hasOwnProperty('genders') ? overrides.genders! : [GenderFilterType.Male],
    };
};

export const anAgeArgs = (overrides?: Partial<AgeArgs>, _relationshipsToOmit: Set<string> = new Set()): AgeArgs => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AgeArgs');
    return {
        kind: overrides && overrides.hasOwnProperty('kind') ? overrides.kind! : BroadcastMarketingFiltersV2Kind.TicketType,
        exclude: overrides && overrides.hasOwnProperty('exclude') ? overrides.exclude! : false,
        minimumAge: overrides && overrides.hasOwnProperty('minimumAge') ? overrides.minimumAge! : 1.5,
        maximumAge: overrides && overrides.hasOwnProperty('maximumAge') ? overrides.maximumAge! : 7.8,
    };
};

export const aSegmentArgs = (overrides?: Partial<SegmentArgs>, _relationshipsToOmit: Set<string> = new Set()): SegmentArgs => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SegmentArgs');
    return {
        kind: overrides && overrides.hasOwnProperty('kind') ? overrides.kind! : BroadcastMarketingFiltersV2Kind.TicketType,
        exclude: overrides && overrides.hasOwnProperty('exclude') ? overrides.exclude! : true,
        segmentIds: overrides && overrides.hasOwnProperty('segmentIds') ? overrides.segmentIds! : ['aperte'],
    };
};

export const aPreAuthActivityArgs = (overrides?: Partial<PreAuthActivityArgs>, _relationshipsToOmit: Set<string> = new Set()): PreAuthActivityArgs => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PreAuthActivityArgs');
    return {
        kind: overrides && overrides.hasOwnProperty('kind') ? overrides.kind! : BroadcastMarketingFiltersV2Kind.TicketType,
        exclude: overrides && overrides.hasOwnProperty('exclude') ? overrides.exclude! : false,
        eventIds: overrides && overrides.hasOwnProperty('eventIds') ? overrides.eventIds! : ['tredecim'],
    };
};

export const aRegisteredForActivityArgs = (overrides?: Partial<RegisteredForActivityArgs>, _relationshipsToOmit: Set<string> = new Set()): RegisteredForActivityArgs => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RegisteredForActivityArgs');
    return {
        kind: overrides && overrides.hasOwnProperty('kind') ? overrides.kind! : BroadcastMarketingFiltersV2Kind.TicketType,
        exclude: overrides && overrides.hasOwnProperty('exclude') ? overrides.exclude! : true,
        eventIds: overrides && overrides.hasOwnProperty('eventIds') ? overrides.eventIds! : ['amet'],
    };
};

export const aJoinedWaitlistActivityArgs = (overrides?: Partial<JoinedWaitlistActivityArgs>, _relationshipsToOmit: Set<string> = new Set()): JoinedWaitlistActivityArgs => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('JoinedWaitlistActivityArgs');
    return {
        kind: overrides && overrides.hasOwnProperty('kind') ? overrides.kind! : BroadcastMarketingFiltersV2Kind.TicketType,
        exclude: overrides && overrides.hasOwnProperty('exclude') ? overrides.exclude! : false,
        eventIds: overrides && overrides.hasOwnProperty('eventIds') ? overrides.eventIds! : ['truculenter'],
    };
};

export const aPostmarkEmailStatsOverviewOutput = (overrides?: Partial<PostmarkEmailStatsOverviewOutput>, _relationshipsToOmit: Set<string> = new Set()): PostmarkEmailStatsOverviewOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PostmarkEmailStatsOverviewOutput');
    return {
        sent: overrides && overrides.hasOwnProperty('sent') ? overrides.sent! : 1.5,
        bounced: overrides && overrides.hasOwnProperty('bounced') ? overrides.bounced! : 3.4,
        smtpApiErrors: overrides && overrides.hasOwnProperty('smtpApiErrors') ? overrides.smtpApiErrors! : 4.3,
        bounceRate: overrides && overrides.hasOwnProperty('bounceRate') ? overrides.bounceRate! : 2.5,
        spamComplaints: overrides && overrides.hasOwnProperty('spamComplaints') ? overrides.spamComplaints! : 1,
        spamComplaintsRate: overrides && overrides.hasOwnProperty('spamComplaintsRate') ? overrides.spamComplaintsRate! : 9.1,
        opens: overrides && overrides.hasOwnProperty('opens') ? overrides.opens! : 8.1,
        uniqueOpens: overrides && overrides.hasOwnProperty('uniqueOpens') ? overrides.uniqueOpens! : 5.6,
        tracked: overrides && overrides.hasOwnProperty('tracked') ? overrides.tracked! : 1.3,
        withLinkTracking: overrides && overrides.hasOwnProperty('withLinkTracking') ? overrides.withLinkTracking! : 0.5,
        withOpenTracking: overrides && overrides.hasOwnProperty('withOpenTracking') ? overrides.withOpenTracking! : 8,
        totalTrackedLinksSent: overrides && overrides.hasOwnProperty('totalTrackedLinksSent') ? overrides.totalTrackedLinksSent! : 6.8,
        uniqueLinksClicked: overrides && overrides.hasOwnProperty('uniqueLinksClicked') ? overrides.uniqueLinksClicked! : 4.3,
        totalClicks: overrides && overrides.hasOwnProperty('totalClicks') ? overrides.totalClicks! : 7.1,
        withClientRecorded: overrides && overrides.hasOwnProperty('withClientRecorded') ? overrides.withClientRecorded! : 1.5,
        withPlatformRecorded: overrides && overrides.hasOwnProperty('withPlatformRecorded') ? overrides.withPlatformRecorded! : 9.7,
        withReadTimeRecorded: overrides && overrides.hasOwnProperty('withReadTimeRecorded') ? overrides.withReadTimeRecorded! : 9.2,
    };
};

export const anAudienceCountInput = (overrides?: Partial<AudienceCountInput>, _relationshipsToOmit: Set<string> = new Set()): AudienceCountInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AudienceCountInput');
    return {
        transactionalType: overrides && overrides.hasOwnProperty('transactionalType') ? overrides.transactionalType! : BroadcastTransactionalType.Event,
        audience: overrides && overrides.hasOwnProperty('audience') ? overrides.audience! : BroadcastAudience.TicketBuyers,
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'compello',
        membershipId: overrides && overrides.hasOwnProperty('membershipId') ? overrides.membershipId! : 'debilito',
        packageId: overrides && overrides.hasOwnProperty('packageId') ? overrides.packageId! : 'defluo',
        ticketTypeId: overrides && overrides.hasOwnProperty('ticketTypeId') ? overrides.ticketTypeId! : ['compono'],
        zoneId: overrides && overrides.hasOwnProperty('zoneId') ? overrides.zoneId! : ['tenax'],
        releaseId: overrides && overrides.hasOwnProperty('releaseId') ? overrides.releaseId! : ['suscipio'],
        addonId: overrides && overrides.hasOwnProperty('addonId') ? overrides.addonId! : ['vestrum'],
    };
};

export const aBroadcastFilterCountInput = (overrides?: Partial<BroadcastFilterCountInput>, _relationshipsToOmit: Set<string> = new Set()): BroadcastFilterCountInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BroadcastFilterCountInput');
    return {
        filters: overrides && overrides.hasOwnProperty('filters') ? overrides.filters! : [relationshipsToOmit.has('MarketingFiltersInput') ? {} as MarketingFiltersInput : aMarketingFiltersInput({}, relationshipsToOmit)],
        filtersV2: overrides && overrides.hasOwnProperty('filtersV2') ? overrides.filtersV2! : [relationshipsToOmit.has('BroadcastMarketingFiltersV2Input') ? {} as BroadcastMarketingFiltersV2Input : aBroadcastMarketingFiltersV2Input({}, relationshipsToOmit)],
        broadcastCommunicationType: overrides && overrides.hasOwnProperty('broadcastCommunicationType') ? overrides.broadcastCommunicationType! : BroadcastCommunicationType.Email,
    };
};

export const aMarketingFiltersInput = (overrides?: Partial<MarketingFiltersInput>, _relationshipsToOmit: Set<string> = new Set()): MarketingFiltersInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MarketingFiltersInput');
    return {
        ids: overrides && overrides.hasOwnProperty('ids') ? overrides.ids! : ['coniecto'],
        criteria: overrides && overrides.hasOwnProperty('criteria') ? overrides.criteria! : BroadcastFilterCriteria.Is,
        filterType: overrides && overrides.hasOwnProperty('filterType') ? overrides.filterType! : BroadcastFilterType.Waitlist,
    };
};

export const aBroadcastMarketingFiltersV2Input = (overrides?: Partial<BroadcastMarketingFiltersV2Input>, _relationshipsToOmit: Set<string> = new Set()): BroadcastMarketingFiltersV2Input => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BroadcastMarketingFiltersV2Input');
    return {
        args: overrides && overrides.hasOwnProperty('args') ? overrides.args! : 'vigor',
    };
};

export const aBroadcastMarketingV2StateInput = (overrides?: Partial<BroadcastMarketingV2StateInput>, _relationshipsToOmit: Set<string> = new Set()): BroadcastMarketingV2StateInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BroadcastMarketingV2StateInput');
    return {
        filterV2: overrides && overrides.hasOwnProperty('filterV2') ? overrides.filterV2! : relationshipsToOmit.has('BroadcastMarketingFiltersV2Input') ? {} as BroadcastMarketingFiltersV2Input : aBroadcastMarketingFiltersV2Input({}, relationshipsToOmit),
    };
};

export const aBroadcastMarketingV2StateOutput = (overrides?: Partial<BroadcastMarketingV2StateOutput>, _relationshipsToOmit: Set<string> = new Set()): BroadcastMarketingV2StateOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BroadcastMarketingV2StateOutput');
    return {
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : BroadcastFilterStateType.Event,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'turbo',
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'necessitatibus',
    };
};

export const aBroadcastDeliveryErrorsOutput = (overrides?: Partial<BroadcastDeliveryErrorsOutput>, _relationshipsToOmit: Set<string> = new Set()): BroadcastDeliveryErrorsOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BroadcastDeliveryErrorsOutput');
    return {
        broadcastId: overrides && overrides.hasOwnProperty('broadcastId') ? overrides.broadcastId! : 'certus',
        totalCount: overrides && overrides.hasOwnProperty('totalCount') ? overrides.totalCount! : 1.4,
        deliveryErrors: overrides && overrides.hasOwnProperty('deliveryErrors') ? overrides.deliveryErrors! : [relationshipsToOmit.has('BroadcastDeliveryError') ? {} as BroadcastDeliveryError : aBroadcastDeliveryError({}, relationshipsToOmit)],
    };
};

export const aBroadcastDeliveryError = (overrides?: Partial<BroadcastDeliveryError>, _relationshipsToOmit: Set<string> = new Set()): BroadcastDeliveryError => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BroadcastDeliveryError');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'aeger',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'aetas',
    };
};

export const aBroadcastDefaultConfigOutput = (overrides?: Partial<BroadcastDefaultConfigOutput>, _relationshipsToOmit: Set<string> = new Set()): BroadcastDefaultConfigOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BroadcastDefaultConfigOutput');
    return {
        style: overrides && overrides.hasOwnProperty('style') ? overrides.style! : relationshipsToOmit.has('EmailStyle') ? {} as EmailStyle : anEmailStyle({}, relationshipsToOmit),
        domainId: overrides && overrides.hasOwnProperty('domainId') ? overrides.domainId! : 'ocer',
        localPart: overrides && overrides.hasOwnProperty('localPart') ? overrides.localPart! : 'tactus',
    };
};

export const aBroadcastLocationFilterOptions = (overrides?: Partial<BroadcastLocationFilterOptions>, _relationshipsToOmit: Set<string> = new Set()): BroadcastLocationFilterOptions => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BroadcastLocationFilterOptions');
    return {
        region: overrides && overrides.hasOwnProperty('region') ? overrides.region! : [relationshipsToOmit.has('ResponseLabelValue') ? {} as ResponseLabelValue : aResponseLabelValue({}, relationshipsToOmit)],
        state: overrides && overrides.hasOwnProperty('state') ? overrides.state! : [relationshipsToOmit.has('ResponseLabelValue') ? {} as ResponseLabelValue : aResponseLabelValue({}, relationshipsToOmit)],
        district: overrides && overrides.hasOwnProperty('district') ? overrides.district! : [relationshipsToOmit.has('ResponseLabelValue') ? {} as ResponseLabelValue : aResponseLabelValue({}, relationshipsToOmit)],
        locality: overrides && overrides.hasOwnProperty('locality') ? overrides.locality! : [relationshipsToOmit.has('ResponseLabelValue') ? {} as ResponseLabelValue : aResponseLabelValue({}, relationshipsToOmit)],
        country: overrides && overrides.hasOwnProperty('country') ? overrides.country! : [relationshipsToOmit.has('ResponseLabelValue') ? {} as ResponseLabelValue : aResponseLabelValue({}, relationshipsToOmit)],
    };
};

export const aResponseLabelValue = (overrides?: Partial<ResponseLabelValue>, _relationshipsToOmit: Set<string> = new Set()): ResponseLabelValue => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ResponseLabelValue');
    return {
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'trucido',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'attero',
    };
};

export const aBroadcastUnsubscribesOutput = (overrides?: Partial<BroadcastUnsubscribesOutput>, _relationshipsToOmit: Set<string> = new Set()): BroadcastUnsubscribesOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BroadcastUnsubscribesOutput');
    return {
        broadcastId: overrides && overrides.hasOwnProperty('broadcastId') ? overrides.broadcastId! : 'arca',
        totalCount: overrides && overrides.hasOwnProperty('totalCount') ? overrides.totalCount! : 8.6,
        unsubscribes: overrides && overrides.hasOwnProperty('unsubscribes') ? overrides.unsubscribes! : [relationshipsToOmit.has('BroadcastUnsubscribe') ? {} as BroadcastUnsubscribe : aBroadcastUnsubscribe({}, relationshipsToOmit)],
    };
};

export const aBroadcastUnsubscribe = (overrides?: Partial<BroadcastUnsubscribe>, _relationshipsToOmit: Set<string> = new Set()): BroadcastUnsubscribe => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BroadcastUnsubscribe');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'votum',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'collum',
    };
};

export const aBroadcastReportedAsSpamUsersOutput = (overrides?: Partial<BroadcastReportedAsSpamUsersOutput>, _relationshipsToOmit: Set<string> = new Set()): BroadcastReportedAsSpamUsersOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BroadcastReportedAsSpamUsersOutput');
    return {
        broadcastId: overrides && overrides.hasOwnProperty('broadcastId') ? overrides.broadcastId! : 'aestus',
        reportedAsSpamUsers: overrides && overrides.hasOwnProperty('reportedAsSpamUsers') ? overrides.reportedAsSpamUsers! : [relationshipsToOmit.has('BroadcastReportedAsSpamUser') ? {} as BroadcastReportedAsSpamUser : aBroadcastReportedAsSpamUser({}, relationshipsToOmit)],
    };
};

export const aBroadcastReportedAsSpamUser = (overrides?: Partial<BroadcastReportedAsSpamUser>, _relationshipsToOmit: Set<string> = new Set()): BroadcastReportedAsSpamUser => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BroadcastReportedAsSpamUser');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'vorax',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'vestigium',
    };
};

export const anEventForBroadcast = (overrides?: Partial<EventForBroadcast>, _relationshipsToOmit: Set<string> = new Set()): EventForBroadcast => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EventForBroadcast');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'doloribus',
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'iste',
        hasResaleTicket: overrides && overrides.hasOwnProperty('hasResaleTicket') ? overrides.hasResaleTicket! : true,
        dates: overrides && overrides.hasOwnProperty('dates') ? overrides.dates! : [relationshipsToOmit.has('EventDate') ? {} as EventDate : anEventDate({}, relationshipsToOmit)],
    };
};

export const aSmsBroadcastListOutput = (overrides?: Partial<SmsBroadcastListOutput>, _relationshipsToOmit: Set<string> = new Set()): SmsBroadcastListOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SmsBroadcastListOutput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'deficio',
        subject: overrides && overrides.hasOwnProperty('subject') ? overrides.subject! : 'stips',
        scheduledAt: overrides && overrides.hasOwnProperty('scheduledAt') ? overrides.scheduledAt! : "2025-08-19T23:16:01.726Z",
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : BroadcastStatus.Scheduled,
        recipientCount: overrides && overrides.hasOwnProperty('recipientCount') ? overrides.recipientCount! : 6.7,
        lastEditedBy: overrides && overrides.hasOwnProperty('lastEditedBy') ? overrides.lastEditedBy! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
    };
};

export const aSmsBroadcastOutput = (overrides?: Partial<SmsBroadcastOutput>, _relationshipsToOmit: Set<string> = new Set()): SmsBroadcastOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SmsBroadcastOutput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'vapulus',
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : BroadcastStatus.Scheduled,
        scheduledAt: overrides && overrides.hasOwnProperty('scheduledAt') ? overrides.scheduledAt! : "2025-07-07T22:24:09.810Z",
        subject: overrides && overrides.hasOwnProperty('subject') ? overrides.subject! : 'tamquam',
        message: overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'vivo',
        sentMessageContent: overrides && overrides.hasOwnProperty('sentMessageContent') ? overrides.sentMessageContent! : 'ipsam',
        recipientCount: overrides && overrides.hasOwnProperty('recipientCount') ? overrides.recipientCount! : 8.6,
        deliveryCount: overrides && overrides.hasOwnProperty('deliveryCount') ? overrides.deliveryCount! : 2.2,
        bounceCount: overrides && overrides.hasOwnProperty('bounceCount') ? overrides.bounceCount! : 9.3,
        deliveryRate: overrides && overrides.hasOwnProperty('deliveryRate') ? overrides.deliveryRate! : 4.2,
        unsubscribeCount: overrides && overrides.hasOwnProperty('unsubscribeCount') ? overrides.unsubscribeCount! : 7.2,
        uniqueClicksCount: overrides && overrides.hasOwnProperty('uniqueClicksCount') ? overrides.uniqueClicksCount! : 2.4,
        conversionCount: overrides && overrides.hasOwnProperty('conversionCount') ? overrides.conversionCount! : 8.2,
        generatedRevenue: overrides && overrides.hasOwnProperty('generatedRevenue') ? overrides.generatedRevenue! : 4.2,
        totalCostInCents: overrides && overrides.hasOwnProperty('totalCostInCents') ? overrides.totalCostInCents! : 1.8,
        hasTrackingLink: overrides && overrides.hasOwnProperty('hasTrackingLink') ? overrides.hasTrackingLink! : true,
        marketingFilters: overrides && overrides.hasOwnProperty('marketingFilters') ? overrides.marketingFilters! : [relationshipsToOmit.has('BroadcastMarketingFiltersV2Output') ? {} as BroadcastMarketingFiltersV2Output : aBroadcastMarketingFiltersV2Output({}, relationshipsToOmit)],
        lastEditedBy: overrides && overrides.hasOwnProperty('lastEditedBy') ? overrides.lastEditedBy! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : relationshipsToOmit.has('TagEntityIds') ? {} as TagEntityIds : aTagEntityIds({}, relationshipsToOmit),
        conversionPercentage: overrides && overrides.hasOwnProperty('conversionPercentage') ? overrides.conversionPercentage! : 2,
    };
};

export const aSmsBroadcastDeliveryErrorsOutput = (overrides?: Partial<SmsBroadcastDeliveryErrorsOutput>, _relationshipsToOmit: Set<string> = new Set()): SmsBroadcastDeliveryErrorsOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SmsBroadcastDeliveryErrorsOutput');
    return {
        smsBroadcastId: overrides && overrides.hasOwnProperty('smsBroadcastId') ? overrides.smsBroadcastId! : 'valens',
        totalCount: overrides && overrides.hasOwnProperty('totalCount') ? overrides.totalCount! : 4.3,
        deliveryErrors: overrides && overrides.hasOwnProperty('deliveryErrors') ? overrides.deliveryErrors! : [relationshipsToOmit.has('SmsBroadcastDeliveryError') ? {} as SmsBroadcastDeliveryError : aSmsBroadcastDeliveryError({}, relationshipsToOmit)],
    };
};

export const aSmsBroadcastDeliveryError = (overrides?: Partial<SmsBroadcastDeliveryError>, _relationshipsToOmit: Set<string> = new Set()): SmsBroadcastDeliveryError => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SmsBroadcastDeliveryError');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'apparatus',
        phoneNumber: overrides && overrides.hasOwnProperty('phoneNumber') ? overrides.phoneNumber! : 'cubo',
    };
};

export const aSmsBroadcastFilterCountInput = (overrides?: Partial<SmsBroadcastFilterCountInput>, _relationshipsToOmit: Set<string> = new Set()): SmsBroadcastFilterCountInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SmsBroadcastFilterCountInput');
    return {
        filters: overrides && overrides.hasOwnProperty('filters') ? overrides.filters! : [relationshipsToOmit.has('BroadcastMarketingFiltersV2Input') ? {} as BroadcastMarketingFiltersV2Input : aBroadcastMarketingFiltersV2Input({}, relationshipsToOmit)],
    };
};

export const aSmsBroadcastAudienceOutput = (overrides?: Partial<SmsBroadcastAudienceOutput>, _relationshipsToOmit: Set<string> = new Set()): SmsBroadcastAudienceOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SmsBroadcastAudienceOutput');
    return {
        totalCostInCents: overrides && overrides.hasOwnProperty('totalCostInCents') ? overrides.totalCostInCents! : 7.4,
        audienceSize: overrides && overrides.hasOwnProperty('audienceSize') ? overrides.audienceSize! : 4.2,
    };
};

export const aSmsBroadcastUnsubscribesOutput = (overrides?: Partial<SmsBroadcastUnsubscribesOutput>, _relationshipsToOmit: Set<string> = new Set()): SmsBroadcastUnsubscribesOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SmsBroadcastUnsubscribesOutput');
    return {
        smsBroadcastId: overrides && overrides.hasOwnProperty('smsBroadcastId') ? overrides.smsBroadcastId! : 'statim',
        totalCount: overrides && overrides.hasOwnProperty('totalCount') ? overrides.totalCount! : 6.6,
        unsubscribes: overrides && overrides.hasOwnProperty('unsubscribes') ? overrides.unsubscribes! : [relationshipsToOmit.has('SmsBroadcastUnsubscribe') ? {} as SmsBroadcastUnsubscribe : aSmsBroadcastUnsubscribe({}, relationshipsToOmit)],
    };
};

export const aSmsBroadcastUnsubscribe = (overrides?: Partial<SmsBroadcastUnsubscribe>, _relationshipsToOmit: Set<string> = new Set()): SmsBroadcastUnsubscribe => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SmsBroadcastUnsubscribe');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'deserunt',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'solus',
        phoneNumber: overrides && overrides.hasOwnProperty('phoneNumber') ? overrides.phoneNumber! : 'decet',
    };
};

export const anEmailDomainOutput = (overrides?: Partial<EmailDomainOutput>, _relationshipsToOmit: Set<string> = new Set()): EmailDomainOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EmailDomainOutput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'utor',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'summisse',
        verified: overrides && overrides.hasOwnProperty('verified') ? overrides.verified! : true,
        records: overrides && overrides.hasOwnProperty('records') ? overrides.records! : [relationshipsToOmit.has('EmailDomainRecordOutput') ? {} as EmailDomainRecordOutput : anEmailDomainRecordOutput({}, relationshipsToOmit)],
        isDeletable: overrides && overrides.hasOwnProperty('isDeletable') ? overrides.isDeletable! : true,
    };
};

export const anEmailDomainRecordOutput = (overrides?: Partial<EmailDomainRecordOutput>, _relationshipsToOmit: Set<string> = new Set()): EmailDomainRecordOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EmailDomainRecordOutput');
    return {
        host: overrides && overrides.hasOwnProperty('host') ? overrides.host! : 'cado',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'admiratio',
        verified: overrides && overrides.hasOwnProperty('verified') ? overrides.verified! : true,
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'comptus',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'talus',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'circumvenio',
    };
};

export const aCodeReportOutput = (overrides?: Partial<CodeReportOutput>, _relationshipsToOmit: Set<string> = new Set()): CodeReportOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CodeReportOutput');
    return {
        counts: overrides && overrides.hasOwnProperty('counts') ? overrides.counts! : 6.9,
        items: overrides && overrides.hasOwnProperty('items') ? overrides.items! : [relationshipsToOmit.has('CodeReportItem') ? {} as CodeReportItem : aCodeReportItem({}, relationshipsToOmit)],
    };
};

export const aCodeReportItem = (overrides?: Partial<CodeReportItem>, _relationshipsToOmit: Set<string> = new Set()): CodeReportItem => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CodeReportItem');
    return {
        code: overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'pauci',
        redeemed: overrides && overrides.hasOwnProperty('redeemed') ? overrides.redeemed! : 9.6,
        sold: overrides && overrides.hasOwnProperty('sold') ? overrides.sold! : 0.8,
        amount: overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 2.5,
        scanned: overrides && overrides.hasOwnProperty('scanned') ? overrides.scanned! : 2.2,
    };
};

export const aGetReportSchedulesInput = (overrides?: Partial<GetReportSchedulesInput>, _relationshipsToOmit: Set<string> = new Set()): GetReportSchedulesInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('GetReportSchedulesInput');
    return {
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : ReportScheduleType.Event,
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'vulnus',
        membershipId: overrides && overrides.hasOwnProperty('membershipId') ? overrides.membershipId! : 'truculenter',
    };
};

export const aReportSchedule = (overrides?: Partial<ReportSchedule>, _relationshipsToOmit: Set<string> = new Set()): ReportSchedule => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ReportSchedule');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '20f8cb21-d466-4cb7-867e-36fb8cf468c0',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2026-03-01T17:52:54.617Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-04-25T06:47:47.574Z",
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'ocer',
        membershipId: overrides && overrides.hasOwnProperty('membershipId') ? overrides.membershipId! : 'acquiro',
        scheduleName: overrides && overrides.hasOwnProperty('scheduleName') ? overrides.scheduleName! : 'voluptate',
        recipientList: overrides && overrides.hasOwnProperty('recipientList') ? overrides.recipientList! : ['alter'],
        scheduleOptions: overrides && overrides.hasOwnProperty('scheduleOptions') ? overrides.scheduleOptions! : relationshipsToOmit.has('ReportScheduleOptions') ? {} as ReportScheduleOptions : aReportScheduleOptions({}, relationshipsToOmit),
        isPaused: overrides && overrides.hasOwnProperty('isPaused') ? overrides.isPaused! : false,
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : ReportScheduleType.Event,
        scheduleDateInfo: overrides && overrides.hasOwnProperty('scheduleDateInfo') ? overrides.scheduleDateInfo! : relationshipsToOmit.has('ReportScheduleDateInfoOutput') ? {} as ReportScheduleDateInfoOutput : aReportScheduleDateInfoOutput({}, relationshipsToOmit),
    };
};

export const aReportScheduleOptions = (overrides?: Partial<ReportScheduleOptions>, _relationshipsToOmit: Set<string> = new Set()): ReportScheduleOptions => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ReportScheduleOptions');
    return {
        frequency: overrides && overrides.hasOwnProperty('frequency') ? overrides.frequency! : ReportScheduleFrequency.Monthly,
        sendTime: overrides && overrides.hasOwnProperty('sendTime') ? overrides.sendTime! : 'vita',
        sendDay: overrides && overrides.hasOwnProperty('sendDay') ? overrides.sendDay! : 'cattus',
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : 'coadunatio',
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : 'depereo',
    };
};

export const aReportScheduleDateInfoOutput = (overrides?: Partial<ReportScheduleDateInfoOutput>, _relationshipsToOmit: Set<string> = new Set()): ReportScheduleDateInfoOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ReportScheduleDateInfoOutput');
    return {
        nextSendDate: overrides && overrides.hasOwnProperty('nextSendDate') ? overrides.nextSendDate! : 'coniuratio',
        firstSendDate: overrides && overrides.hasOwnProperty('firstSendDate') ? overrides.firstSendDate! : 'sursum',
        mostRecentSendDate: overrides && overrides.hasOwnProperty('mostRecentSendDate') ? overrides.mostRecentSendDate! : 'dedecor',
    };
};

export const aChargeSummaryOutput = (overrides?: Partial<ChargeSummaryOutput>, _relationshipsToOmit: Set<string> = new Set()): ChargeSummaryOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ChargeSummaryOutput');
    return {
        month: overrides && overrides.hasOwnProperty('month') ? overrides.month! : "2025-05-15T09:31:00.285Z",
        totalCents: overrides && overrides.hasOwnProperty('totalCents') ? overrides.totalCents! : 3.9,
        totalChargedCents: overrides && overrides.hasOwnProperty('totalChargedCents') ? overrides.totalChargedCents! : 2.3,
        totalUnchargedCents: overrides && overrides.hasOwnProperty('totalUnchargedCents') ? overrides.totalUnchargedCents! : 4.7,
    };
};

export const aChargeMonthSummaryOutput = (overrides?: Partial<ChargeMonthSummaryOutput>, _relationshipsToOmit: Set<string> = new Set()): ChargeMonthSummaryOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ChargeMonthSummaryOutput');
    return {
        lineItems: overrides && overrides.hasOwnProperty('lineItems') ? overrides.lineItems! : [relationshipsToOmit.has('ChargeLineItem') ? {} as ChargeLineItem : aChargeLineItem({}, relationshipsToOmit)],
    };
};

export const aChargeLineItem = (overrides?: Partial<ChargeLineItem>, _relationshipsToOmit: Set<string> = new Set()): ChargeLineItem => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ChargeLineItem');
    return {
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-10-16T15:15:22.113Z",
        orderId: overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'conitor',
        lineItemCount: overrides && overrides.hasOwnProperty('lineItemCount') ? overrides.lineItemCount! : 9.7,
        lineItemTotalCents: overrides && overrides.hasOwnProperty('lineItemTotalCents') ? overrides.lineItemTotalCents! : 8.8,
        lineItemChargedCents: overrides && overrides.hasOwnProperty('lineItemChargedCents') ? overrides.lineItemChargedCents! : 2,
        lineItemUnchargedCents: overrides && overrides.hasOwnProperty('lineItemUnchargedCents') ? overrides.lineItemUnchargedCents! : 9.6,
    };
};

export const aTrackingCodeOutput = (overrides?: Partial<TrackingCodeOutput>, _relationshipsToOmit: Set<string> = new Set()): TrackingCodeOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TrackingCodeOutput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '0681667a-1058-4457-86cb-7cd0f388d71b',
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'adopto',
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'ipsum',
        url: overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'non',
        visitorCount: overrides && overrides.hasOwnProperty('visitorCount') ? overrides.visitorCount! : 3.9,
        sales: overrides && overrides.hasOwnProperty('sales') ? overrides.sales! : 1,
        totalTicketRevenue: overrides && overrides.hasOwnProperty('totalTicketRevenue') ? overrides.totalTicketRevenue! : 9.4,
        ticketsSold: overrides && overrides.hasOwnProperty('ticketsSold') ? overrides.ticketsSold! : 9.4,
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-03-26T22:28:39.858Z",
    };
};

export const anAtrMembershipOrdersUpdatedBetweenInput = (overrides?: Partial<AtrMembershipOrdersUpdatedBetweenInput>, _relationshipsToOmit: Set<string> = new Set()): AtrMembershipOrdersUpdatedBetweenInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AtrMembershipOrdersUpdatedBetweenInput');
    return {
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2025-11-25T19:37:04.857Z",
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : "2025-05-12T06:08:47.971Z",
    };
};

export const anAtrMembershipOrdersUpdatedBetweenOutput = (overrides?: Partial<AtrMembershipOrdersUpdatedBetweenOutput>, _relationshipsToOmit: Set<string> = new Set()): AtrMembershipOrdersUpdatedBetweenOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AtrMembershipOrdersUpdatedBetweenOutput');
    return {
        order: overrides && overrides.hasOwnProperty('order') ? overrides.order! : relationshipsToOmit.has('Order') ? {} as Order : anOrder({}, relationshipsToOmit),
        arcMembershipId: overrides && overrides.hasOwnProperty('arcMembershipId') ? overrides.arcMembershipId! : 'demens',
        arcContactId: overrides && overrides.hasOwnProperty('arcContactId') ? overrides.arcContactId! : 'tersus',
    };
};

export const anAtrUsersUpdatedBetweenOutput = (overrides?: Partial<AtrUsersUpdatedBetweenOutput>, _relationshipsToOmit: Set<string> = new Set()): AtrUsersUpdatedBetweenOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AtrUsersUpdatedBetweenOutput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'c9ac7588-3c96-4a5c-8ea0-f5612cdcd6e4',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-12-01T14:01:17.169Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-07-01T15:40:54.332Z",
        organization: overrides && overrides.hasOwnProperty('organization') ? overrides.organization! : relationshipsToOmit.has('Organization') ? {} as Organization : anOrganization({}, relationshipsToOmit),
        roles: overrides && overrides.hasOwnProperty('roles') ? overrides.roles! : [Role.Superadmin],
        permissions: overrides && overrides.hasOwnProperty('permissions') ? overrides.permissions! : [Permission.AccountCreate],
        firstName: overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'confugo',
        lastName: overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'statim',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'vaco',
        fullName: overrides && overrides.hasOwnProperty('fullName') ? overrides.fullName! : 'virga',
        hasPassword: overrides && overrides.hasOwnProperty('hasPassword') ? overrides.hasPassword! : false,
        isTwoFactorAuthenticationEnabled: overrides && overrides.hasOwnProperty('isTwoFactorAuthenticationEnabled') ? overrides.isTwoFactorAuthenticationEnabled! : true,
        isLoggedInWithLinkedAccount: overrides && overrides.hasOwnProperty('isLoggedInWithLinkedAccount') ? overrides.isLoggedInWithLinkedAccount! : false,
        hasVerifiedEmail: overrides && overrides.hasOwnProperty('hasVerifiedEmail') ? overrides.hasVerifiedEmail! : true,
        birthDate: overrides && overrides.hasOwnProperty('birthDate') ? overrides.birthDate! : "2026-02-17T16:05:08.674Z",
        phoneNumber: overrides && overrides.hasOwnProperty('phoneNumber') ? overrides.phoneNumber! : 'color',
        gender: overrides && overrides.hasOwnProperty('gender') ? overrides.gender! : Gender.Male,
        usableForEmailMarketing: overrides && overrides.hasOwnProperty('usableForEmailMarketing') ? overrides.usableForEmailMarketing! : false,
        receiveScannerEmail: overrides && overrides.hasOwnProperty('receiveScannerEmail') ? overrides.receiveScannerEmail! : false,
        usableForSMSMarketing: overrides && overrides.hasOwnProperty('usableForSMSMarketing') ? overrides.usableForSMSMarketing! : false,
        billingAddress: overrides && overrides.hasOwnProperty('billingAddress') ? overrides.billingAddress! : relationshipsToOmit.has('PartialAddress') ? {} as PartialAddress : aPartialAddress({}, relationshipsToOmit),
        shippingAddress: overrides && overrides.hasOwnProperty('shippingAddress') ? overrides.shippingAddress! : relationshipsToOmit.has('PartialAddress') ? {} as PartialAddress : aPartialAddress({}, relationshipsToOmit),
        shippingAddressMatchesBillingAddress: overrides && overrides.hasOwnProperty('shippingAddressMatchesBillingAddress') ? overrides.shippingAddressMatchesBillingAddress! : true,
        credits: overrides && overrides.hasOwnProperty('credits') ? overrides.credits! : 8,
        points: overrides && overrides.hasOwnProperty('points') ? overrides.points! : 0.6,
        usSegment: overrides && overrides.hasOwnProperty('usSegment') ? overrides.usSegment! : relationshipsToOmit.has('UsSegment') ? {} as UsSegment : anUsSegment({}, relationshipsToOmit),
        referralId: overrides && overrides.hasOwnProperty('referralId') ? overrides.referralId! : 'verto',
        instagramUsername: overrides && overrides.hasOwnProperty('instagramUsername') ? overrides.instagramUsername! : 'atqui',
        companyName: overrides && overrides.hasOwnProperty('companyName') ? overrides.companyName! : 'acsi',
        taxNumber: overrides && overrides.hasOwnProperty('taxNumber') ? overrides.taxNumber! : 'derideo',
        region: overrides && overrides.hasOwnProperty('region') ? overrides.region! : 'solum',
        unsubscribeReason: overrides && overrides.hasOwnProperty('unsubscribeReason') ? overrides.unsubscribeReason! : UnsubscribeReason.NoLongerInterested,
        lastLoginAttemptedAt: overrides && overrides.hasOwnProperty('lastLoginAttemptedAt') ? overrides.lastLoginAttemptedAt! : 'arma',
        loginAttempts: overrides && overrides.hasOwnProperty('loginAttempts') ? overrides.loginAttempts! : 'stultus',
        otherUnsubscribeReason: overrides && overrides.hasOwnProperty('otherUnsubscribeReason') ? overrides.otherUnsubscribeReason! : 'suggero',
        lastTimeLoggedInAt: overrides && overrides.hasOwnProperty('lastTimeLoggedInAt') ? overrides.lastTimeLoggedInAt! : "2025-04-12T09:38:48.322Z",
        e164Number: overrides && overrides.hasOwnProperty('e164Number') ? overrides.e164Number! : 'attero',
        internationalPhoneNumber: overrides && overrides.hasOwnProperty('internationalPhoneNumber') ? overrides.internationalPhoneNumber! : relationshipsToOmit.has('InternationalPhoneNumberOutput') ? {} as InternationalPhoneNumberOutput : anInternationalPhoneNumberOutput({}, relationshipsToOmit),
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : [relationshipsToOmit.has('Tag') ? {} as Tag : aTag({}, relationshipsToOmit)],
        scoutCommunications: overrides && overrides.hasOwnProperty('scoutCommunications') ? overrides.scoutCommunications! : [relationshipsToOmit.has('ScoutCommunication') ? {} as ScoutCommunication : aScoutCommunication({}, relationshipsToOmit)],
        orders: overrides && overrides.hasOwnProperty('orders') ? overrides.orders! : relationshipsToOmit.has('OrderConnection') ? {} as OrderConnection : anOrderConnection({}, relationshipsToOmit),
        ticketHolderOrders: overrides && overrides.hasOwnProperty('ticketHolderOrders') ? overrides.ticketHolderOrders! : relationshipsToOmit.has('OrderConnection') ? {} as OrderConnection : anOrderConnection({}, relationshipsToOmit),
        hasOrders: overrides && overrides.hasOwnProperty('hasOrders') ? overrides.hasOrders! : true,
        membershipTickets: overrides && overrides.hasOwnProperty('membershipTickets') ? overrides.membershipTickets! : [relationshipsToOmit.has('Ticket') ? {} as Ticket : aTicket({}, relationshipsToOmit)],
        eventTickets: overrides && overrides.hasOwnProperty('eventTickets') ? overrides.eventTickets! : [relationshipsToOmit.has('Ticket') ? {} as Ticket : aTicket({}, relationshipsToOmit)],
        hasMemberships: overrides && overrides.hasOwnProperty('hasMemberships') ? overrides.hasMemberships! : false,
        hasTickets: overrides && overrides.hasOwnProperty('hasTickets') ? overrides.hasTickets! : false,
        LTV: overrides && overrides.hasOwnProperty('LTV') ? overrides.LTV! : 2.6,
        history: overrides && overrides.hasOwnProperty('history') ? overrides.history! : relationshipsToOmit.has('HistoryConnection') ? {} as HistoryConnection : aHistoryConnection({}, relationshipsToOmit),
        accessEventIds: overrides && overrides.hasOwnProperty('accessEventIds') ? overrides.accessEventIds! : ['voluptatibus'],
        accessMembershipIds: overrides && overrides.hasOwnProperty('accessMembershipIds') ? overrides.accessMembershipIds! : ['celer'],
        shopifyUser: overrides && overrides.hasOwnProperty('shopifyUser') ? overrides.shopifyUser! : relationshipsToOmit.has('ShopifyUser') ? {} as ShopifyUser : aShopifyUser({}, relationshipsToOmit),
        pfOrgHasCustomEmailDomain: overrides && overrides.hasOwnProperty('pfOrgHasCustomEmailDomain') ? overrides.pfOrgHasCustomEmailDomain! : true,
        hmac: overrides && overrides.hasOwnProperty('hmac') ? overrides.hmac! : relationshipsToOmit.has('HmacOutput') ? {} as HmacOutput : aHmacOutput({}, relationshipsToOmit),
        canConnectToPaymentTerminal: overrides && overrides.hasOwnProperty('canConnectToPaymentTerminal') ? overrides.canConnectToPaymentTerminal! : true,
        paymentTerminalGatewayId: overrides && overrides.hasOwnProperty('paymentTerminalGatewayId') ? overrides.paymentTerminalGatewayId! : 'tumultus',
        contactId: overrides && overrides.hasOwnProperty('contactId') ? overrides.contactId! : 'eum',
    };
};

export const anExportFilterColumnsInput = (overrides?: Partial<ExportFilterColumnsInput>, _relationshipsToOmit: Set<string> = new Set()): ExportFilterColumnsInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ExportFilterColumnsInput');
    return {
        exportType: overrides && overrides.hasOwnProperty('exportType') ? overrides.exportType! : ExportType.Order,
        source: overrides && overrides.hasOwnProperty('source') ? overrides.source! : PointReportingFilterSource.Overall,
        sourceId: overrides && overrides.hasOwnProperty('sourceId') ? overrides.sourceId! : 'b0ec1716-ffb1-432c-900f-e411575c04aa',
        scanType: overrides && overrides.hasOwnProperty('scanType') ? overrides.scanType! : ScanExportType.Tickets,
    };
};

export const anExportFilterCategoryOutput = (overrides?: Partial<ExportFilterCategoryOutput>, _relationshipsToOmit: Set<string> = new Set()): ExportFilterCategoryOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ExportFilterCategoryOutput');
    return {
        categories: overrides && overrides.hasOwnProperty('categories') ? overrides.categories! : [relationshipsToOmit.has('ExportFilterCategory') ? {} as ExportFilterCategory : anExportFilterCategory({}, relationshipsToOmit)],
    };
};

export const anExportFilterCategory = (overrides?: Partial<ExportFilterCategory>, _relationshipsToOmit: Set<string> = new Set()): ExportFilterCategory => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ExportFilterCategory');
    return {
        key: overrides && overrides.hasOwnProperty('key') ? overrides.key! : 'cornu',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'creptio',
        columns: overrides && overrides.hasOwnProperty('columns') ? overrides.columns! : [relationshipsToOmit.has('ExportFilterColumn') ? {} as ExportFilterColumn : anExportFilterColumn({}, relationshipsToOmit)],
    };
};

export const anExportFilterColumn = (overrides?: Partial<ExportFilterColumn>, _relationshipsToOmit: Set<string> = new Set()): ExportFilterColumn => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ExportFilterColumn');
    return {
        key: overrides && overrides.hasOwnProperty('key') ? overrides.key! : 'tamen',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'volva',
        default: overrides && overrides.hasOwnProperty('default') ? overrides.default! : false,
        tooltip: overrides && overrides.hasOwnProperty('tooltip') ? overrides.tooltip! : relationshipsToOmit.has('StatisticTooltip') ? {} as StatisticTooltip : aStatisticTooltip({}, relationshipsToOmit),
    };
};

export const aSignupFormOutput = (overrides?: Partial<SignupFormOutput>, _relationshipsToOmit: Set<string> = new Set()): SignupFormOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SignupFormOutput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'a79b5126-bfcf-4ca7-81de-3572bc4d5701',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-05-14T14:02:41.131Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-08-29T21:09:26.056Z",
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'textilis',
        heading: overrides && overrides.hasOwnProperty('heading') ? overrides.heading! : 'amplitudo',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'cilicium',
        buttonText: overrides && overrides.hasOwnProperty('buttonText') ? overrides.buttonText! : 'amita',
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : relationshipsToOmit.has('SignUpFormTagEntityIds') ? {} as SignUpFormTagEntityIds : aSignUpFormTagEntityIds({}, relationshipsToOmit),
        formFields: overrides && overrides.hasOwnProperty('formFields') ? overrides.formFields! : [relationshipsToOmit.has('SignupFormFieldOutput') ? {} as SignupFormFieldOutput : aSignupFormFieldOutput({}, relationshipsToOmit)],
        styles: overrides && overrides.hasOwnProperty('styles') ? overrides.styles! : relationshipsToOmit.has('SignupFormStyles') ? {} as SignupFormStyles : aSignupFormStyles({}, relationshipsToOmit),
        successMessage: overrides && overrides.hasOwnProperty('successMessage') ? overrides.successMessage! : 'adulescens',
        successHeading: overrides && overrides.hasOwnProperty('successHeading') ? overrides.successHeading! : 'sponte',
        processedCustomCSS: overrides && overrides.hasOwnProperty('processedCustomCSS') ? overrides.processedCustomCSS! : 'cultura',
        submissionCount: overrides && overrides.hasOwnProperty('submissionCount') ? overrides.submissionCount! : 7.1,
    };
};

export const aSignUpFormTagEntityIds = (overrides?: Partial<SignUpFormTagEntityIds>, _relationshipsToOmit: Set<string> = new Set()): SignUpFormTagEntityIds => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SignUpFormTagEntityIds');
    return {
        entityIds: overrides && overrides.hasOwnProperty('entityIds') ? overrides.entityIds! : ['deludo'],
    };
};

export const aSignupFormFieldOutput = (overrides?: Partial<SignupFormFieldOutput>, _relationshipsToOmit: Set<string> = new Set()): SignupFormFieldOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SignupFormFieldOutput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'admiratio',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'benigne',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : NamingFieldType.FirstName,
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'vicinus',
        required: overrides && overrides.hasOwnProperty('required') ? overrides.required! : true,
        options: overrides && overrides.hasOwnProperty('options') ? overrides.options! : ['repellendus'],
        orderKey: overrides && overrides.hasOwnProperty('orderKey') ? overrides.orderKey! : 1,
        isLocked: overrides && overrides.hasOwnProperty('isLocked') ? overrides.isLocked! : true,
    };
};

export const aSignupFormStyles = (overrides?: Partial<SignupFormStyles>, _relationshipsToOmit: Set<string> = new Set()): SignupFormStyles => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SignupFormStyles');
    return {
        backgroundColour: overrides && overrides.hasOwnProperty('backgroundColour') ? overrides.backgroundColour! : 'nobis',
        textColour: overrides && overrides.hasOwnProperty('textColour') ? overrides.textColour! : 'tollo',
        buttonColour: overrides && overrides.hasOwnProperty('buttonColour') ? overrides.buttonColour! : 'ambitus',
        customCSS: overrides && overrides.hasOwnProperty('customCSS') ? overrides.customCSS! : 'claustrum',
    };
};

export const aSegmentListOutput = (overrides?: Partial<SegmentListOutput>, _relationshipsToOmit: Set<string> = new Set()): SegmentListOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SegmentListOutput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'statua',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'acies',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'dolore',
        editedAt: overrides && overrides.hasOwnProperty('editedAt') ? overrides.editedAt! : "2025-05-02T05:44:38.449Z",
    };
};

export const aSegmentOutput = (overrides?: Partial<SegmentOutput>, _relationshipsToOmit: Set<string> = new Set()): SegmentOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SegmentOutput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'dicta',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'sol',
        filters: overrides && overrides.hasOwnProperty('filters') ? overrides.filters! : [relationshipsToOmit.has('BroadcastMarketingFiltersV2Output') ? {} as BroadcastMarketingFiltersV2Output : aBroadcastMarketingFiltersV2Output({}, relationshipsToOmit)],
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'cervus',
        editedAt: overrides && overrides.hasOwnProperty('editedAt') ? overrides.editedAt! : "2025-04-23T13:30:08.080Z",
    };
};

export const aSegmentCustomerCountOutput = (overrides?: Partial<SegmentCustomerCountOutput>, _relationshipsToOmit: Set<string> = new Set()): SegmentCustomerCountOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SegmentCustomerCountOutput');
    return {
        overall: overrides && overrides.hasOwnProperty('overall') ? overrides.overall! : 905,
        emailMarketing: overrides && overrides.hasOwnProperty('emailMarketing') ? overrides.emailMarketing! : 3836,
        smsMarketing: overrides && overrides.hasOwnProperty('smsMarketing') ? overrides.smsMarketing! : 6655,
    };
};

export const aMutation = (overrides?: Partial<Mutation>, _relationshipsToOmit: Set<string> = new Set()): Mutation => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Mutation');
    return {
        register: overrides && overrides.hasOwnProperty('register') ? overrides.register! : false,
        linkedAccountLogin: overrides && overrides.hasOwnProperty('linkedAccountLogin') ? overrides.linkedAccountLogin! : relationshipsToOmit.has('LinkedAccountUser') ? {} as LinkedAccountUser : aLinkedAccountUser({}, relationshipsToOmit),
        linkedAccountRegister: overrides && overrides.hasOwnProperty('linkedAccountRegister') ? overrides.linkedAccountRegister! : relationshipsToOmit.has('LinkedAccountUser') ? {} as LinkedAccountUser : aLinkedAccountUser({}, relationshipsToOmit),
        initiateLinkedAccountRegistration: overrides && overrides.hasOwnProperty('initiateLinkedAccountRegistration') ? overrides.initiateLinkedAccountRegistration! : false,
        login: overrides && overrides.hasOwnProperty('login') ? overrides.login! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        socialAuth: overrides && overrides.hasOwnProperty('socialAuth') ? overrides.socialAuth! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        logout: overrides && overrides.hasOwnProperty('logout') ? overrides.logout! : false,
        requestMagicLink: overrides && overrides.hasOwnProperty('requestMagicLink') ? overrides.requestMagicLink! : false,
        requestDeleteAccount: overrides && overrides.hasOwnProperty('requestDeleteAccount') ? overrides.requestDeleteAccount! : false,
        verifyMagicLink: overrides && overrides.hasOwnProperty('verifyMagicLink') ? overrides.verifyMagicLink! : relationshipsToOmit.has('VerifyMagicLinkOutput') ? {} as VerifyMagicLinkOutput : aVerifyMagicLinkOutput({}, relationshipsToOmit),
        verifyToken: overrides && overrides.hasOwnProperty('verifyToken') ? overrides.verifyToken! : relationshipsToOmit.has('VerifyMagicLinkOutput') ? {} as VerifyMagicLinkOutput : aVerifyMagicLinkOutput({}, relationshipsToOmit),
        requestResetPassword: overrides && overrides.hasOwnProperty('requestResetPassword') ? overrides.requestResetPassword! : false,
        resetPassword: overrides && overrides.hasOwnProperty('resetPassword') ? overrides.resetPassword! : true,
        setPasswordForNewUser: overrides && overrides.hasOwnProperty('setPasswordForNewUser') ? overrides.setPasswordForNewUser! : false,
        updatePassword: overrides && overrides.hasOwnProperty('updatePassword') ? overrides.updatePassword! : false,
        assignTwoFactorAuthenticationSecret: overrides && overrides.hasOwnProperty('assignTwoFactorAuthenticationSecret') ? overrides.assignTwoFactorAuthenticationSecret! : relationshipsToOmit.has('TwoFactorAuthenticationSetupResult') ? {} as TwoFactorAuthenticationSetupResult : aTwoFactorAuthenticationSetupResult({}, relationshipsToOmit),
        removeMultiFactorAuthenticationSecret: overrides && overrides.hasOwnProperty('removeMultiFactorAuthenticationSecret') ? overrides.removeMultiFactorAuthenticationSecret! : true,
        enableTwoFactorAuthentication: overrides && overrides.hasOwnProperty('enableTwoFactorAuthentication') ? overrides.enableTwoFactorAuthentication! : false,
        authenticateWithTwoFactor: overrides && overrides.hasOwnProperty('authenticateWithTwoFactor') ? overrides.authenticateWithTwoFactor! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        sendTwoFactorCodeViaEmail: overrides && overrides.hasOwnProperty('sendTwoFactorCodeViaEmail') ? overrides.sendTwoFactorCodeViaEmail! : false,
        verifyManageTicketsLink: overrides && overrides.hasOwnProperty('verifyManageTicketsLink') ? overrides.verifyManageTicketsLink! : relationshipsToOmit.has('VerifyManageTicketsOutput') ? {} as VerifyManageTicketsOutput : aVerifyManageTicketsOutput({}, relationshipsToOmit),
        createUser: overrides && overrides.hasOwnProperty('createUser') ? overrides.createUser! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        createPosUser: overrides && overrides.hasOwnProperty('createPosUser') ? overrides.createPosUser! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        createTemporaryPosUser: overrides && overrides.hasOwnProperty('createTemporaryPosUser') ? overrides.createTemporaryPosUser! : relationshipsToOmit.has('CreateTemporaryPosUserOutput') ? {} as CreateTemporaryPosUserOutput : aCreateTemporaryPosUserOutput({}, relationshipsToOmit),
        updatePosUser: overrides && overrides.hasOwnProperty('updatePosUser') ? overrides.updatePosUser! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        updateUser: overrides && overrides.hasOwnProperty('updateUser') ? overrides.updateUser! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        deleteUser: overrides && overrides.hasOwnProperty('deleteUser') ? overrides.deleteUser! : relationshipsToOmit.has('DeleteOneOutput') ? {} as DeleteOneOutput : aDeleteOneOutput({}, relationshipsToOmit),
        deleteSelf: overrides && overrides.hasOwnProperty('deleteSelf') ? overrides.deleteSelf! : relationshipsToOmit.has('DeleteOneOutput') ? {} as DeleteOneOutput : aDeleteOneOutput({}, relationshipsToOmit),
        updateProfile: overrides && overrides.hasOwnProperty('updateProfile') ? overrides.updateProfile! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        sendUserInvite: overrides && overrides.hasOwnProperty('sendUserInvite') ? overrides.sendUserInvite! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        importAndInviteUsers: overrides && overrides.hasOwnProperty('importAndInviteUsers') ? overrides.importAndInviteUsers! : relationshipsToOmit.has('ImportOutput') ? {} as ImportOutput : anImportOutput({}, relationshipsToOmit),
        importUsers: overrides && overrides.hasOwnProperty('importUsers') ? overrides.importUsers! : true,
        deleteRequest: overrides && overrides.hasOwnProperty('deleteRequest') ? overrides.deleteRequest! : false,
        userPaymentTerminalConnect: overrides && overrides.hasOwnProperty('userPaymentTerminalConnect') ? overrides.userPaymentTerminalConnect! : false,
        userPaymentTerminalDisconnect: overrides && overrides.hasOwnProperty('userPaymentTerminalDisconnect') ? overrides.userPaymentTerminalDisconnect! : true,
        optInMarketing: overrides && overrides.hasOwnProperty('optInMarketing') ? overrides.optInMarketing! : false,
        updateCreditsForUser: overrides && overrides.hasOwnProperty('updateCreditsForUser') ? overrides.updateCreditsForUser! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        createPos: overrides && overrides.hasOwnProperty('createPos') ? overrides.createPos! : relationshipsToOmit.has('Pos') ? {} as Pos : aPos({}, relationshipsToOmit),
        createOrUpdatePosRelease: overrides && overrides.hasOwnProperty('createOrUpdatePosRelease') ? overrides.createOrUpdatePosRelease! : relationshipsToOmit.has('Release') ? {} as Release : aRelease({}, relationshipsToOmit),
        setPosReleasePaymentOptions: overrides && overrides.hasOwnProperty('setPosReleasePaymentOptions') ? overrides.setPosReleasePaymentOptions! : relationshipsToOmit.has('ReleasePosPaymentOptions') ? {} as ReleasePosPaymentOptions : aReleasePosPaymentOptions({}, relationshipsToOmit),
        posAutoscan: overrides && overrides.hasOwnProperty('posAutoscan') ? overrides.posAutoscan! : false,
        posTerminalConnect: overrides && overrides.hasOwnProperty('posTerminalConnect') ? overrides.posTerminalConnect! : false,
        posTerminalDisconnect: overrides && overrides.hasOwnProperty('posTerminalDisconnect') ? overrides.posTerminalDisconnect! : false,
        posTerminalIdentify: overrides && overrides.hasOwnProperty('posTerminalIdentify') ? overrides.posTerminalIdentify! : true,
        posTerminalCancel: overrides && overrides.hasOwnProperty('posTerminalCancel') ? overrides.posTerminalCancel! : false,
        posTerminalConnectionToken: overrides && overrides.hasOwnProperty('posTerminalConnectionToken') ? overrides.posTerminalConnectionToken! : relationshipsToOmit.has('PosTerminalConnectionOutput') ? {} as PosTerminalConnectionOutput : aPosTerminalConnectionOutput({}, relationshipsToOmit),
        syncEventToIntellitix: overrides && overrides.hasOwnProperty('syncEventToIntellitix') ? overrides.syncEventToIntellitix! : true,
        updateForecast: overrides && overrides.hasOwnProperty('updateForecast') ? overrides.updateForecast! : relationshipsToOmit.has('EventForecastOutput') ? {} as EventForecastOutput : anEventForecastOutput({}, relationshipsToOmit),
        addForecastScenario: overrides && overrides.hasOwnProperty('addForecastScenario') ? overrides.addForecastScenario! : relationshipsToOmit.has('EventForecastOutput') ? {} as EventForecastOutput : anEventForecastOutput({}, relationshipsToOmit),
        deleteForecastScenario: overrides && overrides.hasOwnProperty('deleteForecastScenario') ? overrides.deleteForecastScenario! : relationshipsToOmit.has('EventForecastOutput') ? {} as EventForecastOutput : anEventForecastOutput({}, relationshipsToOmit),
        createEvent: overrides && overrides.hasOwnProperty('createEvent') ? overrides.createEvent! : relationshipsToOmit.has('Event') ? {} as Event : anEvent({}, relationshipsToOmit),
        updateEvent: overrides && overrides.hasOwnProperty('updateEvent') ? overrides.updateEvent! : relationshipsToOmit.has('Event') ? {} as Event : anEvent({}, relationshipsToOmit),
        duplicateEvent: overrides && overrides.hasOwnProperty('duplicateEvent') ? overrides.duplicateEvent! : 'vesica',
        addGatesToZoneAndEvent: overrides && overrides.hasOwnProperty('addGatesToZoneAndEvent') ? overrides.addGatesToZoneAndEvent! : relationshipsToOmit.has('Event') ? {} as Event : anEvent({}, relationshipsToOmit),
        toggleMultiScanning: overrides && overrides.hasOwnProperty('toggleMultiScanning') ? overrides.toggleMultiScanning! : true,
        updateTicketEntryTimeEnforcement: overrides && overrides.hasOwnProperty('updateTicketEntryTimeEnforcement') ? overrides.updateTicketEntryTimeEnforcement! : false,
        updateEventSeatSelectionDefaults: overrides && overrides.hasOwnProperty('updateEventSeatSelectionDefaults') ? overrides.updateEventSeatSelectionDefaults! : relationshipsToOmit.has('Event') ? {} as Event : anEvent({}, relationshipsToOmit),
        setTicketTypePricingTiers: overrides && overrides.hasOwnProperty('setTicketTypePricingTiers') ? overrides.setTicketTypePricingTiers! : [relationshipsToOmit.has('PricingTierOutput') ? {} as PricingTierOutput : aPricingTierOutput({}, relationshipsToOmit)],
        setTicketTypePricingTierSoldOut: overrides && overrides.hasOwnProperty('setTicketTypePricingTierSoldOut') ? overrides.setTicketTypePricingTierSoldOut! : false,
        createTicketType: overrides && overrides.hasOwnProperty('createTicketType') ? overrides.createTicketType! : relationshipsToOmit.has('TicketType') ? {} as TicketType : aTicketType({}, relationshipsToOmit),
        updateTicketType: overrides && overrides.hasOwnProperty('updateTicketType') ? overrides.updateTicketType! : relationshipsToOmit.has('TicketType') ? {} as TicketType : aTicketType({}, relationshipsToOmit),
        deleteTicketType: overrides && overrides.hasOwnProperty('deleteTicketType') ? overrides.deleteTicketType! : relationshipsToOmit.has('DeleteOneOutput') ? {} as DeleteOneOutput : aDeleteOneOutput({}, relationshipsToOmit),
        createRelease: overrides && overrides.hasOwnProperty('createRelease') ? overrides.createRelease! : relationshipsToOmit.has('Release') ? {} as Release : aRelease({}, relationshipsToOmit),
        updateRelease: overrides && overrides.hasOwnProperty('updateRelease') ? overrides.updateRelease! : relationshipsToOmit.has('Release') ? {} as Release : aRelease({}, relationshipsToOmit),
        deleteRelease: overrides && overrides.hasOwnProperty('deleteRelease') ? overrides.deleteRelease! : relationshipsToOmit.has('DeleteOneOutput') ? {} as DeleteOneOutput : aDeleteOneOutput({}, relationshipsToOmit),
        holdBestAvailableSeats: overrides && overrides.hasOwnProperty('holdBestAvailableSeats') ? overrides.holdBestAvailableSeats! : relationshipsToOmit.has('HoldBestAvailableSeatsOutput') ? {} as HoldBestAvailableSeatsOutput : aHoldBestAvailableSeatsOutput({}, relationshipsToOmit),
        validateReleasePasswordOrRelease: overrides && overrides.hasOwnProperty('validateReleasePasswordOrRelease') ? overrides.validateReleasePasswordOrRelease! : relationshipsToOmit.has('ValidateReleasePasswordOrReleaseOutput') ? {} as ValidateReleasePasswordOrReleaseOutput : aValidateReleasePasswordOrReleaseOutput({}, relationshipsToOmit),
        validateReleasePassword: overrides && overrides.hasOwnProperty('validateReleasePassword') ? overrides.validateReleasePassword! : relationshipsToOmit.has('ReleasePassword') ? {} as ReleasePassword : aReleasePassword({}, relationshipsToOmit),
        importReleasePasswords: overrides && overrides.hasOwnProperty('importReleasePasswords') ? overrides.importReleasePasswords! : true,
        duplicateSingleRelease: overrides && overrides.hasOwnProperty('duplicateSingleRelease') ? overrides.duplicateSingleRelease! : relationshipsToOmit.has('Release') ? {} as Release : aRelease({}, relationshipsToOmit),
        createEventPromoCode: overrides && overrides.hasOwnProperty('createEventPromoCode') ? overrides.createEventPromoCode! : relationshipsToOmit.has('EventPromoCode') ? {} as EventPromoCode : anEventPromoCode({}, relationshipsToOmit),
        updateEventPromoCode: overrides && overrides.hasOwnProperty('updateEventPromoCode') ? overrides.updateEventPromoCode! : relationshipsToOmit.has('EventPromoCode') ? {} as EventPromoCode : anEventPromoCode({}, relationshipsToOmit),
        deleteEventPromoCode: overrides && overrides.hasOwnProperty('deleteEventPromoCode') ? overrides.deleteEventPromoCode! : relationshipsToOmit.has('DeleteOneOutput') ? {} as DeleteOneOutput : aDeleteOneOutput({}, relationshipsToOmit),
        createEventMultiBuyPromotion: overrides && overrides.hasOwnProperty('createEventMultiBuyPromotion') ? overrides.createEventMultiBuyPromotion! : relationshipsToOmit.has('EventMultiBuyPromotion') ? {} as EventMultiBuyPromotion : anEventMultiBuyPromotion({}, relationshipsToOmit),
        updateEventMultiBuyPromotion: overrides && overrides.hasOwnProperty('updateEventMultiBuyPromotion') ? overrides.updateEventMultiBuyPromotion! : relationshipsToOmit.has('EventMultiBuyPromotion') ? {} as EventMultiBuyPromotion : anEventMultiBuyPromotion({}, relationshipsToOmit),
        deleteEventMultiBuyPromotion: overrides && overrides.hasOwnProperty('deleteEventMultiBuyPromotion') ? overrides.deleteEventMultiBuyPromotion! : relationshipsToOmit.has('DeleteOneOutput') ? {} as DeleteOneOutput : aDeleteOneOutput({}, relationshipsToOmit),
        createEventAddon: overrides && overrides.hasOwnProperty('createEventAddon') ? overrides.createEventAddon! : relationshipsToOmit.has('EventAddon') ? {} as EventAddon : anEventAddon({}, relationshipsToOmit),
        updateEventAddon: overrides && overrides.hasOwnProperty('updateEventAddon') ? overrides.updateEventAddon! : relationshipsToOmit.has('EventAddon') ? {} as EventAddon : anEventAddon({}, relationshipsToOmit),
        deleteEventAddon: overrides && overrides.hasOwnProperty('deleteEventAddon') ? overrides.deleteEventAddon! : relationshipsToOmit.has('DeleteOneOutput') ? {} as DeleteOneOutput : aDeleteOneOutput({}, relationshipsToOmit),
        addGatesToScannableGatesId: overrides && overrides.hasOwnProperty('addGatesToScannableGatesId') ? overrides.addGatesToScannableGatesId! : relationshipsToOmit.has('EventAddon') ? {} as EventAddon : anEventAddon({}, relationshipsToOmit),
        createReleaseZone: overrides && overrides.hasOwnProperty('createReleaseZone') ? overrides.createReleaseZone! : relationshipsToOmit.has('ReleaseZone') ? {} as ReleaseZone : aReleaseZone({}, relationshipsToOmit),
        updateReleaseZone: overrides && overrides.hasOwnProperty('updateReleaseZone') ? overrides.updateReleaseZone! : relationshipsToOmit.has('ReleaseZone') ? {} as ReleaseZone : aReleaseZone({}, relationshipsToOmit),
        deleteReleaseZone: overrides && overrides.hasOwnProperty('deleteReleaseZone') ? overrides.deleteReleaseZone! : false,
        reorderTicketTypes: overrides && overrides.hasOwnProperty('reorderTicketTypes') ? overrides.reorderTicketTypes! : relationshipsToOmit.has('ReleaseZone') ? {} as ReleaseZone : aReleaseZone({}, relationshipsToOmit),
        createOrUpdateAccessCodeRelease: overrides && overrides.hasOwnProperty('createOrUpdateAccessCodeRelease') ? overrides.createOrUpdateAccessCodeRelease! : relationshipsToOmit.has('AccessCodeReleaseOutput') ? {} as AccessCodeReleaseOutput : anAccessCodeReleaseOutput({}, relationshipsToOmit),
        deleteAccessCode: overrides && overrides.hasOwnProperty('deleteAccessCode') ? overrides.deleteAccessCode! : relationshipsToOmit.has('AccessCodeReleaseOutput') ? {} as AccessCodeReleaseOutput : anAccessCodeReleaseOutput({}, relationshipsToOmit),
        updateAccessCode: overrides && overrides.hasOwnProperty('updateAccessCode') ? overrides.updateAccessCode! : relationshipsToOmit.has('AccessCodeOutput') ? {} as AccessCodeOutput : anAccessCodeOutput({}, relationshipsToOmit),
        createOrUpdatePresale: overrides && overrides.hasOwnProperty('createOrUpdatePresale') ? overrides.createOrUpdatePresale! : relationshipsToOmit.has('PresaleReleaseOutput') ? {} as PresaleReleaseOutput : aPresaleReleaseOutput({}, relationshipsToOmit),
        deletePresale: overrides && overrides.hasOwnProperty('deletePresale') ? overrides.deletePresale! : true,
        enablePresale: overrides && overrides.hasOwnProperty('enablePresale') ? overrides.enablePresale! : false,
        createOrUpdateNamingField: overrides && overrides.hasOwnProperty('createOrUpdateNamingField') ? overrides.createOrUpdateNamingField! : relationshipsToOmit.has('NamingFieldOutput') ? {} as NamingFieldOutput : aNamingFieldOutput({}, relationshipsToOmit),
        deleteNamingField: overrides && overrides.hasOwnProperty('deleteNamingField') ? overrides.deleteNamingField! : false,
        toggleNamingFields: overrides && overrides.hasOwnProperty('toggleNamingFields') ? overrides.toggleNamingFields! : true,
        toggleCanRename: overrides && overrides.hasOwnProperty('toggleCanRename') ? overrides.toggleCanRename! : false,
        resendUsherTicket: overrides && overrides.hasOwnProperty('resendUsherTicket') ? overrides.resendUsherTicket! : false,
        createUsherTicketType: overrides && overrides.hasOwnProperty('createUsherTicketType') ? overrides.createUsherTicketType! : relationshipsToOmit.has('TicketType') ? {} as TicketType : aTicketType({}, relationshipsToOmit),
        updateUsherTicketTypeName: overrides && overrides.hasOwnProperty('updateUsherTicketTypeName') ? overrides.updateUsherTicketTypeName! : relationshipsToOmit.has('TicketType') ? {} as TicketType : aTicketType({}, relationshipsToOmit),
        disableUsherTicketType: overrides && overrides.hasOwnProperty('disableUsherTicketType') ? overrides.disableUsherTicketType! : true,
        deleteUsherTicketType: overrides && overrides.hasOwnProperty('deleteUsherTicketType') ? overrides.deleteUsherTicketType! : true,
        createSeason: overrides && overrides.hasOwnProperty('createSeason') ? overrides.createSeason! : relationshipsToOmit.has('Season') ? {} as Season : aSeason({}, relationshipsToOmit),
        updateSeason: overrides && overrides.hasOwnProperty('updateSeason') ? overrides.updateSeason! : relationshipsToOmit.has('Season') ? {} as Season : aSeason({}, relationshipsToOmit),
        completeStripeSetup: overrides && overrides.hasOwnProperty('completeStripeSetup') ? overrides.completeStripeSetup! : relationshipsToOmit.has('Integration') ? {} as Integration : anIntegration({}, relationshipsToOmit),
        createIntegration: overrides && overrides.hasOwnProperty('createIntegration') ? overrides.createIntegration! : relationshipsToOmit.has('Integration') ? {} as Integration : anIntegration({}, relationshipsToOmit),
        updateIntegration: overrides && overrides.hasOwnProperty('updateIntegration') ? overrides.updateIntegration! : relationshipsToOmit.has('Integration') ? {} as Integration : anIntegration({}, relationshipsToOmit),
        deleteIntegration: overrides && overrides.hasOwnProperty('deleteIntegration') ? overrides.deleteIntegration! : false,
        rollIntegrationApiKey: overrides && overrides.hasOwnProperty('rollIntegrationApiKey') ? overrides.rollIntegrationApiKey! : relationshipsToOmit.has('Integration') ? {} as Integration : anIntegration({}, relationshipsToOmit),
        completeStripeOAuthSetup: overrides && overrides.hasOwnProperty('completeStripeOAuthSetup') ? overrides.completeStripeOAuthSetup! : relationshipsToOmit.has('CompleteStripeOAuth') ? {} as CompleteStripeOAuth : aCompleteStripeOAuth({}, relationshipsToOmit),
        setXeroConfiguration: overrides && overrides.hasOwnProperty('setXeroConfiguration') ? overrides.setXeroConfiguration! : relationshipsToOmit.has('XeroConfigurationOutput') ? {} as XeroConfigurationOutput : aXeroConfigurationOutput({}, relationshipsToOmit),
        enableXeroIntegration: overrides && overrides.hasOwnProperty('enableXeroIntegration') ? overrides.enableXeroIntegration! : false,
        completeShopifySetup: overrides && overrides.hasOwnProperty('completeShopifySetup') ? overrides.completeShopifySetup! : false,
        upsertAdobeIntegration: overrides && overrides.hasOwnProperty('upsertAdobeIntegration') ? overrides.upsertAdobeIntegration! : relationshipsToOmit.has('AdobeExperiencePlatformIntegration') ? {} as AdobeExperiencePlatformIntegration : anAdobeExperiencePlatformIntegration({}, relationshipsToOmit),
        createOrganization: overrides && overrides.hasOwnProperty('createOrganization') ? overrides.createOrganization! : relationshipsToOmit.has('CreateOrganizationOutput') ? {} as CreateOrganizationOutput : aCreateOrganizationOutput({}, relationshipsToOmit),
        updateOrganization: overrides && overrides.hasOwnProperty('updateOrganization') ? overrides.updateOrganization! : relationshipsToOmit.has('Organization') ? {} as Organization : anOrganization({}, relationshipsToOmit),
        updateOrganizationById: overrides && overrides.hasOwnProperty('updateOrganizationById') ? overrides.updateOrganizationById! : relationshipsToOmit.has('Organization') ? {} as Organization : anOrganization({}, relationshipsToOmit),
        uploadImage: overrides && overrides.hasOwnProperty('uploadImage') ? overrides.uploadImage! : 'adhuc',
        updateCalendarHomepageCustomization: overrides && overrides.hasOwnProperty('updateCalendarHomepageCustomization') ? overrides.updateCalendarHomepageCustomization! : relationshipsToOmit.has('CalendarHomepageCustomization') ? {} as CalendarHomepageCustomization : aCalendarHomepageCustomization({}, relationshipsToOmit),
        syncOrderToIntellitix: overrides && overrides.hasOwnProperty('syncOrderToIntellitix') ? overrides.syncOrderToIntellitix! : relationshipsToOmit.has('Order') ? {} as Order : anOrder({}, relationshipsToOmit),
        createOrder: overrides && overrides.hasOwnProperty('createOrder') ? overrides.createOrder! : relationshipsToOmit.has('OrderCreateOutput') ? {} as OrderCreateOutput : anOrderCreateOutput({}, relationshipsToOmit),
        createCompOrder: overrides && overrides.hasOwnProperty('createCompOrder') ? overrides.createCompOrder! : relationshipsToOmit.has('Order') ? {} as Order : anOrder({}, relationshipsToOmit),
        updateOrder: overrides && overrides.hasOwnProperty('updateOrder') ? overrides.updateOrder! : relationshipsToOmit.has('Order') ? {} as Order : anOrder({}, relationshipsToOmit),
        updateHoldOrder: overrides && overrides.hasOwnProperty('updateHoldOrder') ? overrides.updateHoldOrder! : relationshipsToOmit.has('Order') ? {} as Order : anOrder({}, relationshipsToOmit),
        splitHoldOrder: overrides && overrides.hasOwnProperty('splitHoldOrder') ? overrides.splitHoldOrder! : relationshipsToOmit.has('Order') ? {} as Order : anOrder({}, relationshipsToOmit),
        releaseSeats: overrides && overrides.hasOwnProperty('releaseSeats') ? overrides.releaseSeats! : relationshipsToOmit.has('Order') ? {} as Order : anOrder({}, relationshipsToOmit),
        createPayment: overrides && overrides.hasOwnProperty('createPayment') ? overrides.createPayment! : relationshipsToOmit.has('CreatePaymentOutput') ? {} as CreatePaymentOutput : aCreatePaymentOutput({}, relationshipsToOmit),
        applyPromoCodeToOrder: overrides && overrides.hasOwnProperty('applyPromoCodeToOrder') ? overrides.applyPromoCodeToOrder! : relationshipsToOmit.has('Order') ? {} as Order : anOrder({}, relationshipsToOmit),
        updateTicketCoverForOrder: overrides && overrides.hasOwnProperty('updateTicketCoverForOrder') ? overrides.updateTicketCoverForOrder! : relationshipsToOmit.has('Order') ? {} as Order : anOrder({}, relationshipsToOmit),
        removePromoCodeFromOrder: overrides && overrides.hasOwnProperty('removePromoCodeFromOrder') ? overrides.removePromoCodeFromOrder! : relationshipsToOmit.has('Order') ? {} as Order : anOrder({}, relationshipsToOmit),
        holdCustomerOrder: overrides && overrides.hasOwnProperty('holdCustomerOrder') ? overrides.holdCustomerOrder! : relationshipsToOmit.has('Order') ? {} as Order : anOrder({}, relationshipsToOmit),
        updateOrderStatus: overrides && overrides.hasOwnProperty('updateOrderStatus') ? overrides.updateOrderStatus! : relationshipsToOmit.has('Order') ? {} as Order : anOrder({}, relationshipsToOmit),
        completePreprintTicketOrder: overrides && overrides.hasOwnProperty('completePreprintTicketOrder') ? overrides.completePreprintTicketOrder! : relationshipsToOmit.has('Order') ? {} as Order : anOrder({}, relationshipsToOmit),
        addPosTransaction: overrides && overrides.hasOwnProperty('addPosTransaction') ? overrides.addPosTransaction! : relationshipsToOmit.has('PosTransaction') ? {} as PosTransaction : aPosTransaction({}, relationshipsToOmit),
        removePosTransaction: overrides && overrides.hasOwnProperty('removePosTransaction') ? overrides.removePosTransaction! : relationshipsToOmit.has('Order') ? {} as Order : anOrder({}, relationshipsToOmit),
        finishPosTransaction: overrides && overrides.hasOwnProperty('finishPosTransaction') ? overrides.finishPosTransaction! : relationshipsToOmit.has('Order') ? {} as Order : anOrder({}, relationshipsToOmit),
        sendOrderConfirmation: overrides && overrides.hasOwnProperty('sendOrderConfirmation') ? overrides.sendOrderConfirmation! : relationshipsToOmit.has('SendOrderConfirmationOutput') ? {} as SendOrderConfirmationOutput : aSendOrderConfirmationOutput({}, relationshipsToOmit),
        sendInternalOrderReceipt: overrides && overrides.hasOwnProperty('sendInternalOrderReceipt') ? overrides.sendInternalOrderReceipt! : relationshipsToOmit.has('SendOrderConfirmationOutput') ? {} as SendOrderConfirmationOutput : aSendOrderConfirmationOutput({}, relationshipsToOmit),
        cancelOrder: overrides && overrides.hasOwnProperty('cancelOrder') ? overrides.cancelOrder! : relationshipsToOmit.has('Order') ? {} as Order : anOrder({}, relationshipsToOmit),
        cancelOrderPaymentPlan: overrides && overrides.hasOwnProperty('cancelOrderPaymentPlan') ? overrides.cancelOrderPaymentPlan! : true,
        expireOrder: overrides && overrides.hasOwnProperty('expireOrder') ? overrides.expireOrder! : relationshipsToOmit.has('Order') ? {} as Order : anOrder({}, relationshipsToOmit),
        generateXeroInvoiceForOrder: overrides && overrides.hasOwnProperty('generateXeroInvoiceForOrder') ? overrides.generateXeroInvoiceForOrder! : 'suadeo',
        splitGroupOrder: overrides && overrides.hasOwnProperty('splitGroupOrder') ? overrides.splitGroupOrder! : relationshipsToOmit.has('Order') ? {} as Order : anOrder({}, relationshipsToOmit),
        createBulkOrders: overrides && overrides.hasOwnProperty('createBulkOrders') ? overrides.createBulkOrders! : true,
        createRefund: overrides && overrides.hasOwnProperty('createRefund') ? overrides.createRefund! : relationshipsToOmit.has('Refund') ? {} as Refund : aRefund({}, relationshipsToOmit),
        automaticallyAttribute: overrides && overrides.hasOwnProperty('automaticallyAttribute') ? overrides.automaticallyAttribute! : true,
        createAttributableRefund: overrides && overrides.hasOwnProperty('createAttributableRefund') ? overrides.createAttributableRefund! : false,
        createPurchaseRestriction: overrides && overrides.hasOwnProperty('createPurchaseRestriction') ? overrides.createPurchaseRestriction! : relationshipsToOmit.has('PurchaseRestriction') ? {} as PurchaseRestriction : aPurchaseRestriction({}, relationshipsToOmit),
        updatePurchaseRestriction: overrides && overrides.hasOwnProperty('updatePurchaseRestriction') ? overrides.updatePurchaseRestriction! : relationshipsToOmit.has('PurchaseRestriction') ? {} as PurchaseRestriction : aPurchaseRestriction({}, relationshipsToOmit),
        deletePurchaseRestriction: overrides && overrides.hasOwnProperty('deletePurchaseRestriction') ? overrides.deletePurchaseRestriction! : relationshipsToOmit.has('DeleteOneOutput') ? {} as DeleteOneOutput : aDeleteOneOutput({}, relationshipsToOmit),
        createHistory: overrides && overrides.hasOwnProperty('createHistory') ? overrides.createHistory! : relationshipsToOmit.has('History') ? {} as History : aHistory({}, relationshipsToOmit),
        createVenue: overrides && overrides.hasOwnProperty('createVenue') ? overrides.createVenue! : relationshipsToOmit.has('Venue') ? {} as Venue : aVenue({}, relationshipsToOmit),
        updateVenue: overrides && overrides.hasOwnProperty('updateVenue') ? overrides.updateVenue! : relationshipsToOmit.has('Venue') ? {} as Venue : aVenue({}, relationshipsToOmit),
        updateVenueZones: overrides && overrides.hasOwnProperty('updateVenueZones') ? overrides.updateVenueZones! : relationshipsToOmit.has('Venue') ? {} as Venue : aVenue({}, relationshipsToOmit),
        deleteVenue: overrides && overrides.hasOwnProperty('deleteVenue') ? overrides.deleteVenue! : relationshipsToOmit.has('DeleteOneOutput') ? {} as DeleteOneOutput : aDeleteOneOutput({}, relationshipsToOmit),
        updateVenueCapacity: overrides && overrides.hasOwnProperty('updateVenueCapacity') ? overrides.updateVenueCapacity! : true,
        updateDefaultSeatSelectionFilters: overrides && overrides.hasOwnProperty('updateDefaultSeatSelectionFilters') ? overrides.updateDefaultSeatSelectionFilters! : true,
        reorderZones: overrides && overrides.hasOwnProperty('reorderZones') ? overrides.reorderZones! : [relationshipsToOmit.has('Zone') ? {} as Zone : aZone({}, relationshipsToOmit)],
        createMembership: overrides && overrides.hasOwnProperty('createMembership') ? overrides.createMembership! : relationshipsToOmit.has('Membership') ? {} as Membership : aMembership({}, relationshipsToOmit),
        updateMembership: overrides && overrides.hasOwnProperty('updateMembership') ? overrides.updateMembership! : relationshipsToOmit.has('Membership') ? {} as Membership : aMembership({}, relationshipsToOmit),
        duplicateMembership: overrides && overrides.hasOwnProperty('duplicateMembership') ? overrides.duplicateMembership! : 'curriculum',
        releaseAllMembershipHolds: overrides && overrides.hasOwnProperty('releaseAllMembershipHolds') ? overrides.releaseAllMembershipHolds! : false,
        updateExchangeableEvents: overrides && overrides.hasOwnProperty('updateExchangeableEvents') ? overrides.updateExchangeableEvents! : false,
        upsertMembershipTypeEventTransferPrices: overrides && overrides.hasOwnProperty('upsertMembershipTypeEventTransferPrices') ? overrides.upsertMembershipTypeEventTransferPrices! : [relationshipsToOmit.has('MembershipTypeEventTransferPrice') ? {} as MembershipTypeEventTransferPrice : aMembershipTypeEventTransferPrice({}, relationshipsToOmit)],
        createMembershipType: overrides && overrides.hasOwnProperty('createMembershipType') ? overrides.createMembershipType! : relationshipsToOmit.has('MembershipType') ? {} as MembershipType : aMembershipType({}, relationshipsToOmit),
        updateMembershipType: overrides && overrides.hasOwnProperty('updateMembershipType') ? overrides.updateMembershipType! : relationshipsToOmit.has('MembershipType') ? {} as MembershipType : aMembershipType({}, relationshipsToOmit),
        deleteMembershipType: overrides && overrides.hasOwnProperty('deleteMembershipType') ? overrides.deleteMembershipType! : relationshipsToOmit.has('DeleteOneOutput') ? {} as DeleteOneOutput : aDeleteOneOutput({}, relationshipsToOmit),
        createMembershipAddon: overrides && overrides.hasOwnProperty('createMembershipAddon') ? overrides.createMembershipAddon! : relationshipsToOmit.has('MembershipAddon') ? {} as MembershipAddon : aMembershipAddon({}, relationshipsToOmit),
        updateMembershipAddon: overrides && overrides.hasOwnProperty('updateMembershipAddon') ? overrides.updateMembershipAddon! : relationshipsToOmit.has('MembershipAddon') ? {} as MembershipAddon : aMembershipAddon({}, relationshipsToOmit),
        deleteMembershipAddon: overrides && overrides.hasOwnProperty('deleteMembershipAddon') ? overrides.deleteMembershipAddon! : relationshipsToOmit.has('DeleteOneOutput') ? {} as DeleteOneOutput : aDeleteOneOutput({}, relationshipsToOmit),
        createMembershipPromoCode: overrides && overrides.hasOwnProperty('createMembershipPromoCode') ? overrides.createMembershipPromoCode! : relationshipsToOmit.has('MembershipPromoCode') ? {} as MembershipPromoCode : aMembershipPromoCode({}, relationshipsToOmit),
        updateMembershipPromoCode: overrides && overrides.hasOwnProperty('updateMembershipPromoCode') ? overrides.updateMembershipPromoCode! : relationshipsToOmit.has('MembershipPromoCode') ? {} as MembershipPromoCode : aMembershipPromoCode({}, relationshipsToOmit),
        deleteMembershipPromoCode: overrides && overrides.hasOwnProperty('deleteMembershipPromoCode') ? overrides.deleteMembershipPromoCode! : relationshipsToOmit.has('DeleteOneOutput') ? {} as DeleteOneOutput : aDeleteOneOutput({}, relationshipsToOmit),
        createMembershipMultiBuyPromotion: overrides && overrides.hasOwnProperty('createMembershipMultiBuyPromotion') ? overrides.createMembershipMultiBuyPromotion! : relationshipsToOmit.has('MembershipMultiBuyPromotion') ? {} as MembershipMultiBuyPromotion : aMembershipMultiBuyPromotion({}, relationshipsToOmit),
        updateMembershipMultiBuyPromotion: overrides && overrides.hasOwnProperty('updateMembershipMultiBuyPromotion') ? overrides.updateMembershipMultiBuyPromotion! : relationshipsToOmit.has('MembershipMultiBuyPromotion') ? {} as MembershipMultiBuyPromotion : aMembershipMultiBuyPromotion({}, relationshipsToOmit),
        deleteMembershipMultiBuyPromotion: overrides && overrides.hasOwnProperty('deleteMembershipMultiBuyPromotion') ? overrides.deleteMembershipMultiBuyPromotion! : relationshipsToOmit.has('DeleteOneOutput') ? {} as DeleteOneOutput : aDeleteOneOutput({}, relationshipsToOmit),
        createOrUpdateMembershipAutoRenewal: overrides && overrides.hasOwnProperty('createOrUpdateMembershipAutoRenewal') ? overrides.createOrUpdateMembershipAutoRenewal! : relationshipsToOmit.has('MembershipAutoRenewal') ? {} as MembershipAutoRenewal : aMembershipAutoRenewal({}, relationshipsToOmit),
        deleteMembershipAutoRenewalOrders: overrides && overrides.hasOwnProperty('deleteMembershipAutoRenewalOrders') ? overrides.deleteMembershipAutoRenewalOrders! : true,
        createScout: overrides && overrides.hasOwnProperty('createScout') ? overrides.createScout! : relationshipsToOmit.has('Scout') ? {} as Scout : aScout({}, relationshipsToOmit),
        updateScout: overrides && overrides.hasOwnProperty('updateScout') ? overrides.updateScout! : relationshipsToOmit.has('Scout') ? {} as Scout : aScout({}, relationshipsToOmit),
        updateScoutUsers: overrides && overrides.hasOwnProperty('updateScoutUsers') ? overrides.updateScoutUsers! : true,
        deleteScoutUsers: overrides && overrides.hasOwnProperty('deleteScoutUsers') ? overrides.deleteScoutUsers! : true,
        createScoutCommunication: overrides && overrides.hasOwnProperty('createScoutCommunication') ? overrides.createScoutCommunication! : relationshipsToOmit.has('ScoutCommunication') ? {} as ScoutCommunication : aScoutCommunication({}, relationshipsToOmit),
        updateScoutCommunication: overrides && overrides.hasOwnProperty('updateScoutCommunication') ? overrides.updateScoutCommunication! : relationshipsToOmit.has('ScoutCommunication') ? {} as ScoutCommunication : aScoutCommunication({}, relationshipsToOmit),
        createTestEmail: overrides && overrides.hasOwnProperty('createTestEmail') ? overrides.createTestEmail! : true,
        updateScoutCommunicationUser: overrides && overrides.hasOwnProperty('updateScoutCommunicationUser') ? overrides.updateScoutCommunicationUser! : relationshipsToOmit.has('ScoutCommunicationUser') ? {} as ScoutCommunicationUser : aScoutCommunicationUser({}, relationshipsToOmit),
        addReminderToScoutCommunicationUser: overrides && overrides.hasOwnProperty('addReminderToScoutCommunicationUser') ? overrides.addReminderToScoutCommunicationUser! : false,
        clearReminderFromScoutCommunicationUser: overrides && overrides.hasOwnProperty('clearReminderFromScoutCommunicationUser') ? overrides.clearReminderFromScoutCommunicationUser! : true,
        assignScoutCommunicationUsersToAgent: overrides && overrides.hasOwnProperty('assignScoutCommunicationUsersToAgent') ? overrides.assignScoutCommunicationUsersToAgent! : true,
        createTag: overrides && overrides.hasOwnProperty('createTag') ? overrides.createTag! : relationshipsToOmit.has('Tag') ? {} as Tag : aTag({}, relationshipsToOmit),
        updateTag: overrides && overrides.hasOwnProperty('updateTag') ? overrides.updateTag! : relationshipsToOmit.has('Tag') ? {} as Tag : aTag({}, relationshipsToOmit),
        tagEntities: overrides && overrides.hasOwnProperty('tagEntities') ? overrides.tagEntities! : ['velut'],
        deleteTag: overrides && overrides.hasOwnProperty('deleteTag') ? overrides.deleteTag! : false,
        updateTicketHolder: overrides && overrides.hasOwnProperty('updateTicketHolder') ? overrides.updateTicketHolder! : relationshipsToOmit.has('Ticket') ? {} as Ticket : aTicket({}, relationshipsToOmit),
        releaseClaimsForNextMembership: overrides && overrides.hasOwnProperty('releaseClaimsForNextMembership') ? overrides.releaseClaimsForNextMembership! : [relationshipsToOmit.has('Ticket') ? {} as Ticket : aTicket({}, relationshipsToOmit)],
        listTicketForResale: overrides && overrides.hasOwnProperty('listTicketForResale') ? overrides.listTicketForResale! : false,
        unlistTicketForResale: overrides && overrides.hasOwnProperty('unlistTicketForResale') ? overrides.unlistTicketForResale! : false,
        ticketTransferRetryRefund: overrides && overrides.hasOwnProperty('ticketTransferRetryRefund') ? overrides.ticketTransferRetryRefund! : false,
        requestTicketTransfer: overrides && overrides.hasOwnProperty('requestTicketTransfer') ? overrides.requestTicketTransfer! : false,
        cancelPendingTicketTransfer: overrides && overrides.hasOwnProperty('cancelPendingTicketTransfer') ? overrides.cancelPendingTicketTransfer! : true,
        sendTicket: overrides && overrides.hasOwnProperty('sendTicket') ? overrides.sendTicket! : false,
        scanTicket: overrides && overrides.hasOwnProperty('scanTicket') ? overrides.scanTicket! : relationshipsToOmit.has('ScanTicketOutput') ? {} as ScanTicketOutput : aScanTicketOutput({}, relationshipsToOmit),
        redeemTicket: overrides && overrides.hasOwnProperty('redeemTicket') ? overrides.redeemTicket! : relationshipsToOmit.has('ScanTicketOutput') ? {} as ScanTicketOutput : aScanTicketOutput({}, relationshipsToOmit),
        scanVaccinePass: overrides && overrides.hasOwnProperty('scanVaccinePass') ? overrides.scanVaccinePass! : true,
        scanTicketBulk: overrides && overrides.hasOwnProperty('scanTicketBulk') ? overrides.scanTicketBulk! : [relationshipsToOmit.has('ScanTicketOutput') ? {} as ScanTicketOutput : aScanTicketOutput({}, relationshipsToOmit)],
        importDigitalPassCodesForEvent: overrides && overrides.hasOwnProperty('importDigitalPassCodesForEvent') ? overrides.importDigitalPassCodesForEvent! : true,
        importDigitalPassCodesForMembership: overrides && overrides.hasOwnProperty('importDigitalPassCodesForMembership') ? overrides.importDigitalPassCodesForMembership! : false,
        createPinPaymentCharge: overrides && overrides.hasOwnProperty('createPinPaymentCharge') ? overrides.createPinPaymentCharge! : relationshipsToOmit.has('PinPaymentChargeResponse') ? {} as PinPaymentChargeResponse : aPinPaymentChargeResponse({}, relationshipsToOmit),
        verifyPinPayment3DS: overrides && overrides.hasOwnProperty('verifyPinPayment3DS') ? overrides.verifyPinPayment3DS! : relationshipsToOmit.has('PinPaymentChargeResponse') ? {} as PinPaymentChargeResponse : aPinPaymentChargeResponse({}, relationshipsToOmit),
        handleInstagramCode: overrides && overrides.hasOwnProperty('handleInstagramCode') ? overrides.handleInstagramCode! : 'bellum',
        createPoint: overrides && overrides.hasOwnProperty('createPoint') ? overrides.createPoint! : relationshipsToOmit.has('Point') ? {} as Point : aPoint({}, relationshipsToOmit),
        updatePoint: overrides && overrides.hasOwnProperty('updatePoint') ? overrides.updatePoint! : relationshipsToOmit.has('Point') ? {} as Point : aPoint({}, relationshipsToOmit),
        createPointItem: overrides && overrides.hasOwnProperty('createPointItem') ? overrides.createPointItem! : relationshipsToOmit.has('PointItem') ? {} as PointItem : aPointItem({}, relationshipsToOmit),
        updatePointItem: overrides && overrides.hasOwnProperty('updatePointItem') ? overrides.updatePointItem! : relationshipsToOmit.has('PointItem') ? {} as PointItem : aPointItem({}, relationshipsToOmit),
        addAuditLog: overrides && overrides.hasOwnProperty('addAuditLog') ? overrides.addAuditLog! : false,
        addUnsubscribeReason: overrides && overrides.hasOwnProperty('addUnsubscribeReason') ? overrides.addUnsubscribeReason! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        resubscribe: overrides && overrides.hasOwnProperty('resubscribe') ? overrides.resubscribe! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        unsubscribeFromMarketing: overrides && overrides.hasOwnProperty('unsubscribeFromMarketing') ? overrides.unsubscribeFromMarketing! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        unsubscribe: overrides && overrides.hasOwnProperty('unsubscribe') ? overrides.unsubscribe! : relationshipsToOmit.has('MarketingPreferenceUnsubscribeOutput') ? {} as MarketingPreferenceUnsubscribeOutput : aMarketingPreferenceUnsubscribeOutput({}, relationshipsToOmit),
        addUnsubscribeReasonV2: overrides && overrides.hasOwnProperty('addUnsubscribeReasonV2') ? overrides.addUnsubscribeReasonV2! : true,
        resubscribeV2: overrides && overrides.hasOwnProperty('resubscribeV2') ? overrides.resubscribeV2! : false,
        sendScannerEmail: overrides && overrides.hasOwnProperty('sendScannerEmail') ? overrides.sendScannerEmail! : relationshipsToOmit.has('ScannerEmailOutput') ? {} as ScannerEmailOutput : aScannerEmailOutput({}, relationshipsToOmit),
        emailCustomization: overrides && overrides.hasOwnProperty('emailCustomization') ? overrides.emailCustomization! : relationshipsToOmit.has('EmailCustomizationOutput') ? {} as EmailCustomizationOutput : anEmailCustomizationOutput({}, relationshipsToOmit),
        emailCustomizationUpsert: overrides && overrides.hasOwnProperty('emailCustomizationUpsert') ? overrides.emailCustomizationUpsert! : relationshipsToOmit.has('EmailCustomizationOutput') ? {} as EmailCustomizationOutput : anEmailCustomizationOutput({}, relationshipsToOmit),
        emailCustomizationSendTest: overrides && overrides.hasOwnProperty('emailCustomizationSendTest') ? overrides.emailCustomizationSendTest! : false,
        emailCustomizationEnable: overrides && overrides.hasOwnProperty('emailCustomizationEnable') ? overrides.emailCustomizationEnable! : relationshipsToOmit.has('EmailCustomizationOutput') ? {} as EmailCustomizationOutput : anEmailCustomizationOutput({}, relationshipsToOmit),
        copyEmail: overrides && overrides.hasOwnProperty('copyEmail') ? overrides.copyEmail! : true,
        emailCustomizationPublish: overrides && overrides.hasOwnProperty('emailCustomizationPublish') ? overrides.emailCustomizationPublish! : relationshipsToOmit.has('EmailCustomizationOutput') ? {} as EmailCustomizationOutput : anEmailCustomizationOutput({}, relationshipsToOmit),
        emailCustomizationUnpublish: overrides && overrides.hasOwnProperty('emailCustomizationUnpublish') ? overrides.emailCustomizationUnpublish! : relationshipsToOmit.has('EmailCustomizationOutput') ? {} as EmailCustomizationOutput : anEmailCustomizationOutput({}, relationshipsToOmit),
        addExhibitor: overrides && overrides.hasOwnProperty('addExhibitor') ? overrides.addExhibitor! : relationshipsToOmit.has('ExpoExhibitor') ? {} as ExpoExhibitor : anExpoExhibitor({}, relationshipsToOmit),
        updateExhibitor: overrides && overrides.hasOwnProperty('updateExhibitor') ? overrides.updateExhibitor! : relationshipsToOmit.has('ExpoExhibitor') ? {} as ExpoExhibitor : anExpoExhibitor({}, relationshipsToOmit),
        deleteExhibitor: overrides && overrides.hasOwnProperty('deleteExhibitor') ? overrides.deleteExhibitor! : true,
        invalidateExhibitorCredentials: overrides && overrides.hasOwnProperty('invalidateExhibitorCredentials') ? overrides.invalidateExhibitorCredentials! : relationshipsToOmit.has('ExpoExhibitor') ? {} as ExpoExhibitor : anExpoExhibitor({}, relationshipsToOmit),
        importExhibitors: overrides && overrides.hasOwnProperty('importExhibitors') ? overrides.importExhibitors! : relationshipsToOmit.has('ImportExhibitorOutput') ? {} as ImportExhibitorOutput : anImportExhibitorOutput({}, relationshipsToOmit),
        exhibitorLogin: overrides && overrides.hasOwnProperty('exhibitorLogin') ? overrides.exhibitorLogin! : relationshipsToOmit.has('ExhibitorLoginSuccess') ? {} as ExhibitorLoginSuccess : anExhibitorLoginSuccess({}, relationshipsToOmit),
        resendExhibitorLoginEmail: overrides && overrides.hasOwnProperty('resendExhibitorLoginEmail') ? overrides.resendExhibitorLoginEmail! : relationshipsToOmit.has('ResendExhibitorLoginEmailSuccess') ? {} as ResendExhibitorLoginEmailSuccess : aResendExhibitorLoginEmailSuccess({}, relationshipsToOmit),
        exhibitorLogout: overrides && overrides.hasOwnProperty('exhibitorLogout') ? overrides.exhibitorLogout! : false,
        enableSafeMode: overrides && overrides.hasOwnProperty('enableSafeMode') ? overrides.enableSafeMode! : false,
        nameExhibitorSession: overrides && overrides.hasOwnProperty('nameExhibitorSession') ? overrides.nameExhibitorSession! : relationshipsToOmit.has('ExpoExhibitorSessionProfileOutput') ? {} as ExpoExhibitorSessionProfileOutput : anExpoExhibitorSessionProfileOutput({}, relationshipsToOmit),
        expoCreateOrUpdateNamingField: overrides && overrides.hasOwnProperty('expoCreateOrUpdateNamingField') ? overrides.expoCreateOrUpdateNamingField! : relationshipsToOmit.has('ExpoNamingField') ? {} as ExpoNamingField : anExpoNamingField({}, relationshipsToOmit),
        expoDeleteNamingField: overrides && overrides.hasOwnProperty('expoDeleteNamingField') ? overrides.expoDeleteNamingField! : true,
        createOrUpdateAttendee: overrides && overrides.hasOwnProperty('createOrUpdateAttendee') ? overrides.createOrUpdateAttendee! : relationshipsToOmit.has('ExpoAttendee') ? {} as ExpoAttendee : anExpoAttendee({}, relationshipsToOmit),
        bulkCreateOrUpdateAttendee: overrides && overrides.hasOwnProperty('bulkCreateOrUpdateAttendee') ? overrides.bulkCreateOrUpdateAttendee! : false,
        deleteAttendee: overrides && overrides.hasOwnProperty('deleteAttendee') ? overrides.deleteAttendee! : true,
        sendDownloadAttendeesEmail: overrides && overrides.hasOwnProperty('sendDownloadAttendeesEmail') ? overrides.sendDownloadAttendeesEmail! : false,
        createAutomation: overrides && overrides.hasOwnProperty('createAutomation') ? overrides.createAutomation! : relationshipsToOmit.has('Automation') ? {} as Automation : anAutomation({}, relationshipsToOmit),
        updateAutomation: overrides && overrides.hasOwnProperty('updateAutomation') ? overrides.updateAutomation! : relationshipsToOmit.has('Automation') ? {} as Automation : anAutomation({}, relationshipsToOmit),
        anonymize: overrides && overrides.hasOwnProperty('anonymize') ? overrides.anonymize! : relationshipsToOmit.has('AnonymizationOutput') ? {} as AnonymizationOutput : anAnonymizationOutput({}, relationshipsToOmit),
        createReferralCampaign: overrides && overrides.hasOwnProperty('createReferralCampaign') ? overrides.createReferralCampaign! : relationshipsToOmit.has('ReferralCampaign') ? {} as ReferralCampaign : aReferralCampaign({}, relationshipsToOmit),
        updateReferralCampaign: overrides && overrides.hasOwnProperty('updateReferralCampaign') ? overrides.updateReferralCampaign! : relationshipsToOmit.has('ReferralCampaign') ? {} as ReferralCampaign : aReferralCampaign({}, relationshipsToOmit),
        createReferralRewards: overrides && overrides.hasOwnProperty('createReferralRewards') ? overrides.createReferralRewards! : [relationshipsToOmit.has('ReferralReward') ? {} as ReferralReward : aReferralReward({}, relationshipsToOmit)],
        setPromoterSettings: overrides && overrides.hasOwnProperty('setPromoterSettings') ? overrides.setPromoterSettings! : relationshipsToOmit.has('PromoterSettingsOutput') ? {} as PromoterSettingsOutput : aPromoterSettingsOutput({}, relationshipsToOmit),
        createOrUpdateShopifySettings: overrides && overrides.hasOwnProperty('createOrUpdateShopifySettings') ? overrides.createOrUpdateShopifySettings! : relationshipsToOmit.has('ShopifySettings') ? {} as ShopifySettings : aShopifySettings({}, relationshipsToOmit),
        finalisePrechargeOrder: overrides && overrides.hasOwnProperty('finalisePrechargeOrder') ? overrides.finalisePrechargeOrder! : relationshipsToOmit.has('Order') ? {} as Order : anOrder({}, relationshipsToOmit),
        initialiseSetupIntentForPrechargeOrder: overrides && overrides.hasOwnProperty('initialiseSetupIntentForPrechargeOrder') ? overrides.initialiseSetupIntentForPrechargeOrder! : relationshipsToOmit.has('InitialiseSetupIntentOutput') ? {} as InitialiseSetupIntentOutput : anInitialiseSetupIntentOutput({}, relationshipsToOmit),
        cancelPrechargeOrder: overrides && overrides.hasOwnProperty('cancelPrechargeOrder') ? overrides.cancelPrechargeOrder! : false,
        extendOrderExpiry: overrides && overrides.hasOwnProperty('extendOrderExpiry') ? overrides.extendOrderExpiry! : false,
        processPreauthOrder: overrides && overrides.hasOwnProperty('processPreauthOrder') ? overrides.processPreauthOrder! : true,
        createSetupIntentForCardUpdate: overrides && overrides.hasOwnProperty('createSetupIntentForCardUpdate') ? overrides.createSetupIntentForCardUpdate! : relationshipsToOmit.has('CardUpdateSetupIntentOutput') ? {} as CardUpdateSetupIntentOutput : aCardUpdateSetupIntentOutput({}, relationshipsToOmit),
        saveNewSetupIntentForCardUpdate: overrides && overrides.hasOwnProperty('saveNewSetupIntentForCardUpdate') ? overrides.saveNewSetupIntentForCardUpdate! : true,
        createCompetition: overrides && overrides.hasOwnProperty('createCompetition') ? overrides.createCompetition! : relationshipsToOmit.has('Competition') ? {} as Competition : aCompetition({}, relationshipsToOmit),
        updateCompetition: overrides && overrides.hasOwnProperty('updateCompetition') ? overrides.updateCompetition! : relationshipsToOmit.has('Competition') ? {} as Competition : aCompetition({}, relationshipsToOmit),
        unpublishCompetition: overrides && overrides.hasOwnProperty('unpublishCompetition') ? overrides.unpublishCompetition! : relationshipsToOmit.has('Competition') ? {} as Competition : aCompetition({}, relationshipsToOmit),
        deleteCompetition: overrides && overrides.hasOwnProperty('deleteCompetition') ? overrides.deleteCompetition! : false,
        updateAndPublishCompetition: overrides && overrides.hasOwnProperty('updateAndPublishCompetition') ? overrides.updateAndPublishCompetition! : relationshipsToOmit.has('Competition') ? {} as Competition : aCompetition({}, relationshipsToOmit),
        grantCompetitionReward: overrides && overrides.hasOwnProperty('grantCompetitionReward') ? overrides.grantCompetitionReward! : relationshipsToOmit.has('CompetitionReward') ? {} as CompetitionReward : aCompetitionReward({}, relationshipsToOmit),
        broadcastReportingLinkOpened: overrides && overrides.hasOwnProperty('broadcastReportingLinkOpened') ? overrides.broadcastReportingLinkOpened! : true,
        broadcastReportingOrderCreated: overrides && overrides.hasOwnProperty('broadcastReportingOrderCreated') ? overrides.broadcastReportingOrderCreated! : true,
        broadcastReportingSetAsSpamFromUser: overrides && overrides.hasOwnProperty('broadcastReportingSetAsSpamFromUser') ? overrides.broadcastReportingSetAsSpamFromUser! : true,
        createRedirectUrl: overrides && overrides.hasOwnProperty('createRedirectUrl') ? overrides.createRedirectUrl! : relationshipsToOmit.has('RedirectUrl') ? {} as RedirectUrl : aRedirectUrl({}, relationshipsToOmit),
        addAccessCodesToMembership: overrides && overrides.hasOwnProperty('addAccessCodesToMembership') ? overrides.addAccessCodesToMembership! : [relationshipsToOmit.has('AccessCode') ? {} as AccessCode : anAccessCode({}, relationshipsToOmit)],
        deleteAccessCodesFromMembership: overrides && overrides.hasOwnProperty('deleteAccessCodesFromMembership') ? overrides.deleteAccessCodesFromMembership! : false,
        disableAccessCodesForMembership: overrides && overrides.hasOwnProperty('disableAccessCodesForMembership') ? overrides.disableAccessCodesForMembership! : false,
        enableAccessCodesForMembership: overrides && overrides.hasOwnProperty('enableAccessCodesForMembership') ? overrides.enableAccessCodesForMembership! : true,
        updateMembershipAccessCode: overrides && overrides.hasOwnProperty('updateMembershipAccessCode') ? overrides.updateMembershipAccessCode! : relationshipsToOmit.has('AccessCode') ? {} as AccessCode : anAccessCode({}, relationshipsToOmit),
        createShortUrl: overrides && overrides.hasOwnProperty('createShortUrl') ? overrides.createShortUrl! : relationshipsToOmit.has('ShortUrl') ? {} as ShortUrl : aShortUrl({}, relationshipsToOmit),
        testUrl: overrides && overrides.hasOwnProperty('testUrl') ? overrides.testUrl! : 'synagoga',
        joinWaitlist: overrides && overrides.hasOwnProperty('joinWaitlist') ? overrides.joinWaitlist! : relationshipsToOmit.has('Waitlist') ? {} as Waitlist : aWaitlist({}, relationshipsToOmit),
        updateTicketResaleConfig: overrides && overrides.hasOwnProperty('updateTicketResaleConfig') ? overrides.updateTicketResaleConfig! : relationshipsToOmit.has('Event') ? {} as Event : anEvent({}, relationshipsToOmit),
        createResaleTicketType: overrides && overrides.hasOwnProperty('createResaleTicketType') ? overrides.createResaleTicketType! : relationshipsToOmit.has('TicketType') ? {} as TicketType : aTicketType({}, relationshipsToOmit),
        updateResaleTicketType: overrides && overrides.hasOwnProperty('updateResaleTicketType') ? overrides.updateResaleTicketType! : relationshipsToOmit.has('TicketType') ? {} as TicketType : aTicketType({}, relationshipsToOmit),
        deleteResaleTicketType: overrides && overrides.hasOwnProperty('deleteResaleTicketType') ? overrides.deleteResaleTicketType! : true,
        hideResaleTicketTypeFromPublic: overrides && overrides.hasOwnProperty('hideResaleTicketTypeFromPublic') ? overrides.hideResaleTicketTypeFromPublic! : false,
        unhideResaleTicketTypeFromPublic: overrides && overrides.hasOwnProperty('unhideResaleTicketTypeFromPublic') ? overrides.unhideResaleTicketTypeFromPublic! : false,
        joinResaleWaitlist: overrides && overrides.hasOwnProperty('joinResaleWaitlist') ? overrides.joinResaleWaitlist! : relationshipsToOmit.has('ResaleWaitlistOutput') ? {} as ResaleWaitlistOutput : aResaleWaitlistOutput({}, relationshipsToOmit),
        deleteBroadcast: overrides && overrides.hasOwnProperty('deleteBroadcast') ? overrides.deleteBroadcast! : relationshipsToOmit.has('DeleteOneOutput') ? {} as DeleteOneOutput : aDeleteOneOutput({}, relationshipsToOmit),
        sendBroadcast: overrides && overrides.hasOwnProperty('sendBroadcast') ? overrides.sendBroadcast! : true,
        saveEmailBroadcastTags: overrides && overrides.hasOwnProperty('saveEmailBroadcastTags') ? overrides.saveEmailBroadcastTags! : false,
        createSMSBroadcast: overrides && overrides.hasOwnProperty('createSMSBroadcast') ? overrides.createSMSBroadcast! : relationshipsToOmit.has('SmsBroadcastSaveOutput') ? {} as SmsBroadcastSaveOutput : aSmsBroadcastSaveOutput({}, relationshipsToOmit),
        updateSMSBroadcast: overrides && overrides.hasOwnProperty('updateSMSBroadcast') ? overrides.updateSMSBroadcast! : relationshipsToOmit.has('SmsBroadcastSaveOutput') ? {} as SmsBroadcastSaveOutput : aSmsBroadcastSaveOutput({}, relationshipsToOmit),
        deleteSMSBroadcast: overrides && overrides.hasOwnProperty('deleteSMSBroadcast') ? overrides.deleteSMSBroadcast! : relationshipsToOmit.has('DeleteOneOutput') ? {} as DeleteOneOutput : aDeleteOneOutput({}, relationshipsToOmit),
        emailDomainCreate: overrides && overrides.hasOwnProperty('emailDomainCreate') ? overrides.emailDomainCreate! : relationshipsToOmit.has('EmailDomainOutput') ? {} as EmailDomainOutput : anEmailDomainOutput({}, relationshipsToOmit),
        emailDomainDelete: overrides && overrides.hasOwnProperty('emailDomainDelete') ? overrides.emailDomainDelete! : false,
        createReportSchedule: overrides && overrides.hasOwnProperty('createReportSchedule') ? overrides.createReportSchedule! : relationshipsToOmit.has('ReportSchedule') ? {} as ReportSchedule : aReportSchedule({}, relationshipsToOmit),
        updateReportSchedule: overrides && overrides.hasOwnProperty('updateReportSchedule') ? overrides.updateReportSchedule! : relationshipsToOmit.has('ReportSchedule') ? {} as ReportSchedule : aReportSchedule({}, relationshipsToOmit),
        deleteReportSchedule: overrides && overrides.hasOwnProperty('deleteReportSchedule') ? overrides.deleteReportSchedule! : false,
        pauseReportSchedule: overrides && overrides.hasOwnProperty('pauseReportSchedule') ? overrides.pauseReportSchedule! : relationshipsToOmit.has('ReportSchedule') ? {} as ReportSchedule : aReportSchedule({}, relationshipsToOmit),
        createTrackingCode: overrides && overrides.hasOwnProperty('createTrackingCode') ? overrides.createTrackingCode! : false,
        deleteTrackingCode: overrides && overrides.hasOwnProperty('deleteTrackingCode') ? overrides.deleteTrackingCode! : true,
        onTrackingCodeVisit: overrides && overrides.hasOwnProperty('onTrackingCodeVisit') ? overrides.onTrackingCodeVisit! : true,
        createOrderToTrackingCodeAssociation: overrides && overrides.hasOwnProperty('createOrderToTrackingCodeAssociation') ? overrides.createOrderToTrackingCodeAssociation! : true,
        signupFormCreate: overrides && overrides.hasOwnProperty('signupFormCreate') ? overrides.signupFormCreate! : relationshipsToOmit.has('SignupFormOutput') ? {} as SignupFormOutput : aSignupFormOutput({}, relationshipsToOmit),
        signupFormUpdate: overrides && overrides.hasOwnProperty('signupFormUpdate') ? overrides.signupFormUpdate! : relationshipsToOmit.has('SignupFormOutput') ? {} as SignupFormOutput : aSignupFormOutput({}, relationshipsToOmit),
        signupFormDelete: overrides && overrides.hasOwnProperty('signupFormDelete') ? overrides.signupFormDelete! : false,
        signupFormSubmit: overrides && overrides.hasOwnProperty('signupFormSubmit') ? overrides.signupFormSubmit! : true,
        createSegment: overrides && overrides.hasOwnProperty('createSegment') ? overrides.createSegment! : relationshipsToOmit.has('SegmentOutput') ? {} as SegmentOutput : aSegmentOutput({}, relationshipsToOmit),
        updateSegment: overrides && overrides.hasOwnProperty('updateSegment') ? overrides.updateSegment! : relationshipsToOmit.has('SegmentOutput') ? {} as SegmentOutput : aSegmentOutput({}, relationshipsToOmit),
    };
};

export const aRegisterInput = (overrides?: Partial<RegisterInput>, _relationshipsToOmit: Set<string> = new Set()): RegisterInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RegisterInput');
    return {
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'aequus',
        password: overrides && overrides.hasOwnProperty('password') ? overrides.password! : 'ager',
        posId: overrides && overrides.hasOwnProperty('posId') ? overrides.posId! : 'amo',
        firstName: overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'cauda',
        lastName: overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'enim',
        enableTwoFactorAuthentication: overrides && overrides.hasOwnProperty('enableTwoFactorAuthentication') ? overrides.enableTwoFactorAuthentication! : true,
        userAcquisition: overrides && overrides.hasOwnProperty('userAcquisition') ? overrides.userAcquisition! : relationshipsToOmit.has('UserAcquisition') ? {} as UserAcquisition : aUserAcquisition({}, relationshipsToOmit),
    };
};

export const aUserAcquisition = (overrides?: Partial<UserAcquisition>, _relationshipsToOmit: Set<string> = new Set()): UserAcquisition => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UserAcquisition');
    return {
        referralCodeId: overrides && overrides.hasOwnProperty('referralCodeId') ? overrides.referralCodeId! : 'nam',
    };
};

export const aLoginInput = (overrides?: Partial<LoginInput>, _relationshipsToOmit: Set<string> = new Set()): LoginInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LoginInput');
    return {
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'truculenter',
        password: overrides && overrides.hasOwnProperty('password') ? overrides.password! : 'copiose',
        posId: overrides && overrides.hasOwnProperty('posId') ? overrides.posId! : 'spiritus',
    };
};

export const aLinkedAccountRegisterInput = (overrides?: Partial<LinkedAccountRegisterInput>, _relationshipsToOmit: Set<string> = new Set()): LinkedAccountRegisterInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LinkedAccountRegisterInput');
    return {
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'absorbeo',
        password: overrides && overrides.hasOwnProperty('password') ? overrides.password! : 'sordeo',
        newAccountPassword: overrides && overrides.hasOwnProperty('newAccountPassword') ? overrides.newAccountPassword! : 'comminor',
        token: overrides && overrides.hasOwnProperty('token') ? overrides.token! : 'conventus',
    };
};

export const aSocialAuthInput = (overrides?: Partial<SocialAuthInput>, _relationshipsToOmit: Set<string> = new Set()): SocialAuthInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SocialAuthInput');
    return {
        socialAuthType: overrides && overrides.hasOwnProperty('socialAuthType') ? overrides.socialAuthType! : SocialAuthType.Facebook,
        accessToken: overrides && overrides.hasOwnProperty('accessToken') ? overrides.accessToken! : 'cura',
    };
};

export const aRequestMagicLinkInput = (overrides?: Partial<RequestMagicLinkInput>, _relationshipsToOmit: Set<string> = new Set()): RequestMagicLinkInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RequestMagicLinkInput');
    return {
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'tametsi',
        redirectUrl: overrides && overrides.hasOwnProperty('redirectUrl') ? overrides.redirectUrl! : 'carmen',
        entry: overrides && overrides.hasOwnProperty('entry') ? overrides.entry! : 'crux',
    };
};

export const aVerifyEmailInput = (overrides?: Partial<VerifyEmailInput>, _relationshipsToOmit: Set<string> = new Set()): VerifyEmailInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('VerifyEmailInput');
    return {
        token: overrides && overrides.hasOwnProperty('token') ? overrides.token! : 'advoco',
    };
};

export const aVerifyMagicLinkOutput = (overrides?: Partial<VerifyMagicLinkOutput>, _relationshipsToOmit: Set<string> = new Set()): VerifyMagicLinkOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('VerifyMagicLinkOutput');
    return {
        redirectUrl: overrides && overrides.hasOwnProperty('redirectUrl') ? overrides.redirectUrl! : 'aspernatur',
    };
};

export const aRequestResetPasswordInput = (overrides?: Partial<RequestResetPasswordInput>, _relationshipsToOmit: Set<string> = new Set()): RequestResetPasswordInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RequestResetPasswordInput');
    return {
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'bis',
    };
};

export const aResetPasswordInput = (overrides?: Partial<ResetPasswordInput>, _relationshipsToOmit: Set<string> = new Set()): ResetPasswordInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ResetPasswordInput');
    return {
        token: overrides && overrides.hasOwnProperty('token') ? overrides.token! : 'cotidie',
        password: overrides && overrides.hasOwnProperty('password') ? overrides.password! : 'avaritia',
    };
};

export const aSetPasswordForNewUserInput = (overrides?: Partial<SetPasswordForNewUserInput>, _relationshipsToOmit: Set<string> = new Set()): SetPasswordForNewUserInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SetPasswordForNewUserInput');
    return {
        password: overrides && overrides.hasOwnProperty('password') ? overrides.password! : 'paens',
    };
};

export const anUpdatePasswordInput = (overrides?: Partial<UpdatePasswordInput>, _relationshipsToOmit: Set<string> = new Set()): UpdatePasswordInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdatePasswordInput');
    return {
        oldPassword: overrides && overrides.hasOwnProperty('oldPassword') ? overrides.oldPassword! : 'dens',
        newPassword: overrides && overrides.hasOwnProperty('newPassword') ? overrides.newPassword! : 'timidus',
    };
};

export const aTwoFactorAuthenticationSetupResult = (overrides?: Partial<TwoFactorAuthenticationSetupResult>, _relationshipsToOmit: Set<string> = new Set()): TwoFactorAuthenticationSetupResult => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TwoFactorAuthenticationSetupResult');
    return {
        dataURL: overrides && overrides.hasOwnProperty('dataURL') ? overrides.dataURL! : 'cena',
        secret: overrides && overrides.hasOwnProperty('secret') ? overrides.secret! : 'adfero',
    };
};

export const aTwoFactorAuthenticationCodeInput = (overrides?: Partial<TwoFactorAuthenticationCodeInput>, _relationshipsToOmit: Set<string> = new Set()): TwoFactorAuthenticationCodeInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TwoFactorAuthenticationCodeInput');
    return {
        twoFactorAuthenticationCode: overrides && overrides.hasOwnProperty('twoFactorAuthenticationCode') ? overrides.twoFactorAuthenticationCode! : 'praesentium',
    };
};

export const aVerifyManageTicketsOutput = (overrides?: Partial<VerifyManageTicketsOutput>, _relationshipsToOmit: Set<string> = new Set()): VerifyManageTicketsOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('VerifyManageTicketsOutput');
    return {
        isLoggedIn: overrides && overrides.hasOwnProperty('isLoggedIn') ? overrides.isLoggedIn! : true,
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'bonus',
        isEventEnded: overrides && overrides.hasOwnProperty('isEventEnded') ? overrides.isEventEnded! : true,
    };
};

export const aCreateUserInput = (overrides?: Partial<CreateUserInput>, _relationshipsToOmit: Set<string> = new Set()): CreateUserInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateUserInput');
    return {
        firstName: overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'uter',
        lastName: overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'adstringo',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'amoveo',
        roles: overrides && overrides.hasOwnProperty('roles') ? overrides.roles! : [Role.Superadmin],
        phoneNumber: overrides && overrides.hasOwnProperty('phoneNumber') ? overrides.phoneNumber! : 'cavus',
        birthDate: overrides && overrides.hasOwnProperty('birthDate') ? overrides.birthDate! : "2025-09-08T08:01:22.926Z",
        receiveScannerEmail: overrides && overrides.hasOwnProperty('receiveScannerEmail') ? overrides.receiveScannerEmail! : true,
        gender: overrides && overrides.hasOwnProperty('gender') ? overrides.gender! : Gender.Male,
        usableForEmailMarketing: overrides && overrides.hasOwnProperty('usableForEmailMarketing') ? overrides.usableForEmailMarketing! : true,
        usableForSMSMarketing: overrides && overrides.hasOwnProperty('usableForSMSMarketing') ? overrides.usableForSMSMarketing! : false,
        billingAddress: overrides && overrides.hasOwnProperty('billingAddress') ? overrides.billingAddress! : relationshipsToOmit.has('PartialAddressInput') ? {} as PartialAddressInput : aPartialAddressInput({}, relationshipsToOmit),
        shippingAddress: overrides && overrides.hasOwnProperty('shippingAddress') ? overrides.shippingAddress! : relationshipsToOmit.has('PartialAddressInput') ? {} as PartialAddressInput : aPartialAddressInput({}, relationshipsToOmit),
        shippingAddressMatchesBillingAddress: overrides && overrides.hasOwnProperty('shippingAddressMatchesBillingAddress') ? overrides.shippingAddressMatchesBillingAddress! : true,
        credits: overrides && overrides.hasOwnProperty('credits') ? overrides.credits! : 9.6,
        companyName: overrides && overrides.hasOwnProperty('companyName') ? overrides.companyName! : 'dolor',
        taxNumber: overrides && overrides.hasOwnProperty('taxNumber') ? overrides.taxNumber! : 'reprehenderit',
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['vulpes'],
        instagramUsername: overrides && overrides.hasOwnProperty('instagramUsername') ? overrides.instagramUsername! : 'fugit',
        referralId: overrides && overrides.hasOwnProperty('referralId') ? overrides.referralId! : 'casus',
        accessEventIds: overrides && overrides.hasOwnProperty('accessEventIds') ? overrides.accessEventIds! : ['vel'],
        accessMembershipIds: overrides && overrides.hasOwnProperty('accessMembershipIds') ? overrides.accessMembershipIds! : ['sortitus'],
        elevatePrivileges: overrides && overrides.hasOwnProperty('elevatePrivileges') ? overrides.elevatePrivileges! : false,
        userAcquisition: overrides && overrides.hasOwnProperty('userAcquisition') ? overrides.userAcquisition! : relationshipsToOmit.has('UserAcquisition') ? {} as UserAcquisition : aUserAcquisition({}, relationshipsToOmit),
    };
};

export const aPartialAddressInput = (overrides?: Partial<PartialAddressInput>, _relationshipsToOmit: Set<string> = new Set()): PartialAddressInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PartialAddressInput');
    return {
        line1: overrides && overrides.hasOwnProperty('line1') ? overrides.line1! : 'spectaculum',
        line2: overrides && overrides.hasOwnProperty('line2') ? overrides.line2! : 'universe',
        suburb: overrides && overrides.hasOwnProperty('suburb') ? overrides.suburb! : 'rerum',
        postalCode: overrides && overrides.hasOwnProperty('postalCode') ? overrides.postalCode! : 'uxor',
        city: overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'optio',
        state: overrides && overrides.hasOwnProperty('state') ? overrides.state! : 'ulterius',
        country: overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'vox',
    };
};

export const aCreatePosUserInput = (overrides?: Partial<CreatePosUserInput>, _relationshipsToOmit: Set<string> = new Set()): CreatePosUserInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreatePosUserInput');
    return {
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'esse',
        firstName: overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'commemoro',
        lastName: overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'suffoco',
        accessCode: overrides && overrides.hasOwnProperty('accessCode') ? overrides.accessCode! : 'deficio',
    };
};

export const aCreateTemporaryPosUserInput = (overrides?: Partial<CreateTemporaryPosUserInput>, _relationshipsToOmit: Set<string> = new Set()): CreateTemporaryPosUserInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateTemporaryPosUserInput');
    return {
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'vel',
        fullName: overrides && overrides.hasOwnProperty('fullName') ? overrides.fullName! : 'alveus',
    };
};

export const aCreateTemporaryPosUserOutput = (overrides?: Partial<CreateTemporaryPosUserOutput>, _relationshipsToOmit: Set<string> = new Set()): CreateTemporaryPosUserOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateTemporaryPosUserOutput');
    return {
        user: overrides && overrides.hasOwnProperty('user') ? overrides.user! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        password: overrides && overrides.hasOwnProperty('password') ? overrides.password! : 'nulla',
        oneTimeAccessToken: overrides && overrides.hasOwnProperty('oneTimeAccessToken') ? overrides.oneTimeAccessToken! : 'cornu',
    };
};

export const anUpdatePosUserInput = (overrides?: Partial<UpdatePosUserInput>, _relationshipsToOmit: Set<string> = new Set()): UpdatePosUserInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdatePosUserInput');
    return {
        firstName: overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'congregatio',
        lastName: overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'venia',
        accessCode: overrides && overrides.hasOwnProperty('accessCode') ? overrides.accessCode! : 'accusamus',
    };
};

export const anUpdateUserInput = (overrides?: Partial<UpdateUserInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateUserInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateUserInput');
    return {
        firstName: overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'suscipit',
        lastName: overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'velum',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'turbo',
        roles: overrides && overrides.hasOwnProperty('roles') ? overrides.roles! : [Role.Superadmin],
        phoneNumber: overrides && overrides.hasOwnProperty('phoneNumber') ? overrides.phoneNumber! : 'aestivus',
        birthDate: overrides && overrides.hasOwnProperty('birthDate') ? overrides.birthDate! : "2026-02-08T13:09:22.846Z",
        receiveScannerEmail: overrides && overrides.hasOwnProperty('receiveScannerEmail') ? overrides.receiveScannerEmail! : false,
        gender: overrides && overrides.hasOwnProperty('gender') ? overrides.gender! : Gender.Male,
        usableForEmailMarketing: overrides && overrides.hasOwnProperty('usableForEmailMarketing') ? overrides.usableForEmailMarketing! : false,
        usableForSMSMarketing: overrides && overrides.hasOwnProperty('usableForSMSMarketing') ? overrides.usableForSMSMarketing! : false,
        billingAddress: overrides && overrides.hasOwnProperty('billingAddress') ? overrides.billingAddress! : relationshipsToOmit.has('PartialAddressInput') ? {} as PartialAddressInput : aPartialAddressInput({}, relationshipsToOmit),
        shippingAddress: overrides && overrides.hasOwnProperty('shippingAddress') ? overrides.shippingAddress! : relationshipsToOmit.has('PartialAddressInput') ? {} as PartialAddressInput : aPartialAddressInput({}, relationshipsToOmit),
        shippingAddressMatchesBillingAddress: overrides && overrides.hasOwnProperty('shippingAddressMatchesBillingAddress') ? overrides.shippingAddressMatchesBillingAddress! : false,
        credits: overrides && overrides.hasOwnProperty('credits') ? overrides.credits! : 6.8,
        companyName: overrides && overrides.hasOwnProperty('companyName') ? overrides.companyName! : 'deludo',
        taxNumber: overrides && overrides.hasOwnProperty('taxNumber') ? overrides.taxNumber! : 'dolor',
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['artificiose'],
        instagramUsername: overrides && overrides.hasOwnProperty('instagramUsername') ? overrides.instagramUsername! : 'soluta',
        referralId: overrides && overrides.hasOwnProperty('referralId') ? overrides.referralId! : 'at',
        accessEventIds: overrides && overrides.hasOwnProperty('accessEventIds') ? overrides.accessEventIds! : ['supplanto'],
        accessMembershipIds: overrides && overrides.hasOwnProperty('accessMembershipIds') ? overrides.accessMembershipIds! : ['aegrus'],
        elevatePrivileges: overrides && overrides.hasOwnProperty('elevatePrivileges') ? overrides.elevatePrivileges! : true,
        userAcquisition: overrides && overrides.hasOwnProperty('userAcquisition') ? overrides.userAcquisition! : relationshipsToOmit.has('UserAcquisition') ? {} as UserAcquisition : aUserAcquisition({}, relationshipsToOmit),
    };
};

export const aDeleteOneOutput = (overrides?: Partial<DeleteOneOutput>, _relationshipsToOmit: Set<string> = new Set()): DeleteOneOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteOneOutput');
    return {
        deletedId: overrides && overrides.hasOwnProperty('deletedId') ? overrides.deletedId! : 'adsum',
    };
};

export const anUpdateProfileInput = (overrides?: Partial<UpdateProfileInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateProfileInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateProfileInput');
    return {
        firstName: overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'aranea',
        lastName: overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'ventito',
        phoneNumber: overrides && overrides.hasOwnProperty('phoneNumber') ? overrides.phoneNumber! : 'repellendus',
        birthDate: overrides && overrides.hasOwnProperty('birthDate') ? overrides.birthDate! : "2026-02-16T14:31:49.053Z",
        gender: overrides && overrides.hasOwnProperty('gender') ? overrides.gender! : Gender.Male,
        usableForEmailMarketing: overrides && overrides.hasOwnProperty('usableForEmailMarketing') ? overrides.usableForEmailMarketing! : false,
        usableForSMSMarketing: overrides && overrides.hasOwnProperty('usableForSMSMarketing') ? overrides.usableForSMSMarketing! : true,
        billingAddress: overrides && overrides.hasOwnProperty('billingAddress') ? overrides.billingAddress! : relationshipsToOmit.has('PartialAddressInput') ? {} as PartialAddressInput : aPartialAddressInput({}, relationshipsToOmit),
        shippingAddress: overrides && overrides.hasOwnProperty('shippingAddress') ? overrides.shippingAddress! : relationshipsToOmit.has('PartialAddressInput') ? {} as PartialAddressInput : aPartialAddressInput({}, relationshipsToOmit),
        shippingAddressMatchesBillingAddress: overrides && overrides.hasOwnProperty('shippingAddressMatchesBillingAddress') ? overrides.shippingAddressMatchesBillingAddress! : true,
        companyName: overrides && overrides.hasOwnProperty('companyName') ? overrides.companyName! : 'id',
        taxNumber: overrides && overrides.hasOwnProperty('taxNumber') ? overrides.taxNumber! : 'cena',
        instagramUsername: overrides && overrides.hasOwnProperty('instagramUsername') ? overrides.instagramUsername! : 'taceo',
    };
};

export const anImportInput = (overrides?: Partial<ImportInput>, _relationshipsToOmit: Set<string> = new Set()): ImportInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ImportInput');
    return {
        file: overrides && overrides.hasOwnProperty('file') ? overrides.file! : 'claustrum',
    };
};

export const anImportOutput = (overrides?: Partial<ImportOutput>, _relationshipsToOmit: Set<string> = new Set()): ImportOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ImportOutput');
    return {
        failed: overrides && overrides.hasOwnProperty('failed') ? overrides.failed! : [relationshipsToOmit.has('FailedImportItem') ? {} as FailedImportItem : aFailedImportItem({}, relationshipsToOmit)],
    };
};

export const aFailedImportItem = (overrides?: Partial<FailedImportItem>, _relationshipsToOmit: Set<string> = new Set()): FailedImportItem => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('FailedImportItem');
    return {
        index: overrides && overrides.hasOwnProperty('index') ? overrides.index! : 5.2,
        message: overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'tenus',
    };
};

export const anUpdateCreditsInput = (overrides?: Partial<UpdateCreditsInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateCreditsInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateCreditsInput');
    return {
        credits: overrides && overrides.hasOwnProperty('credits') ? overrides.credits! : 2.1,
    };
};

export const aCreatePosInput = (overrides?: Partial<CreatePosInput>, _relationshipsToOmit: Set<string> = new Set()): CreatePosInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreatePosInput');
    return {
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'similique',
        releaseId: overrides && overrides.hasOwnProperty('releaseId') ? overrides.releaseId! : 'tenuis',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'alii',
        bookingFeeType: overrides && overrides.hasOwnProperty('bookingFeeType') ? overrides.bookingFeeType! : FeeType.FlatRate,
        bookingFee: overrides && overrides.hasOwnProperty('bookingFee') ? overrides.bookingFee! : 0.2,
        paymentOptions: overrides && overrides.hasOwnProperty('paymentOptions') ? overrides.paymentOptions! : relationshipsToOmit.has('PosPaymentOptionsInput') ? {} as PosPaymentOptionsInput : aPosPaymentOptionsInput({}, relationshipsToOmit),
        deliveryOptions: overrides && overrides.hasOwnProperty('deliveryOptions') ? overrides.deliveryOptions! : [ShippingOption.Eticket],
        cashAmount: overrides && overrides.hasOwnProperty('cashAmount') ? overrides.cashAmount! : 4.8,
        enableReceipts: overrides && overrides.hasOwnProperty('enableReceipts') ? overrides.enableReceipts! : true,
        autoPrintTickets: overrides && overrides.hasOwnProperty('autoPrintTickets') ? overrides.autoPrintTickets! : false,
    };
};

export const aPosPaymentOptionsInput = (overrides?: Partial<PosPaymentOptionsInput>, _relationshipsToOmit: Set<string> = new Set()): PosPaymentOptionsInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PosPaymentOptionsInput');
    return {
        cash: overrides && overrides.hasOwnProperty('cash') ? overrides.cash! : relationshipsToOmit.has('PosPaymentFeeInput') ? {} as PosPaymentFeeInput : aPosPaymentFeeInput({}, relationshipsToOmit),
        eftpos: overrides && overrides.hasOwnProperty('eftpos') ? overrides.eftpos! : relationshipsToOmit.has('PosPaymentFeeInput') ? {} as PosPaymentFeeInput : aPosPaymentFeeInput({}, relationshipsToOmit),
        cc: overrides && overrides.hasOwnProperty('cc') ? overrides.cc! : relationshipsToOmit.has('PosPaymentFeeInput') ? {} as PosPaymentFeeInput : aPosPaymentFeeInput({}, relationshipsToOmit),
        MPAiSA: overrides && overrides.hasOwnProperty('MPAiSA') ? overrides.MPAiSA! : relationshipsToOmit.has('PosPaymentFeeInput') ? {} as PosPaymentFeeInput : aPosPaymentFeeInput({}, relationshipsToOmit),
    };
};

export const aPosPaymentFeeInput = (overrides?: Partial<PosPaymentFeeInput>, _relationshipsToOmit: Set<string> = new Set()): PosPaymentFeeInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PosPaymentFeeInput');
    return {
        feeType: overrides && overrides.hasOwnProperty('feeType') ? overrides.feeType! : FeeType.FlatRate,
        feeAmount: overrides && overrides.hasOwnProperty('feeAmount') ? overrides.feeAmount! : 9.7,
    };
};

export const aPosReleaseInput = (overrides?: Partial<PosReleaseInput>, _relationshipsToOmit: Set<string> = new Set()): PosReleaseInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PosReleaseInput');
    return {
        releaseId: overrides && overrides.hasOwnProperty('releaseId') ? overrides.releaseId! : 'amplexus',
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'doloremque',
        tickets: overrides && overrides.hasOwnProperty('tickets') ? overrides.tickets! : [relationshipsToOmit.has('PosTicketDto') ? {} as PosTicketDto : aPosTicketDto({}, relationshipsToOmit)],
        posPaymentOptions: overrides && overrides.hasOwnProperty('posPaymentOptions') ? overrides.posPaymentOptions! : relationshipsToOmit.has('PosPaymentOptionsInput') ? {} as PosPaymentOptionsInput : aPosPaymentOptionsInput({}, relationshipsToOmit),
        bookingFeeType: overrides && overrides.hasOwnProperty('bookingFeeType') ? overrides.bookingFeeType! : FeeType.FlatRate,
        bookingFee: overrides && overrides.hasOwnProperty('bookingFee') ? overrides.bookingFee! : 1,
    };
};

export const aPosTicketDto = (overrides?: Partial<PosTicketDto>, _relationshipsToOmit: Set<string> = new Set()): PosTicketDto => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PosTicketDto');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'vomer',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : TicketTypeKind.Standard,
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : false,
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 8.4,
    };
};

export const aSetPosPaymentOptionsInput = (overrides?: Partial<SetPosPaymentOptionsInput>, _relationshipsToOmit: Set<string> = new Set()): SetPosPaymentOptionsInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SetPosPaymentOptionsInput');
    return {
        posPaymentOptions: overrides && overrides.hasOwnProperty('posPaymentOptions') ? overrides.posPaymentOptions! : relationshipsToOmit.has('PosPaymentOptionsInput') ? {} as PosPaymentOptionsInput : aPosPaymentOptionsInput({}, relationshipsToOmit),
        bookingFeeType: overrides && overrides.hasOwnProperty('bookingFeeType') ? overrides.bookingFeeType! : FeeType.FlatRate,
        bookingFee: overrides && overrides.hasOwnProperty('bookingFee') ? overrides.bookingFee! : 5.4,
    };
};

export const aPosTerminalConnectionOutput = (overrides?: Partial<PosTerminalConnectionOutput>, _relationshipsToOmit: Set<string> = new Set()): PosTerminalConnectionOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PosTerminalConnectionOutput');
    return {
        connectionToken: overrides && overrides.hasOwnProperty('connectionToken') ? overrides.connectionToken! : 'asporto',
        organizationId: overrides && overrides.hasOwnProperty('organizationId') ? overrides.organizationId! : 'averto',
        eventTitle: overrides && overrides.hasOwnProperty('eventTitle') ? overrides.eventTitle! : 'copiose',
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'speculum',
        posReleaseId: overrides && overrides.hasOwnProperty('posReleaseId') ? overrides.posReleaseId! : 'vilis',
        posId: overrides && overrides.hasOwnProperty('posId') ? overrides.posId! : 'conturbo',
        posName: overrides && overrides.hasOwnProperty('posName') ? overrides.posName! : 'theatrum',
        posEmail: overrides && overrides.hasOwnProperty('posEmail') ? overrides.posEmail! : 'antiquus',
        timezone: overrides && overrides.hasOwnProperty('timezone') ? overrides.timezone! : 'Pacific/Auckland',
        locale: overrides && overrides.hasOwnProperty('locale') ? overrides.locale! : 'en',
        currency: overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'custodia',
        transactionFeeType: overrides && overrides.hasOwnProperty('transactionFeeType') ? overrides.transactionFeeType! : FeeType.FlatRate,
        transactionFeeAmount: overrides && overrides.hasOwnProperty('transactionFeeAmount') ? overrides.transactionFeeAmount! : 7.8,
        bookingFeeType: overrides && overrides.hasOwnProperty('bookingFeeType') ? overrides.bookingFeeType! : FeeType.FlatRate,
        bookingFee: overrides && overrides.hasOwnProperty('bookingFee') ? overrides.bookingFee! : 8.1,
    };
};

export const anUpdateForecastInput = (overrides?: Partial<UpdateForecastInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateForecastInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateForecastInput');
    return {
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'cum',
        zones: overrides && overrides.hasOwnProperty('zones') ? overrides.zones! : [relationshipsToOmit.has('ForecastZoneInput') ? {} as ForecastZoneInput : aForecastZoneInput({}, relationshipsToOmit)],
        scenarios: overrides && overrides.hasOwnProperty('scenarios') ? overrides.scenarios! : [relationshipsToOmit.has('ScenarioInput') ? {} as ScenarioInput : aScenarioInput({}, relationshipsToOmit)],
    };
};

export const aForecastZoneInput = (overrides?: Partial<ForecastZoneInput>, _relationshipsToOmit: Set<string> = new Set()): ForecastZoneInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ForecastZoneInput');
    return {
        zoneId: overrides && overrides.hasOwnProperty('zoneId') ? overrides.zoneId! : 'thermae',
        comps: overrides && overrides.hasOwnProperty('comps') ? overrides.comps! : 0.3,
        contingency: overrides && overrides.hasOwnProperty('contingency') ? overrides.contingency! : 5,
    };
};

export const aScenarioInput = (overrides?: Partial<ScenarioInput>, _relationshipsToOmit: Set<string> = new Set()): ScenarioInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ScenarioInput');
    return {
        scenarioId: overrides && overrides.hasOwnProperty('scenarioId') ? overrides.scenarioId! : 'adstringo',
        zones: overrides && overrides.hasOwnProperty('zones') ? overrides.zones! : [relationshipsToOmit.has('ScenarioZoneInput') ? {} as ScenarioZoneInput : aScenarioZoneInput({}, relationshipsToOmit)],
    };
};

export const aScenarioZoneInput = (overrides?: Partial<ScenarioZoneInput>, _relationshipsToOmit: Set<string> = new Set()): ScenarioZoneInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ScenarioZoneInput');
    return {
        zoneId: overrides && overrides.hasOwnProperty('zoneId') ? overrides.zoneId! : 'cras',
        ticketTypes: overrides && overrides.hasOwnProperty('ticketTypes') ? overrides.ticketTypes! : [relationshipsToOmit.has('ScenarioZoneTicketTypeInput') ? {} as ScenarioZoneTicketTypeInput : aScenarioZoneTicketTypeInput({}, relationshipsToOmit)],
    };
};

export const aScenarioZoneTicketTypeInput = (overrides?: Partial<ScenarioZoneTicketTypeInput>, _relationshipsToOmit: Set<string> = new Set()): ScenarioZoneTicketTypeInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ScenarioZoneTicketTypeInput');
    return {
        ticketTypeId: overrides && overrides.hasOwnProperty('ticketTypeId') ? overrides.ticketTypeId! : 'vestrum',
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 6.3,
        splitPercentage: overrides && overrides.hasOwnProperty('splitPercentage') ? overrides.splitPercentage! : 8.4,
    };
};

export const aCreateEventInput = (overrides?: Partial<CreateEventInput>, _relationshipsToOmit: Set<string> = new Set()): CreateEventInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateEventInput');
    return {
        eventKind: overrides && overrides.hasOwnProperty('eventKind') ? overrides.eventKind! : EventKind.Standard,
        digitalInfo: overrides && overrides.hasOwnProperty('digitalInfo') ? overrides.digitalInfo! : relationshipsToOmit.has('CreateDigitalInfoInput') ? {} as CreateDigitalInfoInput : aCreateDigitalInfoInput({}, relationshipsToOmit),
        season: overrides && overrides.hasOwnProperty('season') ? overrides.season! : 'amicitia',
        venue: overrides && overrides.hasOwnProperty('venue') ? overrides.venue! : 'cruciamentum',
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'comes',
        logo: overrides && overrides.hasOwnProperty('logo') ? overrides.logo! : 'tego',
        backgroundImage: overrides && overrides.hasOwnProperty('backgroundImage') ? overrides.backgroundImage! : 'deleo',
        backgroundImageFullPage: overrides && overrides.hasOwnProperty('backgroundImageFullPage') ? overrides.backgroundImageFullPage! : 'aegrotatio',
        descriptionImage: overrides && overrides.hasOwnProperty('descriptionImage') ? overrides.descriptionImage! : 'amplexus',
        thumbnail: overrides && overrides.hasOwnProperty('thumbnail') ? overrides.thumbnail! : 'deserunt',
        printBanner1: overrides && overrides.hasOwnProperty('printBanner1') ? overrides.printBanner1! : 'solum',
        printBanner2: overrides && overrides.hasOwnProperty('printBanner2') ? overrides.printBanner2! : 'benevolentia',
        hardCopyTicketBanner: overrides && overrides.hasOwnProperty('hardCopyTicketBanner') ? overrides.hardCopyTicketBanner! : 'congregatio',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'depulso',
        dates: overrides && overrides.hasOwnProperty('dates') ? overrides.dates! : [relationshipsToOmit.has('CreateEventDate') ? {} as CreateEventDate : aCreateEventDate({}, relationshipsToOmit)],
        doorsOpen: overrides && overrides.hasOwnProperty('doorsOpen') ? overrides.doorsOpen! : 'corona',
        showDoorsOpen: overrides && overrides.hasOwnProperty('showDoorsOpen') ? overrides.showDoorsOpen! : false,
        showStartTime: overrides && overrides.hasOwnProperty('showStartTime') ? overrides.showStartTime! : true,
        showEndTime: overrides && overrides.hasOwnProperty('showEndTime') ? overrides.showEndTime! : false,
        ticketsViewableFromDate: overrides && overrides.hasOwnProperty('ticketsViewableFromDate') ? overrides.ticketsViewableFromDate! : 'tero',
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : false,
        isFeatured: overrides && overrides.hasOwnProperty('isFeatured') ? overrides.isFeatured! : true,
        bookingFeeType: overrides && overrides.hasOwnProperty('bookingFeeType') ? overrides.bookingFeeType! : FeeType.FlatRate,
        bookingFee: overrides && overrides.hasOwnProperty('bookingFee') ? overrides.bookingFee! : 8.6,
        isR18: overrides && overrides.hasOwnProperty('isR18') ? overrides.isR18! : false,
        isDiscoverable: overrides && overrides.hasOwnProperty('isDiscoverable') ? overrides.isDiscoverable! : true,
        isFestival: overrides && overrides.hasOwnProperty('isFestival') ? overrides.isFestival! : true,
        checkForVaccinePass: overrides && overrides.hasOwnProperty('checkForVaccinePass') ? overrides.checkForVaccinePass! : false,
        canNameTicket: overrides && overrides.hasOwnProperty('canNameTicket') ? overrides.canNameTicket! : true,
        canRenameTicket: overrides && overrides.hasOwnProperty('canRenameTicket') ? overrides.canRenameTicket! : false,
        canChangeSeats: overrides && overrides.hasOwnProperty('canChangeSeats') ? overrides.canChangeSeats! : true,
        canTransferTicket: overrides && overrides.hasOwnProperty('canTransferTicket') ? overrides.canTransferTicket! : true,
        enableWaitlist: overrides && overrides.hasOwnProperty('enableWaitlist') ? overrides.enableWaitlist! : true,
        waitlistStartDate: overrides && overrides.hasOwnProperty('waitlistStartDate') ? overrides.waitlistStartDate! : "2025-03-15T07:33:36.571Z",
        waitlistEndDate: overrides && overrides.hasOwnProperty('waitlistEndDate') ? overrides.waitlistEndDate! : "2025-09-19T11:05:34.569Z",
        enableReleaseCodes: overrides && overrides.hasOwnProperty('enableReleaseCodes') ? overrides.enableReleaseCodes! : true,
        changingSeatsFee: overrides && overrides.hasOwnProperty('changingSeatsFee') ? overrides.changingSeatsFee! : 8.6,
        sellerTransferringTicketFee: overrides && overrides.hasOwnProperty('sellerTransferringTicketFee') ? overrides.sellerTransferringTicketFee! : 6.8,
        buyerTransferringTicketFee: overrides && overrides.hasOwnProperty('buyerTransferringTicketFee') ? overrides.buyerTransferringTicketFee! : 5.9,
        shippingOptions: overrides && overrides.hasOwnProperty('shippingOptions') ? overrides.shippingOptions! : relationshipsToOmit.has('ShippingOptionsInput') ? {} as ShippingOptionsInput : aShippingOptionsInput({}, relationshipsToOmit),
        gateways: overrides && overrides.hasOwnProperty('gateways') ? overrides.gateways! : ['tenus'],
        artists: overrides && overrides.hasOwnProperty('artists') ? overrides.artists! : [relationshipsToOmit.has('CreateArtistInput') ? {} as CreateArtistInput : aCreateArtistInput({}, relationshipsToOmit)],
        genres: overrides && overrides.hasOwnProperty('genres') ? overrides.genres! : [relationshipsToOmit.has('CreateGenreInput') ? {} as CreateGenreInput : aCreateGenreInput({}, relationshipsToOmit)],
        termsAndConditions: overrides && overrides.hasOwnProperty('termsAndConditions') ? overrides.termsAndConditions! : 'votum',
        importantNotice: overrides && overrides.hasOwnProperty('importantNotice') ? overrides.importantNotice! : 'cultura',
        accessibility: overrides && overrides.hasOwnProperty('accessibility') ? overrides.accessibility! : 'benevolentia',
        invoiceInformation: overrides && overrides.hasOwnProperty('invoiceInformation') ? overrides.invoiceInformation! : 'triumphus',
        presaleInformation: overrides && overrides.hasOwnProperty('presaleInformation') ? overrides.presaleInformation! : 'subnecto',
        emailNotification: overrides && overrides.hasOwnProperty('emailNotification') ? overrides.emailNotification! : 'adulatio',
        redirectURL: overrides && overrides.hasOwnProperty('redirectURL') ? overrides.redirectURL! : 'cupiditas',
        zonesAllocatedGates: overrides && overrides.hasOwnProperty('zonesAllocatedGates') ? overrides.zonesAllocatedGates! : [relationshipsToOmit.has('ZoneAllocatedGateInput') ? {} as ZoneAllocatedGateInput : aZoneAllocatedGateInput({}, relationshipsToOmit)],
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['alius'],
        insideFeeDetails: overrides && overrides.hasOwnProperty('insideFeeDetails') ? overrides.insideFeeDetails! : [relationshipsToOmit.has('InsideFeeDetailsInput') ? {} as InsideFeeDetailsInput : anInsideFeeDetailsInput({}, relationshipsToOmit)],
        canUsePoints: overrides && overrides.hasOwnProperty('canUsePoints') ? overrides.canUsePoints! : false,
        gaVenue: overrides && overrides.hasOwnProperty('gaVenue') ? overrides.gaVenue! : relationshipsToOmit.has('CreateGaEventVenueInput') ? {} as CreateGaEventVenueInput : aCreateGaEventVenueInput({}, relationshipsToOmit),
        ticketCover: overrides && overrides.hasOwnProperty('ticketCover') ? overrides.ticketCover! : relationshipsToOmit.has('TicketCoverInput') ? {} as TicketCoverInput : aTicketCoverInput({}, relationshipsToOmit),
        listedReleaseOptions: overrides && overrides.hasOwnProperty('listedReleaseOptions') ? overrides.listedReleaseOptions! : relationshipsToOmit.has('ListedReleaseOptionsInput') ? {} as ListedReleaseOptionsInput : aListedReleaseOptionsInput({}, relationshipsToOmit),
        merchantReference: overrides && overrides.hasOwnProperty('merchantReference') ? overrides.merchantReference! : 'verbum',
        intellitixProjectId: overrides && overrides.hasOwnProperty('intellitixProjectId') ? overrides.intellitixProjectId! : 'coadunatio',
        intellitixSourceId: overrides && overrides.hasOwnProperty('intellitixSourceId') ? overrides.intellitixSourceId! : 'aranea',
        pixelId: overrides && overrides.hasOwnProperty('pixelId') ? overrides.pixelId! : 'esse',
        hiddenFromPublic: overrides && overrides.hasOwnProperty('hiddenFromPublic') ? overrides.hiddenFromPublic! : true,
        enablePaymentPlans: overrides && overrides.hasOwnProperty('enablePaymentPlans') ? overrides.enablePaymentPlans! : true,
        paymentPlanScheduleOptions: overrides && overrides.hasOwnProperty('paymentPlanScheduleOptions') ? overrides.paymentPlanScheduleOptions! : [relationshipsToOmit.has('ScheduleOptionInput') ? {} as ScheduleOptionInput : aScheduleOptionInput({}, relationshipsToOmit)],
        seoMetadata: overrides && overrides.hasOwnProperty('seoMetadata') ? overrides.seoMetadata! : relationshipsToOmit.has('SeoMetadataInput') ? {} as SeoMetadataInput : aSeoMetadataInput({}, relationshipsToOmit),
        productUpsell: overrides && overrides.hasOwnProperty('productUpsell') ? overrides.productUpsell! : relationshipsToOmit.has('ProductUpsellInput') ? {} as ProductUpsellInput : aProductUpsellInput({}, relationshipsToOmit),
        ticketTypes: overrides && overrides.hasOwnProperty('ticketTypes') ? overrides.ticketTypes! : [relationshipsToOmit.has('UpdateTicketTypeInputWithId') ? {} as UpdateTicketTypeInputWithId : anUpdateTicketTypeInputWithId({}, relationshipsToOmit)],
        eventAddons: overrides && overrides.hasOwnProperty('eventAddons') ? overrides.eventAddons! : [relationshipsToOmit.has('UpdateEventAddonInputWithId') ? {} as UpdateEventAddonInputWithId : anUpdateEventAddonInputWithId({}, relationshipsToOmit)],
        tax: overrides && overrides.hasOwnProperty('tax') ? overrides.tax! : [relationshipsToOmit.has('TaxInput') ? {} as TaxInput : aTaxInput({}, relationshipsToOmit)],
        seatSelectionFilterOverrides: overrides && overrides.hasOwnProperty('seatSelectionFilterOverrides') ? overrides.seatSelectionFilterOverrides! : relationshipsToOmit.has('SeatSelectionFiltersInput') ? {} as SeatSelectionFiltersInput : aSeatSelectionFiltersInput({}, relationshipsToOmit),
    };
};

export const aCreateDigitalInfoInput = (overrides?: Partial<CreateDigitalInfoInput>, _relationshipsToOmit: Set<string> = new Set()): CreateDigitalInfoInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateDigitalInfoInput');
    return {
        url: overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'celer',
        emailTemplateId: overrides && overrides.hasOwnProperty('emailTemplateId') ? overrides.emailTemplateId! : 'absque',
        additionalEmailInfo: overrides && overrides.hasOwnProperty('additionalEmailInfo') ? overrides.additionalEmailInfo! : relationshipsToOmit.has('AdditionalEmailInfoInput') ? {} as AdditionalEmailInfoInput : anAdditionalEmailInfoInput({}, relationshipsToOmit),
    };
};

export const anAdditionalEmailInfoInput = (overrides?: Partial<AdditionalEmailInfoInput>, _relationshipsToOmit: Set<string> = new Set()): AdditionalEmailInfoInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AdditionalEmailInfoInput');
    return {
        text: overrides && overrides.hasOwnProperty('text') ? overrides.text! : 'canonicus',
        buttonText: overrides && overrides.hasOwnProperty('buttonText') ? overrides.buttonText! : 'congregatio',
        buttonUrl: overrides && overrides.hasOwnProperty('buttonUrl') ? overrides.buttonUrl! : 'victoria',
    };
};

export const aCreateEventDate = (overrides?: Partial<CreateEventDate>, _relationshipsToOmit: Set<string> = new Set()): CreateEventDate => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateEventDate');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'fuga',
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : 'deprecator',
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : 'bene',
        doorsOpen: overrides && overrides.hasOwnProperty('doorsOpen') ? overrides.doorsOpen! : 'agnitio',
    };
};

export const aShippingOptionsInput = (overrides?: Partial<ShippingOptionsInput>, _relationshipsToOmit: Set<string> = new Set()): ShippingOptionsInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ShippingOptionsInput');
    return {
        eTicket: overrides && overrides.hasOwnProperty('eTicket') ? overrides.eTicket! : 6.3,
        printedTicketByMail: overrides && overrides.hasOwnProperty('printedTicketByMail') ? overrides.printedTicketByMail! : 4.8,
        printedTicketByCourier: overrides && overrides.hasOwnProperty('printedTicketByCourier') ? overrides.printedTicketByCourier! : 1.7,
        printedTicketByCourierRural: overrides && overrides.hasOwnProperty('printedTicketByCourierRural') ? overrides.printedTicketByCourierRural! : 7.2,
        printedTicketAtVenue: overrides && overrides.hasOwnProperty('printedTicketAtVenue') ? overrides.printedTicketAtVenue! : 3.8,
    };
};

export const aCreateArtistInput = (overrides?: Partial<CreateArtistInput>, _relationshipsToOmit: Set<string> = new Set()): CreateArtistInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateArtistInput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'utrum',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'succurro',
        source: overrides && overrides.hasOwnProperty('source') ? overrides.source! : 'deduco',
        sourceId: overrides && overrides.hasOwnProperty('sourceId') ? overrides.sourceId! : 'vespillo',
        imageUrl: overrides && overrides.hasOwnProperty('imageUrl') ? overrides.imageUrl! : 'texo',
        genres: overrides && overrides.hasOwnProperty('genres') ? overrides.genres! : [relationshipsToOmit.has('CreateGenreInput') ? {} as CreateGenreInput : aCreateGenreInput({}, relationshipsToOmit)],
        followerCount: overrides && overrides.hasOwnProperty('followerCount') ? overrides.followerCount! : 4.7,
    };
};

export const aCreateGenreInput = (overrides?: Partial<CreateGenreInput>, _relationshipsToOmit: Set<string> = new Set()): CreateGenreInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateGenreInput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'curia',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'curvo',
    };
};

export const aZoneAllocatedGateInput = (overrides?: Partial<ZoneAllocatedGateInput>, _relationshipsToOmit: Set<string> = new Set()): ZoneAllocatedGateInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ZoneAllocatedGateInput');
    return {
        zoneId: overrides && overrides.hasOwnProperty('zoneId') ? overrides.zoneId! : 'complectus',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'neque',
        gates: overrides && overrides.hasOwnProperty('gates') ? overrides.gates! : ['uter'],
        sections: overrides && overrides.hasOwnProperty('sections') ? overrides.sections! : [relationshipsToOmit.has('ZoneAllocatedGateSectionInput') ? {} as ZoneAllocatedGateSectionInput : aZoneAllocatedGateSectionInput({}, relationshipsToOmit)],
        availabilityCount: overrides && overrides.hasOwnProperty('availabilityCount') ? overrides.availabilityCount! : relationshipsToOmit.has('ZoneAllocationAvailabilityInput') ? {} as ZoneAllocationAvailabilityInput : aZoneAllocationAvailabilityInput({}, relationshipsToOmit),
        dates: overrides && overrides.hasOwnProperty('dates') ? overrides.dates! : [relationshipsToOmit.has('ZoneAllocatedDateInput') ? {} as ZoneAllocatedDateInput : aZoneAllocatedDateInput({}, relationshipsToOmit)],
    };
};

export const aZoneAllocatedGateSectionInput = (overrides?: Partial<ZoneAllocatedGateSectionInput>, _relationshipsToOmit: Set<string> = new Set()): ZoneAllocatedGateSectionInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ZoneAllocatedGateSectionInput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'impedit',
        sectionId: overrides && overrides.hasOwnProperty('sectionId') ? overrides.sectionId! : 'voluptates',
        gates: overrides && overrides.hasOwnProperty('gates') ? overrides.gates! : ['varietas'],
    };
};

export const aZoneAllocationAvailabilityInput = (overrides?: Partial<ZoneAllocationAvailabilityInput>, _relationshipsToOmit: Set<string> = new Set()): ZoneAllocationAvailabilityInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ZoneAllocationAvailabilityInput');
    return {
        notForSale: overrides && overrides.hasOwnProperty('notForSale') ? overrides.notForSale! : 7.5,
        holdByMembership: overrides && overrides.hasOwnProperty('holdByMembership') ? overrides.holdByMembership! : 5.9,
        booked: overrides && overrides.hasOwnProperty('booked') ? overrides.booked! : 9.1,
        available: overrides && overrides.hasOwnProperty('available') ? overrides.available! : 8.2,
    };
};

export const aZoneAllocatedDateInput = (overrides?: Partial<ZoneAllocatedDateInput>, _relationshipsToOmit: Set<string> = new Set()): ZoneAllocatedDateInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ZoneAllocatedDateInput');
    return {
        eventDateId: overrides && overrides.hasOwnProperty('eventDateId') ? overrides.eventDateId! : '8388232d-2a74-4661-84cd-006fb41343a0',
        alternateEntryTime: overrides && overrides.hasOwnProperty('alternateEntryTime') ? overrides.alternateEntryTime! : 'tempore',
    };
};

export const anInsideFeeDetailsInput = (overrides?: Partial<InsideFeeDetailsInput>, _relationshipsToOmit: Set<string> = new Set()): InsideFeeDetailsInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InsideFeeDetailsInput');
    return {
        priceRangeFrom: overrides && overrides.hasOwnProperty('priceRangeFrom') ? overrides.priceRangeFrom! : 5.8,
        priceRangeTo: overrides && overrides.hasOwnProperty('priceRangeTo') ? overrides.priceRangeTo! : 0.8,
        insideFee: overrides && overrides.hasOwnProperty('insideFee') ? overrides.insideFee! : 4.1,
    };
};

export const aCreateGaEventVenueInput = (overrides?: Partial<CreateGaEventVenueInput>, _relationshipsToOmit: Set<string> = new Set()): CreateGaEventVenueInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateGaEventVenueInput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'cras',
        address: overrides && overrides.hasOwnProperty('address') ? overrides.address! : relationshipsToOmit.has('AddressInput') ? {} as AddressInput : anAddressInput({}, relationshipsToOmit),
        location: overrides && overrides.hasOwnProperty('location') ? overrides.location! : relationshipsToOmit.has('CoordinateInput') ? {} as CoordinateInput : aCoordinateInput({}, relationshipsToOmit),
        timezone: overrides && overrides.hasOwnProperty('timezone') ? overrides.timezone! : 'Pacific/Auckland',
        locale: overrides && overrides.hasOwnProperty('locale') ? overrides.locale! : 'en',
    };
};

export const anAddressInput = (overrides?: Partial<AddressInput>, _relationshipsToOmit: Set<string> = new Set()): AddressInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AddressInput');
    return {
        line1: overrides && overrides.hasOwnProperty('line1') ? overrides.line1! : 'sumptus',
        line2: overrides && overrides.hasOwnProperty('line2') ? overrides.line2! : 'clementia',
        suburb: overrides && overrides.hasOwnProperty('suburb') ? overrides.suburb! : 'valeo',
        postalCode: overrides && overrides.hasOwnProperty('postalCode') ? overrides.postalCode! : 'aequitas',
        city: overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'aut',
        state: overrides && overrides.hasOwnProperty('state') ? overrides.state! : 'ab',
        country: overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'corrupti',
        formattedAddress: overrides && overrides.hasOwnProperty('formattedAddress') ? overrides.formattedAddress! : 'cena',
    };
};

export const aCoordinateInput = (overrides?: Partial<CoordinateInput>, _relationshipsToOmit: Set<string> = new Set()): CoordinateInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CoordinateInput');
    return {
        lat: overrides && overrides.hasOwnProperty('lat') ? overrides.lat! : 4.2,
        lng: overrides && overrides.hasOwnProperty('lng') ? overrides.lng! : 8.4,
    };
};

export const aTicketCoverInput = (overrides?: Partial<TicketCoverInput>, _relationshipsToOmit: Set<string> = new Set()): TicketCoverInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TicketCoverInput');
    return {
        promoterFeePercentage: overrides && overrides.hasOwnProperty('promoterFeePercentage') ? overrides.promoterFeePercentage! : 0.7,
        purchaseBehaviour: overrides && overrides.hasOwnProperty('purchaseBehaviour') ? overrides.purchaseBehaviour! : TicketCoverPurchaseBehaviour.Optional,
        isEnabled: overrides && overrides.hasOwnProperty('isEnabled') ? overrides.isEnabled! : true,
    };
};

export const aListedReleaseOptionsInput = (overrides?: Partial<ListedReleaseOptionsInput>, _relationshipsToOmit: Set<string> = new Set()): ListedReleaseOptionsInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ListedReleaseOptionsInput');
    return {
        askHowDidYouHearAboutUs: overrides && overrides.hasOwnProperty('askHowDidYouHearAboutUs') ? overrides.askHowDidYouHearAboutUs! : true,
        askForDietaryRequirements: overrides && overrides.hasOwnProperty('askForDietaryRequirements') ? overrides.askForDietaryRequirements! : false,
        startCondition: overrides && overrides.hasOwnProperty('startCondition') ? overrides.startCondition! : ReleaseStartCondition.Manual,
        startConditionDate: overrides && overrides.hasOwnProperty('startConditionDate') ? overrides.startConditionDate! : "2026-02-22T14:55:12.192Z",
        endCondition: overrides && overrides.hasOwnProperty('endCondition') ? overrides.endCondition! : ReleaseEndCondition.Manual,
        endConditionDate: overrides && overrides.hasOwnProperty('endConditionDate') ? overrides.endConditionDate! : "2025-11-30T04:43:52.012Z",
        endConditionQuantity: overrides && overrides.hasOwnProperty('endConditionQuantity') ? overrides.endConditionQuantity! : 5.3,
    };
};

export const aScheduleOptionInput = (overrides?: Partial<ScheduleOptionInput>, _relationshipsToOmit: Set<string> = new Set()): ScheduleOptionInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ScheduleOptionInput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'modi',
        interval: overrides && overrides.hasOwnProperty('interval') ? overrides.interval! : ScheduleOptionInterval.Day,
        installmentCount: overrides && overrides.hasOwnProperty('installmentCount') ? overrides.installmentCount! : 0,
        availableUntil: overrides && overrides.hasOwnProperty('availableUntil') ? overrides.availableUntil! : 'villa',
        minimumOrderAmount: overrides && overrides.hasOwnProperty('minimumOrderAmount') ? overrides.minimumOrderAmount! : 6.4,
        finalPaymentDate: overrides && overrides.hasOwnProperty('finalPaymentDate') ? overrides.finalPaymentDate! : 'carus',
        depositPercentage: overrides && overrides.hasOwnProperty('depositPercentage') ? overrides.depositPercentage! : 3.6,
        stripeFeePercentage: overrides && overrides.hasOwnProperty('stripeFeePercentage') ? overrides.stripeFeePercentage! : 3.3,
        promoterFeePercentage: overrides && overrides.hasOwnProperty('promoterFeePercentage') ? overrides.promoterFeePercentage! : 6.8,
        flicketFeePercentage: overrides && overrides.hasOwnProperty('flicketFeePercentage') ? overrides.flicketFeePercentage! : 5.3,
    };
};

export const aSeoMetadataInput = (overrides?: Partial<SeoMetadataInput>, _relationshipsToOmit: Set<string> = new Set()): SeoMetadataInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SeoMetadataInput');
    return {
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'eligendi',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'traho',
        origin: overrides && overrides.hasOwnProperty('origin') ? overrides.origin! : SeoMetadataOrigin.UserDefined,
    };
};

export const aProductUpsellInput = (overrides?: Partial<ProductUpsellInput>, _relationshipsToOmit: Set<string> = new Set()): ProductUpsellInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ProductUpsellInput');
    return {
        selectedProducts: overrides && overrides.hasOwnProperty('selectedProducts') ? overrides.selectedProducts! : [relationshipsToOmit.has('SelectedProductInput') ? {} as SelectedProductInput : aSelectedProductInput({}, relationshipsToOmit)],
        customizedUpsell: overrides && overrides.hasOwnProperty('customizedUpsell') ? overrides.customizedUpsell! : true,
    };
};

export const aSelectedProductInput = (overrides?: Partial<SelectedProductInput>, _relationshipsToOmit: Set<string> = new Set()): SelectedProductInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SelectedProductInput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'pauper',
    };
};

export const anUpdateTicketTypeInputWithId = (overrides?: Partial<UpdateTicketTypeInputWithId>, _relationshipsToOmit: Set<string> = new Set()): UpdateTicketTypeInputWithId => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateTicketTypeInputWithId');
    return {
        kind: overrides && overrides.hasOwnProperty('kind') ? overrides.kind! : TicketTypeKind.Standard,
        isGrouped: overrides && overrides.hasOwnProperty('isGrouped') ? overrides.isGrouped! : false,
        isChild: overrides && overrides.hasOwnProperty('isChild') ? overrides.isChild! : false,
        groupAmount: overrides && overrides.hasOwnProperty('groupAmount') ? overrides.groupAmount! : 3,
        quantitySet: overrides && overrides.hasOwnProperty('quantitySet') ? overrides.quantitySet! : 6.1,
        intellitixIds: overrides && overrides.hasOwnProperty('intellitixIds') ? overrides.intellitixIds! : ['illo'],
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'degenero',
        dates: overrides && overrides.hasOwnProperty('dates') ? overrides.dates! : [relationshipsToOmit.has('CreateTicketTypeDate') ? {} as CreateTicketTypeDate : aCreateTicketTypeDate({}, relationshipsToOmit)],
        bookingFeeType: overrides && overrides.hasOwnProperty('bookingFeeType') ? overrides.bookingFeeType! : FeeType.FlatRate,
        bookingFee: overrides && overrides.hasOwnProperty('bookingFee') ? overrides.bookingFee! : 8.6,
        stadiumLevyFee: overrides && overrides.hasOwnProperty('stadiumLevyFee') ? overrides.stadiumLevyFee! : 4.1,
        inHighDemand: overrides && overrides.hasOwnProperty('inHighDemand') ? overrides.inHighDemand! : true,
        customBadge: overrides && overrides.hasOwnProperty('customBadge') ? overrides.customBadge! : 'acervus',
        customBadgeBackgroundColor: overrides && overrides.hasOwnProperty('customBadgeBackgroundColor') ? overrides.customBadgeBackgroundColor! : 'pecus',
        customBadgeTextColor: overrides && overrides.hasOwnProperty('customBadgeTextColor') ? overrides.customBadgeTextColor! : 'sit',
        soldOut: overrides && overrides.hasOwnProperty('soldOut') ? overrides.soldOut! : true,
        hidePriceWhenSoldOut: overrides && overrides.hasOwnProperty('hidePriceWhenSoldOut') ? overrides.hidePriceWhenSoldOut! : true,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'uterque',
        restrictions: overrides && overrides.hasOwnProperty('restrictions') ? overrides.restrictions! : 'accusator',
        printAtHomeInformation: overrides && overrides.hasOwnProperty('printAtHomeInformation') ? overrides.printAtHomeInformation! : 'adimpleo',
        namingFields: overrides && overrides.hasOwnProperty('namingFields') ? overrides.namingFields! : [relationshipsToOmit.has('FormFieldInput') ? {} as FormFieldInput : aFormFieldInput({}, relationshipsToOmit)],
        doorsOpen: overrides && overrides.hasOwnProperty('doorsOpen') ? overrides.doorsOpen! : 'tepidus',
        showDoorsOpen: overrides && overrides.hasOwnProperty('showDoorsOpen') ? overrides.showDoorsOpen! : true,
        showStartTime: overrides && overrides.hasOwnProperty('showStartTime') ? overrides.showStartTime! : true,
        showEndTime: overrides && overrides.hasOwnProperty('showEndTime') ? overrides.showEndTime! : false,
        entryDates: overrides && overrides.hasOwnProperty('entryDates') ? overrides.entryDates! : [relationshipsToOmit.has('CreateEventDate') ? {} as CreateEventDate : aCreateEventDate({}, relationshipsToOmit)],
        ticketBanner: overrides && overrides.hasOwnProperty('ticketBanner') ? overrides.ticketBanner! : 'vulticulus',
        ticketImage: overrides && overrides.hasOwnProperty('ticketImage') ? overrides.ticketImage! : 'convoco',
        imageGallery: overrides && overrides.hasOwnProperty('imageGallery') ? overrides.imageGallery! : [relationshipsToOmit.has('ImageGalleryItemInput') ? {} as ImageGalleryItemInput : anImageGalleryItemInput({}, relationshipsToOmit)],
        quantity: overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 4.4,
        minPurchaseQuantity: overrides && overrides.hasOwnProperty('minPurchaseQuantity') ? overrides.minPurchaseQuantity! : 0.9,
        maxPurchaseQuantity: overrides && overrides.hasOwnProperty('maxPurchaseQuantity') ? overrides.maxPurchaseQuantity! : 0,
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['averto'],
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 0.2,
        releaseZoneId: overrides && overrides.hasOwnProperty('releaseZoneId') ? overrides.releaseZoneId! : 'acidus',
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : true,
        isComplimentary: overrides && overrides.hasOwnProperty('isComplimentary') ? overrides.isComplimentary! : false,
        isBusinessOnly: overrides && overrides.hasOwnProperty('isBusinessOnly') ? overrides.isBusinessOnly! : true,
        onSaleConfig: overrides && overrides.hasOwnProperty('onSaleConfig') ? overrides.onSaleConfig! : relationshipsToOmit.has('TicketTypeOnSaleConfigInput') ? {} as TicketTypeOnSaleConfigInput : aTicketTypeOnSaleConfigInput({}, relationshipsToOmit),
        pricingTiers: overrides && overrides.hasOwnProperty('pricingTiers') ? overrides.pricingTiers! : [relationshipsToOmit.has('PricingTierInput') ? {} as PricingTierInput : aPricingTierInput({}, relationshipsToOmit)],
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'deorsum',
    };
};

export const aCreateTicketTypeDate = (overrides?: Partial<CreateTicketTypeDate>, _relationshipsToOmit: Set<string> = new Set()): CreateTicketTypeDate => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateTicketTypeDate');
    return {
        eventDateId: overrides && overrides.hasOwnProperty('eventDateId') ? overrides.eventDateId! : 'clamo',
        alternateEntryTime: overrides && overrides.hasOwnProperty('alternateEntryTime') ? overrides.alternateEntryTime! : 'vergo',
    };
};

export const aFormFieldInput = (overrides?: Partial<FormFieldInput>, _relationshipsToOmit: Set<string> = new Set()): FormFieldInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('FormFieldInput');
    return {
        field: overrides && overrides.hasOwnProperty('field') ? overrides.field! : 'decet',
        isRequired: overrides && overrides.hasOwnProperty('isRequired') ? overrides.isRequired! : false,
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'placeat',
        isCustom: overrides && overrides.hasOwnProperty('isCustom') ? overrides.isCustom! : true,
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'terga',
        defaultValue: overrides && overrides.hasOwnProperty('defaultValue') ? overrides.defaultValue! : 'suus',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'antea',
        options: overrides && overrides.hasOwnProperty('options') ? overrides.options! : ['caecus'],
    };
};

export const anImageGalleryItemInput = (overrides?: Partial<ImageGalleryItemInput>, _relationshipsToOmit: Set<string> = new Set()): ImageGalleryItemInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ImageGalleryItemInput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'tametsi',
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'cohaero',
        original: overrides && overrides.hasOwnProperty('original') ? overrides.original! : relationshipsToOmit.has('GalleryImageInput') ? {} as GalleryImageInput : aGalleryImageInput({}, relationshipsToOmit),
        cropped: overrides && overrides.hasOwnProperty('cropped') ? overrides.cropped! : relationshipsToOmit.has('GalleryImageInput') ? {} as GalleryImageInput : aGalleryImageInput({}, relationshipsToOmit),
    };
};

export const aGalleryImageInput = (overrides?: Partial<GalleryImageInput>, _relationshipsToOmit: Set<string> = new Set()): GalleryImageInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('GalleryImageInput');
    return {
        src: overrides && overrides.hasOwnProperty('src') ? overrides.src! : 'verumtamen',
        metaData: overrides && overrides.hasOwnProperty('metaData') ? overrides.metaData! : relationshipsToOmit.has('MetaDataInput') ? {} as MetaDataInput : aMetaDataInput({}, relationshipsToOmit),
        aspectRatio: overrides && overrides.hasOwnProperty('aspectRatio') ? overrides.aspectRatio! : 0.3,
    };
};

export const aMetaDataInput = (overrides?: Partial<MetaDataInput>, _relationshipsToOmit: Set<string> = new Set()): MetaDataInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MetaDataInput');
    return {
        width: overrides && overrides.hasOwnProperty('width') ? overrides.width! : 1.2,
        height: overrides && overrides.hasOwnProperty('height') ? overrides.height! : 7.4,
    };
};

export const aTicketTypeOnSaleConfigInput = (overrides?: Partial<TicketTypeOnSaleConfigInput>, _relationshipsToOmit: Set<string> = new Set()): TicketTypeOnSaleConfigInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TicketTypeOnSaleConfigInput');
    return {
        startConfig: overrides && overrides.hasOwnProperty('startConfig') ? overrides.startConfig! : relationshipsToOmit.has('TicketTypeOnSaleStartConfigInput') ? {} as TicketTypeOnSaleStartConfigInput : aTicketTypeOnSaleStartConfigInput({}, relationshipsToOmit),
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : "2025-03-22T03:43:55.695Z",
    };
};

export const aTicketTypeOnSaleStartConfigInput = (overrides?: Partial<TicketTypeOnSaleStartConfigInput>, _relationshipsToOmit: Set<string> = new Set()): TicketTypeOnSaleStartConfigInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TicketTypeOnSaleStartConfigInput');
    return {
        condition: overrides && overrides.hasOwnProperty('condition') ? overrides.condition! : TicketTypeOnSaleCondition.TicketType,
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2025-11-22T15:30:11.144Z",
        ticketTypeId: overrides && overrides.hasOwnProperty('ticketTypeId') ? overrides.ticketTypeId! : '572eea93-8a56-4911-8c91-3d01866269cd',
    };
};

export const aPricingTierInput = (overrides?: Partial<PricingTierInput>, _relationshipsToOmit: Set<string> = new Set()): PricingTierInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PricingTierInput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'caveo',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'addo',
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 2.3,
        quantity: overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 2.9,
        soldOut: overrides && overrides.hasOwnProperty('soldOut') ? overrides.soldOut! : true,
    };
};

export const anUpdateEventAddonInputWithId = (overrides?: Partial<UpdateEventAddonInputWithId>, _relationshipsToOmit: Set<string> = new Set()): UpdateEventAddonInputWithId => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateEventAddonInputWithId');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'vinculum',
        enableNaming: overrides && overrides.hasOwnProperty('enableNaming') ? overrides.enableNaming! : true,
        quantity: overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 8.9,
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 5,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'territo',
        imageGallery: overrides && overrides.hasOwnProperty('imageGallery') ? overrides.imageGallery! : [relationshipsToOmit.has('ImageGalleryItemInput') ? {} as ImageGalleryItemInput : anImageGalleryItemInput({}, relationshipsToOmit)],
        restrictions: overrides && overrides.hasOwnProperty('restrictions') ? overrides.restrictions! : 'cuppedia',
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : true,
        namingFields: overrides && overrides.hasOwnProperty('namingFields') ? overrides.namingFields! : [relationshipsToOmit.has('FormFieldInput') ? {} as FormFieldInput : aFormFieldInput({}, relationshipsToOmit)],
        addonImage: overrides && overrides.hasOwnProperty('addonImage') ? overrides.addonImage! : 'adamo',
        insideFee: overrides && overrides.hasOwnProperty('insideFee') ? overrides.insideFee! : 6.1,
        hideQRCode: overrides && overrides.hasOwnProperty('hideQRCode') ? overrides.hideQRCode! : false,
        intellitixId: overrides && overrides.hasOwnProperty('intellitixId') ? overrides.intellitixId! : 'curo',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'cogito',
    };
};

export const aTaxInput = (overrides?: Partial<TaxInput>, _relationshipsToOmit: Set<string> = new Set()): TaxInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TaxInput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'reiciendis',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 7.5,
        isExclusive: overrides && overrides.hasOwnProperty('isExclusive') ? overrides.isExclusive! : false,
    };
};

export const aSeatSelectionFiltersInput = (overrides?: Partial<SeatSelectionFiltersInput>, _relationshipsToOmit: Set<string> = new Set()): SeatSelectionFiltersInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SeatSelectionFiltersInput');
    return {
        seatQuantity: overrides && overrides.hasOwnProperty('seatQuantity') ? overrides.seatQuantity! : 1564,
        sortType: overrides && overrides.hasOwnProperty('sortType') ? overrides.sortType! : 'ipsa',
        selectType: overrides && overrides.hasOwnProperty('selectType') ? overrides.selectType! : 'vulgus',
    };
};

export const anUpdateEventInput = (overrides?: Partial<UpdateEventInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateEventInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateEventInput');
    return {
        eventKind: overrides && overrides.hasOwnProperty('eventKind') ? overrides.eventKind! : EventKind.Standard,
        digitalInfo: overrides && overrides.hasOwnProperty('digitalInfo') ? overrides.digitalInfo! : relationshipsToOmit.has('UpdateDigitalInfoInput') ? {} as UpdateDigitalInfoInput : anUpdateDigitalInfoInput({}, relationshipsToOmit),
        season: overrides && overrides.hasOwnProperty('season') ? overrides.season! : 'arguo',
        venue: overrides && overrides.hasOwnProperty('venue') ? overrides.venue! : 'tres',
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'curo',
        logo: overrides && overrides.hasOwnProperty('logo') ? overrides.logo! : 'cumque',
        backgroundImage: overrides && overrides.hasOwnProperty('backgroundImage') ? overrides.backgroundImage! : 'patior',
        backgroundImageFullPage: overrides && overrides.hasOwnProperty('backgroundImageFullPage') ? overrides.backgroundImageFullPage! : 'suadeo',
        descriptionImage: overrides && overrides.hasOwnProperty('descriptionImage') ? overrides.descriptionImage! : 'clementia',
        thumbnail: overrides && overrides.hasOwnProperty('thumbnail') ? overrides.thumbnail! : 'tyrannus',
        printBanner1: overrides && overrides.hasOwnProperty('printBanner1') ? overrides.printBanner1! : 'depulso',
        printBanner2: overrides && overrides.hasOwnProperty('printBanner2') ? overrides.printBanner2! : 'auxilium',
        hardCopyTicketBanner: overrides && overrides.hasOwnProperty('hardCopyTicketBanner') ? overrides.hardCopyTicketBanner! : 'delicate',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'surgo',
        dates: overrides && overrides.hasOwnProperty('dates') ? overrides.dates! : [relationshipsToOmit.has('CreateEventDate') ? {} as CreateEventDate : aCreateEventDate({}, relationshipsToOmit)],
        doorsOpen: overrides && overrides.hasOwnProperty('doorsOpen') ? overrides.doorsOpen! : 'cinis',
        showDoorsOpen: overrides && overrides.hasOwnProperty('showDoorsOpen') ? overrides.showDoorsOpen! : true,
        showStartTime: overrides && overrides.hasOwnProperty('showStartTime') ? overrides.showStartTime! : false,
        showEndTime: overrides && overrides.hasOwnProperty('showEndTime') ? overrides.showEndTime! : false,
        ticketsViewableFromDate: overrides && overrides.hasOwnProperty('ticketsViewableFromDate') ? overrides.ticketsViewableFromDate! : 'tam',
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : true,
        isFeatured: overrides && overrides.hasOwnProperty('isFeatured') ? overrides.isFeatured! : true,
        bookingFeeType: overrides && overrides.hasOwnProperty('bookingFeeType') ? overrides.bookingFeeType! : FeeType.FlatRate,
        bookingFee: overrides && overrides.hasOwnProperty('bookingFee') ? overrides.bookingFee! : 1.6,
        isR18: overrides && overrides.hasOwnProperty('isR18') ? overrides.isR18! : true,
        isDiscoverable: overrides && overrides.hasOwnProperty('isDiscoverable') ? overrides.isDiscoverable! : false,
        isFestival: overrides && overrides.hasOwnProperty('isFestival') ? overrides.isFestival! : false,
        checkForVaccinePass: overrides && overrides.hasOwnProperty('checkForVaccinePass') ? overrides.checkForVaccinePass! : true,
        canNameTicket: overrides && overrides.hasOwnProperty('canNameTicket') ? overrides.canNameTicket! : false,
        canRenameTicket: overrides && overrides.hasOwnProperty('canRenameTicket') ? overrides.canRenameTicket! : false,
        canChangeSeats: overrides && overrides.hasOwnProperty('canChangeSeats') ? overrides.canChangeSeats! : false,
        canTransferTicket: overrides && overrides.hasOwnProperty('canTransferTicket') ? overrides.canTransferTicket! : false,
        enableWaitlist: overrides && overrides.hasOwnProperty('enableWaitlist') ? overrides.enableWaitlist! : false,
        waitlistStartDate: overrides && overrides.hasOwnProperty('waitlistStartDate') ? overrides.waitlistStartDate! : "2025-08-19T19:30:32.859Z",
        waitlistEndDate: overrides && overrides.hasOwnProperty('waitlistEndDate') ? overrides.waitlistEndDate! : "2025-09-07T18:29:02.392Z",
        enableReleaseCodes: overrides && overrides.hasOwnProperty('enableReleaseCodes') ? overrides.enableReleaseCodes! : true,
        changingSeatsFee: overrides && overrides.hasOwnProperty('changingSeatsFee') ? overrides.changingSeatsFee! : 0.8,
        sellerTransferringTicketFee: overrides && overrides.hasOwnProperty('sellerTransferringTicketFee') ? overrides.sellerTransferringTicketFee! : 5.5,
        buyerTransferringTicketFee: overrides && overrides.hasOwnProperty('buyerTransferringTicketFee') ? overrides.buyerTransferringTicketFee! : 4,
        shippingOptions: overrides && overrides.hasOwnProperty('shippingOptions') ? overrides.shippingOptions! : relationshipsToOmit.has('ShippingOptionsInput') ? {} as ShippingOptionsInput : aShippingOptionsInput({}, relationshipsToOmit),
        gateways: overrides && overrides.hasOwnProperty('gateways') ? overrides.gateways! : ['temeritas'],
        artists: overrides && overrides.hasOwnProperty('artists') ? overrides.artists! : [relationshipsToOmit.has('CreateArtistInput') ? {} as CreateArtistInput : aCreateArtistInput({}, relationshipsToOmit)],
        genres: overrides && overrides.hasOwnProperty('genres') ? overrides.genres! : [relationshipsToOmit.has('CreateGenreInput') ? {} as CreateGenreInput : aCreateGenreInput({}, relationshipsToOmit)],
        termsAndConditions: overrides && overrides.hasOwnProperty('termsAndConditions') ? overrides.termsAndConditions! : 'cohibeo',
        importantNotice: overrides && overrides.hasOwnProperty('importantNotice') ? overrides.importantNotice! : 'clam',
        accessibility: overrides && overrides.hasOwnProperty('accessibility') ? overrides.accessibility! : 'bellicus',
        invoiceInformation: overrides && overrides.hasOwnProperty('invoiceInformation') ? overrides.invoiceInformation! : 'congregatio',
        presaleInformation: overrides && overrides.hasOwnProperty('presaleInformation') ? overrides.presaleInformation! : 'aeger',
        emailNotification: overrides && overrides.hasOwnProperty('emailNotification') ? overrides.emailNotification! : 'tero',
        redirectURL: overrides && overrides.hasOwnProperty('redirectURL') ? overrides.redirectURL! : 'cultura',
        zonesAllocatedGates: overrides && overrides.hasOwnProperty('zonesAllocatedGates') ? overrides.zonesAllocatedGates! : [relationshipsToOmit.has('ZoneAllocatedGateInput') ? {} as ZoneAllocatedGateInput : aZoneAllocatedGateInput({}, relationshipsToOmit)],
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['spoliatio'],
        insideFeeDetails: overrides && overrides.hasOwnProperty('insideFeeDetails') ? overrides.insideFeeDetails! : [relationshipsToOmit.has('InsideFeeDetailsInput') ? {} as InsideFeeDetailsInput : anInsideFeeDetailsInput({}, relationshipsToOmit)],
        canUsePoints: overrides && overrides.hasOwnProperty('canUsePoints') ? overrides.canUsePoints! : true,
        gaVenue: overrides && overrides.hasOwnProperty('gaVenue') ? overrides.gaVenue! : relationshipsToOmit.has('CreateGaEventVenueInput') ? {} as CreateGaEventVenueInput : aCreateGaEventVenueInput({}, relationshipsToOmit),
        ticketCover: overrides && overrides.hasOwnProperty('ticketCover') ? overrides.ticketCover! : relationshipsToOmit.has('TicketCoverInput') ? {} as TicketCoverInput : aTicketCoverInput({}, relationshipsToOmit),
        listedReleaseOptions: overrides && overrides.hasOwnProperty('listedReleaseOptions') ? overrides.listedReleaseOptions! : relationshipsToOmit.has('ListedReleaseOptionsInput') ? {} as ListedReleaseOptionsInput : aListedReleaseOptionsInput({}, relationshipsToOmit),
        merchantReference: overrides && overrides.hasOwnProperty('merchantReference') ? overrides.merchantReference! : 'tamisium',
        intellitixProjectId: overrides && overrides.hasOwnProperty('intellitixProjectId') ? overrides.intellitixProjectId! : 'derelinquo',
        intellitixSourceId: overrides && overrides.hasOwnProperty('intellitixSourceId') ? overrides.intellitixSourceId! : 'viridis',
        pixelId: overrides && overrides.hasOwnProperty('pixelId') ? overrides.pixelId! : 'damno',
        hiddenFromPublic: overrides && overrides.hasOwnProperty('hiddenFromPublic') ? overrides.hiddenFromPublic! : false,
        enablePaymentPlans: overrides && overrides.hasOwnProperty('enablePaymentPlans') ? overrides.enablePaymentPlans! : true,
        paymentPlanScheduleOptions: overrides && overrides.hasOwnProperty('paymentPlanScheduleOptions') ? overrides.paymentPlanScheduleOptions! : [relationshipsToOmit.has('ScheduleOptionInput') ? {} as ScheduleOptionInput : aScheduleOptionInput({}, relationshipsToOmit)],
        seoMetadata: overrides && overrides.hasOwnProperty('seoMetadata') ? overrides.seoMetadata! : relationshipsToOmit.has('SeoMetadataInput') ? {} as SeoMetadataInput : aSeoMetadataInput({}, relationshipsToOmit),
        productUpsell: overrides && overrides.hasOwnProperty('productUpsell') ? overrides.productUpsell! : relationshipsToOmit.has('ProductUpsellInput') ? {} as ProductUpsellInput : aProductUpsellInput({}, relationshipsToOmit),
        ticketTypes: overrides && overrides.hasOwnProperty('ticketTypes') ? overrides.ticketTypes! : [relationshipsToOmit.has('UpdateTicketTypeInputWithId') ? {} as UpdateTicketTypeInputWithId : anUpdateTicketTypeInputWithId({}, relationshipsToOmit)],
        eventAddons: overrides && overrides.hasOwnProperty('eventAddons') ? overrides.eventAddons! : [relationshipsToOmit.has('UpdateEventAddonInputWithId') ? {} as UpdateEventAddonInputWithId : anUpdateEventAddonInputWithId({}, relationshipsToOmit)],
        tax: overrides && overrides.hasOwnProperty('tax') ? overrides.tax! : [relationshipsToOmit.has('TaxInput') ? {} as TaxInput : aTaxInput({}, relationshipsToOmit)],
        seatSelectionFilterOverrides: overrides && overrides.hasOwnProperty('seatSelectionFilterOverrides') ? overrides.seatSelectionFilterOverrides! : relationshipsToOmit.has('SeatSelectionFiltersInput') ? {} as SeatSelectionFiltersInput : aSeatSelectionFiltersInput({}, relationshipsToOmit),
    };
};

export const anUpdateDigitalInfoInput = (overrides?: Partial<UpdateDigitalInfoInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateDigitalInfoInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateDigitalInfoInput');
    return {
        url: overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'solio',
        emailTemplateId: overrides && overrides.hasOwnProperty('emailTemplateId') ? overrides.emailTemplateId! : 'angulus',
        additionalEmailInfo: overrides && overrides.hasOwnProperty('additionalEmailInfo') ? overrides.additionalEmailInfo! : relationshipsToOmit.has('AdditionalEmailInfoInput') ? {} as AdditionalEmailInfoInput : anAdditionalEmailInfoInput({}, relationshipsToOmit),
    };
};

export const anAddGatesToZoneInput = (overrides?: Partial<AddGatesToZoneInput>, _relationshipsToOmit: Set<string> = new Set()): AddGatesToZoneInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AddGatesToZoneInput');
    return {
        zoneId: overrides && overrides.hasOwnProperty('zoneId') ? overrides.zoneId! : 'tamisium',
        names: overrides && overrides.hasOwnProperty('names') ? overrides.names! : ['aperio'],
    };
};

export const aSetPricingTiersInput = (overrides?: Partial<SetPricingTiersInput>, _relationshipsToOmit: Set<string> = new Set()): SetPricingTiersInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SetPricingTiersInput');
    return {
        pricingTiers: overrides && overrides.hasOwnProperty('pricingTiers') ? overrides.pricingTiers! : [relationshipsToOmit.has('PricingTierInput') ? {} as PricingTierInput : aPricingTierInput({}, relationshipsToOmit)],
    };
};

export const aCreateTicketTypeInput = (overrides?: Partial<CreateTicketTypeInput>, _relationshipsToOmit: Set<string> = new Set()): CreateTicketTypeInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateTicketTypeInput');
    return {
        event: overrides && overrides.hasOwnProperty('event') ? overrides.event! : 'carpo',
        kind: overrides && overrides.hasOwnProperty('kind') ? overrides.kind! : TicketTypeKind.Standard,
        isGrouped: overrides && overrides.hasOwnProperty('isGrouped') ? overrides.isGrouped! : true,
        isChild: overrides && overrides.hasOwnProperty('isChild') ? overrides.isChild! : false,
        groupAmount: overrides && overrides.hasOwnProperty('groupAmount') ? overrides.groupAmount! : 6.7,
        quantitySet: overrides && overrides.hasOwnProperty('quantitySet') ? overrides.quantitySet! : 1.1,
        intellitixIds: overrides && overrides.hasOwnProperty('intellitixIds') ? overrides.intellitixIds! : ['blandior'],
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'bellicus',
        dates: overrides && overrides.hasOwnProperty('dates') ? overrides.dates! : [relationshipsToOmit.has('CreateTicketTypeDate') ? {} as CreateTicketTypeDate : aCreateTicketTypeDate({}, relationshipsToOmit)],
        bookingFeeType: overrides && overrides.hasOwnProperty('bookingFeeType') ? overrides.bookingFeeType! : FeeType.FlatRate,
        bookingFee: overrides && overrides.hasOwnProperty('bookingFee') ? overrides.bookingFee! : 8.5,
        stadiumLevyFee: overrides && overrides.hasOwnProperty('stadiumLevyFee') ? overrides.stadiumLevyFee! : 9.7,
        inHighDemand: overrides && overrides.hasOwnProperty('inHighDemand') ? overrides.inHighDemand! : false,
        customBadge: overrides && overrides.hasOwnProperty('customBadge') ? overrides.customBadge! : 'utrimque',
        customBadgeBackgroundColor: overrides && overrides.hasOwnProperty('customBadgeBackgroundColor') ? overrides.customBadgeBackgroundColor! : 'delibero',
        customBadgeTextColor: overrides && overrides.hasOwnProperty('customBadgeTextColor') ? overrides.customBadgeTextColor! : 'calco',
        soldOut: overrides && overrides.hasOwnProperty('soldOut') ? overrides.soldOut! : true,
        hidePriceWhenSoldOut: overrides && overrides.hasOwnProperty('hidePriceWhenSoldOut') ? overrides.hidePriceWhenSoldOut! : true,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'tendo',
        restrictions: overrides && overrides.hasOwnProperty('restrictions') ? overrides.restrictions! : 'arma',
        printAtHomeInformation: overrides && overrides.hasOwnProperty('printAtHomeInformation') ? overrides.printAtHomeInformation! : 'pecco',
        namingFields: overrides && overrides.hasOwnProperty('namingFields') ? overrides.namingFields! : [relationshipsToOmit.has('FormFieldInput') ? {} as FormFieldInput : aFormFieldInput({}, relationshipsToOmit)],
        doorsOpen: overrides && overrides.hasOwnProperty('doorsOpen') ? overrides.doorsOpen! : 'ut',
        showDoorsOpen: overrides && overrides.hasOwnProperty('showDoorsOpen') ? overrides.showDoorsOpen! : true,
        showStartTime: overrides && overrides.hasOwnProperty('showStartTime') ? overrides.showStartTime! : true,
        showEndTime: overrides && overrides.hasOwnProperty('showEndTime') ? overrides.showEndTime! : false,
        entryDates: overrides && overrides.hasOwnProperty('entryDates') ? overrides.entryDates! : [relationshipsToOmit.has('CreateEventDate') ? {} as CreateEventDate : aCreateEventDate({}, relationshipsToOmit)],
        ticketBanner: overrides && overrides.hasOwnProperty('ticketBanner') ? overrides.ticketBanner! : 'cras',
        ticketImage: overrides && overrides.hasOwnProperty('ticketImage') ? overrides.ticketImage! : 'cometes',
        imageGallery: overrides && overrides.hasOwnProperty('imageGallery') ? overrides.imageGallery! : [relationshipsToOmit.has('ImageGalleryItemInput') ? {} as ImageGalleryItemInput : anImageGalleryItemInput({}, relationshipsToOmit)],
        quantity: overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 0.1,
        minPurchaseQuantity: overrides && overrides.hasOwnProperty('minPurchaseQuantity') ? overrides.minPurchaseQuantity! : 7.3,
        maxPurchaseQuantity: overrides && overrides.hasOwnProperty('maxPurchaseQuantity') ? overrides.maxPurchaseQuantity! : 1.7,
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['cribro'],
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 1.5,
        releaseZoneId: overrides && overrides.hasOwnProperty('releaseZoneId') ? overrides.releaseZoneId! : 'venio',
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : true,
        isComplimentary: overrides && overrides.hasOwnProperty('isComplimentary') ? overrides.isComplimentary! : true,
        isBusinessOnly: overrides && overrides.hasOwnProperty('isBusinessOnly') ? overrides.isBusinessOnly! : false,
        onSaleConfig: overrides && overrides.hasOwnProperty('onSaleConfig') ? overrides.onSaleConfig! : relationshipsToOmit.has('TicketTypeOnSaleConfigInput') ? {} as TicketTypeOnSaleConfigInput : aTicketTypeOnSaleConfigInput({}, relationshipsToOmit),
        pricingTiers: overrides && overrides.hasOwnProperty('pricingTiers') ? overrides.pricingTiers! : [relationshipsToOmit.has('PricingTierInput') ? {} as PricingTierInput : aPricingTierInput({}, relationshipsToOmit)],
    };
};

export const anUpdateTicketTypeInput = (overrides?: Partial<UpdateTicketTypeInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateTicketTypeInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateTicketTypeInput');
    return {
        kind: overrides && overrides.hasOwnProperty('kind') ? overrides.kind! : TicketTypeKind.Standard,
        isGrouped: overrides && overrides.hasOwnProperty('isGrouped') ? overrides.isGrouped! : true,
        isChild: overrides && overrides.hasOwnProperty('isChild') ? overrides.isChild! : true,
        groupAmount: overrides && overrides.hasOwnProperty('groupAmount') ? overrides.groupAmount! : 6.8,
        quantitySet: overrides && overrides.hasOwnProperty('quantitySet') ? overrides.quantitySet! : 8.9,
        intellitixIds: overrides && overrides.hasOwnProperty('intellitixIds') ? overrides.intellitixIds! : ['dolor'],
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'tabella',
        dates: overrides && overrides.hasOwnProperty('dates') ? overrides.dates! : [relationshipsToOmit.has('CreateTicketTypeDate') ? {} as CreateTicketTypeDate : aCreateTicketTypeDate({}, relationshipsToOmit)],
        bookingFeeType: overrides && overrides.hasOwnProperty('bookingFeeType') ? overrides.bookingFeeType! : FeeType.FlatRate,
        bookingFee: overrides && overrides.hasOwnProperty('bookingFee') ? overrides.bookingFee! : 8.7,
        stadiumLevyFee: overrides && overrides.hasOwnProperty('stadiumLevyFee') ? overrides.stadiumLevyFee! : 0.7,
        inHighDemand: overrides && overrides.hasOwnProperty('inHighDemand') ? overrides.inHighDemand! : true,
        customBadge: overrides && overrides.hasOwnProperty('customBadge') ? overrides.customBadge! : 'alioqui',
        customBadgeBackgroundColor: overrides && overrides.hasOwnProperty('customBadgeBackgroundColor') ? overrides.customBadgeBackgroundColor! : 'video',
        customBadgeTextColor: overrides && overrides.hasOwnProperty('customBadgeTextColor') ? overrides.customBadgeTextColor! : 'abeo',
        soldOut: overrides && overrides.hasOwnProperty('soldOut') ? overrides.soldOut! : true,
        hidePriceWhenSoldOut: overrides && overrides.hasOwnProperty('hidePriceWhenSoldOut') ? overrides.hidePriceWhenSoldOut! : true,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'ater',
        restrictions: overrides && overrides.hasOwnProperty('restrictions') ? overrides.restrictions! : 'arca',
        printAtHomeInformation: overrides && overrides.hasOwnProperty('printAtHomeInformation') ? overrides.printAtHomeInformation! : 'denuo',
        namingFields: overrides && overrides.hasOwnProperty('namingFields') ? overrides.namingFields! : [relationshipsToOmit.has('FormFieldInput') ? {} as FormFieldInput : aFormFieldInput({}, relationshipsToOmit)],
        doorsOpen: overrides && overrides.hasOwnProperty('doorsOpen') ? overrides.doorsOpen! : 'nostrum',
        showDoorsOpen: overrides && overrides.hasOwnProperty('showDoorsOpen') ? overrides.showDoorsOpen! : true,
        showStartTime: overrides && overrides.hasOwnProperty('showStartTime') ? overrides.showStartTime! : false,
        showEndTime: overrides && overrides.hasOwnProperty('showEndTime') ? overrides.showEndTime! : true,
        entryDates: overrides && overrides.hasOwnProperty('entryDates') ? overrides.entryDates! : [relationshipsToOmit.has('CreateEventDate') ? {} as CreateEventDate : aCreateEventDate({}, relationshipsToOmit)],
        ticketBanner: overrides && overrides.hasOwnProperty('ticketBanner') ? overrides.ticketBanner! : 'verbera',
        ticketImage: overrides && overrides.hasOwnProperty('ticketImage') ? overrides.ticketImage! : 'timidus',
        imageGallery: overrides && overrides.hasOwnProperty('imageGallery') ? overrides.imageGallery! : [relationshipsToOmit.has('ImageGalleryItemInput') ? {} as ImageGalleryItemInput : anImageGalleryItemInput({}, relationshipsToOmit)],
        quantity: overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 5.1,
        minPurchaseQuantity: overrides && overrides.hasOwnProperty('minPurchaseQuantity') ? overrides.minPurchaseQuantity! : 7.2,
        maxPurchaseQuantity: overrides && overrides.hasOwnProperty('maxPurchaseQuantity') ? overrides.maxPurchaseQuantity! : 4.6,
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['aro'],
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 6,
        releaseZoneId: overrides && overrides.hasOwnProperty('releaseZoneId') ? overrides.releaseZoneId! : 'suffoco',
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : true,
        isComplimentary: overrides && overrides.hasOwnProperty('isComplimentary') ? overrides.isComplimentary! : false,
        isBusinessOnly: overrides && overrides.hasOwnProperty('isBusinessOnly') ? overrides.isBusinessOnly! : true,
        onSaleConfig: overrides && overrides.hasOwnProperty('onSaleConfig') ? overrides.onSaleConfig! : relationshipsToOmit.has('TicketTypeOnSaleConfigInput') ? {} as TicketTypeOnSaleConfigInput : aTicketTypeOnSaleConfigInput({}, relationshipsToOmit),
        pricingTiers: overrides && overrides.hasOwnProperty('pricingTiers') ? overrides.pricingTiers! : [relationshipsToOmit.has('PricingTierInput') ? {} as PricingTierInput : aPricingTierInput({}, relationshipsToOmit)],
    };
};

export const aCreateReleaseInput = (overrides?: Partial<CreateReleaseInput>, _relationshipsToOmit: Set<string> = new Set()): CreateReleaseInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateReleaseInput');
    return {
        event: overrides && overrides.hasOwnProperty('event') ? overrides.event! : 'cribro',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'tabella',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : ReleaseType.Listed,
        slug: overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'volubilis',
        password: overrides && overrides.hasOwnProperty('password') ? overrides.password! : 'curo',
        startCondition: overrides && overrides.hasOwnProperty('startCondition') ? overrides.startCondition! : ReleaseStartCondition.Manual,
        startConditionDate: overrides && overrides.hasOwnProperty('startConditionDate') ? overrides.startConditionDate! : "2025-12-19T04:43:08.881Z",
        endCondition: overrides && overrides.hasOwnProperty('endCondition') ? overrides.endCondition! : ReleaseEndCondition.Manual,
        endConditionQuantity: overrides && overrides.hasOwnProperty('endConditionQuantity') ? overrides.endConditionQuantity! : 7.8,
        endConditionDate: overrides && overrides.hasOwnProperty('endConditionDate') ? overrides.endConditionDate! : "2025-08-13T00:38:21.879Z",
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : true,
        releaseZones: overrides && overrides.hasOwnProperty('releaseZones') ? overrides.releaseZones! : [relationshipsToOmit.has('ReleaseZoneInput') ? {} as ReleaseZoneInput : aReleaseZoneInput({}, relationshipsToOmit)],
        presaleTitle: overrides && overrides.hasOwnProperty('presaleTitle') ? overrides.presaleTitle! : 'ter',
        presaleLogo: overrides && overrides.hasOwnProperty('presaleLogo') ? overrides.presaleLogo! : 'curso',
        presaleHeader: overrides && overrides.hasOwnProperty('presaleHeader') ? overrides.presaleHeader! : 'vespillo',
        presaleInformation: overrides && overrides.hasOwnProperty('presaleInformation') ? overrides.presaleInformation! : 'praesentium',
        releaseNotes: overrides && overrides.hasOwnProperty('releaseNotes') ? overrides.releaseNotes! : 'accedo',
        askHowDidYouHearAboutUs: overrides && overrides.hasOwnProperty('askHowDidYouHearAboutUs') ? overrides.askHowDidYouHearAboutUs! : true,
        askForDietaryRequirements: overrides && overrides.hasOwnProperty('askForDietaryRequirements') ? overrides.askForDietaryRequirements! : true,
        allowPublicComp: overrides && overrides.hasOwnProperty('allowPublicComp') ? overrides.allowPublicComp! : false,
        allowAccount2Account: overrides && overrides.hasOwnProperty('allowAccount2Account') ? overrides.allowAccount2Account! : true,
        allowHoldOrders: overrides && overrides.hasOwnProperty('allowHoldOrders') ? overrides.allowHoldOrders! : true,
        minPurchaseQuantity: overrides && overrides.hasOwnProperty('minPurchaseQuantity') ? overrides.minPurchaseQuantity! : 4.8,
        maxPurchaseQuantity: overrides && overrides.hasOwnProperty('maxPurchaseQuantity') ? overrides.maxPurchaseQuantity! : 2.5,
        releaseEventAddons: overrides && overrides.hasOwnProperty('releaseEventAddons') ? overrides.releaseEventAddons! : ['tepidus'],
        isEnabled: overrides && overrides.hasOwnProperty('isEnabled') ? overrides.isEnabled! : true,
        channels: overrides && overrides.hasOwnProperty('channels') ? overrides.channels! : ['commodi'],
        requiredMembershipIds: overrides && overrides.hasOwnProperty('requiredMembershipIds') ? overrides.requiredMembershipIds! : ['viscus'],
    };
};

export const aReleaseZoneInput = (overrides?: Partial<ReleaseZoneInput>, _relationshipsToOmit: Set<string> = new Set()): ReleaseZoneInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ReleaseZoneInput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'adversus',
        zone: overrides && overrides.hasOwnProperty('zone') ? overrides.zone! : relationshipsToOmit.has('ReleaseZoneZoneInput') ? {} as ReleaseZoneZoneInput : aReleaseZoneZoneInput({}, relationshipsToOmit),
        pricingLevel: overrides && overrides.hasOwnProperty('pricingLevel') ? overrides.pricingLevel! : ZonePricingLevel.Zone,
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : true,
        ticketTypes: overrides && overrides.hasOwnProperty('ticketTypes') ? overrides.ticketTypes! : [relationshipsToOmit.has('ReleaseZoneTicketTypeInput') ? {} as ReleaseZoneTicketTypeInput : aReleaseZoneTicketTypeInput({}, relationshipsToOmit)],
    };
};

export const aReleaseZoneZoneInput = (overrides?: Partial<ReleaseZoneZoneInput>, _relationshipsToOmit: Set<string> = new Set()): ReleaseZoneZoneInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ReleaseZoneZoneInput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'cena',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'spero',
    };
};

export const aReleaseZoneTicketTypeInput = (overrides?: Partial<ReleaseZoneTicketTypeInput>, _relationshipsToOmit: Set<string> = new Set()): ReleaseZoneTicketTypeInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ReleaseZoneTicketTypeInput');
    return {
        ticketTypeId: overrides && overrides.hasOwnProperty('ticketTypeId') ? overrides.ticketTypeId! : 'id',
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 7.5,
        sections: overrides && overrides.hasOwnProperty('sections') ? overrides.sections! : [relationshipsToOmit.has('ReleaseZoneTicketTypeSectionInput') ? {} as ReleaseZoneTicketTypeSectionInput : aReleaseZoneTicketTypeSectionInput({}, relationshipsToOmit)],
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : true,
    };
};

export const aReleaseZoneTicketTypeSectionInput = (overrides?: Partial<ReleaseZoneTicketTypeSectionInput>, _relationshipsToOmit: Set<string> = new Set()): ReleaseZoneTicketTypeSectionInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ReleaseZoneTicketTypeSectionInput');
    return {
        sectionId: overrides && overrides.hasOwnProperty('sectionId') ? overrides.sectionId! : 'subvenio',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'undique',
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 2.5,
    };
};

export const anUpdateReleaseInput = (overrides?: Partial<UpdateReleaseInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateReleaseInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateReleaseInput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'demo',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : ReleaseType.Listed,
        slug: overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'calco',
        password: overrides && overrides.hasOwnProperty('password') ? overrides.password! : 'vulpes',
        startCondition: overrides && overrides.hasOwnProperty('startCondition') ? overrides.startCondition! : ReleaseStartCondition.Manual,
        startConditionDate: overrides && overrides.hasOwnProperty('startConditionDate') ? overrides.startConditionDate! : "2025-10-10T07:33:16.409Z",
        endCondition: overrides && overrides.hasOwnProperty('endCondition') ? overrides.endCondition! : ReleaseEndCondition.Manual,
        endConditionQuantity: overrides && overrides.hasOwnProperty('endConditionQuantity') ? overrides.endConditionQuantity! : 5.2,
        endConditionDate: overrides && overrides.hasOwnProperty('endConditionDate') ? overrides.endConditionDate! : "2025-04-16T00:44:37.353Z",
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : true,
        releaseZones: overrides && overrides.hasOwnProperty('releaseZones') ? overrides.releaseZones! : [relationshipsToOmit.has('ReleaseZoneInput') ? {} as ReleaseZoneInput : aReleaseZoneInput({}, relationshipsToOmit)],
        presaleTitle: overrides && overrides.hasOwnProperty('presaleTitle') ? overrides.presaleTitle! : 'comminor',
        presaleLogo: overrides && overrides.hasOwnProperty('presaleLogo') ? overrides.presaleLogo! : 'crapula',
        presaleHeader: overrides && overrides.hasOwnProperty('presaleHeader') ? overrides.presaleHeader! : 'torqueo',
        presaleInformation: overrides && overrides.hasOwnProperty('presaleInformation') ? overrides.presaleInformation! : 'demitto',
        releaseNotes: overrides && overrides.hasOwnProperty('releaseNotes') ? overrides.releaseNotes! : 'cupiditas',
        askHowDidYouHearAboutUs: overrides && overrides.hasOwnProperty('askHowDidYouHearAboutUs') ? overrides.askHowDidYouHearAboutUs! : true,
        askForDietaryRequirements: overrides && overrides.hasOwnProperty('askForDietaryRequirements') ? overrides.askForDietaryRequirements! : true,
        allowPublicComp: overrides && overrides.hasOwnProperty('allowPublicComp') ? overrides.allowPublicComp! : true,
        allowAccount2Account: overrides && overrides.hasOwnProperty('allowAccount2Account') ? overrides.allowAccount2Account! : false,
        allowHoldOrders: overrides && overrides.hasOwnProperty('allowHoldOrders') ? overrides.allowHoldOrders! : true,
        minPurchaseQuantity: overrides && overrides.hasOwnProperty('minPurchaseQuantity') ? overrides.minPurchaseQuantity! : 2.5,
        maxPurchaseQuantity: overrides && overrides.hasOwnProperty('maxPurchaseQuantity') ? overrides.maxPurchaseQuantity! : 2.5,
        releaseEventAddons: overrides && overrides.hasOwnProperty('releaseEventAddons') ? overrides.releaseEventAddons! : ['vito'],
        isEnabled: overrides && overrides.hasOwnProperty('isEnabled') ? overrides.isEnabled! : true,
        channels: overrides && overrides.hasOwnProperty('channels') ? overrides.channels! : ['calcar'],
        requiredMembershipIds: overrides && overrides.hasOwnProperty('requiredMembershipIds') ? overrides.requiredMembershipIds! : ['adflicto'],
    };
};

export const aHoldBestAvailableSeatsInput = (overrides?: Partial<HoldBestAvailableSeatsInput>, _relationshipsToOmit: Set<string> = new Set()): HoldBestAvailableSeatsInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('HoldBestAvailableSeatsInput');
    return {
        holdToken: overrides && overrides.hasOwnProperty('holdToken') ? overrides.holdToken! : 'sordeo',
        quantity: overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 8100,
        categories: overrides && overrides.hasOwnProperty('categories') ? overrides.categories! : [6981],
    };
};

export const aHoldBestAvailableSeatsOutput = (overrides?: Partial<HoldBestAvailableSeatsOutput>, _relationshipsToOmit: Set<string> = new Set()): HoldBestAvailableSeatsOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('HoldBestAvailableSeatsOutput');
    return {
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : ['trepide'],
        nextToEachOther: overrides && overrides.hasOwnProperty('nextToEachOther') ? overrides.nextToEachOther! : false,
    };
};

export const aValidateReleasePasswordOrReleaseOutput = (overrides?: Partial<ValidateReleasePasswordOrReleaseOutput>, _relationshipsToOmit: Set<string> = new Set()): ValidateReleasePasswordOrReleaseOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ValidateReleasePasswordOrReleaseOutput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '47903fbb-619c-4e63-b332-b0d95e4fe5dc',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2026-02-01T09:55:22.730Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-10-01T08:48:55.769Z",
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'alius',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : ReleaseType.Listed,
        slug: overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'quo',
        password: overrides && overrides.hasOwnProperty('password') ? overrides.password! : 'arbustum',
        startCondition: overrides && overrides.hasOwnProperty('startCondition') ? overrides.startCondition! : ReleaseStartCondition.Manual,
        startConditionDate: overrides && overrides.hasOwnProperty('startConditionDate') ? overrides.startConditionDate! : "2025-10-14T07:16:56.917Z",
        endCondition: overrides && overrides.hasOwnProperty('endCondition') ? overrides.endCondition! : ReleaseEndCondition.Manual,
        endConditionQuantity: overrides && overrides.hasOwnProperty('endConditionQuantity') ? overrides.endConditionQuantity! : 5,
        endConditionDate: overrides && overrides.hasOwnProperty('endConditionDate') ? overrides.endConditionDate! : "2025-06-02T08:24:51.433Z",
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : false,
        presaleTitle: overrides && overrides.hasOwnProperty('presaleTitle') ? overrides.presaleTitle! : 'explicabo',
        presaleLogo: overrides && overrides.hasOwnProperty('presaleLogo') ? overrides.presaleLogo! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        presaleHeader: overrides && overrides.hasOwnProperty('presaleHeader') ? overrides.presaleHeader! : relationshipsToOmit.has('ExtendedFile') ? {} as ExtendedFile : anExtendedFile({}, relationshipsToOmit),
        presaleInformation: overrides && overrides.hasOwnProperty('presaleInformation') ? overrides.presaleInformation! : 'confido',
        releaseNotes: overrides && overrides.hasOwnProperty('releaseNotes') ? overrides.releaseNotes! : 'ver',
        askHowDidYouHearAboutUs: overrides && overrides.hasOwnProperty('askHowDidYouHearAboutUs') ? overrides.askHowDidYouHearAboutUs! : true,
        askForDietaryRequirements: overrides && overrides.hasOwnProperty('askForDietaryRequirements') ? overrides.askForDietaryRequirements! : false,
        allowPublicComp: overrides && overrides.hasOwnProperty('allowPublicComp') ? overrides.allowPublicComp! : false,
        allowHoldOrders: overrides && overrides.hasOwnProperty('allowHoldOrders') ? overrides.allowHoldOrders! : true,
        allowAccount2Account: overrides && overrides.hasOwnProperty('allowAccount2Account') ? overrides.allowAccount2Account! : true,
        minPurchaseQuantity: overrides && overrides.hasOwnProperty('minPurchaseQuantity') ? overrides.minPurchaseQuantity! : 197,
        maxPurchaseQuantity: overrides && overrides.hasOwnProperty('maxPurchaseQuantity') ? overrides.maxPurchaseQuantity! : 3088,
        isEnabled: overrides && overrides.hasOwnProperty('isEnabled') ? overrides.isEnabled! : true,
        linkToWaitlist: overrides && overrides.hasOwnProperty('linkToWaitlist') ? overrides.linkToWaitlist! : false,
        allowPrePurchase: overrides && overrides.hasOwnProperty('allowPrePurchase') ? overrides.allowPrePurchase! : false,
        purchaseRestrictions: overrides && overrides.hasOwnProperty('purchaseRestrictions') ? overrides.purchaseRestrictions! : relationshipsToOmit.has('ReleasePurchaseRestriction') ? {} as ReleasePurchaseRestriction : aReleasePurchaseRestriction({}, relationshipsToOmit),
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : relationshipsToOmit.has('ReleaseStatus') ? {} as ReleaseStatus : aReleaseStatus({}, relationshipsToOmit),
        event: overrides && overrides.hasOwnProperty('event') ? overrides.event! : relationshipsToOmit.has('Event') ? {} as Event : anEvent({}, relationshipsToOmit),
        canBeHardDeleted: overrides && overrides.hasOwnProperty('canBeHardDeleted') ? overrides.canBeHardDeleted! : false,
        requiresAuth: overrides && overrides.hasOwnProperty('requiresAuth') ? overrides.requiresAuth! : true,
        releaseZones: overrides && overrides.hasOwnProperty('releaseZones') ? overrides.releaseZones! : [relationshipsToOmit.has('ReleaseZone') ? {} as ReleaseZone : aReleaseZone({}, relationshipsToOmit)],
        releaseEventAddons: overrides && overrides.hasOwnProperty('releaseEventAddons') ? overrides.releaseEventAddons! : [relationshipsToOmit.has('ReleaseEventAddon') ? {} as ReleaseEventAddon : aReleaseEventAddon({}, relationshipsToOmit)],
        isResaleRelease: overrides && overrides.hasOwnProperty('isResaleRelease') ? overrides.isResaleRelease! : false,
        channels: overrides && overrides.hasOwnProperty('channels') ? overrides.channels! : [relationshipsToOmit.has('EventChannelOutput') ? {} as EventChannelOutput : anEventChannelOutput({}, relationshipsToOmit)],
        isPrePurchaseActive: overrides && overrides.hasOwnProperty('isPrePurchaseActive') ? overrides.isPrePurchaseActive! : true,
        showMemberTicketsBanner: overrides && overrides.hasOwnProperty('showMemberTicketsBanner') ? overrides.showMemberTicketsBanner! : false,
        releasePasswordId: overrides && overrides.hasOwnProperty('releasePasswordId') ? overrides.releasePasswordId! : 'adfero',
    };
};

export const aDuplicateSingleReleaseInput = (overrides?: Partial<DuplicateSingleReleaseInput>, _relationshipsToOmit: Set<string> = new Set()): DuplicateSingleReleaseInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DuplicateSingleReleaseInput');
    return {
        releaseId: overrides && overrides.hasOwnProperty('releaseId') ? overrides.releaseId! : 'amoveo',
        newSlug: overrides && overrides.hasOwnProperty('newSlug') ? overrides.newSlug! : 'tego',
        releaseType: overrides && overrides.hasOwnProperty('releaseType') ? overrides.releaseType! : 'arx',
    };
};

export const aCreateEventPromoCodeInput = (overrides?: Partial<CreateEventPromoCodeInput>, _relationshipsToOmit: Set<string> = new Set()): CreateEventPromoCodeInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateEventPromoCodeInput');
    return {
        code: overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'somnus',
        discountType: overrides && overrides.hasOwnProperty('discountType') ? overrides.discountType! : DiscountType.Percentage,
        discountAmount: overrides && overrides.hasOwnProperty('discountAmount') ? overrides.discountAmount! : 5.3,
        maxUsage: overrides && overrides.hasOwnProperty('maxUsage') ? overrides.maxUsage! : 7,
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2025-04-27T19:25:19.964Z",
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : "2025-08-13T02:38:18.012Z",
        minOrderAmount: overrides && overrides.hasOwnProperty('minOrderAmount') ? overrides.minOrderAmount! : 0.7,
        maxOrderAmount: overrides && overrides.hasOwnProperty('maxOrderAmount') ? overrides.maxOrderAmount! : 2.9,
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'aperte',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : EventPromoCodeType.EventAndAddons,
        ticketTypes: overrides && overrides.hasOwnProperty('ticketTypes') ? overrides.ticketTypes! : ['cavus'],
        eventAddons: overrides && overrides.hasOwnProperty('eventAddons') ? overrides.eventAddons! : ['utrum'],
    };
};

export const anUpdateEventPromoCodeInput = (overrides?: Partial<UpdateEventPromoCodeInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateEventPromoCodeInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateEventPromoCodeInput');
    return {
        code: overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'vigor',
        discountType: overrides && overrides.hasOwnProperty('discountType') ? overrides.discountType! : DiscountType.Percentage,
        discountAmount: overrides && overrides.hasOwnProperty('discountAmount') ? overrides.discountAmount! : 9.9,
        maxUsage: overrides && overrides.hasOwnProperty('maxUsage') ? overrides.maxUsage! : 9.4,
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2025-07-02T04:41:29.438Z",
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : "2025-06-13T15:19:15.496Z",
        minOrderAmount: overrides && overrides.hasOwnProperty('minOrderAmount') ? overrides.minOrderAmount! : 1.2,
        maxOrderAmount: overrides && overrides.hasOwnProperty('maxOrderAmount') ? overrides.maxOrderAmount! : 4.4,
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : EventPromoCodeType.EventAndAddons,
        ticketTypes: overrides && overrides.hasOwnProperty('ticketTypes') ? overrides.ticketTypes! : ['creptio'],
        eventAddons: overrides && overrides.hasOwnProperty('eventAddons') ? overrides.eventAddons! : ['validus'],
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false,
    };
};

export const aCreateEventMultiBuyPromotionInput = (overrides?: Partial<CreateEventMultiBuyPromotionInput>, _relationshipsToOmit: Set<string> = new Set()): CreateEventMultiBuyPromotionInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateEventMultiBuyPromotionInput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'tondeo',
        buyQuantity: overrides && overrides.hasOwnProperty('buyQuantity') ? overrides.buyQuantity! : 1.4,
        getQuantity: overrides && overrides.hasOwnProperty('getQuantity') ? overrides.getQuantity! : 1.1,
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 6.3,
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'terreo',
        buyTicketTypeId: overrides && overrides.hasOwnProperty('buyTicketTypeId') ? overrides.buyTicketTypeId! : 'amor',
        getTicketTypeId: overrides && overrides.hasOwnProperty('getTicketTypeId') ? overrides.getTicketTypeId! : 'adiuvo',
    };
};

export const anUpdateEventMultiBuyPromotionInput = (overrides?: Partial<UpdateEventMultiBuyPromotionInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateEventMultiBuyPromotionInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateEventMultiBuyPromotionInput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'tergeo',
        buyQuantity: overrides && overrides.hasOwnProperty('buyQuantity') ? overrides.buyQuantity! : 0,
        getQuantity: overrides && overrides.hasOwnProperty('getQuantity') ? overrides.getQuantity! : 6.7,
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 2.2,
        buyTicketTypeId: overrides && overrides.hasOwnProperty('buyTicketTypeId') ? overrides.buyTicketTypeId! : 'astrum',
        getTicketTypeId: overrides && overrides.hasOwnProperty('getTicketTypeId') ? overrides.getTicketTypeId! : 'acquiro',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false,
    };
};

export const aCreateEventAddonInput = (overrides?: Partial<CreateEventAddonInput>, _relationshipsToOmit: Set<string> = new Set()): CreateEventAddonInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateEventAddonInput');
    return {
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'subiungo',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'sulum',
        enableNaming: overrides && overrides.hasOwnProperty('enableNaming') ? overrides.enableNaming! : true,
        quantity: overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 8.6,
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 8.8,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'crepusculum',
        imageGallery: overrides && overrides.hasOwnProperty('imageGallery') ? overrides.imageGallery! : [relationshipsToOmit.has('ImageGalleryItemInput') ? {} as ImageGalleryItemInput : anImageGalleryItemInput({}, relationshipsToOmit)],
        restrictions: overrides && overrides.hasOwnProperty('restrictions') ? overrides.restrictions! : 'consuasor',
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : true,
        namingFields: overrides && overrides.hasOwnProperty('namingFields') ? overrides.namingFields! : [relationshipsToOmit.has('FormFieldInput') ? {} as FormFieldInput : aFormFieldInput({}, relationshipsToOmit)],
        addonImage: overrides && overrides.hasOwnProperty('addonImage') ? overrides.addonImage! : 'supra',
        insideFee: overrides && overrides.hasOwnProperty('insideFee') ? overrides.insideFee! : 5.2,
        hideQRCode: overrides && overrides.hasOwnProperty('hideQRCode') ? overrides.hideQRCode! : false,
        intellitixId: overrides && overrides.hasOwnProperty('intellitixId') ? overrides.intellitixId! : 'confero',
    };
};

export const anUpdateEventAddonInput = (overrides?: Partial<UpdateEventAddonInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateEventAddonInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateEventAddonInput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'vallum',
        enableNaming: overrides && overrides.hasOwnProperty('enableNaming') ? overrides.enableNaming! : false,
        quantity: overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 2.1,
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 6.9,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'commodi',
        imageGallery: overrides && overrides.hasOwnProperty('imageGallery') ? overrides.imageGallery! : [relationshipsToOmit.has('ImageGalleryItemInput') ? {} as ImageGalleryItemInput : anImageGalleryItemInput({}, relationshipsToOmit)],
        restrictions: overrides && overrides.hasOwnProperty('restrictions') ? overrides.restrictions! : 'creta',
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : true,
        namingFields: overrides && overrides.hasOwnProperty('namingFields') ? overrides.namingFields! : [relationshipsToOmit.has('FormFieldInput') ? {} as FormFieldInput : aFormFieldInput({}, relationshipsToOmit)],
        addonImage: overrides && overrides.hasOwnProperty('addonImage') ? overrides.addonImage! : 'verumtamen',
        insideFee: overrides && overrides.hasOwnProperty('insideFee') ? overrides.insideFee! : 0.4,
        hideQRCode: overrides && overrides.hasOwnProperty('hideQRCode') ? overrides.hideQRCode! : false,
        intellitixId: overrides && overrides.hasOwnProperty('intellitixId') ? overrides.intellitixId! : 'molestiae',
    };
};

export const anAddGatesToEventAddonInput = (overrides?: Partial<AddGatesToEventAddonInput>, _relationshipsToOmit: Set<string> = new Set()): AddGatesToEventAddonInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AddGatesToEventAddonInput');
    return {
        addonId: overrides && overrides.hasOwnProperty('addonId') ? overrides.addonId! : 'turbo',
        names: overrides && overrides.hasOwnProperty('names') ? overrides.names! : ['conturbo'],
    };
};

export const aCreateReleaseZoneInput = (overrides?: Partial<CreateReleaseZoneInput>, _relationshipsToOmit: Set<string> = new Set()): CreateReleaseZoneInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateReleaseZoneInput');
    return {
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'tepesco',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'amplus',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'commodi',
        imageGallery: overrides && overrides.hasOwnProperty('imageGallery') ? overrides.imageGallery! : [relationshipsToOmit.has('ImageGalleryItemInput') ? {} as ImageGalleryItemInput : anImageGalleryItemInput({}, relationshipsToOmit)],
        capacity: overrides && overrides.hasOwnProperty('capacity') ? overrides.capacity! : 7676,
        admission: overrides && overrides.hasOwnProperty('admission') ? overrides.admission! : true,
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : false,
    };
};

export const anUpdateReleaseZoneInput = (overrides?: Partial<UpdateReleaseZoneInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateReleaseZoneInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateReleaseZoneInput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'aeternus',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'beatae',
        imageGallery: overrides && overrides.hasOwnProperty('imageGallery') ? overrides.imageGallery! : [relationshipsToOmit.has('ImageGalleryItemInput') ? {} as ImageGalleryItemInput : anImageGalleryItemInput({}, relationshipsToOmit)],
        capacity: overrides && overrides.hasOwnProperty('capacity') ? overrides.capacity! : 3819,
        admission: overrides && overrides.hasOwnProperty('admission') ? overrides.admission! : true,
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : true,
    };
};

export const aReorderTicketTypeInput = (overrides?: Partial<ReorderTicketTypeInput>, _relationshipsToOmit: Set<string> = new Set()): ReorderTicketTypeInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ReorderTicketTypeInput');
    return {
        releaseZoneId: overrides && overrides.hasOwnProperty('releaseZoneId') ? overrides.releaseZoneId! : 'comitatus',
        ticketTypeIds: overrides && overrides.hasOwnProperty('ticketTypeIds') ? overrides.ticketTypeIds! : ['tener'],
    };
};

export const anAccessCodeReleaseInput = (overrides?: Partial<AccessCodeReleaseInput>, _relationshipsToOmit: Set<string> = new Set()): AccessCodeReleaseInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AccessCodeReleaseInput');
    return {
        releaseId: overrides && overrides.hasOwnProperty('releaseId') ? overrides.releaseId! : 'tandem',
        accessCodes: overrides && overrides.hasOwnProperty('accessCodes') ? overrides.accessCodes! : [relationshipsToOmit.has('AccessCodeInput') ? {} as AccessCodeInput : anAccessCodeInput({}, relationshipsToOmit)],
        tickets: overrides && overrides.hasOwnProperty('tickets') ? overrides.tickets! : [relationshipsToOmit.has('AccessCodeTicketInput') ? {} as AccessCodeTicketInput : anAccessCodeTicketInput({}, relationshipsToOmit)],
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'supra',
        requiredMembershipIds: overrides && overrides.hasOwnProperty('requiredMembershipIds') ? overrides.requiredMembershipIds! : ['colligo'],
    };
};

export const anAccessCodeInput = (overrides?: Partial<AccessCodeInput>, _relationshipsToOmit: Set<string> = new Set()): AccessCodeInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AccessCodeInput');
    return {
        accessCode: overrides && overrides.hasOwnProperty('accessCode') ? overrides.accessCode! : 'custodia',
        quantity: overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 4.8,
        quantityFree: overrides && overrides.hasOwnProperty('quantityFree') ? overrides.quantityFree! : 4.6,
        isEnabled: overrides && overrides.hasOwnProperty('isEnabled') ? overrides.isEnabled! : false,
    };
};

export const anAccessCodeTicketInput = (overrides?: Partial<AccessCodeTicketInput>, _relationshipsToOmit: Set<string> = new Set()): AccessCodeTicketInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AccessCodeTicketInput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'urbs',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : TicketTypeKind.Standard,
    };
};

export const aPresaleReleaseInput = (overrides?: Partial<PresaleReleaseInput>, _relationshipsToOmit: Set<string> = new Set()): PresaleReleaseInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PresaleReleaseInput');
    return {
        releaseId: overrides && overrides.hasOwnProperty('releaseId') ? overrides.releaseId! : 'cauda',
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'degusto',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'creo',
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2025-08-16T02:26:22.082Z",
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : "2025-03-09T08:15:02.227Z",
        tickets: overrides && overrides.hasOwnProperty('tickets') ? overrides.tickets! : [relationshipsToOmit.has('AccessCodeTicketInput') ? {} as AccessCodeTicketInput : anAccessCodeTicketInput({}, relationshipsToOmit)],
        accessCodes: overrides && overrides.hasOwnProperty('accessCodes') ? overrides.accessCodes! : [relationshipsToOmit.has('AccessCodeInput') ? {} as AccessCodeInput : anAccessCodeInput({}, relationshipsToOmit)],
        accessScreenMessage: overrides && overrides.hasOwnProperty('accessScreenMessage') ? overrides.accessScreenMessage! : 'decimus',
        accessScreenImage: overrides && overrides.hasOwnProperty('accessScreenImage') ? overrides.accessScreenImage! : 'delectatio',
        linkToWaitlist: overrides && overrides.hasOwnProperty('linkToWaitlist') ? overrides.linkToWaitlist! : true,
        allowPrePurchase: overrides && overrides.hasOwnProperty('allowPrePurchase') ? overrides.allowPrePurchase! : true,
    };
};

export const aNamingFieldInput = (overrides?: Partial<NamingFieldInput>, _relationshipsToOmit: Set<string> = new Set()): NamingFieldInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('NamingFieldInput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'trucido',
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'damno',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : NamingFieldType.FirstName,
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'torrens',
        required: overrides && overrides.hasOwnProperty('required') ? overrides.required! : true,
        allTickets: overrides && overrides.hasOwnProperty('allTickets') ? overrides.allTickets! : false,
        specificTicketTypes: overrides && overrides.hasOwnProperty('specificTicketTypes') ? overrides.specificTicketTypes! : [relationshipsToOmit.has('AccessCodeTicketInput') ? {} as AccessCodeTicketInput : anAccessCodeTicketInput({}, relationshipsToOmit)],
        options: overrides && overrides.hasOwnProperty('options') ? overrides.options! : ['labore'],
        orderKey: overrides && overrides.hasOwnProperty('orderKey') ? overrides.orderKey! : 0.8,
    };
};

export const anEmailUsherComplimentaryInput = (overrides?: Partial<EmailUsherComplimentaryInput>, _relationshipsToOmit: Set<string> = new Set()): EmailUsherComplimentaryInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EmailUsherComplimentaryInput');
    return {
        ticketTypeId: overrides && overrides.hasOwnProperty('ticketTypeId') ? overrides.ticketTypeId! : 'arto',
        ticketTypeName: overrides && overrides.hasOwnProperty('ticketTypeName') ? overrides.ticketTypeName! : 'voluptas',
        releaseId: overrides && overrides.hasOwnProperty('releaseId') ? overrides.releaseId! : 'congregatio',
    };
};

export const anUsherComplimetaryCreateInput = (overrides?: Partial<UsherComplimetaryCreateInput>, _relationshipsToOmit: Set<string> = new Set()): UsherComplimetaryCreateInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UsherComplimetaryCreateInput');
    return {
        releaseId: overrides && overrides.hasOwnProperty('releaseId') ? overrides.releaseId! : 'damnatio',
        seatZoneId: overrides && overrides.hasOwnProperty('seatZoneId') ? overrides.seatZoneId! : 'quaerat',
        seatZone: overrides && overrides.hasOwnProperty('seatZone') ? overrides.seatZone! : 'amet',
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'virga',
        releaseZoneId: overrides && overrides.hasOwnProperty('releaseZoneId') ? overrides.releaseZoneId! : 'vobis',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'vorago',
    };
};

export const aCreateSeasonInput = (overrides?: Partial<CreateSeasonInput>, _relationshipsToOmit: Set<string> = new Set()): CreateSeasonInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateSeasonInput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'commemoro',
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : false,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'timidus',
        thumbnail: overrides && overrides.hasOwnProperty('thumbnail') ? overrides.thumbnail! : 'amplitudo',
        backgroundImageFullPage: overrides && overrides.hasOwnProperty('backgroundImageFullPage') ? overrides.backgroundImageFullPage! : 'pauci',
        landingBanner: overrides && overrides.hasOwnProperty('landingBanner') ? overrides.landingBanner! : 'avaritia',
        landingDescription: overrides && overrides.hasOwnProperty('landingDescription') ? overrides.landingDescription! : 'pel',
        displayOrder: overrides && overrides.hasOwnProperty('displayOrder') ? overrides.displayOrder! : 1.5,
    };
};

export const anUpdateSeasonInput = (overrides?: Partial<UpdateSeasonInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateSeasonInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateSeasonInput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'adimpleo',
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : true,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'amet',
        thumbnail: overrides && overrides.hasOwnProperty('thumbnail') ? overrides.thumbnail! : 'verbera',
        backgroundImageFullPage: overrides && overrides.hasOwnProperty('backgroundImageFullPage') ? overrides.backgroundImageFullPage! : 'umerus',
        landingBanner: overrides && overrides.hasOwnProperty('landingBanner') ? overrides.landingBanner! : 'utpote',
        landingDescription: overrides && overrides.hasOwnProperty('landingDescription') ? overrides.landingDescription! : 'tripudio',
        displayOrder: overrides && overrides.hasOwnProperty('displayOrder') ? overrides.displayOrder! : 1.8,
    };
};

export const aCreateIntegrationInput = (overrides?: Partial<CreateIntegrationInput>, _relationshipsToOmit: Set<string> = new Set()): CreateIntegrationInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateIntegrationInput');
    return {
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : IntegrationType.PaymentStripe,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'contigo',
        secretKey: overrides && overrides.hasOwnProperty('secretKey') ? overrides.secretKey! : 'talus',
        publicKey: overrides && overrides.hasOwnProperty('publicKey') ? overrides.publicKey! : 'strenuus',
        wcPxPostSecretKey: overrides && overrides.hasOwnProperty('wcPxPostSecretKey') ? overrides.wcPxPostSecretKey! : 'voluptatem',
        wcPxPostPublicKey: overrides && overrides.hasOwnProperty('wcPxPostPublicKey') ? overrides.wcPxPostPublicKey! : 'ver',
        webhookUrl: overrides && overrides.hasOwnProperty('webhookUrl') ? overrides.webhookUrl! : 'inventore',
        transactionFeeType: overrides && overrides.hasOwnProperty('transactionFeeType') ? overrides.transactionFeeType! : FeeType.FlatRate,
        transactionFee: overrides && overrides.hasOwnProperty('transactionFee') ? overrides.transactionFee! : 4.4,
        transactionFeeType2: overrides && overrides.hasOwnProperty('transactionFeeType2') ? overrides.transactionFeeType2! : FeeType.FlatRate,
        transactionFee2: overrides && overrides.hasOwnProperty('transactionFee2') ? overrides.transactionFee2! : 6.7,
        paymentMethodType: overrides && overrides.hasOwnProperty('paymentMethodType') ? overrides.paymentMethodType! : 'terreo',
        expressCheckoutEnabled: overrides && overrides.hasOwnProperty('expressCheckoutEnabled') ? overrides.expressCheckoutEnabled! : false,
        facebookTempToken: overrides && overrides.hasOwnProperty('facebookTempToken') ? overrides.facebookTempToken! : 'vos',
        facebookPageId: overrides && overrides.hasOwnProperty('facebookPageId') ? overrides.facebookPageId! : 'spiculum',
        facebookUserId: overrides && overrides.hasOwnProperty('facebookUserId') ? overrides.facebookUserId! : 'tametsi',
        bnplEnabled: overrides && overrides.hasOwnProperty('bnplEnabled') ? overrides.bnplEnabled! : true,
        bnplTransactionFeePercent: overrides && overrides.hasOwnProperty('bnplTransactionFeePercent') ? overrides.bnplTransactionFeePercent! : 0.5,
        daysAfterCanRefund: overrides && overrides.hasOwnProperty('daysAfterCanRefund') ? overrides.daysAfterCanRefund! : 5.3,
        createAccount: overrides && overrides.hasOwnProperty('createAccount') ? overrides.createAccount! : false,
    };
};

export const anUpdateIntegrationInput = (overrides?: Partial<UpdateIntegrationInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateIntegrationInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateIntegrationInput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'una',
        secretKey: overrides && overrides.hasOwnProperty('secretKey') ? overrides.secretKey! : 'quasi',
        publicKey: overrides && overrides.hasOwnProperty('publicKey') ? overrides.publicKey! : 'decet',
        wcPxPostSecretKey: overrides && overrides.hasOwnProperty('wcPxPostSecretKey') ? overrides.wcPxPostSecretKey! : 'cogito',
        wcPxPostPublicKey: overrides && overrides.hasOwnProperty('wcPxPostPublicKey') ? overrides.wcPxPostPublicKey! : 'arbustum',
        webhookUrl: overrides && overrides.hasOwnProperty('webhookUrl') ? overrides.webhookUrl! : 'possimus',
        transactionFeeType: overrides && overrides.hasOwnProperty('transactionFeeType') ? overrides.transactionFeeType! : FeeType.FlatRate,
        transactionFee: overrides && overrides.hasOwnProperty('transactionFee') ? overrides.transactionFee! : 4.2,
        transactionFeeType2: overrides && overrides.hasOwnProperty('transactionFeeType2') ? overrides.transactionFeeType2! : FeeType.FlatRate,
        transactionFee2: overrides && overrides.hasOwnProperty('transactionFee2') ? overrides.transactionFee2! : 4.1,
        paymentMethodType: overrides && overrides.hasOwnProperty('paymentMethodType') ? overrides.paymentMethodType! : 'viridis',
        expressCheckoutEnabled: overrides && overrides.hasOwnProperty('expressCheckoutEnabled') ? overrides.expressCheckoutEnabled! : false,
        facebookTempToken: overrides && overrides.hasOwnProperty('facebookTempToken') ? overrides.facebookTempToken! : 'voluntarius',
        facebookPageId: overrides && overrides.hasOwnProperty('facebookPageId') ? overrides.facebookPageId! : 'turba',
        facebookUserId: overrides && overrides.hasOwnProperty('facebookUserId') ? overrides.facebookUserId! : 'demonstro',
        bnplEnabled: overrides && overrides.hasOwnProperty('bnplEnabled') ? overrides.bnplEnabled! : true,
        bnplTransactionFeePercent: overrides && overrides.hasOwnProperty('bnplTransactionFeePercent') ? overrides.bnplTransactionFeePercent! : 3.6,
        daysAfterCanRefund: overrides && overrides.hasOwnProperty('daysAfterCanRefund') ? overrides.daysAfterCanRefund! : 3.3,
        createAccount: overrides && overrides.hasOwnProperty('createAccount') ? overrides.createAccount! : false,
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : IntegrationType.PaymentStripe,
    };
};

export const aCompleteStripeOAuth = (overrides?: Partial<CompleteStripeOAuth>, _relationshipsToOmit: Set<string> = new Set()): CompleteStripeOAuth => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CompleteStripeOAuth');
    return {
        redirectUrl: overrides && overrides.hasOwnProperty('redirectUrl') ? overrides.redirectUrl! : 'speculum',
    };
};

export const aXeroConfigurationInput = (overrides?: Partial<XeroConfigurationInput>, _relationshipsToOmit: Set<string> = new Set()): XeroConfigurationInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('XeroConfigurationInput');
    return {
        accountCode: overrides && overrides.hasOwnProperty('accountCode') ? overrides.accountCode! : 'abbas',
        sendFlicketInvoice: overrides && overrides.hasOwnProperty('sendFlicketInvoice') ? overrides.sendFlicketInvoice! : false,
        invoiceStatus: overrides && overrides.hasOwnProperty('invoiceStatus') ? overrides.invoiceStatus! : XeroInvoiceStatus.Draft,
        numDaysToPay: overrides && overrides.hasOwnProperty('numDaysToPay') ? overrides.numDaysToPay! : 4,
        useCompanyNameOnInvoice: overrides && overrides.hasOwnProperty('useCompanyNameOnInvoice') ? overrides.useCompanyNameOnInvoice! : false,
    };
};

export const aXeroCallbackInput = (overrides?: Partial<XeroCallbackInput>, _relationshipsToOmit: Set<string> = new Set()): XeroCallbackInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('XeroCallbackInput');
    return {
        code: overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'quisquam',
    };
};

export const aShopifySetupInput = (overrides?: Partial<ShopifySetupInput>, _relationshipsToOmit: Set<string> = new Set()): ShopifySetupInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ShopifySetupInput');
    return {
        token: overrides && overrides.hasOwnProperty('token') ? overrides.token! : 'patrocinor',
    };
};

export const anAdobeExperiencePlatformIntegrationInput = (overrides?: Partial<AdobeExperiencePlatformIntegrationInput>, _relationshipsToOmit: Set<string> = new Set()): AdobeExperiencePlatformIntegrationInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AdobeExperiencePlatformIntegrationInput');
    return {
        tenant: overrides && overrides.hasOwnProperty('tenant') ? overrides.tenant! : 'tolero',
        sandboxName: overrides && overrides.hasOwnProperty('sandboxName') ? overrides.sandboxName! : 'theologus',
        clientId: overrides && overrides.hasOwnProperty('clientId') ? overrides.clientId! : 'cohibeo',
        clientSecret: overrides && overrides.hasOwnProperty('clientSecret') ? overrides.clientSecret! : 'supra',
        imsOrgId: overrides && overrides.hasOwnProperty('imsOrgId') ? overrides.imsOrgId! : 'vilis',
        technicalAccountId: overrides && overrides.hasOwnProperty('technicalAccountId') ? overrides.technicalAccountId! : 'solutio',
        privateKeyBase64: overrides && overrides.hasOwnProperty('privateKeyBase64') ? overrides.privateKeyBase64! : 'theca',
        customerEndpoint: overrides && overrides.hasOwnProperty('customerEndpoint') ? overrides.customerEndpoint! : 'praesentium',
        customerSchemaRefId: overrides && overrides.hasOwnProperty('customerSchemaRefId') ? overrides.customerSchemaRefId! : 'vetus',
        customerDatasetId: overrides && overrides.hasOwnProperty('customerDatasetId') ? overrides.customerDatasetId! : 'alioqui',
        scanEndpoint: overrides && overrides.hasOwnProperty('scanEndpoint') ? overrides.scanEndpoint! : 'basium',
        scanSchemaRefId: overrides && overrides.hasOwnProperty('scanSchemaRefId') ? overrides.scanSchemaRefId! : 'ter',
        scanDatasetId: overrides && overrides.hasOwnProperty('scanDatasetId') ? overrides.scanDatasetId! : 'vitium',
        ticketEndpoint: overrides && overrides.hasOwnProperty('ticketEndpoint') ? overrides.ticketEndpoint! : 'attollo',
        ticketSchemaRefId: overrides && overrides.hasOwnProperty('ticketSchemaRefId') ? overrides.ticketSchemaRefId! : 'vomito',
        ticketDatasetId: overrides && overrides.hasOwnProperty('ticketDatasetId') ? overrides.ticketDatasetId! : 'viriliter',
    };
};

export const aCreateOrganizationInput = (overrides?: Partial<CreateOrganizationInput>, _relationshipsToOmit: Set<string> = new Set()): CreateOrganizationInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateOrganizationInput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'derelinquo',
        slug: overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'pectus',
        address: overrides && overrides.hasOwnProperty('address') ? overrides.address! : relationshipsToOmit.has('AddressInput') ? {} as AddressInput : anAddressInput({}, relationshipsToOmit),
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'confero',
        phone: overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : 'coepi',
        taxNumber: overrides && overrides.hasOwnProperty('taxNumber') ? overrides.taxNumber! : 'confugo',
        taxRate: overrides && overrides.hasOwnProperty('taxRate') ? overrides.taxRate! : 0.5,
        currency: overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'decretum',
        supportInfo: overrides && overrides.hasOwnProperty('supportInfo') ? overrides.supportInfo! : 'suscipit',
        landingPage: overrides && overrides.hasOwnProperty('landingPage') ? overrides.landingPage! : LandingPage.MultiEvent,
        showMemberships: overrides && overrides.hasOwnProperty('showMemberships') ? overrides.showMemberships! : true,
        showMembershipRenewal: overrides && overrides.hasOwnProperty('showMembershipRenewal') ? overrides.showMembershipRenewal! : true,
        termsAndConditions: overrides && overrides.hasOwnProperty('termsAndConditions') ? overrides.termsAndConditions! : 'umerus',
        privacyPolicy: overrides && overrides.hasOwnProperty('privacyPolicy') ? overrides.privacyPolicy! : 'amaritudo',
        branding: overrides && overrides.hasOwnProperty('branding') ? overrides.branding! : relationshipsToOmit.has('BrandingInput') ? {} as BrandingInput : aBrandingInput({}, relationshipsToOmit),
        landingTours: overrides && overrides.hasOwnProperty('landingTours') ? overrides.landingTours! : relationshipsToOmit.has('LandingToursInput') ? {} as LandingToursInput : aLandingToursInput({}, relationshipsToOmit),
        marketing: overrides && overrides.hasOwnProperty('marketing') ? overrides.marketing! : relationshipsToOmit.has('MarketingInput') ? {} as MarketingInput : aMarketingInput({}, relationshipsToOmit),
        helpLink: overrides && overrides.hasOwnProperty('helpLink') ? overrides.helpLink! : 'viriliter',
        customTaxRate: overrides && overrides.hasOwnProperty('customTaxRate') ? overrides.customTaxRate! : 1.3,
        customTaxName: overrides && overrides.hasOwnProperty('customTaxName') ? overrides.customTaxName! : 'appello',
        features: overrides && overrides.hasOwnProperty('features') ? overrides.features! : ['crapula'],
        i18n: overrides && overrides.hasOwnProperty('i18n') ? overrides.i18n! : 'compello',
        defaultOptInMarketing: overrides && overrides.hasOwnProperty('defaultOptInMarketing') ? overrides.defaultOptInMarketing! : false,
        cookieConsent: overrides && overrides.hasOwnProperty('cookieConsent') ? overrides.cookieConsent! : true,
    };
};

export const aBrandingInput = (overrides?: Partial<BrandingInput>, _relationshipsToOmit: Set<string> = new Set()): BrandingInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BrandingInput');
    return {
        logo: overrides && overrides.hasOwnProperty('logo') ? overrides.logo! : 'odio',
        mobileLogo: overrides && overrides.hasOwnProperty('mobileLogo') ? overrides.mobileLogo! : 'cultellus',
        favicon: overrides && overrides.hasOwnProperty('favicon') ? overrides.favicon! : 'deripio',
        background: overrides && overrides.hasOwnProperty('background') ? overrides.background! : 'communis',
        fullBackground: overrides && overrides.hasOwnProperty('fullBackground') ? overrides.fullBackground! : 'terror',
        primaryColor: overrides && overrides.hasOwnProperty('primaryColor') ? overrides.primaryColor! : 'deputo',
        secondaryColor: overrides && overrides.hasOwnProperty('secondaryColor') ? overrides.secondaryColor! : 'adaugeo',
        greyScale: overrides && overrides.hasOwnProperty('greyScale') ? overrides.greyScale! : GreyScale.Warm,
    };
};

export const aLandingToursInput = (overrides?: Partial<LandingToursInput>, _relationshipsToOmit: Set<string> = new Set()): LandingToursInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LandingToursInput');
    return {
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'sponte',
        banner: overrides && overrides.hasOwnProperty('banner') ? overrides.banner! : 'desino',
        showCalendarOnTourPage: overrides && overrides.hasOwnProperty('showCalendarOnTourPage') ? overrides.showCalendarOnTourPage! : false,
    };
};

export const aMarketingInput = (overrides?: Partial<MarketingInput>, _relationshipsToOmit: Set<string> = new Set()): MarketingInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MarketingInput');
    return {
        gtmId: overrides && overrides.hasOwnProperty('gtmId') ? overrides.gtmId! : 'viridis',
        pixelId: overrides && overrides.hasOwnProperty('pixelId') ? overrides.pixelId! : 'sordeo',
    };
};

export const aCreateOrganizationOutput = (overrides?: Partial<CreateOrganizationOutput>, _relationshipsToOmit: Set<string> = new Set()): CreateOrganizationOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateOrganizationOutput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'est',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'talis',
        slug: overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'catena',
    };
};

export const anUpdateOrganizationInput = (overrides?: Partial<UpdateOrganizationInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateOrganizationInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateOrganizationInput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'tubineus',
        slug: overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'thorax',
        address: overrides && overrides.hasOwnProperty('address') ? overrides.address! : relationshipsToOmit.has('AddressInput') ? {} as AddressInput : anAddressInput({}, relationshipsToOmit),
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'vociferor',
        phone: overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : 'curso',
        taxNumber: overrides && overrides.hasOwnProperty('taxNumber') ? overrides.taxNumber! : 'aegrotatio',
        taxRate: overrides && overrides.hasOwnProperty('taxRate') ? overrides.taxRate! : 7,
        currency: overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'carpo',
        supportInfo: overrides && overrides.hasOwnProperty('supportInfo') ? overrides.supportInfo! : 'astrum',
        landingPage: overrides && overrides.hasOwnProperty('landingPage') ? overrides.landingPage! : LandingPage.MultiEvent,
        showMemberships: overrides && overrides.hasOwnProperty('showMemberships') ? overrides.showMemberships! : true,
        showMembershipRenewal: overrides && overrides.hasOwnProperty('showMembershipRenewal') ? overrides.showMembershipRenewal! : false,
        termsAndConditions: overrides && overrides.hasOwnProperty('termsAndConditions') ? overrides.termsAndConditions! : 'thorax',
        privacyPolicy: overrides && overrides.hasOwnProperty('privacyPolicy') ? overrides.privacyPolicy! : 'adipisci',
        branding: overrides && overrides.hasOwnProperty('branding') ? overrides.branding! : relationshipsToOmit.has('BrandingInput') ? {} as BrandingInput : aBrandingInput({}, relationshipsToOmit),
        landingTours: overrides && overrides.hasOwnProperty('landingTours') ? overrides.landingTours! : relationshipsToOmit.has('LandingToursInput') ? {} as LandingToursInput : aLandingToursInput({}, relationshipsToOmit),
        marketing: overrides && overrides.hasOwnProperty('marketing') ? overrides.marketing! : relationshipsToOmit.has('MarketingInput') ? {} as MarketingInput : aMarketingInput({}, relationshipsToOmit),
        helpLink: overrides && overrides.hasOwnProperty('helpLink') ? overrides.helpLink! : 'solvo',
        customTaxRate: overrides && overrides.hasOwnProperty('customTaxRate') ? overrides.customTaxRate! : 0.9,
        customTaxName: overrides && overrides.hasOwnProperty('customTaxName') ? overrides.customTaxName! : 'caecus',
        features: overrides && overrides.hasOwnProperty('features') ? overrides.features! : ['voveo'],
        i18n: overrides && overrides.hasOwnProperty('i18n') ? overrides.i18n! : 'surculus',
        defaultOptInMarketing: overrides && overrides.hasOwnProperty('defaultOptInMarketing') ? overrides.defaultOptInMarketing! : false,
        cookieConsent: overrides && overrides.hasOwnProperty('cookieConsent') ? overrides.cookieConsent! : true,
        shippingLabels: overrides && overrides.hasOwnProperty('shippingLabels') ? overrides.shippingLabels! : relationshipsToOmit.has('ShippingLabelsInput') ? {} as ShippingLabelsInput : aShippingLabelsInput({}, relationshipsToOmit),
    };
};

export const aShippingLabelsInput = (overrides?: Partial<ShippingLabelsInput>, _relationshipsToOmit: Set<string> = new Set()): ShippingLabelsInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ShippingLabelsInput');
    return {
        eTicket: overrides && overrides.hasOwnProperty('eTicket') ? overrides.eTicket! : 'aliquam',
        printedTicketByMail: overrides && overrides.hasOwnProperty('printedTicketByMail') ? overrides.printedTicketByMail! : 'socius',
        printedTicketByCourier: overrides && overrides.hasOwnProperty('printedTicketByCourier') ? overrides.printedTicketByCourier! : 'comedo',
        printedTicketByCourierRural: overrides && overrides.hasOwnProperty('printedTicketByCourierRural') ? overrides.printedTicketByCourierRural! : 'laborum',
        printedTicketAtVenue: overrides && overrides.hasOwnProperty('printedTicketAtVenue') ? overrides.printedTicketAtVenue! : 'curis',
    };
};

export const anUpdateCalendarHomepageCustomizationInput = (overrides?: Partial<UpdateCalendarHomepageCustomizationInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateCalendarHomepageCustomizationInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateCalendarHomepageCustomizationInput');
    return {
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'uterque',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'tracto',
        banner: overrides && overrides.hasOwnProperty('banner') ? overrides.banner! : 'vita',
    };
};

export const aCreateOrderInput = (overrides?: Partial<CreateOrderInput>, _relationshipsToOmit: Set<string> = new Set()): CreateOrderInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateOrderInput');
    return {
        sendSmsConfirmation: overrides && overrides.hasOwnProperty('sendSmsConfirmation') ? overrides.sendSmsConfirmation! : false,
        orderType: overrides && overrides.hasOwnProperty('orderType') ? overrides.orderType! : OrderType.Default,
        orderOriginatedFrom: overrides && overrides.hasOwnProperty('orderOriginatedFrom') ? overrides.orderOriginatedFrom! : OrderOriginatedFrom.ExpressCheckout,
        releaseId: overrides && overrides.hasOwnProperty('releaseId') ? overrides.releaseId! : 'succurro',
        releasePasswordId: overrides && overrides.hasOwnProperty('releasePasswordId') ? overrides.releasePasswordId! : 'ceno',
        accessCodeId: overrides && overrides.hasOwnProperty('accessCodeId') ? overrides.accessCodeId! : 'uredo',
        membershipId: overrides && overrides.hasOwnProperty('membershipId') ? overrides.membershipId! : 'vereor',
        userId: overrides && overrides.hasOwnProperty('userId') ? overrides.userId! : 'admiratio',
        lineItems: overrides && overrides.hasOwnProperty('lineItems') ? overrides.lineItems! : [relationshipsToOmit.has('LineItemInput') ? {} as LineItemInput : aLineItemInput({}, relationshipsToOmit)],
        holdToken: overrides && overrides.hasOwnProperty('holdToken') ? overrides.holdToken! : 'corpus',
        multiBuyId: overrides && overrides.hasOwnProperty('multiBuyId') ? overrides.multiBuyId! : 'arma',
        posId: overrides && overrides.hasOwnProperty('posId') ? overrides.posId! : 'suppono',
        referralId: overrides && overrides.hasOwnProperty('referralId') ? overrides.referralId! : 'tibi',
        referralCode: overrides && overrides.hasOwnProperty('referralCode') ? overrides.referralCode! : 'calamitas',
        transferFee: overrides && overrides.hasOwnProperty('transferFee') ? overrides.transferFee! : 2.6,
        isCreatedFromRecoveredCart: overrides && overrides.hasOwnProperty('isCreatedFromRecoveredCart') ? overrides.isCreatedFromRecoveredCart! : false,
        buyerInformation: overrides && overrides.hasOwnProperty('buyerInformation') ? overrides.buyerInformation! : relationshipsToOmit.has('BuyerInformationInput') ? {} as BuyerInformationInput : aBuyerInformationInput({}, relationshipsToOmit),
        usableForMarketing: overrides && overrides.hasOwnProperty('usableForMarketing') ? overrides.usableForMarketing! : false,
        seekaPId: overrides && overrides.hasOwnProperty('seekaPId') ? overrides.seekaPId! : 'candidus',
    };
};

export const aLineItemInput = (overrides?: Partial<LineItemInput>, _relationshipsToOmit: Set<string> = new Set()): LineItemInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LineItemInput');
    return {
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : LineItemType.Ticket,
        quantity: overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 8.7,
        previousTicketId: overrides && overrides.hasOwnProperty('previousTicketId') ? overrides.previousTicketId! : 'vado',
        seatLabel: overrides && overrides.hasOwnProperty('seatLabel') ? overrides.seatLabel! : 'capitulus',
        seatZone: overrides && overrides.hasOwnProperty('seatZone') ? overrides.seatZone! : 'vox',
        seatType: overrides && overrides.hasOwnProperty('seatType') ? overrides.seatType! : 'tardus',
        seatTags: overrides && overrides.hasOwnProperty('seatTags') ? overrides.seatTags! : ['calcar'],
        seatSection: overrides && overrides.hasOwnProperty('seatSection') ? overrides.seatSection! : 'villa',
        ticketTypeId: overrides && overrides.hasOwnProperty('ticketTypeId') ? overrides.ticketTypeId! : 'quis',
        membershipTypeId: overrides && overrides.hasOwnProperty('membershipTypeId') ? overrides.membershipTypeId! : 'deleniti',
        addonId: overrides && overrides.hasOwnProperty('addonId') ? overrides.addonId! : 'accusantium',
        ticketTransferId: overrides && overrides.hasOwnProperty('ticketTransferId') ? overrides.ticketTransferId! : 'facilis',
        pointItemId: overrides && overrides.hasOwnProperty('pointItemId') ? overrides.pointItemId! : 'illo',
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 1.6,
    };
};

export const aBuyerInformationInput = (overrides?: Partial<BuyerInformationInput>, _relationshipsToOmit: Set<string> = new Set()): BuyerInformationInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BuyerInformationInput');
    return {
        firstName: overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'celer',
        lastName: overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'eius',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'talio',
        phoneNumber: overrides && overrides.hasOwnProperty('phoneNumber') ? overrides.phoneNumber! : 'cauda',
        city: overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'aliqua',
        country: overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'timor',
        postalCode: overrides && overrides.hasOwnProperty('postalCode') ? overrides.postalCode! : 'hic',
        taxNumber: overrides && overrides.hasOwnProperty('taxNumber') ? overrides.taxNumber! : 'cauda',
        companyName: overrides && overrides.hasOwnProperty('companyName') ? overrides.companyName! : 'argentum',
        travelDeals: overrides && overrides.hasOwnProperty('travelDeals') ? overrides.travelDeals! : 'aegrus',
        state: overrides && overrides.hasOwnProperty('state') ? overrides.state! : 'asper',
    };
};

export const aCreateCompOrderInput = (overrides?: Partial<CreateCompOrderInput>, _relationshipsToOmit: Set<string> = new Set()): CreateCompOrderInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateCompOrderInput');
    return {
        sendSmsConfirmation: overrides && overrides.hasOwnProperty('sendSmsConfirmation') ? overrides.sendSmsConfirmation! : true,
        orderType: overrides && overrides.hasOwnProperty('orderType') ? overrides.orderType! : OrderType.Default,
        orderOriginatedFrom: overrides && overrides.hasOwnProperty('orderOriginatedFrom') ? overrides.orderOriginatedFrom! : OrderOriginatedFrom.ExpressCheckout,
        releaseId: overrides && overrides.hasOwnProperty('releaseId') ? overrides.releaseId! : 'summopere',
        releasePasswordId: overrides && overrides.hasOwnProperty('releasePasswordId') ? overrides.releasePasswordId! : 'ratione',
        accessCodeId: overrides && overrides.hasOwnProperty('accessCodeId') ? overrides.accessCodeId! : 'calcar',
        membershipId: overrides && overrides.hasOwnProperty('membershipId') ? overrides.membershipId! : 'tutis',
        userId: overrides && overrides.hasOwnProperty('userId') ? overrides.userId! : 'summisse',
        lineItems: overrides && overrides.hasOwnProperty('lineItems') ? overrides.lineItems! : [relationshipsToOmit.has('LineItemInput') ? {} as LineItemInput : aLineItemInput({}, relationshipsToOmit)],
        holdToken: overrides && overrides.hasOwnProperty('holdToken') ? overrides.holdToken! : 'delectus',
        multiBuyId: overrides && overrides.hasOwnProperty('multiBuyId') ? overrides.multiBuyId! : 'capitulus',
        posId: overrides && overrides.hasOwnProperty('posId') ? overrides.posId! : 'conservo',
        referralId: overrides && overrides.hasOwnProperty('referralId') ? overrides.referralId! : 'sub',
        referralCode: overrides && overrides.hasOwnProperty('referralCode') ? overrides.referralCode! : 'adeo',
        transferFee: overrides && overrides.hasOwnProperty('transferFee') ? overrides.transferFee! : 4.7,
        isCreatedFromRecoveredCart: overrides && overrides.hasOwnProperty('isCreatedFromRecoveredCart') ? overrides.isCreatedFromRecoveredCart! : true,
        buyerInformation: overrides && overrides.hasOwnProperty('buyerInformation') ? overrides.buyerInformation! : relationshipsToOmit.has('BuyerInformationInput') ? {} as BuyerInformationInput : aBuyerInformationInput({}, relationshipsToOmit),
        usableForMarketing: overrides && overrides.hasOwnProperty('usableForMarketing') ? overrides.usableForMarketing! : true,
        seekaPId: overrides && overrides.hasOwnProperty('seekaPId') ? overrides.seekaPId! : 'abeo',
        deliveryMethod: overrides && overrides.hasOwnProperty('deliveryMethod') ? overrides.deliveryMethod! : ShippingOption.Eticket,
        billingAddress: overrides && overrides.hasOwnProperty('billingAddress') ? overrides.billingAddress! : relationshipsToOmit.has('AddressInput') ? {} as AddressInput : anAddressInput({}, relationshipsToOmit),
        shippingAddress: overrides && overrides.hasOwnProperty('shippingAddress') ? overrides.shippingAddress! : relationshipsToOmit.has('AddressInput') ? {} as AddressInput : anAddressInput({}, relationshipsToOmit),
        shippingAddressMatchesBillingAddress: overrides && overrides.hasOwnProperty('shippingAddressMatchesBillingAddress') ? overrides.shippingAddressMatchesBillingAddress! : false,
        dietaryRequirements: overrides && overrides.hasOwnProperty('dietaryRequirements') ? overrides.dietaryRequirements! : 'cupiditas',
        heardAboutUs: overrides && overrides.hasOwnProperty('heardAboutUs') ? overrides.heardAboutUs! : HeardAboutUsType.WordOfMouth,
        heardAboutUsDetails: overrides && overrides.hasOwnProperty('heardAboutUsDetails') ? overrides.heardAboutUsDetails! : 'astrum',
        automaticRenewMambership: overrides && overrides.hasOwnProperty('automaticRenewMambership') ? overrides.automaticRenewMambership! : false,
        updateDetails: overrides && overrides.hasOwnProperty('updateDetails') ? overrides.updateDetails! : true,
        userAcquisition: overrides && overrides.hasOwnProperty('userAcquisition') ? overrides.userAcquisition! : relationshipsToOmit.has('UserAcquisition') ? {} as UserAcquisition : aUserAcquisition({}, relationshipsToOmit),
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : OrderStatus.Pending,
        method: overrides && overrides.hasOwnProperty('method') ? overrides.method! : PaymentProvider.Stripe,
        skipOrderConfirmation: overrides && overrides.hasOwnProperty('skipOrderConfirmation') ? overrides.skipOrderConfirmation! : true,
        sendHoldOrderCustomerEmail: overrides && overrides.hasOwnProperty('sendHoldOrderCustomerEmail') ? overrides.sendHoldOrderCustomerEmail! : false,
        shouldGenerateXeroInvoice: overrides && overrides.hasOwnProperty('shouldGenerateXeroInvoice') ? overrides.shouldGenerateXeroInvoice! : true,
        isComp: overrides && overrides.hasOwnProperty('isComp') ? overrides.isComp! : true,
        compReason: overrides && overrides.hasOwnProperty('compReason') ? overrides.compReason! : 'pax',
        manualTransactionFee: overrides && overrides.hasOwnProperty('manualTransactionFee') ? overrides.manualTransactionFee! : 0,
    };
};

export const anUpdateOrderInput = (overrides?: Partial<UpdateOrderInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateOrderInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateOrderInput');
    return {
        step: overrides && overrides.hasOwnProperty('step') ? overrides.step! : 0.5,
        deliveryMethod: overrides && overrides.hasOwnProperty('deliveryMethod') ? overrides.deliveryMethod! : ShippingOption.Eticket,
        buyerInformation: overrides && overrides.hasOwnProperty('buyerInformation') ? overrides.buyerInformation! : relationshipsToOmit.has('BuyerInformationInput') ? {} as BuyerInformationInput : aBuyerInformationInput({}, relationshipsToOmit),
        billingAddress: overrides && overrides.hasOwnProperty('billingAddress') ? overrides.billingAddress! : relationshipsToOmit.has('AddressInput') ? {} as AddressInput : anAddressInput({}, relationshipsToOmit),
        shippingAddress: overrides && overrides.hasOwnProperty('shippingAddress') ? overrides.shippingAddress! : relationshipsToOmit.has('AddressInput') ? {} as AddressInput : anAddressInput({}, relationshipsToOmit),
        shippingAddressMatchesBillingAddress: overrides && overrides.hasOwnProperty('shippingAddressMatchesBillingAddress') ? overrides.shippingAddressMatchesBillingAddress! : false,
        dietaryRequirements: overrides && overrides.hasOwnProperty('dietaryRequirements') ? overrides.dietaryRequirements! : 'suppellex',
        heardAboutUs: overrides && overrides.hasOwnProperty('heardAboutUs') ? overrides.heardAboutUs! : HeardAboutUsType.WordOfMouth,
        heardAboutUsDetails: overrides && overrides.hasOwnProperty('heardAboutUsDetails') ? overrides.heardAboutUsDetails! : 'aliquam',
        automaticRenewMambership: overrides && overrides.hasOwnProperty('automaticRenewMambership') ? overrides.automaticRenewMambership! : true,
        updateDetails: overrides && overrides.hasOwnProperty('updateDetails') ? overrides.updateDetails! : true,
        userAcquisition: overrides && overrides.hasOwnProperty('userAcquisition') ? overrides.userAcquisition! : relationshipsToOmit.has('UserAcquisition') ? {} as UserAcquisition : aUserAcquisition({}, relationshipsToOmit),
        sendSmsConfirmation: overrides && overrides.hasOwnProperty('sendSmsConfirmation') ? overrides.sendSmsConfirmation! : true,
        usableForMarketing: overrides && overrides.hasOwnProperty('usableForMarketing') ? overrides.usableForMarketing! : true,
    };
};

export const anUpdateHoldOrderInput = (overrides?: Partial<UpdateHoldOrderInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateHoldOrderInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateHoldOrderInput');
    return {
        lineItemActions: overrides && overrides.hasOwnProperty('lineItemActions') ? overrides.lineItemActions! : [relationshipsToOmit.has('LineItemActionInput') ? {} as LineItemActionInput : aLineItemActionInput({}, relationshipsToOmit)],
        multiBuyId: overrides && overrides.hasOwnProperty('multiBuyId') ? overrides.multiBuyId! : 'ex',
    };
};

export const aLineItemActionInput = (overrides?: Partial<LineItemActionInput>, _relationshipsToOmit: Set<string> = new Set()): LineItemActionInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LineItemActionInput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ulterius',
        action: overrides && overrides.hasOwnProperty('action') ? overrides.action! : LineItemAction.Delete,
        ticketOrMembershipTypeId: overrides && overrides.hasOwnProperty('ticketOrMembershipTypeId') ? overrides.ticketOrMembershipTypeId! : 'amaritudo',
    };
};

export const aSplitOrderInput = (overrides?: Partial<SplitOrderInput>, _relationshipsToOmit: Set<string> = new Set()): SplitOrderInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SplitOrderInput');
    return {
        lineItemIds: overrides && overrides.hasOwnProperty('lineItemIds') ? overrides.lineItemIds! : ['vehemens'],
        userId: overrides && overrides.hasOwnProperty('userId') ? overrides.userId! : 'caterva',
        deliveryMethod: overrides && overrides.hasOwnProperty('deliveryMethod') ? overrides.deliveryMethod! : ShippingOption.Eticket,
        curMultiBuyId: overrides && overrides.hasOwnProperty('curMultiBuyId') ? overrides.curMultiBuyId! : 'tyrannus',
        newMultiBuyId: overrides && overrides.hasOwnProperty('newMultiBuyId') ? overrides.newMultiBuyId! : 'debeo',
        newTicketTypes: overrides && overrides.hasOwnProperty('newTicketTypes') ? overrides.newTicketTypes! : [relationshipsToOmit.has('SplitOrderTicketTypes') ? {} as SplitOrderTicketTypes : aSplitOrderTicketTypes({}, relationshipsToOmit)],
    };
};

export const aSplitOrderTicketTypes = (overrides?: Partial<SplitOrderTicketTypes>, _relationshipsToOmit: Set<string> = new Set()): SplitOrderTicketTypes => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SplitOrderTicketTypes');
    return {
        lineItemId: overrides && overrides.hasOwnProperty('lineItemId') ? overrides.lineItemId! : 'confero',
        ticketTypeId: overrides && overrides.hasOwnProperty('ticketTypeId') ? overrides.ticketTypeId! : 'curvo',
    };
};

export const aReleaseSeatsInput = (overrides?: Partial<ReleaseSeatsInput>, _relationshipsToOmit: Set<string> = new Set()): ReleaseSeatsInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ReleaseSeatsInput');
    return {
        orderId: overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'credo',
        notes: overrides && overrides.hasOwnProperty('notes') ? overrides.notes! : 'dicta',
        ticketIds: overrides && overrides.hasOwnProperty('ticketIds') ? overrides.ticketIds! : ['sequi'],
    };
};

export const aCreatePaymentInput = (overrides?: Partial<CreatePaymentInput>, _relationshipsToOmit: Set<string> = new Set()): CreatePaymentInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreatePaymentInput');
    return {
        gateway: overrides && overrides.hasOwnProperty('gateway') ? overrides.gateway! : 'rerum',
        usableForMarketing: overrides && overrides.hasOwnProperty('usableForMarketing') ? overrides.usableForMarketing! : true,
        skipOrderConfirmation: overrides && overrides.hasOwnProperty('skipOrderConfirmation') ? overrides.skipOrderConfirmation! : false,
        sendHoldOrderCustomerEmail: overrides && overrides.hasOwnProperty('sendHoldOrderCustomerEmail') ? overrides.sendHoldOrderCustomerEmail! : false,
        reoccurringPayment: overrides && overrides.hasOwnProperty('reoccurringPayment') ? overrides.reoccurringPayment! : false,
        pointRedemptionAmount: overrides && overrides.hasOwnProperty('pointRedemptionAmount') ? overrides.pointRedemptionAmount! : 9.4,
        gatewayOptions: overrides && overrides.hasOwnProperty('gatewayOptions') ? overrides.gatewayOptions! : relationshipsToOmit.has('GatewayOptions') ? {} as GatewayOptions : aGatewayOptions({}, relationshipsToOmit),
        customFields: overrides && overrides.hasOwnProperty('customFields') ? overrides.customFields! : [relationshipsToOmit.has('CustomFieldInput') ? {} as CustomFieldInput : aCustomFieldInput({}, relationshipsToOmit)],
    };
};

export const aGatewayOptions = (overrides?: Partial<GatewayOptions>, _relationshipsToOmit: Set<string> = new Set()): GatewayOptions => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('GatewayOptions');
    return {
        variantId: overrides && overrides.hasOwnProperty('variantId') ? overrides.variantId! : 'traho',
        isBNPL: overrides && overrides.hasOwnProperty('isBNPL') ? overrides.isBNPL! : false,
        isStripeTerminal: overrides && overrides.hasOwnProperty('isStripeTerminal') ? overrides.isStripeTerminal! : false,
        isStripeEmbeddedCard: overrides && overrides.hasOwnProperty('isStripeEmbeddedCard') ? overrides.isStripeEmbeddedCard! : true,
        expressCheckoutPaymentMethod: overrides && overrides.hasOwnProperty('expressCheckoutPaymentMethod') ? overrides.expressCheckoutPaymentMethod! : StripePaymentMethod.CreditCard,
    };
};

export const aCustomFieldInput = (overrides?: Partial<CustomFieldInput>, _relationshipsToOmit: Set<string> = new Set()): CustomFieldInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CustomFieldInput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'cena',
        fieldName: overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'theatrum',
        fieldValue: overrides && overrides.hasOwnProperty('fieldValue') ? overrides.fieldValue! : 'ullus',
    };
};

export const aCreatePaymentOutput = (overrides?: Partial<CreatePaymentOutput>, _relationshipsToOmit: Set<string> = new Set()): CreatePaymentOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreatePaymentOutput');
    return {
        order: overrides && overrides.hasOwnProperty('order') ? overrides.order! : relationshipsToOmit.has('Order') ? {} as Order : anOrder({}, relationshipsToOmit),
        result: overrides && overrides.hasOwnProperty('result') ? overrides.result! : relationshipsToOmit.has('PaymentSuccess') ? {} as PaymentSuccess : aPaymentSuccess({}, relationshipsToOmit),
    };
};

export const aPaymentSuccess = (overrides?: Partial<PaymentSuccess>, _relationshipsToOmit: Set<string> = new Set()): PaymentSuccess => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PaymentSuccess');
    return {
        gateway: overrides && overrides.hasOwnProperty('gateway') ? overrides.gateway! : PaymentProvider.Stripe,
        redirectTo: overrides && overrides.hasOwnProperty('redirectTo') ? overrides.redirectTo! : 'tui',
        externalId: overrides && overrides.hasOwnProperty('externalId') ? overrides.externalId! : 'thalassinus',
    };
};

export const aPaymentError = (overrides?: Partial<PaymentError>, _relationshipsToOmit: Set<string> = new Set()): PaymentError => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PaymentError');
    return {
        code: overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'ceno',
        message: overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'repellendus',
    };
};

export const anApplyPromoCode = (overrides?: Partial<ApplyPromoCode>, _relationshipsToOmit: Set<string> = new Set()): ApplyPromoCode => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ApplyPromoCode');
    return {
        promoCode: overrides && overrides.hasOwnProperty('promoCode') ? overrides.promoCode! : 'curriculum',
    };
};

export const anUpdateOrderTicketCoverInput = (overrides?: Partial<UpdateOrderTicketCoverInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateOrderTicketCoverInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateOrderTicketCoverInput');
    return {
        includeTicketCover: overrides && overrides.hasOwnProperty('includeTicketCover') ? overrides.includeTicketCover! : false,
    };
};

export const anUpdateOrderStatusInput = (overrides?: Partial<UpdateOrderStatusInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateOrderStatusInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateOrderStatusInput');
    return {
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : OrderStatus.Pending,
        method: overrides && overrides.hasOwnProperty('method') ? overrides.method! : PaymentProvider.Stripe,
        skipOrderConfirmation: overrides && overrides.hasOwnProperty('skipOrderConfirmation') ? overrides.skipOrderConfirmation! : true,
        sendHoldOrderCustomerEmail: overrides && overrides.hasOwnProperty('sendHoldOrderCustomerEmail') ? overrides.sendHoldOrderCustomerEmail! : false,
        shouldGenerateXeroInvoice: overrides && overrides.hasOwnProperty('shouldGenerateXeroInvoice') ? overrides.shouldGenerateXeroInvoice! : false,
        isComp: overrides && overrides.hasOwnProperty('isComp') ? overrides.isComp! : true,
        compReason: overrides && overrides.hasOwnProperty('compReason') ? overrides.compReason! : 'vel',
        manualTransactionFee: overrides && overrides.hasOwnProperty('manualTransactionFee') ? overrides.manualTransactionFee! : 6.2,
    };
};

export const aLineItemsToCompleteInput = (overrides?: Partial<LineItemsToCompleteInput>, _relationshipsToOmit: Set<string> = new Set()): LineItemsToCompleteInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LineItemsToCompleteInput');
    return {
        items: overrides && overrides.hasOwnProperty('items') ? overrides.items! : [relationshipsToOmit.has('LineItemToCompleteInput') ? {} as LineItemToCompleteInput : aLineItemToCompleteInput({}, relationshipsToOmit)],
        method: overrides && overrides.hasOwnProperty('method') ? overrides.method! : PaymentProvider.Stripe,
        skipOrderConfirmation: overrides && overrides.hasOwnProperty('skipOrderConfirmation') ? overrides.skipOrderConfirmation! : false,
    };
};

export const aLineItemToCompleteInput = (overrides?: Partial<LineItemToCompleteInput>, _relationshipsToOmit: Set<string> = new Set()): LineItemToCompleteInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LineItemToCompleteInput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'sequi',
        quantity: overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 5243,
    };
};

export const anAddPosTransactionInput = (overrides?: Partial<AddPosTransactionInput>, _relationshipsToOmit: Set<string> = new Set()): AddPosTransactionInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AddPosTransactionInput');
    return {
        method: overrides && overrides.hasOwnProperty('method') ? overrides.method! : PaymentProvider.Stripe,
        amount: overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 9.5,
        returned: overrides && overrides.hasOwnProperty('returned') ? overrides.returned! : 3.4,
        externalId: overrides && overrides.hasOwnProperty('externalId') ? overrides.externalId! : 'contabesco',
    };
};

export const aSendOrderConfirmationInput = (overrides?: Partial<SendOrderConfirmationInput>, _relationshipsToOmit: Set<string> = new Set()): SendOrderConfirmationInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SendOrderConfirmationInput');
    return {
        notificationType: overrides && overrides.hasOwnProperty('notificationType') ? overrides.notificationType! : NotificationType.Email,
        firstName: overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'clam',
        lastName: overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'aedificium',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'ambitus',
        phoneNumber: overrides && overrides.hasOwnProperty('phoneNumber') ? overrides.phoneNumber! : 'conservo',
    };
};

export const aSendOrderConfirmationOutput = (overrides?: Partial<SendOrderConfirmationOutput>, _relationshipsToOmit: Set<string> = new Set()): SendOrderConfirmationOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SendOrderConfirmationOutput');
    return {
        notificationType: overrides && overrides.hasOwnProperty('notificationType') ? overrides.notificationType! : NotificationType.Email,
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'clibanus',
        phoneNumber: overrides && overrides.hasOwnProperty('phoneNumber') ? overrides.phoneNumber! : 'pecus',
    };
};

export const aCreateRefundInput = (overrides?: Partial<CreateRefundInput>, _relationshipsToOmit: Set<string> = new Set()): CreateRefundInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateRefundInput');
    return {
        orderId: overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'rerum',
        amount: overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 0,
        notes: overrides && overrides.hasOwnProperty('notes') ? overrides.notes! : 'chirographum',
        ticketIds: overrides && overrides.hasOwnProperty('ticketIds') ? overrides.ticketIds! : ['aliquid'],
        isManual: overrides && overrides.hasOwnProperty('isManual') ? overrides.isManual! : false,
        gateway: overrides && overrides.hasOwnProperty('gateway') ? overrides.gateway! : RefundGateway.Cash,
        sendEmail: overrides && overrides.hasOwnProperty('sendEmail') ? overrides.sendEmail! : false,
        attributions: overrides && overrides.hasOwnProperty('attributions') ? overrides.attributions! : [relationshipsToOmit.has('RefundAttributionInput') ? {} as RefundAttributionInput : aRefundAttributionInput({}, relationshipsToOmit)],
    };
};

export const aRefundAttributionInput = (overrides?: Partial<RefundAttributionInput>, _relationshipsToOmit: Set<string> = new Set()): RefundAttributionInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RefundAttributionInput');
    return {
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : OrderComponentType.FaceValue,
        amount: overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 8.1,
        ticketId: overrides && overrides.hasOwnProperty('ticketId') ? overrides.ticketId! : 'synagoga',
        taxName: overrides && overrides.hasOwnProperty('taxName') ? overrides.taxName! : 'veritas',
    };
};

export const anAutomaticallyAttributeInput = (overrides?: Partial<AutomaticallyAttributeInput>, _relationshipsToOmit: Set<string> = new Set()): AutomaticallyAttributeInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AutomaticallyAttributeInput');
    return {
        refundId: overrides && overrides.hasOwnProperty('refundId') ? overrides.refundId! : 'custodia',
        additionalMetadata: overrides && overrides.hasOwnProperty('additionalMetadata') ? overrides.additionalMetadata! : 'stultus',
    };
};

export const aCreateAttributableRefundInput = (overrides?: Partial<CreateAttributableRefundInput>, _relationshipsToOmit: Set<string> = new Set()): CreateAttributableRefundInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateAttributableRefundInput');
    return {
        orderId: overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'centum',
        notes: overrides && overrides.hasOwnProperty('notes') ? overrides.notes! : 'absorbeo',
        manual: overrides && overrides.hasOwnProperty('manual') ? overrides.manual! : relationshipsToOmit.has('ManualRefundInput') ? {} as ManualRefundInput : aManualRefundInput({}, relationshipsToOmit),
        sendEmail: overrides && overrides.hasOwnProperty('sendEmail') ? overrides.sendEmail! : true,
        attributions: overrides && overrides.hasOwnProperty('attributions') ? overrides.attributions! : [relationshipsToOmit.has('RefundAttributionInput') ? {} as RefundAttributionInput : aRefundAttributionInput({}, relationshipsToOmit)],
        ticketIdsToRelease: overrides && overrides.hasOwnProperty('ticketIdsToRelease') ? overrides.ticketIdsToRelease! : ['adhaero'],
    };
};

export const aManualRefundInput = (overrides?: Partial<ManualRefundInput>, _relationshipsToOmit: Set<string> = new Set()): ManualRefundInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ManualRefundInput');
    return {
        manualGateway: overrides && overrides.hasOwnProperty('manualGateway') ? overrides.manualGateway! : RefundGateway.Cash,
        amount: overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 1.2,
    };
};

export const aCreatePurchaseRestrictionInput = (overrides?: Partial<CreatePurchaseRestrictionInput>, _relationshipsToOmit: Set<string> = new Set()): CreatePurchaseRestrictionInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreatePurchaseRestrictionInput');
    return {
        restrictedType: overrides && overrides.hasOwnProperty('restrictedType') ? overrides.restrictedType! : LineItemType.Ticket,
        restrictedId: overrides && overrides.hasOwnProperty('restrictedId') ? overrides.restrictedId! : 'ambulo',
        requiredEntities: overrides && overrides.hasOwnProperty('requiredEntities') ? overrides.requiredEntities! : [relationshipsToOmit.has('PurchaseRestrictionRequiredEntityInput') ? {} as PurchaseRestrictionRequiredEntityInput : aPurchaseRestrictionRequiredEntityInput({}, relationshipsToOmit)],
        isExclusive: overrides && overrides.hasOwnProperty('isExclusive') ? overrides.isExclusive! : true,
        isAlwaysVisible: overrides && overrides.hasOwnProperty('isAlwaysVisible') ? overrides.isAlwaysVisible! : true,
        quantity: overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 6.6,
    };
};

export const aPurchaseRestrictionRequiredEntityInput = (overrides?: Partial<PurchaseRestrictionRequiredEntityInput>, _relationshipsToOmit: Set<string> = new Set()): PurchaseRestrictionRequiredEntityInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PurchaseRestrictionRequiredEntityInput');
    return {
        requiredType: overrides && overrides.hasOwnProperty('requiredType') ? overrides.requiredType! : LineItemType.Ticket,
        requiredId: overrides && overrides.hasOwnProperty('requiredId') ? overrides.requiredId! : '4f1dbf2c-4816-4ca7-9c4b-a6962e8bdcf7',
    };
};

export const aCreateHistoryInput = (overrides?: Partial<CreateHistoryInput>, _relationshipsToOmit: Set<string> = new Set()): CreateHistoryInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateHistoryInput');
    return {
        refName: overrides && overrides.hasOwnProperty('refName') ? overrides.refName! : HistoryReferenceType.Order,
        refId: overrides && overrides.hasOwnProperty('refId') ? overrides.refId! : 'somnus',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'vestrum',
    };
};

export const aCreateVenueInput = (overrides?: Partial<CreateVenueInput>, _relationshipsToOmit: Set<string> = new Set()): CreateVenueInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateVenueInput');
    return {
        seating: overrides && overrides.hasOwnProperty('seating') ? overrides.seating! : VenueSeating.Seated,
        seatsChartKey: overrides && overrides.hasOwnProperty('seatsChartKey') ? overrides.seatsChartKey! : 'illum',
        accessibilityInfo: overrides && overrides.hasOwnProperty('accessibilityInfo') ? overrides.accessibilityInfo! : 'clarus',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'thema',
        capacity: overrides && overrides.hasOwnProperty('capacity') ? overrides.capacity! : 808,
        capacityUtilization: overrides && overrides.hasOwnProperty('capacityUtilization') ? overrides.capacityUtilization! : 2.3,
        timezone: overrides && overrides.hasOwnProperty('timezone') ? overrides.timezone! : 'Pacific/Auckland',
        locale: overrides && overrides.hasOwnProperty('locale') ? overrides.locale! : 'en',
        address: overrides && overrides.hasOwnProperty('address') ? overrides.address! : relationshipsToOmit.has('AddressInput') ? {} as AddressInput : anAddressInput({}, relationshipsToOmit),
        location: overrides && overrides.hasOwnProperty('location') ? overrides.location! : relationshipsToOmit.has('CoordinateInput') ? {} as CoordinateInput : aCoordinateInput({}, relationshipsToOmit),
        zones: overrides && overrides.hasOwnProperty('zones') ? overrides.zones! : [relationshipsToOmit.has('ZoneInput') ? {} as ZoneInput : aZoneInput({}, relationshipsToOmit)],
        gates: overrides && overrides.hasOwnProperty('gates') ? overrides.gates! : [relationshipsToOmit.has('GateInput') ? {} as GateInput : aGateInput({}, relationshipsToOmit)],
        defaultSeatSelectionFilters: overrides && overrides.hasOwnProperty('defaultSeatSelectionFilters') ? overrides.defaultSeatSelectionFilters! : relationshipsToOmit.has('SeatSelectionFiltersInput') ? {} as SeatSelectionFiltersInput : aSeatSelectionFiltersInput({}, relationshipsToOmit),
    };
};

export const aZoneInput = (overrides?: Partial<ZoneInput>, _relationshipsToOmit: Set<string> = new Set()): ZoneInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ZoneInput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'suus',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'valens',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'varius',
        capacity: overrides && overrides.hasOwnProperty('capacity') ? overrides.capacity! : 3884,
        stand: overrides && overrides.hasOwnProperty('stand') ? overrides.stand! : 'virga',
        displayOrder: overrides && overrides.hasOwnProperty('displayOrder') ? overrides.displayOrder! : 4.6,
        admission: overrides && overrides.hasOwnProperty('admission') ? overrides.admission! : false,
    };
};

export const aGateInput = (overrides?: Partial<GateInput>, _relationshipsToOmit: Set<string> = new Set()): GateInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('GateInput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'optio',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'conicio',
    };
};

export const anUpdateVenueInput = (overrides?: Partial<UpdateVenueInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateVenueInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateVenueInput');
    return {
        accessibilityInfo: overrides && overrides.hasOwnProperty('accessibilityInfo') ? overrides.accessibilityInfo! : 'culpa',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'dapifer',
        capacity: overrides && overrides.hasOwnProperty('capacity') ? overrides.capacity! : 3197,
        capacityUtilization: overrides && overrides.hasOwnProperty('capacityUtilization') ? overrides.capacityUtilization! : 9.5,
        timezone: overrides && overrides.hasOwnProperty('timezone') ? overrides.timezone! : 'Pacific/Auckland',
        locale: overrides && overrides.hasOwnProperty('locale') ? overrides.locale! : 'en',
        address: overrides && overrides.hasOwnProperty('address') ? overrides.address! : relationshipsToOmit.has('AddressInput') ? {} as AddressInput : anAddressInput({}, relationshipsToOmit),
        location: overrides && overrides.hasOwnProperty('location') ? overrides.location! : relationshipsToOmit.has('CoordinateInput') ? {} as CoordinateInput : aCoordinateInput({}, relationshipsToOmit),
        zones: overrides && overrides.hasOwnProperty('zones') ? overrides.zones! : [relationshipsToOmit.has('ZoneInput') ? {} as ZoneInput : aZoneInput({}, relationshipsToOmit)],
        gates: overrides && overrides.hasOwnProperty('gates') ? overrides.gates! : [relationshipsToOmit.has('GateInput') ? {} as GateInput : aGateInput({}, relationshipsToOmit)],
        defaultSeatSelectionFilters: overrides && overrides.hasOwnProperty('defaultSeatSelectionFilters') ? overrides.defaultSeatSelectionFilters! : relationshipsToOmit.has('SeatSelectionFiltersInput') ? {} as SeatSelectionFiltersInput : aSeatSelectionFiltersInput({}, relationshipsToOmit),
    };
};

export const aReorderZoneInput = (overrides?: Partial<ReorderZoneInput>, _relationshipsToOmit: Set<string> = new Set()): ReorderZoneInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ReorderZoneInput');
    return {
        venueId: overrides && overrides.hasOwnProperty('venueId') ? overrides.venueId! : 'adeptio',
        zoneIds: overrides && overrides.hasOwnProperty('zoneIds') ? overrides.zoneIds! : ['ipsam'],
    };
};

export const aCreateMembershipInput = (overrides?: Partial<CreateMembershipInput>, _relationshipsToOmit: Set<string> = new Set()): CreateMembershipInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateMembershipInput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'urbanus',
        membershipKind: overrides && overrides.hasOwnProperty('membershipKind') ? overrides.membershipKind! : MembershipKind.Standard,
        digitalInfo: overrides && overrides.hasOwnProperty('digitalInfo') ? overrides.digitalInfo! : relationshipsToOmit.has('CreateDigitalInfoInput') ? {} as CreateDigitalInfoInput : aCreateDigitalInfoInput({}, relationshipsToOmit),
        previousMemberships: overrides && overrides.hasOwnProperty('previousMemberships') ? overrides.previousMemberships! : ['adamo'],
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2025-09-10T14:15:41.816Z",
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : "2025-08-10T00:38:39.798Z",
        bookingFeeType: overrides && overrides.hasOwnProperty('bookingFeeType') ? overrides.bookingFeeType! : FeeType.FlatRate,
        bookingFee: overrides && overrides.hasOwnProperty('bookingFee') ? overrides.bookingFee! : 8.2,
        shippingOptions: overrides && overrides.hasOwnProperty('shippingOptions') ? overrides.shippingOptions! : relationshipsToOmit.has('ShippingOptionsInput') ? {} as ShippingOptionsInput : aShippingOptionsInput({}, relationshipsToOmit),
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'odit',
        thumbnail: overrides && overrides.hasOwnProperty('thumbnail') ? overrides.thumbnail! : 'alo',
        backgroundImage: overrides && overrides.hasOwnProperty('backgroundImage') ? overrides.backgroundImage! : 'artificiose',
        descriptionImage: overrides && overrides.hasOwnProperty('descriptionImage') ? overrides.descriptionImage! : 'aedificium',
        banner: overrides && overrides.hasOwnProperty('banner') ? overrides.banner! : 'ustilo',
        printBanner1: overrides && overrides.hasOwnProperty('printBanner1') ? overrides.printBanner1! : 'aranea',
        printBanner2: overrides && overrides.hasOwnProperty('printBanner2') ? overrides.printBanner2! : 'denique',
        gateways: overrides && overrides.hasOwnProperty('gateways') ? overrides.gateways! : ['uredo'],
        canNameMembership: overrides && overrides.hasOwnProperty('canNameMembership') ? overrides.canNameMembership! : true,
        canRenameMembership: overrides && overrides.hasOwnProperty('canRenameMembership') ? overrides.canRenameMembership! : true,
        hiddenFromPublic: overrides && overrides.hasOwnProperty('hiddenFromPublic') ? overrides.hiddenFromPublic! : true,
        canChangeSeats: overrides && overrides.hasOwnProperty('canChangeSeats') ? overrides.canChangeSeats! : false,
        changingSeatsFee: overrides && overrides.hasOwnProperty('changingSeatsFee') ? overrides.changingSeatsFee! : 1.7,
        isTicketed: overrides && overrides.hasOwnProperty('isTicketed') ? overrides.isTicketed! : false,
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : true,
        termsAndConditions: overrides && overrides.hasOwnProperty('termsAndConditions') ? overrides.termsAndConditions! : 'inventore',
        importantNotice: overrides && overrides.hasOwnProperty('importantNotice') ? overrides.importantNotice! : 'bos',
        accessibility: overrides && overrides.hasOwnProperty('accessibility') ? overrides.accessibility! : 'cito',
        invoiceInformation: overrides && overrides.hasOwnProperty('invoiceInformation') ? overrides.invoiceInformation! : 'amoveo',
        showSchedule: overrides && overrides.hasOwnProperty('showSchedule') ? overrides.showSchedule! : false,
        emailNotification: overrides && overrides.hasOwnProperty('emailNotification') ? overrides.emailNotification! : 'patior',
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['demonstro'],
        canUsePoints: overrides && overrides.hasOwnProperty('canUsePoints') ? overrides.canUsePoints! : false,
        enableAutoRenew: overrides && overrides.hasOwnProperty('enableAutoRenew') ? overrides.enableAutoRenew! : false,
        canTransferTickets: overrides && overrides.hasOwnProperty('canTransferTickets') ? overrides.canTransferTickets! : true,
        ticketCover: overrides && overrides.hasOwnProperty('ticketCover') ? overrides.ticketCover! : relationshipsToOmit.has('MembershipTicketCoverInput') ? {} as MembershipTicketCoverInput : aMembershipTicketCoverInput({}, relationshipsToOmit),
        enablePaymentPlans: overrides && overrides.hasOwnProperty('enablePaymentPlans') ? overrides.enablePaymentPlans! : true,
        paymentPlanScheduleOptions: overrides && overrides.hasOwnProperty('paymentPlanScheduleOptions') ? overrides.paymentPlanScheduleOptions! : [relationshipsToOmit.has('ScheduleOptionInput') ? {} as ScheduleOptionInput : aScheduleOptionInput({}, relationshipsToOmit)],
        seoMetadata: overrides && overrides.hasOwnProperty('seoMetadata') ? overrides.seoMetadata! : relationshipsToOmit.has('SeoMetadataInput') ? {} as SeoMetadataInput : aSeoMetadataInput({}, relationshipsToOmit),
        productUpsell: overrides && overrides.hasOwnProperty('productUpsell') ? overrides.productUpsell! : relationshipsToOmit.has('ProductUpsellInput') ? {} as ProductUpsellInput : aProductUpsellInput({}, relationshipsToOmit),
        tax: overrides && overrides.hasOwnProperty('tax') ? overrides.tax! : [relationshipsToOmit.has('TaxInput') ? {} as TaxInput : aTaxInput({}, relationshipsToOmit)],
        membershipsViewableFromDate: overrides && overrides.hasOwnProperty('membershipsViewableFromDate') ? overrides.membershipsViewableFromDate! : "2025-07-30T09:30:35.411Z",
        isFlexiMembership: overrides && overrides.hasOwnProperty('isFlexiMembership') ? overrides.isFlexiMembership! : false,
    };
};

export const aMembershipTicketCoverInput = (overrides?: Partial<MembershipTicketCoverInput>, _relationshipsToOmit: Set<string> = new Set()): MembershipTicketCoverInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MembershipTicketCoverInput');
    return {
        promoterFeePercentage: overrides && overrides.hasOwnProperty('promoterFeePercentage') ? overrides.promoterFeePercentage! : 0.2,
        purchaseBehaviour: overrides && overrides.hasOwnProperty('purchaseBehaviour') ? overrides.purchaseBehaviour! : TicketCoverPurchaseBehaviour.Optional,
        isEnabled: overrides && overrides.hasOwnProperty('isEnabled') ? overrides.isEnabled! : false,
    };
};

export const anUpdateMembershipInput = (overrides?: Partial<UpdateMembershipInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateMembershipInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateMembershipInput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'concedo',
        membershipKind: overrides && overrides.hasOwnProperty('membershipKind') ? overrides.membershipKind! : MembershipKind.Standard,
        digitalInfo: overrides && overrides.hasOwnProperty('digitalInfo') ? overrides.digitalInfo! : relationshipsToOmit.has('UpdateDigitalInfoInput') ? {} as UpdateDigitalInfoInput : anUpdateDigitalInfoInput({}, relationshipsToOmit),
        previousMemberships: overrides && overrides.hasOwnProperty('previousMemberships') ? overrides.previousMemberships! : ['alioqui'],
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2025-05-16T11:57:38.589Z",
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : "2025-10-24T03:44:12.222Z",
        bookingFeeType: overrides && overrides.hasOwnProperty('bookingFeeType') ? overrides.bookingFeeType! : FeeType.FlatRate,
        bookingFee: overrides && overrides.hasOwnProperty('bookingFee') ? overrides.bookingFee! : 3.7,
        shippingOptions: overrides && overrides.hasOwnProperty('shippingOptions') ? overrides.shippingOptions! : relationshipsToOmit.has('ShippingOptionsInput') ? {} as ShippingOptionsInput : aShippingOptionsInput({}, relationshipsToOmit),
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'cui',
        thumbnail: overrides && overrides.hasOwnProperty('thumbnail') ? overrides.thumbnail! : 'cubicularis',
        backgroundImage: overrides && overrides.hasOwnProperty('backgroundImage') ? overrides.backgroundImage! : 'pariatur',
        descriptionImage: overrides && overrides.hasOwnProperty('descriptionImage') ? overrides.descriptionImage! : 'bene',
        banner: overrides && overrides.hasOwnProperty('banner') ? overrides.banner! : 'agnosco',
        printBanner1: overrides && overrides.hasOwnProperty('printBanner1') ? overrides.printBanner1! : 'umerus',
        printBanner2: overrides && overrides.hasOwnProperty('printBanner2') ? overrides.printBanner2! : 'capto',
        gateways: overrides && overrides.hasOwnProperty('gateways') ? overrides.gateways! : ['aut'],
        canNameMembership: overrides && overrides.hasOwnProperty('canNameMembership') ? overrides.canNameMembership! : false,
        canRenameMembership: overrides && overrides.hasOwnProperty('canRenameMembership') ? overrides.canRenameMembership! : false,
        hiddenFromPublic: overrides && overrides.hasOwnProperty('hiddenFromPublic') ? overrides.hiddenFromPublic! : false,
        canChangeSeats: overrides && overrides.hasOwnProperty('canChangeSeats') ? overrides.canChangeSeats! : false,
        changingSeatsFee: overrides && overrides.hasOwnProperty('changingSeatsFee') ? overrides.changingSeatsFee! : 3.3,
        isTicketed: overrides && overrides.hasOwnProperty('isTicketed') ? overrides.isTicketed! : false,
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : false,
        termsAndConditions: overrides && overrides.hasOwnProperty('termsAndConditions') ? overrides.termsAndConditions! : 'volo',
        importantNotice: overrides && overrides.hasOwnProperty('importantNotice') ? overrides.importantNotice! : 'acer',
        accessibility: overrides && overrides.hasOwnProperty('accessibility') ? overrides.accessibility! : 'cruciamentum',
        invoiceInformation: overrides && overrides.hasOwnProperty('invoiceInformation') ? overrides.invoiceInformation! : 'baiulus',
        showSchedule: overrides && overrides.hasOwnProperty('showSchedule') ? overrides.showSchedule! : false,
        emailNotification: overrides && overrides.hasOwnProperty('emailNotification') ? overrides.emailNotification! : 'deputo',
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['coma'],
        canUsePoints: overrides && overrides.hasOwnProperty('canUsePoints') ? overrides.canUsePoints! : true,
        enableAutoRenew: overrides && overrides.hasOwnProperty('enableAutoRenew') ? overrides.enableAutoRenew! : false,
        canTransferTickets: overrides && overrides.hasOwnProperty('canTransferTickets') ? overrides.canTransferTickets! : false,
        ticketCover: overrides && overrides.hasOwnProperty('ticketCover') ? overrides.ticketCover! : relationshipsToOmit.has('MembershipTicketCoverInput') ? {} as MembershipTicketCoverInput : aMembershipTicketCoverInput({}, relationshipsToOmit),
        enablePaymentPlans: overrides && overrides.hasOwnProperty('enablePaymentPlans') ? overrides.enablePaymentPlans! : true,
        paymentPlanScheduleOptions: overrides && overrides.hasOwnProperty('paymentPlanScheduleOptions') ? overrides.paymentPlanScheduleOptions! : [relationshipsToOmit.has('ScheduleOptionInput') ? {} as ScheduleOptionInput : aScheduleOptionInput({}, relationshipsToOmit)],
        seoMetadata: overrides && overrides.hasOwnProperty('seoMetadata') ? overrides.seoMetadata! : relationshipsToOmit.has('SeoMetadataInput') ? {} as SeoMetadataInput : aSeoMetadataInput({}, relationshipsToOmit),
        productUpsell: overrides && overrides.hasOwnProperty('productUpsell') ? overrides.productUpsell! : relationshipsToOmit.has('ProductUpsellInput') ? {} as ProductUpsellInput : aProductUpsellInput({}, relationshipsToOmit),
        tax: overrides && overrides.hasOwnProperty('tax') ? overrides.tax! : [relationshipsToOmit.has('TaxInput') ? {} as TaxInput : aTaxInput({}, relationshipsToOmit)],
        membershipsViewableFromDate: overrides && overrides.hasOwnProperty('membershipsViewableFromDate') ? overrides.membershipsViewableFromDate! : "2025-11-20T16:14:42.828Z",
        isFlexiMembership: overrides && overrides.hasOwnProperty('isFlexiMembership') ? overrides.isFlexiMembership! : false,
        season: overrides && overrides.hasOwnProperty('season') ? overrides.season! : 'virga',
        events: overrides && overrides.hasOwnProperty('events') ? overrides.events! : ['demoror'],
        membershipZones: overrides && overrides.hasOwnProperty('membershipZones') ? overrides.membershipZones! : [relationshipsToOmit.has('UpdateMembershipZoneInput') ? {} as UpdateMembershipZoneInput : anUpdateMembershipZoneInput({}, relationshipsToOmit)],
        sendMembershipViewableEmails: overrides && overrides.hasOwnProperty('sendMembershipViewableEmails') ? overrides.sendMembershipViewableEmails! : true,
    };
};

export const anUpdateMembershipZoneInput = (overrides?: Partial<UpdateMembershipZoneInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateMembershipZoneInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateMembershipZoneInput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'volaticus',
        zone: overrides && overrides.hasOwnProperty('zone') ? overrides.zone! : relationshipsToOmit.has('MembershipZoneZoneInput') ? {} as MembershipZoneZoneInput : aMembershipZoneZoneInput({}, relationshipsToOmit),
        pricingLevel: overrides && overrides.hasOwnProperty('pricingLevel') ? overrides.pricingLevel! : ZonePricingLevel.Zone,
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : false,
        membershipTypes: overrides && overrides.hasOwnProperty('membershipTypes') ? overrides.membershipTypes! : [relationshipsToOmit.has('UpdateMembershipZoneMembershipTypeInput') ? {} as UpdateMembershipZoneMembershipTypeInput : anUpdateMembershipZoneMembershipTypeInput({}, relationshipsToOmit)],
    };
};

export const aMembershipZoneZoneInput = (overrides?: Partial<MembershipZoneZoneInput>, _relationshipsToOmit: Set<string> = new Set()): MembershipZoneZoneInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MembershipZoneZoneInput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'colo',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'capio',
    };
};

export const anUpdateMembershipZoneMembershipTypeInput = (overrides?: Partial<UpdateMembershipZoneMembershipTypeInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateMembershipZoneMembershipTypeInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateMembershipZoneMembershipTypeInput');
    return {
        membershipTypeId: overrides && overrides.hasOwnProperty('membershipTypeId') ? overrides.membershipTypeId! : 'subiungo',
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 5.7,
        sections: overrides && overrides.hasOwnProperty('sections') ? overrides.sections! : [relationshipsToOmit.has('UpdateMembershipZoneMembershipTypeSectionInput') ? {} as UpdateMembershipZoneMembershipTypeSectionInput : anUpdateMembershipZoneMembershipTypeSectionInput({}, relationshipsToOmit)],
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : false,
    };
};

export const anUpdateMembershipZoneMembershipTypeSectionInput = (overrides?: Partial<UpdateMembershipZoneMembershipTypeSectionInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateMembershipZoneMembershipTypeSectionInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateMembershipZoneMembershipTypeSectionInput');
    return {
        sectionId: overrides && overrides.hasOwnProperty('sectionId') ? overrides.sectionId! : 'callide',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'tergeo',
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 3.4,
    };
};

export const anUpdateExchangeableEventsInput = (overrides?: Partial<UpdateExchangeableEventsInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateExchangeableEventsInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateExchangeableEventsInput');
    return {
        fromEventId: overrides && overrides.hasOwnProperty('fromEventId') ? overrides.fromEventId! : 'umerus',
        toEventIds: overrides && overrides.hasOwnProperty('toEventIds') ? overrides.toEventIds! : ['cado'],
    };
};

export const anUpdateMembershipTypeEventTransferPriceInput = (overrides?: Partial<UpdateMembershipTypeEventTransferPriceInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateMembershipTypeEventTransferPriceInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateMembershipTypeEventTransferPriceInput');
    return {
        membershipTypeId: overrides && overrides.hasOwnProperty('membershipTypeId') ? overrides.membershipTypeId! : 'cupiditate',
        membershipZoneId: overrides && overrides.hasOwnProperty('membershipZoneId') ? overrides.membershipZoneId! : 'vereor',
        prices: overrides && overrides.hasOwnProperty('prices') ? overrides.prices! : [relationshipsToOmit.has('MembershipTypeTransferPriceInput') ? {} as MembershipTypeTransferPriceInput : aMembershipTypeTransferPriceInput({}, relationshipsToOmit)],
    };
};

export const aMembershipTypeTransferPriceInput = (overrides?: Partial<MembershipTypeTransferPriceInput>, _relationshipsToOmit: Set<string> = new Set()): MembershipTypeTransferPriceInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MembershipTypeTransferPriceInput');
    return {
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'patior',
        maxSalePrice: overrides && overrides.hasOwnProperty('maxSalePrice') ? overrides.maxSalePrice! : 9.7,
    };
};

export const aCreateMembershipTypeInput = (overrides?: Partial<CreateMembershipTypeInput>, _relationshipsToOmit: Set<string> = new Set()): CreateMembershipTypeInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateMembershipTypeInput');
    return {
        membershipId: overrides && overrides.hasOwnProperty('membershipId') ? overrides.membershipId! : 'vesica',
        kind: overrides && overrides.hasOwnProperty('kind') ? overrides.kind! : MembershipTypeKind.Standard,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'vilicus',
        ticketFeeType: overrides && overrides.hasOwnProperty('ticketFeeType') ? overrides.ticketFeeType! : FeeType.FlatRate,
        quantitySet: overrides && overrides.hasOwnProperty('quantitySet') ? overrides.quantitySet! : 3.6,
        ticketFee: overrides && overrides.hasOwnProperty('ticketFee') ? overrides.ticketFee! : 5,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'voluptate',
        restrictions: overrides && overrides.hasOwnProperty('restrictions') ? overrides.restrictions! : 'delicate',
        namingFields: overrides && overrides.hasOwnProperty('namingFields') ? overrides.namingFields! : [relationshipsToOmit.has('FormFieldInput') ? {} as FormFieldInput : aFormFieldInput({}, relationshipsToOmit)],
        minPurchaseQuantity: overrides && overrides.hasOwnProperty('minPurchaseQuantity') ? overrides.minPurchaseQuantity! : 5.3,
        maxPurchaseQuantity: overrides && overrides.hasOwnProperty('maxPurchaseQuantity') ? overrides.maxPurchaseQuantity! : 6,
        isGuestCard: overrides && overrides.hasOwnProperty('isGuestCard') ? overrides.isGuestCard! : false,
        isChild: overrides && overrides.hasOwnProperty('isChild') ? overrides.isChild! : true,
        isHidden: overrides && overrides.hasOwnProperty('isHidden') ? overrides.isHidden! : false,
    };
};

export const anUpdateMembershipTypeInput = (overrides?: Partial<UpdateMembershipTypeInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateMembershipTypeInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateMembershipTypeInput');
    return {
        kind: overrides && overrides.hasOwnProperty('kind') ? overrides.kind! : MembershipTypeKind.Standard,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'ullam',
        ticketFeeType: overrides && overrides.hasOwnProperty('ticketFeeType') ? overrides.ticketFeeType! : FeeType.FlatRate,
        quantitySet: overrides && overrides.hasOwnProperty('quantitySet') ? overrides.quantitySet! : 1.6,
        ticketFee: overrides && overrides.hasOwnProperty('ticketFee') ? overrides.ticketFee! : 5.8,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'commemoro',
        restrictions: overrides && overrides.hasOwnProperty('restrictions') ? overrides.restrictions! : 'tristis',
        namingFields: overrides && overrides.hasOwnProperty('namingFields') ? overrides.namingFields! : [relationshipsToOmit.has('FormFieldInput') ? {} as FormFieldInput : aFormFieldInput({}, relationshipsToOmit)],
        minPurchaseQuantity: overrides && overrides.hasOwnProperty('minPurchaseQuantity') ? overrides.minPurchaseQuantity! : 3.4,
        maxPurchaseQuantity: overrides && overrides.hasOwnProperty('maxPurchaseQuantity') ? overrides.maxPurchaseQuantity! : 3.9,
        isGuestCard: overrides && overrides.hasOwnProperty('isGuestCard') ? overrides.isGuestCard! : true,
        isChild: overrides && overrides.hasOwnProperty('isChild') ? overrides.isChild! : true,
        isHidden: overrides && overrides.hasOwnProperty('isHidden') ? overrides.isHidden! : true,
    };
};

export const aCreateMembershipAddonInput = (overrides?: Partial<CreateMembershipAddonInput>, _relationshipsToOmit: Set<string> = new Set()): CreateMembershipAddonInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateMembershipAddonInput');
    return {
        membershipId: overrides && overrides.hasOwnProperty('membershipId') ? overrides.membershipId! : 'cursim',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'clam',
        enableNaming: overrides && overrides.hasOwnProperty('enableNaming') ? overrides.enableNaming! : true,
        quantity: overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 2.4,
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 1.4,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'bellicus',
        restrictions: overrides && overrides.hasOwnProperty('restrictions') ? overrides.restrictions! : 'decet',
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : true,
        namingFields: overrides && overrides.hasOwnProperty('namingFields') ? overrides.namingFields! : [relationshipsToOmit.has('FormFieldInput') ? {} as FormFieldInput : aFormFieldInput({}, relationshipsToOmit)],
        addonImage: overrides && overrides.hasOwnProperty('addonImage') ? overrides.addonImage! : 'vinco',
    };
};

export const anUpdateMembershipAddonInput = (overrides?: Partial<UpdateMembershipAddonInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateMembershipAddonInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateMembershipAddonInput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'curiositas',
        enableNaming: overrides && overrides.hasOwnProperty('enableNaming') ? overrides.enableNaming! : false,
        quantity: overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 1.1,
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 0.7,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'derelinquo',
        restrictions: overrides && overrides.hasOwnProperty('restrictions') ? overrides.restrictions! : 'uredo',
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : true,
        namingFields: overrides && overrides.hasOwnProperty('namingFields') ? overrides.namingFields! : [relationshipsToOmit.has('FormFieldInput') ? {} as FormFieldInput : aFormFieldInput({}, relationshipsToOmit)],
        addonImage: overrides && overrides.hasOwnProperty('addonImage') ? overrides.addonImage! : 'turbo',
    };
};

export const aCreateMembershipPromoCodeInput = (overrides?: Partial<CreateMembershipPromoCodeInput>, _relationshipsToOmit: Set<string> = new Set()): CreateMembershipPromoCodeInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateMembershipPromoCodeInput');
    return {
        code: overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'comedo',
        discountType: overrides && overrides.hasOwnProperty('discountType') ? overrides.discountType! : DiscountType.Percentage,
        discountAmount: overrides && overrides.hasOwnProperty('discountAmount') ? overrides.discountAmount! : 6.8,
        maxUsage: overrides && overrides.hasOwnProperty('maxUsage') ? overrides.maxUsage! : 3.7,
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2025-05-02T21:28:05.365Z",
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : "2026-02-24T20:00:12.552Z",
        minOrderAmount: overrides && overrides.hasOwnProperty('minOrderAmount') ? overrides.minOrderAmount! : 4.8,
        maxOrderAmount: overrides && overrides.hasOwnProperty('maxOrderAmount') ? overrides.maxOrderAmount! : 1.3,
        membershipId: overrides && overrides.hasOwnProperty('membershipId') ? overrides.membershipId! : 'vere',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : MembershipPromoCodeType.MembershipAndAddons,
        membershipTypes: overrides && overrides.hasOwnProperty('membershipTypes') ? overrides.membershipTypes! : ['ambitus'],
        membershipAddons: overrides && overrides.hasOwnProperty('membershipAddons') ? overrides.membershipAddons! : ['appositus'],
    };
};

export const anUpdateMembershipPromoCodeInput = (overrides?: Partial<UpdateMembershipPromoCodeInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateMembershipPromoCodeInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateMembershipPromoCodeInput');
    return {
        code: overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'atque',
        discountType: overrides && overrides.hasOwnProperty('discountType') ? overrides.discountType! : DiscountType.Percentage,
        discountAmount: overrides && overrides.hasOwnProperty('discountAmount') ? overrides.discountAmount! : 10,
        maxUsage: overrides && overrides.hasOwnProperty('maxUsage') ? overrides.maxUsage! : 3.3,
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2025-10-24T09:41:35.485Z",
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : "2025-05-11T10:15:59.973Z",
        minOrderAmount: overrides && overrides.hasOwnProperty('minOrderAmount') ? overrides.minOrderAmount! : 1.4,
        maxOrderAmount: overrides && overrides.hasOwnProperty('maxOrderAmount') ? overrides.maxOrderAmount! : 5.3,
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : MembershipPromoCodeType.MembershipAndAddons,
        membershipTypes: overrides && overrides.hasOwnProperty('membershipTypes') ? overrides.membershipTypes! : ['accusator'],
        membershipAddons: overrides && overrides.hasOwnProperty('membershipAddons') ? overrides.membershipAddons! : ['earum'],
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
    };
};

export const aCreateMembershipMultiBuyPromotionInput = (overrides?: Partial<CreateMembershipMultiBuyPromotionInput>, _relationshipsToOmit: Set<string> = new Set()): CreateMembershipMultiBuyPromotionInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateMembershipMultiBuyPromotionInput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'accusator',
        buyQuantity: overrides && overrides.hasOwnProperty('buyQuantity') ? overrides.buyQuantity! : 9.1,
        getQuantity: overrides && overrides.hasOwnProperty('getQuantity') ? overrides.getQuantity! : 3.5,
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 7.6,
        membershipId: overrides && overrides.hasOwnProperty('membershipId') ? overrides.membershipId! : 'testimonium',
        buyMembershipTypeId: overrides && overrides.hasOwnProperty('buyMembershipTypeId') ? overrides.buyMembershipTypeId! : 'talus',
        getMembershipTypeId: overrides && overrides.hasOwnProperty('getMembershipTypeId') ? overrides.getMembershipTypeId! : 'contigo',
    };
};

export const anUpdateMembershipMultiBuyPromotionInput = (overrides?: Partial<UpdateMembershipMultiBuyPromotionInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateMembershipMultiBuyPromotionInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateMembershipMultiBuyPromotionInput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'vito',
        buyQuantity: overrides && overrides.hasOwnProperty('buyQuantity') ? overrides.buyQuantity! : 8.2,
        getQuantity: overrides && overrides.hasOwnProperty('getQuantity') ? overrides.getQuantity! : 1.4,
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 4.3,
        buyMembershipTypeId: overrides && overrides.hasOwnProperty('buyMembershipTypeId') ? overrides.buyMembershipTypeId! : 'amitto',
        getMembershipTypeId: overrides && overrides.hasOwnProperty('getMembershipTypeId') ? overrides.getMembershipTypeId! : 'sulum',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false,
    };
};

export const aMembershipAutoRenewalInput = (overrides?: Partial<MembershipAutoRenewalInput>, _relationshipsToOmit: Set<string> = new Set()): MembershipAutoRenewalInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MembershipAutoRenewalInput');
    return {
        membershipId: overrides && overrides.hasOwnProperty('membershipId') ? overrides.membershipId! : 'tabgo',
        renewalDate: overrides && overrides.hasOwnProperty('renewalDate') ? overrides.renewalDate! : "2025-12-09T00:21:10.783Z",
        reminderDate: overrides && overrides.hasOwnProperty('reminderDate') ? overrides.reminderDate! : "2025-06-10T01:47:12.278Z",
        membershipMappings: overrides && overrides.hasOwnProperty('membershipMappings') ? overrides.membershipMappings! : [relationshipsToOmit.has('MembershipRenewalMappingInput') ? {} as MembershipRenewalMappingInput : aMembershipRenewalMappingInput({}, relationshipsToOmit)],
        renewalStep: overrides && overrides.hasOwnProperty('renewalStep') ? overrides.renewalStep! : MembershipAutoRenewalStep.Scheduled,
    };
};

export const aMembershipRenewalMappingInput = (overrides?: Partial<MembershipRenewalMappingInput>, _relationshipsToOmit: Set<string> = new Set()): MembershipRenewalMappingInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MembershipRenewalMappingInput');
    return {
        membershipId: overrides && overrides.hasOwnProperty('membershipId') ? overrides.membershipId! : 'appono',
        membershipTypeMappings: overrides && overrides.hasOwnProperty('membershipTypeMappings') ? overrides.membershipTypeMappings! : [relationshipsToOmit.has('MembershipTypeMappingInput') ? {} as MembershipTypeMappingInput : aMembershipTypeMappingInput({}, relationshipsToOmit)],
    };
};

export const aMembershipTypeMappingInput = (overrides?: Partial<MembershipTypeMappingInput>, _relationshipsToOmit: Set<string> = new Set()): MembershipTypeMappingInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MembershipTypeMappingInput');
    return {
        previousMembershipTypeId: overrides && overrides.hasOwnProperty('previousMembershipTypeId') ? overrides.previousMembershipTypeId! : 'caecus',
        newMembershipTypeId: overrides && overrides.hasOwnProperty('newMembershipTypeId') ? overrides.newMembershipTypeId! : 'alioqui',
    };
};

export const aCreateScoutInput = (overrides?: Partial<CreateScoutInput>, _relationshipsToOmit: Set<string> = new Set()): CreateScoutInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateScoutInput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'saepe',
        promoteTo: overrides && overrides.hasOwnProperty('promoteTo') ? overrides.promoteTo! : [relationshipsToOmit.has('FilterSelectionInput') ? {} as FilterSelectionInput : aFilterSelectionInput({}, relationshipsToOmit)],
        exclude: overrides && overrides.hasOwnProperty('exclude') ? overrides.exclude! : [relationshipsToOmit.has('FilterSelectionInput') ? {} as FilterSelectionInput : aFilterSelectionInput({}, relationshipsToOmit)],
    };
};

export const aFilterSelectionInput = (overrides?: Partial<FilterSelectionInput>, _relationshipsToOmit: Set<string> = new Set()): FilterSelectionInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('FilterSelectionInput');
    return {
        userTagIds: overrides && overrides.hasOwnProperty('userTagIds') ? overrides.userTagIds! : ['cur'],
        seasonIds: overrides && overrides.hasOwnProperty('seasonIds') ? overrides.seasonIds! : ['complectus'],
        eventTypes: overrides && overrides.hasOwnProperty('eventTypes') ? overrides.eventTypes! : [ScoutEventType.Event],
        regions: overrides && overrides.hasOwnProperty('regions') ? overrides.regions! : ['combibo'],
        membershipTypes: overrides && overrides.hasOwnProperty('membershipTypes') ? overrides.membershipTypes! : ['cenaculum'],
        eventIds: overrides && overrides.hasOwnProperty('eventIds') ? overrides.eventIds! : ['via'],
        eventTitlesForWaitlist: overrides && overrides.hasOwnProperty('eventTitlesForWaitlist') ? overrides.eventTitlesForWaitlist! : ['aperio'],
        totalEventsPurchasedTo: overrides && overrides.hasOwnProperty('totalEventsPurchasedTo') ? overrides.totalEventsPurchasedTo! : 0.5,
        ticketTypeKinds: overrides && overrides.hasOwnProperty('ticketTypeKinds') ? overrides.ticketTypeKinds! : [TicketTypeKind.Standard],
        zones: overrides && overrides.hasOwnProperty('zones') ? overrides.zones! : ['succedo'],
        releaseIds: overrides && overrides.hasOwnProperty('releaseIds') ? overrides.releaseIds! : ['caste'],
        gender: overrides && overrides.hasOwnProperty('gender') ? overrides.gender! : [Gender.Male],
        minAge: overrides && overrides.hasOwnProperty('minAge') ? overrides.minAge! : 2.5,
        maxAge: overrides && overrides.hasOwnProperty('maxAge') ? overrides.maxAge! : 1.6,
    };
};

export const anUpdateScoutInput = (overrides?: Partial<UpdateScoutInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateScoutInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateScoutInput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'laborum',
        promoteTo: overrides && overrides.hasOwnProperty('promoteTo') ? overrides.promoteTo! : [relationshipsToOmit.has('FilterSelectionInput') ? {} as FilterSelectionInput : aFilterSelectionInput({}, relationshipsToOmit)],
        exclude: overrides && overrides.hasOwnProperty('exclude') ? overrides.exclude! : [relationshipsToOmit.has('FilterSelectionInput') ? {} as FilterSelectionInput : aFilterSelectionInput({}, relationshipsToOmit)],
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : true,
    };
};

export const aDeleteScoutUserInput = (overrides?: Partial<DeleteScoutUserInput>, _relationshipsToOmit: Set<string> = new Set()): DeleteScoutUserInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteScoutUserInput');
    return {
        ids: overrides && overrides.hasOwnProperty('ids') ? overrides.ids! : ['tego'],
    };
};

export const aCreateScoutCommunicationInput = (overrides?: Partial<CreateScoutCommunicationInput>, _relationshipsToOmit: Set<string> = new Set()): CreateScoutCommunicationInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateScoutCommunicationInput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'cunae',
        purpose: overrides && overrides.hasOwnProperty('purpose') ? overrides.purpose! : ScoutPurpose.SellMembership,
        scheduledAt: overrides && overrides.hasOwnProperty('scheduledAt') ? overrides.scheduledAt! : "2025-04-30T09:44:24.586Z",
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : ScoutCommunicationType.Email,
        includeOptedOutOfMarketing: overrides && overrides.hasOwnProperty('includeOptedOutOfMarketing') ? overrides.includeOptedOutOfMarketing! : false,
        segmentId: overrides && overrides.hasOwnProperty('segmentId') ? overrides.segmentId! : 'corona',
        campaignId: overrides && overrides.hasOwnProperty('campaignId') ? overrides.campaignId! : 'cui',
        trackSource: overrides && overrides.hasOwnProperty('trackSource') ? overrides.trackSource! : ReportingFilterSource.Overall,
        trackSourceId: overrides && overrides.hasOwnProperty('trackSourceId') ? overrides.trackSourceId! : 'depopulo',
        trackReleaseId: overrides && overrides.hasOwnProperty('trackReleaseId') ? overrides.trackReleaseId! : 'occaecati',
        link: overrides && overrides.hasOwnProperty('link') ? overrides.link! : 'iure',
        shouldUpdate: overrides && overrides.hasOwnProperty('shouldUpdate') ? overrides.shouldUpdate! : false,
        message: overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'cubicularis',
        listId: overrides && overrides.hasOwnProperty('listId') ? overrides.listId! : 'voco',
        templateId: overrides && overrides.hasOwnProperty('templateId') ? overrides.templateId! : 9.5,
        subject: overrides && overrides.hasOwnProperty('subject') ? overrides.subject! : 'conitor',
    };
};

export const anUpdateScoutCommunicationInput = (overrides?: Partial<UpdateScoutCommunicationInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateScoutCommunicationInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateScoutCommunicationInput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'perspiciatis',
        purpose: overrides && overrides.hasOwnProperty('purpose') ? overrides.purpose! : ScoutPurpose.SellMembership,
        scheduledAt: overrides && overrides.hasOwnProperty('scheduledAt') ? overrides.scheduledAt! : "2025-12-29T15:27:37.705Z",
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : ScoutCommunicationType.Email,
        includeOptedOutOfMarketing: overrides && overrides.hasOwnProperty('includeOptedOutOfMarketing') ? overrides.includeOptedOutOfMarketing! : false,
        segmentId: overrides && overrides.hasOwnProperty('segmentId') ? overrides.segmentId! : 'soleo',
        campaignId: overrides && overrides.hasOwnProperty('campaignId') ? overrides.campaignId! : 'alo',
        trackSource: overrides && overrides.hasOwnProperty('trackSource') ? overrides.trackSource! : ReportingFilterSource.Overall,
        trackSourceId: overrides && overrides.hasOwnProperty('trackSourceId') ? overrides.trackSourceId! : 'clam',
        trackReleaseId: overrides && overrides.hasOwnProperty('trackReleaseId') ? overrides.trackReleaseId! : 'ascit',
        link: overrides && overrides.hasOwnProperty('link') ? overrides.link! : 'trucido',
        shouldUpdate: overrides && overrides.hasOwnProperty('shouldUpdate') ? overrides.shouldUpdate! : false,
        message: overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'fugiat',
        listId: overrides && overrides.hasOwnProperty('listId') ? overrides.listId! : 'testimonium',
        templateId: overrides && overrides.hasOwnProperty('templateId') ? overrides.templateId! : 9,
        subject: overrides && overrides.hasOwnProperty('subject') ? overrides.subject! : 'recusandae',
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : true,
    };
};

export const aCreateTestEmailInput = (overrides?: Partial<CreateTestEmailInput>, _relationshipsToOmit: Set<string> = new Set()): CreateTestEmailInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateTestEmailInput');
    return {
        emails: overrides && overrides.hasOwnProperty('emails') ? overrides.emails! : ['convoco'],
        templateId: overrides && overrides.hasOwnProperty('templateId') ? overrides.templateId! : 8.3,
        subject: overrides && overrides.hasOwnProperty('subject') ? overrides.subject! : 'cras',
        communicationId: overrides && overrides.hasOwnProperty('communicationId') ? overrides.communicationId! : 'usitas',
    };
};

export const anUpdateScoutCommunicationUserInput = (overrides?: Partial<UpdateScoutCommunicationUserInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateScoutCommunicationUserInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateScoutCommunicationUserInput');
    return {
        stage: overrides && overrides.hasOwnProperty('stage') ? overrides.stage! : ScoutStage.NoContact,
        usableForEmailMarketing: overrides && overrides.hasOwnProperty('usableForEmailMarketing') ? overrides.usableForEmailMarketing! : false,
        usableForSMSMarketing: overrides && overrides.hasOwnProperty('usableForSMSMarketing') ? overrides.usableForSMSMarketing! : true,
    };
};

export const anAddReminderToScoutCommunicationUserInput = (overrides?: Partial<AddReminderToScoutCommunicationUserInput>, _relationshipsToOmit: Set<string> = new Set()): AddReminderToScoutCommunicationUserInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AddReminderToScoutCommunicationUserInput');
    return {
        remindAt: overrides && overrides.hasOwnProperty('remindAt') ? overrides.remindAt! : "2025-11-19T11:42:43.046Z",
        message: overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'suasoria',
    };
};

export const anAssignScoutCommunicationUsersToAgentInput = (overrides?: Partial<AssignScoutCommunicationUsersToAgentInput>, _relationshipsToOmit: Set<string> = new Set()): AssignScoutCommunicationUsersToAgentInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AssignScoutCommunicationUsersToAgentInput');
    return {
        scoutCommunicationId: overrides && overrides.hasOwnProperty('scoutCommunicationId') ? overrides.scoutCommunicationId! : 'inflammatio',
        agentUserId: overrides && overrides.hasOwnProperty('agentUserId') ? overrides.agentUserId! : 'aliquam',
        scoutCommunicationUserIds: overrides && overrides.hasOwnProperty('scoutCommunicationUserIds') ? overrides.scoutCommunicationUserIds! : ['dedico'],
    };
};

export const aCreateTagInput = (overrides?: Partial<CreateTagInput>, _relationshipsToOmit: Set<string> = new Set()): CreateTagInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateTagInput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'amiculum',
    };
};

export const anUpdateTagInput = (overrides?: Partial<UpdateTagInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateTagInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateTagInput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'appono',
    };
};

export const aTagEntitiesInput = (overrides?: Partial<TagEntitiesInput>, _relationshipsToOmit: Set<string> = new Set()): TagEntitiesInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TagEntitiesInput');
    return {
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['tertius'],
        entityIds: overrides && overrides.hasOwnProperty('entityIds') ? overrides.entityIds! : ['auditor'],
        scoutCommunicationId: overrides && overrides.hasOwnProperty('scoutCommunicationId') ? overrides.scoutCommunicationId! : 'auditor',
    };
};

export const anUpdateTicketHolderInput = (overrides?: Partial<UpdateTicketHolderInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateTicketHolderInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateTicketHolderInput');
    return {
        vaccinePass: overrides && overrides.hasOwnProperty('vaccinePass') ? overrides.vaccinePass! : 'vesica',
        customFields: overrides && overrides.hasOwnProperty('customFields') ? overrides.customFields! : [relationshipsToOmit.has('CustomFieldInput') ? {} as CustomFieldInput : aCustomFieldInput({}, relationshipsToOmit)],
        firstName: overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'tam',
        lastName: overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'appello',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'quo',
        phoneNumber: overrides && overrides.hasOwnProperty('phoneNumber') ? overrides.phoneNumber! : 'sequi',
        birthDate: overrides && overrides.hasOwnProperty('birthDate') ? overrides.birthDate! : "2025-03-06T22:38:13.510Z",
        gender: overrides && overrides.hasOwnProperty('gender') ? overrides.gender! : Gender.Male,
        postalCode: overrides && overrides.hasOwnProperty('postalCode') ? overrides.postalCode! : 'corroboro',
        companyName: overrides && overrides.hasOwnProperty('companyName') ? overrides.companyName! : 'rerum',
        memberSince: overrides && overrides.hasOwnProperty('memberSince') ? overrides.memberSince! : "2025-03-26T07:18:07.605Z",
        licensePlate: overrides && overrides.hasOwnProperty('licensePlate') ? overrides.licensePlate! : 'umquam',
        membershipNumber: overrides && overrides.hasOwnProperty('membershipNumber') ? overrides.membershipNumber! : 'ullam',
        comments: overrides && overrides.hasOwnProperty('comments') ? overrides.comments! : 'similique',
        dietaryRequirements: overrides && overrides.hasOwnProperty('dietaryRequirements') ? overrides.dietaryRequirements! : 'defaeco',
        usableForEmailMarketing: overrides && overrides.hasOwnProperty('usableForEmailMarketing') ? overrides.usableForEmailMarketing! : false,
        usableForSMSMarketing: overrides && overrides.hasOwnProperty('usableForSMSMarketing') ? overrides.usableForSMSMarketing! : false,
        lengthOfStay: overrides && overrides.hasOwnProperty('lengthOfStay') ? overrides.lengthOfStay! : 'subnecto',
        emergencyName: overrides && overrides.hasOwnProperty('emergencyName') ? overrides.emergencyName! : 'aegrus',
        emergencyContact: overrides && overrides.hasOwnProperty('emergencyContact') ? overrides.emergencyContact! : 'confugo',
        emergencyContactRelationship: overrides && overrides.hasOwnProperty('emergencyContactRelationship') ? overrides.emergencyContactRelationship! : 'voluptate',
        dunedinResidentialAddress: overrides && overrides.hasOwnProperty('dunedinResidentialAddress') ? overrides.dunedinResidentialAddress! : 'despecto',
        studentId: overrides && overrides.hasOwnProperty('studentId') ? overrides.studentId! : 'bellicus',
    };
};

export const aRequestTicketTransferInput = (overrides?: Partial<RequestTicketTransferInput>, _relationshipsToOmit: Set<string> = new Set()): RequestTicketTransferInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RequestTicketTransferInput');
    return {
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'coniecto',
        ticketId: overrides && overrides.hasOwnProperty('ticketId') ? overrides.ticketId! : 'accedo',
        ticketSalePrice: overrides && overrides.hasOwnProperty('ticketSalePrice') ? overrides.ticketSalePrice! : 1.7,
    };
};

export const aScanTicketInput = (overrides?: Partial<ScanTicketInput>, _relationshipsToOmit: Set<string> = new Set()): ScanTicketInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ScanTicketInput');
    return {
        ticketNumber: overrides && overrides.hasOwnProperty('ticketNumber') ? overrides.ticketNumber! : 'cubicularis',
        gateId: overrides && overrides.hasOwnProperty('gateId') ? overrides.gateId! : 'thalassinus',
        scanDirection: overrides && overrides.hasOwnProperty('scanDirection') ? overrides.scanDirection! : TicketScanDirection.ScanIn,
        scanType: overrides && overrides.hasOwnProperty('scanType') ? overrides.scanType! : TicketScanType.Eticket,
        isOffline: overrides && overrides.hasOwnProperty('isOffline') ? overrides.isOffline! : false,
        bypassValidations: overrides && overrides.hasOwnProperty('bypassValidations') ? overrides.bypassValidations! : [TicketScanValidations.EntryTime],
    };
};

export const aScanTicketOutput = (overrides?: Partial<ScanTicketOutput>, _relationshipsToOmit: Set<string> = new Set()): ScanTicketOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ScanTicketOutput');
    return {
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : ScanStatus.Ok,
        message: overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'vindico',
        ticket: overrides && overrides.hasOwnProperty('ticket') ? overrides.ticket! : relationshipsToOmit.has('Ticket') ? {} as Ticket : aTicket({}, relationshipsToOmit),
        problemCode: overrides && overrides.hasOwnProperty('problemCode') ? overrides.problemCode! : ProblemCode.TicketNotFound,
    };
};

export const aRedeemTicketInput = (overrides?: Partial<RedeemTicketInput>, _relationshipsToOmit: Set<string> = new Set()): RedeemTicketInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RedeemTicketInput');
    return {
        ticketNumber: overrides && overrides.hasOwnProperty('ticketNumber') ? overrides.ticketNumber! : 'decimus',
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'textor',
        timestamp: overrides && overrides.hasOwnProperty('timestamp') ? overrides.timestamp! : "2026-01-04T14:45:55.802Z",
    };
};

export const aScanTicketBulkInput = (overrides?: Partial<ScanTicketBulkInput>, _relationshipsToOmit: Set<string> = new Set()): ScanTicketBulkInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ScanTicketBulkInput');
    return {
        scans: overrides && overrides.hasOwnProperty('scans') ? overrides.scans! : [relationshipsToOmit.has('ScanTicketBulk') ? {} as ScanTicketBulk : aScanTicketBulk({}, relationshipsToOmit)],
    };
};

export const aScanTicketBulk = (overrides?: Partial<ScanTicketBulk>, _relationshipsToOmit: Set<string> = new Set()): ScanTicketBulk => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ScanTicketBulk');
    return {
        ticketNumber: overrides && overrides.hasOwnProperty('ticketNumber') ? overrides.ticketNumber! : 'cito',
        gateId: overrides && overrides.hasOwnProperty('gateId') ? overrides.gateId! : 'arcesso',
        scanDirection: overrides && overrides.hasOwnProperty('scanDirection') ? overrides.scanDirection! : TicketScanDirection.ScanIn,
        scanType: overrides && overrides.hasOwnProperty('scanType') ? overrides.scanType! : TicketScanType.Eticket,
        isOffline: overrides && overrides.hasOwnProperty('isOffline') ? overrides.isOffline! : true,
        bypassValidations: overrides && overrides.hasOwnProperty('bypassValidations') ? overrides.bypassValidations! : [TicketScanValidations.EntryTime],
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'caelestis',
        scannedAt: overrides && overrides.hasOwnProperty('scannedAt') ? overrides.scannedAt! : "2025-12-17T15:43:52.446Z",
    };
};

export const aCreatePinPaymentCharge = (overrides?: Partial<CreatePinPaymentCharge>, _relationshipsToOmit: Set<string> = new Set()): CreatePinPaymentCharge => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreatePinPaymentCharge');
    return {
        refId: overrides && overrides.hasOwnProperty('refId') ? overrides.refId! : 'crur',
        cardToken: overrides && overrides.hasOwnProperty('cardToken') ? overrides.cardToken! : 'vetus',
    };
};

export const aPinPaymentChargeResponse = (overrides?: Partial<PinPaymentChargeResponse>, _relationshipsToOmit: Set<string> = new Set()): PinPaymentChargeResponse => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PinPaymentChargeResponse');
    return {
        redirectUrl: overrides && overrides.hasOwnProperty('redirectUrl') ? overrides.redirectUrl! : 'tero',
    };
};

export const aVerifyPinPayment3Ds = (overrides?: Partial<VerifyPinPayment3Ds>, _relationshipsToOmit: Set<string> = new Set()): VerifyPinPayment3Ds => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('VerifyPinPayment3Ds');
    return {
        refId: overrides && overrides.hasOwnProperty('refId') ? overrides.refId! : 'conservo',
        sessionToken: overrides && overrides.hasOwnProperty('sessionToken') ? overrides.sessionToken! : 'acceptus',
    };
};

export const aHandleInstagramCodeInput = (overrides?: Partial<HandleInstagramCodeInput>, _relationshipsToOmit: Set<string> = new Set()): HandleInstagramCodeInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('HandleInstagramCodeInput');
    return {
        code: overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'aliquid',
        url: overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'averto',
    };
};

export const aCreatePointInput = (overrides?: Partial<CreatePointInput>, _relationshipsToOmit: Set<string> = new Set()): CreatePointInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreatePointInput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'adicio',
        termsAndConditions: overrides && overrides.hasOwnProperty('termsAndConditions') ? overrides.termsAndConditions! : 'utor',
        gatewayIds: overrides && overrides.hasOwnProperty('gatewayIds') ? overrides.gatewayIds! : ['cruciamentum'],
        isEnabled: overrides && overrides.hasOwnProperty('isEnabled') ? overrides.isEnabled! : false,
    };
};

export const anUpdatePointInput = (overrides?: Partial<UpdatePointInput>, _relationshipsToOmit: Set<string> = new Set()): UpdatePointInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdatePointInput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'saepe',
        termsAndConditions: overrides && overrides.hasOwnProperty('termsAndConditions') ? overrides.termsAndConditions! : 'terebro',
        gatewayIds: overrides && overrides.hasOwnProperty('gatewayIds') ? overrides.gatewayIds! : ['possimus'],
        isEnabled: overrides && overrides.hasOwnProperty('isEnabled') ? overrides.isEnabled! : true,
    };
};

export const aCreatePointItemInput = (overrides?: Partial<CreatePointItemInput>, _relationshipsToOmit: Set<string> = new Set()): CreatePointItemInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreatePointItemInput');
    return {
        pointId: overrides && overrides.hasOwnProperty('pointId') ? overrides.pointId! : 'tamquam',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'sursum',
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 9.1,
        amount: overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 7.7,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'creptio',
        thumbnail: overrides && overrides.hasOwnProperty('thumbnail') ? overrides.thumbnail! : 'verecundia',
        banner: overrides && overrides.hasOwnProperty('banner') ? overrides.banner! : 'calcar',
        backgroundImage: overrides && overrides.hasOwnProperty('backgroundImage') ? overrides.backgroundImage! : 'alii',
        descriptionImage: overrides && overrides.hasOwnProperty('descriptionImage') ? overrides.descriptionImage! : 'summisse',
        isVisible: overrides && overrides.hasOwnProperty('isVisible') ? overrides.isVisible! : false,
    };
};

export const anUpdatePointItemInput = (overrides?: Partial<UpdatePointItemInput>, _relationshipsToOmit: Set<string> = new Set()): UpdatePointItemInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdatePointItemInput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'conicio',
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 2.9,
        amount: overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 7.6,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'contigo',
        thumbnail: overrides && overrides.hasOwnProperty('thumbnail') ? overrides.thumbnail! : 'adsidue',
        banner: overrides && overrides.hasOwnProperty('banner') ? overrides.banner! : 'a',
        backgroundImage: overrides && overrides.hasOwnProperty('backgroundImage') ? overrides.backgroundImage! : 'sunt',
        descriptionImage: overrides && overrides.hasOwnProperty('descriptionImage') ? overrides.descriptionImage! : 'vigilo',
        isVisible: overrides && overrides.hasOwnProperty('isVisible') ? overrides.isVisible! : true,
    };
};

export const anAddAuditLogInput = (overrides?: Partial<AddAuditLogInput>, _relationshipsToOmit: Set<string> = new Set()): AddAuditLogInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AddAuditLogInput');
    return {
        eventType: overrides && overrides.hasOwnProperty('eventType') ? overrides.eventType! : AuditEventType.UserExport,
        eventDetails: overrides && overrides.hasOwnProperty('eventDetails') ? overrides.eventDetails! : 'vesica',
        destinationOrganizationId: overrides && overrides.hasOwnProperty('destinationOrganizationId') ? overrides.destinationOrganizationId! : 'ars',
    };
};

export const anAddUnsubscribeReasonInput = (overrides?: Partial<AddUnsubscribeReasonInput>, _relationshipsToOmit: Set<string> = new Set()): AddUnsubscribeReasonInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AddUnsubscribeReasonInput');
    return {
        userId: overrides && overrides.hasOwnProperty('userId') ? overrides.userId! : 'stips',
        unsubscribeReason: overrides && overrides.hasOwnProperty('unsubscribeReason') ? overrides.unsubscribeReason! : UnsubscribeReason.NoLongerInterested,
        otherUnsubscribeReason: overrides && overrides.hasOwnProperty('otherUnsubscribeReason') ? overrides.otherUnsubscribeReason! : 'territo',
    };
};

export const aMarketingPreferenceUnsubscribeOutput = (overrides?: Partial<MarketingPreferenceUnsubscribeOutput>, _relationshipsToOmit: Set<string> = new Set()): MarketingPreferenceUnsubscribeOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MarketingPreferenceUnsubscribeOutput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'bellum',
    };
};

export const anAddUnsubscribeReasonV2Input = (overrides?: Partial<AddUnsubscribeReasonV2Input>, _relationshipsToOmit: Set<string> = new Set()): AddUnsubscribeReasonV2Input => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AddUnsubscribeReasonV2Input');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ter',
        unsubscribeReason: overrides && overrides.hasOwnProperty('unsubscribeReason') ? overrides.unsubscribeReason! : UnsubscribeReason.NoLongerInterested,
        unsubscribeReasonDetails: overrides && overrides.hasOwnProperty('unsubscribeReasonDetails') ? overrides.unsubscribeReasonDetails! : 'vulnus',
    };
};

export const aScannerEmailOutput = (overrides?: Partial<ScannerEmailOutput>, _relationshipsToOmit: Set<string> = new Set()): ScannerEmailOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ScannerEmailOutput');
    return {
        success: overrides && overrides.hasOwnProperty('success') ? overrides.success! : false,
    };
};

export const aCreateEmailCustomizationInput = (overrides?: Partial<CreateEmailCustomizationInput>, _relationshipsToOmit: Set<string> = new Set()): CreateEmailCustomizationInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateEmailCustomizationInput');
    return {
        emailType: overrides && overrides.hasOwnProperty('emailType') ? overrides.emailType! : EmailType.AbandonedCart,
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'ciminatio',
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : EmailCustomizationStatus.Active,
        membershipId: overrides && overrides.hasOwnProperty('membershipId') ? overrides.membershipId! : 'voluptas',
        pointItemId: overrides && overrides.hasOwnProperty('pointItemId') ? overrides.pointItemId! : 'vilitas',
    };
};

export const anUpdateEmailCustomizationInput = (overrides?: Partial<UpdateEmailCustomizationInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateEmailCustomizationInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateEmailCustomizationInput');
    return {
        emailType: overrides && overrides.hasOwnProperty('emailType') ? overrides.emailType! : EmailType.AbandonedCart,
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'adsidue',
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : EmailCustomizationStatus.Active,
        membershipId: overrides && overrides.hasOwnProperty('membershipId') ? overrides.membershipId! : 'adstringo',
        pointItemId: overrides && overrides.hasOwnProperty('pointItemId') ? overrides.pointItemId! : 'appello',
        subject: overrides && overrides.hasOwnProperty('subject') ? overrides.subject! : 'dolorum',
        richTextTemplate: overrides && overrides.hasOwnProperty('richTextTemplate') ? overrides.richTextTemplate! : 'turbo',
        style: overrides && overrides.hasOwnProperty('style') ? overrides.style! : relationshipsToOmit.has('EmailStyleInput') ? {} as EmailStyleInput : anEmailStyleInput({}, relationshipsToOmit),
    };
};

export const anEmailStyleInput = (overrides?: Partial<EmailStyleInput>, _relationshipsToOmit: Set<string> = new Set()): EmailStyleInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EmailStyleInput');
    return {
        backgroundColour: overrides && overrides.hasOwnProperty('backgroundColour') ? overrides.backgroundColour! : 'quasi',
        bodyColour: overrides && overrides.hasOwnProperty('bodyColour') ? overrides.bodyColour! : 'tergiversatio',
        headingColour: overrides && overrides.hasOwnProperty('headingColour') ? overrides.headingColour! : 'substantia',
        paragraphColour: overrides && overrides.hasOwnProperty('paragraphColour') ? overrides.paragraphColour! : 'voco',
        linkColour: overrides && overrides.hasOwnProperty('linkColour') ? overrides.linkColour! : 'deputo',
        buttonColour: overrides && overrides.hasOwnProperty('buttonColour') ? overrides.buttonColour! : 'validus',
    };
};

export const aSendTestEmailInput = (overrides?: Partial<SendTestEmailInput>, _relationshipsToOmit: Set<string> = new Set()): SendTestEmailInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SendTestEmailInput');
    return {
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'adicio',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'asperiores',
        subject: overrides && overrides.hasOwnProperty('subject') ? overrides.subject! : 'pariatur',
        richTextTemplate: overrides && overrides.hasOwnProperty('richTextTemplate') ? overrides.richTextTemplate! : 'dolore',
        style: overrides && overrides.hasOwnProperty('style') ? overrides.style! : relationshipsToOmit.has('EmailStyleInput') ? {} as EmailStyleInput : anEmailStyleInput({}, relationshipsToOmit),
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'conatus',
        membershipId: overrides && overrides.hasOwnProperty('membershipId') ? overrides.membershipId! : 'villa',
        pointItemId: overrides && overrides.hasOwnProperty('pointItemId') ? overrides.pointItemId! : 'terebro',
    };
};

export const aCopyEmailInput = (overrides?: Partial<CopyEmailInput>, _relationshipsToOmit: Set<string> = new Set()): CopyEmailInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CopyEmailInput');
    return {
        targetId: overrides && overrides.hasOwnProperty('targetId') ? overrides.targetId! : 'sono',
        copyFromId: overrides && overrides.hasOwnProperty('copyFromId') ? overrides.copyFromId! : 'comparo',
        idType: overrides && overrides.hasOwnProperty('idType') ? overrides.idType! : 'ultio',
        emailTypes: overrides && overrides.hasOwnProperty('emailTypes') ? overrides.emailTypes! : [EmailType.AbandonedCart],
    };
};

export const anAddExhibitorInput = (overrides?: Partial<AddExhibitorInput>, _relationshipsToOmit: Set<string> = new Set()): AddExhibitorInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AddExhibitorInput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'tempore',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'assumenda',
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'demitto',
        allowCustomQuestions: overrides && overrides.hasOwnProperty('allowCustomQuestions') ? overrides.allowCustomQuestions! : false,
    };
};

export const anUpdateExhibitorInput = (overrides?: Partial<UpdateExhibitorInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateExhibitorInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateExhibitorInput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'venia',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'color',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'suspendo',
        allowCustomQuestions: overrides && overrides.hasOwnProperty('allowCustomQuestions') ? overrides.allowCustomQuestions! : true,
        shouldInvalidateLogins: overrides && overrides.hasOwnProperty('shouldInvalidateLogins') ? overrides.shouldInvalidateLogins! : false,
    };
};

export const anImportExhibitorInput = (overrides?: Partial<ImportExhibitorInput>, _relationshipsToOmit: Set<string> = new Set()): ImportExhibitorInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ImportExhibitorInput');
    return {
        file: overrides && overrides.hasOwnProperty('file') ? overrides.file! : 'thesaurus',
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'temptatio',
    };
};

export const anImportExhibitorOutput = (overrides?: Partial<ImportExhibitorOutput>, _relationshipsToOmit: Set<string> = new Set()): ImportExhibitorOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ImportExhibitorOutput');
    return {
        importedCount: overrides && overrides.hasOwnProperty('importedCount') ? overrides.importedCount! : 4168,
        failed: overrides && overrides.hasOwnProperty('failed') ? overrides.failed! : [relationshipsToOmit.has('ImportExhibitorParseFailedResultOutput') ? {} as ImportExhibitorParseFailedResultOutput : anImportExhibitorParseFailedResultOutput({}, relationshipsToOmit)],
        duplicates: overrides && overrides.hasOwnProperty('duplicates') ? overrides.duplicates! : [relationshipsToOmit.has('ImportExhibitorAlreadyExistsResultOutput') ? {} as ImportExhibitorAlreadyExistsResultOutput : anImportExhibitorAlreadyExistsResultOutput({}, relationshipsToOmit)],
    };
};

export const anImportExhibitorParseFailedResultOutput = (overrides?: Partial<ImportExhibitorParseFailedResultOutput>, _relationshipsToOmit: Set<string> = new Set()): ImportExhibitorParseFailedResultOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ImportExhibitorParseFailedResultOutput');
    return {
        rowData: overrides && overrides.hasOwnProperty('rowData') ? overrides.rowData! : 'talus',
        reason: overrides && overrides.hasOwnProperty('reason') ? overrides.reason! : 'blandior',
    };
};

export const anImportExhibitorAlreadyExistsResultOutput = (overrides?: Partial<ImportExhibitorAlreadyExistsResultOutput>, _relationshipsToOmit: Set<string> = new Set()): ImportExhibitorAlreadyExistsResultOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ImportExhibitorAlreadyExistsResultOutput');
    return {
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'asporto',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'amicitia',
    };
};

export const anExpoExhibitorLoginInput = (overrides?: Partial<ExpoExhibitorLoginInput>, _relationshipsToOmit: Set<string> = new Set()): ExpoExhibitorLoginInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ExpoExhibitorLoginInput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'careo',
        exhibitorId: overrides && overrides.hasOwnProperty('exhibitorId') ? overrides.exhibitorId! : 'cubitum',
        exhibitorSecret: overrides && overrides.hasOwnProperty('exhibitorSecret') ? overrides.exhibitorSecret! : 'inflammatio',
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'atrocitas',
    };
};

export const anExhibitorLoginSuccess = (overrides?: Partial<ExhibitorLoginSuccess>, _relationshipsToOmit: Set<string> = new Set()): ExhibitorLoginSuccess => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ExhibitorLoginSuccess');
    return {
        success: overrides && overrides.hasOwnProperty('success') ? overrides.success! : true,
        exhibitor: overrides && overrides.hasOwnProperty('exhibitor') ? overrides.exhibitor! : relationshipsToOmit.has('ExpoExhibitor') ? {} as ExpoExhibitor : anExpoExhibitor({}, relationshipsToOmit),
    };
};

export const anExhibitorLoginFailure = (overrides?: Partial<ExhibitorLoginFailure>, _relationshipsToOmit: Set<string> = new Set()): ExhibitorLoginFailure => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ExhibitorLoginFailure');
    return {
        failure: overrides && overrides.hasOwnProperty('failure') ? overrides.failure! : false,
    };
};

export const anExhibitorLoginMultipleFound = (overrides?: Partial<ExhibitorLoginMultipleFound>, _relationshipsToOmit: Set<string> = new Set()): ExhibitorLoginMultipleFound => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ExhibitorLoginMultipleFound');
    return {
        multipleFound: overrides && overrides.hasOwnProperty('multipleFound') ? overrides.multipleFound! : true,
        events: overrides && overrides.hasOwnProperty('events') ? overrides.events! : [relationshipsToOmit.has('ExpoEventForLogin') ? {} as ExpoEventForLogin : anExpoEventForLogin({}, relationshipsToOmit)],
    };
};

export const anExpoEventForLogin = (overrides?: Partial<ExpoEventForLogin>, _relationshipsToOmit: Set<string> = new Set()): ExpoEventForLogin => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ExpoEventForLogin');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'voluptas',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'virgo',
    };
};

export const aResendExhibitorLoginEmailSuccess = (overrides?: Partial<ResendExhibitorLoginEmailSuccess>, _relationshipsToOmit: Set<string> = new Set()): ResendExhibitorLoginEmailSuccess => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ResendExhibitorLoginEmailSuccess');
    return {
        success: overrides && overrides.hasOwnProperty('success') ? overrides.success! : false,
    };
};

export const aResendExhibitorLoginEmailNotFound = (overrides?: Partial<ResendExhibitorLoginEmailNotFound>, _relationshipsToOmit: Set<string> = new Set()): ResendExhibitorLoginEmailNotFound => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ResendExhibitorLoginEmailNotFound');
    return {
        notFound: overrides && overrides.hasOwnProperty('notFound') ? overrides.notFound! : true,
    };
};

export const aResendExhibitorLoginEmailMultipleFound = (overrides?: Partial<ResendExhibitorLoginEmailMultipleFound>, _relationshipsToOmit: Set<string> = new Set()): ResendExhibitorLoginEmailMultipleFound => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ResendExhibitorLoginEmailMultipleFound');
    return {
        multipleFound: overrides && overrides.hasOwnProperty('multipleFound') ? overrides.multipleFound! : true,
        events: overrides && overrides.hasOwnProperty('events') ? overrides.events! : [relationshipsToOmit.has('ExpoEventForLogin') ? {} as ExpoEventForLogin : anExpoEventForLogin({}, relationshipsToOmit)],
    };
};

export const anExpoNamingFieldInput = (overrides?: Partial<ExpoNamingFieldInput>, _relationshipsToOmit: Set<string> = new Set()): ExpoNamingFieldInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ExpoNamingFieldInput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'theologus',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : ExpoNamingFieldType.FirstName,
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'voluptatem',
        required: overrides && overrides.hasOwnProperty('required') ? overrides.required! : false,
        orderKey: overrides && overrides.hasOwnProperty('orderKey') ? overrides.orderKey! : 5.6,
        options: overrides && overrides.hasOwnProperty('options') ? overrides.options! : ['creta'],
    };
};

export const anExpoAttendeeInput = (overrides?: Partial<ExpoAttendeeInput>, _relationshipsToOmit: Set<string> = new Set()): ExpoAttendeeInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ExpoAttendeeInput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'comminor',
        ticketId: overrides && overrides.hasOwnProperty('ticketId') ? overrides.ticketId! : 'beatae',
        ticketNumber: overrides && overrides.hasOwnProperty('ticketNumber') ? overrides.ticketNumber! : 'saepe',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'vix',
        firstName: overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'ars',
        lastName: overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'speciosus',
        phoneNumber: overrides && overrides.hasOwnProperty('phoneNumber') ? overrides.phoneNumber! : 'socius',
        birthDate: overrides && overrides.hasOwnProperty('birthDate') ? overrides.birthDate! : "2026-01-18T12:49:03.436Z",
        gender: overrides && overrides.hasOwnProperty('gender') ? overrides.gender! : Gender.Male,
        postalCode: overrides && overrides.hasOwnProperty('postalCode') ? overrides.postalCode! : 'caveo',
        companyName: overrides && overrides.hasOwnProperty('companyName') ? overrides.companyName! : 'sordeo',
        notes: overrides && overrides.hasOwnProperty('notes') ? overrides.notes! : 'ab',
        optInToMarketing: overrides && overrides.hasOwnProperty('optInToMarketing') ? overrides.optInToMarketing! : true,
        customFields: overrides && overrides.hasOwnProperty('customFields') ? overrides.customFields! : [relationshipsToOmit.has('ExpoCustomFieldInput') ? {} as ExpoCustomFieldInput : anExpoCustomFieldInput({}, relationshipsToOmit)],
    };
};

export const anExpoCustomFieldInput = (overrides?: Partial<ExpoCustomFieldInput>, _relationshipsToOmit: Set<string> = new Set()): ExpoCustomFieldInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ExpoCustomFieldInput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'deripio',
        fieldName: overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'sumptus',
        fieldValue: overrides && overrides.hasOwnProperty('fieldValue') ? overrides.fieldValue! : 'acsi',
    };
};

export const aBulkExpoAttendeeInput = (overrides?: Partial<BulkExpoAttendeeInput>, _relationshipsToOmit: Set<string> = new Set()): BulkExpoAttendeeInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BulkExpoAttendeeInput');
    return {
        attendees: overrides && overrides.hasOwnProperty('attendees') ? overrides.attendees! : [relationshipsToOmit.has('ExpoAttendeeInput') ? {} as ExpoAttendeeInput : anExpoAttendeeInput({}, relationshipsToOmit)],
    };
};

export const aCreateAutomationInput = (overrides?: Partial<CreateAutomationInput>, _relationshipsToOmit: Set<string> = new Set()): CreateAutomationInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateAutomationInput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'absconditus',
        automationType: overrides && overrides.hasOwnProperty('automationType') ? overrides.automationType! : AutomationType.OrderAbandoned,
        templateId: overrides && overrides.hasOwnProperty('templateId') ? overrides.templateId! : 4.2,
        subject: overrides && overrides.hasOwnProperty('subject') ? overrides.subject! : 'canonicus',
        listId: overrides && overrides.hasOwnProperty('listId') ? overrides.listId! : 'cresco',
        targetSource: overrides && overrides.hasOwnProperty('targetSource') ? overrides.targetSource! : ReportingFilterSource.Overall,
        targetSourceId: overrides && overrides.hasOwnProperty('targetSourceId') ? overrides.targetSourceId! : 'unus',
        targetReleaseId: overrides && overrides.hasOwnProperty('targetReleaseId') ? overrides.targetReleaseId! : 'confido',
        timeOfDay: overrides && overrides.hasOwnProperty('timeOfDay') ? overrides.timeOfDay! : "2025-03-13T20:37:10.198Z",
        templateName: overrides && overrides.hasOwnProperty('templateName') ? overrides.templateName! : 'commemoro',
    };
};

export const anUpdateAutomationInput = (overrides?: Partial<UpdateAutomationInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateAutomationInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateAutomationInput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'quibusdam',
        automationType: overrides && overrides.hasOwnProperty('automationType') ? overrides.automationType! : AutomationType.OrderAbandoned,
        templateId: overrides && overrides.hasOwnProperty('templateId') ? overrides.templateId! : 0.7,
        subject: overrides && overrides.hasOwnProperty('subject') ? overrides.subject! : 'cuppedia',
        listId: overrides && overrides.hasOwnProperty('listId') ? overrides.listId! : 'traho',
        targetSource: overrides && overrides.hasOwnProperty('targetSource') ? overrides.targetSource! : ReportingFilterSource.Overall,
        targetSourceId: overrides && overrides.hasOwnProperty('targetSourceId') ? overrides.targetSourceId! : 'cattus',
        targetReleaseId: overrides && overrides.hasOwnProperty('targetReleaseId') ? overrides.targetReleaseId! : 'colligo',
        timeOfDay: overrides && overrides.hasOwnProperty('timeOfDay') ? overrides.timeOfDay! : "2025-10-29T17:06:08.250Z",
        templateName: overrides && overrides.hasOwnProperty('templateName') ? overrides.templateName! : 'approbo',
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : true,
    };
};

export const anAnonymizationInput = (overrides?: Partial<AnonymizationInput>, _relationshipsToOmit: Set<string> = new Set()): AnonymizationInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AnonymizationInput');
    return {
        userId: overrides && overrides.hasOwnProperty('userId') ? overrides.userId! : 'arguo',
        orgId: overrides && overrides.hasOwnProperty('orgId') ? overrides.orgId! : 'vero',
    };
};

export const anAnonymizationOutput = (overrides?: Partial<AnonymizationOutput>, _relationshipsToOmit: Set<string> = new Set()): AnonymizationOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AnonymizationOutput');
    return {
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : 'tabesco',
        message: overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'aeternus',
    };
};

export const aCreateReferralCampaignDto = (overrides?: Partial<CreateReferralCampaignDto>, _relationshipsToOmit: Set<string> = new Set()): CreateReferralCampaignDto => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateReferralCampaignDto');
    return {
        referralReleaseId: overrides && overrides.hasOwnProperty('referralReleaseId') ? overrides.referralReleaseId! : 'debitis',
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'suasoria',
        membershipId: overrides && overrides.hasOwnProperty('membershipId') ? overrides.membershipId! : 'tui',
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : false,
        referralOwnerRewardType: overrides && overrides.hasOwnProperty('referralOwnerRewardType') ? overrides.referralOwnerRewardType! : ReferralRewardType.Points,
        referralOwnerRewardQuantityType: overrides && overrides.hasOwnProperty('referralOwnerRewardQuantityType') ? overrides.referralOwnerRewardQuantityType! : ReferralRewardQuantityType.FlatRate,
        referralOwnerRewardQuantity: overrides && overrides.hasOwnProperty('referralOwnerRewardQuantity') ? overrides.referralOwnerRewardQuantity! : 4,
        referralUserRewardType: overrides && overrides.hasOwnProperty('referralUserRewardType') ? overrides.referralUserRewardType! : ReferralRewardType.Points,
        referralUserRewardQuantityType: overrides && overrides.hasOwnProperty('referralUserRewardQuantityType') ? overrides.referralUserRewardQuantityType! : ReferralRewardQuantityType.FlatRate,
        referralUserRewardQuantity: overrides && overrides.hasOwnProperty('referralUserRewardQuantity') ? overrides.referralUserRewardQuantity! : 8.5,
    };
};

export const anUpdateReferralCampaignDto = (overrides?: Partial<UpdateReferralCampaignDto>, _relationshipsToOmit: Set<string> = new Set()): UpdateReferralCampaignDto => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateReferralCampaignDto');
    return {
        referralReleaseId: overrides && overrides.hasOwnProperty('referralReleaseId') ? overrides.referralReleaseId! : 'excepturi',
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'credo',
        membershipId: overrides && overrides.hasOwnProperty('membershipId') ? overrides.membershipId! : 'volva',
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : false,
        referralOwnerRewardType: overrides && overrides.hasOwnProperty('referralOwnerRewardType') ? overrides.referralOwnerRewardType! : ReferralRewardType.Points,
        referralOwnerRewardQuantityType: overrides && overrides.hasOwnProperty('referralOwnerRewardQuantityType') ? overrides.referralOwnerRewardQuantityType! : ReferralRewardQuantityType.FlatRate,
        referralOwnerRewardQuantity: overrides && overrides.hasOwnProperty('referralOwnerRewardQuantity') ? overrides.referralOwnerRewardQuantity! : 9.2,
        referralUserRewardType: overrides && overrides.hasOwnProperty('referralUserRewardType') ? overrides.referralUserRewardType! : ReferralRewardType.Points,
        referralUserRewardQuantityType: overrides && overrides.hasOwnProperty('referralUserRewardQuantityType') ? overrides.referralUserRewardQuantityType! : ReferralRewardQuantityType.FlatRate,
        referralUserRewardQuantity: overrides && overrides.hasOwnProperty('referralUserRewardQuantity') ? overrides.referralUserRewardQuantity! : 5.9,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'adopto',
    };
};

export const aCreateReferralRewardsDto = (overrides?: Partial<CreateReferralRewardsDto>, _relationshipsToOmit: Set<string> = new Set()): CreateReferralRewardsDto => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateReferralRewardsDto');
    return {
        referralCampaignId: overrides && overrides.hasOwnProperty('referralCampaignId') ? overrides.referralCampaignId! : 'tabula',
        referralOwnerUserReferralId: overrides && overrides.hasOwnProperty('referralOwnerUserReferralId') ? overrides.referralOwnerUserReferralId! : 'aiunt',
        referralUserId: overrides && overrides.hasOwnProperty('referralUserId') ? overrides.referralUserId! : 'timor',
        orderId: overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'cauda',
    };
};

export const aPromoterSettingsInput = (overrides?: Partial<PromoterSettingsInput>, _relationshipsToOmit: Set<string> = new Set()): PromoterSettingsInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PromoterSettingsInput');
    return {
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'caries',
        config: overrides && overrides.hasOwnProperty('config') ? overrides.config! : [relationshipsToOmit.has('PromoterShareActionInput') ? {} as PromoterShareActionInput : aPromoterShareActionInput({}, relationshipsToOmit)],
        socialPages: overrides && overrides.hasOwnProperty('socialPages') ? overrides.socialPages! : [relationshipsToOmit.has('EventSocialPageInput') ? {} as EventSocialPageInput : anEventSocialPageInput({}, relationshipsToOmit)],
        rewardSettings: overrides && overrides.hasOwnProperty('rewardSettings') ? overrides.rewardSettings! : relationshipsToOmit.has('RewardSettingsDto') ? {} as RewardSettingsDto : aRewardSettingsDto({}, relationshipsToOmit),
    };
};

export const aPromoterShareActionInput = (overrides?: Partial<PromoterShareActionInput>, _relationshipsToOmit: Set<string> = new Set()): PromoterShareActionInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PromoterShareActionInput');
    return {
        platform: overrides && overrides.hasOwnProperty('platform') ? overrides.platform! : 'defluo',
        actionType: overrides && overrides.hasOwnProperty('actionType') ? overrides.actionType! : 'substantia',
    };
};

export const anEventSocialPageInput = (overrides?: Partial<EventSocialPageInput>, _relationshipsToOmit: Set<string> = new Set()): EventSocialPageInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EventSocialPageInput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'tardus',
        isEnabled: overrides && overrides.hasOwnProperty('isEnabled') ? overrides.isEnabled! : false,
        url: overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'vorax',
    };
};

export const aRewardSettingsDto = (overrides?: Partial<RewardSettingsDto>, _relationshipsToOmit: Set<string> = new Set()): RewardSettingsDto => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RewardSettingsDto');
    return {
        referralOwnerRewardQuantityType: overrides && overrides.hasOwnProperty('referralOwnerRewardQuantityType') ? overrides.referralOwnerRewardQuantityType! : ReferralRewardQuantityType.FlatRate,
        referralOwnerRewardQuantity: overrides && overrides.hasOwnProperty('referralOwnerRewardQuantity') ? overrides.referralOwnerRewardQuantity! : 6.7,
        referralUserRewardQuantityType: overrides && overrides.hasOwnProperty('referralUserRewardQuantityType') ? overrides.referralUserRewardQuantityType! : ReferralRewardQuantityType.FlatRate,
        referralUserRewardQuantity: overrides && overrides.hasOwnProperty('referralUserRewardQuantity') ? overrides.referralUserRewardQuantity! : 7.9,
    };
};

export const aShopifySettingsInput = (overrides?: Partial<ShopifySettingsInput>, _relationshipsToOmit: Set<string> = new Set()): ShopifySettingsInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ShopifySettingsInput');
    return {
        url: overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'decretum',
        navLinkLabel: overrides && overrides.hasOwnProperty('navLinkLabel') ? overrides.navLinkLabel! : 'acceptus',
        showNavLink: overrides && overrides.hasOwnProperty('showNavLink') ? overrides.showNavLink! : false,
        alwaysShowPostPurchase: overrides && overrides.hasOwnProperty('alwaysShowPostPurchase') ? overrides.alwaysShowPostPurchase! : false,
        selectedProducts: overrides && overrides.hasOwnProperty('selectedProducts') ? overrides.selectedProducts! : [relationshipsToOmit.has('SelectedProductInput') ? {} as SelectedProductInput : aSelectedProductInput({}, relationshipsToOmit)],
    };
};

export const aFinalisePrechargeOrderInput = (overrides?: Partial<FinalisePrechargeOrderInput>, _relationshipsToOmit: Set<string> = new Set()): FinalisePrechargeOrderInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('FinalisePrechargeOrderInput');
    return {
        orderId: overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'vapulus',
        setupIntentId: overrides && overrides.hasOwnProperty('setupIntentId') ? overrides.setupIntentId! : 'cuppedia',
        postCode: overrides && overrides.hasOwnProperty('postCode') ? overrides.postCode! : 'maiores',
        country: overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'comis',
        state: overrides && overrides.hasOwnProperty('state') ? overrides.state! : 'tergeo',
    };
};

export const anInitialiseSetupIntentOutput = (overrides?: Partial<InitialiseSetupIntentOutput>, _relationshipsToOmit: Set<string> = new Set()): InitialiseSetupIntentOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InitialiseSetupIntentOutput');
    return {
        clientSecret: overrides && overrides.hasOwnProperty('clientSecret') ? overrides.clientSecret! : 'aequus',
    };
};

export const aCardUpdateSetupIntentOutput = (overrides?: Partial<CardUpdateSetupIntentOutput>, _relationshipsToOmit: Set<string> = new Set()): CardUpdateSetupIntentOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CardUpdateSetupIntentOutput');
    return {
        clientSecret: overrides && overrides.hasOwnProperty('clientSecret') ? overrides.clientSecret! : 'suspendo',
    };
};

export const aSaveNewSetupIntentForCardUpdateInput = (overrides?: Partial<SaveNewSetupIntentForCardUpdateInput>, _relationshipsToOmit: Set<string> = new Set()): SaveNewSetupIntentForCardUpdateInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SaveNewSetupIntentForCardUpdateInput');
    return {
        orderId: overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'verto',
        setupIntentId: overrides && overrides.hasOwnProperty('setupIntentId') ? overrides.setupIntentId! : 'incidunt',
    };
};

export const aCreateCompetitionInput = (overrides?: Partial<CreateCompetitionInput>, _relationshipsToOmit: Set<string> = new Set()): CreateCompetitionInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateCompetitionInput');
    return {
        competitionType: overrides && overrides.hasOwnProperty('competitionType') ? overrides.competitionType! : CompetitionType.Registration,
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2025-11-13T06:17:52.846Z",
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : "2026-02-17T08:38:55.232Z",
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'sperno',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'sapiente',
        termsAndConditions: overrides && overrides.hasOwnProperty('termsAndConditions') ? overrides.termsAndConditions! : 'solutio',
        referralRewardValue: overrides && overrides.hasOwnProperty('referralRewardValue') ? overrides.referralRewardValue! : 2589,
        bannerImage: overrides && overrides.hasOwnProperty('bannerImage') ? overrides.bannerImage! : 'antepono',
        prizes: overrides && overrides.hasOwnProperty('prizes') ? overrides.prizes! : [relationshipsToOmit.has('CompetitionPrizeInput') ? {} as CompetitionPrizeInput : aCompetitionPrizeInput({}, relationshipsToOmit)],
        promoter: overrides && overrides.hasOwnProperty('promoter') ? overrides.promoter! : [relationshipsToOmit.has('CompetitionPromoterInput') ? {} as CompetitionPromoterInput : aCompetitionPromoterInput({}, relationshipsToOmit)],
    };
};

export const aCompetitionPrizeInput = (overrides?: Partial<CompetitionPrizeInput>, _relationshipsToOmit: Set<string> = new Set()): CompetitionPrizeInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CompetitionPrizeInput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'utique',
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'coniuratio',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'tribuo',
        prizeOrder: overrides && overrides.hasOwnProperty('prizeOrder') ? overrides.prizeOrder! : 4814,
        quantity: overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 2048,
        image: overrides && overrides.hasOwnProperty('image') ? overrides.image! : 'contabesco',
    };
};

export const aCompetitionPromoterInput = (overrides?: Partial<CompetitionPromoterInput>, _relationshipsToOmit: Set<string> = new Set()): CompetitionPromoterInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CompetitionPromoterInput');
    return {
        platform: overrides && overrides.hasOwnProperty('platform') ? overrides.platform! : 'sapiente',
        actionType: overrides && overrides.hasOwnProperty('actionType') ? overrides.actionType! : 'culpo',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 838,
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
    };
};

export const aPublishCompetitionInput = (overrides?: Partial<PublishCompetitionInput>, _relationshipsToOmit: Set<string> = new Set()): PublishCompetitionInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PublishCompetitionInput');
    return {
        competitionType: overrides && overrides.hasOwnProperty('competitionType') ? overrides.competitionType! : CompetitionType.Registration,
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2025-07-18T08:35:10.399Z",
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : "2025-10-10T09:05:06.906Z",
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'velum',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'iure',
        termsAndConditions: overrides && overrides.hasOwnProperty('termsAndConditions') ? overrides.termsAndConditions! : 'tepesco',
        referralRewardValue: overrides && overrides.hasOwnProperty('referralRewardValue') ? overrides.referralRewardValue! : 7353,
        bannerImage: overrides && overrides.hasOwnProperty('bannerImage') ? overrides.bannerImage! : 'inventore',
        prizes: overrides && overrides.hasOwnProperty('prizes') ? overrides.prizes! : [relationshipsToOmit.has('CompetitionPrizeInput') ? {} as CompetitionPrizeInput : aCompetitionPrizeInput({}, relationshipsToOmit)],
        promoter: overrides && overrides.hasOwnProperty('promoter') ? overrides.promoter! : [relationshipsToOmit.has('CompetitionPromoterInput') ? {} as CompetitionPromoterInput : aCompetitionPromoterInput({}, relationshipsToOmit)],
        competitionId: overrides && overrides.hasOwnProperty('competitionId') ? overrides.competitionId! : 'speculum',
    };
};

export const aGrantCompetitionRewardInput = (overrides?: Partial<GrantCompetitionRewardInput>, _relationshipsToOmit: Set<string> = new Set()): GrantCompetitionRewardInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('GrantCompetitionRewardInput');
    return {
        competitionId: overrides && overrides.hasOwnProperty('competitionId') ? overrides.competitionId! : 'aspernatur',
        userId: overrides && overrides.hasOwnProperty('userId') ? overrides.userId! : 'colligo',
        platform: overrides && overrides.hasOwnProperty('platform') ? overrides.platform! : 'turpis',
        actionType: overrides && overrides.hasOwnProperty('actionType') ? overrides.actionType! : 'terra',
        orderId: overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'accusamus',
    };
};

export const aBroadcastReportingInputBase = (overrides?: Partial<BroadcastReportingInputBase>, _relationshipsToOmit: Set<string> = new Set()): BroadcastReportingInputBase => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BroadcastReportingInputBase');
    return {
        communicationType: overrides && overrides.hasOwnProperty('communicationType') ? overrides.communicationType! : BroadcastCommunicationType.Email,
        userId: overrides && overrides.hasOwnProperty('userId') ? overrides.userId! : 'voluntarius',
        waitlistUserId: overrides && overrides.hasOwnProperty('waitlistUserId') ? overrides.waitlistUserId! : 'dignissimos',
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'ventosus',
        membershipId: overrides && overrides.hasOwnProperty('membershipId') ? overrides.membershipId! : 'eius',
        broadcastId: overrides && overrides.hasOwnProperty('broadcastId') ? overrides.broadcastId! : 'laboriosam',
    };
};

export const aBroadcastReportingOrderInput = (overrides?: Partial<BroadcastReportingOrderInput>, _relationshipsToOmit: Set<string> = new Set()): BroadcastReportingOrderInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BroadcastReportingOrderInput');
    return {
        communicationType: overrides && overrides.hasOwnProperty('communicationType') ? overrides.communicationType! : BroadcastCommunicationType.Email,
        userId: overrides && overrides.hasOwnProperty('userId') ? overrides.userId! : 'quidem',
        waitlistUserId: overrides && overrides.hasOwnProperty('waitlistUserId') ? overrides.waitlistUserId! : 'viridis',
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'aer',
        membershipId: overrides && overrides.hasOwnProperty('membershipId') ? overrides.membershipId! : 'tremo',
        broadcastId: overrides && overrides.hasOwnProperty('broadcastId') ? overrides.broadcastId! : 'cuius',
        orderId: overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'aliqua',
    };
};

export const aCreateRedirectUrlInput = (overrides?: Partial<CreateRedirectUrlInput>, _relationshipsToOmit: Set<string> = new Set()): CreateRedirectUrlInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateRedirectUrlInput');
    return {
        refName: overrides && overrides.hasOwnProperty('refName') ? overrides.refName! : 'cena',
        refId: overrides && overrides.hasOwnProperty('refId') ? overrides.refId! : 'tego',
        redirectURL: overrides && overrides.hasOwnProperty('redirectURL') ? overrides.redirectURL! : 'thema',
    };
};

export const anAddAccessCodesToMembershipInput = (overrides?: Partial<AddAccessCodesToMembershipInput>, _relationshipsToOmit: Set<string> = new Set()): AddAccessCodesToMembershipInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AddAccessCodesToMembershipInput');
    return {
        code: overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'depraedor',
        quantityPaid: overrides && overrides.hasOwnProperty('quantityPaid') ? overrides.quantityPaid! : 8,
        quantityComp: overrides && overrides.hasOwnProperty('quantityComp') ? overrides.quantityComp! : 9,
        membershipTypeIds: overrides && overrides.hasOwnProperty('membershipTypeIds') ? overrides.membershipTypeIds! : ['ee7965fd-76b5-481b-8f77-0902626e1d5a'],
    };
};

export const aBulkActionAccessCodesFromMembershipInput = (overrides?: Partial<BulkActionAccessCodesFromMembershipInput>, _relationshipsToOmit: Set<string> = new Set()): BulkActionAccessCodesFromMembershipInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BulkActionAccessCodesFromMembershipInput');
    return {
        accessCodeIds: overrides && overrides.hasOwnProperty('accessCodeIds') ? overrides.accessCodeIds! : ['73dcaee7-9056-4d45-a7b8-8449c3b9df2b'],
    };
};

export const anUpsertAccessCodeInput = (overrides?: Partial<UpsertAccessCodeInput>, _relationshipsToOmit: Set<string> = new Set()): UpsertAccessCodeInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpsertAccessCodeInput');
    return {
        code: overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'video',
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : true,
        quantityPaid: overrides && overrides.hasOwnProperty('quantityPaid') ? overrides.quantityPaid! : 5.3,
        quantityComp: overrides && overrides.hasOwnProperty('quantityComp') ? overrides.quantityComp! : 9.1,
        membershipTypeIds: overrides && overrides.hasOwnProperty('membershipTypeIds') ? overrides.membershipTypeIds! : ['5eb456c6-e77e-4a3e-ab88-3c6a4d04a63b'],
    };
};

export const aJoinWaitlistInput = (overrides?: Partial<JoinWaitlistInput>, _relationshipsToOmit: Set<string> = new Set()): JoinWaitlistInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('JoinWaitlistInput');
    return {
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'templum',
        phoneNumber: overrides && overrides.hasOwnProperty('phoneNumber') ? overrides.phoneNumber! : 'temptatio',
        firstName: overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'delego',
        lastName: overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'cultellus',
        usableForMarketing: overrides && overrides.hasOwnProperty('usableForMarketing') ? overrides.usableForMarketing! : true,
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'voluntarius',
        releaseId: overrides && overrides.hasOwnProperty('releaseId') ? overrides.releaseId! : 'atque',
        referralCode: overrides && overrides.hasOwnProperty('referralCode') ? overrides.referralCode! : 'acer',
        userAcquisition: overrides && overrides.hasOwnProperty('userAcquisition') ? overrides.userAcquisition! : relationshipsToOmit.has('UserAcquisition') ? {} as UserAcquisition : aUserAcquisition({}, relationshipsToOmit),
        customFields: overrides && overrides.hasOwnProperty('customFields') ? overrides.customFields! : [relationshipsToOmit.has('CustomFieldInput') ? {} as CustomFieldInput : aCustomFieldInput({}, relationshipsToOmit)],
    };
};

export const aWaitlist = (overrides?: Partial<Waitlist>, _relationshipsToOmit: Set<string> = new Set()): Waitlist => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Waitlist');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '9ed920fe-3fda-4ba1-b5ff-0e3ac5df9b76',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-08-04T06:38:42.850Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-12-23T15:08:06.175Z",
        organization: overrides && overrides.hasOwnProperty('organization') ? overrides.organization! : relationshipsToOmit.has('Organization') ? {} as Organization : anOrganization({}, relationshipsToOmit),
        user: overrides && overrides.hasOwnProperty('user') ? overrides.user! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        event: overrides && overrides.hasOwnProperty('event') ? overrides.event! : relationshipsToOmit.has('Event') ? {} as Event : anEvent({}, relationshipsToOmit),
    };
};

export const anUpdateResaleConfigInput = (overrides?: Partial<UpdateResaleConfigInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateResaleConfigInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateResaleConfigInput');
    return {
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'adopto',
        canTransferTicket: overrides && overrides.hasOwnProperty('canTransferTicket') ? overrides.canTransferTicket! : false,
        ticketResaleWaitlistEnabled: overrides && overrides.hasOwnProperty('ticketResaleWaitlistEnabled') ? overrides.ticketResaleWaitlistEnabled! : false,
        ticketResaleEnabled: overrides && overrides.hasOwnProperty('ticketResaleEnabled') ? overrides.ticketResaleEnabled! : false,
        sellerTransferringTicketFee: overrides && overrides.hasOwnProperty('sellerTransferringTicketFee') ? overrides.sellerTransferringTicketFee! : 6.5,
        buyerTransferringTicketFee: overrides && overrides.hasOwnProperty('buyerTransferringTicketFee') ? overrides.buyerTransferringTicketFee! : 7.5,
        canChangeSeats: overrides && overrides.hasOwnProperty('canChangeSeats') ? overrides.canChangeSeats! : true,
    };
};

export const aCreateResaleTicketTypeInput = (overrides?: Partial<CreateResaleTicketTypeInput>, _relationshipsToOmit: Set<string> = new Set()): CreateResaleTicketTypeInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateResaleTicketTypeInput');
    return {
        event: overrides && overrides.hasOwnProperty('event') ? overrides.event! : 'laborum',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'temeritas',
        bookingFeeType: overrides && overrides.hasOwnProperty('bookingFeeType') ? overrides.bookingFeeType! : FeeType.FlatRate,
        bookingFee: overrides && overrides.hasOwnProperty('bookingFee') ? overrides.bookingFee! : 4.6,
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 1.2,
        ticketTypes: overrides && overrides.hasOwnProperty('ticketTypes') ? overrides.ticketTypes! : ['statua'],
    };
};

export const aResaleWaitlistInput = (overrides?: Partial<ResaleWaitlistInput>, _relationshipsToOmit: Set<string> = new Set()): ResaleWaitlistInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ResaleWaitlistInput');
    return {
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'arma',
        phoneNumber: overrides && overrides.hasOwnProperty('phoneNumber') ? overrides.phoneNumber! : 'volubilis',
        firstName: overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'cohaero',
        lastName: overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'complectus',
        usableForMarketing: overrides && overrides.hasOwnProperty('usableForMarketing') ? overrides.usableForMarketing! : false,
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'temeritas',
        releaseId: overrides && overrides.hasOwnProperty('releaseId') ? overrides.releaseId! : 'cibus',
        referralCode: overrides && overrides.hasOwnProperty('referralCode') ? overrides.referralCode! : 'approbo',
        userAcquisition: overrides && overrides.hasOwnProperty('userAcquisition') ? overrides.userAcquisition! : relationshipsToOmit.has('UserAcquisition') ? {} as UserAcquisition : aUserAcquisition({}, relationshipsToOmit),
        customFields: overrides && overrides.hasOwnProperty('customFields') ? overrides.customFields! : [relationshipsToOmit.has('CustomFieldInput') ? {} as CustomFieldInput : aCustomFieldInput({}, relationshipsToOmit)],
        resaleTicketTypes: overrides && overrides.hasOwnProperty('resaleTicketTypes') ? overrides.resaleTicketTypes! : [relationshipsToOmit.has('ResaleWaitlistInputTicketTypes') ? {} as ResaleWaitlistInputTicketTypes : aResaleWaitlistInputTicketTypes({}, relationshipsToOmit)],
    };
};

export const aResaleWaitlistInputTicketTypes = (overrides?: Partial<ResaleWaitlistInputTicketTypes>, _relationshipsToOmit: Set<string> = new Set()): ResaleWaitlistInputTicketTypes => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ResaleWaitlistInputTicketTypes');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'appositus',
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 4.7,
        quantity: overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 9.9,
    };
};

export const aResaleWaitlistOutput = (overrides?: Partial<ResaleWaitlistOutput>, _relationshipsToOmit: Set<string> = new Set()): ResaleWaitlistOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ResaleWaitlistOutput');
    return {
        e164Number: overrides && overrides.hasOwnProperty('e164Number') ? overrides.e164Number! : 'depromo',
        user: overrides && overrides.hasOwnProperty('user') ? overrides.user! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
    };
};

export const aSendBroadcastInput = (overrides?: Partial<SendBroadcastInput>, _relationshipsToOmit: Set<string> = new Set()): SendBroadcastInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SendBroadcastInput');
    return {
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : [relationshipsToOmit.has('BroadcastTags') ? {} as BroadcastTags : aBroadcastTags({}, relationshipsToOmit)],
        richTextString: overrides && overrides.hasOwnProperty('richTextString') ? overrides.richTextString! : 'vacuus',
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'asporto',
        membershipId: overrides && overrides.hasOwnProperty('membershipId') ? overrides.membershipId! : 'corpus',
        packageId: overrides && overrides.hasOwnProperty('packageId') ? overrides.packageId! : 'delicate',
        audience: overrides && overrides.hasOwnProperty('audience') ? overrides.audience! : BroadcastAudience.TicketBuyers,
        fromName: overrides && overrides.hasOwnProperty('fromName') ? overrides.fromName! : 'quidem',
        fromLocalPart: overrides && overrides.hasOwnProperty('fromLocalPart') ? overrides.fromLocalPart! : 'cervus',
        fromDomainId: overrides && overrides.hasOwnProperty('fromDomainId') ? overrides.fromDomainId! : 'cupiditate',
        subject: overrides && overrides.hasOwnProperty('subject') ? overrides.subject! : 'aurum',
        subjectRich: overrides && overrides.hasOwnProperty('subjectRich') ? overrides.subjectRich! : 'confero',
        sendTime: overrides && overrides.hasOwnProperty('sendTime') ? overrides.sendTime! : "2025-07-11T17:58:57.985Z",
        broadcastId: overrides && overrides.hasOwnProperty('broadcastId') ? overrides.broadcastId! : 'fugiat',
        ticketTypeId: overrides && overrides.hasOwnProperty('ticketTypeId') ? overrides.ticketTypeId! : ['sunt'],
        zoneId: overrides && overrides.hasOwnProperty('zoneId') ? overrides.zoneId! : ['brevis'],
        releaseId: overrides && overrides.hasOwnProperty('releaseId') ? overrides.releaseId! : ['cilicium'],
        addonId: overrides && overrides.hasOwnProperty('addonId') ? overrides.addonId! : ['stabilis'],
        testEmail: overrides && overrides.hasOwnProperty('testEmail') ? overrides.testEmail! : 'calco',
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : BroadcastStatus.Scheduled,
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : BroadcastType.Marketing,
        marketingType: overrides && overrides.hasOwnProperty('marketingType') ? overrides.marketingType! : BroadcastMarketingType.OptIn,
        marketingFilters: overrides && overrides.hasOwnProperty('marketingFilters') ? overrides.marketingFilters! : [relationshipsToOmit.has('MarketingFiltersInput') ? {} as MarketingFiltersInput : aMarketingFiltersInput({}, relationshipsToOmit)],
        marketingFiltersV2: overrides && overrides.hasOwnProperty('marketingFiltersV2') ? overrides.marketingFiltersV2! : [relationshipsToOmit.has('BroadcastMarketingFiltersV2Input') ? {} as BroadcastMarketingFiltersV2Input : aBroadcastMarketingFiltersV2Input({}, relationshipsToOmit)],
        transactionalType: overrides && overrides.hasOwnProperty('transactionalType') ? overrides.transactionalType! : BroadcastTransactionalType.Event,
        style: overrides && overrides.hasOwnProperty('style') ? overrides.style! : relationshipsToOmit.has('EmailStyleInput') ? {} as EmailStyleInput : anEmailStyleInput({}, relationshipsToOmit),
        preheader: overrides && overrides.hasOwnProperty('preheader') ? overrides.preheader! : 'stabilis',
    };
};

export const aBroadcastTags = (overrides?: Partial<BroadcastTags>, _relationshipsToOmit: Set<string> = new Set()): BroadcastTags => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BroadcastTags');
    return {
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'quam',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : TagType.Tag,
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'cultellus',
        isNew: overrides && overrides.hasOwnProperty('isNew') ? overrides.isNew! : false,
    };
};

export const aCreateSmsBroadcastInput = (overrides?: Partial<CreateSmsBroadcastInput>, _relationshipsToOmit: Set<string> = new Set()): CreateSmsBroadcastInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateSmsBroadcastInput');
    return {
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : [relationshipsToOmit.has('BroadcastTags') ? {} as BroadcastTags : aBroadcastTags({}, relationshipsToOmit)],
        subject: overrides && overrides.hasOwnProperty('subject') ? overrides.subject! : 'adsuesco',
        message: overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'communis',
        scheduledAt: overrides && overrides.hasOwnProperty('scheduledAt') ? overrides.scheduledAt! : "2025-10-14T08:16:58.605Z",
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : BroadcastStatus.Scheduled,
        testPhoneNumber: overrides && overrides.hasOwnProperty('testPhoneNumber') ? overrides.testPhoneNumber! : 'valeo',
        marketingFilters: overrides && overrides.hasOwnProperty('marketingFilters') ? overrides.marketingFilters! : [relationshipsToOmit.has('BroadcastMarketingFiltersV2Input') ? {} as BroadcastMarketingFiltersV2Input : aBroadcastMarketingFiltersV2Input({}, relationshipsToOmit)],
    };
};

export const aSmsBroadcastSaveOutput = (overrides?: Partial<SmsBroadcastSaveOutput>, _relationshipsToOmit: Set<string> = new Set()): SmsBroadcastSaveOutput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SmsBroadcastSaveOutput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'f899f461-76a7-426a-a1cf-57965329bc20',
    };
};

export const anUpdateSmsBroadcastInput = (overrides?: Partial<UpdateSmsBroadcastInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateSmsBroadcastInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateSmsBroadcastInput');
    return {
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : [relationshipsToOmit.has('BroadcastTags') ? {} as BroadcastTags : aBroadcastTags({}, relationshipsToOmit)],
        subject: overrides && overrides.hasOwnProperty('subject') ? overrides.subject! : 'comptus',
        message: overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'volaticus',
        scheduledAt: overrides && overrides.hasOwnProperty('scheduledAt') ? overrides.scheduledAt! : "2025-08-24T21:33:51.013Z",
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : BroadcastStatus.Scheduled,
        testPhoneNumber: overrides && overrides.hasOwnProperty('testPhoneNumber') ? overrides.testPhoneNumber! : 'communis',
        marketingFilters: overrides && overrides.hasOwnProperty('marketingFilters') ? overrides.marketingFilters! : [relationshipsToOmit.has('BroadcastMarketingFiltersV2Input') ? {} as BroadcastMarketingFiltersV2Input : aBroadcastMarketingFiltersV2Input({}, relationshipsToOmit)],
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'molestiae',
    };
};

export const aCreateEmailDomainInput = (overrides?: Partial<CreateEmailDomainInput>, _relationshipsToOmit: Set<string> = new Set()): CreateEmailDomainInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateEmailDomainInput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'tollo',
    };
};

export const aReportScheduleInput = (overrides?: Partial<ReportScheduleInput>, _relationshipsToOmit: Set<string> = new Set()): ReportScheduleInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ReportScheduleInput');
    return {
        scheduleName: overrides && overrides.hasOwnProperty('scheduleName') ? overrides.scheduleName! : 'tonsor',
        recipientList: overrides && overrides.hasOwnProperty('recipientList') ? overrides.recipientList! : ['labore'],
        scheduleOptions: overrides && overrides.hasOwnProperty('scheduleOptions') ? overrides.scheduleOptions! : relationshipsToOmit.has('ReportScheduleOptionsInput') ? {} as ReportScheduleOptionsInput : aReportScheduleOptionsInput({}, relationshipsToOmit),
        isPaused: overrides && overrides.hasOwnProperty('isPaused') ? overrides.isPaused! : true,
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : ReportScheduleType.Event,
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'alii',
        membershipId: overrides && overrides.hasOwnProperty('membershipId') ? overrides.membershipId! : 'pariatur',
    };
};

export const aReportScheduleOptionsInput = (overrides?: Partial<ReportScheduleOptionsInput>, _relationshipsToOmit: Set<string> = new Set()): ReportScheduleOptionsInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ReportScheduleOptionsInput');
    return {
        frequency: overrides && overrides.hasOwnProperty('frequency') ? overrides.frequency! : ReportScheduleFrequency.Monthly,
        sendTime: overrides && overrides.hasOwnProperty('sendTime') ? overrides.sendTime! : 'laborum',
        sendDay: overrides && overrides.hasOwnProperty('sendDay') ? overrides.sendDay! : 'conor',
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : 'curis',
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : 'conscendo',
    };
};

export const aTrackingCodeCreateInput = (overrides?: Partial<TrackingCodeCreateInput>, _relationshipsToOmit: Set<string> = new Set()): TrackingCodeCreateInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TrackingCodeCreateInput');
    return {
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'cauda',
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'deputo',
    };
};

export const aTrackingCodeVisitInput = (overrides?: Partial<TrackingCodeVisitInput>, _relationshipsToOmit: Set<string> = new Set()): TrackingCodeVisitInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TrackingCodeVisitInput');
    return {
        trackingCodeTitle: overrides && overrides.hasOwnProperty('trackingCodeTitle') ? overrides.trackingCodeTitle! : 'varius',
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'optio',
    };
};

export const aTrackingCodeOrderInput = (overrides?: Partial<TrackingCodeOrderInput>, _relationshipsToOmit: Set<string> = new Set()): TrackingCodeOrderInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TrackingCodeOrderInput');
    return {
        trackingCodeTitle: overrides && overrides.hasOwnProperty('trackingCodeTitle') ? overrides.trackingCodeTitle! : 'velut',
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'quam',
        orderId: overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'laudantium',
    };
};

export const aCreateSignupFormInput = (overrides?: Partial<CreateSignupFormInput>, _relationshipsToOmit: Set<string> = new Set()): CreateSignupFormInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateSignupFormInput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'nesciunt',
        heading: overrides && overrides.hasOwnProperty('heading') ? overrides.heading! : 'venustas',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'veritas',
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : [relationshipsToOmit.has('SignupFormTag') ? {} as SignupFormTag : aSignupFormTag({}, relationshipsToOmit)],
        buttonText: overrides && overrides.hasOwnProperty('buttonText') ? overrides.buttonText! : 'tumultus',
        styles: overrides && overrides.hasOwnProperty('styles') ? overrides.styles! : relationshipsToOmit.has('SignupFormStylesInput') ? {} as SignupFormStylesInput : aSignupFormStylesInput({}, relationshipsToOmit),
        formFields: overrides && overrides.hasOwnProperty('formFields') ? overrides.formFields! : [relationshipsToOmit.has('SignupFormFieldInput') ? {} as SignupFormFieldInput : aSignupFormFieldInput({}, relationshipsToOmit)],
        successMessage: overrides && overrides.hasOwnProperty('successMessage') ? overrides.successMessage! : 'defetiscor',
        successHeading: overrides && overrides.hasOwnProperty('successHeading') ? overrides.successHeading! : 'concido',
    };
};

export const aSignupFormTag = (overrides?: Partial<SignupFormTag>, _relationshipsToOmit: Set<string> = new Set()): SignupFormTag => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SignupFormTag');
    return {
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'patruus',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : TagType.Tag,
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'absum',
        isNew: overrides && overrides.hasOwnProperty('isNew') ? overrides.isNew! : true,
    };
};

export const aSignupFormStylesInput = (overrides?: Partial<SignupFormStylesInput>, _relationshipsToOmit: Set<string> = new Set()): SignupFormStylesInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SignupFormStylesInput');
    return {
        backgroundColour: overrides && overrides.hasOwnProperty('backgroundColour') ? overrides.backgroundColour! : 'accedo',
        textColour: overrides && overrides.hasOwnProperty('textColour') ? overrides.textColour! : 'aeger',
        buttonColour: overrides && overrides.hasOwnProperty('buttonColour') ? overrides.buttonColour! : 'ventus',
        customCSS: overrides && overrides.hasOwnProperty('customCSS') ? overrides.customCSS! : 'tero',
    };
};

export const aSignupFormFieldInput = (overrides?: Partial<SignupFormFieldInput>, _relationshipsToOmit: Set<string> = new Set()): SignupFormFieldInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SignupFormFieldInput');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'crudelis',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : NamingFieldType.FirstName,
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'agnosco',
        required: overrides && overrides.hasOwnProperty('required') ? overrides.required! : false,
        options: overrides && overrides.hasOwnProperty('options') ? overrides.options! : ['doloribus'],
        orderKey: overrides && overrides.hasOwnProperty('orderKey') ? overrides.orderKey! : 8.9,
    };
};

export const aSubmissionInput = (overrides?: Partial<SubmissionInput>, _relationshipsToOmit: Set<string> = new Set()): SubmissionInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SubmissionInput');
    return {
        signUpFormId: overrides && overrides.hasOwnProperty('signUpFormId') ? overrides.signUpFormId! : 'cupressus',
        fieldValues: overrides && overrides.hasOwnProperty('fieldValues') ? overrides.fieldValues! : [relationshipsToOmit.has('SignupFormFieldValue') ? {} as SignupFormFieldValue : aSignupFormFieldValue({}, relationshipsToOmit)],
    };
};

export const aSignupFormFieldValue = (overrides?: Partial<SignupFormFieldValue>, _relationshipsToOmit: Set<string> = new Set()): SignupFormFieldValue => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SignupFormFieldValue');
    return {
        signUpFormFieldId: overrides && overrides.hasOwnProperty('signUpFormFieldId') ? overrides.signUpFormFieldId! : 'volva',
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'spargo',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'sumptus',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : NamingFieldType.FirstName,
    };
};

export const aSegmentInput = (overrides?: Partial<SegmentInput>, _relationshipsToOmit: Set<string> = new Set()): SegmentInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SegmentInput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'modi',
        filters: overrides && overrides.hasOwnProperty('filters') ? overrides.filters! : [relationshipsToOmit.has('BroadcastMarketingFiltersV2Input') ? {} as BroadcastMarketingFiltersV2Input : aBroadcastMarketingFiltersV2Input({}, relationshipsToOmit)],
    };
};

export const aFilterArgs = (overrides?: Partial<FilterArgs>, _relationshipsToOmit: Set<string> = new Set()): FilterArgs => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('FilterArgs');
    return {
        kind: overrides && overrides.hasOwnProperty('kind') ? overrides.kind! : BroadcastMarketingFiltersV2Kind.TicketType,
        exclude: overrides && overrides.hasOwnProperty('exclude') ? overrides.exclude! : true,
    };
};

export const aBroadcastMarketingFiltersV2 = (overrides?: Partial<BroadcastMarketingFiltersV2>, _relationshipsToOmit: Set<string> = new Set()): BroadcastMarketingFiltersV2 => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BroadcastMarketingFiltersV2');
    return {
        args: overrides && overrides.hasOwnProperty('args') ? overrides.args! : 'averto',
    };
};

export const aBroadcast = (overrides?: Partial<Broadcast>, _relationshipsToOmit: Set<string> = new Set()): Broadcast => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Broadcast');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '60a0e5e1-b494-4da9-8aa1-2fdc52e2f389',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-10-25T02:53:53.784Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-09-25T02:05:05.762Z",
        fromName: overrides && overrides.hasOwnProperty('fromName') ? overrides.fromName! : 'alienus',
        fromLocalPart: overrides && overrides.hasOwnProperty('fromLocalPart') ? overrides.fromLocalPart! : 'universe',
        fromDomainId: overrides && overrides.hasOwnProperty('fromDomainId') ? overrides.fromDomainId! : 'vorago',
        fromDomainName: overrides && overrides.hasOwnProperty('fromDomainName') ? overrides.fromDomainName! : 'alias',
        audienceType: overrides && overrides.hasOwnProperty('audienceType') ? overrides.audienceType! : BroadcastAudience.TicketBuyers,
        message: overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'vox',
        event: overrides && overrides.hasOwnProperty('event') ? overrides.event! : relationshipsToOmit.has('Event') ? {} as Event : anEvent({}, relationshipsToOmit),
        membership: overrides && overrides.hasOwnProperty('membership') ? overrides.membership! : relationshipsToOmit.has('Membership') ? {} as Membership : aMembership({}, relationshipsToOmit),
        package: overrides && overrides.hasOwnProperty('package') ? overrides.package! : relationshipsToOmit.has('PointItem') ? {} as PointItem : aPointItem({}, relationshipsToOmit),
        scheduledAt: overrides && overrides.hasOwnProperty('scheduledAt') ? overrides.scheduledAt! : "2025-12-07T03:50:01.724Z",
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : BroadcastStatus.Scheduled,
        errors: overrides && overrides.hasOwnProperty('errors') ? overrides.errors! : 'claudeo',
        count: overrides && overrides.hasOwnProperty('count') ? overrides.count! : 9.2,
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : relationshipsToOmit.has('TagEntityIds') ? {} as TagEntityIds : aTagEntityIds({}, relationshipsToOmit),
        audienceData: overrides && overrides.hasOwnProperty('audienceData') ? overrides.audienceData! : relationshipsToOmit.has('AudienceData') ? {} as AudienceData : anAudienceData({}, relationshipsToOmit),
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : BroadcastType.Marketing,
        marketingType: overrides && overrides.hasOwnProperty('marketingType') ? overrides.marketingType! : BroadcastMarketingType.OptIn,
        transactionalType: overrides && overrides.hasOwnProperty('transactionalType') ? overrides.transactionalType! : BroadcastTransactionalType.Event,
        marketingFilters: overrides && overrides.hasOwnProperty('marketingFilters') ? overrides.marketingFilters! : [relationshipsToOmit.has('BroadcastMarketingFilters') ? {} as BroadcastMarketingFilters : aBroadcastMarketingFilters({}, relationshipsToOmit)],
        marketingFiltersV2: overrides && overrides.hasOwnProperty('marketingFiltersV2') ? overrides.marketingFiltersV2! : [relationshipsToOmit.has('BroadcastMarketingFiltersV2') ? {} as BroadcastMarketingFiltersV2 : aBroadcastMarketingFiltersV2({}, relationshipsToOmit)],
        style: overrides && overrides.hasOwnProperty('style') ? overrides.style! : relationshipsToOmit.has('EmailStyle') ? {} as EmailStyle : anEmailStyle({}, relationshipsToOmit),
        reportingVersion: overrides && overrides.hasOwnProperty('reportingVersion') ? overrides.reportingVersion! : 3.3,
        postmarkStats: overrides && overrides.hasOwnProperty('postmarkStats') ? overrides.postmarkStats! : relationshipsToOmit.has('PostmarkEmailStatsOverviewOutput') ? {} as PostmarkEmailStatsOverviewOutput : aPostmarkEmailStatsOverviewOutput({}, relationshipsToOmit),
        postmarkServerId: overrides && overrides.hasOwnProperty('postmarkServerId') ? overrides.postmarkServerId! : 8.2,
        preheader: overrides && overrides.hasOwnProperty('preheader') ? overrides.preheader! : 'similique',
        subjectRich: overrides && overrides.hasOwnProperty('subjectRich') ? overrides.subjectRich! : 'fuga',
    };
};

export const aSalesComparisonDataItem = (overrides?: Partial<SalesComparisonDataItem>, _relationshipsToOmit: Set<string> = new Set()): SalesComparisonDataItem => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SalesComparisonDataItem');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'concedo',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'statua',
        faceValue: overrides && overrides.hasOwnProperty('faceValue') ? overrides.faceValue! : 4.8,
        ticketsSold: overrides && overrides.hasOwnProperty('ticketsSold') ? overrides.ticketsSold! : 9.4,
        addonsSold: overrides && overrides.hasOwnProperty('addonsSold') ? overrides.addonsSold! : 5,
        membershipSold: overrides && overrides.hasOwnProperty('membershipSold') ? overrides.membershipSold! : 9.8,
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2025-09-08T15:11:48.612Z",
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : "2025-06-01T13:51:57.123Z",
        insufficientPeriod: overrides && overrides.hasOwnProperty('insufficientPeriod') ? overrides.insufficientPeriod! : true,
    };
};

export const aSalesComparisonBasePeriod = (overrides?: Partial<SalesComparisonBasePeriod>, _relationshipsToOmit: Set<string> = new Set()): SalesComparisonBasePeriod => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SalesComparisonBasePeriod');
    return {
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : 'sulum',
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : 'arca',
    };
};

export const aWalletTicket = (overrides?: Partial<WalletTicket>, _relationshipsToOmit: Set<string> = new Set()): WalletTicket => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('WalletTicket');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '5277024a-05f7-4b0b-beb7-f93c4b5a86d6',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-09-22T03:50:59.853Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2025-03-17T02:17:25.231Z",
        authenticationToken: overrides && overrides.hasOwnProperty('authenticationToken') ? overrides.authenticationToken! : 'ad',
        googleObjectId: overrides && overrides.hasOwnProperty('googleObjectId') ? overrides.googleObjectId! : 'architecto',
        ticket: overrides && overrides.hasOwnProperty('ticket') ? overrides.ticket! : relationshipsToOmit.has('Ticket') ? {} as Ticket : aTicket({}, relationshipsToOmit),
        organization: overrides && overrides.hasOwnProperty('organization') ? overrides.organization! : relationshipsToOmit.has('Organization') ? {} as Organization : anOrganization({}, relationshipsToOmit),
    };
};

export const aTokenSet = (overrides?: Partial<TokenSet>, _relationshipsToOmit: Set<string> = new Set()): TokenSet => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TokenSet');
    return {
        idToken: overrides && overrides.hasOwnProperty('idToken') ? overrides.idToken! : 'verumtamen',
        accessToken: overrides && overrides.hasOwnProperty('accessToken') ? overrides.accessToken! : 'molestias',
        expiresAt: overrides && overrides.hasOwnProperty('expiresAt') ? overrides.expiresAt! : 8.5,
        tokenType: overrides && overrides.hasOwnProperty('tokenType') ? overrides.tokenType! : 'verto',
        refreshToken: overrides && overrides.hasOwnProperty('refreshToken') ? overrides.refreshToken! : 'dolores',
        scope: overrides && overrides.hasOwnProperty('scope') ? overrides.scope! : 'celebrer',
    };
};

export const aBulkOrdersItem = (overrides?: Partial<BulkOrdersItem>, _relationshipsToOmit: Set<string> = new Set()): BulkOrdersItem => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BulkOrdersItem');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '7fca6e15-211c-49e7-aa00-2ea6e5cce1bf',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-07-07T13:23:44.248Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2026-01-29T18:32:19.673Z",
        processedAt: overrides && overrides.hasOwnProperty('processedAt') ? overrides.processedAt! : "2026-02-08T07:41:25.559Z",
        errorMessage: overrides && overrides.hasOwnProperty('errorMessage') ? overrides.errorMessage! : 'crux',
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : BulkOrdersItemStatus.Success,
    };
};

export const anEventForecastZone = (overrides?: Partial<EventForecastZone>, _relationshipsToOmit: Set<string> = new Set()): EventForecastZone => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EventForecastZone');
    return {
        zoneId: overrides && overrides.hasOwnProperty('zoneId') ? overrides.zoneId! : 'combibo',
        comps: overrides && overrides.hasOwnProperty('comps') ? overrides.comps! : 4433,
        contingency: overrides && overrides.hasOwnProperty('contingency') ? overrides.contingency! : 7055,
    };
};

export const aSalesComparisonSumItem = (overrides?: Partial<SalesComparisonSumItem>, _relationshipsToOmit: Set<string> = new Set()): SalesComparisonSumItem => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SalesComparisonSumItem');
    return {
        faceValue: overrides && overrides.hasOwnProperty('faceValue') ? overrides.faceValue! : 8.7,
        ticketSold: overrides && overrides.hasOwnProperty('ticketSold') ? overrides.ticketSold! : 9430,
        addonSold: overrides && overrides.hasOwnProperty('addonSold') ? overrides.addonSold! : 6588,
        membershipSold: overrides && overrides.hasOwnProperty('membershipSold') ? overrides.membershipSold! : 6483,
    };
};

export const aSalesComparisonGraphDataItem = (overrides?: Partial<SalesComparisonGraphDataItem>, _relationshipsToOmit: Set<string> = new Set()): SalesComparisonGraphDataItem => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SalesComparisonGraphDataItem');
    return {
        faceValue: overrides && overrides.hasOwnProperty('faceValue') ? overrides.faceValue! : 10,
        ticketSold: overrides && overrides.hasOwnProperty('ticketSold') ? overrides.ticketSold! : 8735,
        addonSold: overrides && overrides.hasOwnProperty('addonSold') ? overrides.addonSold! : 4540,
        membershipSold: overrides && overrides.hasOwnProperty('membershipSold') ? overrides.membershipSold! : 7844,
        date: overrides && overrides.hasOwnProperty('date') ? overrides.date! : 'antepono',
        sourceId: overrides && overrides.hasOwnProperty('sourceId') ? overrides.sourceId! : 'aut',
    };
};

export const anImportUserItem = (overrides?: Partial<ImportUserItem>, _relationshipsToOmit: Set<string> = new Set()): ImportUserItem => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ImportUserItem');
    return {
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '1e10229a-d6f3-4da7-865e-b36bab80beb6',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : "2025-09-02T01:23:38.791Z",
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : "2026-01-17T06:03:34.144Z",
        processedAt: overrides && overrides.hasOwnProperty('processedAt') ? overrides.processedAt! : "2025-08-23T18:05:07.098Z",
        message: overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'quam',
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : ImportUserItemStatus.Success,
    };
};

export const aPurchaseRestrictionInput = (overrides?: Partial<PurchaseRestrictionInput>, _relationshipsToOmit: Set<string> = new Set()): PurchaseRestrictionInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PurchaseRestrictionInput');
    return {
        restrictedType: overrides && overrides.hasOwnProperty('restrictedType') ? overrides.restrictedType! : LineItemType.Ticket,
        restrictedId: overrides && overrides.hasOwnProperty('restrictedId') ? overrides.restrictedId! : 'b62c2723-6442-4f77-91be-dd2461b727f1',
        quantity: overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 2461,
        requiredEntities: overrides && overrides.hasOwnProperty('requiredEntities') ? overrides.requiredEntities! : [relationshipsToOmit.has('PurchaseRestrictionRequiredEntityInput') ? {} as PurchaseRestrictionRequiredEntityInput : aPurchaseRestrictionRequiredEntityInput({}, relationshipsToOmit)],
        isExclusive: overrides && overrides.hasOwnProperty('isExclusive') ? overrides.isExclusive! : true,
        isAlwaysVisible: overrides && overrides.hasOwnProperty('isAlwaysVisible') ? overrides.isAlwaysVisible! : true,
    };
};

export const anAudienceDataInput = (overrides?: Partial<AudienceDataInput>, _relationshipsToOmit: Set<string> = new Set()): AudienceDataInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AudienceDataInput');
    return {
        ticketTypeId: overrides && overrides.hasOwnProperty('ticketTypeId') ? overrides.ticketTypeId! : ['volo'],
        zoneId: overrides && overrides.hasOwnProperty('zoneId') ? overrides.zoneId! : ['autem'],
        releaseId: overrides && overrides.hasOwnProperty('releaseId') ? overrides.releaseId! : ['defetiscor'],
        addonId: overrides && overrides.hasOwnProperty('addonId') ? overrides.addonId! : ['cohors'],
    };
};
